const Far0 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far0",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160v128c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 80C98.1 80 48 130.1 48 192v128c0 61.9 50.1 112 112 112s112-50.1 112-112V192c0-61.9-50.1-112-112-112z"
        }
    ]
};

const Far00 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far00",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32C64.5 32 0 96.5 0 176v160c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM48 176c0-53 43-96 96-96s96 43 96 96v160c0 53-43 96-96 96s-96-43-96-96V176zM496 32c-79.5 0-144 64.5-144 144v160c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zm-96 144c0-53 43-96 96-96s96 43 96 96v160c0 53-43 96-96 96s-96-43-96-96V176z"
        }
    ]
};

const Far1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far1",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 56c0-8.7-4.7-16.7-12.3-21s-16.9-4-24.3.5l-104 64c-11.3 6.9-14.8 21.7-7.9 33s21.7 14.8 33 7.9L104 98.9V432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80V56z"
        }
    ]
};

const Far2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far2",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M147.5 80c-26.6 0-52.2 10.6-71 29.4L41 145c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l35.5-35.6C70.4 47.6 108.2 32 147.5 32h7.3c78 0 141.2 63.2 141.2 141.2 0 39.1-16.2 76.4-44.7 103.1L84.8 432H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-9.9 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3l210.9-197.3c18.8-17.6 29.5-42.2 29.5-68 0-51.5-41.7-93.2-93.2-93.2h-7.3z"
        }
    ]
};

const Far3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far3",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h256c9.8 0 18.6 6 22.3 15.1s1.4 19.5-5.7 26.3L147.7 216H188c72.9 0 132 59.1 132 132s-59.1 132-132 132H97.4c-39.4 0-75.4-22.3-93-57.5l-1.9-3.8c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l1.9 3.8c9.5 19 28.9 31 50.1 31H188c46.4 0 84-37.6 84-84s-37.6-84-84-84H88c-9.8 0-18.6-6-22.3-15.1s-1.4-19.5 5.7-26.3L220.3 80H24C10.7 80 0 69.3 0 56z"
        }
    ]
};

const Far360Degrees = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far360Degrees",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M608 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM24 64C10.7 64 0 74.7 0 88s10.7 24 24 24h83.2L36 218.7c-4.9 7.4-5.4 16.8-1.2 24.6S47.1 256 56 256h32c30.9 0 56 25.1 56 56v40c0 26.5-21.5 48-48 48h-1.5c-16 0-31-8-39.9-21.4L44 362.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l10.6 15.9C32.5 432 62.4 448 94.5 448H96c53 0 96-43 96-96v-40c0-53.3-40-97.2-91.6-103.3L172 101.3c4.9-7.4 5.4-16.8 1.2-24.6S160.9 64 152 64H24zm440 80c0-17.7 14.3-32 32-32s32 14.3 32 32v224c0 17.7-14.3 32-32 32s-32-14.3-32-32V144zm112 224V144c0-44.2-35.8-80-80-80s-80 35.8-80 80v224c0 44.2 35.8 80 80 80s80-35.8 80-80zM272 160c0-26.5 21.5-48 48-48 13.3 0 24-10.7 24-24s-10.7-24-24-24c-53 0-96 43-96 96v208c0 44.2 35.8 80 80 80s80-35.8 80-80v-96c0-44.2-35.8-80-80-80-11.4 0-22.2 2.4-32 6.7V160zm32 80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32z"
        }
    ]
};

const Far4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far4",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M189.2 67.2c6.2-11.7 1.7-26.2-10-32.4s-26.2-1.7-32.4 10l-144 272c-3.9 7.4-3.7 16.4.6 23.6S15.6 352 24 352h248v104c0 13.3 10.7 24 24 24s24-10.7 24-24V352h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v152H63.9L189.2 67.2z"
        }
    ]
};

const Far5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far5",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.4 51.9C34.4 40.4 44.3 32 56 32h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H76.2L52.5 216H188c72.9 0 132 59.1 132 132s-59.1 132-132 132H92.5c-36.4 0-69.6-20.5-85.9-53.1l-4.1-8.2c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l4.1 8.2c8.2 16.3 24.8 26.6 43 26.6H188c46.4 0 84-37.6 84-84s-37.6-84-84-84H24c-7.1 0-13.8-3.1-18.4-8.6S-.9 242.9.4 235.9l32-184z"
        }
    ]
};

const Far6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far6",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 320c0-61.9-50.1-112-112-112-32.3 0-61.5 13.7-81.9 35.6l-5.1 6.3c-16.2 19.8-25 44.6-25 70.1 0 61.9 50.1 112 112 112s112-50.1 112-112zM145.7 160.6c4.7-.4 9.5-.6 14.3-.6 88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-41.5 15.8-79.4 41.8-107.8L181.4 40.8c8.4-10.3 23.5-11.8 33.8-3.4s11.8 23.5 3.4 33.8l-72.9 89.5z"
        }
    ]
};

const Far7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far7",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h272c8.6 0 16.6 4.7 20.9 12.2s4.1 16.8-.3 24.2l-240 400c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9L253.6 80H24C10.7 80 0 69.3 0 56z"
        }
    ]
};

const Far8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far8",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 156c0-68.5-55.5-124-124-124h-40C71.5 32 16 87.5 16 156c0 37.7 16.8 71.4 43.3 94.2C23.7 272 0 311.2 0 356c0 68.5 55.5 124 124 124h72c68.5 0 124-55.5 124-124 0-44.8-23.7-84-59.3-105.8 26.5-22.8 43.3-56.5 43.3-94.2zM180.1 280H196c42 0 76 34 76 76s-34 76-76 76h-72c-42 0-76-34-76-76s34-76 76-76h56.1zm0-48H140c-42 0-76-34-76-76s34-76 76-76h40c42 0 76 34 76 76s-34 76-76 76z"
        }
    ]
};

const Far9 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Far9",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 192c0 61.9 50.1 112 112 112 32.3 0 61.5-13.7 81.9-35.6l5.1-6.3c16.2-19.8 25-44.6 25-70.1 0-61.9-50.1-112-112-112S48 130.1 48 192zm126.3 159.4c-4.7.4-9.5.6-14.3.6C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 41.5-15.8 79.4-41.8 107.8L138.6 471.2c-8.4 10.3-23.5 11.8-33.8 3.4s-11.8-23.5-3.4-33.8l72.9-89.5z"
        }
    ]
};

const FarA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarA",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M214.1 46.7C210.4 37.8 201.7 32 192 32s-18.4 5.8-22.1 14.7l-168 400c-5.1 12.2.6 26.3 12.8 31.4s26.3-.6 31.4-12.8L80.3 384h223.4l34.1 81.3c5.1 12.2 19.2 18 31.4 12.8s18-19.2 12.8-31.4l-168-400zM283.6 336H100.4L192 118l91.6 218z"
        }
    ]
};

const FarAbacus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAbacus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c8.8 0 16 7.2 16 16v112h-80v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h64zm-96 48h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H288v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h128v48zm-160 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32h-96v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h96v48zm-128 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H48V96c0-8.8 7.2-16 16-16h64v48zM48 416V240h80v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v48H64c-8.8 0-16-7.2-16-16zm112-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24h96v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v48h-96v-48zm128-72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24h128v96h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v48H288v-48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24zm160 72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-96h80v176c0 8.8-7.2 16-16 16h-64v-48zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarAccentGrave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAccentGrave",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 65.3C80 55.8 87.8 48 97.3 48c8.4 0 15.6 6 17 14.3l18.2 102.1-49.6-84.5c-1.9-3.3-2.9-7-2.9-10.7v-3.9zm-48 0v3.9c0 12.3 3.3 24.4 9.5 35.1l57.3 97.4c8.1 13.8 23 22.3 39 22.3 28.2 0 49.5-25.5 44.6-53.3L161.6 53.8C156.1 22.7 129 0 97.3 0 61.2 0 32 29.2 32 65.3z"
        }
    ]
};

const FarAcorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAcorn",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.2 38.4c8-10.6 5.8-25.6-4.8-33.6S236.8-1 228.8 9.6L224 16c-10.7 14.3-18 30.7-21.6 48H96c-53 0-96 43-96 96v16c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-16c0-53-43-96-96-96h-99.9c2.4-6.8 5.9-13.3 10.3-19.2l4.8-6.4zM400 160H48c0-26.5 21.5-48 48-48h256c26.5 0 48 21.5 48 48zM48.4 240c4.1 78.1 39 189.3 165.5 236.4 6.5 2.4 13.7 2.4 20.2 0C360.6 429.3 395.5 318.1 399.6 240h-48.1c-3.9 65.7-32.7 150.2-127.5 188.9C129.2 390.2 100.3 305.7 96.5 240H48.4z"
        }
    ]
};

const FarAddressBook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAddressBook",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h288zM96 0C60.7 0 32 28.7 32 64v384c0 35.3 28.7 64 64 64h288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm144 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80h-64zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm-16 112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64z"
        }
    ]
};

const FarAddressCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAddressCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm144 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80h-64zm200-144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80z"
        }
    ]
};

const FarAirConditioner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAirConditioner",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm120 64h336c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm248 160v104c0 22.1 17.9 40 40 40s40-17.9 40-40c0-14.8-8-27.7-20-34.7-11.5-6.6-15.4-21.3-8.7-32.8s21.3-15.4 32.8-8.7C478.3 331 496 359.4 496 392c0 48.6-39.4 88-88 88s-88-39.4-88-88V288h48zM208 424V288h48v136c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-32.6 17.7-61 43.9-76.2 11.5-6.6 26.2-2.7 32.8 8.7s2.7 26.2-8.7 32.8c-12 7-20 19.9-20 34.7 0 22.1 17.9 40 40 40s40-17.9 40-40z"
        }
    ]
};

const FarAirplay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAirplay",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 80H96c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h53.5l-34.7 34.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128c0-53 43-96 96-96h384c53 0 96 43 96 96v192c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L426.5 368H480c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48zM198.6 432h178.8L288 342.6 198.6 432zm112-134.6 128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0z"
        }
    ]
};

const FarAlarmClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlarmClock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zm96 86.6a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4l145.1 121zM280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v104c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41V184z"
        }
    ]
};

const FarAlarmExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlarmExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M14.9 146.4C5.5 131.6 0 114 0 95.2 0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4l-145.1 121zM432 288a176 176 0 1 0-352 0 176 176 0 1 0 352 0zm-35.5 174.5C358.1 493.4 309.2 512 256 512s-102.1-18.6-140.5-49.5L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l42.5-42.5C50.6 390.1 32 341.2 32 288 32 164.3 132.3 64 256 64s224 100.3 224 224c0 53.2-18.6 102.1-49.5 140.5L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-42.5-42.5zM352 25.4C369 9.6 391.8 0 416.8 0 469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM256 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24-168v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarAlarmPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlarmPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zm96 86.6a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4l145.1 121zM256 176c-13.3 0-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarAlarmSnooze = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlarmSnooze",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zm96 86.6a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4l145.1 121zM200 192c-13.3 0-24 10.7-24 24s10.7 24 24 24h62.9l-81.8 105.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5H312c13.3 0 24-10.7 24-24s-10.7-24-24-24h-62.9L331 230.8c5.6-7.2 6.6-17 2.6-25.3S321.2 192 312 192H200z"
        }
    ]
};

const FarAlbumCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlbumCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80h320c8.8 0 16 7.2 16 16v98.9c10.4-1.9 21.1-2.9 32-2.9 5.4 0 10.7.2 16 .7V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h232.2c-11.8-14.3-21.4-30.5-28.2-48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm160 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1-1.4-9.1-2.2-18.4-2.2-27.9 0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112zm-32 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm240 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarAlbumCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlbumCircleUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80h320c8.8 0 16 7.2 16 16v98.9c10.4-1.9 21.1-2.9 32-2.9 5.4 0 10.7.2 16 .7V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h232.2c-11.8-14.3-21.4-30.5-28.2-48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm160 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1-1.4-9.1-2.2-18.4-2.2-27.9 0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112zm-32 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm384 112a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-66.3 80.7C489.5 468.1 462.2 480 432 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FarAlbumCollectionCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlbumCollectionCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 0h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160h372.8c23.9 0 44.4 13 55.4 32H496c-26.2 0-51.1 5.7-73.4 16h-353c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9h249.4c12.3 18.8 28 35.1 46.3 48H99.1c-32.1 0-59.3-23.8-63.5-55.7l-29.4-224zM256 232c38.9 0 74.2 11.1 100.1 29.2C333.4 290.8 320 327.8 320 368c0 20.1 3.4 39.4 9.6 57.4C308 434.7 282.9 440 256 440c-79.5 0-144-46.6-144-104s64.5-104 144-104zM16 104c0-13.3 10.7-24 24-24h432c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24zm240 264c17.7 0 32-10.7 32-24s-14.3-24-32-24-32 10.7-32 24 14.3 24 32 24zm240-144a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FarAlbumCollectionCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlbumCollectionCircleUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 0h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160h372.8c23.9 0 44.4 13 55.4 32H496c-26.2 0-51.1 5.7-73.4 16h-353c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9h249.4c12.3 18.8 28 35.1 46.3 48H99.1c-32.1 0-59.3-23.8-63.5-55.7l-29.4-224zM256 232c38.9 0 74.2 11.1 100.1 29.2C333.4 290.8 320 327.8 320 368c0 20.1 3.4 39.4 9.6 57.4C308 434.7 282.9 440 256 440c-79.5 0-144-46.6-144-104s64.5-104 144-104zM16 104c0-13.3 10.7-24 24-24h432c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24zm240 264c17.7 0 32-10.7 32-24s-14.3-24-32-24-32 10.7-32 24 14.3 24 32 24zm96 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7h-65.2c-21 0-38.9 13.7-45.1 32.7 20.2 19.4 47.5 31.3 77.7 31.3s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarAlbumCollection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlbumCollection",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 0h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160h372.8c38.7 0 68.5 34 63.5 72.3l-29.5 224c-4.2 31.9-31.4 55.7-63.5 55.7H99.1c-32.1 0-59.3-23.8-63.5-55.7l-29.4-224zM69.6 208c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9h313.8c8 0 14.8-6 15.9-13.9l29.5-224c1.3-9.6-6.2-18.1-15.9-18.1H69.6zM400 336c0 57.4-64.5 104-144 104s-144-46.6-144-104 64.5-104 144-104 144 46.6 144 104zM16 104c0-13.3 10.7-24 24-24h432c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24zm240 264c17.7 0 32-10.7 32-24s-14.3-24-32-24-32 10.7-32 24 14.3 24 32 24z"
        }
    ]
};

const FarAlbum = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlbum",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm80 160a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm176 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarAlicorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlicorn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M109.6 133.9c-9.9 7.3-18.5 16.1-25.5 26.2C37.3 162.1 0 200.7 0 248v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.2 6.4-25 16.3-32.2-.2 2.8-.3 5.6-.3 8.5 0 14.3 2.7 28.4 8 41.7l21.9 54.6-8.2 21.7c-11.3 30.1-12.7 63.1-4.1 94.1l11.2 40.5c5.8 20.8 24.7 35.2 46.2 35.2h49.8c31.7 0 54.7-30.3 46.2-60.8L220.2 398c-.5-1.6-.4-3.4.2-5l12.1-32.3c1.4-3.7 2.6-7.4 3.6-11.2l51.9 15V464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V327.8c19.8-22.6 32-52.3 32-85.5v-10.1c17.7 6 37.5 5.8 55.8-1.5 34.4-13.8 55-49.3 49.7-86l-9.9-69.2c-1.6-11.3-5.3-21.9-10.7-31.3C555.6 40 560 32.5 560 24c0-13.3-10.7-24-24-24h-56v.3c-2.5-.2-5-.3-7.5-.3H432c-1.8 0-3.5.2-5.2.6C365 5.9 313.7 48.2 295.3 105.3l-131-77.9c-7.4-4.4-16.6-4.5-24.1-.2S128 39.4 128 48c0 76.3 36.1 130.2 71.3 164.2 17.5 17 35 29.3 48.1 37.3 6.6 4 12.1 7.1 16.1 9.1l4.8 2.4c.6.3 1 .5 1.4.6l.4.2.1.1h.1l9.6-22-9.6 22c12.1 5.3 26.3-.2 31.6-12.4s-.2-26.3-12.4-31.6h-.1l-.7-.3c-.7-.3-1.9-.9-3.4-1.7-3-1.5-7.5-4-12.9-7.3-10.9-6.7-25.4-16.9-39.9-30.9-20.8-20.2-41.2-47.8-50.8-84.1l19.4 11.6 86.4 51.4c2.6 1.6 5.4 2.6 8.3 3v.3H313c12.1 0 22.3-9 23.8-21 6.1-49.1 46.6-87.7 96.6-90.8.7 0 1.3-.1 2-.2h37.1c19.9 0 36.8 14.6 39.6 34.3l9.9 69.2c2.1 14.8-6.2 29.1-20 34.7-13.3 5.3-28.4 1.3-37.3-9.8l-5.9-7.3c-6.4-8-17.1-11-26.7-7.7S416 173.8 416 183.9v58.2c0 23.5-9.6 44.1-24.7 58.8-4.6 4.5-7.3 10.7-7.3 17.2V464h-48V346.2c0-11.3-7.9-21.1-19-23.5-2.1-.4-4.2-1-6.3-1.6l-88-25.7c-7.3-2.1-15.3-.7-21.3 4s-9.6 11.9-9.4 19.5v1.3c0 8-1.4 16-4.3 23.5L175.6 376c-4.2 11.1-4.7 23.2-1.5 34.6l14.8 53.4h-49.8l-11.2-40.5c-5.9-21.2-4.9-43.7 2.8-64.4l8.2-21.7c4.2-11.2 4.1-23.6-.4-34.7l-21.9-54.6c-3-7.6-4.6-15.7-4.6-23.9 0-17.4 7-33.3 18.2-44.8-8-13.7-15-28.9-20.6-45.5zM464 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm166.7-48H544v48l89.6-29.9c3.8-1.3 6.4-4.8 6.4-8.8 0-5.1-4.2-9.3-9.3-9.3z"
        }
    ]
};

const FarAlien8bit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlien8bit",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 32c13.3 0 24 10.7 24 24h24c13.3 0 24 10.7 24 24v48h192V80c0-13.3 10.7-24 24-24h24c0-13.3 10.7-24 24-24s24 10.7 24 24v24c0 13.3-10.7 24-24 24h-24v56h24c13.3 0 24 10.7 24 24v56h48v-88c0-13.3 10.7-24 24-24s24 10.7 24 24v112c0 13.3-10.7 24-24 24h-40v72c0 13.3-10.7 24-24 24h-40v72c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h56v-48H208v48h56c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-72h-40c-13.3 0-24-10.7-24-24v-72H56c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v88h48v-56c0-13.3 10.7-24 24-24h24v-56h-24c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm72 144v8c0 13.3-10.7 24-24 24h-24v56c0 13.3-10.7 24-24 24h-8v48h352v-48h-8c-13.3 0-24-10.7-24-24v-56h-24c-13.3 0-24-10.7-24-24v-8H224zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48zm144-16h32c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarAlien = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlien",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M194.7 503.2c8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224 448 100.3 347.7 0 224 0S0 100.3 0 224c0 135.3 148.8 247.7 194.7 279.2zM224 48c97.2 0 176 78.8 176 176 0 50.4-28.2 101.3-68.2 146.9-39.2 44.7-84.2 78.1-105.6 92.7h-.4c-.3.1-.9.2-1.8.2s-1.4-.1-1.8-.2c-.1 0-.2-.1-.2-.1h-.2c-21.4-14.6-66.4-48-105.6-92.7C76.2 325.3 48 274.4 48 224c0-97.2 78.8-176 176-176zm16 258.3c0 7.6 6.1 13.7 13.7 13.7h32c45.4 0 82.3-36.8 82.3-82.3 0-7.6-6.1-13.7-13.7-13.7h-32c-45.4 0-82.3 36.8-82.3 82.3zM125.7 224h-32c-7.6 0-13.7 6.1-13.7 13.7 0 45.4 36.8 82.3 82.3 82.3h32c7.6 0 13.7-6.1 13.7-13.7 0-45.4-36.8-82.3-82.3-82.3z"
        }
    ]
};

const FarAlignCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlignCenter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 40c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM24 168c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm72 152c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarAlignJustify = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlignJustify",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 40C10.7 40 0 50.7 0 64s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM0 320c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarAlignLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlignLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 40C10.7 40 0 50.7 0 64s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM0 320c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarAlignRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlignRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M424 40c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h240zm0 128c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h400zm24 152c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h240c13.3 0 24 10.7 24 24zm-24 104c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h400z"
        }
    ]
};

const FarAlignSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlignSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L471.2 344H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H409.9l-102-80H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H246.6l-102-80H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-9 0-16.9 5-21 12.3L38.8 5.1zM152.3 216l-50.4-39.7C98.2 180.5 96 186 96 192c0 13.3 10.7 24 24 24h32.3zm162.5 128-60.9-48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h194.8zM120 424c-13.3 0-24 10.7-24 24s10.7 24 24 24h357.2l-60.9-48H120z"
        }
    ]
};

const FarAlt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAlt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M467.9 120.4c4.6-5.3 11.2-8.4 18.2-8.4H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H486.1c-21 0-41 9.2-54.7 25.1L172.1 391.6c-4.6 5.3-11.2 8.4-18.2 8.4H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h129.9c21 0 41-9.2 54.7-25.1l259.3-302.5zM440 400c-13.3 0-24 10.7-24 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H440z"
        }
    ]
};

const FarAmpGuitar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAmpGuitar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-48.9 0-92.5 28.8-121.6 53.8-10.7 9.2-20 18.3-27.5 26.2H64c-35.3 0-64 28.7-64 64v304c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-42.9c-7.5-7.9-16.8-17.1-27.5-26.2C348.5 28.8 304.9 0 256 0zm0 48c26.4 0 53.6 13.8 77.7 32H178.3c24.1-18.2 51.4-32 77.7-32zm208 224v176c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V272h416zm0-48H48v-80c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v80zm-352-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-40 128a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-32 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm288-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"
        }
    ]
};

const FarAmpersand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAmpersand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M178 80h44.4c27.4 0 49.7 22.2 49.7 49.7 0 16.2-7.9 31.4-21.2 40.7l-61.4 43-47.2-48.5C133.1 155.5 128 143 128 130c0-27.6 22.4-50 50-50zm45.3 168.2 55.1-38.5c26.1-18.3 41.7-48.1 41.7-80-.1-54-43.8-97.7-97.8-97.7H178c-54.1 0-98 43.9-98 98 0 25.5 10 50 27.7 68.3l41.8 43-73.6 51.5C48.4 312 32 343.5 32 377.1 32 433.9 78.1 480 134.9 480h77.8c35.1 0 67.8-17.7 87-47.1l14.6-22.3 60.4 62.1c9.2 9.5 24.4 9.7 33.9.5s9.7-24.4.5-33.9l-67.9-69.8L412 261.2c7.3-11.1 4.1-26-7-33.2s-26-4.1-33.2 7L307 334.2l-83.7-86zm-39.8 27.9 96.6 99.3-20.5 31.3c-10.3 15.8-28 25.4-46.9 25.4h-77.8c-30.3-.1-54.9-24.7-54.9-55 0-17.9 8.7-34.7 23.4-45l80-56z"
        }
    ]
};

const FarAnchorCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnchorCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 80a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80 0 35.9 23.7 66.3 56.3 76.4-.2 1.2-.3 2.4-.3 3.6v32h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v224h-24c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512h96c17.2 0 33.9-2.4 49.7-6.8-14.7-11.8-27.4-25.9-37.6-41.7-4 .4-8 .5-12.1.5h-24V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zm352 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarAnchorCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnchorCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 80a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80 0 35.9 23.7 66.3 56.3 76.4-.2 1.2-.3 2.4-.3 3.6v32h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v224h-24c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512h96c17.2 0 33.9-2.4 49.7-6.8-14.7-11.8-27.4-25.9-37.6-41.7-4 .4-8 .5-12.1.5h-24V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zm208 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarAnchorCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnchorCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 80a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80 0 35.9 23.7 66.3 56.3 76.4-.2 1.2-.3 2.4-.3 3.6v32h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v224h-24c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512h96c17.2 0 33.9-2.4 49.7-6.8-14.7-11.8-27.4-25.9-37.6-41.7-4 .4-8 .5-12.1.5h-24V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zm208 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FarAnchorLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnchorLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 80a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80 0 35.9 23.7 66.3 56.3 76.4-.2 1.2-.3 2.4-.3 3.6v32h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v224h-24c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512h96c18.3 0 36.1-2.7 52.8-7.7-3.1-7.5-4.8-15.7-4.8-24.3v-24.7c-14.9 5.6-31.1 8.7-48 8.7h-24V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zm240 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FarAnchor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnchor",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 80a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80 0 35.9 23.7 66.3 56.3 76.4-.2 1.2-.3 2.4-.3 3.6v32h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v224h-24c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512h96c100.2 0 181.8-80.2 184-179.9l16.4 14.1c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.2-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l16.3-14C469.7 405.4 409.7 464 336 464h-24V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80z"
        }
    ]
};

const FarAngel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAngel",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64v.2c0 .1-.1.3-.2.6-.3.6-.9 1.8-2.3 3.5s-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5 4.1-10 9.6-19.3 16.3-27.7-2.7-2-4.8-4-6.2-5.6-1.4-1.7-2-2.8-2.3-3.5-.1-.3-.2-.5-.2-.6v-.4c0-.1.1-.3.2-.6.3-.6.9-1.8 2.3-3.5 2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4 1.4 1.7 2 2.8 2.3 3.5.1.3.2.5.2.6v.2zm-128 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM87.6 388.2c5.6-11.1 8.4-23.4 8.4-35.8v-.9c0-12.4-2.9-24.7-8.4-35.8L69.2 279c-3.4-6.7-5.2-14.4-5.2-22.1 0-27.1 22-48.9 48.2-48.9 12.8 0 25 5.1 34.1 14.1l66.4 66.4c-6.8 7.2-12.7 15.5-17.3 24.7L120 464H49.7l37.9-75.8zm166.2-126.4-73.6-73.6c-18-18-42.5-28.2-68-28.2-53.1 0-96.2 43.8-96.2 96.9 0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3h485.4c25 0 45.3-20.3 45.3-45.3 0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3v-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9-25.5 0-50 10.1-68 28.2l-73.6 73.6c-10.8-3.8-22.4-5.8-34.2-5.8s-23.4 2-34.2 5.8zm109.6 26.7 66.4-66.4c9-9 21.3-14.1 34.1-14.1 26.1 0 48.2 21.8 48.2 48.9 0 7.7-1.8 15.4-5.2 22.1l-18.4 36.7c-5.6 11.1-8.4 23.4-8.4 35.8v.9c0 12.4 2.9 24.7 8.4 35.8l37.8 75.8H456l-75.4-150.8c-4.6-9.2-10.4-17.5-17.3-24.7zm-25.7 46.2L402.3 464H173.7l64.6-129.3C247.7 315.9 267 304 288 304s40.3 11.9 49.7 30.7z"
        }
    ]
};

const FarAngle90 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAngle90",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v400c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V56zm48 41.6v48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6zm115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384h48.3c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z"
        }
    ]
};

const FarAngleDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAngleDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z"
        }
    ]
};

const FarAngleLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAngleLeft",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z"
        }
    ]
};

const FarAngleRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAngleRight",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z"
        }
    ]
};

const FarAngleUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAngleUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z"
        }
    ]
};

const FarAngle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAngle",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M253.3 67.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2l-208 400c-3.9 7.4-3.6 16.4.8 23.5S15.6 480 24 480h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H63.5L253.3 67.1zM242 175.5l-22.6 43.4c19.3 15.8 36.5 34 51.3 54.1l40.8-25.6c-19.6-27.2-43-51.4-69.5-71.9zM322.7 392h48.8c-6-36.9-18-71.8-34.7-103.8L296 313.8c12.4 24.3 21.5 50.6 26.8 78.2z"
        }
    ]
};

const FarAnglesDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnglesDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M401 113 241 273c-9.4 9.4-24.6 9.4-33.9 0L47 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 79c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm0 192L241 465c-9.4 9.4-24.6 9.4-33.9 0L47 305c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarAnglesLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnglesLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM399 79 239 239c-9.4 9.4-9.4 24.6 0 33.9L399 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-143-143L433 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
        }
    ]
};

const FarAnglesRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnglesRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m113 433 160-160c9.4-9.4 9.4-24.6 0-33.9L113 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l143 143L79 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm192 0 160-160c9.4-9.4 9.4-24.6 0-33.9L305 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l143 143L271 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"
        }
    ]
};

const FarAnglesUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnglesUpDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M239 498.7c-8.8 7-21.2 7-30 0l-160-128c-10.4-8.3-12-23.4-3.7-33.7s23.4-12 33.7-3.8l145 116 145-116c10.4-8.3 25.5-6.6 33.7 3.8s6.6 25.5-3.8 33.7l-160 128zm160-357.4c10.3 8.3 12 23.4 3.7 33.7s-23.4 12-33.7 3.7l-145-116-145 116c-10.4 8.3-25.5 6.6-33.7-3.7s-6.6-25.5 3.7-33.7l160-128c8.8-7 21.2-7 30 0l160 128z"
        }
    ]
};

const FarAnglesUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnglesUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241 47c-9.4-9.4-24.6-9.4-33.9 0L47 207c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l143-143L367 241c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 47zm160 352L241 239c-9.4-9.4-24.6-9.4-33.9 0L47 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l143-143L367 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"
        }
    ]
};

const FarAnkh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAnkh",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 128c0 42.3 22.6 78.9 50.5 107.6 10.3 10.6 20.6 19.4 29.5 26.3 8.9-6.9 19.3-15.7 29.5-26.3C217.4 206.9 240 170.3 240 128c0-44.2-35.8-80-80-80s-80 35.8-80 80zm18.9 144C66 238.9 32 189.8 32 128 32 57.3 89.3 0 160 0s128 57.3 128 128c0 61.8-34 110.9-66.9 144H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v168c0 13.3-10.7 24-24 24s-24-10.7-24-24V320H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h74.9z"
        }
    ]
};

const FarApartment = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarApartment",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 96V64c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16v128c0 26.5 21.5 48 48 48h64c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H320v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h64c26.5 0 48-21.5 48-48zm16 416h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-64V64c0-35.3-28.7-64-64-64H192c-35.3 0-64 28.7-64 64v32H64c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h128zm160-176c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zm144 80v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm-368-80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zm16 80v-32c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm112-80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zM368 96c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V96zM256 80h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16zm112 144v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm112 112c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zM144 224v-32c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm112 16c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32z"
        }
    ]
};

const FarAperture = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAperture",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m256 464 67-116 13.8-23.8c0-.1.1-.1.1-.2l11.5-20 56.3 97.5C366.9 440.1 314.2 464 256 464zm-92.4-256-56.3-97.5C145.1 71.9 197.8 48 256 48l-67 116-13.9 24-11.5 20zm87.8-56 56.3-97.5c54.8 14 100.9 49.8 128.5 97.5H251.4zm104.1 68.3c-.1-.1-.1-.2-.2-.3l-11.5-20h112.6c5 17.8 7.6 36.6 7.6 56 0 37.9-10.1 73.4-27.8 104l-67-116-13.7-23.7zM48 256c0-37.9 10.1-73.4 27.8-104l67 116 25.4 44H55.6c-5-17.8-7.6-36.6-7.6-56zm156.3 201.5c-54.8-14-100.9-49.8-128.5-97.5h184.8l-56.3 97.5zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-39.3-300c4.3-7.4 12.1-11.9 20.6-12h37.3c8.5.1 16.3 4.6 20.5 11.8l18.7 32.3c4.2 7.4 4.2 16.4 0 23.8 0 0 0 .1-.1.1l-18.5 32v.1a23.93 23.93 0 0 1-20.7 11.9h-37c-8.6 0-16.5-4.6-20.8-12l-18.5-32c-4.3-7.4-4.3-16.6 0-24l18.5-32z"
        }
    ]
};

const FarApostrophe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarApostrophe",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 176c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64zm16 46c-5.1 1.3-10.5 2-16 2H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v136c0 66.3-53.7 120-120 120H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c39.8 0 72-32.2 72-72v-10z"
        }
    ]
};

const FarAppleCore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAppleCore",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80h-16zm-64 352c4.6 0 13.6-1.7 24.9-5.1 25.4-7.6 52.7-7.6 78.1 0 11.3 3.4 20.3 5.1 24.9 5.1 11.4 0 24.9-3.9 38.9-13.1C260.7 411.6 240 360.2 240 304c0-46 13.9-88.8 37.7-124.4-12.7 3-26.4 7.5-39 12.4-30 11.7-63.5 11.7-93.5 0-12.6-4.9-26.2-9.4-39-12.4C130.1 215.2 144 258 144 304c0 56.2-20.7 107.6-54.9 146.9 14 9.2 27.4 13.1 38.9 13.1zm176-336c6.7 0 13 .6 19.1 1.9l.5.1c11.3 2.3 21.5 6.7 30.6 12.7 8.6 5.6 7.3 17.9-.7 24.3-40 32.3-65.5 81.7-65.5 137 0 54.4 24.7 103 63.4 135.3 7 5.9 8.8 16.3 2.7 23.1-28.3 31.3-63.2 49.6-98.1 49.6-11.9 0-26.5-3.4-38.8-7.1-16.4-4.9-34.1-4.9-50.5 0-12.2 3.7-26.8 7.1-38.8 7.1-34.9 0-69.8-18.3-98.1-49.6-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137-8-6.5-9.3-18.7-.7-24.3 9.2-6 19.4-10.3 30.6-12.7l.5-.1C67 128.6 73.3 128 80 128c27.3 0 59.7 10.3 82.7 19.3 18.8 7.3 39.9 7.3 58.7 0 22.9-8.9 55.4-19.3 82.7-19.3z"
        }
    ]
};

const FarAppleWhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAppleWhole",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 112h16c44.2 0 80-35.8 80-80V16c0-8.8-7.2-16-16-16h-16c-44.2 0-80 35.8-80 80v16c0 8.8 7.2 16 16 16zM48 288c0-31.7 7.6-62.5 20.4-83.7 12.1-20 26.3-28.3 43.6-28.3 17.8 0 43.2 7.4 65.3 16 30 11.7 63.5 11.7 93.5 0 22.1-8.6 47.5-16 65.3-16 17.3 0 31.5 8.3 43.6 28.3 12.7 21.2 20.3 52 20.3 83.7 0 54.2-17 100-40.4 131.2-24 32-51.2 44.8-71.6 44.8-4.6 0-13.6-1.7-24.9-5.1-25.4-7.6-52.7-7.6-78.1 0-11.3 3.4-20.3 5.1-24.9 5.1-20.4 0-47.6-12.8-71.6-44.8C65 388 48 342.2 48 288zm64-160C35.7 128 0 211.7 0 288c0 128 80 224 160 224 11.9 0 26.5-3.4 38.8-7.1 16.4-4.9 34.1-4.9 50.5 0 12.2 3.7 26.8 7.1 38.8 7.1 80 0 160-96 160-224 0-76.3-35.7-160-112-160-27.3 0-59.7 10.3-82.7 19.3-18.8 7.3-39.9 7.3-58.7 0-23-9-55.4-19.3-82.7-19.3z"
        }
    ]
};

const FarArchway = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArchway",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h456c13.3 0 24 10.7 24 24s-10.7 24-24 24v352h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V336c0-44.2-35.8-80-80-80s-80 35.8-80 80v120c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V80h-8C10.7 80 0 69.3 0 56zm80 24v32h352V80H80zm0 80v272h48v-96c0-70.7 57.3-128 128-128s128 57.3 128 128v96h48V160H80z"
        }
    ]
};

const FarArrowDown19 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDown19",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 56c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16C363.8 53.4 357 67 361.2 79.6S379 99 391.6 94.8l16.4-5.5V176h-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h96c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24V56zM143 473c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96zm281-89a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-17.9 46.2-8.7 10.6c-8.4 10.3-6.9 25.4 3.4 33.8s25.4 6.9 33.8-3.4l56.8-69.4c13.3-16.3 20.6-36.7 20.6-57.8 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 42.5 30.1 77.9 70.1 86.2z"
        }
    ]
};

const FarArrowDown91 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDown91",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47 377 96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm409-65c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16c-12.6 4.2-19.4 17.8-15.2 30.4s17.8 19.4 30.4 15.2l16.4-5.5V432h-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h96c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24V312zm-32-152a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm88-40c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 42.1 29.6 77.3 69.1 86l-15.6 18.7c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1l64.6-77.6c13-15.6 20.3-35.1 20.9-55.3V120z"
        }
    ]
};

const FarArrowDownAZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownAZ",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47 377 96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm305-89c-13.3 0-24 10.7-24 24s10.7 24 24 24h74.6l-92.5 104.1c-6.3 7.1-7.8 17.2-4 25.8S342.6 480 352 480h128c13.3 0 24-10.7 24-24s-10.7-24-24-24h-74.6l92.5-104.1c6.3-7.1 7.8-17.2 4-25.8S489.4 288 480 288H352zm64-256c-9.1 0-17.4 5.1-21.5 13.3l-80 160c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l13.4-26.8H456c1.7 0 3.3-.2 4.9-.5l13.6 27.2c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-80-160c-4-8.1-12.3-13.2-21.4-13.2zm-21.2 120 21.2-42.3 21.2 42.3h-42.4z"
        }
    ]
};

const FarArrowDownArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47 377 96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM399 39l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V456c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L433 39c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarArrowDownBigSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownBigSmall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m143 473-96-96c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55V56c0-13.3 10.7-24 24-24s24 10.7 24 24v342.1l55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0zm225-105v64h64v-64h-64zm-48 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48v-64zm48-160h128V80H368v128zm-48 0V80c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FarArrowDownFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48C141.1 48 48 141.1 48 256c0 13.3-10.7 24-24 24S0 269.3 0 256C0 114.6 114.6 0 256 0s256 114.6 256 256c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-114.9-93.1-208-208-208zM134.4 392.3c-9-9.7-8.5-24.9 1.3-33.9s24.9-8.5 33.9 1.3l62.4 67.2V184c0-13.3 10.7-24 24-24s24 10.7 24 24v242.9l62.4-67.2c9-9.7 24.2-10.3 33.9-1.3s10.3 24.2 1.3 33.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112z"
        }
    ]
};

const FarArrowDownFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241.5 472.4c-4.5 4.8-10.9 7.6-17.5 7.6s-12.9-2.7-17.5-7.6l-128-136c-9.1-9.7-8.6-24.8 1-33.9s24.8-8.6 33.9 1l86.6 92V184c0-13.3 10.7-24 24-24s24 10.7 24 24v211.5l86.5-91.9c9.1-9.7 24.3-10.1 33.9-1s10.1 24.3 1 33.9l-128 136zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FarArrowDownFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M174.5 472.4c4.5 4.8 10.9 7.6 17.5 7.6s12.9-2.7 17.5-7.6l128-136c9.1-9.7 8.6-24.8-1-33.9s-24.8-8.6-33.9 1l-86.6 92V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v211.5l-86.5-91.9c-9.1-9.7-24.3-10.1-33.9-1s-10.1 24.3-1 33.9l128 136zM360 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 32 0 42.7 0 56s10.7 24 24 24h336z"
        }
    ]
};

const FarArrowDownLeftAndArrowUpRightToCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownLeftAndArrowUpRightToCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M489 57c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V72c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24H440c13.3 0 24-10.7 24-24s-10.7-24-24-24h-86.1L489 57zM23 455c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V440c0 13.3 10.7 24 24 24s24-10.7 24-24V296c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h86.1L23 455z"
        }
    ]
};

const FarArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 416c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v182.1L311 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-231 231H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H56z"
        }
    ]
};

const FarArrowDownLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownLong",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175 505c9.4 9.4 24.6 9.4 33.9 0L345 369c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v406.1L73 335c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 505z"
        }
    ]
};

const FarArrowDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328 416c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v182.1L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l231 231H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h240z"
        }
    ]
};

const FarArrowDownShortWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownShortWide",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m15 377 96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v342.1L49 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM312 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H312zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H312zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24H312z"
        }
    ]
};

const FarArrowDownSmallBig = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownSmallBig",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m143 473-96-96c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55V56c0-13.3 10.7-24 24-24s24 10.7 24 24v342.1l55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0zm225-329h64V80h-64v64zm-48 0V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48zm48 160v128h128V304H368zm-48 0c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V304z"
        }
    ]
};

const FarArrowDownSquareTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownSquareTriangle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47 377 96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm481 78c0-4.5-1.2-9-3.6-12.9l-84.2-140.4c-5.1-8.5-14.3-13.7-24.2-13.7s-19.1 5.2-24.2 13.7L307.6 442c-2.3 3.9-3.6 8.4-3.6 12.9 0 13.8 11.2 25.1 25.1 25.1h173.8c13.8 0 25.1-11.2 25.1-25.1zM368 80h96v96h-96V80zm94.4 352h-92.8l46.4-77.4 46.4 77.4zM320 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarArrowDownToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c114.9 0 208-93.1 208-208 0-13.3 10.7-24 24-24s24 10.7 24 24c0 141.4-114.6 256-256 256S0 397.4 0 256c0-13.3 10.7-24 24-24s24 10.7 24 24c0 114.9 93.1 208 208 208zm121.6-231.7-104 112c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112c-9-9.7-8.5-24.9 1.3-33.9s24.9-8.5 33.9 1.3l62.4 67.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24v242.9l62.4-67.2c9-9.7 24.2-10.3 33.9-1.3s10.3 24.2 1.3 33.9z"
        }
    ]
};

const FarArrowDownToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownToBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M369 217 241 345c-9.4 9.4-24.6 9.4-33.9 0L79 217c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87V24c0-13.3 10.7-24 24-24s24 10.7 24 24v246.1l87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 344v80c0 22.1 17.9 40 40 40h272c22.1 0 40-17.9 40-40v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 48.6-39.4 88-88 88H88c-48.6 0-88-39.4-88-88v-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarArrowDownToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-206.5-87.6c-4.5 4.8-10.9 7.6-17.5 7.6s-12.9-2.7-17.5-7.6l-128-136c-9.1-9.7-8.6-24.8 1-33.9s24.8-8.6 33.9 1l86.6 92V72c0-13.3 10.7-24 24-24s24 10.7 24 24v211.5l86.5-91.9c9.1-9.7 24.3-10.1 33.9-1s10.1 24.3 1 33.9l-128 136z"
        }
    ]
};

const FarArrowDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M360 480c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h336zM174.5 344.4c4.5 4.8 10.9 7.6 17.5 7.6s12.9-2.7 17.5-7.6l128-136c9.1-9.7 8.6-24.8-1-33.9s-24.8-8.6-33.9 1l-86.6 92V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v211.5l-86.5-91.9c-9.1-9.7-24.3-10.1-33.9-1s-10.1 24.3-1 33.9l128 136z"
        }
    ]
};

const FarArrowDownToSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownToSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M385 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v246.1l-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 345c9.4 9.4 24.6 9.4 33.9 0L385 233zM72 32C32.2 32 0 64.2 0 104v336c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72V104c0-39.8-32.2-72-72-72h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24 10.7 24 24v336c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
        }
    ]
};

const FarArrowDownTriangleSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownTriangleSquare",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47 377 96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM416 32c-9.9 0-19.1 5.2-24.2 13.7L307.6 186c-2.3 3.9-3.6 8.4-3.6 12.9 0 13.8 11.2 25.1 25.1 25.1h173.8c13.8 0 25.1-11.2 25.1-25.1 0-4.5-1.2-9-3.6-12.9L440.2 45.7C435.1 37.2 425.9 32 416 32zm-48 400v-96h96v96h-96zm48-333.4 46.4 77.4h-92.8L416 98.6zM320 432c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v96z"
        }
    ]
};

const FarArrowDownUpAcrossLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownUpAcrossLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M143 505c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V280h368c13.3 0 24-10.7 24-24s-10.7-24-24-24H440V81.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L433 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h112v150.1L81 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96zm-7-313h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v136zm304 128h-48v136c0 13.3 10.7 24 24 24s24-10.7 24-24V320z"
        }
    ]
};

const FarArrowDownUpLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownUpLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m145 505 96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V280H416v-8c0-14.1 2.6-27.6 7.4-40H344V81.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L337 7c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80v150.1L49 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0zm7-313V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v136h48zm144 128v136c0 13.3 10.7 24 24 24s24-10.7 24-24V320h-48zm232-80c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FarArrowDownWideShort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownWideShort",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m15 377 96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v342.1L49 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm297 103h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128h240c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24s10.7 24 24 24z"
        }
    ]
};

const FarArrowDownZA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDownZA",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47 377 96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM352 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h74.6l-92.5 104.1c-6.3 7.1-7.8 17.2-4 25.8S342.6 224 352 224h128c13.3 0 24-10.7 24-24s-10.7-24-24-24h-74.6l92.5-104.1c6.3-7.1 7.8-17.2 4-25.8S489.4 32 480 32H352zm64 240c-9.1 0-17.4 5.1-21.5 13.3l-80 160c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l13.4-26.8H456c1.7 0 3.3-.2 4.9-.5l13.6 27.2c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-80-160c-4.1-8.1-12.4-13.3-21.5-13.3zm-21.2 120 21.2-42.3 21.2 42.3h-42.4z"
        }
    ]
};

const FarArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9.8L216 396.1V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z"
        }
    ]
};

const FarArrowLeftFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowLeftFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-114.9-93.1-208-208-208-13.3 0-24-10.7-24-24s10.7-24 24-24c141.4 0 256 114.6 256 256S397.4 512 256 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c114.9 0 208-93.1 208-208zM119.7 134.4c9.7-9 24.9-8.5 33.9 1.3s8.5 24.9-1.3 33.9L85.1 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H85.1l67.2 62.4c9.7 9 10.3 24.2 1.3 33.9s-24.2 10.3-33.9 1.3l-112-104C2.8 269 0 262.7 0 256s2.8-13 7.7-17.6l112-104z"
        }
    ]
};

const FarArrowLeftFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowLeftFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7.6 238.5C2.7 243.1 0 249.4 0 256s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9l-92-86.6H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H84.5l91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128zM400 424c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v336z"
        }
    ]
};

const FarArrowLeftLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowLeftLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24S0 74.7 0 88zm135 151c-9.4 9.4-9.4 24.6 0 33.9L271 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-95-95L616 280c13.3 0 24-10.7 24-24s-10.7-24-24-24H209.9l95-95c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L135 239z"
        }
    ]
};

const FarArrowLeftLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowLeftLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7 239c-9.4 9.4-9.4 24.6 0 33.9L143 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-95-95L488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24H81.9l95-95c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239z"
        }
    ]
};

const FarArrowLeftToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowLeftToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-114.9 93.1-208 208-208 13.3 0 24-10.7 24-24S269.3 0 256 0C114.6 0 0 114.6 0 256s114.6 256 256 256c13.3 0 24-10.7 24-24s-10.7-24-24-24c-114.9 0-208-93.1-208-208zm231.7-121.6-112 104c-4.9 4.5-7.7 10.9-7.7 17.6s2.8 13 7.7 17.6l112 104c9.7 9 24.9 8.5 33.9-1.3s8.5-24.9-1.3-33.9L245.1 280H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H245.1l67.2-62.4c9.7-9 10.3-24.2 1.3-33.9s-24.2-10.3-33.9-1.3z"
        }
    ]
};

const FarArrowLeftToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowLeftToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 424c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24S0 74.7 0 88v336zm135.6-185.5c-4.8 4.5-7.6 10.9-7.6 17.5s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9l-92-86.6H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H212.5l91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128z"
        }
    ]
};

const FarArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9.8s8.8 24.8-.8 33.9L83.9 232H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H83.9l132.7 126.6c9.6 9.2 9.9 24.3.8 33.9s-24.3 9.9-33.9.8l-176-168z"
        }
    ]
};

const FarArrowPointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowPointer",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 272h85.8L48 110.4v246.4l59.9-68.4C117 278 130.2 272 144 272zM0 426V55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5 0 12.2-9.9 22.1-22.1 22.1H170.5l59.1 126.8c5.6 12 .4 26.3-11.6 31.9s-26.3.4-31.9-11.6l-59.4-127.5-88.1 100.8c-4.2 4.8-10.2 7.5-16.6 7.5-12.2 0-22-9.9-22-22z"
        }
    ]
};

const FarArrowProgress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowProgress",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM0 160C0 93.7 53.7 40 120 40h136V17.9C256 8 264 0 273.9 0c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8-9.9 0-17.9-8-17.9-17.9V88H120c-39.8 0-72 32.2-72 72s32.2 72 72 72h272c66.3 0 120 53.7 120 120 0 59.5-43.3 108.8-100 118.3-9.1 24.3-32.5 41.7-60 41.7-35.3 0-64-28.7-64-64s28.7-64 64-64c25.9 0 48.3 15.4 58.3 37.6 30.9-8.1 53.7-36.2 53.7-69.6 0-39.8-32.2-72-72-72H120C53.7 280 0 226.3 0 160zm123.3 264H160v-22.1c0-9.9 8-17.9 17.9-17.9 4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8-9.9 0-17.9-8-17.9-17.9V472h-36.7c-9.5 23.5-32.5 40-59.3 40-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40zM88 448a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm264 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarArrowRightArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRightArrowLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M103 497c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L424 408c13.3 0 24-10.7 24-24s-10.7-24-24-24H81.9l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 367c-9.4 9.4-9.4 24.6 0 33.9l96 96zm338-352c9.4-9.4 9.4-24.6 0-33.9L345 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55L24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24h342.1l-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96z"
        }
    ]
};

const FarArrowRightFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRightFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-114.9 93.1-208 208-208 13.3 0 24-10.7 24-24S269.3 0 256 0C114.6 0 0 114.6 0 256s114.6 256 256 256c13.3 0 24-10.7 24-24s-10.7-24-24-24c-114.9 0-208-93.1-208-208zm344.3-121.6c-9.7-9-24.9-8.5-33.9 1.3s-8.5 24.9 1.3 33.9l67.2 62.4H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h242.9l-67.2 62.4c-9.7 9-10.3 24.2-1.3 33.9s24.2 10.3 33.9 1.3l112-104c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104z"
        }
    ]
};

const FarArrowRightFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRightFromBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 273c9.4-9.4 9.4-24.6 0-33.9L377 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87-246.1.1c-13.3 0-24 10.7-24 24s10.7 24 24 24h246.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H88C39.4 32 0 71.4 0 120v272c0 48.6 39.4 88 88 88h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-22.1 0-40-17.9-40-40V120c0-22.1 17.9-40 40-40h80z"
        }
    ]
};

const FarArrowRightFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRightFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V88zm392.4 185.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9l92 86.6H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h211.5l-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z"
        }
    ]
};

const FarArrowRightLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRightLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 88v336c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zM505 239c9.4 9.4 9.4 24.6 0 33.9L369 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l95-95L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24h406.1l-95-95c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L505 239z"
        }
    ]
};

const FarArrowRightLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRightLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 273c9.4-9.4 9.4-24.6 0-33.9L369 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l95 95L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h406.1l-95 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273z"
        }
    ]
};

const FarArrowRightToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRightToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-114.9-93.1-208-208-208-13.3 0-24-10.7-24-24s10.7-24 24-24c141.4 0 256 114.6 256 256S397.4 512 256 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c114.9 0 208-93.1 208-208zM232.3 134.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9l67.2-62.4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h242.9l-67.2-62.4c-9.7-9-10.3-24.2-1.3-33.9s24.2-10.3 33.9-1.3z"
        }
    ]
};

const FarArrowRightToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRightToBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m217 401 128-128c9.4-9.4 9.4-24.6 0-33.9L217 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h246.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zM344 80h80c22.1 0 40 17.9 40 40v272c0 22.1-17.9 40-40 40h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c48.6 0 88-39.4 88-88V120c0-48.6-39.4-88-88-88h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24z"
        }
    ]
};

const FarArrowRightToCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRightToCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 56c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v160c0 13.3 10.7 24 24 24h96c4.4 0 8 3.6 8 8v240c0 13.3 10.7 24 24 24s24-10.7 24-24V248c0-28.2-20.9-51.6-48-55.4V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-32V56c0-30.9-25.1-56-56-56H344c-30.9 0-56 25.1-56 56v432c0 13.3 10.7 24 24 24s24-10.7 24-24V56zm32 40v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zM160.1 158.2c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9l42.1 38.3H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h145.9l-42.1 38.2c-9.8 8.9-10.5 24.1-1.6 33.9s24.1 10.5 33.9 1.6l88-80c5-4.5 7.9-11 7.9-17.8s-2.9-13.2-7.9-17.8l-88-80z"
        }
    ]
};

const FarArrowRightToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRightToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v336c0 13.3 10.7 24 24 24s24-10.7 24-24V88zM312.4 273.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9l92 86.6H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h211.5l-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z"
        }
    ]
};

const FarArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9.8s-8.8 24.8.8 33.9L364.1 232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h340.1L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9.8l176-168z"
        }
    ]
};

const FarArrowRotateLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRotateLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 224c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24s24 10.7 24 24v80.1l20-23.5C125 63.4 186.9 32 256 32c123.7 0 224 100.3 224 224S379.7 480 256 480c-50.4 0-97-16.7-134.4-44.8-10.6-8-12.7-23-4.8-33.6s23-12.7 33.6-4.8C179.8 418.9 216.3 432 256 432c97.2 0 176-78.8 176-176S353.2 80 256 80c-54.3 0-102.9 24.6-135.2 63.4l-.1.2L93.1 176H184c13.3 0 24 10.7 24 24s-10.7 24-24 24H40z"
        }
    ]
};

const FarArrowRotateRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowRotateRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472 224c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v80.1l-20-23.5C387 63.4 325.1 32 256 32 132.3 32 32 132.3 32 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8 10.6-8 12.7-23 4.8-33.6s-23-12.7-33.6-4.8C332.2 418.9 295.7 432 256 432c-97.2 0-176-78.8-176-176S158.8 80 256 80c54.3 0 102.9 24.6 135.2 63.4l.1.2 27.6 32.4H328c-13.3 0-24 10.7-24 24s10.7 24 24 24h144z"
        }
    ]
};

const FarArrowTrendDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowTrendDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 392c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v118.1L337 143c-9.4-9.4-24.6-9.4-33.9 0l-111 111L41 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 305c9.4 9.4 24.6 9.4 33.9 0l111-111 174.2 174H376c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarArrowTrendUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowTrendUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 120c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V177.9L337 369c-9.4 9.4-24.6 9.4-33.9 0l-111-111L41 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L175 207c9.4-9.4 24.6-9.4 33.9 0l111 111 174.2-174H376c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarArrowTurnDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowTurnDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 56c0-13.3 10.7-24 24-24s24 10.7 24 24v168c0 48.6-39.4 88-88 88H81.9l87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 305c-9.4-9.4-9.4-24.6 0-33.9L135 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87H424c22.1 0 40-17.9 40-40V56z"
        }
    ]
};

const FarArrowTurnDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowTurnDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v168c0 48.6 39.4 88 88 88h342.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9L377 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87H88c-22.1 0-40-17.9-40-40V56z"
        }
    ]
};

const FarArrowTurnDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowTurnDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 48C10.7 48 0 37.3 0 24S10.7 0 24 0h104c48.6 0 88 39.4 88 88v342.1l87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L209 505c-9.4 9.4-24.6 9.4-33.9 0L47 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87L168 88c0-22.1-17.9-40-40-40H24z"
        }
    ]
};

const FarArrowTurnUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowTurnUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h104c48.6 0 88-39.4 88-88V81.9l87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L168 424c0 22.1-17.9 40-40 40H24z"
        }
    ]
};

const FarArrowUp19 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUp19",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 56v120h24c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V89.3l-16.4 5.5c-12.6 4.2-26.2-2.6-30.4-15.2s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zm281 265a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm-17.9 126.2c-40-8.3-70.1-43.7-70.1-86.2 0-48.6 39.4-88 88-88s88 39.4 88 88c0 21.1-7.3 41.5-20.6 57.8l-56.8 69.4c-8.4 10.3-23.5 11.8-33.8 3.4s-11.8-23.5-3.4-33.8l8.7-10.6z"
        }
    ]
};

const FarArrowUp91 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUp91",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M424 80a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm88 40v2.5c-.6 20.2-7.9 39.7-20.9 55.3l-64.6 77.6c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8l15.5-18.7c-39.5-8.6-69.1-43.8-69.1-86 0-48.6 39.4-88 88-88s88 39.4 88 88zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zm313 273v120h24c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-86.7l-16.4 5.5c-12.6 4.2-26.2-2.6-30.4-15.2s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"
        }
    ]
};

const FarArrowUpAZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpAZ",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 32c9.1 0 17.4 5.1 21.5 13.3l80 160c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L461 199.6c-1.6.3-3.2.5-4.9.5h-85.3l-13.4 26.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l80-160C398.6 37.1 406.9 32 416 32zm-21.2 120h42.3L416 109.7 394.8 152zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zm209 249h128c9.4 0 18 5.5 21.9 14.2s2.3 18.7-4 25.8l-92.5 104H480c13.3 0 24 10.7 24 24s-10.7 24-24 24H352c-9.4 0-18-5.5-21.9-14.2s-2.3-18.7 4-25.8l92.5-104H352c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarArrowUpArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M529 377c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v342.1l-55-55c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V456c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39z"
        }
    ]
};

const FarArrowUpBigSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpBigSmall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 208V80h128v128H368zm-48 0c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v128zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V456c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39zm191 329h64v64h-64v-64zm-48 0v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarArrowUpFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c-114.9 0-208-93.1-208-208 0-13.3-10.7-24-24-24S0 242.7 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 114.9-93.1 208-208 208zM134.4 119.7c-9 9.7-8.5 24.9 1.3 33.9s24.9 8.5 33.9-1.3L232 85.1V328c0 13.3 10.7 24 24 24s24-10.7 24-24V85.1l62.4 67.2c9 9.7 24.2 10.3 33.9 1.3s10.3-24.2 1.3-33.9l-104-112C269 2.8 262.7 0 256 0s-13 2.8-17.6 7.7l-104 112z"
        }
    ]
};

const FarArrowUpFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpFromBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241 7c-9.4-9.4-24.6-9.4-33.9 0L79 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V328c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zM48 344c0-13.3-10.7-24-24-24S0 330.7 0 344v80c0 48.6 39.4 88 88 88h272c48.6 0 88-39.4 88-88v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40v-80z"
        }
    ]
};

const FarArrowUpFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241.5 39.6c-4.6-4.9-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1l86.6-92V328c0 13.3 10.7 24 24 24s24-10.7 24-24V116.5l86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136zM32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FarArrowUpFromGroundWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpFromGroundWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 352c13.3 0 24-10.7 24-24V81.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L305 7c-9.4-9.4-24.6-9.4-33.9 0L191 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V328c0 13.3 10.7 24 24 24zM80 430.1c-17.2 14.9-39 26.7-61.2 31.7C5.9 464.7-2.3 477.5.6 490.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zM192 192H64c-35.3 0-64 28.7-64 64v169c5.3-3.1 11.2-5.4 17.5-6.9 10.4-2.4 21.2-7.2 30.5-13.5V256c0-8.8 7.2-16 16-16h128v-48zm384 64c0-35.3-28.7-64-64-64H384v48h128c8.8 0 16 7.2 16 16v148.6c9.3 6.3 20.1 11.1 30.5 13.6 6.3 1.5 12.1 3.8 17.5 6.9V256z"
        }
    ]
};

const FarArrowUpFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.5 39.6c-4.6-4.9-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1l86.6-92V328c0 13.3 10.7 24 24 24s24-10.7 24-24V116.5l86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarArrowUpFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpFromSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M273 7c-9.4-9.4-24.6-9.4-33.9 0L127 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l71-71V328c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l71 71c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 7zM72 32C32.2 32 0 64.2 0 104v336c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72V104c0-39.8-32.2-72-72-72h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8c13.3 0 24 10.7 24 24v336c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h8c13.3 0 24-10.7 24-24S93.3 32 80 32h-8z"
        }
    ]
};

const FarArrowUpFromWaterPump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpFromWaterPump",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0C85.5 0 64 21.5 64 48v208c-35.3 0-64 28.7-64 64v105c5.3-3.1 11.2-5.4 17.5-6.9 10.4-2.4 21.2-7.2 30.5-13.5V320c0-8.8 7.2-16 16-16h448c8.8 0 16 7.2 16 16v84.6c9.3 6.3 20.1 11.1 30.5 13.6 6.3 1.5 12.1 3.8 17.5 6.9V320c0-35.3-28.7-64-64-64h-40V81.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L465 7c-9.4-9.4-24.6-9.4-33.9 0L351 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L424 256H288V48c0-26.5-21.5-48-48-48H112zm-.1 430.1c-9.1-8.1-22.8-8.1-31.9 0-17.2 14.9-39 26.7-61.2 31.7C5.9 464.7-2.3 477.5.6 490.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"
        }
    ]
};

const FarArrowUpLeftFromCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpLeftFromCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 0H24C10.7 0 0 10.7 0 24v160c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9L295 329c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L81.9 48H184c13.3 0 24-10.7 24-24S197.3 0 184 0zm104 64c-13.3 0-24 10.7-24 24s10.7 24 24 24c97.2 0 176 78.8 176 176s-78.8 176-176 176-176-78.8-176-176c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z"
        }
    ]
};

const FarArrowUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 96c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24s24-10.7 24-24V177.9L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-231-231H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H56z"
        }
    ]
};

const FarArrowUpLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpLong",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209 7c-9.4-9.4-24.6-9.4-33.9 0L39 143c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l95-95V488c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l95 95c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7z"
        }
    ]
};

const FarArrowUpRightAndArrowDownLeftFromCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpRightAndArrowDownLeftFromCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M295 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V168c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24s10.7 24 24 24h86.1L295 183zm-78 146c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L48 430.1V344c0-13.3-10.7-24-24-24S0 330.7 0 344v144c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H81.9L217 329z"
        }
    ]
};

const FarArrowUpRightDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpRightDots",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24c0 13.3 10.7 24 24 24h86.1L7 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l231-231V168c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24zm448 56a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-304-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-176 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm432-176a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarArrowUpRightFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpRightFromSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 24c0 13.3 10.7 24 24 24h102.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104v336c0 39.8 32.2 72 72 72h336c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24v128c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
        }
    ]
};

const FarArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328 96c13.3 0 24 10.7 24 24v240c0 13.3-10.7 24-24 24s-24-10.7-24-24V177.9L73 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l231-231H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h240z"
        }
    ]
};

const FarArrowUpShortWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpShortWide",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M111 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L49 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zm201 9h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128h240c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarArrowUpSmallBig = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpSmallBig",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 144V80h64v64h-64zm-48 0c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48v64zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V456c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39zm191 265h128v128H368V304zm-48 0v128c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarArrowUpSquareTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpSquareTriangle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 454.9c0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1 0-4.5 1.2-9 3.6-12.9l84.2-140.3c5.1-8.5 14.3-13.7 24.2-13.7s19.1 5.2 24.2 13.7L524.4 442c2.3 3.9 3.6 8.4 3.6 12.9zM368 80v96h96V80h-96zm94.4 352L416 354.6 369.6 432h92.8zM320 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96z"
        }
    ]
};

const FarArrowUpToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48c114.9 0 208 93.1 208 208 0 13.3 10.7 24 24 24s24-10.7 24-24C512 114.6 397.4 0 256 0S0 114.6 0 256c0 13.3 10.7 24 24 24s24-10.7 24-24c0-114.9 93.1-208 208-208zm121.6 231.7-104-112c-4.5-4.9-10.9-7.7-17.6-7.7s-13 2.8-17.6 7.7l-104 112c-9 9.7-8.5 24.9 1.3 33.9s24.9 8.5 33.9-1.3l62.4-67.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V245.1l62.4 67.2c9 9.7 24.2 10.3 33.9 1.3s10.3-24.2 1.3-33.9z"
        }
    ]
};

const FarArrowUpToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-142.5 87.6c-4.5-4.8-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1l86.6-92V440c0 13.3 10.7 24 24 24s24-10.7 24-24V228.5l86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136z"
        }
    ]
};

const FarArrowUpToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm185.5 135.6c-4.5-4.8-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1l86.6-92V456c0 13.3 10.7 24 24 24s24-10.7 24-24V244.5l86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136z"
        }
    ]
};

const FarArrowUpTriangleSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpTriangleSquare",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 32c9.9 0 19.1 5.2 24.2 13.7L524.4 186c2.3 3.9 3.6 8.4 3.6 12.9 0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1 0-4.5 1.2-9 3.6-12.9l84.2-140.3C396.9 37.2 406.1 32 416 32zm-48 400h96v-96h-96v96zm48-333.4L369.6 176h92.8L416 98.6zM320 432v-96c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96z"
        }
    ]
};

const FarArrowUpWideShort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpWideShort",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M111 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L49 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zm201 441c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H312zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H312zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24h240c13.3 0 24 10.7 24 24s-10.7 24-24 24H312z"
        }
    ]
};

const FarArrowUpZA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUpZA",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32h128c9.4 0 18 5.5 21.9 14.2s2.3 18.7-4 25.8l-92.5 104H480c13.3 0 24 10.7 24 24s-10.7 24-24 24H352c-9.4 0-18-5.5-21.9-14.2s-2.3-18.7 4-25.8l92.5-104H352c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-209 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zm273 233c9.1 0 17.4 5.1 21.5 13.3l80 160c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L461 439.6c-1.6.3-3.2.5-4.9.5h-85.3l-13.4 26.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l80-160c4.1-8.1 12.4-13.3 21.5-13.3zm-21.2 120h42.3L416 349.7 394.8 392z"
        }
    ]
};

const FarArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.4 39.4c-4.6-4.7-10.8-7.4-17.4-7.4s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8.8 33.9s24.8 8.8 33.9-.8L168 115.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V115.9l126.6 132.7c9.2 9.6 24.3 9.9 33.9.8s9.9-24.3.8-33.9l-168-176z"
        }
    ]
};

const FarArrowsCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsCross",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h70.1L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l359-359V184c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24H296zM41 39c-9.4-9.3-24.6-9.3-34 0s-9.3 24.6 0 34l160.4 160.4 33.9-33.9L41 39zm205.6 273.6L366.1 432H296c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24s-24 10.7-24 24v70.1L280.6 278.6l-33.9 33.9z"
        }
    ]
};

const FarArrowsDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsDownToLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M552 432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24zm17-159c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-63 63L472 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v246.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L431 377c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l104-104zm-320-34c-9.4-9.4-24.6-9.4-33.9 0l-63 63-.1-246c0-13.3-10.7-24-24-24s-24 10.7-24 24v246.1L41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L111 377c9.4 9.4 24.6 9.4 33.9 0L249 273c9.4-9.4 9.4-24.6 0-33.9z"
        }
    ]
};

const FarArrowsDownToPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsDownToPeople",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 24c0-13.3 10.7-24 24-24s24 10.7 24 24v118.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24zm295 95c9.4-9.4 24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24s24 10.7 24 24v118.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9zm81 137a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-16 208h32v-63.5c-2-.3-4.1-.5-6.2-.5h-19.6c-2.1 0-4.2.2-6.2.5V464zm98.9 27.4-18.9-35V480c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-23.7l-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8l-18.9-35V400c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32v-39.7l-18.9 35c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8l-18.9-35V480c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32v-23.7l-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3C72 369.8 101.8 352 134.2 352h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8zM280 200a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm24 104.5V384h32v-79.5c-2-.3-4.1-.5-6.2-.5h-19.6c-2.1 0-4.2.2-6.2.5zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-16 208h32v-63.5c-2-.3-4.1-.5-6.2-.5h-19.6c-2.1 0-4.2.2-6.2.5V464z"
        }
    ]
};

const FarArrowsFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241 7c-9.4-9.4-24.6-9.4-33.9 0L135 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V168c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zm7 337c0-13.3-10.7-24-24-24s-24 10.7-24 24v86.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V344zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FarArrowsFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241 7c-9.4-9.4-24.6-9.4-33.9 0L135 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V168c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zm7 337c0-13.3-10.7-24-24-24s-24 10.7-24 24v86.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V344zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarArrowsLeftRightToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsLeftRightToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 64c13.3 0 24 10.7 24 24v336c0 13.3-10.7 24-24 24S0 437.3 0 424V88c0-13.3 10.7-24 24-24zm217 71c9.4 9.4 9.4 24.6 0 33.9l-63 63h284.1l-63-63c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l104 104c9.4 9.4 9.4 24.6 0 33.9L433 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l63-63H178l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L207 135c9.4-9.4 24.6-9.4 33.9 0zm399-47v336c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarArrowsLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 273c9.4-9.4 9.4-24.6 0-33.9l-96-96c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55H81.9l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55H430l-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96z"
        }
    ]
};

const FarArrowsMaximize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsMaximize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h70.1L256 222.1 113.9 80H184c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24v128c0 13.3 10.7 24 24 24s24-10.7 24-24v-70.1L222.1 256 80 398.1V328c0-13.3-10.7-24-24-24s-24 10.7-24 24v128c0 13.3 10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24h-70.1L256 289.9 398.1 432H328c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24s-24 10.7-24 24v70.1L289.9 256 432 113.9V184c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24H328z"
        }
    ]
};

const FarArrowsMinimize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsMinimize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M23 23c9.4-9.4 24.6-9.4 33.9 0l119 119V56c0-13.3 10.7-24 24-24s24 10.7 24 24v144c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h86.1L23 57c-9.4-9.4-9.4-24.6 0-33.9zm466 0c9.4 9.4 9.4 24.6 0 33.9l-119 119h86c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24s24 10.7 24 24v86.1L455 23c9.4-9.4 24.6-9.4 33.9 0zM56 336c-13.3 0-24-10.7-24-24s10.7-24 24-24h144c13.3 0 24 10.7 24 24v144c0 13.3-10.7 24-24 24s-24-10.7-24-24v-86.1L57 489c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l119-119H56zm232-24c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24h-86.1L489 455c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-119-119V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V312z"
        }
    ]
};

const FarArrowsRepeat1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsRepeat1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M22.5 280C9.3 279.1-.8 267.7 0 254.5l.5-8C5.6 166.4 72 104 152.2 104h213.9L311 49c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l96 96c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H152.2c-54.9 0-100.4 42.7-103.8 97.5l-.5 8c-.8 13.2-12.2 23.3-25.5 22.5zm467-47.9c13.2.8 23.3 12.2 22.5 25.5l-.5 8C506.4 345.6 440 408 359.8 408H145.9l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 401c-6.9-6.9-8.9-17.2-5.2-26.2S78.3 360 88 360h271.8c54.9 0 100.4-42.7 103.8-97.5l.5-8c.8-13.2 12.2-23.3 25.4-22.5zM288 216v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c-10 0-19.4-6.4-22.8-16.4-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"
        }
    ]
};

const FarArrowsRepeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsRepeat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 254.5c-.8 13.2 9.2 24.6 22.5 25.5s24.6-9.2 25.5-22.5l.5-8c3.4-54.8 48.8-97.5 103.7-97.5h213.9l-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-96-96c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55H152.2C72 104 5.6 166.4.5 246.5l-.5 8zm511.9 3c.8-13.2-9.2-24.6-22.5-25.5s-24.6 9.2-25.4 22.5l-.5 8c-3.4 54.8-48.9 97.5-103.8 97.5H145.9l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 367c-9.4 9.4-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55h213.9c80.3 0 146.7-62.4 151.7-142.5l.5-8z"
        }
    ]
};

const FarArrowsRetweet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsRetweet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145 71c-9.4-9.4-24.6-9.4-33.9 0L23 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47V328c0 48.6 39.4 88 88 88H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-22.1 0-40-17.9-40-40V145.9l47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L145 71zm167 25c-13.3 0-24 10.7-24 24s10.7 24 24 24h136c22.1 0 40 17.9 40 40v182.1l-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l88 88c9.4 9.4 24.6 9.4 33.9 0l88-88c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47V184c0-48.6-39.4-88-88-88H312z"
        }
    ]
};

const FarArrowsRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsRotate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 200c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24s10.7-24 24-24h86.1L362 123.9C333.8 95.8 295.7 80 256 80c-72.7 0-135.2 44.1-162 107.1-5.2 12.2-19.3 17.9-31.5 12.7s-17.9-19.3-12.7-31.5C83.9 88.2 163.4 32 256 32c52.5 0 102.8 20.8 139.9 57.9l52.1 52.2V56c0-13.3 10.7-24 24-24s24 10.7 24 24v144zM40 288h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H97.9l52.1 52.1c28.2 28.1 66.3 43.9 106 43.9 72.6 0 135-43.9 161.9-106.8 5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5C427.8 424 348.5 480 256 480c-52.5 0-102.8-20.8-139.9-57.9L64 369.9V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarArrowsSpin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsSpin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M257.1 87.5c-11.3 0-22.4 1.1-33.1 3.3V42.1c10.8-1.7 21.9-2.5 33.1-2.5 56 0 107 21.3 145.4 56.2l35.1-35.1c10.1-10.1 27.3-2.9 27.3 11.3v105.4c0 8.8-7.2 16-16 16H343.5c-14.3 0-21.4-17.2-11.3-27.3l36.3-36.3c-29.6-26.3-68.7-42.2-111.4-42.2zm-127.2 58.4c-25.4 29.4-40.7 67.8-40.7 109.7 0 11.1 1.1 22 3.1 32.5H43.6c-1.6-10.6-2.4-21.4-2.4-32.5 0-55.2 20.7-105.5 54.7-143.7L60.7 76.7c-10.1-10.1-3-27.3 11.3-27.3h105.4c8.8 0 16 7.2 16 16v105.3c0 14.3-17.2 21.4-27.3 11.3l-36.2-36.2zm52.2 202.4-34.6 34.6c29.4 25.4 67.8 40.7 109.7 40.7 10.5 0 20.9-1 30.9-2.8v48.6c-10.1 1.4-20.4 2.2-30.9 2.2-55.2 0-105.5-20.7-143.7-54.7l-36.8 36.7c-10.1 10.1-27.3 2.9-27.3-11.3V336.9c0-8.8 7.2-16 16-16h105.4c14.3 0 21.4 17.2 11.3 27.3zm166.2-16L383 367c26.3-29.6 42.2-68.7 42.2-111.4 0-10.8-1-21.3-3-31.5h48.7c1.5 10.3 2.3 20.8 2.3 31.5 0 56-21.3 107-56.2 145.4l36.7 36.7c10.1 10.1 2.9 27.3-11.3 27.3H336.9c-8.8 0-16-7.2-16-16V343.5c0-14.3 17.2-21.4 27.3-11.3z"
        }
    ]
};

const FarArrowsSplitUpAndLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsSplitUpAndLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241 137c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L303 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V392c0 39.8 32.2 72 72 72h72c13.3 0 24 10.7 24 24s-10.7 24-24 24h-72c-66.3 0-120-53.7-120-120v-8c0-39.8-32.2-72-72-72H81.9l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 305c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l96-96c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55H224c27 0 51.9 8.9 72 24v-206l-55 55z"
        }
    ]
};

const FarArrowsToCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsToCircle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7 7c9.4-9.3 24.6-9.3 34 0l119 119V88c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h38.1L7 41c-9.3-9.4-9.3-24.6 0-34zm626 0c9.4 9.4 9.4 24.6 0 33.9l-119 119h38c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24v38.1L599 7c9.4-9.4 24.6-9.4 33.9 0zM256 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm176 168v-96c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-38.1L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-119-119V424c0 13.3-10.7 24-24 24s-24-10.7-24-24zm-224 0c0 13.3-10.7 24-24 24s-24-10.7-24-24v-38.1L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l119-119H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96z"
        }
    ]
};

const FarArrowsToDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsToDot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v86.1L201 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31-.1-86zm153 321c9.4-9.4 9.4-24.6 0-33.9l-31-31h86c13.3 0 24-10.7 24-24s-10.7-24-24-24h-86.1l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zm-145-89a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-175-89c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-86.1.1c-13.3 0-24 10.7-24 24s10.7 24 24 24h86.1L79 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72zm54 266c9.4 9.4 24.6 9.4 33.9 0l31-31v86.1c0 13.3 10.7 24 24 24s24-10.7 24-24v-86.2l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9z"
        }
    ]
};

const FarArrowsToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m241 185 72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v86.1L169 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM0 256a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM313 399l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-86.1l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"
        }
    ]
};

const FarArrowsToEye = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsToEye",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M49 15c-9.4-9.3-24.6-9.3-34 0s-9.3 24.6 0 34l63 63H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h96c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24s-24 10.7-24 24v38.1L49 15zm271 337c-64.5 0-113.8-52.1-138.5-96 24.7-43.9 74-96 138.5-96s113.8 52.1 138.5 96c-24.7 43.9-74 96-138.5 96zm0-240c-97.3 0-161.4 81.6-186.5 131.9-3.8 7.6-3.8 16.5 0 24.2C158.6 318.4 222.7 400 320 400s161.4-81.6 186.5-131.9c3.8-7.6 3.8-16.5 0-24.2C481.4 193.6 417.3 112 320 112zm305-97c-9.4-9.4-24.6-9.4-33.9 0l-63 63V40c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24h96c13.3 0 24-10.7 24-24s-10.7-24-24-24h-38.2l63-63c9.4-9.4 9.4-24.6 0-33.9zM49 497l63-63v38c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h38.1L15 463c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm576 0c9.4-9.4 9.4-24.6 0-33.9l-63-63h38c13.3 0 24-10.7 24-24s-10.7-24-24-24h-96c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-38.2l63 63c9.4 9.4 24.6 9.4 33.9 0zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FarArrowsToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m241 185 72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v86.1L169 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM0 256c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm241 71c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-86.1l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z"
        }
    ]
};

const FarArrowsTurnRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsTurnRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M294.4 7.7c9-9.7 24.2-10.3 33.9-1.3l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9l67.2-62.4H120c-39.8 0-72 32.2-72 72v40c0 13.3-10.7 24-24 24S0 277.3 0 264v-40c0-66.3 53.7-120 120-120h242.9l-67.2-62.4c-9.7-9-10.3-24.2-1.3-33.9zm-96 256c9-9.7 24.2-10.3 33.9-1.3l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9l67.2-62.4H88c-22.1 0-40 17.9-40 40v40c0 13.3-10.7 24-24 24S0 501.3 0 488v-40c0-48.6 39.4-88 88-88h178.9l-67.2-62.4c-9.7-9-10.3-24.2-1.3-33.9z"
        }
    ]
};

const FarArrowsTurnToDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsTurnToDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M255 31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39 174.1.1c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40c0-22.1-17.9-40-40-40H249.9l39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9l80-80zm2 256 80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H88c-22.1 0-40 17.9-40 40v40c0 13.3-10.7 24-24 24S0 501.3 0 488v-40c0-48.6 39.4-88 88-88h174.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm127 97a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM64 192a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"
        }
    ]
};

const FarArrowsUpDownLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsUpDownLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M273 7c-9.4-9.4-24.6-9.4-33.9 0L167 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V232h-150l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31H232v150.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V280h150l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H280v-150l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 7z"
        }
    ]
};

const FarArrowsUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsUpDown",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177 7c-9.4-9.4-24.6-9.4-33.9 0L47 103c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55v348.2L81 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V81.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 7z"
        }
    ]
};

const FarArrowsUpToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarArrowsUpToLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 80h528c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 32 0 42.7 0 56s10.7 24 24 24zM7 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63L104 456c0 13.3 10.7 24 24 24s24-10.7 24-24V209.9l63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L145 135c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7L7 239zm320 34c9.4 9.4 24.6 9.4 33.9 0l63-63 .1 246c0 13.3 10.7 24 24 24s24-10.7 24-24V209.9l63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L465 135c-9.4-9.4-24.6-9.4-33.9 0L327 239c-9.4 9.4-9.4 24.6 0 33.9z"
        }
    ]
};

const FarAsterisk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAsterisk",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c13.3 0 24 10.7 24 24v156.9l131.4-81.3c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33l-135 83.6 135 83.6c11.3 7 14.8 21.8 7.8 33s-21.8 14.7-33 7.8L216 299.1V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V299.1L36.6 380.4c-11.3 7-26.1 3.5-33-7.8s-3.5-26.1 7.8-33l135-83.6-135-83.6c-11.3-7-14.8-21.8-7.8-33s21.8-14.8 33-7.8L168 212.9V56c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarAt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c13.3 0 24 10.7 24 24s-10.7 24-24 24C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256v28c0 50.8-41.2 92-92 92-31.1 0-58.7-15.5-75.3-39.2-22 24.1-53.6 39.2-88.7 39.2-66.3 0-120-53.7-120-120s53.7-120 120-120c28.8 0 55.2 10.1 75.8 27 4.3-6.6 11.7-11 20.2-11 13.3 0 24 10.7 24 24v108c0 24.3 19.7 44 44 44s44-19.7 44-44v-28c0-114.9-93.1-208-208-208zm72 208a72 72 0 1 0-144 0 72 72 0 1 0 144 0z"
        }
    ]
};

const FarAtomSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAtomSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M89.6 422.4c7.9 7.9 31.4 16.9 80.4.6 13.2-4.4 27.2-10.4 41.6-17.9-18.9-14.4-37.7-30.8-55.8-48.9s-34.5-36.9-48.9-55.8C99.4 314.8 93.4 328.8 89 342c-16.3 49-7.3 72.5.6 80.4zM76.8 256C27.6 173.9 16.5 94.9 55.7 55.7S173.9 27.6 256 76.8c82.1-49.2 161.1-60.3 200.3-21.1s28.1 118.2-21.1 200.3c49.2 82.1 60.3 161.1 21.1 200.3S338.1 484.4 256 435.2c-82.1 49.2-161.1 60.3-200.3 21.1S27.6 338.1 76.8 256zm30.2-44.4c14.4-18.9 30.8-37.7 48.9-55.8s36.9-34.5 55.8-48.9c-14.4-7.5-28.4-13.5-41.6-17.9-49-16.3-72.5-7.3-80.4.6S72.8 121 89.1 170c4.4 13.2 10.4 27.2 17.9 41.6zM256 134c-22.1 15.5-44.5 34.1-66.2 55.8S149.5 233.9 134 256c15.5 22.1 34.1 44.5 55.8 66.2s44.1 40.3 66.2 55.8c22.1-15.5 44.5-34.1 66.2-55.8s40.3-44.1 55.8-66.2c-15.5-22.1-34.1-44.5-55.8-66.2S278.1 149.5 256 134zm149 77.7c7.5-14.4 13.5-28.4 17.9-41.6 16.3-49 7.3-72.5-.6-80.4s-31.4-16.9-80.4-.6c-13.2 4.4-27.2 10.4-41.6 17.9 18.9 14.4 37.7 30.8 55.8 48.9s34.5 36.9 48.9 55.8zm0 88.7c-14.4 18.9-30.8 37.7-48.9 55.8s-36.9 34.5-55.8 48.9c14.4 7.5 28.4 13.5 41.6 17.9 49 16.3 72.5 7.3 80.4-.6s16.9-31.4.6-80.4c-4.4-13.2-10.4-27.2-17.9-41.6zM224 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarAtom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAtom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M306.3 417.2c-16.3-4.7-33.1-10.9-50.3-18.4-17.1 7.5-34 13.6-50.3 18.4 18.4 38.3 37.4 46.8 50.3 46.8s31.9-8.5 50.3-46.8zM293 325.7c14.8-8.9 28.7-18.1 41.4-27.6 1-13.5 1.6-27.6 1.6-42.1s-.5-28.6-1.6-42.1c-12.8-9.4-26.6-18.7-41.4-27.6-12.5-7.5-24.9-14.2-37-20.2-12.1 6-24.5 12.7-37 20.2-14.8 8.9-28.7 18.1-41.4 27.6-1 13.5-1.6 27.6-1.6 42.1s.5 28.6 1.6 42.1c12.8 9.4 26.6 18.7 41.4 27.6 12.5 7.5 24.9 14.2 37 20.2 12.1-6 24.5-12.7 37-20.2zm120.5-32.2c-10.2 10.2-21.3 20.2-33.4 29.9-2.4 20.1-5.8 39.2-10.3 57 37.2 2.2 51.9-9.1 57.8-19.7 6.5-11.7 8.2-32.8-14.1-67.2zM469.6 128c20.7 37.1 9.4 82.8-23.6 128 33 45.2 44.3 90.9 23.6 128-20.2 36.3-62.5 49.3-115.2 43.2-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128 20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2zM84.4 360.7c5.9 10.6 20.6 22 57.8 19.7-4.5-17.8-7.9-36.9-10.3-57-12-9.7-23.2-19.8-33.4-29.9-22.3 34.3-20.7 55.5-14.1 67.2zm14.1-142.2c10.2-10.2 21.3-20.2 33.4-29.9 2.4-20.1 5.8-39.2 10.3-57-37.2-2.3-51.9 9.1-57.8 19.7-6.5 11.7-8.2 32.8 14.1 67.2zM256 113.2c17.1-7.5 34-13.6 50.3-18.4C287.9 56.5 268.9 48 256 48s-31.9 8.5-50.3 46.8c16.3 4.7 33.1 10.9 50.3 18.4zm124.2 75.4c12 9.7 23.2 19.8 33.4 29.9 22.3-34.3 20.6-55.5 14.1-67.2-5.9-10.6-20.6-22-57.8-19.7 4.5 17.8 7.9 36.9 10.3 57zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarAudioDescriptionSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAudioDescriptionSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9l-38-29.8zM134.4 80H544c8.8 0 16 7.2 16 16v317.6l-95.4-74.8C493 322.1 512 291.3 512 256c0-53-43-96-96-96h-56c-13.3 0-24 10.7-24 24v54L134.4 80zm285.5 223.8L384 275.7V208h32c26.5 0 48 21.5 48 48 0 25.2-19.4 45.8-44.1 47.8zM487.4 480l-60.9-48H96c-8.8 0-16-7.2-16-16V159l-48-37.8V416c0 35.3 28.7 64 64 64h391.4zM130.5 317.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l9.4-18.9H265l9.4 18.9c5.9 11.9 20.3 16.7 32.2 10.7 3-1.5 5.5-3.5 7.5-5.9l-80.9-63.8h-30.3l8.6-17.2-38.5-30.3-42.5 85z"
        }
    ]
};

const FarAudioDescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAudioDescription",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm213.5 77.3 72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9h-82.3l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96h-56c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48h-32z"
        }
    ]
};

const FarAustralSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAustralSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.1 46.7C242.4 37.8 233.7 32 224 32s-18.4 5.8-22.1 14.7L127.4 224H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h83.2l-20.1 48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h42.9l-33 78.7c-5.1 12.2.6 26.3 12.8 31.4s26.3-.6 31.4-12.8L119 368h210l40.9 97.3c5.1 12.2 19.2 18 31.4 12.8s18-19.2 12.8-31.4l-33-78.7H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-63.1l-20.2-48H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H320.6L246.1 46.7zM268.5 224h-89L224 118l44.5 106zm-109.2 48h129.4l20.2 48H139.2l20.2-48z"
        }
    ]
};

const FarAvocado = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAvocado",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 144c0 29.9-13.6 56.5-35.1 74.2-24.2 19.9-47.3 49.3-54.7 86.9-8.9 45.7-29.5 88.5-53.1 112-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c23.6-23.6 66.3-44.2 112-53.1 37.6-7.4 67-30.4 86.9-54.7 17.8-21.4 44.4-35 74.3-35 53 0 96 43 96 96zm-42.7 170.3c4.6-23.5 19.6-43.9 38.1-59.1C491.5 228.9 512 188.8 512 144 512 64.5 447.5 0 368 0c-44.8 0-84.9 20.5-111.3 52.6-15.2 18.5-35.6 33.5-59.1 38.1-51.9 10.2-104.5 34-136.7 66.3-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c32.3-32.3 56.1-84.9 66.3-136.7zm-138.1 32.9c41.7-41.7 49.1-102.1 16.4-134.8s-93-25.3-134.8 16.4-49.1 102.1-16.4 134.8 93 25.3 134.8-16.4z"
        }
    ]
};

const FarAwardSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAwardSimple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2.7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3l16.1 8.7c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4.3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3.7-2.3 1.7-3 3l-8.7 16.2c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9.3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3.4c-20.8.5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1l-9.5-15.7c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3l8.7-16c10-18.2 29.3-29.4 50-28.9l18.3.4c1.4 0 2.9-.3 4.1-1.1L163 8.1zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6-20.5-12.5 20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3.4c2.8.1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3.4c-10.6.3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM64.4 492.4 88 390.1c11.7 5.2 24.5 7.9 37.8 7.6l11.1-.3 9.5 5.8c28 17 63.1 17 91.1 0l9.5-5.8 11.1.3c13.3.3 26.1-2.4 37.8-7.6l23.6 102.3c1.4 5.9-.7 12-5.3 15.9s-11 4.8-16.6 2.4L192 465.4 86.3 510.7c-5.5 2.4-11.9 1.4-16.6-2.4s-6.7-10-5.3-15.9z"
        }
    ]
};

const FarAward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAward",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2.7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3l16.1 8.7c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4.3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3.7-2.3 1.7-3 3l-8.7 16.2c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9.3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3.4c-20.8.5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1l-9.5-15.7c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3l8.7-16c10-18.2 29.3-29.4 50-28.9l18.3.4c1.4 0 2.9-.3 4.1-1.1L163 8.1zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6-20.5-12.5 20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3.4c2.8.1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3.4c-10.6.3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM1.3 441.8l41.2-97.9 4.5 8.2c15.7 28.7 46.1 46.3 78.9 45.5l11.1-.3 9.5 5.8c8 4.9 16.7 8.4 25.6 10.5l-37.3 88.5c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2l-32.3-49.1-56.1 8.3c-5.7.8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L212 413.7c8.9-2.1 17.5-5.6 25.5-10.5l9.5-5.8 11.1.3c32.7.8 63.2-16.8 78.9-45.5l4.5-8.2 41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
        }
    ]
};

const FarAxeBattle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAxeBattle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120.8 70.4c15 20 39.3 40.8 79.2 51.1v49.2c-57.2-11.6-94.4-40.5-117.6-71.5-3.1-4.2-6.2-8.6-9.2-13.3C57.2 119.3 48 156.7 48 192c0 36.8 10 76.1 27.4 110.7 4.4-6.6 9-12.9 13.8-18.8l37.3 30.3c-13.6 16.8-25 36.8-30.9 57.8-1.5 5.8-6.1 10.4-11.9 11.7s-12-.7-15.8-5.3c-4.4-5.3-8.7-10.9-12.8-16.6l-1-1.4c-1.1-1.6-2.3-3.3-3.4-4.9l-.2-.3C18.6 307.4 0 247.9 0 192 0 136.2 18.5 77.4 50 29.8l.7-1c2.1-3.1 4.2-6.1 6.3-9.1l.5-.7c3.3-4.5 6.7-8.9 10.2-13.2C71.8.9 78.4-1.1 84.5.7 90.6 2.5 95 7.7 95.8 14c.9 6.4 2.6 12.8 4.7 19l.2.6c.6 1.7 1.2 3.3 1.9 5l.1.2c4.6 11.4 11 22.2 18 31.7zm5.6 243.7-37.2-30.3c23.4-28.8 59.1-57.3 110.8-69.5V264c-34.2 10.7-57.6 30.4-73.6 50.1zM312 170.7v-49.2c40-10.3 64.3-31.1 79.3-51.1 7.1-9.5 13.4-20.3 18-31.7l.1-.2c.7-1.6 1.3-3.3 1.9-5l.2-.6c2.2-6.2 3.8-12.6 4.7-19 .8-6.3 5.3-11.5 11.3-13.3 6.1-1.8 12.7.2 16.8 5.1 3.5 4.3 6.9 8.7 10.2 13.2l.5.7c2.2 3 4.3 6 6.3 9.1l.7 1c27.1 41.1 44.6 90.5 48.9 139.2L488 192l23.1 23.1c-4.3 48.9-22 98.9-49.4 140l-.2.3c-1.1 1.7-2.2 3.3-3.4 4.9l-1 1.4c-4.1 5.7-8.3 11.3-12.8 16.6-3.9 4.6-10 6.6-15.8 5.3s-10.5-5.9-11.9-11.7c-5.9-21-17.3-41-30.9-57.8-15.9-19.6-39.4-39.4-73.7-50.1v-49.7c51.7 12.3 87.5 40.7 110.9 69.5 4.8 5.9 9.4 12.2 13.8 18.8 11.1-22.1 19.3-46.2 23.6-70.4l-6.3-6.3c-18.7-18.7-18.7-49.1 0-67.9l6.3-6.3c-4.1-22.6-11.5-45-21.5-65.9-3 4.7-6 9.2-9.2 13.3-23.2 31-60.5 59.9-117.7 71.5zM280 56v432c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarAxe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarAxe",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M486.6 9.4c-12.5-12.5-32.8-12.5-45.3 0L408 42.7 374.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3L384 301.3V384c0 17.7 14.3 32 32 32 123.7 0 224-100.3 224-224 0-17.7-14.3-32-32-32h-82.7l-56-56 33.4-33.4c12.5-12.5 12.5-32.8 0-45.3l-16-16zM305.4 267.9l-61.3-61.3L9.4 441.4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l234.7-234.8zM491.3 194c9 9 21.2 14.1 33.9 14.1h66c-7.6 84.4-74.8 151.7-159.3 159.3v-66c0-12.7-5.1-24.9-14.1-33.9L278.6 128 352 54.6l139.3 139.3z"
        }
    ]
};

const FarB = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarB",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h140c68.5 0 124-55.5 124-124 0-48.9-28.3-91.1-69.3-111.3 23-22.5 37.3-53.9 37.3-88.7 0-68.5-55.5-124-124-124H56zm108 200H48V88c0-4.4 3.6-8 8-8h108c42 0 76 34 76 76s-34 76-76 76zM48 280h148c42 0 76 34 76 76s-34 76-76 76H56c-4.4 0-8-3.6-8-8V280z"
        }
    ]
};

const FarBabyCarriage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBabyCarriage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M138.9 22.9 256 192h144v-40c0-30.9 25.1-56 56-56h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32c-4.4 0-8 3.6-8 8v72c0 28-6.1 55.6-17.7 81.1-11.6 25.5-28.6 48.4-49.5 67.5-21 19.1-45.6 34-72.5 44.1S252.8 432 224 432s-57.4-5.2-84.3-15.3-51.5-25-72.5-44.1-37.9-42-49.5-67.5C6.1 279.6 0 252 0 224v-32h.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM56.1 272c1.5 4.5 3.3 8.9 5.3 13.2 8.8 19.4 21.8 37.1 38.2 51.9s35.7 26.6 57.1 34.7 44.2 12.2 67.4 12.2 46-4.1 67.4-12.2 40.8-19.8 57.1-34.7 29.3-32.5 38.2-51.9c2-4.3 3.7-8.8 5.3-13.2 3.6-10.4 6-21.1 7.2-32H48.9c1.2 10.9 3.6 21.6 7.2 32z"
        }
    ]
};

const FarBaby = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBaby",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM107.3 180.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l18.7 18.7c12.8 12.8 27.5 23.4 43.4 31.5 8.1 4.1 13.1 12.4 13.1 21.4v13H288v-13c0-9 5.1-17.3 13.1-21.4 15.9-8.1 30.6-18.6 43.4-31.5l18.7-18.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-18.7 18.7c-26 26-61.2 40.6-97.9 40.6s-72-14.6-97.9-40.6l-18.7-18.7zm197.3 160.8-24.1 21.1 23.5 30.3c6.8 8.8 6.7 21.1-.2 29.7L291.5 438c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l32-40c4.6-5.8 4.7-14 .1-19.8l-44.1-56.7zm-137 21.1-24.1-21.1-44.1 56.7c-4.5 5.8-4.5 14 .1 19.8l32 40c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-12.3-15.4c-6.9-8.7-7-21-.2-29.7l23.6-30.3zM50.7 146.7c25-25 65.5-25 90.5 0l18.8 18.8c17 17 40 26.5 64 26.5s47-9.5 64-26.5l18.7-18.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L378.5 256c-12.9 12.9-27.2 23.9-42.5 33.1v14.6l50.5 65c18.2 23.4 18 56.2-.5 79.3l-32 40c-22.1 27.6-62.4 32.1-90 10s-32.1-62.4-10-90l.5-.6-5.8-7.4h-49.4l-5.8 7.4.5.6c22.1 27.6 17.6 67.9-10 90s-67.9 17.6-90-10l-32-40c-18.5-23.1-18.7-55.9-.5-79.3l50.5-65v-14.6c-15.4-9.2-29.7-20.3-42.5-33.1l-18.8-18.7c-25-25-25-65.5 0-90.5z"
        }
    ]
};

const FarBackpack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBackpack",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48h64c4.4 0 8 3.6 8 8v24h-80V56c0-4.4 3.6-8 8-8zm-56 8v24h-8C57.3 80 0 137.3 0 208v240c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V208c0-70.7-57.3-128-128-128h-8V56c0-30.9-25.1-56-56-56h-64c-30.9 0-56 25.1-56 56zm232 408V312c0-39.8-32.2-72-72-72H152c-39.8 0-72 32.2-72 72v152H64c-8.8 0-16-7.2-16-16V208c0-44.2 35.8-80 80-80h192c44.2 0 80 35.8 80 80v240c0 8.8-7.2 16-16 16h-16zm-240 0v-64h192v64H128zm16-304c-13.3 0-24 10.7-24 24s10.7 24 24 24h160c13.3 0 24-10.7 24-24s-10.7-24-24-24H144zm176 192H128v-40c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24v40z"
        }
    ]
};

const FarBackwardFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBackwardFast",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 424c0 13.3 10.7 24 24 24s24-10.7 24-24V287.9l174.6 152.7c5.4 4.8 12.4 7.4 19.6 7.4 16.5 0 29.8-13.3 29.8-29.8V287.9l174.6 152.7c5.4 4.8 12.4 7.4 19.6 7.4 16.5 0 29.8-13.3 29.8-29.8V93.8c0-16.5-13.3-29.8-29.8-29.8-7.2 0-14.2 2.6-19.6 7.4L288 224.1V93.8c0-16.5-13.3-29.8-29.8-29.8-7.2 0-14.2 2.6-19.6 7.4L64 224.1V88c0-13.3-10.7-24-24-24S16 74.7 16 88v336zm448-290.1v244.2L324.4 256 464 133.9zM240 378.1 100.4 256 240 133.9v244.2z"
        }
    ]
};

const FarBackwardStep = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBackwardStep",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 88c0-13.3-10.7-24-24-24S32 74.7 32 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V318.9l176.7 123.7c5.1 3.5 11.1 5.4 17.3 5.4 16.6 0 30.1-13.5 30.1-30.1V94.1C304 77.5 290.5 64 273.9 64c-6.2 0-12.2 1.9-17.3 5.4L80 193.1V88zm0 172.3v-8.6l176-123.2v255L80 260.3z"
        }
    ]
};

const FarBackward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBackward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 94c0-16.6-13.5-30-30-30-6.3 0-12.5 2-17.6 5.7L9.9 236.6C3.7 241.1 0 248.3 0 256s3.7 14.9 9.9 19.4l230.4 166.9c5.1 3.7 11.3 5.7 17.6 5.7 16.6 0 30-13.4 30-30v-99.1l176.8 123.7c5.1 3.5 11.1 5.4 17.3 5.4 16.6 0 30.1-13.5 30.1-30.1V94.1C512 77.5 498.5 64 481.9 64c-6.2 0-12.2 1.9-17.3 5.4L288 193.1V94zm0 157.7 176-123.2v255L288 260.3v-8.6zM64.9 256 240 129.2v253.6L64.9 256z"
        }
    ]
};

const FarBacon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBacon",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M441.7 216c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2c-44.4 64.6-96.7 140.7-229.9 207.3-12.3 6.2-27.2 3.7-36.9-6l-96-96c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5c118.4-59.1 163.2-124.3 205.6-186l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9 33.4-29.5 75.8-53.6 135.9-70.8 11.2-3.2 23.2-.1 31.4 8.1l96 96c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2zm-178.8-19.6C221.2 257.1 173.7 326 58.8 388.1l24.3 24.3C197.6 352.8 242.8 287 284.5 226.3l2.3-3.3c21.9-31.9 43.9-63.5 75.1-90.9 26.6-23.5 59.5-43.6 104.2-59.3l-22.7-22.7c-49 15.1-82.4 35.1-108.3 58-27.8 24.5-47.8 53-69.9 85.1l-2.3 3.4zM106.8 436.1l24.3 24.3c114.5-59.7 159.8-125.5 201.3-186l.2-.3 2.2-3.2c21.9-31.9 43.9-63.5 75.1-90.9 26.6-23.5 59.5-43.6 104.2-59.3L491.4 98c-49 15.1-82.4 35.1-108.3 58-27.8 24.5-47.8 52.9-69.9 85.1l-2.2 3.3c-41.7 60.5-89.1 129.6-204.2 191.7z"
        }
    ]
};

const FarBacteria = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBacteria",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304.9.7c9.6 2.7 15.1 12.7 12.4 22.3l-2.9 10.3c15.4 7.9 28.3 20.5 36.4 36.4l10.2-3c9.6-2.7 19.5 2.8 22.3 12.4s-2.8 19.5-12.4 22.3l-11 3.1c.8 17.6-4.1 34.6-13.2 48.8l8 8c7 7 7 18.4 0 25.5s-18.4 7-25.5 0l-8-8c-7.9 5.1-16.8 8.9-26.4 11.1-5.9 1.4-11.4 2.9-16.6 4.6l3 10.6c2.7 9.6-2.8 19.5-12.4 22.3s-19.5-2.8-22.3-12.4l-1.6-5.6c-17.8 10.8-29 23.4-36.5 34.5l8.5 3.6c9.1 3.9 13.4 14.5 9.5 23.6s-14.5 13.4-23.6 9.5l-9.6-4.1c-.8 2.9-1.4 5.8-1.8 8.7-1.4 13.3-6 25.6-12.7 36.2l8 8c7 7 7 18.4 0 25.5s-18.4 7-25.5 0l-8-8c-14.1 9-31 13.9-48.8 13.2l-3.1 11c-2.7 9.6-12.7 15.1-22.3 12.4S64 370.6 66.7 361l2.9-10.3c-15.7-8.1-28.4-20.9-36.4-36.4l-10.3 2.9C13.4 320 3.4 314.5.7 304.9s2.8-19.5 12.4-22.3l11-3.1c-.2-3.7-.1-7.4.3-11.2 1.1-12.1 3.8-24.2 7-35.9.2-.8.4-1.5.7-2.3l-8.7-3.5c-9.2-3.7-13.7-14.2-10-23.4s14.2-13.7 23.4-10l7.4 3c4.6-10.7 10.3-22.2 17.4-34 1.4-2.4 2.9-4.8 4.5-7.3l-11.2-9c-7.8-6.2-9-17.5-2.8-25.3s17.5-9 25.3-2.8l9.9 8.2c10.2-12.2 22-24.1 35.5-35.3L117 82c-5.5-8.3-3.3-19.4 5-25s19.4-3.3 25 5l4.9 7.4c13.7-8.8 28.7-16.8 45.2-23.9l-3.6-8.5c-3.9-9.1.3-19.7 9.5-23.6s19.7.3 23.6 9.5l4.4 10.3c8.4-2.6 17.1-4.9 26.2-7 7.5-1.7 15.1-2.4 22.4-2.1l3.1-11C285.4 3.5 295.4-2 304.9.7zM143.8 279.9l.3-2.1c3.2-20.9 11.7-39.5 20.3-53.8 18-30 52.2-65.4 119.7-80.9 19.4-4.5 31.5-23.8 27-43.2s-23.8-31.5-43.2-27c-88.4 20.4-138.2 69-165.3 114.1-13.3 22.1-20.8 42.9-25 58.3-2.8 10-4.7 19.2-5.5 27.6-1.8 19.8 12.8 37.2 32.6 39 19.6 1.8 36.9-12.5 39-31.9zm352.4-47.8-.3 2.1c-3.2 20.9-11.7 39.5-20.3 53.8-18 30-52.2 65.4-119.7 80.9-19.4 4.5-31.5 23.8-27 43.2s23.8 31.5 43.2 27c88.4-20.4 138.2-69 165.3-114.1 13.3-22.1 20.8-42.9 25-58.3 2.8-10 4.7-19.2 5.5-27.6 1.8-19.8-12.8-37.2-32.6-39-19.6-1.8-36.9 12.5-39 31.9zm39.3-80 3.1-11c2.7-9.6 12.7-15.1 22.3-12.4s15.1 12.7 12.4 22.3l-2.9 10.3c15.7 8.1 28.4 20.9 36.4 36.4l10.3-2.9c9.6-2.7 19.5 2.8 22.2 12.4s-2.8 19.5-12.4 22.3l-11 3.1c.2 3.7.1 7.4-.3 11.2-1.1 12.1-3.8 24.2-7 35.9l-.2.8-.4 1.5 8.7 3.5c9.2 3.7 13.7 14.2 10 23.4s-14.2 13.7-23.4 10l-7.4-3c-4.6 10.7-10.3 22.2-17.4 34-1.4 2.4-3 4.8-4.5 7.3l11.2 9c7.8 6.2 9 17.5 2.8 25.3s-17.5 9-25.3 2.8l-10-8.3c-10.2 12.2-22 24.1-35.5 35.3l5.8 8.7c5.5 8.3 3.3 19.4-5 25s-19.4 3.3-25-5l-4.9-7.4c-13.7 8.8-28.7 16.8-45.2 23.9l3.6 8.5c3.9 9.1-.3 19.7-9.5 23.6s-19.7-.3-23.6-9.5l-4.4-10.3c-8.4 2.6-17.1 4.9-26.2 7-7.5 1.7-15.1 2.4-22.5 2.1l-3.1 11c-2.7 9.6-12.7 15.1-22.2 12.4s-15.1-12.7-12.4-22.3l3-10.3c-15.4-7.9-28.3-20.5-36.4-36.4l-10.3 2.9c-9.6 2.7-19.5-2.8-22.3-12.4s2.8-19.5 12.4-22.2l11-3.1c-.8-17.6 4.1-34.6 13.2-48.8l-8-8c-7-7-7-18.4 0-25.5s18.4-7 25.5 0l8 8c7.9-5.1 16.8-8.9 26.4-11.1 5.9-1.4 11.4-2.9 16.6-4.6l-3-10.6c-2.7-9.6 2.8-19.5 12.4-22.3s19.5 2.8 22.3 12.4l1.6 5.6c17.8-10.8 29-23.4 36.5-34.5l-8.5-3.6c-9.1-3.9-13.4-14.5-9.5-23.6s14.5-13.4 23.6-9.5l9.6 4.1c.8-2.9 1.4-5.8 1.8-8.7 1.4-13.3 5.9-25.6 12.7-36.2l-8-8c-7-7-7-18.4 0-25.5s18.4-7 25.5 0l8 8c14.1-9 31-13.9 48.8-13.2zM192 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 240a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm304 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarBacterium = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBacterium",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9.5-29.9 2.8-12.1 2.8-23.7 5.9-34.9 9.4L302 30.6c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8l-6.6-9.9c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7-8.6 14.3-16.5 29.5-23.3 45.2l-9.8-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.4 4.5c-4.8 16.8-8.2 34-10 51-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8.9 406.6s16.9 20.1 29.7 16.5l13.8-3.9C55 439.9 72 457 92.9 467.7L89 481.4c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3.6-3.9 1.4-7.7 2.5-11.5l12.7 5.5c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-4-14.4c6.9-2.2 14.3-4.3 22.2-6.1 12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7S494.2 85.4 481.4 89l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM207.9 372.9l-.3 2.1c-3.8 34.6-34.6 59.9-69.4 56.8-35.1-3.2-61-34.2-58-69.2 4.4-41 20.4-84 42.9-121.4 38-63.4 107.9-131.1 230.5-159.4 34.4-7.9 68.8 13.5 76.8 48s-13.5 68.8-48 76.8c-85.4 19.5-127.5 63.7-149.5 100.3-10.8 18-21.1 40.8-25 66zM192 320a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm48-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarBadgeCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBadgeCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5c5.4 10.2 17.3 15.1 28.3 11.7 21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2 20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2 6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7c10.2-5.4 15.1-17.3 11.7-28.3-6.6-21.6-1.4-46.1 15.7-63.1s41.5-22.3 63.1-15.7c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4-33-4.3-67.6 6.2-93 31.6S39 135 43.3 168C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6c20.2 26.3 52.1 43.3 88 43.3s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93c26.3-20.2 43.3-52.1 43.3-88s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93S377 39 344 43.3C323.8 17 291.9 0 256 0zm113 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
        }
    ]
};

const FarBadgeDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBadgeDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5c5.4 10.2 17.3 15.1 28.3 11.7 21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2 20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2 6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7c10.2-5.4 15.1-17.3 11.7-28.3-6.6-21.6-1.4-46.1 15.7-63.1s41.5-22.3 63.1-15.7c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4-33-4.3-67.6 6.2-93 31.6S39 135 43.3 168C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6c20.2 26.3 52.1 43.3 88 43.3s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93c26.3-20.2 43.3-52.1 43.3-88s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93S377 39 344 43.3C323.8 17 291.9 0 256 0zm20.9 140.4c0-11-9-20-20-20s-20 9-20 20v17.4c-8.8 1.8-17.7 4.8-25.7 9.6-15 8.9-27.7 24.4-27.6 46.9.1 21.5 12.6 35.1 26.3 43.4 11.9 7.2 27 11.7 39.1 15.4l1.9.6c13.9 4.2 24.4 7.6 31.7 12.2 6.1 3.8 7.5 6.8 7.6 11 .1 6.5-2.5 10.4-7.6 13.6-6 3.7-15.2 5.9-25.1 5.6-12.7-.4-24.6-4.4-39.7-9.6-2.6-.9-5.2-1.8-8-2.7-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c2.2.7 4.5 1.5 6.8 2.3 9.7 3.3 20.9 7.2 32.8 9.6v18c0 11 9 20 20 20s20-9 20-20v-17.2c9.3-1.7 18.6-4.9 26.8-10.1 15.3-9.5 26.8-25.7 26.5-48.1-.3-21.6-12.4-35.6-26.3-44.3-12.5-7.9-28.3-12.6-40.8-16.4l-.6-.2c-14.1-4.3-24.6-7.5-31.9-11.9-6.2-3.7-7-6.3-7-9.3 0-5.1 2.1-8.8 7.9-12.3 6.5-3.8 16-6 25-5.8 10.9.2 22.9 2.6 35.2 5.8 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-7.8-2.1-16.3-4.1-25.1-5.4v-17.3z"
        }
    ]
};

const FarBadgePercent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBadgePercent",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5c5.4 10.2 17.3 15.1 28.3 11.7 21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2 20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2 6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7c10.2-5.4 15.1-17.3 11.7-28.3-6.6-21.6-1.4-46.1 15.7-63.1s41.5-22.3 63.1-15.7c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4-33-4.3-67.6 6.2-93 31.6S39 135 43.3 168C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6c20.2 26.3 52.1 43.3 88 43.3s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93c26.3-20.2 43.3-52.1 43.3-88s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93S377 39 344 43.3C323.8 17 291.9 0 256 0zm-64 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-15-111c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z"
        }
    ]
};

const FarBadgeSheriff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBadgeSheriff",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256.1 63.9c5-6.7 7.9-14.9 7.9-23.9 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 9 2.9 17.2 7.9 23.9-.9 1.2-1.7 2.4-2.5 3.8l-37.3 64-74 .3c-1.2 0-2.3.1-3.5.2-6.9-12-19.9-20-34.7-20-22.1 0-40 17.9-40 40s17.9 40 40 40c1.2 0 2.4-.1 3.6-.2l36.9 64-36.8 64.2c-1.2-.1-2.4-.2-3.6-.2-22.1 0-40 17.9-40 40s17.9 40 40 40c14.8 0 27.8-8.1 34.7-20 1.1.1 2.3.2 3.5.2l74 .3 37.3 64c.8 1.3 1.6 2.6 2.5 3.8-5 6.7-7.9 14.9-7.9 23.9 0 22.1 17.9 40 40 40s40-17.9 40-40c0-9-2.9-17.2-7.9-23.9.9-1.2 1.7-2.4 2.5-3.8l37.3-64 74-.3c1.2 0 2.3-.1 3.5-.2 6.9 12 19.9 20 34.7 20 22.1 0 40-17.9 40-40s-17.9-40-40-40c-1.2 0-2.4.1-3.6.2l-37-64.2 36.7-64.2c1.2.1 2.4.2 3.6.2 22.1 0 40-17.9 40-40s-17.9-40-40-40c-14.8 0-27.8 8.1-34.7 20-1.1-.1-2.3-.2-3.5-.2l-74-.3-37.3-64c-.8-1.3-1.6-2.6-2.5-3.8zM272 256a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-80.7-96.3 32.7-56 32.7 56c7.1 12.2 20.2 19.8 34.4 19.9l64.9.3-32.2 56.3c-7 12.3-7 27.4 0 39.7l32.2 56.3-64.9.3c-14.2.1-27.3 7.6-34.4 19.9l-32.7 56-32.7-56c-7.1-12.2-20.2-19.8-34.4-19.9l-64.9-.3 32.2-56.3c7-12.3 7-27.4 0-39.7l-32.1-56.4 64.9-.3c14.2-.1 27.3-7.6 34.4-19.9z"
        }
    ]
};

const FarBadge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBadge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48c-24.1 0-45.1 13.5-55.7 33.5-5.4 10.2-17.3 15.1-28.3 11.7-21.6-6.6-46.1-1.4-63.1 15.7S86.6 150.4 93.2 172c3.4 11-1.5 22.9-11.7 28.2C61.5 210.9 48 231.9 48 256s13.5 45.1 33.5 55.7c10.2 5.4 15.1 17.3 11.7 28.3-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7c11-3.4 22.9 1.5 28.2 11.7 10.6 20 31.6 33.5 55.7 33.5s45.1-13.5 55.7-33.5c5.4-10.2 17.2-15.1 28.2-11.7 21.6 6.6 46.1 1.4 63.1-15.7s22.3-41.5 15.7-63.1c-3.4-11 1.5-22.9 11.7-28.2 20-10.6 33.5-31.6 33.5-55.7s-13.5-45.1-33.5-55.7c-10.2-5.4-15.1-17.2-11.7-28.2 6.6-21.6 1.4-46.1-15.7-63.1S361.6 86.6 340 93.2c-11 3.4-22.9-1.5-28.3-11.7C301.1 61.5 280.1 48 256 48zm-88.1-4.6C188.2 17 220.1 0 256 0s67.8 17 88.1 43.4c33-4.3 67.6 6.2 93 31.6s35.9 60 31.6 93c26.3 20.2 43.3 52.1 43.3 88s-17 67.8-43.4 88.1c4.3 33-6.2 67.6-31.6 93s-60 35.9-93 31.6C323.8 495 291.9 512 256 512s-67.8-17-88.1-43.4c-33 4.3-67.6-6.2-93-31.6S39 377 43.3 344C17 323.8 0 291.9 0 256s17-67.8 43.4-88.1c-4.3-33 6.2-67.6 31.6-93s60-35.9 93-31.6z"
        }
    ]
};

const FarBadgerHoney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBadgerHoney",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M465 112c16.9 0 33.6 3.7 49 10.9l45.2 21.1h-72.3c-49.3 0-97.7 13.4-139.9 38.8l-69.4 41.7c-17 10.2-36.4 15.6-56.2 15.6-55.4 0-101.1-41.2-108.3-94.6 4.9-.9 9.9-1.4 15-1.4h204.1c27.3 0 54.1-6.3 78.5-18.5l2.5-1.2c16.1-8 33.8-12.2 51.8-12.2zm126.8 64c-.6 4.7-2.8 9-6.1 12.4L583 191l16.4 16.4L583 191c-5.5 5.5-13.8 9.2-23.9 10.1-67.9 6.4-128.1 37.5-169.4 67.9-7.8 5.7-11.4 15.6-9.1 25 0 .2.1.4.1.6l21.3 128c.8 4.9-2.9 9.3-7.9 9.3h-31c-3.9 0-7.2-2.8-7.9-6.7l-16.9-101.1c-1.9-11.6-11.9-20.1-23.7-20.1h-110c-9.6 0-18.3 5.7-22.1 14.5l-16 37.3c-5.2 12.1-5.9 25.6-2.2 38.2l8.3 27.7c1.5 5.1-2.3 10.3-7.7 10.3h-29.1c-3.5 0-6.6-2.3-7.7-5.7L115 382.6c-1.3-4.4-1.3-9.1-.1-13.5l10.7-37.6c1.8-6.2 1-13-2.3-18.6s-8.6-9.7-14.9-11.3C73.7 292.9 48 261.4 48 224c0-27.3 13.7-51.5 34.7-65.9C95.4 223 152.6 272 221.3 272c25.6 0 50.7-7 72.7-20.1l69.4-41.7c33.2-19.9 70.6-31.5 109.1-33.8 2 8.9 10 15.6 19.5 15.6 9.7 0 17.7-6.9 19.6-16h80.2zM48 323.9c7.8 6.2 16.3 11.6 25.4 15.9l-4.6 16.1c-3.8 13.2-3.7 27.3.3 40.5l13.1 43.7c7.1 23.7 28.9 39.9 53.6 39.9H165c37.5 0 64.4-36.2 53.6-72.1l-8.3-27.7c-.5-1.8-.4-3.7.3-5.4l9.8-22.8h73.9l13.5 81.2c4.5 27 27.9 46.8 55.2 46.8h31.1c34.6 0 60.9-31.1 55.2-65.2l-19.1-115.5c28.6-19.1 64.3-36.8 103.4-45.6l19.6 31.4c3.1 5 10.4 5 13.6 0l27.8-44.5c8.1-3.8 15.7-9 22.4-15.7l2.6-2.6c13.1-13.1 20.4-30.8 20.4-49.3 0-27.1-15.7-51.7-40.2-63.1l-65.6-30.5C512.6 69.2 488.9 64 465 64c-25.4 0-50.5 5.9-73.2 17.3l-2.5 1.2C371.6 91.4 352 96 332.2 96H128C57.3 96 0 153.3 0 224v104c0 13.3 10.7 24 24 24s24-10.7 24-24v-4.1z"
        }
    ]
};

const FarBadminton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBadminton",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M228.9 100.9C193.7 136.1 176 180.4 176 221c0 31.9 10.9 61.1 32.4 82.6 48.2 48.2 138.8 43.5 202.7-20.5C446.3 247.9 464 203.6 464 163c0-31.9-10.9-61.1-32.4-82.6S380.8 48 349 48c-40.6 0-84.9 17.7-120.1 52.9zm-34-34C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154-56.3 56.3-137 80.2-204.8 59.8-27.3-8.2-58.7-7.8-80.5 9.7 11.3 12.6 10.9 31.9-1.2 44l-72 72c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l72-72c12.1-12.1 31.4-12.5 44-1.2 17.5-21.8 18.1-53.3 9.9-80.6-4.9-16.3-7.3-33.4-7.3-50.6 0-54.2 23.4-110.5 66.9-154zM104 398.6 54.6 448l9.4 9.4 49.4-49.4-9.4-9.4zM512 352c26.5 0 48 21.5 48 48v32h-96v-32c0-26.5 21.5-48 48-48zm-50.3 96h33.4l-15.8 52.6c-2.5 8.5-11.5 13.3-19.9 10.7s-13.3-11.5-10.7-19.9l13-43.4zm34.3 0h32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48zm32.9 0h33.4l13 43.4c2.5 8.5-2.3 17.4-10.7 19.9s-17.4-2.3-19.9-10.7L528.9 448z"
        }
    ]
};

const FarBagSeedling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBagSeedling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M91.9 150.1C84 181.9 80 214.4 80 247.2v17.7c0 32.7 4 65.3 11.9 97l5.6 22.1h317l5.5-22.1c7.9-31.7 11.9-64.3 11.9-97v-17.7c0-32.7-4-65.3-11.9-97l-5.5-22.2h-317L92 150.1zM427.5 48h-343l14.2 32h314.6l14.2-32zM83.7 464h344.6l-12.8-32h-319l-12.8 32zM55 99.8 35.4 55.7C33.2 50.6 32 45.1 32 39.6 32 17.7 49.7 0 71.6 0h368.8C462.3 0 480 17.7 480 39.6c0 5.5-1.2 11-3.4 16.1L457 99.8l9.7 38.7c8.9 35.5 13.4 72 13.4 108.7v17.7c0 36.6-4.5 73.1-13.4 108.7l-8.8 35.1 19.3 48.2c1.9 4.8 2.9 9.8 2.9 14.9 0 22.2-18 40.2-40.2 40.2H72.2C50 512 32 494 32 471.8c0-5.1 1-10.2 2.9-14.9l19.3-48.2-8.8-35.1C36.5 338 32 301.5 32 264.8v-17.6c0-36.6 4.5-73.1 13.4-108.7L55 99.8zm89 60.2h2c47.3 0 88.4 26 110 64.5C277.6 186 318.7 160 366 160h2c8.8 0 16 7.2 16 16 0 59.2-45.9 107.6-104 111.7V328c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40.3c-58.1-4.1-104-52.6-104-111.7 0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarBagShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBagShopping",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 112v48h128v-48c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 96H48v208c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V208h-64v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56H160v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56zm0-48v-48C112 50.1 162.1 0 224 0s112 50.1 112 112v48h64c26.5 0 48 21.5 48 48v208c0 53-43 96-96 96H96c-53 0-96-43-96-96V208c0-26.5 21.5-48 48-48h64z"
        }
    ]
};

const FarBagel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBagel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 208c0 114.9-93.1 208-208 208-3.9 0-7.7-.1-11.5-.3 6.5-12.3 12-25.3 16.3-38.8 4.7-.7 9.3-2.5 13.3-5.3l20.9-14.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6l20.1-15.4c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6l-20.9-14.2c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6l-25.3.7c-13.2.4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0c114.9 0 208 93.1 208 208zm-144 0c0 30.6-21.5 56.3-50.3 62.5-6-43.3-23.6-82.9-49.5-115.6 10.2-6.9 22.6-11 35.9-11 35.3 0 64 28.7 64 64zM48 304a160 160 0 1 0 320 0 160 160 0 1 0-320 0zm-48 0a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm144-96a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm160 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 368a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM96 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 48a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm16 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"
        }
    ]
};

const FarBagsShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBagsShopping",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 96c0-26.5 21.5-48 48-48s48 21.5 48 48v64h-96V96zm-48 64H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h96v-48H64c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16h48c0-35.3-28.7-64-64-64h-64V96c0-53-43-96-96-96s-96 43-96 96v64zm128 96c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H256zm64 80v16c0 35.3 28.7 64 64 64s64-28.7 64-64v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 53-43 96-96 96s-96-43-96-96v-16c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarBaguette = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBaguette",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M578.6 83.6c-24.5-36.8-74.2-46.7-110.9-22.2L398 107.9l35 35.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L357.2 135l-74.5 49.6L321 223c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L242 211.8l-74.5 49.6L209 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48.3-48.3-43.2 28.8c-36.8 24.5-46.7 74.2-22.2 110.9s74.2 46.7 110.9 22.2l384-256c36.8-24.5 46.7-74.2 22.2-110.9zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z"
        }
    ]
};

const FarBahai = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBahai",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c10.9 0 20.4 7.3 23.2 17.8l28.1 105.3 89.2-62.6c8.9-6.2 20.9-5.7 29.2 1.3s10.9 18.7 6.3 28.6L417.8 189l108.6 9.4c10.8.9 19.7 9 21.6 19.7s-3.7 21.3-13.5 25.9l-98.9 46 77.2 77c7.7 7.7 9.3 19.6 3.8 29s-16.5 14-27 11.2l-105.2-28.4 9.6 108.6c1 10.8-5.5 21-15.7 24.7s-21.7.1-27.9-8.8L288 413.9l-62.4 89.4c-6.2 8.9-17.7 12.5-27.9 8.8S181 498.3 182 487.4l9.6-108.6-105.2 28.4c-10.5 2.8-21.6-1.8-27-11.2s-3.9-21.3 3.8-29l77.2-77-98.9-45.9c-9.9-4.6-15.4-15.2-13.5-25.9s10.7-18.8 21.6-19.7l108.6-9.5L112 90.3c-4.6-9.8-2-21.6 6.3-28.6s20.3-7.5 29.2-1.3l89.2 62.6 28.1-105.2C267.6 7.3 277.1 0 288 0zm0 117.1-13.7 51.6c-2 7.6-7.6 13.7-15 16.4s-15.6 1.6-22-2.9l-43.7-30.7 22.6 48.3c3.3 7.1 3 15.4-1 22.2s-10.9 11.2-18.7 11.9l-53.2 4.6 48.5 22.5c7.1 3.3 12.2 9.9 13.5 17.6s-1.1 15.6-6.7 21.2l-37.8 37.7 51.5-13.9c7.6-2 15.7-.2 21.7 4.8s9.2 12.7 8.5 20.5l-4.7 53.1 30.6-43.7c4.5-6.4 11.8-10.3 19.7-10.3s15.2 3.8 19.7 10.3l30.4 43.7-4.7-53.1c-.7-7.8 2.5-15.5 8.5-20.5s14.1-6.8 21.7-4.8l51.5 13.9-37.8-37.7c-5.5-5.5-8-13.4-6.7-21.2s6.4-14.3 13.5-17.6l48.4-22.5-53.2-4.6c-7.8-.7-14.8-5.1-18.7-11.9s-4.3-15.1-1-22.2l22.6-48.3-43.7 30.7c-6.4 4.5-14.6 5.6-22 2.9s-13-8.8-15-16.4L288 117.1z"
        }
    ]
};

const FarBahtSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBahtSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 0c-13.3 0-24 10.7-24 24v40H37.6C16.8 64 0 80.8 0 101.6v304.7c0 23 18.7 41.7 41.7 41.7H112v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h52c59.6 0 108-48.4 108-108 0-42.1-24.1-78.5-59.2-96.4 16.9-19 27.2-44.1 27.2-71.6 0-59.6-48.4-108-108-108h-20V24c0-13.3-10.7-24-24-24zm-24 112v120H48V112h64zm48 120V112h20c33.1 0 60 26.9 60 60s-26.9 60-60 60h-20zm-48 48v120H48V280h64zm48 120V280h52c33.1 0 60 26.9 60 60s-26.9 60-60 60h-52z"
        }
    ]
};

const FarBallPile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBallPile",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm48 0c0 26.7-10.9 50.9-28.6 68.3 9-2.8 18.6-4.3 28.6-4.3 53 0 96 43 96 96 0 26.7-10.9 50.9-28.6 68.3 9-2.8 18.6-4.3 28.6-4.3 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3c17.7 17.4 28.6 41.6 28.6 68.3 0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3c17.7 17.4 28.6 41.6 28.6 68.3 0 53-43 96-96 96s-96-43-96-96 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3-17.7-17.4-28.6-41.6-28.6-68.3 0-53 43-96 96-96 9.9 0 19.5 1.5 28.6 4.3C234.9 146.9 224 122.7 224 96c0-53 43-96 96-96s96 43 96 96zm-96 96c-9.9 0-19.5-1.5-28.6-4.3 17.7 17.4 28.6 41.6 28.6 68.3 0-26.7 10.9-50.9 28.6-68.3-9 2.8-18.6 4.3-28.6 4.3zm0 64c0 26.7-10.9 50.9-28.6 68.3 9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C330.9 306.9 320 282.7 320 256zM176 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm144 112a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm144 112a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarBalloon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBalloon",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 35.8-18.4 74.2-46.5 110.7-27.5 35.7-60.2 64.2-79 79.3-7.6 6.1-13.8 13.5-18.4 21.8-4.6-8.3-10.9-15.8-18.4-21.8-18.9-15.1-51.5-43.6-79-79.3C66.4 266.2 48 227.8 48 192zm102.7 258.5L144 464l-.1.1-3 6-11.6 23.2c-.9 1.8-1.4 3.8-1.4 5.8 0 7.1 5.8 12.9 12.9 12.9h102.1c7.1 0 12.9-5.8 12.9-12.9 0-2-.5-4-1.4-5.8l-11.6-23.2-3-6-.1-.1-6.7-13.5c-5.3-10.6-2.1-23.6 7.1-31C281.2 386.9 384 294.6 384 192 384 86 298 0 192 0S0 86 0 192c0 102.6 102.8 194.9 143.6 227.5 9.3 7.4 12.5 20.4 7.1 31zM128 184c0-30.9 25.1-56 56-56 13.3 0 24-10.7 24-24s-10.7-24-24-24c-57.4 0-104 46.6-104 104 0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarBalloons = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBalloons",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 160c0-61.9-50.1-112-112-112S48 98.1 48 160c0 31.6 15.3 65.1 38.2 96.6 22.5 30.8 48.7 54.8 62.4 66.3 4.4 3.7 8.2 7.9 11.4 12.5 3.2-4.6 7-8.8 11.4-12.5 13.7-11.5 39.9-35.5 62.4-66.3 23-31.5 38.2-65 38.2-96.6zM112 400l10-20.1c3.5-6.9 1.6-15.3-4.4-20.3C87.2 334 0 252.5 0 160 0 71.6 71.6 0 160 0s160 71.6 160 160c0 92.5-87.2 174-117.7 199.7-5.9 5-7.8 13.4-4.4 20.3l10.1 20 .1.1 3 6 11.6 23.2c.9 1.8 1.4 3.8 1.4 5.8 0 7.1-5.8 12.9-12.9 12.9H108.9c-7.1 0-12.9-5.8-12.9-12.9 0-2 .5-4 1.4-5.8l11.6-23.2 3-6 .1-.1zm48-264c-13.3 0-24 10.7-24 24s-10.7 24-24 24-24-10.7-24-24c0-39.8 32.2-72 72-72 13.3 0 24 10.7 24 24s-10.7 24-24 24zm277.7 287.7c-26.2-22.1-94.5-85.6-113-161.8C340.5 231.8 352 197.2 352 160c0-9.9-.7-19.6-2.2-29 29-40.5 76.5-67 130.2-67 88.4 0 160 71.6 160 160 0 92.5-87.2 174-117.7 199.7-5.9 5-7.8 13.4-4.4 20.3l10.1 20 .1.1 3 6 11.6 23.2c.9 1.8 1.4 3.8 1.4 5.8 0 7.1-5.8 12.9-12.9 12.9H428.9c-7.1 0-12.9-5.8-12.9-12.9 0-2 .5-4 1.4-5.8l11.6-23.2 3-6 .1-.1 10-20.1c3.5-6.9 1.6-15.3-4.4-20.3zM480 112c-61.9 0-112 50.1-112 112 0 31.6 15.3 65.1 38.2 96.6 22.5 30.8 48.7 54.8 62.4 66.3 4.4 3.7 8.2 7.9 11.4 12.5 3.2-4.6 7-8.8 11.4-12.5 13.7-11.5 39.9-35.5 62.4-66.3 23-31.5 38.2-65 38.2-96.6 0-61.9-50.1-112-112-112zm-24 112c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-39.8 32.2-72 72-72 13.3 0 24 10.7 24 24s-10.7 24-24 24-24 10.7-24 24z"
        }
    ]
};

const FarBallotCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBallotCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h320zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm16 240c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H96zm80-224c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H200c-13.3 0-24 10.7-24 24zm32 128c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H232c-13.3 0-24 10.7-24 24zm-32 128c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H200c-13.3 0-24 10.7-24 24zm-4.7-140.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 257.4l-12.7-12.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48z"
        }
    ]
};

const FarBallot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBallot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h320zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H96zM80 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm120-264c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H200zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H200zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H200z"
        }
    ]
};

const FarBanBug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBanBug",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c-114.9 0-208-93.1-208-208 0-48.8 16.8-93.7 44.9-129.1l292.2 292.2C349.7 447.2 304.8 464 256 464zm78.9-163c.2-1.1.3-2.1.5-3.2l29.5 5.9c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7v-18.6l35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19-21.6 0-41.2 8.6-55.6 22.5l-73.5-73.6C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208 0 48.8-16.8 93.7-44.9 129.1L334.9 301zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM140.9 272.3c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5l27.9-16.8c14 11.9 32.1 19 51.8 19 6.6 0 13-.8 19.2-2.3L175 265.5l-34.1 6.8z"
        }
    ]
};

const FarBanParking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBanParking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c-114.9 0-208-93.1-208-208 0-48.8 16.8-93.7 44.9-129.1l292.2 292.2C349.7 447.2 304.8 464 256 464zm80-162c24.2-17.4 40-45.9 40-78 0-53-43-96-96-96h-80c-10.4 0-19.6 4.9-25.5 12.6l-47.6-47.7C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208 0 48.8-16.8 93.7-44.9 129.1L336 302zM216 182v-6h64c26.5 0 48 21.5 48 48 0 18.9-11 35.3-26.9 43.1l-85.1-85zm40 330a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-88-246.1V360c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h6.1L168 265.9z"
        }
    ]
};

const FarBanSmoking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBanSmoking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m92.9 126.9 292.2 292.2C349.7 447.2 304.8 464 256 464c-114.9 0-208-93.1-208-208 0-48.8 16.8-93.7 44.9-129.1zm165 97.1-131-131.1C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208 0 48.8-16.8 93.7-44.9 129.1L353.9 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H257.9zm32 32H384v32h-62.1l-32-32zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm16-416c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16c0-26.5-21.5-48-48-48h-32c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM112 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h128.8l-96-96H112z"
        }
    ]
};

const FarBan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBan",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M385.1 419.1 92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208 48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9c28.2-35.5 45-80.4 45-129.2 0-114.9-93.1-208-208-208-48.8 0-93.7 16.8-129.1 44.9l292.2 292.2zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FarBanana = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBanana",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 144c0 46.7-10.5 90.9-29.3 130.4l-25.3-20.2c-4.4-3.5-9.1-6.8-13.9-9.8C296.7 213.6 304 179.7 304 144c0-31.4-5.6-61.3-15.9-89-9.5-25.5 8.6-55 38-55 9.8 0 19.5 3.6 27 10.4C411.4 63.1 448 139.3 448 224c0 10.9-.6 21.6-1.8 32.1-10.9.4-21.7 2.1-32.3 4.9l-17.6 4.7c2.4-13.5 3.6-27.5 3.6-41.7 0-59.5-21.7-114-57.6-156 6.2 24.3 9.6 49.7 9.6 76zM211.3 304c-12.5 0-24.7 4.1-34.7 11.6l-42.2 31.6c-10.6 8-25.6 5.8-33.6-4.8s-5.8-25.6 4.8-33.6l42.2-31.6c18.3-13.7 40.6-21.2 63.5-21.2 24 0 47.4 8.2 66.1 23.2l48.1 38.5 96.7-25.8c6.1-1.6 12.3-2.7 18.5-3.4 3.7-.4 7.5-.6 11.3-.6 40.7 0 78.4 21.3 99.3 56.2l21.3 35.4c6.8 11.4 3.1 26.1-8.2 32.9s-26.1 3.1-32.9-8.2l-21.3-35.4C497.9 348.5 475.8 336 452 336c-5.9 0-11.8.8-17.5 2.3l-11.5 3.1C378.2 441.9 277.3 512 160 512H48c-26.5 0-48-21.5-48-48v-16c0-26.5 21.5-48 48-48 77 0 146.1-34 193-87.8-8.9-5.3-19.2-8.2-29.7-8.2z"
        }
    ]
};

const FarBandage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBandage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 144v224h112c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H448zM192 96h368c44.2 0 80 35.8 80 80v160c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h112zm0 272V144H80c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32h112zm80-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM272 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarBangladeshiTakaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBangladeshiTakaSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M26.4 32.1C13.2 30.8 1.4 40.4.1 53.6s8.3 25 21.5 26.3L44 82.1c20.4 2 36 19.3 36 39.8V176H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v168c0 48.6 39.4 88 88 88h32c101.6 0 184-82.4 184-184v-32c0-48.6-39.4-88-88-88h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c22.1 0 40 17.9 40 40v32c0 75.1-60.9 136-136 136h-32c-22.1 0-40-17.9-40-40V224h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-54.1c0-45.2-34.3-83.1-79.2-87.6l-22.4-2.2z"
        }
    ]
};

const FarBanjo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBanjo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-22.2 59.1-61.5 61.5-1.2 1.2c-22-16.5-48.2-27.7-76.6-31.7V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.7c-28.5 4.1-54.6 15.3-76.6 31.7l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2C41 241.4 29.8 267.5 25.7 296H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h1.7c4.1 28.5 15.3 54.6 31.7 76.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c22 16.5 48.2 27.7 76.6 31.7v1.8c0 13.3 10.7 24 24 24s24-10.7 24-24v-1.7c28.5-4.1 54.6-15.3 76.6-31.7l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c16.5-22 27.7-48.2 31.7-76.6h1.9c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.7c-4.1-28.5-15.3-54.6-31.7-76.6l1.2-1.2 61.5-61.5 59.1-22.2c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-39 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-48-48z"
        }
    ]
};

const FarBarcodeRead = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBarcodeRead",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 48c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24S0 149.3 0 136V56C0 25.1 25.1 0 56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56zm64 80c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm56 16c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm272 0c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm-208 8c0-13.3 10.7-24 24-24s24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm152-24c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm136-72c0-4.4-3.6-8-8-8h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56zM56 464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 4.4 3.6 8 8 8zm472-8v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 30.9-25.1 56-56 56h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8z"
        }
    ]
};

const FarBarcodeScan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBarcodeScan",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 32c-13.3 0-24 10.7-24 24v136h48V56c0-13.3-10.7-24-24-24zM64 456c0 13.3 10.7 24 24 24s24-10.7 24-24V320H64v136zm96 8c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32v144zm64-8c0 13.3 10.7 24 24 24s24-10.7 24-24V320h-48v136zm0-400v136h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24zm112 400c0 13.3 10.7 24 24 24s24-10.7 24-24V320h-48v136zm0-400v136h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24zm128 408c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32v144zm0-416v144h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 408c0 13.3 10.7 24 24 24s24-10.7 24-24V320h-48v136zm0-400v136h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24zM160 192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v144zM0 256c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarBarcode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBarcode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm88 0c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm112 0c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm168 24v400c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-64-8v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FarBarsFilter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBarsFilter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm64 160c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm224 160c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24z"
        }
    ]
};

const FarBarsProgress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBarsProgress",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 112v64H320v-64h144zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H48zm416 272v64H192v-64h272zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H48z"
        }
    ]
};

const FarBarsSort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBarsSort",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm0 160c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm192 160c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h144c13.3 0 24 10.7 24 24z"
        }
    ]
};

const FarBarsStaggered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBarsStaggered",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm64 160c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm384 160c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h400c13.3 0 24 10.7 24 24z"
        }
    ]
};

const FarBars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBars",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm0 160c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm448 160c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h400c13.3 0 24 10.7 24 24z"
        }
    ]
};

const FarBaseballBatBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBaseballBatBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M372 17.5C383.8 6.3 399.5 0 415.7 0c16.8 0 32.9 6.7 44.7 18.5l33 33c11.9 11.9 18.5 28 18.5 44.7 0 16.3-6.3 31.9-17.5 43.7L356.3 284.7c-14.1 14.8-30.3 27.5-48 37.8l-106.5 61.7c-12.6 7.3-24.3 16.3-34.6 26.6l-38.6 38.6c-.3-.3-.6-.7-1-1l-64-64c-.3-.3-.7-.6-1-1l38.6-38.6c10.3-10.3 19.3-22 26.6-34.6l61.6-106.5c10.3-17.7 23-33.9 37.8-48L372 17.5zM171.9 329.9l10.2 10.2L284.2 281c13.8-8 26.4-17.9 37.3-29.4l138.3-144.8c2.7-2.8 4.2-6.6 4.2-10.5 0-4-1.6-7.9-4.5-10.8l-33-33c-2.9-2.9-6.7-4.5-10.8-4.5-3.9 0-7.7 1.5-10.5 4.2L260.4 190.4c-11.5 11-21.4 23.6-29.4 37.3l-59.1 102.2zM464 432a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0zM15 399c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L15 433c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarBaseball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBaseball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 463.8c0-6 .3-11.9.7-17.8 1.1-13.2 12.7-23 25.9-21.9s23 12.7 21.9 25.9c-.3 3.4-.5 6.8-.5 10.2C378.8 444 444 378.8 460.2 296c-3.4.1-6.8.3-10.2.5-13.2 1.1-24.8-8.7-25.9-21.9s8.7-24.8 21.9-25.9c5.9-.5 11.8-.7 17.8-.7C459.7 139.5 372.5 52.3 264 48.2c0 6-.3 11.9-.7 17.8-1.1 13.2-12.7 23-25.9 21.9s-23-12.7-21.9-25.9c.3-3.4.5-6.8.5-10.2C133.2 68 68 133.2 51.9 216c3.4-.1 6.8-.3 10.2-.5 13.2-1.1 24.8 8.7 25.9 21.9s-8.7 24.8-21.9 25.9c-5.9.5-11.8.7-17.8.7 4 108.5 91.2 195.7 199.7 199.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm118-55.2c36.5-16.8 66-46.3 82.8-82.8 5.5-12 19.8-17.3 31.8-11.8s17.3 19.8 11.8 31.8C222.8 185 185 222.8 138 244.4c-12 5.5-26.3.2-31.8-11.8s-.2-26.3 11.8-31.8zm276 110.4c-36.5 16.8-66 46.3-82.8 82.8-5.5 12-19.8 17.3-31.8 11.8S262.1 386 267.6 374c21.6-47 59.4-84.8 106.4-106.4 12-5.5 26.3-.2 31.8 11.8s.2 26.3-11.8 31.8z"
        }
    ]
};

const FarBasketShoppingSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBasketShoppingSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192h232.6L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192H552c13.3 0 24 10.7 24 24s-10.7 24-24 24h-20l-55.9 223.5C469 492 443.4 512 414 512H162c-29.4 0-55-20-62.1-48.5L44 240H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h93.6l93.1-179.1c6.1-11.8 20.6-16.3 32.4-10.2zM482.5 240h-389l53 211.9c1.8 7.1 8.2 12.1 15.5 12.1h252c7.3 0 13.7-5 15.5-12.1l53-211.9zM144 296a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarBasketShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBasketShopping",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192h232.6L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192H552c13.3 0 24 10.7 24 24s-10.7 24-24 24h-20l-55.9 223.5C469 492 443.4 512 414 512H162c-29.4 0-55-20-62.1-48.5L44 240H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h93.6l93.1-179.1c6.1-11.8 20.6-16.3 32.4-10.2zM93.5 240l53 211.9c1.8 7.1 8.2 12.1 15.5 12.1h252c7.3 0 13.7-5 15.5-12.1l53-211.9h-389zM224 312v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm64-24c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24zm112 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarBasketballHoop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBasketballHoop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M49.2 209.4C64.9 179.7 144.6 48 320 48s255.1 131.7 270.8 161.4c.7 1.4 1.2 3.1 1.2 5.5v116.3c0 6.3-3.7 12.1-9.5 14.6l-60.3 26.8-8 56.1 87.8-39c23.1-10.3 38-33.2 38-58.5V214.9c0-8.9-1.8-18.6-6.8-28C615.3 153.1 523.3 0 320 0S24.7 153.1 6.8 187c-5 9.3-6.8 19-6.8 27.9v116.3c0 25.3 14.9 48.2 38 58.5l87.8 39-8-56.1-60.3-26.8c-5.8-2.6-9.5-8.3-9.5-14.6V214.9c0-2.4.5-4.2 1.2-5.5zm92.9 78.6 7.3 50.8v.1l22.9 152c1.1 7.5 6.4 13.8 13.7 16.1s15.2.3 20.5-5.2l48.7-50.6 50.7 50.9c3.8 3.8 8.8 5.9 14.2 5.9s10.4-2.1 14.2-5.9l50.7-50.9 48.7 50.6c5.3 5.5 13.2 7.5 20.5 5.2s12.6-8.6 13.7-16.1l22.9-152v-.1l7.3-50.8h5.9c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-13.3 0-24 10.7-24 24s10.7 24 24 24h6.1zm315.4 0-4.1 28.9-34.8-28.9h38.9zM356 288l.5.4-36.5 37.8-36.4-37.8.5-.4H356zm-134.5 0-34.8 28.9-4.2-28.9h38.9zM283 422.4l37-38.5 37.1 38.5-37.1 37.3-37.1-37.2zm9.3-67.4-37.6 39-44.5-44.7 42.5-35.3 39.5 41.1zm-94.2 39 28.8 28.9-21.2 22-7.6-50.9zm149.7-38.9 39.5-41.1 42.6 35.4-44.5 44.7-37.6-39zm94.1 38.9-7.7 50.9-21.2-22 28.9-28.9zM208 176h224v32h48v-40c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40v40h48v-32z"
        }
    ]
};

const FarBasketball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBasketball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 458.4V456c0-33.3 10.7-64.1 28.9-89.2l52.2 52.2c-23.5 18.6-51 32.2-81.1 39.4zm-47.8 5.6h-.2c-48.8 0-93.7-16.8-129.1-44.9L256 289.9l42.6 42.6C271.9 366.6 256 409.4 256 456c0 2.7.1 5.3.2 8zm76.4-165.4L289.9 256l129.2-129.1C447.2 162.3 464 207.2 464 256v.2c-2.7-.1-5.3-.2-8-.2-46.6 0-89.4 15.9-123.4 42.6zm125.8 5.4c-7.1 30.1-20.8 57.7-39.4 81.1l-52.2-52.2c25-18.2 55.9-28.9 89.2-28.9h2.4zM256 222.1l-42.6-42.6C240.1 145.4 256 102.6 256 56c0-2.7-.1-5.3-.2-8h.2c48.8 0 93.7 16.8 129.1 44.9L256 222.1zm-76.9-76.9-52.2-52.3c23.5-18.6 51-32.2 81.1-39.4v2.4c0 33.3-10.7 64.1-28.9 89.2zm-33.9 33.9C120.1 197.3 89.3 208 56 208h-2.4c7.1-30.1 20.8-57.7 39.4-81.1l52.2 52.2zM48 255.8c2.7.1 5.3.2 8 .2 46.6 0 89.4-15.9 123.4-42.6l42.7 42.6L92.9 385.1C64.8 349.7 48 304.8 48 256v-.2zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"
        }
    ]
};

const FarBat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M356.3 187.3c-13.3-6.8-22.7-19.3-25.4-33.9l-6.5-34.9c-11.1 6.2-23.6 9.5-36.4 9.5s-25.3-3.3-36.4-9.5l-6.5 34.9c-2.7 14.6-12.1 27.2-25.4 33.9s-28.9 7-42.4.6l-68.7-32.7C70.1 202.4 48.7 261.3 48 322.3l13.3-6.6c29.9-15 66.3-4.4 83.5 24.3l8.7 14.6 7.6-7.6c27.3-27.3 72.4-24.4 96 6.2l30.9 40.1 30.8-40.1c23.6-30.6 68.7-33.6 96-6.2l7.6 7.6 8.7-14.6c17.2-28.7 53.6-39.3 83.5-24.3l13.3 6.6c-.6-61-22-120-60.6-167.2l-68.7 32.7c-13.5 6.4-29.1 6.2-42.4-.6zm219.7 159v30.5c0 10.6-11.2 17.5-20.6 12.8l-25.5-12.8-1.9-.8-34.7-17.4c-7.5-3.7-16.6-1.1-20.9 6.1l-29.8 49.7c-5.4 8.9-17.7 10.4-25 3.1L381 380.9c-6.8-6.8-18.1-6.1-24 1.6l-56.2 73.1c-6.4 8.3-19 8.3-25.4 0l-56.2-73.1c-5.9-7.7-17.2-8.4-24-1.6l-36.6 36.6c-7.4 7.4-19.7 5.8-25-3.1l-29.8-49.7c-4.3-7.2-13.4-9.8-20.9-6.1L48 376l-1.8.9-25.5 12.8C11.2 394.4 0 387.5 0 376.9v-51.7C0 249.6 27.1 176.4 76.3 119c11.6-13.6 30.9-17.7 47.1-10l29.7 14.1 44.8 21.3 9.2-48.8 6.8-36.2c1.3-6.7 7.1-11.5 13.9-11.5 2.8 0 5.5.8 7.8 2.4l37.8 25.2c4.3 2.9 9.4 4.4 14.7 4.4s10.3-1.5 14.7-4.4l37.8-25.2c2.3-1.5 5-2.4 7.8-2.4 6.8 0 12.6 4.8 13.9 11.5l6.8 36.2 9.2 48.8 44.8-21.3 29.5-14.1c16.2-7.7 35.5-3.6 47.1 10 49.2 57.4 76.3 130.6 76.3 206.2v21.1z"
        }
    ]
};

const FarBath = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBath",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M101.3 48C89.5 48 80 57.5 80 69.3V256h408c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V69.3C32 31 63 0 101.3 0c18.4 0 36 7.3 49 20.3l4.8 4.8c11.1-5.8 23.7-9.1 37-9.1 23.9 0 45.4 10.5 60.1 27.2 9.2-5.3 21.1-4 28.9 3.9 9.4 9.4 9.4 24.6 0 33.9L177 185c-9.4 9.4-24.6 9.4-33.9 0-7.8-7.8-9.1-19.7-3.9-28.9C122.5 141.4 112 119.9 112 96c0-13.4 3.3-25.9 9.1-37l-4.8-4.8c-4-4-9.4-6.2-15-6.2zM32 336h48v32c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48v-32h48v32c0 28.4-12.4 54-32 71.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-25.3c-5.2.9-10.5 1.3-16 1.3H128c-5.5 0-10.8-.5-16-1.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48.4C44.4 422 32 396.4 32 368v-32zM192 64c-17.7 0-32 14.3-32 32 0 10.4 4.9 19.6 12.6 25.5l44.8-44.8c-5.8-7.8-15-12.7-25.4-12.7z"
        }
    ]
};

const FarBatteryBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBatteryBolt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h92.2c-11.6-13-15.3-31.5-9.5-48H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h159.2l60-48H80zm384 272H304.8l-60 48H464c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80h-92.2c11.6 13 15.3 31.5 9.5 48H464c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32zM346.1 115.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8S169.2 272 176 272h70.1l-52.4 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
        }
    ]
};

const FarBatteryEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBatteryEmpty",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 144c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H80zM0 176c0-44.2 35.8-80 80-80h384c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"
        }
    ]
};

const FarBatteryExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBatteryExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 96v48H80c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32h113.6c-1 5.2-1.6 10.5-1.6 16 0 11.4 2.4 22.2 6.7 32H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h128zm256 320H345.3c4.3-9.8 6.7-20.6 6.7-32 0-5.5-.6-10.8-1.6-16H464c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H336V96h128c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80zM272 96c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm-32 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarBatteryFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBatteryFull",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 144c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h384zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H80zm368 96H96v128h352V192z"
        }
    ]
};

const FarBatteryHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBatteryHalf",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 144c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h384zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H80zm208 96H96v128h192V192z"
        }
    ]
};

const FarBatteryLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBatteryLow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 144c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h384zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H80zm80 96H96v128h64V192z"
        }
    ]
};

const FarBatteryQuarter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBatteryQuarter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 144c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h384zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H80zm112 96H96v128h96V192z"
        }
    ]
};

const FarBatterySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBatterySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c19.8-14.5 32.7-38 32.7-64.5v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H154.8L38.8 5.1zM216 144h280c17.7 0 32 14.3 32 32v160c0 15.9-11.6 29.1-26.7 31.6L216 144zm129.2 224H112c-17.7 0-32-14.3-32-32V176c0-5.1 1.2-10 3.4-14.3l-38-30C36.9 144.4 32 159.6 32 176v160c0 44.2 35.8 80 80 80h294.2l-60.9-48z"
        }
    ]
};

const FarBatteryThreeQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBatteryThreeQuarters",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 144c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h384zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H80zm272 96H96v128h256V192z"
        }
    ]
};

const FarBedBunk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBedBunk",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0c13.3 0 24 10.7 24 24v136h208V40c0-22.1 17.9-40 40-40h160c66.3 0 120 53.7 120 120v368c0 13.3-10.7 24-24 24s-24-10.7-24-24v-24.3H48V488c0 13.3-10.7 24-24 24S0 501.3 0 488V24C0 10.7 10.7 0 24 0zm232 415.7V296c0-22.1 17.9-40 40-40h232v-48H48v207.7h208zM528 160v-40c0-39.8-32.2-72-72-72H304v112h224zm0 144H304v111.7h224V304zM96 328a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm56-312a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
        }
    ]
};

const FarBedEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBedEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v400c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h544v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-66.3-53.7-120-120-120H48V56zm544 280H48V208h472c39.8 0 72 32.2 72 72v56z"
        }
    ]
};

const FarBedFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBedFront",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 80v125.8c14.5-7.7 30.8-12.4 48-13.6V160c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32h32v-32c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32.3c17.2 1.1 33.5 5.9 48 13.6V80c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48zm56 144c-48.6 0-88 39.4-88 88v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h416v40c0 13.3 10.7 24 24 24s24-10.7 24-24V312c0-48.6-39.4-88-88-88H88zm376 144H48v-56c0-22.1 17.9-40 40-40h336c22.1 0 40 17.9 40 40v56z"
        }
    ]
};

const FarBedPulse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBedPulse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M483.2 9.6 524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6l-24.1-32.1-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h136c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6.1s16.6 2.7 21.6 9.5zM288 216c0-27.3 19.5-50 45.4-55l20 30.1c4.7 7 10.8 12.7 17.8 16.9H344c-4.4 0-8 3.6-8 8v152h256v-88c0-39.8-32.2-72-72-72h-91.2c9.3-5.6 17-13.9 21.8-24.2l11.3-23.8H520c66.3 0 120 53.7 120 120v216c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80H48v72c0 13.3-10.7 24-24 24S0 501.3 0 488V88c0-13.3 10.7-24 24-24s24 10.7 24 24v280h240V216zm-80 32a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm-128 0a88 88 0 1 1 176 0 88 88 0 1 1-176 0z"
        }
    ]
};

const FarBed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v400c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h544v80c0 13.3 10.7 24 24 24s24-10.7 24-24V248c0-66.3-53.7-120-120-120H344c-30.9 0-56 25.1-56 56v152H48V56zm544 192v88H336V184c0-4.4 3.6-8 8-8h176c39.8 0 72 32.2 72 72zm-464-32a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm128 0a88 88 0 1 0-176 0 88 88 0 1 0 176 0z"
        }
    ]
};

const FarBee = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBee",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M219.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l31.5 31.5C215.6 73 208 91.6 208 112c0 3 .2 6 .5 8.9C185.7 105 157 96 128 96 63 96 0 140.9 0 208c0 61.9 53.6 104.9 112.9 111.2-.6-5.1-.9-10.2-.9-15.2 0-11.2 1-22.2 3.1-32.8-40.6-5.1-67.1-34-67.1-63.2 0-32.2 32.3-64 80-64 37.3 0 65.2 19.5 75.6 43.3C167.5 213.5 144 256 144 304c0 83.8 103.6 179.7 129.9 202.8 3.9 3.4 8.9 5.2 14.1 5.2s10.2-1.8 14.1-5.2C328.4 483.7 432 387.8 432 304c0-48-23.5-90.5-59.6-116.7 10.4-23.8 38.3-43.3 75.6-43.3 47.7 0 80 31.8 80 64 0 29.2-26.5 58.1-67.1 63.2 2 10.6 3.1 21.6 3.1 32.8 0 5-.3 10.1-.9 15.2C522.4 312.9 576 269.9 576 208c0-67.1-63-112-128-112-29 0-57.7 9-80.5 24.9.3-2.9.5-5.9.5-8.9 0-20.4-7.6-39-20.2-53.2l31.5-31.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-34.8 34.8C311.6 34.7 300.1 32 288 32s-23.6 2.7-33.9 7.5L219.3 4.7zm17.6 393.9c-3.8-4.9-7.5-9.8-10.9-14.6h124c-3.4 4.8-7 9.7-10.9 14.6-17.6 22.5-36.7 42.2-51.1 56-14.4-13.8-33.5-33.5-51.1-56zm140-62.6H199.1c-4.6-11.7-7.1-22.5-7.1-32h192c0 9.5-2.5 20.3-7.1 32zm-5.8-80H204.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48z"
        }
    ]
};

const FarBeerMugEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBeerMugEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 80v336c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V80H80zm304 303.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32v32h59.2c38 0 68.8 30.8 68.8 68.8v117.9c0 27.3-16.2 52.1-41.2 63l-86.8 38zm0-239.7v187.3l67.5-29.5c7.6-3.3 12.5-10.8 12.5-19.1V164.8c0-11.5-9.3-20.8-20.8-20.8H384zm-240-16c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarBeerMug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBeerMug",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0c-26.8 0-51.1 11-68.5 28.8h-.1C126.9 20.7 112 16 96 16c-44.2 0-80 35.8-80 80s35.8 80 80 80c16 0 30.9-4.7 43.4-12.8h.1C156.9 181 181.2 192 208 192c26.5 0 50.6-10.8 68-28.2 12.8 8.5 28.2 13.5 44.6 13.5 44.5 0 80.6-36.1 80.6-80.6s-36.1-80.6-80.6-80.6c-16.1 0-31.2 4.8-43.9 13C259.3 11.1 234.9 0 208 0zm-34.9 63c8.8-9.3 21.1-15 34.9-15 13.8 0 26.2 5.8 35 15.1 8.4 8.9 19.6 12.8 29.3 13.7 9.7.9 20.9-1 30.4-7.4 5.2-3.4 11.3-5.4 18-5.4 18 0 32.6 14.6 32.6 32.6s-14.6 32.6-32.6 32.6c-6.8 0-13.1-2.1-18.3-5.6-9.4-6.4-20.6-8.4-30.3-7.7-9.7.7-20.9 4.5-29.4 13.3-8.8 9.1-21 14.7-34.6 14.7-13.7 0-26.1-5.7-34.9-15-8.4-8.9-19.6-12.7-29.2-13.6-9.7-.8-20.8 1.1-30.3 7.3-5 3.3-11.1 5.3-17.6 5.3-17.7 0-32-14.3-32-32s14.3-32 32-32c6.5 0 12.6 1.9 17.6 5.3 9.5 6.3 20.6 8.2 30.3 7.3 9.7-.8 20.8-4.7 29.2-13.6zM32 187.9V448c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64v-.3l86.8-38c25-11 41.2-35.7 41.2-63V228.8c0-38-30.8-68.8-68.8-68.8h-29.4c-17.5 25.7-45.5 43.8-77.8 48.2V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V206.9c-17.7-2.5-34-9.2-48-18.9zM208 224c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM320.3 97.2c.1 0 .1.1.1.1h.4l.2-.2c.1-.1.1-.2.2-.2v-.4l-.2-.2c-.1-.1-.2-.1-.2-.2h-.5l-.9.6.8.6zM96 96zm347.2 112c11.5 0 20.8 9.3 20.8 20.8v117.9c0 8.3-4.9 15.7-12.5 19.1L384 395.3V208h59.2zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"
        }
    ]
};

const FarBellConcierge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBellConcierge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368h48c0-97.2 78.8-176 176-176s176 78.8 176 176h48c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarBellExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBellExclamation",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-17.7 0-32 14.3-32 32v17.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416h400c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6c-28.3-35.5-43.8-79.6-43.8-125V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3c25.8-40 39.7-86.7 39.7-134.6V200c0-57.4 46.6-104 104-104h8zm64 352H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7S288 465 288 448zm-32-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-8-168c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80z"
        }
    ]
};

const FarBellOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBellOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c-17.7 0-32 14.3-32 32v17.9C215.5 61.4 160 124.2 160 200v33.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S110.8 416 120 416h400c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6c-28.3-35.5-43.8-79.6-43.8-125V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H168.3c25.8-40 39.7-86.7 39.7-134.6V200c0-57.4 46.6-104 104-104h8zm64 352H256c0 17 6.7 33.3 18.7 45.3S303 512 320 512s33.3-6.7 45.3-18.7S384 465 384 448zM0 200c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm536-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zm61.5-154.7c-5.9-11.9-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32c11.9-5.9 16.7-20.3 10.7-32.2zM53.3 53.5l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32c-11.9-6-26.3-1.2-32.3 10.7s-1.1 26.3 10.7 32.2z"
        }
    ]
};

const FarBellPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBellPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-17.7 0-32 14.3-32 32v17.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416h400c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6c-28.3-35.5-43.8-79.6-43.8-125V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3c25.8-40 39.7-86.7 39.7-134.6V200c0-57.4 46.6-104 104-104h8zm64 352H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7S288 465 288 448zm-64-296c-13.3 0-24 10.7-24 24v40h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-40c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarBellSchoolSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBellSchoolSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L570.7 422c3.4-6.6 5.3-14.1 5.3-22 0-26.5-21.5-48-48-48-12.1 0-23.1 4.5-31.5 11.8L445 323.5c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0c-60.8 0-115.4 26.1-153.5 67.6L38.8 5.1zm117.7 92.2C185.6 66.9 226.6 48 272 48c88.4 0 160 71.6 160 160 0 31.6-9.1 61-24.9 85.8L356.3 254c7.5-13.7 11.7-29.3 11.7-46 0-53-43-96-96-96-25 0-47.7 9.5-64.8 25.1l-50.7-39.8zm161 126.2-71.3-55.9c7.5-4.8 16.4-7.6 25.9-7.6 26.5 0 48 21.5 48 48 0 5.4-.9 10.6-2.6 15.5zM331 356.8c-18.3 7.2-38.2 11.2-59 11.2-88.4 0-160-71.6-160-160 0-7.6.5-15.2 1.6-22.5l-42-33.1c-5 17.7-7.6 36.3-7.6 55.6 0 59 24.6 112.2 64 150.1V448c0 35.3 28.7 64 64 64h288c13.1 0 25.3-3.5 35.9-9.6L467.1 464H414c1.3-5.1 2-10.5 2-16v-24.2l-85-67zm5 107.2H192c-8.8 0-16-7.2-16-16v-55.4c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4V448c0 8.8-7.2 16-16 16h-16z"
        }
    ]
};

const FarBellSchool = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBellSchool",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm144 310.1c39.4-37.9 64-91.1 64-150.1C416 93.1 322.9 0 208 0S0 93.1 0 208c0 59 24.6 112.2 64 150.1V448c0 35.3 28.7 64 64 64h288c39.2 0 71.1-31.4 72-70.4 14.4-8.3 24-23.8 24-41.6 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.7 9.6 33.2 24 41.5-.8 12.5-11.2 22.5-24 22.5h-66c1.3-5.1 2-10.5 2-16v-89.9zM288 464H128c-8.8 0-16-7.2-16-16v-55.4c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4V448c0 8.8-7.2 16-16 16zm-80-304a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
        }
    ]
};

const FarBellSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBellSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6c-28.3-35.5-43.8-79.6-43.8-125V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zm182.9 143.3C239.6 117.1 273.3 96 312 96h16c57.4 0 104 46.6 104 104v33.4c0 32.7 6.4 64.8 18.7 94.5l-229-179.5zM406.2 416l-60.9-48h-177c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1v11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S110.8 416 120 416h286.2zM384 448H256c0 17 6.7 33.3 18.7 45.3S303 512 320 512s33.3-6.7 45.3-18.7S384 465 384 448z"
        }
    ]
};

const FarBell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBell",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-17.7 0-32 14.3-32 32v17.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416h400c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6c-28.3-35.5-43.8-79.6-43.8-125V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3c25.8-40 39.7-86.7 39.7-134.6V200c0-57.4 46.6-104 104-104h8zm64 352H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7S288 465 288 448z"
        }
    ]
};

const FarBells = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBells",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M230.8 245.5c-27.6-75.2 1.6-157.3 65.7-199.5-4.5-2.2-9.1-4.2-13.9-6C214 15.1 138 50.4 112.8 119l-14.6 40C84 197.8 57.6 231 23 253.7l-8.1 5.3C4.7 265.7-.8 277.5.6 289.5s9.4 22.2 20.8 26.3l230.5 83.9 1.1-3.9c9.4-32.5 8.1-67.2-3.5-99.1l-18.7-51.2zm75.2-27.3c-17-46.4 6.9-97.8 53.3-114.7s97.9 7 114.9 53.4l18.8 51.2c15.8 43.1 43.6 80.8 80.1 108.5l-239.4 87.1c9.9-44.6 6.9-91.2-9-134.4L306 218.2zm-22.1 186.4-4.6 15.8c-3.3 11.6.1 24 9 32.2s21.5 10.8 32.8 6.7l297.5-108.2c11.3-4.1 19.4-14.2 20.8-26.2s-4-23.7-14-30.4l-13.7-9.2c-33.8-22.7-59.6-55.4-73.6-93.6l-18.8-51.2c-26.1-71.3-105.2-108-176.5-82.1s-108 104.8-81.9 176.2l18.8 51.2c14 38.2 15.5 79.8 4.3 118.9zM480.8 480c35.6 0 64.5-28.8 64.5-64.3 0-1.3 0-2.6-.1-3.9l-116.1 42.3c11.8 15.7 30.6 25.9 51.7 25.9zM94.3 376.1c-.3 2.5-.4 5-.4 7.5 0 35.5 28.9 64.3 64.5 64.3 22.3 0 41.9-11.3 53.5-28.4L94.3 376.1z"
        }
    ]
};

const FarBenchTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBenchTree",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M578.7 150c-14.7-10.6-22.1-28.5-19.3-46.4.4-2.5.6-5 .6-7.6 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 2.6.2 5.2.6 7.6 2.8 17.9-4.6 35.8-19.3 46.4-8.2 5.9-13.3 15.3-13.3 26 0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32 0-10.6-5.1-20.1-13.3-26zM608 96c0 5.1-.4 10.2-1.2 15.1 20.1 14.6 33.2 38.2 33.2 64.9 0 44.2-35.8 80-80 80h-24v232c0 13.3-10.7 24-24 24s-24-10.7-24-24V256h-24c-44.2 0-80-35.8-80-80 0-26.7 13.1-50.3 33.2-64.9-.8-4.9-1.2-10-1.2-15.1 0-53 43-96 96-96s96 43 96 96zM80 272h224v-32H80v32zm-48-48c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v64c0 14.9-10.2 27.4-24 31v33h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v88c0 13.3-10.7 24-24 24s-24-10.7-24-24v-88H80v88c0 13.3-10.7 24-24 24s-24-10.7-24-24v-88h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-33c-13.8-3.6-24-16.1-24-31v-64zm72 96v32h176v-32H104z"
        }
    ]
};

const FarBezierCurve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBezierCurve",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 80v64h-64V80h64zm-64-48c-26.5 0-48 21.5-48 48v8H123.3C113.9 64.5 90.9 48 64 48 28.7 48 0 76.7 0 112s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40h79C138.2 173.8 93.9 241.5 88.5 320H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-7.3c5.9-68.4 49.2-126.1 109.4-152.6C254.3 182.1 270 192 288 192h64c18 0 33.7-9.9 41.9-24.6 60.2 26.4 103.5 84.1 109.4 152.6H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-8.5c-5.3-78.5-49.7-146.2-113.8-184h79c9.5 23.5 32.5 40 59.3 40 35.3 0 64-28.7 64-64s-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H400v-8c0-26.5-21.5-48-48-48h-64zM48 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm512 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM144 368v64H80v-64h64zm352 0h64v64h-64v-64z"
        }
    ]
};

const FarBicycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBicycle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38c-4.5-6.3-11.8-10-19.5-10h-56c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zm142.6 264.3 36.3 67.1c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-36.3-67.1c4.9-.9 10-1.4 15.2-1.4 44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80c0-21.7 8.6-41.3 22.6-55.7zm-317.7-23.8-28.1 56.1c-9 18.1 4.1 39.4 24.3 39.4h73.2c-7.4 36.5-39.7 64-78.4 64-44.2 0-80-35.8-80-80s35.8-80 80-80c3 0 6 .2 8.9.5zm29.9 47.5 50.7-101.3 72.9 101.2-.1.1H166.8zm90.6-128h108.5L317 274.8 257.4 192z"
        }
    ]
};

const FarBillboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBillboard",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M440 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H248v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H80c-26.5 0-48 21.5-48 48v272h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h272v88c0 13.3 10.7 24 24 24s24-10.7 24-24v-88h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80c0-26.5-21.5-48-48-48H440v-8zM320 352H80V80h120v48h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h144v48h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h120v272H320z"
        }
    ]
};

const FarBinBottlesRecycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBinBottlesRecycle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0h80c13.3 0 24 10.7 24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16v-8c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96h128c24.9 0 47.6 9.5 64.6 25 1.1 1 2.2 2 3.2 3.1 17.5 17.4 28.2 41.4 28.2 67.9h32c0-40.7-19-76.9-48.6-100.4C340.6 86 346.9 81.3 354 78l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v42.1c5.6 1.3 11.1 3.2 16.4 5.7l13.2 6.2c21 9.9 34.4 31 34.4 54.2 0 12.3-3.7 23.8-10.1 33.3 5 7.8 8.4 16.9 9.6 26.5H616c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8l-23.7 201.3c-4.7 40.3-38.9 70.7-79.5 70.7H135.1c-40.6 0-74.7-30.4-79.5-70.7L32 240h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8zm48.3 48 23 195.7c1.9 16.1 15.6 28.3 31.8 28.3h369.8c16.2 0 29.9-12.1 31.8-28.3l23-195.7H80.3zm228.1 70.1-7.6 11.4c-4.8 7.2-14.5 9.3-21.8 4.7-7.6-4.8-9.8-14.9-4.8-22.4l7.6-11.4c8.5-12.7 22.8-20.4 38.1-20.4 15.4 0 29.8 7.7 38.2 20.6l8.5 12.9c4.9 7.5 2.7 17.6-4.9 22.4-7.4 4.6-17.1 2.5-21.8-4.8l-8.5-12.9c-2.6-3.9-6.9-6.2-11.5-6.2s-8.9 2.3-11.5 6.1zm-43.1 64.7-7.9 11.9c-.9 1.4-1.4 3.1-1.4 4.7 0 4.7 3.8 8.6 8.6 8.6h25.2c8.8 0 16 7.2 16 16s-7.2 16-16 16h-25.2c-22.4 0-40.6-18.2-40.6-40.6 0-8 2.4-15.8 6.8-22.5l7.9-11.9c4.8-7.2 14.5-9.3 21.8-4.7 7.6 4.8 9.8 14.9 4.8 22.4zm88.4 25.2h20.9c4.8 0 8.6-3.9 8.6-8.6 0-1.7-.5-3.3-1.4-4.7l-6.6-10.1c-4.9-7.5-2.7-17.6 4.9-22.4 7.4-4.6 17.1-2.5 21.8 4.8l6.6 10.1c4.4 6.6 6.7 14.4 6.7 22.4 0 22.4-18.2 40.6-40.6 40.6h-20.9c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarBinBottles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBinBottles",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0h80c13.3 0 24 10.7 24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16v-8c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96h128c24.9 0 47.6 9.5 64.6 25 1.1 1 2.2 2 3.2 3.1 17.5 17.4 28.2 41.4 28.2 67.9h32c0-40.7-19-76.9-48.6-100.4C340.6 86 346.9 81.3 354 78l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v42.1c5.6 1.3 11.1 3.2 16.4 5.7l13.2 6.2c21 9.9 34.4 31 34.4 54.2 0 12.3-3.7 23.8-10.1 33.3 5 7.8 8.4 16.9 9.6 26.5H616c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8l-23.7 201.3c-4.7 40.3-38.9 70.7-79.5 70.7H135.1c-40.6 0-74.7-30.4-79.5-70.7L32 240h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8zm71.4 243.7c1.9 16.1 15.6 28.3 31.8 28.3h369.7c16.2 0 29.9-12.1 31.8-28.3l23-195.7H80.3l23 195.7z"
        }
    ]
};

const FarBinRecycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBinRecycle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h528c13.3 0 24 10.7 24 24s-10.7 24-24 24h-11.4l-24.4 340.6c-2.3 33.5-30.2 59.4-63.8 59.4H123.6c-33.6 0-61.4-25.9-63.8-59.4L35.4 80H24C10.7 80 0 69.3 0 56zm83.6 24 24.1 337.1c.6 8.4 7.6 14.9 16 14.9h328.7c8.4 0 15.4-6.5 16-14.9l24-337.1H83.6zM288 176c-2.2 0-4.3 1.1-5.5 2.9l-20.7 29.6c-7.3 10.5-21.6 13.4-32.4 6.6-11.7-7.3-14.8-22.9-6.9-34.1l20.7-29.6c10.2-14.6 27-23.3 44.8-23.3s34.6 8.7 44.8 23.3l20.7 29.6c7.9 11.3 4.7 26.8-6.9 34.1-10.8 6.8-25.1 3.9-32.4-6.6l-20.7-29.6c-1.3-1.8-3.3-2.9-5.5-2.9zm-88.3 77.1c11.7 7.3 14.8 22.9 6.9 34.1l-21.5 30.7c-.8 1.1-1.2 2.4-1.2 3.7 0 3.5 2.9 6.4 6.4 6.4H240c13.3 0 24 10.7 24 24s-10.7 24-24 24h-49.6c-30.1 0-54.4-24.4-54.4-54.4 0-11.2 3.4-22.1 9.8-31.2l21.5-30.7c7.3-10.5 21.6-13.4 32.4-6.6zM312 352c0-13.3 10.7-24 24-24h49.6c3.5 0 6.4-2.9 6.4-6.4 0-1.3-.4-2.6-1.2-3.7l-21.5-30.7c-7.9-11.3-4.7-26.8 6.9-34.1 10.8-6.8 25.1-3.9 32.4 6.6l21.5 30.7c6.4 9.1 9.8 20 9.8 31.2 0 30.1-24.4 54.4-54.4 54.4H336c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarBinaryCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBinaryCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M318 4.5c6.3 4.5 10 11.8 10 19.5v152h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V57.3l-16.4 5.5c-12.6 4.2-26.2-2.6-30.4-15.2s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3zm-224 288c6.3 4.5 10 11.8 10 19.5v152h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V345.3l-16.4 5.5C27 355 13.4 348.2 9.2 335.6s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3zM72 0h48c39.8 0 72 32.2 72 72v80c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72V72C0 32.2 32.2 0 72 0zM48 72v80c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24zm144 288c0-39.8 32.2-72 72-72h48c8.8 0 17.2 1.6 25 4.5-6.8 14.4-11.8 29.8-14.5 45.9-3.2-1.5-6.7-2.4-10.5-2.4h-48c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h84.5c5.4 8.2 11.4 15.9 18 23.1-13.3 15.3-32.8 24.9-54.5 24.9h-48c-39.8 0-72-32.2-72-72v-80zm160 8a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FarBinaryLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBinaryLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M318 4.5c-6.3-4.5-14.3-5.7-21.6-3.3l-48 16C235.8 21.4 229 35 233.2 47.6S251 67 263.6 62.8l16.4-5.5V176h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V24c0-7.7-3.7-15-10-19.5zm-224 288c-6.3-4.5-14.3-5.7-21.6-3.3l-48 16C11.8 309.4 5 323 9.2 335.6S27 355 39.6 350.8l16.4-5.5V464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V312c0-7.7-3.7-15-10-19.5zM72 0C32.2 0 0 32.2 0 72v80c0 39.8 32.2 72 72 72h48c39.8 0 72-32.2 72-72V72c0-39.8-32.2-72-72-72H72zM48 72c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V72zm144 288v80c0 39.8 32.2 72 72 72h48c39.8 0 72-32.2 72-72v-80c0-39.8-32.2-72-72-72h-48c-39.8 0-72 32.2-72 72zm72-24h48c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24zm264-96c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FarBinarySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBinarySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376v-16c0-39.8-32.2-72-72-72h-40.3l-104.3-81.8C310.5 193 320 173.6 320 152V72c0-39.8-32.2-72-72-72h-48c-39.8 0-72 32.2-72 72v3L38.8 5.1zM176 112.6V72c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v80c0 10.7-7 19.7-16.6 22.8L176 112.6zM456 24c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16C363.8 21.4 357 35 361.2 47.6S379 67 391.6 62.8l16.4-5.5V176h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V24zM232 312c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16c-12.6 4.2-19.4 17.8-15.2 30.4s17.8 19.4 30.4 15.2l16.4-5.5V464h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V312zm88 48v80c0 39.8 32.2 72 72 72h48c22.2 0 42-10 55.2-25.8l-37.8-29.7c-4.4 4.7-10.6 7.6-17.5 7.6H392c-13.3 0-24-10.7-24-24v-54.2l-47.1-37.1c-.6 3.7-.9 7.4-.9 11.2z"
        }
    ]
};

const FarBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBinary",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328 24v152h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V57.3l-16.4 5.5c-12.6 4.2-26.2-2.6-30.4-15.2s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM104 312v152h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V345.3l-16.4 5.5C27 355 13.4 348.2 9.2 335.6s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM0 72C0 32.2 32.2 0 72 0h48c39.8 0 72 32.2 72 72v80c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72V72zm72-24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H72zm192 240h48c39.8 0 72 32.2 72 72v80c0 39.8-32.2 72-72 72h-48c-39.8 0-72-32.2-72-72v-80c0-39.8 32.2-72 72-72zm-24 72v80c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarBinoculars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBinoculars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v16H96V64zm-36.4 94c4.8-26.6 28-46 55.1-46H200c13.3 0 24 10.7 24 24v24h64v-24c0-13.3 10.7-24 24-24h85.3c27.1 0 50.3 19.4 55.1 46l5 27.3c3.6 19.9 10.8 39 21.2 56.4l2.6 4.4c20.1 33.6 30.8 72 30.8 111.1V424c0 30.9-25.1 56-56 56H344c-30.9 0-56-25.1-56-56V288h-64v136c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56v-66.8C0 318 10.6 279.6 30.8 246l2.6-4.4c10.4-17.4 17.6-36.5 21.2-56.4l5-27.3zm55.1 2c-3.9 0-7.2 2.8-7.9 6.6l-5 27.3C97.2 219.5 88 244 74.6 266.4l-2.6 4.4c-15.7 26.1-24 55.9-24 86.4V424c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8V160h-61.3zm282.6 0H336v264c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-66.8c0-30.4-8.3-60.3-23.9-86.4l-2.6-4.4c-13.4-22.3-22.6-46.9-27.3-72.5l-5-27.3c-.7-3.8-4-6.6-7.9-6.6zM352 32h32c17.7 0 32 14.3 32 32v16h-96V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarBiohazard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBiohazard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M173.2 0c-1.8 0-3.5.7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73-22 2.4-43.8 9.1-64.2 20.5-34.5 19.3-59.1 48.9-72 82.5-.7 1.7-.5 3.7.5 5.2 2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6 1 1.6 2.6 2.7 4.5 3 36.5 5.9 75.2.1 109.7-19.2 20.4-11.4 37.4-26.5 50.5-43.8 13.1 17.3 30.1 32.4 50.5 43.8 34.5 19.3 73.3 25.2 109.7 19.2 1.9-.3 3.5-1.4 4.5-3 2.2-3.7.1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3 1-1.6 1.1-3.5.5-5.2-12.9-33.6-37.5-63.2-72.1-82.5a168.77 168.77 0 0 0-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118-1.3-1.3-3-2-4.8-2-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-58.3 145.6c3.3-6.2 5.9-12.8 7.3-19.8-29.9-23.5-51.1-57.5-58.3-96.4-7.1-2.2-14.4-3.4-21.7-3.8-9-.4-18.1.6-27.1 2.7 7.8 57.1 38.7 106.8 82.9 139.4 6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5 2 8.3 5 16.2 9 23.5 3.8 6.9 8.5 13.3 14.3 18.8 18-7 37.5-10.8 57.9-10.8s40 3.8 57.9 10.8c5.8-5.5 10.5-11.9 14.3-18.8 4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zm157.3 237.3c-7.2 38.9-28.5 72.9-58.3 96.4 1.5 7 4 13.7 7.3 19.8 4.3 8 10 15.4 16.8 22.1 44.3-32.6 75.2-82.3 82.9-139.4-9-2.2-18.1-3.1-27.1-2.7-7.3.3-14.6 1.5-21.7 3.8z"
        }
    ]
};

const FarBird = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBird",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48.7 208H192c44.2 0 80-35.8 80-80v-16c0-35.3 28.7-64 64-64s64 28.7 64 64v80c0 97.2-78.8 176-176 176-91.8 0-167.2-70.3-175.3-160zM0 188.4v3.6c0 102.3 68.5 188.5 162.1 215.4l48.6 91.9c6.2 11.7 20.7 16.2 32.4 10s16.2-20.7 10-32.4L221 416h3c12.6 0 25-1 37.1-3.1l45.7 86.3c6.2 11.7 20.7 16.2 32.4 10s16.2-20.7 10-32.4l-40.9-77.2C390.3 366.3 448 285.9 448 192v-16.5l56.2-33.7c4.8-2.9 7.8-8.1 7.8-13.7s-2.9-10.8-7.8-13.7l-61.7-37C427.9 32.4 385.7 0 336 0c-61.9 0-112 50.1-112 112v16c0 17.7-14.3 32-32 32H28.4C12.7 160 0 172.7 0 188.4zM336 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarBitcoinSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBitcoinSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 24C64 10.7 74.7 0 88 0s24 10.7 24 24v40h32V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40.7c54 6 96 51.8 96 107.3 0 27.5-10.3 52.6-27.2 71.6 35.1 17.9 59.2 54.3 59.2 96.4 0 59.6-48.4 108-108 108h-20v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40h-32v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H41.7C18.7 448 0 429.3 0 406.3V101.6C0 80.8 16.8 64 37.6 64H64V24zM48 232h132c33.1 0 60-26.9 60-60s-26.9-60-60-60H48v120zm132 48H48v120h164c33.1 0 60-26.9 60-60s-26.9-60-60-60h-32z"
        }
    ]
};

const FarBlanketFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlanketFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 112c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v39.4c4.1-3.9 8.2-7.7 12.5-11.5 10-8.9 23-12.8 35.5-11.7V112C448 50.1 397.9 0 336 0H112C50.1 0 0 50.1 0 112v224c0 61.9 50.1 112 112 112h202.4c-8.7-14.9-15.4-31-19.9-48H112c-35.3 0-64-28.7-64-64s28.7-64 64-64h197c4.9-10 10.3-19.8 16.2-29.3 3.8-6.2 7.9-12.5 12.3-18.7H112c-23.8 0-45.9 7.4-64 20.1V112zm240 238.1c0-12.4 2-25.2 5.6-38.1H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h168.3c-.2-3.3-.3-6.6-.3-9.9zm165.5-186.3c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 433c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96z"
        }
    ]
};

const FarBlanket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlanket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 144v132.1c18.1-12.7 40.2-20.1 64-20.1h268c7 0 13.7 1 20 3V144c0-35.3-28.7-64-64-64H112c-35.3 0-64 28.7-64 64zM0 368V144C0 82.1 50.1 32 112 32h224c61.9 0 112 50.1 112 112v176h-.1c.1 1.3.1 2.7.1 4 0 37.6-30.4 68-68 68H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h260c11 0 20-9 20-20s-9-20-20-20H112c-35.3 0-64 28.7-64 64s28.7 64 64 64h312c13.3 0 24 10.7 24 24s-10.7 24-24 24H112C50.1 480 0 429.9 0 368z"
        }
    ]
};

const FarBlenderPhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlenderPhone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M158.1 64.1c4.7-12.4.2-26.7-10.6-33.4l-44-27.2c-9.7-6-21.9-4.2-29.8 4.3-98.3 106.2-98.3 278.2 0 384.4 7.9 8.5 20.1 10.3 29.8 4.3l44-27.2c10.8-6.7 15.3-21 10.6-33.4l-22-57.8c-4.2-10.9-14.5-17.6-25.3-16.4l-33.3 3.6c-13.6-42.2-13.6-88.4 0-130.7l33.3 3.6c10.9 1.2 21.2-5.5 25.3-16.4l22-57.8zM268.2 336h174.3l28-112H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h110.5l16-64H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h134.5l12-48H244.2l24 288zM566.1 39.8l-76.5 305.7C521.8 361 544 393.9 544 432v16c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-16c0-40.5 25.1-75.1 60.6-89.2L196.3 52C194 24 216.1 0 244.2 0H535c20.8 0 36.1 19.6 31 39.8zM208 432v16c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16v-16c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48zm144-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarBlender = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlender",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80C0 35.8 35.8 0 80 0h391c20.8 0 36.1 19.6 31 39.8l-76.4 305.7C457.8 361 480 393.9 480 432v16c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64v-16c0-40.5 25.1-75.1 60.6-89.2l-7.3-86.8H80c-44.2 0-80-35.8-80-80V80zm144 352v16c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16v-16c0-26.5-21.5-48-48-48H192c-26.5 0-48 21.5-48 48zm262.5-208H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h110.5l16-64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h134.5l12-48H180.2l24 288h174.3l28-112zM80 48c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h65.3L132 48H80zm208 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarBlindsOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlindsOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h120v196.1c-28 9.9-48 36.6-48 67.9 0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.3-20-58-48-67.9V48h296c13.3 0 24-10.7 24-24S501.3 0 488 0H24zm120 312a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM0 488c0 13.3 10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm64.3-168H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h56.3c-9-14.1-14.7-30.4-16-48zm191.3 48H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H271.7c-1.3 17.6-7 33.9-16 48zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h88v-48H24zm200 48h264c13.3 0 24-10.7 24-24s-10.7-24-24-24H224v48z"
        }
    ]
};

const FarBlindsRaised = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlindsRaised",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24c0 10.6 6.9 19.6 16.4 22.8l-15 45C.5 94.6 0 97.5 0 100.5 0 115.7 12.3 128 27.5 128H112V80H55.9l10.7-32H144v324.1c-28 9.9-48 36.5-48 67.9 0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.4-20-58-48-67.9V48h253.4l10.7 32H224v48h260.5c15.2 0 27.5-12.3 27.5-27.5 0-3-.5-5.9-1.4-8.7l-15-45C505.1 43.6 512 34.6 512 24c0-13.3-10.7-24-24-24H24zm120 440a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-32-232H55.5l15.4-48H20.5L1.3 219.9c-.9 2.7-1.3 5.6-1.3 8.4C0 243.6 12.4 256 27.7 256H112v-48zm112 48h260.3c15.3 0 27.7-12.4 27.7-27.7 0-2.9-.4-5.7-1.3-8.4L491.5 160h-50.4l15.4 48H224v48z"
        }
    ]
};

const FarBlinds = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlinds",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h464c13.3 0 24 10.7 24 24 0 8.6-4.5 16.2-11.4 20.4l11 57.6c.3 1.4.4 2.7.4 4.1 0 12.1-9.8 21.9-21.9 21.9H224V80h234.6l-6.1-32H192v116.1c28 9.9 48 36.6 48 67.9 0 39.8-32.2 72-72 72s-72-32.2-72-72c0-31.3 20-58 48-67.9V48H59.5l-6.1 32H112v48H21.9C9.8 128 0 118.2 0 106.1c0-1.4.1-2.8.4-4.1l11-57.6C4.5 40.2 0 32.6 0 24zm66.8 184c-1.8 7.7-2.8 15.7-2.8 24s1 16.3 2.8 24H21.9C9.8 256 0 246.2 0 234.1c0-1.4.1-2.8.4-4.1l13.3-70h48.9l-9.1 48h13.3zm202.4 48c1.8-7.7 2.8-15.7 2.8-24s-1-16.3-2.8-24h189.4l-9.1-48h48.9l13.3 70c.3 1.4.4 2.7.4 4.1 0 12.1-9.8 21.9-21.9 21.9h-221zM168 336h290.6l-9.1-48h48.9l13.3 70c.3 1.4.4 2.7.4 4.1 0 12.1-9.8 21.9-21.9 21.9H21.9C9.8 384 0 374.2 0 362.1c0-1.4.1-2.8.4-4.1l13.3-70h48.9l-9.1 48H168zM13.7 416h48.9l-9.1 48h405.1l-9.1-48h48.9l13.3 70c.3 1.4.4 2.7.4 4.1 0 12.1-9.8 21.9-21.9 21.9H21.9C9.8 512 0 502.2 0 490.1c0-1.4.1-2.8.4-4.1l13.3-70zM168 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarBlockBrickFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlockBrickFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 80v48h160V80H176zm-48 48V80H96c-8.8 0-16 7.2-16 16v32h48zm-48 48v56h128v-56H80zm0 160h48v-56H80v56zm0 48v32c0 8.8 7.2 16 16 16h112v-48H80zm96-48h112.8c-.5 4.7-.8 9.4-.8 14.1 0 11.5 1 22.9 3 33.9h-35v48h50.1c8.1 17.5 18.8 33.7 31.5 48H96c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v48.6c-1.7-1.5-3.3-3.1-5-4.6-17.7-16-44.7-16-62.5-.1-12.9 11.5-25.1 23.7-36.5 36.1H256v56h76c-2.4 3.6-4.7 7.2-6.9 10.7-7.4 12-14.2 24.5-19.9 37.3H176v56zm256-208V96c0-8.8-7.2-16-16-16h-32v48h48zm21.5 35.8c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15z"
        }
    ]
};

const FarBlockBrick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlockBrick",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80v48h160V80H144zm-48 48V80H64c-8.8 0-16 7.2-16 16v32h48zm-48 48v56h152v-56H48zm0 160h48v-56H48v56zm0 48v32c0 8.8 7.2 16 16 16h136v-48H48zm96-48h160v-56H144v56zm208 0h48v-56h-48v56zm48 48H248v48h136c8.8 0 16-7.2 16-16v-32zm0-208H248v56h152v-56zm0-48V96c0-8.8-7.2-16-16-16h-32v48h48zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FarBlockQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlockQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H160zM96 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96zm137.8 77.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L344 272.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM288 360a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM160 120a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm296-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 392a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm296-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarBlockQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlockQuote",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 72C10.7 72 0 82.7 0 96s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm128 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm-24 184c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H152c-13.3 0-24 10.7-24 24zM0 424c0 13.3 10.7 24 24 24s24-10.7 24-24V248c0-13.3-10.7-24-24-24S0 234.7 0 248v176z"
        }
    ]
};

const FarBlock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM160 32c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm48 88a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 392a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarBlog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlog",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 0c163.5 0 296 132.5 296 296 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-137-111-248-248-248-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 96c13.3 0 24 10.7 24 24v248c0 53 43 96 96 96s96-43 96-96-43-96-96-96h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c79.5 0 144 64.5 144 144s-64.5 144-144 144S0 447.5 0 368V120c0-13.3 10.7-24 24-24zm168 24c0-13.3 10.7-24 24-24 110.5 0 200 89.5 200 200 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-83.9-68.1-152-152-152-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarBlueberries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBlueberries",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 176C512 78.8 433.2 0 336 0c-80.6 0-148.6 54.2-169.4 128.2 3.1-.1 6.3-.2 9.4-.2 114.9 0 208 93.1 208 208 0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176zM384 64v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32z"
        }
    ]
};

const FarBluetooth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBluetooth",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.1 2.1c8.6-3.9 18.7-2.4 25.8 3.9l136 120c5.3 4.7 8.2 11.4 8.1 18.4s-3.3 13.6-8.7 18.1L229.8 256l113.5 93.5c5.4 4.5 8.6 11.1 8.7 18.1s-2.8 13.8-8.1 18.4l-136 120c-7.1 6.2-17.2 7.8-25.8 3.9S168 497.4 168 488V306.9l-96.7 79.6c-10.2 8.4-25.4 7-33.8-3.3s-7-25.4 3.3-33.8L154.2 256 40.7 162.5c-10.2-8.4-11.7-23.5-3.2-33.8s23.6-11.7 33.8-3.3l96.7 79.7V24c0-9.4 5.5-18 14.1-21.9zM216 306.9v128l75-66.2-75-61.8zm0-101.7 75-61.8-75-66.2v128z"
        }
    ]
};

const FarBold = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBold",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h188c68.5 0 124 55.5 124 124 0 34.7-14.3 66.2-37.3 88.7 41 20.2 69.3 62.4 69.3 111.3 0 68.5-55.5 124-124 124H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V80H24C10.7 80 0 69.3 0 56zm212 176c42 0 76-34 76-76s-34-76-76-76H96v152h116zM96 280v152h148c42 0 76-34 76-76s-34-76-76-76H96z"
        }
    ]
};

const FarBoltAuto = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoltAuto",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M317.4 36.6C322.6 18.3 308.8 0 289.7 0c-6.8 0-13.5 2.4-18.7 6.9L11.8 228.6C4.3 235 0 244.4 0 254.3 0 272.9 15.1 288 33.7 288h86.4L66.6 475.4c-5.2 18.3 8.6 36.6 27.7 36.6 6.8 0 13.4-2.4 18.6-6.8l258.8-219.6c7.8-6.6 12.3-16.4 12.3-26.6 0-19.3-15.6-34.9-34.9-34.9h-85.3l53.6-187.5zM72.4 240 253.6 85l-44.7 156.4c-2.1 7.2-.6 15 3.9 21s11.6 9.5 19.2 9.5h81.5L130.3 427.5l44.8-156.9c2.1-7.2.6-15-3.9-21s-11.6-9.5-19.2-9.5H72.4zM464 288c-9.1 0-17.4 5.1-21.5 13.3l-88 176c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l13.4-26.8h106.4l13.4 26.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-88-176c-4.1-8.1-12.4-13.3-21.5-13.3zm0 77.7 29.2 58.3h-58.4l29.2-58.3z"
        }
    ]
};

const FarBoltLightning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoltLightning",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M77 48 51.4 240H208c7.4 0 14.4 3.4 18.9 9.2s6.2 13.4 4.4 20.6l-23 91.8L322.8 192H176c-7.9 0-15.3-3.9-19.8-10.4s-5.4-14.9-2.6-22.2L196.9 48H77zM30.4 34.7C33 14.8 50 0 70 0h138.6c28.1 0 47.5 28.3 37.3 54.5L211.1 144h126.8c32.1 0 51.1 35.8 33.2 62.4l-199.2 295c-6.5 9.7-19 13.2-29.7 8.5s-16.3-16.4-13.5-27.7L177.3 288h-135c-24.2 0-42.9-21.3-39.7-45.3l27.7-208z"
        }
    ]
};

const FarBoltSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoltSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L450.2 327.6l49.5-42c7.8-6.6 12.3-16.4 12.3-26.6 0-19.3-15.6-34.9-34.9-34.9h-85.3l53.6-187.5C450.6 18.3 436.8 0 417.7 0c-6.8 0-13.5 2.4-18.7 6.9L227.9 153.3 38.8 5.1zm227.6 178.4L381.6 85l-44.1 154.3-71.1-55.7zM379.3 272h62.2l-29.8 25.3-32.4-25.3zm-42.9 89.1-78.2 66.4L288.1 323l-40.7-32.1-52.8 184.5c-5.2 18.4 8.5 36.6 27.6 36.6 6.8 0 13.4-2.4 18.6-6.8l134.1-113.8-38.5-30.3zm-183-144.2-13.7 11.7a33.71 33.71 0 0 0-11.8 25.6c0 18.6 15.1 33.7 33.7 33.7h82l-90.2-71.1z"
        }
    ]
};

const FarBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBolt",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M321.7 0c19.1 0 32.9 18.3 27.6 36.6L295.8 224H381c19.3 0 34.9 15.6 34.9 34.9 0 10.3-4.5 20-12.3 26.6L144.9 505.2c-5.2 4.4-11.8 6.8-18.6 6.8-19.1 0-32.9-18.3-27.6-36.6L152.2 288H65.7C47.1 288 32 272.9 32 254.3c0-9.9 4.3-19.2 11.8-25.6L303.1 6.9c5.2-4.5 11.8-6.9 18.6-6.9zm-36.1 85L104.4 240H184c7.5 0 14.6 3.5 19.2 9.5s6 13.8 3.9 21l-44.8 157L345.5 272H264c-7.5 0-14.6-3.5-19.2-9.5s-6-13.8-3.9-21L285.6 85z"
        }
    ]
};

const FarBomb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBomb",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m459.1 52.4 45.7 16.8c4.3 1.6 7.3 5.9 7.2 10.4 0 4.5-3 8.7-7.2 10.2l-45.7 16.8-16.5 45.8c-1.5 4.4-5.8 7.5-10.4 7.5s-8.9-3.1-10.4-7.5L405 106.6l-45.8-16.8c-4.2-1.5-7.2-5.7-7.2-10.2 0-4.6 3-8.9 7.2-10.4l46-16.8 16.5-45.9c1.9-3.9 6.1-6.5 10.4-6.5s8.5 2.6 10.4 6.5L459 52.3zm-156.2 97.2c-12.1 7.2-27.1 8.8-40.7 3.8-16.9-6.1-35.1-9.4-54.2-9.4-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160c0-19.1-3.3-37.4-9.4-54.2-4.9-13.7-3.3-28.6 3.8-40.7l-59.5-59.5zm-24.4-41.3 2.9-2.9c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3zM200 224c-39.8 0-72 32.2-72 72 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-66.3 53.7-120 120-120 13.3 0 24 10.7 24 24s-10.7 24-24 24z"
        }
    ]
};

const FarBoneBreak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoneBreak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM201 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-48-48zm272 34c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48zM296.1 264.8c-1.9-13.4-14.5-22.6-27.9-20.2L180.1 260c-4.1.7-8-1.8-9.4-5.7-14.3-39.1-55.3-63.6-98-56.1-47.8 8.4-79.8 53.6-71.3 101.1 4.5 25.1 19.3 45.7 39.4 58.4 4.7 3 5.8 9.5 2.5 13.9-14.5 18.7-21.3 43.2-16.8 68.3 8.4 47.5 54.1 79.1 101.9 70.8 42.7-7.5 72.8-44.4 72.7-86 0-4.1 2.8-7.8 6.9-8.5l112-19.6 112.1 19.6c4.1.7 6.9 4.4 6.9 8.5-.1 41.6 30 78.5 72.7 86 47.9 8.4 93.5-23.3 101.9-70.8 4.5-25.1-2.4-49.5-16.8-68.3-3.4-4.4-2.2-11 2.5-13.9 20.1-12.7 34.9-33.4 39.4-58.4 8.4-47.5-23.5-92.7-71.4-101.1-42.7-7.5-83.7 17-98 56.1-1.4 3.9-5.3 6.4-9.4 5.7l-88.1-15.4c-13.3-2.3-26 6.8-27.9 20.2-1.8 12.8 6.9 24.8 19.6 27l88.1 15.4c29.1 5.1 54.1-12.9 62.8-36.5 6.4-17.4 24.9-28.7 44.6-25.3 22.1 3.9 36.1 24.4 32.4 45.4-2 11.2-8.5 20.4-17.8 26.3-28.5 18-35.6 57-14.8 83.8 6.6 8.5 9.5 19.4 7.6 30.5-3.7 21.1-24.3 35.8-46.4 31.9-19.6-3.4-33-20.2-33-38.6 0-25.3-17.4-50.8-46.6-55.9l-115.6-20.1c-1.6-.3-3.2-.4-4.8-.4-1.6 0-3.2.1-4.8.4l-115.5 20.2c-29.2 5.1-46.7 30.6-46.7 55.9 0 18.4-13.4 35.2-33 38.6-22.2 3.9-42.7-10.8-46.4-31.9-2-11.1 1-22 7.6-30.5 20.8-26.9 13.7-65.9-14.8-83.8-9.2-5.8-15.8-15.1-17.8-26.3-3.7-20.9 10.3-41.5 32.4-45.4 19.7-3.4 38.3 7.9 44.6 25.3 8.6 23.6 33.7 41.6 62.8 36.5l88.1-15.4c12.8-2.2 21.5-14.2 19.6-27z"
        }
    ]
};

const FarBone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M127.4 177c-3.3-18.8-19.7-33-39.4-33-22.1 0-40 17.9-40 40 0 11.7 4.9 22.1 13 29.5 24.8 22.8 24.8 62.2 0 85-8 7.4-13 17.8-13 29.5 0 22.1 17.9 40 40 40 19.7 0 36.1-14.3 39.4-33 4.3-24.6 25.7-47 55.6-47h210c29.9 0 51.3 22.4 55.6 47 3.3 18.8 19.7 33 39.4 33 22.1 0 40-17.9 40-40 0-11.7-4.9-22.1-13-29.5-24.8-22.8-24.8-62.2 0-85 8-7.4 13-17.8 13-29.5 0-22.1-17.9-40-40-40-19.7 0-36.1 14.3-39.4 33-4.3 24.6-25.7 47-55.6 47H183c-29.9 0-51.3-22.4-55.6-47zm47.3-8.3c.7 4.1 4.1 7.3 8.3 7.3h210c4.1 0 7.6-3.2 8.3-7.3C408.5 127.4 444.6 96 488 96c48.6 0 88 39.4 88 88 0 25.7-11 48.8-28.5 64.9-4.1 3.7-4.1 10.5 0 14.2C565 279.2 576 302.3 576 328c0 48.6-39.4 88-88 88-43.4 0-79.5-31.4-86.7-72.7-.7-4.1-4.1-7.3-8.3-7.3H183c-4.1 0-7.6 3.2-8.3 7.3-7.2 41.3-43.3 72.7-86.7 72.7-48.6 0-88-39.4-88-88 0-25.7 11-48.8 28.5-64.9 4.1-3.7 4.1-10.5 0-14.2C11 232.8 0 209.7 0 184c0-48.6 39.4-88 88-88 43.4 0 79.5 31.4 86.7 72.7z"
        }
    ]
};

const FarBong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 208.5c0 23.3-12.4 43.2-29.9 54.4-21.8 14-39.6 33.8-51.1 57.1h258c-11.6-23.3-29.3-43.1-51.2-57.2-17.4-11.2-29.9-31.1-29.9-54.4V48H144v160.5zM288 48v160.5c0 5.7 3.1 10.9 7.9 14 11.2 7.2 21.5 15.5 30.9 24.8l39.3-39.3-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5 4.8-3.1 7.9-8.3 7.9-14V48h-8c-13.3 0-24-10.7-24-24S74.7 0 88 0h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8z"
        }
    ]
};

const FarBookArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h344c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-69.4c18.9-9 32-28.3 32-50.6v-56h-48v56c0 4.4-3.6 8-8 8H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h304c4.4 0 8 3.6 8 8v72h48V56c0-30.9-25.1-56-56-56H88zm280 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h288zm185-289c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h278.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"
        }
    ]
};

const FarBookArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h96v-48H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h96v-48H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h304c4.4 0 8 3.6 8 8v288c0 4.4-3.6 8-8 8h-88v48h64v64h-64v48h120c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-69.4c18.9-9 32-28.3 32-50.6V56c0-30.9-25.1-56-56-56H88zm55 215c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L216 488c0 13.3 10.7 24 24 24s24-10.7 24-24V209.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
        }
    ]
};

const FarBookAtlas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookAtlas",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64H80zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88c-22.1 0-40 17.9-40 40v270.7zM176.5 216h-31c4.8 26.1 21.1 48.2 43.5 60.8-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8-22.4 12.6-38.7 34.7-43.5 60.8h31zM112 200a120 120 0 1 1 240 0 120 120 0 1 1-240 0zm206.5 16h-31c-1.4 22.9-5.9 43.8-12.5 60.8 22.4-12.6 38.7-34.7 43.5-60.8zM275 123.2c6.6 16.9 11 37.8 12.5 60.8h31c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 216h-46.8c1.6 22.6 6.5 41.8 12.8 55.3 4.7 10.1 8.6 14.2 10.6 15.8 2-1.6 5.9-5.7 10.6-15.8 6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32h46.9c-1.6-22.6-6.5-41.8-12.8-55.3-4.7-10.1-8.6-14.2-10.6-15.8-2 1.6-5.9 5.7-10.6 15.8-6.3 13.5-11.2 32.7-12.8 55.3z"
        }
    ]
};

const FarBookBible = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookBible",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm48 344c0 17.7 14.3 32 32 32h288v-64H80c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88c-22.1 0-40 17.9-40 40v270.7zM208 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v96c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-96h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48V96z"
        }
    ]
};

const FarBookBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookBlank",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h344c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-69.4c18.9-9 32-28.3 32-50.6V56c0-30.9-25.1-56-56-56H88zm280 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h288zM80 352c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h304c4.4 0 8 3.6 8 8v288c0 4.4-3.6 8-8 8H80z"
        }
    ]
};

const FarBookBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookBookmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64H80zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8h-40v158.7c0 13.4-15.5 20.9-26 12.5L272 176l-54 43.2c-10.5 8.4-26 .9-26-12.5V48H88c-22.1 0-40 17.9-40 40v270.7z"
        }
    ]
};

const FarBookCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookCircleArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h314.8c-18.3-12.9-34.1-29.2-46.3-48H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h242.9c-1.9-10.4-2.9-21.1-2.9-32 0-5.4.2-10.7.7-16H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h304c4.4 0 8 3.6 8 8v164.5c14.6-9.5 30.8-17 48-21.8V56c0-30.9-25.1-56-56-56H88zm552 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-147.3-67.3c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FarBookCircleArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookCircleArrowUp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h314.8c-18.3-12.9-34.1-29.2-46.3-48H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h242.9c-1.9-10.4-2.9-21.1-2.9-32 0-5.4.2-10.7.7-16H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h304c4.4 0 8 3.6 8 8v164.5c14.6-9.5 30.8-17 48-21.8V56c0-30.9-25.1-56-56-56H88zm408 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zm-67.3 147.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-89.4l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"
        }
    ]
};

const FarBookCopy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookCopy",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 88c0-48.6 39.4-88 88-88h248c26.5 0 48 21.5 48 48v208c0 20.9-13.4 38.7-32 45.3V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H272c-44.2 0-80-35.8-80-80V88zm336-40H280c-22.1 0-40 17.9-40 40v174.7c9.8-4.3 20.6-6.7 32-6.7h256V48zM272 304c-17.7 0-32 14.3-32 32s14.3 32 32 32h224v-64H272zM160 96v48H88c-22.1 0-40 17.9-40 40v174.7c9.8-4.3 20.6-6.7 32-6.7h81.1c2.5 17.7 9.2 34 18.9 48H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h224v-16h48v16h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80V184c0-48.6 39.4-88 88-88h72z"
        }
    ]
};

const FarBookFont = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookFont",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64H80zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88c-22.1 0-40 17.9-40 40v270.7zM261.5 93.3l88 176c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 256h-98.4l-17.4 34.8c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l88-176C222.6 85.1 230.9 80 240 80s17.4 5.1 21.5 13.3zm3.7 114.7L240 157.7 214.8 208h50.3z"
        }
    ]
};

const FarBookHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64H80zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88c-22.1 0-40 17.9-40 40v270.7zm80-185.4c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
        }
    ]
};

const FarBookJournalWhills = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookJournalWhills",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64H80zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88c-22.1 0-40 17.9-40 40v270.7zm100.8-168.2c3.4 3.4 8.9 3.4 12.3 0s3.4-8.9 0-12.3l-28.8-28.9c8.2-17 20.2-31.8 35-43.4 3.9-3.1 9.3 1.9 7.9 6.7-6.9 23.5-.9 49.4 16.5 67.2 3.3 3.4 3.6 8.8.9 12.6-11 15.4-14.4 35.2-8.7 53.5 6.4 21.1 24 37.2 45.7 41.7L231 252l-11.3 7.8c-.7.4-1.6.7-2.5.7-1.1 0-2.2-.4-3-1.1-.8-1-1.4-2-1.4-3.3 0-.7.3-1.5.5-2.2l9.4-15.5-19.6-4.1c-1.9-.4-3.4-2.3-3.4-4.4s1.5-3.8 3.4-4.2l19.6-4.1-9.3-15.6c-1-1.8-.7-4.1.8-5.5s3.8-1.6 5.5-.4l13.1 8.9 5-120.8c.1-2.5 2-4.2 4.4-4.2s4.2 1.8 4.4 4.2l5.2 122.5 15.4-10.5c.6-.5 1.5-.7 2.3-.8h.1c1.6 0 3 .8 3.8 2.2s.7 3.1-.1 4.5l-9.3 15.5 19.6 4.1c1.9.4 3.4 2.2 3.4 4.2s-1.5 4-3.4 4.4l-19.6 4 9.3 15.7c.8 1.4 1 3 .1 4.4s-2.2 2.2-3.8 2.2c-.8 0-1.8-.3-2.5-.7l-13.8-9.4 1.5 37.4c21.7-4.5 39.3-20.6 45.7-41.7 5.7-18.3 2.3-38.2-8.7-53.5-2.8-3.8-2.4-9.3.9-12.7 17.4-17.9 23.4-43.8 16.4-67.3-1.4-4.8 4-9.7 7.9-6.7 14.8 11.5 26.8 26.4 35 43.5l-28.8 28.9c-3.4 3.4-3.4 8.9 0 12.3s8.9 3.4 12.3 0l23.2-23.2c3.3 11 5.6 22.5 5.6 34.5 0 .3 0 .5-.1.8s-.1.5-.1.8l-40.5 35.5c-1.8 1.8-2.9 4.1-3 6.5.1 2 .8 4.1 2.2 5.7 1.8 1.8 4.1 2.9 6.5 3 2.2 0 4.2-.8 5.7-2.2l26-22.6c-12.7 54.1-60.9 94.5-118.8 94.5s-106.1-40.4-118.8-94.5l25.8 22.5c1.6 1.4 3.7 2 5.7 2.2 3.7 0 6.8-2.3 8.2-5.6 1.2-3.4.3-7.4-2.5-9.7l-40.5-35.5c0-.3 0-.5-.1-.8s-.1-.5-.1-.8c0-12 2.3-23.5 5.6-34.5l23.2 23.2z"
        }
    ]
};

const FarBookMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm48 344c0 17.7 14.3 32 32 32h288v-64H80c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88c-22.1 0-40 17.9-40 40v270.7zM208 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FarBookOpenCover = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookOpenCover",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 337.2V52.4L344 77v296l168-35.8zM296 373V77L128 52.4v284.8L296 373zM523.4 2.2C542.7-.7 560 14.3 560 33.8v316.3c0 15.1-10.6 28.1-25.3 31.3l-201.3 43c-8.8 1.9-17.9 1.9-26.7 0l-201.3-43C90.6 378.3 80 365.2 80 350.1V33.8C80 14.3 97.3-.7 116.6 2.2L320 32 523.4 2.2zM38.3 23.7l10.2 2c-.3 2.7-.5 5.4-.5 8.1v375l265.8 54.5c2 .4 4.1.6 6.2.6s4.2-.2 6.2-.6L592 408.8v-375c0-2.8-.2-5.5-.5-8.1l10.2-2c19.8-4 38.3 11.1 38.3 31.3v366.9c0 15.2-10.7 28.3-25.6 31.3l-278.6 57.2c-5.2 1.1-10.5 1.6-15.8 1.6s-10.6-.5-15.8-1.6L25.6 453.2C10.7 450.2 0 437.1 0 421.9V55c0-20.2 18.5-35.3 38.3-31.3z"
        }
    ]
};

const FarBookOpenReader = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookOpenReader",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-28 279-.2-.1c-.7-.5-2.4-1.5-5.2-2.9-5.5-2.8-15.4-7.3-30.6-12.2-28-9-74.2-19.3-144-22.7v176.3c84.9 5 147.1 22.3 184 35.7V282l-4-3zm52 3v171.1c36.9-13.4 99.1-30.7 184-35.7V241.1c-69.9 3.4-116 13.7-144 22.7-15.1 4.9-25 9.4-30.6 12.2-2.8 1.4-4.5 2.4-5.2 2.9l-.2.1-4 3zM32 192.5c167.2 4.9 224 47.5 224 47.5s56.8-42.6 224-47.5c17.7-.5 32 13.9 32 31.5v208c0 17.7-14.4 31.9-32 32.7-114.9 4.7-186.9 33.7-208.8 43.8-4.8 2.2-9.9 3.5-15.1 3.5s-10.4-1.3-15.1-3.5c-21.9-10.1-93.9-39.1-208.8-43.8-17.7-.7-32-15-32-32.7V224c0-17.7 14.4-32.1 32-31.5z"
        }
    ]
};

const FarBookOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M156 32C100.6 32 48.8 46.6 27.1 53.6 10.3 59 0 74.5 0 91.1v312.4c0 26.1 24 44.2 48 40.2 19.8-3.3 54.8-7.7 100-7.7 54 0 97.5 25.5 112.5 35.6 7.5 5 16.8 8.4 27 8.4 11.5 0 21.6-4.2 29.3-9.9 13.4-9.8 52.3-34.1 111.2-34.1 47.7 0 80.5 4 99 7.2 23.9 4.1 49-13.8 49-40.6V91.1c0-16.5-10.3-32.1-27.1-37.5C527.2 46.6 475.4 32 420 32c-36.8 0-71.8 6.4-97.4 12.7-12.8 3.2-23.5 6.3-30.9 8.7-1.3.4-2.6.8-3.7 1.2-1.1-.4-2.4-.8-3.7-1.2-7.5-2.4-18.1-5.5-30.9-8.7C227.8 38.4 192.8 32 156 32zm108 65.3v320.6c-26-13.7-67.2-29.9-116-29.9-42.9 0-77.4 3.7-100 7.1V97.3C70.3 90.6 112.4 80 156 80c31.6 0 62.6 5.6 85.9 11.3 8.6 2.1 16.1 4.2 22.1 6zm48 319.2V97.3c6-1.8 13.5-3.9 22.1-6C357.4 85.6 388.4 80 420 80c43.6 0 85.7 10.6 108 17.3v297.4c-21.7-3.3-54.9-6.7-100-6.7-51.4 0-90.8 15-116 28.6z"
        }
    ]
};

const FarBookQuran = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookQuran",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M360 0c48.6 0 88 39.4 88 88v336h-.4c.3 2.6.4 5.3.4 8 0 44.2-35.8 80-80 80H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-69.4c-18.9-9-32-28.3-32-50.6V56C0 25.1 25.1 0 56 0h304zM80 400v64h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80zm288-48c11.4 0 22.2 2.4 32 6.7V88c0-22.1-17.9-40-40-40H56c-4.4 0-8 3.6-8 8v288c0 4.4 3.6 8 8 8h312zm-85.9-201.8c2.2-5.3 9.6-5.3 11.8 0l8.9 21.4 23.1 1.9c5.7.5 8 7.5 3.7 11.2L312 199.8l5.4 22.6c1.3 5.5-4.7 9.9-9.6 6.9L288 217.2l-19.8 12.1c-4.9 3-10.9-1.4-9.6-6.9l5.4-22.6-17.6-15.1c-4.3-3.7-2-10.8 3.7-11.2l23.1-1.9 8.9-21.4zm-24.6-45.6c4.1 1.8 6.5 5.9 6.5 10.3 0 7.6-7.1 13.2-14.7 13.1H248c-39.8 0-72 32.2-72 72s32.2 72 72 72h1.3c7.6-.1 14.7 5.5 14.7 13.1 0 4.4-2.4 8.5-6.5 10.3-12.7 5.5-26.8 8.6-41.5 8.6-57.4 0-104-46.6-104-104S158.6 96 216 96c14.8 0 28.8 3.1 41.5 8.6z"
        }
    ]
};

const FarBookSection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookSection",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64H80zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88c-22.1 0-40 17.9-40 40v270.7zm176.7-112.6c-20.7-5.5-63.7-17-55.7-58.8 2-10.5 7.5-19.2 15.6-25.8-11.5-8.8-19.4-21.7-15.6-41.7 5.7-29.8 37.9-45 82-38.7 7.8 1.1 16.8 3.3 28.3 6.9 7.9 2.5 12.3 10.9 9.9 18.8-2.5 7.9-11 12.3-18.8 9.9-9.9-3.1-17.5-4.9-23.6-5.8-26.1-3.8-46 2.3-48.4 14.7-1.7 8.7-.2 15.1 34 24.1l6.8 1.8c28.2 7.3 70.9 18.3 62.8 60.6-2 10.5-7.5 19.2-15.6 25.9 11.8 8.9 19.4 21.7 15.6 41.6-4.8 25.3-28.9 40.2-63.1 40.2-6 0-12.3-.5-18.9-1.4-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8c-7.9-2.5-12.2-11-9.7-18.8 2.5-7.9 11-12.3 18.9-9.7l5.5 1.8c10.1 3.3 21.5 7 31 8.3 26.3 3.7 46.1-2.3 48.4-14.7 2.3-11.9-5.4-16.8-40.9-26l-7-1.8zm-2.7-68.2c-8.1 1.1-21.6 4.5-23.6 15.1-1.7 8.7-.2 15.1 34 24.1 0 0 13.2 3.5 16.6 4.4 8.2-1.1 21.6-4.5 23.6-15 2.3-11.9-5.4-16.8-40.9-26 0 0-8.8-2.3-9.7-2.6z"
        }
    ]
};

const FarBookSkull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookSkull",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm48 344c0 17.7 14.3 32 32 32h288v-64H80c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88c-22.1 0-40 17.9-40 40v270.7zm240-163.5V208c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-12.8c-19.4-11.7-32-30.3-32-51.2 0-35.3 35.8-64 80-64s80 28.7 80 64c0 20.9-12.6 39.5-32 51.2zM224 144a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-143.2 74.9c2.8-8.4 11.9-12.9 20.2-10.1l91 30.3 90.9-30.3c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2L290.6 272l50.5 16.8c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-91-30.2-90.9 30.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l50.4-16.9-50.5-16.8c-8.4-2.8-12.9-11.9-10.1-20.2z"
        }
    ]
};

const FarBookSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookSparkles",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64H80zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88c-22.1 0-40 17.9-40 40v270.7zM160 112l8.8-17.7c2.9-5.9 11.4-5.9 14.3 0L192 112l17.7 8.8c5.9 2.9 5.9 11.4 0 14.3L192 144l-8.8 17.7c-2.9 5.9-11.4 5.9-14.3 0L160 144l-17.7-8.8c-5.9-2.9-5.9-11.4 0-14.3L160 112zm104 104 16.6-38.8c2.8-6.5 11.9-6.5 14.7 0L312 216l38.8 16.6c6.5 2.8 6.5 11.9 0 14.7L312 264l-16.6 38.8c-2.8 6.5-11.9 6.5-14.7 0L264 264l-38.8-16.6c-6.5-2.8-6.5-11.9 0-14.7L264 216z"
        }
    ]
};

const FarBookTanakh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookTanakh",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 88c0-48.6-39.4-88-88-88H56C25.1 0 0 25.1 0 56v288c0 22.3 13.1 41.6 32 50.6V464h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h344c44.2 0 80-35.8 80-80 0-2.7-.1-5.4-.4-8h.4V88zm-80 312c17.7 0 32 14.3 32 32s-14.3 32-32 32H80v-64h288zm32-41.3c-9.8-4.3-20.6-6.7-32-6.7H56c-4.4 0-8-3.6-8-8V56c0-4.4 3.6-8 8-8h304c22.1 0 40 17.9 40 40v270.7zM216 104l13.9 24h-27.8l13.9-24zm-13.9-24-27.7 48H119c-12.3 0-20 13.3-13.9 24l27.7 48-27.7 48c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H313c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24h-55.4l-27.7-48c-6.2-10.7-21.6-10.7-27.7 0zm-69.3 72h27.7l-13.9 24-13.9-24zm55.4 0h55.4l27.7 48-27.7 48h-55.3l-27.7-48 27.7-48zm-55.4 96 13.9-24 13.9 24h-27.7zm83.2 48-13.9-24h27.7L216 296zm83.1-48h-27.7l13.9-24 13.9 24zm0-96-13.9 24-13.9-24H299z"
        }
    ]
};

const FarBookUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C39.4 0 0 39.4 0 88v336h.4c-.3 2.6-.4 5.3-.4 8 0 44.2 35.8 80 80 80h344c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-69.4c18.9-9 32-28.3 32-50.6V56c0-30.9-25.1-56-56-56H88zm280 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h288zM80 352c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40h304c4.4 0 8 3.6 8 8v288c0 4.4-3.6 8-8 8h-40v-16c0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80v16H80zm160-128a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FarBook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBook",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h304c30.9 0 56 25.1 56 56v288c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80 0-2.7.1-5.4.4-8H0V88zm80 312c-17.7 0-32 14.3-32 32s14.3 32 32 32h288v-64H80zm-32-41.3c9.8-4.3 20.6-6.7 32-6.7h312c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88c-22.1 0-40 17.9-40 40v270.7zM152 112h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarBookmarkSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookmarkSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v27L38.8 5.1zM176 112.6V48h288v290.4L176 112.6zm333.9 385.2L315.3 344.5c-3.3.6-6.5 2-9.3 4l-130 92.9V234.7l-48-37.8V488c0 9 5 17.2 13 21.3s17.6 3.4 24.9-1.8l154.1-110 154.1 110c7.3 5.2 16.9 5.9 24.9 1.8 4.9-2.5 8.8-6.7 10.9-11.6z"
        }
    ]
};

const FarBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBookmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0v441.4l130.1-92.9c8.3-6 19.6-6 27.9 0l130 92.9V48H48V0h288c26.5 0 48 21.5 48 48v440c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5l-154.1 110c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488V48z"
        }
    ]
};

const FarBooksMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBooksMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 416v48h64v-48h-64zm88 89.6c-7.1 4.1-15.3 6.4-24 6.4h-64c-26.5 0-48-21.5-48-48v-80h112v-64h48v48h64V144h-64v48h-48v-64H64V48c0-26.5 21.5-48 48-48h64c8.7 0 16.9 2.3 24 6.4 7.1-4.1 15.3-6.4 24-6.4h64c20.6 0 38.1 12.9 45 31.1 5.6-6.1 12.9-10.7 21.4-13l59.5-16.5c24.7-6.8 50.1 8.3 56.7 33.8l18 69.2 6 23.2 61.8 238.3 6 23.2 11.9 46c6.6 25.5-8 51.7-32.7 58.5L482 510.3c-24.7 6.8-50.1-8.3-56.7-33.8l-18-69.2-6-23.2-61.7-238.2-3.6-13.7V464c0 26.5-21.5 48-48 48h-64c-8.7 0-16.9-2.3-24-6.4zm24-41.6h64v-48h-64v48zM176 48h-64v48h64V48zm48 48h64V48h-64v48zm280.1 259.7-55.8-215-56.5 15.6 55.8 215 56.5-15.6zm-44.4 62.1 11.9 45.7 56.4-15.6v-.4l-11.7-45.2-56.5 15.6zm-79.9-308 56.5-15.6-11.9-45.7L368 64.1v.4l11.7 45.2zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-48H16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FarBooks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBooks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416v48h64v-48H48zm88 89.6c-7.1 4.1-15.3 6.4-24 6.4H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h64c8.7 0 16.9 2.3 24 6.4 7.1-4.1 15.3-6.4 24-6.4h64c20.6 0 38.1 12.9 45 31.1 5.6-6.1 12.9-10.7 21.4-13l59.5-16.5c24.7-6.8 50.1 8.3 56.7 33.8l18 69.2 6 23.2 61.8 238.3 6 23.2 11.9 46c6.6 25.5-8 51.7-32.7 58.5L418 510.3c-24.7 6.8-50.1-8.3-56.7-33.8l-18-69.2-6-23.2-61.7-238.2-3.6-13.7V464c0 26.5-21.5 48-48 48h-64c-8.7 0-16.9-2.3-24-6.4zm24-41.6h64v-48h-64v48zM112 48H48v48h64V48zm0 96H48v224h64V144zm48-48h64V48h-64v48zm64 272V144h-64v224h64zm216.1-12.3-55.8-215-56.5 15.6 55.8 215 56.5-15.6zm-44.4 62.1 11.9 45.7 56.4-15.6v-.4l-11.7-45.2-56.5 15.6zm-79.9-308 56.5-15.6-11.9-45.7L304 64.1v.4l11.7 45.2z"
        }
    ]
};

const FarBoombox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoombox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 48h368c22.1 0 40 17.9 40 40v72h-96c0-17.7-14.3-32-32-32s-32 14.3-32 32h-32c0-17.7-14.3-32-32-32s-32 14.3-32 32h-32c0-17.7-14.3-32-32-32s-32 14.3-32 32H96V88c0-22.1 17.9-40 40-40zM48 88v74c-27.6 7.1-48 32.2-48 62v224c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V224c0-29.8-20.4-54.9-48-62V88c0-48.6-39.4-88-88-88H136C87.4 0 48 39.4 48 88zm16 120h512c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zm112 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-48-96a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm432 0a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarBootHeeled = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBootHeeled",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M31.3 0C14 0 0 14 0 31.3c0 1.8.1 3.9.6 6.2C2.6 47.1 24 154.3 24 232c0 33.2-12.8 93.5-19.7 123.2C1.6 367 0 379.3 0 391.8V488c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-22.7l121.6 40.5c12.2 4.1 25 6.2 37.9 6.2H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-33.3c0-28.1-16.3-53.6-41.8-65.4l-124.4-57.4a72.027 72.027 0 0 1-41.8-65.4V24c0-13.3-10.7-24-24-24H31.3zM432 430.7V464H287.6c-7.7 0-15.4-1.2-22.8-3.7l-129.2-43.1c-2.4-.8-5-1.2-7.6-1.2H48v-24.2c0-8.5 1.1-17.2 3.1-25.8C57.6 337.7 72 271.8 72 232c0-64.6-13.5-146.3-20.5-184H96v184c0 13.3 10.7 24 24 24s24-10.7 24-24V48h80v194.6c0 46.8 27.2 89.3 69.7 109L418 409c8.5 3.9 13.9 12.4 13.9 21.8z"
        }
    ]
};

const FarBoot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0h320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H0V32C0 14.3 14.3 0 32 0zM0 464V160h48v256h416v-56.6c0-21.2-13.9-39.9-34.2-46L345 288H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h66.7c-1.8-5-2.7-10.4-2.7-16v-16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-32h48v80l91.6 27.5c40.6 12.2 68.4 49.6 68.4 92V464h-.4c-1.5 12-6.9 23.3-15.6 32-10.2 10.2-24.1 16-38.6 16h-14.9c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7H54.6c-14.5 0-28.4-5.8-38.6-16-8.7-8.7-14.1-20-15.6-32H0z"
        }
    ]
};

const FarBoothCurtain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoothCurtain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 48c-4.4 0-8 3.6-8 8v432c0 13.3-10.7 24-24 24S0 501.3 0 488V56C0 25.1 25.1 0 56 0h90.3v48h-16.4.1-2.4.4-2.4.4-12.2.2-3.2.2-55zM416 0h40c30.9 0 56 25.1 56 56v432c0 13.3-10.7 24-24 24s-24-10.7-24-24v-28.1c-7.5 2.7-15.6 4.1-24 4.1-18.4 0-35.3-6.9-48-18.3-12.7 11.4-29.6 18.3-48 18.3s-35.3-6.9-48-18.3c-12.7 11.4-29.6 18.3-48 18.3-39.8 0-72-32.2-72-72V32c0-17.7 14.3-32 32-32h208zm-48 48h-48v344c0 13.3 10.7 24 24 24s24-10.7 24-24V48zm96 344V56c0-4.4-3.6-8-8-8h-40v344c0 13.3 10.7 24 24 24s24-10.7 24-24zm-240 0c0 13.3 10.7 24 24 24s24-10.7 24-24V48h-48v344z"
        }
    ]
};

const FarBorderAll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderAll",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v136H248V80h136zm16 200v136c0 8.8-7.2 16-16 16H248V280h152zm-200-48H48V96c0-8.8 7.2-16 16-16h136v152zM48 280h152v152H64c-8.8 0-16-7.2-16-16V280zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarBorderBottomRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderBottomRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v352c0 13.3-10.7 24-24 24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h352c39.8 0 72-32.2 72-72V56zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-192 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
        }
    ]
};

const FarBorderBottom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderBottom",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 456c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h400c13.3 0 24 10.7 24 24zm-64-104a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-320 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm256-192a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM0 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm256 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm128 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-320 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM448 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM0 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm256 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm32 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm64-192a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM96 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm64 192a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FarBorderCenterH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderCenterH",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm384-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarBorderCenterV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderCenterV",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 448a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-384 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm320-192a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-320 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm320 96a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-320 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM0 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm64 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm224-192a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm64-192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-64 384a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM96 448a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm64-192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm40 200c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v400z"
        }
    ]
};

const FarBorderInner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderInner",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-384 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm352-160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm352-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM0 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 64c-13.3 0-24-10.7-24-24V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h176V56c0-13.3 10.7-24 24-24s24 10.7 24 24v176h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v176c0 13.3-10.7 24-24 24z"
        }
    ]
};

const FarBorderLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 480c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24s24 10.7 24 24v400c0 13.3-10.7 24-24 24zm104-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FarBorderNone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderNone",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm384-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FarBorderOuter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderOuter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FarBorderRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M424 32c13.3 0 24 10.7 24 24v400c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192-32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarBorderTopLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderTopLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 456c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3 10.7-24 24-24h352c13.3 0 24-10.7 24-24s-10.7-24-24-24H72C32.2 32 0 64.2 0 104v352zm128-40a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarBorderTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBorderTop",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 80 0 69.3 0 56zm64 104a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-128 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM0 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm448 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM64 256a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-128 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM0 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm448 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-32-192a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM96 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm256 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-64-192a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarBoreHole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoreHole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c13.3 0 24 10.7 24 24v204.7c23.5 9.5 40 32.5 40 59.3 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V24c0-13.3 10.7-24 24-24zm0 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-144-96H80c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h352c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32h-32v112c0 79.5-64.5 144-144 144s-144-64.5-144-144V176zm16-48c17.7 0 32 14.3 32 32v128c0 53 43 96 96 96s96-43 96-96V160c0-17.7 14.3-32 32-32h48c44.2 0 80 35.8 80 80v224c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V208c0-44.2 35.8-80 80-80h48z"
        }
    ]
};

const FarBottleDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBottleDroplet",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48v104.2c0 16-8 31-21.3 39.9C80.9 209.4 64 238.8 64 272v176c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16V272c0-33.2-16.9-62.6-42.7-79.9-13.3-8.9-21.3-23.8-21.3-39.9V48h-64zm128-24c0 10.4-6.7 19.3-16 22.6v105.6C278.6 178 304 222 304 272v176c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V272c0-49.9 25.4-93.9 64-119.8V46.6C70.7 43.3 64 34.5 64 24 64 10.7 74.7 0 88 0h144c13.3 0 24 10.7 24 24zm-96 360c-26.5 0-48-21.5-48-48 0-22.2 23-52 37.2-68.2 5.8-6.7 15.9-6.7 21.7 0C185 284 208 313.8 208 336c0 32-21.5 48-48 48z"
        }
    ]
};

const FarBottleWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBottleWater",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v54c10.7 3.7 20.9 9.2 30 16.2l6 4.6c22.7 17.4 36 44.4 36 73.1 0 12.5-2.5 24.4-7 35.3 4.5 10 7 21.1 7 32.8 0 11.4-2.4 22.2-6.7 32 4.3 9.8 6.7 20.6 6.7 32s-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32s-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32 0 44.2-35.8 80-80 80H104c-44.2 0-80-35.8-80-80 0-11.4 2.4-22.2 6.7-32-4.3-9.8-6.7-20.6-6.7-32s2.4-22.2 6.7-32c-4.3-9.8-6.7-20.6-6.7-32s2.4-22.2 6.7-32c-4.3-9.8-6.7-20.6-6.7-32 0-11.7 2.5-22.8 7-32.8-4.5-10.9-7-22.8-7-35.3 0-28.6 13.3-55.6 36-73.1l6-4.6c9.1-7 19.3-12.5 30-16.2V24zm141.8 184c0-4.5 1.2-8.9 3.6-12.9 4.2-6.7 6.6-14.7 6.6-23.2 0-13.7-6.4-26.7-17.3-35l-6-4.6c-10.4-8-23.1-12.3-36.2-12.3h-57.1c-13.1 0-25.8 4.3-36.2 12.3l-6 4.6c-10.9 8.4-17.3 21.3-17.3 35 0 8.6 2.4 16.5 6.6 23.2 2.5 4 3.7 8.4 3.6 12.9h155.7zM82 336c0 4.8-1.4 9.6-4.3 13.7-3.6 5.2-5.7 11.5-5.7 18.3s2.1 13.1 5.7 18.3c5.8 8.2 5.8 19.2 0 27.5-3.6 5.1-5.7 11.4-5.7 18.2 0 17.7 14.3 32 32 32h112c17.7 0 32-14.3 32-32 0-6.8-2.1-13.1-5.7-18.3-5.8-8.2-5.8-19.2 0-27.5 3.6-5.2 5.7-11.4 5.7-18.3s-2.1-13.1-5.7-18.3c-2.9-4.1-4.3-8.9-4.3-13.7H82z"
        }
    ]
};

const FarBowArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowArrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1.3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35-247.2 247.1-50.8-12.7c-8.2-2-16.8.4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8 247.2-247 35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zM132.2 379.8l9.2 36.8-24.4 24.5-5.7-22.9c-2.1-8.6-8.9-15.3-17.5-17.5L70.9 395l24.4-24.4 36.8 9.2zm-79.5-265L49 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l136.3 136.5 33.9-33.9-98-98c61.2-37.6 138.2-39.2 200.8-4.9l35.1-35.1c-82.8-51.7-189.4-50-270.6 5.2zm314.7 109c34.3 62.6 32.7 139.6-4.9 200.8l-98-98-33.9 33.9L367 497c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-3.7-3.7c55.2-81.2 57-187.8 5.2-270.6l-35.1 35.1z"
        }
    ]
};

const FarBowlChopsticksNoodles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlChopsticksNoodles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M13.1 93.6 128 72V56c0-13.3 10.7-24 24-24s24 10.7 24 24v168h32V40c0-13.3 10.7-24 24-24s24 10.7 24 24v184h208c26.5 0 48 21.5 48 48 0 90.8-54.1 169-131.7 204.2-8.1 21-28.4 35.8-52.3 35.8H184c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272c0-26.5 21.5-48 48-48h80v-48H16.2C7.3 176 0 168.7 0 159.7c0-8.8 7-16 15.7-16.2L128 140v-32L18.5 125.1c-9.7 1.5-18.5-6-18.5-15.8 0-7.7 5.5-14.3 13.1-15.7zM488.4 176H288v-41l199.6-6.2c13.4-.5 24.4 10.2 24.4 23.6 0 13-10.6 23.6-23.6 23.6zm3.9-124.9L288 83V42L484.4 5.2c14.3-2.7 27.6 8.3 27.6 22.9 0 11.5-8.4 21.2-19.7 23zM151.5 432.5c11.5 5.2 20.4 14.7 25 26.4 1.2 3.1 4.2 5.1 7.5 5.1h144c3.3 0 6.3-2 7.5-5.1 4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272H48c0 71.3 42.4 132.8 103.5 160.5z"
        }
    ]
};

const FarBowlChopsticks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlChopsticks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M18.5 125.1c-9.7 1.5-18.5-6-18.5-15.8 0-7.7 5.5-14.3 13.1-15.7L484.4 5.2c14.3-2.7 27.6 8.3 27.6 22.9 0 11.5-8.4 21.2-19.7 23l-473.8 74zM0 159.7c0-8.8 7-16 15.7-16.2l471.9-14.7c13.4-.5 24.4 10.2 24.4 23.6 0 13-10.6 23.6-23.6 23.6H16.2C7.3 176 0 168.7 0 159.7zm151.5 272.8c11.5 5.2 20.4 14.7 25 26.4 1.2 3.1 4.2 5.1 7.5 5.1h144c3.3 0 6.3-2 7.5-5.1 4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272H48c0 71.3 42.4 132.8 103.5 160.5zM0 272c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48 0 90.8-54.1 169-131.7 204.2-8.1 21-28.4 35.8-52.3 35.8H184c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272z"
        }
    ]
};

const FarBowlFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlFood",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192c0 11.7 3.1 22.6 8.6 32h494.8c5.4-9.4 8.6-20.3 8.6-32 0-35.3-28.7-64-64-64h-1.6C439 91.5 406.7 64 368 64c-15 0-29 4.1-40.9 11.2C313.8 49.6 286.9 32 256 32s-57.8 17.6-71.1 43.2C173 68.1 159 64 144 64c-38.7 0-71 27.5-78.4 64H64c-35.3 0-64 28.7-64 64zm144.7 228.6c-4-13.5-13.8-24.6-26.8-30.3-35.2-15.4-61.2-47.6-68.1-86.3h412.4c-6.9 38.7-32.9 70.9-68.1 86.3-12.9 5.7-22.7 16.7-26.8 30.3-2 6.6-8.2 11.4-15.3 11.4H160c-7.2 0-13.4-4.8-15.3-11.4zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480h192c29 0 53.5-19.3 61.4-45.7 58.1-25.4 98.6-83.4 98.6-150.8 0-15.1-12.3-27.4-27.4-27.4H27.4z"
        }
    ]
};

const FarBowlHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlHot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0c13.3 0 24 10.7 24 24v8c0 17.6 8.3 34.2 22.4 44.8C224.6 96.4 240 127.3 240 160v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-17.6-8.3-34.2-22.4-44.8C143.4 95.6 128 64.7 128 32v-8c0-13.3 10.7-24 24-24zm-.5 432.5c11.5 5.2 20.4 14.7 25 26.4 1.2 3.1 4.2 5.1 7.5 5.1h144c3.3 0 6.3-2 7.5-5.1 4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272H48c0 71.3 42.4 132.8 103.5 160.5zM0 272c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48 0 90.8-54.1 169-131.7 204.2-8.1 21-28.4 35.8-52.3 35.8H184c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272zM304 24v8c0 17.6 8.3 34.2 22.4 44.8C352.6 96.4 368 127.3 368 160v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-17.6-8.3-34.2-22.4-44.8C271.4 95.6 256 64.7 256 32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarBowlRice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlRice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24zm24 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16zM56 176c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm88.7 244.6c-4-13.5-13.8-24.6-26.8-30.3-35.2-15.4-61.2-47.6-68.1-86.3h412.4c-6.9 38.7-32.9 70.9-68.1 86.3-12.9 5.7-22.7 16.7-26.8 30.3-2 6.6-8.2 11.4-15.3 11.4H160c-7.2 0-13.4-4.8-15.3-11.4zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480h192c29 0 53.5-19.3 61.4-45.7 58.1-25.4 98.6-83.4 98.6-150.8 0-15.1-12.3-27.4-27.4-27.4H27.4zM224 200c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24zm-96 0c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16zm216 96c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16zm120 96c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16zm-96-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16z"
        }
    ]
};

const FarBowlScoop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlScoop",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224h384c0-106-86-192-192-192S32 118 32 224zm141.8 144H145c-41.4 0-77.2-26.3-90.5-64h339c-13.3 37.7-49.1 64-90.5 64H173.8zm36.9 78.7 13.3-15.9 13.3 15.9 14.4 17.3h-55.4l14.4-17.3zm92.3 3.9L274.2 416H303c10.6 0 20.9-1.1 30.9-3.3 58.5-12.8 104.3-61.2 112-122.8l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c7.7 61.6 53.5 110 112 122.8 10 2.2 20.3 3.3 30.9 3.3h28.8L145 450.6l-10.9 13.1-.3.3-.4.5-5.4 6.5-12.3 14.7c-4 4.8-4.8 11.4-2.2 17s8.3 9.2 14.5 9.2h192c6.2 0 11.9-3.6 14.5-9.2s1.8-12.3-2.2-17L320 471l-5.5-6.5-.4-.5-.3-.3-10.8-13.1z"
        }
    ]
};

const FarBowlScoops = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlScoops",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208c0 5.4.4 10.8 1.1 16h221.8c.7-5.2 1.1-10.6 1.1-16 0-61.9-50.1-112-112-112h-1.1c-38.7.4-72.7 20.4-92.6 50.6-11.6 17.6-18.3 38.7-18.3 61.4zM0 208c0 5.4.4 10.8 1.1 16h191.8c-.6-5.3-.9-10.6-.9-16 0-22 4.9-42.8 13.7-61.4-19.8-30.2-53.8-50.2-92.6-50.6H112C50.1 96 0 146.1 0 208zM325.4 64.4C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4c40.9 3 77.1 23 101.4 53.1 24.3-30.1 60.5-50.1 101.4-53.1zM173.8 368H145c-41.4 0-77.2-26.3-90.5-64h339c-13.3 37.7-49.1 64-90.5 64H173.8zm36.9 78.7 13.3-15.9 13.3 15.9 14.4 17.3h-55.4l14.4-17.3zm92.3 3.9L274.2 416H303c10.6 0 20.9-1.1 30.9-3.3 58.5-12.8 104.3-61.2 112-122.8l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c7.7 61.6 53.5 110 112 122.8 10 2.2 20.3 3.3 30.9 3.3h28.8L145 450.6l-10.9 13.1-.3.3-.4.5-5.4 6.5-12.3 14.7c-4 4.8-4.8 11.4-2.2 17s8.3 9.2 14.5 9.2h192c6.2 0 11.9-3.6 14.5-9.2s1.8-12.3-2.2-17L320 471l-5.5-6.5-.4-.5-.3-.3-10.8-13.1z"
        }
    ]
};

const FarBowlSoftServe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlSoftServe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-8.9 0-17 4.9-21.2 12.7S231.1 30 236 37.3l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7 0 3.7-3 6.7-6.7 6.7H172c-42 0-76 34-76 76 0 4.7.4 9.3 1.2 13.8C51 162.5 16 203.2 16 252c0 29 12.3 55.1 32 73.3V344c0 57.4 46.6 104 104 104h30.1l-20.4 40.8c-1.1 2.3-1.7 4.7-1.7 7.2 0 2.9.8 5.8 2.4 8.4 2.9 4.7 8.1 7.6 13.6 7.6h160c5.5 0 10.7-2.9 13.6-7.6 1.6-2.6 2.4-5.5 2.4-8.4 0-2.4-.6-4.9-1.7-7.2L329.9 448H360c57.4 0 104-46.6 104-104v-18.7c19.7-18.3 32-44.4 32-73.3 0-49.1-35.3-89.9-82-98.4 1.3-5.7 2-11.6 2-17.6C416 60.9 355.1 0 280 0h-24zm140 304H116c-28.7 0-52-23.3-52-52s23.3-52 52-52h52c13.3 0 24-10.7 24-24s-10.7-24-24-24h-21.3c-1.7-3.6-2.7-7.7-2.7-12 0-15.5 12.5-28 28-28h69.3c30.2 0 54.7-24.5 54.7-54.7 0-2.7-.2-5.3-.6-8C336.7 56.6 368 92.7 368 136c0 5.8-1.5 11.3-4.3 16H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h116c28.7 0 52 23.3 52 52s-23.3 52-52 52z"
        }
    ]
};

const FarBowlSpoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlSpoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 144c-42.6 0-64-28.2-64-48s21.4-48 64-48 64 28.2 64 48-21.4 48-64 48zm0 48c52.2 0 96-30.6 108.5-72H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H220.5C208 30.6 164.2 0 112 0 50.1 0 0 43 0 96s50.1 96 112 96zm64.5 266.9c-4.5-11.7-13.5-21.2-25-26.4C90.4 404.8 48 343.3 48 272h416c0 71.3-42.4 132.8-103.5 160.5-11.5 5.2-20.4 14.7-25 26.4-1.2 3.1-4.2 5.1-7.5 5.1H184c-3.3 0-6.3-2-7.5-5.1zM48 224c-26.5 0-48 21.5-48 48 0 90.8 54.1 169 131.7 204.2 8.1 21 28.4 35.8 52.3 35.8h144c23.8 0 44.2-14.9 52.3-35.8C457.9 441 512 362.8 512 272c0-26.5-21.5-48-48-48H48z"
        }
    ]
};

const FarBowlingBallPin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlingBallPin",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 48c-17.7 0-32 14.3-32 32v4.4c0 5.8.7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1h33.6c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1V80c0-17.7-14.3-32-32-32zm-25.7 182.2-1 2.7c-8.5-27.4-21.8-52.7-38.8-74.9-.4-2.5-1-5-1.6-7.4l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7V80c0-44.2 35.8-80 80-80s80 35.8 80 80v4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2v1c0 12.5 2.2 24.8 6.6 36.5l28.4 75.7c8.6 23 13 47.4 13 72 0 29.3-6.3 58.2-18.4 84.8L536 493.2c-5.2 11.4-16.6 18.8-29.1 18.8h-85.7c-12.6 0-23.9-7.3-29.1-18.8l-10.6-23.3c12.6-13.1 23.7-27.7 33-43.4l17 37.5h65.1l17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9 0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2h-38.6c-1.6 7.5-3.7 14.9-6.4 22.2zM168 196a28 28 0 1 1 56 0 28 28 0 1 1-56 0zm28 60a28 28 0 1 1 0 56 28 28 0 1 1 0-56zM96 244a28 28 0 1 1 56 0 28 28 0 1 1-56 0zm272 60a160 160 0 1 0-320 0 160 160 0 1 0 320 0zM0 304a208 208 0 1 1 416 0 208 208 0 1 1-416 0z"
        }
    ]
};

const FarBowlingBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlingBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarBowlingPins = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBowlingPins",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48c-17.7 0-32 14.3-32 32v4.4c0 5.8.7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1h33.6c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1V80c0-17.7-14.3-32-32-32zm-25.7 182.2L74 305.7c-6.6 17.6-10 36.3-10 55.1 0 22.4 4.8 44.5 14.1 64.9L95.5 464h65.1l17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9 0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2h-38.6c-1.6 7.5-3.7 14.9-6.4 22.2zM48 80c0-44.2 35.8-80 80-80s80 35.8 80 80v4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2v1c0 12.5 2.2 24.8 6.6 36.5l28.4 75.7c8.6 23 13 47.4 13 72 0 29.3-6.3 58.2-18.4 84.8L200 493.2c-5.2 11.4-16.6 18.8-29.1 18.8H85.2c-12.5 0-23.9-7.3-29.1-18.8l-21.7-47.6C22.3 419 16 390.1 16 360.8c0-24.6 4.4-48.9 13-72l28.3-75.5c4.4-11.7 6.6-24 6.6-36.5v-1c0-8.5-1-17-3.1-25.2l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7V80zm336-32c-17.7 0-32 14.3-32 32v4.4c0 5.8.7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1h33.6c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1V80c0-17.7-14.3-32-32-32zm-25.7 182.2L330 305.7c-6.6 17.6-10 36.3-10 55.1 0 22.4 4.8 44.5 14.1 64.9l17.4 38.3h65.1l17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9 0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2h-38.6c-1.6 7.5-3.7 14.9-6.4 22.2zM304 80c0-44.2 35.8-80 80-80s80 35.8 80 80v4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2v1c0 12.5 2.2 24.8 6.6 36.5l28.4 75.7c8.6 23 13 47.4 13 72 0 29.3-6.3 58.2-18.4 84.8L456 493.2c-5.2 11.4-16.6 18.8-29.1 18.8h-85.7c-12.6 0-23.9-7.3-29.1-18.8l-21.7-47.6C278.3 419 272 390.1 272 360.8c0-24.6 4.4-48.9 13-72l28.3-75.5c4.4-11.7 6.6-24 6.6-36.5v-1c0-8.5-1-17-3.1-25.2l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7V80z"
        }
    ]
};

const FarBoxArchive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxArchive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 80v48h416V80H48zM32 32h448c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm128 216c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zM32 416V208h48v208c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V208h48v208c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64z"
        }
    ]
};

const FarBoxBallot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxBallot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 208h224V48H176v160zM128 32c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V32zM48 160h48v48H48v112h480V208h-48v-48h48c26.5 0 48 21.5 48 48v256c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V208c0-26.5 21.5-48 48-48zm480 208H48v96h480v-96z"
        }
    ]
};

const FarBoxCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 80h94.4c6.3 0 12.1 3.7 14.6 9.5l31.4 70.5H248V80zM48 208h352v208c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208zm152-48H59.6L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5H200v80zm200.9-90c-10.3-23.1-33.2-38-58.5-38H105.6c-25.3 0-48.2 14.9-58.5 38L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM337 265c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 265z"
        }
    ]
};

const FarBoxCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M342.4 80c6.3 0 12.1 3.7 14.6 9.5l31.4 70.5H248V80h94.4zM48 208h310.6c22.3-10.3 47.2-16 73.4-16 5.4 0 10.7.2 16 .7v-3.1c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6c-25.3 0-48.2 14.9-58.5 38L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64h232.2c-11.8-14.3-21.4-30.5-28.2-48H64c-8.8 0-16-7.2-16-16V208zm11.6-48L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5H200v80H59.6zM576 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarBoxDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxDollar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 80h94.4c6.3 0 12.1 3.7 14.6 9.5l31.4 70.5H248V80zm-5.7 128H400v208c0 8.8-7.2 16-16 16H242.3c1.1-2.5 1.7-5.2 1.7-8v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216c0-2.8-.6-5.6-1.7-8zm-36.7 0c-1.1 2.4-1.7 5.2-1.7 8v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V424c0 2.8.6 5.5 1.7 8H64c-8.8 0-16-7.2-16-16V208h157.7zm-5.6-48H59.6L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5H200v80zm200.9-90c-10.3-23.1-33.2-38-58.5-38H105.6c-25.3 0-48.2 14.9-58.5 38L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70z"
        }
    ]
};

const FarBoxHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 80h94.4c6.3 0 12.1 3.7 14.6 9.5l31.4 70.5H248V80zM48 208h352v208c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208zm152-48H59.6L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5H200v80zm200.9-90c-10.3-23.1-33.2-38-58.5-38H105.6c-25.3 0-48.2 14.9-58.5 38L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM212.7 404.7c6.2 6.2 16.4 6.2 22.6 0l77.3-77.3c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 267.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3l77.3 77.3z"
        }
    ]
};

const FarBoxOpenFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxOpenFull",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480.9 3.1c-24.9-9.3-52.5 3.2-61.8 28.1L384 124.8C382.2 55.6 325.6 0 256 0c-70.7 0-128 57.3-128 128 0 2.2.1 4.3.2 6.5l65.5 8.2c-1.1-4.7-1.7-9.6-1.7-14.7 0-35.3 28.7-64 64-64s64 28.7 64 64c0 10.7-2.6 20.7-7.2 29.6l7.2.9 161.4-20.2 27.5-73.4c9.3-24.8-3.3-52.5-28.1-61.8zm-422 167-41.7 83.4c-9 17.9.6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 192 75.2 161.4c-6.7-.8-13.3 2.7-16.3 8.7zM576 339.6l-48 13.7v57.2l-184 46V312c0-13.3-10.7-24-24-24s-24 10.7-24 24v144.5l-184-46v-57.2l-48-13.7v71c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.5 20.9 2.5 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6v-71zm46.8-86.1-41.7-83.4c-3-6.1-9.6-9.6-16.3-8.7L320 192l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1z"
        }
    ]
};

const FarBoxOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxOpen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.2 125.5c-9 17.9.6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 64 75.2 33.4c-6.7-.8-13.3 2.7-16.3 8.7l-41.7 83.4zM320 64l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1l-41.6-83.4c-3-6.1-9.6-9.6-16.3-8.7L320 64zm-1.1 64h2.2-2.2zM528 225.3v153.2l-184 46V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v240.5l-184-46V225.3l-48-13.7v167c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.5 20.9 2.5 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6v-167l-48 13.7z"
        }
    ]
};

const FarBoxTaped = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxTaped",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M261.3 80h81.1c6.3 0 12.1 3.7 14.6 9.5l31.4 70.5H288l-26.7-80zm-74.7 0L160 160H59.6L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5h81.1zM160 208v48c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-48h112v208c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208h112zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6c-25.3 0-48.2 14.9-58.5 38L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70z"
        }
    ]
};

const FarBoxTissue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxTissue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48h-90.5l57.1 228.4 2.9 11.6h154.8l7.1-17.8L389.9 144H336c-31.1 0-56.2-9.9-75.5-28.2-15.8-15-25.1-33.7-30.5-44.6l-.9-1.8c-6.8-13.4-9.3-17.4-11.6-19.6-.5-.5-.8-.6-1.3-.8-.7-.3-3-1-8.2-1zm176 240h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h8l-8-32-12-48L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2c14.8 0 26.8 12 26.8 26.8 0 3.4-.7 6.8-1.9 10L416 208l-19.2 48-12.8 32zM75 208l12 48H48v112h416V256h-32.7l19.2-48H464c26.5 0 48 21.5 48 48v208c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48h27zM48 416v48h416v-48H48z"
        }
    ]
};

const FarBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBox",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M342.4 80H248v80h140.4L357 89.5c-2.6-5.8-8.3-9.5-14.6-9.5zM400 208H48v208c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V208zM59.6 160H200V80h-94.4c-6.3 0-12.1 3.7-14.6 9.5L59.6 160zM342.4 32c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38h236.8z"
        }
    ]
};

const FarBoxesPacking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxesPacking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M592 48H304v80h-48V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16v-32h208V48zm-31 263c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V392c0 13.3-10.7 24-24 24s-24-10.7-24-24v-70.1l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0l64 64zM48 208v48h288v-48H48zM0 272v-80c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32v176c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V304c-17.7 0-32-14.3-32-32zm80 32v160h224V304H80zm72 32h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarBoxesStacked = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxesStacked",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c8.8 0 16 7.2 16 16v128h48V64c0-35.3-28.7-64-64-64H192c-35.3 0-64 28.7-64 64v128h48V64c0-8.8 7.2-16 16-16h56v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V48h56zm-56.4 464H512c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H327.6c11.8 13.2 20.1 29.7 23.1 48H376v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-64h56c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H350.7a95.98 95.98 0 0 1-23.1 48zM256 272c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16h56v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-64h56zM64 224c-35.3 0-64 28.7-64 64v160c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarBoxingGlove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBoxingGlove",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 120c0-39.8 32.2-72 72-72h152c39.8 0 72 32.2 72 72v8h-32c-40.3 0-74.2 27.1-84.7 64h-59.8c-19.9 0-36.8-14.6-39.6-34.3l-.2-1.1c-1.9-13.1-14-22.2-27.2-20.4s-22.2 14-20.4 27.2l.2 1.1c6.2 43.4 43.3 75.6 87.1 75.6h59.8c10.4 36.9 44.4 64 84.7 64 13.3 0 24-10.7 24-24s-10.7-24-24-24c-22.1 0-40-17.9-40-40s17.9-40 40-40H363c.6.1 1.2.2 1.9.3 19.7 2.5 35 19.3 35 39.7V255c0 14.9-5.9 29.1-16.4 39.6l-60.9 60.9c-12 12-18.7 28.3-18.7 45.3V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-88.4c0-6.8-2.9-13.3-8-17.9-14.8-13.2-24-32.4-24-53.7V120zM120 0C53.7 0 0 53.7 0 120v168c0 31.5 12.2 60.2 32 81.6V448c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64v-47.4c0-4.2 1.7-8.3 4.7-11.3l60.9-60.9c19.5-19.5 30.5-46 30.5-73.5V216c0-37.3-23.2-69.2-56-82v-14C392 53.7 338.3 0 272 0H120zm32.9 346.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l39.1-26.1 39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 372.8l-39.1-26.1z"
        }
    ]
};

const FarBracketCurlyRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBracketCurlyRight",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 120c0-48.6-39.4-88-88-88H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c22.1 0 40 17.9 40 40v45.5c0 23.3 9.3 45.7 25.8 62.2l28.3 28.3-28.3 28.3c-16.5 16.5-25.8 38.9-25.8 62.2V392c0 22.1-17.9 40-40 40H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c48.6 0 88-39.4 88-88v-45.5c0-10.6 4.2-20.8 11.7-28.3L249 273c9.4-9.4 9.4-24.6 0-33.9l-45.3-45.3c-7.5-7.5-11.7-17.7-11.7-28.3V120z"
        }
    ]
};

const FarBracketCurly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBracketCurly",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 120c0-48.6 39.4-88 88-88h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-22.1 0-40 17.9-40 40v45.5c0 23.3-9.3 45.7-25.8 62.2L57.9 256l28.3 28.3c16.5 16.5 25.8 38.9 25.8 62.2V392c0 22.1 17.9 40 40 40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-48.6 0-88-39.4-88-88v-45.5c0-10.6-4.2-20.8-11.7-28.3L7 273c-9.4-9.4-9.4-24.6 0-33.9l45.3-45.3c7.5-7.5 11.7-17.7 11.7-28.3V120z"
        }
    ]
};

const FarBracketRoundRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBracketRoundRight",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M35.4 43.7c-6.8 11.4-3 26.1 8.3 32.9C76.7 96.3 144 160.7 144 256S76.7 415.7 43.7 435.4c-11.4 6.8-15.1 21.5-8.3 32.9s21.5 15.1 32.9 8.3C110 451.8 192 374.1 192 256S110 60.2 68.3 35.4c-11.4-6.8-26.1-3-32.9 8.3z"
        }
    ]
};

const FarBracketRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBracketRound",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M156.6 43.7c6.8 11.4 3 26.1-8.3 32.9C115.3 96.3 48 160.7 48 256s67.3 159.7 100.3 179.4c11.4 6.8 15.1 21.5 8.3 32.9s-21.5 15.1-32.9 8.3C82 451.8 0 374.1 0 256S82 60.2 123.7 35.4c11.4-6.8 26.1-3 32.9 8.3z"
        }
    ]
};

const FarBracketSquareRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBracketSquareRight",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 88c0-30.9-25.1-56-56-56H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c4.4 0 8 3.6 8 8v336c0 4.4-3.6 8-8 8H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c30.9 0 56-25.1 56-56V88z"
        }
    ]
};

const FarBracketSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBracketSquare",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88c0-30.9 25.1-56 56-56h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v336c0 4.4 3.6 8 8 8h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V88z"
        }
    ]
};

const FarBracketsCurly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBracketsCurly",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 32c-48.6 0-88 39.4-88 88v45.5c0 10.6-4.2 20.8-11.7 28.3L7 239c-9.4 9.4-9.4 24.6 0 33.9l45.3 45.3c7.5 7.5 11.7 17.7 11.7 28.3V392c0 48.6 39.4 88 88 88h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48c-22.1 0-40-17.9-40-40v-45.5c0-23.3-9.3-45.7-25.8-62.2L57.9 256l28.3-28.3c16.5-16.5 25.8-38.9 25.8-62.2V120c0-22.1 17.9-40 40-40h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm272 0h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c22.1 0 40 17.9 40 40v45.5c0 23.3 9.3 45.7 25.8 62.2l28.3 28.3-28.3 28.3c-16.5 16.5-25.8 38.9-25.8 62.2V392c0 22.1-17.9 40-40 40h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c48.6 0 88-39.4 88-88v-45.5c0-10.6 4.2-20.8 11.7-28.3L569 273c9.4-9.4 9.4-24.6 0-33.9l-45.3-45.3c-7.5-7.5-11.7-17.7-11.7-28.3V120c0-48.6-39.4-88-88-88z"
        }
    ]
};

const FarBracketsRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBracketsRound",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M148.3 76.6c11.4-6.8 15.1-21.5 8.3-32.9s-21.5-15.1-32.9-8.3C82 60.2 0 137.9 0 256s82 195.8 123.7 220.6c11.4 6.8 26.1 3 32.9-8.3s3-26.1-8.3-32.9C115.3 415.7 48 351.3 48 256S115.3 96.3 148.3 76.6zm215.4 0C396.7 96.3 464 160.7 464 256s-67.3 159.7-100.3 179.4c-11.4 6.8-15.1 21.5-8.3 32.9s21.5 15.1 32.9 8.3C430 451.8 512 374.1 512 256S430 60.2 388.3 35.4c-11.4-6.8-26.1-3-32.9 8.3s-3 26.1 8.3 32.9z"
        }
    ]
};

const FarBracketsSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBracketsSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm336 0h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c4.4 0 8 3.6 8 8v336c0 4.4-3.6 8-8 8h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56z"
        }
    ]
};

const FarBraille = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBraille",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zm224 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM88 416a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm248 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm128 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm248 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm64 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-96-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarBrainArrowCurvedRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBrainArrowCurvedRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M153.5 76.9c-1.9 6.8-6.8 12.4-13.2 15.3-16.6 7.5-28.2 24.1-28.3 43.5-.1 9.1-5.2 17.3-13.3 21.3-15.9 7.9-26.7 24.2-26.7 43 0 7.1 1.5 13.7 4.2 19.7 4.4 9.7 1.9 21-6.1 28C56.5 259.4 48 276.7 48 296c0 20.2 9.3 38.1 23.9 49.9 6.7 5.4 10 14 8.7 22.5-.4 2.5-.6 5-.6 7.6 0 26.1 20.8 47.3 46.7 48 9.2.3 17.4 5.7 21.2 14.1 6.9 15.3 22.3 25.9 40.1 25.9 24.3 0 44-19.7 44-44V88c0-22.1-17.9-40-40-40-18.2 0-33.7 12.2-38.5 28.9zM256 482c-16.8 18.5-41.1 30-68 30-32.2 0-60.5-16.5-76.9-41.5-45-8-79.1-47.3-79.1-94.5v-1.6C12.2 354.2 0 326.5 0 296c0-27.8 10.1-53.2 26.8-72.7C25 215.8 24 208 24 200c0-32.6 16.3-61.5 41.1-78.8 4.5-28.9 21.8-53.5 45.9-67.8C124.5 22 155.7 0 192 0c25.2 0 48 10.6 64 27.6C272 10.6 294.8 0 320 0c36.3 0 67.5 22 80.9 53.4 24.1 14.3 41.5 38.9 45.9 67.8 24.9 17.3 41.2 46.2 41.2 78.8 0 8-1 15.8-2.8 23.3 1.3 1.5 2.6 3.1 3.8 4.8-5.7 8-9 17.7-9 28v16h-20.6c-3.8-9.4-9.8-17.8-17.4-24.3-8-6.9-10.5-18.3-6.1-28 2.7-6 4.2-12.6 4.2-19.7 0-18.8-10.8-35.1-26.7-43-8.1-4-13.3-12.3-13.3-21.3-.1-19.3-11.7-36-28.3-43.5-6.4-2.9-11.3-8.5-13.2-15.3-4.9-16.8-20.4-29-38.6-29-22.1 0-40 17.9-40 40v332c0 19.8 13.1 36.5 31 42.1 6.5 20.5 16.6 36.8 26.4 49-4.4.6-8.8 1-13.4 1-26.9 0-51.2-11.6-68-30zm283.3-237.3 96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8v-48h-48c-35.3 0-64 28.7-64 64v35.7c0 6.8-5.5 12.3-12.3 12.3-2.4 0-4.8-.7-6.7-2.2-10.5-8.2-45-39.5-45-93.8 0-61.9 50.1-112 112-112h64v-48c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5z"
        }
    ]
};

const FarBrainCircuit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBrainCircuit",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48c22.1 0 40 17.9 40 40v40h-19.3c-6.2-14.1-20.3-24-36.7-24-22.1 0-40 17.9-40 40s17.9 40 40 40c16.4 0 30.5-9.9 36.7-24H232v96h-40c-26.5 0-48 21.5-48 48v11.3c-14.1 6.2-24 20.3-24 36.7 0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7V304c0-8.8 7.2-16 16-16h40v132c0 24.3-19.7 44-44 44-17.8 0-33.2-10.6-40.1-25.9-3.8-8.4-12-13.9-21.2-14.1-25.9-.7-46.7-21.9-46.7-48 0-2.6.2-5.2.6-7.6 1.4-8.5-2-17.1-8.7-22.5C57.3 334.1 48 316.2 48 296c0-19.3 8.5-36.6 22.1-48.3 8-6.9 10.5-18.3 6.1-28-2.7-6-4.2-12.6-4.2-19.7 0-18.8 10.8-35.1 26.7-43 8.1-4 13.3-12.3 13.3-21.3.1-19.3 11.7-36 28.3-43.5 6.4-2.9 11.3-8.5 13.2-15.3C158.3 60.2 173.8 48 192 48zm-4 464c26.9 0 51.2-11.6 68-30 16.8 18.5 41.1 30 68 30 32.2 0 60.5-16.5 76.9-41.5 45-8 79.1-47.3 79.1-94.5v-1.6c19.8-20.2 32-47.9 32-78.4 0-27.8-10.1-53.2-26.8-72.7 1.8-7.5 2.8-15.3 2.8-23.3 0-32.6-16.3-61.5-41.1-78.8-4.5-28.9-21.8-53.5-45.9-67.8C387.5 22 356.3 0 320 0c-25.2 0-48 10.6-64 27.6C240 10.6 217.2 0 192 0c-36.3 0-67.5 22-80.9 53.4-24.2 14.3-41.5 38.9-46 67.8C40.3 138.5 24 167.4 24 200c0 8 1 15.8 2.8 23.3C10.1 242.8 0 268.2 0 296c0 30.5 12.2 58.2 32 78.4v1.6c0 47.3 34.1 86.5 79.1 94.5 16.4 25 44.7 41.5 76.9 41.5zm136-48c-24.3 0-44-19.7-44-44v-68h51.3c6.2 14.1 20.3 24 36.7 24 22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24H280V160h40c8.8 0 16 7.2 16 16v11.3c-14.1 6.2-24 20.3-24 36.7 0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7V176c0-26.5-21.5-48-48-48h-40V88c0-22.1 17.9-40 40-40 18.2 0 33.7 12.2 38.5 28.9 1.9 6.8 6.8 12.4 13.2 15.3 16.6 7.5 28.2 24.1 28.3 43.5.1 9.1 5.2 17.3 13.3 21.3 15.9 7.9 26.7 24.2 26.7 43 0 7.1-1.5 13.7-4.2 19.7-4.4 9.7-1.9 21 6.1 28 13.5 11.8 22.1 29 22.1 48.3 0 20.2-9.3 38.1-23.9 49.9-6.7 5.4-10 14-8.7 22.5.4 2.5.6 5 .6 7.6 0 26.1-20.8 47.3-46.7 48-9.2.3-17.4 5.7-21.2 14.1-6.9 15.3-22.3 25.9-40.1 25.9zM176 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm176-112a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm32 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarBrain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBrain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M153.5 76.9c-1.9 6.8-6.8 12.4-13.2 15.3-16.6 7.5-28.2 24.1-28.3 43.5-.1 9.1-5.2 17.3-13.3 21.3-15.9 7.9-26.7 24.2-26.7 43 0 7.1 1.5 13.7 4.2 19.7 4.4 9.7 1.9 21-6.1 28C56.5 259.4 48 276.7 48 296c0 20.2 9.3 38.1 23.9 49.9 6.7 5.4 10 14 8.7 22.5-.4 2.5-.6 5-.6 7.6 0 26.1 20.8 47.3 46.7 48 9.2.3 17.4 5.7 21.2 14.1 6.9 15.3 22.3 25.9 40.1 25.9 24.3 0 44-19.7 44-44V88c0-22.1-17.9-40-40-40-18.2 0-33.7 12.2-38.5 28.9zM256 482c-16.8 18.5-41.1 30-68 30-32.2 0-60.5-16.5-76.9-41.5-45-8-79.1-47.3-79.1-94.5v-1.6C12.2 354.2 0 326.5 0 296c0-27.8 10.1-53.2 26.8-72.7C25 215.8 24 208 24 200c0-32.6 16.3-61.5 41.1-78.8 4.5-28.9 21.8-53.5 45.9-67.8C124.5 22 155.7 0 192 0c25.2 0 48 10.6 64 27.6C272 10.6 294.8 0 320 0c36.3 0 67.5 22 80.9 53.4 24.1 14.3 41.5 38.9 45.9 67.8 24.9 17.3 41.2 46.2 41.2 78.8 0 8-1 15.8-2.8 23.3 16.7 19.6 26.8 45 26.8 72.7 0 30.5-12.2 58.2-32 78.4v1.6c0 47.3-34.1 86.5-79.1 94.5-16.4 25-44.7 41.5-76.9 41.5-26.9 0-51.2-11.6-68-30zm24-62c0 24.3 19.7 44 44 44 17.8 0 33.2-10.6 40.1-25.9 3.8-8.4 12-13.9 21.2-14.1 25.9-.7 46.7-21.9 46.7-48 0-2.6-.2-5.2-.6-7.6-1.4-8.5 2-17.1 8.7-22.5 14.6-11.8 23.9-29.7 23.9-49.9 0-19.3-8.5-36.6-22.1-48.3-8-6.9-10.5-18.3-6.1-28 2.7-6 4.2-12.6 4.2-19.7 0-18.8-10.8-35.1-26.7-43-8.1-4-13.3-12.3-13.3-21.3-.1-19.3-11.7-36-28.3-43.5-6.4-2.9-11.3-8.5-13.2-15.3C353.7 60.2 338.2 48 320 48c-22.1 0-40 17.9-40 40v332z"
        }
    ]
};

const FarBrakeWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBrakeWarning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM83.9 75.8c-11.1-7.2-26-4-33.2 7.2C18.6 132.9 0 192.3 0 256s18.6 123.1 50.7 173c7.2 11.1 22 14.4 33.2 7.2s14.4-22 7.2-33.2C63.8 360.6 48 310.2 48 256s15.8-104.6 43.1-147c7.2-11.1 4-26-7.2-33.2zm472.2 0c-11.1 7.2-14.4 22-7.2 33.2 27.3 42.4 43.1 92.8 43.1 147s-15.8 104.6-43.1 147c-7.2 11.1-4 26 7.2 33.2s26 4 33.2-7.2c32.1-49.9 50.7-109.3 50.7-173s-18.6-123.1-50.7-173c-7.2-11.1-22-14.4-33.2-7.2zM320 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarBrazilianRealSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBrazilianRealSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0c13.3 0 24 10.7 24 24v41.2c14.6 1.7 29 5.4 42.7 10.9l14.2 5.7c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-14.3-5.7c-14.2-5.7-29.3-8.6-44.6-8.6H392c-30.9 0-56 25.1-56 56 0 23.5 14.7 44.6 36.8 52.6l70.7 25.7c41.1 14.9 68.4 54 68.4 97.7 0 52-38.2 95.1-88 102.8V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-42.2c-17.1-3-33.7-8.9-48.9-17.6l-27-15.4c-11.5-6.6-15.5-21.2-8.9-32.7s21.2-15.5 32.7-8.9l27 15.4c15.4 8.8 32.8 13.4 50.6 13.4h6.6c30.9 0 56-25.1 56-56 0-23.5-14.7-44.6-36.8-52.6l-70.7-25.7c-41.1-14.9-68.4-54-68.4-97.7 0-52 38.2-95.1 88-102.8V24c0-13.3 10.7-24 24-24zM0 56c0-13.3 10.7-24 24-24h96c75.1 0 136 60.9 136 136 0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304H48v152c0 13.3-10.7 24-24 24S0 469.3 0 456V56zm48 200h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H48v176z"
        }
    ]
};

const FarBreadLoaf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBreadLoaf",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 208c-8.8 0-16-7.2-16-16 0-36.7 23.6-63.9 68.1-84.4C160.5 87.1 213.4 80 240 80s79.5 7.1 123.9 27.6c44.5 20.5 68.1 47.7 68.1 84.4 0 8.8-7.2 16-16 16-26.5 0-48 21.5-48 48v176H112V256c0-26.5-21.5-48-48-48zm352 48h112v176H416V256zm155.3-47.8c-1.1-.1-2.2-.2-3.3-.2h-90c1.3-5.1 2-10.5 2-16 0-51.1-28-86.9-65.8-111.5 28.7 2 72.2 9.7 109.7 27 44.5 20.6 68.1 47.8 68.1 84.5 0 8.8-7.2 16-16 16-1.6 0-3.1.1-4.7.2zM112 480h416c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C640 64 464 32 400 32H240C176 32 0 64 0 192c0 35.3 28.7 64 64 64v176c0 26.5 21.5 48 48 48z"
        }
    ]
};

const FarBreadSliceButter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBreadSliceButter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 256v176h288V256c0-26.5 21.5-48 48-48 8.8 0 16-7.2 16-16 0-34.5-24.6-62.3-74.9-83.9C340.2 87.2 282.8 80 256 80s-84.2 7.2-133.1 28.1C72.6 129.7 48 157.5 48 192c0 8.8 7.2 16 16 16 26.5 0 48 21.5 48 48zm336 0v176c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64zm-265.4 9.4 50.7-50.7c12.5-12.5 32.8-12.5 45.3 0l50.7 50.7c12.5 12.5 12.5 32.8 0 45.3l-50.7 50.7c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3z"
        }
    ]
};

const FarBreadSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBreadSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 208c-8.8 0-16-7.2-16-16 0-34.5 24.6-62.3 74.9-83.9C171.8 87.2 229.2 80 256 80s84.2 7.2 133.1 28.1c50.3 21.6 74.9 49.4 74.9 83.9 0 8.8-7.2 16-16 16-26.5 0-48 21.5-48 48v176H112V256c0-26.5-21.5-48-48-48zm384 96v-48c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64v176c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V304z"
        }
    ]
};

const FarBridgeCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBridgeCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v64H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48V80h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm283.1 256.1c8-15.7 18.3-30 30.4-42.5-10.5-3.7-21.7-5.6-33.5-5.6h-32c-57.4 0-104 46.6-104 104v88h-48v-96c0-53-43-96-96-96-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48v104c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40v-96c0-30.9 25.1-56 56-56h32c1.1 0 2.1 0 3.1.1zM488 80v64h-80V80h80zm-128 0v64h-80V80h80zm-128 0v64h-80V80h80zm408 288a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7z"
        }
    ]
};

const FarBridgeCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBridgeCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v64H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48V80h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm283.1 256.1c8-15.7 18.3-30 30.4-42.5-10.5-3.7-21.7-5.6-33.5-5.6h-32c-57.4 0-104 46.6-104 104v88h-48v-96c0-53-43-96-96-96-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48v104c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40v-96c0-30.9 25.1-56 56-56h32c1.1 0 2.1 0 3.1.1zM488 80v64h-80V80h80zm-128 0v64h-80V80h80zm-128 0v64h-80V80h80zm264 432a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarBridgeCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBridgeCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v64H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48V80h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm283.1 256.1c8-15.7 18.3-30 30.4-42.5-10.5-3.7-21.7-5.6-33.5-5.6h-32c-57.4 0-104 46.6-104 104v88h-48v-96c0-53-43-96-96-96-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48v104c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40v-96c0-30.9 25.1-56 56-56h32c1.1 0 2.1 0 3.1.1zM488 80v64h-80V80h80zm-128 0v64h-80V80h80zm-128 0v64h-80V80h80zm264 432a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FarBridgeLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBridgeLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v64H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h393.6c20.2-19.8 47.9-32 78.4-32 27.3 0 52.4 9.8 71.8 26.1 5-4.4 8.2-10.9 8.2-18.1 0-13.3-10.7-24-24-24h-48V80h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm280 208h-32c-57.4 0-104 46.6-104 104v88h-48v-96c0-53-43-96-96-96-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48v104c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40v-96c0-30.9 25.1-56 56-56h32c24.9 0 45.9 16.2 53.2 38.6 5.5-12.6 14.9-23.2 26.8-30v-19c-19.1-22.9-47.8-37.5-80-37.5zM488 80v64h-80V80h80zm-128 0v64h-80V80h80zm-128 0v64h-80V80h80zm296 160c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FarBridgeSuspension = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBridgeSuspension",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M149.1 12.5C145 5 137.1 0 128 0c-8.8 0-16.5 4.7-20.7 11.8-13 21.2-26.6 42.1-42 59.7-15.5 17.7-31.7 30.6-49.4 36.9-12.5 4.6-19 18.3-14.5 30.8s18.2 18.9 30.7 14.4c28.2-10.2 50.8-29.4 69.2-50.4.9-1 1.8-2 2.6-3V240H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80V100.2c.9 1 1.7 2 2.6 3 18.4 21 41 40.3 69.2 50.4 12.5 4.5 26.2-2 30.7-14.4s-2-26.2-14.4-30.7c-17.7-6.4-33.9-19.3-49.4-36.9-15.4-17.6-29-38.6-42-59.8C528.5 4.7 520.8 0 512 0c-9.1 0-17 5-21.1 12.5C455.8 73.6 390.3 112 320 112S184.2 73.6 149.1 12.5zM200 240h-48V92.8c14.5 13.7 30.7 25.6 48 35.4V240zm96 0h-48v-91c15.5 4.8 31.6 8.1 48 9.8V240zm96 0h-48v-81.2c16.4-1.6 32.5-4.9 48-9.8v91zm96 0h-48V128.3c17.3-9.8 33.5-21.7 48-35.4V240zM0 360c0 13.3 10.7 24 24 24h16c30.9 0 56 25.1 56 56v24c0 26.5 21.5 48 48 48h49.4c25.7 0 46.6-20.9 46.6-46.6V464c0-44.2 35.8-80 80-80s80 35.8 80 80v1.4c0 25.7 20.9 46.6 46.6 46.6H496c26.5 0 48-21.5 48-48v-24c0-30.9 25.1-56 56-56h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16c-57.4 0-104 46.6-104 104v24h-48c0-70.7-57.3-128-128-128s-128 57.3-128 128h-48v-24c0-57.4-46.6-104-104-104H24c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarBridgeWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBridgeWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 112v50.8c45.9 10.9 80 52.2 80 101.5V361c-14.8-8.5-32-10.6-48-6.5v-90.2c0-31.1-25.2-56.3-56.3-56.3C10.6 208 0 197.4 0 184.3V96c0-17.7 14.3-32 32-32h512c17.7 0 32 14.3 32 32v88.3c0 13.1-10.6 23.7-23.7 23.7-31.1 0-56.3 25.2-56.3 56.3v90.2c-16-4.1-33.2-2-48 6.6v-96.8c0-49.2 34.1-90.5 80-101.5V112H48zm144 272.5c-5.2 0-10.5-.6-16-1.7V272c0-61.9 50.1-112 112-112s112 50.1 112 112v110.8c-5.5 1.1-10.8 1.7-16 1.7-10.4 0-21.3-2.2-32-6.1V272c0-35.3-28.7-64-64-64s-64 28.7-64 64v106.4c-10.3 3.8-21.1 6.1-32 6.1zm-80.1 13.6c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7 9.1-8.1 22.8-8.1 31.9 0z"
        }
    ]
};

const FarBridge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBridge",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h48v64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48V80h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm432 48v64h-80V80h80zm-128 0v64h-80V80h80zm-128 0v64h-80V80h80zM24 240c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48v104c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40v-96c0-30.9 25.1-56 56-56h32c30.9 0 56 25.1 56 56v96c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V336c0-26.5 21.5-48 48-48 13.3 0 24-10.7 24-24s-10.7-24-24-24c-53 0-96 43-96 96v96h-48v-88c0-57.4-46.6-104-104-104h-32c-57.4 0-104 46.6-104 104v88h-48v-96c0-53-43-96-96-96z"
        }
    ]
};

const FarBriefcaseArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBriefcaseArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8zm-56 8v40H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm24 88h296c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h88zm145 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h150.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"
        }
    ]
};

const FarBriefcaseBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBriefcaseBlank",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56v40h160V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V56c0-30.9 25.1-56 56-56h144c30.9 0 56 25.1 56 56v40h64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm232 48H64c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16h-88z"
        }
    ]
};

const FarBriefcaseMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBriefcaseMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8zm-56 8v40H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm24 88h296c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h88zm72 64v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarBriefcase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBriefcase",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56v40h160V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V56c0-30.9 25.1-56 56-56h144c30.9 0 56 25.1 56 56v40h64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zM48 304v112c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V304H320v16c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-16H48zm144-48h272v-96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v96h144z"
        }
    ]
};

const FarBrightnessLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBrightnessLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 80a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm176-176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM48 256a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm112-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm256 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0-256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FarBrightness = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBrightness",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 88c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v64zm24 120a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM0 256c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm424-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64zM256 512c13.3 0 24-10.7 24-24v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24zM75 75c-9.4 9.4-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0zm316.8 282.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l45.2 45.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3zM75 437c9.4 9.4 24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9zm282.8-316.8c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l45.3-45.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3z"
        }
    ]
};

const FarBringForward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBringForward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 464h224c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16h-64v-48h64c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-64h48v64c0 8.8 7.2 16 16 16zm64-112H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64z"
        }
    ]
};

const FarBringFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBringFront",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h128c8.8 0 16 7.2 16 16h48c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v128c0 35.3 28.7 64 64 64h64v-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm384 464h128c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64h-64v48h64c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16h-48c0 35.3 28.7 64 64 64zM224 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H224z"
        }
    ]
};

const FarBroccoli = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBroccoli",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-37.2 0-69.5 21.2-85.4 52.1-8.4-2.7-17.3-4.1-26.6-4.1-48.6 0-88 39.4-88 88 0 10.7 1.9 20.9 5.4 30.4C25.5 180.3 0 215.2 0 256c0 53 43 96 96 96h320c53 0 96-43 96-96 0-40.8-25.5-75.7-61.4-89.6 3.5-9.5 5.4-19.7 5.4-30.4 0-48.6-39.4-88-88-88-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0zm-47.6 89.7C211.5 66.2 231.6 48 256 48s44.5 18.2 47.6 41.7c1.1 8.6 6.9 16 15 19.2s17.3 1.8 24.1-3.8c6.9-5.7 15.7-9.1 25.4-9.1 22.1 0 40 17.9 40 40 0 12-5.3 22.8-13.7 30.2-7.8 6.8-10.4 17.9-6.3 27.4s13.7 15.4 24.1 14.6c1.3-.1 2.6-.2 4-.2 26.5 0 48 21.5 48 48s-21.5 48-48 48H96c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.3 0 2.7.1 4 .2 10.3.8 20-5 24.1-14.6s1.5-20.6-6.3-27.4C109.3 158.8 104 148 104 136c0-22.1 17.9-40 40-40 9.7 0 18.5 3.4 25.4 9.1 6.7 5.5 15.9 7 24.1 3.8s13.8-10.6 15-19.2zm-16.2 400.6c5 12.8 17.1 21.7 30.9 21.7H289c13.8 0 25.9-8.9 30.9-21.7C337.5 445 359.5 408.2 376 384h-96l-16.8 33.7c-2.9 5.9-11.4 5.9-14.3 0L232 384h-95.9c16.5 24.2 38.5 60.9 56.1 106.3z"
        }
    ]
};

const FarBroomBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBroomBall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M569 7c9.4 9.4 9.4 24.6 0 33.9L369 241l39 39c5.1 5.1 8 12.1 8 19.4 0 12.2-8.1 23-19.9 26.3l-55.6 15.9.1.6c7.1 46.4-8.3 93.4-41.5 126.7C271.5 496.5 234 512 194.9 512H22.3C10 512 0 502 0 489.7c0-6.2 2.6-12.1 7.2-16.4l49.9-46.1 24.3-22.4L104 384H81.3c-9.6 0-17.3-7.8-17.3-17.3 0-3.9.2-7.8.6-11.6 2.7-25.6 14-49.7 32.4-68l10.2-10.2c33.2-33.2 80.2-48.6 126.7-41.5l.6.1 15.9-55.6c3.4-11.8 14.1-19.9 26.3-19.9 7.3 0 14.2 2.9 19.4 8l39 39L535 7c9.4-9.4 24.6-9.4 33.9 0zM321.2 297.2l28.1-8-62.4-62.4-8 28.1 42.3 42.3zm-84.9-12.9-9.8-1.5c-31.3-4.8-63 5.6-85.4 28L130.9 321c-5.1 5.1-9.3 11-12.4 17.3 13.5 4.3 24.8 14.5 30.1 28.3 7.2 18.4 2.4 39.3-12.1 52.7L88.1 464h106.8c26.4 0 51.7-10.5 70.3-29.1 22.4-22.4 32.8-54.1 28-85.4l-1.5-9.8-55.4-55.4zM528 432a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FarBroomWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBroomWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L335 143l-12.9-12.9c-20.2-20.2-51.4-24.6-76.3-10.7L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l205.4 205.3c6 6 14.1 9.3 22.6 9.3 11.6 0 22.3-6.3 27.9-16.4l127.4-229.4c13.9-25 9.5-56.1-10.7-76.3L369 177 505 41zM323.6 291.6l-90 162.1-96.6-96.6 18-53.9c2.1-6.3-3.9-12.2-10.1-10.1l-54 17.9-32.5-32.5 162.1-90 103.1 103.1z"
        }
    ]
};

const FarBroom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBroom",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M569 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L335 207l-39-39c-5.1-5.1-12.1-8-19.4-8-12.2 0-23 8.1-26.3 19.9l-15.9 55.6-.6-.1c-46.4-7.1-93.5 8.3-126.7 41.5L97 287c-18.4 18.4-29.7 42.4-32.4 68-.4 3.8-.6 7.7-.6 11.6 0 9.6 7.8 17.3 17.3 17.3H104l-22.7 21-24.2 22.4-49.9 46.1C2.6 477.6 0 483.5 0 489.7 0 502 10 512 22.3 512H195c39.1 0 76.6-15.5 104.2-43.2 33.2-33.2 48.6-80.2 41.5-126.7l-.1-.6 55.6-15.9c11.8-3.4 19.9-14.1 19.9-26.3 0-7.3-2.9-14.2-8-19.4l-39-39L569 41zM278.8 254.8l8-28.1 62.4 62.4-28.1 8-42.3-42.3zm-52.3 28 9.8 1.5 55.4 55.4 1.5 9.8c4.8 31.3-5.6 63-28 85.4-18.6 18.6-43.9 29.1-70.3 29.1H88.1l48.5-44.7c14.5-13.4 19.3-34.3 12.1-52.7-5.4-13.7-16.6-23.9-30.1-28.3 3.1-6.4 7.3-12.2 12.4-17.3l10.2-10.2c22.4-22.4 54.1-32.8 85.4-28z"
        }
    ]
};

const FarBrowser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBrowser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.3 89.5C.1 91.6 0 93.8 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64c-2.2 0-4.4.1-6.5.3-9.2.9-17.8 3.8-25.5 8.2-10.2 6-18.6 14.6-24.3 25-3.9 7.3-6.5 15.4-7.4 24zM48 160h416v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160z"
        }
    ]
};

const FarBrowsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBrowsers",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 352V128h384v224c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16zM160 0c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v256c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FarBrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBrush",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 288V64c0-8.8 7.2-16 16-16h32v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48h64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V48h96c8.8 0 16 7.2 16 16v224H48zM0 320c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64v-64h64c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v256zm192 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarBucket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBucket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8h-48v-8c0-57.4-46.6-104-104-104h-48C142.6 48 96 94.6 96 152zM0 216c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24h-6l-28.7 230c-3 24-23.4 42-47.6 42H106.4c-24.2 0-44.6-18-47.6-42L30 240h-6c-13.3 0-24-10.7-24-24zm78.4 24 28 224h235.2l28-224H78.4z"
        }
    ]
};

const FarBugSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBugSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 96c0-53 43-96 96-96s96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H252.4c-15.7 0-28.4-12.7-28.4-28.4V96zm73.7 112L432 313.3V264c0-30.9-25.1-56-56-56h-78.3zm179.7 140.9 153.4 120.2c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L240 162.8c7.7-1.8 15.8-2.8 24-2.8h112c20 0 38.7 5.7 54.6 15.5L503 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72.4 72.4c9.8 16 15.5 34.7 15.5 54.7h72c13.3 0 24 10.7 24 24s-10.7 24-24 24h-72v8c0 9.9-.9 19.5-2.6 28.9zm-46.6 86.5C402.1 463 363 480 320 480c-43.7 0-83.3-17.5-112.2-45.9L137 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l75.8-75.8c-12-22.4-18.8-48.1-18.8-75.3v-8H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c0-12.9 2.4-25.3 6.7-36.7l41.4 32.7c-.1 1.3-.1 2.7-.1 4v56c0 53.6 37.7 98.4 88 109.4V329.2l48 37.8v62.4c18.3-4 34.8-12.4 48.6-24.1l38.2 30.1z"
        }
    ]
};

const FarBug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBug",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM39 103c9.4-9.4 24.6-9.4 33.9 0l72.4 72.4c16-9.7 34.7-15.4 54.7-15.4h112c20 0 38.7 5.7 54.6 15.5L439 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72.4 72.4c9.8 16 15.5 34.7 15.5 54.7h72c13.3 0 24 10.7 24 24s-10.7 24-24 24h-72v8c0 27.2-6.8 52.8-18.8 75.3L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L368.2 434c-28.9 28.5-68.5 46-112.2 46s-83.3-17.5-112.2-45.9L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l75.8-75.8C102.8 372.8 96 347.2 96 320v-8H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c0-20 5.7-38.7 15.5-54.6L39 137c-9.4-9.4-9.4-24.6 0-33.9zm105 161v56c0 53.6 37.7 98.4 88 109.4V280c0-13.3 10.7-24 24-24s24 10.7 24 24v149.4c50.3-11 88-55.8 88-109.4v-56c0-30.9-25.1-56-56-56H200c-30.9 0-56 25.1-56 56z"
        }
    ]
};

const FarBugs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBugs",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m164.5 107.4 33.4-73.5c5.5-12.1.1-26.3-11.9-31.8S159.7 2 154.2 14L128 71.7l-26.1-57.6C96.4 2 82.1-3.3 70.1 2.1s-17.4 19.8-12 31.8l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7.5 124.7l8 40C10.7 175.9 20.6 184 32 184h32v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6c10.7 19.7 31.8 33.1 56 33.1s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9l-37.9-9.4V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8l-4.2 20.7h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6l-7.8 80.3c-12.3 1-24.2 5.6-34.1 13.3l-14.7-8.5 6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15L332.3 258c-3.7 10.8.8 22.8 10.7 28.5l27.7 16-11.7 20.2-37.5-10.7c-9.4-2.7-19.5.6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3l21.2-52.5c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9l27-30.7c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2zM144 224c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64zm307.9 97.8-32 55.4c-4.4 7.7-14.2 10.3-21.9 5.9s-10.3-14.2-5.9-21.9l32-55.4c4.4-7.7 14.2-10.3 21.9-5.9s10.3 14.2 5.9 21.9z"
        }
    ]
};

const FarBuildingCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingCircleArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c8.8 0 16 7.2 16 16v230.6c11.1-24.3 27.7-45.5 48-62.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c19.5 0 37-8.7 48.7-22.5-13.4-14-24.5-30.3-32.7-48.1v6.6c0 8.8-7.2 16-16 16h-80v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zm408 152a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-147.3-67.3c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FarBuildingCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c8.8 0 16 7.2 16 16v230.6c11.1-24.3 27.7-45.5 48-62.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c19.5 0 37-8.7 48.7-22.5-13.4-14-24.5-30.3-32.7-48.1v6.6c0 8.8-7.2 16-16 16h-80v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zm408 152a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarBuildingCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c8.8 0 16 7.2 16 16v230.6c11.1-24.3 27.7-45.5 48-62.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c19.5 0 37-8.7 48.7-22.5-13.4-14-24.5-30.3-32.7-48.1v6.6c0 8.8-7.2 16-16 16h-80v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zm264 296a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarBuildingCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c8.8 0 16 7.2 16 16v230.6c11.1-24.3 27.7-45.5 48-62.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c19.5 0 37-8.7 48.7-22.5-13.4-14-24.5-30.3-32.7-48.1v6.6c0 8.8-7.2 16-16 16h-80v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zm264 296a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FarBuildingColumns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingColumns",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9 0 176.8 15.2 192 34.1 192h443.8c18.8 0 34.1-15.2 34.1-34.1 0-12.4-6.7-23.8-17.6-29.8L267.6 3zm-39.3 141H88.2L256 51.4 423.8 144H283.7c2.7-4.7 4.3-10.2 4.3-16 0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM64 224v160c-13.3 0-24 10.7-24 24s10.7 24 24 24h392c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V224h-48v160h-64V224h-48v160h-64V224h-48v160h-64V224H64zM32 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h456c13.3 0 24-10.7 24-24s-10.7-24-24-24H32z"
        }
    ]
};

const FarBuildingFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingFlag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h80v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16zM448 0c17.7 0 32 14.3 32 32h144c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H480v320h-64V32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarBuildingLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c8.8 0 16 7.2 16 16v245.7c4.6-5.2 10-9.6 16-13.1V272c0-30.5 12.2-58.2 32-78.4V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c2.8 0 5.6-.2 8.3-.5-5.3-9.3-8.3-20-8.3-31.5v-16h-80v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zm232 24c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FarBuildingNgo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingNgo",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48H2C9.1 20.4 34.2 0 64 0h256c29.8 0 54.9 20.4 62 48h-62zm16 192h48v208c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V240h48v208c0 8.8 7.2 16 16 16h80v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V240zM168 80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V96c0-8.8 7.2-16 16-16zm136 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32zM61.3 87.1l34.7 52V96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 148.8V192c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM88 264c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarBuildingShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingShield",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c8.8 0 16 7.2 16 16v162.2l48-19.2V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c10.9 0 21.2-2.7 30.2-7.6-15.4-12.4-28.5-26-39.5-40.4H240v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm232 184c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h24c.1-22.8 14-43.4 35.2-51.8l4.8-1.9V232zM88 104v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm335.1-6.3-120 48C294 277.4 288 286.2 288 296c0 63.3 25.9 168.8 134.8 214.2 5.9 2.5 12.6 2.5 18.5 0C550.1 464.8 576 359.3 576 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM527.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8l95.4 38.2z"
        }
    ]
};

const FarBuildingUn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingUn",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h80v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm104 184h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48zm21.3-176.9 34.7 52V96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V192c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 96v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V96c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarBuildingUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c8.8 0 16 7.2 16 16v351.7c11.3-20 27.9-36.7 48-47.9V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c3.2 0 6.4-.2 9.5-.7-6-10-9.5-21.8-9.5-34.4 0-4.4.2-8.7.7-13H240V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zm344 56a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9h218.2c19.3 0 34.9-15.6 34.9-34.9 0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"
        }
    ]
};

const FarBuildingWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildingWheat",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16h-80v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h256zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm40 88c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zm112 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zM104 216c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zm112 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm424-40h-16c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80v-16zm0 128v-16h-16c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80zm0 112v-16h-16c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80zm-128 64c0-44.2-35.8-80-80-80h-16v16c0 44.2 35.8 80 80 80h16v-16zm0-96v-16c0-44.2-35.8-80-80-80h-16v16c0 44.2 35.8 80 80 80h16zm0-128c0-44.2-35.8-80-80-80h-16v16c0 44.2 35.8 80 80 80h16v-16zm16-240c-13.3 0-24 10.7-24 24v104c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm96 64c0-13.3-10.7-24-24-24s-24 10.7-24 24v32c0 13.3 10.7 24 24 24s24-10.7 24-24V96zM456 72c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarBuilding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuilding",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h80v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarBuildings = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuildings",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160zM288 0c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H288zm-96 128H72c-39.8 0-72 32.2-72 72v240c0 39.8 32.2 72 72 72h144.4c-11.8-13.2-20.1-29.7-23.1-48H72c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24h120v-48zm-80 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm224 16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32zM112 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm224-112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm16 144h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16z"
        }
    ]
};

const FarBullhorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBullhorn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m432 73.9-10.7 10.7C364.5 141.4 288.1 174 208 175.9v128.2c80.1 1.9 156.5 34.5 213.3 91.3l10.7 10.7V73.9zM160 128h40.7c70 0 137.2-27.8 186.7-77.3l38-38C445.5-7.5 480 6.8 480 35.3v144.3c18.6 8.8 32 32.5 32 60.4s-13.4 51.6-32 60.4v144.3c0 28.5-34.5 42.8-54.6 22.6l-38-38c-47.8-47.8-112-75.4-179.4-77.2V456c0 30.9-25.1 56-56 56h-32c-30.9 0-56-25.1-56-56V352c-35.3 0-64-28.7-64-64v-96c0-35.3 28.7-64 64-64h96zm-48 224v104c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V352h-48zM64 176c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96V176H64z"
        }
    ]
};

const FarBullseyeArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBullseyeArrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361.5 218.4c4.2 11.8 6.5 24.4 6.5 37.6 0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112c13.2 0 25.9 2.3 37.6 6.5l4.9-4.9-7.6-45.8C279.6 97.3 268 96 256 96c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160c0-12-1.3-23.6-3.8-34.9l-45.8-7.6-4.9 4.9zm97.4-8.1c3.3 14.7 5 30 5 45.7 0 114.9-93.1 208-208 208S48 370.9 48 256 141.1 48 256 48c15.7 0 31 1.7 45.7 5l38.8-38.8C314 5 285.6 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-29.6-5-58-14.3-84.5L459 210.3zM365 180.9l50.7 8.4c10.2 1.7 20.6-1.6 27.9-8.9l51.2-51.2c8.1-8.1 5.3-21.9-5.4-26.2L432 80l-23-57.5c-4.3-10.7-18-13.5-26.2-5.4l-51.2 51.3c-7.3 7.3-10.6 17.7-8.9 27.9l8.4 50.7-92.1 92c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l92.1-92.1z"
        }
    ]
};

const FarBullseyePointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBullseyePointer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c114.9 0 208-93.1 208-208S370.9 48 256 48 48 141.1 48 256c0 5.5.2 10.9.6 16.3L1.8 286.1C.6 276.2 0 266.2 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l13.8-46.9c5.4.4 10.8.6 16.3.6zm-2.4-48 14.3-48.6c56.3-6 100.1-53.6 100.1-111.4 0-61.9-50.1-112-112-112-57.8 0-105.4 43.8-111.4 100.1L96 258.4V256c0-88.4 71.6-160 160-160s160 71.6 160 160-71.6 160-160 160h-2.4zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5l-57.2-28.6c-13-6.5-11.3-25.6 2.6-29.7z"
        }
    ]
};

const FarBullseye = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBullseye",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 112a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-272a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarBuoyMooring = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuoyMooring",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 24c0-13.3 10.7-24 24-24s24 10.7 24 24v42.6c42.6 9.4 76.7 43.2 85.3 87.5l47.1 241.2-1.2.9c-13.3 9.2-28.9 15.9-43.8 18.8l-15.5-79H192.1l-15.4 78.9c-14.9-2.9-30.5-9.6-43.8-18.8-.4-.3-.8-.6-1.3-.9L178.7 154c8.6-44.3 42.8-78.1 85.3-87.5V24zm24 88c-30.3 0-56.4 21.5-62.2 51.3L201.4 288h173.2l-24.4-124.7c-5.8-29.8-31.9-51.3-62.2-51.3zM111.9 430.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7 9.1-8.1 22.8-8.1 31.9 0z"
        }
    ]
};

const FarBuoy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBuoy",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h12.1l-53.9 256H96c-17.7 0-32 14.3-32 32v16c0 13.3 1.8 26.1 5.2 38.3 15.8-7.3 33.9-7.9 50.2-1.5-4.7-11.3-7.3-23.8-7.3-36.8H464c0 13.1-2.6 25.5-7.3 36.9 16.2-6.4 34.4-5.8 50.2 1.5 3.4-12.2 5.2-25.1 5.2-38.3V336c0-17.7-14.3-32-32-32h-46.3L379.9 48H392c13.3 0 24-10.7 24-24S405.3 0 392 0H184zm146.8 48 11.9 56.6-54.7 63.9-54.8-63.9 12-56.6h85.7zm-110 115.8 35.6 41.5-58.8 68.6 23.2-110.1zm67.2 78.4 53 61.8H235l53-61.8zm90.4 31.7-58.8-68.6 35.6-41.5 23.2 110.1zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0-17.2 14.9-39 26.7-61.2 31.7C5.9 464.7-2.3 477.5.6 490.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"
        }
    ]
};

const FarBurgerCheese = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBurgerCheese",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9.1.6.1 1.3.1 2 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6-19.9-9.1-44.5-15.6-75.3-17.1 1.2 2.3 1.9 4.9 1.9 7.7 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8.7-5.4 1.9-7.7-30.7 1.5-55.4 8-75.3 17.1 5.5 2.5 9.3 8.1 9.3 14.6 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3.1-2-11.6 7.8-21 16.4-28.6 24.9-12.8 14.2-21.5 29-27.1 41.1h335.4c-5.7-12.1-14.3-26.9-27.1-41.1zm54.4 89.1H61.1C45 224 32 211 32 194.9c0-1.9.2-3.7.6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9.6 3.7.6 5.6 0 16.1-13 29.1-29.1 29.1zM128 432h256c20.9 0 38.7-13.4 45.3-32H82.7c6.6 18.6 24.4 32 45.3 32zm-96-48c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32 0 53-43 96-96 96H128c-53 0-96-43-96-96zm221.5-121.2 52.2 26.1c9 4.5 19.6 4.5 28.6 0l52.2-26.1c8.9-4.4 18.7-6.8 28.6-6.8H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h176.9c9.9 0 19.7 2.3 28.6 6.8z"
        }
    ]
};

const FarBurgerFries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBurgerFries",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M167.6 2.4c-4.7 2.9-7.6 8.1-7.6 13.6v253.9c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16c-5-2.5-10.8-2.2-15.6.7zM128 261V14.7l-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2.9 2.3 1.2 3.4 2 6.3 6.7 15.9 18.7 24.3 3.2 2.2 7.1 4.5 11.8 6.6zm-69.8-68L40.3 85.6l-20.4-5.1c-5.3-1.3-10.8.1-14.8 3.8S-.7 93.4.2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1zm312-17.5 13.6-76.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-18 4.6-19 107.8c2.5-.4 5.1-.7 7.9-.8 10.4-6.1 22.1-11.7 35.1-16.4zM286.6 230c.7-2.3 1.7-4.7 2.8-7l30.4-172.2c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8c-6.2 1.5-10.9 6.5-12 12.7l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6 2.1-1.5 4-3 5.7-4.5 3.2-4.9 7-10 11.4-15.4.7-1.6 1.3-3.1 1.7-4.5zM192 304c-91.7 0-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224H21.4C9.6 224 0 233.6 0 245.4c0 1.7.2 3.4.6 5.1l57.5 237c3.4 14.4 16.3 24.5 31.1 24.5h204.9c-14-13.1-24.9-29.5-31.3-48h-161L66.1 316.8c1.4 1.1 2.8 2.1 4.3 3.1C99.3 340.1 139.1 352 192 352c26.8 0 50.3-3.1 70.6-8.7-4.3-11.8-6.6-24.6-6.6-37.8 0-3.2.1-6.7.5-10.5-16.7 5.5-37.8 9-64.5 9zm257.9-63.8c-1.2 2.3-1.9 4.9-1.9 7.6 0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6 22.5 1.3 40.8 5.5 55.7 11.3-3.5 2.9-5.8 7.4-5.8 12.3 0 8.8 7.2 16 16 16 8.3 0 15.2-6.4 15.9-14.6 18.4 12.7 27.4 26.8 31.1 33.6.3.7 1 2.3 1 6.1 0 17-13.8 30.8-30.8 30.8H366.8c-17 0-30.8-13.8-30.8-30.8 0-3.7.6-5.4 1-6.1 3.7-6.9 12.7-21 31.1-33.6.7 8.2 7.6 14.6 15.9 14.6 8.8 0 16-7.2 16-16 0-4.9-2.2-9.4-5.8-12.3 14.8-5.8 33.1-10.1 55.7-11.3zm177.9 106.9c7.7-12.2 12.2-26.6 12.2-42.1 0-8.4-1.3-18.7-6.7-28.8-14.3-26.7-59.1-84.4-169.3-84.4s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8 0 15.5 4.5 29.9 12.2 42.1-7.5 7.3-12.2 17.5-12.2 28.7 0 8.1 2.4 15.6 6.5 21.8-4.1 7.8-6.5 16.7-6.5 26.2 0 48.6 39.4 88 88 88h176c48.6 0 88-39.4 88-88 0-9.5-2.3-18.4-6.5-26.2 4.1-6.3 6.5-13.8 6.5-21.8 0-11.3-4.7-21.5-12.2-28.7zM344 415.8h240c4.4 0 8 3.6 8 8 0 22.1-17.9 40-40 40H376c-22.1 0-40-17.9-40-40 0-4.4 3.6-8 8-8z"
        }
    ]
};

const FarBurgerGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBurgerGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4.1 26.1l36.2 420.1C39.5 483.4 70.7 512 108 512h168c5.6 0 11-.6 16.2-1.8-13.1-12.8-23.3-28.5-29.4-46.2H108c-12.5 0-22.8-9.5-23.9-21.9L64 208h247.8c15.5-12.4 35-24.1 59.2-32.7l12.9-149.2c.6-6.7-1.7-13.3-6.2-18.3S366.7 0 360 0H24zm35.8 160L50.2 48h283.6l-9.7 112H59.8zm390.1 80.2c-1.2 2.3-1.9 4.9-1.9 7.6 0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6 22.5 1.3 40.8 5.5 55.7 11.3-3.5 2.9-5.8 7.4-5.8 12.3 0 8.8 7.2 16 16 16 8.3 0 15.2-6.4 15.9-14.6 18.4 12.7 27.4 26.8 31.1 33.6.3.7 1 2.3 1 6.1 0 17-13.8 30.8-30.8 30.8H366.8c-17 0-30.8-13.8-30.8-30.8 0-3.7.6-5.4 1-6.1 3.7-6.9 12.7-21 31.1-33.6.7 8.2 7.6 14.6 15.9 14.6 8.8 0 16-7.2 16-16 0-4.9-2.2-9.4-5.8-12.3 14.8-5.8 33.1-10.1 55.7-11.3zm177.9 106.9c7.7-12.2 12.2-26.6 12.2-42.1 0-8.4-1.3-18.7-6.7-28.8-14.3-26.7-59.1-84.4-169.3-84.4s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8 0 15.5 4.5 29.9 12.2 42.1-7.5 7.3-12.2 17.5-12.2 28.7 0 8.1 2.4 15.6 6.5 21.8-4.1 7.8-6.5 16.7-6.5 26.2 0 48.6 39.4 88 88 88h176c48.6 0 88-39.4 88-88 0-9.5-2.3-18.4-6.5-26.2 4.1-6.3 6.5-13.8 6.5-21.8 0-11.3-4.7-21.5-12.2-28.7zM344 415.8h240c4.4 0 8 3.6 8 8 0 22.1-17.9 40-40 40H376c-22.1 0-40-17.9-40-40 0-4.4 3.6-8 8-8z"
        }
    ]
};

const FarBurgerLettuce = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBurgerLettuce",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9.1.6.1 1.3.1 2 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6-19.9-9.1-44.5-15.6-75.3-17.1 1.2 2.3 1.9 4.9 1.9 7.7 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8.7-5.4 1.9-7.7-30.7 1.5-55.4 8-75.3 17.1 5.5 2.5 9.3 8.1 9.3 14.6 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3.1-2-11.6 7.8-21 16.4-28.6 24.9-12.8 14.2-21.5 29-27.1 41.1h335.4c-5.7-12.1-14.3-26.9-27.1-41.1zm54.4 89.1H61.1C45 224 32 211 32 194.9c0-1.9.2-3.7.6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9.6 3.7.6 5.6 0 16.1-13 29.1-29.1 29.1zM128 432h256c20.9 0 38.7-13.4 45.3-32H82.7c6.6 18.6 24.4 32 45.3 32zm-96-48c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32 0 53-43 96-96 96H128c-53 0-96-43-96-96zm48-56c-20.1 0-35.8-5.1-46.7-10.5-5.4-2.7-9.6-5.5-12.7-7.8-1.5-1.1-2.7-2.1-3.7-3-.5-.4-.9-.8-1.2-1.1l-.4-.4-.2-.2-.1-.1 17-17L15 305c-9.4-9.4-9.4-24.6 0-33.9 9.2-9.2 24.2-9.4 33.6-.4.1.1.4.3.8.6 1 .7 2.8 1.9 5.3 3.2C59.8 277 68.1 280 80 280c8.2 0 15.2-3.8 30-12.6l.2-.1c13.2-7.9 32.3-19.3 57.8-19.3 25.1 0 42.2 11.1 54.1 18.8l1.6 1c12 7.7 19.8 12.2 32.3 12.2 12.2 0 19-4.2 30.7-12l.6-.4c12.3-8.2 29.4-19.6 56.7-19.6 27.2 0 46.1 11.3 59.6 19.6 14.5 9 20.5 12.4 28.4 12.4 11.9 0 20.2-2.9 25.3-5.5 2.6-1.3 4.4-2.5 5.3-3.2.4-.3.7-.6.8-.6 9.4-9 24.3-8.9 33.6.4 9.4 9.4 9.4 24.6 0 33.9l-17-17 17 17-.1.1-.2.2-.4.4c-.3.3-.7.7-1.2 1.1-.9.8-2.1 1.8-3.7 3-3 2.3-7.2 5.1-12.7 7.8-10.9 5.3-26.6 10.4-46.7 10.4-22.2 0-39.3-10.7-50.8-17.9-1-.6-1.9-1.2-2.7-1.7-12.6-7.7-21.7-12.4-34.5-12.4-12.2 0-19 4.2-30.7 12l-.6.4c-12.3 8.2-29.4 19.6-56.7 19.6-27.5 0-45.5-11.6-58.3-19.8-12.9-8.3-19.3-12.2-29.7-12.2-11 0-19.8 4.5-33.4 12.6l-2.3 1.4c-12.1 7.3-29.9 18-52.2 18z"
        }
    ]
};

const FarBurgerSoda = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBurgerSoda",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24S293.3 0 280 0h-30.7zm-189 468c2.1 24.9 22.9 44 47.8 44h167.7c5.4 0 10.7-.9 15.5-2.6-12.7-12.7-22.6-28.1-28.7-45.4H108.2L86.8 208H38.7l21.6 260zm389.6-227.8c-1.2 2.3-1.9 4.9-1.9 7.6 0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6 22.5 1.3 40.8 5.5 55.7 11.3-3.5 2.9-5.8 7.4-5.8 12.3 0 8.8 7.2 16 16 16 8.3 0 15.2-6.4 15.9-14.6 18.4 12.7 27.4 26.8 31.1 33.6.3.7 1 2.3 1 6.1 0 17-13.8 30.8-30.8 30.8H366.8c-17 0-30.8-13.8-30.8-30.8 0-3.7.6-5.4 1-6.1 3.7-6.9 12.7-21 31.1-33.6.7 8.2 7.6 14.6 15.9 14.6 8.8 0 16-7.2 16-16 0-4.9-2.2-9.4-5.8-12.3 14.8-5.8 33.1-10.1 55.7-11.3zm177.9 106.9c7.7-12.2 12.2-26.6 12.2-42.1 0-8.4-1.3-18.7-6.7-28.8-14.3-26.7-59.1-84.4-169.3-84.4s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8 0 15.5 4.5 29.9 12.2 42.1-7.5 7.3-12.2 17.5-12.2 28.7 0 8.1 2.4 15.6 6.5 21.8-4.1 7.8-6.5 16.7-6.5 26.2 0 48.6 39.4 88 88 88h176c48.6 0 88-39.4 88-88 0-9.5-2.3-18.4-6.5-26.2 4.1-6.3 6.5-13.8 6.5-21.8 0-11.3-4.7-21.5-12.2-28.7zM344 415.8h240c4.4 0 8 3.6 8 8 0 22.1-17.9 40-40 40H376c-22.1 0-40-17.9-40-40 0-4.4 3.6-8 8-8z"
        }
    ]
};

const FarBurger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBurger",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9.1.6.1 1.3.1 2 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6-19.9-9.1-44.5-15.6-75.3-17.1 1.2 2.3 1.9 4.9 1.9 7.7 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8.7-5.4 1.9-7.7-30.7 1.5-55.4 8-75.3 17.1 5.5 2.5 9.3 8.1 9.3 14.6 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3.1-2-11.6 7.8-21 16.4-28.6 24.9-12.8 14.2-21.5 29-27.1 41.1h335.4c-5.7-12.1-14.3-26.9-27.1-41.1zm54.4 89.1H61.1C45 224 32 211 32 194.9c0-1.9.2-3.7.6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9.6 3.7.6 5.6 0 16.1-13 29.1-29.1 29.1zM128 432h256c20.9 0 38.7-13.4 45.3-32H82.7c6.6 18.6 24.4 32 45.3 32zm-96-48c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32 0 53-43 96-96 96H128c-53 0-96-43-96-96zm-16-96c0-17.7 14.3-32 32-32h416c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FarBurrito = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBurrito",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M67.9 304c-4.4 4.4-8.1 9.4-11.2 14.7 17.3 6 35.9 9.3 55.3 9.3 75.6 0 139.5-49.9 160.6-118.6 4.8-15.6 7.4-32.2 7.4-49.4 0-20.3-3.6-39.8-10.2-57.9L67.9 304zm-53.8-7.4c5.3-9.7 11.9-18.6 19.8-26.5L242 62c8.2-35.5 40-62 78-62 11.4 0 22.2 2.4 32 6.7 9.8-4.3 20.6-6.7 32-6.7 34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32 2.7 6.1 4.6 12.7 5.7 19.6 6.6 41.7-20.4 81-61 90.4L241.9 478.1C220.2 499.8 190.7 512 160 512s-60.2-12.2-81.9-33.9l33.9-34c12.7 12.7 30 19.9 48 19.9s35.3-7.2 48-19.9l201.9-201.9c-18-6.6-37.5-10.2-57.9-10.2-13 0-25.7 1.5-37.9 4.3C283.3 317.9 204.5 376 112 376c-21.7 0-42.6-3.2-62.4-9.1 2.8 12.5 9.1 24 18.2 33.1l44.2 44.1-33.9 34-44.2-44.2C12.2 412.2 0 382.7 0 352c0-2.4.1-4.8.2-7.1 1-17 5.8-33.5 13.9-48.3z"
        }
    ]
};

const FarBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBurst",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M161.7 216.4c4.9-14.3 2.7-30.1-5.9-42.6l-39.2-57.1 57.1 39.2c12.5 8.6 28.3 10.7 42.6 5.9s25.5-16.2 30.2-30.6l9.4-29.1 11.7 36c4 12.4 12.9 22.6 24.6 28.3s25.2 6.4 37.5 2l22-8-8 22.1c-4.5 12.2-3.8 25.8 2 37.5s15.9 20.6 28.3 24.6l36 11.7-32.6 10.6c-13.5 4.4-24.3 14.5-29.7 27.6s-4.6 27.9 2 40.4l17 32.2-32.2-17c-12.5-6.6-27.3-7.3-40.4-2s-23.2 16.2-27.6 29.7L256 410.1l-10.6-32.6c-4.4-13.5-14.5-24.3-27.6-29.7s-27.9-4.6-40.4 2l-32.2 17 16.9-32.2c6.6-12.5 7.3-27.3 2-40.4s-16.2-23.2-29.7-27.6L101.9 256l29.1-9.4c14.4-4.7 25.8-15.9 30.6-30.2zm-2-128.5L37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l83.7 122 28.3 41.3-47.6 15.5-52 16.8C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l56.7 18.4 46.3 15L97 355.3l-30.2 57.5c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l57.5-30.2 43.1-22.7 15 46.3 18.4 56.7c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l18.4-56.7 15-46.3 43.1 22.7 57.5 30.2c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L415 355.3l-22.7-43.1 46.3-15 56.7-18.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-60.8-19.7-45.7-14.8 16.4-45.1 9.2-25.3c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-25.3 9.2-45.1 16.4-14.7-45.7-19.7-60.8C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-16.8 52-15.4 47.6-41.4-28.3z"
        }
    ]
};

const FarBusSchool = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBusSchool",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 95v1h84.3c5.5-9.6 15.9-16 27.7-16h96c11.8 0 22.2 6.4 27.7 16H416v-1c0-.4 0-.8-.1-1v-.1C404.2 79.4 363.5 48 256 48c-99.1 0-146.4 31.1-160 46.3v.7zm0 49v82.8c7.7-1.8 15.7-2.8 24-2.8h112v-80H96zm320 82.8V144H280v80h112c8.3 0 16.3 1 24 2.8zM464 95v33h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-13c17.9 18.7 29 44.1 29 72v56c0 29.8-20.4 54.9-48 62v42c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H112v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-42c-27.6-7.1-48-32.2-48-62v-56c0-27.9 11-53.3 29-72H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h16V95c0-8.8 2-20.6 10.4-30.6C82.9 35.2 145.9 0 256 0c117.7 0 174.9 35.1 198.3 65 7.7 9.8 9.7 21.1 9.7 30zM112 336a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-216-64c-30.9 0-56 25.1-56 56v56c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16v-56c0-30.9-25.1-56-56-56H120z"
        }
    ]
};

const FarBusSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBusSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M51.5 96h345.7c-15.8-17.1-62-48-173.2-48C121.8 48 69.8 78.3 51.5 96zM400 144H48v80h352v-80zm0 128H48v104c0 13.3 10.7 24 24 24h304c13.3 0 24-10.7 24-24V272zM10.2 70C35.9 38.7 103.8 0 224 0c128.6 0 190 38.6 214.4 70.6 7.5 9.8 9.6 20.9 9.6 29.9V376c0 25-12.7 47-32 59.9V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H80v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-52.1C12.7 423 0 401 0 376V100.4C0 91.6 2 80 10.2 70zM112 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarBus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M363.7 96h97.5c-15.8-17.1-62-48-173.2-48-102.2 0-154.2 30.3-172.5 48h96.8c5.5-9.6 15.9-16 27.7-16h96c11.8 0 22.2 6.4 27.7 16zM464 144H312v80h152v-80zm-352 0v80h152v-80H112zm0 128v104c0 13.3 10.7 24 24 24h304c13.3 0 24-10.7 24-24V272H112zM74.2 70C99.9 38.7 167.8 0 288 0c128.6 0 190 38.6 214.4 70.6 7.5 9.8 9.6 20.9 9.6 29.9V128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v120c0 25-12.7 47-32 59.9V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H144v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-52.1C76.7 423 64 401 64 376V256c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32v-27.6C64 91.6 66 80 74.2 70zM176 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarBusinessTime = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarBusinessTime",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56v40h160V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V56c0-30.9 25.1-56 56-56h144c30.9 0 56 25.1 56 56v40h64c35.3 0 64 28.7 64 64v32.7c-5.3-.5-10.6-.7-16-.7-10.9 0-21.6 1-32 2.9V160c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v96h312.2c-21.9 26.6-36.2 59.7-39.5 96H224c-17.7 0-32-14.3-32-32v-16H48v112c0 8.8 7.2 16 16 16h268c6.9 17.5 16.4 33.7 28.2 48H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm224 272a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarButter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarButter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 112v176h-48V112H128c-8.8 0-16 7.2-16 16v160H64V128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v160h-48V128c0-8.8-7.2-16-16-16h-48zM0 344c0-13.3 10.7-24 24-24h592c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-48h-8c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarC = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarC",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343.5 131.7C275.8 63 166 63 98.3 131.7s-67.7 180 0 248.7 177.5 68.7 245.2 0c9.3-9.4 24.4-9.4 33.7 0s9.3 24.7 0 34.2c-86.3 87.5-226.3 87.5-312.6 0s-86.3-229.5 0-317 226.3-87.5 312.6 0c9.3 9.4 9.3 24.7 0 34.2s-24.4 9.4-33.7 0z"
        }
    ]
};

const FarCabin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCabin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 54.1 95.3 176h321.4L256 54.1zm-24.2-41.9c14.3-10.8 34.1-10.8 48.4 0L432 127.4V56c0-13.3 10.7-24 24-24s24 10.7 24 24v107.8l22.5 17.1c8.2 6.2 11.5 17 8.2 26.8S498.3 224 488 224H24c-10.3 0-19.5-6.6-22.7-16.3s0-20.5 8.2-26.8L231.8 12.2zM32 296c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zm0 192c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zm24-120h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zm264-72c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm24 168h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-96-264a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarCabinetFiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCabinetFiling",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 232H48V64c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v168zM0 256v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v192zm400 192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V280h352v168zM160 152v-8h128v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-16c0-22.1-17.9-40-40-40H152c-22.1 0-40 17.9-40 40v16c0 13.3 10.7 24 24 24s24-10.7 24-24zm-8 184c-22.1 0-40 17.9-40 40v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h128v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-16c0-22.1-17.9-40-40-40H152z"
        }
    ]
};

const FarCableCar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCableCar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64-8a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm208 232v64h-80v-80h64c8.8 0 16 7.2 16 16zm0 112v48c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-48h352zM80 352v-64c0-8.8 7.2-16 16-16h64v80H80zm128-80h96v80h-96v-80zM96 224c-35.3 0-64 28.7-64 64v160c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H280v-76.5l212.9-44c13-2.7 21.3-15.4 18.6-28.4s-15.4-21.3-28.4-18.6l-232 48-232 48c-13 2.7-21.3 15.4-18.6 28.4s15.4 21.3 28.4 18.6l203.1-42V224H96z"
        }
    ]
};

const FarCactus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCactus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 448c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V96c0-26.5 21.5-48 48-48s48 21.5 48 48v352zM256 0c-53 0-96 43-96 96v128h-48c-8.8 0-16-7.2-16-16v-64c0-26.5-21.5-48-48-48S0 117.5 0 144v64c0 61.9 50.1 112 112 112h48v128c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64h48c61.9 0 112-50.1 112-112v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64c0 8.8-7.2 16-16 16h-48V96c0-53-43-96-96-96zm0 144a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarCakeCandles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCakeCandles",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M86.4 5.5 61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.8c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0-24.6 42.1c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.8c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zm103.4 42.1c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.8c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5l-24.6 42.1zM120 168c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-8c-35.3 0-64 28.7-64 64v192c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V288c0-35.3-28.7-64-64-64h-8v-56c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-80v-56c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-80v-56zM64 272h320c8.8 0 16 7.2 16 16v60.8c-5.5-2.1-10.9-5.1-15.8-8.5-3.2-2.2-6.1-5-9.1-7.7-6.7-6.3-13.5-12.6-23.2-12.6-9.4 0-16.5 6.5-23.4 12.8-2.9 2.7-5.8 5.4-8.9 7.5C310.2 347 299 352 288 352s-22.2-5-31.8-11.7c-3.2-2.2-6.1-5-9.1-7.7-6.7-6.3-13.5-12.6-23.2-12.6-9.4 0-16.5 6.5-23.4 12.8-2.9 2.7-5.8 5.4-8.9 7.5C182.2 347 171 352 160 352s-22.2-5-31.8-11.7c-3.2-2.2-6.1-5-9.1-7.7-6.7-6.3-13.4-12.6-23.1-12.6-9.4 0-16.5 6.5-23.4 12.8-2.9 2.7-5.8 5.4-8.9 7.5-4.9 3.4-10.3 6.4-15.8 8.5V288c0-8.8 7.2-16 16-16zm336 126.5V464H48v-65.5c17.5-3.3 33.9-11.6 48-22.3 18.4 14 40.6 23.8 64 23.8s45.6-9.8 64-23.8c18.4 14 40.6 23.8 64 23.8s45.6-9.8 64-23.8c14.1 10.7 30.5 19 48 22.3z"
        }
    ]
};

const FarCakeSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCakeSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 304v48H48v-48h416zM48 416v-32h416v30.4c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM296 32c-7.2 0-14.2 2.4-19.8 6.9l-264 208C4.5 252.9 0 262.2 0 272v144c0 35.3 28.7 64 64 64h384c35.3 0 64-28.6 64-64v-42.2.2-62.2.2-56c0-74.3-32.8-130.8-76.1-168.2C393.6 51.2 340.3 32 296 32z"
        }
    ]
};

const FarCalculatorSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalculatorSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c13.3 0 24 10.7 24 24v208h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h208V24c0-13.3 10.7-24 24-24zm144 32c13.3 0 24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V56c0-13.3 10.7-24 24-24zM55.4 343.4c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7 22.6-22.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L145.9 400l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L112 433.9l-22.6 22.7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L78.1 400l-22.7-22.6c-9.4-9.4-9.4-24.6 0-33.9zM64 88h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H64c-13.3 0-24-10.7-24-24s10.7-24 24-24zm288 248h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarCalculator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalculator",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 176v272c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V176h288zm0-48H48V64c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16v64zm48 0V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128zM80 232a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm24 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM80 408c0 13.3 10.7 24 24 24h88c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88c-13.3 0-24 10.7-24 24zm112-200a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-24 112a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm112-112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-24 112a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm24 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"
        }
    ]
};

const FarCalendarArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarArrowDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H48v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zm-152 56v102.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V248c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarCalendarArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H48v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zM200 408V305.9l-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39V408c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarCalendarCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H48v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zm-71 105L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarCalendarCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v64H48v256c0 8.8 7.2 16 16 16h220.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm304 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarCalendarCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v64H48v256c0 8.8 7.2 16 16 16h220.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm160 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FarCalendarCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v64H48v256c0 8.8 7.2 16 16 16h220.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm304 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FarCalendarCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarCircleUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v64H48v256c0 8.8 7.2 16 16 16h220.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm160 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7h-65.2c-21 0-38.9 13.7-45.1 32.7 20.2 19.4 47.5 31.3 77.7 31.3s57.5-11.9 77.7-31.3zM480 336a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarCalendarClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v64H48v256c0 8.8 7.2 16 16 16h220.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm160 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarCalendarDay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarDay",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H48v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zm-288 64h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarCalendarDays = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarDays",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H152V24zM48 192h80v56H48v-56zm0 104h80v64H48v-64zm128 0h96v64h-96v-64zm144 0h80v64h-80v-64zm80-48h-80v-56h80v56zm0 160v40c0 8.8-7.2 16-16 16h-64v-56h80zm-128 0v56h-96v-56h96zm-144 0v56H64c-8.8 0-16-7.2-16-16v-40h80zm144-160h-96v-56h96v56z"
        }
    ]
};

const FarCalendarExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarExclamation",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H152V24zM48 192h352v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192zm208 208a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-8-152c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64z"
        }
    ]
};

const FarCalendarHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H48v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zM112 301.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
        }
    ]
};

const FarCalendarImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarImage",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H152V24zM48 192h352v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192zm99.2 136.7-47.4 61.5c-8.1 10.5-.6 25.8 12.7 25.8h226.4c12.6 0 20.3-13.9 13.5-24.6l-83.5-131.1c-6.1-9.7-20.1-9.9-26.7-.5L184 344l-11.4-15.1c-6.4-8.5-19-8.5-25.5-.2zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarCalendarLinesPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarLinesPen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v64H48v256c0 8.8 7.2 16 16 16h198.5l-5.1 20.2c-2.3 9.4-1.8 19 1.4 27.8H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm-8 256h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zM96 376c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm453.8-140.3 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FarCalendarLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarLines",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H152V24zM48 192h352v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192zm48 88c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"
        }
    ]
};

const FarCalendarMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H80v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zM328 352H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
        }
    ]
};

const FarCalendarPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarPen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H80v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zm-91.2 51c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9-53.3-53.2 14.9-15c14.7-14.7 38.6-14.7 53.3 0zM178.1 352.5l71.9-71.9 53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.6c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FarCalendarPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H96c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H184V24zM80 192h352v256c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V192zm176 40c-13.3 0-24 10.7-24 24v48h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-48c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarCalendarRange = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarRange",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H96c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H184V24zM80 192h352v256c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V192zm48 96a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm224 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-128-64c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm40 72H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24z"
        }
    ]
};

const FarCalendarStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarStar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H80v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zm-166.7 50.9 23.6 47.8 52.7 7.7c8.5 1.2 11.9 11.7 5.8 17.7l-38.2 37.2 9 52.5c1.5 8.5-7.5 15-15.1 11L256 392l-47.2 24.8c-7.6 4-16.5-2.5-15.1-11l9-52.5-38.2-37.2c-6.2-6-2.8-16.5 5.8-17.7l52.7-7.7 23.6-47.8c3.8-7.7 14.8-7.7 18.7 0z"
        }
    ]
};

const FarCalendarUsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarUsers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-40c-35.3 0-64 28.7-64 64v64h448v-64c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H248V24zm6.7 440c.9 5.2 1.3 10.5 1.3 16 0 11.7-3.1 22.6-8.6 32h145.2c-5.4-9.4-8.6-20.3-8.6-32 0-5.5.5-10.8 1.3-16H254.7zM528 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-48 32c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64h-96zM192 304a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM0 480c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FarCalendarWeek = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarWeek",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H48v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zm-288 64h224c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarCalendarXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendarXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H80v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zm-95 89-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarCalendar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H152V24zM48 192h352v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"
        }
    ]
};

const FarCalendars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCalendars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c13.3 0 24 10.7 24 24v40h112V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm-80 192v160c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V192H144zm-96-8v208c0 39.8 32.2 72 72 72h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H120C53.7 512 0 458.3 0 392V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarCamcorder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCamcorder",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 120c0-22.1 17.9-40 40-40h160c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88 39.4-88 88v42c-27.6 7.1-48 32.2-48 62v192c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H96v-40zm-32 88h256c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zm456.3 252.5c5.1 2.3 10.6 3.5 16.2 3.5 21.8 0 39.5-17.7 39.5-39.5v-209c0-21.8-17.7-39.5-39.5-39.5-5.6 0-11.1 1.2-16.2 3.5L416 226.4V279l112-50.4v182.8L416 361v52.6l104.3 46.9zM80 264c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H104c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarCameraCctv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCameraCctv",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m54.9 192.2 169.3 70.5c.1 0 .2.1.2.1.6.2 1.1.4 1.6.7l92.2 38.4 160-106.7-343.3-143-80 140zm130.3 106.3-165.5-69c-8.5-3.5-15-10.5-18-19.2s-2-18.2 2.5-26.2l96-168c8-14 25.2-19.9 40.1-13.7l384 160c10.9 4.5 18.4 14.7 19.5 26.5s-4.3 23.2-14.1 29.7l-192 128c-8.9 5.9-20.2 7-30.1 2.9L229.5 317l-47.1 123.5C178.9 449.8 170 456 160 456H48v32c0 13.3-10.7 24-24 24S0 501.3 0 488V376c0-13.3 10.7-24 24-24s24 10.7 24 24v32h95.5l41.7-109.5zM397 345.6 529.9 257l36.7 16.3c7.9 3.5 11.6 12.8 8.3 20.8l-40 96c-1.7 4-4.9 7.2-8.9 8.7s-8.5 1.5-12.5-.3l-116.6-52.9z"
        }
    ]
};

const FarCameraMovie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCameraMovie",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 120a72 72 0 1 0-144 0 72 72 0 1 0 144 0zm120 120H152c-66.3 0-120-53.7-120-120S85.7 0 152 0c39.3 0 74.1 18.8 96 48 21.9-29.1 56.7-48 96-48 66.3 0 120 53.7 120 120s-53.7 120-120 120zm-72-120a72 72 0 1 0 144 0 72 72 0 1 0-144 0zM112 336v112c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm32-64h208c35.3 0 64 28.7 64 64v112c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V336c0-5.5.7-10.9 2-16H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h120zm384 36.6-80 36V292l75.6-34c2.9-1.3 6-2.2 9.1-2.8 22.6-3.8 43.3 13.7 43.3 36.6v180.7c0 21.8-17.7 39.5-39.5 39.5-5.6 0-11.1-1.2-16.2-3.5L448 476v-52.6l80 36V308.6z"
        }
    ]
};

const FarCameraPolaroid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCameraPolaroid",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 432H64c-8.8 0-16-7.2-16-16v-32h480v32c0 8.8-7.2 16-16 16zM68.4 336l32.9-49.3c7-10.5 10.7-22.9 10.7-35.5V96c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v155.2c0 12.6 3.7 25 10.7 35.5l32.9 49.3H68.4zM64 480h448c35.3 0 64-28.7 64-64v-44.6c0-12.6-3.7-25-10.7-35.5L514.7 260c-1.8-2.6-2.7-5.7-2.7-8.9V96c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v155.2c0 3.2-.9 6.2-2.7 8.9l-50.6 75.8C3.7 346.4 0 358.7 0 371.4V416c0 35.3 28.7 64 64 64zm344-368a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM288 288a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-32-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarCameraRetro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCameraRetro",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 112H64c-8.8 0-16 7.2-16 16v64h108.1c23.5-29.3 59.5-48 99.9-48s76.5 18.7 99.9 48H464V96c0-8.8-7.2-16-16-16H271.1c-2.5 0-4.9.6-7.2 1.7l-50.5 25.2c-6.7 3.3-14 5.1-21.5 5.1zM48 240v176c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V240h-84c2.6 10.2 4 21 4 32 0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32H48zM0 416V128c0-35.3 28.7-64 64-64V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v16h32l50.5-25.2c8.9-4.4 18.7-6.8 28.6-6.8H448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm336-144a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FarCameraRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCameraRotate",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M263.1 32C239 32 217.6 47.4 210 70.3l22.8 7.6-22.8-7.6-8.6 25.7H128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-73.4L430 70.3C422.4 47.4 401 32 376.9 32H263.1zm-7.6 53.5c1.1-3.3 4.1-5.5 7.6-5.5h113.8c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4H512c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h90.7c10.3 0 19.5-6.6 22.8-16.4l14-42.1zm106.9 152.1-15 15c-2.1 2.1-3.3 5-3.3 8 0 6.2 5.1 11.3 11.3 11.3H416c8.8 0 16-7.2 16-16v-60.6c0-6.2-5.1-11.3-11.3-11.3-3 0-5.9 1.2-8 3.3l-16.1 16.1C375.1 185.8 348 176 320 176c-32 0-62.6 12.7-85.3 35.3L231 215c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l3.7-3.7c13.7-13.6 32.2-21.2 51.4-21.2 15.3 0 30.1 4.8 42.4 13.6zM208 380.7c0 6.2 5.1 11.3 11.3 11.3 3 0 5.9-1.2 8-3.3l16.1-16.1C264.9 390.2 292 400 320 400c32 0 62.6-12.7 85.3-35.3l3.7-3.7c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-3.7 3.7A72.995 72.995 0 0 1 320 352c-15.3 0-30.1-4.8-42.4-13.6l15-15c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H224c-8.8 0-16 7.2-16 16v60.7z"
        }
    ]
};

const FarCameraSecurity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCameraSecurity",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h320zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h40.1l-36.5 59.4c-4.6 7.4-4.8 16.7-.5 24.3s12.3 12.3 21 12.3H360c8.7 0 16.7-4.7 21-12.3s4-16.9-.5-24.3L343.9 416H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm223.5 416 29.5 48H130.9l29.5-48h127zM336 208a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-112-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarCameraSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCameraSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1.7-6.3.7-9.6V160c0-35.3-28.7-64-64-64h-73.4L430 70.3C422.4 47.4 401 32 376.9 32H263.1C239 32 217.6 47.4 210 70.3L201.4 96h-46.6L38.8 5.1zM216 144h2.7c10.3 0 19.5-6.6 22.8-16.4l14-42.1c1.1-3.3 4.1-5.5 7.6-5.5h113.8c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4H512c8.8 0 16 7.2 16 16v228.5l-98.4-77.2c1.6-7.5 2.4-15.4 2.4-23.4 0-61.9-50.1-112-112-112-17.5 0-34.1 4-48.9 11.2L216 144zm166.6 130.6L318.1 224h1.9c30.7 0 56.4 21.7 62.6 50.6zM487.4 480l-60.9-48H128c-8.8 0-16-7.2-16-16V184.2l-46.8-36.8c-.8 4.1-1.2 8.3-1.2 12.6v256c0 35.3 28.7 64 64 64h359.4zm-116.8-92-45.9-36.1c-1.6.1-3.1.2-4.7.2-31.8 0-58.2-23.2-63.2-53.6L211 262.2c-1.9 8.3-3 16.9-3 25.8 0 61.9 50.1 112 112 112 18.2 0 35.4-4.3 50.6-12z"
        }
    ]
};

const FarCameraViewfinder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCameraViewfinder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24S0 149.3 0 136V56C0 25.1 25.1 0 56 0zm320 0h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0v80c0 30.9-25.1 56-56 56h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zM173.8 120.2c6.3-14.7 20.8-24.2 36.8-24.2h90.9c16 0 30.5 9.5 36.8 24.2l3.3 7.8H352c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h10.5l3.3-7.8zm42 23.8-7.5 17.5c-3.8 8.8-12.5 14.5-22.1 14.5H160c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16h-26.3c-9.6 0-18.3-5.7-22.1-14.5l-7.4-17.5h-80.4zM200 256a56 56 0 1 1 112 0 56 56 0 1 1-112 0z"
        }
    ]
};

const FarCameraWebSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCameraWebSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-145.5-114C516.9 317.5 536 269 536 216 536 96.7 439.3 0 320 0c-71.7 0-135.2 34.9-174.5 88.7L38.8 5.1zm144.5 113.2C213.8 75.8 263.6 48 320 48c92.8 0 168 75.2 168 168 0 41.8-15.3 80-40.5 109.4l-37.8-29.7c18.8-21.1 30.3-49.1 30.3-79.7 0-66.3-53.7-120-120-120-41 0-77.2 20.6-98.9 52l-37.8-29.7zm188.4 147.8L259 177.7c12.7-20.3 35.3-33.7 61-33.7 39.8 0 72 32.2 72 72 0 19.5-7.7 37.1-20.3 50.1zm-12.1 113.2c-12.7 3.1-25.9 4.7-39.6 4.7-92.8 0-168-75.2-168-168v-.2l-45.1-35.5c-1.9 11.6-2.9 23.5-2.9 35.7 0 72.8 36 137.2 91.3 176.4l-62.3 81c-5.6 7.2-6.5 17-2.5 25.2S142.9 512 152 512h376l-60.9-48H200.7l37.1-48.2c25.3 10.4 53.1 16.2 82.2 16.2 30 0 58.6-6.1 84.6-17.2l-45-35.5z"
        }
    ]
};

const FarCameraWeb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCameraWeb",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 384a168 168 0 1 0 0-336 168 168 0 1 0 0 336zm0 48c-29.1 0-56.9-5.8-82.2-16.2L104.7 464h238.6l-37.1-48.2C280.9 426.2 253.1 432 224 432zm216-216c0 72.8-36 137.2-91.3 176.4l62.3 81c5.6 7.2 6.5 17 2.5 25.2S401.1 512 392 512H56c-9.1 0-17.5-5.2-21.5-13.4s-3.1-18 2.5-25.2l62.3-81C44 353.2 8 288.8 8 216 8 96.7 104.7 0 224 0s216 96.7 216 216zm-144 0a72 72 0 1 0-144 0 72 72 0 1 0 144 0zm-192 0a120 120 0 1 1 240 0 120 120 0 1 1-240 0z"
        }
    ]
};

const FarCamera = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCamera",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M199.1 32C175 32 153.6 47.4 146 70.3l22.8 7.6-22.8-7.6-8.6 25.7H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-73.4L366 70.3C358.4 47.4 337 32 312.9 32H199.1zm-7.6 53.5c1.1-3.3 4.1-5.5 7.6-5.5h113.8c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h90.7c10.3 0 19.5-6.6 22.8-16.4l14-42.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm-64-112a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarCampfire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCampfire",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232.2 3.4c-2.5-2.3-5.6-3.4-8.8-3.4-3.2 0-6.4 1.1-9 3.4-29.9 27-55.3 57.7-73.2 87.1-17.7 29-29.2 60.2-29.2 84.2 0 79.8 63.3 145.3 144 145.3 79.9 0 144-65.5 144-145.3 0-18.3-8.7-46.3-21.7-71.8C365 77 346.2 49.7 323.9 29.1c-5-4.7-12.9-4.7-18 0-8.7 8-16.7 17.8-23.8 26.8C266.6 37 250 19.6 232.2 3.4zM301 248.2c-13.5 9.1-27.9 13.6-44.1 13.6-40.5 0-72.9-26.4-72.9-70.9 0-21.8 13.5-40.9 40.5-74.5 3.6 4.5 55.8 71.8 55.8 71.8l32.4-38.2c2.7 3.6 4.5 7.3 6.3 10.9 16.2 30 9 68.2-18 87.3zM32.5 289.6c-12.4-4.7-26.3 1.5-31 13.9s1.5 26.2 13.9 31L188.3 400 15.5 465.6c-12.4 4.7-18.6 18.6-13.9 31s18.6 18.6 31 13.9L256 425.7l223.5 84.8c12.4 4.7 26.3-1.5 31-13.9s-1.5-26.2-13.9-31L323.7 400l172.8-65.6c12.4-4.7 18.6-18.6 13.9-31s-18.6-18.6-31-13.9L256 374.3 32.5 289.6z"
        }
    ]
};

const FarCampground = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCampground",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M375.4 5.6c10.2 8.5 11.5 23.6 3 33.8l-59.1 70.7 235.7 282c8.4 10.1 13 22.8 13 35.9v28c0 30.9-25.1 56-56 56H64c-30.9 0-56-25.1-56-56v-28c0-13.1 4.6-25.8 13-35.9l235.7-282-59.1-70.7c-8.5-10.2-7.1-25.3 3-33.8s25.3-7.1 33.8 3L288 72.7l53.6-64.1c8.5-10.2 23.6-11.5 33.8-3zM57.9 422.8c-1.2 1.4-1.9 3.3-1.9 5.1v28c0 4.4 3.6 8 8 8h62l143.1-182.7c4.5-5.8 11.5-9.2 18.9-9.2s14.4 3.4 18.9 9.2L450 464h62c4.4 0 8-3.6 8-8v-28c0-1.9-.7-3.7-1.9-5.1L288 147.5 57.9 422.8zM187 464h202L288 334.9 187 464z"
        }
    ]
};

const FarCanFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCanFood",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 434.3c-3.4 3-10.2 7.5-21.7 12.2C273.5 456.6 235.9 464 192 464s-81.5-7.4-106.3-17.5c-11.5-4.7-18.3-9.2-21.7-12.2V289.4c14.2 6.1 31 11.3 49.7 15.1 7.6 36.3 39.8 63.5 78.3 63.5s70.7-27.2 78.3-63.5c18.7-3.8 35.5-8.9 49.7-15.1v144.9zm48 5.7V72c0-39.8-78.8-72-176-72S16 32.2 16 72v368c0 39.8 78.8 72 176 72s176-32.2 176-72zM304 72c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24 112 10.7 112 24zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarCandleHolder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCandleHolder",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 112c0 17.7 14.3 32 32 32s32-14.3 32-32c0-3.2-3.6-14.8-17.4-33.6-4.7-6.4-9.8-12.5-14.6-18.1-4.9 5.5-9.9 11.7-14.6 18.1C131.6 97.2 128 108.8 128 112zm32 80c-44.2 0-80-35.8-80-80 0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zm-32 80H96v192h128V272h-48v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56zM48 464V272c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v192h36.1c-2.7-7.5-4.1-15.6-4.1-24 0-39.8 32.2-72 72-72s72 32.2 72 72c0 39.7-32.2 71.9-71.8 72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h24zm352-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarCandyBar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCandyBar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 320v-96h128v96H0zm0 64v-32h128v96H64c-35.3 0-64-28.7-64-64zm288 64H160v-96h128v-32H160v-96h128v-32H160V64h416c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H288zM36.7 177c7.2-12 11.3-26 11.3-41 0-4-.3-7.9-.9-11.7-1-7 6.2-14.2 13.1-13.1 3.8.6 7.7.9 11.7.9 15 0 29-4.1 41-11.3 6.1-3.6 15 .4 15 7.4V192H44.2c-7.1 0-11.1-9-7.4-15zM336 112v288h240c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H336z"
        }
    ]
};

const FarCandyCane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCandyCane",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343 82.3c5.8-1.5 11.9-2.3 18-2.3 13.8 0 26.7 3.9 37.6 10.8l23-23c-17-12.5-38-19.8-60.6-19.8-9.6 0-19 1.3-28.1 3.9L343 82.3zm78.3 31.1c6.8 10.9 10.8 23.8 10.8 37.6v5.6c0 3.5-.2 6.9-.7 10.3l30.7 10.2c1.3-6.7 1.9-13.6 1.9-20.5V151c0-22.7-7.3-43.6-19.7-60.7l-23 23zm30.2 93.9-31-10.3c-6.1 9.8-14.4 18.3-24.5 24.6l-51.2 32 30.2 18.9 37.9-23.7c16.5-10.3 29.7-24.7 38.5-41.4zm-106.6 84-30.2-18.9-77 48.1 30.2 18.9 77-48.1zm-107.2 67-30.2-18.9-73 45.6 30.1 19 73-45.6zm-103.3 64.6L104.2 404l-48.7 30.4c-7.5 4.7-9.8 14.6-5.1 22s14.6 9.8 22 5.1l61.9-38.7zM303.6 65.4l-24.1 15c-7.5 4.7-9.8 14.6-5.1 22s14.6 9.8 22 5.1l17.5-11-10.3-31.1zM361 128c-4.3 0-8.6 1.2-12.2 3.5L322 148.3c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L280.9 23c24-15 51.8-23 80.1-23 83.4 0 151 67.6 151 151v5.6c0 54-27.8 104.2-73.6 132.8L97.9 502.3c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2l340.4-212.8c8.4-5.2 13.5-14.4 13.5-24.3V151c0-12.7-10.3-23-23-23z"
        }
    ]
};

const FarCandyCorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCandyCorn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M612.6 18.1C570.4 4.2 524.1 0 480 0c-44 0-90 4.4-132.2 17.9C331.4 23.4 320 38.8 320 56c0 20.1 7 52 15.6 84 9.1 33.8 21.4 73 34.7 110.4 13.2 37.2 27.9 73.6 41.6 101.3 13.4 27 32.9 64.3 68.1 64.3s54.6-37.3 68.1-64.3c13.8-27.7 28.4-64.1 41.6-101.3C603 213 615.3 173.8 624.4 140 633 108 640 76.1 640 56c0-17.2-11-32.5-27.4-37.9zM480 280c14.2 0 32.1 2.4 45.4 4.6-6.9 17-13.8 32.6-20.3 45.7-7 14-12.8 24.8-19.3 32.3-2.9 3.4-4.9 4.8-5.7 5.2l-.1.1-.1-.1c-.8-.5-2.8-1.8-5.7-5.2-6.5-7.5-12.3-18.3-19.3-32.3-6.5-13.1-13.4-28.7-20.3-45.7 13.3-2.2 31.2-4.6 45.4-4.6zm103.2-172.6C556.2 102.6 512.4 96 480 96s-76.2 6.6-103.2 11.4c-4.7-19.2-7.7-35-8.5-45.5C402.6 51.7 441 48 480 48c39.2 0 77.7 3.6 111.7 13.8-.9 10.6-3.9 26.4-8.5 45.6zm-391.5 14.9c-39.6 20.1-75.4 49.9-106.6 81C54 234.5 24.5 270.1 4.3 309.5c-7.7 15.4-4.9 34.4 7.3 46.6 14.2 14.2 41.8 31.8 70.4 48.3 30.3 17.5 66.8 36.5 102.6 53.6 35.7 16.9 71.8 32.4 101 42.2 28.6 9.6 68.7 22.2 93.6-2.7s12.2-65 2.7-93.6c-9.8-29.3-25.2-65.4-42.2-101-17-35.9-36.1-72.3-53.6-102.6-16.5-28.7-34.2-56.2-48.3-70.4a40.009 40.009 0 0 0-46.2-7.5zm91.4 279c10-10 24.4-21 35.4-28.8 7.2 16.9 13.3 32.8 18 46.7 5 14.8 8.5 26.6 9.2 36.5.3 4.5-.1 6.9-.3 7.8v.1h-.1c-.9.3-3.3.7-7.8.3-9.9-.7-21.7-4.3-36.5-9.2-13.9-4.7-29.7-10.8-46.7-18 7.8-10.9 18.8-25.3 28.8-35.4zm-49.1-195c-22.5 15.8-58.1 42-81 64.9s-49.2 58.5-64.9 81C71.2 341.9 58 332.9 49.9 326c17.1-31.4 41.6-61.2 69.2-88.8 27.7-27.7 57.5-52.4 88.8-69.2 6.8 8.1 15.9 21.4 26.2 38.3z"
        }
    ]
};

const FarCandy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCandy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M309 399.6 198.5 178.7C184.3 201 176 227.5 176 256c0 75.8 58.6 137.9 133 143.6zM233.3 141 360 394.4c17.1-4.9 32.8-12.9 46.7-23.4L280 117.6c-17.1 4.9-32.8 12.9-46.7 23.4zm97.7-28.6 110.5 220.9C455.7 311 464 284.5 464 256c0-75.8-58.6-137.9-133-143.6zM320 64c88 0 162.1 59.1 184.8 139.8l91.9-49c10.5-5.6 23.5-2.7 30.6 6.9s6.1 22.9-2.3 31.3l-29.6 29.6 29.1 10.9C633.8 237 640 246 640 256s-6.2 19-15.6 22.5l-29.1 10.9L625 319c8.4 8.4 9.4 21.7 2.3 31.3s-20.1 12.5-30.6 6.9l-91.9-49C482.1 388.9 408 448 320 448s-162.1-59.1-184.8-139.8l-91.9 49c-10.5 5.6-23.5 2.7-30.6-6.9S6.6 327.4 15 319l29.6-29.6-29-10.9C6.2 275 0 266 0 256s6.2-19 15.6-22.5l29.1-10.9L15 193c-8.4-8.4-9.4-21.7-2.3-31.3s20.1-12.5 30.6-6.9l91.9 49C157.9 123.1 232 64 320 64z"
        }
    ]
};

const FarCannabis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCannabis",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M275.9 10.6C271.5 4 264 0 256 0s-15.5 4-19.9 10.6c-16.1 24.1-36.5 67.2-49.2 115.1-6.8 25.8-11.7 54.2-12 82.5-15-10.3-30.7-19-45.9-26.4-34.5-16.7-68.6-27-92.3-31.7-7.9-1.6-16 .9-21.7 6.6s-8.1 13.8-6.5 21.7C15.4 212.8 35 272 70.8 321.6c-21.3 8.1-39.3 17.5-50.5 23.7-7.6 4.2-12.3 12.3-12.3 21s4.7 16.8 12.4 21c14.6 8.1 40.5 21.5 70.1 30.4 17.6 5.3 37.8 9.5 58.5 9.3l-5.8 23.2c-2.3 9.1.9 18.7 8.2 24.5s17.3 7 25.7 2.8l54.9-27.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-37.8l54.9 27.3c8.4 4.2 18.4 3.1 25.7-2.8s10.5-15.5 8.2-24.5l-5.7-23.2c20.6.2 40.8-4 58.5-9.3 29.6-8.9 55.6-22.3 70.1-30.4 7.6-4.2 12.4-12.3 12.4-21s-4.7-16.8-12.4-21c-11.1-6.2-29.1-15.6-50.5-23.7 35.8-49.4 55.4-108.6 62.3-143.2 1.6-7.9-.9-16-6.5-21.7s-13.8-8.2-21.7-6.6c-23.7 4.7-57.7 15-92.3 31.7-15.3 7.4-30.9 16.1-45.9 26.4-.3-28.3-5.2-56.7-12-82.5-12.6-47.9-33-91.1-49.2-115.1zm4.1 386V344c0-13.3-10.7-24-24-24s-24 10.7-24 24v52.6l-29.6 14.7 2-7.8c2.2-8.6-.6-17.6-7.1-23.6s-15.8-7.8-24.1-4.9c-19 6.7-43.3 4.3-68.7-3.3-5.5-1.6-10.8-3.5-16-5.4 9.3-3.5 19.2-6.7 29.3-9 8.5-1.9 15.2-8.3 17.7-16.6s.3-17.3-5.8-23.5c-30.1-31-50.9-73.8-63.1-109.2 13.1 4.5 27.3 10.1 41.7 17.1C139 240 168.8 260 189.6 285c7.4 9 20.2 11.3 30.3 5.5s14.7-17.9 10.8-28.9c-12.4-34.8-8.9-79.8 2.6-123.7 6.2-23.5 14.4-45.4 22.7-63.6 8.3 18.2 16.5 40.2 22.7 63.6 11.6 43.8 15 88.8 2.6 123.7-3.9 11 .6 23.1 10.8 28.9s22.9 3.4 30.3-5.5c20.8-25.1 50.6-45 81.5-59.9 14.3-6.9 28.6-12.6 41.7-17.1-11.1 32-29.2 70.2-55 100.3-2.6 3.1-5.3 6-8.1 8.9-6 6.2-8.2 15.2-5.8 23.5s9.2 14.6 17.7 16.6c10.1 2.3 20 5.5 29.3 9-5.2 2-10.5 3.8-16 5.4-25.4 7.7-49.7 10-68.7 3.3-8.3-2.9-17.6-1.1-24.1 4.9s-9.3 15-7.1 23.6l2 7.8-29.8-14.7z"
        }
    ]
};

const FarCapsules = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCapsules",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 144c0-35.3 28.7-64 64-64s64 28.7 64 64v112H48V144zm-48 0v224c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8l128.5 187.3c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3c-35.5-51.8-105.4-64.3-156-28.1-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm283.4 73.3c-20.9-30.4-13.3-72.2 15.8-93 28.5-20.4 68-13.7 88.5 16.2l66.9 97.5-106.1 74.2-65.1-94.9z"
        }
    ]
};

const FarCarBattery = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarBattery",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h16zm-16 48c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H64zm304 32c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16zM96 224h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarCarBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarBolt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M127.7 106.8 103.4 176H128v48H96c-26.5 0-48 21.5-48 48v80h416v-80c0-26.5-21.5-48-48-48h-32v-48h24.6l-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8H165.4c-17 0-32.1 10.7-37.8 26.8zm-79.6 82 34.2-97.9C94.7 55.6 128 32 165.4 32h181.2c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9c28.6 16.6 48 47.6 48 83.2v184c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56H48v56c0 13.3-10.7 24-24 24S0 469.3 0 456V272c0-35.6 19.3-66.6 48.1-83.2zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-52.8-171.4c5.3 5.2 6.3 13.3 2.5 19.6L284.3 192H336c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6l33.4-55.8H176c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z"
        }
    ]
};

const FarCarBuilding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarBuilding",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48H64c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h128v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v64.5c-17.5 1.7-33.9 7.7-48 17.1V64c0-8.8-7.2-16-16-16zm-32 171.1-13.1 36.6c-.9.2-1.9.3-2.9.3h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v11.1zM96 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM96 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm0 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm265.8-96c-10.1 0-19.2 6.4-22.6 15.9L322.1 272h219.8l-17.2-48.1c-3.4-9.6-12.5-15.9-22.6-15.9H361.8zm-96.4 79.9 28.6-80.1c10.2-28.7 37.4-47.8 67.8-47.8h140.4c30.4 0 57.6 19.1 67.8 47.8l28.6 80.1c.2.5.3.9.5 1.4 24.7 17.4 40.9 46.2 40.9 78.7v120c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H272v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V368c0-32.5 16.2-61.3 40.9-78.7.1-.5.3-.9.5-1.4zM544 320H320c-26.5 0-48 21.5-48 48v32h320v-32c0-26.5-21.5-48-48-48zm-208 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarCarBump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarBump",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m142.2 101.6 165.1-44.2c16.4-4.4 33.8 2.1 43.4 16.1l38.6 56.6-281.8 75.5 5.1-68.4c1.3-17 13.1-31.2 29.5-35.6zm-77.4 32.1-7.6 101c-21.4 23.4-30.7 56.8-21.9 89.7l18.5 69.1 6.2 23 6.2 23.3 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1 1.7-.5 383.3-102.6 1.7-.5 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1-12.3-46.2-18.5-69.1c-8.8-32.9-33.6-57.1-63.8-66.7l-57.1-83.8C369.3 15.5 331 1.3 294.9 11L129.8 55.2c-36.1 9.7-62.2 41.1-65 78.4zm50.8 119.5 290.5-77.8c25.6-6.9 51.9 8.3 58.8 33.9l18.5 69.1-383.2 102.7-18.5-69.2c-6.9-25.6 8.3-51.9 33.9-58.8zm56.6 46.7a30.8 30.8 0 1 0-59.5 15.9 30.8 30.8 0 1 0 59.5-15.9zm245.9-34a30.8 30.8 0 1 0-15.9-59.5 30.8 30.8 0 1 0 15.9 59.5zM584.8 512c19.5 0 34.7-17.7 25.8-35-18.6-36.2-56.3-61-99.7-61s-81.2 24.8-99.7 61c-8.9 17.3 6.3 35 25.8 35h147.8z"
        }
    ]
};

const FarCarBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m197.2 20.7 30.1 56.7 63.1-11.8c1-.2 2.1-.3 3.1-.4-3.6 4.1-7 8.4-10.2 13l-29.3 43-35.2 6.6c-10.3 1.9-20.7-3.1-25.6-12.3L176 83.2l-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c1.9-1.4 3.9-2.4 6-3.2l-19.5 72.7-24 17.7c-7.2 5.3-16.6 6.1-24.6 2.3S86.5 330.9 86.1 322l-2.5-64.2-62-16.8c-8.6-2.3-15.2-9.2-17.1-17.8s1-17.7 7.7-23.5l48.6-42-25.7-58.9c-3.5-8.1-2.3-17.6 3.3-24.5S52.9 64 61.6 65.7l63.1 11.8 30.1-56.7C159 12.9 167.1 8 176 8s17 4.9 21.2 12.7zm339.3 127.8-137-36.7c-16.4-4.4-33.8 2.1-43.4 16.1l-31 45.5c1.3.3 2.5.6 3.8.9L566.5 238c1.3.3 2.5.7 3.7 1.1l-4.2-55c-1.3-17-13.1-31.2-29.5-35.6zm77.4 32.1 7.2 96.4c15 22.2 20.7 50.6 13.2 78.6l-12.3 46-6.9 25.7-5.5 20.7-12.4 46.3c-2.9 11-14.2 17.5-25.1 14.5s-17.5-14.2-14.5-25.1l12.4-46.3-6.7-1.8-330.4-88.7-6.7-1.8-12.4 46.3c-2.9 11-14.2 17.5-25.1 14.5s-17.5-14.2-14.5-25.1l12.4-46.3 12.4-46.4 12.3-46c7.5-28 26.6-49.7 50.7-61.5l54.5-79.9c21.1-30.9 59.4-45.1 95.5-35.4L549 102c36.1 9.7 62.2 41.1 65 78.4zM554 284.3l-237.6-63.7c-25.6-6.9-51.9 8.3-58.8 33.9l-12.3 46L575.6 389l12.3-46c6.9-25.6-8.3-51.9-33.9-58.8zm14.3 53.3a27.4 27.4 0 1 1-52.9-14.2 27.4 27.4 0 1 1 52.9 14.2zm-257.4-97.3a27.4 27.4 0 1 1-14.2 52.9 27.4 27.4 0 1 1 14.2-52.9z"
        }
    ]
};

const FarCarBus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarBus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64.5 80h256.9C302.1 65.3 263.5 48 192 48 126.6 48 86.2 64.8 64.5 80zM48 128v80h120v-80H48zm0 128v96c0 13.3 10.7 24 24 24h120v48H80v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-44.1C12.7 399 0 377 0 352V118.2c0-22 4.6-51.9 28.8-71.4C58.6 22.7 111.5 0 192 0c84.9 0 135.8 22.1 164.5 46.6 23.4 20 27.5 49.9 27.5 71.6v9.8h-35.8c-4.1 0-8.2.3-12.2.8v-.8H216v80h36.9l-13.7 48H48zm56 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm257.8-80c-10.1 0-19.2 6.4-22.6 15.9L322.1 272h219.8l-17.2-48.1c-3.4-9.6-12.5-15.9-22.6-15.9H361.8zm-96.4 79.9 28.6-80.1c10.2-28.7 37.4-47.8 67.8-47.8h140.4c30.4 0 57.6 19.1 67.8 47.8l28.6 80.1c.2.5.3.9.5 1.4 24.7 17.4 40.9 46.2 40.9 78.7v120c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H272v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V368c0-32.5 16.2-61.3 40.9-78.7.1-.5.3-.9.5-1.4zM544 320H320c-26.5 0-48 21.5-48 48v32h320v-32c0-26.5-21.5-48-48-48zm-208 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarCarCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarCircleBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M127.7 106.8 103.4 176h305.2l-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8H165.4c-17 0-32.1 10.7-37.8 26.8zm-79.6 82 34.2-97.9C94.7 55.6 128 32 165.4 32h181.2c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9c2.6 1.5 5.2 3.2 7.6 4.9-28.3 3.9-54.4 14.6-76.8 30.3H96c-26.5 0-48 21.5-48 48v80h272.7c-.5 5.3-.7 10.6-.7 16 0 10.9 1 21.6 2.9 32H48v56c0 13.3-10.7 24-24 24S0 469.3 0 456V272c0-35.6 19.3-66.6 48.1-83.2zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm384-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1.6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2h-35.6l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"
        }
    ]
};

const FarCarGarage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarGarage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M331.4 2.9c-7.1-3.8-15.7-3.8-22.8 0l-296 160c-11.7 6.3-16 20.9-9.7 32.5s20.9 16 32.5 9.7L320 51.3l284.6 153.8c11.7 6.3 26.2 2 32.5-9.7s2-26.2-9.7-32.5l-296-160zM249.8 208h140.4c10.1 0 19.2 6.4 22.6 15.9l17.1 48.1H210.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2.5-.3.9-.5 1.4-24.7 17.4-40.9 46.2-40.9 78.7v120c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h320v40c0 13.3 10.7 24 24 24s24-10.7 24-24V368c0-32.5-16.2-61.3-40.9-78.7-.1-.5-.3-.9-.5-1.4L458 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H249.8c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM432 320c26.5 0 48 21.5 48 48v32H160v-32c0-26.5 21.5-48 48-48h224zm-208 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarCarMirrors = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarMirrors",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M197.4 80c-17 0-32.1 10.7-37.8 26.8L135.4 176h305.2l-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8H197.4zM44.8 224H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h44.6l29.8-85.1C126.7 55.6 160 32 197.4 32h181.2c37.4 0 70.7 23.6 83.1 58.9l29.7 85.1H536c13.3 0 24 10.7 24 24s-10.7 24-24 24h-4.8c8.2 14.1 12.8 30.5 12.8 48v184c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56H80v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V272c0-17.5 4.7-33.9 12.8-48zm83.2 0c-26.5 0-48 21.5-48 48v80h416v-80c0-26.5-21.5-48-48-48H128zm-16 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm320-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarCarOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarOn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zm-94.2 184h140.4c10.1 0 19.2 6.4 22.6 15.9l17.1 48.1H146.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2.5-.3.9-.5 1.4C64.2 306.7 48 335.5 48 368v120c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h320v40c0 13.3 10.7 24 24 24s24-10.7 24-24V368c0-32.5-16.2-61.3-40.9-78.7-.1-.5-.3-.9-.5-1.4L394 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H185.8c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM416 368v32H96v-32c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48zm-256 16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
        }
    ]
};

const FarCarRear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarRear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M165.4 80h181.2c17 0 32.1 10.7 37.8 26.8l24.2 69.2H103.4l24.2-69.2c5.6-16 20.8-26.8 37.8-26.8zM82.3 90.9l-34.2 97.9C19.3 205.4 0 236.4 0 272v64c0 23.7 12.9 44.4 32 55.4V456c0 13.3 10.7 24 24 24s24-10.7 24-24v-56h352v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-64.6c19.1-11.1 32-31.7 32-55.4v-64c0-35.6-19.4-66.6-48.1-83.2l-34.2-97.9C417.3 55.6 384 32 346.6 32H165.4C128 32 94.7 55.6 82.3 90.9zM96 224h320c20.9 0 38.7 13.4 45.3 32H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v32c0 8.8-7.2 16-16 16H320v-32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v32H64c-8.8 0-16-7.2-16-16v-32h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H50.7c6.6-18.6 24.4-32 45.3-32z"
        }
    ]
};

const FarCarSideBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarSideBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M134.2 105.1 99.4 192H128v48H64c-8.8 0-16 7.2-16 16v96h21.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64h139c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H592v-32c0-44.2-35.8-80-80-80h-96v-48h46.1l-77.6-97c-7.6-9.5-19.1-15-31.2-15h-182c-16.4 0-31.1 10-37.1 25.1zm-87.4 89.2 42.8-107C103 53.9 135.3 32 171.3 32h181.9c26.7 0 52 12.2 68.7 33L524 192.6c65.1 6 116 60.8 116 127.4v48c0 17.7-14.3 32-32 32h-33.3c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H254.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H32c-17.7 0-32-14.3-32-32V256c0-29.4 19.8-54.2 46.8-61.7zM434.7 400a48 48 0 1 0 90.5-32 48 48 0 1 0-90.5 32zM208 384a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm123.2-283.4c5.3 5.2 6.3 13.3 2.5 19.6L300.3 176H352c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6l33.4-55.8H192c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z"
        }
    ]
};

const FarCarSide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarSide",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 80H224v112H99.4l34.7-86.9C140.3 90 155 80 171.3 80zM272 192V80h81.2c12.2 0 23.6 5.5 31.2 15l77.6 97H272zm252 .6L422 65c-16.7-20.9-42-33-68.7-33h-182c-36 0-68.3 21.9-81.7 55.3l-42.8 107C19.8 201.8 0 226.6 0 256v112c0 17.7 14.3 32 32 32h33.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80h130.6c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32v-48c0-66.7-50.9-121.4-116-127.4zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1-90.5-32zm135.8-16c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64h-139c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H48v-96c0-8.8 7.2-16 16-16h448c44.2 0 80 35.8 80 80v32h-21.5zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarCarTilt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarTilt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m142.2 101.6 165.1-44.2c16.4-4.4 33.8 2.1 43.4 16.1l38.6 56.6-281.8 75.5 5.1-68.4c1.3-17 13.1-31.2 29.5-35.6zm-77.4 32.1-7.6 101c-21.4 23.4-30.7 56.8-21.9 89.7l18.5 69.1 6.2 23 6.2 23.3 6.5 24.2H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24H120.5l-9.7-36.1 1.7-.5 383.3-102.7 1.7-.5 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1-12.3-46.2-18.5-69.1c-8.8-32.9-33.6-57.1-63.8-66.7l-57.1-83.8C369.3 15.5 331 1.3 294.9 11L129.8 55.2c-36.1 9.7-62.2 41.1-65 78.4zm50.8 119.5 290.5-77.8c25.6-6.9 51.9 8.3 58.8 33.9l18.5 69.1-383.2 102.7-18.5-69.2c-6.9-25.6 8.3-51.9 33.9-58.8zm56.6 46.7a30.8 30.8 0 1 0-59.5 15.9 30.8 30.8 0 1 0 59.5-15.9zm245.9-34a30.8 30.8 0 1 0-15.9-59.5 30.8 30.8 0 1 0 15.9 59.5z"
        }
    ]
};

const FarCarTunnel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarTunnel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48C141.1 48 48 141.1 48 256v232c0 13.3-10.7 24-24 24S0 501.3 0 488V256C0 114.6 114.6 0 256 0s256 114.6 256 256v232c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-114.9-93.1-208-208-208zm-65.2 229.5L177 320h158l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM122.7 332l22.5-69.3c7.5-23.1 29-38.7 53.3-38.7h115.1c24.3 0 45.8 15.6 53.3 38.7l22.4 69.3c16.1 11.6 26.7 30.6 26.7 52v104c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H144v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V384c0-21.4 10.5-40.4 26.7-52zM144 432h224v-48c0-8.8-7.2-16-16-16H160c-8.8 0-16 7.2-16 16v48zm16-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarCarWash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarWash",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 128c26.5 0 48-16 48-48 0-22.2-23-52-37.2-68.2-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48zm-70.2 80h140.4c10.1 0 19.2 6.4 22.6 15.9l17.1 48.1H114.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2.5-.3.9-.5 1.4C32.2 306.7 16 335.5 16 368v120c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h320v40c0 13.3 10.7 24 24 24s24-10.7 24-24V368c0-32.5-16.2-61.3-40.9-78.6-.1-.5-.3-.9-.5-1.4L362 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H153.8c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM384 368v32H64v-32c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48zm-256 16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM112 80c0-22.2-23-52-37.2-68.2-5.8-6.7-15.8-6.7-21.6 0C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48s48-16 48-48zm272 48c26.5 0 48-16 48-48 0-22.2-23-52-37.2-68.2-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48z"
        }
    ]
};

const FarCarWrench = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarWrench",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M468.9 104h-13.4c-.7 0-1.4-.1-2.1-.1C441.3 102.5 432 92.4 432 80s9.3-22.5 21.3-23.9c.7-.1 1.4-.1 2.1-.1h31c10.8 0 18.4-10.6 12.5-19.6-3.6-5.5-7.8-10.5-12.5-14.9-4.2-3.9-8.8-7.4-13.8-10.3-1.8-1.2-3.7-2.2-5.7-3.2-10.5-5.1-22.4-8-34.9-8-29.1 0-54.5 15.5-68.5 38.7-3.3 5.4-8.9 9.3-15.3 9.3H163.8c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0 67.5 0 55.6 2.9 45.1 8c-2 1-3.9 2-5.8 3.1-5 2.9-9.6 6.4-13.8 10.3-4.7 4.4-9 9.4-12.5 14.9C7 45.4 14.7 56 25.5 56h31c.7 0 1.4.1 2.1.1C70.7 57.5 80 67.6 80 80s-9.3 22.5-21.3 23.9c-.7.1-1.4.1-2.1.1H25.5c-10.8 0-18.5 10.6-12.6 19.6 3.6 5.5 7.8 10.5 12.5 14.9 4.2 3.9 8.8 7.4 13.8 10.3 1.9 1.1 3.8 2.2 5.8 3.1 10.6 5.1 22.4 8 34.9 8 29.1 0 54.5-15.5 68.5-38.7 3.3-5.4 8.9-9.3 15.3-9.3h184.5c6.4 0 12 3.8 15.3 9.3 14 23.2 39.5 38.7 68.5 38.7 12.5 0 24.4-2.9 34.9-8 2-1 3.9-2 5.8-3.1 5-2.9 9.6-6.4 13.8-10.3 4.7-4.4 9-9.4 12.5-14.9 5.9-9-1.7-19.6-12.5-19.6h-17.6zM185.8 208h140.4c10.1 0 19.2 6.4 22.6 15.9l17.1 48.1H146.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2.5-.3.9-.5 1.4C64.2 306.7 48 335.5 48 368v120c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h320v40c0 13.3 10.7 24 24 24s24-10.7 24-24V368c0-32.5-16.2-61.3-40.9-78.7-.1-.5-.3-.9-.5-1.4L394 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H185.8c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM368 320c26.5 0 48 21.5 48 48v32H96v-32c0-26.5 21.5-48 48-48h224zm-208 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarCar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M127.7 106.8 103.4 176h305.2l-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8H165.4c-17 0-32.1 10.7-37.8 26.8zm-79.6 82 34.2-97.9C94.7 55.6 128 32 165.4 32h181.2c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9c28.6 16.6 48 47.6 48 83.2v184c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56H48v56c0 13.3-10.7 24-24 24S0 469.3 0 456V272c0-35.6 19.3-66.6 48.1-83.2zM416 224H96c-26.5 0-48 21.5-48 48v80h416v-80c0-26.5-21.5-48-48-48zm-304 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarCaravanSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCaravanSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 80c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h28.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H528V192c0-61.9-50.1-112-112-112H80zm16 336H80c-44.2 0-80-35.8-80-80V112c0-44.2 35.8-80 80-80h336c88.4 0 160 71.6 160 160v176h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H288c0 53-43 96-96 96s-96-43-96-96zm0-256c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-64zm256-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zM240 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarCaravan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCaravan",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 80c61.9 0 112 50.1 112 112v176h-48V168c0-22.1-17.9-40-40-40h-80c-22.1 0-40 17.9-40 40v200h-44.8c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H80c-17.7 0-32-14.3-32-32V112c0-17.7 14.3-32 32-32h336zM80 416h16c0 53 43 96 96 96s96-43 96-96h328c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V192c0-88.4-71.6-160-160-160H80C35.8 32 0 67.8 0 112v224c0 44.2 35.8 80 80 80zm352-192h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v96h-64V176h64v48zm-304-96c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H128zm64 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarCardClub = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCardClub",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h256zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm66.1 208.3c-28.2 3-50.1 26.8-50.1 55.7 0 30.9 25.1 56 56 56 15.7 0 29.8-6.4 40-16.8V336h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-32.8c10.2 10.4 24.3 16.8 40 16.8 30.9 0 56-25.1 56-56 0-28.9-21.9-52.7-50.1-55.7 1.4-5.2 2.1-10.7 2.1-16.3 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6.7 11.1 2.1 16.3z"
        }
    ]
};

const FarCardDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCardDiamond",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm180.7 84.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96z"
        }
    ]
};

const FarCardHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCardHeart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 157.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.9-82.7C86.5 253.1 80 237.5 80 221.3z"
        }
    ]
};

const FarCardSpade = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCardSpade",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm175 77.2c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6 59.7 59.7c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-3.2-3.2c-.3-.3-.6-.6-1-.9V336h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-37.4c-.3.3-.7.6-1 .9l-3.2 3.2c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l59.7-59.7 22.7-22.6z"
        }
    ]
};

const FarCardsBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCardsBlank",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M51.8 160.4c-3.7 2.1-4.9 6.8-2.8 10.5l167 289.3c2.1 3.7 6.8 4.9 10.5 2.8l192.9-111.4c3.7-2.1 4.9-6.8 2.8-10.5l-167-289.3c-2.1-3.7-6.8-4.9-10.5-2.8L51.8 160.4zM7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.2-76.1-20.4L7.5 194.9zm451.9 226c41.9-24.2 56.3-77.8 32.1-119.8L354.7 64.2c1.7-.2 3.5-.2 5.3-.2h224c30.9 0 56 25.1 56 56v336c0 30.9-25.1 56-56 56H360c-13.7 0-26.2-4.9-35.9-13l135.3-78.1z"
        }
    ]
};

const FarCards = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCards",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M244.7 49c3.7-2.1 8.4-.9 10.5 2.8l167 289.3c2.1 3.7.9 8.4-2.8 10.5L226.5 463c-3.7 2.1-8.4.9-10.5-2.8L49 170.9c-2.1-3.7-.9-8.4 2.8-10.5L244.7 49zM27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4l192.8-111.4c26.6-15.4 35.8-49.4 20.4-76.1l-167-289.3C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zM324.1 499c9.7 8.1 22.2 13 35.9 13h224c30.9 0 56-25.1 56-56V120c0-30.9-25.1-56-56-56H360c-1.8 0-3.5.1-5.3.2l136.8 236.9c24.2 41.9 9.8 95.6-32.1 119.8L324.1 499zM582 187.6l-48.2 49.9c-3.2 3.2-8.5 3.2-11.5 0l-48.4-49.9c-14-14.5-13.2-38.5 2.5-51.9 13.5-11.7 34.2-9.5 46.7 3.2l5 5.2 4.7-5.2c12.5-12.7 33-15 46.9-3.2 15.5 13.5 16.2 37.5 2.2 51.9zm-410.6-13.3-7.2 26.9-20.4 76.1c-7 26 8.5 52.7 34.4 59.7s52.7-8.5 59.7-34.4l2.4-8.8c.1-.4.2-.8.3-1.1l17.7 30.7-12.1 7c-6.7 3.8-8.9 12.4-5.1 19s12.4 8.9 19 5.1l48.2-27.8c6.7-3.8 8.9-12.4 5.1-19s-12.4-8.9-19-5.1l-12.1 7-17.7-30.7c.4.1.8.2 1.1.3l8.8 2.4c26 7 52.7-8.5 59.7-34.4s-8.5-52.7-34.4-59.7l-76.1-20.4-26.7-7.5c-11.1-3-22.6 3.6-25.6 14.8z"
        }
    ]
};

const FarCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCaretDown",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m160 329.4 89.4-89.4H70.6l89.4 89.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 192 32 192h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
        }
    ]
};

const FarCaretLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCaretLeft",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m54.6 256 89.4-89.4v178.7L54.6 256zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V128c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-128 128z"
        }
    ]
};

const FarCaretRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCaretRight",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M201.4 256 112 166.6v178.7l89.4-89.3zm45.3-22.6c12.5 12.5 12.5 32.8 0 45.3l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9S64 397 64 384V128c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128z"
        }
    ]
};

const FarCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCaretUp",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 182.6 70.6 272h178.8L160 182.6zm-22.6-45.3c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9S301 320 288 320H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"
        }
    ]
};

const FarCarrot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCarrot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7 4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74-3.2-4-8.1-6-13.2-6s-10 2-13.3 6C337.6 17 320 42.3 320 72zM199.3 197.4c13.2-8.6 28.9-13.4 45.3-13.4 46.1 0 83.4 37.3 83.4 83.4 0 32.5-18.9 62-48.3 75.7l-42.8 19.8L209 335c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15.4 15.4-117.2 54.4 94.8-204.6L207 273c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41.7-41.7zM34.1 509.8l265.7-123.2c46.4-21.5 76.2-68 76.2-119.2 0-72.6-58.8-131.4-131.4-131.4-51.2 0-97.7 29.7-119.2 76.2L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8z"
        }
    ]
};

const FarCars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCars",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M137.8 48h140.4c10.1 0 19.2 6.4 22.6 15.9l17.1 48.1H98.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2.5-.3.9-.5 1.4C16.2 146.7 0 175.5 0 208v120c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h172.1c5.3-6.6 11.3-12.7 17.8-18.2l10.6-29.8H48v-32c0-26.5 21.5-48 48-48h190.8c19.2-20 46.1-32 75.1-32h12.8v-.1L346 47.8C335.7 19.1 308.6 0 278.2 0H137.8C107.4 0 80.3 19.1 70 47.8l-28.6 80.1zM112 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm249.8-16h140.4c10.1 0 19.2 6.4 22.6 15.9l17.1 48.1H322.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2.5-.3.9-.5 1.4-24.7 17.4-40.9 46.2-40.9 78.7v120c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h320v40c0 13.3 10.7 24 24 24s24-10.7 24-24V368c0-32.5-16.2-61.3-40.9-78.7-.1-.5-.3-.9-.5-1.4L570 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H361.8c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM544 320c26.5 0 48 21.5 48 48v32H272v-32c0-26.5 21.5-48 48-48h224zm-208 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarCartArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h45.5c26.9 0 50 19.1 55 45.5l37 194.5h297.7c10.9 0 20.4-7.3 23.2-17.8l46.4-172.4c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4l-46.4 172.4c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zm128 440a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM344 24v102.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarCartArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 184V81.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L303 7c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V184c0 13.3-10.7 24-24 24s-24-10.7-24-24zM0 24C0 10.7 10.7 0 24 0h45.5c26.9 0 50 19.1 55 45.5l37 194.5h297.7c10.9 0 20.4-7.3 23.2-17.8l46.4-172.4c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4l-46.4 172.4c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zm128 440a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarCartCircleArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartCircleArrowDown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h389.5l-31.5 112.1c2.3-.1 4.6-.1 6.9-.1 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-147.3c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0l-56-56c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7V304c0-8.8 7.2-16 16-16s16 7.2 16 16v89.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarCartCircleArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartCircleArrowUp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h389.5l-31.5 112.1c2.3-.1 4.6-.1 6.9-.1 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320-288a144 144 0 1 0 0 288 144 144 0 1 0 0-288zm-67.3 147.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-89.4l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"
        }
    ]
};

const FarCartCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h389.5l-31.5 112.1c2.3-.1 4.6-.1 6.9-.1 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-144a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7z"
        }
    ]
};

const FarCartCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h389.5l-31.5 112.1c2.3-.1 4.6-.1 6.9-.1 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarCartCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h389.5l-31.5 112.1c2.3-.1 4.6-.1 6.9-.1 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm176-144a144 144 0 1 0 288 0 144 144 0 1 0-288 0zm208 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16z"
        }
    ]
};

const FarCartCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c9.2-18 21.4-34.2 36-48H161.6L131.1 80h389.5l-31.5 112.1c2.3-.1 4.6-.1 6.9-.1 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FarCartFlatbedBoxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartFlatbedBoxes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v352c0 30.9 25.1 56 56 56h24c0 26.5 21.5 48 48 48s48-21.5 48-48h192c0 26.5 21.5 48 48 48s48-21.5 48-48h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-4.4 0-8-3.6-8-8V56c0-30.9-25.1-56-56-56H24zm216 80h128v224H240V80zm-48 0v224c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48zm368 0v64h-64V80h64zm-64-48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-64zm0 240h96v32h-96v-32zm-48 0v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarCartFlatbedEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartFlatbedEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h48c30.9 0 56 25.1 56 56v352c0 4.4 3.6 8 8 8h480c13.3 0 24 10.7 24 24s-10.7 24-24 24h-72c0 26.5-21.5 48-48 48s-48-21.5-48-48H256c0 26.5-21.5 48-48 48s-48-21.5-48-48h-24c-30.9 0-56-25.1-56-56V56c0-4.4-3.6-8-8-8H24C10.7 48 0 37.3 0 24z"
        }
    ]
};

const FarCartFlatbedSuitcase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartFlatbedSuitcase",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h48c30.9 0 56 25.1 56 56v352c0 4.4 3.6 8 8 8h480c13.3 0 24 10.7 24 24s-10.7 24-24 24h-72c0 26.5-21.5 48-48 48s-48-21.5-48-48H256c0 26.5-21.5 48-48 48s-48-21.5-48-48h-24c-30.9 0-56-25.1-56-56V56c0-4.4-3.6-8-8-8H24C10.7 48 0 37.3 0 24zm360 24c-4.4 0-8 3.6-8 8v40h96V56c0-4.4-3.6-8-8-8h-80zm136 48h48c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h48V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56v40zm-240 48c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h32V144h-32zm80 0v160h128V144H336zm208 160c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16h-32v160h32z"
        }
    ]
};

const FarCartFlatbed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartFlatbed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v352c0 30.9 25.1 56 56 56h24c0 26.5 21.5 48 48 48s48-21.5 48-48h192c0 26.5 21.5 48 48 48s48-21.5 48-48h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-4.4 0-8-3.6-8-8V56c0-30.9-25.1-56-56-56H24zm216 80h96v96c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l39.1-26.1 39.1 26.1c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1V80h96v224H240V80zm-48 0v224c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarCartMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h45.5c26.9 0 50 19.1 55 45.5l37 194.5h297.7c10.9 0 20.4-7.3 23.2-17.8l46.4-172.4c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4l-46.4 172.4c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zm128 440a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM256 96h128c13.3 0 24 10.7 24 24s-10.7 24-24 24H256c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarCartPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartPlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h45.5c26.9 0 50 19.1 55 45.5l37 194.5h297.7c10.9 0 20.4-7.3 23.2-17.8l46.4-172.4c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4l-46.4 172.4c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zm128 440a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM344 48v40h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40h-40c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V48c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarCartShoppingFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartShoppingFast",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 24C64 10.7 74.7 0 88 0h45.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H234.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H263.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H88c-13.3 0-24-10.7-24-24zm161.6 216h297.6c10.9 0 20.4-7.3 23.2-17.8L584.7 80H195.1l30.5 160zM192 464a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM24 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarCartShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartShopping",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5h288.5c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zm107.1 80h389.6l-38.3 142.2c-2.8 10.5-12.3 17.8-23.2 17.8H161.6L131.1 80zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarCartXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCartXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5h288.5c32.6 0 61.1-21.8 69.5-53.3l46.5-172.5c3.4-12.8-4.1-26-16.9-29.4s-26 4.1-29.4 16.9l-46.5 172.5c-2.8 10.5-12.3 17.8-23.2 17.8H161.6l-37-194.5C119.5 19.1 96.4 0 69.5 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM257.8 65.8c-9.4 9.4-9.4 24.6 0 33.9l28.3 28.3-28.3 28.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l28.3-28.3 28.3 28.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L353.9 128l28.3-28.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L320 94.1l-28.3-28.3c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarCashRegister = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCashRegister",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C46.3 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32h80v32H87.5c-31.8 0-58.9 23.4-63.4 54.9L.6 379.5c-.4 3-.6 6-.6 9V448c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-59.5c0-3-.2-6.1-.6-9l-23.6-164.6c-4.5-31.5-31.5-54.9-63.4-54.9H208v-32h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zm32 48h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM48 448v-16h416v16c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zm392.3-226.3L463.5 384h-415l23.2-162.3c1.1-7.9 7.9-13.7 15.8-13.7h337c8 0 14.7 5.9 15.8 13.7zM112 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"
        }
    ]
};

const FarCassetteBetamax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCassetteBetamax",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416V160h480v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm304 224h80v80h-80v-80zm-48-16v112c0 17.7 14.3 32 32 32h112c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm-136 0a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160a104 104 0 1 0 0-208 104 104 0 1 0 0 208zm0-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarCassetteTape = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCassetteTape",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16h-40l-25.6-61.5c-8.7-20.9-29.1-34.5-51.7-34.5H181.3c-22.6 0-43 13.6-51.7 34.5L104 432H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h448zm-92 352H156l17.9-43.1c1.2-3 4.2-4.9 7.4-4.9h213.4c3.2 0 6.1 1.9 7.4 4.9L420 432zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm112 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16c0-5.5-.7-10.9-2-16h100c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16H238c1.3-5.1 2-10.5 2-16zm224 0c0-35.3-28.7-64-64-64H176c-35.3 0-64 28.7-64 64s28.7 64 64 64h224c35.3 0 64-28.7 64-64zm-80 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarCassetteVhs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCassetteVhs",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416V160h480v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm288 304H224v-80h128v80zm-208-40c0-19.4 13.7-35.5 32-39.2v78.4c-18.3-3.7-32-19.8-32-39.2zm288 0c0 19.4-13.7 35.5-32 39.2v-78.4c18.3 3.7 32 19.8 32 39.2zm-336 0c0 48.6 39.4 88 88 88h208c48.6 0 88-39.4 88-88s-39.4-88-88-88H184c-48.6 0-88 39.4-88 88z"
        }
    ]
};

const FarCastle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCastle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v200H48v-40c0-13.3-10.7-24-24-24S0 170.7 0 184v256c0 39.8 32.2 72 72 72h496c39.8 0 72-32.2 72-72V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-80V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-64V24zm0 88h288v112H176V112zM48 272h544v168c0 13.3-10.7 24-24 24H384v-80c0-35.3-28.7-64-64-64s-64 28.7-64 64v80H72c-13.3 0-24-10.7-24-24V272z"
        }
    ]
};

const FarCatSpace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCatSpace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 304c70.7 0 128-57.3 128-128 0-32.5-12.1-62.1-32-84.7V176c0 53-43 96-96 96s-96-43-96-96V91.3c-19.9 22.6-32 52.2-32 84.7 0 70.7 57.3 128 128 128zM397.8 66.4l29.4 39.2c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l29.4-39.2C510.9 54.7 488.2 48 464 48s-46.9 6.7-66.2 18.4zM464 352v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-98.9c-10.4 1.9-21.1 2.9-32 2.9zm176-176c0 68.4-39 127.7-96 156.8V448c0 35.3-28.7 64-64 64s-64-28.7-64-64v-54l-80 47v23h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-48.6 0-88-39.4-88-88V184.5c0-20.2-15-37.2-35-39.7l-7.9-1c-13.2-1.6-22.5-13.6-20.8-26.8S45.8 94.5 59 96.2l7.9 1c44 5.5 77.1 42.9 77.1 87.3V279c34.5-46.4 85.2-80.1 144.3-92.7-.2-3.4-.3-6.9-.3-10.3C288 78.8 366.8 0 464 0s176 78.8 176 176zM144 423.9v.1c0 22.1 17.9 40 40 40h104v-64c0-17.7-14.3-32-32-32h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c39.4 0 72.2 28.5 78.8 66l73.3-43.1c-51.7-17.3-92.7-58-110.5-109.5C209 252.6 144 331.2 144 423.9zm87.5-411.6 10.7 28.8c.8 2.2 2.5 3.9 4.7 4.7l28.8 10.7c7 2.6 7 12.4 0 15l-28.8 10.7c-2.2.8-3.9 2.5-4.7 4.7l-10.7 28.8c-2.6 7-12.4 7-15 0l-10.7-28.8c-.8-2.2-2.5-3.9-4.7-4.7l-28.8-10.7c-7-2.6-7-12.4 0-15l28.8-10.7c2.2-.8 3.9-2.5 4.7-4.7l10.7-28.8c2.6-7 12.4-7 15 0zM432 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarCat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361 0c10.9 0 21.3 4.3 29 12l36 36h44.1l36-36c7.7-7.7 18.1-12 29-12 22.6 0 41 18.3 41 41v119c0 70.7-57.3 128-128 128s-128-57.3-128-128V41c0-22.6 18.3-41 41-41zm7 160c0 44.2 35.8 80 80 80s80-35.8 80-80V57.9l-26.3 26.4C494.2 91.8 484 96 473.4 96h-50.8c-10.6 0-20.8-4.2-28.3-11.7L368 57.9V160zm48-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-179 38 4.4-.4c2.2 16.6 7 32.4 13.9 46.9l-14 1.3C188.9 238.9 112 323.1 112 423.9v.1c0 22.1 17.9 40 40 40h104v-64c0-17.7-14.3-32-32-32h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c39.4 0 72.2 28.5 78.8 66l93-54.7c7.4-4.4 16.6-4.4 24.1-.1S432 343.4 432 352v96c0 8.8 7.2 16 16 16s16-7.2 16-16V319.2c16.9-1.7 33.1-6 48-12.5V448c0 35.3-28.7 64-64 64s-64-28.7-64-64v-54l-80 47v23h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-48.6 0-88-39.4-88-88V184.5c0-20.2-15-37.2-35-39.7l-7.9-1C7.9 142.2-1.5 130.2.2 117S13.8 94.5 27 96.2l7.9 1c44 5.5 77.1 42.9 77.1 87.3V279c40-53.7 101.7-90.5 173-97z"
        }
    ]
};

const FarCauldron = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCauldron",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM74.2 252.5c9.6-17.7 20.1-33.2 28.6-44.5h242.4c8.5 11.4 19 26.9 28.6 44.5 15.9 29.2 26.2 58.5 26.2 81.9 0 39.2-18.3 70-49.4 92.5-32.3 23.3-78 37.1-126.6 37.1s-94.3-13.8-126.6-37.1C66.3 404.4 48 373.6 48 334.4c0-23.3 10.3-52.6 26.2-81.9zM44.6 208C22.5 243.4 0 290.8 0 334.4c0 37.4 11.9 69.4 32 95.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-15c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39v15c0 13.3 10.7 24 24 24s24-10.7 24-24v-58.1c20.1-26.1 32-58.1 32-95.5 0-43.6-22.5-91-44.6-126.4H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h20.6z"
        }
    ]
};

const FarCediSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCediSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 0c13.3 0 24 10.7 24 24v48.5c37.9 2.5 73 15.5 101.9 35.9 10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7c-20.9-14.8-46.3-24.5-74.1-27v270.8c27.8-2.5 53.2-12.2 74.1-27 10.8-7.7 25.8-5.1 33.5 5.7s5.1 25.8-5.7 33.5C313 424 277.9 437 240 439.5V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-50.8C102 422 32 347.7 32 256S102 90 192 74.8V24c0-13.3 10.7-24 24-24zM80 256c0 63.2 47 117.9 112 132.3V123.7C127 138.1 80 192.8 80 256z"
        }
    ]
};

const FarCentSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCentSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 0c13.3 0 24 10.7 24 24v48.5c37.9 2.5 73 15.5 101.9 35.9 10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7C289.7 130.3 259.2 120 226 120c-82 0-146 62.2-146 136s64 136 146 136c33.3 0 63.7-10.3 88.2-27.6 10.8-7.7 25.8-5.1 33.5 5.7s5.1 25.8-5.7 33.5c-29 20.4-64.1 33.4-102 35.9V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-50.8C102 422 32 347.7 32 256S102 90 192 74.8V24c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarCertificate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCertificate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M178.7 122.2c11.2-6.5 19.3-17.2 22.5-29.8l5.3-20.9 15 15.5c9 9.3 21.4 14.5 34.4 14.5s25.4-5.2 34.4-14.5l15-15.5 5.3 20.9c3.2 12.6 11.3 23.3 22.5 29.8s24.6 8.1 37 4.6l20.8-5.9-5.9 20.8c-3.5 12.5-1.9 25.8 4.6 37s17.2 19.3 29.8 22.5l20.9 5.3-15.5 15c-9.3 9-14.5 21.4-14.5 34.4s5.2 25.4 14.5 34.4l15.5 15-20.9 5.3c-12.6 3.2-23.3 11.3-29.8 22.5s-8.1 24.6-4.6 37l5.9 20.8-20.8-5.9c-12.5-3.5-25.8-1.9-37 4.6s-19.3 17.2-22.5 29.8l-5.3 20.9-15-15.5c-9-9.3-21.4-14.5-34.4-14.5s-25.4 5.2-34.4 14.5l-15 15.5-5.3-20.9c-3.2-12.6-11.3-23.3-22.5-29.8s-24.6-8.1-37-4.6l-20.8 5.9 5.9-20.8c3.5-12.5 1.9-25.8-4.6-37s-17.2-19.3-29.8-22.5l-20.9-5.3 15.5-15c9.3-9 14.5-21.4 14.5-34.4s-5.2-25.4-14.5-34.4l-15.5-15 20.9-5.3c12.6-3.2 23.3-11.3 29.8-22.5s8.1-24.6 4.6-37l-5.9-20.8 20.8 5.9c12.5 3.5 25.8 1.9 37.1-4.6zm43.8-103.1L211 7.3C205 1 196-1.4 187.6.8s-14.9 8.9-17.1 17.3l-4 15.9-11.8 46.6-46.2-13.1-15.8-4.4c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l4.5 15.8 13.1 46.2-46.6 11.8-15.9 4c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l11.8 11.5L53.5 256l-34.4 33.5L7.3 301c-6.3 6-8.7 15-6.5 23.4s8.9 14.9 17.3 17.1l15.9 4 46.5 11.8-13 46.2-4.5 15.8c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l15.8-4.5 46.2-13.1 11.8 46.5 4 15.9c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l11.6-11.6 33.5-34.5 33.5 34.5 11.5 11.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l4-15.9 11.8-46.5 46.2 13.1 15.8 4.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-4.5-15.8-13.1-46.2 46.5-11.8 15.9-4c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4L493 289.5 458.5 256l34.5-33.5 11.7-11.5c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-15.9-4-46.5-11.8 13.1-46.2 4.5-15.8c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-15.8 4.5-46.3 13-11.8-46.5-4-15.9c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3l-11.5 11.8L256 53.5l-33.5-34.4z"
        }
    ]
};

const FarChairOffice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChairOffice",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48c8.8 0 16 7.2 16 16v160h48V64c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64v160h48V64c0-8.8 7.2-16 16-16h128zM64 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64zm368 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64zM248 400h122.5c25.2 0 45.5-20.4 45.5-45.5 0-5.5-1-10.9-2.9-16l-19.2-51.3c-7-18.7-24.9-31.1-44.9-31.1H99.1c-20 0-37.9 12.4-44.9 31.1l-19.3 51.3c-1.9 5.1-2.9 10.5-2.9 16 0 25.1 20.4 45.5 45.5 45.5H200v64h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-64zM99.1 304h249.8l18 48H81.1l18-48z"
        }
    ]
};

const FarChair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 48h-48v176h-48V58.7c-23.9 13.8-40 39.7-40 69.3v96H64v-96C64 57.3 121.3 0 192 0h64c70.7 0 128 57.3 128 128v96h-48v-96c0-29.6-16.1-55.5-40-69.3V224h-48V48zM67.1 304l-18 48h349.8l-18-48H67.1zm-45-16.9C29.1 268.4 47 256 67 256h313.9c20 0 37.9 12.4 44.9 31.1l19.2 51.3c1.9 5.1 2.9 10.5 2.9 16 0 20.4-13.5 37.7-32 43.5v90c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H80v88c0 13.3-10.7 24-24 24s-24-10.7-24-24v-90c-18.5-5.8-32-23.1-32-43.5 0-5.5 1-10.9 2.9-16l19.2-51.3z"
        }
    ]
};

const FarChalkboardUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChalkboardUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 48H224c-8.8 0-16 7.2-16 16v41.3c-14.8-6-31-9.3-48-9.3V64c0-35.3 28.7-64 64-64h352c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336.8c-8.3-18-19.8-34.2-33.7-48H368v-40c0-30.9 25.1-56 56-56h64c30.9 0 56 25.1 56 56v40h32c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zm-80 320v-40c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v40h80zM208 224a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zM50.7 464h218.6c-9.5-36.8-42.9-64-82.6-64h-53.4c-39.8 0-73.2 27.2-82.6 64zM0 485.3C0 411.7 59.7 352 133.3 352h53.3c73.7 0 133.4 59.7 133.4 133.3 0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3z"
        }
    ]
};

const FarChalkboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChalkboard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 88c0-4.4 3.6-8 8-8h400c4.4 0 8 3.6 8 8v312h48V88c0-30.9-25.1-56-56-56H88c-30.9 0-56 25.1-56 56v312h48V88zm144 320v24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24H416v-24c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56zm144 0v24h-96v-24c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z"
        }
    ]
};

const FarChampagneGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChampagneGlass",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0C68.1 0 58 8.7 56.3 20.5L29.7 201C19.1 272.5 67.8 337.3 136 349.8V464H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64V349.8c64.4-12.2 110.8-72.8 102.6-140.6l-22.8-188C262.4 9.1 252.1 0 240 0H80zm8.9 128 11.8-80h118l9.7 80H88.9zm-7.1 48h152.4l4.7 38.9c5.7 47.4-31.2 89.1-78.9 89.1-51.1 0-90.3-45.4-82.9-96l4.7-32z"
        }
    ]
};

const FarChampagneGlasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChampagneGlasses",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M159.2 12.6c5.7-10.5 18.1-15.2 29.3-11.1L320 49.3 451.5 1.5c11.2-4.1 23.7.7 29.3 11.1l81.6 151c32.4 60.1 10.6 133.3-45.6 167l35.8 98.4 55.2-20.1c12.5-4.5 26.2 1.9 30.8 14.3s-1.9 26.2-14.3 30.8l-77.8 28.3-77.8 28.3c-12.5 4.5-26.2-1.9-30.8-14.3s1.9-26.2 14.3-30.8l55.2-20.1-35.8-98.5c-61.2 9.4-121.7-29.6-136.3-92.5L320 188.6l-15.3 65.8c-14.6 62.9-75.1 101.9-136.3 92.5l-35.8 98.5 55.2 20.1c12.5 4.5 18.9 18.3 14.3 30.8s-18.3 18.9-30.8 14.3l-77.7-28.3L15.8 454c-12.5-4.6-18.9-18.3-14.3-30.8s18.3-18.9 30.8-14.3L87.4 429l35.8-98.4c-56.2-33.7-78.1-106.9-45.6-167l81.6-151zm32.4 41L156.8 118 277 161.7l16.5-71-101.9-37.1zm-71.8 132.8c-22.4 41.5-2.8 93.3 41.6 109.4 41.3 15 86.5-9.4 96.5-52.3l8.1-34.7-132.3-48.1-13.9 25.7zM448.4 53.6 346.5 90.7l16.5 71L483.2 118l-34.8-64.4zm71.7 132.7-13.9-25.7L374 208.8l8.1 34.7c10 42.9 55.2 67.3 96.5 52.3 44.3-16.1 64-67.9 41.6-109.4z"
        }
    ]
};

const FarChargingStation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChargingStation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 48c-8.8 0-16 7.2-16 16v400h192V64c0-8.8-7.2-16-16-16H96zM32 464V64C32 28.7 60.7 0 96 0h160c35.3 0 64 28.7 64 64v192h8c48.6 0 88 39.4 88 88v28c0 15.5 12.5 28 28 28s28-12.5 28-28V268.3c-32.5-10.2-56-40.5-56-76.3v-40c0-13.3 10.7-24 24-24h8V80c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32V80c0-8.8 7.2-16 16-16s16 7.2 16 16v48h8c13.3 0 24 10.7 24 24v40c0 35.8-23.5 66.1-56 76.3V372c0 42-34 76-76 76s-76-34-76-76v-28c0-22.1-17.9-40-40-40h-8v160h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8zm432-272c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h-64v16zm-241.1-74.1L199.6 176H240c6.7 0 12.8 4.2 15 10.6s.4 13.4-4.8 17.7l-96 80c-5.6 4.7-13.7 5-19.6.7s-8.2-12.1-5.5-18.9l23.3-58.1H112c-6.7 0-12.8-4.2-15-10.6s-.4-13.4 4.8-17.7l96-80c5.6-4.7 13.7-5 19.6-.7s8.2 12.1 5.5 18.9z"
        }
    ]
};

const FarChartArea = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartArea",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v352c0 39.8 32.2 72 72 72h416c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zm238.1 169.9c9 9 21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1l27.3-27.3 50.8 59.2V336H144v-92.1l80-80 62.1 62.1zM320 192l-33.9-33.9-39.4-39.4c-12.5-12.5-32.8-12.5-45.3 0L110.1 210c-9 9-14.1 21.2-14.1 33.9V352c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-94.2c0-11.5-4.1-22.5-11.6-31.2l-62-72.3c-12.1-14.2-33.7-15-46.9-1.8l-5.6 5.6L320 192z"
        }
    ]
};

const FarChartBar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartBar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32c13.3 0 24 10.7 24 24v352c0 13.3 10.7 24 24 24h416c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56c0-13.3 10.7-24 24-24zm104 104c0-13.3 10.7-24 24-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm24 72h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarChartBullet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartBullet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 32c13.3 0 24 10.7 24 24v8h176c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h192v-8c0-13.3 10.7-24 24-24zm-104 80v64h80v-64h-80zm128 0v64h176v-64H288zm-176 0H48v64h64v-64zm248 144c13.3 0 24 10.7 24 24v8h80c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-80v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h288v-8c0-13.3 10.7-24 24-24zm-136 80v64h112v-64H224zm160 0v64h80v-64h-80zm-208 0H48v64h128v-64z"
        }
    ]
};

const FarChartCandlestick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartCandlestick",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v352c0 39.8 32.2 72 72 72h416c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zm272-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32V48zm64 176v64c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c-17.7 0-32 14.3-32 32zm-224-96c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48z"
        }
    ]
};

const FarChartColumn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartColumn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32c13.3 0 24 10.7 24 24v352c0 13.3 10.7 24 24 24h416c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56c0-13.3 10.7-24 24-24zm144 192c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24zm120-72v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm72 40c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM480 88v240c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarChartGantt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartGantt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32c13.3 0 24 10.7 24 24v352c0 13.3 10.7 24 24 24h416c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56c0-13.3 10.7-24 24-24zm104 104c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm88 72h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarChartLineDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartLineDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v352c0 39.8 32.2 72 72 72h416c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zm272 240c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v54.1L321 127c-9.4-9.4-24.6-9.4-33.9 0l-79 79-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l79-79 94 94.1H344c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarChartLineUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartLineUpDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32c13.3 0 24 10.7 24 24v352c0 13.3 10.7 24 24 24h416c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56c0-13.3 10.7-24 24-24zm352 80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c6.4 0 12.5 2.5 17 7s7 10.6 7 17v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-22.1L305 273c-9.4 9.4-24.6 9.4-33.9 0l-63-63-63 63c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l63 63 110-110.1H376zm0 272c-13.3 0-24-10.7-24-24s10.7-24 24-24h22.1l-47-47 33.9-34 47 47v-22.1c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 6.4-2.5 12.5-7 17s-10.6 7-17 7h-80z"
        }
    ]
};

const FarChartLineUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartLineUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v352c0 39.8 32.2 72 72 72h416c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zm272 96c0 13.3 10.7 24 24 24h54.1L304 270.1l-79-79c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63 79 79c9.4 9.4 24.6 9.4 33.9 0l111-111v54c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarChartLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartLine",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v352c0 39.8 32.2 72 72 72h416c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zm425 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-79-79c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l79-79 79 79c9.4 9.4 24.6 9.4 33.9 0L473 169z"
        }
    ]
};

const FarChartMixedUpCircleCurrency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartMixedUpCircleCurrency",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h52.5L320.2 168.2 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9l-168 112c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4.2L496 80.7V136c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H408zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V272c0-4.4 3.6-8 8-8s8 3.6 8 8v160zm-8-208c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8v-64c0-4.4 3.6-8 8-8s8 3.6 8 8v64zm-8-112c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48zm368 192a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0-50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l17.2-17.4c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l17.4 17.3c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z"
        }
    ]
};

const FarChartMixedUpCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartMixedUpCircleDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h52.5L320.2 168.2 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9l-168 112c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4.2L496 80.7V136c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H408zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V272c0-4.4 3.6-8 8-8s8 3.6 8 8v160zm-8-208c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8v-64c0-4.4 3.6-8 8-8s8 3.6 8 8v64zm-8-112c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48zm368 192a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-23.9-173v.1c0 .4 0 1.9 4.8 4.5 5.6 3 13.5 5.2 23.9 8.2h.2c9.3 2.6 21.1 6 30.5 11.5 10.2 6 20 16.1 20.5 32.3.5 18.2-9.7 30.4-21.7 36.9-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-11.4c-8.6-1.7-16.7-4.3-23.7-6.6-1.7-.6-3.4-1.1-5-1.6-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8 11.4 3.6 20.4 6.5 29.9 6.8 6.7.2 13.8-1.1 18.5-3.6 2.2-1.2 3.4-2.4 4-3.3.5-.8 1.1-2.1 1-4.5 0-1.4-.2-3-4.7-5.6-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3-9.9-5.3-20.6-14.7-21.6-30.7-1.2-18.8 10-30.9 21.8-37.2 5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3.9 12.3 2.3 17.9 3.7 8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1-6.2-.1-13.6 1.3-18.7 4-2.4 1.3-3.6 2.5-4.2 3.4-.4.7-.9 1.6-.8 3.6z"
        }
    ]
};

const FarChartMixed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartMixed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M503.6 74.2c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6L320.2 168.3 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9l-168 112c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4.2l168-144zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V272c0-4.4 3.6-8 8-8s8 3.6 8 8v160zm-8-208c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8v-64c0-4.4 3.6-8 8-8s8 3.6 8 8v64zm-8-112c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48zm264 16v96c0 4.4-3.6 8-8 8s-8-3.6-8-8v-96c0-4.4 3.6-8 8-8s8 3.6 8 8zm-56 0v96c0 26.5 21.5 48 48 48s48-21.5 48-48v-96c0-26.5-21.5-48-48-48s-48 21.5-48 48zm184 96c0 4.4-3.6 8-8 8s-8-3.6-8-8V272c0-4.4 3.6-8 8-8s8 3.6 8 8v160zm-8-208c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FarChartNetwork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartNetwork",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64c0 16.9-6.5 32.2-17.2 43.6l26.9 57.5c12.2-3.4 25-5.2 38.3-5.2 39 0 74.4 15.5 100.3 40.7l77.6-56.9c-1.3-5-1.9-10.3-1.9-15.7 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-12.3 0-23.9-3.5-33.7-9.6l-77.6 56.9c9.8 19.4 15.3 41.4 15.3 64.6 0 18.5-3.5 36.2-9.9 52.5l67.3 40.4c10.7-8.1 24.1-12.9 38.5-12.9 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64c0-3.4.3-6.7.8-9.9l-67.4-40.4C419 428.5 379.8 448 336 448c-71.4 0-130.6-51.9-142-120h-70.7c-9.5 23.5-32.5 40-59.3 40-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40H194c6.6-39.1 28.9-72.9 60.2-94.5l-26.9-57.6c-1.1.1-2.2.1-3.3.1-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64zm48 336a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
        }
    ]
};

const FarChartPieSimpleCircleCurrency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartPieSimpleCircleCurrency",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 192c-46.8 0-89.3 18.2-120.8 48H272V16.6c0-9 7-16.6 16-16.6 113 0 206.5 83.7 221.8 192.5-4.6-.4-9.2-.5-13.8-.5zm-224 96h67.2c-7.6 14.9-13.2 31-16.3 48H224c-26.5 0-48-21.5-48-48V90.9C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192 34.5 0 66.9-9.1 94.9-25 6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512 107.5 512 0 404.6 0 272 0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V288h48zm80 80a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1-50.7-50.7zm60.7 83.4 17.3 17.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.3 17.4c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17.4-17.3c21.6 13.2 49.1 13.2 70.7 0z"
        }
    ]
};

const FarChartPieSimpleCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartPieSimpleCircleDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 192c-46.8 0-89.3 18.2-120.8 48H272V16.6c0-9 7-16.6 16-16.6 113 0 206.5 83.7 221.8 192.5-4.6-.4-9.2-.5-13.8-.5zm-224 96h67.2c-7.6 14.9-13.2 31-16.3 48H224c-26.5 0-48-21.5-48-48V90.9C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192 34.5 0 66.9-9.1 94.9-25 6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512 107.5 512 0 404.6 0 272 0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V288h48zm80 80a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1 8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.6c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6z"
        }
    ]
};

const FarChartPieSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartPieSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M495.4 240c9 0 16.6-7 16.6-16C512 100.3 411.7 0 288 0c-9 0-16 7.6-16 16.6V240h223.4zM176 288c0 26.5 21.5 48 48 48h197.1c-26.4 74.6-97.5 128-181.1 128-106 0-192-86-192-192 0-83.6 53.4-154.7 128-181.1V288zm48-221.3c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272c0 132.6 107.5 240 240 240 115.5 0 211.9-81.5 234.8-190.2 3.8-18.1-11-33.8-29.5-33.8H224V66.7z"
        }
    ]
};

const FarChartPie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartPie",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M493.1 192H352V50.9C423.5 64 480 120.5 493.1 192zM352 240h175.4c9 0 16.6-7 16.6-16C544 100.3 443.7 0 320 0c-9 0-16 7.6-16 16.6V240h48zm-129.9 81.9 126.3 126.3C325 458.4 299.2 464 272 464c-106 0-192-86-192-192 0-83.6 53.4-154.7 128-181.1V288c0 12.7 5.1 24.9 14.1 33.9zM239 34.3C122.1 50.3 32 150.7 32 272c0 132.5 107.5 240 240 240 51.8 0 99.8-16.4 139-44.3 7.7-5.5 8.2-16.5 1.5-23.1L256 288V49.6c0-9.2-7.8-16.6-17-15.4zM558.4 288H320l158.7 158.7c5.8 5.8 15.2 6.3 21.2.7 39.3-36.7 66.2-86.5 73.9-142.3 1.3-9.2-6.1-17-15.4-17z"
        }
    ]
};

const FarChartPyramid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartPyramid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 95.8 199.9 192h112.2L256 95.8zM125.2 320h261.6l-46.7-80H171.9l-46.7 80zm-28 48-37.3 64h392.3l-37.3-64H97.2zM214.5 71.6c18.5-31.8 64.4-31.8 82.9 0l196.2 336.2c18.7 32-4.4 72.2-41.5 72.2H59.9c-37 0-60.1-40.2-41.5-72.2L214.5 71.6z"
        }
    ]
};

const FarChartRadar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartRadar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 220a71.814 71.814 0 0 0 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36h176.5a72.1 72.1 0 0 0 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.7a72.1 72.1 0 0 0-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24l88.2-152.9c4.3-7.4 12.2-12 20.8-12h176.6c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24l-88.3 152.9c-4.3 7.4-12.2 12-20.8 12H167.7c-8.6 0-16.5-4.6-20.8-12L58.6 268zm231.5-87.2c3.7-6.1 5.8-13.2 5.8-20.8 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 3.9.6 7.7 1.6 11.2L160 248c-22.1 0-40 17.9-40 40s17.9 40 40 40c10.2 0 19.6-3.9 26.7-10.2l97.2 19.4c6.4 13.5 20.2 22.7 36.1 22.7 22.1 0 40-17.9 40-40 0-18.5-12.6-34.1-29.6-38.6l-40.2-100.5zM202 271.9l47.5-63.4 31.7 79.2-79.2-15.8z"
        }
    ]
};

const FarChartScatter3d = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartScatter3d",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm248-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v220.8L40.6 437.6c-10.1 8.5-11.5 23.7-2.9 33.8s23.7 11.5 33.8 2.9l184.5-155 184.6 155c10.2 8.5 25.3 7.2 33.8-2.9s7.2-25.3-2.9-33.8L280 276.8V56zm104 40a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-320-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarChartScatterBubble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartScatterBubble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32c13.3 0 24 10.7 24 24v352c0 13.3 10.7 24 24 24h416c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56c0-13.3 10.7-24 24-24zm152 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm200 32a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-48-160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm168 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarChartScatter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartScatter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v352c0 39.8 32.2 72 72 72h416c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zm144 136a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarChartSimpleHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartSimpleHorizontal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 240H48v32h352v-32zm48 32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v32zM208 400H48v32h160v-32zm48 32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v32zm80-320V80H48v32h288zm0 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48z"
        }
    ]
};

const FarChartSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 80v352h-32V80h32zm-32-48c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-32zM80 272v160H48V272h32zm-32-48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm320-80h32v288h-32V144zm-48 0v288c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarChartTreeMap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartTreeMap",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 80v112H48V80h128zM48 32C21.5 32 0 53.5 0 80v112c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm128 288v112H48V320h128zM48 272c-26.5 0-48 21.5-48 48v112c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H48zM304 80h160v32H304V80zm-48 0v32c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zm208 160v32H304v-32h160zm-160-48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H304zm0 208h160v32H304v-32zm-48 0v32c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarChartUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 48H224c-8.8 0-16 7.2-16 16v41.3c-14.8-6-31-9.3-48-9.3V64c0-35.3 28.7-64 64-64h352c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336.8c-8.3-18-19.8-34.2-33.7-48H576c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zm-163.3 91.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h88c8.8 0 16 7.2 16 16v88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27zM160 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-26.7 272c-39.8 0-73.2 27.2-82.6 64h218.6c-9.5-36.8-42.9-64-82.6-64h-53.4zm0-48h53.3c73.7 0 133.4 59.7 133.4 133.3 0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3 0 411.7 59.7 352 133.3 352z"
        }
    ]
};

const FarChartWaterfall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChartWaterfall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32c13.3 0 24 10.7 24 24v352c0 13.3 10.7 24 24 24h416c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56c0-13.3 10.7-24 24-24zm144 192c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24zm120-72v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm72-88c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm120 24v240c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarCheckDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCheckDouble",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M337 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143L97 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0L337 81zm104 120c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-247 247L41 295c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L143 465c9.4 9.4 24.6 9.4 33.9 0L441 201z"
        }
    ]
};

const FarCheckToSlot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCheckToSlot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80v280h288V80H144zM96 360V80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v280c13.3 0 24 10.7 24 24s-10.7 24-24 24H96c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-32-72v48H48v96h480v-96h-16v-48h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48h16zm321-108.4L278.3 286.3c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7L191 233c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36.4 36.4 89.7-89.8c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"
        }
    ]
};

const FarCheeseSwiss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCheeseSwiss",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256v-15.8C464 151.7 392.3 80 303.8 80c-.8 0-1.6.2-2.3.7l-35 23.3c12.9 8.6 21.5 23.3 21.5 40 0 26.5-21.5 48-48 48-23.4 0-42.9-16.7-47.1-38.9L53.3 246.2c-3.3 2.2-5.3 5.9-5.3 9.8h274.7c6.6-18.6 24.4-32 45.3-32s38.7 13.4 45.3 32H464zM48 304v112c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V304h-60.2c-8.8 9.8-21.6 16-35.8 16s-27-6.2-35.8-16H48zm464-63.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7 115 0 208.2 93.2 208.2 208.2zM176 320a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarCheese = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCheese",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 240.2V256H48c0-3.9 2-7.6 5.3-9.8L301.5 80.7c.7-.4 1.5-.7 2.3-.7C392.3 80 464 151.7 464 240.2zM48 304h416v112c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V304zm464-48v-15.8C512 125.2 418.8 32 303.8 32c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256v160c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V256z"
        }
    ]
};

const FarCherries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCherries",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m288 24 14.1-19.5c-6.9-5-15.9-5.9-23.7-2.5s-13.2 10.7-14.2 19.1v.2l-.1.9c-.1.9-.3 2.2-.6 4-.6 3.6-1.5 9-2.9 15.8-2.8 13.7-7.6 33.3-15.3 56.3-14 42-37.4 94.7-75.8 143.7-17.2-8.5-43-18-73.5-18 0 0-96 0-96 112 0 144 144 176 192 176s192-16 192-176c0-112-96-112-96-112-20.5 0-38.9 4.3-54 9.7 27.1-42.6 45-85.1 56.7-120.2 5.7-17 9.9-32.3 13-45.1 11.7 10.8 25.8 24.7 40.1 41.2 29.6 34.3 59.1 78.4 73.1 128.5-12-5.3-27-10.3-44.2-12.7 16.3 14.8 30.1 35.3 37.4 63 1.8 1 3.3 2 4.6 2.8 1.5 1 2.6 1.8 3.2 2.2l.4.3c17.4 13.7 41.9 13.7 59.3 0l.4-.3c.6-.4 1.6-1.2 3.2-2.2 3.1-2 8-4.9 14.2-7.8 12.6-5.9 29.3-11.3 48-11.4h.7c1.1.1 3.1.3 5.7.8 5.3 1 11.9 3 18 6.6 9.1 5.3 24.2 17.4 24.2 56.5 0 62-26.1 90.5-53.8 106.3-31.5 18-69.7 21.7-90.2 21.7-12.3 0-36.6-3.4-61.7-13.4-9.2 14.8-20.2 27.5-32.3 38.2 36.4 17.6 73.7 23.3 94 23.3 48 0 192-16 192-176 0-112-96-112-96-112-32.3 0-59.2 10.6-76.3 19.6-14.2-67.6-52.5-124.7-87.5-165.3-19.9-23-39.2-41.3-53.6-53.9-7.2-6.3-13.2-11.2-17.5-14.5-2.1-1.7-3.8-3-5-3.9-.6-.4-1.1-.8-1.4-1l-.4-.3-.1-.1L288.1 24zM162.4 293.8c17.4 13.7 41.9 13.7 59.3 0l.4-.3c.6-.4 1.6-1.2 3.2-2.2 3.1-2 8-4.9 14.2-7.8 12.6-5.9 29.3-11.3 48-11.4h.7c1.1.1 3.1.3 5.7.8 5.3 1 11.9 3 18 6.6 9.1 5.3 24.2 17.4 24.2 56.5 0 62-26.1 90.5-53.8 106.3-31.5 18-69.7 21.7-90.2 21.7-16.7 0-55.6-6.3-88.7-26.8C72.7 418.3 48 388.4 48 336c0-39.1 15.1-51.2 24.2-56.5 6.1-3.6 12.7-5.6 18-6.6 2.6-.5 4.6-.7 5.7-.8.3 0 .6 0 .7-.1 18.7.1 35.4 5.5 48 11.4 6.2 2.9 11.1 5.8 14.2 7.8 1.5 1 2.6 1.8 3.2 2.2l.4.3z"
        }
    ]
};

const FarChessBishopPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessBishopPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24 0 12.2-9.2 22.3-21 23.8 6.2 6.4 13.2 14.4 20.2 23.8C210.8 129.8 232 168.8 232 216c0 20-5.9 35.9-13.9 48.2 3.7 4.2 5.9 9.7 5.9 15.8 0 11.3-7.8 20.8-18.3 23.3l4.9 48.7h-48.3l-4.8-48h-59l-4.8 48H45.5l4.9-48.7C39.8 300.8 32 291.3 32 280c0-6 2.2-11.6 5.9-15.8C29.9 251.9 24 236 24 216c0-47.2 21.2-86.2 40.8-112.4 7-9.4 14.1-17.4 20.2-23.8C73.2 78.3 64 68.2 64 56zm93.3 200 7.5-5.1c9.6-6.5 19.2-16.9 19.2-34.9 0-13.8-2.6-26.9-6.9-39.2L161 193c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l26.1-26.1c-.1-.2-.2-.3-.4-.5-8.1-10.8-16.2-19.3-22.2-25.1-.9-.9-1.8-1.7-2.6-2.5-.8.8-1.7 1.6-2.6 2.5-6 5.8-14.1 14.4-22.2 25.1C86.8 154.2 72 183.2 72 216c0 18.1 9.6 28.5 19.2 34.9l7.5 5.1h58.7zM69.2 432l-16.5 32h150.6l-16.6-32H69.2zm-9.7-48h137c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7 0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2c5.4-10.6 16.4-17.3 28.4-17.3z"
        }
    ]
};

const FarChessBishop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessBishop",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8V352h48v-27c0-9-5-17.2-13-21.3-18-9.3-35-24.7-35-52.7 0-55.5 29.8-106.8 62.4-145.9 16-19.2 32.1-34.8 44.2-45.5 1.9-1.7 3.7-3.2 5.3-4.6 1.7 1.4 3.4 3 5.3 4.6 12.1 10.7 28.2 26.3 44.2 45.5 5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8 0 28-17 43.4-35 52.7-8 4.1-13 12.3-13 21.3v27h48v-13.2c23.4-15.6 48-42.9 48-87.8 0-72.1-38.2-134.2-73.6-176.7-8.3-9.9-16.6-19-24.4-27 10.3-2.7 18-12.1 18-23.2 0-13.3-10.7-24-24-24H104zM52.7 464l16.6-32h181.5l16.6 32H52.7zm207.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512h238.4c22.5 0 40.8-18.2 40.8-40.8 0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"
        }
    ]
};

const FarChessBoard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessBoard",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 0v64h64V96h64v64h64V96h64v64h-64v64h64v64h-64v64h64v64h-64v-64h-64v64h-64v-64h-64v64H64v-64h64v-64H64v-64h64v-64H64V96h64zm64 128h64v-64h-64v64zm0 64v-64h-64v64h64zm64 0h-64v64h64v-64zm0 0h64v-64h-64v64z"
        }
    ]
};

const FarChessClockFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessClockFlip",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 56c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v32h88c35.3 0 64 28.7 64 64v240c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64h32V96c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v16h184V80h-32c-13.3 0-24-10.7-24-24zM64 160c-8.8 0-16 7.2-16 16v240c0 8.8 7.2 16 16 16h512c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H64zm376 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm16 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48zm-329.5-17.5a104 104 0 1 1 147 147 104 104 0 1 1-147-147zM251 245.1c-6.2-6.2-16.4-6.2-22.6 0L194.3 279c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FarChessClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 56c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v32H64c-35.3 0-64 28.7-64 64v240c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V176c0-35.3-28.7-64-64-64h-32V96c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16v16H200V80h32c13.3 0 24-10.7 24-24zm320 104c8.8 0 16 7.2 16 16v240c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h512zM200 400a104 104 0 1 0 0-208 104 104 0 1 0 0 208zm-16-160c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48zm329.5 129.5a104 104 0 1 0-147-147 104 104 0 1 0 147 147zm-22.6-124.4c6.2 6.2 6.2 16.4 0 22.6l-33.9 34c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarChessKingPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessKingPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H66.9C43.2 96 24 115.2 24 138.9c0 4.7.8 9.4 2.3 13.8l19.6 57.5C37.7 214.1 32 222.4 32 232c0 11.6 8.2 21.3 19.2 23.5L49.1 352h48l2.1-96h57.6l2.1 96h48l-2.1-96.5c10.9-2.2 19.2-11.9 19.2-23.5 0-9.6-5.7-17.9-13.9-21.8l19.6-57.5c1.5-4.5 2.3-9.1 2.3-13.8 0-23.7-19.2-42.9-42.9-42.9H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V16zm16.2 192H95.8L74 144h108l-21.8 64zm-91 224h117.6l16.6 32H52.7l16.6-32zm-9.7-48c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512h174.4c22.5 0 40.8-18.2 40.8-40.8 0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3h-137z"
        }
    ]
};

const FarChessKing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessKing",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v32h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v40H59.6C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352h52.3L49 208.2c-.6-1.5-1-3-1-4.6 0-6.4 5.2-11.6 11.6-11.6h328.8c6.4 0 11.6 5.2 11.6 11.6 0 1.6-.3 3.2-1 4.6L336.5 352h52.3L443 227.4c3.3-7.5 4.9-15.6 4.9-23.8 0-32.9-26.7-59.6-59.6-59.6H248v-40h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V24zM101.2 432h245.6l16.6 32H84.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3h-265c-12 0-22.9 6.7-28.4 17.3l-26.5 51.2c-3 5.8-4.6 12.2-4.6 18.7 0 22.6 18.2 40.8 40.8 40.8h302.4c22.5 0 40.8-18.2 40.8-40.8 0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
        }
    ]
};

const FarChessKnightPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessKnightPiece",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M68.9 112h79.8c68.1 0 123.3 55.2 123.3 123.3 0 11.3-1.6 22.5-4.6 33.4L243.9 352h49.9l19.8-70.3c4.3-15.1 6.4-30.7 6.4-46.4C320 140.7 243.3 64 148.7 64H40.8C18.5 64 .4 82.1.4 104.5c0 11.6 5 22.5 13.3 30C5 148.3.3 164.4.3 181l-.2 51C0 253.2 8 273.7 22.4 289.2l1.9 2c6.5 7 14 12.6 22 16.8-8.3 13-13.1 28.2-13.8 43.9h48c1.1-11.5 7-22 16.2-29l25.1-15.4c2.7-1.4 5.3-3 7.8-4.8l42.9-26.3c11.3-6.9 14.8-21.7 7.9-33s-21.7-14.8-33-7.9l-42.7 26.2-.1-.2-1.5 1.2-4.9 3c-12.8 6.4-28.7 3.8-38.8-7.1l-1.9-2c-6.2-6.6-9.6-15.4-9.5-24.4l.2-51c0-10.6 4.2-20.7 11.7-28.1l8-8c5.5-5.5 8-13.2 6.7-20.8-.7-4.6-2.8-8.8-5.8-12.2zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM52.7 464l16.6-32h181.5l16.6 32H52.7zm207.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512h238.4c22.5 0 40.8-18.2 40.8-40.8 0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"
        }
    ]
};

const FarChessKnight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessKnight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M226.6 48H117.3l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1H66.8c5.3-22.1 17.8-41.9 35.9-56.3-1.3-.8-2.6-1.7-3.8-2.6l-1.9-1.3c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3 64 20.3 84.3 0 109.3 0h117.3C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2l-23 129.4h-48.8l24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432l-16.5 32h310.6l-16.6-32H85.2zm315.7-30.7 26.5 51.2c3 5.8 4.6 12.2 4.6 18.7 0 22.5-18.2 40.8-40.8 40.8H56.8C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2c5.4-10.6 16.4-17.3 28.4-17.3h297c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"
        }
    ]
};

const FarChessPawnPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessPawnPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm73.4 144c12.6-.7 22.6-11.2 22.6-24 0-9.7-5.8-18.1-14.1-21.9 8.9-14.6 14.1-31.8 14.1-50.1 0-53-43-96-96-96s-96 43-96 96c0 18.4 5.2 35.5 14.1 50.1C37.8 245.9 32 254.3 32 264c0 12.8 10 23.3 22.6 24L51 352h48.1l3.6-64h50.6l3.6 64H205l-3.6-64zM52.7 464l16.6-32h117.5l16.6 32H52.7zm143.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512h174.4c22.5 0 40.8-18.2 40.8-40.8 0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"
        }
    ]
};

const FarChessPawn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessPawn",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 152a72 72 0 1 0-144 0 72 72 0 1 0 144 0zm24 120h-12.6l10.7 80h-48.4L195 272h-70l-10.7 80H65.9l10.7-80H64c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72 13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464h214.6l-16.6-32H69.2l-16.5 32zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7 0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2c5.4-10.6 16.4-17.3 28.4-17.3h201z"
        }
    ]
};

const FarChessQueenPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessQueenPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM16 232c0-13.3 10.7-24 24-24h5.1L3.6 140.6c-6.4-10.4-4-24 5.7-31.5l2.5-1.9c6.1-4.7 14.1-6.3 21.5-4.1 2.1.6 4.4 1 6.8 1 11.7 0 21.4-8.3 23.6-19.4 1.9-9.7 9.5-17.3 19.2-19s19.5 2.6 24.7 11C111.8 83.5 119.4 88 128 88s16.2-4.5 20.5-11.4c5.2-8.4 15-12.8 24.7-11s17.4 9.3 19.2 19c2.1 11 11.9 19.4 23.6 19.4 2.4 0 4.7-.3 6.8-1 7.4-2.2 15.4-.6 21.5 4.1l2.5 1.9c9.7 7.5 12.1 21.1 5.7 31.5L211 208h5c13.3 0 24 10.7 24 24s-10.7 24-24 24h-15.2l4.4 96h-48l-4.4-96h-49.5l-4.4 96h-48l4.4-96H40c-13.3 0-24-10.7-24-24zm138.6-24 37.1-60.2c-11.6-4.2-21.8-11.2-29.7-20.3-10.1 5.4-21.6 8.5-33.9 8.5s-23.8-3.1-33.9-8.5c-8 9.1-18.2 16.1-29.7 20.3l36.9 60.2h53.2zM52.7 464h150.6l-16.6-32H69.2l-16.5 32zm143.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7 0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2c5.4-10.6 16.4-17.3 28.4-17.3h137z"
        }
    ]
};

const FarChessQueen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessQueen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9-8 26.2-32.4 45.2-61.2 45.2-10 0-19.4-2.3-27.7-6.3-7.6-3.7-16.7-3.3-24 1.2-11.6 7.1-15.4 22.1-8.6 33.9L97.6 352H153L70 207.9c40.5-2.2 75.3-25.9 93.1-59.8 22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352h55.4l93.9-163.1c6.8-11.7 3-26.7-8.6-33.8-7.3-4.5-16.4-4.9-24-1.2-8.4 4-17.7 6.3-27.7 6.3-28.8 0-53.2-19-61.2-45.2-4.3-14.2-17.5-27-35.6-27-14.5 0-26.3 8.5-32.4 19.3-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zm-27.6 344h245.6l16.6 32H116.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3h-265c-12 0-22.9 6.7-28.4 17.3l-26.5 51.2c-3 5.8-4.6 12.2-4.6 18.7 0 22.5 18.2 40.8 40.8 40.8h302.4c22.5 0 40.8-18.2 40.8-40.8 0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
        }
    ]
};

const FarChessRookPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessRookPiece",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 120c0-13.3 10.7-24 24-24h240c13.3 0 24 10.7 24 24v104c0 5.6-2 11.1-5.6 15.4l-33.9 40.7 4.2 71.9h-48l-4.7-78.6c-.4-6.1 1.6-12.1 5.5-16.8l34.5-41.3V144h-40v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-48v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H64v71.3l34.4 41.3c3.9 4.7 5.9 10.7 5.5 16.8L99.3 352h-48l4.2-71.9-33.9-40.7C18 235.1 16 229.6 16 224V120zm120 160.9V248c0-13.3 10.7-24 24-24s24 10.7 24 24v32.9c0 3.9-3.2 7.1-7.1 7.1h-33.8c-3.9 0-7.1-3.2-7.1-7.1zM52.7 464h214.6l-16.6-32H69.2l-16.5 32zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7 0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2c5.4-10.6 16.4-17.3 28.4-17.3h201z"
        }
    ]
};

const FarChessRook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChessRook",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 80v112c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352H85.2l9.4-85-40.2-30.2C40.3 226.2 32 209.6 32 192V72c0-22.1 17.9-40 40-40h304c22.1 0 40 17.9 40 40v120c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85h-48.3l-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4V80h-64v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80h-64v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H80zm4.7 384h278.6l-16.6-32H101.2l-16.5 32zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7 0 22.5-18.2 40.8-40.8 40.8H72.8C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2c5.4-10.6 16.4-17.3 28.4-17.3h265zM208 288c-8.8 0-16-7.2-16-16v-48c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 8.8-7.2 16-16 16h-32z"
        }
    ]
};

const FarChess = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChess",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v32h45.1c23.7 0 42.9 19.2 42.9 42.9 0 4.7-.8 9.4-2.3 13.8l-19.6 57.5c8.2 3.8 13.9 12.1 13.9 21.8 0 11.6-8.2 21.3-19.2 23.5l2.1 96.5h-48l-2.1-96H99.2l-2.1 96h-48l2.1-96.5C40.2 253.3 32 243.6 32 232c0-9.6 5.7-17.9 13.9-21.8l-19.6-57.4c-1.5-4.5-2.3-9.1-2.3-13.8 0-23.8 19.2-43 42.9-43H112V64H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16zm54 144H74l21.8 64h64.4l21.8-64zM52.7 464h150.6l-16.6-32H69.2l-16.5 32zm143.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7 0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2c5.4-10.6 16.4-17.3 28.4-17.3h137zM280 160h208c13.3 0 24 10.7 24 24v72c0 5-1.6 9.9-4.5 13.9L472 319.7V352h-48v-40c0-5 1.6-9.9 4.5-13.9l35.5-49.8V208h-32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-32v40.3l35.5 49.7c2.9 4.1 4.5 8.9 4.5 13.9v40h-48v-32.2L260.5 270c-2.9-4.1-4.5-8.9-4.5-13.9V184c0-13.3 10.7-24 24-24zm195.6 236.3 31.4 56.6c3.3 5.9 5 12.6 5 19.3 0 22-17.8 39.8-39.8 39.8H295.8c-22 0-39.8-17.8-39.8-39.8 0-6.8 1.7-13.4 5-19.3l31.4-56.6c4.2-7.6 12.3-12.3 21-12.3h141.2c8.7 0 16.7 4.7 21 12.3zM327.5 432l-17.8 32h148.5l-17.8-32H327.5z"
        }
    ]
};

const FarChestnut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChestnut",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M154 90.5c13.9-11.4 27.8-22.7 41.1-34.8 7.6-6.9 12.7-12.3 15.5-16.6 3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6 13.3 12.1 27.2 23.4 41.1 34.8 19.6 16.1 39.3 32.1 57.3 50.2C400.8 190.2 448 258 448 352c0 70.7-57.3 128-128 128H128C57.3 480 0 422.7 0 352c0-94 47.2-161.8 96.7-211.3 18.1-18.1 37.7-34.1 57.3-50.2zM393.3 384H54.7c12.3 28.3 40.5 48 73.3 48h192c32.8 0 61-19.7 73.3-48zm-76-209.4c-13.6-13.6-28.6-26.3-45.2-39.9-2.7-2.2-5.5-4.5-8.2-6.8-12.8-10.5-26.6-21.7-39.9-33.6-13.3 11.9-27.1 23.1-39.9 33.6-2.8 2.3-5.6 4.5-8.2 6.8-16.6 13.6-31.6 26.3-45.2 39.9C88.9 216.4 53.4 268 48.6 336h350.8c-4.8-68-40.3-119.6-82.1-161.4z"
        }
    ]
};

const FarChevronDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChevronDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"
        }
    ]
};

const FarChevronLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChevronLeft",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"
        }
    ]
};

const FarChevronRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChevronRight",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"
        }
    ]
};

const FarChevronUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChevronUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"
        }
    ]
};

const FarChevronsDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChevronsDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M239 465c9.4 9.4 24.6 9.4 33.9 0L465 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 465zM47 81l192 192c9.4 9.4 24.6 9.4 33.9 0L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
        }
    ]
};

const FarChevronsLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChevronsLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47 239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
        }
    ]
};

const FarChevronsRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChevronsRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47l192 192c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FarChevronsUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChevronsUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M273 47c-9.4-9.4-24.6-9.4-33.9 0L47 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L431 273c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 47zm192 384L273 239c-9.4-9.4-24.6-9.4-33.9 0L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"
        }
    ]
};

const FarChfSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChfSign",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 115.3C0 69 38.2 32 83.9 32c30.9 0 59.6 17.4 73.6 45.3 5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7C108.9 87.4 96.9 80 83.9 80 64.1 80 48 96.1 48 115.3v281.4c0 19.2 16.1 35.3 35.9 35.3 13 0 25-7.4 30.6-18.7 5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2c-13.9 27.8-42.7 45.2-73.5 45.2C38.2 480 0 443 0 396.7V115.3zM216 32c13.3 0 24 10.7 24 24v168h128V56c0-13.3 10.7-24 24-24s24 10.7 24 24v400c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H240v184c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm232 24c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H496v144h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v184c0 13.3-10.7 24-24 24s-24-10.7-24-24V56z"
        }
    ]
};

const FarChildCombatant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChildCombatant",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-64 144c5.5 0 10.9.9 16 2.6V336h-32V210.6a50.6 50.6 0 0 1 16-2.6zm-16 280V384h32v104c0 13.3 10.7 24 24 24s24-10.7 24-24V264.8l27.7 44c7.1 11.2 21.9 14.6 33.1 7.5s14.6-21.9 7.5-33.1l-48.4-76.9C241.8 177.5 210.1 160 176 160s-65.8 17.5-83.9 46.3l-48.4 76.9c-7.1 11.2-3.7 26 7.5 33.1s26 3.7 33.1-7.5l27.7-44V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16v100.3c-9.6 5.5-16 15.9-16 27.7v32h-16c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h32v112c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-48v-26.7l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16h-32zm16 336h-32v-96h32v96z"
        }
    ]
};

const FarChildDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChildDress",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0zM71 201.8c21.3-25.7 52.7-40.9 86-41.8h6.2c33.3.9 64.6 16.1 86 41.8l65.4 78.8c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1l-43.1-52 36.3 109c2.4 7.3 1.2 15.4-3.3 21.6s-11.8 10-19.5 10H224v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V400h-32v88c0 13.3-10.7 24-24 24s-24-10.7-24-24v-88H72c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l36.3-109-43.1 52c-8.5 10.2-23.6 11.6-33.8 3.1s-11.5-23.6-3.1-33.8l65.4-78.8zm89 6.2h-1.4c-3.2.2-6.1 2.3-7.1 5.5L105.3 352h109.4l-46.2-138.5c-1-3.1-3.9-5.3-7.1-5.5H160z"
        }
    ]
};

const FarChildReaching = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChildReaching",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm-.2 32c-41.6 0-80-22.4-100.6-58.5L76.9 92.2c-6.5-11.5-21.2-15.6-32.7-9s-15.6 21.2-9 32.7l14.4 25.3c15 26.5 36.8 47.7 62.5 62.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h64v104c0 13.3 10.7 24 24 24s24-10.7 24-24V203c25-14 46.2-34.6 61.1-60.2l15.6-26.7c6.7-11.4 2.8-26.1-8.6-32.8s-26.1-2.8-32.8 8.6l-15.6 26.7c-20.8 35.6-58.9 57.4-100 57.4zM224 336h-64V220.9c10.4 2.1 21 3.1 31.8 3.1 10.9 0 21.7-1.1 32.2-3.2V336z"
        }
    ]
};

const FarChild = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChild",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-96a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm-32 214v122h64V214.4c-10.2-4.2-21.2-6.4-32.4-6.4-11 0-21.6 2.1-31.6 6zm0 170v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V257.9l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.6-22.6-6-33.5L50.1 217c25-35.7 65.9-57 109.5-57 43.2 0 83.7 20.8 108.8 56l47.1 66c7.7 10.8 5.2 25.8-5.6 33.5s-25.8 5.2-33.5-5.6l-36.4-51V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-64z"
        }
    ]
};

const FarChildren = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChildren",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 16c-34.6 0-67.3 16.2-88.2 43.8l-58.9 77.7c-8 10.6-5.9 25.6 4.6 33.6s25.6 5.9 33.6-4.6l45.3-59.8-39.2 117.7c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24v-88h32v88c0 13.3 10.7 24 24 24s24-10.7 24-24v-88h16c7.7 0 15-3.7 19.5-10s5.7-14.3 3.3-21.6l-39.3-117.7 45.3 59.8c8 10.6 23.1 12.6 33.6 4.6S315 292 307 281.5l-58.9-77.7C227.3 176.2 194.7 160 160 160zm-46.7 192L160 211.9 206.7 352h-93.4zM456 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm96 0a72 72 0 1 0-144 0 72 72 0 1 0 144 0zm-72 136c5.5 0 10.9.9 16 2.6V336h-32V210.6a50.6 50.6 0 0 1 16-2.6zm-16 280V384h32v104c0 13.3 10.7 24 24 24s24-10.7 24-24V264.8l27.7 44c7.1 11.2 21.9 14.6 33.1 7.5s14.6-21.9 7.5-33.1l-48.4-76.9C545.8 177.5 514.1 160 480 160s-65.8 17.5-83.9 46.3l-48.4 76.9c-7.1 11.2-3.7 26 7.5 33.1s26 3.7 33.1-7.5l27.7-44V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarChimney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChimney",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 176h352V80H48v96zM0 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32v240c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80h-80v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80H80v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V224c-17.7 0-32-14.3-32-32V64zm80 160v112h80V224H80zm128 0v112h160V224H208z"
        }
    ]
};

const FarChopsticks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChopsticks",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m144.9 332.9 188-278.2c3.5-4.3 8.4-6.7 13.6-6.7 9.2 0 18.1 8 18.1 19.5 0 4.6-1.4 8.7-3.8 11.9L144.9 332.9zM346.5 0c-21.4 0-40.3 10.4-52.2 26.1l-.4.5-.4.6L7.4 450.7c-12 16.4-9.2 39.8 6.8 52.8 16.6 13.5 40.5 10.5 53.5-5.9l330.2-387.7.4-.5.4-.5c8.7-11.5 13.9-25.9 13.9-41.4C412.6 31 383.7 0 346.5 0zm-37 356.7 251.6-240.5c3.2-2.6 7.3-4.2 11.9-4.2 10.4 0 18.9 8.4 18.9 18.9 0 5.5-2.4 10.5-6.2 14L309.5 356.7zM573 64c-16.6 0-31.8 6.1-43.5 16.1l-.5.4-.5.4-381 364.2c-15.5 13.8-17.1 37.6-3.5 53.5s37.3 17.9 53.4 4.7l418.1-320.9.5-.4.5-.4c14.3-12.2 23.3-30.4 23.3-50.8.1-36.9-29.9-66.8-66.8-66.8z"
        }
    ]
};

const FarChurch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarChurch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v24h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v26.9l-103.1 66.8c-20.5 13.3-32.9 36-32.9 60.4V464H72c-13.3 0-24-10.7-24-24v-69.9c0-8.1 4.1-15.7 11-20.2l69-44.7v-57.1l-95.1 61.6C12.4 322.9 0 345.7 0 370.1V440c0 39.8 32.2 72 72 72h496c39.8 0 72-32.2 72-72v-69.9c0-24.4-12.4-47.2-32.9-60.4L512 248.1v57.2l69 44.7c6.8 4.4 11 12 11 20.1V440c0 13.3-10.7 24-24 24h-88V250.1c0-24.4-12.4-47.2-32.9-60.4L344 122.9V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V24zm-24 140.6L421 230c6.8 4.4 11 12 11 20.1V464h-64v-96c0-26.5-21.5-48-48-48s-48 21.5-48 48v96h-64V250.1c0-8.1 4.1-15.7 11-20.1l101-65.4z"
        }
    ]
};

const FarCircle0 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle0",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96v64c0 53 43 96 96 96s96-43 96-96v-64c0-53-43-96-96-96zm-48 96c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 26.5-21.5 48-48 48s-48-21.5-48-48v-64z"
        }
    ]
};

const FarCircle1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm268-124.8c7.4 4.3 12 12.2 12 20.8v184h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H192c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V193.4l-20.1 11.5c-11.5 6.6-26.2 2.6-32.7-8.9s-2.6-26.2 8.9-32.7l56-32c7.4-4.2 16.6-4.2 24 .1z"
        }
    ]
};

const FarCircle2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-33.3-327.3c7.2-5.5 16.1-8.4 25.3-8.3l3.4.1c20.3.3 36.6 16.8 36.6 37.1 0 10.3-4.2 20.1-11.7 27.1L167.6 342.5c-7.2 6.7-9.5 17.2-5.9 26.3S174.2 384 184 384h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-83.3l64.4-60.4c17.2-16.1 26.9-38.6 26.9-62.1 0-46.5-37.3-84.4-83.8-85.1l-3.4-.1c-19.9-.3-39.3 6.1-55.1 18.1l-24.2 18.4c-10.5 8-12.6 23.1-4.5 33.6s23.1 12.6 33.6 4.5l24.2-18.4z"
        }
    ]
};

const FarCircle3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle3",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384c-13.3 0-24 10.7-24 24s10.7 24 24 24h66.3l-50.5 46.3c-7.3 6.7-9.7 17.2-6.1 26.5s12.6 15.3 22.5 15.2l51.5-.3c20.1-.1 36.4 16.1 36.4 36.2 0 20-16.2 36.2-36.2 36.2H240c-13.5 0-26-7-33-18.4l-2.6-4.2c-7-11.3-21.8-14.8-33-7.8s-14.8 21.8-7.8 33l2.6 4.2C182 368.4 209.9 384 240 384h27.8c46.5 0 84.2-37.7 84.2-84.2 0-43.3-32.6-78.9-74.6-83.6l50.8-46.5c7.3-6.7 9.7-17.2 6.2-26.4S321.9 128 312 128H184z"
        }
    ]
};

const FarCircle4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle4",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm223.6-126.8c12.6 4.2 19.4 17.8 15.2 30.4L201.3 272H272v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H168c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l48-144c4.2-12.6 17.8-19.4 30.4-15.2z"
        }
    ]
};

const FarCircle5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle5",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48-384c-11.6 0-21.5 8.3-23.6 19.7l-16 88c-1.2 6.5.4 13.3 4.4 18.6s10 8.8 16.6 9.5l86.9 9.8c15.8 1.8 27.8 15.2 27.8 31.1 0 17.3-14 31.3-31.3 31.3h-36c-11.5 0-22.3-5.7-28.8-15.3l-4.1-6.1c-7.4-11-22.3-13.9-33.3-6.5s-13.9 22.3-6.5 33.3l4.1 6.1c15.4 22.9 41.1 36.6 68.6 36.6h36c43.8 0 79.3-35.5 79.3-79.3 0-40.3-30.3-74.3-70.4-78.8l-61.5-7 7.8-43h84c13.3 0 24-10.7 24-24s-10.7-24-24-24H208z"
        }
    ]
};

const FarCircle6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle6",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-96-48c0-32.4 14.2-63.2 38.8-84.3l81.6-70c10.1-8.6 25.2-7.5 33.8 2.6s7.5 25.2-2.6 33.8L282 195.6c40.4 11.4 70 48.4 70 92.4 0 53-43 96-96 96s-96-43-96-96z"
        }
    ]
};

const FarCircle7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle7",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384c-13.3 0-24 10.7-24 24s10.7 24 24 24h103.8l-93 172.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l112-208c4-7.4 3.8-16.4-.5-23.7s-12.2-11.7-20.6-11.7H184z"
        }
    ]
};

const FarCircle8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle8",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm264-128c39.8 0 72 32.2 72 72 0 15.7-5 30.1-13.5 42 18 14.7 29.5 37 29.5 62 0 44.2-35.8 80-80 80h-32c-44.2 0-80-35.8-80-80 0-25 11.5-47.4 29.5-62-8.5-11.9-13.5-26.3-13.5-42 0-39.8 32.2-72 72-72h16zm-16 96h16c13.2 0 24-10.8 24-24s-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24zm16 48h-24c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8z"
        }
    ]
};

const FarCircle9 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle9",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256-80a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm-26 140.4C189.6 305 160 268 160 224c0-53 43-96 96-96s96 43 96 96c0 32.4-14.2 63.2-38.8 84.3l-81.6 70c-10.1 8.6-25.2 7.5-33.8-2.6s-7.5-25.2 2.6-33.8l29.6-25.5z"
        }
    ]
};

const FarCircleA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleA",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-400c-9.1 0-17.4 5.1-21.5 13.3l-104 208c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l17.4-34.8h130.4l17.4 34.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-104-208c-4.1-8.1-12.4-13.3-21.5-13.3zm0 77.7 41.2 82.3h-82.4l41.2-82.3z"
        }
    ]
};

const FarCircleAmpersand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleAmpersand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-40-320.4c0-8.6 7-15.6 15.6-15.6h19.2c7.3 0 13.2 5.9 13.2 13.2 0 4.2-2 8.1-5.4 10.6L235 217.1l-14.5-14.5c-2.9-2.9-4.6-6.9-4.6-11zm71 46.9c15.7-11.5 25-29.8 25-49.3 0-33.8-27.4-61.2-61.2-61.2h-19.2c-35.1 0-63.6 28.5-63.6 63.6 0 16.9 6.7 33 18.6 45l9.2 9.2-24.7 18.1a66.366 66.366 0 0 0-27.2 53.6c0 36.7 29.8 66.5 66.5 66.5h32.2c24.1 0 46.9-10.9 62-29.4L327 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-28.4-28.4 31.1-45c7.5-10.9 4.8-25.8-6.1-33.4s-25.8-4.8-33.4 6.1l-26.2 37.8-28.7-28.7 17.8-13zm-87.5 64.1 30.7-22.5 40.1 40.1-1.4 2c-6 8.6-15.8 13.8-26.3 13.8h-32.1c-10.2 0-18.5-8.3-18.5-18.5 0-5.9 2.8-11.4 7.5-14.9z"
        }
    ]
};

const FarCircleArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleArrowDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm64-144H168c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24v102.1L327 151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-135 135H320c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
        }
    ]
};

const FarCircleArrowDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleArrowDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zm0-464a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-64 368h152c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v102.1L185 151c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l135 135H192c-13.3 0-24 10.7-24 24s10.7 24 24 24z"
        }
    ]
};

const FarCircleArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm105-223-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47V152c0-13.3 10.7-24 24-24s24 10.7 24 24v150.1l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarCircleArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleArrowLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM223 151l-88 88c-9.4 9.4-9.4 24.6 0 33.9l88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H209.9l47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
        }
    ]
};

const FarCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm289 105 88-88c9.4-9.4 9.4-24.6 0-33.9l-88-88c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h150.1l-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"
        }
    ]
};

const FarCircleArrowUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleArrowUpLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm64-368H168c-13.3 0-24 10.7-24 24v160c0 13.3 10.7 24 24 24s24-10.7 24-24V225.9L327 361c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-135-135H320c13.3 0 24-10.7 24-24s-10.7-24-24-24z"
        }
    ]
};

const FarCircleArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-64 144h152c13.3 0 24 10.7 24 24v160c0 13.3-10.7 24-24 24s-24-10.7-24-24V225.9L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135H192c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarCircleArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm105-289-88-88c-9.4-9.4-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47V360c0 13.3 10.7 24 24 24s24-10.7 24-24V209.9l47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"
        }
    ]
};

const FarCircleB = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleB",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-360v208c0 13.3 10.7 24 24 24h108c42 0 76-34 76-76 0-24.6-11.7-46.4-29.8-60.3 8.7-12.4 13.8-27.4 13.8-43.7 0-42-34-76-76-76h-92c-13.3 0-24 10.7-24 24zm144 52c0 15.5-12.5 28-28 28h-68v-56h68c15.5 0 28 12.5 28 28zm-96 132v-56h84c15.5 0 28 12.5 28 28s-12.5 28-28 28h-84z"
        }
    ]
};

const FarCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleBolt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm330.1-140.4c5.8 4.7 7.6 12.9 4.2 19.6L281.9 240H352c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272H160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1z"
        }
    ]
};

const FarCircleBookOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleBookOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-176c23.1 0 41 11.1 46.3 14.8 1.1.8 2.4 1.2 3.7 1.2 3.3 0 5.9-2.7 5.9-5.9V185.3c0-5.8-3.1-11.1-8.3-13.5-10.4-4.7-29.1-11.8-47.6-11.8s-37.2 7.1-47.7 11.9c-5.2 2.4-8.3 7.7-8.3 13.5v160.7c0 3.3 2.7 5.9 5.9 5.9 1.3 0 2.6-.4 3.7-1.2 5.4-3.7 23.3-14.8 46.4-14.8zm144 0c23.1 0 41 11.1 46.3 14.8 1.1.8 2.4 1.2 3.7 1.2 3.3 0 5.9-2.7 5.9-5.9V185.3c0-5.8-3.1-11.1-8.3-13.5-10.4-4.7-29.1-11.8-47.6-11.8s-37.2 7.1-47.7 11.9c-5.2 2.4-8.3 7.7-8.3 13.5v160.7c0 3.3 2.7 5.9 5.9 5.9 1.3 0 2.6-.4 3.7-1.2 5.4-3.7 23.3-14.8 46.4-14.8z"
        }
    ]
};

const FarCircleBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleBookmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-336v192c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4V176c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarCircleC = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleC",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-56.6-199.4c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181 131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"
        }
    ]
};

const FarCircleCalendar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleCalendar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm208-144c8.8 0 16 7.2 16 16v16h64v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48h16v-16c0-8.8 7.2-16 16-16zm-32 208h160v-96H176v96z"
        }
    ]
};

const FarCircleCamera = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleCamera",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm196-96 6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6h62.7c10 0 19 6.2 22.5 15.6L316 160h36c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h36zm108 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarCircleCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleCaretDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zm0-464a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm0 368c6.7 0 13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9S369.5 208 360 208H152c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7z"
        }
    ]
};

const FarCircleCaretLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleCaretLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zm-368 0c0 6.7 2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22V152c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104c-4.9 4.5-7.7 10.9-7.7 17.6z"
        }
    ]
};

const FarCircleCaretRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleCaretRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm368 0c0-6.7-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4S208 142.5 208 152v208c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104c4.9-4.5 7.7-10.9 7.7-17.6z"
        }
    ]
};

const FarCircleCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleCaretUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-368c-6.7 0-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9s12.5 14.4 22 14.4h208c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112c-4.5-4.9-10.9-7.7-17.6-7.7z"
        }
    ]
};

const FarCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm113-303c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
        }
    ]
};

const FarCircleChevronDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleChevronDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zm0-464a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM135 241l104 104c9.4 9.4 24.6 9.4 33.9 0L377 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
        }
    ]
};

const FarCircleChevronLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleChevronLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM271 135 167 239c-9.4 9.4-9.4 24.6 0 33.9L271 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-87-87 87-87c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
        }
    ]
};

const FarCircleChevronRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleChevronRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm241 121 104-104c9.4-9.4 9.4-24.6 0-33.9L241 135c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"
        }
    ]
};

const FarCircleChevronUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleChevronUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm121-241L273 167c-9.4-9.4-24.6-9.4-33.9 0L135 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"
        }
    ]
};

const FarCircleD = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleD",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384c-13.3 0-24 10.7-24 24v208c0 13.3 10.7 24 24 24h72c70.7 0 128-57.3 128-128s-57.3-128-128-128h-72zm72 208h-48V176h48c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
        }
    ]
};

const FarCircleDashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleDashed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M27.7 232c12.3 0 22.5-9.3 25.2-21.3 5.3-23.9 14.7-46.2 27.4-66.2 6.6-10.4 6-24.2-2.8-32.9-10.1-10.1-26.8-9.4-34.7 2.5-18.2 27.3-31.3 58.3-37.9 91.6-2.8 14 8.5 26.3 22.8 26.3zM144.5 80.4c20-12.7 42.3-22.1 66.2-27.4 12-2.7 21.3-12.9 21.3-25.2 0-14.3-12.3-25.6-26.3-22.8-33.3 6.6-64.3 19.7-91.6 37.9-11.9 7.9-12.6 24.6-2.5 34.7 8.7 8.7 22.5 9.4 32.9 2.8zM280 484.3c0 14.3 12.3 25.6 26.3 22.8 33.3-6.6 64.3-19.7 91.6-37.9 11.9-7.9 12.6-24.6 2.5-34.7-8.7-8.7-22.5-9.4-32.9-2.8-20 12.7-42.3 22.1-66.2 27.4-12 2.7-21.3 12.9-21.3 25.2zm151.6-116.8c-6.6 10.4-6 24.2 2.8 32.9 10.1 10.1 26.8 9.4 34.7-2.5 18.2-27.3 31.3-58.3 37.9-91.6 2.8-14-8.5-26.3-22.8-26.3-12.3 0-22.5 9.3-25.2 21.3-5.3 23.9-14.7 46.2-27.4 66.2zm-320 66.8c-10.1 10.1-9.4 26.8 2.5 34.7 27.3 18.2 58.3 31.3 91.6 37.9 14 2.8 26.3-8.5 26.3-22.8 0-12.3-9.3-22.5-21.3-25.2-23.9-5.3-46.2-14.7-66.2-27.4-10.4-6.6-24.2-6-32.9 2.8zm-68.7-36.4c7.9 11.9 24.6 12.6 34.7 2.5 8.7-8.7 9.4-22.5 2.8-32.9-12.7-20-22.1-42.3-27.4-66.2-2.7-12-12.9-21.3-25.2-21.3-14.3 0-25.6 12.3-22.8 26.3 6.6 33.3 19.7 64.3 37.9 91.6zM400.4 77.6c10.1-10.1 9.4-26.8-2.5-34.7-27.3-18.2-58.3-31.3-91.6-37.9-14-2.8-26.3 8.5-26.3 22.8 0 12.3 9.3 22.5 21.3 25.2 23.9 5.3 46.2 14.7 66.2 27.4 10.4 6.6 24.2 6 32.9-2.8zm31.2 66.8c12.7 20 22.1 42.3 27.4 66.2 2.7 12 12.9 21.3 25.2 21.3 14.3 0 25.6-12.3 22.8-26.3-6.6-33.3-19.7-64.3-37.9-91.6-7.9-11.9-24.6-12.6-34.7-2.5-8.7 8.7-9.4 22.5-2.8 32.9z"
        }
    ]
};

const FarCircleDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleDivide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zm120 120a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCircleDollarToSlot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleDollarToSlot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32c0-35.3-28.6-64-64-64-13.6 18.2-29.8 34.3-48 48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48c-18.2-13.7-34.3-29.8-48-48zm212-248c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
        }
    ]
};

const FarCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm276.8-122.4v14.2c9.7 1.2 19.4 3.9 29 6.6 1.9.5 3.7 1 5.6 1.6 11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3-7-2-14-3.9-21.1-5.3-13.2-2.5-28.5-1.3-40.8 4-11 4.8-20.1 16.4-7.6 24.4 9.8 6.3 21.8 9.5 33.2 12.6 2.4.6 4.7 1.3 7 1.9 15.6 4.4 35.5 10.1 50.4 20.3 19.4 13.3 28.5 34.9 24.2 58.1-4.1 22.4-19.7 37.1-38.4 44.7-7.8 3.2-16.3 5.2-25.2 6.2v15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6v-17.4c-14.5-3.3-28.7-7.9-42.8-12.5-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5.8 5 1.7 7.5 2.5 11.3 3.8 22.9 7.7 34.5 9.6 17 2.5 30.6 1 39.5-2.6 12-4.8 17.7-19.1 5.9-27.1-10.1-6.9-22.6-10.3-34.5-13.5-2.3-.6-4.5-1.2-6.8-1.9-15.1-4.3-34-9.6-48.2-18.7-19.5-12.5-29.4-33.3-25.2-56.4 4-21.8 21-36.3 39-44.1 5.5-2.4 11.4-4.3 17.5-5.7v-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"
        }
    ]
};

const FarCircleDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleDot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FarCircleDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm-96-313.4c0-12.5 10.1-22.6 22.6-22.6 6 0 11.8 2.4 16 6.6L232 216l66.3-66.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l36.7 36.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L296 280l33.4 33.4c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H176c-8.8 0-16-7.2-16-16V198.6z"
        }
    ]
};

const FarCircleDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zm0-464a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm96 198.6c0-12.5-10.1-22.6-22.6-22.6-6 0-11.8 2.4-16 6.6L280 216l-66.3-66.3c-3.7-3.7-8.6-5.7-13.7-5.7s-10 2-13.7 5.7l-36.7 36.7c-3.6 3.6-5.6 8.5-5.6 13.6s2 10 5.7 13.7L216 280l-33.4 33.4c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6H336c8.8 0 16-7.2 16-16V198.6z"
        }
    ]
};

const FarCircleDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zm0-464a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm120.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3 0-12.3-10-22.3-22.3-22.3H304v-96c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v96h-57.7c-12.3 0-22.3 10-22.3 22.3 0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z"
        }
    ]
};

const FarCircleE = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleE",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384c-13.3 0-24 10.7-24 24v208c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H208v-56h88c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88v-56h120c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarCircleEllipsisVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleEllipsisVertical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarCircleEllipsis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleEllipsis",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm32 256a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-160 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FarCircleEnvelope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleEnvelope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-7.3-256.4c2.2 1.2 4.7 1.9 7.3 1.9s5.1-.6 7.3-1.9l120.6-66.4c-1.4-16.3-15.2-29.2-31.9-29.2H160c-16.7 0-30.5 12.9-31.9 29.3l120.6 66.4zm30 28c-7 3.8-14.8 5.8-22.7 5.8s-15.8-2-22.7-5.8L128 225.7V320c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-94.3l-105.3 57.9z"
        }
    ]
};

const FarCircleEuro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleEuro",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm128 16h16c-.6-5-.9-10.1-.9-15.2 0-5.7.4-11.3 1.1-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h24.7c19.2-46.9 65.4-80 119.2-80H313c13.3 0 24 10.7 24 24s-10.7 24-24 24h-41.1c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16h-95.1c-1.1 5.4-1.7 11-1.7 16.8 0 5.2.5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16h-81.6c14.7 20.3 38.5 33.5 65.5 33.5H313c13.3 0 24 10.7 24 24s-10.7 24-24 24h-41.1c-54.4 0-101-33.8-119.8-81.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarCircleExclamationCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleExclamationCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-114.9 93.1-208 208-208 84.1 0 156.7 50 189.4 121.9 5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8C448.8 61.6 359.6 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c72.9 0 138.8-30.5 185.4-79.4 9.1-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9.8c-38 39.7-91.4 64.5-150.7 64.5-114.9 0-208-93.1-208-208zm232-104c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm369-209c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L625 209c9.4-9.4 9.4-24.6 0-33.9z"
        }
    ]
};

const FarCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCircleF = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleF",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384c-13.3 0-24 10.7-24 24v208c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h88c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88v-64h120c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarCircleG = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleG",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-256c0-44.2 35.8-80 80-80 20.5 0 39.2 7.7 53.3 20.4 9.9 8.8 25.1 8 33.9-1.9s8-25-1.9-33.9C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h52.3c-10.2 32.5-40.5 56-76.3 56-44.2 0-80-35.8-80-80z"
        }
    ]
};

const FarCircleH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleH",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm112-360c0-13.3-10.7-24-24-24s-24 10.7-24 24v80H192v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v208c0 13.3 10.7 24 24 24s24-10.7 24-24v-80h128v80c0 13.3 10.7 24 24 24s24-10.7 24-24V152z"
        }
    ]
};

const FarCircleHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleHalfStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-114.9-93.1-208-208-208v416c114.9 0 208-93.1 208-208zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FarCircleHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 53.6C116.3 75.2 48 157.7 48 256s68.3 180.8 160 202.4V53.6zM224.1 2C241.6-.2 256 14.3 256 32v448c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z"
        }
    ]
};

const FarCircleHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM131.9 280.9l101.6 103.2c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4l101.6-103.2c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0l-17.7 18-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108z"
        }
    ]
};

const FarCircleI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleI",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v160h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48V176h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarCircleInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleInfo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-40-176c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-88c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64h-24zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarCircleJ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleJ",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm80-360c0-13.3-10.7-24-24-24s-24 10.7-24 24v136c0 26.5-21.5 48-48 48s-48-21.5-48-48v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 53 43 96 96 96s96-43 96-96V152z"
        }
    ]
};

const FarCircleK = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleK",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm89.1-343.2c9.3-9.5 9.2-24.6-.3-33.9s-24.6-9.2-33.9.3L208 239.8V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v208c0 13.3 10.7 24 24 24s24-10.7 24-24v-51.7l30-30.5 70.7 96.4c7.8 10.7 22.9 13 33.5 5.2s13-22.9 5.2-33.5l-75.3-102.8 73.1-74.3z"
        }
    ]
};

const FarCircleL = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleL",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48-360c0-13.3-10.7-24-24-24s-24 10.7-24 24v208c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H208V152z"
        }
    ]
};

const FarCircleLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1 12.3 0 22.3-10 22.3-22.3V304h96c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-96v-57.7c0-12.3-10-22.3-22.3-22.3-6.2 0-12.1 2.6-16.3 7.1l-99.9 107.1c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"
        }
    ]
};

const FarCircleLocationArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleLocationArrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm358.2-73.3-84 196c-3.5 8.1-11.4 13.3-20.2 13.3-1.4 0-2.9-.1-4.4-.4-10.2-2.1-17.6-11.2-17.6-21.6v-90h-90c-10.4 0-19.5-7.4-21.5-17.6-2.1-10.2 3.3-20.5 12.9-24.6l196-84c8.5-3.5 18-1.7 24.2 4.7 6.4 6.3 8.2 15.9 4.7 24.2z"
        }
    ]
};

const FarCircleM = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleM",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-84.5-374.1c-6.1-8.4-16.9-12-26.8-8.8s-16.6 12.4-16.6 22.8V360c0 13.3 10.7 24 24 24s24-10.7 24-24V226.2l60.5 83.8c4.5 6.2 11.7 9.9 19.5 9.9s14.9-3.7 19.5-9.9l60.4-83.8V360c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-10.4-6.7-19.6-16.6-22.8s-20.7.3-26.8 8.8L256 255l-84.5-117.1z"
        }
    ]
};

const FarCircleMicrophoneLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleMicrophoneLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-416c-26.5 0-48 21.5-48 48v112c0 26.5 21.5 48 48 48s48-21.5 48-48h-24c-8.8 0-16-7.2-16-16s7.2-16 16-16h24v-32h-24c-8.8 0-16-7.2-16-16s7.2-16 16-16h24v-16c0-26.5-21.5-48-48-48zm-80 160c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 62.5 44.8 114.5 104 125.8V392c0 13.3 10.7 24 24 24s24-10.7 24-24v-10.2c59.2-11.2 104-63.3 104-125.8 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 44.2-35.8 80-80 80s-80-35.8-80-80z"
        }
    ]
};

const FarCircleMicrophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleMicrophone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm208-112c0-26.5 21.5-48 48-48s48 21.5 48 48v112c0 26.5-21.5 48-48 48s-48-21.5-48-48V144zm-56 88c13.3 0 24 10.7 24 24 0 44.2 35.8 80 80 80s80-35.8 80-80c0-13.3 10.7-24 24-24s24 10.7 24 24c0 62.5-44.8 114.5-104 125.8V392c0 13.3-10.7 24-24 24s-24-10.7-24-24v-10.2c-59.2-11.3-104-63.3-104-125.8 0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-280c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarCircleN = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleN",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-52.3-373.7c-6-8.6-16.9-12.4-26.9-9.2S160 141.5 160 152v208c0 13.3 10.7 24 24 24s24-10.7 24-24V228.8l100.3 144.9c6 8.6 16.9 12.4 26.9 9.2S352 370.5 352 360V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v131.2L203.7 138.3z"
        }
    ]
};

const FarCircleNodes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleNodes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-29.9 50.6c6.8 8.3 15.2 15.2 24.7 20.2L326 352.6c-11.5 1.4-22.2 5.3-31.7 11.1l-141-123.5c4.3-9.9 6.7-20.7 6.7-32.2 0-2-.1-4.1-.2-6.1l178.3-71.3zm71.9 28.8c39.5-4.9 70-38.6 70-79.4 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 2 .1 4.1.2 6.1l-178.3 71.3C127.3 139.4 105 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c15.3 0 29.5-4.3 41.6-11.7l141.1 123.5c-4.3 9.9-6.7 20.7-6.7 32.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-30.7-17.3-57.4-42.7-70.8L410 159.4zM304 432a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM80 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarCircleNotch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleNotch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.1 26.3c3.6 12.7-3.7 26-16.5 29.7C111.6 80.9 48 161.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-94.9-63.6-175.1-150.6-200-12.7-3.6-20.1-16.9-16.5-29.7s16.9-20.1 29.7-16.5C433.6 40.5 512 139.1 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 139.1 78.4 40.5 185.4 9.9c12.7-3.6 26 3.7 29.7 16.5z"
        }
    ]
};

const FarCircleO = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleO",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm80-256a80 80 0 1 1-160 0 80 80 0 1 1 160 0zm-80-128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"
        }
    ]
};

const FarCircleP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleP",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384c-13.3 0-24 10.7-24 24v208c0 13.3 10.7 24 24 24s24-10.7 24-24v-48h68c50.8 0 92-41.2 92-92s-41.2-92-92-92h-92zm92 136h-68v-88h68c24.3 0 44 19.7 44 44s-19.7 44-44 44z"
        }
    ]
};

const FarCircleParking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleParking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm216 16h64c26.5 0 48-21.5 48-48s-21.5-48-48-48h-64v96zm64 48h-64v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V160c0-17.7 14.3-32 32-32h80c53 0 96 43 96 96s-43 96-96 96z"
        }
    ]
};

const FarCirclePause = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCirclePause",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm224-72v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarCirclePhoneFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCirclePhoneFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm69.3 128.7 44 12C378 143.1 384 151 384 160c0 123.7-100.3 224-224 224-9 0-16.9-6-19.3-14.7l-12-44c-2.6-9.7 2.3-19.9 11.6-23.7l48-20c8.2-3.4 17.6-1 23.2 5.8l20.2 24.6c35.2-16.6 63.7-45.1 80.3-80.3l-24.7-20.2c-6.8-5.6-9.2-15-5.8-23.2l20-48c3.9-9.3 14-14.2 23.7-11.6z"
        }
    ]
};

const FarCirclePhoneHangup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCirclePhoneHangup",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm135.4-218 21.7-35.2c4.8-7.8 3.4-17.5-3.4-23.8-84.9-78.6-222.6-78.6-307.5 0-6.8 6.3-8.2 16.1-3.4 23.8l21.8 35.2c5.3 8.6 16.8 12.3 26.7 8.5l46.2-17.6c8.7-3.3 14.1-11.6 13.1-20.3l-2.9-26.6c33.8-10.8 70.8-10.8 104.6 0l-2.9 26.7c-.9 8.7 4.4 16.9 13.1 20.3l46.2 17.6c9.9 3.8 21.4.2 26.7-8.5z"
        }
    ]
};

const FarCirclePhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCirclePhone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-69.3-383.3-44 12C134 143.1 128 151 128 160c0 123.7 100.3 224 224 224 9 0 16.9-6 19.3-14.7l12-44c2.6-9.7-2.3-19.9-11.6-23.7l-48-20c-8.2-3.4-17.6-1-23.2 5.8L280.3 312c-35.2-16.6-63.7-45.1-80.3-80.3l24.7-20.2c6.8-5.6 9.2-15 5.8-23.2l-20-48c-3.9-9.3-14-14.2-23.7-11.6z"
        }
    ]
};

const FarCirclePlay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCirclePlay",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm188.3-108.9c7.6-4.2 16.8-4.1 24.3.5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3.5S176 352.9 176 344.2V168c0-8.7 4.7-16.7 12.3-20.9z"
        }
    ]
};

const FarCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCirclePlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-24-168c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FarCircleQ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleQ",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-256c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.4-3.3 25.9-9.1 37l-30-30c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l30 30c-11.1 5.8-23.7 9.1-37 9.1-44.2 0-80-35.8-80-80zm208 0c0-70.7-57.3-128-128-128s-128 57.3-128 128 57.3 128 128 128c26.7 0 51.4-8.2 71.9-22.1L343 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L361.8 328c14-20.5 22.1-45.3 22.1-71.9z"
        }
    ]
};

const FarCircleQuarterStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleQuarterStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-114.9-93.1-208-208-208h-4.3c2.7 4.6 4.3 10.1 4.3 16v160c0 17.7-14.3 32-32 32H64c-5.8 0-11.3-1.6-16-4.3v4.3c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FarCircleQuarter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleQuarter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 53.6V208H53.6c18-76.3 78.1-136.4 154.4-154.4zM2 224.1C-.2 241.6 14.3 256 32 256h192c17.7 0 32-14.3 32-32V32c0-17.7-14.4-32.2-31.9-30C108.2 16.4 16.4 108.2 2 224.1z"
        }
    ]
};

const FarCircleQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleQuarters",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M108.9 403.1 256 256l147.1 147.1C440.7 365.4 464 313.4 464 256s-23.3-109.4-60.9-147.1L256 256 108.9 108.9C71.3 146.6 48 198.6 48 256s23.3 109.4 60.9 147.1zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FarCircleQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarCircleR = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleR",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384c-13.3 0-24 10.7-24 24v208c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h44l64.8 86.4c8 10.6 23 12.8 33.6 4.8s12.8-23 4.8-33.6L309.8 285c33.6-9.5 58.2-40.4 58.2-77 0-44.2-35.8-80-80-80H184zm80 112h-56v-64h80c17.7 0 32 14.3 32 32s-14.3 32-32 32h-24z"
        }
    ]
};

const FarCircleRadiation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleRadiation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-56-256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9-25.6 22.6-43.9 53.3-50.9 88.1-3.4 17.2 11.2 31.7 28.9 31.7h72zm28 48.5-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8 16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zm84-48.5h72c17.7 0 32.3-14.5 28.8-31.8-7-34.8-25.3-65.5-50.9-88.1-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarCircleRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm294.6-120.9c-4.2-4.5-10.1-7.1-16.3-7.1-12.3 0-22.3 10-22.3 22.3V208h-96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h96v57.7c0 12.3 10 22.3 22.3 22.3 6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8l-99.9-107.1z"
        }
    ]
};

const FarCircleS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleS",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48.4-315.8c1.1-6.2 5-11.8 15.4-15.8 11-4.3 27.6-6 47.8-2.9 6 .9 20.6 4 27.3 5.7 12.8 3.3 25.9-4.5 29.2-17.3s-4.5-25.9-17.3-29.2c-7.7-2-23.9-5.5-32-6.7-25.6-3.9-51.3-2.6-72.6 5.7-21.9 8.6-40.3 25.7-45 52-2.6 14.4-1.3 28 4.4 40.3 5.6 12.1 14.7 20.8 24.1 27.2 17.2 11.6 40.3 18.1 58.6 23.2l2 .6c21.1 5.9 36.7 10.6 46.8 17.4 4.5 3 6.5 5.6 7.4 7.7.9 1.9 1.8 5.2.6 11.6-1.1 6.2-5 11.8-15.4 15.8-11 4.3-27.5 6-47.7 2.9-12.2-1.9-36.1-8.9-50-13.4-12.6-4-26.1 2.9-30.2 15.5s2.9 26.1 15.5 30.2c13.6 4.4 40.9 12.5 57.3 15.1h.1c25.6 3.9 51.3 2.6 72.6-5.7 21.9-8.6 40.3-25.7 45-52 2.6-14.4 1.4-28-4.4-40.3-5.6-12.1-14.7-20.8-24.1-27.2-17.2-11.6-40.3-18.1-58.6-23.2l-2-.6c-21.1-5.9-36.7-10.6-46.8-17.4-4.5-3-6.5-5.6-7.4-7.7-.9-1.9-1.8-5.2-.6-11.6z"
        }
    ]
};

const FarCircleSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleSmall",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 256a112 112 0 1 0-224 0 112 112 0 1 0 224 0zM0 256a160 160 0 1 1 320 0 160 160 0 1 1-320 0z"
        }
    ]
};

const FarCircleSortDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleSortDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM267.3 411.3l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96c6.2 6.2 16.4 6.2 22.6 0zm0-310.6c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h192c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zm46.1 91.3H198.6l57.4-57.4 57.4 57.4z"
        }
    ]
};

const FarCircleSortUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleSortUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm267.3-155.3 96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zm0 310.6c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h192c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96zm46.1-91.3H198.6l57.4 57.4 57.4-57.4z"
        }
    ]
};

const FarCircleSort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleSort",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm267.3-155.3 96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zm-22.6 310.6-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h192c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0z"
        }
    ]
};

const FarCircleStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleStar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-391c-6.1 0-11.7 3.5-14.3 8.9l-31.3 63.3-69.9 10.2c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l50.6 49.3-11.9 69.6c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.9 1.2l62.4-32.8 62.5 32.9c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6L329.8 280l50.6-49.3c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-69.9-10.2-31.3-63.3c-2.7-5.5-8.3-8.9-14.3-8.9z"
        }
    ]
};

const FarCircleSterling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleSterling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm261.5-96c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5H272c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40.3l.1 9.7c.1 18.6-3.1 37-9.6 54.3H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c7.7-14.9 11.6-31.5 11.5-48.3l-.1-10.1H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h7.5l-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9 10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z"
        }
    ]
};

const FarCircleStop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleStop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm192-96h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarCircleT = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleT",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80v168c0 13.3 10.7 24 24 24s24-10.7 24-24V192h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"
        }
    ]
};

const FarCircleThreeQuartersStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleThreeQuartersStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48v176c0 17.7 14.3 32 32 32h176c0-114.9-93.1-208-208-208zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FarCircleThreeQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleThreeQuarters",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 304c-26.5 0-48-21.5-48-48V53.6C116.3 75.2 48 157.7 48 256c0 114.9 93.1 208 208 208 98.3 0 180.8-68.3 202.4-160H256zM224.1 2C241.6-.2 256 14.3 256 32v224h224c17.7 0 32.2 14.4 30 31.9C494.3 414.2 386.6 512 256 512 114.6 512 0 397.4 0 256 0 125.4 97.8 17.7 224.1 2z"
        }
    ]
};

const FarCircleTrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleTrash",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm160-128h41.4l11.3-11.3c3-3 7.1-4.7 11.3-4.7h64c4.2 0 8.3 1.7 11.3 4.7l11.3 11.3H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h192l-13.6 162.7c-1.4 16.6-15.2 29.3-31.9 29.3H205.4c-16.6 0-30.5-12.8-31.9-29.3L160 192z"
        }
    ]
};

const FarCircleU = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleU",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-344c0-13.3-10.7-24-24-24s-24 10.7-24 24v120c0 61.9 50.1 112 112 112s112-50.1 112-112V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v120c0 35.3-28.7 64-64 64s-64-28.7-64-64V168z"
        }
    ]
};

const FarCircleUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleUpLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-198.6c0 12.5 10.1 22.6 22.6 22.6 6 0 11.8-2.4 16-6.6L232 296l66.3 66.3c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l36.7-36.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L296 232l33.4-33.4c4.2-4.2 6.6-10 6.6-16 0-12.5-10.1-22.6-22.6-22.6H176c-8.8 0-16 7.2-16 16v137.4z"
        }
    ]
};

const FarCircleUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm96 313.4c0 12.5-10.1 22.6-22.6 22.6-6 0-11.8-2.4-16-6.6L280 296l-66.3 66.3c-3.7 3.7-8.6 5.7-13.7 5.7s-10-2-13.7-5.7l-36.7-36.7c-3.6-3.6-5.6-8.5-5.6-13.6s2-10 5.7-13.7L216 232l-33.4-33.4c-4.2-4.2-6.6-10-6.6-16 0-12.5 10.1-22.6 22.6-22.6H336c8.8 0 16 7.2 16 16v137.4z"
        }
    ]
};

const FarCircleUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3 0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-96h57.7c12.3 0 22.3-10 22.3-22.3 0-6.2-2.6-12.1-7.1-16.3l-107.1-99.9c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5l-107.1 99.9z"
        }
    ]
};

const FarCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleUser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M406.5 399.6c-19.1-46.7-65-79.6-118.5-79.6h-64c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7c-32 20.1-69.8 31.7-110.4 31.7s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0-176 0z"
        }
    ]
};

const FarCircleV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleV",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-82.5-354.7c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l104 208c4.1 8.1 12.4 13.3 21.5 13.3s17.4-5.1 21.5-13.3l104-208c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7l-82.7 165-82.5-165z"
        }
    ]
};

const FarCircleVideo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleVideo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm144-56c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24V200zm220.9 117.9L320 288v-64l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1 6.8 0 12.3 5.5 12.3 12.3v103.4c0 6.8-5.5 12.3-12.3 12.3-2.4 0-4.8-.7-6.8-2.1z"
        }
    ]
};

const FarCircleW = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleW",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM150.9 168.7c-4-12.6-17.5-19.6-30.2-15.5s-19.6 17.5-15.5 30.2l64 200c3.2 9.9 12.4 16.7 22.9 16.7s19.7-6.7 22.9-16.7l41-128.7 41.1 128.6c3.2 9.9 12.4 16.7 22.9 16.7s19.7-6.7 22.9-16.7l64-200c4-12.6-2.9-26.1-15.5-30.2s-26.1 2.9-30.2 15.5L320 297.3l-41.1-128.6c-3.2-9.9-12.4-16.7-22.9-16.7s-19.7 6.7-22.9 16.7L192 297.3l-41.1-128.6z"
        }
    ]
};

const FarCircleWaveformLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleWaveformLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-368c0-13.3-10.7-24-24-24s-24 10.7-24 24v224c0 13.3 10.7 24 24 24s24-10.7 24-24V144zm80 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V200zm-160 16c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80zm240 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v32c0 13.3 10.7 24 24 24s24-10.7 24-24v-32z"
        }
    ]
};

const FarCircleX = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleX",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-69.7-375.5c-8.6-10.1-23.7-11.4-33.8-2.8s-11.4 23.7-2.8 33.8l74.9 88.5-74.9 88.5c-8.6 10.1-7.3 25.3 2.8 33.8s25.3 7.3 33.8-2.8l69.7-82.3 69.7 82.3c8.6 10.1 23.7 11.4 33.8 2.8s11.4-23.7 2.8-33.8L287.4 256l74.9-88.5c8.6-10.1 7.3-25.3-2.8-33.8s-25.3-7.3-33.8 2.8L256 218.8l-69.7-82.3z"
        }
    ]
};

const FarCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-81-337c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarCircleY = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleY",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-85.9-359.7c-8.7-10-23.8-11.1-33.9-2.4s-11.1 23.8-2.4 33.9L232 297v79c0 13.3 10.7 24 24 24s24-10.7 24-24v-79l98.1-113.2c8.7-10 7.6-25.2-2.4-33.9s-25.2-7.6-33.9 2.4L256 251.4l-85.9-99.1z"
        }
    ]
};

const FarCircleYen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleYen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm159.9-105.8c9.8-8.9 25-8.2 33.9 1.6l62.2 68.5 62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9L288.4 256H320c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40v32h40c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40v25c0 13.3-10.7 24-24 24s-24-10.7-24-24v-25h-40c-8.8 0-16-7.2-16-16s7.2-16 16-16h40v-32h-40c-8.8 0-16-7.2-16-16s7.2-16 16-16h31.6l-65.3-71.9c-8.9-9.8-8.2-25 1.6-33.9z"
        }
    ]
};

const FarCircleZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircleZ",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384c-13.3 0-24 10.7-24 24s10.7 24 24 24h98.2L164.3 346.3c-5.1 7.3-5.7 16.9-1.5 24.8S175.1 384 184 384h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-98.2l117.9-170.3c5.1-7.3 5.7-16.9 1.5-24.8S336.9 128 328 128H184z"
        }
    ]
};

const FarCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FarCirclesOverlap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCirclesOverlap",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 288c0 40.8 10.9 79 30 112-96.3-1.1-174-79.5-174-176 0-97.2 78.8-176 176-176 38.9 0 74.8 12.6 104 34-80 34.2-136 113.5-136 206zm32 160c11.2 0 22.1-.8 32.8-2.4 40.6 41 96.9 66.4 159.2 66.4 123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1.8-32.8 2.4C342.6 25.4 286.3 0 224 0 100.3 0 0 100.3 0 224s100.3 224 224 224zm192 16c-38.9 0-74.8-12.6-104-34 80-34.2 136-113.5 136-206 0-40.8-10.9-79-30-112 96.3 1.1 174 79.5 174 176 0 97.2-78.8 176-176 176z"
        }
    ]
};

const FarCitrusSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCitrusSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7 391c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17c115.6 115.6 302.6 116 418.3.3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0L7 391zm384.3.3c-91.1 91.1-235.2 96.2-332.6 15.8l22.4-22.4C118.1 414.3 165 432 216 432c119.3 0 216-96.7 216-216 0-51-17.7-97.9-47.2-134.8l22.4-22.4c80.4 97.4 75.3 241.5-15.8 332.6zm-40.8-276c13.3 17.8 23.2 38.3 28.7 60.6h-89.3l60.6-60.6zM272 208h111.8c.1 2.7.2 5.3.2 8 0 40.6-14.4 77.9-38.4 106.9l-82.4-82.4c5.9-10 8.9-21.3 8.9-32.5zm-31.5 55.1 82.4 82.4c-29 24.1-66.3 38.5-106.9 38.5-2.7 0-5.3-.1-8-.2V272c11.3 0 22.5-3 32.5-8.9zm-125.1 87.5 60.6-60.7v89.3c-22.3-5.4-42.8-15.3-60.6-28.7z"
        }
    ]
};

const FarCitrus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCitrus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128h80c53 0 96-43 96-96V16c0-8.8-7.2-16-16-16h-80c-31 0-58.7 14.7-76.2 37.6-16.7-3.7-34-5.6-51.8-5.6C123.5 32 16 139.5 16 272s107.5 240 240 240 240-107.5 240-240c0-49.5-15-95.5-40.7-133.7-13.5 9.1-28.8 15.7-45.3 19.1 23.9 32 38 71.7 38 114.6 0 106-86 192-192 192S64 378 64 272 150 80 256 80c11.2 0 22.2 1 32.9 2.8-.6 4.3-.9 8.7-.9 13.2v16c0 8.8 7.2 16 16 16z"
        }
    ]
};

const FarCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 0C90.7 0 80 10.7 80 24v40h-8C32.2 64 0 96.2 0 136v304c0 39.8 32.2 72 72 72h168c-10-13.4-16-30-16-48H72c-13.3 0-24-10.7-24-24V136c0-13.3 10.7-24 24-24h152V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-48V24c0-13.3-10.7-24-24-24zm360 160c0 26.5 21.5 48 48 48h64c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v96zm48-48V64c0-35.3-28.7-64-64-64H320c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64h-64v-48zM352 336c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32zm16-240c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-16 144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32zm144 176h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm-16-112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32zm-368 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm-16 80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32zm16-176h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16z"
        }
    ]
};

const FarClapperboardPlay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClapperboardPlay",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V208H48v208zm288-256h64l64-64c0-8.8-7.2-16-16-16h-32l-80 80zm-96 0 80-80h-64l-80 80h64zm-160 0 80-80H96l-48 48v32h32zm432-64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64zM216.5 241.9c5.2-2.8 11.5-2.5 16.4.8l96 64c4.4 3 7.1 8 7.1 13.3s-2.7 10.3-7.1 13.3l-96 64c-4.9 3.3-11.2 3.6-16.4.8s-8.5-8.2-8.5-14.1V256c0-5.9 3.2-11.3 8.5-14.1z"
        }
    ]
};

const FarClapperboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClapperboard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 208h416v208c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208zm352-48h-64l80-80h32c8.8 0 16 7.2 16 16l-64 64zm-80-80-80 80h-64l80-80h64zm-160 0-80 80H48v-32l48-48h64zm352 80V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160z"
        }
    ]
};

const FarClarinet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClarinet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 112c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v32h44.6c7.9 0 15.6-2.3 22.2-6.7l55.9-37.3c7.4-4.9 16.8-5.4 24.6-1.2S640 127.1 640 136v240c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-55.9-37.3c-6.6-4.4-14.3-6.7-22.2-6.7H113.4c-8.6 0-17.1-1.3-25.3-3.7l-71-21.3C7 323.9 0 314.6 0 304v-96c0-10.6 7-19.9 17.1-23l71-21.3c8.2-2.5 16.7-3.7 25.3-3.7H256v-32h-16c-8.8 0-16-7.2-16-16zm64 48h64v-32h-64v32zm96 0h64v-32h-64v32zm-136 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm133.4-62.8C559 202.9 542 208 524.6 208H113.4c-3.9 0-7.8.6-11.5 1.7L48 225.9v60.3l53.9 16.2c3.7 1.1 7.6 1.7 11.5 1.7h411.2c17.4 0 34.4 5.1 48.8 14.8l18.6 12.3V180.8l-18.6 12.4z"
        }
    ]
};

const FarClawMarks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClawMarks",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M39 7c9.4-9.3 24.6-9.3 34 0l103.6 103.6c15 15 23.4 35.4 23.4 56.6V184h16.8c21.2 0 41.6 8.4 56.6 23.4l95.2 95.2c15 15 23.4 35.4 23.4 56.6V376h16.8c21.2 0 41.6 8.4 56.6 23.4L537 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71.6-71.6c-6-6-14.1-9.4-22.6-9.4H368c-13.3 0-24-10.7-24-24v-40.7c0-8.5-3.4-16.6-9.4-22.6l-95.2-95.2c-6-6-14.1-9.4-22.6-9.4H176c-13.3 0-24-10.7-24-24v-40.8c0-8.5-3.4-16.6-9.4-22.6L39 41c-9.3-9.4-9.3-24.6 0-34zm0 224c9.4-9.4 24.6-9.4 33.9 0l74 74c13.5 13.5 21.1 31.8 21.1 50.9V376h20.1c19.1 0 37.4 7.6 50.9 21.1l74 73.9c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-74-73.9c-4.5-4.5-10.6-7-17-7H144c-13.3 0-24-10.7-24-24v-44.1c0-6.4-2.5-12.5-7-17L39 265c-9.4-9.4-9.4-24.6 0-33.9zM297 7l9.9 9.9c13.5 13.6 21.1 31.9 21.1 51V88h20.1c19.1 0 37.4 7.6 50.9 21.1l35.9 35.9c13.5 13.5 21.1 31.8 21.1 50.9V216h20.1c19.1 0 37.4 7.6 50.9 21.1l10 9.9c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.9-9.9c-4.5-4.5-10.6-7-17-7H432c-13.3 0-24-10.7-24-24v-44.1c0-6.4-2.5-12.5-7-17L365.1 143c-4.5-4.5-10.6-7-17-7H304c-13.3 0-24-10.7-24-24V67.9c0-6.4-2.5-12.5-7-17L263 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FarClipboardCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClipboardCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64h-49.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24v-24h16c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h16zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm121 187.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z"
        }
    ]
};

const FarClipboardListCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClipboardListCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64h-49.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24v-24h16c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h16zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm3.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 249.4l-12.7-12.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48zM192 272c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm-32 96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm-48 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarClipboardList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClipboardList",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64h-49.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24v-24h16c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h16zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-32 192a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarClipboardMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClipboardMedical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64h-49.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24v-24h16c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h16zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-8 160v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarClipboardPrescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClipboardPrescription",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64h-49.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24v-24h16c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h16zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-64 124c-11 0-20 9-20 20v144c0 11 9 20 20 20s20-9 20-20v-44h35.7l52 52-25.9 25.9c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0l25.9-25.9 25.9 25.9c7.8 7.8 20.5 7.8 28.3 0s7.8-20.5 0-28.3L268.3 376l25.9-25.9c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L240 347.7l-32.6-32.6c17.2-10.5 28.6-29.5 28.6-51.1 0-33.1-26.9-60-60-60h-72zm72 80h-52v-40h52c11 0 20 9 20 20s-9 20-20 20z"
        }
    ]
};

const FarClipboardQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClipboardQuestion",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64h-49.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24v-24h16c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h16zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-62.2 149.3-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L180 293.6c-7.5 4.3-12.1 12.2-12.1 20.8V328c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM224 416a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarClipboardUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClipboardUser",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64h-49.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24v-24h16c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16h-16c0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h16zm88-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88 208a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FarClipboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClipboard",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 64h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h49.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64h9.6zM64 112c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16h-16v24c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24v-24H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarClockDesk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockDesk",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 224a176 176 0 1 0-352 0 176 176 0 1 0 352 0zM224 0c123.7 0 224 100.3 224 224v240c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V224C0 100.3 100.3 0 224 0zm0 96c13.3 0 24 10.7 24 24v94.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V120c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarClockEightThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockEightThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 0 416 0 208 208 0 1 0-416 0zm464 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0zM232 392v-91.2L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256v136c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarClockEight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockEight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm280-136v136c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l85.3-56.8V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarClockElevenThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockElevenThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 0 416 0 208 208 0 1 0-416 0zm464 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0zM232 392V263.3l-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3v136c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarClockEleven = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockEleven",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v56.7l-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FarClockFiveThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockFiveThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM280 392v-56.7l20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23v136c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarClockFive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockFive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm280-136v128.7l60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarClockFourThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockFourThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM280 392v-91.2l58.7 39.2c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256v136c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarClockNineThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockNineThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM280 392V256c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h80v112c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarClockNine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockNine",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm280-136v136c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarClockOneThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockOneThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM280 392V263.3l60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3v136c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarClockOne = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockOne",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm280-136v56.7l20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarClockRotateLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockRotateLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 106.7V56c0-13.3-10.7-24-24-24S0 42.7 0 56v112c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H80.7c37-57.8 101.7-96 175.3-96 114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5-11-7.3-25.9-4.3-33.3 6.7s-4.3 25.9 6.7 33.3C155.2 496.4 203.8 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM256 128c-13.3 0-24 10.7-24 24v104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarClockSevenThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockSevenThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 0 416 0 208 208 0 1 0-416 0zm464 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0zM232 392v-56.7l-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23v136c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarClockSeven = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockSeven",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v128.7l-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FarClockSixThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockSixThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM280 392V256c0-13.3-10.7-24-24-24s-24 10.7-24 24v136c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarClockSix = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockSix",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm280-136v240c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarClockTenThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockTenThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM280 392V256c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l85.3 56.8V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarClockTen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockTen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FarClockThreeThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockThreeThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 0 416 0 208 208 0 1 0-416 0zm464 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0zM232 392V256c0-13.3 10.7-24 24-24h104c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80v112c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarClockThree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockThree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v136c0 13.3 10.7 24 24 24h104c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FarClockTwelveThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockTwelveThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm280-104v240c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarClockTwelve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockTwelve",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm280-136v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarClockTwoThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockTwoThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 0 416 0 208 208 0 1 0-416 0zm464 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0zM232 392V256c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarClockTwo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClockTwo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm280-136v91.2l58.7-39.2c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FarClone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h224c8.8 0 16-7.2 16-16v-64h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v48H64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm160-160h224c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm-64-16V64c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"
        }
    ]
};

const FarClosedCaptioningSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClosedCaptioningSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9l-38-29.8zM134.4 80H544c8.8 0 16 7.2 16 16v317.6l-92.1-72.2c10.5-5.4 19.9-12.7 27.7-21.4 8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16-1.4 0-2.7-.1-4.1-.2l-41.4-32.5c-1.6-4.8-2.5-10-2.5-15.4 0-26.5 21.5-48 48-48 14.2 0 27 6.1 35.8 16 8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32-45.4 0-83.4 31.5-93.4 73.8l-22.4-17.5c2.9-8.1 1.5-17.4-4.7-24.3-16.6-18.5-40.4-30.6-67-31.9L134.4 80zm353 400-60.9-48H96c-8.8 0-16-7.2-16-16V159l-48-37.8V416c0 35.3 28.7 64 64 64h391.4zM295 328.4l-39.1-30.8c-7 4.1-15.2 6.4-23.9 6.4-26.5 0-48-21.5-48-48 0-4.7.7-9.2 1.9-13.5l-39.1-30.8C139.9 224.9 136 240 136 256c0 53 43 96 96 96 24.1 0 46.2-8.9 63-23.6z"
        }
    ]
};

const FarClosedCaptioning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClosedCaptioning",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm136 176c14.2 0 27 6.1 35.8 16 8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32 8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48 14.2 0 27 6.1 35.8 16 8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32 8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FarClothesHanger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClothesHanger",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M211.4 91.3C221 38.4 267 0 320.8 0 382.2 0 432 49.8 432 111.2v2.9c0 36.5-17.5 70.8-47 92.3l-23.2 16.9L611 391.7c18.1 12.2 29 32.7 29 54.5 0 36.3-29.5 65.8-65.8 65.8H65.8C29.5 512 0 482.5 0 446.2c0-21.9 10.9-42.3 29-54.5l277.2-187.4 50.6-36.8c17.1-12.4 27.2-32.3 27.2-53.5v-2.9c0-34.8-28.3-63.1-63.2-63.1-30.6 0-56.7 21.8-62.2 51.9l-3 16.4c-2.4 13-14.9 21.7-27.9 19.3s-21.7-14.9-19.3-27.9l3-16.4zM320 253 55.8 431.5c-4.9 3.3-7.8 8.8-7.8 14.7 0 9.8 8 17.8 17.8 17.8h508.4c9.8 0 17.8-8 17.8-17.8 0-5.9-2.9-11.4-7.8-14.7L320 253z"
        }
    ]
};

const FarCloudArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudArrowDown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8-.6 0-1.3.1-1.9.2H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 19.2-6.8 32-24.9 32-45.3v-.2c0-66.3 53.7-120 120-120 36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8 0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-92.8 0-168 75.2-168 168v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h368zM223 313l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v134.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
        }
    ]
};

const FarCloudArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudArrowUp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8-.6 0-1.3.1-1.9.2H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 19.2-6.8 32-24.9 32-45.3v-.2c0-66.3 53.7-120 120-120 36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8 0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-92.8 0-168 75.2-168 168v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h368zM223 255c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V384c0 13.3 10.7 24 24 24s24-10.7 24-24V249.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
        }
    ]
};

const FarCloudBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudBinary",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8-.6 0-1.3.1-1.9.2H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 19.2-6.8 32-24.9 32-45.3v-.2c0-66.3 53.7-120 120-120 36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8 0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-92.8 0-168 75.2-168 168v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h368zM176 216v16c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-16c0-22.1-17.9-40-40-40h-16c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8zm72-16c0 8.8 7.2 16 16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm120-16c-22.1 0-40 17.9-40 40v16c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-16c0-22.1-17.9-40-40-40h-16zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16zM192 320c0 8.8 7.2 16 16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm80 24v16c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-16c0-22.1-17.9-40-40-40h-16c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8zm88-32c-8.8 0-16 7.2-16 16s7.2 16 16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16z"
        }
    ]
};

const FarCloudBoltMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudBoltMoon",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361.4 79.9c31.2 18.7 52.5 52.2 54.3 90.8 33.3 15.8 57.6 47.5 63 85.3h2.4c34.9 0 66.7-13.8 89.9-36.1 5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9.8-10 1.3-15.2 1.3-49 0-88.4-39.3-88.4-87.4 0-32.6 18-61.1 44.9-76.1 6.1-3.4 9.3-10.5 7.8-17.4S499 1 492 .4c-3.6-.3-7.3-.5-10.9-.5-54 .1-100.5 33.1-119.7 80zM128.1 160c0-26.5 21.5-48 48-48 22.8 0 41.9 15.9 46.8 37.2 2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9 20.3 0 37.2 15.2 39.7 34.8.1.6.2 1.2.3 1.7v36.1c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3 17.7 0 32 14.3 32 32s-14.3 32-32 32h-74.4l-8 16.1H304c20.3 0 38.4 12.8 45.2 31.9H368c44.2 0 80-35.8 80-80 0-38.7-27.5-71-64-78.4V176c0-2.9-.5-5.7-1.5-8.3-7.6-40.8-43.4-71.7-86.4-71.7-14.7 0-28.5 3.6-40.6 9.9C238.1 80.6 209.1 64 176.1 64c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 169 .1 208.5.1 256c0 43.4 28.8 80 68.3 91.9 3.1-6.6 7.6-12.6 13.6-17.4l33.3-26.6H96.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7.1 4 .2 13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8.1-1.6.1-2.5zm154 67.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8S105.2 384 112 384h70.1l-52.4 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"
        }
    ]
};

const FarCloudBoltSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudBoltSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3-14.6-9-31.8-14.1-50.2-14.1-53 0-96 43-96 96 0 35.5 19.3 66.6 48 83.2.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14-84.6-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9-1.2 4.1-2.2 8.3-3 12.6-37.9 14.6-67.2 46.6-77.8 86.4-12.5-11.8-20.3-28.4-20.3-46.9 0-35.3 28.7-64 64-64zm112.1 48c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9-1.3-.1-2.6-.2-4-.2-26.5 0-48 21.5-48 48 0 20.6 12.9 38.1 31.1 44.9-12.6 11.7-17.9 29.3-14 46-37.9-12.9-65.1-48.7-65.1-90.9 0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8 33 0 62 16.6 79.3 41.9 12.2-6.3 26-9.9 40.6-9.9 43 0 78.8 30.9 86.5 71.7 1 2.6 1.5 5.4 1.5 8.3v17.6c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80h-18.7c3.5-10.1 3.7-21.3 0-31.8-2.1-6.1-5.4-11.6-9.6-16.2h28.4c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1.1-4.6.3-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1v-36.3c-.1-.6-.2-1.1-.3-1.7-2.5-19.6-19.3-34.8-39.7-34.8-12.6 0-23.8 5.8-31.1 14.9-.6.7-1.1 1.3-1.8 1.9-6.1 1.1-12 3.5-17.4 7-1.6 0-3.3-.2-4.9-.6-8.9-2.1-15.9-9.1-18-18-4.9-21.3-24-37.2-46.8-37.2-26.5 0-48 21.5-48 48zm154 35.6c5.8 4.7 7.6 12.9 4.2 19.6L425.9 352H496c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L374.1 384H304c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1z"
        }
    ]
};

const FarCloudBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudBolt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 48c-39.8 0-72 32.2-72 72 0 2.6.1 5.2.4 7.7 1.3 12-6.6 23.1-18.3 25.9C67.6 159.9 48 183.7 48 212c0 32.2 25.3 58.4 57.1 59.9.3 0 .7 0 1 .1h97.1l-60 48H104c-1.2 0-2.4-.1-3.5-.3C44.3 315.9 0 269.1 0 212c0-44.1 26.4-81.9 64.2-98.7C67.7 50.1 120 0 184 0c33.9 0 64.5 14.1 86.3 36.6C285.1 28.6 302 24 320 24c46.9 0 86.5 31 99.5 73.7 52.6 9.2 92.5 55.1 92.5 110.3 0 61.9-50.1 112-112 112h-66.3l24-48H400c35.3 0 64-28.7 64-64s-28.6-64-64-64h-.3c-12.4 0-22.7-9.3-23.9-21.6C372.9 94.1 349 72 320 72c-14.7 0-28.1 5.7-38.1 15-5.3 4.9-12.4 7.2-19.5 6.2s-13.4-5-17.2-11.1C232.5 61.6 209.8 48 184 48zm146.1 179.6c5.8 4.7 7.6 12.9 4.3 19.6L281.9 352H352c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 384H160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1z"
        }
    ]
};

const FarCloudCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8-.6 0-1.3.1-1.9.2H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 19.2-6.8 32-24.9 32-45.3v-.2c0-66.3 53.7-120 120-120 36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8 0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-92.8 0-168 75.2-168 168v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h368zm-79-239c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z"
        }
    ]
};

const FarCloudDrizzle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudDrizzle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 120c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H106.1c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3 26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM88 376c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48zm96 64c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48zm168-24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm-72-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48zm168-24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarCloudExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8-.6 0-1.3.1-1.9.2H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 19.2-6.8 32-24.9 32-45.3v-.2c0-66.3 53.7-120 120-120 36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8 0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-92.8 0-168 75.2-168 168v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h368zM320 144c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCloudFog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudFog",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 120c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H170.1c-.3 0-.7-.1-1-.1-31.8-1.4-57.1-27.6-57.1-59.8 0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zM248 0c-64 0-116.3 50.1-119.8 113.3C90.4 130.1 64 167.9 64 212c0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3C470.5 55 430.9 24 384 24c-18 0-34.9 4.6-49.7 12.6C312.5 14.1 281.9 0 248 0zM0 392c0 13.3 10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm64 96c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm208 0c0 13.3 10.7 24 24 24h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H296c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarCloudHailMixed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudHailMixed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 120c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H106.1c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3 26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3.4-31.5 12.6l-10.3 24c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24c5.2-12.2-.4-26.3-12.6-31.5zm120 0c-12.2-5.2-26.3.4-31.5 12.6l-48 112c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm232 0c-12.2-5.2-26.3.4-31.5 12.6l-48 112c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm-107.4 31.6c5.2-12.2-.4-26.3-12.6-31.5s-26.3.4-31.5 12.6l-10.3 24c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm256-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCloudHail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudHail",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 120c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H106.1c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3 26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zm-24 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCloudMeatball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudMeatball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 49.2c-38.7 0-72 33.3-72 76.8 0 2.8.1 5.6.4 8.4 1.2 11.9-6.5 22.8-18.1 25.7-25.8 6.4-46.3 31.4-46.3 62.5 0 35.5 26.4 62.6 57.2 64.1.3 0 .7 0 1 .1h65.1c-18.3 9.2-31.6 27-34.6 48H104c-1.2 0-2.4-.1-3.6-.3C43.3 330.4 0 280.9 0 222.6c0-45.2 25.9-84.9 64.1-102.6C67.1 54.9 118.6 1.2 184 1.2c34.2 0 64.8 14.8 86.4 38.2 14.7-8.3 31.6-13 49.6-13 47.9 0 87.2 33.2 99.7 77.4 53.2 9.7 92.3 58.2 92.3 114.6 0 63.2-49.1 116.4-112 116.4h-24.7c-3-21-16.3-38.8-34.6-48H400c34.3 0 64-29.5 64-68.4S434.3 150 400 150h-.3c-12.4 0-22.8-9.4-23.9-21.7-3-31.2-27.7-53.9-55.7-53.9-14.4 0-27.6 5.8-37.7 15.6-5.3 5.1-12.6 7.6-19.9 6.6S248.8 91.4 245 85c-13-21.9-35.7-35.9-60.9-35.9zM288 320c0 1-.1 2.1-.1 3.1.7-.8 1.3-1.6 2.1-2.3 12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-.7.7-1.5 1.4-2.3 2.1 1-.1 2.1-.2 3.1-.2 17.7 0 32 14.3 32 32s-14.3 32-32 32c-1 0-2.1-.1-3.1-.1.8.7 1.6 1.3 2.3 2.1 12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0c-.7-.7-1.4-1.5-2.1-2.3.1 1 .1 2.1.1 3.1 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1 .1-2.1.1-3.1-.7.8-1.3 1.6-2.1 2.3-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3c.7-.7 1.5-1.4 2.3-2.1-1 .1-2.1.1-3.1.1-17.7 0-32-14.3-32-32s14.3-32 32-32c1 0 2.1.1 3.1.1-.8-.6-1.6-1.3-2.3-2.1-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c.7.7 1.4 1.5 2.1 2.3-.1-1-.1-2.1-.1-3.1 0-17.7 14.3-32 32-32s32 14.3 32 32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm416 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarCloudMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudMinus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8-.6 0-1.3.1-1.9.2H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 19.2-6.8 32-24.9 32-45.3v-.2c0-66.3 53.7-120 120-120 36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8 0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-92.8 0-168 75.2-168 168v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h368zM248 264c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
        }
    ]
};

const FarCloudMoonRain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudMoonRain",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M353.6 107.6c35.4 17.6 60.2 53.3 62.1 95.1 23.2 11 42 29.7 53.1 52.7 4 .4 8.2.6 12.3.6 34.9 0 66.7-13.8 89.9-36.1 5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9.8-10 1.3-15.2 1.3-49 0-88.4-39.3-88.4-87.4 0-32.6 18-61.1 44.9-76.1 6.1-3.4 9.3-10.5 7.8-17.4S499 1 492 .4c-3.6-.3-7.3-.5-10.9-.5C417 0 363.5 46.5 353.6 107.6zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zM128.1 192c0-26.5 21.5-48 48-48 22.8 0 41.9 15.9 46.8 37.2 2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9 20.3 0 37.2 15.2 39.7 34.8.1.6.2 1.2.3 1.7v36.1c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3 17.7 0 32 14.3 32 32s-14.3 32-32 32h-272c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7.1 4 .2 13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8.1-1.6.1-2.5zm48-96c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 201 .1 240.5.1 288c0 53 43 96 96 96 1.1 0 2.2 0 3.2-.1H368c44.2 0 80-35.8 80-80 0-38.7-27.5-71-64-78.4V208c0-2.9-.5-5.7-1.5-8.3-7.7-40.8-43.4-71.7-86.5-71.7-14.7 0-28.5 3.6-40.6 9.9-17.3-25.3-46.3-41.9-79.3-41.9z"
        }
    ]
};

const FarCloudMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudMoon",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M495.8 0C389.8 0 304 86.1 304 192.2c0 10.8.9 21.5 2.6 31.8 58.8 1.4 106.4 48.2 109.2 106.7 22.8 10.8 41.4 29.1 52.6 51.7 8.9 1.3 18.1 1.9 27.4 1.9 52 0 99.1-20.7 133.6-54.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.1-25.1 2.1-80.7 0-146.2-65.6-146.2-146.6 0-54.8 30-102.6 74.4-127.8 6.1-3.5 9.2-10.5 7.7-17.3S519 1.3 512 .7c-5.4-.5-10.8-.7-16.3-.7zM128.1 320c0-26.5 21.5-48 48-48 22.8 0 41.9 15.9 46.8 37.2 2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9 20.3 0 37.2 15.2 39.7 34.8.1.6.2 1.2.3 1.7v36.1c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3 17.7 0 32 14.3 32 32s-14.3 32-32 32h-272c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7.1 4 .2 13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8.1-1.6.1-2.5zm48-96c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 329 .1 368.5.1 416c0 53 43 96 96 96 1.1 0 2.2 0 3.2-.1H368c44.2 0 80-35.8 80-80 0-38.7-27.5-71-64-78.4V336c0-2.9-.5-5.7-1.5-8.3-7.7-40.8-43.4-71.7-86.5-71.7-14.7 0-28.5 3.6-40.6 9.9-17.3-25.3-46.3-41.9-79.3-41.9z"
        }
    ]
};

const FarCloudMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8-.6 0-1.3.1-1.9.2H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 19.2-6.8 32-24.9 32-45.3v-.2c0-66.3 53.7-120 120-120 36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8 0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-92.8 0-168 75.2-168 168v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h368zm-96-296c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V275.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V184z"
        }
    ]
};

const FarCloudPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudPlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8-.6 0-1.3.1-1.9.2H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 19.2-6.8 32-24.9 32-45.3v-.2c0-66.3 53.7-120 120-120 36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8 0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-92.8 0-168 75.2-168 168v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h368zM296 376c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FarCloudQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8-.6 0-1.3.1-1.9.2H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 19.2-6.8 32-24.9 32-45.3v-.2c0-66.3 53.7-120 120-120 36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8 0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-92.8 0-168 75.2-168 168v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h368zM233.8 197.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L308 261.6c-7.5 4.3-12.1 12.2-12.1 20.8V296c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM352 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCloudRain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudRain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 120c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H106.1c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3 26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM89.2 372l-35 64.6c-4.1 7.5-6.2 15.9-6.2 24.4v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3l-35-64.7c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4zm160 0-35.1 64.6c-4.1 7.5-6.2 15.8-6.2 24.3v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3L262.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4zm124.9 64.6c-4.1 7.5-6.2 15.8-6.2 24.3v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3L422.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-35.1 64.6z"
        }
    ]
};

const FarCloudRainbow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudRainbow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M291.5 195.2C344.7 107 441.5 48 552 48c13.3 0 24-10.7 24-24S565.3 0 552 0C420.9 0 306.5 71.7 245.9 178.1c10.8 6 20.8 13.4 29.6 21.9 5.2-1.9 10.5-3.5 16-4.8zM394.6 216c38.1-44.1 94.5-72 157.4-72 13.3 0 24-10.7 24-24s-10.7-24-24-24c-82.4 0-155.7 38.9-202.5 99.4 16.5 3.9 31.8 11 45.2 20.6zm42.9 53.3c9.8 2.8 19.2 6.7 28 11.6 20.6-25 51.7-40.9 86.5-40.9 13.3 0 24-10.7 24-24s-10.7-24-24-24c-50.1 0-94.8 23-124.1 59.1 3.7 5.8 6.9 11.8 9.7 18.2zM112 312c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H106.1c-.3 0-.7-.1-1-.1C73.3 462.4 48 436.2 48 404c0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zm72-120c-64 0-116.3 50.1-119.8 113.3C26.4 322.1 0 359.9 0 404c0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3-13-42.7-52.6-73.7-99.5-73.7-18 0-34.9 4.6-49.7 12.6-21.8-22.5-52.4-36.6-86.3-36.6z"
        }
    ]
};

const FarCloudShowersHeavy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudShowersHeavy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 120c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H106.1c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3 26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3.4-31.5 12.6l-48 112c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm120 0c-12.2-5.2-26.3.4-31.5 12.6l-48 112c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm244.6 31.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3.4-31.5 12.6l-48 112c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112zm-132.6-31.5c-12.2-5.2-26.3.4-31.5 12.6l-48 112c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5z"
        }
    ]
};

const FarCloudShowersWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudShowersWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184.1 107.8c2.2-33.4 30-59.8 63.9-59.8 23.4 0 43.9 12.6 55.1 31.5 3.4 5.7 9 9.8 15.5 11.2s13.3.1 18.8-3.7c6.4-4.4 14.2-7 22.6-7 19.1 0 35.2 13.4 39.1 31.4 2.4 11 12.2 18.9 23.4 18.9h10.6c17 0 30.9 13.8 30.9 30.9s-13.8 30.9-30.9 30.9H142.9c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9h17.3c12.7 0 23.1-9.8 24-22.5zM248 0c-51.6 0-95 34.9-108 82.3-42.2 1.5-76 36.2-76 78.8 0 43.6 35.3 78.9 78.9 78.9h290.2c43.6 0 78.9-35.3 78.9-78.9 0-41.4-31.8-75.3-72.4-78.6C425.6 52.7 395.2 32 360 32c-10.1 0-19.9 1.7-28.9 4.9C310.6 14.3 281 0 248 0zM132.6 308.3c6.8-11.4 3.1-26.1-8.2-32.9s-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80zm327.8-32.9c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zm-215.8 32.9c6.8-11.4 3.1-26.1-8.2-32.9s-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80zm103.8-32.9c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0-17.2 14.9-39 26.7-61.2 31.7C5.9 464.7-2.3 477.5.6 490.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"
        }
    ]
};

const FarCloudShowers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudShowers",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 120c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H106.1c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3 26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zm-72 352c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24zm192 0c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24zm-72 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80zm168-24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarCloudSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-33.4-26.2C623.6 418.1 640 383 640 344c0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-48.5 0-92.1 20.5-122.8 53.4L38.8 5.1zm140.4 110C200.9 93.4 230.9 80 264 80c36.3 0 68.8 16.1 90.9 41.7 13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 27.8-12.9 52.6-33.1 68.8L179.2 115.1zM426.5 432H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 16.4-5.8 28.2-19.9 31.2-36.6l-45.1-35.6C96.7 182 96 190.9 96 200v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h343.4l-60.9-48z"
        }
    ]
};

const FarCloudSleet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudSleet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 120c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H106.1c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3 26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3.4-31.5 12.6l-48 112c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm272 0c-12.2-5.2-26.3.4-31.5 12.6l-48 112c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zM216 376c0-13.3-10.7-24-24-24s-24 10.7-24 24v16h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-16zm256 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v16h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-16z"
        }
    ]
};

const FarCloudSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudSnow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 120c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H106.1c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3 26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM64 352c-13.3 0-24 10.7-24 24v16H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H88v-16c0-13.3-10.7-24-24-24zm192 32c-13.3 0-24 10.7-24 24v16h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-16c0-13.3-10.7-24-24-24zm216-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v16h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-16z"
        }
    ]
};

const FarCloudSunRain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudSunRain",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3-14.6-9-31.8-14.1-50.2-14.1-53 0-96 43-96 96 0 35.6 19.3 66.6 48 83.2.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14-84.6-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9-1.2 4.1-2.2 8.3-3 12.6-37.9 14.6-67.2 46.6-77.8 86.4-12.5-11.8-20.3-28.4-20.3-46.9 0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zM320.1 192c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9-1.3-.1-2.6-.2-4-.2-26.5 0-48 21.5-48 48s21.5 48 48 48h272c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1.1-4.6.3-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1v-36.2c-.1-.6-.2-1.1-.3-1.7-2.5-19.6-19.3-34.8-39.7-34.8-12.6 0-23.8 5.8-31.1 14.9-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9 12.2-6.3 26-9.9 40.6-9.9 43 0 78.8 30.9 86.5 71.7 1 2.6 1.5 5.4 1.5 8.3v17.6c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80H291.3c-1.1 0-2.1.1-3.2.1-53 0-96-43-96-96 0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z"
        }
    ]
};

const FarCloudSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1L317.9 98l84.7 14.1c5.4.9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2-23.3 0-45.1 6.2-64 17.1v-1.1c0-53-43-96-96-96s-96 43-96 96 43 96 96 96c8.1 0 15.9-1 23.4-2.9-36.6 18.1-63.3 53.1-69.8 94.9L137.1 413c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14-84.6-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm176.1 112c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9-1.3-.1-2.6-.2-4-.2-26.5 0-48 21.5-48 48s21.5 48 48 48h272c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1.1-4.6.3-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1v-36.2c-.1-.6-.2-1.1-.3-1.7-2.5-19.6-19.3-34.8-39.7-34.8-12.6 0-23.8 5.8-31.1 14.9-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9 12.2-6.3 26-9.9 40.6-9.9 43 0 78.8 30.9 86.5 71.7 1 2.6 1.5 5.4 1.5 8.3v17.6c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80H291.3c-1.1 0-2.1.1-3.2.1-53 0-96-43-96-96 0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z"
        }
    ]
};

const FarCloudWord = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudWord",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120v.2c0 20.4-12.8 38.5-32 45.3-37.4 13.2-64 48.8-64 90.5 0 53 43 96 96 96h363.3c.6-.1 1.3-.1 1.9-.2 46.2-2.7 82.8-41 82.8-87.8 0-36-21.6-67.1-52.8-80.7-20.1-8.8-31.6-30-28.1-51.7.6-3.8.9-7.7.9-11.7 0-39.8-32.2-72-72-72-10.5 0-20.4 2.2-29.2 6.2zM512 479.8v.2H144C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8v-.2c0-92.8 75.2-168 168-168 50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120 0 6.6-.5 13-1.5 19.3 48 21 81.5 68.9 81.5 124.7 0 72.4-56.6 131.6-128 135.8zm0-111.8c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h192c8.8 0 16 7.2 16 16zm-272-16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h96zm-112-48c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm272-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarCloudXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5 8.9-3.9 18.7-6.2 29.2-6.2 39.8 0 72 32.2 72 72 0 4-.3 7.9-.9 11.7-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8-.6 0-1.3.1-1.9.2H144c-53 0-96-43-96-96 0-41.7 26.6-77.3 64-90.5 19.2-6.8 32-24.9 32-45.3v-.2c0-66.3 53.7-120 120-120 36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8 0-55.7-33.5-103.7-81.5-124.7 1-6.3 1.5-12.8 1.5-19.3 0-66.3-53.7-120-120-120-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-92.8 0-168 75.2-168 168v.2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144h368zM239 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120v.2c0 20.4-12.8 38.5-32 45.3-37.4 13.2-64 48.8-64 90.5 0 53 43 96 96 96h363.3c.6-.1 1.3-.1 1.9-.2 46.2-2.7 82.8-41 82.8-87.8 0-36-21.6-67.1-52.8-80.7-20.1-8.8-31.6-30-28.1-51.7.6-3.8.9-7.7.9-11.7 0-39.8-32.2-72-72-72-10.5 0-20.4 2.2-29.2 6.2zM512 479.8v.2H144C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8v-.2c0-92.8 75.2-168 168-168 50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120 0 6.6-.5 13-1.5 19.3 48 21 81.5 68.9 81.5 124.7 0 72.4-56.6 131.6-128 135.8z"
        }
    ]
};

const FarCloudsMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudsMoon",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 160c0 11.5 1.2 22.7 3.5 33.4 53.7 8.2 96.5 49.8 106.4 103 14.2 5.5 27.2 13.4 38.5 23.2 3.7.3 7.4.4 11.2.4 43.2 0 82.5-17.3 111.2-45.3 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7-64.3 0-116.5-52.3-116.5-116.9 0-43.7 23.9-81.8 59.3-101.9 6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1.6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160zm-16.2 112c26.5 0 48 21.5 48 48 0 .8 0 1.7.1 2.5l2 23.8c1.1 13.2 12.7 23 25.9 21.9 1.3-.1 2.6-.2 4-.2 26.5 0 48 21.5 48 48s-21.5 48-48 48h-272c-17.7 0-32-14.3-32-32s14.3-32 32-32c1.6 0 3.1.1 4.6.3 6.9 1 13.9-1.1 19.1-5.6s8.3-11.2 8.3-18.1v-36.2c.1-.6.2-1.1.3-1.7 2.5-19.6 19.3-34.8 39.7-34.8 12.6 0 23.8 5.8 31.1 14.9 5.8 7.1 15.1 10.4 24.1 8.3s15.9-9.1 18-18c4.9-21.3 24-37.2 46.8-37.2zm96 46.8c-.6-52.5-43.4-94.8-96-94.8-33 0-62 16.6-79.3 41.9-12.2-6.3-26-9.9-40.6-9.9-43 0-78.8 30.9-86.5 71.7-1 2.6-1.5 5.4-1.5 8.3v17.6c-36.5 7.4-64 39.7-64 78.4 0 44.2 35.8 80 80 80h268.7c1.1 0 2.1.1 3.2.1 53 0 96-43 96-96 0-47.5-34.5-86.9-79.8-94.6l-.2-2.5zM320 192.1c0-35.3-28.6-64-64-64-7.4 0-14.6 1.3-21.2 3.6-11.5-30.1-40.6-51.6-74.8-51.6-38.9 0-71.3 27.8-78.5 64.6-3.1-.4-6.3-.6-9.5-.6-39.8 0-72 32.2-72 72s32.2 72 72 72h34.8c9.4-19.9 24.6-36.6 43.4-48H72.1c-13.2 0-24-10.7-24-24s10.7-24 24-24c1.1 0 2.2.1 3.2.2 25.1 3.3 48.5-13.5 53.4-38.4 2.9-14.7 15.9-25.8 31.4-25.8 13.6 0 25.3 8.5 29.9 20.6 9.2 24.3 36.2 36.9 60.8 28.2 1.6-.6 3.4-.9 5.3-.9 8.8 0 16 7.2 16 16v.9c-.1 6.6-1.6 12.9-4.1 18.6 15.5-9.7 33.2-16.3 52.1-18.7v-.9z"
        }
    ]
};

const FarCloudsSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCloudsSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1L317.9 98l30.7 5.1c-26.4 10.6-47 32.6-55.7 59.9-16.1-30.3-48.1-51-84.9-51-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17.1c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14.1-84.7-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm409.8 32.1H568c13.2 0 24-10.7 24-24s-10.7-24-24-24c-1.1 0-2.2.1-3.2.2-25.1 3.3-48.5-13.5-53.4-38.4-2.9-14.7-15.9-25.8-31.4-25.8-13.6 0-25.3 8.5-29.9 20.6-9.2 24.3-36.2 36.9-60.8 28.2-1.6-.6-3.4-.9-5.3-.9-8.8 0-15.9 7.1-16 15.9h-.1c-16.7 0-32.6 3.2-47.3 9-.4-2.9-.6-5.9-.6-8.9 0-35.3 28.6-64 64-64 7.4 0 14.6 1.3 21.2 3.6C416.7 101.5 445.8 80 480 80c38.9 0 71.3 27.8 78.5 64.6 3.1-.4 6.3-.6 9.5-.6 39.8 0 72 32.2 72 72 0 30.4-18.8 56.3-45.4 66.9-9.5-17.7-23.6-32.5-40.8-42.9zM320.1 320c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9-1.3-.1-2.6-.2-4-.2-26.5 0-48 21.5-48 48s21.5 48 48 48h272c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1.1-4.6.3-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1v-36.2c-.1-.6-.2-1.1-.3-1.7-2.5-19.6-19.3-34.8-39.7-34.8-12.6 0-23.8 5.8-31.1 14.9-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9 12.2-6.3 26-9.9 40.6-9.9 43 0 78.8 30.9 86.5 71.7 1 2.6 1.5 5.4 1.5 8.3v17.6c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80H291.3c-1.1 0-2.1.1-3.2.1-53 0-96-43-96-96 0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z"
        }
    ]
};

const FarClouds = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClouds",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 112v2c-.3 10.3 6 19.7 15.6 23.2s20.5.6 27-7.4c8.8-10.9 22.3-17.9 37.4-17.9 26.5 0 48 21.5 48 48 0 8.7-2.3 16.8-6.3 23.8 3.6 2.3 7.1 4.8 10.6 7.4 12.8-4.4 26.5-6.8 40.7-7.2 2-7.7 3-15.7 3-24 0-53-43-96-96-96-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0 151.6 0 104.9 41.7 97.1 96H96c-53 0-96 43-96 96s43 96 96 96h65.9c2.7-17.1 8.3-33.3 16.2-48H96c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.4 1 16.6 2.9 7.9 2.9 16.8 1.5 23.4-3.8s9.9-13.7 8.7-22c-.4-2.9-.6-6-.6-9.1 0-35.3 28.7-64 64-64s64 28.7 64 64zm-32 200c0-39.8 32.2-72 72-72 25.8 0 48.5 13.6 61.2 34 3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15 29 0 52.9 22.1 55.7 50.4 1.2 12.3 11.6 21.7 23.9 21.6h.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H234.1c-.3 0-.7-.1-1-.1-31.8-1.4-57.1-27.6-57.1-59.8 0-28.3 19.6-52.1 46.1-58.4 11.8-2.8 19.6-13.9 18.3-25.9-.3-2.5-.4-5.1-.4-7.7zm72-120c-64 0-116.3 50.1-119.8 113.3-37.8 16.8-64.2 54.6-64.2 98.7 0 57.1 44.3 103.9 100.5 107.7 1.2.2 2.3.3 3.5.3h296c61.9 0 112-50.1 112-112 0-55.2-39.9-101.1-92.5-110.3-13-42.7-52.6-73.7-99.5-73.7-18 0-34.9 4.6-49.7 12.6-21.8-22.5-52.4-36.6-86.3-36.6z"
        }
    ]
};

const FarClover = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClover",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M174.4 80c-14.4 0-26 11.7-26 26 0 6.6 1.7 13.2 5 18.9l35.6 63.2c5.3 9.4 3.7 21.1-3.9 28.8s-19.4 9.2-28.8 3.9L93 185.3c-5.8-3.3-12.3-5-18.9-5-14.4 0-26 11.7-26 26v2.7c0 7.6 3 14.9 8.4 20.3l9.8 9.8c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-9.8 9.8C51 288.2 48 295.4 48 303v2.6c0 14.4 11.7 26 26 26 6.6 0 13.2-1.7 18.9-5l63.2-35.6c9.4-5.3 21.1-3.7 28.8 3.9s9.2 19.4 3.9 28.8L153.3 387c-3.3 5.8-5 12.3-5 18.9 0 14.4 11.7 26 26 26h2.7c7.6 0 14.9-3 20.3-8.4l9.8-9.8c4.5-4.5 10.6-7 17-7s12.5 2.5 17 7l9.8 9.8c5.4 5.4 12.7 8.4 20.3 8.4h2.6c14.4 0 26-11.7 26-26 0-6.6-1.7-13.2-5-18.9l-35.6-63.2c-5.3-9.4-3.7-21.1 3.9-28.8s19.4-9.2 28.8-3.9l63.1 35.6c5.8 3.3 12.3 5 18.9 5 14.4 0 26-11.7 26-26V303c0-7.6-3-14.9-8.4-20.3l-9.8-9.8c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l9.8-9.8c5.4-5.4 8.4-12.7 8.4-20.3V206c0-14.3-11.6-25.9-25.9-25.9-6.7 0-13.3 1.7-19.1 5.1L293 220.7c-9.3 5.3-21.1 3.8-28.7-3.7s-9.4-19.2-4.2-28.7l34.7-63.4c3.1-5.7 4.8-12.2 4.8-18.7 0-14.6-11.8-26.4-26.4-26.4H271c-7.6 0-14.9 3-20.3 8.4l-9.7 10c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-9.8-9.8C191.8 83 184.6 80 177 80h-2.6zm-74 26c0-40.9 33.2-74 74-74h2.6c17.1 0 33.7 5.7 47 16.1C237.4 37.7 253.9 32 271 32h2.3c41.1 0 74.4 33.3 74.4 74.4 0 11.1-2.1 22.1-6.3 32.4 10.3-4.2 21.4-6.4 32.7-6.4 40.8 0 73.9 33.1 73.9 73.9v2.7c0 17.1-5.7 33.7-16.1 47 10.4 13.4 16.1 29.9 16.1 47v2.6c0 40.9-33.2 74-74 74-11.2 0-22.3-2.2-32.7-6.4 4.2 10.3 6.4 21.4 6.4 32.7 0 40.9-33.2 74-74 74H271c-17.1 0-33.7-5.7-47-16.1a76.607 76.607 0 0 1-47 16.1h-2.6c-40.9 0-74-33.2-74-74 0-11.2 2.2-22.3 6.4-32.7-10.3 4.2-21.4 6.4-32.7 6.4-40.9 0-74-33.2-74-74V303c0-17.1 5.7-33.7 16.1-47C5.7 242.6 0 226.1 0 209v-2.6c0-40.9 33.2-74 74-74 11.2 0 22.3 2.2 32.7 6.4-4.2-10.3-6.4-21.4-6.4-32.7z"
        }
    ]
};

const FarClub = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarClub",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 146.4V144c0-53-43-96-96-96s-96 43-96 96v2.4c.6 22.9-15.1 42.9-37.4 48-42.7 9.7-74.6 48-74.6 93.6 0 53 43 96 96 96 30.1 0 57-13.8 74.7-35.7 9.1-11.3 22.8-17.8 37.3-17.8s28.2 6.5 37.3 17.8C311 370.2 337.9 384 368 384c53 0 96-43 96-96 0-45.6-31.9-83.9-74.6-93.6-22.3-5.1-37.9-25.1-37.4-48zM368 432c-27.9 0-53.9-7.9-76-21.7-4.1-2.6-8.1-5.4-12-8.3v62h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-62c-3.8 3-7.8 5.8-12 8.3-22.1 13.7-48.1 21.7-76 21.7C64.5 432 0 367.5 0 288c0-68.5 47.9-125.9 112-140.4V144C112 64.5 176.5 0 256 0s144 64.5 144 144v3.6c64.1 14.5 112 71.9 112 140.4 0 79.5-64.5 144-144 144z"
        }
    ]
};

const FarCoconut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoconut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M274.5 55.3c42.7-13.2 71.9-7.4 86.7 7.5s20.6 44 7.5 86.7c-12.8 41.5-42.1 89.6-85.8 133.3s-91.8 73-133.3 85.8c-42.7 13.2-71.9 7.4-86.7-7.5s-20.6-44-7.5-86.7c12.8-41.5 42.1-89.6 85.8-133.3s91.8-73 133.3-85.8zm120.7-26.4C361.5-4.8 309.6-5.7 260.4 9.5 210 25 155.3 59.1 107.2 107.2S25 210 9.5 260.4C-5.7 309.6-4.8 361.5 28.9 395.2l41 41C118.4 484.7 184.3 512 253 512c143 0 259-116 259-259 0-68.7-27.3-134.6-75.9-183.2l-40.9-40.9zm27.4 98.5c23.7 32 37.9 70.2 40.9 110.1L457 231c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l35.6 35.6c-7.2 31.1-21.2 59.6-40.4 83.7L377 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l41.2 41.2c-24.2 19.2-52.6 33.3-83.7 40.4L265 423c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l6.5 6.5c-39.9-2.9-78.1-17.2-110.1-40.9 12.1-1.5 24.2-4.3 36.3-8 50.4-15.5 105-49.7 153.1-97.8s82.2-102.7 97.8-153.1c3.7-12 6.5-24.2 8-36.3zM256 256c62.5-62.5 92.9-133.4 67.9-158.4S228 103 165.5 165.5 72.6 298.9 97.6 323.9s95.9-5.4 158.4-67.9z"
        }
    ]
};

const FarCodeBranch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCodeBranch",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3V256c20.1-15.1 45-24 72-24h96c39.8 0 72-32.2 72-72v-3.7c-32.5-10.2-56-40.5-56-76.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3v3.7c0 66.3-53.7 120-120 120h-96c-39.8 0-72 32.2-72 72v3.7c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80S0 476.2 0 432c0-35.8 23.5-66.1 56-76.3V156.3C23.5 146.1 0 115.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80zm240 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM80 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarCodeCommit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCodeCommit",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm158.2-88c-11.6 77-78 136-158.2 136s-146.6-59-158.2-136H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h137.8c11.6-77 78-136 158.2-136s146.6 59 158.2 136H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H478.2z"
        }
    ]
};

const FarCodeCompare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCodeCompare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1S320 334.5 320 344v48h16c39.8 0 72-32.2 72-72V156.3c-32.5-10.2-56-40.5-56-76.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V320c0 66.3-53.7 120-120 120h-16v48zM464 80a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM192 24c0-9.5 5.6-18.1 14.2-21.9S225-.2 232 6.2l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1S192 177.5 192 168v-48h-16c-39.8 0-72 32.2-72 72v163.7c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80S0 476.2 0 432c0-35.8 23.5-66.1 56-76.3V192c0-66.3 53.7-120 120-120h16V24zM48 432a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FarCodeFork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCodeFork",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3V192c0 22.1 17.9 40 40 40h160c22.1 0 40-17.9 40-40v-35.7c-32.5-10.2-56-40.5-56-76.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V192c0 48.6-39.4 88-88 88h-56v75.7c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V280h-56c-48.6 0-88-39.4-88-88v-35.7C23.5 146.1 0 115.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80zm208 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 432a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCodeMerge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCodeMerge",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24.7 108.1C136.8 145.7 160 115.6 160 80c0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.4C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3V254.9c27.2 25.5 63.8 41.1 104 41.1h83.7c10.2 32.5 40.5 56 76.3 56 44.2 0 80-35.8 80-80s-35.8-80-80-80c-35.8 0-66.1 23.5-76.3 56H208c-53.3 0-97.3-40.2-103.3-91.9zM80 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256-128a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarCodePullRequestClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCodePullRequestClosed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm48 0c0 35.8-23.5 66.1-56 76.3v199.4c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V156.3C55.5 146.1 32 115.8 32 80c0-44.2 35.8-80 80-80s80 35.8 80 80zm-80 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 48c-44.2 0-80-35.8-80-80 0-35.8 23.5-66.1 56-76.3V224c0-13.3 10.7-24 24-24s24 10.7 24 24v131.7c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80zM327 7c9.4-9.4 24.6-9.4 33.9 0l39 39L439 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L327 41c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarCodePullRequestDraft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCodePullRequestDraft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm56 76.3c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.4C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3V156.3zM48 432a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm320-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm48-432a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarCodePullRequest = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCodePullRequest",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M305.8 2.1C314.4 5.9 320 14.5 320 24v48h16c66.3 0 120 53.7 120 120v163.7c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V192c0-39.8-32.2-72-72-72h-16v48c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM112 80a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-8 76.3v199.4c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80S0 476.2 0 432c0-35.8 23.5-66.1 56-76.3V156.3C23.5 146.1 0 115.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3zm8 275.7a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm320 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarCodeSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCodeSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216.6 105.4c9.6-9.2 9.9-24.3.8-33.9s-24.3-9.9-33.9-.8l-176 168C2.7 243.2 0 249.4 0 256s2.7 12.8 7.4 17.4l176 168c9.6 9.2 24.8 8.8 33.9-.8s8.8-24.8-.8-33.9L58.8 256l157.8-150.6zm142.9 0L517.2 256 359.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9.8l176-168c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9.8s-8.8 24.8.8 33.9z"
        }
    ]
};

const FarCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCode",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M399.1 1.1c-12.7-3.9-26.1 3.1-30 15.8l-144 464c-3.9 12.7 3.1 26.1 15.8 30s26.1-3.1 30-15.8l144-464c3.9-12.7-3.1-26.1-15.8-30zm71.4 118.5c-9.1 9.7-8.6 24.9 1.1 33.9L580.9 256 471.6 358.5c-9.7 9.1-10.2 24.3-1.1 33.9s24.3 10.2 33.9 1.1l128-120c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-13-7.6-17.5l-128-120c-9.7-9.1-24.9-8.6-33.9 1.1zm-301 0c-9.1-9.7-24.3-10.2-33.9-1.1l-128 120C2.7 243 0 249.4 0 256s2.7 13 7.6 17.5l128 120c9.7 9.1 24.9 8.6 33.9-1.1s8.6-24.9-1.1-33.9L59.1 256l109.3-102.5c9.7-9.1 10.2-24.3 1.1-33.9z"
        }
    ]
};

const FarCoffeeBean = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoffeeBean",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M385.4 134.2c-13.2 27.4-29.7 55.9-48.4 74.7-34.5 34.8-69.6 52.3-101.5 68.2l-.8.4c-32.1 16-61 30.6-89.7 59.4-16.5 16.6-34.2 46.5-49.4 76.9 22.9 13.6 52.9 19.1 87.6 14.1 45.5-6.5 96.1-30.9 138.9-73.8s67.3-93.4 73.8-138.9c4.5-31.5.4-59.1-10.5-81zm-34.9-39c-23.2-14.8-54.2-20.9-90.3-15.8-45.5 6.5-96.1 30.9-138.9 73.8s-67.3 93.5-73.8 139c-4.8 33.6.2 62.7 12.8 85.3 14.6-27.4 32.1-55.8 50.7-74.4 34.5-34.8 69.6-52.3 101.5-68.2l.8-.4c32.1-16 61-30.6 89.7-59.4 16.8-16.9 33.6-48.3 47.5-79.8zM401 74.5c74.2 74.2 54.2 214.6-44.8 313.6s-239.4 119-313.6 44.8-54.2-214.6 44.8-313.6S326.8.3 401 74.5z"
        }
    ]
};

const FarCoffeeBeans = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoffeeBeans",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8 210.6 173 273.1 235.4 426.8 308 476.8 258zm-46.6-46.7c3.5 4.1 7 9.2 10.4 14.9-25.8 22.7-83.8 25-133.5-24.7-28-28-39.5-58.7-40.1-84.8 27.8 29.1 60 40.6 87.3 50.3l1.4.5c30.2 10.8 54.3 19.8 74.6 43.8zm-10-123c28 28 39.5 58.7 40.1 84.8-27.8-29.1-60-40.6-87.3-50.3l-1.4-.5c-30.2-10.8-54.3-19.8-74.6-43.8-3.5-4.1-7-9.2-10.4-14.9 25.8-22.7 83.8-25 133.5 24.7zM128.1 446c-.4 5.4-1.6 11.5-3.1 17.9-34.3-2.2-77-41.6-77-111.9 0-39.7 13.6-69.5 31.6-88.3-.9 40.2 13.7 71.1 26.1 97.3l.6 1.3c13.7 29 24.4 52.4 21.8 83.7zm79.9-94c0 39.7-13.6 69.5-31.6 88.3.9-40.2-13.7-71.1-26.1-97.3l-.6-1.3c-13.7-29-24.4-52.4-21.8-83.7.4-5.4 1.6-11.5 3.1-17.9 34.3 2.2 77 41.6 77 111.9zm-80 160c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z"
        }
    ]
};

const FarCoffeePot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoffeePot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 80c-22.1 0-40 17.9-40 40v80c0 13.3-10.7 24-24 24S0 213.3 0 200v-80c0-48.6 39.4-88 88-88h365.6c14.6 0 26.4 11.8 26.4 26.4 0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9v8c0 55.5-34.6 99.4-55.9 121.2-9.9 10.1-23.8 14.8-38.1 14.8H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344v-8c0-65.4 32.7-123.2 82.7-157.9L103.1 80H88zm296.8 80 35.6-80H155.6l35.6 80h193.6zm1.2 48H190c-41.8 21.6-71.7 63.1-77.1 112h350.2c-5.4-48.9-35.3-90.4-77.1-112zm32.2 224H157.7h260.5z"
        }
    ]
};

const FarCoffinCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoffinCross",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M140.1 464h103.8l91.9-318.2L250.2 48H133.8l-85.6 97.8L140.1 464zM11.5 114.9l91-104c6-6.9 14.8-10.9 24-10.9h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6 0 4.4-.6 8.7-1.8 12.9l-95.6 330.5c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6zM216 120v40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v120c0 13.3-10.7 24-24 24s-24-10.7-24-24V208h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-40c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarCoffin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoffin",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48.2 145.8 133.8 48h116.4l85.6 97.8L243.9 464H140.1L48.2 145.8zm54.2-134.9-91 104a46.668 46.668 0 0 0-9.6 43.4l95.5 330.6c4 13.7 16.5 23.1 30.7 23.1h127.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9 0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9z"
        }
    ]
};

const FarCoinBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoinBlank",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 304c64 0 119.6-14.7 157.5-36 39.4-22.2 50.5-45.3 50.5-60s-11.1-37.8-50.5-60c-37.9-21.3-93.5-36-157.5-36s-119.6 14.7-157.5 36C59.1 170.2 48 193.3 48 208s11.1 37.8 50.5 60c37.9 21.3 93.5 36 157.5 36zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144v112c0 70.7-114.6 128-256 128S0 390.7 0 320V208zm256 144c-13.6 0-27-.6-40-1.7v48a471.705 471.705 0 0 0 80 0v-48c-13 1.1-26.4 1.7-40 1.7zm-136-22v47.7c18.7 7 40.3 12.7 64 16.6v-48.1c-22.8-3.8-44.3-9.2-64-16.2zm-32-13.3C73 309.3 59.6 301 48 292v28c0 6.8 6.2 24.2 40 43.1v-46.5zm240 29.6v48.1c23.7-3.9 45.3-9.6 64-16.6v-47.7c-19.7 7-41.2 12.5-64 16.2zM464 320v-28c-11.6 9.1-25 17.4-40 24.7v46.5c33.8-18.9 40-36.3 40-43.1z"
        }
    ]
};

const FarCoinFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoinFront",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm24-248c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"
        }
    ]
};

const FarCoinVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoinVertical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M204 413.5c-22.2 39.4-45.3 50.5-60 50.5s-37.8-11.1-60-50.5C62.7 375.6 48 320 48 256S62.7 136.4 84 98.5C106.2 59.1 129.3 48 144 48s37.8 11.1 60 50.5c21.3 37.9 36 93.5 36 157.5s-14.7 119.6-36 157.5zM0 256c0 141.4 64.5 256 144 256h112c70.7 0 128-114.6 128-256S326.7 0 256 0H144C64.5 0 0 114.6 0 256zm286.3 40c1.2-13 1.7-26.4 1.7-40s-.6-27-1.7-40h48a471.705 471.705 0 0 1 0 80h-48zm-4 32h48.1c-3.9 23.7-9.6 45.3-16.6 64H266c7-19.7 12.5-41.2 16.2-64zM228 464c9.1-11.6 17.4-25 24.7-40h46.5c-18.9 33.8-36.3 40-43.1 40H228zm102.3-280h-48.1c-3.8-22.8-9.2-44.3-16.2-64h47.7c7 18.7 12.7 40.3 16.6 64zm-31.2-96h-46.4C245.3 73 237 59.6 228 48h28c6.8 0 24.2 6.2 43.1 40zM120 256c0-40.2 5.2-75.7 12.9-100.3 3.7-11.8 7.7-19.9 11.1-24.7 3.4 4.8 7.3 12.9 11.1 24.7 7.8 24.6 12.9 60 12.9 100.3s-5.2 75.7-12.9 100.3c-3.7 11.8-7.7 19.9-11.1 24.7-3.4-4.8-7.3-12.9-11.1-24.7-7.8-24.6-12.9-60-12.9-100.3zm27.4-128.8a.2.2 0 1 0 .1.4.2.2 0 1 0-.1-.4zm-6.6.1a.2.2 0 1 0-.5.1.2.2 0 1 0 .5-.1zm-.2 257.4a.2.2 0 1 0-.1-.4.2.2 0 1 0 .1.4zm6.6-.1a.2.2 0 1 0 .5-.1.2.2 0 1 0-.5.1zM144 80c-17.7 0-30.3 11.3-37.9 21.6-8 10.7-14.2 24.6-18.9 39.7C77.6 171.7 72 212.3 72 256s5.6 84.3 15.2 114.7c4.8 15.1 10.9 29 18.9 39.7 7.7 10.3 20.2 21.6 37.9 21.6s30.3-11.3 37.9-21.6c8-10.7 14.2-24.6 18.9-39.7 9.6-30.4 15.2-71 15.2-114.7s-5.6-84.3-15.2-114.7c-4.8-15.1-10.9-29-18.9-39.7C174.3 91.3 161.7 80 144 80z"
        }
    ]
};

const FarCoin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M98.5 268C59.1 245.8 48 222.7 48 208s11.1-37.8 50.5-60c37.9-21.3 93.5-36 157.5-36s119.6 14.7 157.5 36c39.4 22.2 50.5 45.3 50.5 60s-11.1 37.8-50.5 60c-37.9 21.3-93.5 36-157.5 36s-119.6-14.7-157.5-36zM256 64C114.6 64 0 128.5 0 208v112c0 70.7 114.6 128 256 128s256-57.3 256-128V208c0-79.5-114.6-144-256-144zm-40 286.3c13 1.1 26.4 1.7 40 1.7s27-.6 40-1.7v48a471.705 471.705 0 0 1-80 0v-48zm-32-4v48.1c-23.7-3.9-45.3-9.6-64-16.6v-47.7c19.7 7 41.2 12.5 64 16.2zM48 292c11.6 9.1 25 17.4 40 24.7v46.5c-33.8-19-40-36.4-40-43.2v-28zm280 102.3v-48.1c22.8-3.8 44.3-9.2 64-16.2v47.7c-18.7 7-40.3 12.7-64 16.6zm96-31.2v-46.5c15-7.3 28.4-15.6 40-24.7v28c0 6.8-6.2 24.2-40 43.1zM256 184c40.2 0 75.7 5.2 100.3 12.9 11.8 3.7 19.9 7.7 24.7 11.1-4.8 3.4-12.9 7.3-24.7 11.1-24.6 7.8-60 12.9-100.3 12.9s-75.7-5.2-100.3-12.9c-11.8-3.7-19.9-7.7-24.7-11.1 4.8-3.4 12.9-7.3 24.7-11.1 24.6-7.8 60-12.9 100.3-12.9zm128.8 27.4a.2.2 0 1 0-.4.1.2.2 0 1 0 .4-.1zm-.1-6.6a.2.2 0 1 0-.1-.5.2.2 0 1 0 .1.5zm-257.4-.2a.2.2 0 1 0 .4-.1.2.2 0 1 0-.4.1zm.1 6.6a.2.2 0 1 0 .1.5.2.2 0 1 0-.1-.5zM432 208c0-17.7-11.3-30.3-21.6-37.9-10.7-8-24.6-14.2-39.7-18.9-30.4-9.6-71-15.2-114.7-15.2s-84.3 5.6-114.7 15.2c-15.1 4.8-29 10.9-39.7 18.9C91.3 177.7 80 190.3 80 208s11.3 30.3 21.6 37.9c10.7 8 24.6 14.2 39.7 18.9 30.4 9.6 71 15.2 114.7 15.2s84.3-5.6 114.7-15.2c15.1-4.8 29-10.9 39.7-18.9 10.3-7.7 21.6-20.2 21.6-37.9z"
        }
    ]
};

const FarCoins = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCoins",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 88c0 .1.1.6.6 1.5.6 1.2 2 3.1 4.7 5.5.4.3.8.7 1.2 1-18.7.4-36.9 1.7-54.4 4.1V88c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C226.4 7.5 271.5 0 320 0s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S512 70 512 88v208c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9c-9.6 3.7-20.1 6.9-31.3 9.6v-49.6c5.1-1.5 9.8-3.1 14.2-4.8 13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.6-1.1.6-1.5.6-1.5v-43.7c-5.3 2.6-10.9 5-16.7 7.2-9.6 3.7-20.1 6.9-31.3 9.6v-49.6c5.1-1.5 9.8-3.1 14.2-4.8 13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.5-.9.6-1.4.6-1.5v-43.7c-5.3 2.6-10.9 5-16.7 7.2-13.7 5.2-29.4 9.6-46.3 12.9-5.1-7.5-11-13.9-16.8-19.1-10.1-9.1-21.8-16.5-34-22.6 31.7-2.3 59.3-8.2 80-16.1 13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.5-.9.6-1.4.6-1.5 0 0 0-.5-.6-1.5-.6-1.2-2-3.1-4.7-5.5-5.5-5-14.9-10.6-28.5-15.7C403.2 54.9 364.2 48 320 48s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7-2.7 2.4-4.1 4.3-4.7 5.5-.6 1.1-.6 1.5-.6 1.5zM48 216c0 .1.1.6.6 1.5.6 1.2 2 3.1 4.7 5.5 5.5 5 14.9 10.6 28.5 15.7 27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.5-.9.6-1.4.6-1.5 0 0 0-.5-.6-1.5-.6-1.2-2-3.1-4.7-5.5-5.5-5-14.9-10.6-28.5-15.7-27-10.3-66-17.2-110.2-17.2s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7-2.7 2.4-4.1 4.3-4.7 5.5-.6 1.1-.6 1.5-.6 1.5zm-48 0c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C98.4 135.5 143.5 128 192 128s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S384 198 384 216v208c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9C285.6 504.5 240.5 512 192 512s-93.6-7.5-127.3-20.3c-16.8-6.4-32-14.6-43.5-24.9S0 442 0 424V216zm336 104v-43.6c-5.3 2.6-10.9 5-16.7 7.2C285.6 296.5 240.5 304 192 304s-93.6-7.5-127.3-20.3c-5.8-2.2-11.4-4.6-16.7-7.2V320c0 .1.1.6.6 1.5.6 1.2 2 3.1 4.7 5.5 5.5 5 14.9 10.6 28.5 15.7 27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.5-.9.6-1.4.6-1.5zM64.7 387.7c-5.8-2.2-11.4-4.6-16.7-7.2V424s0 .5.6 1.5c.6 1.2 2 3.1 4.7 5.5 5.5 5 14.9 10.6 28.5 15.7 27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7 2.7-2.4 4.1-4.3 4.7-5.5.6-1.1.6-1.5.6-1.5v-43.6c-5.3 2.6-10.9 5-16.7 7.2C285.6 400.5 240.5 408 192 408s-93.6-7.5-127.3-20.3z"
        }
    ]
};

const FarColonSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarColonSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M255.3 29.6c3.1-12.9-4.8-25.9-17.7-29s-25.9 4.8-29 17.7l-13.5 56C103.6 88.3 32 163.2 32 256c0 63 33 117.8 82.9 150.8l-18.2 75.6c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7l15.6-65c9.3 3.2 18.9 5.8 28.8 7.7l-11.1 46c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7l13-53.9c39.3-2 75.7-15.1 105.5-36.1 10.8-7.7 13.4-22.6 5.7-33.5s-22.6-13.4-33.5-5.7c-18.8 13.3-41.3 22.5-65.9 26l59.6-247c2.1 1.3 4.2 2.7 6.3 4.2 10.8 7.7 25.8 5.1 33.5-5.7s5.1-25.8-5.7-33.5c-7.1-5-14.5-9.5-22.3-13.6l15.7-65.2c3.1-12.9-4.8-25.9-17.7-29s-25.9 4.8-29 17.7l-14.3 59.4c-9.6-2.3-19.4-4-29.4-4.9l10.4-43.2zM182.6 126l-55.5 230C98 331 80 295.1 80 256c0-60.1 42.5-112.6 102.7-129.9zm-12.3 255.8 63.2-261.6c10.2.5 20.1 1.9 29.6 4.2L199 389.7c-10-1.7-19.6-4.4-28.7-7.9z"
        }
    ]
};

const FarColon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarColon",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 128a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0zm96 256a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0z"
        }
    ]
};

const FarColumns3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarColumns3",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 80v352h128c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H448zm-48 0H240v352h160V80zM192 432V80H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h128zM0 96c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FarComet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarComet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M459.8 3.2c4.7-2.1 9.8-3.2 15-3.2C495.3 0 512 16.7 512 37.2c0 5.2-1.1 10.3-3.2 15l-59.5 135.3 10.7-.8c33.9-2.6 55.4 35.5 35.6 63.1L369.2 426.7C331 480.2 269.3 512 203.6 512 91 512 0 419.8 0 307.5c0-64.8 30.6-126.3 82.7-165L261.6 9.6c27.5-20.4 66.3.9 63.7 35.1L324 62.9 459.8 3.2zm-6 55.1-147 64.7c-7.7 3.4-16.6 2.5-23.5-2.4s-10.7-13-10.1-21.4l3-40.6L111.4 181C71.6 210.6 48 257.8 48 307.5 48 393.6 117.8 464 203.6 464c50.2 0 97.4-24.3 126.6-65.2l116.4-163-33.6 2.7c-8.4.6-16.5-3.2-21.4-10.1s-5.8-15.8-2.4-23.5l64.6-146.6zM208 200c6.1 0 11.7 3.5 14.3 8.9l24.5 49.6 54.8 8c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-39.6 38.6 9.4 54.5c1 6-1.4 12.1-6.4 15.7s-11.5 4.1-16.8 1.2l-49-25.8-49 25.8c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.7l9.4-54.5-39.6-38.6c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l54.8-8 24.5-49.6c2.7-5.5 8.3-8.9 14.3-8.9z"
        }
    ]
};

const FarComma = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarComma",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 353.4c0-9.6-7.8-17.4-17.4-17.4-8.4 0-15.6 6-17.1 14.3L66.7 453.6l50.4-85.7c1.9-3.3 2.9-7 2.9-10.7v-3.8zm48 0v3.8c0 12.3-3.3 24.4-9.5 35.1l-57.2 97.2C93.1 503.4 78 512 61.8 512H60c-24.3 0-44-19.7-44-44 0-2.6.2-5.3.7-7.9l21.5-118.4C43.9 310.6 71 288 102.6 288c36.1 0 65.4 29.3 65.4 65.4z"
        }
    ]
};

const FarCommand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 92C0 41.2 41.2 0 92 0s92 41.2 92 92v44h144V92c0-50.8 41.2-92 92-92s92 41.2 92 92v4c0 53-43 96-96 96h-40v128h40c53 0 96 43 96 96v4c0 50.8-41.2 92-92 92s-92-41.2-92-92v-44H184v44c0 50.8-41.2 92-92 92S0 470.8 0 420v-4c0-53 43-96 96-96h40V192H96c-53 0-96-43-96-96v-4zm136 52V92c0-24.3-19.7-44-44-44S48 67.7 48 92v4c0 26.5 21.5 48 48 48h40zm48 176v8h144V184H184v136zm-48 48H96c-26.5 0-48 21.5-48 48v4c0 24.3 19.7 44 44 44s44-19.7 44-44v-52zm240 8v44c0 24.3 19.7 44 44 44s44-19.7 44-44v-4c0-26.5-21.5-48-48-48h-40v8zm0-232h40c26.5 0 48-21.5 48-48v-4c0-24.3-19.7-44-44-44s-44 19.7-44 44v52z"
        }
    ]
};

const FarCommentArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v110.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V152z"
        }
    ]
};

const FarCommentArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM200 152c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V288c0 13.3 10.7 24 24 24s24-10.7 24-24V176c0-13.3-10.7-24-24-24H200z"
        }
    ]
};

const FarCommentArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM280 328V217.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V328c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarCommentCaptions = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentCaptions",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm-208 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32zm112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
        }
    ]
};

const FarCommentCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM369 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 193z"
        }
    ]
};

const FarCommentCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM217 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zm112-34c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"
        }
    ]
};

const FarCommentDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM276 136c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V344c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V136z"
        }
    ]
};

const FarCommentDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarCommentExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM256 112c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCommentHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM144 221.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FarCommentImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4 26.5 9.6 56.2 15.1 87.8 15.1 124.7 0 208-80.5 208-160S380.7 80 256 80 48 160.5 48 240c0 32 12.4 62.8 35.7 89.2 8.6 9.7 12.8 22.5 11.8 35.5-1.4 18.1-5.7 34.7-11.3 49.4 17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1 10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240 0 125.1 114.6 32 256 32s256 93.1 256 208-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9-11.9 8.7-31.3 20.6-54.3 30.6-15.1 6.6-32.3 12.6-50.1 16.1-.8.2-1.6.3-2.4.5-4.4.8-8.7 1.5-13.2 1.9l-.7.1c-5.1.5-10.2.8-15.3.8-6.5 0-12.3-3.9-14.8-9.9S0 457.4 4.5 452.8c4.1-4.2 7.8-8.7 11.3-13.5 1.7-2.3 3.3-4.6 4.8-6.9l.3-.5zM296 160c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5S390 320 384 320H160c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8l48-64c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l9.6 12.8 52.4-76.3c3-4.3 7.9-6.9 13.2-6.9zm-120-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarCommentLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM152 176c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"
        }
    ]
};

const FarCommentMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM224 160v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarCommentMiddleTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentMiddleTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M231.3 124.8 256 75.3l24.7 49.5c6.5 12.9 18.4 22.3 32.5 25.4C407 171 464 237.3 464 304c0 79.5-83.3 160-208 160S48 383.5 48 304c0-66.7 57-133 150.7-153.8 14.1-3.1 26.1-12.5 32.5-25.4zm92.4-21.5-44.5-89C274.8 5.5 265.8 0 256 0s-18.8 5.5-23.2 14.3l-44.5 89C79.8 127.5 0 208.2 0 304c0 114.9 114.6 208 256 208s256-93.1 256-208c0-95.8-79.8-176.5-188.3-200.7z"
        }
    ]
};

const FarCommentMiddle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentMiddle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m231.3 387.2 24.7 49.5 24.7-49.5c6.5-12.9 18.4-22.3 32.5-25.4C407 341 464 274.7 464 208c0-79.5-83.3-160-208-160S48 128.5 48 208c0 66.7 57 133 150.7 153.8 14.1 3.1 26.1 12.5 32.5 25.4zm92.4 21.5-44.5 89c-4.4 8.8-13.3 14.3-23.2 14.3s-18.8-5.5-23.2-14.3l-44.5-89C79.8 384.5 0 303.8 0 208 0 93.1 114.6 0 256 0s256 93.1 256 208c0 95.8-79.8 176.5-188.3 200.7z"
        }
    ]
};

const FarCommentMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM184 216c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarCommentMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM352 128c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V219.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V128z"
        }
    ]
};

const FarCommentPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentPen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM340.8 155c-14.7-14.7-38.6-14.7-53.3 0l-14.9 15 53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 264.5c-4.1 4.1-7 9.2-8.4 14.9l-9.2 36.6c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9-53.3-53.3-71.9 71.9z"
        }
    ]
};

const FarCommentPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM232 328c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FarCommentQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zm143.5-274.5-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L244 213.6c-7.5 4.3-12.1 12.2-12.1 20.8V248c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM288 336a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCommentQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentQuote",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM160 144c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V176c0-17.7-14.3-32-32-32h-48zm224 80v-48c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V224z"
        }
    ]
};

const FarCommentSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-117.9-92.4C552.2 340.2 576 292.3 576 240c0-114.9-114.6-208-256-208-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM184.2 119c35.1-23.8 81.5-39 135.8-39 124.7 0 208 80.5 208 160 0 38.4-19.4 77-53.5 106.6L184.2 119zM112 240c0-16.2 3.4-32.4 10-47.9l-39-30.8c-12.3 24.3-19 50.9-19 78.7 0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 37 0 72.3-6.4 104-17.9l-46-36.3c-18.1 4-37.5 6.2-58 6.2-31.6 0-61.3-5.5-87.8-15.1-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5-23.6-26.3-36-57.1-36-89.1z"
        }
    ]
};

const FarCommentSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentSmile",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM192 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-169.5 62.1c-9.9 8.8-10.7 24-1.9 33.9 26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"
        }
    ]
};

const FarCommentSms = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentSms",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zm177.9-243.2c-4.9 1.6-8.2 6.2-8.2 11.4v96c0 6.6 5.4 12 12 12s12-5.4 12-12v-60l26.4 35.2c2.3 3 5.8 4.8 9.6 4.8s7.3-1.8 9.6-4.8L292 228v60c0 6.6 5.4 12 12 12s12-5.4 12-12v-96c0-5.2-3.3-9.8-8.2-11.4s-10.3.1-13.4 4.2L256 236l-38.4-51.2c-3.1-4.1-8.5-5.8-13.4-4.2zM116 214.9c0-3.1 1.3-5.3 4.8-7.4 3.9-2.3 9.6-3.6 15-3.5 6.9.1 17.4 1.7 24.3 3.5 6.4 1.7 13-2.1 14.7-8.5s-2.1-13-8.5-14.7c-8.6-2.3-21-4.2-30.1-4.3-8.7-.1-19 1.8-27.6 6.8-9 5.4-16.6 14.7-16.6 28.2.1 12.9 7.6 21.1 15.8 26 7.2 4.3 16.2 7 23.5 9.2l1.1.3c8.4 2.5 14.6 4.6 19 7.3 3.7 2.3 4.5 4.1 4.5 6.6.1 3.9-1.5 6.3-4.6 8.2-3.6 2.2-9.1 3.5-15 3.4-7.9-.3-15.4-2.8-24.9-6-1.3-.4-2.7-.9-4-1.4-6.3-2.1-13.1 1.3-15.2 7.6s1.3 13.1 7.6 15.2c1.2.4 2.4.8 3.7 1.3 9.1 3.1 20.3 6.9 32 7.3 9.2.3 19.8-1.6 28.5-7 9.2-5.7 16.1-15.4 15.9-28.9-.2-12.9-7.4-21.3-15.8-26.6-7.5-4.7-17-7.6-24.5-9.8l-.4-.1c-8.5-2.6-14.8-4.5-19.2-7.2-3.7-2.2-4.2-3.8-4.2-5.6zm240 0c0-3.1 1.3-5.3 4.8-7.4 3.9-2.3 9.6-3.6 15-3.5 6.6.1 13.7 1.5 21.1 3.5 6.4 1.7 13-2.1 14.7-8.5s-2.1-13-8.5-14.7c-8-2.1-17.4-4.2-26.9-4.3-8.7-.1-19 1.8-27.6 6.8-9 5.3-16.6 14.6-16.5 28.1.1 12.9 7.6 21.1 15.8 26 7.2 4.3 16.2 7 23.5 9.2l1.1.3c8.4 2.5 14.6 4.6 19 7.3 3.7 2.3 4.5 4.1 4.5 6.6 0 3.9-1.5 6.3-4.6 8.2-3.6 2.2-9.1 3.5-15 3.4-7.6-.2-14.7-2.7-23.8-5.8-1.5-.5-3.1-1.1-4.8-1.6-6.3-2.1-13.1 1.3-15.2 7.6s1.3 13.1 7.6 15.2c1.3.4 2.7.9 4.1 1.4 8.9 3.1 19.8 6.8 31.3 7.2 9.2.3 19.8-1.6 28.5-7 9.2-5.7 16.1-15.4 15.9-28.9-.2-12.9-7.4-21.3-15.8-26.6-7.5-4.7-17-7.6-24.5-9.8l-.4-.1c-8.5-2.6-14.8-4.5-19.2-7.2-3.7-2.2-4.2-3.8-4.2-5.6z"
        }
    ]
};

const FarCommentText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentText",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM184 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v104c0 13.3 10.7 24 24 24s24-10.7 24-24V208h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarCommentXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4-8.2 6-22.3 14.8-39.4 22.7 5.6-14.7 9.9-31.3 11.3-49.4 1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3.5-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9.8-.1 1.6-.3 2.4-.5 17.8-3.5 34.9-9.5 50.1-16.1 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9zM175 159c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarComment = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarComment",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4 26.5 9.6 56.2 15.1 87.8 15.1 124.7 0 208-80.5 208-160S380.7 80 256 80 48 160.5 48 240c0 32 12.4 62.8 35.7 89.2 8.6 9.7 12.8 22.5 11.8 35.5-1.4 18.1-5.7 34.7-11.3 49.4 17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1 10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240 0 125.1 114.6 32 256 32s256 93.1 256 208-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9-11.9 8.7-31.3 20.6-54.3 30.6-15.1 6.6-32.3 12.6-50.1 16.1-.8.2-1.6.3-2.4.5-4.4.8-8.7 1.5-13.2 1.9-.2 0-.5.1-.7.1-5.1.5-10.2.8-15.3.8-6.5 0-12.3-3.9-14.8-9.9S0 457.4 4.5 452.8c4.1-4.2 7.8-8.7 11.3-13.5 1.7-2.3 3.3-4.6 4.8-6.9.1-.2.2-.3.3-.5z"
        }
    ]
};

const FarCommentsDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentsDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80.7 253.2c14.3 15 17.3 37.6 7.5 55.8-1.1 2-2.2 4-3.2 5.9-2.5 4.5-5.2 9-7.9 13.6 17.1-4.5 33.9-10.7 49.9-18 4.3-1.9 8.5-3.9 12.6-6 9.5-4.8 20.3-6.2 30.7-4.2 12.1 2.4 24.8 3.6 37.8 3.6 96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 28 11.4 54.9 32.7 77.2zM416 176c0 97.2-93.1 176-208 176-16.2 0-31.9-1.6-47.1-4.5-4.6 2.3-9.4 4.6-14.2 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5-3.8-8.8-2-19 4.6-25.9 14.2-15.6 26.2-33.7 36.6-52.1.9-1.7 1.9-3.4 2.8-5.1C17.2 256.1 0 217.8 0 176 0 78.8 93.1 0 208 0s208 78.8 208 176zM245.2 381.5c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.1 0 25.8-1.3 37.8-3.6 10.4-2 21.2-.6 30.7 4.2 4.1 2.1 8.3 4.1 12.6 6 16 7.2 32.9 13.5 49.9 18-2.8-4.6-5.4-9.1-7.9-13.6-1.1-1.9-2.2-3.9-3.2-5.9-9.8-18.3-6.8-40.8 7.5-55.8C580.6 358.9 592 332 592 304c0-59.9-56.8-120.7-144-127.4v-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 41.8-17.2 80.1-45.9 110.3.9 1.7 1.9 3.5 2.8 5.1 10.3 18.4 22.3 36.5 36.6 52.1 6.6 7 8.3 17.2 4.6 25.9-3.8 8.8-12.5 14.5-22 14.5-43 0-86.5-13.3-122.7-29.7-4.8-2.2-9.6-4.5-14.2-6.8-15.1 3-30.9 4.5-47.1 4.5-82 0-153-40.2-186.8-98.5zM224 83.6v13.8c7.2 1.1 14.1 2.7 20.5 4.4 8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7-7.4-.1-15.1 1.6-20.5 4.7-4.8 2.8-6.5 5.8-6.4 9.8 0 2.3.6 4.4 5.7 7.4 6 3.6 14.5 6.2 25.9 9.6l.5.2c10.1 3 22.9 6.8 33 13.1 11.2 7 21 18.2 21.2 35.5.2 18-9.1 30.9-21.5 38.5-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16v-14.4c-9.7-1.9-18.8-5-26.7-7.7-1.9-.7-3.8-1.3-5.5-1.9-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2.7 4.4 1.5 6.5 2.2 12.2 4.1 21.9 7.4 32.3 7.7 8 .3 15.6-1.5 20.5-4.5 4.2-2.6 6.3-5.7 6.2-10.8 0-3.2-1.1-5.6-6.1-8.7-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4c-9.8-2.9-22-6.6-31.6-12.3-11-6.6-21.2-17.4-21.3-34.7-.1-18.1 10.2-30.5 22.3-37.6 6.5-3.8 13.7-6.2 20.8-7.6v-14c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarCommentsQuestionCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentsQuestionCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6-10.4-2-21.2-.6-30.7 4.2-4.1 2.1-8.3 4.1-12.6 6-16 7.2-32.9 13.5-49.9 18 2.8-4.6 5.4-9.1 7.9-13.6 1.1-1.9 2.2-3.9 3.2-5.9zM208 352c114.9 0 208-78.8 208-176S322.9 0 208 0 0 78.8 0 176c0 41.8 17.2 80.1 45.9 110.3-.9 1.7-1.9 3.5-2.8 5.1-10.3 18.4-22.3 36.5-36.6 52.1-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7 4.8-2.2 9.6-4.5 14.2-6.8 15.1 3 30.9 4.5 47.1 4.5zm224 128c16.2 0 31.9-1.6 47.1-4.5 4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5 3.8-8.8 2-19-4.6-25.9-14.2-15.6-26.2-33.7-36.6-52.1-.9-1.7-1.9-3.4-2.8-5.1 28.8-30.3 46-68.6 46-110.4 0-94.4-87.9-171.5-198.2-175.8 4.1 15.2 6.2 31.2 6.2 47.8v.6c87.2 6.7 144 67.5 144 127.4 0 28-11.4 54.9-32.7 77.2-14.3 15-17.3 37.6-7.5 55.8 1.1 2 2.2 4 3.2 5.9 2.5 4.5 5.2 9 7.9 13.6-17-4.5-33.9-10.7-49.9-18-4.3-1.9-8.5-3.9-12.6-6-9.5-4.8-20.3-6.2-30.7-4.2-12.1 2.4-24.8 3.6-37.8 3.6-61.7 0-110-26.5-136.8-62.3-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480zM184.3 86.3c-16.4 0-31 10.3-36.4 25.7l-.3.9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4h41.3c6.5 0 11.7 5.3 11.7 11.7 0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9v9.5c0 8.8 7.2 16 16 16s16-7.2 16-16v-.3l23.4-13.3c13.6-7.8 22-22.3 22-37.9 0-24.2-19.6-43.7-43.7-43.7h-41.4zM208 266.7a22.7 22.7 0 1 0 0-45.3 22.7 22.7 0 1 0 0 45.3zm331.3 22c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-74 74-31.4-31.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l42.7 42.7c6.2 6.2 16.4 6.2 22.6 0l85.3-85.3z"
        }
    ]
};

const FarCommentsQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCommentsQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80.7 253.2c14.3 15 17.3 37.6 7.5 55.8-1.1 2-2.2 4-3.2 5.9-2.5 4.5-5.2 9-7.9 13.6 17.1-4.5 33.9-10.7 49.9-18 4.3-1.9 8.5-3.9 12.6-6 9.5-4.8 20.3-6.2 30.7-4.2 12.1 2.4 24.8 3.6 37.8 3.6 96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 28 11.4 54.9 32.7 77.2zM416 176c0 97.2-93.1 176-208 176-16.2 0-31.9-1.6-47.1-4.5-4.6 2.3-9.4 4.6-14.2 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5-3.8-8.8-2-19 4.6-25.9 14.2-15.6 26.2-33.7 36.6-52.1.9-1.7 1.9-3.4 2.8-5.1C17.2 256.1 0 217.8 0 176 0 78.8 93.1 0 208 0s208 78.8 208 176zM245.2 381.5c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.1 0 25.8-1.3 37.8-3.6 10.4-2 21.2-.6 30.7 4.2 4.1 2.1 8.3 4.1 12.6 6 16 7.2 32.9 13.5 49.9 18-2.8-4.6-5.4-9.1-7.9-13.6-1.1-1.9-2.2-3.9-3.2-5.9-9.8-18.3-6.8-40.8 7.5-55.8C580.6 358.9 592 332 592 304c0-59.9-56.8-120.7-144-127.4v-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 41.8-17.2 80.1-45.9 110.3.9 1.7 1.9 3.5 2.8 5.1 10.3 18.4 22.3 36.5 36.6 52.1 6.6 7 8.3 17.2 4.6 25.9-3.8 8.8-12.5 14.5-22 14.5-43 0-86.5-13.3-122.7-29.7-4.8-2.2-9.6-4.5-14.2-6.8-15.1 3-30.9 4.5-47.1 4.5-82 0-153-40.2-186.8-98.5zm-97.3-269.4c5.5-15.4 20.1-25.7 36.4-25.7h41.3c24.2 0 43.7 19.6 43.7 43.7 0 15.7-8.4 30.1-22 37.9L224 181.4v.3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2 0-6.5-5.3-11.7-11.7-11.7h-41.3c-2.8 0-5.3 1.8-6.3 4.4l-.3.9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 244a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1-45.3 0z"
        }
    ]
};

const FarComments = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarComments",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6-10.4-2-21.2-.6-30.7 4.2-4.1 2.1-8.3 4.1-12.6 6-16 7.2-32.9 13.5-49.9 18 2.8-4.6 5.4-9.1 7.9-13.6 1.1-1.9 2.2-3.9 3.2-5.9zM0 176c0 41.8 17.2 80.1 45.9 110.3-.9 1.7-1.9 3.5-2.8 5.1-10.3 18.4-22.3 36.5-36.6 52.1-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7 4.8-2.2 9.6-4.5 14.2-6.8 15.1 3 30.9 4.5 47.1 4.5 114.9 0 208-78.8 208-176S322.9 0 208 0 0 78.8 0 176zm432 304c16.2 0 31.9-1.6 47.1-4.5 4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5 3.8-8.8 2-19-4.6-25.9-14.2-15.6-26.2-33.7-36.6-52.1-.9-1.7-1.9-3.4-2.8-5.1 28.8-30.3 46-68.6 46-110.4 0-94.4-87.9-171.5-198.2-175.8 4.1 15.2 6.2 31.2 6.2 47.8v.6c87.2 6.7 144 67.5 144 127.4 0 28-11.4 54.9-32.7 77.2-14.3 15-17.3 37.6-7.5 55.8 1.1 2 2.2 4 3.2 5.9 2.5 4.5 5.2 9 7.9 13.6-17-4.5-33.9-10.7-49.9-18-4.3-1.9-8.5-3.9-12.6-6-9.5-4.8-20.3-6.2-30.7-4.2-12.1 2.4-24.7 3.6-37.8 3.6-61.7 0-110-26.5-136.8-62.3-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"
        }
    ]
};

const FarCompactDisc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCompactDisc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-14.2-103.2c8.8-1 15.1-8.9 14.1-17.7S247 96 238.2 97c-74.1 8.2-133 67.1-141.2 141.2-1 8.8 5.4 16.7 14.1 17.7s16.7-5.4 17.7-14.1c6.6-59.3 53.7-106.4 113-113z"
        }
    ]
};

const FarCompassDrafting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCompassDrafting",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-19.6 91.7c-9 2.8-18.5 4.3-28.4 4.3s-19.4-1.5-28.4-4.3l-69.5 118.7C187.9 320.3 221 328 256 328c85.8 0 160.8-46.6 201-116 6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8C450.2 319.6 359.7 376 256 376c-43.8 0-85.3-10.1-122.2-28L44.7 500.1c-6.7 11.4-21.4 15.3-32.8 8.6s-15.3-21.4-8.6-32.8l89.3-152.5c-32.2-23.2-59.2-53-79.1-87.4-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8c15.8 27.2 36.9 51 61.9 69.7l69.8-119.2C170.2 145.2 160 121.8 160 96c0-53 43-96 96-96s96 43 96 96c0 25.8-10.2 49.2-26.7 66.5l53.5 91.4c-12.6 9.8-26.4 18.1-41.1 24.7l-53.2-90.9zm224.3 288.2c6.7 11.4 2.9 26.1-8.6 32.8s-26.1 2.9-32.8-8.6l-72.9-124.4c14.4-7.1 28.2-15.4 41.2-24.6l73 124.8z"
        }
    ]
};

const FarCompassSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCompassSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-95.4-74.8C561.1 354.5 576 307 576 256 576 114.6 461.4 0 320 0c-73.2 0-139.1 30.7-185.8 79.9L38.8 5.1zm133.4 104.6C209.9 71.6 262.2 48 320 48c114.9 0 208 93.1 208 208 0 39.8-11.2 77-30.6 108.6l-100.3-78.7 47.5-123.5c7.5-19.4-11.6-38.5-31-31l-143.3 55.1-98.1-76.9zM320 464c-114.9 0-208-93.1-208-208 0-22.3 3.5-43.8 10-63.9l-39.7-31.3C70.5 190.2 64 222.4 64 256c0 141.4 114.6 256 256 256 55.2 0 106.3-17.5 148.1-47.2l-39.7-31.3C396.8 452.9 359.7 464 320 464zm-3-118.2-92.2-72.6-29.4 76.5c-7.5 19.4 11.6 38.5 31 31l90.6-34.9z"
        }
    ]
};

const FarCompass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCompass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm306.7 69.1-144.3 55.5c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31l-55.5 144.3c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCompressWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCompressWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24V88zM24 288c-13.3 0-24 10.7-24 24s10.7 24 24 24h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V312c0-13.3-10.7-24-24-24H24zM400 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88V88zm-24 200c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24v-88h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"
        }
    ]
};

const FarCompress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCompress",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24V56zM24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24H24zM336 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88V56zm-24 264c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24v-88h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H312z"
        }
    ]
};

const FarComputerClassic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarComputerClassic",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c8.8 0 16 7.2 16 16v304c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h320zM64 0C28.7 0 0 28.7 0 64v304c0 23.7 12.9 44.4 32 55.4V480c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-56.6c19.1-11.1 32-31.7 32-55.4V64c0-35.3-28.7-64-64-64H64zm16 432h288v32H80v-32zm0-320v96c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32zm128 208c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm-88 32a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarComputerMouseScrollwheel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarComputerMouseScrollwheel",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 352V160c0-61.9-50.1-112-112-112h-64C98.1 48 48 98.1 48 160v192c0 61.9 50.1 112 112 112h64c61.9 0 112-50.1 112-112zM0 160C0 71.6 71.6 0 160 0h64c88.4 0 160 71.6 160 160v192c0 88.4-71.6 160-160 160h-64C71.6 512 0 440.4 0 352V160zm192-64c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarComputerMouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarComputerMouse",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 224H48v128c0 61.9 50.1 112 112 112h64c61.9 0 112-50.1 112-112V224H192zm192-48v176c0 88.4-71.6 160-160 160h-64C71.6 512 0 440.4 0 352V160C0 71.6 71.6 0 160 0h64c88.4 0 160 71.6 160 160v16zM216 48v128h120v-16c0-61.9-50.1-112-112-112h-8zm-48 0h-8C98.1 48 48 98.1 48 160v16h120V48z"
        }
    ]
};

const FarComputerSpeaker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarComputerSpeaker",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312.4 480c-11.8-13.2-20.1-29.7-23.1-48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h192.4zM64 32C28.7 32 0 60.7 0 96v224c0 35.3 28.7 64 64 64h224v-48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h225.3a95.98 95.98 0 0 1 23.1-48H64zm512 48c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h192zM384 32c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H384zm96 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-32 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FarComputer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarComputer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 384h86.7l-16 48H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-46.7l-16-48H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v224c0 35.3 28.7 64 64 64zm121.3 48 16-48h45.4l16 48h-77.4zM528 80h64v32h-64V80zm0 80h64v32h-64v-32zm64 80v192h-64V240h64zM480 80v352c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48zm80 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarContainerStorage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarContainerStorage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h8v352h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm56 400V80h480v352H80zm96-280c0-13.3-10.7-24-24-24s-24 10.7-24 24v208c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v208c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v208c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v208c0 13.3 10.7 24 24 24s24-10.7 24-24V152z"
        }
    ]
};

const FarConveyorBeltArm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarConveyorBeltArm",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0h176c13.3 0 24 10.7 24 24s-10.7 24-24 24h-69l-4.5 26.9c6 5 10.8 11.4 13.9 18.8l198.8 26.5c13.1 1.8 22.4 13.8 20.6 27-.8 5.9-3.7 11-7.8 14.7V192c0 8.8-7.2 16-16 16s-16-7.2-16-16v-25.9l-186-24.8c-8.8 11.4-22.6 18.7-38 18.7-26.5 0-48-21.5-48-48 0-20.6 13-38.1 31.2-45l3.2-19H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm88 112a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm176 152c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24h16c61.9 0 112 50.1 112 112s-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-56.4 41.7-103.1 96-110.9V264c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24h64v-24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24h64v-24zm-304 72c-35.3 0-64 28.7-64 64s28.7 64 64 64h416c35.3 0 64-28.7 64-64s-28.7-64-64-64H112zm16 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarConveyorBeltBoxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarConveyorBeltBoxes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 48v160H144V48h160zM144 0c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H144zm384 112v96h-96v-96h96zm-96-48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-96zm96 272c35.3 0 64 28.7 64 64s-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64h416zm-416-48C50.1 288 0 338.1 0 400s50.1 112 112 112h416c61.9 0 112-50.1 112-112s-50.1-112-112-112H112zm48 112a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarConveyorBeltEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarConveyorBeltEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64h416c35.3 0 64-28.7 64-64s-28.7-64-64-64H112zM0 400c0-61.9 50.1-112 112-112h416c61.9 0 112 50.1 112 112s-50.1 112-112 112H112C50.1 512 0 461.9 0 400zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarConveyorBelt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarConveyorBelt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48h80v160H176V48h80v80c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l39.1-26.1 39.1 26.1c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1V48zm-256 0v160c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm464 352c0 35.3-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64h416c35.3 0 64 28.7 64 64zM112 288C50.1 288 0 338.1 0 400s50.1 112 112 112h416c61.9 0 112-50.1 112-112s-50.1-112-112-112H112zm48 112a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarCookieBite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCookieBite",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m182.8 28.4-74 39.5c-19.7 10.5-35.6 27-45.4 47.1l-36.7 75.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9-.9-5.3-5.3-9.3-10.6-10.1-51.5-8.2-92.8-47.1-104.5-97.4-1.8-7.6-8-13.4-15.7-14.6-54.6-8.7-97.7-52-106.2-106.8-.8-5.4-4.9-9.8-10.3-10.6-22.1-3.1-44.6.9-64.4 11.4zm34.9 37.5c19 54.5 63.9 96.7 120 111.9 17.7 50.9 58.1 91.1 109.1 108.7-1 4.8-2.5 9.5-4.7 13.9L405.4 376c-5.4 11-14.1 20.1-24.8 25.8l-74 39.5c-10.8 5.7-23 7.9-35.1 6.2l-83-11.7c-12-1.7-23.3-7.2-32-15.7l-29.7 30.7 29.7-30.7-60.3-58.4c-8.8-8.5-14.7-19.6-16.8-31.7l-14.5-82.8c-2.1-12.1-.4-24.6 5-35.6l36.7-75.6c5.4-11 14.1-20.1 24.8-25.8l74-39.5c3.9-2.1 8.1-3.7 12.4-4.9zM192 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarCookie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCookie",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240.5 64.6c-12-1.7-24.3.5-35.1 6.2l-74 39.5C120.7 116 112 125 106.6 136l-36.7 75.6c-5.4 11-7.1 23.5-5 35.6L79.4 330c2.1 12.1 8 23.2 16.8 31.7l60.3 58.4c8.8 8.5 20 14 32 15.7l83 11.7c12 1.7 24.3-.5 35.1-6.2l74-39.5a58.89 58.89 0 0 0 24.8-25.8l36.7-75.5c5.4-11 7.1-23.5 5-35.6L432.6 182c-2.1-12.1-8-23.2-16.8-31.7l-60.3-58.4c-8.8-8.5-20-14-32-15.7l-83-11.7zm-57.7-36.2c19.7-10.5 42.3-14.5 64.4-11.4l83 11.7c22.1 3.1 42.7 13.2 58.7 28.7l60.3 58.4c16.1 15.6 26.8 35.8 30.7 57.9l14.6 82.8c3.9 22.1.7 44.8-9.1 64.9L448.6 397c-9.8 20.1-25.7 36.6-45.4 47.2l-74 39.5a105.83 105.83 0 0 1-64.4 11.4l-83-11.7c-22.1-3.1-42.7-13.2-58.7-28.7l-60.3-58.5c-16-15.6-26.8-35.9-30.6-57.9l-14.6-82.8c-3.9-22.1-.7-44.8 9.1-64.9L63.4 115c9.8-20.1 25.7-36.6 45.4-47.2l74-39.5zM288 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm0 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarCopy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCopy",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h140.1l67.9 67.9V320c0 8.8-7.2 16-16 16zm-192 48h192c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9l-67.8-67.9c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64v-32h-48v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16h32v-48H64z"
        }
    ]
};

const FarCopyright = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCopyright",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-56.6-199.4c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181 131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"
        }
    ]
};

const FarCorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCorn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 0c-14.6 0-28.1 4.9-38.8 13.1C401.4 9.8 392.9 8 384 8c-20.3 0-38.5 9.5-50.2 24.3-1.9-.2-3.9-.3-5.8-.3-20.4 0-38.5 9.5-50.2 24.3-1.9-.2-3.9-.3-5.8-.3-19.9 0-37.7 9.1-49.4 23.4l3.6 3.6c11.8 11.8 21.9 25.1 30 39.5 0-.3 0-.7-.1-1 0-.5-.1-.9-.1-1.4 0-8.8 7.2-16 16-16 2.6 0 5 .6 7.1 1.7 6.3 3.1 13.7 3.3 20.1.6s11.4-8.2 13.5-15c2-6.5 8.1-11.3 15.3-11.3 2.6 0 5 .6 7.1 1.7 6.3 3.1 13.7 3.3 20.1.6s11.4-8.2 13.5-15c2-6.5 8.1-11.3 15.3-11.3 4.6 0 8.7 1.9 11.6 5 5.3 5.5 12.8 8.3 20.4 7.3s14.3-5.4 18-12.1c2.8-5 8-8.2 14-8.2 8.8 0 16 7.2 16 16 0 6-3.3 11.2-8.2 14-6.7 3.7-11.2 10.4-12.1 18s1.8 15.2 7.3 20.4c3.1 2.9 5 7 5 11.6 0 7.2-4.7 13.3-11.3 15.3-6.7 2.1-12.2 7-15 13.5s-2.6 13.8.6 20.1c1 2.1 1.7 4.5 1.7 7.1 0 7.2-4.7 13.3-11.3 15.3-6.7 2.1-12.2 7-15 13.5s-2.6 13.8.6 20.1c1 2.1 1.7 4.5 1.7 7.1 0 7-4.5 12.9-10.7 15.1 7.2 4.8 14.2 10.2 20.7 16.1l17.5 15.7c12.6-11.7 20.5-28.4 20.5-47 0-2-.1-3.9-.3-5.8 14.8-11.7 24.3-29.8 24.3-50.2 0-2-.1-3.9-.3-5.8 14.8-11.7 24.3-29.8 24.3-50.2 0-8.9-1.8-17.4-5.1-25.2C507.1 92.1 512 78.6 512 64c0-35.3-28.7-64-64-64zM169 71c-6.1-6.1-15-8.5-23.4-6.2s-14.8 8.9-16.9 17.3l-21.9 87.4c-.4 1.4-1.1 2.7-2.1 3.7l-62.8 62.9C15.1 263 0 299.4 0 337.4c0 36 13.6 70.7 38 97.1L66.1 465c27.6 30 66.6 47 107.3 47 38.7 0 75.9-15.4 103.3-42.8l62.9-62.9c.9-.9 1.9-1.5 3.1-1.9l88.8-29.6c8.1-2.7 14.2-9.5 15.9-17.9s-1.1-17-7.4-22.7l-28.5-25.7C374 274.7 325.3 256 274.8 256c-9 0-17.9.6-26.8 1.8V213c0-40.3-16-79-44.5-107.5L169 71zm31 142v57.1c-25.9 10.2-49.7 25.7-69.8 45.7l-69.3 69.4C52.5 370.8 48 354.3 48 337.4c0-25.3 10-49.5 27.9-67.3l62.8-62.8c7.2-7.2 12.3-16.2 14.7-26l11.6-46.4 4.5 4.5C189 159 200 185.4 200 213zm-98.6 219.5-9.6-10.3 72.3-72.3c29.3-29.3 69.1-45.8 110.6-45.8 37.7 0 74.1 13.6 102.5 38.3L327.5 359c-8.2 2.7-15.7 7.4-21.9 13.5l-62.9 62.9a97.937 97.937 0 0 1-69.3 28.7c-27.4 0-53.5-11.4-72.1-31.5z"
        }
    ]
};

const FarCorner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCorner",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 184c0-13.3 10.7-24 24-24h368c30.9 0 56 25.1 56 56v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-4.4-3.6-8-8-8H24c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarCouch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCouch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 80H192c-44.2 0-80 35.8-80 80v40c-12.3-5.1-25.8-8-40-8-2.7 0-5.4.1-8 .3V160c0-70.7 57.3-128 128-128h256c70.7 0 128 57.3 128 128v32.3c-2.6-.2-5.3-.3-8-.3-14.2 0-27.7 2.8-40 8v-40c0-44.2-35.8-80-80-80zm120 144c2.7 0 5.4.1 8 .4 36 4 64 34.5 64 71.6v136c0 26.5-21.5 48-48 48h-48c-20.9 0-38.7-13.4-45.3-32H141.3c-6.6 18.6-24.4 32-45.3 32H48c-26.5 0-48-21.5-48-48V296c0-37.1 28-67.6 64-71.6 2.6-.3 5.3-.4 8-.4 15.2 0 29.4 4.7 41 12.8 16.7 11.6 28.2 30 30.5 51.2h352.9c2.3-21.2 13.9-39.6 30.5-51.2 11.6-8.1 25.8-12.8 41-12.8zm-24 72v136h48V296c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-48 104v-64H144v64h352zm-400 0V296c0-13.3-10.7-24-24-24s-24 10.7-24 24v136h48v-32z"
        }
    ]
};

const FarCow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 184c0-23 10.7-43.4 27.5-56.6-2.3 7.8-3.5 16.1-3.5 24.6v248c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-21.4c2.5.6 5.2 1.2 8 1.7V392c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.1c2.6.1 5.3.1 8 .1s5.4 0 8-.1v8.1c0 8.8 7.2 16 16 16s16-7.2 16-16v-11.6c2.8-.5 5.5-1.1 8-1.7V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V271.1l16 18V336c0 4.6 1.3 9 3.8 12.9l42.3 66.5c12.9 20.3 35.3 32.6 59.4 32.6 38.9 0 70.5-31.6 70.5-70.5V274.9c0-12.4-4.1-24.4-11.7-34.2l-4.3-5.6V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v5l-48.2-62.4C505.1 81.2 470 64 432.9 64H144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4 31.8 0 57.6-25.8 57.6-57.6V184zm91.2-66.1c3.6 12.3 10.3 23.6 19.5 32.8l7.4 7.4c21.7 21.7 51.2 33.9 81.9 33.9s60.2-12.2 81.9-33.9l7.4-7.4c10.7-10.7 17.9-24.1 21-38.6h50.5c22.3 0 43.3 10.3 57 28L590.3 270c1.1 1.4 1.7 3.1 1.7 4.9v102.6c0 12.4-10.1 22.5-22.5 22.5-7.7 0-14.8-3.9-19-10.4L512 329v-49c0-5.9-2.2-11.6-6.1-15.9l-64-72c-6.6-7.4-17.2-10-26.5-6.5S400 198 400 208v192h-32v-64c0-53-43-96-96-96s-96 43-96 96v64h-32V152c0-14.5 7.7-27.1 19.2-34.1zm62.4 211.4-1.1-.4C228 305.7 247.9 288 272 288s44 17.7 47.5 40.9l-1.1.4c-9.7 3.2-25.1 6.8-46.4 6.8s-36.7-3.5-46.4-6.8zM576 320a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarCowbellCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCowbellCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48h96v48h-96V48zm-48-8v56h-16c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416h214.6c-4.3-15.3-6.6-31.4-6.6-48H48l64-224h224l18.8 65.8c14.2-7 29.6-12.1 45.6-15l-18.3-64C376.3 110.2 357.4 96 336 96h-16V40c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40zm32 408c0 35.3 28.7 64 64 64 29.2 0 53.9-19.6 61.5-46.4-3.8-5.7-7.2-11.5-10.3-17.6H160zm272 64a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarCowbell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCowbell",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48h96v48h-96V48zm-48-8v56h-16c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416h352c15.1 0 29.3-7.1 38.3-19.1s12-27.6 7.8-42.1l-64-224C376.3 110.2 357.4 96 336 96h-16V40c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40zm-16 104h224l64 224H48l64-224zm176 304H160c0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FarCrab = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrab",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.2 120C4.4 53 60 0 128 0h44.7c7.1 0 10.7 8.6 5.7 13.7l-36.7 36.6c-5 5-1.5 13.7 5.7 13.7H184c4.4 0 8.1 3.6 7.5 8-3.9 31.6-30.9 56-63.5 56H48v33.3c0 9.4 5.4 17.9 13.9 21.8l71.4 32.9c16.9-12.2 37-20.3 58.7-23v-41c0-13.3 10.7-24 24-24s24 10.7 24 24v40h32v-40c0-13.3 10.7-24 24-24s24 10.7 24 24v41c21.7 2.7 41.7 10.9 58.7 23l71.4-32.9c8.5-3.9 13.9-12.4 13.9-21.8V128h-80c-32.6 0-59.6-24.4-63.5-56-.5-4.4 3.1-8 7.5-8h36.7c7.1 0 10.7-8.6 5.7-13.7l-36.7-36.6c-5-5-1.5-13.7 5.7-13.7H384c68 0 123.6 53 127.8 120v.4l.2 7.6h-8 8v33.3c0 28.1-16.3 53.6-41.8 65.4L413.1 253c2.2 3.6 4.2 7.2 6 11h31.2l26.9-13.5c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-32 16c-3.3 1.7-7 2.5-10.7 2.5h-24.2c.2 2.6.2 5.3.2 8v1.4l23.6 7.9c3.5 1.2 6.7 3.2 9.4 5.8l32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-28-28-30-10L387 381l36.6 12.2c3.5 1.2 6.7 3.2 9.4 5.8l32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-28-28-54-18-2.2 2.2 24.8 13.9c7.6 4.2 12.3 12.3 12.3 21v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-17.9L297.9 449c-.6-.3-1.1-.6-1.6-1h-80.6c-.5.3-1.1.7-1.6 1L176 470.1V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32c0-8.7 4.7-16.7 12.3-21l24.9-13.8-2.2-2.2-54 18-28 28c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l32-32c2.6-2.6 5.8-4.6 9.4-5.8L125 381l-18-18-30 10-28 28c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l32-32c2.6-2.6 5.8-4.6 9.4-5.8l23.5-7.9V320c0-2.7.1-5.4.2-8H56c-3.7 0-7.4-.9-10.7-2.5l-32-16c-11.9-6-16.7-20.4-10.8-32.2s20.3-16.7 32.2-10.7l27 13.4h31.2c1.8-3.8 3.9-7.4 6-11l-57.1-26.3A72.027 72.027 0 0 1 0 161.3V128h8-8l.2-7.6v-.4zM296 240h-88c-42.9 0-77.9 33.8-79.9 76.2l83.8 83.8h88.2l83.8-83.8c-2-42.4-37-76.2-79.9-76.2h-8z"
        }
    ]
};

const FarCrateApple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrateApple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 54.9c0 5 4.1 9.1 9.1 9.1C199.4 64 224 39.4 224 9.1c0-5-4.1-9.1-9.1-9.1C184.6 0 160 24.6 160 54.9zM80 171.4c0-15.3 3.8-29 8.7-37.2 2.3-3.8 4.1-5.3 4.9-5.7.4-.2.8-.5 2.4-.5 2.2 0 6.5.5 12.6 2.1 5.8 1.5 11.9 3.6 17.2 5.7 21.9 8.5 46.4 8.5 68.3 0 5.4-2.1 11.4-4.2 17.2-5.7 6.1-1.6 10.3-2.1 12.6-2.1 1.6 0 2.1.3 2.4.5.7.5 2.6 1.9 4.9 5.7 4.9 8.2 8.7 21.9 8.7 37.2 0 7.2-.6 14.1-1.7 20.6h48.5c.8-6.7 1.2-13.5 1.2-20.6 0-43.6-20.4-91.4-64-91.4-15.6 0-34.1 5.9-47.2 11-10.7 4.2-22.8 4.2-33.5 0-13.1-5.1-31.6-11-47.2-11-43.6 0-64 47.8-64 91.4 0 7 .4 13.9 1.2 20.6h48.5c-1.1-6.5-1.7-13.3-1.7-20.6zM430.3 192h48.5c.8-6.7 1.2-13.5 1.2-20.6 0-43.6-20.4-91.4-64-91.4-15.6 0-34.1 5.9-47.2 11-10.7 4.2-22.8 4.2-33.5 0-12.4-4.8-29.6-10.3-44.6-11 3.4 4 6.4 8.3 9 12.7 7.8 12.9 13.2 27.5 16.4 42.3l1.7.7c21.9 8.5 46.4 8.5 68.3 0 5.4-2.1 11.4-4.2 17.2-5.7 6.1-1.6 10.3-2.1 12.6-2.1 1.6 0 2.1.3 2.4.5.7.5 2.6 1.9 4.9 5.7 4.9 8.2 8.7 21.9 8.7 37.2 0 7.2-.6 14.1-1.7 20.6zM406.9 0C376.6 0 352 24.6 352 54.9c0 5 4.1 9.1 9.1 9.1C391.4 64 416 39.4 416 9.1c0-5-4.1-9.1-9.1-9.1zM456 272c4.4 0 8 3.6 8 8v64H48v-64c0-4.4 3.6-8 8-8h400zM48 456v-64h416v64c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8zm8-232c-30.9 0-56 25.1-56 56v176c0 30.9 25.1 56 56 56h400c30.9 0 56-25.1 56-56V280c0-30.9-25.1-56-56-56H56zm360 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM96 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarCrateEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrateEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 272c-4.4 0-8 3.6-8 8v64h416v-64c0-4.4-3.6-8-8-8H56zm-8 120v64c0 4.4 3.6 8 8 8h400c4.4 0 8-3.6 8-8v-64H48zM0 280c0-30.9 25.1-56 56-56h400c30.9 0 56 25.1 56 56v176c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V280zm400 24a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 304a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarCreditCardBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCreditCardBlank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 264c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarCreditCardFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCreditCardFront",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 264c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zM96 280c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm280-152h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarCreditCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCreditCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16h448zm16 144v192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224h480zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
        }
    ]
};

const FarCricketBatBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCricketBatBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143-24.4-24.4c-21.9-21.9-57.3-21.9-79.2 0L16.1 334C6.1 344-.6 358.4.5 374.4c.8 11.3 2.8 28.6 8.2 46.4 5.1 17.3 14.2 37.1 30.3 52.2 15 16.2 34.9 25.2 52.2 30.4 17.8 5.4 35.1 7.4 46.4 8.2 16 1.1 30.4-5.6 40.4-15.6l208.3-208.4c21.9-21.9 21.9-57.3 0-79.2L361.9 184 505 41zM269.7 159.6l41.2 41.2.2.2.2.2 41.2 41.2c3.1 3.1 3.1 8.2 0 11.3L318.1 288H232c-4.4 0-8-3.6-8-8v-86.1l34.3-34.3c3.1-3.1 8.2-3.1 11.3 0zM176 241.9V280c0 30.9 25.1 56 56 56h38.1l-126 126c-.7.7-1.5 1.2-2.1 1.5-.5.2-.8.2-1.1.2-9.3-.6-22.6-2.2-35.7-6.2s-24-9.7-30.9-17.2c-.8-.8-1.6-1.7-2.4-2.4-7.5-6.9-13.2-17.8-17.2-30.9s-5.6-26.5-6.2-35.7c0-.3 0-.6.2-1.1.2-.6.7-1.4 1.5-2.1l126-126zM400 432a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FarCroissant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCroissant",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323.7 242.1c2 18.9-4.5 38.1-18.4 51.9L294 305.3c-13.9 13.9-33 20.4-51.9 18.4L208 350.2V384l15.6 93.6c.3 1.6.4 3.2.4 4.9 0 16.3-13.2 29.6-29.6 29.6H189c-4.2 0-8.3-.7-12.2-2.3-35.8-14.3-67.5-36.5-93.2-64.3-16.4 7.1-36 2.5-45.3-13.7C14 389.4 0 340.3 0 288c0-22.4 2.6-44.2 7.4-65.1-4.7-7.3-7.4-15.9-7.4-25 0-5 .8-10 2.5-14.6C33.2 99.6 99.6 33.2 183.3 2.5 188 .8 193 0 197.9 0c9.1 0 17.7 2.7 24.9 7.4C243.8 2.6 265.6 0 288 0c52.3 0 101.4 14 143.7 38.4 16.2 9.3 20.8 28.9 13.7 45.3 27.9 25.7 50 57.4 64.3 93.2 1.5 3.9 2.3 8 2.3 12.2v5.4c0 16.3-13.2 29.6-29.6 29.6-1.6 0-3.3-.1-4.9-.4L384 208h-33.8l-26.5 34.1zm-74.3-191 55.3 137.3 89.8-115.5C362.5 57 326.3 48 288 48c-13.1 0-26 1.1-38.6 3.1zM51.1 249.4C49.1 262 48 274.9 48 288c0 38.3 9 74.5 24.9 106.5l115.5-89.8-137.3-55.3zM388 160l3.9.7 62 10.3c-10-17.9-22.6-34.3-37.2-48.4L387.6 160h.4zM171 453.9l-10.3-62-.7-3.9v-.4l-37.4 29.1c14.2 14.6 30.5 27.2 48.4 37.2zm71.8-179c6 2.4 12.8 1 17.3-3.5l11.3-11.3c4.5-4.5 5.9-11.3 3.5-17.3l-78.2-194c-67.9 25.9-122 80-147.9 147.9l194 78.2z"
        }
    ]
};

const FarCropSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCropSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v56H24C10.7 80 0 90.7 0 104s10.7 24 24 24h56v248c0 30.9 25.1 56 56 56h216v-48H136c-4.4 0-8-3.6-8-8V24zm256 464c0 13.3 10.7 24 24 24s24-10.7 24-24v-56h56c13.3 0 24-10.7 24-24s-10.7-24-24-24h-56V136c0-30.9-25.1-56-56-56H160v48h216c4.4 0 8 3.6 8 8v352z"
        }
    ]
};

const FarCrop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 24c0-13.3 10.7-24 24-24s24 10.7 24 24v326.1L350.1 128H160V80h238.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-73 73L432 384h56c13.3 0 24 10.7 24 24s-10.7 24-24 24h-56v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V161.9L161.9 384H352v48H136c-30.9 0-56-25.1-56-56V128H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V24z"
        }
    ]
};

const FarCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCross",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64v192c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48V272H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h64V48zm112 0h-64v88c0 13.3-10.7 24-24 24H48v64h88c13.3 0 24 10.7 24 24v216h64V248c0-13.3 10.7-24 24-24h88v-64h-88c-13.3 0-24-10.7-24-24V48z"
        }
    ]
};

const FarCrosshairsSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrosshairsSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M462.6 232H392c-13.3 0-24 10.7-24 24s10.7 24 24 24h70.6c-11 95.7-86.9 171.6-182.6 182.6V392c0-13.3-10.7-24-24-24s-24 10.7-24 24v70.6c-95.7-11-171.6-86.9-182.6-182.6H120c13.3 0 24-10.7 24-24s-10.7-24-24-24H49.4c11-95.7 86.9-171.6 182.6-182.6V120c0 13.3 10.7 24 24 24s24-10.7 24-24V49.4c95.7 11 171.6 86.9 182.6 182.6zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0z"
        }
    ]
};

const FarCrosshairs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrosshairs",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c13.3 0 24 10.7 24 24v17.3C380.1 52.4 459.6 131.9 470.7 232H488c13.3 0 24 10.7 24 24s-10.7 24-24 24h-17.3C459.6 380.1 380.1 459.6 280 470.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-17.3C131.9 459.6 52.4 380.1 41.3 280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h17.3C52.4 131.9 131.9 52.4 232 41.3V24c0-13.3 10.7-24 24-24zM89.7 280c10.5 73.6 68.7 131.8 142.3 142.3V392c0-13.3 10.7-24 24-24s24 10.7 24 24v30.3c73.6-10.5 131.8-68.7 142.3-142.3H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h30.3C411.8 158.4 353.6 100.2 280 89.7V120c0 13.3-10.7 24-24 24s-24-10.7-24-24V89.7C158.4 100.2 100.2 158.4 89.7 232H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H89.7zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarCrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m39.2 442.6 72-58.6h148l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384h44.1l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192v-72l96-24c-9.4-37.6-43.2-64-82-64h-43c-18.9-19.7-45.5-32-75-32-57.4 0-104 46.6-104 104v35.1L94.1 336l-13.2 10.8-72 58.6c-10.3 8.4-11.9 23.5-3.5 33.8s23.5 11.8 33.8 3.5zm156.2-127.2 137.7-112c-10.9 51.4-51 93.1-104 104.7l-33.7 7.4zM384 161.9V104c0-30.9 25.1-56 56-56s56 25.1 56 56v88c0 79.5-64.5 144-144 144h-62.5c57.1-31.8 94.5-92.7 94.5-160.8v-13.3zm80-57.9a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarCrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M309 106c11.4-7 19-19.7 19-34 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-5.8 11.6-51.5 103c-9.1 18.2-32.7 23.4-48.6 10.7l-72-57.6L72 160c5-6.7 8-15 8-24 0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40h.7l4.4 23.9 41.3 227.5c5.5 30.4 32 52.6 63 52.6h277.2c30.9 0 57.4-22.1 63-52.6L531 199.9l4.4-23.9h.7c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40c0 9 3 17.3 8 24L487 173.7l-72 57.6c-15.9 12.7-39.5 7.5-48.6-10.7l-51.6-102.9L309 106zM133.7 418.9l-31.5-173.3 28.9 23.1c39.8 31.8 98.8 18.9 121.5-26.7l35.4-70.7 35.4 70.7c22.8 45.6 81.8 58.5 121.5 26.7l28.9-23.1-31.5 173.3c-1.4 7.6-8 13.1-15.7 13.1H149.4c-7.7 0-14.4-5.5-15.7-13.1z"
        }
    ]
};

const FarCrutch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrutch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m329 7 176 176c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L295 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM164.2 201.9 287.4 78.6l33.9 33.9-71.4 71.5 78.1 78.1 71.4-71.4 33.9 33.9-123.2 123.2c-11.8 11.8-26.8 20-43.1 23.7l-107.6 23.9c-7.4 1.7-14.2 5.4-19.6 10.8L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l98.8-98.8c5.4-5.4 9.1-12.2 10.8-19.6L140.5 245c3.6-16.3 11.8-31.3 23.7-43.1zm51.8 16-17.9 17.9c-5.4 5.4-9.1 12.2-10.8 19.6l-19.8 89 89-19.8c7.4-1.7 14.2-5.4 19.6-10.8l18-17.8-78.1-78.1z"
        }
    ]
};

const FarCrutches = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrutches",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183 7 7 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l15-15 146 145.9c1.9 1.9 3.8 3.6 5.8 5.3l3.5-3.5c1.1-1.1 1.8-2.4 2.2-3.9l9.9-44.4L89.9 168 168 89.9l95.7 95.7c1.9-2.2 3.9-4.3 5.9-6.4l27.8-27.8L201.9 56l15-15c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zm219 395.7-27.2 6L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-77.2-77.2c-8.2 3.9-16.8 6.9-25.8 8.9zM423 7c-9.4 9.4-9.4 24.6 0 33.9L599 217c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L457 7c-9.4-9.4-24.6-9.4-33.9 0zm-7.6 71.6L292.2 201.9c-11.8 11.8-20 26.8-23.7 43.1l-23.9 107.6c-1.7 7.4-5.4 14.2-10.8 19.6L135 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l98.8-98.8c5.4-5.4 12.2-9.1 19.6-10.8L395 371.5c16.3-3.6 31.3-11.8 43.1-23.7l123.3-123.2-33.9-33.9-71.5 71.4-78.1-78.1 71.4-71.4-33.9-34zm-89.2 157.2 17.8-17.9 78.1 78.1-17.8 17.9c-5.4 5.4-12.2 9.1-19.6 10.8l-89 19.8 19.8-89c1.7-7.4 5.4-14.2 10.8-19.6z"
        }
    ]
};

const FarCruzeiroSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCruzeiroSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 256c0-97 79.3-176 177.6-176 45.6 0 87 17 118.5 44.9 9.9 8.8 25.1 7.9 33.9-2s7.9-25.1-2-33.9c-40-35.5-92.7-57-150.4-57C133.2 32 32 132.1 32 256s101.2 224 225.6 224c57.7 0 110.4-21.5 150.3-57 9.9-8.8 10.8-24 2-33.9s-24-10.8-33.9-2C344.6 415 303.2 432 257.6 432c-6.3 0-12.5-.3-18.6-1 .7-2.2 1-4.6 1-7V318.2c0-21.1 17.1-38.2 38.2-38.2 10.1 0 19.9 4 27 11.2l5.8 5.8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-5.8-5.8c-16.2-16.2-38.1-25.3-61-25.3-14.1 0-27.4 3.4-39.2 9.4C236.2 231.3 227 224 216 224c-13.3 0-24 10.7-24 24v171.6C126.3 393.7 80 330.1 80 256z"
        }
    ]
};

const FarCrystalBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCrystalBall",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 224c0 71-42 132.2-102.6 160h83.3c41.5-40.7 67.2-97.3 67.2-160C448 100.3 347.7 0 224 0S0 100.3 0 224c0 62.7 25.7 119.3 67.2 160h83.3C90 356.2 48 295 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176zM167.5 100.3c-2.6-7-12.4-7-15 0l-9.8 26.4-26.4 9.8c-7 2.6-7 12.4 0 15l26.4 9.8 9.8 26.4c2.6 7 12.4 7 15 0l9.8-26.4 26.4-9.8c7-2.6 7-12.4 0-15l-26.4-9.8-9.8-26.4zm113 48-18.4 49.8-49.8 18.4c-7 2.6-7 12.4 0 15l49.8 18.4 18.4 49.8c2.6 7 12.4 7 15 0l18.4-49.8 49.8-18.4c7-2.6 7-12.4 0-15l-49.8-18.4-18.4-49.8c-2.6-7-12.4-7-15 0zM20.3 474.2c-5.1 7.3-5.8 16.9-1.6 24.8s12.4 13 21.3 13h368c8.9 0 17.2-5 21.3-12.9s3.5-17.5-1.6-24.8L386.9 416H61.1l-40.8 58.2z"
        }
    ]
};

const FarCube = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCube",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M258.8 50.7c-1.8-.7-3.8-.7-5.7 0L63.6 122.6 256 198.2l192.4-75.6-189.6-71.9zM48 377.9c0 3.3 2.1 6.3 5.2 7.5L232 453.2V240.4L48 168.1v209.8zm232 75.3 178.8-67.8c3.1-1.2 5.2-4.2 5.2-7.5V168.1l-184 72.3v212.8zM236.1 5.9C248.9 1 263 1 275.8 5.9l200 75.9c21.8 8.2 36.2 29 36.2 52.3v243.8c0 23.3-14.4 44.1-36.1 52.4l-200 75.9c-12.8 4.9-26.9 4.9-39.7 0l-200-75.9C14.4 422 0 401.2 0 377.9V134.1C0 110.8 14.4 90 36.1 81.7l200-75.9z"
        }
    ]
};

const FarCubesStacked = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCubesStacked",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 80v32h32V80h-32zm-16-48h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm-87.5 236.2 27.7-16-16-27.7-27.7 16 16 27.7zM71 250.7c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c15.3-8.8 34.9-3.6 43.7 11.7l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7l-32-55.4zM304 272h32v-32h-32v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm112 208h32v-32h-32v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm-112 16v32h32v-32h-32zm-16-48h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zM48 432h32v-32H48v32zM0 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64z"
        }
    ]
};

const FarCubes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCubes",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M290.7 48.3c-1.7-.6-3.6-.6-5.4 0l-81.2 29 83.9 32.2 83.9-32.1-81.2-29zM176 207.2l88 31.4v-86.9L176 118v89.3zm136 31.4 88-31.4v-89.3l-88 33.7v86.9zM448 93v114.5l91.9 34.8c21.8 8.2 36.1 29.1 36.1 52.4v119.2c0 22.2-13.1 42.3-33.5 51.3l-96.4 42.4c-14 6.1-29.8 6.3-43.9.5L288 460.7 173.8 508c-14.1 5.8-30 5.7-43.9-.5l-96.4-42.4C13.1 456.2 0 436.1 0 413.9V294.7c0-23.3 14.4-44.1 36.1-52.4l91.9-34.8V93c0-23.7 14.9-44.8 37.2-52.7l104-37.1c12.2-4.3 25.5-4.3 37.6 0l104 37.1c22.3 7.9 37.2 29 37.2 52.7zM264 320.2l-88 33.7v101.2l88-36.4v-98.5zm-211.2 101 75.2 33.1V353.9l-80-30.7v90.7c0 3.2 1.9 6 4.8 7.3zM400 455.1V353.9l-88-33.7v98.6l88 36.4zm48-.9 75.2-33.1c2.9-1.3 4.8-4.2 4.8-7.3v-90.6l-80 30.6v100.5zM155 250.7c-1.8-.6-3.7-.6-5.5.1l-78.7 29.8 81.2 31.1 83.9-32.1-80.9-28.9zm266 0-80.9 28.9 83.9 32.1 81.2-31.1-78.7-29.8c-1.8-.7-3.7-.7-5.5-.1z"
        }
    ]
};

const FarCucumber = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCucumber",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M71.4 440.6c-31.2-31.2-31.2-81.9 0-113.1l256-256c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1l-63 63c-4.4-4.7-10.6-7.6-17.5-7.6-13.3 0-24 10.7-24 24 0 6.9 2.9 13.1 7.6 17.5l-159 159c-31.2 31.2-81.9 31.2-113.1 0zm-33.9 33.9c47.8 47.8 124 49.9 174.3 6.3 12.6 10.3 31.1 9.6 42.9-2.2 11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4 11.7-11.7 12.5-30.3 2.2-42.9 43.6-50.3 41.5-126.5-6.3-174.3-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6l-89.5 89.5c-50 50-50 131 0 181zM352 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM184 320a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarCupStrawSwoosh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCupStrawSwoosh",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M249.3 0H280c13.3 0 24 10.7 24 24s-10.7 24-24 24h-30.7c-3.7 0-6.9 2.6-7.8 6.2L224.2 128H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h150.9l20-84.8C200.8 17.9 223.4 0 249.3 0zm-189 468L38.7 208h48.1l12.9 154.4c15.7-3.1 27.5-7.3 36.9-11.9 19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7 16-8.6 35.4-15.1 59.8-18.9l3-36h48.2l-21.7 260c-2.1 24.9-22.9 44-47.8 44H108.2c-25 0-45.8-19.1-47.8-44zM290 293.5c-14.1 3.1-24.6 7.1-32.9 11.6-17.2 9.3-26.9 21.2-39.9 37.2l-.7.8c-13.3 16.4-29.5 35.9-58.7 50.4-14.9 7.4-32.6 13.1-54.2 17l4.5 53.5h167.7L290 293.5z"
        }
    ]
};

const FarCupStraw = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCupStraw",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m194.8 43.2-20 84.8H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24S293.3 0 280 0h-30.7c-26 0-48.6 17.9-54.5 43.2zM38.7 208l21.6 260c2.1 24.9 22.9 44 47.8 44h167.7c25 0 45.8-19.1 47.8-44l21.7-260h-48.1l-21.4 256H108.2L86.8 208H38.7z"
        }
    ]
};

const FarCupTogo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCupTogo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M108.2 48h232c3 0 5.8 1.7 7.2 4.4L361.2 80H88l13-27.4c1.3-2.8 4.1-4.6 7.2-4.6zm306.6 32-24.5-49c-9.5-19-28.9-31-50.1-31h-232C86.6 0 66.9 12.4 57.6 32L34.8 80H24C10.7 80 0 90.7 0 104s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24h-9.2zM47.4 160l27.2 293.9c3 32.9 30.7 58.1 63.7 58.1h171.4c33.1 0 60.7-25.2 63.7-58.1L400.6 160h-48.2l-5.9 64h-245l-5.9-64H47.4zm68.9 224h215.3l-6.1 65.5c-.8 8.2-7.7 14.5-15.9 14.5H138.3c-8.3 0-15.2-6.3-15.9-14.5l-6-65.5z"
        }
    ]
};

const FarCupcake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCupcake",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-8.9 0-17 4.9-21.2 12.7S199.1 30 204 37.3l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7 0 3.7-3 6.7-6.7 6.7H152c-39.8 0-72 32.2-72 72v.8C34.9 142.7 0 181.3 0 228c0 50.8 41.2 92 92 92h264c50.8 0 92-41.2 92-92 0-46.8-35-85.5-80.2-91.3.2-2 .2-4 .2-6.1C368 58.5 309.5 0 237.3 0H224zm40 57.3c0-1.7-.1-3.3-.2-5 32.7 11 56.2 41.9 56.2 78.3 0 6-1.8 11.5-4.8 16.1-4.9 7.4-5.3 16.8-1.1 24.6s12.3 12.6 21.1 12.6H356c24.3 0 44 19.7 44 44s-19.7 44-44 44H92c-24.3 0-44-19.7-44-44s19.7-44 44-44h18.4c8.6 0 16.5-4.6 20.8-12s4.3-16.6 0-24c-2-3.5-3.2-7.6-3.2-12 0-13.3 10.7-24 24-24h57.3c30.2 0 54.7-24.5 54.7-54.7zM89.3 471.9c3.9 23.1 23.9 40.1 47.4 40.1h11.2l-20-160H69.3l20 119.9zm90.8 40.1h87.8l20-160H160.1l20 160zm120 0h11.2c23.5 0 43.5-17 47.3-40.1l20-119.9h-58.5l-20 160z"
        }
    ]
};

const FarCurlingStone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCurlingStone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 80c-22.1 0-40 17.9-40 40v24h192c35.3 0 64 28.7 64 64v1.1c54.3 7.8 96 54.4 96 110.9v48c0 61.9-50.1 112-112 112H112C50.1 480 0 429.9 0 368v-48c0-56.4 41.7-103.1 96-110.9V208c0-35.3 28.7-64 64-64h16v-24c0-48.6 39.4-88 88-88h128c13.3 0 24 10.7 24 24s-10.7 24-24 24H264zM112 432h352c35.3 0 64-28.7 64-64H48c0 35.3 28.7 64 64 64zM48 320h480c0-35.3-28.7-64-64-64H112c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FarCustard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarCustard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M116.1 112.8 53.7 368h49.4l33.6-137.6c14.1-3.8 27.9-6.4 39.3-6.4 16.7 0 28.8 5.6 45.6 13.6l1 .5C238.9 246 259.8 256 288 256s49.1-10 65.4-17.9l1-.5c16.8-8.1 28.9-13.6 45.6-13.6 11.4 0 25.2 2.6 39.3 6.4L472.9 368h49.4l-62.4-255.2c-7-28.6-32.7-48.8-62.2-48.8H178.2c-29.5 0-55.2 20.2-62.2 48.8zm310.5 65.6c-9-1.5-18-2.4-26.6-2.4-28.2 0-49.1 10-65.4 17.9l-1 .5c-16.8 8-28.9 13.6-45.6 13.6s-28.8-5.6-45.6-13.6l-1-.5C225.1 186 204.2 176 176 176c-8.6 0-17.6.9-26.6 2.4l13.3-54.2c1.8-7.2 8.2-12.2 15.5-12.2h219.6c7.4 0 13.8 5 15.5 12.2l13.3 54.2zM0 424c0 13.3 10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarD = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarD",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 80c-4.4 0-8 3.6-8 8v336c0 4.4 3.6 8 8 8h104c97.2 0 176-78.8 176-176S257.2 80 160 80H56zM0 88c0-30.9 25.1-56 56-56h104c123.7 0 224 100.3 224 224S283.7 480 160 480H56c-30.9 0-56-25.1-56-56V88z"
        }
    ]
};

const FarDagger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDagger",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c13.3 0 24 10.7 24 24v104h120c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48H96c0 26.5-21.5 48-48 48S0 202.5 0 176s21.5-48 48-48h120V24c0-13.3 10.7-24 24-24zm32 397.9V208h48v189.9c0 11.5-3.5 22.7-10.1 32.1l-50.2 71.7c-4.5 6.4-11.8 10.2-19.7 10.2s-15.2-3.8-19.7-10.2L122.1 430c-6.6-9.4-10.1-20.6-10.1-32.1V208h48v189.9c0 1.6.5 3.2 1.4 4.6l30.6 43.7 30.6-43.7c.9-1.3 1.4-2.9 1.4-4.6z"
        }
    ]
};

const FarDash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDash",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0-13.3 10.7-24 24-24h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarDatabase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDatabase",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 86v88.7c-13.3 7.2-31.6 14.2-54.8 19.9C311.3 203 269.5 208 224 208s-87.3-5-121.2-13.4C79.6 188.9 61.3 182 48 174.7V86l.6-.5c5.3-4.5 15.9-10.7 33.2-16.9C115.9 56.5 166.2 48 224 48s108.1 8.5 142.2 20.6c17.3 6.2 27.8 12.4 33.2 16.9l.6.5zm0 141.5v75.2c-13.3 7.2-31.6 14.2-54.8 19.9C311.3 331 269.5 336 224 336s-87.3-5-121.2-13.4C79.6 316.9 61.3 310 48 302.7v-75.1c13.3 5.3 27.9 9.9 43.3 13.7 38.2 9.3 83.9 14.7 132.7 14.7s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7zM48 426v-70.4c13.3 5.3 27.9 9.9 43.3 13.7 38.2 9.3 83.9 14.7 132.7 14.7s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7V426l-.6.5c-5.3 4.5-15.9 10.7-33.2 16.9C332.1 455.5 281.8 464 224 464s-108.1-8.5-142.2-20.6C64.5 437.2 54 431 48.6 426.5l-.6-.5zm354.1-2.1s0 .1-.2.2l.1-.2v-.1zm-356.1 0a.3.3 0 1 0 .6-.2.3.3 0 1 0-.6.2zm0-335.8a.3.3 0 1 0 .5.2.3.3 0 1 0-.5-.2zm356-.2a.3.3 0 1 0-.1.6.3.3 0 1 0 .1-.6zM448 432V80c0-44.2-100.3-80-224-80S0 35.8 0 80v352c0 44.2 100.3 80 224 80s224-35.8 224-80z"
        }
    ]
};

const FarDeerRudolph = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDeerRudolph",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0c8.8 0 16 7.2 16 16v24c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 8.6-1.9 16.7-5.4 24H416c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 20.7-11.2 38.7-27.9 48.4l43.7 39.7c7.3-9.8 19-16.2 32.1-16.2 22.1 0 40 17.9 40 40s-17.9 40-40 40h-.1c-2.3 35.7-31.9 64-68.2 64h-42.3l-16.1 48.2c-.8 2.4-1.2 5-1.2 7.6V472c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-96h-6.8c-22 0-43.7-4.6-63.8-13.3-4.3 17.1-14.7 32.3-29.9 42.4l-6.5 4.3 17.8 48.8c9.5 26.1-9.8 53.7-37.6 53.7h-46c-16.8 0-31.8-10.5-37.6-26.3l-22.4-61.7c-5.6-15.3-5.8-32-.6-47.4l8.2-24.7c.8-2.4 1.2-5 1.2-7.6v-4.3c0-6.4-2.5-12.5-7-17l-1.1-1.1c-1 8.4-8.4 14.7-16.9 14.1-8.8-.6-15.5-8.1-15-17l3.3-53c1.1-17.6 6.9-33.9 16.2-47.6 16.2-30 48-50.4 84.5-50.4h191l7.2-24H274c-9.9 0-18-8-18-18 0-8.2 5.6-15.4 13.6-17.4L320 96h-40c-30.9 0-56-25.1-56-56V16c0-8.8 7.2-16 16-16zm114.9 135.2-19 63.6c-3 10.2-12.4 17.1-23 17.1H104c-26.5 0-48 21.5-48 48v4.1c0 6.4 2.5 12.5 7 17l3.9 3.9c13.5 13.6 21.1 31.9 21.1 51v4.3c0 7.7-1.2 15.4-3.7 22.8l-8.2 24.7c-1.7 5.1-1.6 10.7.2 15.8L96.8 464h28.9l-20.3-55.8c-3.8-10.4 0-22 9.2-28.2l22.2-14.8c7.9-5.2 11.9-14.6 10.4-23.9l-2.9-17.4c-1.6-9.4 2.6-18.9 10.6-24.1s18.4-5.1 26.3.2l13.7 9.2c18.4 12.3 40 18.8 62.1 18.8h31c13.3 0 24 10.7 24 24v112h32V311.8c0-7.7 1.2-15.4 3.7-22.8l21.5-64.6c3.3-9.8 12.4-16.4 22.8-16.4h59.6c11.3 0 20.4-9.1 20.4-20.4 0-5.7-2.4-11.2-6.7-15.1l-57.3-52c-6-5.5-13.8-8.5-21.9-8.5-14.4 0-27.1 9.4-31.2 23.2zM400 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarDeer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDeer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 30.9 25.1 56 56 56h40l-50.4 12.6c-8 2-13.6 9.2-13.6 17.4 0 9.9 8 18 18 18h28.2l-7.2 24H104c-36.5 0-68.3 20.4-84.5 50.4-9.2 13.7-15.1 30-16.2 47.6L0 319c-.6 8.8 6.2 16.4 15 17 8.5.5 15.9-5.7 16.9-14.1L33 323c4.5 4.5 7 10.6 7 17v4.3c0 2.6-.4 5.1-1.2 7.6l-8.2 24.7c-5.1 15.4-4.9 32.1.6 47.4l22.5 61.8c5.7 15.7 20.7 26.2 37.5 26.2h46c27.8 0 47.1-27.6 37.6-53.7L157 409.5l6.5-4.3c15.2-10.1 25.6-25.4 29.9-42.4 20 8.7 41.7 13.3 63.8 13.3h6.8v96c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V311.8c0-2.6.4-5.1 1.2-7.6l16.1-48.2h42.3c37.8 0 68.4-30.6 68.4-68.4 0-19.3-8.1-37.6-22.4-50.6l-53.5-48.6C460.8 78.7 472 60.7 472 40V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 13.3-10.7 24-24 24h-69.4c3.5-7.3 5.4-15.4 5.4-24V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V16zm130.1 96c8.1 0 15.9 3 21.9 8.5l57.3 52.1c4.2 3.9 6.7 9.3 6.7 15.1 0 11.3-9.1 20.4-20.4 20.4H392c-10.3 0-19.5 6.6-22.8 16.4L347.7 289c-2.4 7.3-3.7 15-3.7 22.8V464h-32V352c0-13.3-10.7-24-24-24h-30.8c-22.1 0-43.7-6.5-62.1-18.8l-13.8-9.2c-8-5.3-18.3-5.4-26.3-.2s-12.2 14.7-10.6 24.1l2.9 17.4c1.6 9.3-2.5 18.7-10.4 23.9L114.7 380c-9.2 6.1-13 17.8-9.2 28.2l20.2 55.8H96.8l-20.5-56.5c-1.9-5.1-1.9-10.7-.2-15.8l8.2-24.7c2.4-7.3 3.7-15 3.7-22.8v-4.3c0-19.1-7.6-37.4-21.1-50.9l-3.9-3.9c-4.5-4.5-7-10.6-7-17V264c0-26.5 21.5-48 48-48h208.9c10.6 0 20-7 23-17.1l19-63.6c4.1-13.8 16.8-23.2 31.2-23.2zm29.9 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarDeleteLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDeleteLeft",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M205.3 64c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H205.3zM528 128v256c0 8.8-7.2 16-16 16H205.3c-4.2 0-8.3-1.7-11.3-4.7L54.6 256l139.3-139.3c3-3 7.1-4.7 11.3-4.7H512c8.8 0 16 7.2 16 16zm-95 47c-9.4-9.4-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9z"
        }
    ]
};

const FarDeleteRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDeleteRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M370.7 64c17 0 33.3 6.7 45.3 18.7l150.6 150.7c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h306.7zM48 128v256c0 8.8 7.2 16 16 16h306.7c4.2 0 8.3-1.7 11.3-4.7L521.4 256 382.1 116.7c-3-3-7.1-4.7-11.3-4.7H64c-8.8 0-16 7.2-16 16zm95 47c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarDemocrat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDemocrat",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M102.2 4.7C99.8 11.1 96 23.1 96 32c0 12.7 5 22.8 11.1 30.5-5.3 3.6-10.2 7.9-14.7 12.6l-70.6 76C7.8 166.2 0 186.1 0 206.6 0 251.4 36.2 288 81.2 288c13.8 0 27.4-3.5 39.4-10.2l36.4-20.3 35 75.7V456c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56v-24h96v24c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56V216c0-1.4 0-2.8-.1-4.2 5.5 5.7 9.9 11.1 13.2 15.4 2.2 2.9 3.9 5.4 5 7 .5.8.9 1.4 1.1 1.8l.2.3c6.8 11.3 21.5 15.1 32.9 8.3 11.4-6.8 15.1-21.5 8.4-32.9L616 224l20.6-12.3-.1-.1-.2-.3-.5-.8c-.4-.7-1-1.6-1.8-2.8-1.5-2.3-3.8-5.5-6.6-9.3-5.7-7.6-14.2-17.7-25.1-27.9-21.5-20-55.1-42.4-98.3-42.4-1.9 0-3.7.2-5.5.6-3.5-.4-7-.6-10.5-.6H291.1c-1.8 0-3.5-.6-5-1.7l-76.2-60.3c7.3-8 14.1-19.3 14.1-34.1 0-8.9-3.8-20.9-6.2-27.3-1-2.9-3.8-4.7-6.8-4.7-1.9 0-3.8.7-5.2 2.1L160 45.7 114.2 2.1C112.8.7 110.9 0 109 0c-3 0-5.8 1.8-6.8 4.7zM240 352h288v104c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8v-48c0-13.3-10.7-24-24-24H312c-13.3 0-24 10.7-24 24v48c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8V352zm288-48H231.4l-41.6-90.1c-2.8-6.1-8-10.7-14.3-12.8s-13.3-1.4-19.1 1.8l-59 32.8c-4.9 2.7-10.5 4.2-16.1 4.2C63 240 48 225.1 48 206.6c0-8.5 3.2-16.7 8.9-22.8l70.6-76c7.1-7.7 17.1-12.2 27.5-12.4 9.1-.2 17.9 2.7 25 8.3l76.4 60.3c9.9 7.8 22.1 12 34.7 12H488c22.1 0 40 17.9 40 40v88zm-148.7-93.7c-.7-1.4-2.2-2.3-3.8-2.3s-3.1.9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6.2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5.4 3.1 1.7 4s3.1 1 4.5.3l16.8-8.5 16.8 8.5c1.4.7 3.2.6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4zm-99.8-2.3c-1.6 0-3.1.9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6.2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5.4 3.1 1.7 4s3.1 1 4.5.3l16.8-8.5 16.8 8.5c1.4.7 3.2.6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4c-.7-1.4-2.2-2.3-3.8-2.3zm195.8 2.3c-.7-1.4-2.2-2.3-3.8-2.3s-3.1.9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6.2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5.4 3.1 1.7 4s3.1 1 4.5.3l16.8-8.5 16.8 8.5c1.4.7 3.2.6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4z"
        }
    ]
};

const FarDesktopArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDesktopArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0h160v48H64c-8.8 0-16 7.2-16 16v192h480V64c0-8.8-7.2-16-16-16H352V0h160c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM48 304v48c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16v-48H48zm204.3 160h71.3l-8-48h-55.3l-8 48zM312 24v118.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarDesktop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDesktop",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 48H64c-8.8 0-16 7.2-16 16v192h480V64c0-8.8-7.2-16-16-16zm64 208v96c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v192zM48 304v48c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16v-48H48zm204.3 160h71.3l-8-48h-55.3l-8 48z"
        }
    ]
};

const FarDharmachakra = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDharmachakra",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m232.4 24.7.4 8.5c-44.4 4.6-85 22.1-117.9 48.8l-5.7-6.3c-9.1-10-24.6-10.3-34.2-.8s-9.2 25.1.8 34.2l6.3 5.7c-26.7 32.9-44.3 73.4-48.8 117.9l-8.5-.4C11.3 231.8 0 242.5 0 256s11.3 24.2 24.7 23.6l8.5-.4c4.6 44.4 22.1 85 48.8 117.9l-6.3 5.7c-10 9.1-10.3 24.6-.8 34.2s25.1 9.2 34.2-.8l5.7-6.3c32.9 26.7 73.4 44.3 117.9 48.8l-.4 8.5c-.6 13.5 10.1 24.7 23.6 24.7s24.2-11.3 23.6-24.7l-.4-8.5c44.4-4.6 85-22.1 117.9-48.8l5.7 6.3c9.1 10 24.6 10.3 34.2.8s9.2-25.1-.8-34.2l-6.3-5.7c26.7-32.9 44.3-73.4 48.8-117.9l8.5.4c13.5.6 24.7-10.1 24.7-23.6s-11.3-24.2-24.7-23.6l-8.5.4c-4.6-44.4-22.1-85-48.8-117.9l6.3-5.7c10-9.1 10.3-24.6.8-34.2s-25.1-9.2-34.2.8l-5.6 6.2c-32.9-26.7-73.4-44.3-117.9-48.8l.4-8.5C280.2 11.3 269.5 0 256 0s-24.2 11.3-23.6 24.7zm-85.1 369.7 54.2-59.4c10.9 7.5 23.5 12.9 37.1 15.4l-3.7 80.3c-32.8-3.9-62.9-16.9-87.6-36.3zm29.6-84-59.4 54.2c-19.4-24.6-32.3-54.7-36.3-87.5l80.3-3.7c2.5 13.6 7.8 26.1 15.4 37.1zm-95.7-75.5c3.9-32.8 16.9-62.9 36.3-87.6l59.4 54.2c-7.5 10.9-12.9 23.5-15.4 37.1l-80.3-3.7zm120.3-58-54.2-59.4c24.7-19.4 54.8-32.4 87.6-36.3l3.7 80.3c-13.6 2.5-26.1 7.8-37.1 15.4zm108.9 0c-10.9-7.5-23.5-12.9-37.1-15.4l3.7-80.3c32.8 3.9 62.9 16.9 87.6 36.3l-54.2 59.4zm54.2 217.5c-24.7 19.4-54.8 32.4-87.6 36.3l-3.7-80.3c13.6-2.5 26.1-7.8 37.1-15.4l54.2 59.4zm29.8-29.8L335 310.4c7.5-10.9 12.9-23.5 15.4-37.1l80.3 3.7c-3.9 32.8-16.9 62.9-36.3 87.6zm0-217.4c19.4 24.7 32.4 54.8 36.3 87.6l-80.3 3.7c-2.5-13.6-7.8-26.1-15.4-37.1l59.4-54.2zM208 256a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FarDiagramCells = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramCells",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 224c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h384zm16 128v64c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16zm48 64v-64c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64z"
        }
    ]
};

const FarDiagramLeanCanvas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramLeanCanvas",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80v216h80V96c0-8.8-7.2-16-16-16h-64zm-48 0h-64v88h64V80zm-112 0h-64v216h64V80zm-112 0h-64v88h64V80zm-112 0H64c-8.8 0-16 7.2-16 16v200h80V80zM48 344v72c0 8.8 7.2 16 16 16h232v-88H48zm296 88h232c8.8 0 16-7.2 16-16v-72H344v88zM0 96c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm240 200v-80h-64v80h64zm224-80h-64v80h64v-80z"
        }
    ]
};

const FarDiagramNested = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramNested",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80v96H48V80h96zM48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h24v96c0 48.6 39.4 88 88 88h96v24c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v24h-96c-22.1 0-40-17.9-40-40v-96h24c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm352 304v96h-96v-96h96z"
        }
    ]
};

const FarDiagramNext = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramNext",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 224c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h168v86.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V224H448zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64h-74.3c4.8 16 2.2 33.8-7.7 48h82c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h82c-9.9-14.2-12.5-32-7.7-48H64z"
        }
    ]
};

const FarDiagramPredecessor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramPredecessor",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 416v-64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16zm-16 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h304c39.8 0 72 32.2 72 72v38.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V104c0-13.3-10.7-24-24-24h-82c1.3 5.1 2 10.5 2 16v64z"
        }
    ]
};

const FarDiagramPrevious = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramPrevious",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v64zm48-64c0-35.3-28.7-64-64-64H280v-86.1l23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23V288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-64zM64 224h74.3c-5.7-19.1-1-40.5 14.1-55.6l64-64c21.9-21.9 57.3-21.9 79.2 0l64 64c15 15 19.7 36.5 14.1 55.6H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64z"
        }
    ]
};

const FarDiagramProject = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramProject",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8h80zM56 32C25.1 32 0 57.1 0 88v80c0 30.9 25.1 56 56 56h80c5.6 0 11.1-.8 16.2-2.4l75.9 101.2c-2.7 6.5-4.1 13.7-4.1 21.2v80c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-80c0-30.9-25.1-56-56-56h-80c-5.6 0-11.1.8-16.2 2.4l-75.9-101.2c2.7-6.5 4.1-13.7 4.1-21.2v-16h192v16c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56v16H192V88c0-30.9-25.1-56-56-56H56zm304 304c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h80zm80-256h80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8z"
        }
    ]
};

const FarDiagramSankey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramSankey",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M329.9 80c-2.8 0-5.4 1.5-6.8 3.8l-69.3 113.4C243.6 213.8 225.5 224 206 224H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h182.1c2.8 0 5.4-1.5 6.8-3.8l69.3-113.4C292.3 42.2 310.4 32 329.9 32H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H329.9zm-124 240 61.7 108c1.4 2.5 4.1 4 6.9 4H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H274.6c-20.1 0-38.7-10.8-48.6-28.2L150.6 320H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h528c13.3 0 24 10.7 24 24s-10.7 24-24 24H205.9z"
        }
    ]
};

const FarDiagramSubtask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramSubtask",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H152v96c0 22.1 17.9 40 40 40h32v-8c0-35.3 28.7-64 64-64h160c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H288c-35.3 0-64-28.7-64-64v-8h-32c-48.6 0-88-39.4-88-88v-96H64c-35.3 0-64-28.7-64-64V96zm448 240H288c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarDiagramSuccessor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramSuccessor",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 416v-64c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64zM240 160c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v64zm48-64c0-5.5-.7-10.9-2-16h82c13.3 0 24 10.7 24 24v38.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V104c0-39.8-32.2-72-72-72H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V96z"
        }
    ]
};

const FarDiagramVenn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiagramVenn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M270 425.9c-47.8-41.1-78-102-78-169.9s30.3-128.8 78-169.9c-14.7-4-30.1-6.1-46-6.1-97.2 0-176 78.8-176 176s78.8 176 176 176c15.9 0 31.4-2.1 46-6.1zM252 320h136c5.9-15.1 9.8-31.2 11.3-48H240.7c1.5 16.8 5.4 32.9 11.3 48zm16.5 32c13.4 20.6 31 38.1 51.5 51.5 20.6-13.4 38.1-31 51.5-51.5h-103zM252 192c-5.9 15.1-9.8 31.2-11.3 48h158.6c-1.5-16.8-5.4-32.9-11.3-48H252zm119.5-32c-13.4-20.6-31-38.1-51.5-51.5-20.6 13.4-38.1 31-51.5 51.5h103zM320 458.4c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224S539.7 480 416 480c-34.4 0-66.9-7.7-96-21.6z"
        }
    ]
};

const FarDialHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDialHigh",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 248h109.4c-11 50.3-55.8 88-109.4 88-61.9 0-112-50.1-112-112s50.1-112 112-112c53.6 0 98.4 37.7 109.4 88H288c-13.3 0-24 10.7-24 24s10.7 24 24 24zm160-24a160 160 0 1 0-320 0 160 160 0 1 0 320 0zm128 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarDialLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDialLow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 336c-53.6 0-98.4-37.7-109.4-88H288c13.3 0 24-10.7 24-24s-10.7-24-24-24H178.6c11-50.3 55.8-88 109.4-88 61.9 0 112 50.1 112 112s-50.1 112-112 112zM128 288a160 160 0 1 0 320 0 160 160 0 1 0-320 0zm448 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarDialMax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDialMax",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-17 241 77.4 77.4c-43.4 27.8-101.7 22.8-139.6-15.1-43.7-43.7-43.7-114.7 0-158.4s114.7-43.7 158.4 0c37.9 37.9 43 96.2 15.1 139.6L305 271c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm130.1 96.2a160 160 0 1 0-226.2-226.3 160 160 0 1 0 226.2 226.2zM576 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarDialMedLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDialMedLow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-79.2 303.2c-37.9-37.9-43-96.2-15.1-139.6L271 305c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-77.4-77.4c43.4-27.8 101.7-22.8 139.6 15.1 43.7 43.7 43.7 114.7 0 158.4s-114.7 43.7-158.4 0zm-33.9-192.3a160 160 0 1 0 226.2 226.2 160 160 0 1 0-226.2-226.2zM576 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarDialMed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDialMed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM176 288c0-53.6 37.7-98.4 88-109.4V288c0 13.3 10.7 24 24 24s24-10.7 24-24V178.6c50.3 11 88 55.8 88 109.4 0 61.9-50.1 112-112 112s-112-50.1-112-112zm112-160a160 160 0 1 0 0 320 160 160 0 1 0 0-320zm288 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarDialMin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDialMin",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-17 207-77.4 77.4c-27.8-43.4-22.8-101.7 15.1-139.6 43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4c-37.9 37.9-96.2 43-139.6 15.1L305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zm-96.1 130.1a160 160 0 1 0 226.2-226.2 160 160 0 1 0-226.2 226.2zM576 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarDialOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDialOff",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-24 224v109.4c-50.3-11-88-55.8-88-109.4 0-61.9 50.1-112 112-112s112 50.1 112 112c0 53.6-37.7 98.4-88 109.4V288c0-13.3-10.7-24-24-24s-24 10.7-24 24zm24 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm288-160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarDial = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDial",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-79.2 144.8c37.9-37.9 96.2-43 139.6-15.1L271 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l77.4-77.4c27.8 43.4 22.8 101.7-15.1 139.6-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4zm192.3-33.9a160 160 0 1 0-226.2 226.2 160 160 0 1 0 226.2-226.2zM576 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarDiamondExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiamondExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M50.9 249 249 50.9c1.9-1.9 4.4-2.9 7-2.9s5.2 1 7 2.9L461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L263 461.1c-1.9 1.9-4.4 2.9-7 2.9s-5.2-1-7-2.9L50.9 263c-1.9-1.9-2.9-4.4-2.9-7s1-5.2 2.9-7zM215 17 17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41l198 198c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17l198-198c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17zm41 111c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarDiamondHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiamondHalfStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464V48c2.6 0 5.2 1 7 2.9L461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L263 461.1c-1.9 1.9-4.4 2.9-7 2.9zM215 17 17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41l198 198c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17l198-198c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17z"
        }
    ]
};

const FarDiamondHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiamondHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215 17c10.9-10.9 25.6-17 41-17v512c-15.4 0-30.1-6.1-41-17L17 297C6.1 286.1 0 271.4 0 256s6.1-30.1 17-41L215 17zm-7 403.1V91.9L50.9 249c-1.9 1.9-2.9 4.4-2.9 7s1 5.2 2.9 7L208 420.1z"
        }
    ]
};

const FarDiamondTurnRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiamondTurnRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M50.9 249 249 50.9c1.9-1.9 4.4-2.9 7-2.9s5.2 1 7 2.9L461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L263 461.1c-1.9 1.9-4.4 2.9-7 2.9s-5.2-1-7-2.9L50.9 263c-1.9-1.9-2.9-4.4-2.9-7s1-5.2 2.9-7zM215 17 17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41l198 198c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17l198-198c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17zm100.3 131.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v40h-48c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48c0-8.8 7.2-16 16-16h48v40c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"
        }
    ]
};

const FarDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiamond",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M249 50.9 50.9 249c-1.9 1.9-2.9 4.4-2.9 7s1 5.2 2.9 7L249 461.1c1.9 1.9 4.4 2.9 7 2.9s5.2-1 7-2.9L461.1 263c1.9-1.9 2.9-4.4 2.9-7s-1-5.2-2.9-7L263 50.9c-1.9-1.9-4.4-2.9-7-2.9s-5.2 1-7 2.9zM17 215 215 17c10.9-10.9 25.6-17 41-17s30.1 6.1 41 17l198 198c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L297 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17L17 297C6.1 286.1 0 271.4 0 256s6.1-30.1 17-41z"
        }
    ]
};

const FarDiceD10 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceD10",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c6.9 0 13.5 3 18 8.2l232 264c4.2 4.8 6.4 11.1 5.9 17.5s-3.4 12.3-8.3 16.5l-232 200c-9 7.8-22.3 7.8-31.3 0l-232-200C3.5 302 .5 296 .1 289.7S1.7 277 6 272.2l232-264C242.5 3 249.1 0 256 0zM91.6 247.4l50.9-12 36-86.9-86.9 98.9zM256 86.8 189.7 247l66.3 44.2 66.3-44.2L256 86.8zm100.6 195-76.6 51v102.8l156.7-135-80-18.8zm63.8-34.3-86.9-98.9 36 86.9 50.9 12zM232 435.6V332.8l-76.6-51.1-80 18.8L232 435.6z"
        }
    ]
};

const FarDiceD12 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceD12",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m200.3 48-41.6 24 97.3 30.8L353.3 72l-41.6-24H200.3zm-97.1 56.7-53.5 92.6 83.9 93.1 98.4-49.2v-95.6l-128.8-40.9zM48 267.1v44.7l55.7 96.5 36.3 20.9-33.1-96.8L48 267.1zM202.7 464h108l43.9-131.8-98.6-49.4-98.5 49.3L202.7 464zm170.5-35.4 35.2-20.3 55.6-96.6v-44.6l-58.8 65.3-32.1 96.2zm89.2-231.3L409 104.8l-129 40.8v95.6l98.4 49.2 83.9-93.1zM176.3 6.4c7.3-4.2 15.6-6.4 24-6.4h111.4c8.4 0 16.7 2.2 24 6.4l96.5 55.7c7.3 4.2 13.4 10.3 17.6 17.6l55.7 96.5c4.2 7.3 6.4 15.6 6.4 24v111.5c0 8.4-2.2 16.7-6.4 24l-55.7 96.5c-4.2 7.3-10.3 13.4-17.6 17.6l-96.5 55.7c-7.3 4.2-15.6 6.4-24 6.4H200.3c-8.4 0-16.7-2.2-24-6.4l-96.6-55.7c-7.3-4.2-13.4-10.3-17.6-17.6L6.4 335.7c-4.2-7.3-6.4-15.6-6.4-24V200.3c0-8.4 2.2-16.7 6.4-24l55.8-96.6c4.2-7.3 10.3-13.4 17.6-17.6l96.5-55.7z"
        }
    ]
};

const FarDiceD20 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceD20",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.7 3.4c7.6-4.6 17.1-4.6 24.7 0l200 120c7.2 4.3 11.7 12.1 11.7 20.6v224c0 8.4-4.4 16.2-11.7 20.6l-200 120c-7.6 4.6-17.1 4.6-24.7 0l-200-120C36.4 384.2 32 376.4 32 368V144c0-8.4 4.4-16.2 11.7-20.6l200-120zM80 191.1v83.4l32.8-59.5L80 191.1zm65.5 63.9-50.6 92 115 9.2-64.4-101.1zm10.6 145 75.9 45.6v-39.4l-75.9-6.1zm123.9 6.2v39.5l75.9-45.5-75.9 6zm152-131.6v-83.5L399.2 215l32.8 59.6zm-57-101.3 37.6-27.3-85.5-51.4 47.9 78.7zM184.9 94.6l-85.5 51.3 37.6 27.4 47.9-78.6zM256 70.2 186.7 184h138.6L256 70.2zM324.3 232H187.7L256 339.3 324.3 232zm-22.2 124.2 115-9.2-50.6-92-64.4 101.2z"
        }
    ]
};

const FarDiceD4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceD4",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c7.3 0 14.1 3.3 18.7 8.9l232 288c4.1 5.1 5.9 11.5 5.1 18s-4.1 12.3-9.3 16.2l-232 176c-8.6 6.5-20.4 6.5-29 0l-232-176c-5.2-3.9-8.5-9.8-9.3-16.2s1.1-12.9 5.1-18l232-288C241.9 3.3 248.7 0 256 0zM58.2 307.8 232 439.7V92.1L58.2 307.8zM280 92.1v347.6l173.8-131.9L280 92.1z"
        }
    ]
};

const FarDiceD6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceD6",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.9 7.7C231.5.7 216.3.8 204 8L19.8 115.6C7.5 122.8 0 135.9 0 150.1v216.5c0 14.5 7.8 27.8 20.5 34.9l184 103c12.1 6.8 26.9 6.8 39.1 0l184-103c12.6-7.1 20.5-20.4 20.5-34.9V146.8c0-14.4-7.7-27.7-20.3-34.8L243.9 7.7zM71.8 140.8l152.4-89.1 152 86.2-152.4 90.3-152-87.4zM48 182.4l152 87.4v177.3L48 361.9V182.4zm200 264.7V269.7l152-90.1v182.3l-152 85.2z"
        }
    ]
};

const FarDiceD8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceD8",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M239 7c9.4-9.4 24.6-9.4 33.9 0L505 239c9.4 9.4 9.4 24.6 0 33.9L273 505c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L239 7zM126.2 324.3 232 430.1V368l-105.8-43.7zM280 368v62l105.8-105.7L280 368zm165.6-120.4L280 81.9v234.2l165.6-68.5zM232 81.9 66.4 247.6 232 316.1V81.9z"
        }
    ]
};

const FarDiceFive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceFive",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarDiceFour = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceFour",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm0 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224-224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarDiceOne = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceOne",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarDiceSix = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceSix",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm0 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160-160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarDiceThree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceThree",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarDiceTwo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiceTwo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm288 320a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarDice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDice",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241 68.3c-9.4-9.4-24.6-9.4-33.9 0L68.3 207c-9.4 9.4-9.4 24.6 0 33.9L207 379.7c9.4 9.4 24.6 9.4 33.9 0L379.7 241c9.4-9.4 9.4-24.6 0-33.9L241 68.3zm-67.9-34c28.1-28.1 73.7-28.1 101.8 0l138.8 138.8c28.1 28.1 28.1 73.7 0 101.8L274.9 413.7c-28.1 28.1-73.7 28.1-101.8 0L34.3 274.9c-28.1-28.1-28.1-73.7 0-101.8L173.1 34.3zM320 413.8l116.3-116.3c28.6-28.6 37-69.6 25.4-105.5H576c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H384c-35.3 0-64-28.7-64-64v-34.2zM504 352a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM120 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104-56a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 208a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm104-152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-104 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarDinosaur = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDinosaur",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M449.1 0c-16.8 0-33 6-45.7 16.9l-27.7 23.8c-15 12.8-23.7 31.7-23.7 51.5 0 37.5 30.4 67.8 67.8 67.8H472c13.3 0 24 10.7 24 24v19.2c0 11.5-9.3 20.8-20.8 20.8-13 0-25.6-3.8-36.4-11l-25.5-17c-35.2-23.5-76.6-36-119-36h-9.1c-60.8 0-119.5 22.7-164.5 63.6l-80.2 73C14.7 320 0 353.3 0 388.2 0 456.6 55.4 512 123.8 512h131.3c35.9 0 64.9-29.1 64.9-64.9 0-33-24.7-60.7-57.4-64.5l-103.2-12c-2.5-10.6-12-18.6-23.4-18.6-13.3 0-24 10.7-24 24 0 21.3 16 39.2 37.1 41.7L257 430.3c8.5 1 15 8.2 15 16.8 0 9.3-7.6 16.9-16.9 16.9H123.8C82 464 48 430 48 388.2c0-21.4 9-41.7 24.8-56.1l80.2-73c36.2-32.9 83.3-51.1 132.2-51.1h9.1c32.9 0 65 9.7 92.4 28l25.4 16.9c18.7 12.5 40.6 19.1 63.1 19.1 38 0 68.8-30.8 68.8-68.8V184c0-39.8-32.2-72-72-72h-52.2c-11 0-19.8-8.9-19.8-19.8 0-5.8 2.5-11.3 6.9-15.1l27.7-23.8c4-3.4 9.1-5.3 14.4-5.3h11.6C533.2 48 592 106.8 592 179.3v26.9c0 65-28.9 126.6-78.8 168.2l-8.6 7.2c-6.2 5.2-9.2 12.9-8.6 20.4-.1.7-.1 1.3-.1 2v52c0 4.4-3.6 8-8 8H440c-4.4 0-8-3.6-8-8v-32c0-8-3.9-15.4-10.5-19.9-6.6-4.4-14.9-5.4-22.3-2.4h-.1c-.2.1-.5.2-.9.3-.9.3-2.4.8-4.6 1.5-4.2 1.3-10.8 3.1-19.5 5-7.7 1.6-17.1 3.3-28.2 4.6 4 10.6 6.1 22 6.1 34 0 4.7-.3 9.3-1 13.8 12.7-1.5 23.7-3.4 32.9-5.4h.1v.5c0 30.9 25.1 56 56 56h48c30.9 0 56-25.1 56-56v-44.8c60.8-50.7 96-125.8 96-205v-26.9C640 80.3 559.7 0 460.7 0h-11.6zM480 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarDiploma = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiploma",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m320 80.3-18-20.6A81.011 81.011 0 0 0 241 32h-1c-44.2 0-80 35.8-80 80 0 11.4 2.4 22.2 6.7 32H96c-65.1.3-96 71.5-96 128 0 56.9 24.1 119.2 81 140.7 10.5 4 22.5 4.2 33.4 1.8L256 383v81c0 6.2 3.6 11.9 9.2 14.5s12.3 1.8 17-2.2l37.8-31.5 37.8 31.5c4.8 4 11.4 4.8 17 2.2s9.2-8.3 9.2-14.5v-81l141.6 31.5c10.9 2.4 22.9 2.2 33.4-1.8 56.9-21.5 81-83.8 81-140.7 0-56.5-30.9-127.7-96-128h-70.7c4.3-9.8 6.7-20.6 6.7-32 0-44.2-35.8-80-80-80h-1c-23.4 0-45.6 10.1-61 27.7l-18 20.6zm80 63.7h-54.4c-6.9 0-10.5-8.1-6-13.3l34.5-39.5c5.5-6.3 13.1-10.2 21.3-11.1 1.2-.1 2.3-.2 3.5-.2h1c17.7 0 32 14.3 32 32s-14.3 32-32 32zm-105.6 0H240c-17.7 0-32-14.3-32-32s14.3-32 32-32h1c9.5 0 18.6 4.1 24.8 11.3l34.5 39.5c4.5 5.2.9 13.3-6 13.3zM240 192h16v141.8l-152 33.8c-1.5.3-3.1.5-4.3.4-1.1 0-1.6-.2-1.7-.2-29.9-11.3-50-48.1-50-95.8 0-20.6 5.9-43.3 16.1-59.3 9.5-14.9 19.9-20.6 32-20.7H240zm144 0h159.9c12.1.1 22.6 5.8 32.1 20.7 10.2 16 16.1 38.7 16.1 59.3 0 47.7-20.1 84.5-50 95.8-.1 0-.6.2-1.7.2-1.3.1-2.8-.1-4.3-.4L384 333.8V192z"
        }
    ]
};

const FarDiscDrive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDiscDrive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96v336h352V96c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm400 0v336h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64zM112 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm176 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarDisease = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDisease",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64.1 286.3c0-19.3-8.3-37.6-22.8-50.3l-19.5-17C8 206.9.1 189.5.1 171.2c0-39.3 35.3-69.3 74.1-62.8l55.6 9.3c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3 0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8v25.2c0 32.7-26.5 59.3-59.3 59.3-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3h-7.4c-9.6 0-19.2 1.2-28.5 3.5l-55 13.7c-32.6 8.2-65.7-11.7-73.8-44.3-5.7-22.6 2.1-46.4 20-61.4L49.8 317c9.1-7.6 14.3-18.9 14.3-30.7zM267 102.1c-31.8 47.7-88.6 72.3-145.1 62.9l-55.6-9.3c-9.5-1.6-18.2 5.8-18.2 15.4 0 4.5 1.9 8.8 5.3 11.7l19.5 17.1c24.9 21.8 39.2 53.3 39.2 86.4 0 26.1-11.5 50.8-31.5 67.5L68 364.3c-3.8 3.2-5.4 8.2-4.2 13 1.7 6.9 8.7 11.1 15.6 9.4l54.9-13.7c13.1-3.3 26.6-4.9 40.1-4.9h7.4c38.1 0 75.2 13 104.9 36.8l30.9 24.7c2 1.6 4.5 2.5 7 2.5 6.2 0 11.3-5 11.3-11.3v-25.2c0-54.7 33.6-103.7 84.6-123.5l36.9-14.3c4-1.5 6.6-5.3 6.6-9.6 0-5-3.5-9.2-8.4-10.1l-28-5.1c-55.4-10.1-99.4-52.4-111.8-107.4l-7-31.6c-1.8-8.2-9.1-14-17.5-14-6 0-11.6 3-14.9 8l-9.4 14.1zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm48-128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarDisplayArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDisplayArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0h160v48H64c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H352V0h160c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zm196.3 416-8 48h71.3l-8-48h-55.3zM312 24v182.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarDisplayChartUpCircleCurrency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDisplayChartUpCircleCurrency",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h448c8.8 0 16 7.2 16 16v130.9c17 3.1 33.1 8.7 48 16.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h147.7l-8 48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h242.8c-18.3-12.9-34.1-29.2-46.3-48h-96.2l8-48h66.4c-4.3-15.3-6.6-31.4-6.6-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm416 144.7V120c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111V200c0 1.3.1 2.6.3 3.9 15-5.8 31-9.7 47.7-11.2zM640 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-118.6 25.4a35.9 35.9 0 1 0-50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l17.2-17.4c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l17.4 17.3c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426z"
        }
    ]
};

const FarDisplayChartUpCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDisplayChartUpCircleDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h448c8.8 0 16 7.2 16 16v130.9c17 3.1 33.1 8.7 48 16.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h147.7l-8 48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h242.8c-18.3-12.9-34.1-29.2-46.3-48h-96.2l8-48h66.4c-4.3-15.3-6.6-31.4-6.6-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm416 144.7V120c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111V200c0 1.3.1 2.6.3 3.9 15-5.8 31-9.7 47.7-11.2zM640 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-167.2-32.6c-.4.7-.9 1.6-.8 3.6v.1c0 .4 0 1.9 4.8 4.5 5.6 3 13.5 5.2 23.9 8.2h.2c9.3 2.6 21.1 6 30.5 11.5 10.2 6 20 16.1 20.5 32.3.5 18.2-9.7 30.4-21.7 36.9-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-11.4c-8.6-1.7-16.7-4.3-23.7-6.6-1.7-.6-3.4-1.1-5-1.6-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8 11.4 3.6 20.4 6.5 29.9 6.8 6.7.2 13.8-1.1 18.5-3.6 2.2-1.2 3.4-2.4 4-3.3.5-.8 1.1-2.1 1-4.5 0-1.4-.2-3-4.7-5.6-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3-9.9-5.3-20.6-14.7-21.6-30.7-1.2-18.8 10-30.9 21.8-37.2 5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3.9 12.3 2.3 17.9 3.7 8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1-6.2-.1-13.6 1.3-18.7 4-2.4 1.3-3.6 2.5-4.2 3.4z"
        }
    ]
};

const FarDisplayChartUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDisplayChartUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 48c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h448zM64 416h147.7l-8 48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-51.7l-8-48H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64zm188.3 48 8-48h55.3l8 48h-71.3zM376 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111V200c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24H376z"
        }
    ]
};

const FarDisplayCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDisplayCode",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 48c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h448zM64 416h147.7l-8 48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-51.7l-8-48H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64zm188.3 48 8-48h55.3l8 48h-71.3zM249 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zm112-34c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"
        }
    ]
};

const FarDisplayMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDisplayMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 48c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h448zM64 416h147.7l-8 48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-51.7l-8-48H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64zm188.3 48 8-48h55.3l8 48h-71.3zm3.7-336v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarDisplaySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDisplaySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-70.5-55.2c27.4-7.2 47.6-32.2 47.6-61.9V64c0-35.3-28.7-64-64-64H96C79.6 0 64.6 6.2 53.2 16.4L38.8 5.1zm54.9 43c.7-.1 1.5-.2 2.3-.2h448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16h-42.2L93.7 48.2zM80 352V159.2l-48-37.8V352c0 35.3 28.7 64 64 64h147.7l-8 48H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-51.7l-8-48h9.7l-61-48H96c-8.8 0-16-7.2-16-16zm212.3 64h55.3l8 48h-71.3l8-48z"
        }
    ]
};

const FarDisplay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDisplay",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zm147.7 368H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48zm48.7 0-8 48h71.3l-8-48h-55.4z"
        }
    ]
};

const FarDistributeSpacingHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDistributeSpacingHorizontal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 0c-13.3 0-24 10.7-24 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zM304 368h-96V144h96v224zm48-224c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V144zM80 24C80 10.7 69.3 0 56 0S32 10.7 32 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V24z"
        }
    ]
};

const FarDistributeSpacingVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDistributeSpacingVertical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0 13.3 10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 32 0 42.7 0 56zm368 152v96H144v-96h224zm-224-48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48H144zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarDitto = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDitto",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 105.9c0 1.4.1 2.8.4 4.3L72 252l23.6-141.9c.2-1.4.4-2.8.4-4.3V104c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.9zm96 0c0 4.1-.3 8.1-1 12.1l-24.4 146.5C114.8 287.3 95.1 304 72 304s-42.8-16.7-46.6-39.5L1 118c-.7-4-1-8.1-1-12.1V104c0-39.8 32.2-72 72-72s72 32.2 72 72v1.9zm80 0c0 1.4.1 2.8.4 4.3L248 252l23.6-141.9c.2-1.4.4-2.8.4-4.3V104c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.9zm96 0c0 4.1-.3 8.1-1 12.1l-24.4 146.5c-3.8 22.8-23.5 39.5-46.6 39.5s-42.8-16.7-46.6-39.5L177 118c-.7-4-1-8.1-1-12.1V104c0-39.8 32.2-72 72-72s72 32.2 72 72v1.9z"
        }
    ]
};

const FarDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDivide",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 96a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm0 320a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm144-136c13.3 0 24-10.7 24-24s-10.7-24-24-24H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h368z"
        }
    ]
};

const FarDna = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDna",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 2.7-.1 5.4-.2 8H80.2c-.2-2.6-.2-5.3-.2-8C80 10.7 69.3 0 56 0S32 10.7 32 24c0 55.6 24.5 101.9 58.1 141.9 27.2 32.4 61.5 62 95.8 90.1-34.3 28.1-68.6 57.7-95.8 90.1C56.5 386.1 32 432.4 32 488c0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.7.1-5.4.2-8h287.6c.2 2.6.2 5.3.2 8 0 13.3 10.7 24 24 24s24-10.7 24-24c0-55.6-24.5-101.9-58.1-141.9-20.6-24.5-45.2-47.3-70.8-69.2-8.7 7.1-17.3 14.1-25.7 20.9l-2.2 1.8c-3.4 2.7-6.7 5.5-10.1 8.1 11.2 9.4 22.1 18.8 32.3 28.3h-115c22-20.4 46.7-40.4 72.2-61 .3-.2.5-.4.8-.6l.7-.6c41.3-33.4 84.7-68.6 117.7-107.9C391.5 125.9 416 79.6 416 24zM121.1 384h205.8c12.4 15.7 22.4 31.6 29.4 48H91.7c7-16.4 17-32.3 29.4-48zM91.7 80h264.6c-7 16.4-17 32.3-29.4 48H121.1c-12.4-15.7-22.4-31.6-29.4-48zm189.8 96c-17.8 16.4-37.2 32.6-57.5 49.1-20.3-16.5-39.7-32.7-57.5-49.1h115z"
        }
    ]
};

const FarDoNotEnter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDoNotEnter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm128-48h256c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarDogLeashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDogLeashed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M69.6 8.6c8.5-10.2 23.7-11.5 33.8-3l189.2 158.9 20.9-125.2.1-.4.9-5.6 3.1-18.4C319 6.3 326.4 0 335.1 0c5.6 0 10.9 2.6 14.3 7.1L360.6 22l3.4 4.6.2.3L368 32h76.1c12.7 0 24.9 5.1 33.9 14.1L496 64h32c26.5 0 48 21.5 48 48v32c0 53-43 96-96 96h-45.3l-2.7 16v192c0 35.3-28.7 64-64 64h-16c-35.3 0-64-28.7-64-64v-68.4c-10.4 2.3-21.1 3.7-32 4.2-2.7.1-5.3.2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2V448c0 35.3-28.7 64-64 64h-16c-35.3 0-64-28.7-64-64V224c0-1.3.1-2.6.2-3.8-1.1-.3-2.2-.7-3.3-1.1-27.4-9.6-49-32.4-56.4-61.8L.7 141.8c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l3.9 15.5C55.6 163.5 71.6 176 90 176h141.6L72.6 42.4c-10.2-8.5-11.5-23.7-3-33.8zM318 342.2c11.4 9.1 18 22.9 18 37.4V448c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V274.8l-96-48v104.8c10.8 0 21.4 3.7 30 10.6zm-78-6.4V224H112.1l-.1.8V448c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-68.4c0-14.6 6.6-28.3 18-37.4s26.2-12.6 40.4-9.4c7 1.5 14.2 2.6 21.6 3zm94.2-139.5 55.3 27.6c6.7-18.8 24.6-31.9 45.2-31.9H480c26.5 0 48-21.5 48-48v-32h-32c-12.7 0-24.9-5.1-33.9-14.1l-18-17.9H368c-4.2 0-8.4-.6-12.4-1.6L338 183.9c-.7 4.4-2 8.5-3.8 12.4zM416 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarDog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDog",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M318 342.2c11.4 9.1 18 22.9 18 37.4V448c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V274.3L300.5 223c-3.2.7-6.5 1-9.9 1H112.1l-.1.8V448c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-68.4c0-14.6 6.6-28.3 18-37.4s26.2-12.6 40.4-9.4c9.5 2.1 19.4 3.2 29.6 3.2s20.1-1.1 29.6-3.2c14.2-3.1 29.1.3 40.4 9.4zM336.9 189l53.4 32.8c7.2-17.7 24.6-29.8 44.4-29.8H480c26.5 0 48-21.5 48-48v-32h-32c-12.7 0-24.9-5.1-33.9-14.1l-18-17.9H368c-4.2 0-8.4-.6-12.4-1.6L338 183.9c-.3 1.7-.7 3.4-1.1 5.1zM64.2 220.2c-1.1-.3-2.2-.7-3.3-1.1-27.4-9.6-49-32.4-56.4-61.8L.7 141.8c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l3.9 15.5C55.6 163.5 71.6 176 90 176h200.7l22.8-136.7.1-.4.9-5.6 3.1-18.4C319 6.3 326.4 0 335.1 0c5.6 0 10.9 2.6 14.3 7.1L360.6 22l3.4 4.6.2.3L368 32h76.1c12.7 0 24.9 5.1 33.9 14.1L496 64h32c26.5 0 48 21.5 48 48v32c0 53-43 96-96 96h-45.3l-2.7 16v192c0 35.3-28.7 64-64 64h-16c-35.3 0-64-28.7-64-64v-68.4c-10.4 2.3-21.1 3.7-32 4.2-2.7.1-5.3.2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2V448c0 35.3-28.7 64-64 64h-16c-35.3 0-64-28.7-64-64V224c0-1.3.1-2.6.2-3.8zM416 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarDollarSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDollarSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v47.7c-3.1.1-6.2.3-9.3.6-23.2 1.9-47.2 7.4-67.2 20.1-20.8 13.2-36 33.6-41.5 61.8-3.9 20.3-2 38.8 6.1 55.2 8 16 20.9 27.6 34.8 36.2 26.2 16.2 61.9 25.3 92.9 33.2l2.3.6c33.9 8.6 62.6 16.1 81.7 28 9 5.6 14.3 11.2 17.1 16.9 2.7 5.3 4.2 12.8 2 24.5-2.9 14.7-13.4 26.9-34.5 34.9-21.6 8.2-52 10.9-87.6 5.9-22.6-3.3-61.8-12.7-83-22.1-12.1-5.4-26.3.1-31.7 12.2s.1 26.3 12.2 31.7c26.7 11.8 70.8 22 95.7 25.6h.1c3.3.5 6.6.9 9.9 1.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-48.6c19.3-1.3 37.4-4.9 53.5-11 31.9-12.1 57.7-35.2 64.5-70.6 3.9-20.3 2-38.8-6.1-55.2-8-16-20.9-27.6-34.8-36.2-26.2-16.2-61.9-25.3-92.9-33.2l-2.3-.6c-33.9-8.6-62.6-16.1-81.7-28-9-5.6-14.3-11.2-17.1-16.9-2.7-5.3-4.2-12.8-2-24.5 2.9-14.8 10.1-24 20.2-30.4 10.9-6.9 26.3-11.2 45.3-12.7 38.3-3.1 83.1 5.3 113.9 12.5 12.9 3.1 25.8-4.9 28.9-17.8s-4.9-25.8-17.8-28.9c-18.7-4.4-44.2-9.7-71.5-12.5V24z"
        }
    ]
};

const FarDollyEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDollyEmpty",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h80.8C129 0 150.5 15.6 158 38.6l92 281.6c2-.1 4-.2 6-.2 33.2 0 62.5 16.9 79.8 42.5L544 289.4c12.5-4.4 26.2 2.2 30.6 14.7s-2.2 26.2-14.7 30.6l-208.2 73.1c.2 2.7.3 5.4.3 8.2 0 53-43 96-96 96s-96-43-96-96c0-34 17.7-63.9 44.3-80.9L112.4 53.5c-1.1-3.3-4.1-5.5-7.6-5.5H24C10.7 48 0 37.3 0 24zm304 392a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarDolly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDolly",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h80.8c3.5 0 6.5 2.2 7.6 5.5l91.9 281.6C177.7 352.1 160 382 160 416c0 53 43 96 96 96s96-43 96-96c0-2.8-.1-5.5-.3-8.2L560 334.6c12.5-4.4 19.1-18.1 14.7-30.6s-18.1-19.1-30.6-14.7l-208.3 73.2C318.5 336.9 289.2 320 256 320c-2 0-4 .1-6 .2L158 38.6C150.5 15.6 129 0 104.8 0H24zm232 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm201.4-250.7c-10.6-28.7-42.2-43.7-71.1-33.5l-161.4 56.7 14.9 45.6 57.5-20.2 24.1 66.3c4.5 12.5 18.3 18.9 30.8 14.4s18.9-18.3 14.4-30.8l-24-65.8 59.6-20.9c4.1-1.4 8.7.7 10.2 4.8L467 282.5l45.3-15.9-54.9-149.3z"
        }
    ]
};

const FarDolphin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDolphin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 160c0 13.3 2.3 26 6.5 37.8 3.9 10.8-.4 22.8-10.2 28.7l-19.5 11.7-12.1-20.3 12.1 20.2c-5.5 3.3-8.8 9.2-8.8 15.6 0 10.1 8.2 18.2 18.2 18.2h182.7c6.3 0 12.3 2.5 16.8 6.8l38.3 37.6V296c0-13.3 10.7-24 24-24h16c48.6 0 88 39.4 88 88v10.6c19.9-21.2 32-49.6 32-81 0-60.8-22.4-116.2-59.4-158.7-7.2-8.2-7.9-20.3-1.7-29.3 10.4-15.3 23.4-35.5 31.4-51.9-27.3 4-58.4 14.3-84.2 24.6-6.4 2.5-13.5 2.2-19.6-.8C297.9 57.2 261.2 48 222.3 48H192C130.1 48 80 98.1 80 160zm197.7 248H344c22.1 0 40-17.9 40-40v-8c0-19.4-13.7-35.5-32-39.2v1.9c0 25-20.3 45.3-45.3 45.3-11.8 0-23.2-4.6-31.7-12.9L239.1 320H66.2C29.6 320 0 290.4 0 253.8 0 230.5 12.2 209 32.1 197l3.7-2.2C33.3 183.6 32 171.9 32 160 32 71.6 103.6 0 192 0h30.3c42.7 0 83.3 9.3 119.9 25.9C374.9 13.5 418.7 0 456 0c7.8 0 17.9 2.4 25.2 11.3 6.7 8.1 7.5 17.4 7.3 23.2-.4 11.3-5.2 23.4-9.7 33.1-7 15-17.1 31.8-26.4 46.2 37.4 48.7 59.6 109.7 59.6 175.9 0 91.8-74.5 166.3-166.3 166.3h-68c-19.9 34.5-56.8 56-97 56H176c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l28.4-56.8-28.4-56.8c-2.5-5-2.2-10.9.7-15.6s8.1-7.6 13.6-7.6h4.7c40.2 0 77.1 21.5 97 56zM136 160a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarDongSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDongSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 32c-13.3 0-24 10.7-24 24v8h-56c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v76.1c-21.9-17.6-49.7-28.1-80-28.1-70.7 0-128 57.3-128 128s57.3 128 128 128c30.3 0 58.1-10.5 80-28.1v4.1c0 13.3 10.7 24 24 24s24-10.7 24-24V112h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24zM112 288a80 80 0 1 1 160 0 80 80 0 1 1-160 0zM24 448c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarDonut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDonut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 289.9c7.7 5 14.4 11.5 19.5 19.2 9.4 13 22 23.4 36.5 30.2 14.7 6.8 30.8 9.7 46.9 8.4h1.2c17.7-.2 35.3 3.3 51.7 10.1h.1c16.4 7 34.1 10.5 51.9 10.3h.3c17.8.2 35.5-3.3 51.9-10.3h.1c16.4-6.8 34-10.2 51.7-10.1h1.2c16.1 1.3 32.2-1.5 46.9-8.3 14.6-6.7 27.1-17.1 36.5-30.1 5.1-7.8 11.8-14.3 19.5-19.3v14c0 21.7-14.2 48.5-52.4 72.4C374 399.9 319.1 416 256 416s-118-16.1-155.6-39.6C62.2 352.5 48 325.7 48 304v-14.1zM256 48C114.6 48 0 119.6 0 208v96c0 88.4 114.6 160 256 160s256-71.6 256-160v-96c0-88.4-114.6-160-256-160zm64 144c0 17.7-28.7 32-64 32s-64-14.3-64-32 28.7-32 64-32 64 14.3 64 32zM283.3 84.7c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0zm-112 38.6-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm224 9.4 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM64 192h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm331.3 36.7 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-240 16 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm176 38.6-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FarDoorClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDoorClosed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 48c8.8 0 16 7.2 16 16v400H144V64c0-8.8 7.2-16 16-16h256zm64 416V64c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64v400H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72zM368 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
        }
    ]
};

const FarDoorOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDoorOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 49.7V464H112V92.8l160-43.1zM320 464V42.4C320 19 301 0 277.6 0c-3.7 0-7.4.5-11 1.5L99.5 46.4C78.6 52.1 64 71.1 64 92.8V464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h296v-48zm-96-176c13.2 0 24-14.4 24-32s-10.8-32-24-32-24 14.4-24 32 10.7 32 24 32zm128-176h104c4.4 0 8 3.6 8 8v368c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V120c0-30.9-25.1-56-56-56H352v48z"
        }
    ]
};

const FarDove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDove",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256.3 159c1-14.8 4.3-28.9 9.6-42-14.6-25.7-24.2-55.4-25.3-89-.4-11.3-7.5-21.5-18.4-24.4-7.6-2-15.8-.2-21 5.8-11 12.8-26.3 35.1-40.2 66.7 13.4 29 36.1 50.6 63.1 66.9 10.5 6.3 21.4 11.6 32.2 16zm143.7 1a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-222.9 48c45.8 29 96.4 42.7 132 47 6.8.8 13.7-1.3 18.8-5.9s8.1-11.1 8.1-18V168c0-30.9 25.1-56 56-56h61.8L436 138.7c-2.6 3.9-4 8.6-4 13.3v144c0 57.4-46.6 104-104 104h-58.4c-5.4 0-10.7 1.9-15 5.3L181.2 464c-62.2-.9-106.4-30.9-126.8-51.6l99.7-27.2c8.9-2.4 15.6-9.8 17.3-18.9s-2.1-18.3-9.5-23.7C125.4 316.3 80 267.5 80 184c0-31.8 3.9-55.5 8.9-73.1 20.4 43.4 53.2 74.9 88.2 97.1zM91.2 32c-9.9 0-19.4 4.9-25 13.6C52.7 66.3 32 106.2 32 184c0 77.3 31.8 131.1 66.1 166.7l-68.6 18.7c-12.8 3.5-23 13.1-27.3 25.6S.1 421.4 8 432c22.2 29.6 84.5 80 176 80 9.1 0 17.9-3.1 25-8.8l69-55.2h50c83.9 0 152-68.1 152-152V159.3l25.9-38.9c4-6 6.1-13 6.1-20.1 0-20-16.2-36.3-36.3-36.3H392c-57.4 0-104 46.6-104 104v34.5c-26.3-6.1-57-17.3-85.2-35.1-38.3-24.2-70.7-60-82.3-111.9-3-13.2-14.8-23.5-29.3-23.5z"
        }
    ]
};

const FarDownFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDownFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M114.2 320 224 430l109.8-110H280c-13.3 0-24-10.7-24-24V176h-64v120c0 13.3-10.7 24-24 24h-53.8zM224 480c-11.5 0-22.5-4.6-30.6-12.7L77.6 351.2c-8.7-8.7-13.6-20.5-13.6-32.8 0-25.6 20.8-46.4 46.4-46.4H144v-96c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v96h33.6c25.6 0 46.4 20.8 46.4 46.4 0 12.3-4.9 24.1-13.6 32.8L254.6 467.3c-8.1 8.1-19.1 12.7-30.6 12.7zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarDownFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDownFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M82.2 320 192 430l109.8-110H248c-13.3 0-24-10.7-24-24V176h-64v120c0 13.3-10.7 24-24 24H82.2zM192 480c-11.5 0-22.5-4.6-30.6-12.7L45.6 351.2c-8.7-8.7-13.6-20.5-13.6-32.8 0-25.6 20.8-46.4 46.4-46.4H112v-96c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v96h33.6c25.6 0 46.4 20.8 46.4 46.4 0 12.3-4.9 24.1-13.6 32.8L222.6 467.3c-8.1 8.1-19.1 12.7-30.6 12.7zM24 80C10.7 80 0 69.3 0 56s10.7-24 24-24h336c13.3 0 24 10.7 24 24s-10.7 24-24 24H24z"
        }
    ]
};

const FarDownLeftAndUpRightToCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDownLeftAndUpRightToCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 256h148.7c19.5 0 35.3-15.8 35.3-35.3 0-9.4-3.7-18.3-10.3-25L441.9 168l54.1-54.1c18.7-18.7 18.7-49.1 0-67.9l-30.1-30C447.2-2.7 416.8-2.7 398 16l-54 54.1-27.7-27.8c-6.6-6.6-15.6-10.3-25-10.3-19.5 0-35.3 15.8-35.3 35.3V216c0 22.1 17.9 40 40 40zm95-71 23 23H304V97.9l23 23c9.4 9.4 24.6 9.4 33.9 0l71-71L462.1 80l-71 71c-9.4 9.4-9.4 24.6 0 33.9zM67.3 256C47.8 256 32 271.8 32 291.3c0 9.4 3.7 18.3 10.3 25L70.1 344 16 398.1c-18.7 18.7-18.7 49.1 0 67.9l30.1 30c18.7 18.7 49.1 18.7 67.9 0l54-54.1 27.7 27.7c6.6 6.6 15.6 10.3 25 10.3 19.5 0 35.3-15.8 35.3-35.3V296c0-22.1-17.9-40-40-40H67.3zm53.7 71-23-23h110v110.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0l-71 71L49.9 432l71-71c9.4-9.4 9.4-24.6 0-33.9z"
        }
    ]
};

const FarDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDownLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 384V190.6c0-1.7.8-3.2 2.1-4.2 2.1-1.6 5-1.4 6.9.5l54 54.1c9.4 9.4 24.6 9.4 33.9 0l124.8-124.7c2.7-2.7 6.5-4.3 10.3-4.3s7.6 1.5 10.3 4.3l25.4 25.4c2.7 2.7 4.3 6.5 4.3 10.3s-1.5 7.6-4.3 10.3L207 287c-9.4 9.4-9.4 24.6 0 33.9l54.1 54.1c1.8 1.8 2.1 4.8.5 6.9-1 1.3-2.5 2.1-4.2 2.1H64zm-48 8c0 22.1 17.9 40 40 40h201.4c16.8 0 32.5-7.9 42.6-21.3 15.9-21.2 13.8-50.9-4.9-69.6L257.9 304l107.8-107.7c11.7-11.8 18.3-27.7 18.3-44.3s-6.6-32.5-18.3-44.3l-25.4-25.3C328.5 70.6 312.6 64 296 64s-32.5 6.6-44.3 18.3L144 190.1 106.9 153c-18.7-18.7-48.4-20.8-69.6-5C23.9 158.1 16 173.9 16 190.6V392z"
        }
    ]
};

const FarDownLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDownLong",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176.4 505.5c-9.2 8.7-23.7 8.7-32.9 0L14.6 384.1C5.3 375.3 0 363.1 0 350.3 0 324.7 20.7 304 46.3 304H80V56c0-30.9 25.1-56 56-56h48c30.9 0 56 25.1 56 56v248h33.7c25.6 0 46.3 20.7 46.3 46.3 0 12.8-5.3 25-14.6 33.7l-129 121.4zm93-153.5H216c-13.3 0-24-10.7-24-24V56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 6.4-2.5 12.5-7 17s-10.6 7-17 7H50.5L160 455l109.5-103z"
        }
    ]
};

const FarDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDownRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 384V190.6c0-1.7-.8-3.2-2.1-4.2-2.1-1.6-5-1.4-6.9.5L257 241c-9.4 9.4-24.6 9.4-33.9 0L98.3 116.3c-2.7-2.7-6.5-4.3-10.3-4.3s-7.6 1.5-10.3 4.3l-25.4 25.4c-2.7 2.7-4.3 6.5-4.3 10.3s1.5 7.6 4.3 10.3L177 287c9.4 9.4 9.4 24.6 0 33.9L122.9 375c-1.8 1.8-2.1 4.8-.5 6.9 1 1.3 2.5 2.1 4.2 2.1H320zm48 8c0 22.1-17.9 40-40 40H126.6c-16.8 0-32.5-7.9-42.6-21.3-15.9-21.2-13.8-50.9 4.9-69.6l37.2-37.1L18.3 196.3C6.6 184.5 0 168.6 0 152s6.6-32.5 18.3-44.3l25.4-25.3C55.5 70.6 71.4 64 88 64s32.5 6.6 44.3 18.3L240 190.1l37.1-37.1c18.7-18.7 48.4-20.8 69.6-5 13.4 10.1 21.3 25.8 21.3 42.6V392z"
        }
    ]
};

const FarDownToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDownToBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M114.2 192 224 302l109.8-110H280c-13.3 0-24-10.7-24-24V48h-64v120c0 13.3-10.7 24-24 24h-53.8zM224 352c-11.5 0-22.5-4.6-30.6-12.7L77.6 223.2c-8.7-8.7-13.6-20.5-13.6-32.8 0-25.6 20.8-46.4 46.4-46.4H144V48c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v96h33.6c25.6 0 46.4 20.8 46.4 46.4 0 12.3-4.9 24.1-13.6 32.8L254.6 339.3c-8.1 8.1-19.1 12.7-30.6 12.7zm-176-8v80c0 22.1 17.9 40 40 40h272c22.1 0 40-17.9 40-40v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 48.6-39.4 88-88 88H88c-48.6 0-88-39.4-88-88v-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarDownToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDownToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M114.2 224 224 334l109.8-110H280c-13.3 0-24-10.7-24-24V80h-64v120c0 13.3-10.7 24-24 24h-53.8zM224 384c-11.5 0-22.5-4.6-30.6-12.7L77.6 255.2c-8.7-8.7-13.6-20.5-13.6-32.8 0-25.6 20.8-46.4 46.4-46.4H144V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v96h33.6c25.6 0 46.4 20.8 46.4 46.4 0 12.3-4.9 24.1-13.6 32.8L254.6 371.3c-8.1 8.1-19.1 12.7-30.6 12.7zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FarDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDownToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M82.2 224 192 334l109.8-110H248c-13.3 0-24-10.7-24-24V80h-64v120c0 13.3-10.7 24-24 24H82.2zM192 384c-11.5 0-22.5-4.6-30.6-12.7L45.6 255.2c-8.7-8.7-13.6-20.5-13.6-32.8 0-25.6 20.8-46.4 46.4-46.4H112V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v96h33.6c25.6 0 46.4 20.8 46.4 46.4 0 12.3-4.9 24.1-13.6 32.8L222.6 371.3c-8.1 8.1-19.1 12.7-30.6 12.7zM24 432h336c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 429.6 49.3 279.7c-.8-.8-1.3-2-1.3-3.2 0-2.5 2-4.6 4.6-4.6H136c13.3 0 24-10.7 24-24v-168h64v168c0 13.3 10.7 24 24 24h83.4c2.5 0 4.6 2 4.6 4.6 0 1.2-.5 2.3-1.3 3.2L192 429.6zM0 276.6c0 13.5 5.2 26.5 14.5 36.3l146.6 153.9c8.1 8.5 19.2 13.2 30.9 13.2s22.8-4.8 30.9-13.2l146.6-154c9.3-9.8 14.5-22.8 14.5-36.3 0-29-23.5-52.6-52.6-52.6l-59.4.1V80c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48v144H52.6C23.5 224 0 247.5 0 276.6z"
        }
    ]
};

const FarDownload = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDownload",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v270.1l-95-95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 369c9.4 9.4 24.6 9.4 33.9 0L409 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95V24zM128.8 304H64c-35.3 0-64 28.7-64 64v80c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-80c0-35.3-28.7-64-64-64h-64.8l-48 48H448c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-80c0-8.8 7.2-16 16-16h112.8l-48-48zM432 408a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarDragon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDragon",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M273 17c3.1-10.1 12.4-17 23-17h179.8c35 0 68.3 15.3 91.1 41.9l56 65.4c11 12.8 17 29.1 17 46 0 39.1-31.7 70.7-70.7 70.7h-22.7c-23.3 0-45.7-9.3-62.2-25.8l-3.9-3.9c1.7 12.7 8.4 24.3 18.8 32L592 296c30.2 22.7 48 58.2 48 96 0 66.3-53.7 120-120 120H56.5C27.7 512.3 3 490.4.2 461.3c-2.9-30.8 19.7-58.1 50.5-61l345.6-32.6-12-13.1c-31-34-48.3-78.4-48.3-124.4V156l-49.7-22.1c-8.3-3.7-13.8-11.8-14.2-20.9s4.4-17.6 12.3-22L322 70.1 282.7 44c-8.8-5.9-12.7-16.8-9.7-27zm102.3 31 6 4c7 4.6 11 12.6 10.7 20.9s-5 15.9-12.3 20l-29.9 16.6 20 8.9c8.7 3.9 14.3 12.4 14.3 21.9V230c0 34 12.8 66.8 35.7 91.9l44.6 48.7c6.2 6.7 8 16.3 4.7 24.8S458 409.8 449 410.7L55.2 448c-4.4.4-7.6 4.3-7.2 8.7.4 4.2 3.9 7.3 8 7.3h464c39.8 0 72-32.2 72-72 0-22.7-10.7-44-28.8-57.6l-92.8-69.6C446.2 246.7 432 218.2 432 188v-20c0-13.3 10.7-24 24-24h32c6.4 0 12.5 2.5 17 7l13.3 13.3c7.5 7.5 17.7 11.7 28.3 11.7h22.8c12.5 0 22.7-10.2 22.7-22.7 0-5.4-1.9-10.7-5.5-14.8l-56-65.4C516.8 57.2 496.9 48 475.8 48H375.3zm139.3 47.2c-1.8 2.2-4 4.1-6.6 5.6-11.5 6.6-26.2 2.7-32.8-8.8-1.3-2.3-2.2-4.8-2.7-7.3-.9-4.6 3.7-7.7 8.3-6.5l29.6 7.4c4.5 1.1 7.2 6 4.2 9.6zm5.4-15.7v.9-.9zm-330.6 32.9L304 188.8v41.4c0 31.2 6.8 61.8 19.5 89.8H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l69.4-59.6-152.6 23.5c-7 1.1-13.9-2.6-16.9-9S0 232.7 5.3 228l125.6-111.5c16.3-14.5 40.4-16.2 58.5-4.1z"
        }
    ]
};

const FarDrawCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDrawCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm54.8 17.1C299.6 115.6 279.2 128 256 128s-43.6-12.4-54.8-30.9c-48.7 16.8-87.3 55.4-104.1 104.1 18.5 11.2 30.9 31.6 30.9 54.8s-12.4 43.6-30.9 54.8c16.8 48.7 55.4 87.3 104.1 104.1 11.2-18.5 31.6-30.9 54.8-30.9s43.6 12.4 54.8 30.9c48.7-16.8 87.3-55.4 104.1-104.1-18.5-11.2-30.9-31.6-30.9-54.8s12.4-43.6 30.9-54.8c-16.8-48.7-55.4-87.3-104.1-104.1zm152.1 96.6c28.2 6.7 49.1 32 49.1 62.3s-20.9 55.5-49.1 62.3c-20.8 69.2-75.4 123.8-144.6 144.6-6.7 28.2-32 49.1-62.3 49.1s-55.5-20.9-62.3-49.1c-69.2-20.8-123.8-75.4-144.6-144.6C20.9 311.5 0 286.2 0 256s20.9-55.5 49.1-62.3c20.8-69.2 75.4-123.8 144.6-144.6C200.5 20.9 225.8 0 256 0s55.5 20.9 62.3 49.1c69.2 20.8 123.8 75.4 144.6 144.6zM256 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarDrawPolygon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDrawPolygon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm8 59.3v201.4c16 6.5 28.9 19.3 35.3 35.3h201.4c2.1-5.2 4.9-10.1 8.2-14.5L298 319.2c-3.2.5-6.6.8-10 .8-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.7.3 10 .8l34.9-58.2c-3.3-4.4-6.1-9.3-8.2-14.5H123.3c-6.5 16-19.3 28.9-35.3 35.3zm286.1 197.5c3.2-.5 6.6-.8 9.9-.8 35.3 0 64 28.7 64 64s-28.7 64-64 64c-26.9 0-49.9-16.5-59.3-40H123.3c-9.5 23.5-32.5 40-59.3 40-35.3 0-64-28.7-64-64 0-26.9 16.5-49.9 40-59.3V155.3C16.5 145.9 0 122.9 0 96c0-35.3 28.7-64 64-64 26.9 0 49.9 16.5 59.3 40h201.4c9.5-23.5 32.5-40 59.3-40 35.3 0 64 28.7 64 64s-28.7 64-64 64c-3.4 0-6.7-.3-9.9-.8l-34.9 58.2c8.1 10.7 12.9 24.1 12.9 38.5s-4.8 27.8-12.9 38.5l34.9 58.2zM400 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM64 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm336-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM288 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarDrawSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDrawSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm24 43.3v201.4c16 6.5 28.9 19.3 35.3 35.3h201.4c6.5-16 19.3-28.9 35.3-35.3V155.3c-16-6.5-28.9-19.3-35.3-35.3H123.3c-6.5 16-19.3 28.9-35.3 35.3zM123.3 440c-9.5 23.5-32.5 40-59.3 40-35.3 0-64-28.7-64-64 0-26.9 16.5-49.9 40-59.3V155.3C16.5 145.9 0 122.9 0 96c0-35.3 28.7-64 64-64 26.9 0 49.9 16.5 59.3 40h201.4c9.5-23.5 32.5-40 59.3-40 35.3 0 64 28.7 64 64 0 26.9-16.5 49.9-40 59.3v201.4c23.5 9.5 40 32.5 40 59.3 0 35.3-28.7 64-64 64-26.9 0-49.9-16.5-59.3-40H123.3zM80 416a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm320 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm0-320a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarDreidel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDreidel",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M441 39c9.4 9.4 9.4 24.6 0 33.9L327.6 186.3l67.7 67.7c18.7 18.7 18.7 49.1 0 67.9L256 461.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V269.3c0-17 6.7-33.3 18.7-45.3L158.1 84.7c18.7-18.7 49.1-18.7 67.9 0l67.7 67.7L407 39c9.4-9.4 24.6-9.4 33.9 0zM106.3 204.3l-53.6 53.6c-3 3-4.7 7.1-4.7 11.3V416c0 8.8 7.2 16 16 16h146.7c4.2 0 8.3-1.7 11.3-4.7l53.7-53.7-169.4-169.3zm33.9-33.9 169.5 169.3 51.7-51.7L192 118.6l-51.7 51.7z"
        }
    ]
};

const FarDroneFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDroneFront",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 96c10.4 0 19.3 6.7 22.6 16H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h89.4c3.3-9.3 12.2-16 22.6-16zm345.4 16c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h105.4zM112 256v-64h48v49.6l10.8 5.7 47.7-27.8c30.8-18 65.9-27.5 101.6-27.5s70.7 9.5 101.6 27.5l47.7 27.8 10.8-5.7V192h48v64c0 8.9-4.9 17.1-12.8 21.2l-51.6 27.3 4.5 5.4c18 21.6 27.8 48.8 27.8 76.8v5.3c0 13.3-10.7 24-24 24s-24-10.7-24-24v-5.2c0-16.8-5.9-33.2-16.7-46.1l-11-13.2-41.1 21.7c-3.5 1.8-7.3 2.8-11.2 2.8H272c-3.9 0-7.8-1-11.2-2.8l-41.1-21.7-11 13.2C197.9 353.6 192 370 192 386.8v5.2c0 13.3-10.7 24-24 24s-24-10.7-24-24v-5.2c0-28.1 9.8-55.3 27.8-76.8l4.5-5.4-51.6-27.3c-7.9-4.2-12.8-12.3-12.8-21.2zm307.3 17.7-21.9-12.8C373.9 247.2 347.2 240 320 240s-53.9 7.2-77.4 20.9l-21.9 12.8L278 304h84l57.2-30.3z"
        }
    ]
};

const FarDrone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDrone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 112C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c5.2 0 10.2-.3 15.2-1l-38.5-51.4C64.9 162.3 48 139.1 48 112c0-35.3 28.7-64 64-64 27.1 0 50.3 16.9 59.6 40.7l51.4 38.5c.7-5 1-10.1 1-15.2zm-10.7 47.9L173.5 130l-29.7-22.3C141.7 92.1 128.2 80 112 80c-17.7 0-32 14.3-32 32 0 16.2 12.1 29.7 27.8 31.7l22.3 29.7 29.9 39.8.1.1v85.3l-.1.1-29.9 39.8-22.3 29.7C92.1 370.3 80 383.8 80 400c0 17.7 14.3 32 32 32 16.2 0 29.7-12.1 31.7-27.8l29.7-22.3 39.8-29.9.1-.1h85.3l.1.1 39.8 29.9 29.7 22.3c2.1 15.7 15.5 27.8 31.7 27.8 17.7 0 32-14.3 32-32 0-16.2-12.1-29.7-27.8-31.7l-22.3-29.7-29.9-39.8-.1-.1v-85.4l.1-.1 29.9-39.8 22.3-29.7c15.7-2.1 27.8-15.5 27.8-31.7 0-17.7-14.3-32-32-32-16.2 0-29.7 12.1-31.7 27.8l-29.7 22.3-39.8 29.9-.1.1h-85.3l-.1-.1zm9.7 224.9-51.3 38.5c-9.4 23.8-32.6 40.7-59.7 40.7-35.3 0-64-28.7-64-64 0-27.1 16.9-50.3 40.7-59.6l38.5-51.4c-5-.7-10.1-1-15.2-1C50.1 288 0 338.1 0 400s50.1 112 112 112 112-50.1 112-112c0-5.2-.3-10.2-1-15.2zM288 112c0 5.2.3 10.2 1 15.2l51.3-38.5C349.7 64.9 372.9 48 400 48c35.3 0 64 28.7 64 64 0 27.1-16.9 50.3-40.7 59.6L384.8 223c5 .7 10.1 1 15.2 1 61.9 0 112-50.1 112-112S461.9 0 400 0 288 50.1 288 112zm1 272.8c-.7 5-1 10.1-1 15.2 0 61.9 50.1 112 112 112s112-50.1 112-112-50.1-112-112-112c-5.2 0-10.2.3-15.2 1l38.5 51.3c23.8 9.3 40.7 32.5 40.7 59.6 0 35.3-28.7 64-64 64-27.1 0-50.3-16.9-59.6-40.7L289 384.8zM224 208h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarDropletDegree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDropletDegree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 464c-79.5 0-144-64.5-144-144 0-13 5.1-33.5 17-61.1 11.5-26.6 27.6-55.8 45.5-84.7 29-46.8 61-90.2 81.5-117 20.5 26.7 52.6 70.2 81.5 117 17.9 28.9 34 58 45.5 84.7 11.9 27.6 17 48.2 17 61.1 0 79.5-64.5 144-144 144zM0 320c0 106 86 192 192 192s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3-6-7.5-14.9-11.7-24.5-11.7h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm400-208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FarDropletPercent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDropletPercent",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 464c-79.5 0-144-64.5-144-144 0-13 5.1-33.5 17-61.1 11.5-26.6 27.6-55.8 45.5-84.7 29-46.8 61-90.2 81.5-117 20.5 26.7 52.6 70.2 81.5 117 17.9 28.9 34 58 45.5 84.7 11.9 27.6 17 48.2 17 61.1 0 79.5-64.5 144-144 144zM0 320c0 106 86 192 192 192s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3-6-7.5-14.9-11.7-24.5-11.7h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm267.3-75.3c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm112 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarDropletSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDropletSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 464c37.9 0 72.4-14.6 98.1-38.6l38 30C421.4 490.3 373.2 512 320 512c-106 0-192-86-192-192 0-27.7 12-62.9 29.8-99.6l38.7 30.5c-1.2 2.7-2.4 5.4-3.6 8-11.9 27.6-17 48.2-17 61.1 0 79.5 64.5 144 144 144zm185.2-93.3 125.6 98.4c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1l167 130.9c34.9-54.7 72-103 88.9-124.3C300.6 4.2 309.5 0 319.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C381.8 57.7 512 228.8 512 320c0 17.5-2.4 34.6-6.8 50.7zm-42.3-33.1c.7-5.8 1.1-11.6 1.1-17.6 0-13-5.1-33.5-17-61.1-11.5-26.6-27.6-55.8-45.5-84.7-29-46.8-61-90.2-81.5-117-19.3 25.1-48.7 65-76.3 108.5l219.2 171.8zM224 312c0-11.9 8.7-21.8 20.1-23.7l27.9 21.9c0 .6.1 1.2.1 1.7 0 30.9 25.1 56 56 56 13.3 0 24 10.7 24 24s-10.7 24-24 24c-57.4 0-104-46.6-104-104z"
        }
    ]
};

const FarDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDroplet",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 464c-79.5 0-144-64.5-144-144 0-13 5.1-33.5 17-61.1 11.5-26.6 27.6-55.8 45.5-84.7 29-46.8 61-90.2 81.5-117 20.5 26.7 52.6 70.2 81.5 117 17.9 28.9 34 58 45.5 84.7 11.9 27.6 17 48.2 17 61.1 0 79.5-64.5 144-144 144zM0 320c0 106 86 192 192 192s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3-6-7.5-14.9-11.7-24.5-11.7h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm144-8c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 57.4 46.6 104 104 104 13.3 0 24-10.7 24-24s-10.7-24-24-24c-30.9 0-56-25.1-56-56z"
        }
    ]
};

const FarDrumSteelpan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDrumSteelpan",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 160c0-9.9-8-29.9-55-49.8-20-8.5-44.3-15.4-71.9-20.6-1.2 4.1-2.4 8.8-3.6 13.8-4.5 18.9-7.6 39.2-5.7 53.3 2.2 16.3 10.4 35.1 19.3 51.1 4 7.3 7.9 13.5 10.9 18 19.1-4.5 36.2-9.9 51-16.2 47.1-19.9 55-39.9 55-49.8zm-158.9 71.2c-6.9-12.5-14.9-28.8-20.1-46.3-15.4 8-36 15.1-61 15.1s-45.6-7.1-61-15.1c-5.2 17.5-13.2 33.8-20.1 46.3-.7 1.3-1.4 2.5-2.1 3.8 25.7 3.3 53.7 5 83.2 5s57.5-1.8 83.2-5c-.7-1.2-1.4-2.5-2.1-3.8zM350.8 92.3c.8-3.2 1.6-6.3 2.3-9.3-20.6-2-42.4-3-65.1-3s-44.5 1-65.1 3c.8 2.9 1.6 6 2.3 9.3 2.6 11 5.4 24.5 6.7 38.4.1.1.2.2.3.2 2.6 2.3 6.6 5.4 11.8 8.6 10.5 6.4 25.4 12.5 44 12.5s33.5-6.2 44-12.5c5.2-3.2 9.2-6.3 11.8-8.6.1-.1.2-.2.3-.2 1.3-13.9 4.1-27.4 6.7-38.4zM103 209.8c14.8 6.3 31.9 11.7 51 16.2 3-4.5 6.9-10.8 10.9-18 8.9-16 17.1-34.9 19.3-51.1 1.9-14.2-1.1-34.5-5.7-53.3-1.2-5-2.5-9.7-3.6-13.8-27.6 5.1-51.9 12.1-71.9 20.6-47 19.7-55 39.7-55 49.6s8 29.9 55 49.8zM576 160v192c0 24.3-11.3 44.9-28.1 61-16.5 15.8-39.1 28.3-64.8 37.8C431.7 470.1 362.6 480 288 480s-143.7-9.9-195.1-29.1c-25.6-9.6-48.2-22-64.8-37.8C11.3 396.9 0 376.3 0 352V160C0 80 128.9 32 288 32s288 48 288 128zm-48 74.9C476.4 269 388.2 288 288 288S99.6 269 48 234.9V352c0 8.2 3.5 16.9 13.3 26.3 10.2 9.7 26.2 19.3 48.4 27.6C153.9 422.4 216.8 432 288 432s134.1-9.6 178.3-26.1c22.1-8.3 38.2-17.8 48.4-27.6 9.9-9.4 13.3-18.2 13.3-26.3V234.9z"
        }
    ]
};

const FarDrum = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDrum",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2S486 28.7 474.9 36l-104.7 68.5C335.8 98.7 297 96 256 96 114.6 96 0 128 0 208v160c0 24.9 14.9 44.5 33.2 58.7 18.5 14.3 43.6 25.5 72 33.9C147.4 473 199.8 480 256 480s108.6-7 150.8-19.5c28.4-8.4 53.5-19.6 72-33.9 18.3-14.1 33.2-33.7 33.2-58.6V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zm-193.8 69.5-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5 38.8 15.1 44.4 30.7 44.4 41.3 0 .8-2.7 17.2-46 35.9-38.9 16.8-96 28.1-162 28.1s-123.1-11.3-162-28.1c-43.3-18.7-46-35.1-46-35.9 0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1.5 51.4 1.6zM424 293.2c15-5.6 28.4-12 40-19V368c0 4.1-2.3 11.2-14.5 20.7-6.5 5-15 10-25.5 14.7V293.2zm-144 26.3c34.4-1.3 66.9-5.6 96-12.2v111.8c-27.9 6.7-60.5 11.1-96 12.5v-112zm-144-12.1c29.1 6.6 61.6 10.8 96 12.2v112c-35.5-1.4-68.1-5.8-96-12.5V307.4zm-88-33.2c11.6 7 25 13.4 40 19v110.1c-10.4-4.7-18.9-9.6-25.5-14.7C50.3 379.2 48 372.1 48 368v-93.8z"
        }
    ]
};

const FarDrumstickBite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDrumstickBite",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 272c0 17.7 14.3 32 32 32h67.2c-2.1-10.4-3.2-21.1-3.2-32 0-82.8 62.8-150.8 143.4-159.1C425.4 74.1 383.7 48 336 48c-70.7 0-128 57.3-128 128v96zm-48-32v-64C160 78.8 238.8 0 336 0c86.5 0 158.5 62.5 173.2 144.8 2.1 11.8-10.3 20.1-22 17.6-7.5-1.6-15.3-2.4-23.2-2.4-61.9 0-112 50.1-112 112 0 19.2 4.8 37.2 13.3 53 5.7 10.5 1.1 24.8-10.8 26-6.1.6-12.3 1-18.5 1h-92c-17.7 0-31.3 15.6-41.5 30-1.7 2.4-3.6 4.6-5.7 6.7-12 12-11.1 31.5-6.8 47.9 1.3 4.9 2 10 2 15.4 0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12-33.1 0-60-26.9-60-60s26.9-60 60-60c5.3 0 10.5.7 15.4 2 16.4 4.3 35.9 5.2 47.9-6.8 2.1-2.1 4.4-4 6.8-5.7 14.4-10.2 30-23.9 30-41.5v-28z"
        }
    ]
};

const FarDrumstick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDrumstick",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 304c-17.7 0-32-14.3-32-32v-96c0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128h-96zm-37.5 78c10.2-14.4 23.9-30 41.5-30h92c97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176v92c0 17.7-15.6 31.3-30 41.5-2.4 1.7-4.6 3.6-6.8 5.7-12 12-31.5 11.1-47.9 6.8-4.9-1.3-10-2-15.4-2-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12 0 33.1 26.9 60 60 60s60-26.9 60-60c0-5.3-.7-10.5-2-15.4-4.3-16.4-5.2-35.9 6.8-47.9 2.1-2.1 4-4.4 5.7-6.7z"
        }
    ]
};

const FarDryerHeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDryerHeat",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm104 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM80 288a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm107.3-83.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l12.7 12.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 336c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-12.7-12.7zm80 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l12.7 12.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L270.6 336c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-12.7-12.7z"
        }
    ]
};

const FarDryer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDryer",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h320zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 104a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 256c-44.7 0-82.3-30.6-93-72h53c13.3 0 24-10.7 24-24s-10.7-24-24-24h-53c10.7-41.4 48.2-72 93-72 53 0 96 43 96 96s-43 96-96 96zm0 48a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
        }
    ]
};

const FarDuck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDuck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M69.1 324.1c11.2 4.8 23.7 5.2 35.2 1l146.5-52.7c14.6-5.3 25.8-17.3 30-32.2s.9-31-8.8-43.1c-10-12.4-15.9-28-15.9-45.1 0-39.8 32.2-72 72-72s72 32.2 72 72c0 20.1-8.2 38.2-21.5 51.4l7.5 7.6-7.5-7.6c-7.1 7-13.6 15.5-18.4 25.5-8.7 18.2-5.1 39.9 9 54.4 14.3 14.5 22.9 34.3 22.9 56V352c0 44.2-35.8 80-80 80H196c-69.8 0-128.7-49.4-144.1-115.2l17.2 7.4zM446.8 135C438.5 76.8 388.5 32 328 32c-66.3 0-120 53.7-120 120 0 11.2 1.5 22 4.4 32.2 4.4 15.9 12.1 30.5 22.1 43l-47 16.9L88 280l-51-21.9c-3.3-1.4-6.9-2.1-10.5-2.1C11.9 256 0 268.1 0 282.7 0 391 87.8 480 196 480h116c70.7 0 128-57.3 128-128v-12.8c0-34.7-13.9-66.4-36.6-89.6 2.1-4.4 5.1-8.5 8.7-12 1.8-1.8 3.6-3.7 5.3-5.6h3.5c50.3 0 91.1-40.8 91.1-91.1 0-6.8-6-12.1-12.8-11.3l-35.3 4.4c-5.7.7-11.4 1-17.1 1zM344 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-44.8 113.1c-13.1-1.8-25.2 7.5-27 20.6-2.7 20-18 38.3-40.8 44-18.6 4.6-36.8-.5-49.3-11.6-9.9-8.8-25.1-7.9-33.9 2s-7.9 25.1 2 33.9c24.2 21.5 58.7 30.8 92.8 22.3 41.6-10.4 71.4-44.4 76.7-84.2 1.8-13.1-7.5-25.2-20.6-27z"
        }
    ]
};

const FarDumbbell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDumbbell",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 88c0-30.9 25.1-56 56-56h16c30.9 0 56 25.1 56 56v144h128V88c0-30.9 25.1-56 56-56h16c30.9 0 56 25.1 56 56v16h24c30.9 0 56 25.1 56 56v72h24c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24v72c0 30.9-25.1 56-56 56h-24v16c0 30.9-25.1 56-56 56h-16c-30.9 0-56-25.1-56-56V280H256v144c0 30.9-25.1 56-56 56h-16c-30.9 0-56-25.1-56-56v-16h-24c-30.9 0-56-25.1-56-56v-72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-72c0-30.9 25.1-56 56-56h24V88zm48 16v320c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v16zm-48 48h-24c-4.4 0-8 3.6-8 8v192c0 4.4 3.6 8 8 8h24V152zm336 232V88c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v336c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-40zm72-24c4.4 0 8-3.6 8-8V160c0-4.4-3.6-8-8-8h-24v208h24z"
        }
    ]
};

const FarDumpsterFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDumpsterFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94l25.6-128H49.7zM272 160V32h-98.9l-25.6 128H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1 1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304v128zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2-.1-.7-.3-1.4-.5-2.1l-25.9-84.1c-3.1-10-12.4-16.9-22.9-16.9h-90.8l12.8 64.2c9.6 1 19 4.9 26.6 11.8 11.7 10.6 23 21.6 33.9 33.1 1.6-1.6 3.3-3.2 5-4.8zM80.4 192H32l4 32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h18l22 176v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h225.6c-12.7-14.3-23.4-30.5-31.5-48H106.4l-20-160H309c4.9-10 10.3-19.8 16.2-29.3 3.8-6.2 7.9-12.5 12.3-18.7H80.4zm373.2-60.2c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 87.8 70.3 159.9 160 159.9 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96z"
        }
    ]
};

const FarDumpster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDumpster",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94l25.6-128H49.7zM272 160V32h-98.9l-25.6 128H272zm32 0h124.5L402.9 32H304v128zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9 0-2.1-.3-4.1-.9-6.1l-25.9-84.1c-3.1-10-12.4-16.9-22.9-16.9h-90.8l25.6 128zM86.4 240h403.2l-20 160H106.4l-20-160zM112 448h352v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8l22-176h18c13.3 0 24-10.7 24-24s-10.7-24-24-24h-12l4-32H32l4 32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h18l22 176v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"
        }
    ]
};

const FarDungeon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarDungeon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 128c-6.9 0-13.7.5-20.4 1.4h-.2c-7.8 1-15.6-3-18.5-10.3l-.7-1.8-17.2-43-.2-.5c-3-7.6.2-16.2 7.2-19.5.9-.4 1.9-.8 2.9-1 15.2-3.5 30.9-5.3 47.1-5.3s31.9 1.8 47.1 5.3c1 .2 2 .6 2.9 1 7 3.3 10.3 11.9 7.2 19.5l-.2.5-17.2 43.1-.7 1.8c-2.9 7.3-10.7 11.3-18.5 10.3h-.2c-6.6-.9-13.4-1.4-20.4-1.4zM96 512h352c35.3 0 64-28.7 64-64v-40c0-11.7-3.1-22.6-8.6-32 5.4-9.4 8.6-20.3 8.6-32v-40c0-11.7-3.1-22.6-8.6-32 5.8-10.2 8.9-22.3 7.8-35.6-2.2-28.6-9.1-56-19.9-81.2-6.1-14.3-16.2-24.5-28-30.6-.6-13.3-5.5-26.7-15.8-38.3-16.8-18.9-36.4-35.4-58.1-48.7-13.2-8.1-27.3-10.6-40.5-8.8-8.2-10.5-20-18.7-35.1-22.1C295.2 2.3 275.9 0 256 0s-39.2 2.3-57.9 6.6C183 10.1 171.2 18.2 163 28.7c-13.2-1.8-27.3.7-40.5 8.8-21.7 13.3-41.3 29.8-58.1 48.7-10.2 11.6-15.2 25-15.8 38.3-11.8 6.2-21.9 16.3-28 30.6C9.8 180.4 2.9 207.8.7 236.4c-1 13.3 2 25.4 7.8 35.6-5.4 9.4-8.5 20.3-8.5 32v40c0 11.7 3.1 22.6 8.6 32-5.5 9.4-8.6 20.3-8.6 32v40c0 35.3 28.7 64 64 64h32zm275.4-346.8c-6.4 4.3-14.8 3.3-20.7-1.6l-.2-.2c-5.5-4.8-11.4-9.2-17.6-13.1l-.2-.2c-6.3-4.2-9.6-11.8-7.7-19l.6-1.8 17.2-43.1.2-.5c3.2-7.4 11.4-11.1 18.7-8.6 1 .3 1.9.8 2.8 1.3 17.7 10.8 33.6 24.2 47.2 39.6.7.8 1.3 1.7 1.8 2.6 3.8 6.7 1.5 15.4-5.2 19.9l-1.1.8-32.6 21.7-3.2 2.1zm15.4 46.4-.2-.4c-2.8-6.5-1.8-14 2.8-19 .9-.9 1.8-1.8 2.9-2.5l32.6-21.7c.4-.3.8-.5 1.2-.7 6.8-3.8 15.3-2 19.6 4.1.6.8 1.1 1.7 1.5 2.7 8.8 20.5 14.4 42.7 16.2 66 0 .6.1 1.2 0 1.9-.4 7.9-7.2 14.1-15.4 14.1h-34.6c-7.8 0-14.3-5.7-16.4-13.2-.1-.3-.2-.7-.2-1-2.2-10.6-5.7-20.7-10.1-30.3zM400 304c0-.5 0-.9.1-1.4.6-7.3 6.2-13.3 13.4-14.4.8-.1 1.7-.2 2.6-.2h32c8.1 0 14.9 6.1 15.9 14 .1.7.1 1.4.1 2v40c0 .7 0 1.3-.1 2-1 7.9-7.7 14-15.9 14H416c-8.2 0-14.9-6.1-15.9-14-.1-.6-.1-1.3-.1-2v-40zm0 104c0-.7 0-1.3.1-2 1-7.9 7.7-14 15.9-14h32c8.2 0 14.9 6.1 15.9 14 .1.6.1 1.3.1 2v40c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-40zM147.6 78.5c.9-.6 1.8-1 2.8-1.3 7.3-2.6 15.5 1.2 18.7 8.6l.2.5 17.2 43.1.6 1.8c1.9 7.2-1.4 14.8-7.7 19l-.3.2c-6.2 3.9-12.1 8.3-17.6 13.1l-.2.2c-5.9 4.9-14.3 5.9-20.7 1.6l-3.2-2.1-32.6-21.7-1.1-.8c-6.7-4.5-9-13.2-5.2-19.9.5-.9 1.1-1.8 1.8-2.6 13.7-15.4 29.6-28.8 47.2-39.6zm-82.8 95.6c.4-1 .9-1.9 1.5-2.7 4.3-6.1 12.8-7.9 19.6-4.1.4.2.8.5 1.2.7l32.6 21.7c1.1.7 2.1 1.6 2.9 2.5 4.6 5 5.6 12.6 2.8 19l-.2.4c-4.4 9.6-7.8 19.7-10.1 30.3-.1.3-.1.7-.2 1-2 7.5-8.6 13.2-16.4 13.2H64c-8.2 0-15-6.2-15.4-14.1v-1.9c1.8-23.3 7.4-45.5 16.2-66zM48 304c0-.7 0-1.4.1-2 1-7.9 7.7-14 15.9-14h32c.9 0 1.7.1 2.6.2 7.2 1.2 12.8 7.1 13.4 14.4 0 .5.1.9.1 1.4v40c0 .7 0 1.3-.1 2-1 7.9-7.7 14-15.9 14H64c-8.2 0-14.9-6.1-15.9-14-.1-.6-.1-1.3-.1-2v-40zm0 104c0-.7 0-1.3.1-2 1-7.9 7.7-14 15.9-14h32c8.2 0 14.9 6.1 15.9 14 .1.6.1 1.3.1 2v40c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-40zm224-216v256c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 32v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16s16 7.2 16 16zm128 0v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarE = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarE",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h240c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-4.4 0-8-3.6-8-8V272h184c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V88c0-4.4 3.6-8 8-8h240c13.3 0 24-10.7 24-24s-10.7-24-24-24H56z"
        }
    ]
};

const FarEarDeaf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEarDeaf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m505 41-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM185 361 41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L151 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm55-249c-70.7 0-128 57.3-128 128 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 47.5-18.8 90.6-49.4 122.2-4.8 4.9-6.6 9.9-6.6 13.8 0 75.1-60.9 136-136 136-13.3 0-24-10.7-24-24s10.7-24 24-24c48.6 0 88-39.4 88-88 0-19.1 8.9-35.5 20.1-47.1 22.3-23 35.9-54.4 35.9-88.9 0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6 39.4-88 88-88s88 39.4 88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.1-17.9-40-40-40z"
        }
    ]
};

const FarEarListen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEarListen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M388.9 3.8C450.6 43 493.6 105.8 508 177.6l3.5 17.7c2.6 13-5.8 25.6-18.8 28.2s-25.6-5.8-28.2-18.8l-3.6-17.7c-11.8-58.9-47.1-110.5-97.8-142.7-11.2-7.1-14.5-22-7.4-33.1s21.9-14.5 33.1-7.4zM240 112c-70.7 0-128 57.3-128 128 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 47.5-18.8 90.6-49.4 122.2-4.8 4.9-6.6 9.9-6.6 13.8 0 75.1-60.9 136-136 136-13.3 0-24-10.7-24-24s10.7-24 24-24c48.6 0 88-39.4 88-88 0-19.1 8.9-35.5 20.1-47.1 22.3-23 35.9-54.4 35.9-88.9 0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6 39.4-88 88-88s88 39.4 88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.1-17.9-40-40-40zm-72 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM24 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm57-97 64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L47 401c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FarEarMuffs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEarMuffs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48c-83.1 0-151.4 63.4-159.3 144.4-2.9-.3-5.8-.4-8.7-.4-14.4 0-27.9 3.4-39.9 9.5C115.5 89.7 207.3 0 320 0s204.5 89.7 207.9 201.5c-12-6.1-25.5-9.5-39.9-9.5-3 0-5.9.1-8.7.4C471.4 111.4 403.1 48 320 48zm160 176.6c2.6-.4 5.3-.6 8-.6 12 0 23.2 3.8 32.3 10.2 5-1.5 10.3-2.2 15.7-2.2 19.9 0 37.5 10.4 47.4 26.1 23.4 6.7 40.6 28.3 40.6 53.9 0 5.1-.7 10.1-2 14.9 11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9 0 25.6-17.2 47.2-40.6 53.9-9.9 15.7-27.5 26.1-47.4 26.1-5.5 0-10.7-.8-15.7-2.2-9.1 6.4-20.3 10.2-32.3 10.2-30.9 0-56-25.1-56-56 0-10.2 2.7-19.8 7.5-28-4.8-8.2-7.5-17.8-7.5-28 0-11.9 3.7-22.9 10-32-6.3-9.1-10-20.1-10-32 0-10.2 2.7-19.8 7.5-28-4.8-8.2-7.5-17.8-7.5-28 0-28.2 20.9-51.6 48-55.4zm-328-.6c2.7 0 5.4.2 8 .6 27.1 3.9 48 27.2 48 55.4 0 10.2-2.7 19.8-7.5 28 4.8 8.2 7.5 17.8 7.5 28 0 11.9-3.7 22.9-10 32 6.3 9.1 10 20.1 10 32 0 10.2-2.7 19.8-7.5 28 4.8 8.2 7.5 17.8 7.5 28 0 30.9-25.1 56-56 56-12 0-23.2-3.8-32.3-10.2-5 1.5-10.3 2.2-15.7 2.2-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1.7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9 0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7.8 15.7 2.2 9.1-6.4 20.3-10.2 32.3-10.2zm7 108c-8.6-14.9-8.6-33.2 0-48.1.7-1.1 1-2.4 1-4 0-4.4-3.6-8-8-8-1.8 0-3.3.5-4.6 1.4-12 8.4-27.1 11-41.2 6.9-.7-.2-1.4-.3-2.3-.3-2.8 0-5.3 1.4-6.8 3.8-6.3 10-16.1 17.3-27.4 20.5-3.4 1-5.8 4.1-5.8 7.7 0 .8.1 1.5.3 2.2 4.8 17.3-.5 35.8-13.7 48-1.7 1.5-2.6 3.6-2.6 5.9s.9 4.4 2.6 5.9c13.2 12.2 18.5 30.7 13.7 48-.2.6-.3 1.3-.3 2.2 0 3.6 2.4 6.7 5.8 7.7 11.4 3.2 21.1 10.5 27.4 20.5 1.5 2.4 4 3.8 6.8 3.8.9 0 1.6-.1 2.3-.3 14-4.1 29.2-1.6 41.2 6.9 1.3.9 2.8 1.4 4.6 1.4 4.4 0 8-3.6 8-8 0-1.5-.4-2.8-1-4-8.6-14.9-8.6-33.2 0-48.1.7-1.1 1-2.4 1-4 0-1.8-.5-3.3-1.4-4.5a47.994 47.994 0 0 1 0-54.9c.9-1.3 1.4-2.8 1.4-4.5 0-1.5-.4-2.8-1-4zm321-52c0 1.5.4 2.8 1 4 8.6 14.9 8.6 33.2 0 48.1-.7 1.1-1 2.4-1 4 0 1.8.5 3.3 1.4 4.5 11.5 16.5 11.5 38.4 0 54.9-.9 1.3-1.4 2.8-1.4 4.5 0 1.5.4 2.8 1 4 8.6 14.9 8.6 33.2 0 48.1-.7 1.1-1 2.4-1 4 0 4.4 3.6 8 8 8 1.8 0 3.3-.5 4.6-1.4 12-8.4 27.1-11 41.2-6.9.7.2 1.4.3 2.3.3 2.8 0 5.3-1.4 6.8-3.8 6.3-10 16.1-17.3 27.4-20.5 3.4-1 5.8-4.1 5.8-7.7 0-.8-.1-1.5-.3-2.2-4.7-17.3.5-35.8 13.7-48 1.7-1.5 2.6-3.6 2.6-5.9s-.9-4.4-2.6-5.9c-13.2-12.2-18.5-30.7-13.7-48 .2-.6.3-1.3.3-2.2 0-3.6-2.4-6.7-5.8-7.7-11.4-3.2-21.1-10.5-27.4-20.5-1.5-2.4-4-3.8-6.8-3.8-.9 0-1.6.1-2.3.3-14 4.1-29.2 1.6-41.2-6.9-1.3-.9-2.8-1.4-4.6-1.4-4.4 0-8 3.6-8 8z"
        }
    ]
};

const FarEar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192v176c0 53 43 96 96 96s96-43 96-96c0-21.7 10.9-42.6 29.8-54.8C309.7 287.5 336 242.8 336 192zm48 0c0 67.8-35.1 127.4-88.2 161.5-4.9 3.2-7.8 8.6-7.8 14.5 0 79.5-64.5 144-144 144S0 447.5 0 368V192C0 86 86 0 192 0s192 86 192 192zm-256 0v20.2c0 3 1.7 5.8 4.4 7.2l14 7c18.1 9.1 29.5 27.6 29.5 47.8 0 15.9-7 30.9-19.2 41.1l-37.4 31.2c-10.2 8.5-25.3 7.1-33.8-3.1s-7.1-25.3 3.1-33.8l37.4-31.2c1.2-1 2-2.6 2-4.2 0-2.1-1.2-4-3-4.9l-14-7c-19-9.5-31-28.9-31-50.1V192c0-61.9 50.1-112 112-112s112 50.1 112 112v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-35.3-28.7-64-64-64s-64 28.7-64 64z"
        }
    ]
};

const FarEarthAfrica = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEarthAfrica",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-19.4-2.6-38.1-7.6-55.9l-27.4-5.5c-7.7-1.5-15.4 2.3-18.9 9.2-5.8 11.6-19.2 17.1-31.5 13l-14.1-4.7c-7.7-2.6-16.1-.6-21.8 5.1-3.7 3.7-3.7 9.7 0 13.4l33.5 33.5c5 5 7.8 11.8 7.8 18.9 0 12.3-8.4 23-20.3 26l-5.3 1.3c-3.8.9-6.4 4.3-6.4 8.2v12.1c0 13.8-4.5 27.3-12.8 38.4l-25.6 34.1c-6 8.1-15.5 12.8-25.6 12.8-17.7 0-32-14.3-32-32V336c0-8.8-7.2-16-16-16h-32c-26.5 0-48-21.5-48-48v-28c0-12.6 5.9-24.4 16-32l39.4-29.5c5.6-4.2 12.4-6.5 19.4-6.5 3.5 0 6.9.6 10.2 1.7l32 10.7c7.2 2.4 15 2.7 22.4.9l35.4-8.8c10.2-2.5 17.3-11.7 17.3-22.2 0-8.7-4.9-16.6-12.6-20.5l-29.2-14.6c-3.7-1.8-8.1-1.1-11 1.8l-3.9 3.9c-4.6 4.6-10.9 7.2-17.4 7.2-3.8 0-7.6-.9-11-2.6l-15.2-7.6c-6.7-3.4-14.9-1.6-19.6 4.3l-13.6 17c-5.5 6.9-15.8 7.4-22 1.2a14.6 14.6 0 0 1-4.3-10.4V96.5c0-5.6-1.5-11-4.2-15.9l-10-17.4C101.7 94.1 48 168.8 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FarEarthAmericas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEarthAmericas",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c-114.9 0-208-93.1-208-208 0-22 3.4-43.1 9.7-63l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8l57.9 16.5c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v30.4c0 15.9 15.2 27.3 30.5 23 15.9-4.5 28.3-17 32.8-32.8l1.5-5.4c4.6-16.1 15.3-29.7 29.8-38l9.2-5.3c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9L334 270c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5 4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5.3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c73.6 3.6 137.2 45.6 171.2 106.3L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3C448.7 385.4 361.5 464 256 464zm0 48a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"
        }
    ]
};

const FarEarthAsia = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEarthAsia",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-90.7-58.1-167.9-139.1-196.3l-16.4 40.9c-2.9 7.2-9 12.5-16.5 14.4l-17 4.3c-16.7 4.2-23.7 24-13.4 37.7l16.1 21.5c6.1 8.1 6.4 19.2.8 27.7l-10.7 16.1c-7.3 11-19.8 17.7-33.2 17.7h-2.3c-16.1 0-27.6 15.5-23 30.9l6 19.9c4.4 14.6-6.5 29.2-21.7 29.2-10.7 0-20.6-6.1-25.4-15.7l-9.3-18.5c-7.3-14.7-26.9-17.8-38.4-6.2L105.1 295c-5.7 5.7-13.8 8.1-21.7 6.6l-31.7-6.3C70 391.3 154.5 464 256 464c48.1 0 92.3-16.3 127.5-43.7l-5.9-4.3-18.6 6.9c-19.8 7.4-41.8-1.9-50.4-21.1l-5.6-12.4c-8.5-18.9-1.1-41.2 17-51.3l36.2-20.1c2.3-1.3 4.3-3.1 5.7-5.3l6.1-9.5c6-9.4 16.4-15.1 27.6-15.1s21.6 5.7 27.6 15.1l2 3.1c3.7 5.8 10.8 8.6 17.5 6.7l14.6-4.1c4.4-16.9 6.8-34.5 6.8-52.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm163.9 80.5 32 8c8.6 2.1 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6l-32-8c-8.6-2.1-13.8-10.8-11.6-19.4s10.8-13.8 19.4-11.6zm84.2 11c-8.6-2.1-13.8-10.8-11.6-19.4l8-32c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-8 32c-2.1 8.6-10.8 13.8-19.4 11.6zm102.2-212.3-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z"
        }
    ]
};

const FarEarthEurope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEarthEurope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c-114.9 0-208-93.1-208-208S141.1 48 256 48c3.5 0 6.9.1 10.3.3l-33.8 25.3c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3 2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3 0 3-1.2 5.9-3.3 8l-19.9 19.9a53.03 53.03 0 0 1-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4 0 3.7-1.5 7.3-4.1 10L202 182.1c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7 11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9 4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5 8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6 0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16h-20.7c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8 0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5c-3.6 3.8-5.6 8.7-5.6 13.8s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16h7.4c-4.1 12.6-9.3 24.7-15.6 36.1-3.7-2.6-8.2-4.1-13-4.1-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4h-20.9c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24 0 2.5.4 5 1.1 7.3-5.6.5-11.4.7-17.1.7zm0 48a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-68.7-388.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"
        }
    ]
};

const FarEarthOceania = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEarthOceania",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm208.6 101.3-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1 7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4 4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2l17.9 22.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26l-12 15.4c-8.3 10.6-21 16.8-34.4 16.8-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8 22.2 22.2c10.1 10.1 2.9 27.3-11.3 27.3h-29.9c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 416c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm175.2-125.1 8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FarEclipse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEclipse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5-98.5 18.2c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4l82.6-56.8 82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l8.1-44.3c-15.8-6.6-30.6-15.1-44.2-25.2l-4.5 24.4-65.5-45.3c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3l-78.3-14.4 45.2-65.6c5.7-8.2 5.7-19 0-27.2l-45.2-65.6 78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3 65.6 45.2c8.2 5.7 19 5.7 27.2 0l65.6-45.2 4.5 24.4C353.2 79.1 368 70.6 383.9 64l-8.2-44.3zM256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112c10.4 0 20.5-1.4 30.1-4.1-8.4-13.9-15.3-28.9-20.3-44.6-3.2.5-6.5.7-9.8.7-35.3 0-64-28.7-64-64s28.7-64 64-64c3.3 0 6.6.3 9.8.7 5-15.8 11.9-30.7 20.3-44.6-9.6-2.7-19.7-4.1-30.1-4.1zm80 112a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm304 0a176 176 0 1 0-352 0 176 176 0 1 0 352 0z"
        }
    ]
};

const FarEggFried = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEggFried",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M403.9 162.5c-26.9-6.9-56.4-20.3-82.6-35.6s-52.4-34.3-71.6-54.3c-30.6-31.9-81.3-32.9-113.1-2.2-14.5 14-22.6 32-24.3 50.6-4.6 52.6-19.6 123.5-49.3 175-30.9 53.6-12.6 122.1 41 153s122.1 12.6 153-41c14.7-25.4 38.1-45.6 61.1-59.7 23.3-14.3 50.6-25.3 77.1-29 12.7-1.8 25.3-6.7 36.4-15 35.5-26.3 42.9-76.4 16.6-111.9-11.4-15.4-27.2-25.4-44.4-29.8zM284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7 27.5 7 52.8 23.2 71 47.8 42.1 56.8 30.2 137-26.6 179.1-17.8 13.2-37.9 21.1-58.4 24-37.2 5.2-84.5 32.7-103.3 65.2-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM112 240a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm112-32c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39.8 0-72 32.2-72 72 0 8.8 7.2 16 16 16s16-7.2 16-16c0-22.1 17.9-40 40-40z"
        }
    ]
};

const FarEgg = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEgg",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 448c-74.7 0-144-75.4-144-160 0-48.3 14.1-107.7 41.3-153.5C116.4 88.8 151.1 64 192 64s75.6 24.8 102.7 70.5C321.9 180.3 336 239.7 336 288c0 84.6-69.3 160-144 160zM0 288c0 106 86 208 192 208s192-102 192-208c0-112-64-272-192-272S0 176 0 288zm170.8-154c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8 10.1-28.5 25-54.1 43.7-71.2z"
        }
    ]
};

const FarEggplant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEggplant",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 7c9.4 9.4 9.4 24.6 0 33.9l-9 9V192c0 8.8-7.2 16-16 16-26.5 0-48-21.5-48-48 0-5.8-4-10.7-9.4-12.7-13.3-4.8-25.4-13-35.1-22.8-9.7-9.8-17.9-21.9-22.8-35.2-2-5.4-6.9-9.4-12.6-9.4-26.5 0-48-21.5-48-48 0-8.8 7.2-16 16-16h142l9-9c9.4-9.4 24.6-9.4 33.9 0zM169.9 139.3c40.3-19.6 81-39.3 113.4-66.6 8.4 14.1 20.9 25.5 36 32.3-19.3 17.1-40.4 31-61.2 42.9-21.5 12.3-47 24.8-70.4 36.2-13.9 6.8-27 13.2-38 18.9-33.6 17.6-59 34.3-76.1 54.5-15.7 18.5-26.2 42-25.6 77.9 1 70 59 128.7 128.5 128.7 59 .1 115.4-40.1 163.9-107 33.3-46 59.2-99.9 76.2-148.5 10.2 13.3 24.4 23.3 40.8 28.2-46.8 125.9-146.3 275.4-281 275.2-96.5-.1-175-80.7-176.4-176-1.6-113.5 83.4-154.7 169.9-196.7z"
        }
    ]
};

const FarEject = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEject",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M4.1 323.3c-7.7-17.4-4.3-37.7 8.6-51.8l176-192c9-9.9 21.8-15.5 35.3-15.5s26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 352 400 352H48c-19 0-36.3-11.2-43.9-28.7zM48 304h352L224 112 48 304zm-24 96h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarElephant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarElephant",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M299.8 48c-33 0-59.8 26.8-59.8 59.8v4.2c0 35.3 28.7 64 64 64h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8c-61.9 0-112-50.1-112-112v-4.2c0-6.4.6-12.7 1.6-18.9C127.5 111.6 80 174.2 80 248v19c0 15.5-1.5 31-4.6 46.3-3.3 16.3-10.1 31.7-20.1 44.9l-12.1 16.2c-8 10.6-23 12.8-33.6 4.8s-12.8-23-4.8-33.6l12.1-16.2c5.7-7.6 9.6-16.3 11.4-25.6 2.5-12.1 3.7-24.4 3.7-36.8v-19c0-110.4 82.8-201.4 189.6-214.4C241.3 12.9 269.1 0 299.8 0c30.8 0 59 12.1 79.8 32h4.4c88.4 0 160 71.6 160 160v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-52.6-36.3-96.8-85.3-108.8 2.1 7.3 3.5 14.9 4.2 22.7l1 12.1c1.1 13.2-8.7 24.8-21.9 25.9s-24.8-8.7-25.9-21.9l-1-12.1C364.2 74.9 335 48 299.9 48zM528 381v18.7c0 17.8 14.5 32.3 32.3 32.3 15.8 0 29.3-11.4 31.9-27l.2-1c2.2-13.1 14.5-21.9 27.6-19.7s21.9 14.5 19.7 27.6l-.2 1c-6.5 38.7-40 67.1-79.2 67.1-44.3 0-80.3-36-80.3-80.3v-18.9c-24-4.1-45.9-13.9-64-28.1V464c0 26.5-21.5 48-48 48h-48c-26.5 0-48-21.5-48-48v-52.3c-21.2 2.8-42.8 2.8-64 0V464c0 26.5-21.5 48-48 48h-48c-26.5 0-48-21.5-48-48v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h48v-80c0-7 3-13.6 8.3-18.1s12.2-6.6 19.1-5.6l24.3 3.5c18.8 2.7 37.8 2.7 56.6 0l24.3-3.5c6.9-1 13.9 1.1 19.1 5.6S320 377 320 384v80h48V312c0-13.3 10.7-24 24-24 11.2 0 20.6 7.6 23.2 18 18.7 26.7 51.6 44.9 89.5 44.9 30.1 0 57.1-11.4 76.3-29.6 6.4-6.1 16.5-5.8 22.6.6s5.8 16.5-.6 22.6c-19.9 18.9-46 31.9-75 36.5zm-96-189a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarElevator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarElevator",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M132.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4S214.5 96 208 96H80c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zm224 86.6-64-64c-4.6-4.6-5.9-11.5-3.5-17.4S297.5 0 304 0h128c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-64 64c-6.2 6.2-16.4 6.2-22.6 0zM64 176c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H64zM0 192c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm272 208c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48 0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32zm-144-48h64c26.5 0 48 21.5 48 48 0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32 0-26.5 21.5-48 48-48zm176-80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-144-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarEllipsisStrokeVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEllipsisStrokeVertical",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 88a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm24 96a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm88 160a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarEllipsisStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEllipsisStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm-160 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm-136 64a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-88 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0z"
        }
    ]
};

const FarEllipsisVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEllipsisVertical",
    "viewBox": "0 0 128 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm48-112a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarEllipsis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEllipsis",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 256a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm-160 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0zM64 304a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
        }
    ]
};

const FarEmptySet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEmptySet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-74.6 74.4C358.1 50.6 309.2 32 256 32 132.3 32 32 132.3 32 256c0 53.2 18.6 102.1 49.5 140.5L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.5-74.5c38.4 31 87.3 49.5 140.5 49.5 123.7 0 224-100.3 224-224 0-53.2-18.6-102.1-49.5-140.5L505 41zm-142.7 74.7L115.7 362.3C93.3 332.8 80 295.9 80 256c0-97.2 78.8-176 176-176 39.9 0 76.8 13.3 106.3 35.7zM149.7 396.3l246.6-246.6C418.7 179.2 432 216.1 432 256c0 97.2-78.8 176-176 176-39.9 0-76.8-13.3-106.3-35.7z"
        }
    ]
};

const FarEngineWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEngineWarning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M424 88c0 13.3-10.7 24-24 24h-72v32h68.6c12.6 0 25 3.7 35.5 10.7l51.4 34.3c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H144c-35.3 0-64-28.7-64-64v-40H48v72c0 13.3-10.7 24-24 24S0 365.3 0 352V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72h32v-24c0-35.3 28.7-64 64-64h136v-32h-72c-13.3 0-24-10.7-24-24s10.7-24 24-24h192c13.3 0 24 10.7 24 24zM210.3 354l32 40c3 3.8 7.6 6 12.5 6H448c8.8 0 16-7.2 16-16V242.3c0-5.3-2.7-10.3-7.1-13.3l-51.4-34.3c-2.6-1.8-5.7-2.7-8.9-2.7H144c-8.8 0-16 7.2-16 16v112c0 8.8 7.2 16 16 16h28.8c14.6 0 28.4 6.6 37.5 18zM544 224c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V224zm-240-12c11 0 20 9 20 20v56c0 11-9 20-20 20s-20-9-20-20v-56c0-11 9-20 20-20zm-24 140a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarEngine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEngine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M424 88c0 13.3-10.7 24-24 24h-72v32h68.6c12.6 0 25 3.7 35.5 10.7l51.4 34.3c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H144c-35.3 0-64-28.7-64-64v-40H48v72c0 13.3-10.7 24-24 24S0 365.3 0 352V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72h32v-24c0-35.3 28.7-64 64-64h136v-32h-72c-13.3 0-24-10.7-24-24s10.7-24 24-24h192c13.3 0 24 10.7 24 24zM288 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM172.8 336c14.6 0 28.4 6.6 37.5 18l32 40c3 3.8 7.6 6 12.5 6H448c8.8 0 16-7.2 16-16V242.3c0-5.3-2.7-10.3-7.1-13.3l-51.4-34.3c-2.6-1.8-5.7-2.7-8.9-2.7H144c-8.8 0-16 7.2-16 16v112c0 8.8 7.2 16 16 16h28.8zM576 192h32c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarEnvelopeCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEnvelopeCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112h384c8.8 0 16 7.2 16 16v22.1l-22.6 18.5C458.6 163 477 160 496 160c5.4 0 10.7.2 16 .7V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h296.2c-11.8-14.3-21.4-30.5-28.2-48H64c-8.8 0-16-7.2-16-16V212.2l142 116.6c37.7 31 91.8 31.5 130.1 1.5.9-29.2 8.9-56.5 22.4-80.4l-50.9 41.8c-20.7 17-50.4 17-71.1 0L48 150.1V128c0-8.8 7.2-16 16-16zm576 224a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarEnvelopeDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEnvelopeDot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm16 224V190.9c-5.2.7-10.6 1.1-16 1.1-22.5 0-43.5-6.6-61-18.1L291.5 291.7c-20.7 17-50.4 17-71.1 0L48 150.1V128c0-8.8 7.2-16 16-16h324.6c-3-10.1-4.6-20.9-4.6-32 0-5.4.4-10.8 1.1-16H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64zM48 212.2l142 116.6c38.4 31.5 93.7 31.5 132 0l142-116.6V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V212.2z"
        }
    ]
};

const FarEnvelopeOpenDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEnvelopeOpenDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 48c-4.4 0-8 3.6-8 8v169.2l-42.8-35.1c-1.7-1.4-3.4-2.6-5.2-3.8V56c0-30.9 25.1-56 56-56h272c30.9 0 56 25.1 56 56v130.2c-1.8 1.2-3.5 2.5-5.2 3.8L400 225.2V56c0-4.4-3.6-8-8-8H120zM48 276.2V456c0 4.4 3.6 8 8 8h400c4.4 0 8-3.6 8-8V276.2L322 392.8c-38.4 31.5-93.7 31.5-132 0L48 276.2zM0 237.9C0 221.4 13.4 208 29.9 208c6.9 0 13.6 2.4 19 6.8l171.6 141c20.7 17 50.4 17 71.1 0l171.6-141c5.3-4.4 12.1-6.8 19-6.8 16.5 0 29.9 13.4 29.9 29.9V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V237.9zM276 88v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V296c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V88c0-11 9-20 20-20s20 9 20 20z"
        }
    ]
};

const FarEnvelopeOpenText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEnvelopeOpenText",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M392 48H120c-4.4 0-8 3.6-8 8v169.2l-42.8-35.1c-1.7-1.4-3.4-2.6-5.2-3.8V56c0-30.9 25.1-56 56-56h272c30.9 0 56 25.1 56 56v130.2c-1.8 1.2-3.5 2.5-5.2 3.8L400 225.2V56c0-4.4-3.6-8-8-8zm-232 72c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zm0 80c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zM48 276.2V456c0 4.4 3.6 8 8 8h400c4.4 0 8-3.6 8-8V276.2L322 392.8c-38.4 31.5-93.7 31.5-132 0L48 276.2zM0 237.9C0 221.4 13.4 208 29.9 208c6.9 0 13.6 2.4 19 6.8l171.6 141c20.7 17 50.4 17 71.1 0l171.6-141c5.3-4.4 12.1-6.8 19-6.8 16.5 0 29.9 13.4 29.9 29.9V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V237.9z"
        }
    ]
};

const FarEnvelopeOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEnvelopeOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M255.4 48.2c.2-.1.4-.2.6-.2s.4.1.6.2l204 145.8c2.1 1.5 3.4 3.9 3.4 6.5v13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1v-13.6c0-2.6 1.2-5 3.4-6.5l204-145.8zM48 276.2l142 116.6c38.4 31.5 93.7 31.5 132 0l142-116.6V456c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V276.2zM256 0c-10.2 0-20.2 3.2-28.5 9.1l-204 145.8C8.7 165.4 0 182.4 0 200.5V456c0 30.9 25.1 56 56 56h400c30.9 0 56-25.1 56-56V200.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"
        }
    ]
};

const FarEnvelope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEnvelope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v22.1l172.5 141.6c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
        }
    ]
};

const FarEnvelopesBulk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEnvelopesBulk",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48h320v48h48V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v144h48V48zM48 272h288v6.9L192.1 385.4h-.2L48 278.9V272zm0 66.6L163.3 424c8.3 6.2 18.4 9.5 28.7 9.5s20.4-3.3 28.7-9.5L336 338.6V464H48V338.6zM0 272v192c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48zm272-80v-16h320v192H416v48h176c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48v16h48zm240 16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32z"
        }
    ]
};

const FarEnvelopes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEnvelopes",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80H160c-8.8 0-16 7.2-16 16v7.8l177.4 131.4c4.2 3.1 9.3 4.8 14.6 4.8s10.4-1.7 14.6-4.8L528 103.8V96c0-8.8-7.2-16-16-16zm16 83.5L379.1 273.8C366.7 283 351.5 288 336 288s-30.7-5-43.1-14.2L144 163.5V320c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V163.5zM160 32h352c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zM24 96c13.3 0 24 10.7 24 24v224c0 48.6 39.4 88 88 88h320c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 480 0 419.1 0 344V120c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarEquals = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEquals",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h368c13.3 0 24-10.7 24-24s-10.7-24-24-24H40zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24h368c13.3 0 24-10.7 24-24s-10.7-24-24-24H40z"
        }
    ]
};

const FarEraser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEraser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M97 319c-9.4 9.4-9.4 24.6 0 33.9l72 72c4.5 4.5 10.6 7 17 7h108.1c6.4 0 12.5-2.5 17-7l65-65L216 200 97 319zM285.1 63c28.1-28.1 73.7-28.1 101.8 0L513 189.1c28.1 28.1 28.1 73.7 0 101.8L371.9 432H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H185.9c-19.1 0-37.4-7.6-50.9-21.1l-72-72c-28.1-28.1-28.1-73.7 0-101.8L285.1 63z"
        }
    ]
};

const FarEscalator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEscalator",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm182.1 85.8c16-14 36.6-21.8 57.9-21.8h104c48.6 0 88 39.4 88 88s-39.4 88-88 88h-70.9L249.9 490.2c-16 14-36.6 21.8-57.9 21.8H88c-48.6 0-88-39.4-88-88s39.4-88 88-88h70.9l231.2-202.2zM448 160c-9.7 0-19 3.5-26.3 9.9L183.8 378.1c-4.4 3.8-10 5.9-15.8 5.9H88c-22.1 0-40 17.9-40 40s17.9 40 40 40h104c9.7 0 19-3.5 26.3-9.9l237.9-208.2c4.4-3.8 10-5.9 15.8-5.9h80c22.1 0 40-17.9 40-40s-17.9-40-40-40H448zm-192-32c23.7 0 44.4 12.9 55.5 32L192 264.5V192c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FarEthernet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEthernet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h32v-32c0-17.7 14.3-32 32-32h32V96zm48 16v40c0 13.3-10.7 24-24 24h-40v40c0 13.3-10.7 24-24 24H48v160h40v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h40V240h-40c-13.3 0-24-10.7-24-24v-40h-40c-13.3 0-24-10.7-24-24v-40H176z"
        }
    ]
};

const FarEuroSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEuroSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48.6 240c-.4 5.3-.6 10.6-.6 16s.2 10.7.6 16H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h33.3C84.8 412.5 170.5 480 272 480h24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24c-74.6 0-138.4-46.4-164-112h156c13.3 0 24-10.7 24-24s-10.7-24-24-24H96.7c-.5-5.3-.7-10.6-.7-16s.2-10.7.7-16H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H108c25.6-65.6 89.4-112 164-112h24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24C170.5 32 84.8 99.5 57.3 192H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24.6z"
        }
    ]
};

const FarExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarExclamation",
    "viewBox": "0 0 64 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 56c0-13.3-10.7-24-24-24S8 42.7 8 56v288c0 13.3 10.7 24 24 24s24-10.7 24-24V56zM32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarExpandWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarExpandWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 64c13.3 0 24 10.7 24 24s-10.7 24-24 24H48v88c0 13.3-10.7 24-24 24S0 213.3 0 200V88c0-13.3 10.7-24 24-24h112zM0 312c0-13.3 10.7-24 24-24s24 10.7 24 24v88h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V312zM488 64c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24v-88h-88c-13.3 0-24-10.7-24-24s10.7-24 24-24h112zm-24 248c0-13.3 10.7-24 24-24s24 10.7 24 24v112c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h88v-88z"
        }
    ]
};

const FarExpand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarExpand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 32c13.3 0 24 10.7 24 24s-10.7 24-24 24H48v88c0 13.3-10.7 24-24 24S0 181.3 0 168V56c0-13.3 10.7-24 24-24h112zM0 344c0-13.3 10.7-24 24-24s24 10.7 24 24v88h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V344zM424 32c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V80h-88c-13.3 0-24-10.7-24-24s10.7-24 24-24h112zm-24 312c0-13.3 10.7-24 24-24s24 10.7 24 24v112c0 13.3-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h88v-88z"
        }
    ]
};

const FarExplosion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarExplosion",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.2 30.2c3.1-11.6-2.8-23.7-13.9-28.3s-23.9-.4-30 9.9L344.7 274.1l-33.5-128.2c-2.7-10.5-12.3-17.9-23.2-17.9s-20.5 7.4-23.2 17.9l-37.4 143.5L145 207c-7.6-7.6-19.4-9.2-28.8-3.9s-14.1 16.2-11.5 26.7l23.9 95.7-70.8-5.4c-9.2-.7-18 4-22.7 12s-4.2 18 1.1 25.6L87.7 432h58.4l-41.7-60.2 53.7 4.1c7.7.6 15.2-2.6 20.2-8.4s6.8-13.8 4.9-21.3l-11-43.9L223 353c6.1 6.1 15 8.4 23.3 6.2s14.8-8.8 16.9-17.1l24.8-95 24.8 95c2.4 9.4 10.3 16.4 19.9 17.7s19.1-3.2 24-11.6L451.2 188l-42.4 157.8c-2 7.6-.2 15.7 4.8 21.7s12.7 9.2 20.5 8.4l36.9-3.4-41.1 59.5h58.4l51.5-74.3c5.3-7.7 5.7-17.7 1-25.8s-13.6-12.7-22.9-11.8l-53.8 4.9 79.1-294.8zM465.9 464h-76.7c-10.8-45.9-52-80-101.2-80s-90.4 34.1-101.2 80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24h-86.1zm-228.5 0c9-18.9 28.3-32 50.6-32s41.6 13.1 50.6 32H237.4zM312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V24z"
        }
    ]
};

const FarEyeDropperFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEyeDropperFull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m199 169 34 33.9 76.1 76.1 33.9 34 8 8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-8-8 33.9-33.9 71.3-71.3c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8l-71.3 71.3L233 135l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8zm249.2-29.1L343 245.1 266.9 169 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8 0 14.3-5.7 28-15.8 38.1zM53.1 329A71.983 71.983 0 0 0 32 379.9v52.9l-28 42c-6.3 9.5-5.1 22.2 3 30.3s20.8 9.3 30.3 3l42-28h52.9c19.1 0 37.4-7.6 50.9-21.1l130.3-130.4-130-130L53.1 329z"
        }
    ]
};

const FarEyeDropperHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEyeDropperHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M233 202.9 199 169l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 33.9-33.9 71.3-71.3c19.1-19.1 45-29.8 72-29.8C466.4 0 512 45.6 512 101.8c0 27-10.7 52.9-29.8 72l-71.3 71.3L377 279l8 8c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-8-8-34-33.9-76.1-76.1zm110 42.2 105.2-105.2c10.1-10.1 15.8-23.8 15.8-38.1 0-29.7-24.1-53.8-53.8-53.8-14.3 0-28 5.7-38.1 15.8L266.9 169l76.1 76.1zm-159.6-46.5 33.9 33.9-87.4 87.5h124.2l25.4-25.4 33.9 33.9L183 458.9a71.983 71.983 0 0 1-50.9 21.1H79.3l-42 28c-9.5 6.3-22.2 5.1-30.3-3s-9.3-20.8-3-30.3l28-42v-52.8c0-19.1 7.6-37.4 21.1-50.9l130.3-130.4z"
        }
    ]
};

const FarEyeDropper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEyeDropper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m199 169 34 33.9 76.1 76.1 33.9 34 8 8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-8-8 33.9-33.9 71.3-71.3c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8l-71.3 71.3L233 135l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8zm249.2-29.1L343 245.1 266.9 169 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8 0 14.3-5.7 28-15.8 38.1zM53.1 329A71.983 71.983 0 0 0 32 379.9v52.9l-28 42c-6.3 9.5-5.1 22.2 3 30.3s20.8 9.3 30.3 3l42-28h52.9c19.1 0 37.4-7.6 50.9-21.1l130.3-130.4-33.9-33.9L149.1 425c-4.5 4.5-10.6 7-17 7H80v-52.1c0-6.4 2.5-12.5 7-17l130.4-130.3-33.9-33.9L53.1 329z"
        }
    ]
};

const FarEyeEvil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEyeEvil",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288.4 115.5 320 65l31.6 50.6c6.3 10 16 17.4 27.4 20.7 10.6 3.1 20.6 6.9 30 11.4 11 5.3 23.5 6.2 35.2 2.6l27.7-8.6-2.3 3.6c-10.6 16.2-10.5 37.1.3 53.2 4.2 6.2 7.6 12.5 10.3 19 5.2 12.4 15.4 22 28.1 26.5l33.8 12-33.9 12.1c-12.7 4.5-22.8 14.1-28.1 26.5-2.7 6.5-6.2 12.8-10.3 19-10.8 16.1-10.9 37-.3 53.2l2.3 3.6-27.7-8.6c-11.6-3.6-24.2-2.7-35.2 2.6-9.4 4.5-19.4 8.4-30 11.4-11.4 3.3-21.1 10.6-27.4 20.7L320 447l-31.6-50.6c-6.3-10-16-17.4-27.4-20.7-10.6-3.1-20.6-6.9-30-11.4-11-5.3-23.5-6.2-35.2-2.6l-27.7 8.6 2.3-3.6c10.6-16.2 10.5-37.1-.3-53.2-4.2-6.2-7.6-12.5-10.3-19-5.2-12.4-15.4-22-28.1-26.5l-33.8-12 33.9-12.1c12.7-4.5 22.8-14.1 28.1-26.5 2.7-6.5 6.2-12.8 10.3-19 10.8-16.1 10.9-37 .3-53.2l-2.3-3.6 27.7 8.6c11.6 3.6 24.2 2.7 35.2-2.6 9.4-4.5 19.4-8.4 30-11.4 11.4-3.3 21.1-10.6 27.4-20.7zm103.9-25.4-47.8-76.5C339.2 5.1 330 0 320 0s-19.2 5.1-24.5 13.6l-47.8 76.5c-13.1 3.8-25.7 8.6-37.5 14.3l-95.3-29.7c-9.2-2.9-19.1.3-24.9 8s-6.1 18.1-.8 26.1l41.3 62.7c-5.8 8.6-10.7 17.7-14.7 27.1l-100.7 36C6 237.8 0 246.4 0 256s6 18.2 15.1 21.4l100.6 35.9c4 9.4 8.9 18.5 14.7 27.1l-41.2 62.8c-5.3 8-4.9 18.5.8 26.1s15.7 10.9 24.9 8l95.3-29.8c11.8 5.7 24.4 10.5 37.5 14.3l47.8 76.5c5.3 8.6 14.5 13.7 24.5 13.7s19.2-5.1 24.5-13.6l47.8-76.5c13.1-3.8 25.7-8.6 37.5-14.3l95.3 29.8c9.2 2.9 19.1-.3 24.9-8s6.1-18.1.8-26.1l-41.3-62.7c5.8-8.6 10.7-17.7 14.7-27.1l100.6-35.9c9-3.2 15.1-11.8 15.1-21.4s-6-18.2-15.1-21.4l-100.5-36.1c-4-9.4-8.9-18.5-14.7-27.1l41.3-62.7c5.3-8 4.9-18.5-.8-26.1s-15.7-10.9-24.9-8l-95.3 29.8c-11.8-5.7-24.4-10.5-37.5-14.3zM256 245.5c12 4 24.5 7 37.3 8.7.1.4.2.7.4 1.1 5.5 14.4 13.5 24.4 18.1 29.3 2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c4.5-4.9 12.6-14.9 18.1-29.3.1-.4.3-.7.4-1.1 12.9-1.7 25.3-4.6 37.3-8.7v2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.5zm-10-3.5h.1-.1zm148 0a.1.1 0 1 0-.1-.1.1.1 0 1 0 .1.1zm-173.9-23c-2.7 9.2-4.1 18.9-4.1 29 0 57.4 46.6 104 104 104s104-46.6 104-104c0-10-1.4-19.8-4.1-29-4.9-16.8-25-20.6-41.3-14.1-18.1 7.2-37.9 11.1-58.6 11.1s-40.5-3.9-58.6-11.1c-16.3-6.4-36.4-2.7-41.3 14.1z"
        }
    ]
};

const FarEyeLowVision = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEyeLowVision",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.2-82.4c39.6-40.6 66.4-86.1 79.9-118.4 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7 0-70.7-57.3-128-128-128-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zm205.1 160.8-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3 0-5.5-.7-10.9-2-16h2c44.2 0 80 35.8 80 80 0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3-363.1-286c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1 47 43.8 111.7 80.6 192.5 80.6 3.1 0 6.1-.1 9.2-.2l-74-58c-36.7-11.8-68.5-32.9-95-57.5-18.3-17-34-35.6-46.8-53.6l-80.3-62.9c-1.8 6.8-1.3 14 1.4 20.5z"
        }
    ]
};

const FarEyeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEyeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.2-82.4c39.6-40.6 66.4-86.1 79.9-118.4 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7 0-70.7-57.3-128-128-128-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zm205.1 160.8-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3 0-5.5-.7-10.9-2-16h2c44.2 0 80 35.8 80 80 0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8l-37.7-29.7c-22.8 29.7-39.1 59.3-48.6 82.2-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47 43.8 111.7 80.6 192.5 80.6 47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128 13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"
        }
    ]
};

const FarEye = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEye",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256 63 286 89.6 328.5 128 364.3c41.2 38.1 94.8 67.7 160 67.7s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1 3.3 7.9 3.3 16.7 0 24.6-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80h-2c1.3 5.1 2 10.5 2 16 0 35.3-28.7 64-64 64-5.5 0-10.9-.7-16-2v2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
        }
    ]
};

const FarEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarEyes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M255.6 385.2C231.4 416.6 201.5 432 172 432s-59.4-15.4-83.6-46.8c-9.1-11.9-17.1-25.7-23.5-41.2 9.2 5.1 19.8 8 31.1 8 35.3 0 64-28.7 64-64s-28.7-64-64-64c-19 0-36.1 8.3-47.8 21.4 2-47.8 17.7-89.3 40.2-118.6C112.6 95.4 142.5 80 172 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2zM320 141.8C290 76.1 235 32 172 32 77 32 0 132.3 0 256s77 224 172 224c63 0 118-44.1 148-109.8C350 435.9 405 480 468 480c95 0 172-100.3 172-224S563 32 468 32c-63 0-118 44.1-148 109.8zm42.8 206.6c6.6 2.3 13.7 3.6 21.2 3.6 35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.8 0-28.5 5-39.3 13.5 3.3-44.4 18.5-83 39.8-110.6C408.6 95.4 438.5 80 468 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2C527.4 416.6 497.5 432 468 432s-59.4-15.4-83.6-46.8c-8.2-10.7-15.5-23.1-21.6-36.7z"
        }
    ]
};

const FarF = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarF",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32C25.1 32 0 57.1 0 88v368c0 13.3 10.7 24 24 24s24-10.7 24-24V272h184c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V88c0-4.4 3.6-8 8-8h240c13.3 0 24-10.7 24-24s-10.7-24-24-24H56z"
        }
    ]
};

const FarFaceAngryHorns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceAngryHorns",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464c141.4 0 256-114.6 256-256 0-24.6-3.5-48.4-9.9-70.9 44.3-59.4 67.4-135 73.6-166 1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5-29.8-8.9-59-20.3-78.3-33.1-5.4-3.6-12.4-3.6-17.8 0S-1 12.8.3 19.1c6.2 31 29.3 106.6 73.6 166-6.4 22.5-9.9 46.3-9.9 70.9 0 141.4 114.6 256 256 256zm72.4-102.5c9.7-9 10.2-24.2 1.2-33.9-14.3-15.3-39-31.6-73.6-31.6s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM240.4 288c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2S451.3 190 443 192.8l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FarFaceAngry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceAngry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9-14.3-15.3-39-31.6-73.6-31.6s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2S387.3 174 379 176.8l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FarFaceAnguished = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceAnguished",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-111.6-96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 144c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z"
        }
    ]
};

const FarFaceAnxiousSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceAnxiousSweat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 256c0 114.9-93.1 208-208 208-65.4 0-123.8-30.2-162-77.5-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256v3.3c16.3-7.1 36.4-2.8 48 12.8l.7.9c-.5-5.6-.7-11.3-.7-17 0-114.9 93.1-208 208-208s208 93.1 208 208zM48 416c12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47zm287.6-144a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5.4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6 7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5.4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM288 320c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80z"
        }
    ]
};

const FarFaceAstonished = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceAstonished",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 48c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32c0-26.5 21.5-48 48-48zm-111.6-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 144c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z"
        }
    ]
};

const FarFaceAwesome = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceAwesome",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm192-32v-24c0-2-.1-3.9-.4-5.8-4.2 3.6-9.6 5.8-15.6 5.8-13.3 0-24-10.7-24-24 0-6 2.2-11.4 5.8-15.6-1.9-.3-3.8-.4-5.8-.4-22.1 0-40 17.9-40 40v24h80zm-40-96c39.8 0 72 32.2 72 72v24c0 17.7-14.3 32-32 32h-80c-17.7 0-32-14.3-32-32v-24c0-39.8 32.2-72 72-72zm216 72c-13.3 0-24-10.7-24-24 0-5.4 1.8-10.3 4.7-14.3-4.1-1.1-8.3-1.7-12.7-1.7-26.5 0-48 21.5-48 48v16h96v-16c0-4.4-.6-8.7-1.7-12.7-4 3-8.9 4.7-14.3 4.7zm-32-72c44.2 0 80 35.8 80 80v17.9c0 16.6-13.5 30.1-30.1 30.1h-99.8c-16.6 0-30.1-13.5-30.1-30.1V208c0-44.2 35.8-80 80-80zM100.4 307.8c-2.3-10.2 5.5-19.8 15.9-19.8h279.4c10.4 0 18.1 9.6 15.9 19.8-3.9 17.4-10.6 33.6-19.5 48.2-28.2 45.9-78.9 75.6-134.9 76h-1.1c-4.6 0-9.3-.2-13.8-.6-68.5-5.9-126.7-55.6-141.8-123.6zm263.8 32.4c-8.2-2.7-16.9-4.2-25.9-4.2-39.2 0-71.9 27.3-80.2 64 44.1-.7 83.8-24.1 106.2-59.8z"
        }
    ]
};

const FarFaceBeamHandOverMouth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceBeamHandOverMouth",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1v10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256c0 113.1-73.3 209.1-175.1 242.9l49-49c11.7-11.7 16.1-27.9 13.2-43C439.1 369 464 315.4 464 256c0-114.9-93.1-208-208-208zm-38.4 180.8-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm-78.3 47.9c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2v-86.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarFaceClouds = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceClouds",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c27.9 0 51.7 17.9 60.4 42.8C198.6 36 210.8 32 224 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64c-35.3 0-64-28.7-64-64s28.7-64 64-64h8.6c11-19.1 31.7-32 55.4-32zM72.1 192h50c-6.5 20.2-10 41.7-10 64 0 80.2 45.4 149.9 112 184.6.1 22.3 7.2 42.9 19.3 59.7C139.4 467.7 64 370.6 64 256c0-22.1 2.8-43.5 8.1-64zM307.4 48.4C296.8 29.8 280.1 15.2 260.1 7c19.2-4.6 39.2-7 59.9-7 141.4 0 256 114.6 256 256 0 14.8-1.3 29.3-3.7 43.5-12.5-10.8-28.3-17.8-45.7-19.2.9-8 1.4-16.1 1.4-24.3 0-114.9-93.1-208-208-208-4.2 0-8.4.1-12.6.4zm-99 159.6a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 368c0-44.2 35.8-80 80-80 29.3 0 54.9 15.8 68.9 39.3 8.8-9.4 21.3-15.3 35.1-15.3 26.5 0 48 21.5 48 48 0 2.7-.2 5.4-.7 8h.7c39.8 0 72 32.2 72 72s-32.2 72-72 72H328c-39.8 0-72-32.2-72-72s32.2-72 72-72h8z"
        }
    ]
};

const FarFaceConfounded = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceConfounded",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm231 77.3 25 20 25-20c8.2-6.5 19.6-7 28.3-1.2l31.6 21.1L351 343c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-24 24c-8.1 8.1-20.8 9.3-30.3 3l-33.4-22.3-26.3 21c-8.8 7-21.2 7-30 0l-26.3-21-33.3 22.4c-9.5 6.3-22.2 5.1-30.3-3l-24-24c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l10.1 10.1 31.7-21.2c8.7-5.8 20.1-5.3 28.3 1.2zm-97.5-154.6 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 189.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
        }
    ]
};

const FarFaceConfused = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceConfused",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm203.2 129.6-12.8 9.6c-10.6 8-25.6 5.8-33.6-4.8s-5.8-25.6 4.8-33.6l12.8-9.6c37.4-28 82.9-43.2 129.6-43.2h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c-36.4 0-71.7 11.8-100.8 33.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceCowboyHat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceCowboyHat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 0c-36.8 0-67.4 64.9-82.4 109.8C100 99.3 70 84.6 45.1 66.8 42.6 65 39.7 64 36.7 64c-9 0-15.7 8.3-12.9 16.7C50.8 163.2 144.5 224 256 224s205.2-60.8 232.2-143.3c2.8-8.4-3.9-16.7-12.9-16.7-3 0-6 1-8.4 2.8-24.9 17.8-54.9 32.5-88.5 43C363.4 64.9 332.8 0 296 0c-9.1 0-17.9 4-26.1 10.7-7.9 6.5-19.8 6.5-27.7 0C233.9 4 225.1 0 216 0zM75.8 200C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104-12.8 9.3-26.6 17.5-41.2 24.6 13.4 23.4 21 50.5 21 79.3 0 88.4-71.6 160-160 160s-160-71.6-160-160c0-28.9 7.6-55.9 21-79.3-14.6-7.1-28.4-15.4-41.2-24.6zm290.6 167.5c5.7-11.5-6.2-22.2-18.6-18.8-27.9 7.8-59 12.2-91.6 12.2s-63.7-4.3-91.6-12.2c-12.4-3.5-24.3 7.3-18.6 18.8 20.2 40.6 62 68.5 110.2 68.5s90-27.9 110.2-68.6zM192 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarFaceDiagonalMouth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceDiagonalMouth",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm358.1 79.2-184 48c-12.8 3.3-25.9-4.3-29.3-17.2s4.3-25.9 17.2-29.3l184-48c12.8-3.3 25.9 4.3 29.3 17.2s-4.3 25.9-17.2 29.3zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceDisappointed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceDisappointed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm294.5 152.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9c14.3-15.4 39-31.7 73.6-31.7s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zm-83.2-141.1-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"
        }
    ]
};

const FarFaceDisguise = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceDisguise",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0 114.9-93.1 208-208 208S48 370.9 48 256c0-16.5 1.9-32.6 5.6-48H72c0 50.1 38.4 91.2 87.3 95.6-9.6 7.9-15.3 19.7-15.3 32.4 0 15.9 9 30.4 23.1 37.5L147.5 398c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l23.9-29.9 7.3 3.6-10.5 26.3c-3.3 8.2.7 17.5 8.9 20.8s17.5-.7 20.8-8.9l10-24.9c2.4.7 4.8 1.3 7.2 1.8V432c0 8.8 7.2 16 16 16s16-7.2 16-16v-25.2c2.4-.5 4.8-1.1 7.2-1.8l10 24.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-10.5-26.3 7.3-3.6 23.7 29.9c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-19.6-24.5C359 366.4 368 351.9 368 336c0-12.7-5.7-24.5-15.3-32.4 49-4.4 87.3-45.5 87.3-95.6h18.4c3.6 15.4 5.6 31.5 5.6 48zm-246-26.5-21.4 35.7c-1.1.6-1.9 1-2.6 1.3-7.9 3.5-16.8 5.5-26.1 5.5-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64c0 2.5-.1 4.9-.4 7.3-5.4 3.6-10.1 8.4-13.5 14.1zm62-21.5c0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5-.6-.3-1.5-.7-2.6-1.3L294 229.5c-3.5-5.8-8.1-10.6-13.5-14.1-.3-2.4-.4-4.9-.4-7.3zm219.4-31.6C465.9 74 369.6 0 256 0S46.1 74 12.6 176.4C5.4 177.9 0 184.3 0 192c0 4.7 2 9 5.3 11.9C1.8 220.7 0 238.1 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-17.9-1.8-35.3-5.3-52.1 3.3-2.9 5.3-7.2 5.3-11.9 0-7.7-5.4-14.1-12.6-15.6zM63.9 176c6.4-15.3 14.5-29.7 24.2-42.9-.6 4.5.2 9.3 2.4 13.6l1.4 2.7c-6.1 8-11 16.9-14.4 26.5H63.9zm384.1 0h-13.5c-3.4-9.6-8.3-18.6-14.4-26.5l1.4-2.7c2.2-4.4 2.9-9.1 2.4-13.6 9.7 13.2 17.8 27.6 24.2 42.9zm-343.1-62.9C142.8 73 196.5 48 256 48s113.2 25 151.1 65.1c-9-2.8-18.7 0-24.9 6.8-2-.9-4.1-1.7-6.2-2.4V112c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.3c-1.5.2-2.9.5-4.4.8-6.7-9.6-19.6-13-30.3-7.6s-15.7 17.8-12.1 28.9c-10.7 9.3-19.4 21-25.2 34.2-5.8-13.2-14.4-24.9-25.2-34.2 3.6-11.1-1.3-23.5-12.1-28.9s-23.6-1.9-30.4 7.6c-1.4-.3-2.9-.6-4.4-.8V112c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.5c-2.1.7-4.2 1.6-6.2 2.4-6.2-6.9-16-9.6-24.9-6.8zM256 240c4.3 0 8.3 2.3 10.5 6l39.8 66.3 2.4 4 4.2 2.1 17.7 8.8c3.4 1.7 5.5 5.1 5.5 8.8s-2.1 7.2-5.5 8.8l-53.1 26.5c-13.5 6.8-29.4 6.8-42.9 0l-53.1-26.5c-3.4-1.7-5.5-5.1-5.5-8.8s2.1-7.2 5.5-8.8l17.7-8.8 4.2-2.1 2.4-4 39.7-66.3c2.2-3.7 6.2-6 10.5-6zm-64-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarFaceDizzy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceDizzy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarFaceDotted = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceDotted",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-13.6 0-27 1.1-40 3.1-13.1 2.1-22 14.3-20 27.4s14.3 22 27.4 20C234 48.9 244.9 48 256 48s22 .9 32.6 2.5c13.1 2.1 25.4-6.9 27.4-20s-6.9-25.4-20-27.4c-13-2-26.4-3.1-40-3.1zM133.7 87.7c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3c-21.7 15.8-40.8 34.9-56.6 56.6-7.8 10.7-5.4 25.7 5.3 33.5s25.7 5.4 33.5-5.3c12.8-17.6 28.4-33.2 46.1-46.1zm272.8-38.8c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5c17.6 12.8 33.2 28.4 46 46.1 7.8 10.7 22.8 13.1 33.5 5.3s13.1-22.8 5.3-33.5c-15.8-21.7-34.9-40.8-56.6-56.6zm-356 174.5c2.1-13.1-6.9-25.4-20-27.4s-25.4 6.9-27.4 20c-2 13-3.1 26.4-3.1 40s1.1 27 3.1 40c2.1 13.1 14.3 22 27.4 20s22-14.3 20-27.4C48.9 278 48 267.1 48 256s.9-22 2.5-32.6zm458.4-7.4c-2.1-13.1-14.3-22-27.4-20s-22 14.3-20 27.4c1.7 10.6 2.5 21.5 2.5 32.6s-.9 22-2.5 32.6c-2.1 13.1 6.9 25.4 20 27.4s25.4-6.9 27.4-20c2.1-13.1 3.1-26.4 3.1-40s-1.1-27-3.1-40zM87.7 378.3c-7.8-10.7-22.8-13.1-33.5-5.3s-13.1 22.8-5.3 33.5c15.8 21.7 34.9 40.8 56.6 56.6 10.7 7.8 25.7 5.4 33.5-5.3s5.4-25.7-5.3-33.5c-17.6-12.8-33.2-28.4-46.1-46zm375.4 28.2c7.8-10.7 5.4-25.7-5.3-33.5s-25.7-5.4-33.5 5.3c-12.8 17.6-28.4 33.2-46 46-10.7 7.8-13.1 22.8-5.3 33.5s22.8 13.1 33.5 5.3c21.7-15.8 40.8-34.9 56.6-56.6zm-239.7 55c-13.1-2.1-25.4 6.9-27.4 20s6.9 25.4 20 27.4c13.1 2.1 26.4 3.1 40 3.1s27-1.1 40-3.1c13.1-2.1 22-14.3 20-27.4s-14.3-22-27.4-20c-10.6 1.6-21.5 2.5-32.6 2.5s-22-.9-32.6-2.5zm-47-221.5a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarFaceDowncastSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceDowncastSweat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M35.2 126.3C14.9 120.8 0 102.7 0 81 0 61 28.6 20.6 41.6 3.3c3.2-4.4 9.6-4.4 12.8 0 9.5 12.6 27.1 37.2 36 57.5l.9 2.1C94.2 69.7 96 76 96 81c0 26-21.5 47-48 47-4.4 0-8.7-.6-12.8-1.7zm81.4-85.1C156.7 15.2 204.6 0 256 0c141.4 0 256 114.6 256 256S397.4 512 256 512 0 397.4 0 256c0-35.8 7.3-69.9 20.6-100.8 8.6 3.1 17.8 4.8 27.4 4.8 8.9 0 17.6-1.5 25.7-4.2C57.3 185.5 48 219.7 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S370.9 48 256 48c-48.7 0-93.4 16.7-128.9 44.7.6-3.8.9-7.7.9-11.7 0-11.4-3.8-22.4-7.1-30.5-1.3-3.1-2.7-6.2-4.3-9.3zM96 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm208-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM183.6 409.5c-9.7-9-10.2-24.2-1.2-33.9 14.3-15.3 39-31.6 73.6-31.6s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2z"
        }
    ]
};

const FarFaceDrooling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceDrooling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0 114.9 93.1 208 208 208v48C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 80.8-37.5 152.9-96 199.9v-67c30-36 48-82.4 48-132.9 0-114.9-93.1-208-208-208S48 141.1 48 256zm110.8-32.4c-4.2 12.6-17.8 19.4-30.4 15.2S109 221 113.2 208.4c3.8-11.3 12.2-26.8 25.8-39.8 14.2-13.4 34.5-24.6 61-24.6 13.3 0 24 10.7 24 24s-10.7 24-24 24c-11.9 0-20.9 4.8-27.9 11.4-7.4 7-11.8 15.5-13.4 20.2zM129 309.3c10.4-8.3 25.5-6.6 33.7 3.7 18.7 23.4 49.8 47 93.3 47s74.5-23.6 93.3-47c8.3-10.4 23.4-12 33.7-3.7s12 23.4 3.8 33.7l-2.7 3.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V376.4c-9.5 7-20.2 13.3-32 18.5V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-59.1c-10 2-20.7 3.1-32 3.1-62.6 0-106.2-34.3-130.7-65-8.3-10.3-6.6-25.5 3.7-33.7zm210.9-105.9c-7-6.6-16-11.4-27.9-11.4-13.3 0-24-10.7-24-24s10.7-24 24-24c26.5 0 46.8 11.2 60.9 24.6 13.7 13 22.1 28.5 25.8 39.8 4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2c-1.6-4.7-6-13.2-13.4-20.2z"
        }
    ]
};

const FarFaceExhaling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceExhaling",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 7-.3 13.9-1 20.7 11.6-8 25.6-12.7 40.8-12.7 2.7 0 5.4.2 8.1.5.1-2.8.1-5.6.1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c55.8 0 107.4-17.9 149.5-48.2-10.5-9.3-17.9-22.1-20.5-36.5l-7.7-2.3c-34.1 24.5-76 39-121.3 39-114.9 0-208-93.1-208-208zm208 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm95.6-172c-10.6 0-19.9-3.8-25.4-9.7-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3.9c-5.5 5.8-14.8 9.7-25.4 9.7zm-217.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3.9c-5.5 5.8-14.8 9.7-25.4 9.7s-19.9-3.8-25.4-9.7zm409.2 96.2c.1-.8.1-1.7.1-2.5 0-22.1-17.9-40-39.9-40-16.9 0-31.4 10.5-37.2 25.4-3.3-.9-6.9-1.4-10.5-1.4-20.7 0-37.7 15.8-39.7 35.9L343.9 374c-4.6 1.1-7.8 5.2-7.8 9.9s3.2 8.8 7.8 9.9l72.2 18.2c-.1 1.3-.2 2.6-.2 4 0 22.1 17.9 40 39.9 40 4.9 0 9.6-.9 14-2.5 7.1 11.1 19.5 18.5 33.7 18.5 22.1 0 39.9-17.9 39.9-40 0-.8 0-1.7-.1-2.5 19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z"
        }
    ]
};

const FarFaceExplode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceExplode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 160c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8 7.5-3.7 15.9-5.8 24.8-5.8 30.9 0 56 25.1 56 56s-25.1 56-56 56h-40c-17.7 0-32 14.3-32 32v4.5c0 10.3 4.4 20.1 11.9 27l9.5 6c10.4 6.5 23.5 6.5 33.9 0l17.3-10.8c10.4-6.5 23.5-6.5 33.9 0l20.7 12.9c4.8 3 10.3 4.6 15.8 4.8 4.2.2 8.5-.5 12.6-2.1l33.9-13.1c1.5 11.4 2.3 23 2.3 34.8 0 5.3-.2 10.7-.5 15.9C503.3 405.9 392 512 256 512S8.7 405.9.5 271.9C.2 266.7 0 261.3 0 256c0-11.8.8-23.4 2.3-34.8l34 13.1c4.1 1.6 8.4 2.3 12.6 2.1 5.5-.2 11-1.8 15.8-4.8l20.7-12.9c10.4-6.5 23.5-6.5 33.9 0l17.3 10.8c10.4 6.5 23.5 6.5 33.9 0l9.5-6c7.5-6.9 11.9-16.6 11.9-27V192c0-17.7-14.3-32-32-32H120zm-8.8 110.1-8.8-5.5-12.2 7.6C77.9 279.9 64 284 49.9 284.4 63.8 385.8 150.7 464 256 464s192.2-78.2 206.1-179.6c-14.1-.4-28-4.5-40.3-12.1l-12.2-7.6-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0l-8.8-5.5-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0l-8.8-5.5-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0zm65.2 33.9a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM256 368c26.5 0 48 21.5 48 48v5.3c0 5.9-4.8 10.7-10.7 10.7h-74.6c-5.9 0-10.7-4.8-10.7-10.7V416c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FarFaceExpressionless = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceExpressionless",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm160 72h192c13.3 0 24 10.7 24 24s-10.7 24-24 24H160c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-32-120c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zm176-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarFaceEyesXmarks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceEyesXmarks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm137-121 23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm192 0 23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm-73 169c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80z"
        }
    ]
};

const FarFaceFearful = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceFearful",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-43.5-13.3-83.9-36.2-117.2l-.1.2c-6 6.5-16.2 6.8-22.6.8-15.5-14.5-34.8-24-56.1-26.8-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 8 1.1 15.7 2.8 23.2 5.2C342.4 62.2 300.9 48 256 48s-86.4 14.2-120.4 38.4c7.5-2.4 15.2-4.2 23.2-5.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8l-.1-.2C61.3 172.1 48 212.5 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-119.6-96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48a80 80 0 1 1-160 0 80 80 0 1 1 160 0zm64 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"
        }
    ]
};

const FarFaceFlushed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceFlushed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-95.6 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zm-32-160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FarFaceFrownOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceFrownOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm182.4 126.5c-12.4 5.2-26.5-4.1-21.1-16.4 16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zm-38-174.5a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceFrownSlight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceFrownSlight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm334.4 129.9C319.2 369.5 293.2 352 256 352s-63.2 17.5-78.4 33.9c-9 9.7-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9c22-23.8 60-49.4 113.6-49.4s91.7 25.5 113.6 49.4c9 9.7 8.4 24.9-1.4 33.9s-24.9 8.4-33.9-1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceFrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceFrown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm174.6 128.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4c-9.3-25.7-40.3-48.2-81.5-48.2s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceGlasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGlasses",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c-114.9 0-208-93.1-208-208 0-1.8 0-3.5.1-5.3C49.5 280.4 74 304 104 304h80c30.9 0 56-25.1 56-56v-48c0-2.7-.2-5.4-.6-8h33.1c-.4 2.6-.6 5.3-.6 8v48c0 30.9 25.1 56 56 56h80c30 0 54.5-23.6 55.9-53.3 0 1.8.1 3.5.1 5.3 0 114.9-93.1 208-208 208zm-32-303.2c-10.2-10.4-24.3-16.8-40-16.8h-80c-10.1 0-19.6 2.7-27.8 7.4C112.2 89.6 179.3 48 256 48s143.8 41.6 179.8 103.4c-8.2-4.7-17.7-7.4-27.8-7.4h-80c-15.7 0-29.8 6.4-40 16.8v-.8h-64v.8zM256 512c141.4 0 256-114.6 256-256 0-22.8-3-44.8-8.5-65.8 5.1-2.7 8.5-8 8.5-14.2 0-8.8-7.2-16-16-16h-2.6C455.4 66.2 363.4 0 256 0S56.6 66.2 18.6 160H16c-8.8 0-16 7.2-16 16 0 6.1 3.5 11.5 8.5 14.2C3 211.2 0 233.2 0 256c0 141.4 114.6 256 256 256zM143.7 332.7c-9.7 9-10.4 24.2-1.4 33.9 22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4c-15 16.4-41 33.9-78.2 33.9s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zM304 200c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-48zm-200-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm88.4 48a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarFaceGrimace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrimace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm256 208a256 256 0 1 1-512 0 256 256 0 1 1 512 0zm-344 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v-48h-8zm40 48h32v-48h-32v48zm96 0v-48h-32v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zm-168-80h176c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceGrinBeamSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinBeamSweat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M476.8 126.3c20.3-5.5 35.2-23.6 35.2-45.3 0-20-28.6-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0-9.5 12.6-27.1 37.2-36 57.5l-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47 4.4 0 8.7-.6 12.8-1.7zm-81.4-85.1C355.3 15.2 307.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8-8.6 3.1-17.8 4.8-27.4 4.8-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256 141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7-.6-3.8-.9-7.7-.9-11.7 0-11.4 3.8-22.4 7.1-30.5 1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1 24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm160 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2z"
        }
    ]
};

const FarFaceGrinBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1-24.6 38.1-68.7 63.5-119.1 63.5s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1 28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-131.9-79.6-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FarFaceGrinHearts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinHearts",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1-24.6 38.1-68.7 63.5-119.1 63.5s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1 28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6 4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
        }
    ]
};

const FarFaceGrinSquintTears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinSquintTears",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M426.8 14.2c19.2-19.2 50.7-18.8 70.3.7s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7-5.6.9-10.3-3.9-9.5-9.5 3.3-22.5 12-73.4 26.8-88.2zM75 75c83.2-83.3 209.5-97.2 307.2-41.8-1.5 4.8-2.9 9.6-4.1 14.3-3.1 12.2-5.5 24.6-7.3 35-80.8-53.6-190.7-44.8-261.9 26.4-71.2 71.2-80 181.1-26.4 261.9-10.5 1.8-22.9 4.2-35 7.3-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1 55.3 97.7 41.3 224-41.9 307.2-83.2 83.2-209.5 97.2-307.2 41.8 1.5-4.8 2.8-9.6 4-14.3 3.1-12.2 5.5-24.6 7.3-35 80.8 53.6 190.7 44.8 261.9-26.4 71.2-71.2 80-181.1 26.4-261.9 10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9 9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9 25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19L178.7 352c-2.6 8.6-13.4 11.3-19.8 4.9-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4-6.3-6.3-3.6-17.2 4.9-19.8zM285 87.1c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8.3 5.4 1.5 7.3 3.4 6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zm-270.1 410c-19.6-19.6-20-51-.7-70.3 14.8-14.8 65.6-23.6 88.2-26.7 5.6-.9 10.3 3.9 9.5 9.5-3.2 22.5-11.9 73.5-26.7 88.3-19.2 19.1-50.7 18.7-70.3-.8z"
        }
    ]
};

const FarFaceGrinSquint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinSquint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1-24.6 38.1-68.7 63.5-119.1 63.5s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1 28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
        }
    ]
};

const FarFaceGrinStars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinStars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72.8-379.4a7.934 7.934 0 0 0-14.4 0l-16.6 34.7-38.1 5c-3.1.4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5.6l33.8-18.4 33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8 27.9-26.5c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0a7.934 7.934 0 0 0-14.4 0l-16.6 34.7-38.1 5c-3.1.4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5.6l33.8-18.4 33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8 27.9-26.5c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1 24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"
        }
    ]
};

const FarFaceGrinTears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinTears",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M516.1 325.5c1 3 2.1 6 3.3 8.9 3.3 8.1 8.4 18.5 16.5 26.6 3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512S133.6 454.8 91.4 371.4c4.5-2.9 8.7-6.3 12.7-10.3 8.1-8.1 13.2-18.6 16.5-26.6 1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5-6.7-3.1-14.3-4.3-22.3-3.1-6.8.9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0s234.7 94.5 253.2 217.7c-10.3-2-19.8-3.5-26.6-4.4-8-1.2-15.7.1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2 8.6-8.6 30.1-15.1 50.5-19.6 13-2.8 25.5-4.8 33.9-6 5.4-.8 9.9 3.7 9 9-3.1 21.5-11.4 70.2-25.5 84.4-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2-.2-.2-.5-.4-.7-.7-14.1-14.1-22.5-62.9-25.5-84.4-.8-5.4 3.7-9.9 9-9 1 .1 2.2.3 3.3.5 8.2 1.2 19.2 3 30.6 5.5 20.4 4.4 41.9 10.9 50.5 19.6 18.4 18.4 18 48.5-.7 67.2-17.7 17.7-45.7 19-64.2 3.4zM439 336.5c-24.6 38.1-68.7 63.5-119.1 63.5s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1 28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8l-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FarFaceGrinTongueSquint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinTongueSquint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4-2.4-8.4-3.7-17.3-3.7-26.4v-23.3c-24-17.5-43.1-41.4-54.8-69.2-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7-11.8 28-31.1 52-55.4 69.6V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5 0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416v-37.4c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FarFaceGrinTongueWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinTongueWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4v-52.5c8.8-8 16.6-17.1 23-27 10.4-16.1-6.8-32.5-25.5-28.1-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1 6.5 10 14.3 19.1 23.1 27.1V416c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96.4-292c10.6 0 19.9 3.8 25.4 9.7 7.6 8.1 20.2 8.5 28.3.9s8.5-20.2.9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7.9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64v-37.4c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9 2.8 12.6 20.8 12.6 23.6 0 2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"
        }
    ]
};

const FarFaceGrinTongue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinTongue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4-2.4-8.4-3.7-17.3-3.7-26.4v-52.4c-8.9-8-16.7-17.1-23.1-27.1-10.4-16.1 6.8-32.5 25.5-28.1 28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1-6.4 9.9-14.2 19-23 27V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM320 416v-37.4c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FarFaceGrinWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1-24.6 38.1-68.7 63.5-119.1 63.5s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1 28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64 14.3-64 32-64 32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64z"
        }
    ]
};

const FarFaceGrinWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrinWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1-24.6 38.1-68.7 63.5-119.1 63.5s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1 28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3.9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
        }
    ]
};

const FarFaceGrin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceGrin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1-24.6 38.1-68.7 63.5-119.1 63.5s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1 28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceHandOverMouth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceHandOverMouth",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1v10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256c0 113.1-73.3 209.1-175.1 242.9l49-49c11.7-11.7 16.1-27.9 13.2-43C439.1 369 464 315.4 464 256c0-114.9-93.1-208-208-208zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-37.1 100.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2v-86.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarFaceHandPeeking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceHandPeeking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496.4 145.7c.4-.5.9-1 1.4-1.4 12.9-12.9 31.8-16.1 47.7-9.6C502.2 54.5 417.5 0 320 0c-71.5 0-136.2 29.3-182.7 76.6 7.7 1.8 14.9 5.7 20.9 11.7 6.6 6.6 10.6 14.7 12.2 23.2C208.2 72.3 261.3 48 320 48c74.4 0 139.6 39 176.4 97.7zm40.7 246c-5.4.7-10.8 1.1-16.3 1.1h-44.2C438.5 436.5 382.5 464 320 464c-79.9 0-149.3-45-184.1-111.1h-16.7c-13.3 0-26.4-2.2-38.8-6.5C117 443.2 210.4 512 320 512c91.5 0 171.8-48 217.1-120.2zM352.8 264c-10.4-10.2-16.8-24.3-16.8-40 0-28.5 21.2-52 48.7-55.5 1-5.5 3.3-10.9 6.7-15.7 5.1-7.1 12.1-12.1 19.7-14.6-6.2-1.4-12.6-2.1-19.2-2.1-48.6 0-88 39.4-88 88 0 40.3 27.1 74.3 64.1 84.7.1-1.4.3-2.8.6-4.2-10-7.3-16.6-19.2-16.6-32.6 0-2.7.3-5.4.8-8zM320 432c35.3 0 64-21.5 64-48s-28.7-48-64-48-64 21.5-64 48 28.7 48 64 48zm90.3-192c3.8-4.2 6.1-9.9 6.1-16 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 6.1 2.3 11.8 6.1 16h35.8zM248 192c0-8.8-7.2-16-16-16H118.2c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0l-61.1 61.2-.8.8c-36.4 37.2-36.1 96.9.8 133.8 17.9 17.9 42.1 27.9 67.3 27.9H184c8.8 0 16-7.2 16-16s-7.2-16-16-16h-14c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h62c8.8 0 16-7.2 16-16s-7.2-16-16-16h-62.4c-2.2 0-4-1.8-4-4s1.8-4 4-4H248c8.8 0 16-7.2 16-16s-7.2-16-16-16h-78.4c-2.2 0-4-1.8-4-4s1.8-4 4-4H232c8.8 0 16-7.2 16-16zm163-25.3c-5.1 7.2-3.5 17.2 3.7 22.3l59.7 42.6c3.5 2.5 5.6 6.6 5.6 10.9 0 7.4-6 13.4-13.4 13.4l-74.6.1c-8.8 0-16 7.2-16 16s7.2 16 16 16h84c2.2 0 4 1.8 4 4s-1.8 4-4 4h-68c-8.8 0-16 7.2-16 16s7.2 16 16 16h67.5c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5H456c-8.8 0-16 7.2-16 16s7.2 16 16 16h64.8c25.2 0 49.5-10 67.3-27.9 36.9-36.9 37.2-96.6.8-133.8l-.8-.8-45.1-45.2c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l14.8 14.8c6.6 6.6 2.7 18-6.6 19-2.8.3-5.6-.4-7.8-2L433.3 163c-7.2-5.1-17.2-3.5-22.3 3.7z"
        }
    ]
};

const FarFaceHandYawn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceHandYawn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 59.4-24.9 113-64.9 150.9 2.9 15.1-1.5 31.3-13.2 43l-49 49C438.7 465.1 512 369.1 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4-9.8-18-15.3-38.6-15.3-60.5v-10.8C72.6 368.2 48 315 48 256zm208-48c-44.2 0-81.3 29.8-92.5 70.4h.5c17.9 0 33.6 9 43 22.7l47.1-47.1c18.7-18.7 49.1-18.7 67.9 0 1 1 2 2.1 3 3.2 4.7-1.1 9.5-1.5 14.3-1.2-16.7-28.6-47.7-48-83.3-48zm-29.3-103c-8.3-10.4-23.4-12-33.7-3.7l-80 64c-10.4 8.3-12 23.4-3.7 33.7s23.4 12 33.7 3.7l80-64c10.4-8.3 12-23.4 3.7-33.7zm62.3 33.7 80 64c10.3 8.3 25.5 6.6 33.7-3.7s6.6-25.5-3.8-33.7l-80-64c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7zm10.3 137.9c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7v-19.5c0-11-9-20-20-20s-20 9-20 20v86.4c0 52.6 42.6 95.2 95.2 95.2 25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FarFaceHeadBandage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceHeadBandage",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M71.3 354c6.6-9.7 13.4-19.2 20.6-28.4C120.5 406.2 197.5 464 288 464c114.9 0 208-93.1 208-208 0-13.2-1.2-26.2-3.6-38.7 11.9 3 23.7 6.3 35.4 9.8l15 4.5c.8 8 1.1 16.2 1.1 24.4 0 141.4-114.6 256-256 256-99.5 0-185.8-56.8-228.2-139.8 2.5-3.8 4.8-7.5 6.7-10.7 1.9-3.1 3.5-5.7 4.7-7.5zm147.2-144.4c12.7 4.2 21.9 16.2 21.9 30.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c13.5-10.8 27.6-20.9 42.1-30.4zM368.1 12.8c-45.1 9.1-88.5 23-129.6 41.1-13.9 3.4-27.2 8.2-39.8 14.2-33.5 3.1-66.5 7.9-98.9 14.3C146.6 31.8 213.6 0 288 0c28 0 54.9 4.5 80.1 12.8zm-.3 382.7C352.2 381.2 328.4 368 296 368c-12.3 0-23.2 1.9-32.8 4.9-12.6 4-26.1-3-30.1-15.7s3-26.1 15.7-30.1c14.2-4.5 30-7.1 47.2-7.1 46.5 0 81.4 19.3 104.2 39.9 9.8 8.9 10.5 24.1 1.6 33.9s-24.1 10.5-33.9 1.6zM336.4 240a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM300.6 64.1c38.3-13 78.3-22.2 119.5-27.4 20.8 12.6 39.7 28 56.1 45.7-56.9-11.3-115.6-17.5-175.6-18.3zM406 103.4c34 4.3 67.3 10.5 100.1 18.3 14.1 22.8 24.6 47.9 31 74.7C458.2 172.7 374.6 160 288 160c-17.1 0-34.1.5-51 1.5-47.8 2.8-94.6 9.4-140 19.7-19.6 4.4-39 9.5-58.1 15.3 6.4-26.8 17-51.9 31-74.7 48.4-11.6 98.2-19.5 149.3-23.2 22.7-1.8 45.7-2.6 68.8-2.6 40 0 79.3 2.5 118 7.4zm-355.7 123c41-12.2 83.3-21.3 126.6-27.1-51.6 37.5-96.5 83.8-132.2 136.7-8.2-25.1-12.7-52-12.7-80 0-3 .1-6.1.2-9.1 5.9-7 12-13.8 18.2-20.5z"
        }
    ]
};

const FarFaceHoldingBackTears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceHoldingBackTears",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm208-16a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm32 32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16c-13.4 10-30 16-48 16-11.4 0-22.2-2.4-32-6.7v6.7c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c-10-13.4-16-30-16-48s6-34.6 16-48c-8 0-14.9-5.9-15.9-14-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8 40.4 4 72 38.1 72 79.6v32zm112 16a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.7c-9.8 4.3-20.6 6.7-32 6.7-44.2 0-80-35.8-80-80 0-41.5 31.5-75.6 72-79.6-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9-1 8.1-7.9 14-15.9 14 10 13.4 16 30 16 48s-6 34.6-16 48zm-105.6 74.5c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-17.4 18.8-47.4 39-89.7 39s-72.3-20.2-89.6-38.9c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4c10.4 11.3 28.4 23.4 54.3 23.4s43.9-12.1 54.4-23.5zM128 240c17.7 0 32-14.3 32-32 17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32c17.7 0 32-14.3 32-32z"
        }
    ]
};

const FarFaceHushed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceHushed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176.4-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8.3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8-4.3-.6-8.6-.9-13-.9zm-64 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarFaceIcicles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceIcicles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48C141.1 48 48 141.1 48 256c0 1.4-.1 2.7-.3 4l-15 180c-.4 4.5-4.1 8-8.7 8s-8.3-3.5-8.7-8L.3 260c-.2-1.3-.3-2.6-.3-4C0 114.6 114.6 0 256 0s256 114.6 256 256c0 1-.1 2-.2 3l-15.3 245c-.3 4.5-4 8-8.5 8s-8.2-3.5-8.5-8l-15.3-245c-.1-1-.2-2-.2-3 0-114.9-93.1-208-208-208zm-88 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v-48h-8zm40 48h32v-48h-32v48zm96 0v-48h-32v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zm-168-80h176c30.9 0 56 25.1 56 56 0 15.7-6.4 29.8-16.8 40l-8.9 86.7c-.5 5.3-5 9.3-10.3 9.3s-9.7-4-10.3-9.3l-7.3-70.8c-.8 0-1.6.1-2.5.1h-26.6l-6.5 38.8a11.058 11.058 0 0 1-21.8 0l-6.3-38.8H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM256 512c-75.5 0-143.3-32.7-190.2-84.6l6.2-74.3c34.9 66 104.2 110.9 184 110.9 3.5 0 6.9-.1 10.3-.3 7.9 10 20.2 16.3 33.7 16.3 7.9 0 15.4-2.2 21.9-6 1 10.1 5.6 19.1 12.4 25.8-24.7 7.9-51 12.2-78.3 12.2zm151.3-49.5 7.4-72c8.9-10.5 16.8-21.9 23.5-34.1l4.7 74.6c-10.8 11.6-22.8 22.2-35.6 31.6z"
        }
    ]
};

const FarFaceKissBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceKissBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FarFaceKissClosedEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceKissClosedEyes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zM175.6 220c-10.6 0-19.9 3.8-25.4 9.7-7.6 8.1-20.2 8.5-28.3.9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7zm134.6 9.7c-7.6 8.1-20.2 8.5-28.3.9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
        }
    ]
};

const FarFaceKissWinkHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceKissWinkHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2-114.9 0-208-93.1-208-208S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1 3.1 4.5 5.7 9.4 7.8 14.6 12.7-1.6 25.1.4 36.2 5 9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c35.4 0 69.1-7.2 99.7-20.2-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3-4.3-5.2-10.1-9.7-16.7-13.4-13.3-7.4-30.6-12.3-48-12.3-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l.2.1c.2.1.5.3.9.5.8.5 2 1.2 3.4 2.1 2.8 1.9 6.5 4.5 10.2 7.6 3.7 3.1 7.2 6.6 9.6 10.1 2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1-3.7 3.1-7.4 5.7-10.2 7.6-1.4.9-2.6 1.6-3.4 2.1-.4.2-.7.4-.9.5l-.2.1c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l.2.1c.2.1.5.3.9.5.8.5 2 1.2 3.4 2.1 2.8 1.9 6.5 4.5 10.2 7.6 3.7 3.1 7.2 6.6 9.6 10.1 2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1-3.7 3.1-7.4 5.7-10.2 7.6-1.4.9-2.6 1.6-3.4 2.1-.4.2-.7.4-.9.5l-.2.1c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3 6.6-3.7 12.5-8.2 16.7-13.4 4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4-2.7-1.5-5.7-3-8.7-4.3 3.1-1.3 6-2.7 8.7-4.3 6.6-3.7 12.5-8.2 16.7-13.4 4.3-5.1 7.3-11.4 7.3-18.3zm-119.6-76a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7 7.6 8.1 20.2 8.5 28.3.9s8.5-20.2.9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7.9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
        }
    ]
};

const FarFaceKiss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceKiss",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceLaughBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceLaughBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9h212.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FarFaceLaughSquint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceLaughSquint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9h212.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
        }
    ]
};

const FarFaceLaughWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceLaughWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9h212.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3.9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
        }
    ]
};

const FarFaceLaugh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceLaugh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9h212.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceLying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceLying",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M431.3 368H352c-13.3 0-24-10.7-24-24s10.7-24 24-24h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H288c-13.3 0-24-10.7-24-24s10.7-24 24-24h152c7.7 0 15.1 1.2 22.1 3.4C448.1 126.1 361.2 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208c73.6 0 138.3-38.3 175.3-96zm67.4-30.3C464.6 439 368.8 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 8.8-.4 17.6-1.3 26.2.9 4.5 1.3 9.1 1.3 13.8 0 15.6-4.9 30-13.3 41.7zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM195.2 390.4c-8 10.6-23 12.7-33.6 4.8s-12.7-23-4.8-33.6C175.7 336.4 206 320 240 320c14.7 0 28.8 3.1 41.6 8.7 12.1 5.3 17.7 19.5 12.4 31.6s-19.5 17.7-31.6 12.4c-6.8-3-14.4-4.6-22.4-4.6-18.3 0-34.6 8.8-44.8 22.4z"
        }
    ]
};

const FarFaceMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceMask",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 388.9c-27.6-33.2-45.1-75.1-47.7-121l50.1 26.7c-1.6 5.5-2.4 11.4-2.4 17.4v76.9zM36.4 208.6c-7.1-2-14.9 1.1-18.5 7.9-4.2 7.8-1.2 17.5 6.6 21.6l7.9 4.2c-.2 4.5-.4 9.1-.4 13.7 0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.6-.1-9.1-.4-13.7l7.9-4.2c7.8-4.2 10.7-13.8 6.6-21.6-3.6-6.8-11.4-9.9-18.5-7.9C517.4 89.9 413.2 0 288 0S58.6 89.9 36.4 208.6zm45 23.6C93.2 128.5 181.2 48 288 48s194.8 80.5 206.7 184.2L429.5 267c-11.6-11.7-27.7-19-45.5-19H192c-17.8 0-33.9 7.2-45.5 19l-65.2-34.8zm414.3 35.7c-2.6 45.9-20.1 87.8-47.7 121V312c0-6-.8-11.9-2.4-17.4l50.1-26.7zm-325.3-60.5c4.8-5.7 26.7-23.4 61.6-23.4 13.3 0 24-10.7 24-24s-10.7-24-24-24c-50.4 0-85.4 25-98.4 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1zM176 312c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16v8H176v-8zm0 40h224v32H176v-32zm0 64h224c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm168-232c36.4 0 58.7 15.3 63 19.6 9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-13.5-13.5-48.1-33.7-97-33.7-13.3 0-24 10.7-24 24s10.7 24 24 24z"
        }
    ]
};

const FarFaceMehBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceMehBlank",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm256 208a256 256 0 1 1-512 0 256 256 0 1 1 512 0zm-367.6-48a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceMeh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceMeh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-79.6 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarFaceMelting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceMelting",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 256c0-114.9-93.1-208-208-208s-208 93.1-208 208c0 33.5 7.9 65 21.9 93 16.7 33.4 12.5 72.2-.1 100.7-2.1 4.7-4.6 9.5-7.6 14.4h357.9c-2.7-7.5-4.1-15.6-4.1-24 0-32.6 21.6-60.1 51.3-69-10.9-20.5-14.2-44.9-9.1-66.1 3.8-15.6 5.8-32 5.8-48.9zm40.9 60.1c-6 24.8 11.1 51.9 36.6 51.9H616c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24 24 10.7 24 24-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h22.6c38.9 0 61.8-58.8 44.4-93.6C73.7 336 64 297.1 64 256 64 114.6 178.6 0 320 0s256 114.6 256 256c0 20.7-2.5 40.8-7.1 60.1zm-305.1-158a32 32 0 1 1-16.6 61.8 32 32 0 1 1 16.6-61.8zm115.4 64a32 32 0 1 1 61.8 16.6 32 32 0 1 1-61.8-16.6zm-158.8 57.8c11.3 23.2 33.6 50.1 72.7 60.6s71.9-1.7 93.2-16.1c11-7.4 25.9-4.6 33.3 6.4s4.6 25.9-6.4 33.3c-29.5 19.9-76.5 37.8-132.5 22.8s-87.9-54-103.4-86c-5.8-11.9-.8-26.3 11.1-32.1s26.3-.8 32.1 11.1z"
        }
    ]
};

const FarFaceMonocle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceMonocle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 336.1V224c0-61.9-50.1-112-112-112s-112 50.1-112 112 50.1 112 112 112c31.3 0 59.7-12.9 80-33.6v86.5c-38.2 45.9-95.7 75.1-160 75.1-114.9 0-208-93.1-208-208S141.1 48 256 48c16.7 0 32.9 2 48.4 5.7-6.9 2.8-13.3 6.6-19.2 11.2L262 83.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6c8-6.4 18-9.9 28.2-9.9 8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c5.7 3.8 12.9 3.5 18.2-.3 48 38.1 78.7 96.9 78.7 163 0 28.4-5.7 55.5-16 80.1zm3.9 84.7c37.5-44.5 60.1-102 60.1-164.8C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c65.8 0 125.9-24.8 171.2-65.7 10.2 22.8 27.1 42.5 48.9 56.1l11.4 7.1c7.5 4.7 17.4 2.4 22-5.1s2.4-17.4-5.1-22l-11.4-7.1c-20.2-12.6-34.7-32.2-41.3-54.5zM256 224a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm-79.6-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16 14.3 0 37.9 2.9 60.6 11.7 22.8 8.8 42.7 22.7 53.1 43.4 4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59-27-10.3-54.6-13.8-72.3-13.8-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarFaceNauseated = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceNauseated",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm335.6-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-12.3-84.7-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM172 267.2c17 9.8 30 25.8 36 44.8h96.2c6.1-18.8 19-34.5 35.8-44.2 11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8c-9.4 5.5-15.7 15.6-15.7 27.2s6.3 21.8 15.7 27.2c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8c-17.1-9.9-30.2-26-36.2-45.3H208c-6 19-19.1 35-36 44.8-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8c9.5-5.5 15.7-15.6 15.7-27.2s-6.3-21.8-15.7-27.2c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8z"
        }
    ]
};

const FarFaceNoseSteam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceNoseSteam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c-21.6 0-42.4-3.3-61.9-9.4-3.1 8.6-8.1 16.7-15 23.6-1.3 1.3-2.6 2.5-4 3.7-.3 5.4-1.3 10.8-3 16C198.4 507 226.6 512 256 512c28.7 0 56.3-4.7 82-13.4-1.6-5.1-2.6-10.5-2.9-15.8-1.4-1.2-2.7-2.4-4-3.7-7-7-12-15.2-15.1-23.9-19 5.7-39.2 8.8-60 8.8zm208-208c0 21.3-3.2 41.8-9.1 61.1 8.5 3.1 16.5 8.1 23.4 14.9 1.3 1.3 2.5 2.6 3.7 4 5.5.3 11 1.3 16.3 3.1 8.9-26.1 13.8-54 13.8-83.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 28.6 4.7 56.1 13.3 81.8 4.9-1.5 9.9-2.4 15-2.7 1.2-1.4 2.4-2.7 3.7-4l4 4-4-4c7.2-7.2 15.7-12.3 24.7-15.4C51 296.8 48 276.8 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208zM345.9 443.6c1.5 4.7 4.1 9.1 7.9 12.9.7.7 1.3 1.3 2 1.9 4.2 3.6 9.2 5.9 14.4 6.9-1.8 3.7-2.8 7.7-3.1 11.7-.1 1.3-.1 2.7 0 4 0 .6.1 1.3.2 1.9.8 6.9 3.9 13.6 9.2 18.9 12.5 12.5 32.8 12.5 45.3 0 2.1-2.1 3.8-4.3 5.2-6.7 18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2 12.5-12.5 12.5-32.8 0-45.3-4.3-4.3-9.5-7.1-15-8.5-1.9-.5-3.8-.8-5.8-.9-5.4-.3-10.8.7-15.7 3.1-1-5.2-3.3-10.1-6.9-14.4-.6-.7-1.2-1.4-1.8-2-3.6-3.6-7.9-6.2-12.5-7.7-11.1-3.7-23.9-1.1-32.8 7.7-4.4 4.4-7.2 9.7-8.5 15.3l-69.1-46.8c-2.7-1.9-6.4-1.5-8.7.8-2.3 2.3-2.7 5.9-.9 8.7l46 70c-5.6 1.3-10.9 4.2-15.3 8.5-8.8 8.8-11.4 21.3-7.9 32.4zm-203.5 41.9c.4-1.8.7-3.6.8-5.4.3-5.4-.7-10.8-3.1-15.7 5.2-1 10.1-3.3 14.4-6.9.7-.6 1.4-1.2 2-1.8 3.7-3.7 6.3-8.2 7.9-12.9 3.5-11 .9-23.6-7.9-32.4-4.4-4.4-9.7-7.2-15.3-8.5l47.6-69.1c1.9-2.7 1.5-6.4-.8-8.8-2.3-2.3-5.9-2.7-8.6-.9l-70.9 46.1c-1.3-5.6-4.2-10.9-8.5-15.3-8.6-8.6-20.8-11.3-31.6-8.1-5 1.5-9.7 4.2-13.6 8.1-.7.7-1.3 1.3-1.9 2-3.6 4.3-5.9 9.2-6.9 14.4-4.9-2.4-10.3-3.4-15.7-3.1-1.5.1-3.1.3-4.6.6-5.9 1.2-11.6 4.1-16.2 8.7C-3 389-3 409.3 9.5 421.8c2.1 2.1 4.3 3.8 6.7 5.2-14.5 18.6-13.2 45.7 4.1 62.9s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7 12.5 12.5 32.8 12.5 45.3 0 4.4-4.4 7.2-9.8 8.5-15.4zM112 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm95.2-101.1c-2.8-8.4-11.9-12.9-20.2-10.1-41.3 13.8-74.2 39.9-86.3 51.9-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c9.3-9.3 38.2-32.3 73.7-44.1 8.4-2.8 12.9-11.9 10.1-20.2zm-286.4 0c-2.8 8.4 1.7 17.4 10.1 20.2 35.5 11.8 64.4 34.8 73.7 44.1 6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-12-12-45-38.1-86.3-51.9-8.4-2.8-17.4 1.7-20.2 10.1z"
        }
    ]
};

const FarFaceParty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceParty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 464c59 0 112.2-24.6 150.1-64h61.6C485.6 467.6 408 512 320 512 178.6 512 64 397.4 64 256S178.6 0 320 0c113.4 0 209.7 73.8 243.3 176H560c-15.9 0-30.7 4.6-43.2 12.6C488.9 106.8 411.3 48 320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208zM204.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zm160 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zM416 316c0 6.9-3.1 13.2-7.3 18.3-.5.6-1 1.1-1.5 1.7H592c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H407.2c.5.6 1 1.1 1.5 1.7 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3zM51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8c-35.5 30.7-63.5 69.9-80.7 114.4zm3.8-140C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9s10.8-6 16.7-4.1l34 11.4z"
        }
    ]
};

const FarFacePensive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFacePensive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm208 112h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24s10.7-24 24-24zm143.6-84c10.6 0 19.9-3.8 25.4-9.7 7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2.9 28.3C391.7 317.2 371 324 351.6 324s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7.9-28.3s20.7-7.1 28.3.9c5.5 5.8 14.8 9.7 25.4 9.7zm-217.4-9.7c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2.9 28.3C199.7 317.2 179 324 159.6 324s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7.9-28.3s20.7-7.1 28.3.9zm-52.5-59.1c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4c-7.9 4-17.5.7-21.5-7.2zm341.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L386 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z"
        }
    ]
};

const FarFacePersevering = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFacePersevering",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm294.5 152.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9c14.3-15.4 39-31.7 73.6-31.7s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zm-83.2-307.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zm-167.2 87.4 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 221.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
        }
    ]
};

const FarFacePleading = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFacePleading",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm266.5 156.4c-2-2.1-5.3-4.4-10.5-4.4s-8.5 2.3-10.5 4.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9c8.9-9.5 24.2-19.6 45.5-19.6s36.7 10.1 45.5 19.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 32c-44.2 0-80-35.8-80-80 0-18 6-34.6 16-48-8 0-14.9-5.9-15.9-14-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8 40.4 4 72 38.1 72 79.6 0 44.2-35.8 80-80 80zm240-80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm32 0c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9-1 8.1-7.9 14-15.9 14 10 13.4 16 30 16 48zm-304 0c17.7 0 32-14.3 32-32 17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32c17.7 0 32-14.3 32-32z"
        }
    ]
};

const FarFacePouting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFacePouting",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-94.7-129.9c-5.4 12.3 8.7 21.6 21.1 16.4 22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2S387.3 174 379 176.8l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FarFaceRaisedEyebrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceRaisedEyebrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm256 208a256 256 0 1 1-512 0 256 256 0 1 1 512 0zm-367.6-16a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 352c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zm168.8-210.2-29.5 29.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l29.5-29.5c25-25 66.6-20.9 86.2 8.5l4.9 7.4c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-4.9-7.4c-8.4-12.6-26.2-14.4-36.9-3.7zM128 144h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarFaceRelieved = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceRelieved",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm193 87c11.8 11.8 32.7 25 63 25s51.2-13.1 63-25c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-19.1 19.1-51.6 39-97 39s-77.9-19.9-97-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm158.7-91c10.6 0 19.9-3.8 25.4-9.7 7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2.9 28.3C391.7 285.2 371 292 351.6 292s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7.9-28.3s20.7-7.1 28.3.9c5.5 5.8 14.8 9.7 25.4 9.7zm-217.4-9.7c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2.9 28.3C199.7 285.2 179 292 159.6 292s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7.9-28.3s20.7-7.1 28.3.9zm73-135.4c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4S94 174.4 98.9 167l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zm107.8 20.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-7.8-11.5c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z"
        }
    ]
};

const FarFaceRollingEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceRollingEyes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-88-136c0 13.3 10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48 0-14.3 6.3-27.2 16.2-36-.2 1.3-.2 2.6-.2 4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4 10 8.8 16.2 21.7 16.2 36 0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48 0-14.3 6.3-27.2 16.2-36-.2 1.3-.2 2.6-.2 4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4 10 8.8 16.2 21.7 16.2 36 0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
        }
    ]
};

const FarFaceSadCry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSadCry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 406.1V288c0-13.3-10.7-24-24-24s-24 10.7-24 24v152.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4V288c0-13.3-10.7-24-24-24s-24 10.7-24 24v118.1C72.6 368.2 48 315 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96.4-292c10.6 0 19.9 3.8 25.4 9.7 7.6 8.1 20.2 8.5 28.3.9s8.5-20.2.9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7.9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3.9s8.5-20.2.9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7.9 28.3s20.7 7.1 28.3-.9zM208 320v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
        }
    ]
};

const FarFaceSadSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSadSweat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 256c0 114.9-93.1 208-208 208-65.4 0-123.8-30.2-162-77.5-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256v3.3c16.3-7.1 36.4-2.8 48 12.8l.7.9c-.5-5.6-.7-11.3-.7-17 0-114.9 93.1-208 208-208s208 93.1 208 208zM35.7 299.4C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47 12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0-1.7 2.3-3.8 5-5.9 8.1zm324.7 110.1c9.7-9 10.2-24.2 1.2-33.9-14.3-15.3-39-31.6-73.6-31.6s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zm7.2-105.5a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-192-32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm51.7-100.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5.4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zm121.4-22.6c-6.2 6.2-6.2 16.4 0 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5.4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FarFaceSadTear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSadTear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm128 113c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0-13 17.3-41.6 57.7-41.6 77.7zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6 9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9c-29.7-26.6-69-42.8-112-42.8zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarFaceSaluting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSaluting",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M266.6 14c-9.9-14.6-29.8-18.4-44.4-8.5l-187.1 127c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c28.1 22.9 68.2 24 97.5 2.7l82.3-59.9c14.3-10.4 17.5-30.4 7.1-44.7s-30.4-17.5-44.7-7.1l-3.3 2.4-9.9 7.2-14.2 10.4-17.8 12.9v-39l130.1-88.3c14.6-9.9 18.4-29.8 8.5-44.4zm31.8-8.4c7.2 15.7 7.4 33.4 1.6 48.9 16.6-4.3 34-6.5 52-6.5 114.9 0 208 93.1 208 208s-93.1 208-208 208c-103 0-188.6-74.9-205.1-173.2-13.8 9.9-29.2 16.3-45.2 19.2C126.5 425.5 229.2 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0c-18.4 0-36.3 1.9-53.5 5.6zM256 180.5c-.4 13.7-5.1 27.1-13.8 38.2 4.4 12.4 16.2 21.4 30.2 21.4 17.7 0 32-14.3 32-32s-14.3-32-32-32c-6 0-11.6 1.6-16.3 4.5zm13.4 152.6c-11-7.4-25.9-4.6-33.3 6.4s-4.6 25.9 6.4 33.3C265 388.1 301.7 403 352 403s87-14.9 109.5-30.2c11-7.4 13.8-22.4 6.4-33.3s-22.4-13.8-33.3-6.4c-14.7 9.9-42 21.9-82.6 21.9s-67.9-12-82.5-21.9zm163-93.1a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarFaceScream = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceScream",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 256c0 15.2-1.6 30-4.7 44.3 14.9-9.7 33-13.9 50.7-11.7 1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256c0 11 .7 21.9 2.1 32.6 17.7-2.2 35.7 2 50.7 11.7-3.2-14.3-4.8-29.1-4.8-44.3 0-114.9 93.1-208 208-208s208 93.1 208 208zM320 464c-41.6 0-80.4-12.2-112.9-33.3 6.9 20.3 11.7 41.1 14.8 61.8 30.2 12.6 63.3 19.5 98.1 19.5s68-6.9 98.2-19.5c3.1-20.7 7.9-41.5 14.8-61.8-32.5 21.1-71.3 33.3-113 33.3zm216.7-133.9C482.8 375 455 443.6 448 512h109.8c-.4-50.5 16.7-85.7 43.2-125.7 13.1-19.8 7.6-46.3-12.4-59.3-16.4-10.6-37.6-8.8-51.8 3.1zm-353.4-47.4c27.3 14.9 67.6-2.9 90.1-39.8s18.6-78.8-8.7-93.7-67.6 2.9-90.1 39.8-18.6 78.8 8.7 93.7zM320 304c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm46.6-61c22.5 36.9 62.8 54.7 90.1 39.8s31.1-56.9 8.7-93.7-62.8-54.7-90.1-39.8-31.1 56.9-8.7 93.7zm-263.2 87.1C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3 26.4 40 43.6 75.3 43.2 125.7H192c-7-68.4-34.8-137-88.7-181.9z"
        }
    ]
};

const FarFaceShush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceShush",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0 73.6 38.3 138.3 96 175.3V456c0 11.8 2.3 23.1 6.5 33.3C61.8 449.1 0 359.8 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256c0 82.2-38.8 155.4-99 202.3 6.4-18.5 2.7-39.4-10.4-54.7C440.5 365.9 464 313.7 464 256c0-114.9-93.1-208-208-208S48 141.1 48 256zm299.3-4.7c-8.7 8.7-20.5 17.7-35.3 24.6V248c0-2.8-.2-5.6-.6-8.4 5.2-3.5 9.6-7.3 13.3-10.9 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM200 248v27.9c-14.8-6.9-26.6-15.9-35.3-24.6-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c3.7 3.7 8.1 7.4 13.3 10.9-.4 2.7-.6 5.5-.6 8.4zm-23.6-136a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM280 248v72h-48v-72c0-13.3 10.7-24 24-24s24 10.7 24 24zm-56 160v11.5l63.6 44.5h10c7.1 0 13.9-3.2 18.4-8.6l25.6-30.7c8.5-10.2 23.6-11.6 33.8-3.1s11.6 23.6 3.1 33.8l-25.6 30.7C339.2 502.5 319 512 297.6 512H232c-30.9 0-56-25.1-56-56v-48c0-30.9 25.1-56 56-56h32c30.9 0 56 25.1 56 56v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8z"
        }
    ]
};

const FarFaceSleeping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSleeping",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-114.9 93.1-208 208-208 30.7 0 59.9 6.7 86.1 18.6 12.1 5.5 26.3.2 31.8-11.9s.2-26.3-11.9-31.8C329.6 8.2 293.7 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-37.7-8.2-73.6-22.9-105.9-5.5-12.1-19.7-17.4-31.8-11.9s-17.4 19.7-11.9 31.8c11.9 26.1 18.6 55.3 18.6 86 0 114.9-93.1 208-208 208S48 370.9 48 256zm208 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm64-296h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-25.4l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S390.5 96 384 96h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16zm96-112c0 8.8 7.2 16 16 16h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4S425.5 96 432 96h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-25.4l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0h-64c-8.8 0-16 7.2-16 16zm-64.4 236c-10.6 0-19.9-3.8-25.4-9.7-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3.9c-5.5 5.8-14.8 9.7-25.4 9.7zm-217.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3.9c-5.5 5.8-14.8 9.7-25.4 9.7s-19.9-3.8-25.4-9.7z"
        }
    ]
};

const FarFaceSleepy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSleepy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c47 0 90.4-15.6 125.2-41.9 2.7 14.8 2.8 29.6 2.8 41.9 0 4.5.4 8.9 1.1 13.1-37.9 22.2-82 34.9-129.1 34.9C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 37-7.8 72.1-22 103.9-7.4-6.2-15.1-11.8-22.7-16.7-5.8-3.8-11.8-7.3-17.9-10.6C458.8 308.9 464 283 464 256c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208zm-80-74.5c15.1-24.7 45.3-41.5 80-41.5s64.9 16.8 80.1 41.5c6.8 11.1-6 20.7-18.3 16.4-18.9-6.5-39.8-10.1-61.8-10.1s-42.9 3.6-61.8 10.1c-12.3 4.2-25.1-5.3-18.3-16.4zm150.2-139.2c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2.9 28.3C391.7 293.2 371 300 351.6 300s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7.9-28.3s20.7-7.1 28.3.9zM159.6 260c10.6 0 19.9-3.8 25.4-9.7 7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2.9 28.3C199.7 293.2 179 300 159.6 300s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7.9-28.3s20.7-7.1 28.3.9c5.5 5.8 14.8 9.7 25.4 9.7zM512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-32 0-102.4-64-128 48 0 160 48 160 128z"
        }
    ]
};

const FarFaceSmileBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmileBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm177.6 62.1c15.2 16.4 41.2 33.9 78.4 33.9s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FarFaceSmileHalo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmileHalo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c0-44.2-114.6-80-256-80S0 35.8 0 80s114.6 80 256 80 256-35.8 256-80zm-64 0c0 17.7-86 32-192 32S64 97.7 64 80s86-32 192-32 192 14.3 192 32zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5-14 5.8-29.6 11.1-46.4 15.6 17.8 29.1 28 63.3 28 99.9 0 106-86 192-192 192S64 378 64 272c0-36.6 10.2-70.8 28-99.9-16.9-4.6-32.4-9.8-46.4-15.6zm172 128.3c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm-73.9 47.9c-9.7 9-10.4 24.2-1.4 33.9 22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4c-15 16.4-41 33.9-78.2 33.9s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zm233.9-47.9c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2z"
        }
    ]
};

const FarFaceSmileHearts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmileHearts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M553.5 361.1C568 329 576 293.4 576 256c0-24.5-3.4-48.2-9.9-70.6-3.6-12.7-16.9-20.1-29.7-16.5s-20.1 16.9-16.5 29.7c5.2 18.2 8 37.4 8 57.4 0 35.3-8.8 68.5-24.3 97.6 16.7-3.7 34.5-1.2 49.8 7.4zm-105.4 58.8C412.8 447.5 368.3 464 320 464c-50.4 0-96.6-17.9-132.6-47.7-3.4 9.1-8.8 17.7-16.1 25l-13.1 13.1c44.2 36 100.5 57.6 161.8 57.6 53.3 0 102.8-16.3 143.8-44.2-11.2-13.9-16.5-31-15.7-47.9zm-326-99.8c-6.6-20.2-10.1-41.7-10.1-64.1 0-114.9 93.1-208 208-208 30.7 0 59.9 6.7 86.1 18.6 12.1 5.5 26.3.2 31.8-11.9s.2-26.3-11.9-31.8C393.6 8.2 357.7 0 320 0 178.6 0 64 114.6 64 256c0 25.7 3.8 50.5 10.8 73.8 1.8 1.1 3.5 2.2 5.2 3.4 12.5-9 27.3-13.4 42-13.2zm85.7-3.3c-9.7 9-10.4 24.2-1.4 33.9 22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C383.2 334.5 357.2 352 320 352s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zm6.5-87.1c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3.9s8.5-20.2.9-28.3C279.7 186.8 259 180 239.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7.9 28.3s20.7 7.1 28.3-.9zm185.3-9.7c10.6 0 19.9 3.8 25.4 9.7 7.6 8.1 20.2 8.5 28.3.9s8.5-20.2.9-28.3C439.7 186.8 419 180 399.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7.9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM573.7 11.5 560 25.3l-13.7-13.9c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0zm54.9 384c-15.2-15.3-39.8-15.3-54.9 0L560 409.3l-13.7-13.8c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2zm-534.9-32L80 377.3l-13.7-13.9c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0z"
        }
    ]
};

const FarFaceSmileHorns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmileHorns",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464c141.4 0 256-114.6 256-256 0-24.6-3.5-48.4-9.9-70.9 44.3-59.4 67.4-135 73.6-166 1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5-29.8-8.9-59-20.3-78.3-33.1-5.4-3.6-12.4-3.6-17.8 0S-1 12.8.3 19.1c6.2 31 29.3 106.6 73.6 166-6.4 22.5-9.9 46.3-9.9 70.9 0 141.4 114.6 256 256 256zM207.7 332.7c-9.7 9-10.4 24.2-1.4 33.9 22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4c-15 16.4-41 33.9-78.2 33.9s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zm32.7-44.7c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2S451.3 190 443 192.8l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FarFaceSmilePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmilePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 0c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V24c0-13.3 10.7-24 24-24zM400 288a176 176 0 1 0-352 0 176 176 0 1 0 352 0zM0 288a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm144.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM146 332.8c19.1 21.6 46.9 35.2 78 35.2s58.9-13.6 78-35.2c8.8-9.9 23.9-10.9 33.9-2.1s10.9 23.9 2.1 33.9c-27.8 31.5-68.6 51.4-114 51.4s-86.2-19.9-114-51.5c-8.8-9.9-7.8-25.1 2.1-33.9s25.1-7.8 33.9 2.1z"
        }
    ]
};

const FarFaceSmileRelaxed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmileRelaxed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm177.6 62.1c15.2 16.4 41.2 33.9 78.4 33.9s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm-2-98.1c-10.6 0-19.9 3.8-25.4 9.7-7.6 8.1-20.2 8.5-28.3.9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7zm134.6 9.7c-7.6 8.1-20.2 8.5-28.3.9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
        }
    ]
};

const FarFaceSmileTear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmileTear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M338.7 446.9c4.3.7 8.8 1.1 13.3 1.1 43.4 0 80-34.6 80-79v-2c20.3-32.1 32-70.2 32-111 0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c29.4 0 57.4-6.1 82.7-17.1zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm136.3 61.9c10-8.7 25.2-7.6 33.9 2.4C187 339.8 215.5 360 256 360c13.3 0 24 10.7 24 24s-10.7 24-24 24c-58 0-98.8-29.4-122.1-56.3-8.7-10-7.6-25.2 2.4-33.9zM352 416c-26.5 0-48-21-48-47 0-20 28.4-60.4 41.6-77.7 3.2-4.4 9.6-4.4 12.8 0 13 17.3 41.6 57.7 41.6 77.7 0 26-21.5 47-48 47zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceSmileTongue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmileTongue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M419.5 453c-44.3 36.9-101.3 59-163.5 59C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 27.2-4.2 53.4-12.1 77.9 9.1 23.9 7.8 51.5-6 75.4-16 27.6-44.7 43.2-74.4 43.6zm-56.2-18.8-44.2-27.4c-19.5 8-40.8 12.4-63.1 12.4-70.4 0-130.1-43.8-157.5-105.5-5.4-12.1.1-26.3 12.2-31.7s26.3.1 31.7 12.2c20.4 46.1 64.1 76.9 113.6 76.9 56.5 0 105.6-40.3 120.8-97.4 1.9-7.3 7.2-13.2 14.2-16.1s14.9-2.2 21.4 1.7l49 29.5c1.7-10.7 2.6-21.7 2.6-33 0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c39.3 0 76-10.9 107.3-29.8zM217.6 228.8l-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm180.9 170.8c18.8 11 42.9 4.7 53.8-14.2 11-19.1 4.5-43.6-14.6-54.6l-.4-.2-24.7-14.9c-11.2 24.5-27.5 46.1-47.6 63.2l33.5 20.8zm-20.9-170.8-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FarFaceSmileUpsideDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmileUpsideDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm464 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zm-334.4-62.1c15.2-16.4 41.2-33.9 78.4-33.9s63.2 17.5 78.4 33.9c9 9.7 24.2 10.4 33.9 1.4s10.4-24.2 1.4-33.9c-22-23.8-60-49.4-113.6-49.4s-91.7 25.5-113.6 49.4c-9 9.7-8.4 24.9 1.4 33.9s24.9 8.4 33.9-1.4zM208.4 304a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
        }
    ]
};

const FarFaceSmileWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmileWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm177.6 62.1c15.2 16.4 41.2 33.9 78.4 33.9s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3.9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
        }
    ]
};

const FarFaceSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmile",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm177.6 62.1c15.2 16.4 41.2 33.9 78.4 33.9s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFaceSmilingHands = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmilingHands",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 352c-27.4 0-48.6-9.4-64-20.9v55.4c18 8.1 39.4 13.5 64 13.5s46-5.4 64-13.5v-55.4c-15.4 11.5-36.6 20.9-64 20.9zm-208-99.7C114 139.1 206.4 48 320 48s206 91.1 208 204.3c13.3-11.9 31.7-15.2 47.7-9.6C568.7 107.5 456.9 0 320 0S71.3 107.5 64.3 242.6c16-5.5 34.4-2.3 47.7 9.6zm139 200c-4.6 15.8-12.2 30.4-22.1 43 28.3 10.8 59 16.7 91.1 16.7s62.8-5.9 91.1-16.7c-9.9-12.6-17.5-27.2-22.1-43-21.6 7.6-44.8 11.7-69 11.7s-47.4-4.1-69-11.7zm30.6-223.5c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm160 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm129.7 70.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7v-19.6c0-11-9-20-20-20s-20 9-20 20v86.4c0 52.6 42.6 95.2 95.2 95.2 25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3zM68.7 276.7c-6.2 6.2-6.2 16.4 0 22.6l51.3 51.3c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0l-67.3-67.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0l-51.3-51.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0l-19.3-19.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2v-86.4c0-11-9-20-20-20s-20 9-20 20v19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FarFaceSmirking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSmirking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm382.3 88.9-1.9 4.8c-12.2 30.4-41.6 50.3-74.3 50.3H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h122.1c13.1 0 24.9-8 29.7-20.1l1.9-4.8c4.9-12.3 18.9-18.3 31.2-13.4s18.3 18.9 13.4 31.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FarFaceSpiralEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSpiralEyes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-114.9-93.1-208-208-208-71 0-133.6 35.5-171.1 89.8 18.5-21.6 45.8-36.5 76.6-37.7 6.6-.3 12.2 4.9 12.5 11.5s-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3v.6c2 40.2 40.8 70.7 76.2 66.7h.6c36.3-2 62.1-35.7 58.4-64.5v-.6c-2.1-29.8-31.3-51-56-47.5h-.6c-25.7 2.2-42 26.2-38.9 44.5l.1.4v.4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1h.3c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2-.9-.5-1.8-.9-2.6-1.2 1.7 1.9 2.8 4.2 3 6.9 1 11.1-8.8 15.8-14.1 16.4-6.6.8-13.4-2.2-17.6-8.5-5-6.8-4.4-15.6-1.8-21.8 2.9-7 8.9-13.2 17.8-16 9.2-3.3 19.4-1.3 27.5 3.3 8.3 4.9 15.5 13.4 17.9 24.8 5.8 22.8-11.9 49.5-39.5 53.6-27.7 5.3-59.8-16.2-63.6-49.2-5.4-33 21.9-68.7 60.3-72.1 38.2-5.2 79.6 25.8 82.9 69.3 5.4 43.3-31.5 88.2-80.6 91.2-48.8 5.3-99.6-35.2-102.5-89.1-1.2-11.3 0-22.5 3-33.3C53.5 201.5 48 228.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm338.1 48.5c-.3-6.6 4.9-12.2 11.5-12.5 46.9-1.9 82.2-45 78.1-84.3v-.6c-2-40.2-40.8-70.7-76.2-66.7h-.6c-36.3 2-62.1 35.7-58.4 64.5v.6c2.1 29.8 31.3 51 56 47.5h.6c25.7-2.2 42-26.2 38.9-44.5l-.1-.4v-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3.1h-.3c-15.2 2.1-21.9 16.3-19.9 24l.1.4.1.4c.9 4.3 3.4 7.4 6.5 9.2.9.5 1.8.9 2.6 1.2-1.7-1.9-2.8-4.2-3-6.9-1-11.1 8.8-15.8 14.1-16.4 6.6-.8 13.4 2.2 17.6 8.5 5 6.8 4.4 15.6 1.8 21.8-2.9 7-8.9 13.2-17.8 16-9.2 3.3-19.4 1.3-27.5-3.3-8.3-4.9-15.5-13.4-17.9-24.8-5.8-22.8 11.9-49.5 39.5-53.6 27.7-5.3 59.8 16.2 63.6 49.2 5.4 33-21.9 68.7-60.3 72.1-38.2 5.2-79.6-25.8-82.9-69.3-5.4-43.3 31.5-88.2 80.6-91.2 48.8-5.3 99.6 35.2 102.5 89.1 5.5 53.8-41.1 108.1-101 110.5-6.6.3-12.2-4.9-12.5-11.5zm-35.9 46.6 6.7-4.5c22.2-14.8 51.8-11.9 70.7 7l5.4 5.4c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-5.4-5.4c-2.7-2.7-6.9-3.1-10.1-1l-6.7 4.5c-20.3 13.5-47 12.4-66-2.9l-1.7-1.4c-2.9-2.3-7.1-2.3-10 0l-1.7 1.4c-19 15.2-45.8 16.4-66 2.9l-6.7-4.5c-3.2-2.1-7.4-1.7-10.1 1L161 393c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l5.4-5.4c18.9-18.9 48.5-21.8 70.7-7l6.7 4.5c2.9 1.9 6.7 1.8 9.4-.4l1.7-1.4c20.5-16.4 49.5-16.4 70 0l1.7 1.4c2.7 2.2 6.5 2.3 9.4.4z"
        }
    ]
};

const FarFaceSunglasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSunglasses",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c-114.9 0-208-93.1-208-208 0-16.3 1.9-32.2 5.4-47.4l3.9 23.3C61.2 255 81.2 272 104.7 272h78.7c23.5 0 43.5-17 47.3-40.1l6.6-39.9h37.3l6.6 39.9c3.9 23.1 23.9 40.1 47.3 40.1h78.7c23.5 0 43.5-17 47.3-40.1l3.9-23.3c3.6 15.2 5.4 31.1 5.4 47.4 0 114.9-93.1 208-208 208zm-28.9-320c-8.7-9.8-21.4-16-35.8-16H96.7c-1.6 0-3.2.1-4.8.2C129.9 79.4 189.3 48 256 48s126.1 31.4 164.1 80.2c-1.6-.2-3.2-.2-4.8-.2h-94.6c-14.4 0-27.1 6.2-35.8 16h-57.8zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM143.7 332.7c-9.7 9-10.4 24.2-1.4 33.9 22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4c-15 16.4-41 33.9-78.2 33.9s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4z"
        }
    ]
};

const FarFaceSurprise = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSurprise",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarFaceSwear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceSwear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48c114.9 0 208 93.1 208 208h48C576 114.6 461.4 0 320 0S64 114.6 64 256h48c0-114.9 93.1-208 208-208zm-79.6 176c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2S451.3 126 443 128.8l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32zM48 288c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zm352 96h-16v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-32h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0v32h32v-32h-32zm250.4-52.1c6.7 5.8 7.5 15.8 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 352a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm-24 136a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-56-120v1.8c4.6.8 8.7 1.7 12.1 2.6 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9-4.1.5-6.3 1.4-7.4 2.2-.6.4-1.2.9-1.5 2.9-.2 1-.1 1.6-.1 1.8.1.1.5.6 1.5 1.3 3.7 2.5 9.6 4.4 19.2 7.3l.7.2c8 2.4 19.1 5.8 27.6 11.9 4.7 3.4 9.3 8.2 12.1 14.7 2.9 6.6 3.4 13.8 2.2 21.1-2 11.5-7.9 20.5-17 25.9-4.9 3-10.1 4.6-15.3 5.4v.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c-8.1-1.9-15.3-4.2-20.2-5.9-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1 5 .1 7.6-.8 8.8-1.5.5-.3 1.4-.9 2-4 .2-1.2.2-1.9.2-2.3 0-.4-.1-.6-.1-.6 0-.1-.3-.6-1.6-1.6-3.5-2.5-9.3-4.6-18.7-7.4l-1.5-.4c-7.7-2.3-18.3-5.5-26.4-11-4.7-3.2-9.4-7.7-12.4-14.1-3.1-6.5-3.7-13.7-2.5-20.9 1.8-10.2 7-18.1 14.5-23.5 5.3-3.8 11.2-5.9 16.9-7V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm-31.9 39.4a.1.1 0 1 0 .1-.1.1.1 0 1 0-.1.1z"
        }
    ]
};

const FarFaceThermometer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceThermometer",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48C173.1 48 80 141.1 80 256s93.1 208 208 208c65.9 0 124.7-30.7 162.8-78.5 1.5-1.3 3-2.6 4.4-4l84.8-80.4C518.8 421 414 512 288 512 146.6 512 32 397.4 32 256S146.6 0 288 0c97 0 181.4 54 224.8 133.5-16.5-.3-33.1 4.4-47.3 14.1C429 87.8 363.1 48 288 48zm258.8 132.1c19.8 19.8 19.4 52.1-.9 71.4L415.1 376.1c-1.2 4.2-3.4 8.1-6.8 11.2-9.7 9-24.9 8.4-33.9-1.4-15.2-16.4-41.2-33.9-78.4-33.9s-63.2 17.5-78.4 33.9c-9 9.7-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9c22-23.8 60-49.4 113.6-49.4 16.2 0 31.1 2.3 44.4 6.3L477 179.4c19.6-18.8 50.6-18.4 69.8.7zM401.3 345l28-26.7-5.8-5.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l6.3 6.3 15.4-14.7-6.6-6.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7 7 15.4-14.7-7.4-7.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7.8 7.8 11.5-11c7.3-6.9 7.4-18.5.3-25.6-6.9-6.9-18-7-25-.3L372.5 323.9c11.2 6.3 20.8 13.7 28.9 21.1zm-193-169a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarFaceThinking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceThinking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c114.9 0 208-93.1 208-208S370.9 48 256 48 48 141.1 48 256c0 17.7 2.2 34.8 6.4 51.2C40.8 317.4 32 333.7 32 352v28C11.6 343.3 0 301 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9 4-5.7 7.3-12 9.8-18.8l10.1-27.7c3.8.2 7.7.3 11.6.3zm43-158.9c-9.9-2-20.5-1.3-30.7 2.5L237.9 319l-65.5-15.4c-8.6-2-13.9-10.6-11.9-19.2s10.6-13.9 19.2-11.9l97.1 22.8c8.2 1.9 15.7 5.3 22.3 9.8zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-120-31.2c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l7.1-4c35.2-20.1 79.3-15.9 110.1 10.5l13.2 11.3c6.7 5.8 7.5 15.9 1.7 22.6s-15.9 7.5-22.6 1.7l-13.2-11.3zM112 352v48.4l167.6-62.8c12.4-4.7 26.2 1.6 30.9 14s-1.6 26.2-14 30.9L230.9 407c-.1.4-.3.8-.4 1.2l-26.3 72.2c-6.9 19-24.9 31.6-45.1 31.6H112c-26.5 0-48-21.5-48-48V352c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarFaceTired = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceTired",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176.5 64.3c19.6-18.2 47.3-32.3 79.5-32.3s59.9 14.1 79.5 32.3c19 17.8 32.5 41.7 32.5 63.7 0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
        }
    ]
};

const FarFaceTissue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceTissue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c114.9 0 208-93.1 208-208S370.9 48 256 48 48 141.1 48 256c0 8.7.5 17.3 1.6 25.7l-41.5 7c-2 .3-4 .8-5.9 1.4C.8 278.9 0 267.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256-114.6 256-256 256c-11.5 0-22.9-.8-34-2.2.6-1.9 1-3.9 1.4-5.9l6.9-41.5c8.4 1 17 1.6 25.7 1.6zm-13.3-76 9-54.1 4.3 3.4 25-20c8.2-6.5 19.6-7 28.3-1.2l31.6 21.1L351 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-24 24c-8.1 8.1-20.8 9.3-30.3 3l-33.4-22.3-26.3 21c-8.2 6.6-19.7 7-28.3 1.2zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5 0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zm-159.2 162c3.7 3.7 5.3 8.8 4.5 13.9l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5-84.2 21.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3.8 13.9 4.5z"
        }
    ]
};

const FarFaceTongueMoney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceTongueMoney",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M348.3 442.4c2.2-7.7 3.5-15.9 3.7-24.3 30.5-21.1 53.2-52.1 63.3-88.1 3.8-13.7-7.4-26.1-21.6-26.1H118.4c-14.2 0-25.5 12.4-21.6 26.1 10.1 36 32.8 66.9 63.3 88.1.2 8.4 1.5 16.5 3.7 24.3C95.1 408.4 48 337.7 48 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zm-44.4 16C292.2 471.7 275.1 480 256 480s-36.2-8.3-47.9-21.5c-5.5-6.2-9.8-13.5-12.6-21.6-2.3-6.5-3.5-13.6-3.5-20.9v-80h128v80c0 7.3-1.2 14.4-3.5 20.9-2.8 8-7.1 15.3-12.6 21.6zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-392c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1-7.5 5.4-12.6 13.5-14.4 23.6-1.3 7.3-.7 14.5 2.2 21.2 2.9 6.6 7.6 11.3 12.4 14.6 8.4 5.8 19.3 9 27.2 11.2l1.1.3c9.6 2.7 15.4 4.6 18.8 7 2.6 1.8 2.2 6.4-.6 8-1.2.7-3.8 1.6-8.8 1.5-10.1-.2-22.5-3.9-32-7.1-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6v11c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2 9.1-5.5 15-14.4 17-25.9 1.3-7.3.7-14.5-2.2-21.2-2.9-6.6-7.6-11.3-12.4-14.6-7.1-5-15.5-7.2-23.9-9.4-8.2-2.2-16.4-4.3-23.3-9.1-2.4-1.7-2.4-5.3.2-7.2 1-.7 3.1-1.7 7.1-2.1 8.2-.9 18.7 1 27 3.2 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7v-10zm144-16c-8.8 0-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1-7.5 5.4-12.6 13.5-14.4 23.6-1.3 7.3-.7 14.5 2.2 21.2 2.9 6.6 7.6 11.3 12.4 14.6 8.4 5.8 19.4 9 27.2 11.2l1.1.3c9.5 2.7 15.4 4.6 18.8 7 2.6 1.8 2.2 6.4-.6 8-1.2.7-3.8 1.6-8.8 1.5-10.1-.2-22.5-3.9-32-7.1-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6v11c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2 9.1-5.5 15-14.4 17-25.9 1.3-7.3.7-14.5-2.2-21.2-2.9-6.6-7.6-11.3-12.4-14.6-7.1-5-15.5-7.2-23.9-9.4-8.2-2.2-16.4-4.3-23.3-9.1-2.4-1.7-2.4-5.3.2-7.2 1-.7 3.1-1.7 7.1-2.1 8.2-.9 18.7 1 27 3.2 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7v-10c0-8.8-7.2-16-16-16zm-68.8 251.6c0-6.4-5.4-11.6-12-11.6s-12 5.2-12 11.6v6.8c-4.3.8-8.7 2.4-12.7 5.2-5.6 4-9.5 9.8-10.8 17.2-.9 5.3-.5 10.6 1.7 15.4 2.2 4.8 5.7 8.2 9.3 10.6 6.3 4.2 14.5 6.5 20.4 8.1l.8.2c7.2 2 11.5 3.3 14.1 5.1 1.9 1.3 1.6 4.6-.4 5.8-.9.5-2.8 1.1-6.6 1.1-7.6-.1-16.9-2.9-24-5.2-6.3-2-13.1 1.3-15.2 7.4s1.3 12.7 7.6 14.7c3.8 1.2 9.5 3 15.8 4.4v7.8c0 6.4 5.4 11.6 12 11.6s12-5.2 12-11.6v-6.5c3.6-.6 7.3-1.8 10.8-3.8 6.8-4 11.2-10.5 12.7-18.9.9-5.3.5-10.6-1.7-15.4-2.2-4.8-5.7-8.2-9.3-10.6-5.4-3.6-11.7-5.2-17.9-6.8-6.2-1.6-12.3-3.2-17.5-6.6-1.8-1.2-1.8-3.9.2-5.2.7-.5 2.3-1.2 5.3-1.5 6.1-.6 14 .7 20.2 2.3 6.4 1.7 13-2 14.7-8.3s-2.1-12.6-8.5-14.2c-2.5-.7-5.7-1.4-9.1-2v-7.2z"
        }
    ]
};

const FarFaceTongueSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceTongueSweat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 256c0 81.7-47.1 152.4-115.7 186.4 2.4-8.4 3.7-17.3 3.7-26.4v-15.3c10.2-7.2 16-15.7 16-24.7 0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7V416c0 9.2 1.3 18 3.7 26.4-27.1-13.4-50.8-32.6-69.6-55.9-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256v3.3c16.3-7.1 36.4-2.8 48 12.8l.7.9c-.5-5.6-.7-11.3-.7-17 0-114.9 93.1-208 208-208s208 93.1 208 208zM96 369c0-20-28.4-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47 12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369zm239.6-97a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5.4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6 7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5.4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM352 416c0 35.3-28.7 64-64 64s-64-28.7-64-64v-21.4c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9 2.8 12.6 20.8 12.6 23.6 0 2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"
        }
    ]
};

const FarFaceUnamused = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceUnamused",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm294.5 136.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9c14.3-15.4 39-31.7 73.6-31.7s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FarFaceViewfinder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceViewfinder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56v80c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-4.4 3.6-8 8-8h80c13.3 0 24-10.7 24-24S149.3 0 136 0H56C25.1 0 0 25.1 0 56zm352-32c0 13.3 10.7 24 24 24h80c4.4 0 8 3.6 8 8v80c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-30.9-25.1-56-56-56h-80c-13.3 0-24 10.7-24 24zM24 352c-13.3 0-24 10.7-24 24v80c0 30.9 25.1 56 56 56h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-4.4 0-8-3.6-8-8v-80c0-13.3-10.7-24-24-24zm464 0c-13.3 0-24 10.7-24 24v80c0 4.4-3.6 8-8 8h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c30.9 0 56-25.1 56-56v-80c0-13.3-10.7-24-24-24zM240 216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40-96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm-41.6-136c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c13.8 23.9 39.7 40 69.3 40s55.5-16.1 69.3-40c4.4-7.6 1.8-17.4-5.8-21.9s-17.4-1.8-21.9 5.8c-8.3 14.4-23.8 24-41.6 24s-33.3-9.6-41.6-24z"
        }
    ]
};

const FarFaceVomit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceVomit",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 256c0 63.4-28.3 120.1-73 158.3 5.8 9.5 14.8 17 25.9 20.7l16.7 5.6C513.9 393.9 544 328.5 544 256 544 114.6 429.4 0 288 0S32 114.6 32 256c0 72.5 30.1 137.9 78.5 184.5l16.7-5.6c11.1-3.7 20.1-11.1 25.9-20.7C108.3 376.1 80 319.4 80 256c0-114.9 93.1-208 208-208s208 93.1 208 208zm-348-98.9c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6 0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9c-7.9-4.2-17.5 1.5-17.5 10.5zm262.5-10.5-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5 0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6 0-9-9.6-14.7-17.5-10.5zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm544-64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-192-51.9v-58.3c10.8 4.3 18.7 8.5 23.1 11.5 7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2C406.3 310.3 355.2 288 288 288s-118.3 22.3-136.9 34.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4c4.4-3 12.3-7.2 23.1-11.5v58.3c0 31-19.8 58.5-49.2 68.3l-34.1 11.4c-7.6 2.5-12.7 9.6-12.7 17.6 0 10.3 8.3 18.6 18.6 18.6h346.8c10.3 0 18.6-8.3 18.6-18.6 0-8-5.1-15.1-12.7-17.6l-34.1-11.4c-29.4-9.8-49.2-37.3-49.2-68.3zM304 416a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarFaceWeary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceWeary",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176.5 64.3c19.6-18.2 47.3-32.3 79.5-32.3s59.9 14.1 79.5 32.3c19 17.8 32.5 41.7 32.5 63.7 0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm34.8-155.6c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"
        }
    ]
};

const FarFaceWoozy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceWoozy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm112-304c0-35.3-14.3-64-32-64s-32 28.7-32 64 14.3 64 32 64 32-28.7 32-64zm-154.2 39.3c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-64 16c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l64-16zM200.9 98.7c-7.4-4.9-17.3-2.9-22.2 4.4-23.2 34.8-58.4 53.2-71.7 57.7-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1c18.6-6.2 60.3-28.3 88.3-70.3 4.9-7.4 2.9-17.3-4.4-22.2zm184.9 261.4c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6L319 362.3c-3.3 3.6-7.9 5.7-12.8 5.7-3.5 0-6.9-1.1-9.8-3l-11.7-8.1c-24-16.5-54.7-19.4-81.4-7.7-11.7 5.2-25.3 3.7-35.7-3.9l-9.4-6.9c-10.7-7.8-25.7-5.6-33.6 5.1s-5.6 25.7 5.1 33.6l9.4 6.9c24.2 17.8 56 21.2 83.4 9.1 11.4-5 24.5-3.8 34.8 3.3l11.7 8.1c10.9 7.5 23.8 11.5 37 11.5 18.4 0 36-7.8 48.3-21.4l31.3-34.5z"
        }
    ]
};

const FarFaceWorried = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceWorried",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm182.4 158.5c-12.4 5.2-26.5-4.1-21.1-16.4 16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zm-38-142.5a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z"
        }
    ]
};

const FarFaceZany = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceZany",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M436.1 152C378.7 52.5 251.5 18.4 152 75.9S18.4 260.5 75.9 360c25 43.3 63.2 74.2 106.5 90.6-4.1-10.7-6.4-22.4-6.4-34.6v-7.8c-10.4-6.2-20.1-13.7-28.9-22.2-10.2-9.9-6.6-26.3 5.7-33.4l238.4-137.7c12.3-7.1 28.3-2 31.8 11.8 15.2 59.4-5.9 124.1-55 165V416c0 5.5-.5 10.9-1.4 16.1C461 373 492.3 249.2 436.1 152zM384 477.7c-27.9 16.1-57.5 26.3-87.5 31.1-7.8 2.1-16 3.2-24.5 3.2-1.9 0-3.7-.1-5.6-.2-92 3.7-182.9-42.6-232.1-127.8C-36.4 261.6 5.6 105 128 34.3S407 5.6 477.7 128s28.7 279-93.7 349.7zM296.4 160c-11.1 0-20.4-7.5-23.2-17.7-.8 3.1-1.2 6.4-1.2 9.7 0 22.1 17.9 40 40 40s40-17.9 40-40-17.9-40-40-40c-3 0-6 .3-8.8 1 9.9 2.9 17.2 12.1 17.2 23 0 13.3-10.7 24-24 24zM312 80a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM176 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm48 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm208 192v-37.4c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FarFaceZipper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaceZipper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m389.2 394.3 29.1 58.1c14.7 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5zm91.3 38.2-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0s4.7 12.3 0 17zM256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c42.5 0 82-12.7 114.9-34.6l18.7 37.3c1 2 2 3.9 3.1 5.7C353.2 497.5 306.3 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 34.9-7 68.1-19.6 98.4l-43.1-21.5c9.5-23.8 14.7-49.7 14.7-76.9 0-114.9-93.1-208-208-208zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 320c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-176 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarFalafel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFalafel",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M147.4 120.3c-15.2 18.4-15.2 45.1 0 63.5.3.4.5 1 .3 1.6-2.3 9-1.9 18.2.6 26.6-20.8-9-45-2.4-58.5 15.9-.3.4-.5.4-.7.4-24.3-.7-44.9 16.5-49.4 39.9-.1.6-.5 1-.7 1.1-21.9 10-33.1 34.3-27.3 57.3.2.6 0 1.3-.3 1.6-15.2 18.4-15.2 45.1 0 63.5.3.4.5 1 .3 1.6-5.8 23 5.4 47.3 27.3 57.3.2.1.6.4.7 1.1 4.6 23.4 25.2 40.6 49.4 39.9.1 0 .4 0 .7.4 14.3 19.4 40.5 25.6 61.9 14.3.1-.1.2-.1.3-.1s.2 0 .3.1c21.5 11.3 47.7 5 61.9-14.3.3-.4.5-.4.7-.4 24.3.7 44.9-16.5 49.4-39.9.1-.6.5-1 .7-1.1 10.2-4.7 18.1-12.4 23-21.7 4.9 9.3 12.8 17.1 23 21.7.2.1.6.4.7 1.1 4.6 23.4 25.2 40.6 49.4 39.9.1 0 .4 0 .7.4 14.3 19.4 40.5 25.6 61.9 14.3.1-.1.2-.1.3-.1s.2 0 .3.1c21.5 11.3 47.7 5 61.9-14.3.3-.4.6-.4.7-.4 24.3.7 44.9-16.5 49.4-39.9.1-.6.5-1 .7-1.1 16.4-7.5 26.7-22.9 28.5-39.9-18.6 7.3-39.4 6-56.9 1.2h-.1c-10 7.3-17 18.2-19.4 30.6-.1.5-.3.8-.5.9s-.3.2-.4.2c-16.1-.5-31.2 7.1-40.7 19.9-.1.2-.2.2-.3.3-.1.1-.2.1-.2.1h-.2s-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0-.1 0-.1 0-.1.1h-.4c-.1 0-.2 0-.2-.1-.1 0-.2-.1-.3-.3-9.5-12.8-24.6-20.4-40.7-19.9-.1 0-.2 0-.4-.2s-.4-.5-.5-.9c-3-15.6-13.3-28.9-27.9-35.5-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4.3-31.7-9.9-44-.2-.3-.4-.7-.4-1.1s.2-.9.4-1.1c10.1-12.3 13.8-28.6 9.9-44-.1-.5-.1-.9.1-1.3s.4-.5.6-.6c14.6-6.7 24.8-20 27.9-35.5.1-.5.3-.8.5-.9s.3-.2.4-.2c8.7.2 17.1-1.8 24.5-5.9-.9-11.7.3-23.8 4.6-35.2 7.1-4.1 16-4.4 23.7-.4l.4.2c13.8-12.1 20-31.3 15.4-49.7-.2-.6 0-1.3.3-1.6 15.2-18.4 15.2-45.1 0-63.5-.3-.4-.5-1-.3-1.6 5.8-23-5.4-47.3-27.3-57.3-.2-.1-.6-.4-.7-1.1-4.6-23.4-25.2-40.6-49.4-39.9-.1 0-.4 0-.7-.4C335.9.6 309.7-5.7 288.3 5.6c-.1.1-.2.1-.3.1s-.2 0-.3-.1c-21.5-11.3-47.7-5-61.9 14.3-.3.4-.5.4-.7.4-24.3-.7-44.9 16.5-49.4 39.9-.1.6-.5 1-.7 1.1-21.9 10-33.1 34.3-27.3 57.3.2.6 0 1.3-.3 1.6zm177.1 123.1c-5 3.2-9.4 7.3-13 12.2-.1.2-.2.2-.3.3s-.2.1-.2.1h-.2s-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0-.1.1-.2.1-.2.1h-.2c-.1 0-.2 0-.2-.1s-.2-.1-.3-.3c-3.6-4.9-8-9-13-12.2-7.8-8.2-18.4-13.6-30.2-14.9-4.2-12.9-13.7-23.7-26.3-29.5-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4.3-31.7-9.9-44-.2-.3-.4-.7-.4-1.1s.2-.9.4-1.1c10.1-12.3 13.8-28.6 9.9-44-.1-.5-.1-.9.1-1.3s.4-.5.6-.6c14.6-6.7 24.8-20 27.9-35.5.1-.5.3-.8.5-.9s.3-.2.4-.2c16.1.5 31.2-7.1 40.7-19.9.1-.2.2-.2.3-.3s.2-.1.2-.1h.2s.1 0 .2.1c14.2 7.5 31.1 7.5 45.3 0 .1-.1.2-.1.2-.1h.4s.1 0 .1.1c.1 0 .2.1.3.3 9.5 12.8 24.6 20.4 40.7 19.9.1 0 .2 0 .4.2s.4.5.5.9c3 15.6 13.3 28.9 27.9 35.5.2.1.4.2.6.6s.2.8.1 1.3c-3.9 15.4-.3 31.7 9.9 44 .2.3.4.7.4 1.1s-.2.9-.4 1.1c-10.1 12.3-13.8 28.6-9.9 44 .1.5.1.9-.1 1.3s-.4.5-.6.6c-12.6 5.8-22.1 16.6-26.3 29.5-11.8 1.2-22.4 6.7-30.2 14.9zM48.4 361.1c-.2-.3-.4-.7-.4-1.1s.2-.9.4-1.1c10.1-12.3 13.8-28.6 9.9-44-.1-.5-.1-.9.1-1.3s.4-.5.6-.6c14.6-6.7 24.8-20 27.9-35.5.1-.5.3-.8.5-.9s.3-.2.4-.2c16.1.5 31.2-7.1 40.7-19.9.1-.2.2-.2.3-.3s.2-.1.2-.1h.2s.1 0 .2.1c14.2 7.5 31.1 7.5 45.3 0 .1-.1.2-.1.2-.1h.3s.1 0 .1.1c.1 0 .2.1.3.3 9.5 12.8 24.6 20.4 40.7 19.9.1 0 .2 0 .4.2s.4.5.5.9c3 15.6 13.3 28.9 27.9 35.5.2.1.4.2.6.6s.2.8.1 1.3c-3.9 15.4-.3 31.7 9.9 44 .2.3.4.7.4 1.1s-.2.9-.4 1.1c-10.1 12.3-13.8 28.6-9.9 44 .1.5.1.9-.1 1.3s-.4.5-.6.6c-14.6 6.7-24.8 20-27.9 35.5-.1.5-.3.8-.5.9s-.3.2-.4.2c-16.1-.5-31.2 7.1-40.7 19.9-.1.2-.2.2-.3.3 0 0-.1 0-.1.1h-.4s-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0-.1.1-.2.1-.2.1h-.2c-.1 0-.2 0-.2-.1-.1 0-.2-.1-.3-.3-9.5-12.8-24.6-20.4-40.7-19.9-.1 0-.2 0-.4-.2s-.4-.5-.5-.9c-3-15.6-13.3-28.9-27.9-35.5-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4.3-31.7-9.9-44zM416 261c-1 24.2 13.6 56 40.3 82.7 19.3 19.4 41.4 32.3 61.3 37.6 19.5 5.2 37 3 47.9-7.9 5.5-5.5 8.8-12.7 10-20.9 2.1-14.2-1.8-31.6-10.9-49.3-5.2-10.1-12.1-20.3-20.6-30.1-2.6-3-5.4-5.9-8.2-8.8l-.5-.5c-33.5-33.3-74.9-47.5-99.3-35.9-3.5 1.7-6.6 3.8-9.4 6.6-6.7 6.7-10.1 15.9-10.5 26.5zm-304 91a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm224-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM224 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarFamilyDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFamilyDress",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-79.7 144h70.3c-4.3-9.8-6.7-20.6-6.7-32 0-2.4.1-4.8.3-7.1-9.6-5.7-20.8-8.9-32.6-8.9h-31.3c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H64v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h37.5c-3.5-10-5.5-20.8-5.5-32v-16H63.6l33.3-116.4c2-6.9 8.2-11.6 15.4-11.6zM336 176c0 11.4-2.4 22.2-6.7 32h70.4c7.1 0 13.4 4.7 15.4 11.6L448.4 336H368v16c0 11.2-1.9 22-5.5 32H400v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.8-27.5-33-46.4-61.5-46.4h-31.5c-11.8 0-23 3.2-32.6 8.9.2 2.3.3 4.7.3 7.1zM448 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm32 112v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16c0-17.7 14.3-32 32-32s32 14.3 32 32zm48 16v-16c0-44.2-35.8-80-80-80s-80 35.8-80 80v16c0 24 13.2 44.9 32.7 55.8-.5 2.7-.7 5.4-.7 8.2v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-2.8-.2-5.5-.7-8.2C322.8 396.9 336 376 336 352z"
        }
    ]
};

const FarFamilyPants = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFamilyPants",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3c-.8 9.4 6.6 17.4 16 17.4h63c-3 10.1-4.6 20.9-4.6 32v16h-32v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c9.2 0 18.1 1.6 26.4 4.5-.5 3.8-.8 7.6-.8 11.5 0 11.4 2.4 22.2 6.7 32h-77.1zM336 176c0-3.9-.3-7.8-.8-11.5 8.3-2.9 17.2-4.5 26.4-4.5h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32v-16c0-11.1-1.6-21.9-4.6-32h63c9.4 0 16.7-8 15.9-17.3l-4.1-49.3c-1.3-16.6-15.2-29.4-31.8-29.4h-77.1c4.3-9.8 6.7-20.6 6.7-32zM320 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-64 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 208c0-17.7-14.3-32-32-32s-32 14.3-32 32v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16zm48 16c0 24-13.2 44.9-32.7 55.8.5 2.7.7 5.4.7 8.2v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-2.8.2-5.5.7-8.2C189.2 396.9 176 376 176 352v-16c0-44.2 35.8-80 80-80s80 35.8 80 80v16z"
        }
    ]
};

const FarFamily = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFamily",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-86.4 144h77.1c-4.3-9.8-6.7-20.6-6.7-32 0-3.9.3-7.8.8-11.5-8.3-2.9-17.2-4.5-26.4-4.5h-44.8c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352h32v-16c0-11.1 1.6-21.9 4.6-32h-63c-9.4 0-16.7-8-15.9-17.3l4.1-49.3C75.1 220.8 89 208 105.6 208zM336 176c0 11.4-2.4 22.2-6.7 32h70.4c7.1 0 13.4 4.7 15.4 11.6L448.4 336H368v16c0 11.2-1.9 22-5.5 32H400v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.8-27.5-33-46.4-61.5-46.4h-31.5c-11.8 0-23 3.2-32.6 8.9.2 2.3.3 4.7.3 7.1zM448 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm32 112v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16c0-17.7 14.3-32 32-32s32 14.3 32 32zm48 16v-16c0-44.2-35.8-80-80-80s-80 35.8-80 80v16c0 24 13.2 44.9 32.7 55.8-.5 2.7-.7 5.4-.7 8.2v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-2.8-.2-5.5-.7-8.2C322.8 396.9 336 376 336 352z"
        }
    ]
};

const FarFanTable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFanTable",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 400a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm224-176c0 115.6-87.6 210.8-200 222.7V464h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h112v-17.3C87.6 434.8 0 339.6 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224zm-329.6-26.4c-16.6-41 3.2-87.6 44.2-104.1 12.3-5 26.3 1 31.2 13.3L223 179c16.7-23.7 45.8-37.5 76.6-33.2 43.8 6.1 74.2 46.6 68.1 90.4-1.8 13.1-14 22.3-27.1 20.4l-77.1-10.8c12.2 26.4 9.6 58.4-9.6 82.9-27.2 34.8-77.5 41-112.3 13.8-10.4-8.2-12.3-23.2-4.1-33.7l47.9-61.4c-28.9-2.6-55.4-21-67-49.7zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarFan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFan",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m304 40-4.1 38.2-5.7 52.7c9.4-4 18.9-6.9 28.5-8.6 7-1.2 14-1.9 21-2.2 79-2.9 151.9 53.9 167.7 132.1.5 2.5.7 5.1.7 7.7v4.1c0 22.1-17.9 40-40 40l-38.2-4.1-52.7-5.7c4 9.4 6.9 18.9 8.6 28.5 1.2 7 1.9 14 2.2 21 2.9 79-53.9 151.9-132.1 167.7-2.5.5-5.1.7-7.7.7H248c-22.1 0-40-17.9-40-40l4.1-38.2 5.7-52.7c-9.4 4-18.9 6.9-28.5 8.6-7 1.2-14 1.9-21 2.2C89.4 394.8 16.4 338 .7 259.8c-.5-2.5-.7-5.1-.7-7.7V248c0-22.1 17.9-40 40-40l38.2 4.1 52.7 5.7c-4-9.4-6.9-18.9-8.6-28.5-1.2-7-1.9-14-2.2-21C117.2 89.4 174 16.4 252.2.7c2.5-.5 5.1-.7 7.7-.7h4.1c22.1 0 40 17.9 40 40zm82.3 206.5 76.3 8.3c-15.2-56.4-73.6-95.1-131.8-85.1-5.5.9-11.4 2.7-17.8 5.4-15.7 6.7-33.7 4.6-47.4-5.6s-21-26.8-19.2-43.7l8.3-76.3c-56.4 15.2-95.1 73.6-85.1 131.8.9 5.5 2.7 11.4 5.4 17.8 6.7 15.7 4.6 33.7-5.6 47.4s-26.8 21-43.7 19.2l-76.3-8.3c15.2 56.4 73.6 95.1 131.8 85.1 5.5-.9 11.4-2.7 17.8-5.4 15.7-6.7 33.7-4.6 47.4 5.6s21 26.8 19.2 43.7l-8.3 76.3c56.4-15.2 95.1-73.6 85.1-131.8-.9-5.5-2.7-11.4-5.4-17.8-6.7-15.7-4.6-33.7 5.6-47.4s26.8-21 43.7-19.2zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFarm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFarm",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 464V176h115.3l23.4-50.2c7.2-15.5 19.8-27.9 35.3-35C212.1 39.1 166.6 0 112 0 50.1 0 0 50.1 0 112v352c0 26.5 21.5 48 48 48h100.1c-11-13.3-18.1-29.8-19.8-48H48zm128-336H48v-16c0-35.3 28.7-64 64-64s64 28.7 64 64v16zm81.9 34.4L368 114.2l110.1 48.2 49.9 107V456c0 4.4-3.6 8-8 8h-88v-56c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v56h-88c-4.4 0-8-3.6-8-8V269.3l49.9-107zM384 68.8c-10.2-4.5-21.8-4.5-32.1 0l-116 50.8c-8.9 3.9-16.1 10.9-20.2 19.7l-51.9 111.3c-2.5 5.3-3.8 11.1-3.8 16.9V456c0 30.9 25.1 56 56 56h304c30.9 0 56-25.1 56-56V267.5c0-5.8-1.3-11.6-3.8-16.9l-51.9-111.3c-4.1-8.8-11.3-15.8-20.2-19.7L384 68.8zM320 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarFaucetDrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaucetDrip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v21L96 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l104-13v45h-18.7c-14.9 0-29.1 5.9-39.6 16.4L126.1 160H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c6.4 0 12.5-2.5 17-7l22.6-22.6c1.5-1.5 3.5-2.3 5.7-2.3h93.5c2.1 0 4.2.8 5.7 2.3L303 201c4.5 4.5 10.6 7 17 7h40c57.4 0 104 46.6 104 104v16c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8 0-30.9-25.1-56-56-56h-32.3c-8.2 0-15.8 4.2-20.2 11.1-14.3 22.2-39.2 36.9-67.5 36.9s-53.2-14.7-67.4-36.9c-4.4-6.9-12-11.1-20.2-11.1H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h100.1c23.4 29.2 59.5 48 99.9 48s76.5-18.8 99.9-48H344c4.4 0 8 3.6 8 8 0 30.9 25.1 56 56 56h48c30.9 0 56-25.1 56-56v-16c0-83.9-68.1-152-152-152h-30.1l-15.6-15.6a55.924 55.924 0 0 0-39.6-16.4H248V83l104 13c17.7 0 32-14.3 32-32s-14.3-32-32-32L248 45V24zm172.8 399.4-18.2 42.4c-1.8 4.1-2.7 8.6-2.7 13.1v1.1c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.2c0-4.5-.9-8.9-2.7-13.1L443 423.3c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4z"
        }
    ]
};

const FarFaucet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFaucet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64c13.3 0 24 10.7 24 24v21l104-13c17.7 0 32 14.3 32 32s-14.3 32-32 32l-104-13v45h26.7c14.9 0 29.1 5.9 39.6 16.4l15.6 15.6H360c83.9 0 152 68.1 152 152v16c0 30.9-25.1 56-56 56h-48c-30.9 0-56-25.1-56-56 0-4.4-3.6-8-8-8h-20.1c-23.4 29.2-59.5 48-99.9 48s-76.5-18.8-99.9-48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h112.3c8.2 0 15.8 4.2 20.2 11.1 14.3 22.2 39.2 36.9 67.5 36.9s53.2-14.7 67.4-36.9c4.4-6.9 12-11.1 20.2-11.1H344c30.9 0 56 25.1 56 56 0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-16c0-57.4-46.6-104-104-104h-40c-6.4 0-12.5-2.5-17-7l-22.6-22.6c-1.5-1.5-3.5-2.3-5.7-2.3h-93.4c-2.1 0-4.2.8-5.7 2.3L153 265c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h102.1l15.6-15.6c10.5-10.5 24.7-16.4 39.6-16.4H200v-45L96 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l104 13V88c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarFax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFax",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 64c0-8.8 7.2-16 16-16h191.4c4.2 0 8.3 1.7 11.3 4.7l32.6 32.6c3 3 4.7 7.1 4.7 11.3V160h48V96.6c0-17-6.7-33.3-18.7-45.3l-32.6-32.6C416.7 6.7 400.4 0 383.4 0H192c-35.3 0-64 28.7-64 64v66c-5.1-1.3-10.5-2-16-2H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H176V64zm0 176h272c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H174c1.3-5.1 2-10.5 2-16V240zm-64 224H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16zm160-192a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-32 128a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm128-128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-32 128a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FarFeatherPointed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFeatherPointed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M117.7 343.9c-11.2-41.4-11.7-113 53.7-178.3 38.1-38.1 93.7-66.3 152.8-85.7 50.6-16.7 100.7-26 138.3-30.3-4.3 37.6-13.6 87.7-30.3 138.3-2.2 6.8-4.6 13.5-7 20.1h-87.3l7.9-7.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-189.1 189c-2.6-4.1-4.2-7.9-5.1-11.3zm4.6 79.7c10 7.6 21 13.7 33.3 17 54.1 14.6 144.7 14 224.8-66.1 91.1-91 124.6-254 131.5-337.7.8-9.9-3-19.6-10-26.6S485.2-.6 475.3.2C391.5 7 228.5 40.5 137.4 131.6c-80.1 80.1-80.7 170.7-66.1 224.8 3.3 12.2 9.4 23.2 17 33.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l81.3-81.3zm34.5-34.5 37.1-37.1h140.4c-61.9 53.9-127.3 52.9-166.2 42.3-3.5-.9-7.2-2.6-11.3-5.2zm220-85.2H241.9l48-48h114.7c-8.4 17-17.7 33.2-27.9 48z"
        }
    ]
};

const FarFeather = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFeather",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M311.9 166.1 112 366.1v-36c0-55.2 21.9-108.1 60.9-147.1L276.7 79.2c20-20 47.1-31.2 75.3-31.2s55.3 11.2 75.3 31.2l5.5 5.5c20 20 31.2 47.1 31.2 75.3 0 16.8-4 33.3-11.4 48H337.9l7.9-7.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zm-22 89.9h122.2l-48 48H241.9l48-48zm24.9 96c-37.2 30.9-84.2 48-132.9 48h-36l48-48h121zM64 330v84L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h84c67.9 0 133-27 181-75l103.8-103.6c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149c-48 48-75 113.1-75 181z"
        }
    ]
};

const FarFence = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFence",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c7.8 0 15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9v48h64v-48c0-5 1.6-9.9 4.5-13.9l40-56C241 35.7 248.2 32 256 32s15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9v48h64v-48c0-5 1.6-9.9 4.5-13.9l40-56C433 35.7 440.2 32 448 32s15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9v336c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-48h-64v48c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-48h-64v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V112c0-5 1.6-9.9 4.5-13.9l40-56C49 35.7 56.2 32 64 32zm256 320h64V208h-64v144zM192 208h-64v144h64V208zM48 119.7V432h32V119.7L64 97.3l-16 22.4zm192 0V432h32V119.7l-16-22.4-16 22.4zM432 432h32V119.7l-16-22.4-16 22.4V432z"
        }
    ]
};

const FarFerrisWheel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFerrisWheel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.4 73.4c-20.4-13-43.2-22.6-67.5-28.1C302.5 20.1 281.6 0 256 0s-46.5 20.1-47.9 45.3c-24.3 5.5-47.1 15.1-67.5 28.1-8-5.9-17.9-9.4-28.5-9.4-26.5 0-48 21.5-48 48 0 10.7 3.5 20.6 9.4 28.5-13 20.4-22.6 43.2-28.1 67.5C20.1 209.5 0 230.4 0 256s20.1 46.5 45.3 47.9c5.5 24.3 15.1 47.1 28.1 67.5-5.9 8-9.4 17.9-9.4 28.6 0 25.6 20 46.4 45.1 47.9l38.5-80c-7.4-8.3-17.7-13.9-29.3-15.5-14.8-21.1-24.9-45.7-28.7-72.4h90c-2.4-7.6-3.7-15.6-3.7-24s1.3-16.4 3.7-24h-90c3.8-26.7 13.9-51.3 28.7-72.4 2.1-.3 4.1-.7 6-1.2l60.8 60.6c7.6-14.5 19.5-26.4 33.9-33.9l-60.6-60.6c.5-2 .9-4 1.2-6 21.1-14.8 45.7-24.9 72.4-28.7v90c7.6-2.4 15.6-3.7 24-3.7s16.4 1.3 24 3.7v-90c26.7 3.8 51.3 13.9 72.4 28.7.3 2.1.7 4.1 1.2 6L293 185.1c14.5 7.6 26.4 19.5 33.9 33.9l60.6-60.6c2 .5 4 .9 6 1.2 14.8 21.1 24.9 45.7 28.7 72.4h-90c2.4 7.6 3.7 15.6 3.7 24s-1.3 16.4-3.7 24h90c-3.8 26.7-13.9 51.3-28.7 72.4-11.6 1.5-21.8 7.2-29.3 15.5l38.5 80C428 446.4 448 425.6 448 400c0-10.7-3.5-20.6-9.4-28.6 13-20.4 22.6-43.2 28.1-67.5C492 302.5 512 281.6 512 256s-20.1-46.5-45.3-47.9c-5.5-24.3-15.1-47.1-28.1-67.5 5.9-8 9.4-17.9 9.4-28.5 0-26.5-21.5-48-48-48-10.7 0-20.6 3.5-28.6 9.4zM304 256c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.6 4.1 22.3 11 30.6l-88.8 191.3c-3.5 7.4-2.9 16.1 1.5 23s12 11.1 20.2 11.1H360c8.2 0 15.8-4.2 20.2-11.1s5-15.6 1.5-23L293 286.6c6.9-8.3 11-19 11-30.6zm18.4 208H189.6L256 321l66.4 143z"
        }
    ]
};

const FarFerry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFerry",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32h68c17.1 0 28.7 17.4 22.2 33.2L468 80h4c30.9 0 56 25.1 56 56v157.9c0 11.5-3.5 22.7-10.1 32.1l-50.2 71.7c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4l35.1-50.2h-351l35.2 50.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L58.1 326c-6.6-9.4-10.1-20.6-10.1-32.1V136c0-30.9 25.1-56 56-56h4l-6.2-14.8C95.3 49.4 106.9 32 124 32h68zm288 240V136c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v136h32v-88c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24v88h32zm-304-64v64h224v-64H176zm-64.1 222.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7 9.1-8.1 22.8-8.1 31.9 0z"
        }
    ]
};

const FarFieldHockeyStickBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFieldHockeyStickBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M500.3 100.9C520.7 72 513.7 32 484.9 11.7S416-1.8 395.7 27.1L147.6 379.4c-2 2.8-5.1 4.4-8.5 4.4-5.3 0-10.5-4.7-10.5-11 0-1.6.4-3.1.9-4.4l17-38.5c14.3-32.3-.3-70.1-32.7-84.4s-70.1.3-84.4 32.7l-17 38.5C4.8 334 .7 352.9.6 371.8 0 448.3 61.9 512 139.4 511.8c44.9-.1 86.9-22 112.8-58.7l248.1-352.2zm-102.2 61.7L213 425.4c-16.9 24-44.4 38.3-73.7 38.4-50.5.1-91.1-41.4-90.7-91.6.1-12.4 2.7-24.8 7.8-36.1l17-38.5c3.6-8.1 13-11.7 21.1-8.2s11.7 13 8.2 21.1l-17 38.5c-3.2 7.3-5 15.4-5 23.5-.3 32.7 26.2 59.5 58.6 59.4 19-.1 36.7-9.3 47.6-24.8l185.6-263.7 25.6 19.2zM432 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
        }
    ]
};

const FarFileArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileArrowDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm152 232c0-13.3-10.7-24-24-24s-24 10.7-24 24v102.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V232z"
        }
    ]
};

const FarFileArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileArrowUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm152 408V305.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V408c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarFileAudio = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileAudio",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h256c8.8 0 16-7.2 16-16V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm192 208v128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376H112c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16h17.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"
        }
    ]
};

const FarFileBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileBinary",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm64 240c-30.9 0-56 25.1-56 56v64c0 30.9 25.1 56 56 56h16c30.9 0 56-25.1 56-56v-64c0-30.9-25.1-56-56-56h-16zm-8 56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-64zm120-56c-13.3 0-24 10.7-24 24s10.7 24 24 24v80c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24V264c0-13.3-10.7-24-24-24h-24z"
        }
    ]
};

const FarFileCertificate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCertificate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 464H224v32c0 5.5-1 10.9-2.7 16H448c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C390.7 6.7 374.5 0 357.5 0H192c-35.3 0-64 28.7-64 64v71.1l.1-.1c1.5-.7 4-2 6.6-3 13.6-5.5 28.3-5.4 41.3-.5V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16zM109.2 161.6c-10-4.1-21.5-1-28.1 7.5l-10.5 13.5c-1.3 1.7-3.2 2.7-5.2 3l-16.9 2.3c-10.7 1.5-19.1 9.9-20.5 20.5l-2.3 16.9c-.3 2.1-1.4 4-3 5.2L9.1 241.1c-8.5 6.6-11.6 18.1-7.5 28.1L8 285c.8 1.9.8 4.1 0 6.1l-6.4 15.7c-4.1 10-1 21.5 7.5 28.1l13.5 10.5c1.7 1.3 2.7 3.2 3 5.2l2.3 16.9c1.5 10.7 9.9 19.1 20.5 20.6l15.6 2.1V496c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l39.1-26.1 39.1 26.1c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1V390.2l15.5-2.1c10.7-1.5 19.1-9.9 20.5-20.6l2.3-16.9c.3-2.1 1.4-4 3-5.2l13.5-10.5c8.5-6.6 11.6-18.1 7.5-28.1L248 291c-.8-1.9-.8-4.1 0-6.1l6.5-15.8c4.1-10 1-21.5-7.5-28.1l-13.5-10.5c-1.7-1.3-2.7-3.2-3-5.2l-2.3-16.9c-1.5-10.7-9.9-19.1-20.5-20.5l-16.9-2.3c-2.1-.3-4-1.4-5.2-3l-10.5-13.5c-6.6-8.5-18.1-11.6-28.1-7.5l-16 6.4c-1.9.8-4.1.8-6.1 0l-15.8-6.5zM64 288a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarFileChartColumn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileChartColumn",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm152 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v128c0 13.3 10.7 24 24 24s24-10.7 24-24V280zm88 32c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96zm-176 32c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64z"
        }
    ]
};

const FarFileChartPie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileChartPie",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 464c8.8 0 16-7.2 16-16V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256zM0 64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm160 176.1c8.7-1.5 16 5.8 16 14.7V320c0 8.8 7.2 16 16 16h64c8.9 0 16.3 7.4 14.6 16.1-.5 2.5-1 5-1.7 7.4-13.7 51.2-66.4 81.6-117.6 67.9S69.7 361 83.4 309.8c10-37.4 40.8-63.7 76.5-69.8zm63.9-30.8c40.3 6.7 72 38.5 78.8 78.8 1.5 8.7-5.8 15.9-14.7 15.9h-64c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16.1 15.9-14.7z"
        }
    ]
};

const FarFileCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm225 267.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z"
        }
    ]
};

const FarFileCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h220.5c12 18.4 27.4 34.5 45.3 47.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm224-96a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FarFileCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h220.5c12 18.4 27.4 34.5 45.3 47.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm368-240a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarFileCircleInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCircleInfo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h220.5c12 18.4 27.4 34.5 45.3 47.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm368-240a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16v48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16v-64c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarFileCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h220.5c12 18.4 27.4 34.5 45.3 47.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm224-96a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FarFileCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h220.5c12 18.4 27.4 34.5 45.3 47.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm368-240a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FarFileCircleQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCircleQuestion",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h220.5c12 18.4 27.4 34.5 45.3 47.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm368-240a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64-142.4v6.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9 0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3C486.6 358.7 496 343 496 326c0-25.4-20.6-45.9-45.9-45.9h-40.5c-23 0-41.6 18.6-41.6 41.6z"
        }
    ]
};

const FarFileCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h220.5c12 18.4 27.4 34.5 45.3 47.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm368-240a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
        }
    ]
};

const FarFileCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCode",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zm96-34c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"
        }
    ]
};

const FarFileContract = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileContract",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm32 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm54.2 221.8L160 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l10.6-21.3c.6-1.2 1.8-1.9 3.1-1.9s2.5.7 3.1 1.9l10.6 21.3c2.7 5.4 8.3 8.8 14.3 8.8h40c8.8 0 16-7.2 16-16s-7.2-16-16-16h-30.1l-6.2-12.4c-6-12-18.3-19.6-31.7-19.6-8.6 0-16.8 3.1-23.1 8.6L185.6 323c-3.4-11.3-13.8-19-25.6-19s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.2c21.2 0 39.9-13.9 46-34.2z"
        }
    ]
};

const FarFileCsv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileCsv",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h32v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288h-48V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm136-112h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16h-34.9c-7.2 0-13.1 5.9-13.1 13.1 0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2 0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1 0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2 0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66 10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarFileDashedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileDashedLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 464H192c-8.8 0-16-7.2-16-16v-80h-48v80c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64v-80h-48v80c0 8.8-7.2 16-16 16zm16-304v96h48V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C390.7 6.7 374.5 0 357.5 0H192c-35.3 0-64 28.7-64 64v192h48V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80zM56 288c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zm192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H472z"
        }
    ]
};

const FarFileDoc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileDoc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h32v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288h-48V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm112-112h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v96zm264-128h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40zm-168 40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-16z"
        }
    ]
};

const FarFileExcel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileExcel",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7l44.6 57.2-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2l37-47.7 37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2l-37 47.7-37.1-47.6z"
        }
    ]
};

const FarFileExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileExclamation",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm128 176c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V200c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarFileExport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileExport",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v96h48V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64v-80h-48v80zm153-233c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h278.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"
        }
    ]
};

const FarFileHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileHeart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm29.7 306.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4 0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z"
        }
    ]
};

const FarFileImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileImage",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm96 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2h192c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"
        }
    ]
};

const FarFileImport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileImport",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 464H192c-8.8 0-16-7.2-16-16v-80h-48v80c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C390.7 6.7 374.5 0 357.5 0H192c-35.3 0-64 28.7-64 64v192h48V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16zM297 215c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h278.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"
        }
    ]
};

const FarFileInvoiceDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileInvoiceDollar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 448V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16zM0 64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm192 151.6c11 0 20 9 20 20v10.1c7.2 1.1 14.2 2.5 20.6 4.1 10.7 2.5 17.4 13.3 14.9 24.1s-13.3 17.4-24.1 14.9c-11-2.6-21.8-4.5-31.7-4.7-8.2-.1-16.7 1.6-22.4 4.6-5.2 2.8-5.3 4.7-5.3 5.9v.4c.3.4 1.4 1.6 4.4 3.2 6.5 3.5 15.8 6 28.6 9.5l.7.2c11.2 3 25.4 6.8 36.8 13.2 12.4 7 25.2 19.2 25.4 39.3.3 20.7-11.7 34.8-25.7 42.5-6.9 3.8-14.6 6.3-22.3 7.8v10.1c0 11-9 20-20 20s-20-9-20-20v-11.1c-10-1.9-19.3-4.8-27.5-7.3-2.1-.7-4.2-1.3-6.1-1.9-10.6-3.1-16.6-14.3-13.5-24.9s14.3-16.6 24.9-13.5c2.5.7 4.9 1.5 7.2 2.2 13.6 4.1 24.2 7.3 35.7 7.7 8.9.3 17.2-1.5 22.4-4.4 4.4-2.5 5.1-4.5 5-6.9v-.1c0-.5.2-2-5-4.8-6.4-3.6-15.7-6.3-28.3-9.7l-1.7-.5c-10.9-2.9-24.5-6.6-35.4-12.4-12.2-6.5-25.4-18.4-25.6-38.6-.1-21 13.2-34.4 26.7-41.5 6.7-3.5 14-5.9 21.3-7.3v-10.2c0-11 9-20 20-20zM96 96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarFileInvoice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileInvoice",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h256c8.8 0 16-7.2 16-16V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 48c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm112 224c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-8.8 0-16-7.2-16-16zm-80-176h160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarFileLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileLines",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"
        }
    ]
};

const FarFileLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 464H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v149.7c4.6-5.2 10-9.6 16-13.1V272c0-30.5 12.2-58.2 32-78.4v-39.1c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c2.8 0 5.6-.2 8.3-.5-5.3-9.3-8.3-20-8.3-31.5v-16zm144-224c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FarFileMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileMagnifyingGlass",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm208 304c0-53-43-96-96-96s-96 43-96 96 43 96 96 96c17.8 0 34.4-4.8 48.7-13.2l38.3 38.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarFileMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileMedical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm96 240v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarFileMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm56 288c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"
        }
    ]
};

const FarFileMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileMusic",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm240 208c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V299.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V208z"
        }
    ]
};

const FarFilePdf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilePdf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h32v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288h-48V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm112-112h32c30.9 0 56 25.1 56 56s-25.1 56-56 56h-16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V368z"
        }
    ]
};

const FarFilePen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilePen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h198.6l-5.1 20.5c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v131.2l-48 48V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm485.8-228.3 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FarFilePlusMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilePlusMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm152 200c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-40zm-88 184c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24H128z"
        }
    ]
};

const FarFilePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilePlus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm128 208c-13.3 0-24 10.7-24 24v48h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-48c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarFilePowerpoint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilePowerpoint",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm72 208c-13.3 0-24 10.7-24 24v160c0 13.3 10.7 24 24 24s24-10.7 24-24v-32h44c42 0 76-34 76-76s-34-76-76-76h-68zm68 104h-44v-56h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z"
        }
    ]
};

const FarFilePrescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilePrescription",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm40 192c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h22.1c.3.3.6.7.9 1l55 55-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23 23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23-31.1-31.1c18.7-11.3 31.2-31.7 31.2-55 0-35.3-28.7-64-64-64h-72zm72 80h-48v-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16z"
        }
    ]
};

const FarFileShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileShield",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h246.7c11 14.4 24.1 28.1 39.5 40.4-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V207l-48 19.2V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm359.1-238.3c5.7-2.3 12.1-2.3 17.8 0l120 48c9.1 3.7 15.1 12.5 15.1 22.3 0 63.3-25.9 168.8-134.8 214.2-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312 432 273.8v187.9c68.2-33 91.5-99 95.4-149.7z"
        }
    ]
};

const FarFileSignature = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileSignature",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h256c8.8 0 16-7.2 16-16v-6.7l39.8-9.9c2.8-.7 5.6-1.6 8.2-2.7V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v49.1l-48 48V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm96-115-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7 15.9 0 30.4 9 37.5 23.2l4.4 8.8h25.6l12-48.2c1.4-5.6 4.3-10.8 8.4-14.9l129.2-129.1 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-1.1.3-2.1.4-3.2.5-.8.1-1.5.2-2.3.2H256c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L160 349zm389.8-209.3 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0z"
        }
    ]
};

const FarFileSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C390.7 6.7 374.5 0 357.5 0H192c-35.3 0-64 28.7-64 64v11L38.8 5.1zM176 112.6V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v178.4L176 112.6zM448 464H192c-8.8 0-16-7.2-16-16V234.7l-48-37.8V448c0 35.3 28.7 64 64 64h256c20.1 0 38.1-9.3 49.8-23.8l-37.7-29.7c-2.9 3.4-7.3 5.5-12.1 5.5z"
        }
    ]
};

const FarFileSpreadsheet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileSpreadsheet",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm112 256v48h-64v-48h64zm-64 80h64v48h-64v-48zm96 0h64v48h-64v-48zm-16 80h80c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h80zm16-112v-48h64v48h-64z"
        }
    ]
};

const FarFileUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileUser",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 464c0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16h-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm192 288a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FarFileVideo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileVideo",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 464c8.8 0 16-7.2 16-16V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256zM0 64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 224c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v16l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1 6.8 0 12.3 5.5 12.3 12.3v103.4c0 6.8-5.5 12.3-12.3 12.3-2.4 0-4.8-.7-6.8-2.1L240 368v16c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-96z"
        }
    ]
};

const FarFileWaveform = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileWaveform",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 464H128c-8.8 0-16-7.2-16-16v-96H64v96c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C326.7 6.7 310.5 0 293.5 0H128C92.7 0 64 28.7 64 64v176h48V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16zM276.8 228.1c-4.4-7.7-12.7-12.3-21.5-12.1s-16.8 5.3-20.8 13.3l-45.5 91-25-37.6c-4.5-6.7-12-10.7-20-10.7H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h107.2l40.8 61.3c4.7 7.1 12.9 11.2 21.5 10.6s16.1-5.6 20-13.2l43.9-87.9 9.8 17.1c4.3 7.5 12.2 12.1 20.8 12.1h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-26.1l-25.1-43.9z"
        }
    ]
};

const FarFileWord = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileWord",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1S69.2 242.2 73 254.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"
        }
    ]
};

const FarFileXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileXmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm47 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarFileZip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileZip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288h-48V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm176-112h64c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6.7 15.6L265.9 480H304c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368zm32 64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48z"
        }
    ]
};

const FarFileZipper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFileZipper",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16h48v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm48 112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm-6.3 71.8-23.6 88.1c-1.4 5.4-2.1 10.9-2.1 16.4 0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8h-14.9c-14.5 0-27.2 9.7-30.9 23.8zM128 336h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarFile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFile",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 464c8.8 0 16-7.2 16-16V160h-80c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256zM0 64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"
        }
    ]
};

const FarFilesMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilesMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 368H160c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v48c0 17.7 14.3 32 32 32h48v224c0 8.8-7.2 16-16 16zm-224 48h224c35.3 0 64-28.7 64-64V122.5c0-17-6.7-33.3-18.7-45.3l-58.6-58.5C358.7 6.7 342.5 0 325.5 0H160c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v256c0 75.1 60.9 136 136 136h192c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm197.3 72v37.3H208c-8.8 0-16 7.2-16 16v21.3c0 8.8 7.2 16 16 16h37.3V320c0 8.8 7.2 16 16 16h21.3c8.8 0 16-7.2 16-16v-37.3H336c8.8 0 16-7.2 16-16v-21.4c0-8.8-7.2-16-16-16h-37.3V192c0-8.8-7.2-16-16-16h-21.4c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarFiles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFiles",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 368h224c8.8 0 16-7.2 16-16V128h-48c-17.7 0-32-14.3-32-32V48H160c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16zm224 48H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h165.5c17 0 33.3 6.7 45.3 18.7l58.5 58.5c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64zM24 96c13.3 0 24 10.7 24 24v256c0 48.6 39.4 88 88 88h192c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarFillDrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFillDrip",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M39 7c9.4-9.3 24.6-9.3 34 0l89.4 89.4 58.7-58.7c28.1-28.1 73.7-28.1 101.8 0l151.4 151.4c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8l97.8-97.8L39 41c-9.3-9.4-9.3-24.6 0-34zm192 226-68.7-68.7-97.7 97.8c-7.3 7.3-11.8 16.4-13.4 25.9h358.2l31-31c9.4-9.4 9.4-24.6 0-33.9L289 71.6c-9.4-9.4-24.6-9.4-33.9 0l-58.7 58.7L265 199c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0zm281 279c-35.3 0-64-28.7-64-64 0-25.2 32.6-79.6 51.2-108.7 6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
        }
    ]
};

const FarFill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFill",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M73 7c-9.4-9.3-24.6-9.3-34 0s-9.4 24.6 0 33.9l89.4 89.4-97.8 97.8c-37.5 37.5-37.5 98.3 0 135.8l117.5 117.5c37.5 37.5 98.3 37.5 135.8 0l190.4-190.5c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0l-58.8 58.7L73 7zm89.4 157.3L231 233c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-68.7-68.7L255 71.6c9.4-9.4 24.6-9.4 33.9 0L440.4 223c9.4 9.4 9.4 24.6 0 33.9l-31 31H51.2c1.6-9.5 6.1-18.6 13.4-25.9l97.8-97.8z"
        }
    ]
};

const FarFilmCanister = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilmCanister",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32h72c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v384h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V80h-8C10.7 80 0 69.3 0 56s10.7-24 24-24h72zM80 80v384h192V80H80zm464 48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32s-32 14.3-32 32v32c0 17.7-14.3 32-32 32H352V128h192zm-152 56v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zM392 344v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarFilmSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilmSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 432h192V80H160v352zM112 80H64c-8.8 0-16 7.2-16 16v72h64V80zm0 136H48v80h64v-80zm0 128H48v72c0 8.8 7.2 16 16 16h48v-88zM400 80v88h64V96c0-8.8-7.2-16-16-16h-48zm64 136h-64v80h64v-80zm0 128h-64v88h48c8.8 0 16-7.2 16-16v-72zM64 32h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FarFilmSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilmSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l50.7 39.8C100.2 36.8 113.6 32 128 32h384c35.3 0 64 28.7 64 64v320c0 3.3-.2 6.5-.7 9.6l55.5 43.5c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2zM176 112.6V80h-41.6l41.6 32.6zM328.3 232H416V80H224v70.3L328.3 232zM528 388.5V344h-56.8l56.8 44.5zm-112 35.3 71.4 56.2H128c-35.3 0-64-28.7-64-64V146.4l88.3 69.6H112v80h64v-61.3l57.5 45.3H224v152h192v-8.2zM176 344h-64v72c0 8.8 7.2 16 16 16h48v-88zM464 80v88h64V96c0-8.8-7.2-16-16-16h-48zm64 136h-64v80h64v-80z"
        }
    ]
};

const FarFilm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilm",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 432H160V280h192v152zm0-200H160V80h192v152zM64 80h48v88H48V96c0-8.8 7.2-16 16-16zM48 216h64v80H48v-80zm64 216H64c-8.8 0-16-7.2-16-16v-72h64v88zm288-264V80h48c8.8 0 16 7.2 16 16v72h-64zm0 48h64v80h-64v-80zm0 128h64v72c0 8.8-7.2 16-16 16h-48v-88zm48-312H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z"
        }
    ]
};

const FarFilms = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilms",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 264v-32h160v104H256v-72zm0-80V80h160v104H256zM440 32H160c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64h-72zM160 80h48v48h-64V96c0-8.8 7.2-16 16-16zm-16 96h64v64h-64v-64zm0 112h64v48h-48c-8.8 0-16-7.2-16-16v-32zm368 48h-48v-48h64v32c0 8.8-7.2 16-16 16zm16-96h-64v-64h64v64zm0-112h-64V80h48c8.8 0 16 7.2 16 16v32zm-480-8c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FarFilterCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilterCircleDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 41.7C0 18.7 18.7 0 41.7 0h428.2C493.2 0 512 18.8 512 42.1c0 8.9-2.8 17.6-8.1 24.8l-92.3 126.3c-30.9 3.6-59.3 15.1-83.2 32.5L458.3 48H55l163.6 200.8c3.5 4.3 5.4 9.6 5.4 15.2v68.4l32.3 25.6c-.2 3.3-.3 6.6-.3 10 0 20.8 3.6 40.7 10.2 59.2l-75.1-59.6c-9.6-7.6-15.1-19.1-15.1-31.3v-63.8L9.4 68C3.3 60.6 0 51.3 0 41.7zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1 8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.6c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6z"
        }
    ]
};

const FarFilterCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilterCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 41.7C0 18.7 18.7 0 41.7 0h428.2C493.2 0 512 18.8 512 42.1c0 8.9-2.8 17.6-8.1 24.8l-92.3 126.3c-30.9 3.6-59.3 15.1-83.2 32.5L458.3 48H55l163.6 200.8c3.5 4.3 5.4 9.6 5.4 15.2v68.4l32.3 25.6c-.2 3.3-.3 6.6-.3 10 0 20.8 3.6 40.7 10.2 59.2l-75.1-59.6c-9.6-7.6-15.1-19.1-15.1-31.3v-63.8L9.4 68C3.3 60.6 0 51.3 0 41.7zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
        }
    ]
};

const FarFilterList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilterList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41.2 64C18.5 64 0 82.5 0 105.2c0 10.4 3.9 20.4 11 28.1l93 100.1v126c0 13.4 6.7 26 18 33.4l75.5 49.8c5.3 3.5 11.6 5.4 18 5.4 18 0 32.6-14.6 32.6-32.6v-182l93-100.1c7.1-7.6 11-17.6 11-28.1C352 82.5 333.5 64 310.8 64H41.2zm104.4 143.7L56.8 112h238.4l-88.8 95.7c-4.1 4.4-6.4 10.3-6.4 16.3v162.8l-48-31.7V224c0-6.1-2.3-11.9-6.4-16.3zM344 392c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zm-24-136c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zm88-184c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80z"
        }
    ]
};

const FarFilterSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilterSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L408.1 294.6 566.6 100c6.1-7.4 9.4-16.7 9.4-26.3 0-23-18.7-41.7-41.7-41.7h-429c-8.6 0-16.5 2.6-23.1 7.1l-43.4-34zM134.4 80H521L370.3 265 134.4 80zM288 364.4v-41.5l-48-37.8v83.2c0 12.2 5.6 23.7 15.1 31.3l92.5 73.4c5.7 4.5 12.8 7 20.1 7 17.8 0 32.3-14.5 32.3-32.3v-36.5l-48-37.8v41.9l-64-50.8z"
        }
    ]
};

const FarFilter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 73.7C0 50.7 18.7 32 41.7 32h428.6c23 0 41.7 18.7 41.7 41.7 0 9.6-3.3 18.9-9.4 26.3L336 304.5v143.2c0 17.8-14.5 32.3-32.3 32.3-7.3 0-14.4-2.5-20.1-7l-92.5-73.4c-9.6-7.6-15.1-19.1-15.1-31.3v-63.8L9.4 100C3.3 92.6 0 83.3 0 73.7zM55 80l163.6 200.8c3.5 4.3 5.4 9.6 5.4 15.2v68.4l64 50.8V296c0-5.5 1.9-10.9 5.4-15.2L457 80H55z"
        }
    ]
};

const FarFilters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFilters",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M233.8 32C210.7 32 192 50.7 192 73.8c0 9.3 3.1 18.4 8.9 25.8L336 272.3v63.9c0 12.3 5.6 23.9 15.3 31.5l92.9 73c21 16.5 51.8 1.5 51.8-25.2V272.3L631.1 99.6c5.8-7.4 8.9-16.4 8.9-25.8 0-23.1-18.7-41.8-41.8-41.8H233.8zm145.1 217.2L246.5 80h339L453.1 249.2c-3.3 4.2-5.1 9.4-5.1 14.8v118.6l-64-50.3V264c0-5.4-1.8-10.6-5.1-14.8zM163.4 96H41.8C18.7 96 0 114.7 0 137.8c0 9.3 3.1 18.4 8.9 25.8L144 336.3v31.9c0 12.3 5.6 23.9 15.3 31.5l92.9 73c21 16.5 51.8 1.5 51.8-25.2V283.3l-9.7-12.5-33.2 42.4c-3.3 4.2-5.1 9.4-5.1 14.8v86.6l-64-50.3V328c0-5.4-1.8-10.6-5.1-14.8L54.5 144H195l-19.3-24.6c-5.5-7-9.6-15-12.3-23.4z"
        }
    ]
};

const FarFingerprint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFingerprint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-114.9 93.1-208 208-208 63.1 0 119.6 28.1 157.8 72.5 8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0 114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6-15.2 5-18.7 23.7-8.3 35.9 7.1 8.3 18.8 10.8 29.4 7.9 10.6-2.9 21.8-4.4 33.4-4.4 70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3-1.7 14.6 9.4 27.8 24.2 27.8 11.8 0 21.9-8.6 23.3-20.3 3.3-27.4 5-55 5-82.7v-25c0-97.2-78.8-176-176-176zm-105.3 68.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9-3.4 15.6 7.9 31.2 23.9 31.2 10.5 0 19.9-7 22.2-17.3 6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1 7.2-10.4 8-24.6-.2-34.2zM352 256c0-53-43-96-96-96s-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1-3.8 14.3 6.7 29 21.5 29 9.5 0 17.9-6.2 20.4-15.4 10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9-2.7 13.9 7.7 27.2 21.8 27.2 10.2 0 19-7 21-17 7.7-38.8 11.6-78.3 11.6-118.1V256zm-96-24c-13.3 0-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3A536.19 536.19 0 0 0 280 280.9V256c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarFireBurner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFireBurner",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15zm-338 7c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H80v80h480v-80h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v104c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32V280zm16 184h116.3c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H48v32zm171.7 0h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16h-72.6c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16zm128 0h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16h-72.6c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16zm244.3 0v-32H475.7c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16H592z"
        }
    ]
};

const FarFireExtinguisher = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFireExtinguisher",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M500.3 7.3c7.4 6 11.7 15.1 11.7 24.7v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32c-12.2-2.4-21.7-11.6-24.7-23.3h-89v26.6c50.3 11 88 55.8 88 109.4v208c0 35.3-28.7 64-64 64h-96c-35.3 0-64-28.7-64-64V240c0-53.6 37.7-98.4 88-109.4v-25.7c-46.9 5.5-86.5 34.8-106.3 75.6-5.8 11.9-20.2 16.9-32.1 11.1s-16.9-20.2-11.1-32.1C30.1 102.8 86.1 62.4 152 56.7V24c0-13.3 10.7-24 24-24s24 10.7 24 24v32h89c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1.6 26.6 6.6zM112 416v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-32H112zm0-48h128V240c0-35.3-28.7-64-64-64s-64 28.7-64 64v128z"
        }
    ]
};

const FarFireFlameCurved = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFireFlameCurved",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M53.9 186.1C19.4 220.6 0 267.4 0 316.2v11.5C0 429.5 82.5 512 184.3 512h15.1c102 0 184.6-82.6 184.6-184.6 0-66.1-27.1-129.2-74.9-174.8l-78.2-74.4c-9.5-9.1-14.9-21.6-14.9-34.8V21.3C216 9.6 206.4 0 194.7 0c-6.7 0-13 3.2-17.1 8.5L168 21.3l-9.9 13.2c-14.4 19.3-23.2 42.2-25.2 66.2l-.9 10.8c-.3 3.9-.5 7.8-.4 11.7.2 22.9 6.6 45.4 18.4 65 2.2 3.7 4.6 7.2 7.2 10.6l10.8 14.5 21.2 28.3c7 9.3 10.8 20.7 10.8 32.4v14c0 22.1-17.9 40-40 40s-40-17.9-40-40v-99.7c0-15.6-12.7-28.3-28.3-28.3-1.3 0-2.6.1-3.9.3-6 .8-11.7 3.6-16.1 8l-17.8 17.8zm18.1 53V288c0 48.6 39.4 88 88 88s88-39.4 88-88v-14c0-22.1-7.2-43.5-20.4-61.2l-32-42.7c-11.8-15.7-17.4-35.1-15.7-54.6l.9-10.8c.3-3.6.8-7.2 1.6-10.7 4.3 6.9 9.4 13.3 15.4 18.9l33.1-34.8-33.1 34.8 78.2 74.5c38.3 36.5 60 87.1 60 140 0 75.5-61.1 136.6-136.6 136.6h-15.1C109 464 48 403 48 327.7v-11.5c0-27.7 8.5-54.6 24-77.2z"
        }
    ]
};

const FarFireFlameSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFireFlameSimple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.1 8.5c72.9 68 128.7 152.4 162.7 246.1l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9L57.3 271l-.7 1.9C50.9 288.5 48 305 48 321.6 48 399.7 112.8 464 192 464s144-64.3 144-142.4c0-16.6-2.9-33.1-8.6-48.7l42.3-15.4-42.3 15.4-.7-1.9c-29-79.8-75-152.2-134.7-212.2-59.7 60-105.7 132.4-134.7 212.2l-45.1-16.4C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3zm72.6 281.4a73.3 73.3 0 0 1 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
        }
    ]
};

const FarFireFlame = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFireFlame",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.1 8.5c72.9 68 128.7 152.4 162.7 246.1l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9L57.3 271l-.7 1.9C50.9 288.5 48 305 48 321.6 48 399.7 112.8 464 192 464s144-64.3 144-142.4c0-16.6-2.9-33.1-8.6-48.7l42.3-15.4-42.3 15.4-.7-1.9c-29-79.8-75-152.2-134.7-212.2-59.7 60-105.7 132.4-134.7 212.2l-45.1-16.4C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3zm-19.8 155.3c1.7-2.4 4.4-3.8 7.4-3.8 5 0 9.1 4.1 9.1 9.1v10.8c0 7.8 3.1 15.3 8.5 20.8l44.1 45.1c19 19.4 29.6 45.5 29.6 72.6v1.6c0 53-43 96-96 96s-96-43-96-96v-11.4c0-18.4 6.6-36.3 18.6-50.3l6-7c1.8-2.1 4.4-3.3 7.1-3.3 5.2 0 9.4 4.2 9.4 9.4v40.9c0 20.8 16.9 37.7 37.7 37.7s37.7-16.9 37.7-37.7v-1.5c0-10.2-3.9-19.9-11-27.3l-11-11.4c-12.3-12.8-19.2-29.8-19.2-47.5 0-14.4 4.5-28.4 13-40.1l4.9-6.7z"
        }
    ]
};

const FarFireHydrant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFireHydrant",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-17.7 0-32 14.3-32 32v4c-45 11.6-80.4 47-92 92H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-12c-11.6-45-47-80.4-92-92v-4c0-17.7-14.3-32-32-32zM56 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-80h16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-16v-48h-48v256H112V208H64v48H48c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h16v80h-8zm192-144a56 56 0 1 0-112 0 56 56 0 1 0 112 0z"
        }
    ]
};

const FarFireSmoke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFireSmoke",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M293.5 3.8c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 19.8 3.6 38.8 10.1 56.3 9.6 3.3 18.7 7.6 27.3 12.7 12.7-13.6 27.6-25 44.2-33.8-1.1-5.5-1.6-11.3-1.6-17.4 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 8.6 15.8 11.3 33.7 8.4 50.4 16.6 8.8 31.5 20.2 44.2 33.8 8.5-5.1 17.6-9.3 27.1-12.6C476.4 231 480 212 480 192.2c0-20.2-9.6-50.9-24.2-79-14.7-28.5-35.6-58.5-60.3-81.2-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zm-60.3 357.5c7-41.6 43.2-73.3 86.8-73.3s79.8 31.7 86.8 73.3c1.8 10.7 10.5 18.8 21.2 19.9s20.9-5.1 24.8-15.2c10.4-27 36.6-46 67.2-46 39.8 0 72 32.2 72 72 0 37.7-29 68.7-66 71.8-.7.1-1.3.1-2 .2H116c-.7-.1-1.3-.2-2-.2-36.9-3-66-34-66-71.8 0-39.8 32.2-72 72-72 30.6 0 56.7 19 67.2 46 3.9 10.1 14.1 16.3 24.8 15.2s19.4-9.2 21.2-19.9zM320 240c-49.4 0-92.7 26.4-116.5 65.8-21.6-20.9-51-33.8-83.5-33.8C53.7 272 0 325.7 0 392c0 61.4 46.1 112 105.6 119.1 2 .6 4.2.9 6.4.9h416c2.2 0 4.3-.3 6.4-.9C593.9 504 640 453.4 640 392c0-66.3-53.7-120-120-120-32.5 0-61.9 12.9-83.5 33.8C412.7 266.4 369.4 240 320 240z"
        }
    ]
};

const FarFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFire",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M89.3 156.3C113 115 143.2 77 170.5 50.4c18.7 18.7 40.9 47.2 60.1 71.7 3.8 4.8 7.4 9.5 10.9 13.9 4.6 5.8 11.7 9.2 19.1 9.1s14.4-3.6 18.9-9.5c3.3-4.3 7.7-10.8 12.3-17.4 2.6-3.8 5.3-7.6 7.8-11.2 5.6-7.9 10.5-14.5 14.4-19.1 20 20.8 41 53 57.4 88.4 17.7 38.2 28.6 77 28.6 106.3 0 103-78.8 181.4-176 181.4-98.3 0-176-78.4-176-181.4 0-37.5 16.2-82.4 41.3-126.2zM199.5 11.6c-16.2-15.4-41.5-15.5-57.7-.1-32 30.1-67 73.6-94.1 121C20.7 179.5 0 233 0 282.6 0 410.9 98.1 512 224 512c124.6 0 224-100.9 224-229.4 0-39.1-13.9-85.2-33.1-126.5C395.7 114.6 369.8 74.9 343 49c-16.3-15.8-42-15.8-58.3-.1-7.9 7.6-17 20-24.3 30.3l-1.1 1.6c-18.7-23.8-40.9-51.3-59.8-69.2zM225.7 416c25.3 0 47.7-7 68.8-21 42.1-29.4 53.4-88.2 28.1-134.4-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5-16.5-21-46-58.5-62.8-79.8-6.3-8-18.3-8.1-24.7-.1-33.8 42.5-50.8 69.3-50.8 99.4.1 68.5 50.7 109.1 113.8 109.1z"
        }
    ]
};

const FarFireplace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFireplace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 48h544v32H48V48zM32 0C14.3 0 0 14.3 0 32v64c0 17.7 14.3 32 32 32v360c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V368c0-88.4 71.6-160 160-160s160 71.6 160 160v120c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zm48 464V128h480v336h-32v-96c0-114.9-93.1-208-208-208s-208 93.1-208 208v96H80zm220.6-205.3c-2-1.8-4.6-2.7-7.1-2.7-2.6 0-5.2.9-7.3 2.7-24.2 21.6-44.7 46.1-59.2 69.7-14.3 23.2-23.6 48.2-23.6 67.4 0 63.8 51.1 116.3 116.4 116.3 64.5 0 116.4-52.4 116.4-116.3 0-14.7-7-37-17.6-57.4-10.7-20.7-25.9-42.5-43.9-59-4.1-3.7-10.4-3.8-14.5 0-7 6.4-13.5 14.3-19.2 21.5-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9-32.7 0-58.9-21.1-58.9-56.7 0-17.5 10.9-32.7 32.7-59.6 2.9 3.6 45.1 57.5 45.1 57.5l26.2-30.6c2.2 2.9 3.6 5.8 5.1 8.7 13.1 24 7.3 54.5-14.5 69.8z"
        }
    ]
};

const FarFishBones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFishBones",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 166.9c0-7.2-3.3-14.1-8.9-18.7l-48-38.9c-8.8-7.1-21.3-7.1-30.1-.1s-11.5 19.2-6.6 29.3l52.5 106.9c3.3 6.7 3.3 14.5 0 21.2L2.5 373.4c-5 10.1-2.2 22.3 6.6 29.3s21.3 7 30.1-.1l48-38.9c5.6-4.6 8.9-11.4 8.9-18.7v-65h40v72c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h48v72c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h48v72c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h40v101.1c0 16.9 17.1 28.4 31.8 20 16-9.1 30.6-19.7 43.7-30.7 39.1-33 66.9-72.4 81-99.8 4.7-9.2 4.7-20.1 0-29.3-14.1-27.4-41.9-66.8-81-99.8-13.1-11-27.7-21.6-43.7-30.7-14.7-8.4-31.8 3.1-31.8 20V232H376v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-48v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-48v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H96v-65.1zm368 163.9V181.2c28.5 24.9 49.7 53.6 61.8 74.8-12.1 21.2-33.3 49.9-61.8 74.8z"
        }
    ]
};

const FarFishCooked = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFishCooked",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M149.3 203.9c19.8-22.8 47.5-46.1 78.2-63.6 30.9-17.5 63.2-28.3 92.5-28.3 44.8 0 97.6 25.1 140.5 58.9 21.1 16.6 38.7 34.5 50.7 50.7C524 238.8 528 250.7 528 256s-4 17.2-16.8 34.4c-12.1 16.2-29.6 34.1-50.7 50.7C417.6 374.9 364.8 400 320 400c-29.3 0-61.6-10.8-92.5-28.4-30.7-17.5-58.4-40.8-78.2-63.6-8-9.2-21.7-10.9-31.7-4L60 343.6l17.6-74.8c2-8.4 2-17.2 0-25.7L60 168.4l57.6 39.6c10.1 6.9 23.7 5.2 31.7-4zM320 64c-40.4 0-81 14.5-116.3 34.6-28.5 16.2-54.7 36.7-76 58.1l-80.8-55.6C42 97.8 36.3 96 30.4 96c-18.7 0-32.6 17.5-28.3 35.7l28.8 122.5c.3 1.2.3 2.5 0 3.7L2.1 380.3c-4.3 18.2 9.6 35.7 28.3 35.7 5.9 0 11.6-1.8 16.5-5.1l80.9-55.6c21.3 21.3 47.5 41.8 76 58.1C239 433.5 279.6 448 320 448c60.2 0 123.4-32.2 170.2-69.1 23.8-18.7 44.5-39.5 59.6-59.8 14.3-19.3 26.2-41.7 26.2-63.1s-11.9-43.8-26.2-63.1c-15-20.3-35.8-41.1-59.6-59.8C443.4 96.2 380.2 64 320 64zm-4.7 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm112 16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm16 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64z"
        }
    ]
};

const FarFishFins = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFishFins",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M247.3 166c-13.1 6.7-25.4 14.5-36.5 22.8-10.2 7.6-19.5 15.8-27.9 24-14.2 13.9-35.5 17.6-53.6 9.3l-58.7-26.8 21.1 36.9c8.4 14.8 8.4 32.9 0 47.6l-21.1 36.9 58.7-26.9c18.1-8.3 39.4-4.6 53.6 9.3 8.4 8.3 17.8 16.4 27.9 24 11.2 8.4 23.5 16.3 36.8 23 16.7 8.4 27 25.8 26.3 44.4l-.8 23.6 46.2-36.3c7.7-6.1 17.2-9.6 27-10.2 44.7-2.5 83.7-21 114.9-44.5 29.4-22.1 51.3-48 64-67.2-12.7-19.2-34.6-45.1-64-67.2-31.3-23.5-70.2-42-114.9-44.5-9.8-.5-19.2-4.1-27-10.2l-46.4-36.4.6 24.3c.5 18.5-9.7 35.7-26.3 44.1zM8.4 373.6c-9.4-10.3-11.1-25.4-4.2-37.5L50 256 4.2 175.9c-6.9-12.1-5.2-27.2 4.2-37.5s24.3-13.3 36.9-7.5l103.9 47.6c9.8-9.6 20.8-19.2 32.7-28.1 13.1-9.8 27.7-19.2 43.6-27.2L224 64.9c-.3-12.4 6.5-23.9 17.6-29.4s24.4-4.2 34.1 3.4L349 96.4c56.6 3.2 104.5 26.6 141.1 54 39.2 29.4 67.2 64.7 81.6 89.5 5.8 9.9 5.8 22.2 0 32.1-14.4 24.8-42.5 60.1-81.6 89.5-36.6 27.5-84.5 50.9-141.1 54L275.8 473c-9.8 7.7-23.1 9-34.2 3.4s-17.9-17.2-17.5-29.6l1.9-57.9c-16.1-8.1-30.8-17.5-44-27.4-12-9-22.9-18.5-32.7-28.1l-104 47.7c-12.6 5.8-27.6 2.8-36.9-7.5zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFish = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFish",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M180.8 303.7c9.2 10.4 19.4 20.6 30.7 30.1 33.7 28.5 76 50.2 124.5 50.2s90.8-21.8 124.5-50.2c30.3-25.5 52.7-55.7 65.3-77.8-12.6-22.1-35-52.2-65.3-77.8-33.7-28.5-76-50.2-124.5-50.2s-90.8 21.7-124.5 50.2c-11.3 9.5-21.5 19.7-30.7 30.1-14 15.8-36.7 20.6-56 11.8l-54.2-24.8 21.1 36.9c8.4 14.8 8.4 32.9 0 47.6l-21.1 36.9 54.3-24.9c19.2-8.8 41.9-4 56 11.8zM4.2 336.1 50 256 4.2 175.9c-6.9-12.1-5.2-27.2 4.2-37.5s24.3-13.3 36.9-7.5l99.5 45.6c10.5-11.9 22.5-23.8 35.7-35C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8 4.7 9.2 4.7 20.1 0 29.3-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-13.2-11.2-25.1-23.1-35.7-35l-99.5 45.6c-12.6 5.8-27.6 2.8-36.9-7.5s-11.1-25.4-4.2-37.5zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFishingRod = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFishingRod",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280.4 48c-3.2 0-6.3.5-9.3 1.4l-64.5 19.8C136.1 90.9 88 156.1 88 229.8v42.9c22.7 3.8 40 23.6 40 47.3v144c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V320c0-23.8 17.3-43.5 40-47.3v-42.9C40 135 101.8 51.2 192.5 23.4l64.4-19.9c7.6-2.3 15.5-3.5 23.5-3.5 44 0 79.6 35.7 79.6 79.6V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V79.6c0-17.4-14.2-31.6-31.6-31.6zM48 320v144h32V320H48zm208 24c0-71.6 55.6-127.8 89-148.1 4.3-2.6 9.6-2.6 14 0 33.5 20.3 89 76.6 89 148.1 0 32-16 80-64 112l27.3 27.3c3 3 4.7 7.1 4.7 11.3v1.4c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-1.4c0-4.2 1.7-8.3 4.7-11.3L320 456c-48-32-64-80-64-112zm128-32a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarFlagCheckered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlagCheckered",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0c13.3 0 24 10.7 24 24v28l85-21.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0l9.6-4.8c20.6-10.4 44.8 4.6 44.8 27.6v279.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.3-23.7-122.5-13.4L48 388v100c0 13.3-10.7 24-24 24S0 501.3 0 488V24C0 10.7 10.7 0 24 0zm24 150.7 80-17.4V81.5l-80 20v49.3zm0 49.1v46.9l80-17.4v-46.8l-80 17.4zm0 96v42.7l68.6-17.2c3.8-.9 7.6-1.8 11.4-2.5v-40.3l-80 17.4zm128 18.8c33.1.7 65.9 8.7 96 23.7v-49.8l-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6v46zm144 37c18.7 1.5 37.7-1.1 55.6-7.8l24.4-9.1V288l-25.7 6c-17.9 4.1-36.1 5.5-54.3 4.3v53.5zm80-113V192l-25.7 6c-17.9 4.1-36.1 5.5-54.3 4.3v47.8c14.5 1.4 29.2.4 43.5-2.9l36.5-8.4zm0-96V92.9c-25.6 10.4-52.8 15.6-80 15.6V154c14.5 1.4 29.2.4 43.5-2.9l36.5-8.4zm-128-39.5c-16.1-3.7-31.9-9.4-47-16.9-15.3-7.7-32.1-11.8-49-12.3v50.6c18.2-1.3 36.5.6 54.1 5.8l41.9 12.2v-39.4zm0 89.5-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6v47.8c18.2-1.3 36.5.6 54.1 5.8l41.9 12.2v-46z"
        }
    ]
};

const FarFlagPennant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlagPennant",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V350.9l384.9-137.5c9-3.2 15.1-11.8 15.1-21.4s-6-18.2-15.1-21.4L48 33.1V24zm0 60.1L350.1 192 48 299.9V84.1z"
        }
    ]
};

const FarFlagSwallowtail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlagSwallowtail",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V352h376c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L352 192l91.2-121.6c3.1-4.2 4.8-9.2 4.8-14.4 0-13.3-10.7-24-24-24H48v-8zm0 56h328l-62.4 83.2a48 48 0 0 0 0 57.6L376 304H48V80z"
        }
    ]
};

const FarFlagUsa = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlagUsa",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0c13.3 0 24 10.7 24 24v28l85-21.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0l9.6-4.8c20.6-10.4 44.8 4.6 44.8 27.6v295.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.3-23.7-122.5-13.4L48 404v84c0 13.3-10.7 24-24 24S0 501.3 0 488V24C0 10.7 10.7 0 24 0zm376 93c-56.4 22.9-120.2 20.6-175-6.8-15.3-7.7-32.1-11.8-49-12.3v60.7c18.8.6 37.5 3.6 55.6 9l49.3 14.8c35.2 10.6 72.9 9.3 107.3-3.6l11.8-4.4V93zM48 252.9l68.5-15.8c39.8-9.2 81.4-6.9 119.9 6.6l41.9 14.7c37.1 13 77.6 12.5 114.5-1.3l7.3-2.7v-52.8c-42.9 14.9-89.4 15.9-132.9 2.8l-49.3-14.8c-28-8.4-57.6-9.3-86.1-2.8L48 206.2v46.7zm0 49.3v52.4l68.6-17.2c52.2-13.1 107.4-7 155.6 17.1 32.2 16.1 69.7 18.1 103.4 5.4l24.4-9.1v-45.4c-44.7 14.4-93.1 13.9-137.6-1.7L220.5 289c-30-10.5-62.3-12.3-93.3-5.1L48 302.2zM96 104a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V388l80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4 44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0-35.1-17.6-75.4-22-113.5-12.5L48 52V24zm0 77.5 96.6-24.2c27-6.7 55.5-3.6 80.4 8.8 54.9 27.4 118.7 29.7 175 6.8v241.8l-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5v-237z"
        }
    ]
};

const FarFlashlight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlashlight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 304H48v-96h336c11.6 0 22.9-4.2 31.7-11.9l.1-.1c.2-.2.7-.6 1.4-1.2 1.5-1.2 3.9-3.1 7.4-5.4 6.9-4.8 17.5-11.4 31.4-18.2 15-7.3 33.9-14.6 56.1-19.8v209.3c-22.2-5.2-41-12.5-56.1-19.8-14-6.8-24.5-13.4-31.4-18.2-3.4-2.4-5.9-4.3-7.4-5.4-.7-.6-1.2-1-1.4-1.2l-.1-.1c-8.8-7.7-20-11.9-31.6-11.9zm192 64c-5.5 0-10.8-.2-16-.4V144.4c5.2-.3 10.5-.4 16-.4h16v224h-16zM384 160H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h336s72 64 192 64h32c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32h-32c-120 0-192 64-192 64zm-136 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48z"
        }
    ]
};

const FarFlaskGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlaskGear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48v148.8c0 20.7-5.8 41-16.6 58.7L100 352h225.8c.1.1.2.1.2.2-16.6 10.6-26.7 31.6-20 53.3 4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 6.7 1.5 13.5 4.2 19.7-9 4.3-19 6.6-29.7 6.6H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4l108.2-175.8c6.2-10.1 9.5-21.7 9.5-33.5V48h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v148.8c0 11.8 3.3 23.5 9.5 33.5L336 241c-4.9 6.4-9.5 13.1-13.6 20.3-5.2 9.1-9.6 18.4-13.1 27.9l-20.7-33.6c-10.9-17.7-16.6-38-16.6-58.7V48h-96zm271.3 155.4c-6.8 1.5-11.3 7.8-11.3 14.8v17.4c0 7.9-4.9 15-11.7 18.9-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2 3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6 6.9 3.9 11.7 11 11.7 18.9v17.4c0 7 4.5 13.3 11.3 14.8 10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8v-17.7c0-7.8 4.8-14.8 11.6-18.7 6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4 7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6-6.8-3.9-11.6-10.9-11.6-18.7v-17.7c0-7-4.5-13.3-11.3-14.8-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM480 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarFlaskRoundPoison = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlaskRoundPoison",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48h96v109.7c0 24.3 13.5 44.9 32.3 55.9C352.1 241.4 384 293 384 352c0 43.1-17 82.1-44.7 110.9-.1.1-.3.2-.8.4-.9.4-2.5.7-4.8.7H114.2c-2.2 0-3.8-.4-4.8-.7-.4-.2-.7-.3-.8-.4C81 434.1 64 395.1 64 352c0-59 31.9-110.6 79.7-138.4 18.8-11 32.3-31.6 32.3-55.9V48zm144 109.7V48h8c13.3 0 24-10.7 24-24S341.3 0 328 0H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v109.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3 10.3 10.7 25.1 15.7 40 15.7h219.6c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9-5.2-3-8.5-8.4-8.5-14.4zm-33.2 220.7c15.6-13 25.2-30.8 25.2-50.4 0-39.8-39.4-72-88-72s-88 32.2-88 72c0 19.6 9.6 37.4 25.2 50.4 4.1 3.4 6.8 8.3 6.8 13.6v8c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16v-8c0-5.3 2.7-10.2 6.8-13.6zM192 312a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarFlaskRoundPotion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlaskRoundPotion",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48h96v109.7c0 24.3 13.5 44.9 32.3 55.9C352.1 241.4 384 293 384 351.9c-64.4-.9-94.8-12.3-122.5-22.7-23.8-9-45.7-17.2-85.5-17.2-55.8 0-92.3 16.1-111.5 27.9 4-53.9 34.8-100.4 79.2-126.3 18.8-11 32.3-31.6 32.3-55.9V48zm144 109.7V48h8c13.3 0 24-10.7 24-24S341.3 0 328 0H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v109.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3 10.3 10.7 25.1 15.7 40 15.7h219.6c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9-5.2-3-8.5-8.4-8.5-14.4z"
        }
    ]
};

const FarFlaskVial = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlaskVial",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m175 389.4 49-79.6V48h8c13.3 0 24-10.7 24-24S245.3 0 232 0H24C10.7 0 0 10.7 0 24s10.7 24 24 24h8v304c0 53 43 96 96 96 11.2 0 22-1.9 32-5.5 0-18.7 5.2-37.1 15-53.1zM80 48h96v112H80V48zm0 160h96v144c0 26.5-21.5 48-48 48s-48-21.5-48-48V208zM312 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v169.2L202 408.9c-6.6 10.7-10 22.9-10 35.5 0 37.4 30.3 67.6 67.6 67.6h312.8c37.4 0 67.6-30.3 67.6-67.6 0-12.5-3.5-24.8-10-35.5L512 217.2V48h8c13.3 0 24-10.7 24-24S533.3 0 520 0H312zm152 48v176c0 4.4 1.2 8.8 3.6 12.6l51.3 83.4H313.1l51.3-83.4c2.3-3.8 3.6-8.1 3.6-12.6V48h96zM242.9 434.1l40.7-66.1h264.8l40.6 66.1c1.9 3.1 2.9 6.7 2.9 10.3 0 10.8-8.8 19.6-19.6 19.6H259.6c-10.9 0-19.6-8.8-19.6-19.6 0-3.6 1-7.2 2.9-10.3z"
        }
    ]
};

const FarFlask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlask",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 196.8c0 20.7-5.8 41-16.6 58.7L119.7 320h208.6l-39.7-64.5c-10.9-17.7-16.6-38-16.6-58.7V48h-96v148.8zM320 48v148.8c0 11.8 3.3 23.5 9.5 33.5l108.2 175.9a69.54 69.54 0 0 1 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4l108.2-175.8c6.2-10.1 9.5-21.7 9.5-33.5V48h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8z"
        }
    ]
};

const FarFlatbreadStuffed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlatbreadStuffed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.2 4c-12.8-7-28.7-4.5-38.7 6.1l-46.9 49.8c-4.6 4.9-10.5 8.2-17.1 9.5l-67.1 13.3c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2l-42.8 53.3c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l55.9-55.9C121.1 316.3 112 291.2 112 264c0-66.3 53.7-120 120-120 27.2 0 52.3 9.1 72.5 24.3L424.4 48.4c4.6-4.6 10-8.3 15.8-11.1-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6.8-13.3-.5-19.2-3.7L272.2 4zM159.3 313.5l122.2-122.2c-14.1-9.7-31.1-15.3-49.5-15.3-48.6 0-88 39.4-88 88 0 18.4 5.6 35.4 15.3 49.5zM275 243l-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4c45.8 36.4 102.3 61.3 167 61.3 150.2 0 272-121.8 272-272 0-64.7-24.9-121.2-61.2-166.9-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86zm120-52 43-43 23-23c21.8 34 35 72.7 35 115 0 123.7-100.3 224-224 224-42.4 0-81-13.2-115-35l66-66 86-86 86-86zm-99 209a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarFlatbread = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlatbread",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm361-71L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L327 151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm-120-74c9.4 9.4 9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96c9.4-9.4 24.6-9.4 33.9 0zm160 194-96 96c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarFloppyDiskCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFloppyDiskCircleArrowRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 96v320c0 8.8 7.2 16 16 16h204c6.9 17.5 16.4 33.7 28.2 48H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9-74.6-74.4-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7-10.9 0-21.6 1-32 2.9v-24.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM256 368c0 2.5.1 4.9.2 7.4-9.4 5.5-20.4 8.6-32.2 8.6-35.3 0-64-28.7-64-64s28.7-64 64-64c22.1 0 41.6 11.2 53.1 28.3-13.4 24.9-21.1 53.4-21.1 83.7zM128 80v80h144V80H128zm160 288a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6l28.7 28.7H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FarFloppyDiskCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFloppyDiskCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 96v320c0 8.8 7.2 16 16 16h204c6.9 17.5 16.4 33.7 28.2 48H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9-74.6-74.4-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7-10.9 0-21.6 1-32 2.9v-24.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM256 368c0 2.5.1 4.9.2 7.4-9.4 5.5-20.4 8.6-32.2 8.6-35.3 0-64-28.7-64-64s28.7-64 64-64c22.1 0 41.6 11.2 53.1 28.3-13.4 24.9-21.1 53.4-21.1 83.7zM128 80v80h144V80H128zm304 144a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144 36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368z"
        }
    ]
};

const FarFloppyDiskPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFloppyDiskPen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 96v320c0 8.8 7.2 16 16 16h206.5l-12 48H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9-74.6-74.4-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3v65.1l-48 48V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM128 80v80h144V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm389.8-84.2 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417.1l129.2-129.2 71 71-129.2 129.2c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FarFloppyDisk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFloppyDisk",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 96v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9-74.6-74.4-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80h144V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarFloppyDisks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFloppyDisks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 352c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V138.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9-33.9 33.9-74.5-74.5-.8-.8V120c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V48h-16c-8.8 0-16 7.2-16 16v288zM224 0h149.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h64zm0 48v48h112V48H224zM48 120v256c0 48.6 39.4 88 88 88h256c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm192 136a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarFlorinSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlorinSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M315.3 32c-36 0-68.3 21.9-81.7 55.3L179 224H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h103.8l-54 134.9C99.7 422 85 432 68.7 432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h44.7c36 0 68.3-21.9 81.7-55.3l61-152.7H328c13.3 0 24-10.7 24-24s-10.7-24-24-24h-97.4l47.5-118.9C284.3 90 299 80 315.3 80H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-44.7z"
        }
    ]
};

const FarFlowerDaffodil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlowerDaffodil",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 88c0-48.6 39.4-88 88-88 21.3 0 40.8 7.6 56 20.1C271.2 7.6 290.7 0 312 0c48.6 0 88 39.4 88 88 0 21.3-7.6 40.8-20.1 56 12.6 15.2 20.1 34.7 20.1 56 0 48.6-39.4 88-88 88-11.3 0-22.1-2.1-32-6v91.4c41-52 104.6-85.4 176-85.4h28c15.5 0 28 12.5 28 28 0 108.2-87.8 196-196 196H196C87.8 512 0 424.2 0 316c0-15.5 12.5-28 28-28h28c71.4 0 135 33.4 176 85.4V282c-9.9 3.9-20.7 6-32 6-48.6 0-88-39.4-88-88 0-21.3 7.6-40.8 20.1-56-12.5-15.2-20.1-34.7-20.1-56zm88-40c-22.1 0-40 17.9-40 40 0 15 8.3 28.2 20.6 35 7.6 4.2 12.4 12.3 12.4 21s-4.7 16.8-12.4 21c-12.4 6.9-20.6 20-20.6 35 0 22.1 17.9 40 40 40 15 0 28.2-8.3 35-20.6 4.2-7.6 12.3-12.4 21-12.4s16.8 4.7 21 12.4c6.9 12.4 20 20.6 35 20.6 22.1 0 40-17.9 40-40 0-15-8.3-28.2-20.6-35-7.6-4.2-12.4-12.3-12.4-21s4.7-16.8 12.4-21c12.4-6.9 20.6-20 20.6-35 0-22.1-17.9-40-40-40-15 0-28.2 8.3-35 20.6-4.2 7.7-12.3 12.4-21 12.4s-16.8-4.7-21-12.4C228.2 56.3 215 48 200 48zM49.3 336C59.1 408.3 121 464 196 464h29.4C204.5 390.1 136.6 336 56 336h-6.7zm413.3 0H456c-80.6 0-148.5 54.1-169.4 128H316c75 0 136.9-55.7 146.7-128zM256 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarFlowerTulip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlowerTulip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M273.9 8.1C269.4 2.9 262.9 0 256 0s-13.4 2.9-17.9 8.1L189 63.3l-54.3-42.2c-7.2-5.6-17-6.6-25.3-2.6S96 30.8 96 40v112c0 75.1 60.9 136 136 136v85.4c-41-52-104.6-85.4-176-85.4H28c-15.5 0-28 12.5-28 28 0 108.2 87.8 196 196 196h120c108.2 0 196-87.8 196-196 0-15.5-12.5-28-28-28h-28c-71.4 0-135 33.4-176 85.4V288c75.1 0 136-60.9 136-136V40c0-9.2-5.2-17.5-13.5-21.6s-18-3-25.3 2.6L323 63.3 273.9 8.1zM280 240h-48c-48.6 0-88-39.4-88-88V89.1l33.3 25.9c10 7.8 24.3 6.5 32.7-3l46-51.9 46.1 51.8c8.4 9.5 22.7 10.8 32.7 3L368 89.1V152c0 48.6-39.4 88-88 88zm-84 224c-75 0-136.9-55.7-146.7-128H56c80.6 0 148.5 54.1 169.4 128H196zm120 0h-29.4c20.9-73.9 88.8-128 169.4-128h6.7C452.9 408.3 391 464 316 464z"
        }
    ]
};

const FarFlower = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlower",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 168c0 33.6-12.2 64.3-32.3 88 20.1 23.7 32.3 54.4 32.3 88 0 75.1-60.9 136-136 136-33.6 0-64.3-12.2-88-32.3-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168 0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zm-255.1-67.1C177.6 87.8 157.8 80 136 80c-48.6 0-88 39.4-88 88 0 21.8 7.8 41.6 20.9 56.9 15.2 17.9 15.2 44.2 0 62.2C55.8 302.4 48 322.2 48 344c0 48.6 39.4 88 88 88 21.8 0 41.6-7.8 56.9-20.9 17.9-15.2 44.2-15.2 62.2 0 15.3 13.1 35.1 20.9 56.9 20.9 48.6 0 88-39.4 88-88 0-21.8-7.8-41.6-20.9-56.9-15.2-17.9-15.2-44.2 0-62.2 13.1-15.3 20.9-35.1 20.9-56.9 0-48.6-39.4-88-88-88-21.8 0-41.6 7.8-56.9 20.9-17.9 15.2-44.2 15.2-62.2 0zM256 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FarFlute = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlute",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 304h432c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H144v96zm-48 0v-96H64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32zM64 160h512c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64zm256 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarFluxCapacitor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFluxCapacitor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm219.3 221.3c6.6 1.8 13.6 2.7 20.7 2.7 44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7l-49-49c-15.6-15.6-15.6-40.9 0-56.6s40.9-15.6 56.6 0l51.7 51.7 51.7-51.7c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-49 49zm-102.9 15.6c-21.9 14.3-36.4 39-36.4 67.1 0 44.2 35.8 80 80 80s80-35.8 80-80c0-28.1-14.5-52.8-36.4-67.1l-3.6 3.6V336c0 22.1-17.9 40-40 40s-40-17.9-40-40v-63.4l-3.6-3.6zm-25.1-104.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l75.3 75.3V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-73.4l75.3-75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-68.7-68.7z"
        }
    ]
};

const FarFlyingDisc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFlyingDisc",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M486.4 89.6c7.9 7.9 16.9 31.4.6 80.4-15.3 45.9-49.5 101-100.7 152.2S279.9 407.6 234 422.9c-49 16.3-72.5 7.3-80.4-.6-5.6-5.6-11.8-19.2-9-44.3 19.9 19.2 45.3 20.8 62.5 18.9 18.1-2 36.3-8.8 52.8-17 33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8 1.9-17.2.3-42.6-18.9-62.5 25.1-2.8 38.7 3.3 44.3 9zm-285.2 85.8c-96.9 106.5-133.6 228.8-81.5 280.9 55.3 55.3 189.8 10.5 300.5-100.2S575.6 111 520.3 55.7c-52.1-52.1-174.4-15.4-280.8 81.4-6.6 6-13.2 12.2-19.7 18.7s-12.7 13-18.6 19.6zm35.6 32.2c5.4-6 11.1-11.9 17-17.8s11.9-11.6 17.9-17c57.9-52.3 116.2-78.4 135.5-59.1 21.4 21.4-12.7 90.1-76.1 153.4S199 364.5 177.7 343.2c-19.4-19.4 6.8-77.7 59.1-135.6z"
        }
    ]
};

const FarFolderArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24v102.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V200z"
        }
    ]
};

const FarFolderArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM280 376V273.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V376c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarFolderBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderBookmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c1.4 1.4 2.8 2.7 4.3 3.9V304c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L336 276l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5S416 310 416 304V144h32c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3z"
        }
    ]
};

const FarFolderClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderClosed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zM48 240h416v176c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V240zM285.7 93.7l-43-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3z"
        }
    ]
};

const FarFolderGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderGear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H289.9L247 53.1A71.983 71.983 0 0 0 196.1 32H64zM48 96c0-8.8 7.2-16 16-16h132.1c6.4 0 12.5 2.5 17 7l45.3 45.3c7.5 7.5 17.7 11.7 28.3 11.7H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96zm305.2 168.2c6.3-3.6 9.5-11.2 6.8-17.9-1.7-4.3-3.7-8.4-5.9-12.4l-2-3.5c-2.4-4-5.1-7.9-7.9-11.5-4.5-5.7-12.6-6.8-18.9-3.1l-1.2.7c-8 4.6-17.9 3.5-25.9-1.2s-14.1-12.7-14.1-21.9V192c0-7.3-4.9-13.8-12.2-14.8-5.2-.7-10.5-1.1-15.8-1.1s-10.7.4-15.8 1.1c-7.2 1-12.2 7.5-12.2 14.8v1.4c0 9.3-6.1 17.3-14.1 21.9s-17.9 5.8-25.9 1.2l-1.2-.7c-6.3-3.6-14.4-2.6-18.9 3.1-2.9 3.7-5.5 7.5-8 11.5l-2 3.4c-2.2 4-4.2 8.2-5.9 12.5-2.7 6.8.4 14.3 6.8 17.9l1.2.7c8 4.6 12 13.8 12 23.1s-4 18.4-12 23.1l-1.2.7c-6.3 3.6-9.5 11.2-6.8 17.9 1.7 4.3 3.7 8.4 5.9 12.4l2.1 3.6c2.4 4 5 7.8 7.9 11.5 4.5 5.7 12.6 6.8 18.9 3.1l1.2-.7c8-4.6 17.9-3.5 25.9 1.2s14.1 12.7 14.1 21.9v1.4c0 7.3 4.9 13.8 12.2 14.8 5.2.7 10.5 1.1 15.8 1.1s10.7-.4 15.8-1.1c7.2-1 12.2-7.5 12.2-14.8v-1.4c0-9.3 6.1-17.3 14.1-21.9s17.9-5.8 25.9-1.2l1.2.7c6.3 3.6 14.4 2.6 18.9-3.1 2.9-3.6 5.5-7.5 7.9-11.4l2.1-3.6c2.2-4 4.2-8.1 5.9-12.4 2.7-6.8-.4-14.3-6.8-17.9l-1.2-.7c-8-4.6-12-13.8-12-23.1s4-18.5 12-23.1l1.2-.7zM221 288a35 35 0 1 1 70 0 35 35 0 1 1-70 0z"
        }
    ]
};

const FarFolderGrid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderGrid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM104 240c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm128 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm128 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48z"
        }
    ]
};

const FarFolderHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM144 253.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FarFolderImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM160 208a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm155.2 9.6c-4.5-6-11.6-9.6-19.2-9.6s-14.7 3.6-19.2 9.6l-54.2 72.2-19.9-24.8c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S110.8 384 120 384h272c9.1 0 17.4-5.1 21.5-13.3s3.2-17.9-2.3-25.1l-96-128z"
        }
    ]
};

const FarFolderMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderMagnifyingGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM336 272c0-53-43-96-96-96s-96 43-96 96 43 96 96 96c17.8 0 34.4-4.8 48.7-13.2l38.3 38.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarFolderMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM224 256h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48z"
        }
    ]
};

const FarFolderMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarFolderMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM352 192c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V283.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V192z"
        }
    ]
};

const FarFolderOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1.1-32.1s-16.2-16-27.7-16H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16h117.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48v-32c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7l-26.5-26.6c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320z"
        }
    ]
};

const FarFolderPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FarFolderTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderTree",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24v368c0 30.9 25.1 56 56 56h200v-48H56c-4.4 0-8-3.6-8-8V160h208v-48H48V24zm288 152V48h44.1l17 17c9.6 9.6 22.6 15 36.2 15H528v96H336zM288 32v160c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H433.3c-.8 0-1.7-.3-2.3-.9L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32zm48 432V336h44.1l17 17c9.6 9.6 22.6 15 36.2 15H528v96H336zm-48-144v160c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H433.3c-.8 0-1.7-.3-2.3-.9l-21.7-21.7c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FarFolderUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderUser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16h-80c0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM320 256a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FarFolderXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolderXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.7 127.6c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h133.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9-33.9 33.9 42.9 42.9zm33.9-33.9-42.9-43c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM175 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarFolder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h132.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64-16c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z"
        }
    ]
};

const FarFolders = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFolders",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h117.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H512c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16zm-352 48h352c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7l-26.5-26.6c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FarFonduePot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFonduePot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m319 39.8-24 96c-2.9 11.5-11.6 20-22.2 23l-8.3 33.2h-33l10.2-41c-7.9-7.7-11.7-19.3-8.8-30.8l24-96C261.2 7.1 278.6-3.3 295.8 1s27.6 21.7 23.3 38.8zM381.9 160l-21.3 32h-38.5l33.2-49.8c-4.9-9.9-4.5-22.1 2.1-31.9l64-96C431.2-.5 451-4.4 465.8 5.4s18.7 29.7 8.9 44.4l-64 96c-6.6 9.9-17.7 14.9-28.7 14.2zM48 320c0 61.9 50.1 112 112 112h128c61.9 0 112-50.1 112-112v-48H192v24c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16c0-4.4-3.6-8-8-8s-8 3.6-8 8v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56H48v48zM0 256c0-17.7 14.3-32 32-32h456c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v48c0 52.3-25.1 98.8-64 128v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-15.3c-15.2 4.8-31.3 7.3-48 7.3H160c-16.7 0-32.8-2.6-48-7.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40C25.1 418.8 0 372.3 0 320v-64z"
        }
    ]
};

const FarFontAwesome = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFontAwesome",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v400c0 13.3 10.7 24 24 24s24-10.7 24-24V124.2l12.5-2.4c16.7-3.2 31.5-8.5 44.2-13.1 3.7-1.3 7.1-2.6 10.4-3.7 15.2-5.2 30.4-9.1 51.2-9.1 25.6 0 43 6 63.5 13.3l.5.2c20.9 7.4 44.8 15.9 79.1 15.9 32.4 0 53.7-6.8 90.5-19.6v237.2l-9.5 3.3c-41.5 14.4-55.2 19.2-81 19.2-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8-16.8 0-31 2-43.9 5-12.9 3-20.9 16-17.9 28.9s16 20.9 28.9 17.9c9.6-2.2 20.1-3.7 32.9-3.7 25.6 0 43 6 63.5 13.3l.5.2c20.9 7.4 44.8 15.9 79.1 15.9 34.4 0 56.4-7.7 97.8-22.2 7.5-2.6 15.5-5.4 24.4-8.5l16.2-5.5v-339l-31.5 10.9c-9.7 3.3-18.2 6.3-25.7 8.9-41.5 14.4-55.2 19.2-81 19.2-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8-27.8 0-48.5 5.5-66.6 11.6-4.9 1.7-9.3 3.3-13.6 4.8-11.9 4.3-22 7.9-34.7 10.3l-3.4.6V56z"
        }
    ]
};

const FarFontCase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFontCase",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M198.4 47.5C194.9 38.2 186 32 176 32s-18.9 6.2-22.4 15.5l-152 400c-4.7 12.4 1.5 26.3 13.9 31s26.3-1.5 31-13.9L83.1 368h185.8l36.7 96.5c4.7 12.4 18.6 18.6 31 13.9s18.6-18.6 13.9-31l-152-400zM250.7 320H101.4L176 123.6 250.7 320zM616 160c-13.3 0-24 10.7-24 24v8.8c-22.1-20.4-51.6-32.8-84-32.8-68.5 0-124 55.5-124 124v72c0 68.5 55.5 124 124 124 32.4 0 61.9-12.4 84-32.8v8.8c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zM432 284c0-42 34-76 76-76s76 34 76 76v72c0 42-34 76-76 76s-76-34-76-76v-72z"
        }
    ]
};

const FarFont = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFont",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.2 46.9c-3.7-9-12.4-14.9-22.2-14.9s-18.5 5.9-22.2 14.9L44.6 432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H96.5l32.7-80h189.7l32.7 80H312c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-20.6L246.2 46.9zM299.3 304H148.7L224 119.5 299.3 304z"
        }
    ]
};

const FarFootballHelmet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFootballHelmet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m434.6 185.3-159.5 19.9c-38.3 4.8-67.1 37.4-67.1 76 0 11.9 2.8 23.6 8.1 34.3l38.2 76.5c1.1 2.2 1.7 4.7 1.7 7.2v.9c0 8.8-7.2 16-16 16h-2.9c-2.2 0-4.3-.4-6.3-1.3l-93.9-40.2c-10-4.3-20.7-6.5-31.5-6.5H100c-22.7-31.5-36-70.1-36-112C64 150 150 64 256 64c81 0 150.4 50.2 178.6 121.3zm27.9 44.9c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16 123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1 5.7 7.1 14.4 10.9 23.5 10.9h14c4.3 0 8.6.9 12.6 2.6l93.9 40.2c8 3.4 16.5 5.2 25.2 5.2h2.9c35.3 0 64-28.7 64-64v-.9c0-9.9-2.3-19.7-6.8-28.6L288 352h39.7l9.6 50.9c10.1 54 57.2 93.1 112.1 93.1h17c25.2 0 45.6-20.4 45.6-45.6V368c0-26.5-21.5-48-48-48H354.3l-14-74.5 122.2-15.3zM321.7 320H272l-13-26c-2-4-3-8.4-3-12.8 0-14.4 10.7-26.6 25.1-28.4l27.4-3.4 13.2 70.6zm44.6 64-6-32H464c8.8 0 16 7.2 16 16v16H366.3zM480 416v34.4c0 7.5-6.1 13.6-13.6 13.6h-17c-32.7 0-61.6-19.3-74.7-48H480zm-304-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarFootball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFootball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M442.6 69.4c-32.9-5-63.1-7.4-90.7-7.4l98 98c.5-32.1-2.4-63.1-7.3-90.6zm-217 12.7c-55.4 20.5-93.3 55.2-118.6 96.5-20.6 33.7-33 72-39.5 110.9l156.1 156.1c23.2-3.4 44.1-8.8 62.8-15.8 55.4-20.5 93.3-55.2 118.6-96.5 20.6-33.7 33-72 39.5-110.9l-156.1-156c-23.2 3.4-44.1 8.8-62.8 15.8zM62.1 352c-.5 32.1 2.4 63.1 7.3 90.6 32.9 5 63.1 7.4 90.7 7.4l-98-98zm4-198.4c30.6-50 76.8-92 142.9-116.5 65.4-24.3 148.6-30.6 252.5-13.3 13 2.2 23.4 12.1 26.1 25.1 17.5 84.8 18.6 211.3-41.6 309.5-30.6 50-76.8 92-142.9 116.5-65.6 24.3-148.7 30.7-252.6 13.3-13-2.2-23.4-12.1-26.1-25.1C6.9 378.3 5.8 251.8 66 153.6zM297 151l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm-56 56 64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm-56 56 64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FarForkKnife = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarForkKnife",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M467.2 9.6c8 10.6 5.8 25.6-4.8 33.6l-122.7 92c-2.6 2-5.1 4.1-7.4 6.4l-1.9 1.9C318.6 155.3 312 171.3 312 188s6.6 32.7 18.4 44.5l6.5 6.5 6.5 6.5c11.9 11.9 27.9 18.5 44.6 18.5s32.7-6.6 44.5-18.4l1.9-1.9c2.3-2.3 4.5-4.8 6.4-7.4l92-122.7c8-10.6 23-12.8 33.6-4.8s12.8 23 4.8 33.6l-92 122.7c-3.3 4.4-7 8.6-10.9 12.6l-1.9 1.9c-20.8 20.8-49 32.5-78.4 32.5-24.5 0-48.1-8.1-67.3-22.8L105 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l215.7-215.8A110.87 110.87 0 0 1 264 188c0-29.4 11.7-57.6 32.5-78.4l1.9-1.9c3.9-3.9 8.1-7.6 12.6-10.9l122.7-92c10.6-8 25.6-5.8 33.6 4.8zM521 55c9.4 9.4 9.4 24.6 0 33.9L405 205c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L487 55c9.4-9.4 24.6-9.4 33.9 0zM382.2 343.9l123 127.4c9.2 9.5 8.9 24.7-.6 33.9s-24.7 8.9-33.9-.6L313.4 341.8l12.1-12.1c17.6 8.5 36.8 13.4 56.7 14.2zm-146.6-82.7L48 66.8v16.8c0 52.8 20.9 103.5 58.2 141l70.2 70.6c4.6 4.7 10.3 7.6 16.3 8.8l-36.3 36.3c-5-3.2-9.7-6.9-14-11.3l-70.3-70.5C25.9 212 0 149.1 0 83.6V35.2C0 15.8 15.8 0 35.2 0c9.6 0 18.7 3.9 25.3 10.8L232 188.3c0 21.7 5 42.9 14.4 62.1l-10.7 10.7z"
        }
    ]
};

const FarFork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFork",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M398.4 43.2c10.6-8 12.8-23 4.8-33.6s-23-12.8-33.6-4.8l-122.7 92c-4.4 3.3-8.6 7-12.6 10.9l-1.9 1.9c-20.8 20.8-32.5 49-32.5 78.4 0 24.5 8.1 48.1 22.8 67.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l215.8-215.7c19.2 14.7 42.8 22.8 67.3 22.8 29.4 0 57.6-11.7 78.4-32.5l1.9-1.9c3.9-3.9 7.6-8.1 10.9-12.6l92-122.7c8-10.6 5.8-25.6-4.8-33.6s-25.6-5.8-33.6 4.8l-92 122.7c-2 2.6-4.1 5.1-6.4 7.4l-1.9 1.9C356.7 257.4 340.7 264 324 264s-32.7-6.6-44.5-18.4l-6.5-6.5-6.5-6.5C254.6 220.7 248 204.7 248 188s6.6-32.7 18.4-44.5l1.9-1.9c2.3-2.3 4.8-4.5 7.4-6.4l122.7-92zM457 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L307 171c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L457 89z"
        }
    ]
};

const FarForklift = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarForklift",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 160h16V40c0-22.1 17.9-40 40-40h157c16.6 0 31.5 10.3 37.4 25.8l83 218.9c1.7 4.5 2.6 9.3 2.6 14.2v85.5c19.6 17.6 32 43.1 32 71.6 0 53-43 96-96 96s-96-43-96-96h-64c0 53-43 96-96 96S0 469 0 416V240c0-44.2 35.8-80 80-80zm160 80h120.3L287.4 48H144v123.4l96 68.6zm0 48c-10 0-19.8-3.1-27.9-8.9L112.6 208H80c-17.7 0-32 14.3-32 32v92.8c14.1-8.1 30.5-12.8 48-12.8 35.5 0 66.6 19.3 83.2 48h89.7c16.6-28.7 47.6-48 83.2-48 5.5 0 10.8.5 16 1.3V288H240zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm256 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM528 24v376h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarFort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFort",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 112v48c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-48H48zm176 48c0 5.5-.7 10.9-2 16h196c-1.3-5.1-2-10.5-2-16V24c0-13.3 10.7-24 24-24 7.1 0 13.4 3.1 17.8 7.9 3.8 4.3 6.2 9.9 6.2 16.1v40h40V24c0-6.2 2.3-11.8 6.2-16.1C514.6 3.1 520.9 0 528 0s13.4 3.1 17.8 7.9c3.8 4.3 6.2 9.9 6.2 16.1v40h40V24c0-6.2 2.3-11.8 6.2-16.1C602.6 3.1 608.9 0 616 0c13.3 0 24 10.7 24 24v136c0 23.7-12.9 44.4-32 55.4V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V215.4c-19.1-11-32-31.7-32-55.4V24C0 10.7 10.7 0 24 0c7.1 0 13.4 3.1 17.8 7.9C45.7 12.2 48 17.8 48 24v40h40V24c0-6.2 2.3-11.8 6.2-16.1C98.6 3.1 104.9 0 112 0s13.4 3.1 17.8 7.9c3.9 4.3 6.2 9.9 6.2 16.1v40h40V24c0-6.2 2.3-11.8 6.2-16.1C186.6 3.1 192.9 0 200 0c13.3 0 24 10.7 24 24v136zm160 304h64V224H192v240h64v-80c0-35.3 28.7-64 64-64s64 28.7 64 64v80zm112 0h48c8.8 0 16-7.2 16-16V224h-64v240zm-400 0h48V224H80v224c0 8.8 7.2 16 16 16zm464-288h16c8.8 0 16-7.2 16-16v-48H464v48c0 8.8 7.2 16 16 16h80z"
        }
    ]
};

const FarForwardFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarForwardFast",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 424c0 13.3-10.7 24-24 24s-24-10.7-24-24V287.9L273.4 440.6c-5.4 4.8-12.4 7.4-19.6 7.4-16.5 0-29.8-13.3-29.8-29.8V287.9L49.4 440.6C44 445.4 37 448 29.8 448 13.3 448 0 434.7 0 418.2V93.8C0 77.3 13.3 64 29.8 64c7.2 0 14.2 2.6 19.6 7.4L224 224.1V93.8c0-16.5 13.3-29.8 29.8-29.8 7.2 0 14.2 2.6 19.6 7.4L448 224.1V88c0-13.3 10.7-24 24-24s24 10.7 24 24v336zM48 133.9v244.2L187.6 256 48 133.9zm224 244.2L411.6 256 272 133.9v244.2z"
        }
    ]
};

const FarForwardStep = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarForwardStep",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 88c0-13.3 10.7-24 24-24s24 10.7 24 24v336c0 13.3-10.7 24-24 24s-24-10.7-24-24V318.9L63.3 442.6c-5.1 3.5-11.1 5.4-17.3 5.4-16.5 0-30-13.5-30-30.1V94.1C16 77.5 29.5 64 46.1 64c6.2 0 12.2 1.9 17.3 5.4L240 193.1V88zm0 172.3v-8.6L64 128.5v255l176-123.2z"
        }
    ]
};

const FarForward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarForward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 94c0-16.6 13.5-30 30-30 6.3 0 12.5 2 17.6 5.7l230.5 166.9c6.2 4.5 9.9 11.7 9.9 19.4s-3.7 14.9-9.9 19.4L271.7 442.3c-5.1 3.7-11.3 5.7-17.6 5.7-16.6 0-30-13.4-30-30v-99.1L47.3 442.6c-5.1 3.5-11.1 5.4-17.3 5.4-16.5 0-30-13.5-30-30.1V94.1C0 77.5 13.5 64 30.1 64c6.2 0 12.2 1.9 17.3 5.4L224 193.1V94zm0 157.7L48 128.5v255l176-123.2v-8.6zm223.1 4.3L272 129.2v253.6L447.1 256z"
        }
    ]
};

const FarFrame = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFrame",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 120c0-13.3-10.7-24-24-24h-40V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H112V56c0-13.3-10.7-24-24-24S64 42.7 64 56v40H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v224H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h224v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V144h40c13.3 0 24-10.7 24-24zM112 368V144h224v224H112z"
        }
    ]
};

const FarFrancSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFrancSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 32c-13.3 0-24 10.7-24 24v264H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v88c0 13.3 10.7 24 24 24s24-10.7 24-24v-88h104c13.3 0 24-10.7 24-24s-10.7-24-24-24H96v-80h168c13.3 0 24-10.7 24-24s-10.7-24-24-24H96V80h200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
        }
    ]
};

const FarFrenchFries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFrenchFries",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M167.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l32 16c5.4 2.7 8.8 8.1 8.8 14.1v238c-9.2 1.4-19.8 2.2-32 2.2s-22.8-.8-32-2.2V16c0-5.5 2.9-10.7 7.6-13.6zM128 261c-4.8-2.1-8.7-4.4-11.8-6.6-12-8.4-16.7-18-18.7-24.3-.4-1.1-.8-2.3-1.2-3.4l-32-192c-1.2-6.9 2.3-13.8 8.6-16.9l32-16c4.5-2.3 9.9-2.3 14.4.1s7.7 6.6 8.5 11.6l.2 1.3V261zm-69.8-68c-3.2-.7-6.6-1-10.2-1H21.4c-1.6 0-3.2.1-4.7.2L.2 98.8c-.9-5.4.9-10.8 4.9-14.5s9.5-5.1 14.8-3.8l20.4 5.1L58.2 193zm309.1-.8c-1.6-.1-3.1-.2-4.7-.2H336c-3.1 0-6 .3-8.8.8l19-107.8 17.9-4.5c5.3-1.3 10.8.1 14.8 3.8s5.8 9.1 4.8 14.5l-16.5 93.4zM289.4 223c-1.1 2.4-2.1 4.7-2.8 7-2 6.3-6.7 15.9-18.7 24.3-3.2 2.2-7.1 4.5-11.8 6.6V54.6l.2-1.4c1-6.2 5.7-11.2 11.8-12.7l32-8c5.3-1.3 10.8.1 14.8 3.8s5.8 9.1 4.8 14.5L289.4 223zM48 224c8.8 0 16.3 7.2 18.9 15.7C74.3 263 100.3 304 192 304s117.7-41 125.1-64.3c2.7-8.4 10.1-15.7 18.9-15.7h26.6c11.8 0 21.4 9.6 21.4 21.4 0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5H89.2c-14.8 0-27.6-10.1-31.1-24.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224H48zm269.9 92.8c-1.4 1.1-2.8 2.1-4.3 3.1C284.7 340.1 244.9 352 192 352s-92.7-11.9-121.6-32.1c-1.5-1-2.9-2.1-4.3-3.1L101.8 464h180.4l35.7-147.2z"
        }
    ]
};

const FarFrog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFrog",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M322.4 113c-5.9 17.8-21.6 30.6-40.2 32.7C150.4 160.5 48 272.3 48 408v16c0 4.4 3.6 8 8 8h182.1c.3-.3.6-.7.9-1l56.8-56.8c10.4-10.3 16.2-24.4 16.2-39 0-30.5-24.7-55.2-55.2-55.2-14.6 0-28.7 5.8-39 16.2L169 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48.8-48.8c19.4-19.4 45.6-30.2 73-30.2 50.2 0 92 35.8 101.3 83.2 3-6.3 7.4-11.9 12.9-16.4 4.6-3.8 9.5-7.3 14.5-10.5l135.9-86.5c4.1-2.6 6.5-7.1 6.5-11.9 0-6.2-4-11.7-10-13.5L448 155c-16.8-5.2-29.5-19.1-32.9-36.4C410.6 96.5 391.2 80 368 80c-21.2 0-39.3 13.8-45.6 33zm111.7 258.3 54 58.1c1.5 1.6 3.6 2.6 5.9 2.6h58c13.3 0 24 10.7 24 24s-10.7 24-24 24h-58c-15.6 0-30.4-6.5-41-17.9l-23.5-25.3-28.7-31-16.4-17.6-16.4-17.6-12.6 13.4-20.3 21.8-24.2 26.2H360c4.7 0 9.2 1.4 12.9 3.7 6.7 4.3 11.1 11.8 11.1 20.3 0 .8 0 1.5-.1 2.3-1.2 12.2-11.4 21.7-23.9 21.7H56c-30.9 0-56-25.1-56-56v-16C0 247.6 121.1 115.5 276.8 98c12.6-38.3 48.7-66 91.2-66 46.5 0 85.3 33.1 94.1 77l70 21.5c26.1 8 43.9 32.1 43.9 59.4 0 21.2-10.9 41-28.8 52.4l-105.2 67-30.7 19.6c-3.5 2.2-6.8 4.6-9.9 7.2l1.7 1.9 31 33.4zM368 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarFunction = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFunction",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 88c0-48.6 39.4-88 88-88h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c-22.1 0-40 17.9-40 40v104h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v150.7c0 44.8-33.7 82.5-78.3 87.5l-15.1 1.7c-13.2 1.5-25-8-26.5-21.2s8-25 21.2-26.5l15.1-1.7c20.3-2.3 35.6-19.4 35.6-39.8V240H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V88zm244.3 76.8C288.4 209.1 272 262.5 272 320s16.4 110.9 44.3 155.2c7.1 11.2 3.7 26-7.5 33.1s-26 3.7-33.1-7.5C243 448.9 224 386.7 224 320s19-128.9 51.7-180.8c7.1-11.2 21.9-14.6 33.1-7.5s14.6 21.9 7.5 33.1zm231.4 0c-7.1-11.2-3.7-26 7.5-33.1s26-3.7 33.1 7.5C621 191.1 640 253.3 640 320s-19 128.9-51.7 180.8c-7.1 11.2-21.9 14.6-33.1 7.5s-14.6-21.9-7.5-33.1C575.6 430.9 592 377.5 592 320s-16.4-110.9-44.3-155.2zM393 247l39 39 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FarFutbol = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarFutbol",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m435.4 361.3-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2l76-47.9c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l76.1 47.9c-3 30.8-12.7 59.7-27.6 85.1zM256 48h.9-1.8.9zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.7 2-4 2.9l4-2.9zm75.2-226.6-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
        }
    ]
};

const FarG = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarG",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 80c-97.2 0-176 78.8-176 176s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152h-149c-13.3 0-24-10.7-24-24s10.7-24 24-24H408c21.6 0 41.2 17.9 39.3 41.9C438.2 389.3 341.7 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57 9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C310.2 96.9 269.1 80 224 80z"
        }
    ]
};

const FarGalaxy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGalaxy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 184c0-68.3 50.4-124.9 116.1-134.5-31.2 28.4-51.6 66.6-58 108.1-1.4 9.3 2.7 18.6 10.6 23.7s18.1 5.2 26 .1C275.9 167.8 301 160 328 160c68.3 0 124.9 50.4 134.5 116.1-28.4-31.2-66.6-51.6-108.1-58-9.3-1.4-18.6 2.7-23.7 10.6s-5.2 18.1-.1 26C344.2 275.9 352 301 352 328c0 68.3-50.4 124.9-116.1 134.5 31.2-28.4 51.6-66.6 58-108.1 1.4-9.3-2.7-18.6-10.6-23.7s-18.1-5.2-26-.1C236.1 344.2 211 352 184 352c-68.3 0-124.9-50.4-134.5-116.1 28.4 31.2 66.6 51.6 108.1 58 9.3 1.4 18.6-2.7 23.7-10.6s5.2-18.1.1-26C167.8 236.1 160 211 160 184zM296 0C194.4 0 112 82.4 112 184c0 15.9 2 31.3 5.8 46-16.4-9.4-30.8-22.2-42.2-37.9l-13-17.9c-6.5-9-16.9-14.2-28-14.2C15.5 160 0 175.5 0 194.6V216c0 101.6 82.4 184 184 184 15.9 0 31.3-2 46-5.8-9.4 16.4-22.2 30.8-37.9 42.2l-17.9 13c-9 6.5-14.2 16.9-14.2 28 0 19.1 15.5 34.6 34.6 34.6H216c101.6 0 184-82.4 184-184 0-15.9-2-31.3-5.8-46 16.4 9.4 30.8 22.2 42.2 37.9l13 17.9c6.5 9 16.9 14.2 28 14.2 19.1 0 34.6-15.5 34.6-34.6V296c0-101.6-82.4-184-184-184-15.9 0-31.3 2-46 5.8 9.4-16.4 22.2-30.8 37.9-42.2l17.9-13-14-19.3 14 19.3c9-6.5 14.2-16.9 14.2-28C352 15.5 336.5 0 317.4 0H296zm-40 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarGalleryThumbnails = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGalleryThumbnails",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 48c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h448zM64 0C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM0 448v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32zm128 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32z"
        }
    ]
};

const FarGameBoardSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGameBoardSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm16 80v144h144V112H80zm144 144v144h144V256H224z"
        }
    ]
};

const FarGameBoard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGameBoard",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm240 64h-80v80h-80V96H64v80h80v80H64v80h80v80h80v-80h80v80h80v-80h-80v-80h80v-80h-80V96zm-80 160v80h-80v-80h80zm0 0v-80h80v80h-80z"
        }
    ]
};

const FarGameConsoleHandheldCrank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGameConsoleHandheldCrank",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H96zM32 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v176h32V168c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24h-24v72c0 13.3-10.7 24-24 24h-56v96c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V96zm128 32h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm16 160c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16zm120 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarGameConsoleHandheld = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGameConsoleHandheld",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v352c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v352c0 53-43 96-96 96H96c-53 0-96-43-96-96V64zm232 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-128-24c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16zM112 96h160c8.8 0 16 7.2 16 16v112c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V112c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarGamepadModern = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGamepadModern",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 336h208c22 0 41.2 15 46.6 36.4l3.6 14.3c6.7 26.6 30.6 45.3 58 45.3 33 0 59.8-26.8 59.8-59.8v-2.8c0-3.5-.3-7.1-.9-10.6L558.4 168c-6.2-36-27.8-60.4-54.6-67.1C461.4 90.3 399.7 80 320 80s-141.5 10.3-183.7 20.9c-26.9 6.7-48.5 31.1-54.7 67.1L48.9 358.8c-.6 3.5-.9 7-.9 10.6v2.8c0 33 26.8 59.8 59.8 59.8 27.4 0 51.4-18.7 58-45.3l3.6-14.3C174.8 351 194 336 216 336zm211.6 62.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3.5-12.5 1.6-18.7l32.7-190.9c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM232 168v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-32c0-13.3 10.7-24 24-24s24 10.7 24 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarGamepad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGamepad",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 112c-79.5 0-144 64.5-144 144s64.5 144 144 144h256c79.5 0 144-64.5 144-144s-64.5-144-144-144H192zM0 256C0 150 86 64 192 64h256c106 0 192 86 192 192s-86 192-192 192H192C86 448 0 362 0 256zm232-56v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-32c0-13.3 10.7-24 24-24s24 10.7 24 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarGarageCar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGarageCar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323 51.1a7.8 7.8 0 0 0-6 0l-254 103c-9.1 3.7-15 12.5-15 22.2V488c0 13.3-10.7 24-24 24S0 501.3 0 488V176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 240v248c0 13.3-10.7 24-24 24s-24-10.7-24-24V232c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v256c0 13.3-10.7 24-24 24s-24-10.7-24-24V240H144zm127.9 85.9-7 26.1H375l-7.5-26.2c-1-3.4-4.1-5.8-7.7-5.8h-80.2c-3.6 0-6.8 2.4-7.7 5.9zm-59.7 37 4.6-17.2 8.7-32.3c6.6-24.4 28.8-41.4 54.1-41.4h80.2c25 0 47 16.6 53.8 40.6l9.4 32.8 5.1 17.8C445 374.7 456 394.1 456 416v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H232v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72c0-22.1 11.2-41.5 28.2-53zM408 416c0-8.8-7.2-16-16-16H248c-8.8 0-16 7.2-16 16v16h176v-16z"
        }
    ]
};

const FarGarageOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGarageOpen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323 51.1a7.8 7.8 0 0 0-6 0l-254 103c-9.1 3.7-15 12.5-15 22.2V488c0 13.3-10.7 24-24 24S0 501.3 0 488V176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 320v168c0 13.3-10.7 24-24 24s-24-10.7-24-24V232c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v256c0 13.3-10.7 24-24 24s-24-10.7-24-24V320H144zm0-48h352v-32H144v32zm88 144v16h176v-16c0-8.8-7.2-16-16-16H248c-8.8 0-16 7.2-16 16zm0 64v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72c0-35.3 28.7-64 64-64h144c35.3 0 64 28.7 64 64v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H232z"
        }
    ]
};

const FarGarage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGarage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323 51.1a7.8 7.8 0 0 0-6 0l-254 103c-9.1 3.7-15 12.5-15 22.2V488c0 13.3-10.7 24-24 24S0 501.3 0 488V176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 368v120c0 13.3-10.7 24-24 24s-24-10.7-24-24V232c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v256c0 13.3-10.7 24-24 24s-24-10.7-24-24V368H144zm0-48h352v-80H144v80zm136 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarGarlic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGarlic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M376 131.2c-15.2-12.1-24-30.5-24-50V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v33.2c0 19.4-8.8 37.8-24 50l-83.3 66.6C19.4 224.5 0 264.8 0 307.5 0 385.1 62.9 448 140.5 448H136v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h16v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h16v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h16v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h-4.5c77.6 0 140.5-62.9 140.5-140.5 0-42.7-19.4-83-52.7-109.7L376 131.2zm-168-56V48h32v27.2c0 48.1 15 95 43 134.1l17.4 24.4c12.7 17.8 19.6 39.2 19.6 61.1v9.2c0 53-43 96-96 96s-96-43-96-96v-9.2c0-21.9 6.8-43.3 19.6-61.1l17.4-24.4c24.1-33.7 38.6-73.2 42.1-114.2.6-4.6.9-9.2.9-13.9v-6zM272 48h32v33.2c0 34 15.5 66.2 42 87.5l83.3 66.6c21.9 17.6 34.7 44.1 34.7 72.2 0 51.1-41.4 92.5-92.5 92.5h-62.8c26.6-23.5 43.3-57.8 43.3-96v-9.2c0-28.6-8.9-56.5-25.5-79.7L309 190.7c-24.1-33.7-37-74.1-37-115.5V48zM139.3 400c-50.5-.6-91.3-41.8-91.3-92.5 0-28.1 12.8-54.7 34.7-72.2l57-45.6c-.2.3-.5.6-.7 1l-17.4 24.4C104.9 238.4 96 266.2 96 294.8v9.2c0 38.2 16.8 72.5 43.3 96z"
        }
    ]
};

const FarGasPumpSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGasPumpSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-67.2-52.7C571.4 404.9 576 391 576 376V155.9c0-19.1-7.6-37.4-21.1-50.9L481 31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33 33V160c0 29.8 20.4 54.9 48 62v154c0 3.8-.9 7.4-2.5 10.6L384 275.7V64c0-35.3-28.7-64-64-64H160c-30.9 0-56.7 21.9-62.7 51L38.8 5.1zM144 87.6V64c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v174L144 87.6zm0 376.4V209.5l-48-37.9V464h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-65.5l-48-37.8V464H144z"
        }
    ]
};

const FarGasPump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGasPump",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48c8.8 0 16 7.2 16 16v128H80V64c0-8.8 7.2-16 16-16h160zm16 192v224H80V240h192zM32 64v400h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V304h8c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V155.9c0-19.1-7.6-37.4-21.1-50.9L417 31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33 33V160c0 29.8 20.4 54.9 48 62v154c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64z"
        }
    ]
};

const FarGaugeCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeCircleBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c29.4 0 57.3-6.1 82.6-17.1 7.4 14.7 16.7 28.2 27.7 40.1-33.3 16-70.8 25-110.3 25C114.6 512 0 397.4 0 256S114.6 0 256 0c119.4 0 219.6 81.7 248 192.2-2.6-.1-5.3-.2-8-.2-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56 0-22.3 13.1-41.6 32-50.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v181.4c18.9 9 32 28.3 32 50.6 0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.7 5-1.7 11.1 2.6 14.9s10.6 4 15.1.6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2h-35.6l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"
        }
    ]
};

const FarGaugeCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeCircleMinus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c29.4 0 57.3-6.1 82.6-17.1 7.4 14.7 16.7 28.2 27.7 40.1-33.3 16-70.8 25-110.3 25C114.6 512 0 397.4 0 256S114.6 0 256 0c119.4 0 219.6 81.7 248 192.2-2.6-.1-5.3-.2-8-.2-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56 0-22.3 13.1-41.6 32-50.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v181.4c18.9 9 32 28.3 32 50.6 0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 208a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm224 0c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FarGaugeCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c29.4 0 57.3-6.1 82.6-17.1 7.4 14.7 16.7 28.2 27.7 40.1-33.3 16-70.8 25-110.3 25C114.6 512 0 397.4 0 256S114.6 0 256 0c119.4 0 219.6 81.7 248 192.2-2.6-.1-5.3-.2-8-.2-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56 0-22.3 13.1-41.6 32-50.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v181.4c18.9 9 32 28.3 32 50.6 0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FarGaugeHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeHigh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm32-400a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 296c30.9 0 56-25.1 56-56 0-14-5.1-26.8-13.7-36.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3.2-31.6 12.3L254.4 296c-30.2.8-54.4 25.6-54.4 56 0 30.9 25.1 56 56 56zm-64-248a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-80 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm320-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarGaugeLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm32 112a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 296c-30.9 0-56-25.1-56-56 0-14 5.1-26.8 13.7-36.6L146 161.7c-5.3-12.1.2-26.3 12.3-31.6s26.3.2 31.6 12.3L257.6 296c30.2.8 54.4 25.6 54.4 56 0 30.9-25.1 56-56 56zm128-248a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-256 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FarGaugeMax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeMax",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm32 112a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 296c-30.9 0-56-25.1-56-56s25.1-56 56-56c10.3 0 19.9 2.8 28.2 7.6l110.2-75.4c10.9-7.5 25.9-4.7 33.4 6.3s4.7 25.9-6.3 33.4l-110.2 75.3c.4 2.9.7 5.8.7 8.8 0 30.9-25.1 56-56 56zm128-248a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-272 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80-64a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FarGaugeMin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeMin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm32-400a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 296c30.9 0 56-25.1 56-56s-25.1-56-56-56c-10.3 0-19.9 2.8-28.2 7.6l-110.2-75.4c-10.9-7.5-25.9-4.7-33.4 6.3s-4.7 25.9 6.3 33.4l110.2 75.4c-.4 2.9-.7 5.8-.7 8.8 0 30.9 25.1 56 56 56zm-64-248a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm208 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarGaugeSimpleHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeSimpleHigh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm56-160c0-14-5.1-26.8-13.7-36.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3.2-31.6 12.3L254.4 296c-30.2.8-54.4 25.6-54.4 56 0 30.9 25.1 56 56 56s56-25.1 56-56z"
        }
    ]
};

const FarGaugeSimpleLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeSimpleLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-56 352c0-14 5.1-26.8 13.7-36.6L146 161.7c-5.3-12.1.2-26.3 12.3-31.6s26.3.2 31.6 12.3L257.6 296c30.2.8 54.4 25.6 54.4 56 0 30.9-25.1 56-56 56s-56-25.1-56-56z"
        }
    ]
};

const FarGaugeSimpleMax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeSimpleMax",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm0-464a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-56 352c0-30.9 25.1-56 56-56 10.3 0 19.9 2.8 28.2 7.6l110.2-75.4c10.9-7.5 25.9-4.7 33.4 6.3s4.7 25.9-6.3 33.4l-110.2 75.3c.4 2.9.7 5.8.7 8.8 0 30.9-25.1 56-56 56s-56-25.1-56-56z"
        }
    ]
};

const FarGaugeSimpleMin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeSimpleMin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm56-160c0-30.9-25.1-56-56-56-10.3 0-19.9 2.8-28.2 7.6l-110.2-75.4c-10.9-7.5-25.9-4.7-33.4 6.3s-4.7 25.9 6.3 33.4l110.2 75.4c-.4 2.9-.7 5.8-.7 8.8 0 30.9 25.1 56 56 56s56-25.1 56-56z"
        }
    ]
};

const FarGaugeSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGaugeSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v181.4c-18.9 9-32 28.3-32 50.6 0 30.9 25.1 56 56 56s56-25.1 56-56z"
        }
    ]
};

const FarGauge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGauge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v181.4c-18.9 9-32 28.3-32 50.6 0 30.9 25.1 56 56 56s56-25.1 56-56zM160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarGavel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGavel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M313 7c9.3 9.3 9.4 24.3.2 33.7l158.1 158.1c9.4-9.2 24.4-9.1 33.7.2 9.4 9.4 9.4 24.6 0 33.9l-16.7 16.8L393 345l-16 16c-9.4 9.4-24.6 9.4-33.9 0-9-9-9.4-23.5-.9-32.9L184 169.9c-9.4 8.4-23.9 8.1-32.9-.9-9.4-9.4-9.4-24.6 0-33.9l16-16 95.2-95.3L279 7c9.4-9.4 24.6-9.4 33.9 0zm-33.8 67.7L217.9 136 376 294.1l61.3-61.3L279.2 74.7zm-55.8 179.9 33.9 33.9-49.8 49.8 7 7c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-48-48c-12.5-12.5-12.5-32.8 0-45.3l112-112c12.5-12.5 32.8-12.5 45.3 0l7 7 49.8-49.8zm-79.4 88L54.6 432 80 457.4l89.4-89.4-25.4-25.4z"
        }
    ]
};

const FarGearCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGearCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17 0 33.6 1.7 49.8 4.8 7.9 1.5 21.8 6.1 29.4 20.1 2 3.7 3.6 7.6 4.6 11.8l9.3 38.5c1.4 5.8 11.2 11.5 16.9 9.8l38-11.2c4-1.2 8.1-1.8 12.2-1.9 16.1-.5 27 9.4 32.3 15.4 22.1 25.1 39.1 54.6 49.9 86.3 2.6 7.6 5.6 21.8-2.7 35.4-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10 8.2 13.6 5.2 27.8 2.7 35.4-10.8 31.7-27.8 61.1-49.9 86.3-5.3 6-16.3 15.9-32.3 15.4-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8-7.7 14-21.6 18.5-29.4 20.1-16.2 3.1-32.8 4.8-49.8 4.8s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9-16.1.5-27-9.4-32.3-15.4-22-25.1-39.1-54.6-49.9-86.3-2.6-7.6-5.6-21.8 2.7-35.4 2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5l-28.8-27.3c-3.1-3-5.8-6.4-8-10-8.2-13.6-5.2-27.8-2.6-35.3 10.8-31.7 27.8-61.1 49.9-86.3 5.3-6 16.3-15.9 32.3-15.4 4.1.1 8.2.8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8 7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zm-37.9 51.4-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6l-34.5-10.2c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89l-26.2 24.9c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zm73.7 111.8-32 192c-1.8 10.9-12.1 18.3-23 16.4s-18.3-12.1-16.4-23l32-192c1.8-10.9 12.1-18.3 23-16.4s18.3 12.1 16.4 23zm-93.6 66.9L172.3 256l25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3l40-40c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm144-28.3 40 40c7.8 7.8 7.8 20.5 0 28.3l-40 40c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l25.8-25.8-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z"
        }
    ]
};

const FarGearComplexCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGearComplexCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M188.2 36.7C193.4 15.2 212.7 0 234.9 0h42.2c22.2 0 41.5 15.2 46.7 36.7L332 71l1.1.4 30-18.4c18.9-11.6 43.3-8.7 59 7l29.8 29.8c15.7 15.7 18.6 40.1 7 59l-18.4 30 .4 1.1 34.2 8.3c21.6 5.2 36.7 24.5 36.7 46.7v42.2c0 22.2-15.2 41.5-36.7 46.7L441 332l-.4 1.1 18.4 30c11.6 18.9 8.7 43.3-7 59l-29.8 29.8c-15.7 15.7-40.1 18.6-59 7l-30-18.4-1.2.5-8.3 34.2c-5.2 21.6-24.5 36.7-46.7 36.7h-42.1c-22.2 0-41.5-15.2-46.7-36.7L180 441l-1.1-.4-30 18.4c-18.9 11.6-43.3 8.7-59-7l-29.8-29.9c-15.7-15.7-18.6-40.1-7-59l18.4-30-.5-1.1-34.2-8.3C15.2 318.6 0 299.3 0 277.1v-42.2c0-22.2 15.2-41.5 36.7-46.7L71 180l.4-1.1-18.4-30c-11.6-18.9-8.7-43.3 7-59l29.9-29.8c15.7-15.7 40.1-18.6 59-7l30 18.4 1.1-.5 8.3-34.2zM277.1 48h-42.2l-11.3 46.6c-1.9 8-7.9 14.5-15.7 17.1-6.8 2.3-13.5 5-19.9 8.2-7.4 3.7-16.2 3.3-23.3-1L123.8 94 94 123.8l25 40.9c4.3 7.1 4.7 15.9 1 23.3-3.2 6.4-6 13-8.2 19.9-2.6 7.9-9.1 13.8-17.1 15.7L48 234.9v42.2l46.6 11.3c8 1.9 14.5 7.9 17.1 15.7 2.3 6.8 5 13.5 8.2 19.9 3.7 7.4 3.3 16.2-1 23.3L94 388.2l29.8 29.8 40.9-25c7.1-4.3 15.9-4.7 23.3-1 6.4 3.2 13 6 19.9 8.2 7.9 2.6 13.8 9.1 15.7 17.1l11.3 46.7h42.2l11.3-46.6c1.9-8 7.9-14.5 15.7-17.1 6.8-2.3 13.5-5 19.9-8.2 7.4-3.7 16.2-3.3 23.3 1l40.9 25 29.8-29.9-25-40.9c-4.3-7.1-4.7-15.9-1-23.3 3.2-6.4 6-13 8.2-19.9 2.6-7.9 9.1-13.8 17.1-15.7l46.7-11.3v-42.2l-46.6-11.3c-8-1.9-14.5-7.9-17.1-15.7-2.3-6.8-5-13.5-8.2-19.9-3.7-7.4-3.3-16.2 1-23.3l25-40.9L388.2 94l-40.9 25c-7.1 4.3-15.9 4.7-23.3 1-6.4-3.2-13-6-19.9-8.2-7.9-2.6-13.8-9.1-15.7-17.1L277.1 48zm14.6 115.3-32 192c-1.8 10.9-12.1 18.3-23 16.4s-18.3-12.1-16.4-23l32-192c1.8-10.9 12.1-18.3 23-16.4s18.3 12.1 16.4 23zm-93.6 66.9L172.3 256l25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3l40-40c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm144-28.3 40 40c7.8 7.8 7.8 20.5 0 28.3l-40 40c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l25.9-25.9-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z"
        }
    ]
};

const FarGearComplex = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGearComplex",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm48 96a48 48 0 1 1-96 0 48 48 0 1 1 96 0zM234.9 0c-22.2 0-41.5 15.2-46.7 36.7L180 71l-1.1.4-30-18.4c-18.9-11.6-43.3-8.7-59 7L60.1 89.9c-15.7 15.7-18.6 40.1-7 59l18.4 30-.5 1.1-34.2 8.3C15.2 193.4 0 212.7 0 234.9v42.2c0 22.2 15.2 41.5 36.7 46.7L71 332l.4 1.1-18.4 30c-11.6 18.9-8.7 43.3 7 59l29.8 29.8c15.7 15.7 40.1 18.6 59 7l30-18.4 1.1.4 8.3 34.2c5.2 21.6 24.5 36.7 46.7 36.7h42.2c22.2 0 41.5-15.2 46.7-36.7L332 441l1.1-.4 30 18.4c18.9 11.6 43.3 8.7 59-7l29.8-29.8c15.7-15.7 18.6-40.1 7-59l-18.4-30 .4-1.1 34.2-8.3c21.6-5.2 36.7-24.5 36.7-46.7v-42.2c0-22.2-15.2-41.5-36.7-46.7L441 180l-.4-1.1 18.4-30c11.6-18.9 8.7-43.3-7-59l-29.9-29.8c-15.7-15.7-40.1-18.6-59-7l-30 18.4-1.1-.5-8.3-34.2C318.6 15.2 299.3 0 277.1 0h-42.2zm0 48h42.2l11.3 46.6c1.9 8 7.9 14.5 15.7 17.1 6.8 2.3 13.5 5 19.9 8.2 7.4 3.7 16.2 3.3 23.3-1l40.9-25 29.8 29.9-25 40.9c-4.3 7.1-4.7 15.9-1 23.3 3.2 6.4 6 13 8.2 19.9 2.6 7.9 9.1 13.8 17.1 15.7l46.7 11.3v42.2l-46.6 11.3c-8 1.9-14.5 7.9-17.1 15.7-2.3 6.8-5 13.5-8.2 19.9-3.7 7.4-3.3 16.2 1 23.3l25 40.9-29.9 29.8-40.9-25c-7.1-4.3-15.9-4.7-23.3-1-6.4 3.2-13 6-19.9 8.2-7.9 2.6-13.8 9.1-15.7 17.1L277.1 464h-42.2l-11.3-46.6c-1.9-8-7.9-14.5-15.7-17.1-6.8-2.3-13.5-5-19.9-8.2-7.4-3.7-16.2-3.3-23.3 1l-40.9 25L94 388.2l25-40.9c4.3-7.1 4.7-15.9 1-23.3-3.2-6.4-6-13-8.2-19.9-2.6-7.9-9.1-13.8-17.1-15.7L48 277.1v-42.2l46.6-11.3c8-1.9 14.5-7.9 17.1-15.7 2.3-6.8 5-13.5 8.2-19.9 3.7-7.4 3.3-16.2-1-23.3L94 123.8 123.8 94l40.9 25c7.1 4.3 15.9 4.7 23.3 1 6.4-3.2 13-6 19.9-8.2 7.9-2.6 13.8-9.1 15.7-17.1L234.9 48z"
        }
    ]
};

const FarGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17 0 33.6 1.7 49.8 4.8 7.9 1.5 21.8 6.1 29.4 20.1 2 3.7 3.6 7.6 4.6 11.8l9.3 38.5c1.4 5.8 11.2 11.5 16.9 9.8l38-11.2c4-1.2 8.1-1.8 12.2-1.9 16.1-.5 27 9.4 32.3 15.4 22.1 25.1 39.1 54.6 49.9 86.3 2.6 7.6 5.6 21.8-2.7 35.4-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10 8.2 13.6 5.2 27.8 2.7 35.4-10.8 31.7-27.8 61.1-49.9 86.3-5.3 6-16.3 15.9-32.3 15.4-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8-7.7 14-21.6 18.5-29.4 20.1-16.2 3.1-32.8 4.8-49.8 4.8s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9-16.1.5-27-9.4-32.3-15.4-22-25.1-39.1-54.6-49.9-86.3-2.6-7.6-5.6-21.8 2.7-35.4 2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5l-28.8-27.3c-3.1-3-5.8-6.4-8-10-8.2-13.6-5.2-27.8-2.6-35.3 10.8-31.7 27.8-61.1 49.9-86.3 5.3-6 16.3-15.9 32.3-15.4 4.1.1 8.2.8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8 7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zm-37.9 51.4-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6l-34.5-10.2c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89l-26.2 24.9c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z"
        }
    ]
};

const FarGears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGears",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m147.1 52.7-6.5 23.5c-1.7 6.2-6.3 11.2-12.4 13.5-10 3.7-19.1 9-27.2 15.7-5 4.1-11.6 5.6-17.9 4l-23.6-6.2c-5 6.9-9.4 14.4-12.9 22.3l17.1 17.4c4.5 4.6 6.6 11.1 5.5 17.4-.9 5.1-1.3 10.3-1.3 15.7s.5 10.6 1.3 15.7c1.1 6.4-.9 12.9-5.5 17.4l-17 17.4c3.5 7.9 7.9 15.4 12.9 22.3l23.6-6.2c6.3-1.6 12.9-.1 17.9 4 8 6.7 17.2 12 27.2 15.7 6.1 2.2 10.7 7.2 12.4 13.5l6.5 23.5c4.2.4 8.5.7 12.9.7s8.7-.2 12.9-.7l6.5-23.5c1.7-6.2 6.3-11.2 12.4-13.5 10-3.7 19.1-9 27.2-15.7 5-4.1 11.6-5.6 17.9-4l23.6 6.2c5-6.9 9.4-14.4 12.9-22.3l-17.1-17.4c-4.5-4.6-6.6-11.1-5.5-17.4.9-5.1 1.3-10.3 1.3-15.7s-.5-10.6-1.3-15.7c-1.1-6.4.9-12.9 5.5-17.4l17.1-17.4c-3.5-7.9-7.9-15.4-12.9-22.3l-23.6 6.2c-6.3 1.6-12.9.1-17.9-4-8-6.7-17.2-12-27.2-15.7-6.1-2.2-10.7-7.2-12.4-13.5L173 52.7c-4.2-.4-8.5-.7-12.9-.7s-8.7.2-12.9.7zm-19.8-37.4c10.6-2.2 21.5-3.3 32.7-3.3s22.1 1.1 32.7 3.3c7.4 1.5 13.3 7 15.3 14.3l7.3 26.6c7.3 3.4 14.3 7.4 20.8 12l26.6-7c7.3-1.9 15 .4 20 6.1 14.4 16.3 25.7 35.5 32.8 56.7 2.4 7.1.6 15-4.7 20.4L291.5 164c.4 4 .5 8 .5 12s-.2 8-.5 12l19.4 19.6c5.3 5.4 7.1 13.2 4.7 20.4-7.1 21.2-18.3 40.4-32.8 56.7-5 5.6-12.7 8-20 6.1l-26.6-7c-6.5 4.6-13.5 8.6-20.8 12l-7.4 26.6c-2 7.3-7.9 12.8-15.3 14.3-10.6 2.1-21.5 3.3-32.7 3.3s-22.1-1.1-32.7-3.3c-7.4-1.5-13.3-7-15.3-14.3l-7.3-26.6c-7.3-3.4-14.3-7.4-20.8-12l-26.6 7c-7.3 1.9-15-.4-20-6.1-14.5-16.3-25.8-35.5-32.9-56.7-2.4-7.1-.6-15 4.7-20.4L28.5 188c-.4-4-.5-8-.5-12s.2-8 .5-12L9.2 144.4C3.9 139 2 131.1 4.4 124c7.1-21.2 18.3-40.4 32.8-56.7 5-5.6 12.7-8 20-6.1l26.6 7c6.5-4.6 13.5-8.6 20.8-12l7.4-26.6c2-7.3 7.9-12.8 15.3-14.3zM120 176a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm220.7 188.9 23.5 6.5c6.2 1.7 11.2 6.3 13.5 12.4 3.7 10 9 19.1 15.7 27.2 4.1 5 5.6 11.6 4 17.9l-6.2 23.6c6.9 5 14.4 9.4 22.3 12.9l17.4-17.1c4.6-4.5 11.1-6.6 17.4-5.5 5.1.9 10.3 1.3 15.7 1.3s10.6-.5 15.7-1.3c6.4-1.1 12.9.9 17.4 5.5l17.4 17.1c7.9-3.5 15.4-7.9 22.3-12.9l-6.2-23.6c-1.6-6.2-.1-12.9 4-17.9 6.7-8 12-17.2 15.7-27.2 2.2-6.1 7.2-10.7 13.5-12.4l23.5-6.5c.4-4.2.7-8.5.7-12.9s-.2-8.7-.7-12.9l-23.5-6.5c-6.2-1.7-11.2-6.3-13.5-12.4-3.7-10-9-19.1-15.7-27.2-4.1-5-5.6-11.6-4-17.9l6.2-23.6c-6.9-5-14.4-9.4-22.3-12.9l-17.4 17.1c-4.6 4.5-11.1 6.6-17.4 5.5-5.1-.9-10.3-1.3-15.7-1.3s-10.6.5-15.7 1.3c-6.4 1.1-12.9-.9-17.4-5.5l-17.4-17.1c-7.9 3.5-15.4 7.9-22.3 12.9l6.2 23.6c1.6 6.3.1 12.9-4 17.9-6.7 8-12 17.2-15.7 27.2-2.2 6.1-7.2 10.7-13.5 12.4l-23.5 6.5c-.4 4.2-.7 8.5-.7 12.9s.2 8.7.7 12.9zm-37.4 19.8c-2.1-10.6-3.3-21.5-3.3-32.7s1.1-22.1 3.3-32.7c1.5-7.4 7-13.3 14.3-15.3l26.6-7.3c3.4-7.3 7.4-14.3 12-20.8l-7-26.6c-1.9-7.3.4-15 6.1-20 16.3-14.4 35.5-25.7 56.7-32.8 7.1-2.4 15-.6 20.4 4.7l19.6 19.3c4-.4 8-.5 12-.5s8 .2 12 .5l19.6-19.4c5.4-5.3 13.2-7.1 20.4-4.7 21.2 7.1 40.4 18.3 56.7 32.8 5.6 5 8 12.7 6.1 20l-7 26.6c4.6 6.5 8.6 13.5 12 20.8l26.6 7.3c7.3 2 12.8 7.9 14.3 15.3 2.1 10.6 3.3 21.5 3.3 32.7s-1.1 22.1-3.3 32.7c-1.5 7.4-7 13.3-14.3 15.3l-26.6 7.3c-3.4 7.3-7.4 14.3-12 20.8l7 26.6c1.9 7.3-.5 15-6.1 20-16.3 14.4-35.5 25.7-56.7 32.8-7.1 2.4-15 .6-20.4-4.7L476 483.5c-4 .4-8 .5-12 .5s-8-.2-12-.5l-19.6 19.4c-5.4 5.3-13.2 7.1-20.4 4.7-21.2-7.1-40.4-18.3-56.7-32.8-5.6-5-8-12.7-6.1-20l7-26.6c-4.6-6.5-8.6-13.5-12-20.8l-26.6-7.4c-7.3-2-12.8-7.9-14.3-15.3zM464 392a40 40 0 1 1 0-80 40 40 0 1 1 0 80z"
        }
    ]
};

const FarGem = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGem",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m168.5 72 87.5 93 87.5-93h-175zm215.4 27.1L311.5 176h129l-56.6-76.9zm50 124.9H78.1L256 420.3 433.9 224zM71.5 176h129l-72.4-76.9L71.5 176zm434.3 40.1-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8h240c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"
        }
    ]
};

const FarGenderless = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGenderless",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"
        }
    ]
};

const FarGhost = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGhost",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 192v223.5c26.3-4.9 54.6 3.7 73.6 25.5l6.4 7.3 3.8-4.3c31.9-36.4 88.5-36.4 120.4 0l3.8 4.3 6.4-7.3c19.1-21.8 47.3-30.4 73.6-25.5V192c0-79.5-64.5-144-144-144S48 112.5 48 192zm208 320c-5.1 0-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-29.2-33.5c-11.6-13.3-32.1-14-44.5-1.5l-2.3 2.3c-4.2 4.2-10 6.6-16 6.6-12.6.1-22.7-10-22.7-22.5V192C0 86 86 0 192 0s192 86 192 192v265.4c0 12.5-10.1 22.6-22.6 22.6-6 0-11.8-2.4-16-6.6l-2.3-2.3c-12.5-12.5-32.9-11.8-44.5 1.5L269.3 506c-3.3 3.8-8.2 6-13.3 6zM96 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarGif = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGif",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm232 128c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm56 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-32h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88c-13.3 0-24 10.7-24 24zm-224 72c0-26.5 21.5-48 48-48 8 0 15.4 1.9 22 5.3 11.8 6.1 26.3 1.5 32.3-10.3s1.5-26.3-10.3-32.3c-13.2-6.8-28.2-10.7-44-10.7-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8 7-4.4 11.2-12.1 11.2-20.3V264c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v13.1c-5.3 1.9-10.6 2.9-16 2.9-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FarGiftCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGiftCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M353.5 68.8 318.7 128H392c22.1 0 40-17.9 40-40s-17.9-40-40-40h-2.2c-14.9 0-28.8 7.9-36.3 20.8zM288 197.5l-61.6 73.9c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8l53.9-64.7H64c-8.8 0-16 7.2-16 16v128h480V192c0-8.8-7.2-16-16-16H332.6l53.9 64.6c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1L288 197.5zM48 384v64c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16v-64H48zm208-256h1.3l-34.8-59.2C214.9 55.9 201.1 48 186.2 48H184c-22.1 0-40 17.9-40 40s17.9 40 40 40h72zm7.9-83.6 24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0h2.2c48.6 0 88 39.4 88 88 0 14.4-3.5 28-9.6 40H512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h41.6c-6.1-12-9.6-25.6-9.6-40 0-48.6 39.4-88 88-88h2.2c31.9 0 61.5 16.9 77.7 44.4z"
        }
    ]
};

const FarGift = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGift",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M231.9 44.4C215.7 16.9 186.1 0 154.2 0H152c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40H48c-26.5 0-48 21.5-48 48v64c0 20.9 13.4 38.7 32 45.3V448c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V285.3c18.6-6.6 32-24.4 32-45.3v-64c0-26.5-21.5-48-48-48h-25.6c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41zM464 176v64H288v-64h176zm-240 0v64H48v-64h176zm0 112v176H96c-8.8 0-16-7.2-16-16V288h144zm64 176V288h144v160c0 8.8-7.2 16-16 16H288zm72-336h-73.3l34.8-59.2c7.6-12.9 21.4-20.8 36.3-20.8h2.2c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-136 0h-72c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8l34.8 59.2H224z"
        }
    ]
};

const FarGifts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGifts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16l-10.7 30.2-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H64c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h136.6c-5.4-9.4-8.6-20.3-8.6-32v-16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h192.5c5.3-8.2 11.7-15.7 19-22.1C263.8 106.2 245.1 96 224 96h-6.2l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3l-25.4 18.5 8.1-23.1zm162.9 153.5 29.6 38.5H344c-13.3 0-24-10.7-24-24 0-13.1 10.8-24 24.2-24 7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24 0-39.9-32.5-72-72.2-72-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2-39.7 0-72.2 32.1-72.2 72zm0 72h136v72H272v-72zm0 120h136v72H272v-72zm320 0v72H456v-72h136zm-136-48v-72h136v72H456zm88-144c0 13.3-10.7 24-24 24h-49.1l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5 13.4 0 24.2 10.9 24.2 24z"
        }
    ]
};

const FarGingerbreadMan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGingerbreadMan",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 9.5-1.8 18.4-5.1 26.6-7.6 19 4.4 45.4 30.1 45.4h39c22.1 0 40 17.9 40 40s-17.9 40-40 40h-7c-39.2 0-60.7 45.6-35.8 75.9l41.7 50.7c14 17.1 11.6 42.3-5.5 56.3s-42.3 11.6-56.3-5.5l-37.3-45.3c-18.6-22.6-53.1-22.6-71.7 0l-37.3 45.3c-14 17.1-39.2 19.5-56.3 5.5S75 415.7 89 398.6l41.7-50.7c25-30.3 3.5-75.9-35.7-75.9h-7c-22.1 0-40-17.9-40-40s17.9-40 40-40h39c25.7 0 37.7-26.4 30.1-45.4-3.3-8.2-5.1-17.2-5.1-26.6zM224 0c-66.3 0-120 53.7-120 120 0 8.2.8 16.2 2.4 24H88c-48.6 0-88 39.4-88 88s39.4 88 88 88h3.6L52 368.1c-30.9 37.5-25.5 93 12 123.9l14.5-17.6L64.1 492c37.5 30.9 93 25.5 123.9-12l36-43.8 36 43.8c30.9 37.5 86.3 42.9 123.9 12s42.9-86.3 12-123.9L356.4 320h3.6c48.6 0 88-39.4 88-88s-39.4-88-88-88h-18.4c1.6-7.8 2.4-15.8 2.4-24C344 53.7 290.3 0 224 0zm0 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16-128a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 224a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarGlassCitrus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlassCitrus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 144c0-53-43-96-96-96-35.5 0-66.6 19.3-83.2 48h-52.6C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144 0 78.4-62.7 142.2-140.7 144l4.6-48.3c49.3-4 88.1-45.3 88.1-95.7zM6.2 135.9c4.5-5 11-7.9 17.8-7.9h304c6.8 0 13.2 2.9 17.8 7.9s6.8 11.7 6.1 18.4l-29.2 307C320 490 295.8 512 267 512H85.1c-28.9 0-53-21.9-55.7-50.7L.1 154.3c-.6-6.7 1.6-13.4 6.1-18.4zM62.6 304l14.5 152.8c.4 4.1 3.8 7.2 8 7.2h181.8c4.1 0 7.6-3.1 8-7.2L289.4 304H62.6zM58 256h236l7.6-80H50.4l7.6 80z"
        }
    ]
};

const FarGlassEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlassEmpty",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M6.3 7.8C10.9 2.8 17.3 0 24 0h336c6.7 0 13.1 2.8 17.7 7.8s6.8 11.6 6.2 18.3l-36.2 420.1c-3.2 37.2-34.4 65.8-71.7 65.8H108c-37.4 0-68.5-28.6-71.7-65.8L.1 26.1c-.6-6.7 1.7-13.4 6.2-18.3zM50.2 48l34 394.1c1 12.4 11.4 21.9 23.8 21.9h168c12.5 0 22.8-9.5 23.9-21.9L333.8 48H50.2z"
        }
    ]
};

const FarGlassHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlassHalf",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4.1 26.1l36.2 420.1C39.5 483.4 70.7 512 108 512h168c37.4 0 68.5-28.6 71.7-65.8l36.2-420.1c.6-6.7-1.7-13.3-6.2-18.3S366.7 0 360 0H24zm42.7 240L50.2 48h283.6l-16.5 192H66.7zm4.1 48h242.4l-13.3 154.1c-1.1 12.4-11.5 21.9-23.9 21.9H108c-12.5 0-22.8-9.5-23.9-21.9L70.8 288z"
        }
    ]
};

const FarGlassWaterDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlassWaterDroplet",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4.1 26.1l36.2 420.1C39.5 483.4 70.7 512 108 512h168c37.4 0 68.5-28.6 71.7-65.8l36.2-420.1c.6-6.7-1.7-13.3-6.2-18.3S366.7 0 360 0H24zm49.5 319.2L50.2 48h283.6l-23.3 271.2-9.3 5.2c-16.2 9-36.2 7.3-50.7-4.3-34.2-27.4-82.8-27.4-117 0-14.5 11.5-34.5 13.2-50.7 4.2l-9.3-5.2zm4.7 55c29 8.6 60.9 2.8 85.2-16.6 16.7-13.3 40.4-13.3 57 0 24.3 19.4 56.2 25.3 85.2 16.6l-5.9 67.9c-.9 12.4-11.3 21.9-23.7 21.9H108c-12.5 0-22.8-9.5-23.9-21.9l-5.9-67.9zM256 196c0-24-33.7-70.1-52.2-93.5-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
        }
    ]
};

const FarGlassWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlassWater",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4.1 26.1l36.2 420.1C39.5 483.4 70.7 512 108 512h168c37.4 0 68.5-28.6 71.7-65.8l36.2-420.1c.6-6.7-1.7-13.3-6.2-18.3S366.7 0 360 0H24zm33.6 134.3L50.2 48h283.6l-7.4 86.3-25.2 14c-16.2 9-36.2 7.3-50.7-4.3-34.2-27.4-82.8-27.4-117 0-14.5 11.6-34.5 13.3-50.7 4.3l-25.2-14zm5 57.6c32.7 16.6 72.1 12.6 100.9-10.4 16.7-13.3 40.4-13.3 57 0 28.8 23 68.3 27 100.9 10.4l-21.5 250.2c-1.1 12.4-11.5 21.9-23.9 21.9H108c-12.5 0-22.8-9.5-23.9-21.9L62.6 191.9z"
        }
    ]
};

const FarGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlass",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4.1 26.1l36.2 420.1C39.5 483.4 70.7 512 108 512h168c37.4 0 68.5-28.6 71.7-65.8l36.2-420.1c.6-6.7-1.7-13.3-6.2-18.3S366.7 0 360 0H24zm33.1 128-6.9-80h283.6l-6.9 80H57.1zm4.1 48h261.6l-22.9 266.1c-1.1 12.4-11.5 21.9-23.9 21.9H108c-12.5 0-22.8-9.5-23.9-21.9L61.2 176z"
        }
    ]
};

const FarGlassesRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlassesRound",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80h56c21.3-47.2 68.8-80 124-80 26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1-3.1 0-6.2.6-9.2 1.8l-31.3 12.5c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2 33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6V336c0 .8 0 1.6-.1 2.4.1 1.9.1 3.8.1 5.6 0 75.1-60.9 136-136 136-72.4 0-131.6-56.6-135.8-128h-32.4c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8.1-5.6-.1-.8-.1-1.6-.1-2.4v-10.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-31.3-12.5c-2.9-1.2-6-1.8-9.2-1.8zM136 432a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm392-88a88 88 0 1 0-176 0 88 88 0 1 0 176 0z"
        }
    ]
};

const FarGlasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlasses",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8 40.1 0 82.2 9.6 118.5 27.3 5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.4 7.7-9.8 13.5-12.7C358 257.5 400.2 248 440.3 248c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1-3.1 0-6.2.6-9.2 1.8l-31.3 12.5c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2 33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2.3 1.8.5 3.7.5 5.6v64c0 61.9-50.1 112-112 112h-44.4c-59.4 0-108.5-46.4-111.8-105.8l-1.3-22.2h-37.2l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368v-64c0-1.9.2-3.8.5-5.7.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-31.3-12.5c-2.9-1.2-6-1.8-9.2-1.8zM48 352v16c0 35.3 28.7 64 64 64h44.3c34 0 62-26.5 63.9-60.5l3.2-57.5c-27.3-11.7-58.3-18-87.7-18-29.5 0-60.5 6.4-87.7 18.2V352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c1.9 33.9 29.9 60.5 63.9 60.5H464c35.3 0 64-28.7 64-64v-53.8c-27.2-11.8-58.2-18.2-87.7-18.2z"
        }
    ]
};

const FarGlobePointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlobePointer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.6 415.6C283 456.8 263.4 464 256 464c-3.1 0-8.3-1.3-14.8-5.7l-15.3 52c9.9 1.2 19.9 1.8 30.1 1.8 141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256c0 10.2.6 20.2 1.8 30.1l46.9-13.8c-.4-5.4-.6-10.8-.6-16.3 0-16.5 1.9-32.6 5.6-48h76.7c-1.3 13.3-2 27-2.2 41l48.4-14.2c.4-9.1 1.1-18 2-26.7h155c1.6 15.3 2.5 31.4 2.5 48s-.9 32.7-2.5 48h-47l-14.1 48h53.2c-5.6 24.4-13.2 45.9-22 63.6zM208.4 96.4C229 55.2 248.6 48 256 48s27 7.2 47.6 48.4c8.8 17.7 16.4 39.2 22 63.6H186.4c5.6-24.4 13.2-45.9 22-63.6zM384 256c0-16.4-.8-32.5-2.2-48h76.7c3.6 15.4 5.6 31.5 5.6 48s-1.9 32.6-5.6 48h-76.7c1.5-15.5 2.2-31.6 2.2-48zm-9.3-96c-7.3-35.9-18.5-67.7-32.6-93.4 42.3 19.3 77 52.3 98.4 93.4h-65.8zm-303.3 0c21.4-41.1 56.1-74.1 98.4-93.4-14.1 25.6-25.3 57.5-32.6 93.4H71.4zm303.3 192h65.9c-21.4 41.1-56.1 74.1-98.4 93.4 14.1-25.6 25.3-57.5 32.6-93.4zM39 308.5c-13.9 4.1-15.6 23.2-2.6 29.7l57.3 28.7c1.3.7 2.6 1.5 3.7 2.5l-88 88c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l88-88c1 1.1 1.9 2.3 2.5 3.7l28.7 57.3c6.5 13 25.6 11.3 29.7-2.6l60.2-204.8c3.6-12.1-7.7-23.4-19.9-19.9L39 308.5z"
        }
    ]
};

const FarGlobeSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlobeSnow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M297.4 384C358 356.2 400 295 400 224c0-97.2-78.8-176-176-176S48 126.8 48 224c0 71 42 132.2 102.6 160H67.2C25.7 343.3 0 286.7 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224c0 62.7-25.7 119.3-67.2 160h-83.4zM232 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm3.3 84.7 64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9h-16.5l44.8 53.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2h-56v48h-48v-48h-56c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17l44.8-53.8H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64c6.2-6.2 16.4-6.2 22.6 0zM328 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM80 184a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM20.3 474.2 61.1 416h325.8l40.8 58.2c5.1 7.3 5.8 16.9 1.6 24.8s-12.4 13-21.3 13H40c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8z"
        }
    ]
};

const FarGlobeStand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlobeStand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M15 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3V464H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24h-96v-33.3c49.1-5.3 96.8-26.7 134.4-64.3 81.7-81.7 87.1-211 16.1-298.9L401 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-34.6 34.5c-9.4 9.4-9.4 24.6 0 33.9 68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0L15 367zm97-159a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm240 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0z"
        }
    ]
};

const FarGlobe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGlobe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c7.4 0 27-7.2 47.6-48.4 8.8-17.7 16.4-39.2 22-63.6H186.4c5.6 24.4 13.2 45.9 22 63.6C229 456.8 248.6 464 256 464zm-77.5-160h155c1.6-15.3 2.5-31.4 2.5-48s-.9-32.7-2.5-48h-155c-1.6 15.3-2.5 31.4-2.5 48s.9 32.7 2.5 48zm7.9-144h139.2c-5.6-24.4-13.2-45.9-22-63.6C283 55.2 263.4 48 256 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm195.3 48c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48h76.7c3.6-15.4 5.6-31.5 5.6-48s-1.9-32.6-5.6-48h-76.6zm58.8-48c-21.4-41.1-56.1-74.1-98.4-93.4 14.1 25.6 25.3 57.5 32.6 93.4h65.9zm-303.3 0c7.3-35.9 18.5-67.7 32.6-93.4-42.3 19.3-77 52.3-98.4 93.4h65.9zm-83.6 48C50 223.4 48 239.5 48 256s1.9 32.6 5.6 48h76.7c-1.5-15.5-2.2-31.6-2.2-48s.8-32.5 2.2-48H53.6zm288.5 237.4c42.3-19.3 77-52.3 98.4-93.4h-65.8c-7.3 35.9-18.5 67.7-32.6 93.4zm-172.2 0c-14.1-25.6-25.3-57.5-32.6-93.4H71.4c21.4 41.1 56.1 74.1 98.4 93.4zM256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512z"
        }
    ]
};

const FarGoalNet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGoalNet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 120c0-22.1 17.9-40 40-40h464c22.1 0 40 17.9 40 40v336c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-48.6-39.4-88-88-88H88C39.4 32 0 71.4 0 120v336c0 13.3 10.7 24 24 24s24-10.7 24-24V120zm128 8c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16zm80 256h-64v-64h64v64zm96 0h-64v-64h64v64zm96 0h-64v-64h64v64zm0-96h-64v-64h64v64zm-96 0h-64v-64h64v64zm-96 0h-64v-64h64v64z"
        }
    ]
};

const FarGolfBallTee = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGolfBallTee",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0 55.7-31.7 104.1-78 128h77.1c30.4-34 48.9-78.8 48.9-128C384 86 298 0 192 0S0 86 0 192c0 49.2 18.5 94 48.9 128H126c-46.3-23.9-78-72.3-78-128 0-79.5 64.5-144 144-144s144 64.5 144 144zm-109.9 56.6c0 18.5-15 33.5-33.5 33.5-4.9 0-9.1 5.1-5.4 8.4 5.9 5.2 13.7 8.4 22.1 8.4 18.5 0 33.5-15 33.5-33.5 0-8.5-3.2-16.2-8.4-22.1-3.3-3.7-8.4.5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4 5.9 5.2 13.7 8.4 22.1 8.4 18.5 0 33.5-15 33.5-33.5 0-8.5-3.2-16.2-8.4-22.1-3.3-3.7-8.4.5-8.4 5.4 0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5-4.9 0-9.1 5.1-5.4 8.4 5.9 5.2 13.7 8.4 22.1 8.4 18.5 0 33.5-15 33.5-33.5 0-8.5-3.2-16.2-8.4-22.1-3.3-3.7-8.4.5-8.4 5.4zM64 376c0 13.3 10.7 24 24 24h64c8.8 0 16 7.2 16 16v72c0 13.3 10.7 24 24 24s24-10.7 24-24v-72c0-8.8 7.2-16 16-16h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarGolfClub = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGolfClub",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M498.7 2.5c11.9 5.9 16.7 20.3 10.7 32.2L290.7 472.2a71.96 71.96 0 0 1-64.4 39.8H56c-30.9 0-56-25.1-56-56V347.1c0-37.6 36.3-64.5 72.2-53.6L293 360.4 466.5 13.3c5.9-11.9 20.3-16.7 32.2-10.7zM271.2 404 58.3 339.5c-5.1-1.6-10.3 2.3-10.3 7.7V368h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H48v16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H48v8c0 4.4 3.6 8 8 8h170.3c9.1 0 17.4-5.1 21.5-13.3l23.4-46.7z"
        }
    ]
};

const FarGolfFlagHole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGolfFlagHole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M162.7 2.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 15.7 128 24v360c0 .7 0 1.5.1 2.2-.1.6-.1 1.2-.1 1.8 0 19.9 35.8 36 80 36s80-16.1 80-36-35.8-36-80-36c-11.4 0-22.2 1.1-32 3v-28.8c24.6-3.9 51.5-6.2 80-6.2 61.7 0 116.4 10.4 154.9 26.3 19.3 8 33.3 16.9 42.1 25.5 8.7 8.6 11 15.4 11 20.2s-2.3 11.7-11 20.2c-8.8 8.6-22.8 17.5-42.1 25.5C372.4 453.6 317.7 464 256 464s-116.4-10.4-154.9-26.3c-19.3-8-33.3-16.9-42.1-25.5-8.7-8.6-11-15.4-11-20.2s2.3-11.7 11-20.2c8-7.9 20.3-15.9 37-23.3v-51.7c-4.5 1.6-9 3.3-13.2 5.1-22.7 9.4-42.7 21.2-57.3 35.5C10.7 351.9 0 370.3 0 392s10.7 40.1 25.4 54.5C40.1 460.8 60 472.6 82.7 482c45.6 18.9 106.9 30 173.3 30s127.7-11.1 173.2-29.9c22.7-9.4 42.7-21.2 57.3-35.5 14.8-14.5 25.5-32.9 25.5-54.6s-10.7-40.1-25.4-54.5C472 323.2 452 311.4 429.3 302c-45.6-18.9-106.9-30-173.3-30-27.8 0-54.8 1.9-80 5.6v-30.8l194.7-97.4c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-208-104zM176 193.2V62.8L306.3 128 176 193.2z"
        }
    ]
};

const FarGopuram = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGopuram",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 0c13.3 0 24 10.7 24 24v8h48v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v106.7c18.6 6.6 32 24.4 32 45.3v48c0 .9 0 1.8-.1 2.7 18.7 6.6 32.1 24.4 32.1 45.3v64c0 .9 0 1.8-.1 2.7 18.7 6.6 32.1 24.4 32.1 45.3v80c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-80c0-20.9 13.4-38.7 32.1-45.3 0-.9-.1-1.8-.1-2.7v-64c0-20.9 13.4-38.7 32.1-45.3 0-.9-.1-1.8-.1-2.7v-48c0-20.9 13.4-38.7 32-45.3V24c0-13.3 10.7-24 24-24zm24 80v48h224V80H144zm-32 96v48h48v-48h-48zm208 48v-48H192v48h32c0-17.7 14.3-32 32-32s32 14.3 32 32h32zm32-48v48h48v-48h-48zm0 96H160v64h64v-16c0-17.7 14.3-32 32-32s32 14.3 32 32v16h64v-64zm32 64h48v-64h-48v64zM128 464h80v-16c0-26.5 21.5-48 48-48s48 21.5 48 48v16h80v-80H128v80zm288 0h48v-80h-48v80zM128 272H80v64h48v-64zM96 384H48v80h48v-80z"
        }
    ]
};

const FarGraduationCap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGraduationCap",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 80c2.5 0 5 .4 7.4 1.3l218 78.7-218 78.7c-2.4.9-4.9 1.3-7.4 1.3s-5-.4-7.4-1.3l-127.7-46.1 140.8-52.8c8.3-3.1 12.5-12.3 9.4-20.6s-12.3-12.5-20.6-9.4l-159.6 59.8c-5.2 2-10.3 4.2-15.3 6.6L94.7 160l218-78.7c2.4-.9 4.9-1.3 7.4-1.3zM15.8 182.6l77.4 27.9C66 239.2 49.5 277.2 48.1 318.2c-.1.6-.1 1.2-.1 1.8 0 28.4-10.8 57.8-22.3 80.8-6.5 13-13.9 25.8-22.5 37.6-3.2 4.3-4.1 9.9-2.3 15s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7.3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7-3.2-14-7.5-28.3-13.4-41.5 1.9-37 19.2-70.9 46.7-94.2L296.3 284c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1l280.5-101.4c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1c-7.6-2.7-15.6-4.1-23.7-4.1s-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6zm480.8 80-46.5 16.8 12.7 120.5c-4.8 3.5-12.8 8-24.6 12.6C410 423.6 368 432 320 432s-90-8.4-118.3-19.4c-11.8-4.6-19.8-9.2-24.6-12.6l12.7-120.5-46.5-16.8L128 408c0 35.3 86 72 192 72s192-36.7 192-72l-15.3-145.4zM467.4 396a.7.7 0 1 0-1.2-.7.7.7 0 1 0 1.2.7zm-294.8 0a.7.7 0 1 0 1.2-.6.7.7 0 1 0-1.2.6z"
        }
    ]
};

const FarGramophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGramophone",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M127 0c10.5-.4 20 6 23.6 15.9v.1l.3.7c.3.7.7 1.7 1.3 3.2 1.2 2.9 3.2 7.3 6 12.8 5.7 11.1 14.8 27 28.2 45.1 26.9 36.2 71.4 81.5 141.3 116.8 17.3 8.7 31.6 22.9 40.1 40.4 5.4 10.9 8.2 23 8.2 35v.6c0 45-36.5 81.4-81.4 81.4H184c-13.3 0-24-10.7-24-24 0-1.7.2-3.3.5-4.8 2.2-10.9 11.9-19.2 23.5-19.2h110c18.7 0 33.9-15.1 34-33.7-.1-5.4-1.5-10.7-4.1-15.6-3.1-4.9-7.7-7.8-12.4-8.6-44.1-7.3-133.1-7.9-241.4 69.4-.3.2-.7.5-1 .7-2.7 1.8-5.6 2.9-8.7 3.5-3.2.6-6.6.6-10-.2-1.4-.3-2.7-.8-4-1.3l-1.2-.6c-1.4-.7-2.7-1.5-3.9-2.4-.7-.5-1.3-1.1-1.9-1.7-1.3-1.2-2.4-2.6-3.4-4.1-1.8-2.8-3-5.8-3.6-8.9-.6-3.1-.5-6.4.2-9.6.1-.3.2-.7.3-1l71.9-272C107.5 7.7 116.5.4 127 0zM94.8 243.4c54.3-29.5 103.6-42.4 144.6-46.7-41.1-30.1-70.7-62.3-91.5-90.2-4.5-6.1-8.6-11.9-12.3-17.5L94.8 243.4zM0 488c0-13.3 10.7-24 24-24h8v-32c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm304-24v-32H80v32h224z"
        }
    ]
};

const FarGrapes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrapes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7 4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74-3.2-4-8.1-6-13.2-6s-10 2-13.3 6zM408 264c0-44.2-35.8-80-80-80 0-44.2-35.8-80-80-80-28 0-52.6 14.4-66.9 36.1C167 127.6 148.4 120 128 120c-44.2 0-80 35.8-80 80 0 18 6 34.6 16 48-19.4 14.6-32 37.8-32 64 0 17.6 5.7 33.8 15.2 47C19.4 371.5 0 399.5 0 432c0 44.2 35.8 80 80 80 32.5 0 60.5-19.4 73-47.2 13.2 9.6 29.4 15.2 47 15.2 26.2 0 49.4-12.6 64-32 13.4 10 30 16 48 16 44.2 0 80-35.8 80-80 0-20.4-7.6-39-20.1-53.1C393.6 316.6 408 292 408 264zM248 144a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-120 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM72 312a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm8 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm80 8a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm152-56a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-128-56a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm144-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
        }
    ]
};

const FarGrateDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrateDroplet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56v74.2c-15.1 4.3-28.2 14.6-35.8 28.8L400 214V88c0-4.4-3.6-8-8-8h-48v152h46.4l-53.5 100.2A144.61 144.61 0 0 0 320 400c0 29.6 8.9 57.1 24.2 80H56c-30.9 0-56-25.1-56-56V88zm56-8c-4.4 0-8 3.6-8 8v144h56V80H56zm-8 344c0 4.4 3.6 8 8 8h48V280H48v144zm152 8V280h-48v152h48zm96 0V280h-48v152h48zM248 80v152h48V80h-48zm-48 152V80h-48v152h48zm240.5-25.9c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7 0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z"
        }
    ]
};

const FarGrate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrate",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56H56zm48 48v152H48V88c0-4.4 3.6-8 8-8h48zM48 280h56v152H56c-4.4 0-8-3.6-8-8V280zm104 152V280h48v152h-48zm96 0V280h48v152h-48zm96 0V280h56v144c0 4.4-3.6 8-8 8h-48zm56-200h-56V80h48c4.4 0 8 3.6 8 8v144zM296 80v152h-48V80h48zm-96 0v152h-48V80h48z"
        }
    ]
};

const FarGreaterThanEqual = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGreaterThanEqual",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M47 78.2c-12.3-5-18.2-19-13.2-31.3s19-18.2 31.3-13.2l336 136c9.1 3.7 15 12.5 15 22.2s-5.9 18.6-15 22.2L65 350.2c-12.3 5-26.3-1-31.3-13.2s1-26.3 13.2-31.3L328 192 47 78.2zM424 432c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h400z"
        }
    ]
};

const FarGreaterThan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGreaterThan",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M2.5 77.3c-5.9 11.9-1.1 26.3 10.7 32.2L306.3 256l-293 146.5c-11.9 6-16.7 20.4-10.8 32.2s20.3 16.7 32.2 10.7l336-168c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-336-168c-11.8-5.8-26.2-1-32.2 10.9z"
        }
    ]
};

const FarGrid2Plus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrid2Plus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 80H80v96h96V80zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 304H80v96h96v-96zm-96-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zM336 80v96h96V80h-96zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarGrid2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrid2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 80v96h96V80H80zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zm48 256v96h96v-96H80zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-96zM432 80h-96v96h96V80zm-96-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 304v96h96v-96h-96zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-96z"
        }
    ]
};

const FarGrid4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrid4",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 89.6V64h25.6v25.6H32zm57.6 16V48c0-8.8-7.2-16-16-16H16C7.2 32 0 39.2 0 48v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4zm-16 45.9H16c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4v-57.6c0-6.3-3.7-11.8-9-14.4-2.1-1-4.5-1.6-7-1.6zm0 119.5H16c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4v-57.7c0-6.3-3.7-11.8-9-14.4-2.1-1-4.5-1.6-7-1.6zM16 390.4c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.6c0-6.3-3.7-11.8-9-14.4-2.1-1-4.5-1.6-7-1.6H16zm16-181.3v-25.6h25.6v25.6H32zm0 119.5v-25.7h25.6v25.6H32zM32 448v-25.6h25.6V448H32zM151.5 89.6V64h25.6v25.6h-25.6zm57.6 16V48c0-8.8-7.2-16-16-16h-57.6c-8.8 0-16 7.2-16 16v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4zm-16 45.9h-57.6c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4v-57.6c0-6.3-3.7-11.8-9-14.4-2.1-1-4.5-1.6-7-1.6zm0 119.5h-57.6c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4v-57.7c0-6.3-3.7-11.8-9-14.4-2.1-1-4.5-1.6-7-1.6zm-57.6 119.4c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.6c0-6.3-3.7-11.8-9-14.4-2.1-1-4.5-1.6-7-1.6h-57.6zm16-181.3v-25.6h25.6v25.6h-25.6zm0 119.5v-25.7h25.6v25.6h-25.6zm0 119.5v-25.7h25.6V448h-25.6zM270.9 64h25.6v25.6h-25.6V64zm48.6 56c5.3-2.6 9-8.1 9-14.4V48c0-8.8-7.2-16-16-16h-57.6c-8.8 0-16 7.2-16 16v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6zm0 33.1c-2.1-1-4.5-1.6-7-1.6h-57.6c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4v-57.6c0-6.3-3.7-11.8-9-14.4zm0 119.5c-2.1-1-4.5-1.6-7-1.6h-57.6c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4v-57.7c0-6.3-3.7-11.8-9-14.4zm-7 117.8h-57.6c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.6c0-6.3-3.7-11.8-9-14.4-2.1-1-4.5-1.6-7-1.6zm-41.6-206.9h25.6v25.6h-25.6v-25.6zm0 119.5h25.6v25.6h-25.6v-25.7zm0 119.5h25.6V448h-25.6v-25.6zM390.4 89.6V64H416v25.6h-25.6zm57.6 16V48c0-8.8-7.2-16-16-16h-57.6c-8.8 0-16 7.2-16 16v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6H432c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4zm-16 45.9h-57.6c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6H432c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4v-57.6c0-6.3-3.7-11.8-9-14.4-2.1-1-4.5-1.6-7-1.6zm0 119.5h-57.6c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4 2.1 1 4.5 1.6 7 1.6H432c2.5 0 4.9-.6 7-1.6 5.3-2.6 9-8.1 9-14.4v-57.7c0-6.3-3.7-11.8-9-14.4-2.1-1-4.5-1.6-7-1.6zm-57.6 119.4c-2.5 0-4.9.6-7 1.6-5.3 2.6-9 8.1-9 14.4V464c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16v-57.6c0-6.3-3.7-11.8-9-14.4-2.1-1-4.5-1.6-7-1.6h-57.6zm16-181.3v-25.6H416v25.6h-25.6zm0 119.5v-25.7H416v25.6h-25.6zm0 119.5v-25.7H416V448h-25.6z"
        }
    ]
};

const FarGrid5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrid5",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16C7.2 96 0 88.8 0 80V48zm0 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM0 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V48zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM96 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM208 32h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80-368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V48zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM400 32h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarGridDividers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGridDividers",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zm80 152h32v-32H80v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64zm48 336h32v-32H80v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64zm208-272v32h32v-32h-32zm-16-48h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm16 368h32v-32h-32v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm208-272v32h32v-32h-32zm-16-48h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm16 368h32v-32h-32v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zM24 288h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarGridHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGridHorizontal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 168v48h48v-48H40zm-40 0c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48zm40 160v48h48v-48H40zm-40 0c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48zm248-160h-48v48h48v-48zm-48-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40zm0 200v48h48v-48h-48zm-40 0c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48zm248-160h-48v48h48v-48zm-48-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40zm0 200v48h48v-48h-48zm-40 0c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48z"
        }
    ]
};

const FarGridRound2Plus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGridRound2Plus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 128a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM80 384a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm256-304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm-96 144c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarGridRound2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGridRound2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm-96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm112-256a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1-192 0 96 96 0 1 1 192 0z"
        }
    ]
};

const FarGridRound4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGridRound4",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M44.8 64a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm44.8 106.7a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 196.3a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm57.6 119.4a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 435.2a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zM177.1 76.8a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm57.6 119.5a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0zM164.3 271a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm177-358.5a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm57.6 119.5a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0zM283.7 271a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zM416 76.8a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zM416 315.7a12.8 12.8 0 1 1-25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0z"
        }
    ]
};

const FarGridRound5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGridRound5",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64-352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64-352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FarGridRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGridRound",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 96a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM64 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm24 224a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM0 416a64 64 0 1 0 128 0 64 64 0 1 0-128 0zM248 96a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm88 160a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm88 160a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0-128 0z"
        }
    ]
};

const FarGrid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrid",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 72v48H40V72h48zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zm48 200v48H40v-48h48zm-48-40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40H40zm0 200h48v48H40v-48zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 72v48h-48V72h48zm-48-40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40h-48zm0 200h48v48h-48v-48zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40zm88 160v48h-48v-48h48zm-48-40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48zM360 72h48v48h-48V72zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40zm88 160v48h-48v-48h48zm-48-40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48zm0 200h48v48h-48v-48zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40z"
        }
    ]
};

const FarGrillFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrillFire",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 80v16c0 97.2 78.8 176 176 176 7.3 0 14.5-.4 21.6-1.3-8 16.2-14.3 32.8-18.1 49.3h-3.6c-16.9 0-33.4-1.9-49.3-5.4L151.8 368h73c1.5 16.6 5.2 32.7 10.7 48H160c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c3.4 0 6.8.3 10.1.8l23.1-53.8C52.9 263.3 0 185.8 0 96V72c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v24c0 24.1-3.8 47.3-10.9 69.1-8.5-8.6-17.2-17-26.2-25.1-4.3-3.9-9.3-6.9-14.5-8.9 2.4-11.3 3.6-23.1 3.6-35.1V80H48zm72 336a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm269.5-252.2c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C576 440 504.7 512 416 512c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM466 433c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15z"
        }
    ]
};

const FarGrillHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrillHot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 0c-13.3 0-24 10.7-24 24v2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3v2.6c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6c0-21.4-10.7-41.4-28.5-53.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24c0-13.3-10.7-24-24-24zM48.9 208h350.2c-8 72-69 128-143.1 128h-64c-74.1 0-135.2-56-143.1-128zM32 160c-17.7 0-32 14.3-32 32 0 78.1 46.6 145.3 113.6 175.3l-7.5 17.5c-3.3-.5-6.7-.8-10.1-.8-35.3 0-64 28.7-64 64s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H327l10.9 25.5c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5l-47.6-111.3c67-30 113.6-97.2 113.6-175.3 0-17.7-14.3-32-32-32H32zm115.5 250 12.3-28.7c10.5 1.8 21.2 2.7 32.2 2.7h64c11 0 21.7-.9 32.2-2.7l18.3 42.7H155.3c-2-5-4.7-9.7-7.8-14zM72 448a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM256 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v2.6c0 21.4 10.7 41.4 28.5 53.2l12.4 8.3c4.5 3 7.1 8 7.1 13.3v2.6c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6c0-21.4-10.7-41.4-28.5-53.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24z"
        }
    ]
};

const FarGrill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrill",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 80h352v16c0 97.2-78.8 176-176 176S48 193.2 48 96V80zm-8-48C17.9 32 0 49.9 0 72v24c0 89.8 52.9 167.3 129.2 203l-23.1 53.8c-3.3-.5-6.7-.8-10.1-.8-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64h156.7l21.2 49.5c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5L318.8 299C395.1 263.3 448 185.8 448 96V72c0-22.1-17.9-40-40-40H40zm111.8 336 22.9-53.4c15.9 3.6 32.3 5.4 49.3 5.4s33.4-1.9 49.3-5.4l22.9 53.4H151.8zM72 416a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarGripDotsVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGripDotsVertical",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm96-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarGripDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGripDots",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-160 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM64 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 96a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FarGripLinesVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGripLinesVertical",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C18.7 32 8 42.7 8 56v400c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarGripLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGripLines",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 192c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24zm0 128c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24z"
        }
    ]
};

const FarGripVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGripVertical",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 440v-48h48v48H40zm0 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40zm192-40v-48h48v48h-48zm0 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40zM40 232h48v48H40v-48zM0 280c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48zm232 0v-48h48v48h-48zm0 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40zM40 72h48v48H40V72zM0 120c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v48zm232 0V72h48v48h-48zm0 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40z"
        }
    ]
};

const FarGrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGrip",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 376v-48h-48v48h48zm40 0c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48zm-40-192v-48h-48v48h48zm40 0c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48zM200 376h48v-48h-48v48zm48 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40zm0-232v-48h-48v48h48zm40 0c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48zM40 376h48v-48H40v48zm48 40H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40zm0-232v-48H40v48h48zm40 0c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48z"
        }
    ]
};

const FarGroupArrowsRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGroupArrowsRotate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215 34.4c3.8 12.7-3.5 26.1-16.2 29.8-14.2 4.2-27.8 10-40.5 17.1 1.1 4.8 1.7 9.7 1.7 14.7 0 35.3-28.7 64-64 64-5 0-9.9-.6-14.6-1.7-7.1 12.7-12.9 26.3-17.1 40.5-3.8 12.7-17.1 19.9-29.8 16.2s-19.9-17.1-16.2-29.8c5.7-19.3 13.8-37.7 23.8-54.7C35.7 120.5 32 108.7 32 96c0-35.3 28.7-64 64-64 12.7 0 24.5 3.7 34.5 10.1 17-10 35.4-18 54.7-23.8 12.7-3.8 26.1 3.5 29.8 16.2zm82 0c3.8-12.7 17.1-19.9 29.8-16.2 19.3 5.7 37.7 13.8 54.7 23.8 10-6.3 21.8-10 34.5-10 35.3 0 64 28.7 64 64 0 12.7-3.7 24.5-10.1 34.5 10 17 18 35.4 23.8 54.7 3.8 12.7-3.5 26.1-16.2 29.8s-26.1-3.5-29.8-16.2c-4.2-14.2-10-27.8-17.1-40.5-4.7 1.1-9.6 1.7-14.6 1.7-35.3 0-64-28.7-64-64 0-5 .6-9.9 1.7-14.6-12.7-7.1-26.3-12.9-40.5-17.1-12.7-3.8-19.9-17.1-16.2-29.8zM34.4 297c12.7-3.8 26.1 3.5 29.8 16.2 4.2 14.2 10 27.8 17.1 40.5 4.8-1.1 9.7-1.7 14.7-1.7 35.3 0 64 28.7 64 64 0 5-.6 9.9-1.7 14.6 12.7 7.1 26.3 12.9 40.5 17.1 12.7 3.8 19.9 17.1 16.2 29.8s-17.1 19.9-29.8 16.2c-19.3-5.8-37.7-13.8-54.7-23.8-10 6.4-21.8 10.1-34.5 10.1-35.3 0-64-28.7-64-64 0-12.7 3.7-24.5 10.1-34.5-10-17-18-35.4-23.8-54.7-3.8-12.7 3.5-26.1 16.2-29.8zm443.1 0c12.7 3.8 19.9 17.1 16.2 29.8-5.8 19.3-13.8 37.6-23.8 54.7 6.4 10 10.1 21.8 10.1 34.5 0 35.3-28.7 64-64 64-12.7 0-24.5-3.7-34.5-10.1-17 10-35.4 18-54.7 23.8-12.7 3.8-26.1-3.5-29.8-16.2s3.5-26.1 16.2-29.8c14.2-4.2 27.8-10 40.5-17.1-1.1-4.7-1.7-9.6-1.7-14.6 0-35.3 28.7-64 64-64 5 0 9.9.6 14.6 1.7 7.1-12.7 12.9-26.3 17.1-40.5 3.8-12.7 17.1-19.9 29.8-16.2zM112 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM96 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 336a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192.8 256.8c0 24.8 14.1 46.4 34.9 57 11.8 6 16.5 20.5 10.4 32.3s-20.5 16.5-32.3 10.4c-36.2-18.5-61.1-56.2-61.1-99.8 0-28.9 11-55.2 28.9-75.1l-11.2-11.2c-6.6-6.6-1.9-17.8 7.4-17.8h60.5c5.7 0 10.4 4.7 10.4 10.4v60.5c0 9.3-11.2 13.9-17.8 7.4l-15.3-15.3c-9.3 11.1-14.9 25.4-14.9 41.1zm93.1-58.6c-11.8-6-16.5-20.5-10.4-32.3s20.5-16.5 32.3-10.4c36.2 18.5 61.1 56.2 61.1 99.8 0 28.9-11 55.2-28.9 75.1l11 11.1c6.6 6.6 1.9 17.8-7.4 17.8h-60.4c-5.7 0-10.4-4.7-10.4-10.4v-60.6c0-9.3 11.2-13.9 17.8-7.4l15.3 15.3c9.3-11.1 14.9-25.4 14.9-41.1 0-24.8-14.1-46.4-34.9-57z"
        }
    ]
};

const FarGuaraniSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGuaraniSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-13.3 0-24 10.7-24 24v41.5C73.3 77.3 0 158.1 0 256s73.3 178.7 168 190.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-41.5c94.7-11.8 168-92.6 168-190.5 0-13.3-10.7-24-24-24H216V114c29.7 5 56.2 19 76.8 39.2 9.5 9.3 24.7 9.1 33.9-.3s9.1-24.7-.3-33.9C297.2 90.2 258.8 70.8 216 65.5V24c0-13.3-10.7-24-24-24zm-24 114v284C99.9 386.6 48 327.4 48 256s51.9-130.6 120-142zm48 284V280h118c-10.1 60.3-57.7 107.9-118 118z"
        }
    ]
};

const FarGuitarElectric = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGuitarElectric",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 126.1v-45c0-10.7 5.3-20.7 14.2-26.6l69.4-46.2c8.1-5.4 17.6-8.3 27.3-8.3h1.1c26.5 0 48 21.5 48 48s-21.5 48-48 48h-14.1L314.4 231.6c9.1 8.1 13.8 8.4 14.9 8.4 2.6.1 4.3-.6 10.9-3.5l3.7-1.6c13.2-5.6 36-8.3 52.3 8.2 15.8 15.9 15.8 41.7 0 57.6l-21.6 21.8c-12.2 12.3-28.2 18.8-38.7 23l-2.1.8c-5.5 2.2-12.7 6.3-20.3 14-17.3 17.5-23.7 39.4-30.6 63.5-.9 3-1.7 6-2.6 9.1-5.2 17.5-14.1 35-28.1 49.2-39.4 39.9-103.5 39.9-142.9 0l-79.8-80.8c-39.3-39.7-39.3-104 0-143.7 14.1-14.2 31.4-23.3 48.8-28.5 2.9-.9 5.7-1.7 8.6-2.6 23.9-7.1 45.6-13.5 63-31.1 6.3-6.3 10.1-12.4 12.5-17.5.8-1.8 1.8-3.8 2.8-6 5.4-11.9 13.1-29.1 25.6-41.7l29.9-30.2c15.9-16.1 41.8-16.1 57.7 0 16.1 16.3 14.2 39.7 5.2 54.6-1.1 1.8-2.1 3.4-3 4.9-4.9 8-7.8 12.7-8.8 18.2-.6 3.2-1 9.2 8.7 19.8l71.5-71.4zM167 263c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zm-64 64c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zm139.4-197.2v-.1zm-18 39.8c.4-2.3.9-4.5 1.5-6.7l-1.2 1.2c-5.9 5.9-9.4 13.5-14.7 25.1-1.3 2.9-2.8 6-4.4 9.4-4.6 9.6-11.5 20.2-21.7 30.6-26.7 27-60.7 36.8-83.8 43.5-2.8.8-5.5 1.6-7.9 2.3-11.5 3.5-21.3 9-28.6 16.4-20.8 21-20.8 55.2 0 76.2l79.9 80.8c20.6 20.9 54 20.9 74.6 0 7.3-7.4 12.8-17.4 16.3-29.1.8-2.6 1.5-5.3 2.4-8.2 6.6-23.3 16.2-57.6 42.8-84.4 12.5-12.6 25.3-20.2 36.2-24.7 12.9-5.2 20-8.4 24.7-13.2l2.3-2.4c-4.6 1.1-9.7 1.7-15 1.6-18-.5-35-9.6-52.1-26.9L248 233.2l-.1-.1c-20.4-20.6-27.2-42.3-23.5-63.5z"
        }
    ]
};

const FarGuitar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGuitar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M431 7c9.4-9.4 24.6-9.4 33.9 0l40 40c9.4 9.4 9.4 24.6 0 33.9l-48 48c-2.4 2.4-5.3 4.3-8.5 5.5l-59.1 22.2-35.8 35.8c38.2 50.8 41.4 115.2 4.6 152-12 12-26.8 19.7-43.2 23.4-18.1 4.1-33.5 20.8-34.5 39.4-1.4 27.9-11.7 53.8-31.2 73.4-48.9 48.8-137.2 39.7-197.4-20.4s-69.2-148.5-20.4-197.4c19.6-19.6 45.5-29.8 73.4-31.3 18.5-.9 35.3-16.4 39.4-34.5 3.7-16.4 11.4-31.2 23.4-43.2 36.8-36.8 101.2-33.6 152 4.6l35.8-35.8 22.2-59.1c1.2-3.2 3.1-6.1 5.5-8.5L431 7zM254.4 291.6c1.1 4 1.6 8.1 1.6 12.4 0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48c4.3 0 8.5.6 12.4 1.6l64.8-64.8c-36-24.5-70.6-18.1-83.8-5-5 5-8.6 11.5-10.5 19.8-8.3 37-41.6 69.7-83.8 71.9-17.6.9-31.7 7.1-41.9 17.3-23.9 23.9-27.9 81.2 20.4 129.5s105.6 44.3 129.5 20.4c10.1-10.1 16.4-24.3 17.3-41.9 2.1-42.2 34.9-75.4 71.9-83.8 8.3-1.9 14.8-5.5 19.8-10.5 13.2-13.2 19.6-47.8-5-83.8l-64.8 64.8z"
        }
    ]
};

const FarGuitars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGuitars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 178v-44.3l19.8-39.6c2.8-5.6 4.2-11.7 4.2-17.9V24c0-13.3-10.7-24-24-24h-48C90.7 0 80 10.7 80 24v52.2c0 6.2 1.4 12.3 4.2 17.9l19.8 39.6V178c-50.3 8.6-88 43.8-88 86 0 14 4.2 27.3 11.6 39.1 8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104 29.3 0 56.3-8 77.8-21.4-8.4-14.7-13.4-31.7-13.8-49.7-13.1 12.9-34.3 23.2-64 23.2-54 0-80-33.9-80-56 0-9.7 3.7-19.8 12.4-29.3 26.2-29 26.4-71.9 7.8-101.2-3-4.8-4.2-9.2-4.2-13.5 0-9.6 11.2-29.7 40-37.1v85c0 13.3 10.7 24 24 24s24-10.7 24-24v-85.1c28.8 7.4 40 27.5 40 37.1 0 4.2-1.2 8.7-4.2 13.5-18.6 29.4-18.4 72.2 7.8 101.2 2.5 2.7 4.6 5.5 6.3 8.4 4.1-11.5 8.8-22.1 12.9-31.2l1-2.3c3.3-7.4 6.1-13.9 8.5-19.7-3-10.1-1.5-21.8 4.1-30.7 1.1-1.7 2.1-3.5 3.1-5.3-.9-4.9-2.7-10.7-5.7-19.3l-.4-1.3c-3.5-10-8.5-24.7-9.2-40.9-.1-1.3-.1-2.5-.1-3.8v-23c-15.8-15.7-38.2-27.1-64-31.5zm170.6-53.9 21.4 24.5V240c-23.7 0-38.6-8.8-48-19.8-2.5-2.9-4.6-6-6.3-9.1-3.7-6.6-6-13.3-7.4-19.1v-.2c-2.1-8.6-9.3-15.8-18.2-15.8s-16 7.2-16 16v40.5c0 .8 0 1.7.1 2.5.5 11.5 4.2 22.3 7.9 33.1 4 11.6 8 23.3 8 35.9 0 20-9.3 40.9-19 62.5-10.3 23.2-21 47.1-21 71.7 0 40.8 33 73.8 73.8 73.8h140.3c40.8 0 73.8-33 73.8-73.8 0-24.5-10.7-48.5-21-71.7-9.6-21.6-19-42.5-19-62.5 0-12 4-22.9 8.1-33.8 3.3-8.9 6.6-17.8 7.6-27.2.2-1.9.3-3.8.3-5.7V208c0-8.8-7.2-16-16-16s-16.2 7.3-19.5 15.5l-.2.5c-1.9 4.5-4.7 9.4-9.1 14-1 1.1-2.1 2.1-3.2 3.1-9.4 8.3-24.3 14.9-48 14.9V74.1c9.6-6.4 16-17.3 16-29.7v-4.6c0-22-17.8-39.8-39.8-39.8-18.8 0-35 13.1-38.9 31.5l-13.9 64.8c-2.1 9.9.6 20.2 7.2 27.8zM344 384c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm81.9-99.7c-1.1 6.1-1.9 12.8-1.9 19.7 0 30.7 13.5 60.6 22.2 80 .7 1.5 1.4 3 2 4.4 10.7 24 15.8 38 15.8 49.8 0 14.2-11.6 25.8-25.8 25.8H297.8c-14.2 0-25.8-11.6-25.8-25.8 0-11.9 5.2-25.8 15.8-49.8.6-1.4 1.3-2.9 2-4.4 8.7-19.4 22.2-49.2 22.2-80 0-7.2-.8-14.1-1.9-20.5 10.4 2.9 21.7 4.5 33.9 4.5h48c12.1 0 23.4-1.3 33.9-3.7z"
        }
    ]
};

const FarGunSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGunSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L412.3 297.8l20.6-57.8h32.5c10.6 0 20.8-4.2 28.3-11.7l20.2-20.3H568c22.1 0 40-17.9 40-40v-64c0-22.1-17.9-40-40-40h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H113.9L38.8 5.1zM175.2 112H560v48h-49.4c-10.6 0-20.8 4.2-28.3 11.7L462.1 192H277.2l-102-80zm163.3 128h43.4l-9.5 26.6-33.9-26.6zM80 192v-33l-48-37.8V200c0 22.1 17.9 40 40 40h2c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480h112c14.7 0 27.5-10 31-24.2L265 352h59.9l-91.4-72-38 152h-79l35.1-140.6c4.5-18.1 2.5-35.9-4.3-51.4h35.4l-60.9-48H80z"
        }
    ]
};

const FarGunSquirt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGunSquirt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 32c13.3 0 24 10.7 24 24v8h320c41.8 0 77.4 26.7 90.5 64H552c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24h-13.5c-13.2 37.3-48.7 64-90.5 64H249l-18 72h41v-16c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-53l-20 79.8c-3.5 14.2-16.3 24.2-31 24.2H64c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l46.4-185.6C34.3 246.7 0 207.3 0 160c0-47.6 34.6-87.1 80-94.7V56c0-13.3 10.7-24 24-24zm24.5 224-44 176h71l44-176h-71zM448 208c26.5 0 48-21.5 48-48s-21.5-48-48-48H96c-26.5 0-48 21.5-48 48s21.5 48 48 48h352zM96 144h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarGun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarGun",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H40C17.9 64 0 81.9 0 104v96c0 22.1 17.9 40 40 40h2c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h112c14.7 0 27.5-10 31-24.2L233 352h88.5c23.7 0 44.8-14.9 52.7-37.2l26.7-74.8h32.5c10.6 0 20.8-4.2 28.3-11.7l20.2-20.3H536c22.1 0 40-17.9 40-40v-64c0-22.1-17.9-40-40-40h-8v-8zM245 304l16-64h89l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3H245zm-33.5-64-48 192h-79l35.1-140.6c4.5-18.1 2.5-35.9-4.3-51.4h96.1zm55.5-48H48v-80h480v48h-49.4c-10.6 0-20.8 4.2-28.3 11.7L430.1 192H267z"
        }
    ]
};

const FarH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarH",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 256v200c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v152H48V56c0-13.3-10.7-24-24-24S0 42.7 0 56v400c0 13.3 10.7 24 24 24s24-10.7 24-24V256h288z"
        }
    ]
};

const FarH1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarH1",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V272h224v152c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v136H48V88zm456 0c0-8.5-4.5-16.4-11.8-20.7s-16.4-4.4-23.8-.3l-72 40c-11.6 6.4-15.8 21-9.3 32.6s21 15.8 32.6 9.3l36.3-20.1V400h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48V88z"
        }
    ]
};

const FarH2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarH2",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V272h224v152c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v136H48V88zm397.3 40.8C457.9 118 474 112 490.7 112h9.2c42.1 0 76.2 34.1 76.2 76.2 0 21.3-8.9 41.5-24.5 56L375.7 406.4c-7.3 6.7-9.7 17.2-6.1 26.4s12.5 15.3 22.4 15.3h224c13.3 0 24-10.7 24-24s-10.7-24-24-24H453.4l130.7-120.7c25.5-23.5 39.9-56.6 39.9-91.2C624 119.6 568.4 64 499.8 64h-9.2c-28.1 0-55.3 10.1-76.6 28.3l-29.7 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l29.7-25.4z"
        }
    ]
};

const FarH3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarH3",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V272h224v152c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v136H48V88zm352-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h142.1L423 231c-6.9 6.9-8.9 17.2-5.2 26.2S430.3 272 440 272h88c35.3 0 64 28.7 64 64s-28.7 64-64 64h-72.6c-15.6 0-29-11.3-31.6-26.7l-.2-1.2c-2.2-13.1-14.5-21.9-27.6-19.7s-21.9 14.5-19.7 27.6l.2 1.2c6.4 38.6 39.8 66.8 78.9 66.8H528c61.9 0 112-50.1 112-112s-50.1-112-112-112h-30.1L617 105c6.9-6.9 8.9-17.2 5.2-26.2S609.7 64 600 64H400z"
        }
    ]
};

const FarH4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarH4",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m455.5 92.9-34 163.1H592V88c0-13.3 10.7-24 24-24s24 10.7 24 24v336c0 13.3-10.7 24-24 24s-24-10.7-24-24V304H392c-7.2 0-14.1-3.3-18.6-8.9s-6.3-13-4.9-20l40-192c2.7-13 15.4-21.3 28.4-18.6s21.3 15.4 18.6 28.4zM24 64c13.3 0 24 10.7 24 24v136h224V88c0-13.3 10.7-24 24-24s24 10.7 24 24v336c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H48v152c0 13.3-10.7 24-24 24S0 437.3 0 424V88c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarH5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarH5",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V272h224v152c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v136H48V88zm392-24c-11.4 0-21.3 8.1-23.5 19.3l-32 160c-1.4 7.1.4 14.4 5 19.9s11.4 8.8 18.6 8.8H528c35.3 0 64 28.7 64 64s-28.7 64-64 64h-63.6c-13.8 0-26-8.8-30.4-21.9l-3.2-9.7c-4.2-12.6-17.8-19.4-30.4-15.2S381 371 385.2 383.6l3.2 9.7c11 32.7 41.5 54.7 76 54.7H528c61.9 0 112-50.1 112-112s-50.1-112-112-112h-90.7l22.4-112H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H440z"
        }
    ]
};

const FarH6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarH6",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V272h224v152c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v136H48V88zm471-18.7c-10.3-8.3-25.5-6.6-33.7 3.7l-98 122.5C364.4 224 352 259.5 352 296h.2c-.1 2.6-.2 5.3-.2 8 0 79.5 64.5 144 144 144s144-64.5 144-144-64.5-144-144-144c-6.8 0-13.4.5-20 1.4l46.7-58.4c8.3-10.4 6.6-25.5-3.8-33.7zM496 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FarHammerCrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHammerCrash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m289.9 328.5 1.5.7c15 7.5 31.5 8.6 46.4 4.2l-.3 1.8 54.1-23.5c9.6-4.2 20.9-1.6 27.7 6.3l38.6 44.6 15.4-56.9c2.7-10.1 11.7-17.3 22.2-17.7l58.9-2.3-34.9-47.5c-6.2-8.5-6.2-20 0-28.4l34.9-47.5-59-2.3c-10.5-.4-19.5-7.6-22.2-17.7l-15.4-57-20.3 23.6c-6-9.1-14.4-16.9-24.9-22.1L399 80l52-60.3c5.8-6.7 14.8-9.7 23.5-7.7s15.5 8.6 17.8 17.1l22.7 83.6 86.5 3.4c8.9.3 16.8 5.6 20.7 13.6s3 17.5-2.3 24.6L568.6 224l51.3 69.7c5.3 7.2 6.1 16.6 2.3 24.6s-11.8 13.2-20.7 13.6l-86.5 3.4-22.6 83.5c-2.3 8.6-9.2 15.2-17.8 17.1s-17.7-1-23.5-7.7l-56.6-65.5-79.4 34.5c-8.1 3.5-17.6 2.3-24.5-3.3s-10.3-14.5-8.6-23.2l7.9-42.3zM81.9 64l-28.4 56.8 259.3 129.7 49.7-99.4L188.2 64H81.9zM43.4 33.7C48.8 22.8 59.9 16 72 16h120c5 0 9.9 1.2 14.3 3.4l192 96c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3L186.4 241 69.5 474.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l116.8-233.7-125.7-62.9c-15.8-7.9-22.2-27.1-14.3-42.9l40-80z"
        }
    ]
};

const FarHammerWar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHammerWar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v28L36.7 32.4C17.7 29.5 0 44.7 0 64v192c0 19.3 17.7 34.5 36.7 31.6L187.2 265c3.1-.5 6.3-.5 9.5 0l150.5 22.6c19.1 2.9 36.7-12.4 36.7-31.6V64c0-19.3-17.7-34.5-36.7-31.6L216 52V24zm0 276.3-24-3.6-24 3.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V300.3zm-35.9-82.7L48 237.4V82.6l132.1 19.8c7.9 1.2 15.9 1.2 23.7 0L336 82.6v154.8l-132.1-19.8c-7.9-1.2-15.9-1.2-23.7 0z"
        }
    ]
};

const FarHammer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHammer",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432.8 204.9c-9.1-9.1-21.5-14.2-34.4-14.1-11.3.1-22.4-4.1-31-12.7L329.3 140c-5.9-5.9-9.3-14-9.3-22.4v-12.1c0-17.6-9.6-33.7-25-42.1l-21.7-11.9c8.4-2.3 17.1-3.5 25.8-3.5h18.1c24.5 0 48 9.3 65.8 26.1l44.6 42c9.7 9.1 14.3 21.7 13.5 34.1-.8 13.7 4.3 27.1 14 36.8l37 37-20.1 20.1-39.2-39.2zM216.7 75.3l.3.2 55 30v12.1c0 21.1 8.4 41.4 23.3 56.3l38.1 38.1c18.1 18.1 41.8 26.9 65.4 26.7l39.2 39.2 1 1-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L569 217c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-8 8-1-1-37-37c1.6-26.1-8-52.7-28.5-72l-44.6-42C389.2 14 353.9 0 317.2 0h-18c-20.2 0-40.1 4.2-58.5 12.4L219.1 22l-.3.1-6.2 2.8-19.1 8.5c-5.6 2.5-9.2 7.9-9.5 14s3 11.8 8.3 14.7l18.4 10 6 3.3zm44.2 107.3L27.4 377.1C10.1 391.6 0 413.1 0 435.7 0 477.8 34.1 512 76.3 512c22.6 0 44.1-10.1 58.6-27.4L330 250.4c-6.8-4.5-13.2-9.7-19.2-15.7l-38.1-38.1c-4.3-4.3-8.3-9-11.8-14z"
        }
    ]
};

const FarHamsa = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHamsa",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 104v96c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-13.3 10.7-24 24-24s24 10.7 24 24v128c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3 10.7-24 24-24s24 10.7 24 24v176c0 13.3 10.7 24 24 24h48.4c8.6 0 15.6 7 15.6 15.6 0 4.1-1.6 8.1-4.6 11l-83.8 83.8C343.9 446.2 300.9 464 256 464s-87.9-17.8-119.6-49.5l-83.8-83.9c-2.9-2.9-4.6-6.9-4.6-11 0-8.6 7-15.6 15.6-15.6H112c13.3 0 24-10.7 24-24V104c0-13.3 10.7-24 24-24s24 10.7 24 24zm7.8-64.6c-9.6-4.7-20.4-7.4-31.8-7.4-39.8 0-72 32.2-72 72v152H63.6C28.5 256 0 284.5 0 319.6c0 16.9 6.7 33 18.6 45l83.8 83.8c40.7 40.7 96 63.6 153.5 63.6s112.8-22.9 153.5-63.6l83.8-83.8c11.9-11.9 18.6-28.1 18.6-45 0-35.1-28.5-63.6-63.6-63.6H424V104c0-39.8-32.2-72-72-72-11.4 0-22.2 2.7-31.8 7.4C308.3 16 284 0 256 0s-52.3 16-64.2 39.4zm-26.4 298.8c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8c13.8 14.4 52.2 50.2 90.6 50.2s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288s-76.8 35.8-90.6 50.2zM256 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarHandBackFist = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandBackFist",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2 8.8 0 16 7.2 16 16 0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2 8.8 0 16 7.2 16 16 0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2 8.8 0 16 7.2 16 16v104c0 31.3-20 58-48 67.9-9.6 3.4-16 12.5-16 22.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V370.2c38-20.1 64-60.1 64-106.2V160c0-35.3-28.7-64-64-64-2.8 0-5.6.2-8.3.5A63.831 63.831 0 0 0 288 64c-2.8 0-5.6.2-8.3.5A63.831 63.831 0 0 0 224 32c-2.8 0-5.6.2-8.3.5A63.831 63.831 0 0 0 160 0c-35.3 0-64 28.7-64 64v64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6v12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7-13.8 19.7 8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V359.9c0-12.6-9.8-23.1-22.4-23.9-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4v-12.8c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6V208c0 8.8 7.2 16 16 16s16-7.2 16-16V64z"
        }
    ]
};

const FarHandBackPointDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandBackPointDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 512c-35.3 0-64-28.7-64-64V259.2c-5.2-3.6-10.2-7.6-14.9-11.9l-20.3-18.5C26.5 212.1 16 188.5 16 163.7v-10.2c0-54 28.7-104 75.4-131.3l2.6-1.5C117.3 7.1 143.7 0 170.6 0H296c66.3 0 120 53.7 120 120v104c0 35.3-28.7 64-64 64-2.8 0-5.6-.2-8.3-.5-11 19.4-31.8 32.5-55.7 32.5-5.3 0-10.5-.7-15.5-1.9-10.8 20.2-32 33.9-56.5 33.9-2.7 0-5.4-.2-8-.5V448c0 35.3-28.7 64-64 64zm-16-64c0 8.8 7.2 16 16 16s16-7.2 16-16V312c0-10.3 6.6-19.5 16.4-22.8s20.6.1 26.8 8.3c3 3.9 7.6 6.4 12.8 6.4 8.8 0 16-7.2 16-16v-8c0-10.3 6.6-19.5 16.4-22.8s20.6.1 26.8 8.3c3 3.9 7.6 6.4 12.8 6.4 8.8 0 16-7.2 16-16 0-9.1 5.1-17.4 13.3-21.5s17.9-3.2 25.1 2.3c2.7 2 6 3.2 9.6 3.2 8.8 0 16-7.2 16-16v-104c0-39.8-32.2-72-72-72l-125.4.2c-18.4 0-36.5 4.9-52.4 14.2l-11.7-20 11.7 20-2.6 1.5C83.6 82.3 64 116.5 64 153.5v10.2c0 11.3 4.8 22 13.1 29.6L96 210.5V168c0-8.8 7.2-16 16-16s16 7.2 16 16v280z"
        }
    ]
};

const FarHandBackPointLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandBackPointLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 176c0-35.3 28.7-64 64-64h188.8c3.6-5.2 7.6-10.2 11.9-14.9l18.4-20.3C299.9 58.5 323.5 48 348.3 48h10.2c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6V328c0 66.3-53.7 120-120 120H288c-35.3 0-64-28.7-64-64 0-2.8.2-5.6.5-8.3-19.4-11-32.5-31.8-32.5-55.7 0-5.3.7-10.5 1.9-15.5-20.2-10.8-33.9-32-33.9-56.5 0-2.7.2-5.4.5-8H64c-35.3 0-64-28.7-64-64zm64-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h136c10.3 0 19.5 6.6 22.8 16.4s-.1 20.6-8.3 26.8c-3.9 3-6.4 7.6-6.4 12.8 0 8.8 7.2 16 16 16h8c10.3 0 19.5 6.6 22.8 16.4s-.1 20.6-8.3 26.8c-3.9 3-6.4 7.6-6.4 12.8 0 8.8 7.2 16 16 16 9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6 0 8.8 7.2 16 16 16h104c39.8 0 72-32.2 72-72V202.6c0-18.4-4.9-36.5-14.2-52.4l20-11.7-20 11.7-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6h-10.2c-11.3 0-22 4.8-29.6 13.1L301.5 128H344c8.8 0 16 7.2 16 16s-7.2 16-16 16H64z"
        }
    ]
};

const FarHandBackPointRibbon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandBackPointRibbon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64c0-35.3 28.7-64 64-64s64 28.7 64 64v96.5c2.6-.3 5.3-.5 8-.5 24.5 0 45.7 13.7 56.5 33.9 5-1.2 10.2-1.9 15.5-1.9 23.9 0 44.8 13.1 55.7 32.5 2.7-.3 5.5-.5 8.3-.5 35.3 0 64 28.7 64 64v104c0 66.3-53.7 120-120 120H186.6c-26.9 0-53.3-7.1-76.6-20.7l-2.6-1.5C60.7 462.5 32 412.5 32 358.5v-10.2c0-24.8 10.5-48.4 28.8-65.1l20.3-18.4c4.8-4.3 9.7-8.3 14.9-11.9V176H43.8c-6.5 0-11.8-5.3-11.8-11.8 0-3.9 1.9-7.5 5.1-9.7L75.6 128l-38.5-26.5c-3.2-2.2-5.1-5.8-5.1-9.7C32 85.3 37.3 80 43.8 80H96V64zm48 112v168c0 8.8-7.2 16-16 16s-16-7.2-16-16v-42.5l-18.9 17.2C84.8 326.3 80 337 80 348.3v10.2c0 37 19.6 71.2 51.6 89.8l2.6 1.5-11.7 20 11.7-20c15.9 9.3 34 14.2 52.4 14.2H312c39.8 0 72-32.2 72-72V288c0-8.8-7.2-16-16-16-3.6 0-6.9 1.2-9.6 3.2-7.3 5.5-17 6.3-25.1 2.3S320 265.1 320 256c0-8.8-7.2-16-16-16-5.2 0-9.9 2.5-12.8 6.4-6.2 8.3-17 11.6-26.8 8.3S248 242.3 248 231.9v-8c0-8.8-7.2-16-16-16-5.2 0-9.9 2.5-12.8 6.4-6.2 8.3-17 11.6-26.8 8.3S176 210.2 176 199.8V176h-32zm32-96V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h32z"
        }
    ]
};

const FarHandBackPointRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandBackPointRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 176c0-35.3-28.7-64-64-64H259.2c-3.6-5.2-7.6-10.2-11.9-14.9l-18.5-20.3C212.1 58.5 188.5 48 163.7 48h-10.2c-54 0-104 28.7-131.3 75.4l-1.5 2.6C7.1 149.3 0 175.7 0 202.6V328c0 66.3 53.7 120 120 120h104c35.3 0 64-28.7 64-64 0-2.8-.2-5.6-.5-8.3 19.4-11 32.5-31.8 32.5-55.7 0-5.3-.7-10.5-1.9-15.5 20.2-10.8 33.9-32 33.9-56.5 0-2.7-.2-5.4-.5-8H448c35.3 0 64-28.7 64-64zm-64-16c8.8 0 16 7.2 16 16s-7.2 16-16 16H312c-10.3 0-19.5 6.6-22.8 16.4s.1 20.6 8.3 26.8c3.9 3 6.4 7.6 6.4 12.8 0 8.8-7.2 16-16 16h-8c-10.3 0-19.5 6.6-22.8 16.4s.1 20.6 8.3 26.8c3.9 3 6.4 7.6 6.4 12.8 0 8.8-7.2 16-16 16-9.1 0-17.4 5.1-21.5 13.3s-3.2 17.9 2.3 25.1c2 2.7 3.2 6 3.2 9.6 0 8.8-7.2 16-16 16h-104c-39.8 0-72-32.2-72-72V202.6c0-18.4 4.9-36.5 14.2-52.4l-20-11.7 20 11.7 1.5-2.6c18.6-32 52.8-51.6 89.8-51.6h10.2c11.3 0 22 4.8 29.6 13.1l17.4 18.9H168c-8.8 0-16 7.2-16 16s7.2 16 16 16h280z"
        }
    ]
};

const FarHandBackPointUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandBackPointUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c-35.3 0-64 28.7-64 64v188.8c-5.2 3.6-10.2 7.6-14.9 11.9l-20.3 18.5C26.5 299.9 16 323.5 16 348.3v10.2c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7H296c66.3 0 120-53.7 120-120V288c0-35.3-28.7-64-64-64-2.8 0-5.6.2-8.3.5-11-19.4-31.8-32.5-55.7-32.5-5.3 0-10.5.7-15.5 1.9-10.8-20.2-32-33.9-56.5-33.9-2.7 0-5.4.2-8 .5V64c0-35.3-28.7-64-64-64zm-16 64c0-8.8 7.2-16 16-16s16 7.2 16 16v136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4 8.8 0 16 7.2 16 16v8c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4 8.8 0 16 7.2 16 16 0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2 8.8 0 16 7.2 16 16v104c0 39.8-32.2 72-72 72H170.6c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5c-32-18.8-51.6-53-51.6-90v-10.2c0-11.3 4.8-22 13.1-29.6L96 301.5V344c0 8.8 7.2 16 16 16s16-7.2 16-16V64z"
        }
    ]
};

const FarHandDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M198.4 36C208.8 14.7 230.7 0 256 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4 35.3 0 64 28.7 64 64v2c5.1-1.3 10.5-2 16-2 35.3 0 64 28.7 64 64v176c0 1.5-.1 3-.4 4.5-6.2 91.7-79.4 165-171.1 171.1-1.5.3-2.9.4-4.5.4h-16.5c-67.9 0-133-27-181-75l-87.8-87.7c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7V96c0-35.3 28.7-64 64-64 7.9 0 15.4 1.4 22.4 4zM240 232c0 13.3-10.7 24-24 24s-24-10.7-24-24V95.9c0-8.8-7.2-15.9-16-15.9s-16 7.2-16 16v223.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-43.7-43.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9h13.3c.6-.1 1.3-.1 1.9-.2 69.7-3.4 125.6-59.3 129-129 0-.6.1-1.3.2-1.9V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-8.8-7.2-16-16-16s-16 7.1-16 16v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v168zm0 88a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm48 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarHandFingersCrossed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandFingersCrossed",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169.8 57.6c3.7-8 13.3-11.5 21.3-7.7s11.5 13.3 7.7 21.3L120 240H84.7l55.7-119.5c1-1.7 1.9-3.5 2.5-5.3l26.8-57.6zm-43.5-20.3-6.5 14C102.9 24.1 68 13.1 38.3 27c-32 14.9-45.9 53-31 85l42.1 90.2L22 261c-.9 2-1.5 4-1.9 6C7.6 281.1 0 299.7 0 320v24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V224c0-35.3-28.7-64-64-64-7.9 0-15.4 1.4-22.4 4-10.4-21.3-32.3-36-57.6-36-5.4 0-10.7.7-15.7 1.9l18-38.5c14.9-32 1.1-70.1-31-85.1s-70.1-1.1-85.1 31zM50.8 91.7c-3.7-8-.3-17.5 7.7-21.3s17.5-.3 21.3 7.7l13.7 29.3-17.6 38-25-53.7zM240 176c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c0-8.8 7.2-16 16-16zm0 128c7.9 0 15.4-1.4 22.4-4 10.4 21.3 32.3 36 57.6 36 5.5 0 10.9-.7 16-2v10c0 66.3-53.7 120-120 120h-48c-66.3 0-120-53.7-120-120v-24c0-17.7 14.3-32 32-32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64v-2c5.1 1.3 10.5 2 16 2zm96-48v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v32z"
        }
    ]
};

const FarHandFist = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandFist",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 80c8.8 0 16 7.2 16 16v80h-16c-5.5 0-10.8.6-16 1.6V96c0-8.8 7.2-16 16-16zm0 144h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64v-2c5.1 1.3 10.5 2 16 2 7.9 0 15.4-1.4 22.4-4 10.4 21.3 32.3 36 57.6 36 5.2 0 10.2-.6 15-1.8-4.4 32.4-23.8 60.1-51.1 75.9-7.4 4.3-12 12.2-12 20.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V379.9c38.7-27.5 64-72.8 64-123.9v-96c0-35.3-28.7-64-64-64-5.5 0-10.9.7-16 2v-2c0-35.3-28.7-64-64-64-7.9 0-15.4 1.4-22.4 4C239.2 14.7 217.3 0 192 0s-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4-35.3 0-64 28.7-64 64v104c0 2.3.3 4.6 1 6.7-10.7 13.6-17 30.7-17 49.3 0 64.2 39.8 119 96 141.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V380c0-11-7.4-20.5-18-23.2-44.9-11.6-78-52.4-78-100.8 0-17.7 14.3-32 32-32zm256-32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm-192-16V64c0-8.8 7.2-16 16-16s16 7.2 16 16v114c-5.1-1.3-10.5-2-16-2h-16zm80 0V96c0-8.8 7.2-16 16-16s16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FarHandHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M198.4 36C208.8 14.7 230.7 0 256 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4 35.3 0 64 28.7 64 64v2c5.1-1.3 10.5-2 16-2 35.3 0 64 28.7 64 64v176c0 1.5-.1 3-.4 4.5-6.2 91.7-79.4 165-171.1 171.1-1.5.3-2.9.4-4.5.4h-16.5c-67.9 0-133-27-181-75l-87.8-87.7c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7V96c0-35.3 28.7-64 64-64 7.9 0 15.4 1.4 22.4 4zM240 232c0 13.3-10.7 24-24 24s-24-10.7-24-24V95.9c0-8.8-7.2-15.9-16-15.9s-16 7.2-16 16v223.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-43.7-43.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9h13.3c.6-.1 1.3-.1 1.9-.2 69.7-3.4 125.6-59.3 129-129 0-.6.1-1.3.2-1.9V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-8.8-7.2-16-16-16s-16 7.1-16 16v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v168zm-32 96.8c0-22.6 18.3-40.8 40.8-40.8 10.8 0 21.2 4.3 28.9 12l5 5 5-5c7.7-7.7 18-12 28.9-12 22.6 0 40.8 18.3 40.8 40.8 0 10.8-4.3 21.2-12 28.9l-55.2 55.2c-4.2 4.2-10.9 4.2-15.1 0L220 357.7c-7.7-7.7-12-18-12-28.9z"
        }
    ]
};

const FarHandHoldingBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHoldingBox",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 48h-80v73.7c0 3.5-2.8 6.3-6.3 6.3-1.1 0-2.2-.3-3.1-.8L296 100.6c-4.9-2.8-11-2.8-15.9 0l-46.6 26.6c-1 .5-2 .8-3.1.8-3.5 0-6.3-2.8-6.3-6.3V48H144v160h288V48zm0-48c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h288zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64v2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3 0 20.4-10.4 39.5-27.5 50.6L453 492.8c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h363.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3 0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H256c-13.3 0-24-10.7-24-24s10.7-24 24-24h88c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"
        }
    ]
};

const FarHandHoldingDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHoldingDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 24v10.5c6.4 1.2 12.6 2.7 18.2 4.2 12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5-7.3-.1-14.7 1.7-19.4 4.4-2.1 1.3-3.1 2.4-3.5 3-.3.5-.7 1.2-.7 2.8v.6c.2.2.9 1.2 3.3 2.6 5.8 3.5 14.4 6.2 27.4 10.1l.9.3c11.1 3.3 25.9 7.8 37.9 15.3 13.7 8.6 26.1 22.9 26.4 44.9.3 22.5-11.4 38.9-26.7 48.5-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11.4c-9.5-2.3-18.2-5.3-25.6-7.8-2.1-.7-4.1-1.4-6-2-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6.9 5 1.7 7.3 2.5 13.6 4.6 23.4 7.9 33.9 8.3 8 .3 15.1-1.6 19.2-4.1 1.9-1.2 2.8-2.2 3.2-2.9.4-.6.9-1.8.8-4.1v-.2c0-1 0-2.1-4-4.6-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4-13.5-8.1-26.5-22-26.6-44.1-.1-22.9 12.9-38.6 27.7-47.4 6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64v2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3 0 20.4-10.4 39.5-27.5 50.6L453 492.8c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h363.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3 0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H256c-13.3 0-24-10.7-24-24s10.7-24 24-24h88c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"
        }
    ]
};

const FarHandHoldingDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHoldingDroplet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6l66.3 96.4c11.2 16.3 17.2 35.6 17.2 55.3v1.7c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3l66.3-96.4zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64v2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3 0 20.4-10.4 39.5-27.5 50.6L453 492.8c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h363.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3 0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H256c-13.3 0-24-10.7-24-24s10.7-24 24-24h88c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"
        }
    ]
};

const FarHandHoldingHand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHoldingHand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M146.8 318.9c5.8-3.9 12.7-6 19.7-6h139.3c7.9 0 14.2 6.4 14.2 14.2s-6.4 14.2-14.2 14.2h-78.2c-11.8 0-21.3 9.6-21.3 21.3s9.6 21.3 21.3 21.3h120.9c3.9 0 7.8-1.1 11.2-3.2l83.1-51.1c2.8-1.7 5.9-2.6 9.2-2.6h6.6c6 0 10.9 4.9 10.9 10.9 0 3.7-1.9 7.1-5 9.2l-85 55c-10.4 6.7-22.4 10.3-34.8 10.3H21.3C9.6 412.4 0 422 0 433.8s9.6 21.3 21.3 21.3h323.3c20.6 0 40.7-5.9 57.9-17.1l85-55c15.3-9.9 24.5-26.8 24.5-45 0-29.6-24-53.6-53.6-53.6h-6.6c-11.1 0-22 3.1-31.5 8.9l-57.7 35.5V327c0-31.4-25.5-56.9-56.9-56.9H166.6c-15.4 0-30.5 4.6-43.4 13.1l-65.7 43.9H21.3C9.6 327.1 0 336.7 0 348.4s9.6 21.3 21.3 21.3H64c4.2 0 8.3-1.2 11.8-3.6l71-47.3zm218.4-125.8c-5.8 3.9-12.7 6-19.7 6H206.2c-7.9 0-14.2-6.4-14.2-14.2s6.4-14.2 14.2-14.2h78.2c11.8 0 21.3-9.6 21.3-21.3s-9.6-21.3-21.3-21.3H163.6c-3.9 0-7.8 1.1-11.2 3.2l-83.1 51c-2.8 1.7-5.9 2.6-9.2 2.6h-6.5c-6 0-10.9-4.9-10.9-10.9 0-3.7 1.9-7.1 5-9.2l85-55c10.4-6.7 22.4-10.3 34.8-10.3h323.2c11.8 0 21.3-9.6 21.3-21.3s-9.6-21.3-21.3-21.3H167.4c-20.6 0-40.7 5.9-57.9 17.1l-85 55C9.2 138.9 0 155.8 0 174c0 29.6 24 53.6 53.6 53.6h6.6c11.1 0 22-3.1 31.5-8.9l57.7-35.5v1.8c0 31.4 25.5 56.9 56.9 56.9h139.1c15.4 0 30.5-4.6 43.4-13.1l65.6-43.8h36.2c11.8 0 21.3-9.6 21.3-21.3s-9.6-21.3-21.3-21.3H448c-4.2 0-8.3 1.2-11.8 3.6l-71 47.3z"
        }
    ]
};

const FarHandHoldingHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHoldingHeart",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64v2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3 0 20.4-10.4 39.5-27.5 50.6L453 492.8c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h363.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3 0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H256c-13.3 0-24-10.7-24-24s10.7-24 24-24h88c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"
        }
    ]
};

const FarHandHoldingMagic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHoldingMagic",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 76c0 15.5 12.5 28 28 28h84c13.3 0 24 10.7 24 24s-10.7 24-24 24h-84c-42 0-76-34-76-76s34-76 76-76h124c66.3 0 120 53.7 120 120s-53.7 120-120 120h-48v24c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h72c39.8 0 72-32.2 72-72s-32.2-72-72-72H204c-15.5 0-28 12.5-28 28zm11.4 276c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64v2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3 0 20.4-10.4 39.5-27.5 50.6L453 492.8c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h363.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3 0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H256c-13.3 0-24-10.7-24-24s10.7-24 24-24h88c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"
        }
    ]
};

const FarHandHoldingMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHoldingMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-56v56c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-56h-56c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h56V24zm-36.6 328c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64v2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3 0 20.4-10.4 39.5-27.5 50.6L453 492.8c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h363.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3 0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H256c-13.3 0-24-10.7-24-24s10.7-24 24-24h88c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"
        }
    ]
};

const FarHandHoldingSeedling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHoldingSeedling",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M115.6 0C96 0 80 16 80 35.6 80 113.2 142.8 176 220.4 176H264v80c0 13.3 10.7 24 24 24s24-10.7 24-24V152C312 68.1 243.9 0 160 0h-44.4zM160 48c49.2 0 90.4 34.1 101.2 80h-40.8c-46.8 0-85.5-34.8-91.5-80H160zm5.2 310.7c6.6-4.4 14.3-6.7 22.2-6.7H344c8.8 0 16 7.2 16 16s-7.2 16-16 16h-88c-13.3 0-24 10.7-24 24s10.7 24 24 24h136c4.4 0 8.8-1.2 12.6-3.6l93.5-57.5c3.1-1.9 6.7-2.9 10.3-2.9h7.4c6.8 0 12.3 5.5 12.3 12.3 0 4.2-2.1 8-5.6 10.3l-95.6 61.9c-11.8 7.5-25.4 11.5-39.2 11.5H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h363.7c23.1 0 45.8-6.7 65.2-19.3l95.6-61.9c17.2-11.1 27.5-30.2 27.5-50.6 0-33.3-27-60.3-60.3-60.3h-7.4c-12.5 0-24.8 3.5-35.5 10L408 370v-2c0-35.3-28.7-64-64-64H187.4c-17.4 0-34.4 5.1-48.8 14.8L64.7 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.7 0 9.4-1.4 13.3-4l79.9-53.3zM355.6 176C433.2 176 496 113.2 496 35.6 496 16 480 0 460.4 0H416c-41.7 0-79.5 16.8-107 44 10 13.8 18.1 29 24 45.2 19-25 49.1-41.2 83-41.2h31.2c-6 45.2-44.7 80-91.5 80h-13.3c1 7.9 1.6 15.9 1.6 24v24h11.6z"
        }
    ]
};

const FarHandHoldingSkull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHoldingSkull",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 128c0 29.9 20.4 58.1 53.8 71.8 9.9 4.1 15.9 14.2 14.7 24.9l-1.7 15.3h58.4l-1.7-15.3c-1.2-10.6 4.8-20.8 14.7-24.9 33.4-13.7 53.8-41.9 53.8-71.8 0-41.1-39.6-80-96-80s-96 38.9-96 80zM288 0c76.2 0 144 54.2 144 128 0 46.7-27.7 86.1-66.9 108.2l2.8 25.2c.8 6.8-1.4 13.6-6 18.7s-11.1 8-17.9 8H232c-6.8 0-13.3-2.9-17.9-8s-6.7-11.9-6-18.7l2.8-25.2C171.7 214.1 144 174.7 144 128 144 54.2 211.8 0 288 0zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64v2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3 0 20.4-10.4 39.5-27.5 50.6L453 492.8c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h363.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3 0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H256c-13.3 0-24-10.7-24-24s10.7-24 24-24h88c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4zM224 120a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarHandHolding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHolding",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M165.2 358.7c6.6-4.4 14.3-6.7 22.2-6.7H344c8.8 0 16 7.2 16 16s-7.2 16-16 16h-88c-13.3 0-24 10.7-24 24s10.7 24 24 24h136c4.4 0 8.8-1.2 12.6-3.6l93.5-57.5c3.1-1.9 6.7-2.9 10.3-2.9h7.4c6.8 0 12.3 5.5 12.3 12.3 0 4.2-2.1 8-5.6 10.3l-95.6 61.9c-11.8 7.5-25.4 11.5-39.2 11.5H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h363.7c23.1 0 45.8-6.7 65.2-19.3l95.6-61.9c17.2-11.1 27.5-30.2 27.5-50.6 0-33.3-27-60.3-60.3-60.3h-7.4c-12.5 0-24.8 3.5-35.5 10L408 370v-2c0-35.3-28.7-64-64-64H187.4c-17.4 0-34.4 5.1-48.8 14.8L64.7 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.7 0 9.4-1.4 13.3-4l79.9-53.3z"
        }
    ]
};

const FarHandHorns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandHorns",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 48c8.8 0 16 7.2 16 16v176H80c-5.5 0-10.8.6-16 1.6V64c0-8.8 7.2-16 16-16zM16 64v208C6 285.4 0 302 0 320v24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V128c0-35.3-28.7-64-64-64s-64 28.7-64 64v50c-5.1-1.3-10.5-2-16-2-7.9 0-15.4 1.4-22.4 4-10.4-21.3-32.3-36-57.6-36-5.5 0-10.9.7-16 2V64c0-35.3-28.7-64-64-64S16 28.7 16 64zm320 192v88c0 66.3-53.7 120-120 120h-48c-66.3 0-120-53.7-120-120v-24c0-17.7 14.3-32 32-32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c15.1 0 29-5.3 40-14 11 8.8 24.9 14 40 14 35.3 0 64-28.7 64-64V128c0-8.8 7.2-16 16-16s16 7.2 16 16v128zm-176-16h-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v34c-5.1-1.3-10.5-2-16-2zm96 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v16z"
        }
    ]
};

const FarHandLizard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandLizard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24h168c35.3 0 64 28.7 64 64s-28.7 64-64 64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24h152c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4v24c0 13.3-10.7 24-24 24s-24-10.7-24-24v-10.7L281.1 384H136c-39.8 0-72-32.2-72-72s32.2-72 72-72h104c8.8 0 16-7.2 16-16s-7.2-16-16-16H72c-39.8 0-72-32.2-72-72s32.2-72 72-72h209.6c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V316.1c0-23.2-7.8-45.8-22.1-64.1l-78.4-100.1c-19.7-25.2-49.9-39.9-81.9-39.9H72z"
        }
    ]
};

const FarHandLove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandLove",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48c8.8 0 16 7.2 16 16v240c0 35.3 28.7 64 64 64 15.1 0 29-5.3 40-14 11 8.8 24.9 14 40 14 35.3 0 64-28.7 64-64V128c0-8.8 7.2-16 16-16s16 7.2 16 16v209.9c-.3 1.2-.5 2.5-.7 3.7-6.6 66.5-61.1 118.9-128.5 122.2-.6 0-1.3.1-1.9.2h-13.4c-55.2 0-108.1-21.9-147.1-60.9l-87.7-87.8c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l43.7 43.7c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V64c0-8.8 7.2-16 16-16zm176 208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v16zm0-104v26c-5.1-1.3-10.5-2-16-2-7.9 0-15.4 1.4-22.4 4-10.4-21.3-32.3-36-57.6-36-5.5 0-10.9.7-16 2V64c0-35.3-28.7-64-64-64s-64 28.7-64 64v197.5l-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5l87.7 87.7c48 48 113.1 75 181 75H304c1.5 0 3-.1 4.5-.4 87.6-5.9 158.3-72.9 169.9-158.8 1.1-2.7 1.7-5.7 1.7-8.8V128c0-35.3-28.7-64-64-64s-64 28.7-64 64v24zm-112 64v-8.2c.1-8.8 7.2-15.8 16-15.8s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-88z"
        }
    ]
};

const FarHandMiddleFinger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandMiddleFinger",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-35.3 0-64 28.7-64 64v120.5c-2.6-.3-5.3-.5-8-.5-35.3 0-64 28.7-64 64v10.8c-2.4 1.9-4.7 3.9-6.9 5.9l-20.3 18.5C42.5 299.9 32 323.5 32 348.3v10.2c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7H312c66.3 0 120-53.7 120-120V288c0-35.3-28.7-64-64-64-5.3 0-10.5.7-15.5 1.9-10.8-20.2-32-33.9-56.5-33.9-2.7 0-5.4.2-8 .5V64c0-35.3-28.7-64-64-64zm-16 64c0-8.8 7.2-16 16-16s16 7.2 16 16v168c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4 8.8 0 16 7.2 16 16v8c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4 8.8 0 16 7.2 16 16v104c0 39.8-32.2 72-72 72H186.6c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5c-32-18.8-51.6-53-51.6-90v-10.2c0-11.3 4.8-22 13.1-29.6l10.9-9.9V344c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8 7.2-16 16-16 5.2 0 9.9 2.5 12.8 6.4 6.2 8.3 17 11.6 26.8 8.3s16.4-12.4 16.4-22.8V64z"
        }
    ]
};

const FarHandPeace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandPeace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119l-17.3-49.4C145 36.3 108.4 18.8 75.1 30.5s-50.9 48.3-39.2 81.6l52.8 150.1A79.77 79.77 0 0 0 64 320v24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V224c0-35.3-28.7-64-64-64-7.9 0-15.4 1.4-22.4 4-10.4-21.3-32.3-36-57.6-36h-2.2l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192v50c-5.1-1.3-10.5-2-16-2h-7.4l-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2S261 58 260 66.8l-9.5 90.1zM111.4 85.6 165.7 240H144c-4 0-8 .3-11.9.9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48zm38.4 108c10.4 21.3 32.3 36 57.6 36 5.5 0 10.9-.7 16-2v10c0 66.3-53.7 120-120 120h-48c-66.3 0-120-53.7-120-120v-24c0-17.7 14.3-32 32-32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64v-2c5.1 1.3 10.5 2 16 2 7.9 0 15.4-1.4 22.4-4zm73.6-28c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48z"
        }
    ]
};

const FarHandPointDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandPointDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 448V270.4c5.2 1 10.5 1.6 16 1.6h16v176c0 8.8-7.2 16-16 16s-16-7.2-16-16zm16-224c-17.7 0-32-14.3-32-32v-24c0-66.3 53.7-120 120-120h48c52.5 0 97.1 33.7 113.4 80.7-3.1-.5-6.2-.7-9.4-.7-20 0-37.9 9.2-49.7 23.6-9-4.9-19.4-7.6-30.3-7.6-15.1 0-29 5.3-40 14-11-8.8-24.9-14-40-14h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c8.8 0 16 7.2 16 16s-7.2 16-16 16H80zM0 192c0 18 6 34.6 16 48v208c0 35.3 28.7 64 64 64s64-28.7 64-64v-82c5.1 1.3 10.5 2 16 2 25.3 0 47.2-14.7 57.6-36 7 2.6 14.5 4 22.4 4 20 0 37.9-9.2 49.7-23.6 9 4.9 19.4 7.6 30.3 7.6 35.3 0 64-28.7 64-64v-88C384 75.2 308.8 0 216 0h-48C75.2 0 0 75.2 0 168v24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64zm-176 16c5.5 0 10.9-.7 16-2v34c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h16zm64-24v-40c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-24z"
        }
    ]
};

const FarHandPointLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandPointLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128h177.6c-1 5.2-1.6 10.5-1.6 16v16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32h24c66.3 0 120 53.7 120 120v48c0 52.5-33.7 97.1-80.7 113.4.5-3.1.7-6.2.7-9.4 0-20-9.2-37.9-23.6-49.7 4.9-9 7.6-19.4 7.6-30.3 0-15.1-5.3-29-14-40 8.8-11 14-24.9 14-40v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80zm32-80c-18 0-34.6 6-48 16H64c-35.3 0-64 28.7-64 64s28.7 64 64 64h82c-1.3 5.1-2 10.5-2 16 0 25.3 14.7 47.2 36 57.6-2.6 7-4 14.5-4 22.4 0 20 9.2 37.9 23.6 49.7-4.9 9-7.6 19.4-7.6 30.3 0 35.3 28.7 64 64 64h88c92.8 0 168-75.2 168-168v-48c0-92.8-75.2-168-168-168h-24zm-64 336c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64zm-16-176c0 5.5.7 10.9 2 16h-34c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v16zm24 64h40c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h24z"
        }
    ]
};

const FarHandPointRibbon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandPointRibbon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48c8.8 0 16 7.2 16 16v16H96V64c0-8.8 7.2-16 16-16zm64 32V64c0-35.3-28.7-64-64-64S48 28.7 48 64v16H11.8C5.3 80 0 85.3 0 91.8c0 3.9 1.9 7.5 5.1 9.7L43.6 128 5.1 154.5c-3.2 2.2-5.1 5.8-5.1 9.7 0 6.5 5.3 11.8 11.8 11.8H48v96c-10 13.4-16 30-16 48v24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168v-88c0-35.3-28.7-64-64-64-11 0-21.3 2.8-30.3 7.6C309.9 185.2 292 176 272 176c-7.9 0-15.4 1.4-22.4 4-10.4-21.3-32.3-36-57.6-36V96c0-8.8-7.2-16-16-16zm-48 96v64h-16c-5.5 0-10.8.6-16 1.6V176h32zm24 112h40c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c15.1 0 29-5.3 40-14 11 8.8 24.9 14 40 14 11 0 21.3-2.8 30.3-7.6C314.1 374.8 332 384 352 384c3.2 0 6.3-.2 9.4-.7-16.3 47-60.9 80.7-113.4 80.7h-48c-66.3 0-120-53.7-120-120v-24c0-17.7 14.3-32 32-32h40zm200-48c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm-144 2c-5.1-1.3-10.5-2-16-2h-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v34zm48-2c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64z"
        }
    ]
};

const FarHandPointRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandPointRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 128H270.4c1 5.2 1.6 10.5 1.6 16v16h176c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-224 16c0-17.7-14.3-32-32-32h-24c-66.3 0-120 53.7-120 120v48c0 52.5 33.7 97.1 80.7 113.4-.5-3.1-.7-6.2-.7-9.4 0-20 9.2-37.9 23.6-49.7-4.9-9-7.6-19.4-7.6-30.3 0-15.1 5.3-29 14-40-8.8-11-14-24.9-14-40v-40c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-80zm-32-80c18 0 34.6 6 48 16h208c35.3 0 64 28.7 64 64s-28.7 64-64 64h-82c1.3 5.1 2 10.5 2 16 0 25.3-14.7 47.2-36 57.6 2.6 7 4 14.5 4 22.4 0 20-9.2 37.9-23.6 49.7 4.9 9 7.6 19.4 7.6 30.3 0 35.3-28.7 64-64 64h-88C75.2 448 0 372.8 0 280v-48C0 139.2 75.2 64 168 64h24zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64zm16-176c0 5.5-.7 10.9-2 16h34c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v16zm-24 64h-40c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-24z"
        }
    ]
};

const FarHandPointUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandPointUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64v177.6c5.2-1 10.5-1.6 16-1.6h16V64c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16 224c-17.7 0-32 14.3-32 32v24c0 66.3 53.7 120 120 120h48c52.5 0 97.1-33.7 113.4-80.7-3.1.5-6.2.7-9.4.7-20 0-37.9-9.2-49.7-23.6-9 4.9-19.4 7.6-30.3 7.6-15.1 0-29-5.3-40-14-11 8.8-24.9 14-40 14h-40c-13.3 0-24-10.7-24-24s10.7-24 24-24h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zM0 320c0-18 6-34.6 16-48V64C16 28.7 44.7 0 80 0s64 28.7 64 64v82c5.1-1.3 10.5-2 16-2 25.3 0 47.2 14.7 57.6 36 7-2.6 14.5-4 22.4-4 20 0 37.9 9.2 49.7 23.6 9-4.9 19.4-7.6 30.3-7.6 35.3 0 64 28.7 64 64v88c0 92.8-75.2 168-168 168h-48C75.2 512 0 436.8 0 344v-24zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64zm-176-16c5.5 0 10.9.7 16 2v-34c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h16zm64 24v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v24z"
        }
    ]
};

const FarHandPointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandPointer",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16v136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4 8.8 0 16 7.2 16 16 0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4 7.8 0 14.3 5.6 15.7 13 1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4 8.8 0 16 7.2 16 16V392c0 39.8-32.2 72-72 72H211.4c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4l38.7 58.1c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V64zm16-64c-35.3 0-64 28.7-64 64v197.7c-20.8-23.7-56.5-28.9-83.5-11-29.4 19.7-37.4 59.4-17.7 88.8l67.5 101.3C108 485.3 157.9 512 211.4 512H328c66.3 0 120-53.7 120-120V272c0-35.3-28.7-64-64-64-4.5 0-8.8.5-13 1.3-11.7-15.4-30.2-25.3-51-25.3-6.9 0-13.5 1.1-19.7 3.1-11.6-16.4-30.7-27.1-52.3-27.1-2.7 0-5.4.2-8 .5V64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FarHandScissors = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandScissors",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1-8.2-1.9C22.5 200.5.7 166.3 8.3 131.8s41.9-56.3 76.4-48.6l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64h10.2c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6V344c0 66.3-53.7 120-120 120H288c-35.3 0-64-28.7-64-64 0-2.8.2-5.6.5-8.3-19.4-11-32.5-31.8-32.5-55.7v-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8.3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11 0 8.8 7.2 16 16 16 9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6 0 8.8 7.2 16 16 16h104c39.8 0 72-32.2 72-72V218.6c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6h-10.2c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6.6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12L262.8 172 74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2l-187.1 6.5z"
        }
    ]
};

const FarHandSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandSparkles",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M262.4 36C272.8 14.7 294.7 0 320 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4 35.3 0 64 28.7 64 64v2c5.1-1.3 10.5-2 16-2 35.3 0 64 28.7 64 64v163.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2-29.3 8.4c8.7-16.8 14-35.7 15-55.7 0-.6.1-1.3.2-1.9V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-8.8-7.2-16-16-16s-16 7.1-16 16v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v168c0 13.3-10.7 24-24 24s-24-10.7-24-24V95.9c0-8.8-7.2-15.9-16-15.9s-16 7.2-16 16v223.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-43.7-43.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9h13.3c.6-.1 1.3-.1 1.9-.2 30.9-1.5 59.1-13.4 81.2-32.1v.3c0 17.6 10.8 33.3 27 39.6-28.5 22.8-63.9 37.3-102.5 39.9-1.4.3-3 .4-4.5.4h-16.5c-67.9 0-133-27-181-75l-87.8-87.6c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7V96c0-35.3 28.7-64 64-64 7.9 0 15.4 1.4 22.4 4zm50.3 290.6L320 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L320 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L288 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L288 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm257.5 33.1L584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7zM104 88l40 11.4v25.1L104 136l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 136 7.7 122.2C3.1 120.9 0 116.7 0 112s3.1-8.9 7.7-10.2L56 88l13.8-48.3C71.1 35.1 75.3 32 80 32s8.9 3.1 10.2 7.7L104 88z"
        }
    ]
};

const FarHandSpock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandSpock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9 31.4 6 53 33.9 52 64.9 10-2.6 20.8-2.8 31.5-.1 34.3 8.6 55.1 43.3 46.6 77.6l-55.3 221.7C469.8 464.7 409.2 512 339.6 512h-33.7c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2-51.8-131.2c-13-32.9 3.2-70.1 36-83 11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9l-51.1-128c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8h33.7c47.5 0 89-32.4 100.5-78.5L495.5 164c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7l-31.8 167c-2.2 11.6-12.4 20-24.2 20-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"
        }
    ]
};

const FarHandWave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandWave",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m336.2 82.3-1.2-8.5c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S281.5-1.1 290.3.2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM80 68.7c17.9-17.9 43.8-23 66.2-15.2 3.1-6.8 7.4-13.1 13-18.7 25-25 65.5-25 90.5 0L368 153v-5.2c0-35.3 28.7-64 64-64s64 28.7 64 64v157.8c0 1.6 0 3.1-.1 4.7 0 .6.1 1.1.1 1.7 0 109.9-88.7 199.2-198.5 200h-8.1c-53 0-103.9-21.1-141.4-58.6L34.7 340.2c-25-25-25-65.5 0-90.5 3.9-3.9 8.2-7.2 12.7-9.9l-1.4-1.4c-25-25-25-65.5 0-90.5 5.6-5.6 11.9-9.9 18.7-13C57 112.5 62.1 86.6 80 68.7zm79.3 56.7-.1-.1-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l22.5 22.5.1.1 96.1 96.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96.1-96.1-.1-.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l39.5 39.7.1.1 56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-50.9-50.9-.1-.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l113.2 113.3C210.4 448 249.1 464 289.4 464h7.4c82.8-.5 149.9-67.1 151.1-149.8-.1-1-.1-2.1-.1-3.1.1-1.8.1-3.6.1-5.5V147.9c0-8.8-7.2-16-16-16s-16 7.2-16 16V211c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L215.8 68.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.3-.1 22.6l96.2 96.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96.1-96.1zM13.7 368.2c8.7-1.2 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.3 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2C34 457.7 6.3 430 1.3 394.8l-1.1-8.5c-1.2-8.7 4.8-16.9 13.6-18.1z"
        }
    ]
};

const FarHand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-25.3 0-47.2 14.7-57.6 36-7-2.6-14.5-4-22.4-4-35.3 0-64 28.7-64 64v165.5l-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5l87.7 87.7c48 48 113.1 75 181 75H304c1.5 0 3-.1 4.5-.4 91.7-6.2 165-79.4 171.1-171.1.3-1.5.4-3 .4-4.5V160c0-35.3-28.7-64-64-64-5.5 0-10.9.7-16 2v-2c0-35.3-28.7-64-64-64-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zm-16 96.1V64c0-8.8 7.2-16 16-16s16 7.2 16 16v168c0 13.3 10.7 24 24 24s24-10.7 24-24V95.9c0-8.8 7.2-16 16-16s16 7.2 16 16v136c0 13.3 10.7 24 24 24s24-10.7 24-24V160c0-8.8 7.2-16 16-16s16 7.2 16 16v172.9c-.1.6-.1 1.3-.2 1.9-3.4 69.7-59.3 125.6-129 129-.6 0-1.3.1-1.9.2h-13.4c-55.2 0-108.1-21.9-147.1-60.9l-87.7-87.8c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l43.7 43.7c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V96c0-8.8 7.2-16 16-16s16 7.1 16 15.9V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96.1z"
        }
    ]
};

const FarHandcuffs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandcuffs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-48 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9-.4-1.6-.5-3.3-.5-5.1v-16c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 336a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm192-112c0-25.9-5.1-50.5-14.4-73.1 16.9-32.9 44.8-59.1 78.9-73.9-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160-62 0-115.8-35.3-142.4-86.9 9.3-22.5 14.4-47.2 14.4-73.1zm240 0a112 112 0 1 0-224 0 112 112 0 1 0 224 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarHandsAslInterpreting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsAslInterpreting",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m186.3 55.8-51.8 86.3c-5.8 9.6-17.4 14-28.1 10.5S89 138.6 90 127.5l5.9-61.9c.8-8.8-5.6-16.6-14.4-17.4s-16.6 5.6-17.4 14.4l-16 168-.1.8v32.8c0 61.9 50.1 112 112 112h48c31.6 0 60.5-14.5 76.2-41.6 4.4-7.7 1.8-17.4-5.8-21.9-2.5-1.4-5.1-2.1-7.7-2.2h-.6c-5.5.1-10.7 3-13.6 8C247.4 334.1 230 344 208 344c-30.9 0-56-25.1-56-56s25.1-56 56-56c11.6 0 21.7 1.8 30.1 5.8 8.9 4.2 14.8 10.3 18.4 16.6 2.9 5 8.1 7.9 13.6 8h.6c2.6 0 5.2-.7 7.7-2.2 7.6-4.4 10.3-14.2 5.8-21.9-6-10.3-13.5-18-21.9-23.6-7.1-4.8-11.1-12.9-10.5-21.5s5.6-16.1 13.2-19.9l46.2-23.1c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-87.4 43.7c-9.5 4.8-21.1 2.7-28.3-5.2s-8.5-19.5-3-28.7l35.6-59.4c4.5-7.6 2.1-17.4-5.5-22s-17.4-2.1-22 5.5zm92.8 349.5C257.5 417.8 232.7 424 208 424h-48C71.6 424 0 352.4 0 264v-33.9c0-.8 0-1.5.1-2.3l.2-1.9 16-168C19.6 22.8 50.9-3.1 86.1.3c24.7 2.4 44.9 18.5 53.4 40.1l5.6-9.3C163.3.8 202.6-9 232.9 9.1c26.9 16.2 37.7 49 27 77.4l15.4-7.7c31.4-15.7 69.5-3.2 85.5 28C382.5 94.2 407.3 88 432 88h48c88.4 0 160 71.6 160 160v33.9c0 .8 0 1.5-.1 2.3l-.2 1.9-16 168c-3.4 35.2-34.6 61-69.8 57.6-24.7-2.4-44.9-18.5-53.4-40.1l-5.6 9.3c-18.2 30.3-57.5 40.1-87.8 22-26.9-16.2-37.7-49-27-77.4l-15.4 7.7c-31.4 15.7-69.5 3.2-85.5-28zm174.6 51 51.8-86.3c5.8-9.6 17.4-14 28.1-10.5s17.5 13.9 16.4 25.1l-5.9 61.9c-.8 8.8 5.6 16.6 14.4 17.4s16.6-5.6 17.4-14.4l16-168 .1-.8V248c0-61.9-50.1-112-112-112h-48c-31.6 0-60.5 14.5-76.2 41.6-4.4 7.6-1.8 17.4 5.8 21.9 2.5 1.4 5.1 2.1 7.7 2.2h.6c5.5-.1 10.7-3 13.6-8C392.6 177.9 410 168 432 168c30.9 0 56 25.1 56 56s-25.1 56-56 56c-11.6 0-21.7-1.8-30.1-5.8-8.9-4.2-14.8-10.3-18.4-16.6-2.9-5-8.1-7.9-13.6-8h-.6c-2.6 0-5.2.7-7.7 2.2-7.7 4.4-10.3 14.2-5.8 21.9 6 10.3 13.5 18 21.9 23.6 7.1 4.8 11.1 12.9 10.6 21.5s-5.6 16.1-13.2 19.9l-46.2 23.1c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l87.4-43.7c9.5-4.8 21.1-2.7 28.3 5.2s8.5 19.5 3 28.7l-35.6 59.4c-4.5 7.6-2.1 17.4 5.5 22s17.4 2.1 22-5.5zM224 288a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm208-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarHandsBound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsBound",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 72v134.6c0 22.2 7.4 43.7 21.1 61.2l69.2 88.6C100 360.7 96 367.9 96 376c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24 0-8.1-4-15.3-10.2-19.7l69.2-88.6c13.7-17.5 21.1-39 21.1-61.2V72c0-39.8-32.2-72-72-72s-72 32.2-72 72v66.3c-.5-.5-1-.9-1.6-1.4-29.8-25.2-74.3-22-100.2 7.2l-46.7 52.5c-4.2 4.7-8 9.7-11.5 14.8-3.5-5.2-7.3-10.1-11.5-14.8l-46.7-52.5c-25.9-29.2-70.4-32.4-100.2-7.2-.5.5-1.1.9-1.6 1.4V72c0-39.8-32.2-72-72-72S16 32.2 16 72zm147.8 280L74.9 238.2c-7.1-9-10.9-20.2-10.9-31.6V72c0-13.3 10.7-24 24-24s24 10.7 24 24v107.4l71.5 95.3c.1.2.3.4.4.6 7.5 9.4 20.9 11.6 31 5 11.4-7.4 14.1-22.9 6-33.7-.1-.2-.3-.4-.4-.6l-31.2-39c-2.7-3.3-4.3-7.2-5-11.2-1.3-8.1 1.6-16.6 8.2-22.2 9.9-8.4 24.8-7.3 33.4 2.4l46.7 52.5c15.1 16.9 23.4 38.8 23.4 61.5v62H163.8zm180.2 0v-61.9c0-22.7 8.3-44.6 23.4-61.5l46.7-52.5c8.6-9.7 23.5-10.8 33.4-2.4 6.7 5.6 9.5 14.1 8.2 22.2-.6 4-2.3 7.8-5 11.2l-31.3 39.1c-.2.2-.3.4-.4.6-8.1 10.8-5.4 26.3 6 33.7 10.1 6.6 23.5 4.3 31-5 .2-.2.3-.4.4-.6l71.6-95.5V72c0-13.3 10.7-24 24-24s24 10.7 24 24v134.6c0 11.5-3.8 22.6-10.9 31.7L476.2 352H344zm-224 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h120v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h120v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"
        }
    ]
};

const FarHandsBubbles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsBubbles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm112 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM144 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM48 143.8v84.6c0 39.8 16 77.3 43.4 104.7-14.4 7.6-26.9 18.3-36.6 31.2C20.1 328.3 0 279.8 0 228.4v-84.6c0-35.3 28.7-64 64-64 22.6 0 42.5 11.7 53.9 29.4L164.7 28c15.5-26.8 49.7-36 76.5-20.5 3.8 2.2 7.2 4.8 10.3 7.6 17.4-12.7 41.3-14.8 61.1-3.3s30 33.2 27.7 54.6c4 1.2 8 2.9 11.7 5.1 12.4 7.2 21.1 18.4 25.2 31-21.4-8.7-46.2-9.1-69 1l-53 23.5 20.2-35v-.1l16-27.7c2.2-3.8.9-8.7-2.9-10.9s-8.7-.9-10.9 2.9l-8 13.8v.1l-8 13.9-31.5 54.5c-19.1 9.6-36.4 21.8-51.5 36.1-9.8-7.1-12.9-20.7-6.7-31.4l48-83.1V60c2.2-3.8.9-8.7-2.9-10.9s-8.7-.9-10.9 2.9l-81.3 141.2c-5.4 9.4-16.5 14-27 11.2S80 192.1 80 181.2v-37.4c0-8.8-7.2-16-16-16s-16 7.2-16 16zM326.1 512c-31.3 0-60.7-7.9-86.4-21.8 8.4-13.8 13.9-29.5 15.7-46.4 20.5 12.8 44.7 20.1 70.7 20.1H456c4.4 0 8-3.6 8-8s-3.5-7.9-7.9-8H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c4.4 0 8-3.6 8-8s-3.5-8-7.9-8H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h128c4.4 0 8-3.6 8-8s-3.6-8-8-8H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H335.9c-11.2 0-21-7.8-23.4-18.8s3-22.2 13.2-27l25.1-11.8c8-3.8 11.4-13.3 7.7-21.3s-13.3-11.4-21.3-7.7l-56.4 26.5c-27.6 13-50.1 33.5-65.5 58.4-.2.2-.3.5-.5.7-14.6 21.7-22.8 47.6-22.8 74.8v.9c-14.5-6.9-30.7-10.7-47.7-10.8 1.8-33.2 12.6-64.6 30.4-91.3 20.2-32.4 49.6-59.2 85.7-76.1l56.4-26.5c32-15.1 70.1-1.3 85.2 30.7 7.9 16.8 7.9 35.3 1.4 51.3H488c30.9 0 56 25.1 56 56 0 4.4-.5 8.6-1.5 12.7 19.7 8.7 33.5 28.4 33.5 51.3s-13.8 42.6-33.5 51.3c1 4.1 1.5 8.3 1.5 12.7 0 22.9-13.8 42.6-33.5 51.3 1 4.1 1.5 8.3 1.5 12.7 0 30.9-25.1 56-56 56H326.1z"
        }
    ]
};

const FarHandsClapping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsClapping",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328 0c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM223.1 18.7c7.4-4.9 17.3-2.9 22.2 4.4l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2zM412 152c9.5-5.1 20.4-8 32-8 37.6 0 68 30.4 68 68v117.6c0 100.5-81.3 182-181.7 182.4 27.3-16.9 50.5-39.8 67.8-66.8 39.4-23.4 65.8-66.4 65.8-115.6V212c0-11-9-20-20-20-5 0-9.6 1.9-13.1 4.9-2.5-16.7-9.2-32-18.9-44.9zm-1.3-128.9c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48zM320 208v40c0 3.3-.6 6.4-1.8 9.2s-2.9 5.5-5.2 7.8-5 4-7.8 5.2-5.9 1.8-9.2 1.8-6.4-.6-9.2-1.8-5.5-2.9-7.8-5.2L169 154.9c-1.9-1.9-4.4-2.9-7-2.9-5.5 0-9.9 4.5-9.9 9.9 0 2.6 1 5.2 2.9 7l78 78.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-78.1-78-32-32c-1.9-1.9-4.4-2.9-7-2.9-5.5 0-9.9 4.5-9.9 9.9 0 2.6 1 5.2 2.9 7l24 24 86 86.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-86.1-86c-1.9-1.9-4.4-2.9-7-2.9-5.5 0-9.9 4.5-9.9 9.9 0 2.6 1 5.2 2.9 7l48 48 38 38.1c1.2 1.2 2.2 2.4 3.1 3.8 6.2 9.3 5.1 22-3.1 30.2-9.4 9.4-24.6 9.4-33.9 0L65 338.9c-1.9-1.9-4.4-2.9-7-2.9-5.5 0-9.9 4.5-9.9 9.9 0 2.6 1 5.2 2.9 7l22 22 16 16 33.6 33.6c25.2 25.2 59.4 39.4 95 39.4 74.2.1 134.4-60.1 134.4-134.3V208c0-8.8-7.2-16-16-16s-16 7.2-16 16zm-206.1-78.4C124.3 114.2 142 104 162 104c15.4 0 30.1 6.1 41 17l71 71.1c7.1-27.6 32.2-48.1 62-48.1 35.3 0 64 28.7 64 64v121.6C400 430.3 318.3 512 217.6 512c-48.4 0-94.8-19.2-129-53.4L55 425l-16-16-22-22C6.1 376 0 361.3 0 345.9c0-19.6 9.7-36.9 24.6-47.4l-7.6-7.6C6.1 280 0 265.3 0 249.9c0-21.2 11.4-39.8 28.4-49.9-2.9-7-4.4-14.5-4.4-22.1 0-32 25.9-57.9 57.9-57.9 11.4 0 22.5 3.4 31.9 9.6z"
        }
    ]
};

const FarHandsHoldingChild = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsHoldingChild",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 80a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm44.7 84.3 19.8 16.7c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-27.9-23.6C368.7 104.8 344.7 96 320 96s-48.7 8.8-67.6 24.7l-27.9 23.6c-10.1 8.6-11.4 23.7-2.8 33.8s23.7 11.4 33.8 2.8l19.8-16.7-11.1 88.8c-1.6 13.2 7.7 25.1 20.8 26.8s25.1-7.7 26.8-20.8l4.4-35h7.6l4.4 35c1.6 13.2 13.6 22.5 26.8 20.8s22.5-13.6 20.8-26.8l-11.1-88.8zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136v216.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-67.8-68A71.983 71.983 0 0 1 48 352.2V136c0-13.3 10.7-24 24-24s24 10.7 24 24v145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9L167 393l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16-26.7-26.7c-4-4-6.2-9.4-6.2-15 0-11.7 9.5-21.3 21.3-21.3 5.6 0 11 2.2 15 6.2l61.4 61.4c19.4 19.3 30.3 45.7 30.3 73.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2 11.7 0 21.3 9.5 21.3 21.3 0 5.6-2.2 11-6.2 15L439 359l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16 26.7-26.7 15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4V136c0-13.3 10.7-24 24-24s24 10.7 24 24v216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9V136c0-39.8-32.2-72-72-72s-72 32.2-72 72v128.8c-12.1-10.5-28-16.8-45.3-16.8-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3-5.8-9.1-12.6-17.5-20.4-25.3L238 268.3c-13-13-30.6-20.3-49-20.3-17.3 0-33.1 6.3-45.3 16.8V136z"
        }
    ]
};

const FarHandsHoldingCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsHoldingCircle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136v216.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-67.8-68A71.983 71.983 0 0 1 48 352.2V136c0-13.3 10.7-24 24-24s24 10.7 24 24v145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9L167 393l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16-26.7-26.7c-4-4-6.2-9.4-6.2-15 0-11.7 9.5-21.3 21.3-21.3 5.6 0 11 2.2 15 6.2l61.4 61.4c19.4 19.3 30.3 45.7 30.3 73.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2 11.7 0 21.3 9.5 21.3 21.3 0 5.6-2.2 11-6.2 15L439 359l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16 26.7-26.7 15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4V136c0-13.3 10.7-24 24-24s24 10.7 24 24v216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9V136c0-39.8-32.2-72-72-72s-72 32.2-72 72v128.8c-12.1-10.5-28-16.8-45.3-16.8-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3-5.8-9.1-12.6-17.5-20.4-25.3L238 268.3c-13-13-30.6-20.3-49-20.3-17.3 0-33.1 6.3-45.3 16.8V136z"
        }
    ]
};

const FarHandsHoldingDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsHoldingDiamond",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96zM72 64c39.8 0 72 32.2 72 72v128.8c12.1-10.5 28-16.8 45.3-16.8 18.4 0 36 7.3 49 20.3l61.4 61.4c7.7 7.7 14.5 16.2 20.4 25.3 5.8-9.1 12.6-17.5 20.4-25.3l61.4-61.4c13-13 30.6-20.3 49-20.3 17.3 0 33.1 6.3 45.3 16.8V136c0-39.8 32.2-72 72-72s72 32.2 72 72v216.2c0 31.8-12.6 62.3-35.1 84.9L537 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l67.9-67.9c13.5-13.5 21.1-31.8 21.1-50.9V136c0-13.3-10.7-24-24-24s-24 10.7-24 24v145.9c0 25.6-10.2 50.2-28.3 68.4l-15.9 15.9L473 393l-16 16c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l16-16 26.7-26.7c4-4 6.2-9.4 6.2-15 0-11.7-9.5-21.3-21.3-21.3-5.6 0-11 2.2-15 6.2l-61.4 61.4C354.9 383 344 409.4 344 436.8V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-51.2c0-27.4-10.9-53.8-30.3-73.2l-61.4-61.4c-4-4-9.4-6.2-15-6.2-11.7 0-21.3 9.5-21.3 21.3 0 5.6 2.2 11 6.2 15L201 359l16 16c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-16-16-26.7-26.7-15.9-15.9C106.2 332.1 96 307.5 96 281.9V136c0-13.3-10.7-24-24-24s-24 10.7-24 24v216.2c0 19.1 7.6 37.4 21.1 50.9L137 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-68-67.8C12.6 414.6 0 384.1 0 352.2V136c0-39.8 32.2-72 72-72z"
        }
    ]
};

const FarHandsHoldingDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsHoldingDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v10.9c-6.9 1.8-13.8 4.5-20.2 8.2-14.9 8.8-27.9 24.5-27.7 47.4.1 22.1 13.1 36 26.6 44.1 11.4 6.9 25.6 11.2 36.4 14.4l1.9.6c12.7 3.8 21.3 6.7 27.1 10.3 4 2.5 4 3.6 4 4.6v.2c0 2.3-.5 3.5-.8 4.1-.4.7-1.3 1.8-3.2 2.9-4.1 2.6-11.2 4.4-19.2 4.1-10.5-.3-20.2-3.6-33.9-8.3-2.3-.8-4.8-1.6-7.3-2.5-12.6-4.2-26.2 2.6-30.4 15.2s2.6 26.2 15.2 30.4c1.9.6 3.9 1.3 6 2 7.4 2.6 16.2 5.6 25.6 7.8V232c0 13.3 10.7 24 24 24s24-10.7 24-24v-10.6c7.4-1.8 14.6-4.7 21.3-8.8 15.3-9.5 27-25.9 26.7-48.5-.3-22-12.8-36.3-26.4-44.9-12-7.5-26.8-12-37.9-15.3l-.9-.3c-12.9-3.9-21.6-6.6-27.4-10.1-2.4-1.5-3.2-2.4-3.3-2.6v-.6c0-1.6.4-2.3.7-2.8.4-.6 1.4-1.8 3.5-3 4.7-2.8 12-4.5 19.4-4.4 9.1.1 19.3 2.1 30.2 5 12.8 3.4 26-4.2 29.4-17s-4.2-26-17-29.4c-5.6-1.5-11.7-3-18.2-4.2V24zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136v216.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-67.8-68A71.983 71.983 0 0 1 48 352.2V136c0-13.3 10.7-24 24-24s24 10.7 24 24v145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9L167 393l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16-26.7-26.7c-4-4-6.2-9.4-6.2-15 0-11.7 9.5-21.3 21.3-21.3 5.6 0 11 2.2 15 6.2l61.4 61.4c19.4 19.3 30.3 45.7 30.3 73.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2 11.7 0 21.3 9.5 21.3 21.3 0 5.6-2.2 11-6.2 15L439 359l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16 26.7-26.7 15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4V136c0-13.3 10.7-24 24-24s24 10.7 24 24v216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9V136c0-39.8-32.2-72-72-72s-72 32.2-72 72v128.8c-12.1-10.5-28-16.8-45.3-16.8-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3-5.8-9.1-12.6-17.5-20.4-25.3L238 268.3c-13-13-30.6-20.3-49-20.3-17.3 0-33.1 6.3-45.3 16.8V136z"
        }
    ]
};

const FarHandsHoldingHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsHoldingHeart",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m195.9 136.9 101.6 103.2c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4l101.6-103.2c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0l-17.7 18-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136v216.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-67.8-68A71.983 71.983 0 0 1 48 352.2V136c0-13.3 10.7-24 24-24s24 10.7 24 24v145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9L167 393l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16-26.7-26.7c-4-4-6.2-9.4-6.2-15 0-11.7 9.5-21.3 21.3-21.3 5.6 0 11 2.2 15 6.2l61.4 61.4c19.4 19.3 30.3 45.7 30.3 73.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2 11.7 0 21.3 9.5 21.3 21.3 0 5.6-2.2 11-6.2 15L439 359l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16 26.7-26.7 15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4V136c0-13.3 10.7-24 24-24s24 10.7 24 24v216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9V136c0-39.8-32.2-72-72-72s-72 32.2-72 72v128.8c-12.1-10.5-28-16.8-45.3-16.8-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3-5.8-9.1-12.6-17.5-20.4-25.3L238 268.3c-13-13-30.6-20.3-49-20.3-17.3 0-33.1 6.3-45.3 16.8V136z"
        }
    ]
};

const FarHandsHolding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsHolding",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 64c39.8 0 72 32.2 72 72v128.8c12.1-10.5 28-16.8 45.3-16.8 18.4 0 36 7.3 49 20.3l61.4 61.4c7.7 7.7 14.5 16.2 20.4 25.3 5.8-9.1 12.6-17.5 20.4-25.3l61.4-61.4c13-13 30.6-20.3 49-20.3 17.3 0 33.1 6.3 45.3 16.8V136c0-39.8 32.2-72 72-72s72 32.2 72 72v216.2c0 31.8-12.6 62.3-35.1 84.9L537 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l67.9-67.9c13.5-13.5 21.1-31.8 21.1-50.9V136c0-13.3-10.7-24-24-24s-24 10.7-24 24v145.9c0 25.6-10.2 50.2-28.3 68.4l-15.9 15.9L473 393l-16 16c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l16-16 26.7-26.7c4-4 6.2-9.4 6.2-15 0-11.7-9.5-21.3-21.3-21.3-5.6 0-11 2.2-15 6.2l-61.4 61.4C354.9 383 344 409.4 344 436.8V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-51.2c0-27.4-10.9-53.8-30.3-73.2l-61.4-61.4c-4-4-9.4-6.2-15-6.2-11.7 0-21.3 9.5-21.3 21.3 0 5.6 2.2 11 6.2 15L201 359l16 16c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-16-16-26.7-26.7-15.9-15.9C106.2 332.1 96 307.5 96 281.9V136c0-13.3-10.7-24-24-24s-24 10.7-24 24v216.2c0 19.1 7.6 37.4 21.1 50.9L137 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-68-67.8C12.6 414.6 0 384.1 0 352.2V136c0-39.8 32.2-72 72-72z"
        }
    ]
};

const FarHandsPraying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandsPraying",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.8 48c-5.9 0-11.4 2.9-14.8 7.7l-99.8 141c-12.4 17.6-19.1 38.6-19.1 60.1V297c0 24.1-15.4 45.5-38.3 53.1l-74.2 24.7C19 379 5.4 372.2 1.2 359.6s2.6-26.2 15.2-30.4l74.1-24.7c3.3-1.1 5.5-4.1 5.5-7.6v-40.2c0-31.5 9.8-62.2 28-87.9l99.8-141C236.2 10.4 256.4 0 277.8 0c16.1 0 30.8 5.8 42.2 15.3C331.4 5.8 346.1 0 362.2 0c21.5 0 41.6 10.4 54 27.9l99.8 141c18.2 25.7 28 56.4 28 87.9V297c0 3.4 2.2 6.5 5.5 7.6l74.1 24.7c12.6 4.2 19.4 17.8 15.2 30.4s-17.8 19.4-30.4 15.2l-74.1-24.7c-22.9-7.6-38.3-29-38.3-53.1v-40.4c0-21.5-6.7-42.5-19.1-60.1L377 55.7c-3.4-4.8-8.9-7.7-14.8-7.7-9.6 0-18 8-18.2 18.2v.8c.1 3.7 1.3 7.4 3.3 10.3L416.5 178c10.1 14.7 15.5 32.1 15.5 49.9V296c0 13.3-10.7 24-24 24s-24-10.7-24-24v-60c0-11-9-20-20-20-10.9 0-19.8 8.7-20 19.6v75.3c.4 46.6 31.8 87.3 76.9 99.5l201.4 54.4c12.8 3.5 20.4 16.6 16.9 29.4s-16.6 20.4-29.4 16.9l-201.5-54.4C370.9 446.6 339.9 423 320 392c-19.9 31-50.9 54.6-88.3 64.8L30.3 511.2c-12.8 3.5-26-4.1-29.4-16.9s4.1-26 16.9-29.4l201.4-54.4c45.1-12.2 76.5-52.9 76.9-99.5v-75.4c-.2-10.8-9.1-19.6-20-19.6-11 0-20 9-20 20v60c0 13.3-10.7 24-24 24s-24-10.7-24-24v-68.1c0-17.8 5.4-35.2 15.5-49.9l69.1-100.7c2-2.9 3.2-6.6 3.3-10.3v-.8C295.8 56 287.4 48 277.8 48zm42.2 74.4L287.9 169c12.1 2.1 23.1 7.5 32.1 15.1 9-7.6 20-13 32.1-15.1L320 122.4z"
        }
    ]
};

const FarHands = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHands",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 143.8c0-8.8-7.2-16-16-16s-16 7.2-16 16v37.4c0 10.9-7.3 20.4-17.8 23.2s-21.6-1.8-27-11.2L369.7 52c-2.2-3.8-7.1-5.1-10.9-2.9s-5.1 7.1-2.9 10.9v.1l48 83.1c6.2 10.7 3.2 24.3-6.7 31.4-15.1-14.3-32.3-26.5-51.5-36.1L314.3 84l-8-13.9V70l-8-13.8c-2.2-3.8-7.1-5.1-10.9-2.9s-5.1 7.1-2.9 10.9l8 13.9 8 13.9v.1l20.2 35-53-23.5c-22.8-10.1-47.6-9.8-69-1 4.1-12.6 12.8-23.9 25.2-31 3.8-2.2 7.7-3.9 11.7-5.1-2.3-21.4 7.8-43.2 27.7-54.6s43.8-9.4 61.1 3.3c3.1-2.9 6.5-5.4 10.3-7.6C361.6-8 395.8 1.2 411.3 28l46.9 81.2c11.4-17.7 31.3-29.4 53.9-29.4 35.3 0 64 28.7 64 64v84.6c0 69.4-36.7 133.6-96.5 168.8-10.4 6.1-21 11.1-31.9 15.1 8-19.2 13.3-39.9 15.4-61.4 40.5-27.4 65-73.2 65-122.4v-84.7zm-353.9 13c15.1-32 53.2-45.7 85.2-30.7l56.4 26.5c36 16.9 65.4 43.7 85.7 76.1 19.6 29.4 30.7 64.4 30.7 101.2v6.1c0 1.2-.1 2.3-.2 3.4-5 96.1-84.5 172.6-181.8 172.6H120c-30.9 0-56-25.1-56-56 0-4.4.5-8.6 1.5-12.7C45.8 434.6 32 414.9 32 392c0-4.4.5-8.6 1.5-12.7C13.8 370.6 0 350.9 0 328s13.8-42.6 33.5-51.3c-.9-4.1-1.5-8.3-1.5-12.7 0-30.9 25.1-56 56-56h84.7c-6.4-16-6.5-34.5 1.4-51.3zM72 320H56c-4.4 0-8 3.6-8 8s3.6 8 8 8h128c13.3 0 24 10.7 24 24s-10.7 24-24 24H87.9c-4.4 0-7.9 3.6-7.9 8s3.6 8 8 8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64.1c-4.4.1-7.9 3.6-7.9 8s3.6 8 8 8h129.9c72.3 0 131.3-57.3 134-128.9 0-.4 0-.9.1-1.3v-3.9c0-27.2-8.2-53.1-22.8-74.8-.2-.2-.3-.5-.5-.7-15.5-24.9-38-45.4-65.5-58.4l-56.4-26.5c-8-3.8-17.5-.3-21.3 7.7s-.3 17.5 7.7 21.3l25.1 11.8c10.2 4.8 15.7 16 13.2 27s-12.2 18.8-23.4 18.8H88c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H72z"
        }
    ]
};

const FarHandshakeAngle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandshakeAngle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 320c39.8 0 72-32.2 72-72v-8h104c13.3 0 24 10.7 24 24 0 11.7-8.4 21.5-19.4 23.6-7.7 1.5-14.2 6.6-17.4 13.8s-2.7 15.5 1.4 22.2c2.2 3.6 3.4 7.8 3.4 12.4 0 13.3-10.7 24-24 24s-24 10.7-24 24c0 8.8-7.2 16-16 16H253.3c-14.9 0-29.1 5.9-39.6 16.4L159 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l54.6-54.6c1.5-1.5 3.5-2.3 5.7-2.3H368c28 0 51.8-17.9 60.5-42.9 29.8-8.8 51.5-36.4 51.5-69.1 0-3.9-.3-7.8-.9-11.5 19.8-12.8 32.9-35.1 32.9-60.5 0-39.8-32.2-72-72-72H336v-24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-22.1 17.9-40 40-40h138.7c14.9 0 29.1-5.9 39.6-16.4L513 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-54.7 54.6c-1.5 1.5-3.5 2.3-5.7 2.3H280c-48.6 0-88 39.4-88 88v96c0 39.8 32.2 72 72 72zM160 132.5c-19 7.5-33.9 23.6-39.4 44.2L99 257.5c-.4 1.4-1.1 2.6-2.1 3.6L7 351c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l90-89.9c7-7 12-15.6 14.5-25.2l14.6-54.7v-82.6zm383.2 118.3L633 161c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-75.3 75.3c10.3 13.9 17.1 30.5 19.4 48.5z"
        }
    ]
};

const FarHandshakeSimpleSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandshakeSimpleSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L501.8 368H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H440.6l-99.4-77.9 35.1-32.4c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-40.9 37.7-39-30.5 44.9-42.4c18.5-17.4 42.9-27.1 68.3-27.1 24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1h88c13.3 0 24-10.7 24-24s-10.7-24-24-24h-78.9L475 101.2C448 77.3 413.2 64 377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-50.1 47.4-31.2-24.4c8.3-5 17.2-8.9 26.5-11.5l51.1-51.1c-4.4-.4-8.8-.6-13.2-.6h-10.3c-34 0-66.9 11.4-93.6 32.2L38.8 5.1zm350.1 397.3-42-33.1c.8 8.5-2.1 17.2-8.6 23.7-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8-6.2 6.2-16.4 6.2-22.6 0L193 370.1l-7-7-35.6-35.6c-15-15-35.4-23.4-56.6-23.4H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h37.7c8.5 0 16.6 3.4 22.6 9.4L152 397l7 7 26.9 27c23.6 23.6 60.9 24.9 86 4.1 30.4 22 73 19.3 100.4-8.1 7.3-7.3 12.8-15.6 16.6-24.5zM101.5 176l-57.1-45C37 135.1 32 143 32 152c0 13.3 10.7 24 24 24h45.5z"
        }
    ]
};

const FarHandshakeSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandshakeSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.2 64.6c-4.4-.4-8.8-.6-13.2-.6h-10.3c-37.2 0-73.2 13.7-101 38.4L121.1 126c-1.5 1.3-3.4 2-5.3 2H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h59.8c13.7 0 27-5 37.2-14.1l26.5-23.6c12-10.7 26.2-18.3 41.5-22.5l51.1-51.1zm104.9-.6c-37.6 0-73.9 14.4-101.2 40.2l-70.1 66.2c-30.8 29.1-30.1 78.3 1.6 106.5 27.8 24.7 69.7 24.3 97-.9l35.8-33 75.8 75.8c9.4 9.4 9.4 24.6 0 33.9-8.4 8.4-21.6 9.3-30.9 2.6-7.1-5.1-16.5-5.9-24.4-2.1s-13.1 11.6-13.6 20.4c-.4 7.1-3.2 14-8.6 19.4-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8-6.2 6.2-16.4 6.2-22.6 0L193 370.1l-7-7-35.6-35.6c-15-15-35.4-23.4-56.6-23.4H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h37.7c8.5 0 16.6 3.4 22.6 9.4L152 397l7 7 26.9 27c23.6 23.6 60.9 24.9 86 4.1 30.4 22 73 19.3 100.4-8.1 6.1-6.1 10.9-12.9 14.6-20.2 22.2 3.8 45.8-2.9 63-20.1 5.6-5.6 10.1-11.9 13.5-18.7H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H469.2c-2.9-12.9-9.3-25.1-19.4-35.1l-74.4-74.4.8-.8c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-71.9 66.4c-9.2 8.5-23.2 8.6-32.5.3-10.6-9.4-10.9-26-.5-35.7l70.1-66.2c18.5-17.4 42.9-27.1 68.3-27.1 24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1h88c13.3 0 24-10.7 24-24s-10.7-24-24-24h-79L475 101.2C448 77.3 413.2 64 377.1 64z"
        }
    ]
};

const FarHandshakeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandshakeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L501.8 368h46.5c5.5 9.6 15.9 16 27.7 16h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H505.1L475 101.2C448 77.3 413.2 64 377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-50.1 47.4-31.2-24.4c8.3-5 17.2-8.9 26.5-11.5l51.1-51.1c-4.4-.4-8.8-.6-13.2-.6h-10.3c-34 0-66.9 11.4-93.6 32.2L38.8 5.1zm225.1 176.4 44.9-42.4c18.5-17.4 42.9-27.1 68.3-27.1 24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1h48v144H440.6l-99.4-77.9 35.1-32.4c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-40.9 37.7-39-30.5zM96 171.6 40.6 128H16c-8.8 0-16 7.2-16 16v208c0 17.7 14.3 32 32 32h32c17.6 0 32-14.3 32-31.9 7.7.5 14.9 3.8 20.4 9.3L152 397l7 7 26.9 27c23.6 23.6 60.9 24.9 86 4.1 30.4 22 73 19.3 100.4-8.1 7.3-7.3 12.8-15.6 16.6-24.5l-42-33.1c.8 8.5-2.1 17.2-8.6 23.7-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8-6.2 6.2-16.4 6.2-22.6 0L193 370.1l-7-7-35.6-35.6c-14.6-14.5-34-22.9-54.4-23.5V171.6zM32 336a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm560-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarHandshake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHandshake",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m272.2 64.6-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9c-10.2 9.1-23.5 14.1-37.2 14.1H96v128c20.4.6 39.8 8.9 54.3 23.4l35.6 35.6 7 7 27 27c6.2 6.2 16.4 6.2 22.6 0 1.7-1.7 3-3.7 3.7-5.8 2.8-7.7 9.3-13.5 17.3-15.3s16.4.6 22.2 6.5l10.8 10.6c11.6 11.6 30.4 11.6 41.9 0 5.4-5.4 8.3-12.3 8.6-19.4.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6 9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2l30.1 26.8H624c8.8 0 16 7.2 16 16v208c0 17.7-14.3 32-32 32h-32c-11.8 0-22.2-6.4-27.7-16h-84.9c-3.4 6.7-7.9 13.1-13.5 18.7-17.1 17.1-40.8 23.8-63 20.1-3.6 7.3-8.5 14.1-14.6 20.2-27.3 27.3-70 30-100.4 8.1-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3 0 17.6-14.4 31.9-32 31.9H32c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16h99.8c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64H259c4.4 0 8.9.2 13.2.6zM544 320V176h-48c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8C425 120.9 401.5 112 377.1 112c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3.5 35.7 9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8.8 74.4 74.4c10 10 16.5 22.3 19.4 35.1H544zM64 336a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarHanukiah = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHanukiah",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 56c0-19.4 13.1-43.9 18.2-52.7 1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C330.9 12.1 344 36.6 344 56c0 13.3-10.7 24-24 24s-24-10.7-24-24zM0 104c0-19.4 13.1-43.9 18.2-52.7 1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C34.9 60.1 48 84.6 48 104c0 13.3-10.7 24-24 24S0 117.3 0 104zm106.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3c5.1 8.8 18.2 33.3 18.2 52.7 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM152 104c0-19.4 13.1-43.9 18.2-52.7 1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3c5.1 8.8 18.2 33.3 18.2 52.7 0 13.3-10.7 24-24 24s-24-10.7-24-24zm82.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3c5.1 8.8 18.2 33.3 18.2 52.7 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM376 104c0-19.4 13.1-43.9 18.2-52.7 1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3c5.1 8.8 18.2 33.3 18.2 52.7 0 13.3-10.7 24-24 24s-24-10.7-24-24zm82.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3c5.1 8.8 18.2 33.3 18.2 52.7 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM504 104c0-19.4 13.1-43.9 18.2-52.7 1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3c5.1 8.8 18.2 33.3 18.2 52.7 0 13.3-10.7 24-24 24s-24-10.7-24-24zm106.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3c5.1 8.8 18.2 33.3 18.2 52.7 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM320 112c13.3 0 24 10.7 24 24v200h208c22.1 0 40-17.9 40-40V184c0-13.3 10.7-24 24-24s24 10.7 24 24v112c0 48.6-39.4 88-88 88H344v80h152c13.3 0 24 10.7 24 24s-10.7 24-24 24H144c-13.3 0-24-10.7-24-24s10.7-24 24-24h152v-80H88c-48.6 0-88-39.4-88-88V184c0-13.3 10.7-24 24-24s24 10.7 24 24v112c0 22.1 17.9 40 40 40h208V136c0-13.3 10.7-24 24-24zm-208 48c8.8 0 16 7.2 16 16v128H96V176c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16v128h-32V176c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16v128h-32V176c0-8.8 7.2-16 16-16zm160 0c8.8 0 16 7.2 16 16v128h-32V176c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16v128h-32V176c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16v128h-32V176c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarHardDrive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHardDrive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v162c5.1-1.3 10.5-2 16-2h384c5.5 0 10.9.7 16 2V96c0-8.8-7.2-16-16-16H64zM48 320v96c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm-48 0V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-96zm280 48a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarHashtagLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHashtagLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2l-15 75.3h111l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136H424c13.3 0 24 10.7 24 24v1.1c-19.9 2.9-38.2 11-53.3 22.9h-51.8l-55.4 276.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2l15-75.3h-111l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8S78 464.3 80.6 451.3L95.5 376H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h81.1l28.8-144H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h87.5l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184l-28.8 144h111l28.8-144h-111zM464 240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FarHashtag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHashtag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2l-15 75.3h111l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-81.1l-28.8 144H392c13.3 0 24 10.7 24 24s-10.7 24-24 24h-87.5l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2l14.9-75.3h-111l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8S78 464.3 80.6 451.3L95.5 376H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h81.1l28.8-144H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h87.5l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184l-28.8 144h111l28.8-144h-111z"
        }
    ]
};

const FarHatBeach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHatBeach",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M197.9 201.4C225.6 215.1 270 224 320 224c23.6 0 46-2 66-5.5-1.3-4.2-2-8.7-2-13.2 0-22 15.7-40.4 36.6-44.4C397.1 131.1 360.8 112 320 112c-57.2 0-105.7 37.6-122.1 89.4zM320 64c70.2 0 130.8 41.1 159 100.5 6.1-2.9 12.8-4.5 19.7-4.5 25 0 45.3 20.3 45.3 45.3 0 12-4.8 23.5-13.3 32L528 240l2.7 2.7c.8.8 1.6 1.6 2.3 2.5l77.3 30.9c17.9 7.2 29.7 24.6 29.7 43.9 0 17.6-8.9 34.5-25.1 49.8-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7l16.5-17.4-16.5 17.4C8.9 354.5 0 337.6 0 320c0-19.3 11.8-36.7 29.7-43.9l8.6 21.6-8.6-21.6 114.6-45.8C149.3 137.6 226.1 64 320 64zm109.3 256c-16.7 0-31.3-9-39.1-22.5-21.2 4.1-45 6.5-70.2 6.5-62.4 0-116.5-14.3-142.9-35.2-.3.1-.5.2-.8.3L48 320.5c.2 1.5 1.5 6.4 10.1 14.5 10.3 9.8 27.8 20.8 53.4 31 51 20.3 124.7 34 208.5 34s157.5-13.7 208.4-34.1c25.6-10.2 43.1-21.2 53.4-31 8.6-8.1 9.9-13 10.1-14.5l-54.7-21.9c-8 12.9-22.2 21.4-38.5 21.4-12 0-23.5-4.8-32-13.3L464 304l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3zm34.7-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarHatChef = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHatChef",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M180.9 100.3C192.2 69.7 221.6 48 256 48s63.8 21.7 75.1 52.3c3.2 8.7 11.2 14.8 20.5 15.6s18.2-3.8 22.8-11.9c8.3-14.4 23.9-24 41.6-24 26.5 0 48 21.5 48 48 0 10.9-2.9 28.1-8.1 49.2-5.1 20.6-11.9 43.2-18.8 64.4-6.9 21.2-13.8 40.6-19 54.8-1 2.7-1.9 5.3-2.8 7.6h-54.7l23.2-133.3c1.5-8.7-4.3-17-13-18.5s-17 4.3-18.5 13L328.1 304H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v144h-56.1l-24.1-138.7c-1.5-8.7-9.8-14.5-18.5-13s-14.5 9.8-13 18.5L151.4 304H96.6c-.9-2.3-1.8-4.9-2.8-7.6-5.2-14.2-12.1-33.7-19-54.8-6.9-21.2-13.7-43.8-18.8-64.4-5.1-21.1-8-38.3-8-49.2 0-26.5 21.5-48 48-48 17.7 0 33.3 9.6 41.6 24 4.7 8.1 13.6 12.7 22.8 11.9s17.3-6.9 20.5-15.6zm273.5 236.4L432 328l22.4 8.7v-.1l.1-.3.5-1.3c.4-1.1 1-2.7 1.8-4.8 1.6-4.1 3.8-10.1 6.4-17.3 5.3-14.6 12.4-34.6 19.5-56.4 7.1-21.8 14.3-45.7 19.7-67.8 5.3-21.7 9.4-43.5 9.4-60.6 0-53-43-96-96-96-21.6 0-41.6 7.2-57.6 19.2C335.1 20.1 297.9 0 256 0s-79.1 20.1-102.4 51.2c-16-12-36-19.2-57.6-19.2-53 0-96 43-96 96 0 17.1 4.1 38.9 9.4 60.6 5.4 22.2 12.6 46 19.7 67.8 7.1 21.8 14.2 41.9 19.5 56.4 2.7 7.3 4.9 13.2 6.4 17.3.8 2.1 1.4 3.7 1.8 4.8l.5 1.3.1.3v.1l22.4-8.7-22.4 8.7C61.2 345.9 70.1 352 80 352h352c9.9 0 18.8-6.1 22.4-15.3zM64 384v64c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64v-64h-48v64c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16v-64H64z"
        }
    ]
};

const FarHatCowboySide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHatCowboySide",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M444.8 256H311.3l-31.5-25.6c-25-20.3-55-33-86.6-37.1l4.9-63.4c.3-3.6 2.9-6.5 6.4-7.2l207.8-41.5L444.8 256zM560 400h-40c0-1.4-.1-2.9-.4-4.4l-26-139.6c10.2 5.4 21.6 12 32.8 19.8 37.2 25.4 65.6 57.1 65.6 92.2 0 17.7-14.3 32-32 32zm-62-195.4c-5.9-2.8-11.1-5.1-15.3-6.9l-24.6-132C454.6 46.2 437.6 32 417.7 32c-2.7 0-5.4.3-8.1.8L195.1 75.7c-24.6 4.9-42.9 25.6-44.9 50.6L145 194C62.9 206.8 0 277.9 0 363.6v18.8C0 418.6 29.4 448 65.6 448H560c44.2 0 80-35.8 80-80 0-60.9-47.6-105.2-86.4-131.8-20.3-13.9-40.5-24.5-55.5-31.6zm-450 159C48 295.3 103.3 240 171.6 240c28.4 0 55.9 9.8 77.9 27.7L412.4 400H65.6c-9.7 0-17.6-7.9-17.6-17.6v-18.8z"
        }
    ]
};

const FarHatCowboy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHatCowboy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M254.2 82.7c-2 2.8-4.4 6.7-7.1 11.8-10.3 19.5-20.2 47.5-28.9 78.5-8.5 30.4-15.3 61-19.9 84.3-.9 4.7-1.8 9.1-2.5 13.1-16.8-5-32-10.6-45.7-16.6C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64s22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.4 0 84.4 152.2 97.9 221.9-13.7 5.9-28.9 11.6-45.7 16.6-.8-4-1.6-8.4-2.5-13.2-4.6-23.3-11.3-54-19.9-84.3-8.7-30.9-18.6-59-28.9-78.5-2.7-5.1-5.1-9-7.1-11.8-.5.4-1 .9-1.6 1.4-.5.5-1.1 1-1.8 1.6-8.4 7.6-29 26.3-62.4 26.3s-54-18.7-62.3-26.2c-.7-.6-1.3-1.2-1.8-1.6-.6-.5-1.2-1-1.6-1.4zM380.9 77h.1zm-121.7 0h.1zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7 7.9-7.9 20.2-9.2 29.6-3.3 9.5 5.9 13.5 17.9 9.9 28.5-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2c-27.7-28.4-52.6-63-66.1-100.7-3.6-10.6.4-22.6 9.9-28.5 9.5-5.9 21.7-4.5 29.6 3.3 20.4 19.4 45.3 34.8 70.1 47.7z"
        }
    ]
};

const FarHatSanta = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHatSanta",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 352h51.7l78.6-196.4C212.5 109.9 256.8 80 305.9 80c35.4 0 69 15.6 91.8 42.6l19 22.5c-4-.7-8-1.1-12-1.1h-1.2c-37.3 0-67.6 30.3-67.6 67.6 0 10 2.2 19.8 6.4 28.8L395 352h53l-62.1-132c-1.2-2.6-1.9-5.5-1.9-8.4 0-10.8 8.8-19.6 19.6-19.6h1.2c2.1 0 4.2.3 6.3 1l47.1 14.9c1.9-2.7 4-5.1 6.3-7.4 0-14.3 5.5-28.7 16.4-39.6 2.2-2.2 4.6-4.2 7.1-6l-53.6-63.3c-32-37.8-79-59.6-128.5-59.6-68.8 0-130.7 41.9-156.3 105.8L64 352zm519.9-169.8C583 169.8 572.7 160 560 160s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6c-12.5 1-22.3 11.3-22.3 24s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2c1 12.5 11.3 22.3 24 22.3s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6c12.5-1 22.3-11.3 22.3-24s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 432c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48s-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarHatWinter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHatWinter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-12.7 0-23 9.8-23.9 22.2-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C185.8 57 176 67.3 176 80s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2c1 12.5 11.3 22.3 24 22.3s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6c12.5-1 22.3-11.3 22.3-24s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2C279 9.8 268.7 0 256 0zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48h416c26.5 0 48-21.5 48-48s-21.5-48-48-48H48zm114.5-281.4C42.8 199.9 32 384 32 384h48.1c.1-1.5.3-3.7.6-6.3.7-6.5 2-16 4.2-27.4.9-4.9 2-10.1 3.2-15.5l36.3-18.1c2.3-1.1 4.9-1.1 7.2 0l35.4 17.6c15.8 7.9 34.3 7.9 50.1 0l35.4-17.7c2.3-1.1 4.9-1.1 7.2 0l35.3 17.7c15.8 7.9 34.3 7.9 50.1 0l35.4-17.7c2.3-1.1 4.9-1.1 7.2 0l36.3 18.1c1.2 5.4 2.3 10.6 3.2 15.5 2.1 11.5 3.4 21 4.2 27.4.3 2.6.5 4.7.6 6.3h48s-10.8-184.1-130.5-249.4c-2.5 9-7.3 17.5-14.4 24.6-5.6 5.6-12.2 9.8-19.2 12.6 41 17.8 67.7 53.9 86 95.6.6 1.3 1.2 2.7 1.7 4-14.5-5.5-30.8-4.7-44.9 2.3l-35.4 17.7c-2.3 1.1-4.9 1.1-7.2 0L281 273.7c-15.8-7.9-34.3-7.9-50.1 0l-35.4 17.7c-2.3 1.1-4.9 1.1-7.2 0L153 273.7c-14.1-7-30.3-7.8-44.9-2.3.6-1.3 1.2-2.7 1.7-4 18.4-41.7 45.1-77.8 86-95.6-7-2.7-13.5-6.9-19.2-12.6-7.1-7.1-11.9-15.6-14.4-24.6z"
        }
    ]
};

const FarHatWitch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHatWitch",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M148.4 384H96l85.9-196.3C198.8 149 228 116.9 265 96.5l170.4-94c3-1.7 6.4-2.5 9.9-2.5 7 0 13.7 2.4 19.1 6.7L564 86.4c7.6 6.1 12 15.3 12 25v9.6c0 4.6-1 9.2-2.9 13.4L534 219.1c-3.6 7.9-11.5 12.9-20.1 12.9-10.4 0-19.4-7.2-21.7-17.4l-8-35.9c-2.5-10.9-12.2-18.7-23.4-18.7-8 0-15.5 4-19.9 10.7L421.4 200c-3.5 5.3-5.4 11.5-5.4 17.8 0 4.1.8 8.2 2.3 11.9L480 384h-51.7l-54.6-136.5c-3.8-9.5-5.7-19.7-5.7-29.8 0-15.7 4.6-31.2 13.4-44.5L401 144c13.3-20 35.8-32 59.8-32 22.8 0 43.6 10.7 56.9 27.9l9.8-21.2-82.9-66.4-156.4 86.3c-27.7 15.3-49.7 39.3-62.4 68.4l-77.4 177zm91.6-48c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v48h-96v-48zm313.4 80c12.5 0 22.6 10.1 22.6 22.6 0 6-2.4 11.7-6.9 15.6-19 16.1-75.7 57.8-153.1 57.8H160c-77.4 0-134.1-41.7-153.1-57.8-4.5-3.8-6.9-9.6-6.9-15.6C0 426.1 10.1 416 22.6 416h530.8z"
        }
    ]
};

const FarHatWizard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHatWizard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M327.7 227.6c-5.1-11.5-7.7-23.9-7.7-36.5 0-10.1 1.7-20.1 5-29.7l27.7-79.1-98.3 56.2c-26.6 15.2-47.7 38.5-60.1 66.5l-93.8 211H48l102.4-230.5c16.6-37.4 44.7-68.4 80.2-88.7l146.3-83.6h.1l2.1-1.2 16.6-9.5c2.8-1.6 6-2.5 9.3-2.5 10.5 0 19 8.5 19 19v1.5c0 2.3-.4 4.6-1.2 6.8l-5 14.2-1.5 4.2-.1.3-46 131.3c-1.6 4.4-2.4 9.1-2.4 13.8 0 5.9 1.2 11.7 3.6 17l-43.9 19.5zm43.9-19.5L464 416h-52.5l-83.8-188.4 43.9-19.5zM246.2 416h-44.4l-6.5-19.4-40.4-13.5c-6.5-2.1-10.9-8.2-10.9-15.1s4.4-13 10.9-15.2l40.4-13.5 13.5-40.4c2.2-6.5 8.3-10.9 15.2-10.9s13 4.4 15.2 10.9l13.5 40.4 40.4 13.5c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-40.4 13.5-6.5 19.3zM0 480c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm264-312c3.4 0 6.5 2.2 7.6 5.5l6.7 20.2 20.2 6.7c3.3 1.1 5.5 4.1 5.5 7.6s-2.2 6.5-5.5 7.6l-20.2 6.7-6.7 20.2c-1.1 3.3-4.1 5.5-7.6 5.5s-6.5-2.2-7.6-5.5l-6.7-20.2-20.2-6.7c-3.3-1.1-5.5-4.1-5.5-7.6s2.2-6.5 5.5-7.6l20.2-6.7 6.7-20.2c1.1-3.3 4.1-5.5 7.6-5.5z"
        }
    ]
};

const FarHeadSideBrain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSideBrain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3 3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1 10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11 0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16h-88c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64v-48h.4c35.1 0 63.6-28.5 63.6-63.6 0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0h-24C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5 8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm264-32c22.1 0 40-17.9 40-40s-17.9-40-40-40c-2 0-3.9.1-5.8.4-6.4-9.9-17.5-16.4-30.2-16.4-6.2 0-12.1 1.6-17.2 4.3C252 88.2 238.9 80 224 80s-28 8.2-34.8 20.3c-5.1-2.7-11-4.3-17.2-4.3-18.5 0-33.8 14-35.8 32h-.2c-22.1 0-40 17.9-40 40 0 16.5 9.9 30.6 24.1 36.7-.1 1.1-.1 2.2-.1 3.3 0 22.1 17.9 40 40 40 5.7 0 11.1-1.2 16-3.3V296c0 13.3 10.7 24 24 24s24-10.7 24-24v-48.8c2.6.5 5.3.8 8 .8 22.1 0 40-17.9 40-40 0-5.7-1.2-11.1-3.3-16H312z"
        }
    ]
};

const FarHeadSideCoughSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSideCoughSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M129 75.8C156.4 58.2 189 48 224 48h24c60.1 0 115.7 36.7 139.6 88.3 3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1 10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11 0 8.6-7 15.6-15.6 15.6H424c-6.3 0-12 2.4-16.2 6.3L129 75.8zM459.7 335c29.7-5.3 52.3-31.3 52.3-62.6 0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0h-24c-50.5 0-97 16.7-134.5 44.8L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459.7 335zM27 117.3C9.8 149 0 185.4 0 224c0 53.6 18.9 102.9 50.3 141.5 8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224c0-27.4 6.3-53.3 17.4-76.4L27 117.3zm312.2 245.9-1.3.3c-10.5 2.6-17.8 12-17.8 22.8 0 12.2 9.4 22.4 21.6 23.4l58.4 4.9V432c0 8.8-7.2 16-16 16H296c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24 10.4 0 19.3-6.7 22.6-16H384c30 0 55.2-20.6 62.1-48.5l-107-84.3zM640 384a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarHeadSideCough = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSideCough",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48c-97.2 0-176 78.8-176 176 0 42.2 14.8 80.8 39.5 111.1 13.6 16.6 24.5 38.5 24.5 63.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-89.4c0-10.7-4.8-22.2-13.7-33.1C18.9 326.9 0 277.6 0 224 0 100.3 100.3 0 224 0h24c78.8 0 151.4 47.6 183.2 116.2 4.2 9.1 8.2 18.4 12 27.3l1.5 3.5c4.3 10.1 8.5 19.7 13 29 9 18.6 18.7 34.5 31.4 47.1l4.4 4.4c11.9 11.9 18.6 28.1 18.6 45 0 35.1-28.5 63.6-63.6 63.6h-.5v96c0 35.3-28.7 64-64 64h-65.4c-3.3 9.3-12.2 16-22.6 16-13.3 0-24-10.7-24-24V472c0-13.3 10.7-24 24-24h88c8.8 0 16-7.2 16-16v-17.3l-58.4-4.9c-12.2-1-21.6-11.2-21.6-23.4 0-10.8 7.3-20.2 17.8-22.8L400 348v-36c0-13.3 10.7-24 24-24h24.4c8.6 0 15.6-7 15.6-15.6 0-4.1-1.6-8.1-4.6-11L455 257c-18.1-18.1-30.6-39.4-40.6-60.1-5-10.4-9.6-21-13.9-31.1l-1.5-3.5c-3.8-9-7.5-17.6-11.4-25.9C363.7 84.7 308.1 48 248 48h-24zm80 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm184 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-88-120a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-88 168a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarHeadSideGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSideGear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3 3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1 10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11 0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16h-88c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64v-48h.4c35.1 0 63.6-28.5 63.6-63.6 0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0h-24C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5 8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm288.6-28.1c6.3-3.6 9.5-11.1 6.8-18-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9-2.6 6.8.5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 18 2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5 4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9 6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3 3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8 2.6-6.8-.5-14.3-6.8-18l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM184 224a40 40 0 1 1 80 0 40 40 0 1 1-80 0z"
        }
    ]
};

const FarHeadSideGoggles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSideGoggles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.6 240h48.1c3.3 35.9 17.3 68.7 38.8 95.1 13.6 16.6 24.5 38.5 24.5 63.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-89.4c0-10.7-4.8-22.2-13.7-33.1C22 330.8 3.9 287.4.6 240zM122.8 80h93.7C234 60.4 259.6 48 288 48h-64c-37.7 0-72.6 11.8-101.2 32zM64 80H52.4C93.5 31.1 155.1 0 224 0h32c48.7 0 93.2 18.1 127 48h81c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H288c-28.4 0-54-12.4-71.6-32H64c-35.3 0-64-28.7-64-64s28.7-64 64-64zm400 192.4v-.4h48v.4c0 35.1-28.5 63.6-63.6 63.6h-.4v48c0 35.3-28.7 64-64 64h-64v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64c0-13.3 10.7-24 24-24h88c8.8 0 16-7.2 16-16v-72c0-13.3 10.7-24 24-24h24.4c8.6 0 15.6-7 15.6-15.6zM64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h129.3c-.9-5.2-1.3-10.5-1.3-16s.5-10.8 1.3-16H64zm320-32h-96c-26.5 0-48 21.5-48 48s21.5 48 48 48h96V96zm48 0v96h32V96h-32z"
        }
    ]
};

const FarHeadSideHeadphones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSideHeadphones",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 52.6C106.1 70.7 48 140.5 48 224c0 42.2 14.8 80.8 39.5 111.1 13.6 16.6 24.5 38.5 24.5 63.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-89.4c0-10.7-4.8-22.2-13.7-33.1C18.9 326.9 0 277.6 0 224 0 100.3 100.3 0 224 0h24c78.8 0 151.4 47.6 183.2 116.2 4.2 9.1 8.2 18.4 12 27.3l1.5 3.5c4.3 10.1 8.5 19.7 13 29 9 18.6 18.7 34.5 31.4 47.1l4.4 4.4c11.9 11.9 18.6 28.1 18.6 45 0 35.1-28.5 63.6-63.6 63.6h-.5v48c0 35.3-28.7 64-64 64h-64v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V424c0-13.3 10.7-24 24-24h88c8.8 0 16-7.2 16-16v-72c0-13.3 10.7-24 24-24h24.4c8.6 0 15.6-7 15.6-15.6 0-4.1-1.6-8.1-4.6-11L455 257c-18.1-18.1-30.6-39.4-40.6-60.1-5-10.4-9.6-21-13.9-31.1l-1.5-3.5c-3.8-9-7.5-17.6-11.4-25.9C363.7 84.7 308.1 48 248 48h-16v50.6c50.3 11 88 55.8 88 109.4 0 61.9-50.1 112-112 112S96 269.9 96 208c0-53.6 37.7-98.4 88-109.4v-46zM272 208a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-96 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarHeadSideHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSideHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3 3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1 10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11 0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16h-88c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64v-48h.4c35.1 0 63.6-28.5 63.6-63.6 0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0h-24C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5 8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm64-34.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FarHeadSideMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSideMask",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 224c0-8 .5-15.8 1.5-23.4L256 316.8V480c0 17.7 14.3 32 32 32h143.7c28.6 0 53.7-18.9 61.5-46.4L534.9 320l4.7-16.6c1.5-5.1 2.6-10.4 3.3-15.6.7-3.1 1.1-6.2 1.1-9.5 0-.8 0-1.6-.1-2.3 0-1.3.1-2.6.1-3.9h-.5c-1.1-7.2-4.1-14.1-8.7-19.9l-18-22.5c-11.5-14.4-20.1-31.5-28-50.9-3.7-8.9-7.1-18-10.6-27.5l-1-2.6c-3.9-10.3-7.9-21-12.4-31.6C435.6 48.3 367.5 0 288 0h-32C132.3 0 32 100.3 32 224c0 53.6 18.9 102.9 50.3 141.5 8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-89.4c0-24.9-10.9-46.8-24.5-63.4C94.8 304.8 80 266.2 80 224zm195.3 48-180-120C122.8 90.7 184.4 48 256 48h32c59.5 0 110.7 36.2 132.6 87.8 4 9.5 7.8 19.3 11.6 29.7l1 2.6c3.5 9.4 7.2 19.2 11.1 28.8 8.6 21.1 19.3 43.1 35 62.7l9.9 12.4H275.3zm92.7-48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm63.7 240H304V320h180.9l-6.9 24H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h100.9l-9.1 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h82.6l-3.5 12.4c-2 6.9-8.2 11.6-15.4 11.6z"
        }
    ]
};

const FarHeadSideMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSideMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3 3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1 10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11 0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16h-88c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64v-48h.4c35.1 0 63.6-28.5 63.6-63.6 0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0h-24C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5 8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm144-112v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarHeadSideVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSideVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3 3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1 10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11 0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16h-88c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64v-48h.4c35.1 0 63.6-28.5 63.6-63.6 0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0h-24C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5 8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zM224 72c-8.8 0-16 7.2-16 16 0 33-39.9 49.5-63.2 26.2-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 160.1 129 200 96 200c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 294.5 208 311 208 344c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2 6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 271.9 319 232 352 232c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2 6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 137.5 240 121 240 88c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarHeadSide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadSide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3 3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1 10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11 0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16h-88c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64v-48h.4c35.1 0 63.6-28.5 63.6-63.6 0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0h-24C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5 8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarHeading = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeading",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v144h240V80h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v352h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V272H104v160h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V80H24C10.7 80 0 69.3 0 56z"
        }
    ]
};

const FarHeadphonesSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadphonesSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 80C141.1 80 48 173.1 48 288v104c0 13.3-10.7 24-24 24S0 405.3 0 392V288C0 146.6 114.6 32 256 32s256 114.6 256 256v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zm-96 352V320c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm0-160h16c17.7 0 32 14.3 32 32v144c0 17.7-14.3 32-32 32h-16c-44.2 0-80-35.8-80-80v-48c0-44.2 35.8-80 80-80zm192 48v112c17.7 0 32-14.3 32-32v-48c0-17.7-14.3-32-32-32zm80 32v48c0 44.2-35.8 80-80 80h-16c-17.7 0-32-14.3-32-32V304c0-17.7 14.3-32 32-32h16c44.2 0 80 35.8 80 80z"
        }
    ]
};

const FarHeadphones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadphones",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M49.6 262C62.4 159.4 149.9 80 256 80s193.6 79.4 206.4 182c-9.4-3.9-19.6-6-30.4-6-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48 44.2 0 80-35.8 80-80V288c0-141.4-114.6-256-256-256S0 146.6 0 288v112c0 44.2 35.8 80 80 80 26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48-10.8 0-21 2.1-30.4 6zM48 336c0-17.7 14.3-32 32-32v128c-17.7 0-32-14.3-32-32v-64zm416 0v64c0 17.7-14.3 32-32 32V304c17.7 0 32 14.3 32 32z"
        }
    ]
};

const FarHeadset = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeadset",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-114.9 93.1-208 208-208s208 93.1 208 208v144.1c0 22.1-17.9 40-40 40l-110.4-.1c-8.3-14.4-23.8-24-41.6-24h-32c-26.5 0-48 21.5-48 48s21.5 48 48 48h32c17.8 0 33.3-9.7 41.6-24l110.4.1c48.6 0 88.1-39.4 88.1-88V256C512 114.6 397.4 0 256 0S0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40zm112-32v112c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32zm-80 32v48c0 44.2 35.8 80 80 80h16c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32h-16c-44.2 0-80 35.8-80 80zm272-32c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32V224zm80 32c0-44.2-35.8-80-80-80h-16c-17.7 0-32 14.3-32 32v144c0 17.7 14.3 32 32 32h16c44.2 0 80-35.8 80-80v-48z"
        }
    ]
};

const FarHeartCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeartCircleBolt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m225.8 468.2-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144 39.4-7.6 79.7 1.5 111.8 24.1 9 6.4 17.4 13.8 25 22.3 4.2-4.8 8.7-9.2 13.5-13.3 3.7-3.2 7.5-6.2 11.5-9 32.1-22.6 72.4-31.7 111.8-24.2C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9-14.6-7.3-30.4-12.7-47-15.8v-5.4c0-47.3-33.6-88-80.1-96.9-34-6.5-69 5.4-92 31.2l-.1.1-.1.1-17.8 20c-.3.4-.7.7-1 1.1-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1c-23.1-25.9-58-37.7-92-31.2-46.5 8.8-80.1 49.4-80.1 96.8v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6.6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1.6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2h-35.6l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"
        }
    ]
};

const FarHeartCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeartCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m225.8 468.2-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144 39.4-7.6 79.7 1.5 111.8 24.1 9 6.4 17.4 13.8 25 22.3 4.2-4.8 8.7-9.2 13.5-13.3 3.7-3.2 7.5-6.2 11.5-9 32.1-22.6 72.4-31.7 111.8-24.2C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9-14.6-7.3-30.4-12.7-47-15.8v-5.4c0-47.3-33.6-88-80.1-96.9-34-6.5-69 5.4-92 31.2l-.1.1-.1.1-17.8 20c-.3.4-.7.7-1 1.1-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1c-23.1-25.9-58-37.7-92-31.2-46.5 8.8-80.1 49.4-80.1 96.8v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6.6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FarHeartCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeartCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m225.8 468.2-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144 39.4-7.6 79.7 1.5 111.8 24.1 9 6.4 17.4 13.8 25 22.3 4.2-4.8 8.7-9.2 13.5-13.3 3.7-3.2 7.5-6.2 11.5-9 32.1-22.6 72.4-31.7 111.8-24.2C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9-14.6-7.3-30.4-12.7-47-15.8v-5.4c0-47.3-33.6-88-80.1-96.9-34-6.5-69 5.4-92 31.2l-.1.1-.1.1-17.8 20c-.3.4-.7.7-1 1.1-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1c-23.1-25.9-58-37.7-92-31.2-46.5 8.8-80.1 49.4-80.1 96.8v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6.6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarHeartCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeartCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m225.8 468.2-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144 39.4-7.6 79.7 1.5 111.8 24.1 9 6.4 17.4 13.8 25 22.3 4.2-4.8 8.7-9.2 13.5-13.3 3.7-3.2 7.5-6.2 11.5-9 32.1-22.6 72.4-31.7 111.8-24.2C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9-14.6-7.3-30.4-12.7-47-15.8v-5.4c0-47.3-33.6-88-80.1-96.9-34-6.5-69 5.4-92 31.2l-.1.1-.1.1-17.8 20c-.3.4-.7.7-1 1.1-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1c-23.1-25.9-58-37.7-92-31.2-46.5 8.8-80.1 49.4-80.1 96.8v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6.6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FarHeartCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeartCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m225.8 468.2-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144 39.4-7.6 79.7 1.5 111.8 24.1 9 6.4 17.4 13.8 25 22.3 4.2-4.8 8.7-9.2 13.5-13.3 3.7-3.2 7.5-6.2 11.5-9 32.1-22.6 72.4-31.7 111.8-24.2C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9-14.6-7.3-30.4-12.7-47-15.8v-5.4c0-47.3-33.6-88-80.1-96.9-34-6.5-69 5.4-92 31.2l-.1.1-.1.1-17.8 20c-.3.4-.7.7-1 1.1-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1c-23.1-25.9-58-37.7-92-31.2-46.5 8.8-80.1 49.4-80.1 96.8v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6.6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FarHeartCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeartCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m225.8 468.2-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144 39.4-7.6 79.7 1.5 111.8 24.1 9 6.4 17.4 13.8 25 22.3 4.2-4.8 8.7-9.2 13.5-13.3 3.7-3.2 7.5-6.2 11.5-9 32.1-22.6 72.4-31.7 111.8-24.2C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9-14.6-7.3-30.4-12.7-47-15.8v-5.4c0-47.3-33.6-88-80.1-96.9-34-6.5-69 5.4-92 31.2l-.1.1-.1.1-17.8 20c-.3.4-.7.7-1 1.1-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1c-23.1-25.9-58-37.7-92-31.2-46.5 8.8-80.1 49.4-80.1 96.8v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6.6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
        }
    ]
};

const FarHeartCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeartCrack",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m223.3 465.9 2.5 2.3c8.2 7.6 19 11.9 30.2 11.9s22-4.2 30.2-11.9l2.5-2.3 175.2-162.7c30.7-28.5 48.1-68.5 48.1-110.4v-3.3c0-70.4-50-130.8-119.2-144-39.4-7.6-79.7 1.5-111.8 24.1-4 2.8-7.8 5.8-11.5 9-4.7 4.1-9.3 8.5-13.5 13.3-7.5-8.4-15.9-15.9-25-22.3-32.1-22.6-72.4-31.7-111.8-24.2C50 58.6 0 119.1 0 189.5v3.3c0 41.9 17.4 81.9 48.1 110.4l175.2 162.7zm6.6-331.1-67.6 67.6c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5.3s3.8-7 1.7-10.4l-59.7-97 88.9-51.9c3.6-2.1 5-6.6 3.2-10.3l-16.6-35.1C325 95 354.8 87.1 383.9 92.6c46.5 8.9 80.1 49.5 80.1 96.9v3.3c0 28.5-11.9 55.8-32.8 75.2L256 430.7 80.8 268A102.7 102.7 0 0 1 48 192.8v-3.3c0-47.3 33.6-88 80.1-96.9 34-6.5 69 5.4 92 31.2l.1.1 9.6 10.8z"
        }
    ]
};

const FarHeartHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeartHalfStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m223.3 465.9 2.5 2.3c8.2 7.6 19 11.9 30.2 11.9s22-4.2 30.2-11.9l2.5-2.3 175.2-162.7c30.7-28.5 48.1-68.5 48.1-110.4v-3.3c0-70.4-50-130.8-119.2-144-39.4-7.6-79.7 1.5-111.8 24.1-4 2.8-7.8 5.8-11.5 9-4.7 4.1-9.3 8.5-13.5 13.3-7.5-8.4-15.9-15.9-25-22.3-32.1-22.6-72.4-31.7-111.8-24.2C50 58.6 0 119.1 0 189.5v3.3c0 41.9 17.4 81.9 48.1 110.4l175.2 162.7zm32.7-35.2V152c6.4 0 12.4-2.5 16.9-7 .4-.3.7-.7 1-1.1l17.8-20 .1-.1.1-.1c23.1-25.9 58-37.7 92-31.2 46.5 8.9 80.1 49.5 80.1 96.9v3.3c0 28.5-11.9 55.8-32.8 75.2L256 430.7z"
        }
    ]
};

const FarHeartHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeartHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M236.7 476.9c2.1 2 4.9 3.1 7.8 3.1 6.3 0 11.5-5.1 11.5-11.5V96l-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5L208 450.1l3.3 3.1 16.4 15.3 9 8.4zM208 384.5 80.3 265.3C59.7 246.1 48 219.1 48 190.9v-5.8c0-46.4 33.6-86 79.3-93.6 29.3-4.9 59.1 4.2 80.7 24.5v268.5z"
        }
    ]
};

const FarHeartPulse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeartPulse",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 163.9 222.1 130l-12-12c-21.7-21.7-52.5-31.6-82.7-26.5C81.6 99.1 48 138.7 48 185.1v5.8c0 23.9 8.4 46.9 23.5 65.1h51.1c6.5 0 12.3-3.9 14.8-9.8l31.8-76.3c2.5-5.9 8.2-9.8 14.5-9.8s12.2 3.6 14.8 9.4l58.2 129.3 48.9-97.9c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8l23.2 46.3c2.7 5.4 8.2 8.8 14.3 8.8h68.7c15.1-18.2 23.5-41.2 23.5-65.1v-5.8c0-46.4-33.6-86-79.3-93.6-30.2-5-61.1 4.8-82.7 26.5l-12 12-33.9 33.9zM456 288h-84.2c-18.2 0-34.8-10.3-42.9-26.5l-8.9-17.7-49.7 99.4c-2.8 5.5-8.5 9-14.6 8.8s-11.7-3.8-14.3-9.4l-56.8-126.4-17.6 42.3c-7.5 17.8-25 29.5-44.3 29.5h-87C12.8 261.1 0 226.7 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141 45.6-7.6 92 7.3 124.6 39.9l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9 68.9 11.5 119.4 71.1 119.4 141v5.8c0 35.8-12.8 70.1-35.7 97.1H456zM68.6 320h70.3L256 429.3 373.1 320h70.3L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L68.6 320z"
        }
    ]
};

const FarHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m225.8 468.2-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144 39.4-7.6 79.7 1.5 111.8 24.1 9 6.4 17.4 13.8 25 22.3 4.2-4.8 8.7-9.2 13.5-13.3 3.7-3.2 7.5-6.2 11.5-9 32.1-22.6 72.4-31.7 111.8-24.2C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1c-23.1-25.9-58-37.7-92-31.2-46.6 8.9-80.2 49.5-80.2 96.9v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268a102.7 102.7 0 0 0 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9-34-6.5-69 5.4-92 31.2l-.1.1-.1.1-17.8 20c-.3.4-.7.7-1 1.1-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"
        }
    ]
};

const FarHeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHeat",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32c13.3 0 24 10.7 24 24v88c0 36.4 11.8 71.7 33.6 100.8l19.2 25.6c28 37.4 43.2 82.9 43.2 129.6v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56c0-36.3-11.8-71.7-33.6-100.8l-19.2-25.6c-28-37.4-43.2-82.9-43.2-129.6V56c0-13.3 10.7-24 24-24zM24 96c13.3 0 24 10.7 24 24v37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V456c0 13.3-10.7 24-24 24s-24-10.7-24-24v-37.9c0-33.2-9.8-65.6-28.2-93.2l-31.5-47.2A215.76 215.76 0 0 1 0 157.9V120c0-13.3 10.7-24 24-24zm328 24v37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V456c0 13.3-10.7 24-24 24s-24-10.7-24-24v-37.9c0-33.2-9.8-65.6-28.2-93.2l-31.5-47.3c-23.7-35.4-36.3-77.1-36.3-119.7V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarHelicopterSymbol = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHelicopterSymbol",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M461.6 224H510C495.6 108.2 403.8 16.4 288 2v48.5c89.3 13.7 159.8 84.3 173.6 173.5zm48.4 64h-48.4c-13.8 89.3-84.3 159.8-173.6 173.6V510c115.8-14.4 207.6-106.2 222-222zM2 288c14.4 115.8 106.2 207.6 222 222v-48.4C134.7 447.8 64.2 377.3 50.4 288H2zm0-64h48.4C64.2 134.8 134.7 64.2 224 50.5V2C108.2 16.4 16.4 108.2 2 224zm190-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v192c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h128v72c0 13.3 10.7 24 24 24s24-10.7 24-24V160c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192v-72z"
        }
    ]
};

const FarHelicopter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHelicopter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H384v80h59.2c84 0 152 68.1 152 152v56c0 35.4-28.7 64-64 64h-80.4.2-9.2.2-14.2.2-5.2.2-5.2.2-97.4c-17 0-33.3-6.7-45.3-18.7l-88.1-88.1c-.7-.7-1.5-1.3-2.4-1.7L61.4 236.7c-16.6-7.4-28.6-22.4-32.2-40.2l-16.9-84.7C7.3 87.1 26.3 64 51.5 64h6c16.1 0 31.5 7 42.1 19.1l39.3 44.9H336V48H152c-13.3 0-24-10.7-24-24zM76.3 187.1c.5 2.5 2.2 4.7 4.6 5.7l123.4 54.9c6.3 2.8 12 6.7 16.9 11.6l88.1 88.1c3 3 7.1 4.7 11.3 4.7h15.1V176H128c-6.9 0-13.5-3-18.1-8.2l-46.4-53.1c-.6-.7-1.3-1.2-2-1.7l14.8 74zM384 352h139.5c8.8 0 16-7.2 16-16v-56c0-57.4-46.5-104-104-104h-13 .5-1.5.5-1.5.5-1.5.5-1.5.5-1.5.5-1.5.5-1.4.4-1.5.5-1.5.5-1.4.4-1.4.4-1.4.4-1.5.5-1.5.5-1.5.5-1.5.5-1.4.4-1.4.4-1.4.4-1.4.4-1.5.5-1.4.4-1.4.4-1.4.4-1.4.4-1.4.4-1.4.4-1.4.4-1.4.4-1.3.3-1.4.4-8v176zm247 122.7-22.5 18c-15.6 12.5-35 19.3-55 19.3H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h305.6c9.1 0 17.9-3.1 25-8.8l22.5-18c10.4-8.3 25.5-6.6 33.7 3.8s6.6 25.5-3.8 33.7z"
        }
    ]
};

const FarHelmetBattle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHelmetBattle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 17.1 65.1 225.7c-1.2 17-15.4 30.2-32.5 30.2h-2.2C13.6 256 0 242.4 0 225.6c0-2.3.3-4.6.8-6.8L48.4 12.4c1.9-8.1 9.7-13.5 18-12.2s14.2 8.6 13.6 17zm-4.5 403.4c-9.2-5.6-13.5-16.7-10.6-27.1C81.9 333.6 96 270.2 96 208c0-85 89.1-149.2 153.1-189 1.9-1.2 4-2.6 6.3-4.1C264.8 8.4 277.3 0 288 0s23.2 8.4 32.7 14.9c2.3 1.5 4.4 3 6.3 4.1 63.9 39.8 153 104 153 189 0 62.2 14.1 125.6 31.1 185.4 3 10.4-1.4 21.4-10.6 27.1L316.8 506c-8.5 3.9-17.7 6-27 6h-3.7c-9.3 0-18.6-2-27-6L75.5 420.5zM312 455.3l147.4-68.7C444.4 330.7 432 269.5 432 208c0-25-13.1-50.9-39.2-78.3-26-27.1-60-50.6-91.2-70-2.7-1.7-5.9-3.9-8.3-5.4l-1.5-1c-1.4-1-2.7-1.8-3.9-2.5-1.2.7-2.4 1.6-3.9 2.5l-1.5 1c-2.3 1.6-5.5 3.7-8.3 5.4-31.2 19.4-65.2 42.9-91.2 70-25.9 27.4-39 53.3-39 78.3 0 61.5-12.4 122.7-27.4 178.7L264 455.3V299.2c0-6.7-4.2-12.7-10.5-15l-65.1-23.7c-7.4-2.7-12.4-9.8-12.4-17.7 0-10.4 8.4-18.8 18.8-18.8h186.4c10.4 0 18.8 8.4 18.8 18.8 0 7.9-5 15-12.4 17.7l-65.1 23.7c-6.3 2.3-10.5 8.3-10.5 15v156.1zM509.6.2c8.3-1.2 16.1 4.1 18 12.2l47.6 206.4c.5 2.2.8 4.5.8 6.8 0 16.8-13.6 30.4-30.4 30.4h-2.2c-17.1 0-31.3-13.2-32.5-30.2L496 17.1c-.6-8.3 5.3-15.7 13.6-17z"
        }
    ]
};

const FarHelmetSafety = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHelmetSafety",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 80h48c4.4 0 8 3.6 8 8v208c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-30.9-25.1-56-56-56h-48c-30.9 0-56 25.1-56 56v208c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-4.4 3.6-8 8-8zm295.4 304H16.6C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9 0-9.2-7.4-16.6-16.6-16.6zM32 288v64h48v-64c0-68.4 39-127.7 96-156.8V78.7C91.8 110.9 32 192.5 32 288zm464-2.2V352h48v-66.4c-1-94.5-60.5-174.9-144-206.9v52.5c56.4 28.8 95.2 87.2 96 154.6z"
        }
    ]
};

const FarHelmetUn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHelmetUn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 48c106 0 192 86 192 192H256c-9.4 0-18 5.5-21.8 14.1L196.9 336H82.4c-19 0-34.4-15.4-34.4-34.4V240c0-106 86-192 192-192zm80 372.7-77.7-68.6 29.2-64.1H320v132.7zm48 42.4V288h120c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8C480 107.5 372.5 0 240 0S0 107.5 0 240v61.6C0 347.1 36.9 384 82.4 384h123.5l2.3 2 136 120c4.4 3.9 10 6 15.9 6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24h-87l-1.1-.9zm-82.7-360c-3.9-5.9-11.2-8.5-17.9-6.4S256 105 256 112v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-43.2l34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v43.2l-34.7-52zM160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64z"
        }
    ]
};

const FarHexagonCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHexagonCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24L147 420.9c4.3 7.4 12.2 12 20.8 12h176.5c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12H167.7c-8.6 0-16.5 4.6-20.8 12L58.6 244zM369 209 241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarHexagonDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHexagonDivide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24L147 420.9c4.3 7.4 12.2 12 20.8 12h176.5c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12H167.7c-8.6 0-16.5 4.6-20.8 12L58.6 244zM256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-88 104h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarHexagonExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHexagonExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24L147 420.9c4.3 7.4 12.2 12 20.8 12h176.5c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12H167.7c-8.6 0-16.5 4.6-20.8 12L58.6 244zM256 128c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarHexagonImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHexagonImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 220a71.814 71.814 0 0 0 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36h176.5a72.1 72.1 0 0 0 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.7a72.1 72.1 0 0 0-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24l88.2-152.9c4.3-7.4 12.2-12 20.8-12h176.6c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24l-34.5 59.8-78.1-94c-4.6-5.5-11.3-8.7-18.5-8.7s-13.9 3.2-18.5 8.7L232.2 320l-38.9-40.6c-4.6-4.8-11-7.5-17.6-7.4s-13 2.9-17.4 7.8l-56.9 62.3L58.6 268zM232 160a40 40 0 1 0-80 0 40 40 0 1 0 80 0z"
        }
    ]
};

const FarHexagonMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHexagonMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24L147 420.9c4.3 7.4 12.2 12 20.8 12h176.5c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12H167.7c-8.6 0-16.5 4.6-20.8 12L58.6 244zM184 232h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarHexagonPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHexagonPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24L147 420.9c4.3 7.4 12.2 12 20.8 12h176.5c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12H167.7c-8.6 0-16.5 4.6-20.8 12L58.6 244zM232 344v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarHexagonVerticalNftSlanted = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHexagonVerticalNftSlanted",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M188.9 495.5c22.3 12.9 49.7 12.9 72 0l152.9-88.3c22.3-12.9 36-36.6 36-62.4V168.3a72.1 72.1 0 0 0-36-62.4L260.9 17.7a71.814 71.814 0 0 0-72 0L36 105.9a72.1 72.1 0 0 0-36 62.4v176.6a72.1 72.1 0 0 0 36 62.4l152.9 88.3zm48-41.6c-7.4 4.3-16.6 4.3-24 0L60 365.7c-7.4-4.3-12-12.2-12-20.8V168.3c0-8.6 4.6-16.5 12-20.8l152.9-88.3c7.4-4.3 16.6-4.3 24 0l152.9 88.3c7.4 4.3 12 12.2 12 20.8v176.6c0 8.6-4.6 16.5-12 20.8l-152.9 88.2zm27-344.3c5 2.8 8.1 8.2 8.1 13.9 0 12.3-13.3 20-23.9 13.9l-24.2-13.8v117h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V96.3c0-1.6.2-3.2.6-4.7.5-1.9 1.4-3.7 2.6-5.2 1.1-1.5 2.5-2.8 4-3.7 2.5-1.7 5.6-2.6 8.8-2.6h.1c.5 0 1 0 1.4.1 2.5.2 4.8 1 6.8 2.2l47.8 27.3zm32.1 55.2c-5-2.8-8.1-8.2-8.1-13.9 0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3v156c0 8.8-7.2 16-16 16s-16-7.2-16-16V178.4L296 164.8zm-136.2-20.2v224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7l-32.9-98.5v61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7l32.9 98.5V144.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarHexagonVerticalNft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHexagonVerticalNft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M260.9 495.5a71.814 71.814 0 0 1-72 0L36 407.2c-22.3-12.8-36-36.6-36-62.3V168.3a72.1 72.1 0 0 1 36-62.4l152.9-88.2c22.3-12.9 49.7-12.9 72 0L413.8 106c22.3 12.9 36 36.6 36 62.4v176.5a72.1 72.1 0 0 1-36 62.4l-152.9 88.2zm-48-41.6c7.4 4.3 16.6 4.3 24 0l152.9-88.3c7.4-4.3 12-12.2 12-20.8V168.3c0-8.6-4.6-16.5-12-20.8L236.9 59.2c-7.4-4.3-16.6-4.3-24 0L60 147.5c-7.4 4.3-12 12.2-12 20.8v176.6c0 8.6 4.6 16.5 12 20.8L212.9 454zM95.8 170.6l33.1 82.9v-76.9c0-8.8 7.2-16 16-16s16 7.2 16 16v160c0 7.7-5.4 14.3-13 15.7s-15-2.6-17.9-9.8l-33.1-82.8v76.9c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.7 5.4-14.3 13-15.7s15 2.6 17.9 9.8zm97.1 5.9c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160zm112-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v144c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarHexagonXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHexagonXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24L147 420.9c4.3 7.4 12.2 12 20.8 12h176.5c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12H167.7c-8.6 0-16.5 4.6-20.8 12L58.6 244zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarHexagon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHexagon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 220a71.814 71.814 0 0 0 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36h176.6a72.1 72.1 0 0 0 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.6a72.1 72.1 0 0 0-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24l88.2-152.9c4.3-7.4 12.2-12 20.8-12h176.6c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24l-88.3 152.9c-4.3 7.4-12.2 12-20.8 12H167.7c-8.6 0-16.5-4.6-20.8-12L58.6 268z"
        }
    ]
};

const FarHighDefinition = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHighDefinition",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm240 152v144c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96h-56c-13.3 0-24 10.7-24 24zm80 24c26.5 0 48 21.5 48 48s-21.5 48-48 48h-32v-96h32zm-224-24c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-48h64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48h-64v-48z"
        }
    ]
};

const FarHighlighterLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHighlighterLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m169.9 330.6-38.1 38.1 51.5 51.5 38.1-38.1c9-9 21.2-14.1 33.9-14.1h48l16.2-22.5-113-113-22.5 16.1v48c0 12.7-5.1 24.9-14.1 33.9zm178-24.6L502.8 90.2c.8-1.1 1.2-2.4 1.2-3.7 0-1.7-.7-3.3-1.9-4.5L470 49.9c-1.2-1.2-2.8-1.9-4.5-1.9-1.3 0-2.6.4-3.7 1.2L246 204.1 347.9 306zm-44.5 110h-48l-43.7 43.7c-10.7 10.7-26 14.1-39.5 10.1l-32.8 32.8c-6 6-14.1 9.4-22.6 9.4H32c-17.7 0-32-14.3-32-32v-4.7c0-8.5 3.4-16.6 9.4-22.6l72.8-72.8c-4-13.6-.6-28.8 10.1-39.5l43.7-43.8v-48c0-15.5 7.4-30 20-39L433.8 10.2C443 3.6 454.1 0 465.5 0c14.4 0 28.2 5.7 38.4 15.9l32.2 32.2c10.2 10.2 15.9 24 15.9 38.4 0 11.4-3.6 22.5-10.2 31.7L342.4 396c-9 12.6-23.5 20-39 20zm-190.7 1.3L65.9 464H110l24.7-24.7-22.1-22.1zM248 464h304c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarHighlighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHighlighter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 296.6v-48l22.5-16.2 113 113-16.1 22.6h-48c-12.7 0-24.9 5.1-33.9 14.1l-38.1 38.1-51.5-51.5 38.1-38.1c9-9 14.1-21.2 14.1-33.9zM502.8 90.2 347.9 306 246 204.1 461.8 49.2c1.1-.8 2.4-1.2 3.7-1.2 1.7 0 3.3.7 4.5 1.9L502.1 82c1.2 1.2 1.9 2.8 1.9 4.5 0 1.3-.4 2.6-1.2 3.7zM255.4 416h48c15.5 0 30-7.4 39-20l199.4-277.8c6.6-9.2 10.2-20.3 10.2-31.7 0-14.4-5.7-28.2-15.9-38.4l-32.2-32.2C493.7 5.7 479.9 0 465.5 0c-11.4 0-22.5 3.6-31.7 10.2L156 209.6c-12.6 9-20 23.5-20 39v48l-43.7 43.7c-10.7 10.7-14.1 26-10.1 39.5L9.4 452.7c-6 6-9.4 14.1-9.4 22.6v4.7c0 17.7 14.3 32 32 32h84.7c8.5 0 16.6-3.4 22.6-9.4l32.8-32.8c13.6 4 28.8.6 39.5-10.1l43.8-43.7zm-120.7 23.3L110.1 464H65.9l46.7-46.7 22.1 22.1z"
        }
    ]
};

const FarHillAvalanche = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHillAvalanche",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M551.1 391.1c34.4-34.4 34.4-90.1 0-124.4-27.8-27.8-69.5-33.1-102.6-16-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3 15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7c22.4-14.2 37.2-39.1 37.2-67.5 0-33.9-21.1-62.9-50.9-74.5 1.9-6.8 2.9-14 2.9-21.5 0-44.2-35.8-80-80-80-27.3 0-51.5 13.7-65.9 34.6-5.8-20-24.2-34.6-46.1-34.6-26.5 0-48 21.5-48 48 0 4 .5 7.9 1.4 11.6l310.3 310.3c34.2 23.1 81.1 19.5 111.4-10.8zM448 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM48 440V145.9L366.1 464H72c-13.3 0-24-10.7-24-24zM68.3 98.3C43.1 73.1 0 91 0 126.6V440c0 39.8 32.2 72 72 72h313.4c35.6 0 53.5-43.1 28.3-68.3L68.3 98.3z"
        }
    ]
};

const FarHillRockslide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHillRockslide",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm124.4 71.8c-2.7-4.9-2.7-10.8 0-15.7l27-48c2.8-5 8.2-8.2 13.9-8.2h53.3c5.8 0 11.1 3.1 13.9 8.2l27 48c2.7 4.9 2.7 10.8 0 15.7l-27 48c-2.8 5-8.2 8.2-13.9 8.2h-53.2c-5.8 0-11.1-3.1-13.9-8.2l-27-48zM48 145.9V440c0 13.3 10.7 24 24 24h294.1L48 145.9zM0 126.6C0 91 43.1 73.1 68.3 98.3l345.4 345.4c25.2 25.2 7.4 68.3-28.3 68.3H72c-39.8 0-72-32.2-72-72V126.6zm504.2 277-48-27c-5-2.8-8.2-8.2-8.2-13.9v-53.3c0-5.8 3.1-11.1 8.2-13.9l48-27c4.9-2.7 10.8-2.7 15.7 0l48 27c5 2.8 8.2 8.2 8.2 13.9v53.3c0 5.8-3.1 11.1-8.2 13.9l-48 27c-4.9 2.7-10.8 2.7-15.7 0zM352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarHippo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHippo",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M391 39c9.4-9.4 24.6-9.4 33.9 0l14.2 14.2c10.4-3.3 21.4-5.2 32.9-5.2h32c15.8 0 30.8 3.5 44.2 9.8L559 47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7c13.8 17.7 22 39.9 22 64 0 .3.1.6.3.7 19.4 17.6 31.7 43 31.7 71.3 0 28.4-12.4 54-32 71.6v32.4c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24v-8h-64v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-13.4c-37.3-13.2-64-48.7-64-90.5 0-16.2 4-31.4 11.1-44.8 2.9-5.6 4.9-11.7 4.9-18V152c0-8.9 1.1-17.5 3.2-25.8-25.6-9.4-52.7-14.2-80-14.2h-60C147.7 112 80 179.7 80 263.2c0 19.7-4.1 39.2-12.1 57.2l-22 49.3c-5.4 12.1-19.6 17.6-31.7 12.2s-17.5-19.5-12.1-31.6L24 300.9c5.3-11.9 8-24.7 8-37.7C32 153.2 121.2 64 231.2 64h60c35.1 0 69.9 6.6 102.6 19.5 1.2-1.4 2.4-2.7 3.7-4L391 73c-9.4-9.4-9.4-24.6 0-33.9zm81 57c-30.9 0-56 25.1-56 56v9.2c0 16.4-5.1 30.3-10.5 40.4-3.5 6.6-5.5 14.2-5.5 22.4 0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48 0-14.1-6-26.8-15.8-35.6C566 179.2 560 166 560 152c0-30.9-25.1-56-56-56h-32zm-64 281.6c7.1 4.1 15.3 6.4 24 6.4h24v40c0 30.9-25.1 56-56 56h-48c-30.9 0-56-25.1-56-56v-16.4c-26.4 5.4-53.6 5.4-80 0V424c0 30.9-25.1 56-56 56h-40c-30.9 0-56-25.1-56-56v-48c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-48c0-7.6 3.6-14.8 9.8-19.3s14.1-5.8 21.4-3.6l11.3 3.6c29.6 9.3 61.4 9.3 91 0l11.3-3.6c7.3-2.3 15.2-1 21.4 3.6s9.8 11.7 9.8 19.3v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-46.4zM464 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-56 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarHockeyMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHockeyMask",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 240c0-57.4 14.3-105.3 41.1-137.9C114.7 70.9 156.1 48 224 48s109.3 22.9 134.9 54.1C385.7 134.7 400 182.6 400 240c0 95.1-12.6 148.4-36 178.6-20.6 26.7-58 45.4-140 45.4s-119.4-18.7-140-45.4C60.6 388.4 48 335.1 48 240zM224 0C64 0 0 111 0 240c0 192 48 272 224 272s224-80 224-272C448 111 384 0 224 0zm-24 208c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32 0 35.3 28.7 64 64 64s64-28.7 64-64zm112 64c35.3 0 64-28.7 64-64 0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32 0 35.3 28.7 64 64 64zM176 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-32 160a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32-224a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarHockeyPuck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHockeyPuck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 184c0 4.8 2.3 11.7 11 20.2 8.8 8.6 22.8 17.5 42.1 25.5C139.6 245.6 194.3 256 256 256s116.4-10.4 154.9-26.3c19.3-8 33.3-16.9 42.1-25.5 8.7-8.6 11-15.4 11-20.2s-2.3-11.7-11-20.2c-8.8-8.6-22.8-17.5-42.1-25.5C372.4 122.4 317.7 112 256 112s-116.4 10.4-154.9 26.3c-19.3 8-33.3 16.9-42.1 25.5-8.7 8.6-11 15.4-11 20.2zm-48 0c0-21.7 10.7-40.1 25.4-54.5C40.1 115.2 60 103.4 82.7 94 128.3 75.1 189.6 64 256 64s127.7 11.1 173.2 29.9c22.7 9.4 42.7 21.2 57.3 35.5 14.8 14.5 25.5 32.9 25.5 54.6v144c0 21.7-10.7 40.1-25.4 54.5-14.6 14.3-34.6 26.1-57.3 35.5-45.6 18.9-106.9 30-173.3 30s-127.7-11.1-173.2-29.9c-22.7-9.4-42.7-21.2-57.3-35.5C10.7 368.1 0 349.7 0 328V184zm464 72.2c-10.5 6.7-22.2 12.6-34.8 17.9C383.7 292.9 322.4 304 256 304s-127.7-11.1-173.2-29.9C70.2 268.9 58.5 263 48 256.2V328c0 4.8 2.3 11.7 11 20.2 8.8 8.6 22.8 17.5 42.1 25.5C139.6 389.6 194.3 400 256 400s116.4-10.4 154.9-26.3c19.3-8 33.3-16.9 42.1-25.5 8.7-8.6 11-15.4 11-20.2v-71.8z"
        }
    ]
};

const FarHockeyStickPuck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHockeyStickPuck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M499 2.7c11.8 6.1 16.4 20.6 10.3 32.3L282.7 473.1c-12.4 23.9-37 38.9-64 38.9H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h240c1.3 0 2.5.1 3.7.3L466.7 13C472.8 1.2 487.3-3.4 499 2.7zM283 368H144v96h74.8c9 0 17.2-5 21.3-13l42.9-83zm-219 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32v-96H64zm368 64v32h160v-32H432zm-48 0c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48v-32z"
        }
    ]
};

const FarHockeySticks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHockeySticks",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M173.3 13 302 261.7 288.4 288h-26.9L130.7 35c-6.1-11.7-1.5-26.2 10.3-32.3s26.3-1.5 32.3 10.3zm199.8 355 24.8-48H576c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H421.2c-26.9 0-51.6-15-64-38.9L338 435.9l27-52.2 34.9 67.3c4.1 8 12.3 13 21.3 13H496v-96H373.1zm170.9 0v96h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32zM499 2.7c11.8 6.1 16.4 20.6 10.3 32.3L282.7 473.1c-12.4 23.9-37 38.9-64 38.9H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h240c1.3 0 2.5.1 3.7.3L466.7 13C472.8 1.2 487.3-3.4 499 2.7zM283 368H144v96h74.8c9 0 17.2-5 21.3-13l42.9-83zm-219 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32v-96H64z"
        }
    ]
};

const FarHollyBerry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHollyBerry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 144a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm160 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM161.4 264.5c-1.7 58.6-42.3 107.5-97 121.6 6.2 22 7.2 45.1 2.7 67.4 24.9-6.1 50.9-5.4 75.4 1.9 1.7-58.6 42.3-107.5 97-121.6-6.2-22-7.1-45.1-2.7-67.4-24.9 6.1-50.9 5.4-75.4-1.9zm-48-32.5c0-16.2 15.6-27.7 31.1-22.9l29.8 9.2c16.8 5.2 34.8 5.7 51.8 1.3l39-9.9c11.1-2.8 21.5 2.5 26.6 11.2 15.2 2.8 30.9 1.9 45.7-2.7l29.8-9.2c15.4-4.8 31.1 6.8 31.1 22.9v28.8c0 44.9 36.4 81.4 81.4 81.4 16.6 0 28.2 16.5 22.6 32.1l-6.7 18.6c-6.9 19.2-7.5 40.1-1.8 59.6l8.1 27.7c5.2 17.8-10.9 34.6-28.9 30l-39-9.9c-17.1-4.3-35-3.8-51.8 1.3l-29.8 9.2c-15.4 4.8-31.1-6.8-31.1-22.9V459c0-39.5-28.1-72.4-65.4-79.8-37.4 7.4-65.6 40.3-65.6 79.8v28.8c0 16.2-15.6 27.7-31.1 22.9l-29.8-9.2c-16.8-5.2-34.8-5.7-51.8-1.3l-39 9.9c-18 4.6-34.2-12.2-28.9-30l8.1-27.7c5.8-19.6 5.1-40.4-1.8-59.6l-6.5-18.5c-5.6-15.6 6-32.1 22.6-32.1 44.9 0 81.4-36.4 81.4-81.4V232zm179.3 109c44.2 19.7 75.2 63.4 76.7 114.5 24.5-7.3 50.6-8 75.4-1.9-4.5-22.4-3.5-45.5 2.7-67.4-54.7-14.1-95.3-62.9-97-121.6-21.1 6.3-43.3 7.7-64.9 4.1-5.4 19.2-4.7 39.7 2.1 58.5l5 13.9z"
        }
    ]
};

const FarHoneyPot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHoneyPot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M78.6 352c21.5 40.9 49 67 64.6 79.6h.1c.4.1 1.4.4 3.1.4h155.2c1.6 0 2.6-.2 3.1-.4h.1c15.5-12.6 43.1-38.7 64.6-79.6H78.6zM48 224h352c0-79.5-64.5-144-144-144h-64c-5.4 0-10.7.3-16 .9V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V95c-47.4 23.6-80 72.5-80 129zm8-192h336c13.3 0 24 10.7 24 24s-10.7 24-24 24h-9c39.9 35.2 65 86.7 65 144 0 138.8-79.6 217.9-113.3 245.1-9.3 7.5-21.1 10.9-33.1 10.9H146.4c-12 0-23.7-3.3-33.1-10.9C79.6 441.9 0 362.8 0 224c0-57.3 25.1-108.8 65-144h-9c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarHoodCloak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHoodCloak",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M454.4 15.3c3 7.7 1.8 16.2-2.9 22.7-1 1.3-2.1 2.6-3.3 3.7l-32 29c11.4 10.2 22.6 21.8 33.1 34.8C484.5 149.1 512 208.6 512 288c0 58.5 14.6 101.6 28.6 129.7 7 14.1 14 24.5 19 31.1 2.5 3.3 4.5 5.7 5.7 7.1.6.7 1.1 1.2 1.3 1.4l.1.1c9 9.2 11.7 22.8 6.8 34.7-5 12-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8-4.9-11.9-2.2-25.6 6.8-34.7l.2-.2c.2-.2.7-.7 1.3-1.4 1.3-1.4 3.2-3.8 5.7-7.1 5-6.6 11.9-17 19-31.1 14-28 28.6-71.1 28.6-129.6 0-136.2 47.4-211.1 103.7-250.3C222 0 278.2 0 288 0h144c9.9 0 18.8 6.1 22.4 15.3zm43.3 423.8c-17-34-33.7-84.4-33.7-151.2 0-86.7-38.5-144.2-79.9-181.5-10.1-9.1-15.9-22-15.9-35.6 0-8.1 2-16 5.8-22.9h-86c-7.2 0-51 0-92.8 29.1-40.9 28.5-83.2 87-83.2 211 0 66.8-16.7 117.2-33.7 151.2-4.8 9.6-9.6 17.9-14.1 24.8H160V336c0-70.7 57.3-128 128-128s128 57.3 128 128v128h95.8c-4.5-7-9.3-15.2-14.1-24.8zM208 464h160V336c0-44.2-35.8-80-80-80s-80 35.8-80 80v128z"
        }
    ]
};

const FarHorizontalRule = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHorizontalRule",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0-13.3 10.7-24 24-24h592c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarHorseHead = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHorseHead",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M405.1 48.7c9.2-3.3 18.9 3.6 18.9 13.4 0 4.2-1.9 8.2-5.1 10.9l-34.3 28.5c-7.3 6.1-10.4 16-7.7 25.2s10.6 15.9 20.1 17.1l1.5.2c31.3 3.9 58.7 23 73.3 51l48.2 92.8c11 21.3 7 47.2-9.9 64.2-10.3 10.3-24.3 16.1-38.8 16.1h-7.4c-18.5 0-36-8-48.2-21.9l-26.2-30c-10.3-11.8-28-13.5-40.4-3.9-27.6 21.5-67.3 17.2-89.7-9.7l-25-30c-8.5-10.2-23.6-11.6-33.8-3.1s-11.6 23.6-3.1 33.8l25 30c25 30 62.3 43.8 98.6 40l43.4 68.2c2.3 3.5 3.5 7.7 3.5 11.9 0 5.8-4.7 10.6-10.6 10.6H136c-13.3 0-24-10.7-24-24V316.7c0-98.2 61.8-185.7 154.3-218.6l138.8-49.4zm0 367-21.5-33.8c21 21.7 50 34.1 80.4 34.1h7.4c27.3 0 53.5-10.8 72.8-30.1 31.7-31.7 39.2-80.4 18.5-120.2l-48.3-92.8c-14.4-27.8-37.3-49.6-64.7-63C463.8 98 472 80.5 472 62.1c0-43-42.5-73-83-58.6L250.2 52.9C138.6 92.5 64 198.2 64 316.7V440c0 39.8 32.2 72 72 72h221.4c32.4 0 58.6-26.2 58.6-58.6 0-13.3-3.8-26.4-11-37.6zM360 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarHorseSaddle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHorseSaddle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M426.8.6c1.7-.4 3.4-.6 5.2-.6h40.5c2.5 0 5 .1 7.5.3V0h56c13.3 0 24 10.7 24 24 0 8.5-4.4 16-11.1 20.3 5.4 9.4 9.1 20 10.7 31.3l9.9 69.2c5.2 36.7-15.3 72.2-49.7 86-18.3 7.3-38 7.5-55.8 1.5v10c0 33.2-12.2 62.9-32 85.5V464c0 26.5-21.5 48-48 48h-48c-26.5 0-48-21.5-48-48v-99.5l-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-12.1 32.3c-.6 1.6-.7 3.3-.2 5l14.8 53.3c8.5 30.6-14.5 60.8-46.2 60.8h-49.8c-21.6 0-40.5-14.4-46.2-35.2l-11.3-40.4c-8.6-31-7.2-63.9 4.1-94.1l8.2-21.7L72 265.9c-5.3-13.3-8-27.4-8-41.7 0-2.9.1-5.7.3-8.5A40.1 40.1 0 0 0 48 248v64c0 13.3-10.7 24-24 24S0 325.3 0 312v-64c0-47.3 37.3-85.9 84.1-87.9 20.3-29.1 54-48.1 92.1-48.1h117.1C309.8 51.5 362.6 6.1 426.8.6zM416 239v-55c0-10.2 6.4-19.3 16.1-22.6s20.3-.3 26.7 7.7l5.9 7.3c8.9 11.1 24.1 15.1 37.3 9.8 13.9-5.5 22.2-19.9 20-34.7l-9.9-69.2C509.3 62.6 492.4 48 472.5 48h-37.1c-.6.1-1.3.2-2 .2-50 3.1-90.5 41.6-96.6 90.8-.2 1.4-.4 2.7-.8 3.9V176c0 40.3-27.1 74.2-64 84.7v49.1l38.7 11.3c2.1.6 4.2 1.1 6.3 1.6 11.1 2.3 19 12.1 19 23.5V464h48V318.2c0-6.5 2.6-12.7 7.3-17.2 15.1-14.8 24.7-35.3 24.7-58.8V239zm-128-79h-80v16c0 22.1 17.9 40 40 40s40-17.9 40-40v-16zm-128 2.1c-27.6 7.2-48 32.3-48 62.2 0 8.2 1.6 16.3 4.6 23.9l21.9 54.6c4.4 11.1 4.6 23.5.4 34.7l-8.2 21.7c-7.7 20.6-8.7 43.1-2.8 64.4l11.2 40.4h49.8l-14.8-53.3c-3.2-11.4-2.6-23.6 1.5-34.6l12.1-32.3c2.8-7.5 4.3-15.4 4.3-23.5V319c-.2-7.6 3.3-14.9 9.4-19.5s14-6.1 21.3-4l1.3.4v-35.2c-36.9-10.4-64-44.4-64-84.7v-13.9zM464 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarHorse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHorse",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 0c-1.8 0-3.5.2-5.2.6-64.2 5.5-117 51-133.5 111.4H176.2c-38.1 0-71.8 19-92.1 48.1C37.3 162.1 0 200.7 0 248v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.2 6.4-25 16.3-32.2-.2 2.8-.3 5.6-.3 8.5 0 14.3 2.7 28.4 8 41.7l21.9 54.6-8.2 21.7c-11.3 30.1-12.7 63.1-4.1 94.1l11.2 40.5c5.8 20.8 24.7 35.2 46.2 35.2h49.8c31.7 0 54.7-30.3 46.2-60.8L220.2 398c-.5-1.6-.4-3.4.2-5l12.1-32.3c1.4-3.7 2.6-7.4 3.6-11.2l51.9 15V464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V327.8c19.8-22.6 32-52.3 32-85.5v-10.1c17.7 6 37.5 5.8 55.8-1.5 34.4-13.8 55-49.3 49.7-86l-9.9-69.2c-1.6-11.3-5.3-21.9-10.7-31.3C555.6 40 560 32.5 560 24c0-13.3-10.7-24-24-24h-56v.3c-2.5-.2-5-.3-7.5-.3H432zm-16 240.5v1.7c0 23.5-9.6 44.1-24.7 58.8-4.6 4.5-7.3 10.7-7.3 17.2V464h-48V346.2c0-11.3-7.9-21.1-19-23.5-2.1-.4-4.2-1-6.3-1.6l-88-25.7c-7.3-2.1-15.3-.7-21.3 4s-9.6 11.9-9.4 19.5v1.3c0 8-1.4 16-4.3 23.5L175.6 376c-4.2 11.1-4.7 23.2-1.5 34.6l14.8 53.4h-49.8l-11.2-40.5c-5.9-21.2-4.9-43.7 2.8-64.4l8.2-21.7c4.2-11.2 4.1-23.6-.4-34.7l-21.9-54.6c-3-7.6-4.6-15.7-4.6-23.9 0-35.5 28.8-64.2 64.2-64.2H313c12.1 0 22.3-9 23.8-21 6.1-49.1 46.6-87.7 96.6-90.8.7 0 1.3-.1 2-.2h37.1c19.9 0 36.8 14.6 39.6 34.3l9.9 69.2c2.1 14.8-6.2 29.1-20 34.7-13.3 5.3-28.4 1.3-37.3-9.8l-5.9-7.3c-6.4-8-17.1-11-26.7-7.7S416 173.9 416 184v56.5zM480 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarHoseReel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHoseReel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208c45.6 0 87.7-14.6 122-39.5 10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5C428 494 376.1 512 320 512 178.6 512 64 397.4 64 256S178.6 0 320 0s256 114.6 256 256v96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-2.3l-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8 0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16 0-8.1 6-14.7 13.7-15.8L514.3 400H512c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-96c0-114.9-93.1-208-208-208zM208 256a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm112 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320zm-64-160a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarHose = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHose",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 128c13.3 0 24-10.7 24-24v-2.3l80.2-11.5c1.1 7.8 7.7 13.8 15.8 13.8 8.8 0 16-7.2 16-16V40c0-8.8-7.2-16-16-16-8.1 0-14.7 6-15.8 13.7L336 26.3V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24zM8 488c0 13.3 10.7 24 24 24h384c13.3 0 24-10.7 24-24s-10.7-24-24-24H32c-13.3 0-24 10.7-24 24zm24-104c-13.3 0-24 10.7-24 24s10.7 24 24 24h384c13.3 0 24-10.7 24-24s-10.7-24-24-24H32zM8 328c0 13.3 10.7 24 24 24h384c13.3 0 24-10.7 24-24s-10.7-24-24-24H32c-13.3 0-24 10.7-24 24zm48-172c0-37.6 30.4-68 68-68h132V40H124C59.9 40 8 91.9 8 156s51.9 116 116 116h292c13.3 0 24-10.7 24-24s-10.7-24-24-24H124c-37.6 0-68-30.4-68-68z"
        }
    ]
};

const FarHospitalUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHospitalUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h192c8.8 0 16 7.2 16 16v351.7c11.3-20 27.9-36.7 48-47.9V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h192c3.2 0 6.4-.2 9.5-.7-6-10-9.5-21.8-9.5-34.4 0-4.4.2-8.7.7-13H64c-8.8 0-16-7.2-16-16V416h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H48v-48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V64c0-8.8 7.2-16 16-16zm72 64v24h-24c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-24h24c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-24v-24c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm376 160a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9h218.2c19.3 0 34.9-15.6 34.9-34.9 0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"
        }
    ]
};

const FarHospital = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHospital",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 0c-39.8 0-72 32.2-72 72v8H72c-39.8 0-72 32.2-72 72v288c0 39.8 32.2 72 72 72h496c39.8 0 72-32.2 72-72V152c0-39.8-32.2-72-72-72h-88v-8c0-39.8-32.2-72-72-72H232zm248 128h88c13.3 0 24 10.7 24 24v40h-56c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v48h-56c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v104c0 13.3-10.7 24-24 24h-88V128zm-408 0h88v336H72c-13.2 0-24-10.7-24-24V336h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48v-48h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48v-40c0-13.3 10.7-24 24-24zm136-56c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24v392h-64v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64h-64V72zm88 24v24h-24c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-24h24c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-24V96c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarHospitals = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHospitals",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48h192c8.8 0 16 7.2 16 16v192H320v48h208v48H320v48h208v48c0 8.8-7.2 16-16 16H320c0 17.3-5.5 33.2-14.7 46.3 4.7 1.1 9.7 1.7 14.7 1.7h192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H320c-35.3 0-64 28.7-64 64v1.6c19.5 4 36.5 15 48 30.4V64c0-8.8 7.2-16 16-16zm88 48v24h-24c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-24h24c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-24V96c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm-272 80c-8.8 0-16 7.2-16 16v24H96c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-24h24c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-24v-24c0-8.8-7.2-16-16-16h-16zm-72-32h160c8.8 0 16 7.2 16 16v192H48V160c0-8.8 7.2-16 16-16zM48 400h192v48c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-48zM0 160v288c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FarHotTubPerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHotTubPerson",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0a64 64 0 1 1 0 128A64 64 0 1 1 64 0zM48 336v112c0 8.8 7.2 16 16 16h48V304H48v32zm112 128h72V304h-72v160zm120 0h72V304h-72v160zm-2.7-208H448c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-53 43-96 96-96 20.8 0 41 6.7 57.6 19.2l85.3 64c11.1 8.3 24.6 12.8 38.4 12.8zM48 256h128l-51.2-38.4c-8.3-6.2-18.4-9.6-28.8-9.6-26.5 0-48 21.5-48 48zm352 48v160h48c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16h-48zM272 24v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24v-13.2c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C238.4 95.7 224 63.3 224 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24v-13.2c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C350.4 95.7 336 63.3 336 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarHotdog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHotdog",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m496.2 208.2-34 34c1.2 1.7 1.9 3.7 1.9 5.8 0 2.6-1 5.2-2.9 7L255 461.1c-1.9 1.9-4.4 2.9-7 2.9-2.1 0-4.1-.7-5.8-1.9l-34 34c10.7 10.2 25 15.8 39.8 15.8 15.4 0 30.1-6.1 41-17L495 289c10.9-10.9 17-25.6 17-41 0-14.8-5.7-29.1-15.8-39.8zM15.8 303.8l34-34c-1.2-1.7-1.9-3.7-1.9-5.8 0-2.6 1-5.2 2.9-7L17 223l33.9 34L257 50.9c1.9-1.9 4.4-2.9 7-2.9 2.1 0 4.1.7 5.8 1.9l34-34C293.1 5.7 278.8 0 264 0c-15.4 0-30.1 6.1-41 17L17 223C6.1 233.9 0 248.6 0 264c0 14.8 5.7 29.1 15.8 39.8zm431.8-160.2-304 304c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l304-304c21.9-21.9 57.3-21.9 79.2 0s21.9 57.3 0 79.2zm33.9 33.9c40.6-40.6 40.6-106.5 0-147.1s-106.5-40.6-147.1 0l-304 304c-40.6 40.6-40.6 106.5 0 147.1s106.5 40.6 147.1 0l304-304zm-70.2-38.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-7 7-12.5 10.8-17 13.1-4.5 2.3-8.5 3.4-13.6 4.7l-1.5.4c-4.7 1.2-10.9 2.7-17.3 5.6-7.4 3.4-14.8 8.4-22.7 16.3-16.2 16.2-20.5 30.7-24 42.7v.1c-3.1 10.6-5.5 18.8-16 29.2-5.5 5.5-9.5 7.8-12.4 9.1-3 1.3-5.8 1.7-10.6 2.4l-.4.1c-4.6.6-10.9 1.6-18 4.5-7.4 3.1-14.8 8.1-22.6 15.9-16.2 16.2-20.5 30.7-24 42.7v.1c-3.1 10.6-5.5 18.8-16 29.2-5.5 5.5-9.7 8.1-13.3 9.8-3.6 1.6-6.9 2.5-12 3.7l-1.2.3c-5.6 1.4-12.6 3.2-20.4 7.3-7.9 4-16 9.9-25 18.9-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c7-7 12.5-10.8 17-13.1 4.5-2.3 8.5-3.4 13.6-4.7l1.5-.4c4.7-1.2 10.9-2.7 17.3-5.6 7.4-3.4 14.8-8.4 22.7-16.3 16.2-16.2 20.5-30.7 24-42.7v-.1c3.1-10.6 5.5-18.8 16-29.2 5.5-5.5 9.5-7.8 12.4-9.1 3-1.3 5.8-1.7 10.6-2.4l.4-.1c4.6-.6 10.9-1.6 18-4.5 7.4-3.1 14.8-8.1 22.6-15.9 16.2-16.2 20.5-30.7 24-42.7v-.1c3.1-10.6 5.5-18.8 16-29.2 5.5-5.5 9.7-8.1 13.3-9.8 3.6-1.6 6.9-2.5 12-3.7l1.2-.3c5.6-1.4 12.6-3.2 20.4-7.3 7.9-4 16-9.9 25-18.9z"
        }
    ]
};

const FarHotel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHotel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h8v416h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V48h8c13.3 0 24-10.7 24-24S501.3 0 488 0H24zm408 48v416H304v-80h32c8.8 0 16.1-7.2 14.7-15.9-7.6-45.5-47.1-80.1-94.7-80.1s-87.1 34.6-94.7 80.1c-1.5 8.7 5.8 15.9 14.7 15.9h32v80H80V48h352zM144 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM128 208v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarHourglassClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHourglassClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h336c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v19c0 40.3-16 79-44.5 107.5L225.9 256l43.8 43.8c-8.8 21-13.7 44-13.7 68.2 0 59.5 29.6 112.1 74.8 144H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-19c0-40.3 16-79 44.5-107.5l81.6-81.5-81.6-81.5C48 146 32 107.3 32 67V48h-8C10.7 48 0 37.3 0 24zm99.8 104h184.4C297 110.4 304 89 304 67V48H80v19c0 22.1 7 43.4 19.8 61zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarHourglassEnd = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHourglassEnd",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h336c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v19c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445v19h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-19c0-40.3 16-79 44.5-107.5l81.6-81.5-81.6-81.5C48 146 32 107.3 32 67V48h-8C10.7 48 0 37.3 0 24zm273.5 116.5C293 121 304 94.6 304 67V48H80v19c0 27.6 11 54 30.5 73.5l81.5 81.6 81.5-81.5z"
        }
    ]
};

const FarHourglassHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHourglassHalf",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h336c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v19c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445v19h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-19c0-40.3 16-79 44.5-107.5l81.6-81.5-81.6-81.5C48 146 32 107.3 32 67V48h-8C10.7 48 0 37.3 0 24zm110.5 347.5c-3.9 3.9-7.5 8.1-10.7 12.5h184.4c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67V48H80v19c0 22.1 7 43.4 19.8 61h184.4z"
        }
    ]
};

const FarHourglassStart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHourglassStart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 488c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-19c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67V48h8c13.3 0 24-10.7 24-24S373.3 0 360 0H24C10.7 0 0 10.7 0 24s10.7 24 24 24h8v19c0 40.3 16 79 44.5 107.5l81.6 81.5-81.6 81.5C48 366 32 404.7 32 445v19h-8c-13.3 0-24 10.7-24 24zm273.5-116.5C293 391 304 417.4 304 445v19H80v-19c0-27.6 11-54 30.5-73.5l81.5-81.6 81.5 81.5z"
        }
    ]
};

const FarHourglass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHourglass",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h8v19c0 40.3 16 79 44.5 107.5l81.6 81.5-81.6 81.5C48 366 32 404.7 32 445v19h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-19c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67V48h8c13.3 0 24-10.7 24-24S373.3 0 360 0H24zm168 289.9 81.5 81.5C293 391 304 417.4 304 445v19H80v-19c0-27.6 11-54 30.5-73.5l81.5-81.6zm0-67.9-81.5-81.5C91 121 80 94.6 80 67V48h224v19c0 27.6-11 54-30.5 73.5L192 222.1z"
        }
    ]
};

const FarHouseBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseBlank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM464 204.8V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V204.8L288 55.5l176 149.3z"
        }
    ]
};

const FarHouseBuilding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseBuilding",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48h224c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H416c0 18-6 34.6-16 48h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v60.6l48 44V64c0-8.8 7.2-16 16-16zm61.2 208H432c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v4.6l6.1 5.6c11.2 10.3 19.2 23.4 23.1 37.9zm2.8 96h16c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-16v64zm64-144v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM400 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zM20.8 237C7.5 249.1 0 266.2 0 284.2V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237zM48 284.2c0-4.5 1.9-8.8 5.2-11.8l128-117.4c6.1-5.6 15.5-5.6 21.6 0l128 117.3c3.3 3 5.2 7.3 5.2 11.8V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V284.2zm96 11.8v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarHouseChimneyBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseChimneyBlank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8L512 182.6V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v85.9L303.5 5.7zM112 432V204.8L288 55.5l176 149.3V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FarHouseChimneyCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseChimneyCrack",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9V56c0-13.3 10.7-24 24-24s24 10.7 24 24v126.6l55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32h85.9l-30.3-48.1c-4.4-6.9-2.8-16 3.6-21.1l84.8-67.2-58.1-76.1c-11.3-14.8 7.4-33.6 22.3-22.5l115.2 86.2c8.4 6.3 8.6 18.8.4 25.3L288 403.8l37.9 60.2H432c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8z"
        }
    ]
};

const FarHouseChimneyHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseChimneyHeart",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9V56c0-13.3 10.7-24 24-24s24 10.7 24 24v126.6l55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8zm125.3 3.2c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3 0-33.8 27.4-61.3 61.3-61.3z"
        }
    ]
};

const FarHouseChimneyMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseChimneyMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9V56c0-13.3 10.7-24 24-24s24 10.7 24 24v126.6l55.5 47.1c10.1 8.6 11.3 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8zM272 192h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarHouseChimneyUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseChimneyUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8L512 182.6V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v85.9L303.5 5.7zM112 432V204.8L288 55.5l176 149.3V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32zm176-144a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM176 400c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80z"
        }
    ]
};

const FarHouseChimneyWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseChimneyWindow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9V56c0-13.3 10.7-24 24-24s24 10.7 24 24v126.6l55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8zM256 288h64v-64h-64v64zm-48-72c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40h-80c-22.1 0-40-17.9-40-40v-80z"
        }
    ]
};

const FarHouseChimney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseChimney",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9V56c0-13.3 10.7-24 24-24s24 10.7 24 24v126.6l55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32h48V312c0-22.1 17.9-40 40-40h112c22.1 0 40 17.9 40 40v152h48c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8zM336 320h-96v144h96V320z"
        }
    ]
};

const FarHouseCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80h250.8c-18.3-12.9-34.1-29.2-46.3-48H240V320h86.6c4.8-17.1 12.2-33.2 21.7-47.8-1.4-.2-2.9-.2-4.3-.2H232c-22.1 0-40 17.9-40 40v152h-48c-17.7 0-32-14.3-32-32V204.8L288 55.5l166.7 141.4c13.3-3.2 27.1-4.9 41.3-4.9 10.3 0 20.3.9 30.1 2.6L303.5 5.7zM640 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarHouseCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80h250.8c-18.3-12.9-34.1-29.2-46.3-48H240V320h86.6c4.8-17.1 12.2-33.2 21.7-47.8-1.4-.2-2.9-.2-4.3-.2H232c-22.1 0-40 17.9-40 40v152h-48c-17.7 0-32-14.3-32-32V204.8L288 55.5l166.7 141.4c13.3-3.2 27.1-4.9 41.3-4.9 10.3 0 20.3.9 30.1 2.6L303.5 5.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarHouseCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80h250.8c-18.3-12.9-34.1-29.2-46.3-48H240V320h86.6c4.8-17.1 12.2-33.2 21.7-47.8-1.4-.2-2.9-.2-4.3-.2H232c-22.1 0-40 17.9-40 40v152h-48c-17.7 0-32-14.3-32-32V204.8L288 55.5l166.7 141.4c13.3-3.2 27.1-4.9 41.3-4.9 10.3 0 20.3.9 30.1 2.6L303.5 5.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
        }
    ]
};

const FarHouseCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseCrack",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432V204.8L288 55.5l176 149.3V432c0 17.7-14.3 32-32 32H325.9L288 403.8l79.7-63.3c8.2-6.5 8-19.1-.4-25.3L252.2 229c-14.9-11.1-33.6 7.8-22.3 22.5l58.1 76.1-84.8 67.3c-6.4 5.1-7.9 14.2-3.6 21.1l30.3 48H144c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FarHouseDay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseDay",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M174.2 8.3c-2.8-5.1-8.2-8.4-14.1-8.4S148.8 3.1 146 8.3l-27.6 51.2-55.6-16.7c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.7 55.7L8.3 146c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51.2 27.6-16.7 55.6c-1.7 5.6-.1 11.7 4 15.9s10.3 5.7 15.9 4l55.7-16.7 6.2 11.5 24-19.6 14.5-11.8c-1 0-2.1.1-3.1.1-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80c0 6.6-.8 13-2.3 19.2l54.6-44.5-31.7-17.1 16.7-55.7c1.7-5.6.1-11.7-4-15.9s-10.3-5.7-15.9-4l-55.6 16.7-27.6-51.2zM208 160a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm207.2-58.6c-8.8-7.2-21.5-7.2-30.3 0l-216 176c-10.3 8.4-11.8 23.5-3.4 33.8s23.5 11.8 33.8 3.4l24.7-20.2V456c0 30.9 25.1 56 56 56h240c30.9 0 56-25.1 56-56V294.4l24.8 20.2c10.3 8.4 25.4 6.8 33.8-3.4s6.8-25.4-3.4-33.8l-216-176zM528 255.3V456c0 4.4-3.6 8-8 8H280c-4.4 0-8-3.6-8-8V255.3L400 151l128 104.3zM352 312v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarHouseFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l144.3 122.5c-12.5-1.1-25.5 2.8-35.4 11.7-4.1 3.6-8 7.3-12 11L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32h48V312c0-22.1 17.9-40 40-40h77c-7.7 15.7-13.8 32-17.4 48H240v144h84.8c13.5 18.8 30.3 35.1 49.6 48H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zm181 158.1c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15z"
        }
    ]
};

const FarHouseFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseFlag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472 0c-13.3 0-24 10.7-24 24v488h48V192h128c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H496v-8c0-13.3-10.7-24-24-24zm-56 133L286.3 36.7c-8.5-6.3-20.1-6.3-28.6 0l-248 184c-10.6 7.9-12.9 22.9-5 33.6s22.9 12.9 33.6 5L64 240.2V432c0 44.2 35.8 80 80 80h256c5.5 0 10.8-.6 16-1.6v-50.7c-4.7 2.7-10.2 4.3-16 4.3h-48V344c0-22.1-17.9-40-40-40h-80c-22.1 0-40 17.9-40 40v120h-48c-17.7 0-32-14.3-32-32V204.6L272 85.9l144 106.8V133zM304 352v112h-64V352h64z"
        }
    ]
};

const FarHouseFloodWaterCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseFloodWaterCircleArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M316.1 107.1c-3.5-16.5-9.4-32.2-17.2-46.7l79.2-56c8.3-5.9 19.4-5.9 27.7 0l192 136c10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7l-2.1-1.5v103.3c-5.3-2.9-10.3-6.2-14.8-9.9-9.7-8.2-21.3-13.1-33.2-14.6V144.1L392 53.4l-75.9 53.7zm-172.2 211c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7 9.1-8.1 22.8-8.1 31.9 0zm-31.9 112c9.1-8.1 22.8-8.1 31.9 0 21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zM0 144a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6l28.7 28.7H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FarHouseFloodWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseFloodWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M301.9 4.4c-8.3-5.9-19.4-5.9-27.7 0l-192 136c-10.8 7.7-13.4 22.6-5.7 33.5s22.6 13.4 33.5 5.7l2.1-1.5v80.4c7.3 1.9 14.4 5.1 20.9 9.6 8.4 5.8 17.7 10.6 27.1 14.1V144.1L288 53.4l128 90.7v138.1c9.5-3.5 18.8-8.3 27.2-14.1 6.5-4.5 13.5-7.8 20.8-9.6v-80.4l2.1 1.5c10.8 7.7 25.8 5.1 33.5-5.7s5.1-25.8-5.7-33.5l-192-136zM80 318.1c-17.2 14.9-39 26.7-61.2 31.7C5.9 352.7-2.3 365.5.6 378.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.7-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zm31.9 112c-9.1-8.1-22.8-8.1-31.9 0-17.2 14.9-39 26.7-61.2 31.7C5.9 464.7-2.3 477.5.6 490.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"
        }
    ]
};

const FarHouseHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseHeart",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432V204.8L288 55.5l176 149.3V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32zm64-162.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FarHouseLaptop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseLaptop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224.8 5.4c8.8-7.2 21.5-7.2 30.3 0l216 176c10.3 8.4 11.8 23.5 3.4 33.8s-23.5 11.8-33.8 3.4L416 198.4V240h-48v-80.7L240 55 112 159.3V360c0 4.4 3.6 8 8 8h152v48H120c-30.9 0-56-25.1-56-56V198.4l-24.8 20.2c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176zM288 216v45.7c-6 6.8-10.6 14.9-13.3 23.8-3.2 1.6-6.9 2.5-10.7 2.5h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24zm64 104v144h192V320H352zm-48-16c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32v160h36c6.6 0 12 5.4 12 12 0 19.9-16.1 36-36 36H292c-19.9 0-36-16.1-36-36 0-6.6 5.4-12 12-12h36V304z"
        }
    ]
};

const FarHouseLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l188.6 160.1c-16.3 5.5-31 14.7-43 26.5L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32h48V312c0-22.1 17.9-40 40-40h112c22.1 0 40 17.9 40 40v168c0 11.7 3.1 22.6 8.6 32H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM240 464h96V320h-96v144zm288-224c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FarHouseMedicalCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseMedicalCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l222.5 188.9c-9.8-1.7-19.9-2.6-30.1-2.6-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32h204.5c12.3 18.8 28 35.1 46.3 48H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48zm32 112a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FarHouseMedicalCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseMedicalCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l222.5 188.9c-9.8-1.7-19.9-2.6-30.1-2.6-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32h204.5c12.3 18.8 28 35.1 46.3 48H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarHouseMedicalCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseMedicalCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l222.5 188.9c-9.8-1.7-19.9-2.6-30.1-2.6-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32h204.5c12.3 18.8 28 35.1 46.3 48H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144 36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
        }
    ]
};

const FarHouseMedicalFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseMedicalFlag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 24v8h128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H496v320h-48V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM286.3 36.7 416 133v59.8L272 85.9 112 204.6V432c0 17.7 14.3 32 32 32h256c5.8 0 11.3-1.6 16-4.3v50.7c-5.2 1-10.5 1.6-16 1.6H144c-44.2 0-80-35.8-80-80V240.2l-25.7 19.1c-10.6 7.9-25.7 5.7-33.6-5s-5.7-25.7 5-33.6l248-184c8.5-6.3 20.1-6.3 28.6 0zM240 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FarHouseMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l264 224c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM288 55.5 112 204.8V432c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V204.8L288 55.5zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FarHouseNight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseNight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M125.2 16.1c6.2-4.4 5.4-14.8-2.2-15.6-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112s50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2 5.2-5.6-1-14-8.6-13.2-2.9.3-5.9.4-9 .4-48.6 0-88-39.4-88-88 0-29.7 14.7-55.9 37.2-71.9zm289.9 85.3c-8.8-7.2-21.5-7.2-30.3 0l-216 176c-10.3 8.4-11.8 23.5-3.4 33.8s23.5 11.8 33.8 3.4l24.8-20.2V456c0 30.9 25.1 56 56 56h240c30.9 0 56-25.1 56-56V294.4l24.8 20.2c10.3 8.4 25.4 6.8 33.8-3.4s6.8-25.4-3.4-33.8l-216-176zM528 255.3V456c0 4.4-3.6 8-8 8H280c-4.4 0-8-3.6-8-8V255.3L400 151l128 104.3zM352 312v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zM248.5 12.3l-11.9 32.3-32.3 11.9c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3c-2.6-7-12.4-7-15 0zm-145 320c-2.6-7-12.4-7-15 0l-11.9 32.3-32.3 11.9c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3z"
        }
    ]
};

const FarHousePersonLeave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHousePersonLeave",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-66.2 266.6c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3L513 184.8c.1-.3.2-.7.3-1-6.7-3.5-14-5.9-21.7-7.1l-29.9 89.8zm59 54.6 50.1 40.7c6.9 5.6 11.8 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L434 312.6c-18.1-14.7-25.2-39.1-17.8-61.2l22.8-68.3c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l9.5-21.3c17.1-38.5 49.6-68 89.5-81.3 15.3-5.1 31.3-7.7 47.4-7.7h4.9c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L633 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-29.1-29c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7-28.5 91.3zm-101.1 21 39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L361 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5 24.1-60.4zM255.2 5.4l136.7 111.4c-14.8 7.8-28.4 17.5-40.5 28.9L240 55 112 159.3V360c0 4.4 3.6 8 8 8h254.9l-6.6 16.5-31.5 31.5H120c-30.9 0-56-25.1-56-56V198.4l-24.8 20.2c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176c8.8-7.2 21.5-7.2 30.3 0zM160 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-64z"
        }
    ]
};

const FarHousePersonReturn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHousePersonReturn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm66.2 266.6-29.9-89.8c-7.7 1.2-15 3.6-21.7 7.1.1.3.2.7.3 1l32.4 103.8 16.3-13.3c2.6-2.1 3.6-5.6 2.5-8.7zm-59 54.6-28.5-91.3-10.5 36.7c-1.9 6.5-5.4 12.5-10.2 17.3L361 313c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l27.6-27.6 10.9-38.1C380 162.9 426.2 128 478.8 128h4.9c16.1 0 32.1 2.6 47.4 7.7 39.9 13.3 72.4 42.8 89.5 81.3l9.5 21.3c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-9.5-21.3c-10.9-24.4-30.9-43.5-55.6-53.3l22.8 68.3c7.4 22.1.3 46.5-17.8 61.2l-104.6 84.7-22.1 96c-3 12.9-15.9 21-28.8 18s-21-15.9-18-28.8l22.8-98.6c2-8.7 6.8-16.4 13.8-22.1l50.1-40.7zm101.1 21 24.1 60.4L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-69.7-69.7c-3.8-3.8-6.8-8.4-8.9-13.4l-19.2-48 39-31.7zm-146.7-224 2.9 2.4c-13.5 8.9-25.6 20-35.7 32.8L240 55 112 159.3V360c0 4.4 3.6 8 8 8h226.8c-1.1 2.9-1.9 5.8-2.6 8.8l-9.1 39.2H120c-30.9 0-56-25.1-56-56V198.4l-24.8 20.2c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176c8.8-7.2 21.5-7.2 30.3 0l116 94.4c6.3 7.4 14 13.7 22.6 18.4zM160 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-64z"
        }
    ]
};

const FarHouseSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseSignal",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320.8 5.4c8.8-7.2 21.5-7.2 30.3 0l216 176c10.3 8.4 11.8 23.5 3.4 33.8s-23.5 11.8-33.8 3.4L512 198.4V360c0 30.9-25.1 56-56 56H278.1c-4.7-16.7-11.1-32.8-18.8-48H456c4.4 0 8-3.6 8-8V159.3L336 55 208 159.3v139.4c-14.5-14.1-30.6-26.5-48-37v-63.3l-24.8 20.2c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176zM312 192h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zM24 256c128.1 0 232 103.9 232 232 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 376c0-13.3 10.7-24 24-24 75.1 0 136 60.9 136 136 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarHouseTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseTree",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M417.4 7.5C412.9 2.7 406.6 0 400 0s-12.9 2.7-17.4 7.5l-103.5 109 35.4 32.4 85.5-90L496.1 160H448c-9.6 0-18.2 5.7-22 14.5s-2 19 4.6 26L528.3 304H480c-9.4 0-17.9 5.4-21.8 13.9s-2.6 18.5 3.5 25.6L564.1 464H416c0 18-6 34.6-16 48h216c9.4 0 17.9-5.4 21.8-13.9s2.6-18.5-3.5-25.6L531.9 352H584c9.6 0 18.2-5.7 22-14.5s2-19-4.6-26L503.7 208H552c9.6 0 18.3-5.7 22.1-14.5s2-19-4.7-26l-152-160zM20.8 237C7.5 249.1 0 266.2 0 284.2V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237zM48 284.2c0-4.5 1.9-8.8 5.2-11.8l128-117.4c6.1-5.6 15.5-5.6 21.6 0l128 117.3c3.3 3 5.2 7.3 5.2 11.8V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V284.2zm96 11.8v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarHouseTsunami = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseTsunami",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M50 176.4C62 104.5 127.8 48 209.4 48c18.8 0 36.7 3 53.4 8.5 12.6 4.2 26.2-2.7 30.3-15.3s-2.7-26.2-15.3-30.3C256.4 3.8 233.4 0 209.4 0 95 0 0 88.4 0 200c0 93.2 54.7 174 144.8 194.8 12.7 3.4 26 5.2 39.7 5.2.6 0 1.2 0 1.8-.1 1.8 0 3.6.1 5.4.1h.4c34.6 0 67.9-14.3 96-33.8 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9h-.4c-12.9 0-25.2-1.4-36.7-4.2-43.4-12.7-75-52.6-75-99.8 0-57.4 46.7-104 104.4-104 15.9 0 30.9 3.5 44.3 9.8 12 5.6 26.3.4 31.9-11.6s.4-26.3-11.6-31.9c-19.7-9-41.6-14.1-64.7-14.1-58.1 0-108.8 32.5-134.4 80.4zm318 110.4V152l79.9-60 79.6 60 .3 124.4c9.4 6.4 20.2 11.3 30.8 13.7 6.2 1.4 12 3.7 17.2 6.8l-.3-153c0-10-4.7-19.5-12.7-25.5l-95.6-71.9a31.95 31.95 0 0 0-38.5 0l-96 72c-8.1 6-12.8 15.5-12.8 25.6V265c1.7 1 3.3 2 4.8 3.1 13.4 9.3 28.4 15.9 43.2 18.7zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0-17.2 14.9-39 26.7-61.2 31.7C5.9 464.7-2.3 477.5.6 490.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"
        }
    ]
};

const FarHouseTurret = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseTurret",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 48c-4.4 0-8 3.6-8 8v147.8c0 2 .7 3.9 2 5.3l55.9 62.9c3.9 4.4 6.1 10.1 6.1 15.9V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V297.1L14.1 241C5 230.8 0 217.5 0 203.8V56C0 25.1 25.1 0 56 0h240c30.9 0 56 25.1 56 56v68.6l-48 44V56c0-4.4-3.6-8-8-8h-40v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V48h-64v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V48H56zm120 96c22.1 0 40 17.9 40 40v40c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-40c0-22.1 17.9-40 40-40zm100.8 93 128-117.3c24.5-22.4 62-22.4 86.5 0L619.2 237c13.2 12.1 20.8 29.2 20.8 47.2V448c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V284.2c0-17.9 7.5-35.1 20.8-47.2zm27.2 47.2V448c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V284.2c0-4.5-1.9-8.8-5.2-11.8L458.8 155c-6.1-5.6-15.5-5.6-21.6 0l-128 117.3c-3.3 3-5.2 7.3-5.2 11.8zm96 11.8c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48z"
        }
    ]
};

const FarHouseUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l264 224c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5l-24.5 20.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8zM224 224a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm32 96h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80z"
        }
    ]
};

const FarHouseWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V393c14.6-8.5 31.9-10.7 48-6.6V204.8L288 55.5l176 149.3v181.7c16.1-4.2 33.4-1.9 48 6.5V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM256 224h64v64h-64v-64zm-8-48c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40v-80c0-22.1-17.9-40-40-40h-80zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0-17.2 14.9-39 26.7-61.2 31.7C5.9 464.7-2.3 477.5.6 490.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"
        }
    ]
};

const FarHouseWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouseWindow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432V204.8L288 55.5l176 149.3V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32zm144-144v-64h64v64h-64zm-48-72v80c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40v-80c0-22.1-17.9-40-40-40h-80c-22.1 0-40 17.9-40 40z"
        }
    ]
};

const FarHouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHouse",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432V204.8L288 55.5l176 149.3V432c0 17.7-14.3 32-32 32h-48V312c0-22.1-17.9-40-40-40H232c-22.1 0-40 17.9-40 40v152h-48c-17.7 0-32-14.3-32-32zm128 32V320h96v144h-96z"
        }
    ]
};

const FarHryvniaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHryvniaSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M105.7 104.6C125.6 88.7 150.3 80 175.8 80H227c33.7 0 61 27.3 61 61 0 20.7-10.5 39.8-27.5 51H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h147l-65.3 34.8c-7 3.7-13.5 8.2-19.4 13.2H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h29.8C50 347.1 48 358.9 48 371c0 60.2 48.8 109 109 109h51.2c36.4 0 71.7-12.4 100.1-35.1l2.7-2.2c10.4-8.3 12-23.4 3.7-33.7s-23.4-12-33.7-3.8l-2.7 2.2c-19.9 15.9-44.6 24.6-70.1 24.6H157c-33.7 0-61-27.3-61-61 0-12.8 4-24.9 11-35h253c13.3 0 24-10.7 24-24s-10.7-24-24-24H183l90-48h87c13.3 0 24-10.7 24-24s-10.7-24-24-24h-36.7c8.2-15.4 12.7-32.9 12.7-51 0-60.2-48.8-109-109-109h-51.2c-36.4 0-71.7 12.4-100.1 35.1L73 69.3c-10.3 8.2-12 23.3-3.7 33.7s23.4 12 33.7 3.7l2.7-2.2z"
        }
    ]
};

const FarHundredPoints = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHundredPoints",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.2 99.6c4.1-38.4 36.6-67.6 75.3-67.6 45 0 80.1 39 75.3 83.8l-13 120.6c-4.1 38.5-36.6 67.6-75.3 67.6-45 0-80.1-39-75.3-83.8l13-120.6zM246.5 80c-14.2 0-26 10.7-27.5 24.8l-13 120.5c-1.8 16.4 11.1 30.7 27.5 30.7 14.2 0 26-10.7 27.5-24.8l13-120.5c1.8-16.4-11.1-30.7-27.5-30.7zm-128-43.4c6.9 5.1 10.4 13.4 9.4 22l-32 256c-1.6 13.2-13.6 22.7-26.8 21.3s-22.5-13.3-20.8-26.4L75 95l-33.6 14.9c-12.2 5.4-26.3 0-31.5-12.1s.4-26.3 12.6-31.7l72-32c7.9-3.5 17-2.6 23.9 2.5zM431.7 32c44.4 0 79.2 37.9 75.6 82.1l-7.4 88.4c-3.3 39.3-36.1 69.5-75.6 69.5-44.4 0-79.2-37.9-75.6-82.1l7.4-88.4c3.3-39.3 36.1-69.5 75.6-69.5zM404 105.5l-7.4 88.4c-1.4 16.2 11.4 30.1 27.7 30.1 14.5 0 26.5-11.1 27.7-25.5l7.4-88.4C460.8 93.9 448 80 431.7 80c-14.5 0-26.5 11.1-27.7 25.5zm107.7 218.4c2.3 13.1-6.5 25.5-19.6 27.7l-464 80C15 433.9 2.6 425.1.3 412.1s6.5-25.5 19.6-27.7l464-80c13.1-2.3 25.5 6.5 27.7 19.6zm-51.8 115.8-240 40c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l240-40c13.1-2.2 25.4 6.7 27.6 19.7s-6.7 25.4-19.7 27.6z"
        }
    ]
};

const FarHurricane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHurricane",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 208c0-74.5 51-137.2 120-155v52.4c0 21.2 16 37.1 34.6 40.2C278.3 158.3 336 224.1 336 303.4c0 74.5-51 137.2-120 155V406c0-21.2-16-37.1-34.6-40.2C105.7 353.1 48 287.3 48 208zM216 42.1c0-22.7-20.1-43.4-45.6-38.7C73.5 21.1 0 105.9 0 208c0 101.2 72.3 185.5 168 204.2v57.1c0 22.7 20.1 43.4 45.6 38.7C310.5 490.3 384 405.4 384 303.4c0-101.2-72.3-185.5-168-204.2V42.1zM176 256a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FarHyphen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarHyphen",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarICursor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarICursor",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.1 22.2C-.9 35.4 9 47 22.2 48l15.4 1.2C75 52 104 83.3 104 120.9V232H64c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v111.1c0 37.6-29 68.9-66.5 71.8l-15.4 1.2c-13.2 1-23 12.5-22 25.7s12.6 23.1 25.8 22.1l15.4-1.2c35.7-2.7 66.7-20.9 86.8-47.6 20.1 26.7 51.1 44.9 86.8 47.6l15.4 1.2c13.2 1 24.8-8.9 25.8-22.1S247.2 465 234 464l-15.4-1.2C181 460 152 428.7 152 391.1V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V120.9c0-37.6 29-68.9 66.5-71.8l15.4-1.2c13.2-1 23.1-12.6 22.1-25.8s-12.6-23-25.8-22l-15.4 1.2C179.1 4 148.1 22.2 128 48.9 107.9 22.2 76.9 4 41.2 1.3L25.8.1C12.6-.9 1.1 8.9.1 22.2z"
        }
    ]
};

const FarI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarI",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h112v352H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V80h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarIceCream = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIceCream",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0C140.9 0 72.6 63.3 64.8 144.4 28.4 148 0 178.7 0 216c0 39.8 32.2 72 72 72h304c39.8 0 72-32.2 72-72 0-37.3-28.4-68-64.8-71.6C375.4 63.3 307.1 0 224 0zM112 160c0-61.9 50.1-112 112-112s112 50.1 112 112c0 2.2-.1 4.4-.2 6.6-.4 6.6 2 13.1 6.5 17.9s10.8 7.5 17.5 7.5H376c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h16.2c6.6 0 12.9-2.7 17.5-7.5s6.9-11.3 6.5-17.9c-.1-2.2-.2-4.4-.2-6.6zm88.1 338.1c4.9 8.6 14 13.9 23.9 13.9s19-5.3 23.9-13.9L349.7 320H98.3l101.8 178.1z"
        }
    ]
};

const FarIceSkate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIceSkate",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 0c13.3 0 24 10.7 24 24v158l128.6 37.5c37.5 11 63.4 45.4 63.4 84.5v24c0 30.9-25.1 56-56 56H88c-30.9 0-56-25.1-56-56V136.4c0-25.2 16.8-47.3 41.1-54L272 27.5V24c0-13.3 10.7-24 24-24zm-24 128V77.3L85.9 128.7c-3.5 1-5.9 4.1-5.9 7.7V328c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-24c0-17.8-11.7-33.4-28.8-38.4L292.6 224H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32zm280 280c13.3 0 24 10.7 24 24v8c0 39.8-32.2 72-72 72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h72v-48h48v48h240v-48h48v48h72c13.3 0 24-10.7 24-24v-8c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarIcicles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIcicles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M5.2 9.1C9.7 3.4 16.7 0 24 0h464c6.9 0 13.5 3 18.1 8.2s6.6 12.2 5.7 19L448.9 483c-2.3 16.6-16.5 29-33.2 29-15.8 0-29.4-11-32.8-26.4l-50.3-229.1-11.2 38.2c-4.4 15-18.1 25.2-33.7 25.2-14.5 0-27.6-9-32.8-22.5l-9.4-24.6-20.2 84.9c-3.8 15.4-17.5 26.3-33.3 26.3s-29.5-10.9-33.2-26.2l-20.2-84.9-9.5 24.8C123.9 311.1 111 320 96.6 320c-16.2 0-30.2-11.1-33.9-26.8L.6 29.5C-1 22.4.6 14.8 5.2 9.1zM54.3 48l45.3 192.6 22-57.2c3.8-9.8 13.5-16 24-15.3s19.3 8.2 21.7 18.4L192 290l24.7-103.5c2.4-10.2 11.3-17.7 21.7-18.4s20.2 5.5 24 15.3l23.6 61.4 27-91.6c3.1-10.5 12.9-17.6 23.9-17.2s20.3 8.1 22.6 18.8l53 241.4 48-348.2H54.3z"
        }
    ]
};

const FarIcons = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIcons",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M59.6 54.4c11.1-9.4 30.8-8.7 43.5 3.7l8 8.1L128.6 84l17.1-18.3 7.3-7.8c12.5-12 31.7-13.1 43.8-3.4 14.2 12.1 14.8 33.3 2 46.2l-70.7 70.8-71-70.8c-12.8-12.8-12.2-34.1 2.4-46.2l.1-.1zM28.8 17.6c-36.5 30.3-38.2 84.4-5.7 117l78.6 78.4c14.7 15.1 38.3 14.1 52.5.4l.3-.3 78.3-78.5c32.6-32.6 30.8-86.6-5.2-116.9l-.3-.3c-29.9-24.3-71-21.9-99.3-1C99.7-4.4 58.2-7 28.8 17.6zM512 24c0-7.2-3.2-14-8.8-18.6S490.3-1 483.3.4l-160 32C312.1 34.7 304 44.6 304 56v105.5c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48V75.7l112-22.4v76.2c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48V24zM106.9 309.5l2.7-5.5h68.7l2.7 5.5c8.1 16.3 24.8 26.5 42.9 26.5 8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16 18.2 0 34.8-10.3 42.9-26.5zM224 288l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H99.8c-12.1 0-23.2 6.8-28.6 17.7L64 288c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64v-96c0-35.3-28.7-64-64-64zm-32 104a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm281.4-132.9c-6-4.4-14.3-4-19.9.9l-128 112c-5 4.4-6.8 11.4-4.4 17.7s8.3 10.4 15 10.4h55.7l-38.4 89.7c-2.9 6.9-.7 14.9 5.3 19.2s14.3 4 19.9-.9l128-112c5-4.4 6.8-11.4 4.4-17.7s-8.3-10.4-15-10.4h-55.7l38.4-89.7c2.9-6.9.7-14.9-5.3-19.2z"
        }
    ]
};

const FarIdBadge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIdBadge",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48v16c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16h-64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm160 256h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarIdCardClip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIdCardClip",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32h-64zm-64 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H384v48h128c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h128V64zm96 240a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80h-64z"
        }
    ]
};

const FarIdCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIdCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 160v256c0 8.8-7.2 16-16 16H320c0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V160h480zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm208 224a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80z"
        }
    ]
};

const FarIgloo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIgloo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 432H400v-64h128v48c0 8.8-7.2 16-16 16zM395.4 320c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80H144V192h288v128h-36.6zm95.7-128c23.4 37 36.9 80.9 36.9 128h-48V192h11.1zM96 192v128H48c0-47.1 13.5-91 36.9-128H96zM288 80c5.4 0 10.7.2 16 .5V144H124.8C167.7 104.3 225 80 288 80zm64 64V88.6c37.6 10.4 71.4 29.6 99.2 55.4H352zM176 368v64H64c-8.8 0-16-7.2-16-16v-48h128zM64 480h448c35.3 0 64-28.7 64-64v-96c0-159.1-128.9-288-288-288S0 160.9 0 320v96c0 35.3 28.7 64 64 64zm224-192c35.3 0 64 28.7 64 64v80H224v-80c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FarImageLandscape = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarImageLandscape",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h19.8l80.8-110.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8l29.4 40.2 83.1-127.1c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9L485 400h27c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zm32 336H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H96zm64-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarImagePolaroidUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarImagePolaroidUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-48H48v48zm286-96h66V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v224h66c7.1-27.6 32.2-48 62-48h96c29.8 0 54.9 20.4 62 48zM448 96v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64zm-288 80a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarImagePolaroid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarImagePolaroid",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 368v48c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-48h352zM75.3 320H48V96c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v224h-23.6l-92.3-141.1c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-56 85.6-16.6-22.6c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L75.3 320zm372.7 0V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-96zM144 144a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarImagePortrait = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarImagePortrait",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zm0-48c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256zM128 192a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6 0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"
        }
    ]
};

const FarImageSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarImageSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1.7-6.3.7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM134.4 80H512c8.8 0 16 7.2 16 16v292.5l-53.4-41.9L387 233.3c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3l-7.2 9.3-85.8-67.3c-.4-26.2-21.7-47.3-48-47.3-3.7 0-7.4.4-10.8 1.2L134.4 80zm353 400L282.9 318.9 266 340.7 235.5 298c-4.5-6.3-11.7-10-19.5-10s-15 3.7-19.5 10.1l-80 112-4.5 6.3V184.2l-48-37.8V416c0 35.3 28.7 64 64 64h359.4z"
        }
    ]
};

const FarImageUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarImageUser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm192 96a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-48 164.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6 0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4z"
        }
    ]
};

const FarImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 80c8.8 0 16 7.2 16 16v319.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3l-83 107.4-30.5-42.7c-4.5-6.3-11.7-10-19.5-10s-15 3.7-19.5 10.1l-80 112-4.5 6.2V96c0-8.8 7.2-16 16-16h384zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarImagesUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarImagesUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80H160c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h64c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64h64c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16zM160 32h352c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zM24 96c13.3 0 24 10.7 24 24v224c0 48.6 39.4 88 88 88h320c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 480 0 419.1 0 344V120c0-13.3 10.7-24 24-24zm248 80a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarImages = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarImages",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80h352c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16h-21.2L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm-48 24c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm208 24a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarInboxFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInboxFull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16v-80h-81.2l-20.9 41.9c-6.8 13.6-20.6 22.1-35.8 22.1H185.9c-15.2 0-29-8.6-35.8-22.1L129.2 336H48v80zM405.6 92.1C403.8 85 397.4 80 390 80H122c-7.3 0-13.7 5-15.5 12.1L57.5 288h76.6c15.2 0 29 8.6 35.8 22.1l20.9 41.9h130.4l20.9-41.9c6.8-13.6 20.6-22.1 35.8-22.1h76.6l-49-195.9zM0 416v-88.1c0-5.2.6-10.4 1.9-15.5l58-231.9C67 52 92.6 32 122 32h268c29.4 0 55 20 62.1 48.5l58 231.9c1.3 5.1 1.9 10.3 1.9 15.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm184-288h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-32 80h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarInboxIn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInboxIn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24v206.1l63-63c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 305c-9.4 9.4-24.6 9.4-33.9 0L135 201c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l63 63V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM149.1 405.5 130.3 368H48v96h416v-96h-82.3L363 405.5c-8.2 16.2-24.8 26.5-43 26.5H192c-18.2 0-34.8-10.3-42.9-26.5zm24.2-58.9L192 384h128l18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48h82.3c18.2 0 34.8 10.3 42.9 26.5z"
        }
    ]
};

const FarInboxOut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInboxOut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 288c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9l-63 63c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L377 111c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-63-63V288zM149.1 405.5 130.3 368H48v96h416v-96h-82.3L363 405.5c-8.2 16.2-24.8 26.5-43 26.5H192c-18.2 0-34.8-10.3-42.9-26.5zm24.2-58.9L192 384h128l18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48h82.3c18.2 0 34.8 10.3 42.9 26.5z"
        }
    ]
};

const FarInbox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInbox",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 336h81.2l20.9 41.9c6.8 13.6 20.6 22.1 35.8 22.1h140.2c15.1 0 29-8.6 35.8-22.1l20.9-41.9H464v80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-80zm406.5-48h-76.6c-15.1 0-29 8.6-35.8 22.1L321.2 352H190.8l-20.9-41.9c-6.8-13.6-20.6-22.1-35.8-22.1H57.5l49-195.9C108.2 85 114.6 80 122 80h268c7.3 0 13.7 5 15.5 12.1l49 195.9zM0 327.9V416c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-88.1c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122c-29.4 0-55 20-62.1 48.5l-58 231.9c-1.3 5-1.9 10.2-1.9 15.5z"
        }
    ]
};

const FarInboxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInboxes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M62.5 96h67.9c18.2 0 34.8 10.3 42.9 26.5L192 160h128l18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5h67.8l-40-48h-307l-40 48zM48 144v96h416v-96h-82.3L363 181.5c-8.2 16.2-24.8 26.5-43 26.5H192c-18.2 0-34.8-10.3-42.9-26.5L130.3 144H48zm-48 0v-30.6c0-11.2 3.9-22.1 11.1-30.7l54.5-65.4C74.7 6.3 88.2 0 102.5 0h307c14.2 0 27.8 6.3 36.9 17.3l54.5 65.4c7.2 8.6 11.1 19.5 11.1 30.7V240c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96zm310.1 288H201.9c-24.2 0-46.4-13.7-57.2-35.4L130.3 368H48v96h416v-96h-82.3l-14.3 28.6-42.6-21.3 42.6 21.3c-10.8 21.7-33 35.4-57.2 35.4zM48 320h82.3c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8h108.3c6.1 0 11.6-3.4 14.3-8.8l14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FarIndent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIndent",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 40 0 50.7 0 64zm192 128c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24zm24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H216zM0 448c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm121-179.6c7.8-6.4 7.8-18.3 0-24.7l-94.8-78.1C15.7 157 0 164.4 0 177.9v156.2c0 13.5 15.7 20.9 26.2 12.4l94.8-78.1z"
        }
    ]
};

const FarIndianRupeeSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIndianRupeeSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24s-10.7 24-24 24h-84.7c17.7 19.8 30.1 44.6 34.7 72h50c13.3 0 24 10.7 24 24s-10.7 24-24 24h-50c-11.4 68.1-70.7 120-142 120h-5.1l163 116.5c10.8 7.7 13.3 22.7 5.6 33.5s-22.7 13.3-33.5 5.6l-224-160c-8.4-6.1-12-17-8.9-26.9S13.6 272 24 272h80c44.7 0 82.3-30.6 93-72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h173c-10.7-41.4-48.2-72-93-72H24C10.7 80 0 69.3 0 56z"
        }
    ]
};

const FarIndustryWindows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIndustryWindows",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v126.7c0 8.6 4.6 16.5 12 20.8s16.6 4.2 24-.1l140-81.6v70.9c0 8.8 4.8 16.8 12.5 21.1s17.1 3.9 24.5-.8l139.1-89-.1 148v104c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V88zm8-56c-30.9 0-56 25.1-56 56v320c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72V155.9c0-37.9-41.9-60.9-73.9-40.4L368 180.8v-27c0-37-40.2-60.1-72.2-41.5L192 172.9V88c0-30.9-25.1-56-56-56H88zm56 264c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zm104 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm136-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48z"
        }
    ]
};

const FarIndustry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIndustry",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 80c-4.4 0-8 3.6-8 8v320c0 13.3 10.7 24 24 24h368c13.3 0 24-10.7 24-24V155.9l-139.1 89c-7.4 4.7-16.8 5-24.5.8s-12.5-12.3-12.5-21.1v-70.9l-139.8 81.7c-7.4 4.3-16.6 4.4-24 .1s-12-12.2-12-20.8V88c0-4.4-3.6-8-8-8H88zm-56 8c0-30.9 25.1-56 56-56h48c30.9 0 56 25.1 56 56v84.9l103.8-60.6c32-18.7 72.2 4.4 72.2 41.5v27l102.1-65.4c32-20.4 73.9 2.5 73.9 40.5V408c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72V88z"
        }
    ]
};

const FarInfinity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInfinity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 237.3C0 159.3 63.3 96 141.3 96c39 0 76.2 16.1 102.9 44.5L320 221l75.8-80.5C422.5 112.1 459.7 96 498.7 96c78 0 141.3 63.3 141.3 141.3v37.4c0 78-63.3 141.3-141.3 141.3-39 0-76.2-16.1-102.9-44.5L320 291l-75.8 80.5c-26.7 28.4-63.9 44.5-102.9 44.5C63.3 416 0 352.7 0 274.7v-37.4zM287 256l-77.8-82.6c-17.6-18.7-42.2-29.4-68-29.4-51.4 0-93.2 41.8-93.2 93.3v37.4c0 51.5 41.8 93.3 93.3 93.3 25.7 0 50.3-10.6 68-29.4L287 256zm65.9 0 77.8 82.6c17.6 18.7 42.2 29.4 68 29.4 51.5 0 93.3-41.8 93.3-93.3v-37.4c0-51.5-41.8-93.3-93.3-93.3-25.7 0-50.3 10.6-68 29.4L353 256z"
        }
    ]
};

const FarInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInfo",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 72a40 40 0 1 1 80 0 40 40 0 1 1-80 0zM16 200c0-13.3 10.7-24 24-24h56c13.3 0 24 10.7 24 24v264h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V224H40c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarInhaler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInhaler",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m429.8 32.7 128 32c6.3 1.6 11.6 5.6 14.9 11.2s4.1 12.2 2.4 18.4L533.2 248 386.9 101.6l14-51.8c3.4-12.6 16.3-20.2 29-17zM389 216.9l-2.1 7.8c-7.5 27.9-32.9 47.3-61.8 47.3H240v160h209.9l33-121.2-94-94zM530 290c4.1 4.1 5.6 10 4.1 15.5l-39.5 145C489.8 467.9 474 480 456 480H232c-22.1 0-40-17.9-40-40V264c0-22.1 17.9-40 40-40h93.1c7.2 0 13.6-4.9 15.4-11.8l16.5-61.3c3.2-11.9 18.1-15.9 26.8-7.2L530 290zM0 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm0 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarInputNumeric = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInputNumeric",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 112c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h512zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm40 120c0 13.3 10.7 24 24 24h8v96h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16V184c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24zm190.6 30.4c5.7-8 17.5-8.6 24-1.2 5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24h-33.2l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z"
        }
    ]
};

const FarInputPipe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInputPipe",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm144 56v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarInputText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInputText",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7h-75.4l-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280h32.8L184 243.1zM304 184c0-13.3 10.7-24 24-24h52c33.1 0 60 26.9 60 60 0 9.2-2.1 17.9-5.8 25.7 13.3 11 21.8 27.6 21.8 46.3 0 33.1-26.9 60-60 60h-68c-13.3 0-24-10.7-24-24V184zm48 24v24h28c6.6 0 12-5.4 12-12s-5.4-12-12-12h-28zm0 96h44c6.6 0 12-5.4 12-12s-5.4-12-12-12h-44v24z"
        }
    ]
};

const FarIntegral = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIntegral",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 48c-17.7 0-32 14.3-32 32v352c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-13.3 10.7-24 24-24s24 10.7 24 24v16c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-44.2 35.8-80 80-80s80 35.8 80 80v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V80c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FarInterrobang = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarInterrobang",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80c-44.2 0-80 35.8-80 80 0 13.3-10.7 24-24 24s-24-10.7-24-24C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128v4.6c0 40.1-20.1 77.6-53.4 99.8l-52.3 34.9c-8.9 5.9-14.2 15.9-14.2 26.6v18c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24s24 10.7 24 24v83.2l39.9-26.6c20-13.4 32.1-35.8 32.1-59.9V160c0-44.2-35.8-80-80-80H144zm-16 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarIntersection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIntersection",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 480c13.3 0 24-10.7 24-24V224c0-79.5 64.5-144 144-144s144 64.5 144 144v232c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-106-86-192-192-192S0 118 0 224v232c0 13.3 10.7 24 24 24z"
        }
    ]
};

const FarIslandTropical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarIslandTropical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M114.3 93.7c-1.5 1.5-3.5 2.3-5.7 2.3H78.2c-8.8 0-16.1-7.2-13.8-15.8C73.6 44.8 112.8 0 190.2 0c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c77.4 0 116.6 44.8 125.8 80.2 2.2 8.6-5 15.8-13.8 15.8h-44.7c-2.1 0-4.2-.8-5.7-2.3l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24c-1.5 1.5-3.5 2.3-5.7 2.3h-61.2c3.5 15.4 7.2 35.7 9.5 59.7 4.4 45.4 3.7 104.4-13.9 167.1 57.7 12.4 101 63.7 101 125.1 0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32 0-70.7 57.3-128 128-128h24.9c26-56.3 38-110.2 43.3-151.1 1.3-9.9 2.2-19 2.8-27.1l-71.8 71.8c-6.2 6.2-16.5 6.2-21-1.4-18.5-31.6-22.5-90.9 32.3-145.7 1.4-1.4 2.8-2.7 4.1-4-.3-.3-.7-.5-1-.8l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24zm123 258.3h28.5c18.5-59.2 19.5-115.9 15.3-159.7-.6-6.1-1.3-12-2-17.5-.7 9.6-1.7 20.5-3.3 32.4-5.2 39.6-16 90.6-38.5 144.9zm50.7 48H160c-38.7 0-71 27.5-78.4 64h284.8c-7.4-36.5-39.7-64-78.4-64z"
        }
    ]
};

const FarItalic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarItalic",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 56c0-13.3 10.7-24 24-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-68.7L144.7 432H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h68.7L239.3 80H152c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarJ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJ",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 32c13.3 0 24 10.7 24 24v264c0 88.4-71.6 160-160 160S0 408.4 0 320v-40c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 61.9 50.1 112 112 112s112-50.1 112-112V56c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarJackOLantern = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJackOLantern",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m275.5 10.4-43.9 100.2c-4 2.1-7.9 4.5-11.6 7.1-20-13.6-43.1-21.7-68-21.7-45.4 0-84 26.5-110.2 64.2C15.5 198 0 248.9 0 304s15.5 106 41.8 143.8C68 485.5 106.6 512 152 512c24.9 0 48-8.1 68-21.6 20 13.6 43.1 21.6 68 21.6s48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6 45.4 0 84-26.5 110.2-64.2C560.5 410 576 359.1 576 304s-15.5-106-41.8-143.8C508 122.5 469.4 96 424 96c-24.9 0-48 8.1-68 21.6-1.3-.9-2.7-1.8-4-2.6V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4zM81.2 187.6c20.1-28.9 45.5-43.6 70.8-43.6 18 0 35.8 7.4 51.9 21.9 9.1 8.3 23 8.3 32.2 0C252.2 151.4 270 144 288 144s35.8 7.4 51.9 21.9c9.1 8.3 23 8.3 32.2 0C388.2 151.4 406 144 424 144c25.3 0 50.7 14.7 70.8 43.6 20 28.8 33.2 69.9 33.2 116.4s-13.2 87.6-33.2 116.4C474.7 449.3 449.3 464 424 464c-18 0-35.8-7.4-51.9-21.9-9.1-8.3-23-8.3-32.2 0C323.8 456.6 306 464 288 464s-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C187.8 456.6 170 464 152 464c-25.3 0-50.7-14.7-70.8-43.6C61.2 391.6 48 350.5 48 304s13.2-87.6 33.2-116.4zm140.1 27.5c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5h64c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48zM368 208c-5.4 0-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5h64c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48c-3-4.5-8-7.1-13.3-7.1zm102.1 104c1.4-5-.3-10.2-4-13.8-5.8-5.8-15.1-6.6-22.2-2.4C420.8 309.4 365.6 336 288 336v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-19.5c-52.4-7.7-89.9-26.2-107.9-36.8-7.1-4.2-16.4-3.4-22.2 2.4-3.7 3.7-5.4 8.8-4 13.8 4.2 14.7 17.2 46.8 54.1 71.4.3-8.6 7.3-15.4 16-15.4h16c8.8 0 16 7.2 16 16v21.5c21.8 6.5 48.2 10.5 80 10.5s58.2-4 80-10.5V384c0-8.8 7.2-16 16-16h16c8.6 0 15.7 6.9 16 15.4 36.9-24.7 49.9-56.7 54.1-71.4z"
        }
    ]
};

const FarJarWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJarWheat",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 24c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24S277.3 0 264 0H56C42.7 0 32 10.7 32 24zm224 104c8.8 0 16 7.2 16 16v304c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h192zM64 80c-35.3 0-64 28.7-64 64v304c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64H64zm192 85.8c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224h75.6c32.1 0 58.2-26 58.2-58.2zm-5.8 90.2H208c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320h75.6c32.1 0 58.2-26 58.2-58.2 0-3.2-2.6-5.8-5.8-5.8zm5.8 101.8c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h21.8c32.1 0 58.2-26 58.2-58.2z"
        }
    ]
};

const FarJar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJar",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 24c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24S277.3 0 264 0H56C42.7 0 32 10.7 32 24zm224 104c8.8 0 16 7.2 16 16v80H48v-80c0-8.8 7.2-16 16-16h192zm16 240v80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-80h224zM64 80c-35.3 0-64 28.7-64 64v304c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarJedi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJedi",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m224.8 267.9 21.2 31.8c1.3 1.9.2 4.5-2 4.9l-37.6 7.5c-3.7.7-6.4 4-6.4 7.8s2.7 7.1 6.4 7.8l37.6 7.5c2.2.4 3.3 3 2 4.9L224.8 372c-2.1 3.2-1.7 7.4 1 10.1s6.9 3.1 10.1 1l26.9-17.9c2.2-1.4 5.1.2 5 2.8l-2.1 61.7C214.5 419.4 176 374.2 176 320c0-29.6 11.5-56.5 30.2-76.5 4.5-4.8 6.8-11.2 6.4-17.7s-3.3-12.6-8.3-16.9C177.2 185.4 160 150.7 160 112c0-26.9 8.3-51.9 22.5-72.5 6.4-9.3 5.5-21.7-2.2-30s-20-10-29.7-4.4C70.1 52.4 16 139.9 16 240c0 150.2 121.8 272 272 272s272-121.8 272-272c0-100.1-54.1-187.6-134.6-234.8-9.7-5.7-22.1-3.9-29.7 4.4s-8.6 20.7-2.2 30C407.7 60.1 416 85.1 416 112c0 38.7-17.2 73.4-44.4 96.9-4.9 4.3-7.9 10.4-8.3 16.9s2 12.9 6.4 17.7c18.8 20 30.2 46.9 30.2 76.5 0 54.2-38.5 99.4-89.7 109.8l-2.1-61.7c-.1-2.6 2.8-4.2 5-2.8l26.9 17.9c3.2 2.1 7.4 1.7 10.1-1s3.1-6.9 1-10.1L330 340.3c-1.3-1.9-.2-4.5 2-4.9l37.5-7.5c3.7-.7 6.4-4 6.4-7.8s-2.7-7.1-6.4-7.8l-37.5-7.7c-2.2-.4-3.3-3-2-4.9l21.2-31.9c2.1-3.2 1.7-7.4-1-10.1s-6.9-3.1-10.1-1l-30 20c-2.1 1.4-4.9 0-5-2.6L296.3 8c-.1-4.5-3.8-8-8.3-8s-8.1 3.5-8.3 8l-8.9 266.2c-.1 2.5-2.9 3.9-5 2.6l-30-20c-3.2-2.1-7.4-1.7-10.1 1s-3.1 6.9-1 10.1zM64.1 233.5c.3-10.7 1.4-21.3 3.1-31.6l17.5 17.5c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.8-30.9c8.3-23.7 20.5-45.6 35.8-64.9-.2 3.6-.3 7.3-.3 11 0 44.9 16.8 85.8 44.4 116.9-17.9 25.9-28.4 57.3-28.4 91.1 0 44.5 18.1 84.7 47.4 113.7-54.9-32-94.9-86.6-107.4-151l16.6 16.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-43.1-43.2zm447.8 0-43.2 43.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16.6-16.6c-12.4 64.4-52.5 119.1-107.4 151 29.3-29 47.4-69.2 47.4-113.7 0-33.8-10.5-65.2-28.4-91.1 27.6-31.1 44.4-72 44.4-116.9 0-3.7-.1-7.4-.3-11 15.3 19.3 27.5 41.2 35.8 64.9l-30.8 30.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17.5-17.5c1.8 10.3 2.8 20.9 3.1 31.6z"
        }
    ]
};

const FarJetFighterUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJetFighterUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.2 12.8C273.1 4.9 264.9 0 256 0s-17.1 4.9-21.2 12.8l-66.4 125.4c-5.5 10.4-8.4 21.9-8.4 33.7v31.6L48 281.9V248c0-13.3-10.7-24-24-24S0 234.7 0 248v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h112v1.1l-41.9 66.3c-4 6.3-6.1 13.6-6.1 21.1 0 21.8 17.7 39.5 39.5 39.5h209c21.8 0 39.5-17.7 39.5-39.5 0-7.5-2.1-14.8-6.1-21.1L352 385.1V384h112v8c0 13.3 10.7 24 24 24s24-10.7 24-24V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v33.9l-112-78.4v-31.6c0-11.7-2.9-23.3-8.4-33.7L277.2 12.8zM457.6 336H352v-73.9L457.6 336zM304 360v32c0 4.5 1.3 9 3.7 12.8l37.4 59.2H280v-56c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-65.1l37.4-59.2c2.4-3.8 3.7-8.3 3.7-12.8V171.9c0-3.9 1-7.8 2.8-11.2L256 75.3l45.2 85.4c1.8 3.5 2.8 7.3 2.8 11.2V360zm-144-24H54.4L160 262.1V336z"
        }
    ]
};

const FarJetFighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJetFighter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-6.9c4.7 6.1 9.8 12.6 15.1 19.6C329.5 100.4 361 141.7 386 176h97.1c5.7 0 11.3.9 16.7 2.5l108.1 33.8C627 218.3 640 236 640 256s-13 37.7-32.1 43.7l-108.1 33.7c-5.4 1.7-11 2.6-16.7 2.6H386l-97.5 128h7.5c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V336h-14.1l-31.6 31.6a55.924 55.924 0 0 1-39.6 16.4H88c-30.9 0-56-25.1-56-56v-48h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-48c0-30.9 25.1-56 56-56h18.7c14.9 0 29.1 5.9 39.6 16.4l31.6 31.6H192V48h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h32zm24 176h86.4c-19.9-26.7-41.6-55.1-60.1-79.1-10-12.9-19-24.5-26.3-33.9v113zM80 280v48c0 4.4 3.6 8 8 8h18.7c2.1 0 4.2-.8 5.7-2.3L151 295c4.5-4.5 10.6-7 17-7h315.1c.8 0 1.6-.1 2.4-.4L586.7 256l-101.2-31.6c-.8-.2-1.6-.4-2.4-.4H168c-6.4 0-12.5-2.5-17-7l-38.6-38.6c-1.5-1.5-3.5-2.3-5.7-2.3H88c-4.4 0-8 3.6-8 8v48h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H80zm160 56v112.4L325.6 336H240z"
        }
    ]
};

const FarJoint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJoint",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 24v19c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v19c0 13.3-10.7 24-24 24s-24-10.7-24-24v-19c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm128 240v-19c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24v19c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v19c0 13.3-10.7 24-24 24s-24-10.7-24-24zM120.2 436.8c51.5 13.9 115 27.2 167.8 27.2h27.4l-52.6-63.1c-47 3.2-99.1 14.6-142.6 26.3-5.8 1.6-11.7 3.2-17.5 4.8 5.8 1.7 11.6 3.3 17.5 4.8zM324.6 400l53.3 64h97.5l-53.3-64h-97.5zm160 0 53.3 64H592v-64H484.6zm-468.8 9.5c30.1-11 61.1-20.3 92-28.6 52.5-14.2 121-28.9 180.2-28.9h312c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H288c-59.2 0-127.7-14.7-180.2-28.8-30.8-8.3-62-17.8-92-28.6C6.3 451.1 0 442.1 0 432s6.3-19.1 15.8-22.5z"
        }
    ]
};

const FarJoystick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJoystick",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 173.4c50.3-11 88-55.8 88-109.4C336 50.1 285.9 0 224 0S112 50.1 112 112c0 53.6 37.7 98.4 88 109.4V320h48v-98.6zM96 320c-17.7 0-32 14.3-32 32-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64H128c0-17.7-14.3-32-32-32zm0 80h288c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32z"
        }
    ]
};

const FarJugBottle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJugBottle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v24h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V24zm32 152c-44.2 0-80 35.8-80 80v192c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V256c0-44.2-35.8-80-80-80H128zM0 256c0-70.7 57.3-128 128-128h128c70.7 0 128 57.3 128 128v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm224 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96zM472 64h80c13.3 0 24 10.7 24 24v40H448V88c0-13.3 10.7-24 24-24zm-55 328c-.3-.2-.7-.4-1-.6V256c0-24.7-5.6-48.1-15.6-69 5.1-5.3 11.1-9.8 18-13l13.2-6.2c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l13.2 6.2c21 9.9 34.4 31 34.4 54.2 0 22.8-12.7 42.6-31.5 52.7C627.4 292 640 312.5 640 336c0 24.1-13.3 45.1-33 56 19.7 10.9 33 31.9 33 56 0 35.3-28.7 64-64 64H448c-17 0-32.5-6.7-44-17.5 7.6-13.8 12-29.6 12-46.5v-55.4c.3-.2.7-.4 1-.6z"
        }
    ]
};

const FarJugDetergent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJugDetergent",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 0c-13.3 0-24 10.7-24 24v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V24c0-13.3-10.7-24-24-24h-80zm136 176c44.2 0 80 35.8 80 80v192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80h128zm-128-48C57.3 128 0 185.3 0 256v192c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm128 96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FarJug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarJug",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 85V48h64v37c0 17.8 5.9 35.1 16.9 49.1l37.9-29.5-37.9 29.5 78.3 100.7c10.9 14 16.9 31.3 16.9 49.1v4.1H80v-4.1c0-17.8 5.9-35.1 16.9-49.1l78.3-100.7c10.9-14 16.9-31.3 16.9-49.1zM80 416h288v32c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-32zm242.5-296.2-11.8-15.1C306.4 99 304 92.1 304 85V48c13.3 0 24-10.7 24-24S317.3 0 304 0H144c-13.3 0-24 10.7-24 24s10.7 24 24 24v37c0 7.1-2.4 14-6.7 19.6L59 205.3c-17.5 22.5-27 50.1-27 78.6V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V283.9c0-17.4-3.5-34.5-10.3-50.3 24.9-11.3 42.3-36.4 42.3-65.6 0-39.8-32.2-72-72-72-21.2 0-40.3 9.2-53.5 23.8zM400 168c0 12.4-9.4 22.6-21.4 23.9l-25.1-32.2c3.4-9.1 12.2-15.6 22.5-15.6 13.3 0 24 10.7 24 24z"
        }
    ]
};

const FarK = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarK",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56v400c0 13.3 10.7 24 24 24s24-10.7 24-24V337.9l79.6-79.6 148.8 211.5c7.6 10.8 22.6 13.5 33.4 5.8s13.4-22.6 5.8-33.4L162.1 223.9 313 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L48 270.1V56z"
        }
    ]
};

const FarKaaba = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKaaba",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48.8 490.4 112 288 175.2 85.6 112 288 48.8zm9.5 173.8 230.5-72v45.7l-235.2 73.4c-3.1 1-6.4 1-9.5 0L48 196.2v-45.7l230.5 72c6.2 1.9 12.9 1.9 19.1 0zM48 229.8l225.7 70.5c9.3 2.9 19.3 2.9 28.6 0L528 229.8v30.5l-4.8 1.5c-8.4 2.6-13.1 11.6-10.5 20 2.1 6.8 8.5 11.2 15.3 11.2v95.2l-240 75-240-75V293c6.8 0 13.1-4.4 15.3-11.2 2.6-8.4-2.1-17.4-10.5-20l-4.8-1.6v-30.4zM22.5 81.5C9.1 85.6 0 98 0 112v288c0 14 9.1 26.4 22.5 30.5l256 80c6.2 1.9 12.9 1.9 19.1 0l256-80C566.9 426.4 576 414 576 400V112c0-14-9.1-26.4-22.5-30.5l-256-80c-6.2-1.9-12.9-1.9-19.1 0l-256 80zm94.3 200.3c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
        }
    ]
};

const FarKazoo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKazoo",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M560 256c0 29.6-8.9 57.1-24.2 80H576c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16h-40.2c15.3 22.9 24.2 50.4 24.2 80zm16 128h-94c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16H241.7c-11.8 0-23.4-1.6-34.7-4.8-39.3-11.1-136.7-38.7-184-52.5-13.6-4-23-16.5-23-30.7v-80c0-14.2 9.4-26.7 23-30.7 47.3-13.8 144.7-41.4 184-52.5 11.3-3.2 23-4.8 34.7-4.8H350c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16h94c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64zm-334.3-48h54.5c-15.3-22.9-24.2-50.4-24.2-80s8.9-57.1 24.2-80h-54.5c-7.4 0-14.6 1-21.7 3-36.3 10.3-122.1 34.6-172 49v56c49.9 14.5 135.7 38.7 172.1 49 7 2 14.3 3 21.7 3zM416 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-17.9-142.1 17.9 17.8 17.9-17.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L444.3 256l17.9 17.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L416 284.3l-17.9 17.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l17.9-17.9-17.9-17.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z"
        }
    ]
};

const FarKerning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKerning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M453.8 34.1c5.6-12 .4-26.3-11.6-31.9s-26.3-.4-31.9 11.6l-216 464c-5.6 12-.4 26.3 11.6 31.9s26.3.4 31.9-11.6l216-464zM45.5 109.3c-6-11.9-20.4-16.7-32.2-10.8s-16.7 20.4-10.8 32.2l136 272c4.1 8.1 12.4 13.3 21.5 13.3s17.4-5.1 21.5-13.3l136-272c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7L160 338.3l-114.5-229zm328.2 293 23.6-50.3h165.4l23.6 50.2c5.6 12 19.9 17.1 31.9 11.5s17.1-19.9 11.5-31.9l-128-272c-4-8.4-12.4-13.8-21.7-13.8s-17.8 5.4-21.7 13.8l-128 272c-5.6 12-.5 26.3 11.5 31.9s26.3.5 31.9-11.5zM480 176.4 540.1 304H419.9L480 176.4z"
        }
    ]
};

const FarKeySkeletonLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKeySkeletonLeftRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M592 128a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm48 0c0 70.7-57.3 128-128 128-62.5 0-114.5-44.8-125.8-104H304v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48h-48v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72c0-13.3 10.7-24 24-24h202.2C397.5 44.8 449.5 0 512 0c70.7 0 128 57.3 128 128zM48 384a80 80 0 1 0 160 0 80 80 0 1 0-160 0zm-48 0c0-70.7 57.3-128 128-128 62.5 0 114.5 44.8 125.8 104H336v-48c0-13.3 10.7-24 24-24s24 10.7 24 24v48h48v-48c0-13.3 10.7-24 24-24s24 10.7 24 24v72c0 13.3-10.7 24-24 24H253.8c-11.3 59.2-63.3 104-125.8 104C57.3 512 0 454.7 0 384z"
        }
    ]
};

const FarKeySkeleton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKeySkeleton",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 48a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240c79.5 0 144-64.5 144-144S383.5 0 304 0 160 64.5 160 144c0 31.1 9.9 59.9 26.6 83.4L7 407c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L88 393.9l47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 98.6-98.6c23.6 16.7 52.4 26.6 83.5 26.6z"
        }
    ]
};

const FarKey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKey",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 176c0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128c-10.4 0-20.5-1.2-30.1-3.6-8.1-2-16.7.4-22.6 6.4L254.1 336H200c-13.3 0-24 10.7-24 24v40h-40c-13.3 0-24 10.7-24 24v40H48v-78.1l157.2-157.2c5.9-5.9 8.3-14.5 6.4-22.6-2.3-9.6-3.6-19.7-3.6-30.1zM336 0c-97.2 0-176 78.8-176 176 0 9.5.7 18.8 2.2 27.9L7 359c-4.5 4.5-7 10.6-7 17v112c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24v-40h40c6.4 0 12.5-2.5 17-7l27.2-27.2c9.1 1.4 18.4 2.2 27.9 2.2 97.2 0 176-78.8 176-176S433.2 0 336 0zm32 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarKeyboardBrightnessLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKeyboardBrightnessLow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-416-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm88-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
        }
    ]
};

const FarKeyboardBrightness = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKeyboardBrightness",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M129 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80zm167 33c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v112zm135 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-80 80zM0 392c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm216-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H216zm320 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80z"
        }
    ]
};

const FarKeyboardDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKeyboardDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v176c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm159 295c9.4-9.4 24.6-9.4 33.9 0l95 95 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L305 505c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7L159 393c-9.4-9.4-9.4-24.6 0-33.9zm1-167c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-16zM120 88h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm96-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm96-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarKeyboardLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKeyboardLeft",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 112c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h352zM224 64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H224zm80 272v16c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm48-104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zm-104 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm16-96c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zm72 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm96-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zm72 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm16 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zm-104 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm-295-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-63-63 63-63z"
        }
    ]
};

const FarKeyboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKeyboard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm176 192h224c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarKeynote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKeynote",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M198.4 72H184c-22.1 0-40 17.9-40 40v48h278.3c16.1 0 31 8 39.9 21.4l41.7 62.5c5.3 7.9 8.1 17.1 8.1 26.6V320c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-49.5c0-9.5 2.8-18.7 8.1-26.6l41.7-62.5C58.7 168 73.6 160 89.7 160H96v-48c0-48.6 39.4-88 88-88h14.4C206.7 9.7 222.2 0 240 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48h-64c-17.8 0-33.3-9.7-41.6-24zM48 304h416v-33.5L422.3 208H89.7L48 270.5V304zm80 184c0-13.3 10.7-24 24-24h80v-80h48v80h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarKhanda = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKhanda",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l-.1.1-.3.6c-.3.5-.7 1.3-1.2 2.3-1 2-2.6 5-4.4 8.6-.5.9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9 1.8 3.7 3.3 6.6 4.4 8.6.5 1 .9 1.8 1.2 2.3l.3.6.1.1c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5h.1l41.1-28.2C420.9 261 435 159.5 387.9 88.9c-4-6-3.5-14 1.3-19.5s12.8-6.9 19.3-3.6c58.5 30 104.7 91.3 104.7 158.2 0 53.1-26.4 100.5-51.2 133.6-14.8 19.7-31.7 38.7-50.6 54.7-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7 13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7v-28.2l-40.3 27.7c-1.9 11.5-11.8 20.2-23.7 20.2-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4.3 6.5.9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6-19-15.9-35.8-35-50.6-54.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3 15.4-15.4 32.7-29.2 52.2-39 6.5-3.2 14.3-1.7 19.2 3.7 6.9 7.8 3.4 16.3-1.5 23.7-46.5 69.5-27.6 169.8 41.8 217.5l41.1 28.2h.1l34.4 23.8v-19.1l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l.1-.1.3-.6c.3-.5.7-1.3 1.2-2.3 1-2 2.6-5 4.4-8.6.5-.9.9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9-1.8-3.7-3.3-6.6-4.4-8.6-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1c-3.6-6.7-2-15 3.8-19.9l48-40zm-25.6 119.2c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1zM57.3 163C47 180.1 40 200.4 40 224c0 40.4 20.4 79.2 43.2 109.6 10 13.4 20.7 25.9 32 37l36-20.5-9.5-6.5C81.5 302.2 51.5 231.7 57.3 163zm372.6 170.6c22.8-30.4 43.2-69.2 43.2-109.6 0-24.3-7.4-45.1-18.2-62.5 6.7 68.5-20.8 138.9-83.6 182l-9.5 6.5 35.9 20.4c11.4-11.1 22.1-23.6 32.1-36.9z"
        }
    ]
};

const FarKidneys = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKidneys",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M165.8 0c-24 0-52.6 6.6-76.2 27.3C58.2 54.8 0 119.5 0 221.2c0 23 3.2 49.4 6.4 70.3 8.9 57.7 59.1 95.9 113.3 95.9 69.6 0 123.8-60.3 116.4-129.5l-.5-5.1 15.9 7.9c2.7 1.4 4.4 4.1 4.4 7.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-21.2-12-40.6-31-50.1l-31-15.5 16.4-17.4c18.7-19.8 29.1-46 29.1-73.3 0-36.7-18.9-70.9-50-90.4l-4.9-3.1-12.7 20.2L232.5 18C213.8 6.2 192.1 0 170 0h-4.2zm-44.6 63.4C133.8 52.4 150 48 165.8 48h4.2c13.1 0 25.9 3.7 37 10.6l5.2 3.2c17.1 10.7 27.5 29.5 27.5 49.7 0 15-5.7 29.4-16 40.3l-16.9 17.8c-16.1 17-23.9 40.2-21.4 63.4l3.2 29.8c4.3 40.8-27.7 76.4-68.7 76.4-32.4 0-60.9-22.6-65.9-55.1-3.1-20.2-5.9-43.7-5.9-63 0-82 46.8-134.6 73.2-157.8zm310.7-4.8c11.1-6.9 23.9-10.6 37-10.6h4.2c15.8 0 32 4.4 44.6 15.4 26.4 23.2 73.2 75.8 73.2 157.8 0 19.3-2.8 42.7-5.9 63-5 32.5-33.5 55.1-65.9 55.1-41.1 0-73.1-35.6-68.7-76.4l3.2-29.8c2.5-23.3-5.4-46.4-21.4-63.4l-16.9-17.8c-10.3-10.9-16-25.3-16-40.3 0-20.2 10.4-39 27.5-49.7l5.2-3.2zm37-58.6c-22.1 0-43.8 6.2-62.5 18l-5.2 3.2c-31.1 19.5-50 53.6-50 90.4 0 27.2 10.4 53.5 29.1 73.3l16.8 17.7-30.1 15.1c-19 9.5-31 28.9-31 50.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-3 1.7-5.8 4.4-7.2l14.8-7.4-.5 4.6c-7.4 69.2 46.9 129.5 116.4 129.5 54.3 0 104.5-38.1 113.3-95.9 3.2-20.9 6.4-47.3 6.4-70.3 0-101.7-58.2-166.3-89.6-193.9-23.4-20.6-52-27.2-76-27.2H469z"
        }
    ]
};

const FarKipSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKipSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 32c13.3 0 24 10.7 24 24v154.5L312.3 37.8c10-8.7 25.2-7.5 33.8 2.5s7.5 25.2-2.5 33.8L160.6 232H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H160.6l183.1 157.8c10 8.7 11.2 23.8 2.5 33.8s-23.8 11.2-33.8 2.5L112 301.5V457c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V56c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarKitMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKitMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 432h288V80H144v352zm-48 0V80H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h32zM64 32h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zm416 400h32c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16h-32v352zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FarKitchenSet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKitchenSet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 144a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm46 24c-11.4 68.1-70.7 120-142 120C64.5 288 0 223.5 0 144S64.5 0 144 0c71.4 0 130.6 51.9 142 120h66.7c3.8-22.7 23.6-40 47.3-40h96c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48h-96c-23.8 0-43.5-17.3-47.3-40H286zM80 144a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm296 120c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v144c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V320h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8zm-40 56v144h128V320H336zM32 336c0-8.8 7.2-16 16-16h128c26.5 0 48 21.5 48 48s-21.5 48-48 48h-16c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-80zm128 48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v32zM0 488c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm400-360v32h96v-32h-96z"
        }
    ]
};

const FarKite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKite",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 48h216c2.2 0 4.2.9 5.7 2.3L480 160l112 112v6.3c0 3.7-2.6 7-6.3 7.8l-295.9 65.8c-.3-.3-.5-.6-.8-.9l191-191L368 48zm-61-4.1L234.1 372l-87.5 87.5c-2.9 2.9-6.9 4.6-11 4.6-8.6 0-15.6-7-15.6-15.6v-88.7l-24-12-24 12v88.6c0 35.1 28.5 63.6 63.6 63.6 16.9 0 33-6.7 45-18.6l87.4-87.5L596.1 333c25.6-5.7 43.9-28.4 43.9-54.7V56c0-30.9-25.1-56-56-56H361.7c-26.2 0-49 18.2-54.7 43.9zM0 152c0 13.3 10.7 24 24 24h8c22.1 0 40 17.9 40 40v68l-53.3-26.6c-1.8-.9-3.8-1.4-5.8-1.4C5.8 256 0 261.8 0 268.9V339c0 7.2 5.8 13 12.9 13 2 0 4-.5 5.8-1.4L72 324l9.7-4.8c4.5-2.3 9.4-3.4 14.3-3.4h.5c3.5.1 7 .7 10.4 1.9 1.2.4 2.3.9 3.4 1.5l9.7 4.8 53.3 26.6c1.8.9 3.8 1.4 5.8 1.4 7.1 0 12.9-5.8 12.9-12.9v-70.2c0-7.1-5.8-12.9-12.9-12.9-2 0-4 .5-5.8 1.4L120 284v-68c0-48.6-39.4-88-88-88h-8c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarKiwiBird = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKiwiBird",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M266.4 347.3c31.2-18.9 74.9-43.3 125.9-43.3H448c44.2 0 80-35.8 80-80s-35.8-80-80-80h-55.7c-51 0-94.7-24.4-125.9-43.3C244.7 87.6 219.3 80 192 80c-79.5 0-144 64.5-144 144s64.5 144 144 144c27.3 0 52.7-7.6 74.4-20.7zm125.9 4.7c-36.4 0-69.9 17.6-101.1 36.4-11.1 6.7-22.9 12.3-35.2 16.7V456c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40.7c-5.3.4-10.6.7-16 .7-16.6 0-32.7-2.1-48-6v46c0 13.3-10.7 24-24 24s-24-10.7-24-24v-65.7C38.6 357.1 0 295.1 0 224 0 118 86 32 192 32c36.3 0 70.3 10.1 99.2 27.6C322.4 78.4 355.9 96 392.3 96H448c70.7 0 128 57.3 128 128v240c0 7.3-4.9 13.7-12 15.5s-14.5-1.3-18-7.7l-68.4-123.2c-9.5 2.2-19.4 3.4-29.6 3.4h-55.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarKiwiFruit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKiwiFruit",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M399.8 265.3C358.7 298.6 295.3 320 224 320S89.3 298.6 48.2 265.3C53.1 358.2 129.9 432 224 432s170.9-73.8 175.8-166.7zM448 176v80c0 123.7-100.3 224-224 224S0 379.7 0 256v-80C0 96.5 100.3 32 224 32s224 64.5 224 144zM224 64c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zM64 176c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm256 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm-96 56c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-24c0-8.8-7.2-16-16-16zM139.3 92.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm192 0c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-176 150.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24 25.1 24 56 24 56-10.7 56-24z"
        }
    ]
};

const FarKnifeKitchen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKnifeKitchen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M488 0c-9.4 0-18.3 3.7-25 10.3L284.6 188.7l11.3 11.3 104.4 104.4 31-17.2c15.2-8.5 24.7-24.5 24.7-42v-31.9c0-4.2 1.7-8.3 4.7-11.3l97-97c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L513 10.3C506.3 3.7 497.4 0 488 0zm-56 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-48a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM4.7 468.7c-8.4 8.4-4.7 22.9 6.5 26.6C43.4 505.7 78.1 512 112 512c123.3 0 209.4-62.8 287.3-140.7 6.2-6.2 6.2-16.4 0-22.6l-23-23-33.9 33.9C275 422.2 205.5 464 112 464c-10.7 0-21.6-.8-32.6-2.2L262 279.3l33.9-33.9-33.9-34-33.9 33.9L4.7 468.7z"
        }
    ]
};

const FarKnife = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarKnife",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M451.4 10.8C458.1 3.9 467.2 0 476.8 0 496.2 0 512 15.8 512 35.2v48.4c0 65.5-25.9 128.4-72.1 174.9l-70.2 70.6c-31.2 31.4-82 31.5-113.3.2L233.1 306 41.3 504.7c-9.2 9.5-24.4 9.8-33.9.6s-9.8-24.4-.6-33.9l208.7-216.3L451.4 10.8zm-185 260.7 23.8 23.8c12.5 12.5 32.8 12.5 45.3-.1l70.2-70.6c37.3-37.5 58.2-88.2 58.2-141V66.8L266.4 271.5z"
        }
    ]
};

const FarL = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarL",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32c13.3 0 24 10.7 24 24v376h216c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarLacrosseStickBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLacrosseStickBall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 48h.3c22.9 0 53 15.2 78.8 40.9s40.9 55.9 40.9 78.8v.3c0 37.4-24 70.7-59.5 82.5l-19.7 6.6c-18.9 6.3-36.5 16-51.9 28.6l-42 34.4c-12.6 10.3-28.3 15.9-44.5 15.9-38.8 0-70.3-31.5-70.3-70.3 0-16.2 5.6-32 15.9-44.5l34.4-42c12.6-15.4 22.3-33 28.6-51.9l6.6-19.7C273.3 72 306.6 48 344 48zm0-48c-58.1 0-109.7 37.2-128.1 92.3l-6.5 19.7c-4.5 13.4-11.3 25.8-20.2 36.7l-34.4 42c-17.3 21.1-26.7 47.6-26.7 74.9 0 24 7.1 46.3 19.4 65L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l140.5-140.3c18.6 12.3 41 19.4 65 19.4 27.3 0 53.8-9.4 74.9-26.7l42-34.4c10.9-8.9 23.3-15.8 36.7-20.2l19.7-6.6c55.1-18.4 92.3-70 92.3-128.1v-.3c0-40.8-24.8-82.5-55-112.7S385.1 0 344.3 0h-.3zm120 432a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FarLacrosseStick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLacrosseStick",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m261.5 107.5-6.6 19.7c-6.3 18.9-16 36.5-28.6 51.9l-34.4 42c-10.3 12.6-15.9 28.3-15.9 44.5 0 38.8 31.5 70.3 70.3 70.3 16.2 0 32-5.6 44.5-15.9l42-34.4c15.4-12.6 33-22.3 51.9-28.6l19.7-6.6c35.6-11.7 59.6-45 59.6-82.4v-.3c0-22.9-15.2-53-40.9-78.8S367.2 48 344.3 48h-.3c-37.4 0-70.7 24-82.5 59.5zM344 0h.3c40.8 0 82.5 24.8 112.7 55s55 71.9 55 112.7v.3c0 58.1-37.2 109.7-92.3 128.1l-19.7 6.5c-13.4 4.5-25.8 11.3-36.7 20.2l-42 34.4c-21.1 17.3-47.6 26.7-74.9 26.7-24 0-46.3-7.1-65-19.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l140.3-140.5c-12.3-18.6-19.4-41-19.4-65 0-27.3 9.5-53.8 26.7-74.9l34.4-42c8.9-10.9 15.8-23.3 20.2-36.7l6.6-19.7C234.3 37.2 285.9 0 344 0z"
        }
    ]
};

const FarLambda = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLambda",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h108.6c3 0 5.7 1.7 7.1 4.3l10.2 19.6L2 446.5c-5.3 12.2.4 26.3 12.5 31.5s26.3-.3 31.5-12.5l132.4-306.6 151.3 291c9.6 18.5 28.8 30.2 49.7 30.2H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-44.6c-3 0-5.7-1.7-7.1-4.3l-190-365.6C172.6 43.6 153.5 32 132.6 32H24z"
        }
    ]
};

const FarLampDesk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLampDesk",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m347.3 97.9-38-38c-7.7-7.6-18-11.9-28.7-11.9-22.4 0-40.6 18.2-40.6 40.6 0 10.8 4.3 21.1 11.9 28.7l38.1 38.1c9 9 14.1 21.2 14.1 33.9v60.1L441.4 112h-60.1c-12.7 0-24.9-5.1-33.9-14.1zm-4.1-72L381.3 64H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-73.5 73.5-45.1 45.1-73.5 73.5c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6v-98.8l-13.7-13.7c-.6.7-1.3 1.4-2 2.1l-93.1 86L204.4 464H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h130.5L96.9 262.6c-2.5-8.7.1-18.1 6.8-24.2l104-96c.5-.5 1-.9 1.5-1.3A88.696 88.696 0 0 1 192 88.6C192 39.7 231.7 0 280.6 0c23.5 0 46 9.3 62.6 25.9zM432 288c-14.7 0-27.8-6.6-36.6-16.9l67.7-67.7c10.3 8.8 16.9 21.9 16.9 36.6 0 26.5-21.5 48-48 48z"
        }
    ]
};

const FarLampFloor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLampFloor",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.6 176h272.8L405.2 48H234.8l-51.2 128zm10.7-155.9C199.1 8 210.9 0 224 0h192c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8S490.6 224 480 224H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM216 464h80V256h48v208h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarLampStreet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLampStreet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 172c0-68.5 55.5-124 124-124 65 0 118.3 50 123.6 113.5-84 10.7-151.1 75.6-164.9 158.6-3 17.5 11.6 31.9 29.3 31.9h320c17.7 0 32.3-14.4 29.4-31.9-13.9-83.2-81.4-148.3-165.7-158.7C338.2 71.4 263.4 0 172 0 77 0 0 77 0 172v316c0 13.3 10.7 24 24 24s24-10.7 24-24V172zm407.8 132H184.2c19.8-55.9 73.1-96 135.8-96s116.1 40.1 135.8 96zM320 448c35.3 0 64-28.7 64-64H256c0 35.3 28.7 64 64 64z"
        }
    ]
};

const FarLamp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLamp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m2.5 211.7 80-192C87.4 7.8 99.1 0 112 0h224c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1S426.7 256 416 256H32c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1zM56 208h336L325.3 48H122.7L56 208zm88 105.4V288h48v25.4c0 17-6.7 32-16.2 42.9C165.7 368 144 398.1 144 432c0 12.2 3.7 23.1 8.4 31.9.6.1 1.3.1 2.1.1h139c.8 0 1.5-.1 2.1-.1 4.6-8.8 8.4-19.7 8.4-31.9 0-32.3-22.1-63.8-32.6-76.4-9.2-10.9-15.4-25.6-15.4-42V288h48v25.6c0 4.1 1.6 8 4.2 11.2 11.7 14 43.8 56.9 43.8 107.2 0 24.4-8.3 44.6-16.4 58.7-8.5 14.7-25.2 21.3-42.1 21.3h-139c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-51.9 31.6-93.4 43.5-107.1 2.8-3.2 4.5-7.3 4.5-11.5z"
        }
    ]
};

const FarLandMineOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLandMineOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 336c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v16h31.5c19.6 0 37.3 11.9 44.6 30.2l34.4 85.9c8.4 21-7.1 43.9-29.7 43.9H111.3c-22.6 0-38.1-22.9-29.7-43.9l34.4-85.9c7.3-18.2 24.9-30.2 44.6-30.2H192v-16zm313.1 128-25.6-64h-319l-25.6 64h370.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
        }
    ]
};

const FarLandmarkDome = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLandmarkDome",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c13.3 0 24 10.7 24 24v9.5c89.5 11.1 159.9 83.9 167.3 174.5h8.7c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h8.7C72.1 117.4 142.5 44.6 232 33.5V24c0-13.3 10.7-24 24-24zM112.9 208h286.2c-8-72-69-128-143.1-128s-135.2 56-143.1 128zm-.9 80v96h64v-96h48v96h64v-96h48v96h64v-96h48v96h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H64c-13.3 0-24-10.7-24-24s10.7-24 24-24v-96h48zM8 488c0-13.3 10.7-24 24-24h456c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarLandmarkFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLandmarkFlag",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 0h-16c-8.8 0-16 7.2-16 16v112H48c-13.3 0-24 10.7-24 24s10.7 24 24 24h416c13.3 0 24-10.7 24-24s-10.7-24-24-24H272V96h80c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80zM112 208H64v176h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V208h-48v176h-64V208h-48v176h-64V208h-48v176h-64V208zM0 488c0 13.3 10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarLandmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLandmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9 0 176.8 15.2 192 34.1 192h443.8c18.8 0 34.1-15.2 34.1-34.1 0-12.4-6.7-23.8-17.6-29.8L267.6 3zM256 51.4 423.8 144H88.2L256 51.4zM112 224H64v160h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V224h-48v160h-64V224h-48v160h-64V224h-48v160h-64V224zM0 488c0 13.3 10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarLanguage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLanguage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 48c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H320V112h256zm-397.7 63.9 64 144c4.5 10.1-.1 21.9-10.2 26.4s-21.9-.1-26.4-10.2l-8.9-20.1h-73.6l-8.9 20.1c-4.5 10.1-16.3 14.6-26.4 10.2S73.3 330 77.7 319.9l64-144c3.2-7.2 10.4-11.9 18.3-11.9s15.1 4.7 18.3 11.9zM179 276l-19-42.8-19 42.8h38zm277-112c-11 0-20 9-20 20v4h-52c-11 0-20 9-20 20s9 20 20 20h107.1c-7.3 16.7-17.4 31.9-29.8 45l-.5-.5-14.6-14.6c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l12.1 12.1c-5.9 3.6-12.1 6.9-18.5 9.8l-3.6 1.6c-10.1 4.5-14.6 16.3-10.2 26.4s16.3 14.6 26.4 10.2l3.6-1.6c12-5.3 23.4-11.8 34-19.4 4.3 3 8.6 5.8 13.1 8.5l18.9 11.3c9.5 5.7 21.8 2.6 27.4-6.9s2.6-21.8-6.9-27.4l-18.9-11.3c-.9-.5-1.8-1.1-2.7-1.6 17.2-18.8 30.7-40.9 39.6-65.4l1.8-4.5h2c11 0 20-9 20-20s-9-20-20-20h-60v-4c0-11-9-20-20-20z"
        }
    ]
};

const FarLaptopArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLaptopArrowDown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32v48H128c-8.8 0-16 7.2-16 16v224H64V96c0-35.3 28.7-64 64-64h128zm128 48V32h128c35.3 0 64 28.7 64 64v224h-48V96c0-8.8-7.2-16-16-16H384zm-64-48c13.3 0 24 10.7 24 24v182.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V56c0-13.3 10.7-24 24-24zM96 432h448c20.9 0 38.7-13.4 45.3-32H50.7c6.6 18.6 24.4 32 45.3 32zM0 384c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32 0 53-43 96-96 96H96c-53 0-96-43-96-96z"
        }
    ]
};

const FarLaptopBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLaptopBinary",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 80h384c8.8 0 16 7.2 16 16v224h48V96c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v224h48V96c0-8.8 7.2-16 16-16zM50.7 400h538.6c-6.6 18.6-24.4 32-45.3 32H96c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32 0 53 43 96 96 96h448c53 0 96-43 96-96 0-17.7-14.3-32-32-32H32zm168-224c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-32c0-22.1-17.9-40-40-40h-16zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-32zm112-40c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16h-16zm80 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-32c0-22.1-17.9-40-40-40h-16c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8zM192 272c-8.8 0-16 7.2-16 16s7.2 16 16 16v16h32v-32c0-8.8-7.2-16-16-16h-16zm240 0h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16v16h32v-32c0-8.8-7.2-16-16-16zm-64 40c0-22.1-17.9-40-40-40h-16c-22.1 0-40 17.9-40 40v8h32v-8c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v8h32v-8z"
        }
    ]
};

const FarLaptopCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLaptopCode",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 80h384c8.8 0 16 7.2 16 16v224h48V96c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v224h48V96c0-8.8 7.2-16 16-16zM50.7 400h538.6c-6.6 18.6-24.4 32-45.3 32H96c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32 0 53 43 96 96 96h448c53 0 96-43 96-96 0-17.7-14.3-32-32-32H32zm249-175c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zm112-34c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"
        }
    ]
};

const FarLaptopFile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLaptopFile",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 48H128c-8.8 0-16 7.2-16 16v256h208v64H48c-26.5 0-48-21.5-48-48 0-8.8 7.2-16 16-16h48V64c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v32h-48V64c0-8.8-7.2-16-16-16zm-48 416h192V256h-48c-17.7 0-32-14.3-32-32v-48H400v288zm192 48H400c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h124.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5-21.5 48-48 48z"
        }
    ]
};

const FarLaptopMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLaptopMedical",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 80h384c8.8 0 16 7.2 16 16v224h48V96c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v224h48V96c0-8.8 7.2-16 16-16zM50.7 400h538.6c-6.6 18.6-24.4 32-45.3 32H96c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32 0 53 43 96 96 96h448c53 0 96-43 96-96 0-17.7-14.3-32-32-32H32zm256-208v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarLaptopMobile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLaptopMobile",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48h320c8.8 0 16 7.2 16 16v32h48V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v256H16c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h304v-64H112V64c0-8.8 7.2-16 16-16zm256 128v288c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48zm48 0h160v288H432V176z"
        }
    ]
};

const FarLaptopSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLaptopSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-20.3-15.9c18.2-17.5 29.5-42 29.5-69.2 0-17.7-14.3-32-32-32H481.4l-347-272H512c8.8 0 16 7.2 16 16v224h48V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM542.6 400h46.6c-3.3 9.3-9.4 17.3-17.3 23l-29.4-23zm-116.3 32H96c-20.9 0-38.7-13.4-45.3-32h335l-60.9-48H32c-17.7 0-32 14.3-32 32 0 53 43 96 96 96h391.2l-60.9-48zM112 184.4l-48-37.8V320h48V184.4z"
        }
    ]
};

const FarLaptop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLaptop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80H128c-8.8 0-16 7.2-16 16v224H64V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v224h-48V96c0-8.8-7.2-16-16-16zM96 432h448c20.9 0 38.7-13.4 45.3-32H50.7c6.6 18.6 24.4 32 45.3 32zM0 384c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32 0 53-43 96-96 96H96c-53 0-96-43-96-96z"
        }
    ]
};

const FarLariSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLariSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32c13.3 0 24 10.7 24 24v41.5c7.9-1 15.9-1.5 24-1.5s16.1.5 24 1.5V56c0-13.3 10.7-24 24-24s24 10.7 24 24v54c58.9 23.8 103.2 76 116.2 139.7 2.6 13-5.8 25.7-18.7 28.3s-25.7-5.8-28.3-18.7c-8.3-41-34-75.6-69.1-95.9V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V146c-7.8-1.3-15.8-2-24-2s-16.2.7-24 2v118c0 13.3-10.7 24-24 24s-24-10.7-24-24V163.3C77 188.2 48 234.7 48 288c0 79.5 64.5 144 144 144h168c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h41C25.1 396.8 0 345.3 0 288c0-80.6 49.6-149.6 120-178V56c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarLassoSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLassoSparkles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M290.7 0H288C128.9 0 0 78.8 0 176c0 60.6 50.2 114.1 126.6 145.8l44.3 20.5c22.6 10.4 37.1 33 37.1 57.9 0 35.2-28.6 63.8-63.8 63.8H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h88.2c61.7 0 111.8-50.1 111.8-111.8 0-17.8-4.2-34.9-11.9-50.2 14.3 1.3 29 2 43.9 2 159.1 0 288-78.8 288-176 0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80v.6c49.1 23.4 80 57.5 80 95.4 0 70.7-107.5 128-240 128S48 246.7 48 176c0-60.7 79.2-111.5 185.5-124.7 5.4-7.3 12.9-13 21.8-16.3l26-9.6L290.7 0zM351 10.4C348.7 4.2 342.7 0 336 0s-12.7 4.2-15 10.4l-14.7 39.9L266.4 65c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7 14.8 39.9c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L405.6 95c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.9-14.7L351 10.4zM496 352c-6.7 0-12.7 4.2-15 10.4l-14.7 39.8-39.9 14.8c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7 14.8 39.9c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8 39.9-14.8c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.8-14.7-14.8-39.9c-2.3-6.3-8.3-10.4-15-10.4z"
        }
    ]
};

const FarLasso = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLasso",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 176c0 97.2-128.9 176-288 176-14.9 0-29.6-.7-43.9-2 7.7 15.3 11.9 32.4 11.9 50.2 0 61.7-50.1 111.8-111.8 111.8H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h88.2c35.2 0 63.8-28.6 63.8-63.8 0-24.9-14.5-47.5-37.1-57.9l-44.3-20.5C50.2 290.1 0 236.6 0 176 0 78.8 128.9 0 288 0s288 78.8 288 176zM288 304c132.5 0 240-57.3 240-128S420.5 48 288 48 48 105.3 48 176s107.5 128 240 128z"
        }
    ]
};

const FarLayerGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLayerGroup",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2c1.9-.8 3.9-1.2 5.9-1.2s4 .4 5.9 1.2L477.7 128l-183.8 78.8c-1.9.8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128l183.8-78.8zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4-60.9 26.1 47.7 20.5-183.8 78.8c-1.9.8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256l47.7-20.5-60.9-26.1-31.2 13.4zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4-60.9 26.1 47.7 20.5-183.8 78.8c-1.9.8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384l47.7-20.5-60.9-26.1-31.2 13.4z"
        }
    ]
};

const FarLayerMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLayerMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 60h112c11 0 20 9 20 20s-9 20-20 20H408c-11 0-20-9-20-20s9-20 20-20zm-144.8 73.1c7.8-3.4 16.3-5.1 24.8-5.1s17 1.7 24.8 5.1l209.3 89.7c13.3 5.7 21.9 18.8 21.9 33.2s-8.6 27.5-21.9 33.2l-209.3 89.7c-7.8 3.4-16.3 5.1-24.8 5.1s-17-1.7-24.8-5.1L53.9 289.2C40.6 283.5 32 270.5 32 256s8.6-27.5 21.9-33.2l209.3-89.7zM288 176c-2 0-4 .4-5.9 1.2L98.3 256l183.8 78.8c1.9.8 3.9 1.2 5.9 1.2s4-.4 5.9-1.2L477.7 256l-183.8-78.8c-1.9-.8-3.9-1.2-5.9-1.2zM53.9 350.8l31.2-13.4 60.9 26.1L98.3 384l183.8 78.8c1.9.8 3.9 1.2 5.9 1.2s4-.4 5.9-1.2L477.7 384 430 363.5l60.9-26.1 31.2 13.4c13.3 5.7 21.9 18.8 21.9 33.2s-8.6 27.5-21.9 33.2l-209.3 89.7c-7.8 3.4-16.3 5.1-24.8 5.1s-17-1.7-24.8-5.1L53.9 417.2C40.6 411.5 32 398.5 32 384s8.6-27.5 21.9-33.2z"
        }
    ]
};

const FarLayerPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLayerPlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 4c-11 0-20 9-20 20v36h-36c-11 0-20 9-20 20s9 20 20 20h36v36c0 11 9 20 20 20s20-9 20-20v-36h36c11 0 20-9 20-20s-9-20-20-20h-36V24c0-11-9-20-20-20zM288 128c-8.5 0-17 1.7-24.8 5.1L53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-209.3-89.7c-7.8-3.4-16.3-5.1-24.8-5.1zm-5.9 49.2c1.9-.8 3.9-1.2 5.9-1.2s4 .4 5.9 1.2L477.7 256l-183.8 78.8c-1.9.8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256l183.8-78.8zm-197 160.2-31.2 13.4C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4-60.9 26.1 47.7 20.5-183.8 78.8c-1.9.8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384l47.7-20.5-60.9-26.1z"
        }
    ]
};

const FarLeafHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeafHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 144h104c31.6 0 61-9.1 85.7-24.9 1.5 12.2 2.3 24.7 2.3 37.5 0 143.2-93.8 242.9-191.2 243.4h-1C201.3 400 144 342.7 144 272s57.3-128 128-128zm178.6-76.5C430.8 85.2 404.7 96 376 96H272c-93.2 0-169.5 72.5-175.6 164.1C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16c0-48.6 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448h1c132.1-.7 239-130.9 239-291.4 0-26.4-2.9-51.9-8.3-76.2-.4-1.9-.9-3.8-1.3-5.6-2.2-9.3-4.8-18.3-7.8-27.2-1.2-3.6-2.4-7.1-3.7-10.6-2.6-6.9-12.7-6.6-16.2-.1-1.4 2.7-3 5.3-4.6 7.8-4.9 7.7-10.8 14.7-17.4 20.9-.7.7-1.4 1.3-2.1 1.9zM189.7 242.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4 0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z"
        }
    ]
};

const FarLeafMaple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeafMaple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344.8 13.3C341.1 5.9 333.8.9 325.5.1s-16.4 2.8-21.4 9.5L249.9 82l-2.1-16.1c-.9-7-4.8-13.2-10.7-17.1s-13.2-4.9-19.9-2.9l-35.4 10.5L147 15.9c-4.6-5.3-11.2-8.4-18.2-8.4s-13.7 3.1-18.2 8.4L74 58.5l-47-5.9c-7.9-1-15.8 2-21 8S-1.2 74.7.8 82.4L41.4 238l-30.7 20.5c-7 4.6-11 12.6-10.7 20.9s5 15.9 12.3 20l106.9 59.4L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l112.3-112.1 59.4 106.9c4.1 7.3 11.6 12 20 12.3s16.3-3.7 20.9-10.7l20.5-30.7 155.6 40.6c7.7 2 15.9.1 21.9-5.2s9-13.1 8-21l-5.4-42.8c-.3-2.7.7-5.3 2.7-7.1l39.3-33.7c5.3-4.6 8.4-11.2 8.4-18.2s-3.1-13.7-8.4-18.2l-40.6-34.8 10.5-35.4c2-6.8.9-14-2.9-19.9s-10.1-9.8-17.1-10.7l-16-2.1 72.4-54.3c6.7-5 10.2-13.1 9.5-21.4s-5.7-15.6-13.2-19.3L462.6 149c-3.4-1.7-5.2-5.7-4.1-9.4l22.6-79.2c2.4-8.4.1-17.4-6.1-23.6s-15.2-8.5-23.6-6.1l-79.2 22.8c-3.7 1.1-7.6-.7-9.4-4.1l-18-36.1zM188.5 357.5l125.4-125.4c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L154.5 323.5l-84.4-46.9 2.7-1.8c14.2-9.5 20.8-26.9 16.5-43.4L56.2 104.6l24.7 3.1c8 1 16-2.1 21.2-8.2l26.7-31.1 26.7 31.1c6.2 7.2 16 10.1 25.1 7.4l23.2-6.9 6 46.8c1.2 9.7 8.2 17.7 17.7 20.2s19.5-1 25.3-8.8l66.5-88.7.7 1.4c12 24.1 39.5 36.2 65.4 28.8l37.7-10.8-10.8 37.7c-7.4 25.9 4.7 53.4 28.8 65.5l1.4.7-88.7 66.5c-7.8 5.9-11.3 15.9-8.8 25.3s10.5 16.4 20.2 17.7l46.8 6-6.9 23.2c-2.7 9.1.2 18.9 7.4 25.1l31.1 26.7-18.1 15.5a55.723 55.723 0 0 0-19.1 49.5l1 7.7-126.8-33.2c-16.5-4.3-33.9 2.3-43.4 16.5l-1.8 2.7-46.9-84.5z"
        }
    ]
};

const FarLeafOak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeafOak",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M302 0c-33.4 0-62.4 22.7-70.5 55.1l-1.9 7.5c-25.2-23.7-64.8-23.2-89.4 1.4-14.3 14.3-21 34.5-18.2 54.6l5.4 37.6c-20.5-2-41.6 5-57 20.4l-3.2 3.2c-23.2 23.2-29 58.7-14.3 88.1l12.4 24.7c7.2 14.4 11 30.4 11 46.5v62.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72.4-72.4h56.3c16.1 0 32.1 3.8 46.5 11l24.7 12.4c29.4 14.7 64.9 8.9 88.1-14.3l3.2-3.2c15.4-15.4 22.4-36.5 20.4-57l37.6 5.4c20 2.9 40.2-3.9 54.6-18.2 24.6-24.6 25.1-64.2 1.4-89.4l7.5-1.9c32.4-8.1 55.1-37.2 55.1-70.5 0-24.3-12.2-47-32.4-60.5l-7-4.6 2.8-11.3c6.6-26.4-1.1-54.3-20.3-73.5S404.7 30 378.3 36.5L367 39.3l-4.6-7C349 12.1 326.3 0 302 0zM161.3 384.6l152.6-152.5c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L124.1 353.9v-14.8c0-23.6-5.5-46.9-16-68l-12.4-24.7c-5.4-10.9-3.3-24.1 5.3-32.7l3.2-3.2c7.7-7.7 19.7-8.8 28.7-2.8 21.5 14.3 49.7-3.5 46.1-29l-9.5-66.8c-.7-5.1 1-10.2 4.6-13.8 6.4-6.4 16.7-6.4 23 0l18.5 18.5c17.6 17.6 47.6 9.3 53.7-14.9l8.7-35c2.7-11 12.6-18.7 24-18.7 8.3 0 16 4.1 20.6 11l7.8 11.7c9.4 14.1 26.6 20.7 43 16.6l16.6-4.2c10-2.5 20.6.4 27.9 7.7s10.2 17.9 7.7 27.9l-4.2 16.7c-4.1 16.4 2.6 33.6 16.6 43l11.7 7.8c6.9 4.6 11 12.3 11 20.6 0 11.3-7.7 21.2-18.7 24l-34.9 8.7c-24.1 6-32.5 36.1-14.9 53.7l18.5 18.5c6.4 6.4 6.4 16.7 0 23-3.6 3.6-8.7 5.3-13.8 4.6l-66.8-9.5c-25.5-3.6-43.4 24.6-29 46.1 6 9 4.8 21-2.8 28.7l-3.2 3.2c-8.6 8.6-21.8 10.7-32.7 5.3l-24.7-12.4c-21.1-10.6-44.4-16-68-16h-8.3z"
        }
    ]
};

const FarLeaf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeaf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M149.6 234.4c20.9-6.7 43.2-10.4 66.4-10.4h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-25.4 0-49.5 5.6-71 15.7C152.7 351 206.6 400 271.9 400h1c97.3-.5 191.1-100.3 191.1-243.4 0-12.8-.8-25.3-2.3-37.5C437 134.9 407.6 144 376 144H272c-57.6 0-106.3 38.1-122.4 90.4zm-53.2 25.7C102.5 168.5 178.8 96 272 96h104c28.7 0 54.8-10.8 74.6-28.5.7-.6 1.4-1.3 2.1-1.9 6.6-6.2 12.5-13.2 17.4-20.9 1.6-2.5 3.2-5.1 4.6-7.8 3.5-6.5 13.6-6.8 16.2.1 1.3 3.5 2.5 7 3.7 10.6 2.9 8.9 5.5 17.9 7.8 27.2.5 1.9.9 3.8 1.3 5.6 5.4 24.3 8.3 49.8 8.3 76.2 0 160.5-106.9 290.7-239 291.4h-1c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.3 48 440v16c0 13.3-10.7 24-24 24S0 469.3 0 456v-16c0-75.1 38.3-141.2 96.4-179.9z"
        }
    ]
};

const FarLeafyGreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeafyGreen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M233.8 27C195.8-9.5 135.4-9 98 28.5c-6 5.9-11 12.3-15 19.2-13 21.9-32.4 42.2-52.1 58.2-2.3 1.8-4.4 3.8-6.5 5.9-25.8 25.8-31.2 64.4-15.9 95.4 5.7 11.7 11 24.1 11 37.1V280c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2v12.9c0 2.9.2 5.8.7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6v-45.6c0-25.5 10.1-49.9 28.1-67.9l10.5-10.5c6-6 9.4-14.1 9.4-22.6v-43c0-25.5 10.1-49.9 28.1-67.9l29.1-29.1c5-5 8.8-12.9 13.7-27 4.4-12.9 10.8-24.8 18.9-35.5zM526 128c-9.1 35.4-9.7 73.9-6.3 106.9.2 1.7.3 3.4.3 5.1 0 21-13.5 38.9-32.4 45.4-14.5 5-38.5 13.6-57.7 32.8l-29.1 29.1c-3 3-7.1 4.7-11.3 4.7h-43c-29.7 0-58.2 11.8-79.2 32.8l-10.5 10.5c-3 3-7.1 4.7-11.3 4.7h-35.6L313 297l41-41h86c13.3 0 24-10.7 24-24s-10.7-24-24-24h-38.1l71-71c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L327 215l-7 7v-38c0-13.3-10.7-24-24-24s-24 10.7-24 24v86.1l-96 96v-35.6c0-4.2 1.7-8.3 4.7-11.3l10.5-10.5c21-21 32.8-49.5 32.8-79.2v-43c0-4.2 1.7-8.3 4.7-11.3l29.1-29.1c19.2-19.2 27.8-43.2 32.8-57.7C297.1 69.5 315 56 336 56c1.7 0 3.5.1 5.1.3 33 3.5 71.4 2.8 106.9-6.3 5.1-1.3 10.4-2 16-2 35.3 0 64 28.7 64 64 0 5.6-.7 10.9-2 16zM105 505l38.2-38.2c12-12 28.3-18.7 45.3-18.7h57c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7h43c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3 37.6-13.2 64.7-49 64.7-91.1 0-3.4-.2-6.8-.5-10.1-3.1-29.1-2.3-61.5 5-89.9 2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5-28.4 7.3-60.8 8.1-89.9 5-3.3-.3-6.7-.5-10.1-.5-42.1 0-77.9 27.1-90.8 64.9-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3v43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3v57c0 17-6.7 33.3-18.7 45.3L71 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"
        }
    ]
};

const FarLeftFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeftFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 146.2 50 256l110 109.8V312c0-13.3 10.7-24 24-24h120v-64H184c-13.3 0-24-10.7-24-24v-53.8zM0 256c0-11.5 4.6-22.5 12.7-30.6l116.1-115.8c8.7-8.7 20.5-13.6 32.8-13.6 25.6 0 46.4 20.8 46.4 46.4V176h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-96v33.6c0 25.6-20.8 46.4-46.4 46.4-12.3 0-24.1-4.9-32.8-13.6L12.7 286.6C4.6 278.5 0 267.5 0 256zM400 88c0-13.3 10.7-24 24-24s24 10.7 24 24v336c0 13.3-10.7 24-24 24s-24-10.7-24-24V88z"
        }
    ]
};

const FarLeftLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeftLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88c0-13.3 10.7-24 24-24s24 10.7 24 24v336c0 13.3-10.7 24-24 24S0 437.3 0 424V88zm134.5 184.4c-8.7-9.2-8.7-23.7 0-32.9l121.4-129c8.8-9.3 21-14.6 33.7-14.6 25.6 0 46.3 20.7 46.3 46.3v33.7h248c30.9 0 56 25.1 56 56v48c0 30.9-25.1 56-56 56h-248v33.7c0 25.6-20.7 46.3-46.3 46.3-12.8 0-25-5.3-33.7-14.6l-121.4-129zM288 200v-53.5L185 256l103 109.5V312c0-13.3 10.7-24 24-24h272c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarLeftLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeftLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M6.5 272.4c-8.7-9.2-8.7-23.7 0-32.9l121.4-129c8.8-9.3 21-14.6 33.7-14.6 25.6 0 46.3 20.7 46.3 46.3v33.7h248c30.9 0 56 25.1 56 56v48c0 30.9-25.1 56-56 56h-248v33.7c0 25.6-20.7 46.3-46.3 46.3-12.8 0-25-5.3-33.7-14.6L6.5 272.4zm153.5 93v-53.5c0-13.3 10.7-24 24-24h272c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H184c-6.4 0-12.5-2.5-17-7s-7-10.6-7-17v-53.5L57 256l103 109.5z"
        }
    ]
};

const FarLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505.6 239.7c8.5 9.2 8.5 23.4 0 32.6l-89.4 96.8c-8.8 9.5-21.1 14.9-34 14.9-25.5 0-46.3-20.7-46.3-46.3V328h-160v9.7c0 25.5-20.7 46.3-46.3 46.3-12.9 0-25.2-5.4-34-14.9L6.4 272.3c-8.5-9.2-8.5-23.4 0-32.6l89.4-96.8c8.8-9.5 21.1-14.9 34-14.9 25.5 0 46.3 20.7 46.3 46.3v9.7h160v-9.7c0-25.5 20.7-46.3 46.3-46.3 12.9 0 25.2 5.4 34 14.9l89.4 96.8zm-121.6-61V208c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24v-29.3L56.7 256l71.3 77.3V304c0-13.3 10.7-24 24-24h208c13.3 0 24 10.7 24 24v29.3l71.3-77.3-71.3-77.3zm-253-3.3-1.3-1.2 1.3 1.2z"
        }
    ]
};

const FarLeftToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeftToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 146.2 146 256l110 109.8V312c0-13.3 10.7-24 24-24h120v-64H280c-13.3 0-24-10.7-24-24v-53.8zM96 256c0-11.5 4.6-22.5 12.7-30.6l116.1-115.8c8.7-8.7 20.5-13.6 32.8-13.6 25.6 0 46.4 20.8 46.4 46.4V176h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-96v33.6c0 25.6-20.8 46.4-46.4 46.4-12.3 0-24.1-4.9-32.8-13.6L108.7 286.6C100.6 278.5 96 267.5 96 256zM48 88v336c0 13.3-10.7 24-24 24S0 437.3 0 424V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m50.4 256 149.9-142.7c.8-.8 2-1.3 3.2-1.3 2.5 0 4.6 2 4.6 4.6V200c0 13.3 10.7 24 24 24h168v64h-168c-13.3 0-24 10.7-24 24v83.4c0 2.5-2 4.6-4.6 4.6-1.2 0-2.3-.5-3.2-1.3L50.4 256zm153-192c-13.5 0-26.5 5.2-36.3 14.5L13.2 225.1C4.8 233.2 0 244.3 0 256s4.8 22.8 13.2 30.9l154 146.6c9.8 9.3 22.8 14.5 36.3 14.5 29 0 52.6-23.5 52.6-52.6V336h144c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-144v-59.4c0-29-23.5-52.6-52.6-52.6z"
        }
    ]
};

const FarLemon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLemon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 80c-3.2 0-6.2.4-8.9 1.3-19.1 5.5-46.1 10.6-74.3 3.3-57.4-14.9-124.6 7.4-174.7 57.5S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3-.8 2.8-1.3 5.8-1.3 8.9 0 17.7 14.3 32 32 32 3.2 0 6.2-.4 8.9-1.3 19.1-5.5 46.1-10.7 74.3-3.3 57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3.8-2.8 1.3-5.8 1.3-8.9 0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80 0 7.7-1.1 15.2-3.1 22.3-4.6 15.8-7.1 32.9-3 48.9 20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3-7.1 2-14.6 3.1-22.3 3.1-44.2 0-80-35.8-80-80 0-7.7 1.1-15.2 3.1-22.3 4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3 7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3 12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"
        }
    ]
};

const FarLessThanEqual = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLessThanEqual",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M401 78.2c12.3-5 18.2-19 13.2-31.3s-19-18.2-31.3-13.2L47 169.8c-9.1 3.7-15 12.5-15 22.2s5.9 18.6 15 22.2l336 136c12.3 5 26.3-1 31.3-13.2s-1-26.3-13.2-31.3L120 192 401 78.2zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarLessThan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLessThan",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M381.5 77.3c5.9 11.9 1.1 26.3-10.7 32.2L77.7 256l293 146.5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-336-168C5.1 273.4 0 265.1 0 256s5.1-17.4 13.3-21.5l336-168c11.9-5.9 26.3-1.1 32.2 10.7z"
        }
    ]
};

const FarLifeRing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLifeRing",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1.2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-11.8 11.7C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l11.7 11.8C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zm-34-292.3-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3l-80.2-80.4C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8l-80.4 80.3C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FarLightCeiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightCeiling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v137.1C112.4 172.2 16.7 265.6 2 384.1-.2 401.6 14.3 416 32 416h448c17.7 0 32.2-14.4 30-31.9-14.7-118.5-110.5-211.8-230-223V24zm178.4 344H53.6C75.2 276.3 157.7 208 256 208s180.8 68.3 202.4 160zM256 512c35.3 0 64-28.7 64-64H192c0 35.3 28.7 64 64 64z"
        }
    ]
};

const FarLightEmergencyOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightEmergencyOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M69.3 36c-11-7.4-25.9-4.4-33.3 6.7S31.6 68.6 42.7 76l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zm528 40c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm544 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm-120 16v96h48v-96c0-97.2-78.8-176-176-176s-176 78.8-176 176v96h48v-96c0-70.7 57.3-128 128-128s128 57.3 128 128zM144 432v-48h352v48H144zm-48-48v48c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-48c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48zm224-240c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FarLightEmergency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightEmergency",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 304v-96c0-70.7-57.3-128-128-128S96 137.3 96 208v96H48v-96c0-97.2 78.8-176 176-176s176 78.8 176 176v96h-48zM48 384v48h352v-48H48zm0-48h352c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-48c0-26.5 21.5-48 48-48zm112-128c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96 8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FarLightSwitchOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightSwitchOff",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169.4 464c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H214.6c-3.3 9.3-12.2 16-22.6 16s-19.3-6.7-22.6-16H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h105.4zM64 512c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64zm80-256h96V144h-96v112zm0 160c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-96z"
        }
    ]
};

const FarLightSwitchOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightSwitchOn",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169.4 48c3.3 9.3 12.2 16 22.6 16s19.3-6.7 22.6-16H320c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H214.6c-3.3-9.3-12.2-16-22.6-16s-19.3 6.7-22.6 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h105.4zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm80 256h96v112h-96V256zm0-160c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48h-96z"
        }
    ]
};

const FarLightSwitch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightSwitch",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64c-10.4 0-19.3-6.7-22.6-16H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h105.4c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H214.6c-3.3 9.3-12.2 16-22.6 16zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm144 304h96v-88h-96v88zm0-224v88h96v-88h-96zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V144z"
        }
    ]
};

const FarLightbulbCflOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightbulbCflOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343.3 18.2C340.1 5.3 327-2.5 314.2.7l-128 32c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l128-32c12.9-3.2 20.7-16.2 17.5-29.1zm110.5 93.1c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-256 64c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l256-64zm0 96c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-256 64c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l256-64zM416 416c0-17.7-14.3-32-32-32h-80v-89.8l-48 12V384c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h40v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h40c17.7 0 32-14.3 32-32v-32zm37.8-112.7c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-64 16-16 4-8 2c-11.1 2.8-18.5 12.9-18.2 23.9V384h48v-63.3l5.8-1.5 64-16zM53.3 4C42.3-3.3 27.4-.3 20 10.7S15.6 36.6 26.7 44l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zm560 40c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64zM101.3 332c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zm464-39.9c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32z"
        }
    ]
};

const FarLightbulbCfl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightbulbCfl",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m165.8 47.3-128 32C25 82.5 11.9 74.7 8.7 61.8s4.6-25.9 17.5-29.1l128-32c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1zm145.5 34.9c3.2 12.9-4.6 25.9-17.5 29.1l-256 64c-12.9 3.2-25.9-4.6-29.1-17.5s4.6-25.9 17.5-29.1l256-64c12.9-3.2 25.9 4.6 29.1 17.5zm0 96c3.2 12.9-4.6 25.9-17.5 29.1l-256 64c-12.9 3.2-25.9-4.6-29.1-17.5s4.6-25.9 17.5-29.1l256-64c12.9-3.2 25.9 4.6 29.1 17.5zM144 384h80c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-40v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H96c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32v-77.8l48-12V384zm167.3-109.8c3.2 12.9-4.6 25.9-17.5 29.1l-64 16-5.8 1.5V384h-48v-81.4c-.3-11 7.1-21.1 18.2-23.9l8-2 16-4 64-16c12.9-3.2 25.9 4.6 29.1 17.5z"
        }
    ]
};

const FarLightbulbDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightbulbDollar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 176c0 27.2-8.4 52.3-22.8 72.9-3.7 5.3-8.1 11.3-12.7 17.7-12.9 17.7-28.3 38.9-39.8 59.8-10.4 19-15.7 38.8-18.3 57.5H275c2.2-12 5.9-23.7 11.8-34.5 9.9-18 22.2-34.9 34.5-51.8 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5-11.5-20.9-26.9-42.1-39.8-59.8-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128zM192 512c44.2 0 80-35.8 80-80v-16H112v16c0 44.2 35.8 80 80 80zm16-400c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6.5 3.3 1 5 1.6 7.1 2.3 15.1 4.9 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.6c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1 8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V112z"
        }
    ]
};

const FarLightbulbExclamationOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightbulbExclamationOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m69.3 4 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zm528 40-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-124.1-43.2c14.4-20.6 22.8-45.7 22.8-72.9 0-70.7-57.3-128-128-128s-128 57.3-128 128c0 27.2 8.4 52.3 22.8 72.9 3.7 5.3 8.1 11.3 12.8 17.7 12.9 17.7 28.3 38.9 39.8 59.8 10.4 19 15.7 38.8 18.3 57.5H237c-2.2-12-5.9-23.7-11.8-34.5-9.9-18-22.2-34.9-34.5-51.8-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176 144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4-12.3 16.8-24.6 33.7-34.5 51.8-5.9 10.8-9.6 22.5-11.8 34.5h-48.5c2.6-18.7 7.9-38.6 18.3-57.5 11.5-20.9 26.9-42.1 39.8-59.8 4.7-6.4 9-12.4 12.7-17.7zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16h160v16zm-64-304v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16s16 7.2 16 16zm-16 128a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarLightbulbExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightbulbExclamation",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 176c0 27.2-8.4 52.3-22.8 72.9-3.7 5.3-8.1 11.3-12.7 17.7-12.9 17.7-28.3 38.9-39.8 59.8-10.4 19-15.7 38.8-18.3 57.5H275c2.2-12 5.9-23.7 11.8-34.5 9.9-18 22.2-34.9 34.5-51.8 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5-11.5-20.9-26.9-42.1-39.8-59.8-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128zM192 512c44.2 0 80-35.8 80-80v-16H112v16c0 44.2 35.8 80 80 80zm0-400c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm24 168a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarLightbulbGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightbulbGear",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M314.4 213.6c3.6-11.9 5.6-24.5 5.6-37.6 0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9 3.7 5.3 8.1 11.3 12.8 17.7 12.9 17.7 28.3 38.9 39.8 59.8 10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5-9.9-18-22.2-34.9-34.5-51.8-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176 16 78.8 94.8 0 192 0c97 0 175.6 78.4 176 175.3-17.8 7.7-28 25.6-28 43.3v.9c-7.7-4.3-16.7-6.4-25.6-5.9zM245.6 416c3.5 9.2 7.7 18.3 12.8 27 2.9 5 6 9.9 9.4 14.6-10.7 31.6-40.6 54.4-75.8 54.4-44.2 0-80-35.8-80-80v-16h133.6zM144 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48zm228 42.2c0-7 4.5-13.3 11.3-14.8 10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v17.7c0 7.8 4.8 14.8 11.6 18.7 6.8 3.9 15.1 4.5 21.8.6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4 7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8.6-6.8 3.9-11.6 10.9-11.6 18.7v17.7c0 7-4.5 13.3-11.3 14.8-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8v-17.6c0-7.9-4.9-14.9-11.7-18.9-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2 3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6 6.9-3.9 11.7-11 11.7-18.9v-17.2zm92.1 133.5a48.1 48.1 0 1 0-96.1 0 48.1 48.1 0 1 0 96.1 0z"
        }
    ]
};

const FarLightbulbOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightbulbOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M69.3 4C58.3-3.3 43.4-.3 36 10.7S31.6 36.6 42.7 44l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zm528 40c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64zM117.3 332c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zm432-39.9c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM448 176c0 27.2-8.4 52.3-22.8 72.9-3.7 5.3-8 11.3-12.7 17.7-12.9 17.7-28.3 38.9-39.8 59.8-10.4 19-15.7 38.8-18.3 57.5H403c2.2-12 5.9-23.7 11.8-34.5 9.9-18 22.2-34.9 34.5-51.8 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5-11.5-20.9-26.9-42.1-39.8-59.8-4.7-6.4-9-12.4-12.8-17.7-14.4-20.7-22.8-45.8-22.8-73 0-70.7 57.3-128 128-128s128 57.3 128 128zm-176 0c0-26.5 21.5-48 48-48 8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16s16-7.2 16-16zm128 256v-16H240v16c0 44.2 35.8 80 80 80s80-35.8 80-80z"
        }
    ]
};

const FarLightbulbSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightbulbSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-195-152.8c4.4-6.2 8.9-12.4 13.4-18.6 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0c-70.3 0-130.9 41.2-159.2 100.8L38.8 5.1zM200 131.4C218.1 82.7 265 48 320 48c70.7 0 128 57.3 128 128 0 27.2-8.4 52.3-22.8 72.9-3.7 5.3-8.1 11.3-12.7 17.7-4.6 6.3-9.5 13-14.4 20L268.9 185.5c1.9-2.6 3.1-5.9 3.1-9.5 0-26.5 21.5-48 48-48 8.8 0 16-7.2 16-16s-7.2-16-16-16c-40 0-73.1 29.3-79 67.6l-41-32.1zm200 293.5-11.3-8.9H240v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-7.1zM152.4 229.8c5.4 16.8 13.2 32.4 23 46.6 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5-2-3.7-4.2-7.5-6.5-11.2l-108.5-85.6z"
        }
    ]
};

const FarLightbulb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightbulb",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M297.2 248.9c14.4-20.6 22.8-45.7 22.8-72.9 0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9 3.7 5.3 8.1 11.3 12.8 17.7 12.9 17.7 28.3 38.9 39.8 59.8 10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5-9.9-18-22.2-34.9-34.5-51.8-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176 16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4-12.3 16.8-24.6 33.7-34.5 51.8-5.9 10.8-9.6 22.5-11.8 34.5h-48.5c2.6-18.7 7.9-38.6 18.3-57.5 11.5-20.9 26.9-42.1 39.8-59.8 4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80v-16h160v16c0 44.2-35.8 80-80 80z"
        }
    ]
};

const FarLighthouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLighthouse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m33.5 1.9 112 48c12.2 5.2 17.8 19.3 12.6 31.5S138.8 99.2 126.6 94l-112-48C2.4 40.8-3.3 26.7 1.9 14.5S21.3-3.3 33.5 1.9zm112 204.1-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3.4 31.5 12.6s-.4 26.3-12.6 31.5zM308.6 2.9c7.1-3.8 15.7-3.8 22.8 0l104 56c11.7 6.3 16 20.8 9.8 32.5-5.7 10.6-18.2 15.1-29.1 11.3V128H368V77.1l-48-25.8-48 25.8V128h-48v-25.4c-11 3.9-23.4-.7-29.1-11.3-6.3-11.7-1.9-26.2 9.8-32.5l104-56zM263.4 208l-51.2 256H288v-48c0-17.7 14.3-32 32-32s32 14.3 32 32v48h75.8l-51.2-256H263.4zM352 512H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h11.2l51.2-256.1c-12.5-.8-22.4-11.2-22.4-23.9 0-13.3 10.7-24 24-24h208c13.3 0 24 10.7 24 24 0 12.7-9.9 23.1-22.4 23.9L476.8 464H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H352zM638.1 14.6c5.2 12.2-.4 26.3-12.6 31.5l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3.4 31.5 12.6zM482 174.6c5.2-12.2 19.3-17.8 31.5-12.6l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48c-12.2-5.2-17.8-19.3-12.6-31.5z"
        }
    ]
};

const FarLightsHoliday = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLightsHoliday",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M35.3 66.8h.1l.6.3c.6.3 1.7.8 3.1 1.5 2.8 1.4 7.3 3.4 13.2 5.8 11.9 4.9 30 11.6 54.1 18.3 48.1 13.6 120 27.3 213.6 27.3s165.5-13.7 213.5-27.1c24-6.7 42.1-13.4 54.1-18.3 6-2.5 10.4-4.5 13.2-5.8 1.4-.7 2.5-1.2 3.1-1.5l.6-.3c11.7-6.3 26.2-1.9 32.5 9.8s1.9 26.2-9.8 32.5L616 88l11.4 21.1-.1.1-.4.2-1.2.6c-1 .5-2.4 1.2-4.2 2-3.6 1.7-8.8 4.1-15.6 6.9-13.6 5.6-33.5 12.9-59.4 20.2-52 14.6-128.1 28.9-226.5 28.9s-174.5-14.3-226.5-28.9c-26-7.3-45.9-14.6-59.4-20.2-6.8-2.8-12-5.2-15.6-6.9-1.8-.9-3.2-1.5-4.2-2l-1.2-.6-.4-.2-.1-.1L24 88l-11.4 21.1C1 102.8-3.4 88.3 2.9 76.6c6.3-11.7 20.8-16 32.5-9.8zm80 155.3L130 181c14.8 3.1 30.7 6.1 47.9 8.7l-17.3 48.6c27.2 20.5 39.2 56.9 27.2 90.7-16.1 45.2-95.7 101.8-118.3 93.8S20.9 320.6 37 275.4c12-33.7 44.4-54.4 78.3-53.1zM296 259.7v-60c7.9.2 15.9.3 24 .3s16.1-.1 24-.3v59.9c32.5 10.2 56 40.5 56 76.3 0 48-56 128-80 128s-80-80-80-128c0-35.8 23.5-66.1 56-76.3zm183.4-21.4-17.3-48.6c17.1-2.6 33.1-5.5 47.9-8.7l14.7 41.2c34-1.3 66.3 19.4 78.3 53.1 16.1 45.2-9.8 139.4-32.5 147.4s-102.2-48.6-118.3-93.8c-12-33.7 0-70.2 27.2-90.7zM82.2 291.4c-1.2 3.4-2.6 11-2.1 23.3.4 11.6 2.3 24.6 5.3 37 1.3 5.3 2.7 10.2 4.2 14.6 3.9-2.5 8.1-5.4 12.5-8.7 10.2-7.7 19.9-16.6 27.5-25.4 8-9.2 11.8-16 13-19.4 5.9-16.7-2.8-35-19.4-40.9s-35 2.8-40.9 19.4zM288 336c0 3.6 1.3 11.3 5.8 22.6 4.3 10.8 10.4 22.4 17.4 33.1 3 4.6 6 8.7 8.8 12.4 2.8-3.7 5.8-7.8 8.8-12.4 7-10.7 13.1-22.3 17.4-33.1 4.5-11.4 5.8-19 5.8-22.6 0-17.7-14.3-32-32-32s-32 14.3-32 32zm228.9-64c-16.7 5.9-25.3 24.2-19.4 40.9 1.2 3.4 5 10.2 13 19.4 7.6 8.8 17.3 17.6 27.5 25.4 4.4 3.3 8.6 6.2 12.5 8.7 1.5-4.4 2.9-9.3 4.2-14.6 3-12.4 4.9-25.4 5.3-37 .4-12.2-.9-19.9-2.1-23.3-5.9-16.7-24.2-25.3-40.9-19.4z"
        }
    ]
};

const FarLineColumns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLineColumns",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 40h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 88 0 77.3 0 64s10.7-24 24-24zm0 128h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 320c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm24 104h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm264-232c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24zm24-152h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24 280c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24zm24 104h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarLineHeight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLineHeight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M113.8 39.9c-4.6-5.1-11-7.9-17.8-7.9s-13.3 2.9-17.8 7.9l-72 80c-8.9 9.9-8.1 25 1.8 33.9s25 8.1 33.9-1.8L72 118.5v275l-30.2-33.6c-8.9-9.9-24-10.7-33.9-1.8s-10.7 24-1.8 33.9l72 80c4.6 5.1 11 7.9 17.8 7.9s13.3-2.9 17.8-7.9l72-80c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8l-30 33.6v-275l30.2 33.5c8.9 9.9 24 10.7 33.9 1.8s10.7-24 1.8-33.9l-72-80zM248 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H248zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H248zm-24 184c0 13.3 10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H248c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarLinesLeaning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLinesLeaning",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.6 64.1c4.5-12.5-2-26.2-14.5-30.7s-26.2 2-30.7 14.5l-144 400c-4.5 12.5 2 26.2 14.5 30.7s26.2-2 30.7-14.5l144-400zm78.1-31.7c-13-2.6-25.6 5.8-28.2 18.8l-80 400c-2.6 13 5.8 25.6 18.8 28.2s25.6-5.8 28.2-18.8l80-400c2.6-13-5.8-25.6-18.8-28.2zM360 32c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarLinkHorizontalSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLinkHorizontalSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-56.4-44.2c39.5-25.6 65.6-70.1 65.6-120.7 0-75.7-58.7-138.5-134.3-143.5l-8.1-.5c-13.2-.9-24.7 9.1-25.5 22.4s9.1 24.7 22.3 25.5l8.1.5c50.4 3.4 89.5 45.2 89.5 95.6 0 39.8-24.3 74-58.8 88.4l-118.4-92.8c20.8-25 33.2-57.1 33.2-91.9C448 128.4 383.6 64 304.1 64H143.9c-9.1 0-18.1.9-26.8 2.5L38.8 5.1zM175.2 112h129c52.9 0 95.9 42.9 95.9 95.9 0 23.7-8.6 45.5-23 62.3L175.2 112zm271.6 336-60.9-48h-50c-53 0-95.9-42.9-95.9-95.9 0-6 .6-12 1.6-17.7l-40.8-32.1c-5.7 15.6-8.9 32.4-8.9 49.8.1 79.5 64.5 143.9 144 143.9h110.9zM30.1 119.7C11.2 144.1 0 174.7 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1.5c13.2.9 24.7-9.1 25.5-22.3s-9.1-24.7-22.4-25.5l-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-22 7.4-42.2 19.8-58.4l-37.7-29.8z"
        }
    ]
};

const FarLinkHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLinkHorizontal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M143.9 64C64.4 64 0 128.4 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1.5c13.2.9 24.7-9.1 25.5-22.3s-9.1-24.7-22.4-25.5l-8.1-.5C87.1 300.2 48 258.3 48 207.9 48 155 90.9 112 143.9 112h160.2c52.9 0 95.9 42.9 95.9 95.9 0 50.5-39.1 92.3-89.5 95.6l-8.1.5c-13.2.9-23.2 12.3-22.4 25.5s12.3 23.2 25.5 22.3l8.1-.5c75.6-5 134.3-67.8 134.3-143.5C448 128.4 383.6 64 304.1 64H143.9zm352.2 384c79.5 0 143.9-64.4 143.9-143.9 0-75.7-58.7-138.5-134.3-143.5l-8.1-.5c-13.2-.9-24.7 9.1-25.5 22.4s9.1 24.7 22.3 25.5l8.1.5c50.4 3.4 89.5 45.2 89.5 95.6 0 52.9-42.9 95.9-95.9 95.9H335.9c-53 0-95.9-42.9-95.9-95.9 0-50.5 39.1-92.3 89.5-95.7l7.1-.5c13.2-.9 23.2-12.3 22.3-25.6s-12.3-23.2-25.6-22.3l-7.1.5C250.7 165.6 192 228.4 192 304.1c0 79.5 64.4 143.9 143.9 143.9h160.2z"
        }
    ]
};

const FarLinkSimpleSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLinkSimpleSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136 0-88.4-71.6-160-160-160h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h72c61.9 0 112 50.1 112 112 0 46.6-28.5 86.6-69.1 103.5L389.5 280H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-95.7L216 144h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zm69.6 176.3-37.7-29.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160h72c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72c-61.9 0-112-50.1-112-112 0-28.6 10.7-54.8 28.4-74.6z"
        }
    ]
};

const FarLinkSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLinkSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256C0 167.6 71.6 96 160 96h72c13.3 0 24 10.7 24 24s-10.7 24-24 24h-72c-61.9 0-112 50.1-112 112s50.1 112 112 112h72c13.3 0 24 10.7 24 24s-10.7 24-24 24h-72C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160h-72c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c61.9 0 112-50.1 112-112s-50.1-112-112-112h-72c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c88.4 0 160 71.6 160 160zm-392-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarLinkSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLinkSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l91-91c56.2-56.2 56.2-147.3 0-203.5-53.5-53.5-139.4-56.4-196.4-6.5l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4 37.4 37.4 37.4 98.1 0 135.6l-95.1 95.1-45.5-35.7c24.2-53.3 14.1-117.9-29.3-161.3-52.1-52.1-134.4-55.9-190.8-11.2L38.8 5.1zm186.3 146c36.9-22.3 85.6-17.6 117.4 14.3 26 26 34 63.3 23.7 96.4L225.1 151.1zm181.8 265.5-54.2-42.7c-20.2-2.7-39.7-11.7-55.2-27.3-9.8-9.8-17-21.2-21.7-33.3l-54.2-42.7c-2.2 39.6 11.9 79.9 41.9 109.9 38.8 38.8 94.2 50.8 143.4 36zM116.6 187.9l-56.9 56.9C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4-37.4-37.4-37.4-98.1 0-135.6l60.9-60.9-38-29.9z"
        }
    ]
};

const FarLink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLink",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5-53.5-53.5-139.4-56.4-196.4-6.5l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4 37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4 56.2 56.2 147.3 56.2 203.5 0l113.3-113.3zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0 35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z"
        }
    ]
};

const FarLips = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLips",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M258.2 138.9c-22.5-17.8-42-26.9-58.2-26.9-10.5 0-24.3 4.1-41.7 13.7-17.2 9.5-34 22.1-50.5 34.9-17.5 13.6-33.2 27.9-44.4 40.5-6 6.8-10.3 12.2-13 17-2.1 3.9-2.4 5.7-2.4 5.9 0 .4.1 1.7.6 4.1s1.3 5.2 2.3 8.3c9.8 29.5 28.4 58.7 51.2 85.1C138.4 363.6 190.4 400 256 400h64c65.6 0 117.6-36.4 153.9-78.5 18.1-20.9 31.8-42.8 41-61.2 9.2-18.5 13-29.2 13.1-36.3 0-.2-.2-2-2.5-5.9-2.7-4.8-6.9-10.2-13-17-11.2-12.6-26.9-26.9-44.4-40.5-16.5-12.8-33.3-25.4-50.5-34.9-17.3-9.6-31.1-13.7-41.6-13.7-16.2 0-35.7 9.1-58.2 26.9-17.5 13.8-42.1 13.8-59.5 0zm239.4-16.2c19.1 14.8 37.1 31.2 50.8 46.5 13.4 15 27.6 33.7 27.6 54.8 0 20-9.4 40.3-18.1 57.8-10.8 21.7-26.8 46.9-47.7 71.1-41.4 48-105.5 95.1-190.2 95.1h-64c-84.7 0-148.8-47.1-190.2-95.1-25.5-29.5-48.1-64.1-60.5-101.4C2.6 243.1 0 233.2 0 224c0-21.1 14.2-39.7 27.6-54.8 13.6-15.3 31.7-31.7 50.8-46.5C111.5 97 156 64 200 64c32.7 0 63 17.5 88 37.3C313 81.5 343.3 64 376 64c44 0 88.5 33 121.6 58.7zM96 236c0-6.7 39.4-27.1 118.1-28 3.5 0 7 .5 10.3 1.6 11.8 3.7 42 12.4 63.6 12.4s51.7-8.7 63.6-12.4c3.3-1 6.8-1.6 10.3-1.6 78.7.9 118.1 21.2 118.1 28 0 6.9-68.6 84-192 84S96 242.9 96 236z"
        }
    ]
};

const FarLiraSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLiraSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 159.2c0-43.7 35.5-79.2 79.2-79.2 8.5 0 17 1.4 25.1 4.1l80.1 26.7c12.6 4.2 26.2-2.6 30.4-15.2s-2.6-26.2-15.2-30.4l-80.1-26.7c-13-4.3-26.6-6.5-40.2-6.5C105 32 48 89 48 159.2V192H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v4.5c0 18.8-5.1 37.3-14.8 53.5L3.4 443.7c-4.4 7.4-4.6 16.6-.3 24.2S15.4 480 24 480h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H66.4l8-13.3C88.5 395.1 96 368.1 96 340.5V336h136c13.3 0 24-10.7 24-24s-10.7-24-24-24H96v-48h136c13.3 0 24-10.7 24-24s-10.7-24-24-24H96v-32.8z"
        }
    ]
};

const FarListCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarListCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8l-55 61.1L41 79c-9.4-9.3-24.6-9.3-34 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8l-55 61.1L41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM216 120h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24zm-24 136c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24zm-32 160c0 13.3 10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm-64 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarListDropdown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarListDropdown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 192v224c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V192H48zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm436.7 0h-73.4c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c3.1 3.1 8.2 3.1 11.3 0l36.7-36.7c5-5 1.5-13.7-5.7-13.7zM128 232h256c13.3 0 24 10.7 24 24s-10.7 24-24 24H128c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96h256c13.3 0 24 10.7 24 24s-10.7 24-24 24H128c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarListMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarListMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M481.1 0C498.2 0 512 13.8 512 30.9V136c0 10.4-6.7 19.6-16.6 22.8L384 194.7V432c0 44.2-50.1 80-112 80s-112-35.8-112-80 50.1-80 112-80c23.8 0 45.9 5.3 64 14.3V64c0-10.3 6.6-19.5 16.4-22.8l119-39.6c3.1-1 6.4-1.6 9.8-1.6zM323.3 414.5c-11.2-8-29.2-14.5-51.3-14.5s-40.1 6.5-51.3 14.5c-11.3 8.1-12.7 14.9-12.7 17.5s1.4 9.4 12.7 17.5c11.2 8 29.2 14.5 51.3 14.5s40.1-6.5 51.3-14.5c11.3-8.1 12.7-14.9 12.7-17.5s-1.4-9.4-12.7-17.5zM384 144.3l80-25.8V54.6l-80 26.7v63zM24 48h240c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 96 0 85.3 0 72s10.7-24 24-24zm0 128h240c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarListOl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarListOl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v120h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V80h-8c-13.3 0-24-10.7-24-24zm62.7 285.2c-6.5-7.4-18.3-6.9-24 1.2l-11.2 15.5c-7.7 10.8-22.7 13.3-33.5 5.6S4.7 340.8 12.4 330l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9 21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6.3-20.5zM216 72h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarListRadio = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarListRadio",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm120 40c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM64 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM40 416a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FarListTimeline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarListTimeline",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M219.9 112H400V80H219.9l-16 16 16 16zm-72.6-4.7c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm187.9 16H400v-32H219.9l-16 16 16 16zm-72.6-4.7c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3zM203.9 256l16 16H464v-32H219.9l-16 16zm-13.3 54.6-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4z"
        }
    ]
};

const FarListTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarListTree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 48C10.7 48 0 58.7 0 72v48c0 13.3 10.7 24 24 24v240c0 30.9 25.1 56 56 56h48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24H80c-4.4 0-8-3.6-8-8V280h56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24H72v-88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H24zm136 48c0 13.3 10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm128 160c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24zm0 160c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarListUl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarListUl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm120 8c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM96 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
        }
    ]
};

const FarList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 48c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zm144 24c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM16 232v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zm24 136c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H40z"
        }
    ]
};

const FarLitecoinSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLitecoinSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 56c0-13.3-10.7-24-24-24S64 42.7 64 56v164.5l-46.2 12.3C5 236.2-2.6 249.4.8 262.2s16.6 20.4 29.4 17l33.8-9V456c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H112V257.4l158.2-42.2c12.8-3.4 20.4-16.6 17-29.4s-16.6-20.4-29.4-17L112 207.7V56z"
        }
    ]
};

const FarLoader = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLoader",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zm0 384c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80zM0 256c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm408-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zm29-157c-9.4-9.4-24.6-9.4-33.9 0l-56.6 56.6c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9zM165.5 380.4c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56.6-56.6zM75 75c-9.4 9.4-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0zm305.5 271.5c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.5 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56.6-56.6z"
        }
    ]
};

const FarLobster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLobster",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7.3 67.4 0 64 0 28.7 0 0 28.7 0 64v64c0 35.3 28.7 64 64 64h.7l41.8 27.9c19.7 13.1 42.9 20.1 66.6 20.1h2.9v16h-32.9c-7.5 0-14.8-1.7-21.5-5.1l-34.4-17.2c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4H176v16h-53.6c-5.2 0-10.3-.8-15.2-2.5l-38.1-12.7c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1H176v16h-.9c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1h.9l23.8 66.6c-23.1 7.3-39.8 28.8-39.8 54.3 0 3.9 3.2 7.1 7.1 7.1h177.8c3.9 0 7.1-3.2 7.1-7.1 0-25.5-16.7-47-39.8-54.3L336 384h.9c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4h-.9v-16h53.6c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5H336V288h32.9c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1H336v-16h2.9c23.7 0 46.9-7 66.6-20.2l41.8-27.8h.7c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64-3.4 0-6.7.3-9.9.8-3.6.6-6.1 3.8-6.1 7.5V72c0 7.7-9.8 11-14.4 4.8l-20.2-26.9c-3.7-4.9-11.2-3.9-12.3 2.1-.7 3.9-1.1 7.9-1.1 11.9v64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5a71.6 71.6 0 0 1-40 12.2h-3.4c-2.6-22.5-16-42.9-31.5-59.2V80.7c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7v25c-3.2-2.2-6.3-4.1-9-5.8-4.3-2.6-9.7-2.6-14 0-2.8 1.6-5.8 3.6-9 5.8v-25c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7v52.1c-15.5 16.3-28.9 36.7-31.5 59.2h-3.4c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4V64c0-4.1-.4-8.1-1.1-11.9-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72V8.2zM262.2 448h-12.4L224 375.7V200c0-6.6 3.8-17 15.4-30.3 5.2-6 11-11.4 16.6-16 5.7 4.7 11.5 10.1 16.6 16C284.2 183 288 193.4 288 200v175.7L262.2 448z"
        }
    ]
};

const FarLocationArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationArrow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208h-94.6l241.4-98.7L272 350.6V256c0-26.5-21.5-48-48-48zm-48 48h48v176c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8S32.7 256 48 256h128z"
        }
    ]
};

const FarLocationCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2 10.5 24.8 25.4 52.2 42.5 79.9 28.5 46.2 61.5 90.8 86.2 122.6 24.8-31.8 57.8-76.4 86.2-122.6 17.1-27.7 32-55.1 42.5-79.9 10.8-25.6 15.3-44.8 15.3-57.2zm48 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-79-23L177 297c-9.4 9.4-24.6 9.4-33.9 0L79 233c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarLocationCrosshairsSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationCrosshairsSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-146-114.5c13.4-22.3 22.4-47.6 25.8-74.6H552c13.3 0 24-10.7 24-24s-10.7-24-24-24h-41.5C499.7 145.2 430.8 76.3 344 65.5V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v41.5c-43.1 5.4-81.8 25-111.1 54.1L38.8 5.1zm184.3 144.4c25.5-23.3 59.6-37.5 96.9-37.5 79.5 0 144 64.5 144 144 0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5 0-53-43-96-96-96-22 0-42.2 7.4-58.4 19.8L223 149.6zm144.4 113.3L302 211.5c5.5-2.2 11.6-3.5 17.9-3.5 26.5 0 48 21.5 48 48 0 2.3-.2 4.6-.5 6.8zM414.9 423 373 390c-16.4 6.5-34.3 10.1-53 10.1-79.5 0-144-64.5-144-144 0-6.9.5-13.6 1.4-20.2l-41.9-33c-2.7 9.5-4.7 19.2-6 29.3H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h41.5C140.3 367 209.2 435.9 296 446.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-41.5c25.5-3.2 49.5-11.4 70.9-23.6z"
        }
    ]
};

const FarLocationCrosshairs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationCrosshairs",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c13.3 0 24 10.7 24 24v41.5c86.8 10.8 155.7 79.7 166.5 166.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24h-41.5c-10.8 86.8-79.7 155.7-166.5 166.5V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-41.5C145.2 435.7 76.3 366.8 65.5 280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h41.5C76.3 145.2 145.2 76.3 232 65.5V24c0-13.3 10.7-24 24-24zM112 256a144 144 0 1 0 288 0 144 144 0 1 0-288 0zm192 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0z"
        }
    ]
};

const FarLocationDotSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationDotSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0c-70.8 0-132.7 38.4-166 95.4L38.8 5.1zm153.5 120.3c24-46 72.2-77.4 127.7-77.4 79.5 0 144 64.5 144 144 0 12.4-4.5 31.6-15.3 57.2-7.4 17.4-16.9 36.2-27.9 55.4l-57.7-45.2c22.2-14.3 36.9-39.1 36.9-67.4 0-44.2-35.8-80-80-80-35.1 0-65 22.7-75.7 54.1l-52-40.7zM318 223.9l-28.5-22.4c-.9-3-1.5-6.2-1.5-9.6 0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32c-.7 0-1.3 0-2-.1zm-126.7 25.3c-.5-1.2-1-2.5-1.5-3.7l-61.7-48.6c4.2 88.2 117.8 239.3 168.2 302.2 12.3 15.3 35.1 15.3 47.4 0 16.2-20.2 39-49.6 62.5-83.1l-37.8-29.8c-17.3 24.6-34.2 47.2-48.5 65.4-24.8-31.8-57.8-76.4-86.2-122.6-17.1-27.7-32-55.1-42.5-79.9z"
        }
    ]
};

const FarLocationDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationDot",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2 10.5 24.8 25.4 52.2 42.5 79.9 28.5 46.2 61.5 90.8 86.2 122.6 24.8-31.8 57.8-76.4 86.2-122.6 17.1-27.7 32-55.1 42.5-79.9 10.8-25.6 15.3-44.8 15.3-57.2zm48 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-160 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FarLocationExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationExclamation",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2 10.5 24.8 25.4 52.2 42.5 79.9 28.5 46.2 61.5 90.8 86.2 122.6 24.8-31.8 57.8-76.4 86.2-122.6 17.1-27.7 32-55.1 42.5-79.9 10.8-25.6 15.3-44.8 15.3-57.2zm48 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zM192 96c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarLocationMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2 10.5 24.8 25.4 52.2 42.5 79.9 28.5 46.2 61.5 90.8 86.2 122.6 24.8-31.8 57.8-76.4 86.2-122.6 17.1-27.7 32-55.1 42.5-79.9 10.8-25.6 15.3-44.8 15.3-57.2zm48 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-264-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarLocationPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationPen",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2 10.5 24.8 25.4 52.2 42.5 79.9 28.5 46.2 61.5 90.8 86.2 122.6 24.8-31.8 57.8-76.4 86.2-122.6 17.1-27.7 32-55.1 42.5-79.9 10.8-25.6 15.3-44.8 15.3-57.2zm48 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-107.2-85c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9-53.3-53.2 14.9-15c14.7-14.7 38.6-14.7 53.3 0zM114.1 216.5l71.9-71.9 53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FarLocationPinLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationPinLock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 451.7c18.5-23.7 41.6-54.7 64-88.1v83.2c-15.3 20.6-29.3 38.6-40.3 52.3-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0c95.7 0 175 70 189.6 161.5-16.9 2.8-32.6 9.4-46.1 18.9C329.6 106.3 267.6 48 192 48c-79.5 0-144 64.5-144 144 0 12.4 4.5 31.6 15.3 57.2 10.5 24.8 25.4 52.2 42.5 79.9 28.5 46.2 61.5 90.8 86.2 122.6zM224 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm288 48c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FarLocationPinSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationPinSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0c-70.8 0-132.7 38.4-166 95.4L38.8 5.1zm153.5 120.3c24-46 72.2-77.4 127.7-77.4 79.5 0 144 64.5 144 144 0 12.4-4.5 31.6-15.3 57.2-7.4 17.4-16.9 36.2-27.9 55.4L192.3 125.4zm-2.5 120.1-61.7-48.6c4.2 88.2 117.8 239.3 168.2 302.2 12.3 15.3 35.1 15.3 47.4 0 16.2-20.2 39-49.6 62.5-83.1l-37.8-29.8c-17.3 24.6-34.2 47.2-48.5 65.4-24.8-31.8-57.8-76.4-86.2-122.6-17.1-27.7-32-55.1-42.5-79.9-.5-1.2-1-2.5-1.5-3.7z"
        }
    ]
};

const FarLocationPin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationPin",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320.7 249.2c-10.5 24.8-25.4 52.2-42.5 79.9-28.4 46.2-61.4 90.9-86.2 122.6-24.8-31.8-57.8-76.4-86.2-122.6-17.1-27.7-32-55.1-42.5-79.9C52.5 223.6 48 204.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2zm-105 250C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0z"
        }
    ]
};

const FarLocationPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationPlus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2 10.5 24.8 25.4 52.2 42.5 79.9 28.5 46.2 61.5 90.8 86.2 122.6 24.8-31.8 57.8-76.4 86.2-122.6 17.1-27.7 32-55.1 42.5-79.9 10.8-25.6 15.3-44.8 15.3-57.2zm48 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-216 88v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarLocationQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationQuestion",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2 10.5 24.8 25.4 52.2 42.5 79.9 28.5 46.2 61.5 90.8 86.2 122.6 24.8-31.8 57.8-76.4 86.2-122.6 17.1-27.7 32-55.1 42.5-79.9 10.8-25.6 15.3-44.8 15.3-57.2zm48 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-278.2-58.7C113.7 111 134.9 96 158.6 96h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L216 232.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarLocationSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationSmile",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2 10.5 24.8 25.4 52.2 42.5 79.9 28.5 46.2 61.5 90.8 86.2 122.6 24.8-31.8 57.8-76.4 86.2-122.6 17.1-27.7 32-55.1 42.5-79.9 10.8-25.6 15.3-44.8 15.3-57.2zm48 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-248-64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-79.4 76.9c4.5 6.7 21.6 23.1 47.4 23.1s42.9-16.4 47.4-23.1c6.1-9.2 18.5-11.7 27.7-5.5s11.7 18.5 5.5 27.7c-9.7 14.6-38.1 40.9-80.6 40.9s-70.9-26.3-80.6-40.9c-6.1-9.2-3.6-21.6 5.5-27.7s21.6-3.6 27.7 5.5z"
        }
    ]
};

const FarLocationXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocationXmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2 10.5 24.8 25.4 52.2 42.5 79.9 28.5 46.2 61.5 90.8 86.2 122.6 24.8-31.8 57.8-76.4 86.2-122.6 17.1-27.7 32-55.1 42.5-79.9 10.8-25.6 15.3-44.8 15.3-57.2zm48 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-273-81c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarLockA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLockA",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48c44.2 0 80 35.8 80 80v32H144v-32c0-44.2 35.8-80 80-80zM96 128v32H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64h-32v-32C352 57.3 294.7 0 224 0S96 57.3 96 128zm-32 80h320c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zm58.5 197.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l13.4-26.8h90.3l13.4 26.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-79.8-159.7c-1.2-2.4-2.7-4.6-4.6-6.5-2.2-2.2-4.7-3.9-7.4-5-3.1-1.3-6.3-2-9.5-2s-6.4.6-9.5 2c-2.7 1.2-5.3 2.9-7.4 5-1.9 1.9-3.4 4.1-4.6 6.5l-80.1 159.8zm80.3-53.3 21.2-42.3 21.2 42.3h-42.4z"
        }
    ]
};

const FarLockHashtag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLockHashtag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128v32h160v-32c0-44.2-35.8-80-80-80s-80 35.8-80 80zm-48 32v-32C96 57.3 153.3 0 224 0s128 57.3 128 128v32h32c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h32zm0 48H64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H96zm88 16c13.3 0 24 10.7 24 24v24h32v-24c0-13.3 10.7-24 24-24s24 10.7 24 24v24h24c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24v32h24c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24v24c0 13.3-10.7 24-24 24s-24-10.7-24-24v-24h-32v24c0 13.3-10.7 24-24 24s-24-10.7-24-24v-24h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-32h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-24c0-13.3 10.7-24 24-24zm24 128h32v-32h-32v32z"
        }
    ]
};

const FarLockKeyholeOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLockKeyholeOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 48c-44.2 0-80 35.8-80 80v64h32c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64h240v-64C304 57.3 361.3 0 432 0s128 57.3 128 128v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72c0-44.2-35.8-80-80-80zm-48 192H64c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16zM256 376h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
        }
    ]
};

const FarLockKeyhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLockKeyhole",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48c44.2 0 80 35.8 80 80v64H144v-64c0-44.2 35.8-80 80-80zM96 128v64H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-32v-64C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 240h320c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16zm184 80c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64z"
        }
    ]
};

const FarLockOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLockOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 128c0-44.2 35.8-80 80-80s80 35.8 80 80v72c0 13.3 10.7 24 24 24s24-10.7 24-24v-72C560 57.3 502.7 0 432 0S304 57.3 304 128v64H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-32v-64zM64 240h320c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLock",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128v64h160v-64c0-44.2-35.8-80-80-80s-80 35.8-80 80zm-48 64v-64C96 57.3 153.3 0 224 0s128 57.3 128 128v64h32c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64h32zm-48 64v192c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarLocust = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLocust",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h24c94.6 0 173.9 65.7 194.7 154-12.9-6.4-27.4-10-42.7-10h-45.4l-45.5-83.5c-3.9-7.2-11.3-11.9-19.4-12.5s-16.1 3.1-20.9 9.7l-35 47.5-29.4-46.2c-4.2-6.6-11.3-10.7-19-11.1s-15.2 3-20.1 9.1l-68.7 87h-74.5C63.4 224 32 255.4 32 294.1c0 26.9 15.4 51.3 39.4 63.1L5.2 441.1c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l73.5-93.1 41.5 19-33.2 45c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1l42.5-57.6c11.8 2.3 23.9 3.4 36 3.4h33.4l-16.1 28.1c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9l29.7-51.9h110.7l25.4 50.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-15.2-30.3c46.2-6.9 81.6-46.7 81.7-94.7V280c0-137-111-248-248-248h-24zm61 164.6 15 27.4h-35.2l20.2-27.4zm-103.1-3.2 19.5 30.6h-43.7l24.2-30.6zM102.1 272h36.5L102 318.4l-9.1-4.2c-7.8-3.5-12.9-11.4-12.9-20.1 0-12.2 9.9-22.1 22.1-22.1zm97.7 0H480c26.5 0 48 21.5 48 48s-21.5 48-48 48H241.8c-20.7 0-41.1-4.4-59.9-13l-35-16 52.9-67zM472 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarLollipop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLollipop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M210.8 334.8C265.3 314.2 304 261.6 304 200v-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 53-43 96-96 96h-8c-57.4 0-104-46.6-104-104 0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192c0 106 86 192 192 192 44.4 0 85.2-15 117.7-40.3L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L343.7 309.7C369 277.2 384 236.4 384 192 384 86 298 0 192 0S0 86 0 192z"
        }
    ]
};

const FarLoveseat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLoveseat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 80h160c44.2 0 80 35.8 80 80v34.8c7.7-1.8 15.7-2.8 24-2.8s16.3 1 24 2.8V160c0-70.7-57.3-128-128-128H176C105.3 32 48 89.3 48 160v34.8c7.7-1.8 15.7-2.8 24-2.8s16.3 1 24 2.8V160c0-44.2 35.8-80 80-80zm286.5 147.6c-7.1-2.3-14.6-3.6-22.5-3.6-9.5 0-18.5 1.8-26.8 5.2-24.1 9.7-41.8 32-44.7 58.8H143.6c-3-26.8-20.6-49.1-44.7-58.8-8.4-3.4-17.4-5.2-26.9-5.2-7.9 0-15.4 1.3-22.5 3.6C20.7 237 0 264.1 0 296v136c0 26.5 21.5 48 48 48h48c20.9 0 38.7-13.4 45.3-32h229.4c6.6 18.6 24.4 32 45.3 32h48c26.5 0 48-21.5 48-48V296c0-31.9-20.7-59-49.5-68.4zM368 400H144v-64h224v64zm-272 0v32H48V296c0-13.3 10.7-24 24-24s24 10.7 24 24v104zm368-104v136h-48V296c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarLuchadorMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLuchadorMask",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 464H160c-61.9 0-112-50.1-112-112V224c0-97.2 78.8-176 176-176s176 78.8 176 176v128c0 61.9-50.1 112-112 112zM224 0C100.3 0 0 100.3 0 224v128c0 88.4 71.6 160 160 160h128c88.4 0 160-71.6 160-160V224C448 100.3 347.7 0 224 0zm-64 352h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-6.4-31.7C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64 0-33.2-25.2-60.5-57.6-63.7 1-3.7 1.6-7.6 1.6-11.6 0-7.3-1.8-14.4-5.3-20.7H304c44.2 0 80-35.8 80-80 0-26.5-21.5-48-48-48h-32c-44.2 0-80 35.8-80 80 0-44.2-35.8-80-80-80h-32c-26.5 0-48 21.5-48 48 0 44.2 35.8 80 80 80h13.3c-3.4 6.3-5.3 13.4-5.3 20.7 0 4 .6 7.9 1.6 11.6zm41.7-.3c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l8-8 4.2-4.2.4-.4 10.3-10.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 288l.4.4 4.2 4.2 8 8c2.1 2.1 3.3 5 3.3 8 0 6.2-5.1 11.3-11.3 11.3h-57.3zM96 208c0-8.8 7.2-16 16-16h32c26.5 0 48 21.5 48 48 0 8.8-7.2 16-16 16h-32c-26.5 0-48-21.5-48-48zm240-16c8.8 0 16 7.2 16 16 0 26.5-21.5 48-48 48h-32c-8.8 0-16-7.2-16-16 0-26.5 21.5-48 48-48h32z"
        }
    ]
};

const FarLungsVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLungsVirus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24v126.4c-7.1-4.1-15.3-6.4-24-6.4s-16.9 2.3-24 6.4V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm-88 141.3v24.1c-14.4-9.6-32.8-10.5-48-2.9v-21.2c0-11.8-9.6-21.3-21.3-21.3-6.8 0-12.8 3.2-16.4 8.3-14.7 21.1-42.3 62.6-67.8 111.6C77 312.8 54.3 367.9 48 417v6c0 22.6 18.3 41 41 41 3.4 0 6.7-.4 9.9-1.2l72.7-18.2c6.4-1.6 12.3-4.5 17.3-8.3 1.8 2.9 4 5.6 6.6 8.2 10.7 10.7 25.3 15.3 39.2 13.8-12.8 15.9-30.6 27.7-51.5 32.9l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7-49.1 0-89-39.8-89-89v-7c0-1.3.1-2.7.2-4 7.2-57.9 33.1-119.4 59.6-170.3 26.8-51.5 55.6-94.8 71-116.9 13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3zm273.4 344-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9 14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c2.5-2.5 4.7-5.3 6.6-8.2 5 3.8 10.9 6.7 17.3 8.3l72.7 18.2c3.3.8 6.6 1.2 9.9 1.2 22.6 0 41-18.3 41-41v-6c-6.3-49.1-29-104.2-54.4-153.1-25.5-49-53.1-90.5-67.8-111.6-3.6-5.1-9.6-8.3-16.4-8.3-11.8 0-21.3 9.6-21.3 21.3v21.2c-15.2-7.6-33.6-6.6-48 2.9v-24C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8 15.4 22.1 44.3 65.4 71 116.9 26.5 50.9 52.4 112.5 59.6 170.3.2 1.3.2 2.6.2 4v7c0 49.1-39.8 89-89 89-7.3 0-14.5-.9-21.6-2.7zM320 176c8.8 0 16 7.2 16 16 0 33 39.9 49.5 63.2 26.2 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16zm-24 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarLungs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarLungs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v142.8c0 18.1-8.7 35.1-23.5 45.6L256 224.2v-58.9C256 127 225 96 186.7 96c-21.7 0-42.8 10.2-55.8 28.8-15.4 22.1-44.3 65.4-71 116.9C33.4 292.6 7.5 354.2.2 412c-.2 1.3-.2 2.6-.2 4v7c0 49.1 39.8 89 89 89 7.3 0 14.5-.9 21.6-2.7l72.7-18.2c42.7-10.6 72.7-49 72.7-93.1v-75.5l-48 34.3V398c0 22-15 41.2-36.4 46.6l-72.7 18.2c-3.3.8-6.6 1.2-9.9 1.2-22.6 0-41-18.3-41-41v-6c6.3-49.1 29-104.2 54.4-153.1 25.5-49 53.1-90.5 67.8-111.6 3.6-5.1 9.6-8.3 16.4-8.3 11.8 0 21.3 9.6 21.3 21.3v93.2l-69.9 50c-10.8 7.7-13.3 22.7-5.6 33.5s22.7 13.3 33.5 5.6l42.1-30 48-34.3 44.4-31.7c7.4-5.3 13.9-11.4 19.6-18.2 5.6 6.8 12.2 12.9 19.6 18.2l44.4 31.6 48 34.3 42.1 30c10.8 7.7 25.8 5.2 33.5-5.6s5.2-25.8-5.6-33.5l-69.9-50v-93.1c0-11.8 9.6-21.3 21.3-21.3 6.8 0 12.8 3.2 16.4 8.3 14.7 21.1 42.3 62.6 67.8 111.6 25.4 48.9 48.1 104 54.4 153.1v6c0 22.6-18.3 41-41 41-3.4 0-6.7-.4-9.9-1.2l-72.7-18.2C447 439.3 432 420.1 432 398v-41.2l-48-34.3V398c0 44.1 30 82.5 72.7 93.1l72.7 18.2c7.1 1.8 14.3 2.7 21.6 2.7 49.1 0 89-39.8 89-89v-7c0-1.3-.1-2.7-.2-4-7.2-57.9-33.1-119.4-59.6-170.3-26.8-51.5-55.6-94.8-71-116.9-13-18.6-34-28.8-55.8-28.8-38.4 0-69.4 31-69.4 69.3v58.9l-16.6-11.8c-14.7-10.5-23.4-27.5-23.4-45.6V24z"
        }
    ]
};

const FarM = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarM",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 33c10.2-3 21.1 1 26.9 9.8l180 273.5L403.9 42.8c5.9-8.8 16.8-12.8 27-9.8S448 45.4 448 56v400c0 13.3-10.7 24-24 24s-24-10.7-24-24V136.1l-156 237c-4.4 6.7-12 10.8-20 10.8s-15.6-4.1-20-10.8l-156-237V456c0 13.3-10.7 24-24 24S0 469.3 0 456V56c0-10.6 7-19.9 17.1-23z"
        }
    ]
};

const FarMace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m244.8 95 28-84.1C275 4.4 281.1 0 288 0s13 4.4 15.2 10.9l28 84.1c40.4 13.5 72.3 45.4 85.8 85.8l84.1 28c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-84.1 28c-13.5 40.4-45.4 72.3-85.8 85.8l-28 84.1c-2.2 6.5-8.3 10.9-15.2 10.9s-13-4.4-15.2-10.9l-28-84.1c-12.4-4.1-24-10-34.5-17.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l169.3-169.4c-7.3-10.5-13.2-22.1-17.4-34.5l-84.1-28C68.4 237 64 230.9 64 224s4.4-13 10.9-15.2l84.1-28c13.5-40.4 45.4-72.3 85.8-85.8zM288 312a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm-32-88a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarMagnet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMagnet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0 97.2 78.8 176 176 176s176-78.8 176-176v-64h-64v64c0 61.9-50.1 112-112 112s-112-50.1-112-112v-64H48v64zM0 88c0-30.9 25.1-56 56-56h48c30.9 0 56 25.1 56 56v168c0 35.3 28.7 64 64 64s64-28.7 64-64V88c0-30.9 25.1-56 56-56h48c30.9 0 56 25.1 56 56v168c0 123.7-100.3 224-224 224S0 379.7 0 256V88z"
        }
    ]
};

const FarMagnifyingGlassArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMagnifyingGlassArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-133.8-134C399.2 301.7 416 256.8 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm33-289c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h102.1l-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"
        }
    ]
};

const FarMagnifyingGlassChart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMagnifyingGlassChart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-133.8-134C399.2 301.7 416 256.8 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zM104 216v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96v160c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FarMagnifyingGlassDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMagnifyingGlassDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-133.8-134C399.2 301.7 416 256.8 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm20-312c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
        }
    ]
};

const FarMagnifyingGlassLocation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMagnifyingGlassLocation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-133.8-134C399.2 301.7 416 256.8 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm80-240c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6 6 7.3 16.8 7.3 22.7 0 22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarMagnifyingGlassMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMagnifyingGlassMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-133.8-134C399.2 301.7 416 256.8 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm-72-232c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"
        }
    ]
};

const FarMagnifyingGlassPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMagnifyingGlassPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-133.8-134C399.2 301.7 416 256.8 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm-24-120c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FarMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMagnifyingGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 208a160 160 0 1 0-320 0 160 160 0 1 0 320 0zm-30.9 163.1C301.7 399.2 256.8 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-134-133.8z"
        }
    ]
};

const FarMailboxFlagUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMailboxFlagUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M376 224c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24h64c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24h-40v88c0 13.3-10.7 24-24 24zM144 112c-53 0-96 43-96 96v176c0 8.8 7.2 16 16 16h176V208c0-53-43-96-96-96zm107.3 0c22.8 25.5 36.7 59.1 36.7 96v192h224c8.8 0 16-7.2 16-16V208c0-34.9-18.7-65.5-46.6-82.3 9.1-9.9 14.6-23.2 14.6-37.7v-9c47.4 23.6 80 72.5 80 129v176c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64h176v48h-68.7zM104 192h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarMailbox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMailbox",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 208c0-53 43-96 96-96s96 43 96 96v192H64c-8.8 0-16-7.2-16-16V208zm192 240h272c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144H144C64.5 64 0 128.5 0 208v176c0 35.3 28.7 64 64 64h176zm48-240c0-36.9-13.9-70.5-36.7-96H432c53 0 96 43 96 96v176c0 8.8-7.2 16-16 16H288V208zm-184-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zm256 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v24c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-96z"
        }
    ]
};

const FarManatSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarManatSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c-13.3 0-24 10.7-24 24v41.5C73.3 109.3 0 190.1 0 288v168c0 13.3 10.7 24 24 24s24-10.7 24-24V288c0-71.4 51.9-130.6 120-142v310c0 13.3 10.7 24 24 24s24-10.7 24-24V146c68.1 11.4 120 70.7 120 142v168c0 13.3 10.7 24 24 24s24-10.7 24-24V288c0-97.9-73.3-178.7-168-190.5V56c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarMandolin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMandolin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M435.3 3.6C444.8-2.3 457.1-.9 465 7l40 40c7.9 7.9 9.3 20.2 3.4 29.7l-40 64c-3.2 5.1-8.2 8.8-14 10.4l-81.8 22.3L322 224c2.6 81.1-4.5 288-146 288C78.8 512 0 433.2 0 336c0-141.5 206.9-148.6 287.9-145.9l50.6-50.6 22.3-81.9c1.6-5.8 5.3-10.8 10.4-14l64-40zm-246.8 286 51.5-51.5c-22.3.8-47.1 2.8-71.6 7.1-36.9 6.5-68.6 17.3-90.1 32.8C58.9 292.1 48 309.4 48 336c0 70.7 57.3 128 128 128 26.6 0 43.9-10.9 57.9-30.2 15.6-21.5 26.4-53.2 32.8-90.1 4.3-24.5 6.3-49.3 7.1-71.6l-51.5 51.5c1.1 4 1.6 8.1 1.6 12.4 0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48c4.3 0 8.5.6 12.4 1.6z"
        }
    ]
};

const FarMango = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMango",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 1.4c-2.5-.9-5.2-1.4-8-1.4-13.3 0-24 10.7-24 24v72c-49.1 0-98.3 18.7-135.8 56.2-45.8 37.2-67.8 76.7-88.4 113.5-19.1 34.1-36.9 66-71.2 91.8C15 365 7.4 375.4 3.3 387.9c-11.1 33.5 7.1 69.8 40.6 80.9 0 0 100.1 43.3 244.1 43.3 166.5 0 224-147.4 224-224 0-49.1-18.7-98.3-56.2-135.8-16.6-16.6-35.6-29.6-55.8-38.8v54.8c7.7 5.2 15 11.1 21.8 17.9C450 214.3 464 251.1 464 288c0 28.5-11.4 74.2-39.8 111.7-27 35.6-69.3 64.3-136.2 64.3-67.3 0-124.3-10.1-164.4-20.2-20-5-35.6-10-46.1-13.6-5.2-1.8-9.1-3.3-11.6-4.3-1.2-.5-2.1-.8-2.6-1.1l-.5-.2-1.8-.8-2-.7c-8.4-2.7-13-11.7-10.2-20.1 1-3.1 2.8-5.6 5.1-7.4 42.4-31.9 64.6-71.8 83-104.8l3.1-5.6c19.4-34.8 37.9-65.9 74.5-95.7l1.9-1.6 1.7-1.7c28.1-28.1 65-42.2 101.8-42.2v24c0 13.3 10.7 24 24 24s24-10.7 24-24V53.1C385.2 79 414.6 96 448 96h40c13.3 0 24-10.7 24-24 0-39.8-32.2-72-72-72h-88v1.4zM400 288c-8.8 0-16 7.2-16 16 0 44.2-35.8 80-80 80-8.8 0-16 7.2-16 16s7.2 16 16 16c61.9 0 112-50.1 112-112 0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarManhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarManhole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm281.4-140.6c5.8-7.5 14.5-14.7 23.6-11.8 64.4 20.7 111 81.1 111 152.4s-46.6 131.7-111 152.4c-9 2.9-17.8-4.3-23.6-11.8-5.8-7.6-15.1-12.6-25.4-12.6s-19.6 4.9-25.4 12.6c-5.8 7.5-14.5 14.7-23.6 11.8C142.6 387.7 96 327.3 96 256s46.6-131.7 111-152.4c9-2.9 17.8 4.3 23.6 11.8 5.8 7.6 15.1 12.6 25.4 12.6s19.6-4.9 25.4-12.6zM192 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm80-112a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-32 64a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm32 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"
        }
    ]
};

const FarMapLocationDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMapLocationDot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 120c0 8.6-1.8 18.3-5 28.6-5.7 18.4-15.6 38.8-27.4 59.2l-.1.2c-3.1 5.4-6.3 10.7-9.6 16-4.4 7-8.9 14-13.5 20.8l-.4.6c-18.1 26.9-36.7 51.1-49.2 66.6-7.7 9.6-22 9.6-29.6 0-12.4-15.5-31.1-39.7-49.2-66.6-18.4-27.3-36.3-57.5-46.7-84.4-.8-2.1-1.6-4.2-2.3-6.3-4.4-12.6-7-24.4-7-34.6 0-4.7.3-9.3.8-13.8C175.6 46.4 226.4 0 288 0c66.3 0 120 53.7 120 120zm-56 180.6c13.5-18.2 28.8-39.9 42.7-62.4 1.8-2.9 3.6-5.8 5.3-8.8v224.3l128-46.5V154.3l-108.7 39.5c2.2-4.7 4.4-9.3 6.3-14 5.9-14 11-29.2 13.2-44.2l105-38.2c7.4-2.7 15.6-1.6 22 2.9S576 112.1 576 120v304c0 10.1-6.3 19.1-15.8 22.6l-176 64c-5.3 1.9-11.1 1.9-16.4 0L200 449.5l-167.8 61c-7.4 2.7-15.6 1.6-22-2.9S0 495.8 0 488V184c0-10.1 6.3-19.1 15.8-22.6L136 117.7v2.3c0 15.1 3.7 30.7 8.9 45.6L48 200.8v252.9l128-46.5V229.5c1.8 3 3.5 5.9 5.3 8.8 13.9 22.5 29.1 44.2 42.7 62.4v106.5l128 46.5V300.6zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
        }
    ]
};

const FarMapLocation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMapLocation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M403 148.6c3.2-10.3 5-20 5-28.6C408 53.7 354.3 0 288 0c-61.6 0-112.4 46.4-119.2 106.2-.5 4.5-.8 9.1-.8 13.8 0 10.3 2.6 22 7 34.6.7 2.1 1.5 4.2 2.3 6.3 10.4 27 28.3 57.1 46.7 84.4 18.1 26.9 36.7 51.1 49.2 66.6 7.7 9.6 22 9.6 29.6 0 12.4-15.5 31.1-39.7 49.2-66.6.1-.2.3-.4.4-.6 4.6-6.8 9.1-13.7 13.5-20.8 3.3-5.3 6.5-10.7 9.6-16 0-.1.1-.1.1-.2 11.8-20.4 21.8-40.8 27.4-59.2zm-8.3 89.6c-13.9 22.5-29.1 44.2-42.7 62.4v153.1l-128-46.5V300.6c-13.5-18.2-28.8-39.9-42.7-62.4-1.8-2.9-3.6-5.8-5.3-8.8v177.8L48 453.7V200.8l96.9-35.2c-5.2-14.9-8.9-30.5-8.9-45.6v-2.3L15.8 161.4C6.3 164.9 0 173.9 0 184v304c0 7.8 3.8 15.2 10.2 19.7s14.6 5.6 22 2.9l167.8-61 167.8 61c5.3 1.9 11.1 1.9 16.4 0l176-64c9.5-3.4 15.8-12.5 15.8-22.6V120c0-7.8-3.8-15.2-10.2-19.7s-14.6-5.6-22-2.9l-105 38.2c-2.2 15-7.3 30.2-13.2 44.2-2 4.6-4.1 9.3-6.3 14L528 154.3v252.9l-128 46.5V229.5c-1.8 3-3.5 5.9-5.3 8.8z"
        }
    ]
};

const FarMapPin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMapPin",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 144a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm120 142c68.1-11.4 120-70.7 120-142C304 64.5 239.5 0 160 0S16 64.5 16 144c0 71.4 51.9 130.6 120 142v202c0 13.3 10.7 24 24 24s24-10.7 24-24V286z"
        }
    ]
};

const FarMap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMap",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M565.6 36.2C572.1 40.7 576 48.1 576 56v336c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1.3l-183.9-61.2-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3l183.9 61.2 160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5v284.7l120-45.7V90.8L48 136.5zm312 286.2V137.3l-144-48v285.4l144 48zm48-1.5 120-45.7V90.8l-120 45.7v284.7z"
        }
    ]
};

const FarMarker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMarker",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 113.9 225.9 224l62.1 62.1L447 127c17.1-17.1 17.1-44.9 0-62.1s-44.9-17.1-62.1 0l-15 15-33.9 34zm-144 144-58.5 58.5c-38.8 38.8-66 87.5-78.6 140.7 53.2-12.7 101.9-39.9 140.7-78.6l58.5-58.5-62.1-62.1zm40.4-234.2c27.9-18.4 65.9-15.4 90.5 9.2L336 46.1l15-15c35.9-35.9 94.1-35.9 130-.1 35.9 35.9 35.9 94.1 0 129.9L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8l80-80L199 183l69.1-69.1 6.2-6.2L285.1 97l17-17L289 66.9c-9.4-9.4-24.6-9.3-33.9 0L169 153c-4.1 4.1-9.3 6.4-14.7 6.9-6.9.7-14-1.7-19.3-6.9-9.4-9.4-9.4-24.6 0-33.9L221.1 33c3.5-3.5 7.3-6.6 11.3-9.2z"
        }
    ]
};

const FarMarsAndVenusBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMarsAndVenusBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M520 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h38.1l-54.2 54.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160 0 80.2 59 146.6 136 158.2V416h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v24c0 13.3 10.7 24 24 24s24-10.7 24-24v-24h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32v-33.8c77-11.6 136-78 136-158.2 0-31.4-9-60.7-24.7-85.4L592 81.9V112c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24h-96zM288 224a112 112 0 1 1 224 0 112 112 0 1 1-224 0zM176 8c-8.9 0-17 4.9-21.2 12.7l-30.1 56.8-63.1-11.9C52.9 64 44 67.3 38.4 74.2s-6.8 16.4-3.3 24.5l25.6 58.9-48.6 42c-6.7 5.8-9.7 14.8-7.7 23.5s8.6 15.5 17.1 17.8l62 16.7 2.5 64.2c.3 8.9 5.6 16.8 13.6 20.7s17.5 3 24.6-2.3l51.7-38 51.7 38c6.4 4.7 14.7 5.9 22.1 3.3-16.9-21.2-29.4-46.1-36.2-73.3L190.1 253c-8.5-6.2-20-6.2-28.4 0l-29.5 21.7-1.4-36.6c-.4-10.5-7.6-19.5-17.7-22.2l-35.4-9.6 27.7-24c7.9-6.9 10.5-18.1 6.3-27.7l-14.5-33.5 36 6.7c10.3 1.9 20.7-3.1 25.6-12.3L176 83.2l17.2 32.4c4.9 9.3 15.3 14.3 25.6 12.3l16.8-3.1c14.3-23.6 33.4-43.8 56.1-59.3-.4.1-.9.1-1.3.2l-63.1 11.8-30.1-56.8C193 12.9 184.9 8 176 8z"
        }
    ]
};

const FarMarsAndVenus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMarsAndVenus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 24c0 13.3 10.7 24 24 24h38.1l-42.9 42.9C340.3 64.2 300 48 256 48c-97.2 0-176 78.8-176 176 0 89.1 66.2 162.7 152 174.4v16h-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v24.2h24-24c0 13.3 10.7 24 24 24s24-10.7 24-24h-24 24v-1 .4-1.3.3-1.1.1-10.1.1-4.4.4-6h24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24v-17.4c85.8-11.7 152-85.3 152-174.4 0-35.8-10.7-69.2-29.1-97L448 81.9V120c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24h-96c-13.3 0-24 10.7-24 24zm-96 72a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
        }
    ]
};

const FarMarsDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMarsDouble",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 56c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24v-54.1l-83.7 83.7C338.7 227.2 352 264.1 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7L366.1 80H312c-13.3 0-24-10.7-24-24zM176 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm304-273.9L558.1 80H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h112c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24v-54.1l-83.7 83.7C530.7 227.2 544 264.1 544 304c0 97.2-78.8 176-176 176-22.6 0-44.2-4.3-64-12 14.3-11.2 27.1-24.2 38-38.6 8.4 1.7 17.1 2.6 26 2.6 70.7 0 128-57.3 128-128 0-35.7-14.7-68.1-38.3-91.3 13.6-10.2 22.3-26.4 22.3-44.7v-9.9z"
        }
    ]
};

const FarMarsStrokeRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMarsStrokeRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 256a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm302.4-24C370.7 146.2 297.1 80 208 80c-97.2 0-176 78.8-176 176s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152H416v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48h78.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H464V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48h-33.6z"
        }
    ]
};

const FarMarsStrokeUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMarsStrokeUp",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175.6 5.8c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l16.4-14V128h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v17.8C59 205.4 0 271.8 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-80.2-59-146.6-136-158.2V176h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V76.2l16.4 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48zM160 240a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"
        }
    ]
};

const FarMarsStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMarsStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 24c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9L409.9 136l31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31-27.7 27.7C370.7 227.2 384 264.1 384 304c0 97.2-78.8 176-176 176S32 401.2 32 304s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7l27.8-27.7-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L430.1 48H376c-13.3 0-24-10.7-24-24zM208 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
        }
    ]
};

const FarMars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMars",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-83.7 83.7C252.8 141.3 215.9 128 176 128 78.8 128 0 206.8 0 304s78.8 176 176 176 176-78.8 176-176c0-39.9-13.3-76.8-35.7-106.3l83.7-83.8V168c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24H312zM48 304a128 128 0 1 1 256 0 128 128 0 1 1-256 0z"
        }
    ]
};

const FarMartiniGlassCitrus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMartiniGlassCitrus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 240c-14.3 0-27.9-3.1-40.1-8.7l-35.4 35.4c22 13.5 47.8 21.3 75.5 21.3 79.5 0 144-64.5 144-144S511.5 0 432 0c-62.7 0-116 40.1-135.8 96h52.6c16.6-28.7 47.6-48 83.2-48 53 0 96 43 96 96s-43 96-96 96zM24 128c-9.7 0-18.5 5.8-22.2 14.8S.1 162.1 7 169l177 177v118h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64V345.9L409 169c6.9-6.9 8.9-17.2 5.2-26.2S401.7 128 392 128H24zm310.1 48L208 302.1 81.9 176h252.2z"
        }
    ]
};

const FarMartiniGlassEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMartiniGlassEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 35.3C0 15.8 15.8 0 35.3 0h441.4C496.2 0 512 15.8 512 35.3c0 9.4-3.7 18.3-10.3 25L280 281.9V464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V281.9L10.3 60.3C3.7 53.7 0 44.7 0 35.3zm256 202.8L446.1 48H65.9L256 238.1z"
        }
    ]
};

const FarMartiniGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMartiniGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M35.3 0C15.8 0 0 15.8 0 35.3c0 9.4 3.7 18.3 10.3 25L232 281.9V464h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80V281.9L501.7 60.3c6.6-6.6 10.3-15.6 10.3-25C512 15.8 496.2 0 476.7 0H35.3zm282.8 176L256 238.1 193.9 176h124.2zm48-48H145.9l-80-80h380.2l-80 80z"
        }
    ]
};

const FarMaskFace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMaskFace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 112c17.7 0 35 5.2 49.8 15.1l37.1 24.8c23.7 15.8 51.4 24.2 79.9 24.2h9.2v48c0 59.5-29.5 112.1-74.7 143.9l-3.1.8.3 1.2c-28.1 19-62 30.1-98.5 30.1S249.6 389 221.5 370l.3-1.2-3.1-.8c-45.2-31.9-74.7-84.5-74.7-144v-48h9.2c28.4 0 56.2-8.4 79.9-24.2l37.1-24.8c14.7-9.8 32-15.1 49.8-15.1zM96 224c0 45.1 13.4 87.2 36.3 122.3l-29.8-7.4c-32-8-54.5-36.8-54.5-69.9v-85c0-4.4 3.6-8 8-8h40v48zm-5.1 161.5 108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269v-85c0-30.9-25.1-56-56-56h-97.2c-19 0-37.5-5.6-53.3-16.1l-37.1-24.8C373.8 72 347.2 64 320 64s-53.8 8-76.4 23.1l-37.1 24.8a96.2 96.2 0 0 1-53.3 16.1H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4zm446.6-46.6-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3v-48h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM208 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm-16 80c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm48 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"
        }
    ]
};

const FarMaskSnorkel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMaskSnorkel",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M552 32c13.3 0 24 10.7 24 24v104h-48V56c0-13.3 10.7-24 24-24zm-24 344.6V192h48v184.6c0 74.8-60.6 135.4-135.4 135.4-67.4 0-124.5-49.5-134-116.2l-2.3-16.4c-1.9-13.1 7.2-25.3 20.4-27.2s25.3 7.2 27.2 20.4l2.3 16.4c6.2 43.1 43 75 86.5 75 48.3 0 87.4-39.1 87.4-87.4zM64 112c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h79.7c7.1 0 13.4-4.7 15.4-11.6l3.4-11.7c17.7-61.9 105.4-61.9 123.1 0l3.4 11.7c2 6.9 8.2 11.6 15.4 11.6H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16H64zm240.3 176c-22.3 0-42.4-11.5-54-29.6-.7-1-1.3-2.1-1.9-3.2-.3-.5-.6-1-.8-1.5-2-3.8-3.6-7.8-4.8-12.1l-.6-2.2-2.7-9.6c-4.4-15.5-26.3-15.5-30.8 0l-2.7 9.6-.6 2.2c-1.2 4.2-2.8 8.3-4.8 12.1-.3.5-.5 1-.8 1.5-.6 1.1-1.2 2.2-1.9 3.2-11.5 18.1-31.7 29.6-54 29.6H64c-35.3 0-64-28.7-64-64v-96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64h-79.7z"
        }
    ]
};

const FarMaskVentilator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMaskVentilator",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 300.8c0 26.7 8.9 52.3 24.7 73.6-.5-4.3-.7-8.7-.7-13.1 0-31.9 12.4-72.4 31.4-104.9 9.6-16.5 21.7-32.1 36-43.8 14.3-11.7 32.1-20.6 52.6-20.6 20.4 0 38.2 8.9 52.4 20.7s26.3 27.3 36 43.8c19.1 32.5 31.6 73 31.6 104.9 0 4.3-.2 8.5-.6 12.7 15.6-21.3 24.6-46.7 24.6-73.3 0-38.2-17.9-96.6-49.1-145.7C382.2 103.7 346.7 80 320 80c-27.3 0-62.7 23.8-95.2 75-31.1 49.1-48.8 107.5-48.8 145.8zm72 60.5c0 21.8 9.2 41.2 24 54.5v58.6c-45.3-10.8-84-36.5-109.8-71.1l-71.3-17.8C37.5 372.1 0 324.1 0 269v-85c0-30.9 25.1-56 56-56h129.1c34.7-54.2 82.3-96 134.9-96 52.1 0 99.7 41.8 134.5 96H584c30.9 0 56 25.1 56 56v85c0 55.1-37.5 103.1-90.9 116.4l-71.6 17.9c-26 34.6-64.7 60.2-109.5 71v-58.6c14.7-13.3 24-32.6 24-54.3 0-21.6-9.2-53.7-25-80.6-7.8-13.2-16.4-23.9-25.1-31.1s-16-9.7-21.9-9.7c-6 0-13.5 2.6-22.1 9.7-8.7 7.1-17.3 17.8-25.1 31-15.7 26.8-24.8 59-24.8 80.6zm257.6-14.5 31.8-8c32.1-8 54.5-36.8 54.5-69.9V184c0-4.4-3.6-8-8-8H480.7c19.8 43.2 31.3 88.7 31.3 124.8 0 16-2.2 31.4-6.4 46.1zM159.1 176H56c-4.4 0-8 3.6-8 8v85c0 33 22.5 61.8 54.5 69.9l31.8 7.9c-4.1-14.7-6.3-30.1-6.3-46 0-36.1 11.4-81.6 31.1-124.8zM296 328c0-13.3 10.7-24 24-24s24 10.7 24 24v184h-48V328z"
        }
    ]
};

const FarMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMask",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M91.4 162.3C61 188.5 48 225.2 48 272c0 43.9 15.3 74.8 36.8 95 22 20.6 53.7 33 91.2 33h8.4c6.1 0 11.6-3.4 14.3-8.8l23.2-46.3 39 19.5-39-19.5C234.4 319.8 260 304 288 304s53.6 15.8 66.1 40.8l23.2 46.3c2.7 5.4 8.2 8.8 14.3 8.8h8.4c37.4 0 69.2-12.4 91.2-33 21.5-20.2 36.8-51.1 36.8-95 0-46.8-13-83.5-43.4-109.7C452.9 134.9 394.3 112 288 112s-164.9 22.9-196.6 50.3zM0 272C0 160 64 64 288 64s288 96 288 208-80 176-176 176h-8.4c-24.2 0-46.4-13.7-57.2-35.4l-23.2-46.3c-4.4-8.8-13.3-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-23.2 46.3c-10.8 21.7-33 35.4-57.2 35.4H176C80 448 0 384 0 272zm96-16a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarMasksTheater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMasksTheater",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M376.1 32.1c-41.2.7-71.8 7.8-94.3 16.7-23.1-2-53.9-1.4-94 5.2C95.6 69.1 60.7 98 49.3 110.7l27.5 161.2c4.9 28.7 17.5 52.2 36.1 67.2 20.3 16.4 45.2 34 70.7 46.2 10.4 5 20 8.6 28.8 11.1 1.7 3.1 3.4 6.1 5.3 9.2 8.1 13 17.9 27.5 29.1 42.1-58 4.9-123.3-37.8-165-71.7-29.7-24-46.8-59-53.2-96.2L.8 116.1c-1.7-9.8-1-19.9 4.7-28C20.5 67 63.6 25.9 179.8 6.9S350.5 12.8 371.6 28c1.7 1.2 3.2 2.5 4.5 4zM194 282.3c-15.6 5.8-29.7 14-42.1 24.2-6.6 5.4-16.8 1.7-15.6-6.6 5.4-35 31.3-64.6 67.2-74.3l-8.5 49.6c-.4 2.3-.8 4.7-1.1 7zm-17.3-128.6c4.5-3.2 11.1-2.2 12.2 3.1.1.5.2 1.1.3 1.6 3.7 21.7-11.2 42.2-33.4 45.8s-43.1-11-46.8-32.7c-.1-.5-.2-1.1-.2-1.6-.7-5.4 5.3-8.4 10.5-6.9 9.3 2.8 19.5 3.6 29.8 1.9s19.6-5.7 27.5-11.3zm208.4 356.9c-60-9.8-110.5-74.6-140.1-122-20.1-32.2-24.7-70.7-18.3-107.9L254.6 117c1.7-9.8 5.6-19.1 13.8-24.9 21.1-15.3 75.6-40.3 191.8-21.2s159.3 60.1 174.3 81.2c5.8 8.1 6.4 18.2 4.7 28l-27.9 163.7c-6.4 37.2-23.5 72.2-53.2 96.2-43.7 35.4-113.1 80.5-173 70.7zm-47-80.7c20.7 20.3 39.5 31 55 33.6s36.9-1.6 63.2-14.2c25.5-12.2 50.4-29.8 70.7-46.2 18.6-15.1 31.2-38.6 36.1-67.3l27.5-161.2c-11.3-12.6-46.2-41.5-138.5-56.6s-134.9 1-149.9 9.4l-27.5 161.2c-4.9 28.7-.8 54.9 11.8 75.1 13.7 22 31.5 46.6 51.5 66.2zm57.3-193.4c-7.9-5.6-17.2-9.6-27.5-11.3s-20.4-.9-29.8 1.9c-5.3 1.6-11.2-1.5-10.5-6.9.1-.5.2-1.1.2-1.6 3.7-21.7 24.6-36.3 46.8-32.7s37.1 24.1 33.4 45.8c-.1.5-.2 1.1-.3 1.6-1.1 5.3-7.8 6.3-12.2 3.1zm140.4 17.9c-1.1 5.3-7.8 6.3-12.2 3.1-7.9-5.6-17.2-9.6-27.5-11.3s-20.4-.9-29.8 1.9c-5.3 1.6-11.2-1.5-10.5-6.9.1-.5.2-1.1.2-1.6 3.7-21.7 24.6-36.3 46.8-32.7s37.1 24.1 33.4 45.8c-.1.5-.2 1.1-.3 1.6zM515.5 311c7.9-3.2 16.5 3.5 12.8 11.1-21.1 44.3-70.3 71.2-121.9 62.8s-89.2-49.7-94.4-98.2c-.9-8.3 9.4-12 15.8-6.4 24.3 21.2 54.8 36.2 89.3 41.8s68.3 1.2 98.3-11.1z"
        }
    ]
};

const FarMattressPillow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMattressPillow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 112v288H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h176zm48 0h288c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H288V112zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 112v160c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FarMaximize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMaximize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M156.1 80H80v76.1L156.1 80zM32 192V64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v2.7c0 8.5-3.4 16.6-9.4 22.6L169 135l87 87 87-87-45.6-45.6c-6-6-9.4-14.1-9.4-22.6V64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-2.7c-8.5 0-16.6-3.4-22.6-9.4L377 169l-87 87 87 87 45.7-45.7c6-6 14.1-9.4 22.6-9.4h2.7c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32v-2.7c0-8.5 3.4-16.6 9.4-22.6L343 377l-87-87-87 87 45.7 45.7c6 6 9.4 14.1 9.4 22.6v2.7c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h2.7c8.5 0 16.6 3.4 22.6 9.4L135 343l87-87-87-87-45.6 45.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32zm323.9 240H432v-76.1L355.9 432zM80 355.9V432h76.1L80 355.9zM355.9 80l76.1 76.1V80h-76.1z"
        }
    ]
};

const FarMeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMeat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M443.2 138.7c8.1 13.4 13.9 26.9 17.3 39.8.5 1.9.9 3.8 1.3 5.7 2.4 11.6 2.8 22.5.9 32.1-1.9 10.1-6.2 18.8-13 25.6l-.2.2c-29 28.7-92.5 11.9-142-37.6-49.5-49.7-66.3-113.4-37.3-142.3 1.8-1.8 3.7-3.4 5.8-4.8.7-.5 1.3-.9 2-1.3 3-1.9 6.3-3.5 9.8-4.7.6-.2 1.2-.4 1.9-.6 32.7-10.1 82.4 8.5 122.8 48.9 12.4 12.4 22.8 25.7 30.8 39.1zm-54.4 163.4C363 323.9 330.1 336 296 336h-88c-17.7 0-32-14.3-32-32v-88c0-34.1 12.1-67 33.9-92.8.8 5 1.9 9.9 3.1 14.6 9.3 35.3 30.9 70.9 60.6 100.6s65.3 51.4 100.6 60.6c4.7 1.2 9.6 2.3 14.6 3.1zM212.6 384H296c50.9 0 99.8-20.2 135.8-56.2l51.7-51.8.3-.3c23.7-23.7 29.9-54.3 27.8-82.5-.7-9.4-2.3-18.5-4.6-27-5.8-22-16.4-44.1-30.7-64.8-8.7-12.5-18.7-24.6-30-35.8C416.6 35.9 381.1 14.3 345.8 5c-34-8.9-78-8.3-109.5 23.2l-52 52c-36 36-56.2 84.8-56.2 135.8v83.4c0 7.1-2.8 13.9-7.8 18.9-10.3 10.3-26.9 9.7-40.7 5-6.2-2.2-12.8-3.3-19.6-3.3-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12 0 33.1 26.9 60 60 60s60-26.9 60-60c0-6.8-1.1-13.4-3.2-19.5-4.7-13.8-5.3-30.4 5-40.7 5-5 11.8-7.8 18.9-7.8zm175-204.4c8.9-8.9 3.8-28.5-11.5-43.8s-34.9-20.4-43.8-11.5-3.8 28.5 11.5 43.8 34.9 20.4 43.8 11.5z"
        }
    ]
};

const FarMedal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMedal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m4.1 38.2 102.3 153.3c11.2-11.6 23.7-21.9 37.3-30.6L68.4 48h64.5l54.9 91.5c15.8-5.5 32.4-9.1 49.6-10.6l-6.1-10.1-62-103.3C163.5 5.9 153.1 0 141.9 0H24.6C11 0 0 11 0 24.6c0 4.8 1.4 9.6 4.1 13.6zm276.6 80.5-6.1 10.1c17.2 1.5 33.8 5.2 49.6 10.6l55-91.4h64.5l-75.3 112.9c13.6 8.7 26.1 19 37.3 30.6L507.9 38.2c2.7-4 4.1-8.8 4.1-13.6C512 11 501 0 487.4 0H370.1c-11.2 0-21.7 5.9-27.4 15.5l-61.9 103.2zM256 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm7.2-257.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4l-43 6.2c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4l38.4-20c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4l-7.3-42.8c-.4-2.6.4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4l-19.2-38.9z"
        }
    ]
};

const FarMegaphone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMegaphone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M552 32c-13.3 0-24 10.7-24 24v5.7L48 192.6V184c0-13.3-10.7-24-24-24S0 170.7 0 184v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-8.6l117.6 32.1c-3.6 10.2-5.6 21.1-5.6 32.5 0 53 43 96 96 96 46.9 0 86-33.6 94.3-78.1L528 450.3v5.7c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm-24 368.6L48 269.7v-27.4l480-130.9v289.2zM208 384c0-7.1 1.5-13.8 4.3-19.8l91.5 24.9c-2.6 24.1-23 42.8-47.7 42.8-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FarMelonSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMelonSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7 391c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17c115.6 115.6 302.6 116 418.3.3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0L319 79c-6.2 6.2-8.5 15.3-6.1 23.7l.1.4c.1.5.3 1.3.6 2.4.5 2.3 1.2 5.8 1.8 10.4 1.2 9.2 2.1 22.3.6 37.9-2.9 30.9-15.1 71.3-53 109.2-42.3 42.3-82.7 54-111.6 55.9-14.7 1-26.8-.5-35-2.2-4.1-.8-7.2-1.7-9.2-2.3-1-.3-1.7-.5-2-.7l-.3-.1c-8.9-3.4-19.1-1.4-25.9 5.4L7 391zm306-288.3v-.1zm51.8 35.2c12.3 23.4 19.2 49.9 19.2 78.1 0 92.8-75.2 168-168 168-26.2 0-51-6-73.1-16.7 3.8 0 7.7-.2 11.8-.4 39.9-2.7 91.4-19 142.2-69.9 47.2-47.2 63-98.7 66.8-138.6.7-7.2 1-14.1 1-20.4zM81.2 384.8C118.1 414.3 165 432 216 432c119.3 0 216-96.7 216-216 0-51-17.7-97.9-47.2-134.8l22.4-22.4c80.4 97.4 75.3 241.5-15.8 332.6s-235.2 96.2-332.6 15.8l22.4-22.4z"
        }
    ]
};

const FarMelon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMelon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0-25.8-4.7-50.4-13.2-73.2-14.9 51.3-51.2 110.5-104.3 163.6s-112.3 89.4-163.6 104.3c22.8 8.6 47.4 13.2 73.2 13.2 114.9 0 208-93.1 208-208zM61.2 329.2c14.9-51.3 51.2-110.5 104.3-163.6S277.8 76.2 329.1 61.3C306.4 52.7 281.8 48 256 48 141.1 48 48 141.1 48 256c0 25.8 4.7 50.4 13.2 73.2zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm403-147c-5.2-5.2-24.1-13.9-67.8.7-40.7 13.6-89.8 44-135.7 89.9s-76.3 95-89.9 135.7c-14.6 43.7-5.8 62.6-.7 67.8s24.1 13.9 67.8-.7c40.7-13.6 89.9-44 135.7-89.9s76.3-95 89.9-135.7c14.6-43.7 5.8-62.6.7-67.8z"
        }
    ]
};

const FarMemoCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMemoCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c8.8 0 16 7.2 16 16v156.5c14.6-9.5 30.8-17 48-21.8V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c3.3 0 6.6-.3 9.7-.7-17.9-12.8-33.3-28.8-45.3-47.3H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm456 48a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarMemoCircleInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMemoCircleInfo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h220.5c12 18.4 27.4 34.5 45.3 47.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v134.6c-17.2 4.9-33.4 12.3-48 21.8V64c0-8.8-7.2-16-16-16zM96 152c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm24 72h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24zm312-96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16v48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16v-64c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarMemoPad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMemoPad",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 128v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128h352zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm32 200c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarMemo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMemo",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm120 64h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarMemory = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMemory",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112h448c8.8 0 16 7.2 16 16v8.4c-19.6 17.5-32 43.1-32 71.6s12.4 54 32 71.6V304H48v-24.4C67.6 262 80 236.5 80 208s-12.4-54-32-71.6V128c0-8.8 7.2-16 16-16zm464 240v48h-56c0-13.3-10.7-24-24-24s-24 10.7-24 24h-32c0-13.3-10.7-24-24-24s-24 10.7-24 24h-32c0-13.3-10.7-24-24-24s-24 10.7-24 24h-32c0-13.3-10.7-24-24-24s-24 10.7-24 24h-32c0-13.3-10.7-24-24-24s-24 10.7-24 24H48v-48h480zM64 64C28.7 64 0 92.7 0 128v23.4c0 6.8 4.4 12.6 10.1 16.3C23.3 176.3 32 191.1 32 208s-8.7 31.7-21.9 40.3C4.4 252 0 257.8 0 264.6V416c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V264.6c0-6.8-4.4-12.6-10.1-16.3-13.2-8.6-21.9-23.4-21.9-40.3s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zm104 80c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24zm120 0c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24zm120 0c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarMenorah = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMenorah",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M2.7 49.7 20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4l18.1 42.3c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64v-1.2c0-4.5.9-8.9 2.7-13.1zm96 0 18.1-42.3c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM212.8 7.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18-42.3zm77.8 42.4 18.2-42.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM404.8 7.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18-42.3zm77.8 42.4 18.2-42.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM596.8 7.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18-42.3zM24 128c13.3 0 24 10.7 24 24v128c0 22.1 17.9 40 40 40h208V152c0-13.3 10.7-24 24-24s24 10.7 24 24v168h208c22.1 0 40-17.9 40-40V152c0-13.3 10.7-24 24-24s24 10.7 24 24v128c0 48.6-39.4 88-88 88H344v96h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h144v-96H88c-48.6 0-88-39.4-88-88V152c0-13.3 10.7-24 24-24zm128 24v136h-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0v136h-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm192 0v136h-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0v136h-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarMercury = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMercury",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M73 5.3C83.3-3 98.4-1.4 106.7 9c18.5 23.1 51.4 38.9 84.9 39h.6c33.5-.1 66.4-15.9 84.9-39 8.5-10.4 23.6-12 33.9-3.7s12 23.4 3.7 33.7c-9.9 12.4-22.2 23.1-36 31.8C332 101.1 368 158.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-25.6C82.2 386.7 16 313.1 16 224c0-65.7 36-122.9 89.3-153.2-13.8-8.7-26.1-19.4-36-31.8C61 28.7 62.6 13.6 73 5.3zM192 96h-.3C121.1 96.2 64 153.4 64 224c0 70.7 57.3 128 128 128s128-57.3 128-128c0-70.6-57.1-127.8-127.7-128h-.3z"
        }
    ]
};

const FarMerge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMerge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88c0-13.3 10.7-24 24-24h120.2c17.5 0 34 8.2 44.5 22.1l108.8 142.7c1.5 2 3.9 3.2 6.4 3.2h126.2l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H303.8c-2.5 0-4.9 1.2-6.4 3.2L188.7 425.9c-10.6 13.9-27.1 22.1-44.5 22.1H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h120.2c2.5 0 4.9-1.2 6.4-3.2L257.8 256 150.5 115.2c-1.5-2-3.9-3.2-6.4-3.2H24c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarMessageArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v118.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V120z"
        }
    ]
};

const FarMessageArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM216 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24H216z"
        }
    ]
};

const FarMessageArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM280 296V177.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V296c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarMessageBot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageBot",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 368H160c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H357.3l-12.8 9.6L272 432v-64zM96 208v144c0 35.3 28.7 64 64 64h64v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8.2-.2 101.3-76H480c35.3 0 64-28.7 64-64V208h36.3c5.5 9.6 15.9 16 27.7 16 17.7 0 32-14.3 32-32s-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16H544V64c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64v112H59.7c-5.5-9.6-15.9-16-27.7-16-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16H96zm80-80v128c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H208c-17.7 0-32 14.3-32 32zm32 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarMessageCaptions = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageCaptions",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm-224 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
        }
    ]
};

const FarMessageCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM369 153c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 153z"
        }
    ]
};

const FarMessageCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM217 161c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zm112-34c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"
        }
    ]
};

const FarMessageDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM276 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
        }
    ]
};

const FarMessageDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarMessageExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM256 80c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarMessageHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM144 173.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FarMessageImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h96zm48 124-.2.2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3L208 492zm88-348c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5S390 304 384 304H160c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8l48-64c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l9.6 12.8 52.4-76.3c3-4.3 7.9-6.9 13.2-6.9zm-120-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarMessageLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"
        }
    ]
};

const FarMessageMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM224 128v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarMessageMiddleTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageMiddleTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343.5 144H448c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h104.5c14.2 0 27.8-6.3 36.9-17.3L256 66l50.6 60.7c9.1 10.9 22.6 17.3 36.9 17.3zm-175-48H64c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H343.5L268.3 5.8c-3-3.7-7.6-5.8-12.3-5.8s-9.3 2.1-12.3 5.8L168.5 96z"
        }
    ]
};

const FarMessageMiddle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageMiddle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343.5 368H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h104.5c14.2 0 27.8 6.3 36.9 17.3L256 446l50.6-60.7c9.1-10.9 22.6-17.3 36.9-17.3zm-175 48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H343.5l-75.2 90.2c-3 3.6-7.5 5.8-12.3 5.8s-9.3-2.1-12.3-5.8L168.5 416z"
        }
    ]
};

const FarMessageMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM184 184c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarMessageMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM352 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V96z"
        }
    ]
};

const FarMessagePen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessagePen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zm133-369.2c-14.7-14.7-38.6-14.7-53.3 0l-14.9 15 53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 232.5c-4.1 4.1-7 9.2-8.4 14.9l-9.2 36.6c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9-53.3-53.3-71.9 71.9z"
        }
    ]
};

const FarMessagePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessagePlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM232 296c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FarMessageQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zm-38-374.9-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L244 181.6c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarMessageQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageQuote",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM160 112c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V144c0-17.7-14.3-32-32-32h-48zm224 80v-48c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V192z"
        }
    ]
};

const FarMessageSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128c-23.6 0-44.2 12.7-55.3 31.7L38.8 5.1zm73.3 57.4c.7-8.1 7.6-14.5 15.9-14.5h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16h-10.2L112.1 62.5zM224 368h-96c-8.8 0-16-7.2-16-16V184.2l-48-37.8V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8.2-.2 101.3-76h32.8l-54.4-42.9c-2.5 1.3-4.9 2.8-7.2 4.5L272 432v-16c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FarMessageSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageSmile",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-169.5 62.1c-9.9 8.8-10.7 24-1.9 33.9 26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"
        }
    ]
};

const FarMessageSms = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageSms",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zm-3.6-343.6c-4.9 1.6-8.2 6.2-8.2 11.4v96c0 6.6 5.4 12 12 12s12-5.4 12-12v-60l26.4 35.2c2.3 3 5.8 4.8 9.6 4.8s7.3-1.8 9.6-4.8L292 196v60c0 6.6 5.4 12 12 12s12-5.4 12-12v-96c0-5.2-3.3-9.8-8.2-11.4s-10.3.1-13.4 4.2L256 204l-38.4-51.2c-3.1-4.1-8.5-5.8-13.4-4.2zM108 182.9c0-3.1 1.3-5.3 4.8-7.4 3.9-2.3 9.6-3.6 15-3.5 6.9.1 17.4 1.7 24.3 3.5 6.4 1.7 13-2.1 14.7-8.5s-2.1-13-8.5-14.7c-8.6-2.3-21-4.2-30.1-4.3-8.7-.1-19 1.8-27.6 6.8-9 5.4-16.6 14.7-16.6 28.2.1 12.9 7.6 21.1 15.8 26 7.2 4.3 16.2 7 23.5 9.2l1.1.3c8.4 2.5 14.6 4.6 19 7.3 3.7 2.3 4.5 4.1 4.5 6.6.1 3.9-1.5 6.3-4.6 8.2-3.6 2.2-9.1 3.5-15 3.4-7.9-.3-15.4-2.8-24.9-6-1.3-.4-2.7-.9-4.1-1.4-6.3-2.1-13.1 1.3-15.2 7.6s1.3 13.1 7.6 15.2c1.2.4 2.4.8 3.7 1.3 9.1 3.1 20.3 6.9 32 7.3 9.2.3 19.8-1.6 28.5-7 9.2-5.7 16.1-15.4 15.9-28.9-.2-12.9-7.4-21.3-15.8-26.6-7.5-4.7-17-7.6-24.5-9.8l-.4-.1c-8.5-2.6-14.8-4.5-19.2-7.2-3.7-2.2-4.2-3.8-4.2-5.6zm256 0c0-3.1 1.3-5.3 4.8-7.4 3.9-2.3 9.6-3.6 15-3.5 6.6.1 13.7 1.5 21.1 3.5 6.4 1.7 13-2.1 14.7-8.5s-2.1-13-8.5-14.7c-8-2.1-17.4-4.2-26.9-4.3-8.7-.1-19 1.8-27.6 6.8-9 5.3-16.6 14.6-16.5 28.1.1 12.9 7.6 21.1 15.8 26 7.2 4.3 16.2 7 23.5 9.2l1.1.3c8.4 2.5 14.6 4.6 19 7.3 3.7 2.3 4.5 4.1 4.5 6.6.1 3.9-1.5 6.3-4.6 8.2-3.6 2.2-9.1 3.5-15 3.4-7.6-.2-14.7-2.7-23.8-5.8-1.5-.5-3.1-1.1-4.8-1.6-6.3-2.1-13.1 1.3-15.2 7.6s1.3 13.1 7.6 15.2c1.3.4 2.7.9 4.1 1.4 8.9 3.1 19.8 6.8 31.3 7.2 9.2.3 19.8-1.6 28.5-7 9.2-5.7 16.1-15.4 15.9-28.9-.2-12.9-7.4-21.3-15.8-26.6-7.5-4.7-17-7.6-24.5-9.8l-.4-.1c-8.5-2.6-14.8-4.5-19.2-7.2-3.7-2.2-4.2-3.8-4.2-5.6z"
        }
    ]
};

const FarMessageText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageText",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM168 112c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v136c0 13.3 10.7 24 24 24s24-10.7 24-24V160h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H168z"
        }
    ]
};

const FarMessageXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessageXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432v-16zm-.2 76.2.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l17.1-12.8 5.1-3.8zM175 127c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarMessage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h96zm48 124-.2.2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3L208 492z"
        }
    ]
};

const FarMessagesDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessagesDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 48c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h48c13.3 0 24 10.7 24 24v19.2l58.7-39.2c3.9-2.6 8.6-4 13.3-4h128c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H72zM0 72C0 32.2 32.2 0 72 0h272c39.8 0 72 32.2 72 72v176c0 39.8-32.2 72-72 72H223.3l-90 60c-7.4 4.9-16.8 5.4-24.6 1.2S96 368.9 96 360v-40H72c-39.8 0-72-32.2-72-72V72zm256 280h48v24c0 13.3 10.7 24 24 24h96c4.7 0 9.4 1.4 13.3 4l58.7 39.2V424c0-13.3 10.7-24 24-24h48c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H448v-48h120c39.8 0 72 32.2 72 72v176c0 39.8-32.2 72-72 72h-24v40c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-90-60H328c-39.8 0-72-32.2-72-72v-24zM224 79.1v10.4c5.9.9 11.6 2.3 16.8 3.6 8.6 2.2 13.7 10.9 11.5 19.5s-10.9 13.7-19.5 11.5c-8.8-2.3-17.3-3.9-25-4-6.4-.1-13 1.4-17.4 3.9-3.9 2.2-4.8 4.3-4.8 6.8v.1c0 1 0 2.2 4.1 4.6 5.1 3 12.5 5.2 22.7 8.2l.5.2c9 2.6 20.4 6 29.6 11.6 10.2 6.3 19.6 16.6 19.8 32.8.2 16.7-8.6 28.6-20 35.5-5.7 3.4-12 5.7-18.4 7v10.3c0 8.8-7.2 16-16 16s-16-7.2-16-16V230c-8.2-1.7-15.8-4.3-22.5-6.5-1.7-.6-3.3-1.1-4.9-1.6-8.4-2.7-13-11.7-10.3-20.2s11.7-13 20.2-10.3c2 .6 3.9 1.3 5.8 1.9 10.9 3.6 19.2 6.4 28.2 6.6 6.9.2 13.3-1.3 17.3-3.7 3.3-2 4.6-4.2 4.6-7.7 0-1.8-.4-3.4-4.5-5.9-5-3.1-12.4-5.4-22.5-8.4l-1.4-.4c-8.7-2.5-19.7-5.8-28.4-10.9-10.1-5.9-19.8-16-19.9-32.2-.1-16.8 9.7-28.3 20.8-34.7 5.5-3.2 11.5-5.3 17.6-6.6V79.1c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarMessagesQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessagesQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 48c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h48c13.3 0 24 10.7 24 24v19.2l58.7-39.2c3.9-2.6 8.6-4 13.3-4h128c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H72zM0 72C0 32.2 32.2 0 72 0h272c39.8 0 72 32.2 72 72v176c0 39.8-32.2 72-72 72H223.3l-90 60c-7.4 4.9-16.8 5.4-24.6 1.2S96 368.9 96 360v-40H72c-39.8 0-72-32.2-72-72V72zm256 280h48v24c0 13.3 10.7 24 24 24h96c4.7 0 9.4 1.4 13.3 4l58.7 39.2V424c0-13.3 10.7-24 24-24h48c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H448v-48h120c39.8 0 72 32.2 72 72v176c0 39.8-32.2 72-72 72h-24v40c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-90-60H328c-39.8 0-72-32.2-72-72v-24zM147.9 96.1c5.5-15.4 20.1-25.7 36.4-25.7h41.3c24.2 0 43.7 19.6 43.7 43.7 0 15.7-8.4 30.1-22 37.9L224 165.4v.3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2 0-6.5-5.3-11.7-11.7-11.7h-41.3c-2.8 0-5.3 1.8-6.3 4.4l-.3.9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 228a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1-45.3 0z"
        }
    ]
};

const FarMessages = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMessages",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 72c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24H216c-4.7 0-9.4 1.4-13.3 4L144 315.2V296c0-13.3-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V72zM72 0C32.2 0 0 32.2 0 72v176c0 39.8 32.2 72 72 72h24v40c0 8.9 4.9 17 12.7 21.2s17.3 3.7 24.6-1.2l90-60H344c39.8 0 72-32.2 72-72V72c0-39.8-32.2-72-72-72H72zm184 376c0 39.8 32.2 72 72 72h88.7l90 60c7.4 4.9 16.8 5.4 24.6 1.2S544 496.9 544 488v-40h24c39.8 0 72-32.2 72-72V200c0-39.8-32.2-72-72-72H448v48h120c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24h-48c-13.3 0-24 10.7-24 24v19.2L437.3 404c-3.9-2.6-8.6-4-13.3-4h-96c-13.3 0-24-10.7-24-24v-24h-48v24z"
        }
    ]
};

const FarMeteor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMeteor",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M474.8 0c-5.2 0-10.3 1.1-15 3.2L324 62.9l1.4-18.2c2.5-34.2-36.2-55.5-63.7-35.1l-179 132.9C30.6 181.2 0 242.7 0 307.5 0 419.8 91 512 203.6 512c65.7 0 127.4-31.8 165.7-85.3l126.3-176.9c19.7-27.6-1.8-65.7-35.6-63.1l-10.7.8 59.5-135.3c2.1-4.7 3.2-9.8 3.2-15C512 16.7 495.3 0 474.8 0zm-168 122.9 147-64.7-64.6 146.7c-3.4 7.7-2.5 16.7 2.4 23.5s13 10.7 21.4 10.1l33.5-2.6-116.4 163C301 439.7 253.8 464 203.6 464 117.8 464 48 393.6 48 307.5c0-49.7 23.6-96.9 63.4-126.5L276.2 58.6l-3 40.6c-.6 8.4 3.2 16.5 10.1 21.4s15.8 5.8 23.5 2.4zM200 424a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm-24-160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 96a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarMeterBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMeterBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0 8.9-.6 17.6-1.6 26.2l49.3-39.4C504.8 107.5 393 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c73.7 0 140.1-31.1 186.8-81l7.5-15H432c-11.5 0-22.3-4.1-30.7-11.1C363.8 441.5 312.5 464 256 464c-114.9 0-208-93.1-208-208S141.1 48 256 48s208 93.1 208 208zM192 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48zm234.1 75.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8S425.2 384 432 384h70.1l-52.4 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
        }
    ]
};

const FarMeterDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMeterDroplet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464c48.8 0 93.8-16.8 129.2-45 2.3 17.2 7.6 33.5 15.4 48.3C359.5 495.5 309.7 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c110.8 0 205.2 70.4 240.8 169-8.5 5.3-15.7 12.9-20.6 22.1l-15.4 28.8C443.8 122.2 358.6 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208zm-64-312v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm136.5 54.1c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7 0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z"
        }
    ]
};

const FarMeterFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMeterFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48c68.7 0 129.5 33.3 167.4 84.6 16.7-8 37.2-5.5 51.5 7.4 5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c33.6 0 65.7-6.5 95.1-18.3-12.6-11.6-23.6-24.8-32.8-39.2-19.7 6.2-40.6 9.5-62.3 9.5-114.9 0-208-93.1-208-208S141.1 48 256 48zm112 104c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 11.2 7.6 20.6 18 23.2 9-12.9 19.1-25.7 30-38.3V152zm-176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48zm173.5 11.6c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.6 32-32.3 66.3-32.3 92.7 0 87.8 70.3 159.8 160 159.8 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96z"
        }
    ]
};

const FarMeter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMeter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm192-104v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarMicrochipAi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMicrochipAi",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-8c-35.3 0-64 28.7-64 64v8H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v8c0 35.3 28.7 64 64 64h8v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h8c35.3 0 64-28.7 64-64v-8h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-48h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-48h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-8c0-35.3-28.7-64-64-64h-8V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-48V24zm-72 104c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V128zm224 44c-11 0-20 9-20 20v128c0 11 9 20 20 20s20-9 20-20V192c0-11-9-20-20-20zm-101.7 12c-3.2-7.3-10.4-12-18.3-12s-15.1 4.7-18.3 12l-56 128c-4.4 10.1.2 21.9 10.3 26.3s21.9-.2 26.3-10.3l5.3-12h64.8l5.3 12c4.4 10.1 16.2 14.7 26.3 10.3s14.7-16.2 10.3-26.3l-56-128zM216 241.9l14.9 34.1h-29.8l14.9-34.1z"
        }
    ]
};

const FarMicrochip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMicrochip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-8c-35.3 0-64 28.7-64 64v8H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v8c0 35.3 28.7 64 64 64h8v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h8c35.3 0 64-28.7 64-64v-8h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-48h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-48h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-8c0-35.3-28.7-64-64-64h-8V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-48V24zm216 104v256c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16zm-208 32c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H192zm16 48h96v96h-96v-96z"
        }
    ]
};

const FarMicrophoneLinesSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMicrophoneLinesSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472.1 344.7c15.2-26 23.9-56.3 23.9-88.7v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L408 294.5c5.2-11.8 8-24.8 8-38.5V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7zM272 187.9V96c0-26.5 21.5-48 48-48s48 21.5 48 48h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v64c0 2.3-.2 4.6-.5 6.8L272 187.9zm86.2 190.3c-12.1 3.8-24.9 5.8-38.2 5.8-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z"
        }
    ]
};

const FarMicrophoneLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMicrophoneLines",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 128v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c0 26.5-21.5 48-48 48s-48-21.5-48-48V96c0-26.5 21.5-48 48-48s48 21.5 48 48h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32zM96 96v160c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96S96 43 96 96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6c85.8-11.7 152-85.3 152-174.4v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128S64 326.7 64 256v-40z"
        }
    ]
};

const FarMicrophoneSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMicrophoneSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L408 294.5c5.2-11.8 8-24.8 8-38.5V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM272 187.9V96c0-26.5 21.5-48 48-48s48 21.5 48 48v160c0 2.3-.2 4.6-.5 6.8L272 187.9zm-80 59.4L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9c-12.1 3.7-24.9 5.7-38.2 5.7-70.7 0-128-57.3-128-128v-8.7z"
        }
    ]
};

const FarMicrophoneStand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMicrophoneStand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m476.9 204.9 1-1c45.9-46.9 45.6-122.2-1-168.7s-121.8-46.9-168.7-1l-1 .9-16 16-16 16-.9 1c-22.5 22.9-33.9 52.6-34.3 82.4L17.2 388.2A63.262 63.262 0 0 0 0 431.6c0 16.8 6.7 33 18.6 44.9l16.8 16.8c12 12 28.1 18.7 45 18.7 16.1 0 31.7-6.1 43.4-17.2L232 393.4V488c0 13.3 10.7 24 24 24s24-10.7 24-24V348.4l81.5-76.4c29.8-.4 59.5-11.8 82.4-34.2l1-1 16-16 16-16zm-115 19.1L325 187l-37-36.9c.5-17.4 7.2-34.6 20.1-48l101.8 101.8c-13.4 12.9-30.7 19.6-48 20.1zm82-54L342.1 68.1c28.2-27.2 73-26.8 100.8 1s28.1 72.7 1 100.8zM80.4 464c-4.1 0-8.1-1.6-11-4.5l-16.9-16.9c-2.9-2.9-4.5-6.9-4.5-11 0-3.9 1.5-7.7 4.2-10.6l212.4-226.5L291 221l26.5 26.5L91 459.8c-2.9 2.7-6.7 4.2-10.6 4.2z"
        }
    ]
};

const FarMicrophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMicrophone",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 96v160c0 26.5-21.5 48-48 48s-48-21.5-48-48V96c0-26.5 21.5-48 48-48s48 21.5 48 48zM96 96v160c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96S96 43 96 96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6c85.8-11.7 152-85.3 152-174.4v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128S64 326.7 64 256v-40z"
        }
    ]
};

const FarMicroscope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMicroscope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-17.7 0-32 14.3-32 32-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32 0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32 17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32 0-17.7-14.3-32-32-32h-32zm-16 272V80h64v192h-64zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24h-41c39.9-35.2 65-86.7 65-144 0-106-86-192-192-192v48c79.5 0 144 64.5 144 144s-64.5 144-144 144H24zm72-56c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarMicrowave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMicrowave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h448zM64 32C28.7 32 0 60.7 0 96v288c0 35.3 28.7 64 64 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h352v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm368 104v208c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-312-8c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120z"
        }
    ]
};

const FarMillSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMillSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M302.4 32.5c4.7-12.4-1.5-26.3-13.9-31s-26.3 1.5-31 13.9l-36.1 95.3c-11.3 6.6-21.2 15.2-29.4 25.3-19.8-24.4-50.1-40-84-40-22.5 0-43.3 6.9-60.6 18.6C44.9 103.9 35.4 96 24 96c-13.3 0-24 10.7-24 24v80h.1c0 1.3-.1 2.7-.1 4v220c0 13.3 10.7 24 24 24s24-10.7 24-24V204c0-33.1 26.9-60 60-60s60 26.9 60 60v47.6L81.6 479.5c-4.7 12.4 1.5 26.3 13.9 31s26.3-1.5 31-13.9L168 386.9V424c0 13.3 10.7 24 24 24s24-10.7 24-24V260.4l43.3-114c5.3-1.5 10.9-2.4 16.7-2.4 33.1 0 60 26.9 60 60v220c0 13.3 10.7 24 24 24s24-10.7 24-24V204c0-58.9-47.1-106.7-105.7-108l24.1-63.5z"
        }
    ]
};

const FarMinimize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMinimize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7 7c-9.3 9.4-9.3 24.6 0 34l80 80-45.6 45.6c-6 6-9.4 14.1-9.4 22.6v2.8c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-2.7c-8.5 0-16.6 3.4-22.6 9.4L121 87 41 7C31.6-2.3 16.4-2.3 7 7zm498 34c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L391 87l-45.6-45.6c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-2.7c0-8.5-3.4-16.6-9.4-22.6L425 121l80-80zm0 430-80-80 45.7-45.7c6-6 9.4-14.1 9.4-22.6V320c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h2.7c8.5 0 16.6-3.4 22.6-9.4L391 425l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80 45.7 45.7c6 6 14.1 9.4 22.6 9.4h2.8c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v2.7c0 8.5 3.4 16.6 9.4 22.6L87 391 7 471zm405.1-295H336V99.9l76.1 76.1zM336 412.1V336h76.1L336 412.1zM99.9 176 176 99.9V176H99.9zM176 412.1 99.9 336H176v76.1z"
        }
    ]
};

const FarMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMinus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 256c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h368c13.3 0 24 10.7 24 24z"
        }
    ]
};

const FarMistletoe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMistletoe",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c13.3 0 24 10.7 24 24v62.1l98 98 8.7 1.7 65.9 12.7C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75-54 0-100.3-38.3-110.5-91.3l-12.7-65.9-1.7-8.7-64.1-64.2V288l6 8 46.8 62.4C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L258 296l6-8V153.9L199.9 218l-1.4 7.4c3-.9 6.2-1.4 9.5-1.4 17.7 0 32 14.3 32 32s-14.3 32-32 32c-7.6 0-14.7-2.7-20.2-7.2l-2.3 11.9C175.4 345.7 129 384 75 384c-41.4 0-75-33.6-75-75 0-54 38.3-100.3 91.3-110.5l65.9-12.7 8.7-1.7 98-98V24c0-13.3 10.7-24 24-24zM100.4 245.6C70 251.4 48 278 48 309c0 14.9 12.1 27 27 27 30.9 0 57.5-22 63.4-52.4l9.1-47.1-47.1 9.1zm328.2-9.1 9.1 47.1C443.4 314 470 336 501 336c14.9 0 27-12.1 27-27 0-30.9-22-57.5-52.4-63.4l-47.1-9.1zm-179 150.7c-6.2 8.3-9.6 18.4-9.6 28.8 0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L288 336l-38.4 51.2zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarMitten = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMitten",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 142.6C0 63.8 63.8 0 142.6 0c63.7 0 119.6 42.2 137.1 103.4l21.4 75c15.7-11.8 35-18.4 55.2-18.4h4.5c48.2 0 87.3 39.1 87.3 87.3 0 21.9-8.3 43.1-23.1 59.2L353.3 384H304v-8c0-6 2.3-11.8 6.4-16.3l79.2-85.8c6.7-7.3 10.4-16.8 10.4-26.6 0-21.7-17.6-39.3-39.3-39.3h-4.5c-14.6 0-28.3 7.3-36.4 19.5l-9.5 14.2c-5.2 7.8-14.4 11.8-23.7 10.4s-16.8-8.1-19.4-17.1l-33.7-118.4C221.9 76 184.8 48 142.6 48 90.3 48 48 90.3 48 142.6v2.5c0 7.9 1 15.8 2.9 23.5l52.4 209.5c.5 1.9.7 3.9.7 5.8H55.3l-51-203.6C1.5 168.8 0 157 0 145.1v-2.5zM64 416h288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarMobileButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMobileButton",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H80zM16 64C16 28.7 44.7 0 80 0h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zm176 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarMobileNotch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMobileNotch",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48v16c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16V48H96c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32h-32zM16 80C16 35.8 51.8 0 96 0h192c44.2 0 80 35.8 80 80v352c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80V80z"
        }
    ]
};

const FarMobileRetro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMobileRetro",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h192zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm16 160v64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32zm16 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm40-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm40-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM128 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64z"
        }
    ]
};

const FarMobileScreenButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMobileScreenButton",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 448c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-80H64v80zm0-128h256V64c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v256zM16 64C16 28.7 44.7 0 80 0h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zm176 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarMobileScreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMobileScreen",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 448c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-80H64v80zm0-128h256V64c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v256zM16 64C16 28.7 44.7 0 80 0h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zm144 336h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarMobileSignalOut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMobileSignalOut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h160V0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V288h-48v160c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zM280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184 0 13.3 10.7 24 24 24s24-10.7 24-24C512 103.9 408.1 0 280 0zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-32-136c0 13.3 10.7 24 24 24 48.6 0 88 39.4 88 88 0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarMobileSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMobileSignal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h224c8.8 0 16 7.2 16 16v234.7c14.5-14.1 30.6-26.5 48-37V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h160v-24c0-8.1.4-16.1 1.1-24H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm344-144c-128.1 0-232 103.9-232 232 0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184 13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-136c0-13.3-10.7-24-24-24-75.1 0-136 60.9-136 136 0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88 13.3 0 24-10.7 24-24z"
        }
    ]
};

const FarMobile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMobile",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H80zM16 64C16 28.7 44.7 0 80 0h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zm144 336h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarMoneyBill1Wave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBill1Wave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4 55.9-14.3 119.4-30.6 185.3-28.7 4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9-47-1.7-96.8 9.5-153.7 24-4.5 1.1-9 2.3-13.5 3.5-55.9 14.3-119.4 30.6-185.3 28.7-4.1 31.4-31 55.7-63.5 55.7v176c35.3 0 63.9 28.6 64 63.9 47 1.7 96.8-9.5 153.7-24zM0 421.5V113c0-24.2 25.4-40.3 48.4-34 79.8 22 159.7 1.6 239.6-18.7 86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5V399c0 24.3-25.4 40.3-48.3 34-79.9-22-159.8-1.6-239.7 18.7-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112 43-112 96-112 96 50.1 96 112zm-128-48c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8v-80c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarMoneyBill1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBill1",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 112c0 35.3-28.7 64-64 64v160c35.3 0 64 28.7 64 64h352c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm176 128a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm80-48c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8v-80c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarMoneyBillSimpleWave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBillSimpleWave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4 73.7-18.9 160.5-41.1 248.8-20.9V91.8c-66.2-23.1-134.4-8.8-217.7 12.3-4.5 1.1-9 2.3-13.5 3.5-73.7 18.8-160.5 41.1-248.8 20.8v291.8c66.2 23.1 134.4 8.9 217.7-12.3zM0 421.5V113c0-24.2 25.4-40.3 48.4-34 79.8 22 159.7 1.6 239.6-18.7 86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5V399c0 24.3-25.4 40.3-48.3 34-79.9-22-159.8-1.6-239.7 18.7-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96z"
        }
    ]
};

const FarMoneyBillSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBillSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm288 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FarMoneyBillTransfer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBillTransfer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M558.1 64 535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23H160v16c0 35.3-28.7 64-64 64H80v93.5l-29.3 29L32 333.5V128c0-35.3 28.7-64 64-64h462.1zm1.9 256v-93.5l29.3-29.3 18.7-18.7V384c0 35.3-28.7 64-64 64H81.9l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 174.1.1h224v-16c0-35.3 28.7-64 64-64h16zM320 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FarMoneyBillTrendUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBillTrendUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 24c0 13.3 10.7 24 24 24h54.1L286.7 159.3l-95.1-81.5c-9-7.7-22.4-7.7-31.3.1l-120 104c-10 8.7-11.1 23.8-2.4 33.9s23.8 11.1 33.9 2.4l104.4-90.5 96.3 82.5c9.5 8.2 23.7 7.6 32.6-1.3l127-127V136c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zM103.5 304h305c3.6 29 26.6 51.9 55.5 55.5v49c-29 3.6-51.9 26.6-55.5 55.5h-305c-3.6-29-26.6-51.9-55.5-55.5v-49c28.9-3.6 51.9-26.6 55.5-55.5zM48 256c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zm208 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FarMoneyBillWave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBillWave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4 55.9-14.3 119.4-30.6 185.3-28.7 4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9-47-1.7-96.8 9.5-153.7 24-4.5 1.1-9 2.3-13.5 3.5-55.9 14.3-119.4 30.6-185.3 28.7-4.1 31.4-31 55.7-63.5 55.7v176c35.3 0 63.9 28.6 64 63.9 47 1.7 96.8-9.5 153.7-24zM0 421.5V113c0-24.2 25.4-40.3 48.4-34 79.8 22 159.7 1.6 239.6-18.7 86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5V399c0 24.3-25.4 40.3-48.3 34-79.9-22-159.8-1.6-239.7 18.7-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96z"
        }
    ]
};

const FarMoneyBillWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBillWheat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0c-8.8 0-16 7.2-16 16 0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80zM56 16c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zM24 88C10.7 88 0 98.7 0 112s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm8 96c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24zM272 16c0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80-8.8 0-16 7.2-16 16zM400 0c-8.8 0-16 7.2-16 16 0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80zm80 144c0-8.8-7.2-16-16-16-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80zm-128-16c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80 0-8.8-7.2-16-16-16zm-96 16c0-8.8-7.2-16-16-16-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80zM48 359.5c28.9-3.6 51.9-26.6 55.5-55.5h305c3.6 29 26.6 51.9 55.5 55.5v49c-29 3.6-51.9 26.6-55.5 55.5h-305c-3.6-29-26.6-51.9-55.5-55.5v-49zM48 256c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zm208 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FarMoneyBill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBill",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 112c0 35.3-28.7 64-64 64v160c35.3 0 64 28.7 64 64h352c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm288 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FarMoneyBillsSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBillsSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 80c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h416zM160 32c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm288 176a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v240c0 66.3 53.7 120 120 120h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
        }
    ]
};

const FarMoneyBills = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyBills",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 80c0 35.3 28.7 64 64 64v128c-35.3 0-64 28.7-64 64H208c0-35.3-28.7-64-64-64V144c35.3 0 64-28.7 64-64h320zM160 32c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm288 176a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v240c0 66.3 53.7 120 120 120h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
        }
    ]
};

const FarMoneyCheckDollarPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyCheckDollarPen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 112H64c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h284.3c-5.6 7.1-9.6 15.3-11.8 24.1l-6 23.9H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v64.6c-15.2 2-29.8 8.8-41.4 20.5l-6.6 6.6V128c0-8.8-7.2-16-16-16zM256 296c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24zm24-120h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-120-44c11 0 20 9 20 20v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20zm453.8 103.7 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FarMoneyCheckDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyCheckDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm280 144h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24zm-76-48v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"
        }
    ]
};

const FarMoneyCheckPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyCheckPen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112h448c8.8 0 16 7.2 16 16v91.6l6.6-6.6c11.6-11.6 26.3-18.5 41.4-20.5V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h266.5l6-23.9c2.2-8.8 6.2-17 11.8-24.1H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16zm56 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm-24-72c0 13.3 10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm517.8 35.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4l129.2-129.3-71-71L375.9 417z"
        }
    ]
};

const FarMoneyCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm120 80h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zM96 328c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm280-168h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarMoneyFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneyFromBracket",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 88v80c0 13.3-10.7 24-24 24S0 181.3 0 168V88C0 39.4 39.4 0 88 0h464c48.6 0 88 39.4 88 88v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-22.1-17.9-40-40-40H88c-22.1 0-40 17.9-40 40zm416 8h48v352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V96h48v304c35.3 0 64 28.7 64 64h160c0-35.3 28.7-64 64-64V96zM320 352c-53 0-96-35.8-96-80s43-80 96-80 96 35.8 96 80-43 80-96 80z"
        }
    ]
};

const FarMoneySimpleFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoneySimpleFromBracket",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 88v80c0 13.3-10.7 24-24 24S0 181.3 0 168V88C0 39.4 39.4 0 88 0h464c48.6 0 88 39.4 88 88v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-22.1-17.9-40-40-40H88c-22.1 0-40 17.9-40 40zm416 8h48v352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V96h48v352c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V96zM320 352c-53 0-96-35.8-96-80s43-80 96-80 96 35.8 96 80-43 80-96 80z"
        }
    ]
};

const FarMonitorWaveform = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMonitorWaveform",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v144h128c8.4 0 16.2 4.4 20.6 11.7l25.5 42.5 60.4-120.9c3.9-7.8 11.8-12.9 20.5-13.2s17 4.1 21.5 11.6l41 68.3H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-72c-8.4 0-16.2-4.4-20.6-11.7l-25.5-42.5-60.4 120.9c-3.9 7.8-11.8 12.9-20.5 13.2s-17-4.1-21.5-11.6l-41-68.3H48v128c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FarMonkey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMonkey",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 416c0-91.5 54.8-170.2 133.5-204.9 7.3 15.1 17.2 28.6 29.3 39.9C255.7 275.8 208 340.4 208 416v48h192v-24c0-39.8-32.2-72-72-72h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c27 0 51.9 8.9 72 24v-56.9c5.2.6 10.6.9 16 .9 11 0 21.7-1.3 32-3.8v1.8l83.5 83.5C560 398 576 436.7 576 477v11c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11c0-27.6-11-54-30.5-73.5L448 353.9V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H152C68.1 512 0 443.9 0 360V120C0 53.7 53.7 0 120 0h8c53 0 96 43 96 96s-43 96-96 96h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c26.5 0 48-21.5 48-48s-21.5-48-48-48h-8c-39.8 0-72 32.2-72 72v240c0 57.4 46.6 104 104 104h8v-48zm288-165c-10.1 3.3-20.8 5-32 5-5.4 0-10.8-.4-16-1.2-13.5-2.1-26.1-6.8-37.4-13.5-16.4-9.8-29.9-24.1-38.8-41.1-1.4-2.7-2.7-5.4-3.8-8.2-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-11.6 27.9-35 49.6-64 59zM384 64c-26.5 0-48 21.5-48 48 0 20.8 13.2 38.4 31.6 45.1 4.7 1.7 8.4 5.9 8.4 10.9 0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9 18.5-6.7 31.6-24.4 31.6-45.1 0-26.5-21.5-48-48-48h-64zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarMonument = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMonument",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175 7c9.4-9.4 24.6-9.4 33.9 0l80 80c3.8 3.8 6.2 8.7 6.8 14l41.4 331h-48.3l-39.6-316.9L192 57.9l-57.2 57.2L95.2 432H46.8l41.4-331c.7-5.3 3.1-10.2 6.8-14l80-80zM42.8 464H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h18.8zM144 312c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarMoonCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoonCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M635.2 416.6c-2.6 2.5-5.2 5-7.9 7.3-4.5 4-9.1 7.8-13.9 11.4-1.8 1.4-3.7 2.7-5.5 4C571.5 465 527.2 480 479.5 480c-60.9 0-116.1-24.4-156.4-64 11.6-12 20.3-26.9 25-43.4C380.2 409 427.2 432 479.5 432c13.3 0 26.2-1.5 38.6-4.3C430.5 397.4 367.6 314 367.6 216c0-43 12.1-83.2 33.1-117.3C343.4 127.6 304 187.1 304 256v.3c-13.9-8.9-30.1-14.6-47.5-16 7.6-110.9 95.8-199.6 206.3-207.7 2.3-.2 4.6-.3 6.9-.4 3.2-.1 6.5-.2 9.8-.2 2.7 0 5.5 0 8.2.1 3.6.1 7.2.3 10.7.6 7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-3.2 1.8-6.4 3.8-9.6 5.8-4.3 2.8-8.5 5.8-12.5 9-1.1.8-2.1 1.7-3.2 2.6-39.2 32.3-64.1 81.2-64.1 136 0 97.1 78.5 175.8 175.2 176h4c5.2-.1 10.3-.4 15.3-1 3.7-.4 7.4-.9 11.1-1.6 6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7zM64 416c-35.3 0-64-28.7-64-64s28.7-64 64-64h1.6c7.4-36.5 39.7-64 78.4-64 35 0 64.8 22.5 75.6 53.8 8.7-3.7 18.3-5.8 28.4-5.8 39.8 0 72 32.2 72 72s-32.2 72-72 72H64z"
        }
    ]
};

const FarMoonOverSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoonOverSun",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361.3 1.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L450.9 256l56.9 82.5c4.6 6.7 5.5 15.3 2.4 22.8s-9.8 13-17.8 14.4l-98.5 18.1-18.1 98.5c-1.5 8-6.9 14.7-14.4 17.8s-16.1 2.2-22.8-2.4L256 450.9l-82.5 56.9c-6.7 4.6-15.3 5.5-22.8 2.4s-12.9-9.8-14.4-17.8l-18.1-98.5-98.5-18.2c-8-1.5-14.7-6.9-17.8-14.4s-2.2-16.1 2.4-22.8L61.1 256 4.2 173.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-12.9 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L256 61.1l82.5-56.9c6.7-4.6 15.3-5.5 22.8-2.4zm-26.1 63L269.6 110c-8.2 5.7-19 5.7-27.2 0l-65.6-45.2-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3l-78.3 14.4 45.2 65.6c5.7 8.2 5.7 19 0 27.2l-45.2 65.6 78.3 14.4c9.8 1.8 17.5 9.5 19.3 19.3l14.4 78.3 65.6-45.2c8.2-5.7 19-5.7 27.2 0l65.6 45.2 14.4-78.3c1.8-9.8 9.5-17.5 19.3-19.3l78.3-14.4-45.2-65.6c-5.7-8.2-5.7-19 0-27.2l45.2-65.6-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3l-14.4-78.3zM144 256a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm151.7 50.2c14.8-11.7 24.3-29.8 24.3-50.2 0-35.3-28.7-64-64-64h-.5c-12.3 12.2-19.9 29-19.9 47.5 0 34.4 26.2 62.9 60.1 66.7z"
        }
    ]
};

const FarMoonStars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoonStars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M295.8 137.8c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11 11 38.6zm108 173c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6 16.6 58zM48 320c0-70 50-128.3 116.2-141.3C141.6 206.3 128 241.5 128 280c0 83.2 63.5 151.6 144.7 159.3-23 15.6-50.8 24.7-80.7 24.7-79.5 0-144-64.5-144-144zm144-192C86 128 0 214 0 320s86 192 192 192c69.4 0 130.2-36.9 163.9-92 5.3-8.7 4.6-19.9-2-27.8s-17.3-10.8-26.9-7.2c-12.1 4.5-25.3 7-39.1 7-61.9 0-112-50.1-112-112 0-45 26.6-83.9 65-101.7 9.3-4.3 14.8-14 13.8-24.2s-8.4-18.6-18.3-20.9c-14.3-3.4-29.2-5.2-44.4-5.2z"
        }
    ]
};

const FarMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoon",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3 0 98 62.8 181.4 150.4 211.7-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256c0 123.7 100 224 223.5 224 47.8 0 92-15 128.4-40.6 1.9-1.3 3.7-2.7 5.5-4 4.8-3.6 9.4-7.4 13.9-11.4 2.7-2.4 5.3-4.8 7.9-7.3 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7.6-7.4 1.2-11.1 1.6-5 .5-10.1.9-15.3 1h-4c-96.8-.2-175.2-78.9-175.2-176 0-54.8 24.9-103.7 64.1-136 1-.9 2.1-1.7 3.2-2.6 4-3.2 8.2-6.2 12.5-9 3.1-2 6.3-4 9.6-5.8 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6-2.7-.1-5.5-.1-8.2-.1-3.3 0-6.5.1-9.8.2-2.3.1-4.6.2-6.9.4z"
        }
    ]
};

const FarMoped = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMoped",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328 56c0-13.3 10.7-24 24-24h41.3c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4h8.4c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-8.4c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5 29.6 85.3c4-.3 8-.4 12-.4 43.7 0 83.3 17.5 112.1 45.8 9.5 9.3 9.6 24.5.3 33.9s-24.5 9.6-33.9.3c-20.3-19.8-47.9-32-78.5-32-55.1 0-101 39.8-110.3 92.3-2 11.5-12 19.8-23.6 19.8H336c-.9 0-1.7 0-2.6-.1H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32v-32c0-70.7 57.3-128 128-128h96c17.7 0 32 14.3 32 32v80c0 17.7 14.3 32 32 32h71.3c14.5-46 49.1-83.1 93.6-100.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4H352c-13.3 0-24-10.7-24-24zm-208 56h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm88 128h-80c-44.2 0-80 35.8-80 80v16h166.7c-4.3-9.8-6.7-20.6-6.7-32v-64zm-48 192c26.5 0 48-21.5 48-48h-96c0 26.5 21.5 48 48 48zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FarMortarPestle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMortarPestle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M504.3 11.1c10.9 12.7 10.2 31.7-1.6 43.5L397.3 160h-145L461 6.2c13.5-9.9 32.3-7.8 43.2 4.9zM80 240v16c0 62.9 31.3 109.5 91.9 131 14.6 5.2 25.8 17.1 30.1 32.1s1 31-8.6 43.1c-.5.6-1 1.2-1.4 1.8h128c-.5-.6-.9-1.2-1.4-1.8-9.7-12.1-12.9-28.2-8.6-43.1s15.5-26.9 30.1-32.1c60.7-21.6 91.9-68.1 91.9-131v-16H80zm432-24c0 13.3-10.7 24-24 24h-8v16c0 66-27.8 120.8-80 154.8-13.1 8.5-27.7 15.7-43.9 21.5 10 12.6 17.7 27.1 22.5 42.9.5 1.7 1 3.5 1.4 5.2 4.4 17.1-10.4 31.7-28.1 31.7H160c-17.7 0-32.4-14.6-28.1-31.7.4-1.8.9-3.5 1.4-5.2 4.7-15.8 12.5-30.3 22.5-42.9-16.1-5.7-30.8-12.9-43.9-21.5C59.8 376.8 32 322 32 256v-16h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h464c13.3 0 24 10.7 24 24z"
        }
    ]
};

const FarMosque = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMosque",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0c7.6 0 14.7 3.6 19.2 9.6 18 24 40.1 42.1 66.5 59.5 15.7 10.3 31.3 19.5 48.2 29.3 13.1 7.6 26.9 15.7 42.2 25.2 31 19.2 48 53.2 48 88.3 0 25.6-8.9 49.2-23.8 67.7 23.5 11.8 39.7 36.2 39.7 64.4v96c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72V140.7C0 96.3 20.5 54.3 55.6 27L81.3 7C90 .3 102.1.3 110.8 7l25.7 20c26.9 20.9 45.2 50.4 52.3 83.1-24.1 21.6-38.9 51-43.3 81.9H48v248c0 13.3 10.7 24 24 24h92.1c-2.7-7.5-4.1-15.6-4.1-24v-96c0-28.2 16.2-52.6 39.8-64.4-14.9-18.6-23.8-42.1-23.8-67.8 0-35.1 17-69.1 48-88.3 15.2-9.4 29.1-17.5 42.2-25.2 16.9-9.9 32.5-19 48.2-29.3 26.4-17.4 48.5-35.5 66.4-59.5C385.3 3.6 392.4 0 400 0zM232 464h24v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48v-50c0-19 8.4-37 23-49.2l25-20.8 25 20.8c14.6 12.2 23 30.2 23 49.2v50h48v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h24c13.3 0 24-10.7 24-24v-96c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24zM48 144h96v-3.3c0-29.6-13.7-57.6-37.1-75.8L96 56.4l-10.9 8.5C61.7 83.1 48 111.1 48 140.7v3.3zm528 67.8c0-19.9-9.6-37.7-25.3-47.5-12.6-7.8-25.9-15.6-39-23.3-18.3-10.8-36.5-21.4-52.4-31.9C438.2 95.3 418.1 80 400 61c-18.1 18.9-38.2 34.2-59.3 48.1-16 10.5-34.1 21.1-52.4 31.9-13.1 7.7-26.4 15.5-39 23.3-15.7 9.8-25.3 27.7-25.3 47.5 0 33.2 26.9 60.2 60.2 60.2h231.6c33.2 0 60.2-26.9 60.2-60.2z"
        }
    ]
};

const FarMosquitoNet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMosquitoNet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5l30.4-60.6V336c0-4.2 1.7-8.3 4.7-11.3l59.3-59.3v-23.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2.9 12.2l-12.5 37.6 45.2 38v-22.6c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8-12.6-37.7c-1.3-4-1-8.4.9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2.1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4-2.7 2.6-5.2 5.4-7.3 8.6-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5-13.3 0-25.3 5.4-34 14.1l-11.7-1.7 7.5 6.5c-3.4 4.5-6.1 9.6-7.8 15.2-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2 0 16.7 8.5 31.4 21.5 40-4 2.6-7.5 5.9-10.6 9.5l-42.9-43v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32V384c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM105.2 310c.8-.8 1.6-1.5 2.4-2.3l82-71.4-111.1 16.6c-.4.1-.8.1-1.1.2-16.8 2.1-29.4 16.4-29.4 33.2 0 29.8 36.1 44.8 57.2 23.7zM512 256c8.8 0 16 7.2 16 16v16h48v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-48v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-48v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-48h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-48h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48v-16c0-8.8 7.2-16 16-16zm16 112h48v-48h-48v48zm0 80h48v-48h-48v48zm-80-128v48h48v-48h-48zm0 80v48h48v-48h-48z"
        }
    ]
};

const FarMosquito = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMosquito",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.5 506.9c-10.3-8.2-12.2-23.5-4.3-34.1l43.1-57.3v-55.6c0-5.8 2-11.4 5.7-15.8l62.3-74.6-129.7 118.3C97.6 447.6 0 405.2 0 320.6c0-47.9 34-88.3 79.3-94.2l153-23.9-40.8-40.9c-7.8-7.8-9.4-20.1-3.9-29.8l23.9-41.7-38.2-50.9c-8-10.6-6.1-25.9 4.3-34.1s25.2-6.3 33.2 4.4l48 63.9c5.9 7.9 6.6 18.6 1.7 27.2L237.8 140l50.2 50.3v-38.1c0-14.9 10.2-27.4 24-31V64c0-4.4 3.6-8 8-8s8 3.6 8 8v57.2c13.8 3.6 24 16.1 24 31v38.2l50.2-50.4-22.6-39.5c-4.9-8.6-4.2-19.3 1.7-27.2l48-63.9c8-10.6 22.8-12.6 33.2-4.4s12.2 23.5 4.3 34.1l-38.3 51 23.9 41.7c5.5 9.7 3.9 22-3.9 29.8l-40.8 40.9 153 23.9c45.3 5.9 79.4 46.3 79.4 94.2 0 84.6-97.6 127-154.6 67.1L355.7 269.4 418 344c3.7 4.4 5.7 10 5.7 15.8v62.7l42.1 49c8.6 10.1 7.7 25.5-2.1 34.3s-24.7 7.9-33.4-2.1l-48-55.9c-3.8-4.4-5.9-10.2-5.9-16.1v-62.9L352 339.7v68.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-68.1l-24.3 29.2v54.9c0 5.4-1.7 10.6-4.9 14.9l-48 63.9c-8 10.6-22.8 12.6-33.2 4.4zm-57.6-152.3c.8-.8 1.6-1.6 2.4-2.3l111.1-101.4-146.6 23c-.4.1-.8.1-1.2.2-19.8 2.5-37.6 21-37.6 46.5 0 22.3 12.2 37.3 27 43.7 14.5 6.3 31.3 4.5 44.9-9.7zm286.7-103.7 111.1 101.4c.8.7 1.6 1.5 2.4 2.3 13.6 14.2 30.4 16 44.9 9.7 14.8-6.4 27-21.4 27-43.7 0-25.5-17.8-44-37.6-46.6-.4-.1-.8-.1-1.2-.2l-146.6-22.9z"
        }
    ]
};

const FarMotorcycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMotorcycle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M292.5 224.7c11.1 14.3 20.4 30.2 27.5 47.2 15.3-36.5 40.6-67.8 72.6-90.2l-15.3-28.2-84.9 71.3zM304 384h-16v-32c0-88.4-71.6-160-160-160H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c49.6 0 95.1 17.3 130.8 46.3l95.2-80L337.7 80H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h62.5c14.7 0 28.2 8.1 35.2 21l13.9 25.8 46.7-39.3c5.8-4.8 13.1-7.5 20.6-7.5H480c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-61.8l55.1 102c12.2-3.9 25.2-6 38.7-6 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-40 18.4-75.7 47.1-99.2l-15.4-28.6C377 253.4 352 299.8 352 352v32h-48zm128-32c0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80c-5.2 0-10.3.5-15.2 1.4l36.3 67.1c6.3 11.7 2 26.2-9.7 32.5s-26.2 2-32.5-9.7l-36.3-67.1c-14 14.4-22.6 34.1-22.6 55.7zm-227.7-24c-10.2-32.5-40.5-56-76.3-56-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56h-55.1c-5.6 5-13.1 8-21.2 8-17.7 0-32-14.3-32-32s14.3-32 32-32c8.1 0 15.5 3 21.2 8h55.2zM128 224a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
        }
    ]
};

const FarMound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMound",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M485 368H91l94.8-164.9c21-36.6 60-59.1 102.2-59.1s81.2 22.6 102.2 59.1L485 368zM288 96c-59.4 0-114.2 31.7-143.9 83.2L35.6 368c-12.3 21.3 3.1 48 27.7 48h449.4c24.6 0 40-26.6 27.7-48L431.9 179.2C402.2 127.7 347.4 96 288 96z"
        }
    ]
};

const FarMountainCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMountainCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 48c-4.4 0-8 3.6-8 8v163.7l-48-79.6V56c0-30.9 25.1-56 56-56h112c30.9 0 56 25.1 56 56v136h32v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72.6c27.1 3.9 48 27.2 48 55.4v232c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-4.4-3.6-8-8-8h-96c-13.3 0-24-10.7-24-24V56c0-4.4-3.6-8-8-8H344zm27.3 230.2c2.9-3.8 7.5-6.2 12.7-6.2h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-9.8l-34.9-57.8zM384 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm128 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM224 188.9l-69.5 115.2 21.3 30.8 28-37.3c4.5-6 11.6-9.6 19.2-9.6h60.8L224 188.9zM58 464h332l-77.2-128H235l-40.8 54.4c-4.6 6.2-11.9 9.7-19.7 9.6s-14.9-4-19.3-10.4l-28-40.5L58 464zm195.4-319.3 189.5 314.2c6.5 10.8 6.7 24.3.7 35.3S426 512 413.5 512h-379c-12.5 0-24-6.8-30.1-17.8s-5.8-24.5.7-35.3l189.5-314.2C200.9 134.3 212 128 224 128s23.1 6.3 29.4 16.7z"
        }
    ]
};

const FarMountainSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMountainSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 80a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm-67.3 201.7 48.2-79c4.1-6.6 11.3-10.7 19.1-10.7s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8 0 33.8-27.4 61.1-61.1 61.1h-523C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7zm28.5 45.4 62.2 99.2c5.6 8.9 8.6 19.2 8.6 29.7 0 2.7-.2 5.3-.6 7.9h67.4c7.2 0 13.1-5.9 13.1-13.1 0-2.4-.7-4.8-1.9-6.8L480 263.6l-38.8 63.6zM456.1 464c4.4 0 7.9-3.5 7.9-7.9 0-1.5-.4-2.9-1.2-4.2L256 122.3 49.2 451.9c-.8 1.3-1.2 2.7-1.2 4.2 0 4.4 3.5 7.9 7.9 7.9h400.2z"
        }
    ]
};

const FarMountain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMountain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 424.1c0 4.4-3.5 7.9-7.9 7.9H55.9c-4.4 0-7.9-3.5-7.9-7.9 0-1.5.4-2.9 1.2-4.2L149.6 260l39.5 50.8c4.6 5.9 11.7 9.3 19.2 9.3s14.5-3.6 19-9.6L268 256h92l102.8 163.9c.8 1.3 1.2 2.7 1.2 4.2zM329.8 208H256c-7.6 0-14.7 3.6-19.2 9.6l-29.1 38.9-30.9-39.8L256 90.3 329.8 208zM55.9 480h400.2c30.9 0 55.9-25 55.9-55.9 0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1 0 455 25 480 55.9 480z"
        }
    ]
};

const FarMountains = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMountains",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 424.1c0 4.4-3.5 7.9-7.9 7.9H55.9c-4.4 0-7.9-3.5-7.9-7.9 0-1.5.4-2.9 1.2-4.2L256 90.3l206.8 329.6c.8 1.3 1.2 2.7 1.2 4.2zm-464 0C0 455 25 480 55.9 480h523c33.8 0 61.1-27.4 61.1-61.1 0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 164.1 487.8 160 480 160s-15 4.1-19.1 10.7l-48.2 79L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1z"
        }
    ]
};

const FarMouseField = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMouseField",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M393.4 50.8c4.5-1.8 9.4-2.8 14.6-2.8 22.1 0 40 17.9 40 40 0 8.1-2.4 15.6-6.5 21.9-10.4-5.3-21.7-9.1-33.6-11.4-.9-17.4-6.1-33.7-14.5-47.8zm86.2 88.4C489.9 124.8 496 107.1 496 88c0-48.6-39.4-88-88-88-18.4 0-35.5 5.7-49.6 15.3C342.5 5.6 323.9 0 304 0c-57.4 0-104 46.6-104 104v3.2c0 21.2 6.4 41.3 17.7 58.1C143.2 184.4 88 252 88 332.6c0 12.7 2.8 24.7 7.9 35.4H72c-39.8 0-72 32.2-72 72s32.2 72 72 72h384c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h320c13.3 0 24-10.7 24-24s-10.7-24-24-24h-47.8l32-80H456c30.9 0 56-25.1 56-56v-7.7c0-32.6-12.2-62.4-32.4-85.1zM292.6 368H171.4c-19.6 0-35.4-15.9-35.4-35.4 0-68.8 55.8-124.6 124.6-124.6H280c11.4 0 21.2-8 23.5-19.2s-3.6-22.4-14.1-26.9l-7.5-3.2c-20.6-8.8-33.9-29.1-33.9-51.5V104c0-30.9 25.1-56 56-56s56 25.1 56 56v16c0 12.5 9.7 23 22.2 23.9l8 .6c41.7 3.2 73.9 38 73.9 79.8v7.7c0 4.4-3.6 8-8 8H360c-9.8 0-18.6 6-22.3 15.1L292.6 368zM396 216a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"
        }
    ]
};

const FarMp3Player = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMp3Player",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h256zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm128 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM112 80c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-48c0-17.7-14.3-32-32-32H112z"
        }
    ]
};

const FarMugHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMugHot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0c13.3 0 24 10.7 24 24 0 16.1 7.5 23.7 23.8 37.9l1.1 1C152.6 76.6 176 97.1 176 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C87.4 83.4 64 62.9 64 24 64 10.7 74.7 0 88 0zM48 416c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V240H48v176zM0 224c0-17.7 14.3-32 32-32h368c61.9 0 112 50.1 112 112s-50.1 112-112 112h-16c0 53-43 96-96 96H96c-53 0-96-43-96-96V224zm384 144h16c35.3 0 64-28.7 64-64s-28.7-64-64-64h-16v128zM224 24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C264.6 76.6 288 97.1 288 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C199.4 83.4 176 62.9 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarMugMarshmallows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMugMarshmallows",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M197.7 125.7c-3.7-3.7-5.7-8.6-5.7-13.7s2-10 5.7-13.7l60.7-60.7C262 34 266.9 32 272 32s10 2 13.7 5.7l60.7 60.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L344 128H200l-2.3-2.3zM32 64c0-17.7 14.3-32 32-32h128c7.5 0 14.4 2.6 19.8 6.9L175 75.7c-9.6 9.6-15 22.7-15 36.3 0 5.5.9 10.9 2.6 16H32V64zm16 320c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V208H152v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56H48v176zM0 192c0-17.7 14.3-32 32-32h368c61.9 0 112 50.1 112 112s-50.1 112-112 112h-16c0 53-43 96-96 96H96c-53 0-96-43-96-96V192zm384 144h16c35.3 0 64-28.7 64-64s-28.7-64-64-64h-16v128z"
        }
    ]
};

const FarMugSaucer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMugSaucer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80h288v208c0 26.5-21.5 48-48 48H192c-26.5 0-48-21.5-48-48V80zm-16-48c-17.7 0-32 14.3-32 32v224c0 53 43 96 96 96h192c53 0 96-43 96-96h32c70.7 0 128-57.3 128-128S582.7 32 512 32H128zm384 208h-32V80h32c44.2 0 80 35.8 80 80s-35.8 80-80 80zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarMugTeaSaucer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMugTeaSaucer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 288c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V80H248v10.7c0 8.5 3.4 16.6 9.4 22.6l21.3 21.3c6 6 9.4 14.1 9.4 22.6V224c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32v-66.7c0-8.5 3.4-16.6 9.4-22.6l21.3-21.3c6-6 9.4-14.1 9.4-22.6V80H144v208zM96 64c0-17.7 14.3-32 32-32h384c70.7 0 128 57.3 128 128s-57.3 128-128 128h-32c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zm384 176h32c44.2 0 80-35.8 80-80s-35.8-80-80-80h-32v160zM24 432h528c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarMugTea = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMugTea",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 112h72v10.7c0 8.5-3.4 16.6-9.4 22.6l-21.3 21.3c-6 6-9.4 14.1-9.4 22.6V256c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-66.7c0-8.5-3.4-16.6-9.4-22.6l-21.3-21.3c-6-6-9.4-14.1-9.4-22.6V112H368v240c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48V112zM64 64c-17.7 0-32 14.3-32 32v256c0 53 43 96 96 96h192c53 0 96-43 96-96v-32h32c70.7 0 128-57.3 128-128S518.7 64 448 64H64zm384 208h-32V112h32c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
        }
    ]
};

const FarMug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMug",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 352c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V112H80v240zM32 96c0-17.7 14.3-32 32-32h384c70.7 0 128 57.3 128 128s-57.3 128-128 128h-32v32c0 53-43 96-96 96H128c-53 0-96-43-96-96V96zm384 176h32c44.2 0 80-35.8 80-80s-35.8-80-80-80h-32v160z"
        }
    ]
};

const FarMushroom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMushroom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 258.1C24 133.2 125.2 32 250.1 32h11.8C386.8 32 488 133.2 488 258.1c0 34.2-27.7 61.9-61.9 61.9H85.9C51.7 320 24 292.3 24 258.1zm121.9-144.5C101.2 146 72 198.6 72 258.1c0 7.7 6.2 13.9 13.9 13.9h340.2c7.7 0 13.9-6.2 13.9-13.9 0-12-1.2-23.7-3.4-35-8.8 10.3-22 16.9-36.6 16.9-26.5 0-48-21.5-48-48 0-26.1 20.8-47.3 46.7-48-24.2-29-57.5-50.2-95.4-59.2.5 3.7.8 7.4.8 11.2 0 44.2-35.8 80-80 80-38.1 0-70-26.7-78.1-62.4zM234.3 352l-15 80h73.4l-15-80h48.8l16.9 90.1c1.8 9.4-.7 19-6.8 26.3S321.5 480 312 480H200c-9.5 0-18.5-4.2-24.6-11.6s-8.6-17-6.8-26.3l16.8-90.1h48.8zM144 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarMusicNoteSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMusicNoteSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 31.1C512 13.9 498.1 0 480.9 0c-2.7 0-5.3.3-7.9 1L321.9 40.8C311.3 43.6 304 53.1 304 64v149L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L352 250.6v-55.2l141.9-36.1C504.6 156.6 512 147 512 136V31.1zM304 366.3c-18.1-9-40.2-14.3-64-14.3-61.9 0-112 35.8-112 80s50.1 80 112 80 112-35.8 112-80v-58.7l-48-37.8v30.8zm0 65.7c0 2.6-1.4 9.4-12.7 17.5-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5c-11.3-8.1-12.7-14.9-12.7-17.5s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5c11.3 8.1 12.7 14.9 12.7 17.5zm160-314.7-112 28.5V82.5L464 53v64.3z"
        }
    ]
};

const FarMusicNote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMusicNote",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 31.1C384 13.9 370.1 0 352.9 0c-2.7 0-5.3.3-7.9 1L193.9 40.8C183.3 43.6 176 53.1 176 64v302.3c-18.1-9-40.2-14.3-64-14.3-61.9 0-112 35.8-112 80s50.1 80 112 80 112-35.8 112-80V195.4l141.9-36.1C376.6 156.6 384 147 384 136V31.1zM176 432c0 2.6-1.4 9.4-12.7 17.5-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5C49.4 441.4 48 434.6 48 432s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5c11.3 8.1 12.7 14.9 12.7 17.5zm160-314.7-112 28.5V82.5L336 53v64.3z"
        }
    ]
};

const FarMusicSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMusicSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M545 0c17.1 0 31 13.9 31 31v337c0 16.7-6.2 32.2-16.7 45.1l71.5 56c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L208 137.7V120c0-10.5 6.9-19.8 16.9-22.9l311-95.7c3-.9 6-1.4 9.1-1.4zM256 175.3l31.7 24.9L528 126.3V54l-272 83.7v37.6zm77.7 60.9 87.4 68.5c16.3-10.4 36.7-16.7 58.9-16.7 17.5 0 33.9 3.9 48 10.7V176.5l-194.3 59.8zm129.7 101.7 58 45.4c4.6-5.6 6.6-11.4 6.6-15.3 0-9.8-12.9-32-48-32-6.2 0-11.7.7-16.6 1.9zm-255.4-78 48 37.8V432c0 44.2-43 80-96 80s-96-35.8-96-80 43-80 96-80c17.5 0 33.9 3.9 48 10.7V259.9zM160 400c-35.1 0-48 22.2-48 32s12.9 32 48 32 48-22.2 48-32-12.9-32-48-32z"
        }
    ]
};

const FarMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 31c0-17.1-13.9-31-31-31-3.1 0-6.2.5-9.1 1.4l-311 95.7c-10 3.1-16.9 12.4-16.9 22.9v242.7c-14.1-6.8-30.5-10.7-48-10.7-53 0-96 35.8-96 80s43 80 96 80 96-35.8 96-80V260.2l272-83.7v122.2c-14.1-6.8-30.5-10.7-48-10.7-53 0-96 35.8-96 80s43 80 96 80 96-35.8 96-80V31zm-48 337c0 9.8-12.9 32-48 32s-48-22.2-48-32 12.9-32 48-32 48 22.2 48 32zm-320 64c0 9.8-12.9 32-48 32s-48-22.2-48-32 12.9-32 48-32 48 22.2 48 32zm320-305.7L192 210v-72.3L464 54v72.2z"
        }
    ]
};

const FarMustache = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarMustache",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M233.4 112c-32.9 0-64.4 13.1-87.7 36.3-28.5 28.5-74.2 29.8-104.3 3.1l-1.5-1.3c-2.7-2.4-5.8-4.1-9-5-1.3-.4-2.7-.7-4.1-.9-1.1-.1-2.2-.2-3.3-.2-3.6.1-7 .9-10.1 2.4-2.2 1-4.2 2.4-6 4.2C2.9 154.9 0 161.1 0 168v34c0 109.4 88.6 198 198 198 42.8 0 84.5-13.9 118.8-39.6l3.2-2.4 3.2 2.4c34.3 25.7 76 39.6 118.8 39.6 109.4 0 198-88.6 198-198v-34c0-6.9-2.9-13.1-7.5-17.4-4.2-4-9.8-6.5-16.1-6.6h-1.3c-2.4.1-4.8.5-7.1 1.3-2.9 1-5.6 2.6-8 4.7l-1.5 1.3c-30.1 26.7-75.8 25.4-104.3-3.1-23.2-23.1-54.7-36.2-87.6-36.2h-1.2c-29.7 0-58.5 10.4-81.3 29.5l-4 3.3-4-3.3c-22.8-19-51.6-29.5-81.3-29.5h-1.2zm358.3 98.7C587.3 289.5 521.9 352 442 352c-32.5 0-64-10.5-90-30l-17.6-13.2c-8.5-6.4-20.3-6.4-28.8 0L288 322c-26 19.5-57.5 30-90 30-79.9 0-145.3-62.5-149.8-141.3 44.3 16.7 96 7 131.4-28.4 14.3-14.3 33.7-22.3 53.8-22.3h1.2c18.5 0 36.4 6.5 50.6 18.3l19.3 16.1c8.9 7.4 21.8 7.4 30.7 0l19.3-16.1c14.2-11.8 32.1-18.3 50.6-18.3h1.2c20.2 0 39.5 8 53.8 22.3 35.4 35.4 87.1 45.1 131.4 28.4z"
        }
    ]
};

const FarN = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarN",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M15.8 33.4c9.5-3.5 20.1-.6 26.6 7.1L336 390.1V56c0-13.3 10.7-24 24-24s24 10.7 24 24v400c0 10.1-6.3 19.1-15.8 22.6s-20.1.6-26.6-7.1L48 121.9V456c0 13.3-10.7 24-24 24S0 469.3 0 456V56c0-10.1 6.3-19.1 15.8-22.6z"
        }
    ]
};

const FarNairaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNairaSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M107.8 42.5C101.9 33.8 91 30 80.9 33.1S64 45.5 64 56v200H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v152c0 13.3 10.7 24 24 24s24-10.7 24-24V304h115.6l112.6 165.5c5.9 8.7 16.8 12.5 26.9 9.4S384 466.5 384 456V304h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v200h-83L107.8 42.5zM285.7 304H336v74l-50.3-74zM195 256h-83V134l83 122z"
        }
    ]
};

const FarNarwhal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNarwhal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M639.4 20.5c2.3-7.7-1.6-16-9-19.2s-16-.4-20.1 6.5L516 167.3c-15.7-4.7-32.3-7.3-49.6-7.3-53.1 0-104.4 19.5-144.1 54.8L177.9 343.2c-6.4 5.7-14.6 8.8-23.1 8.8-19.2 0-34.8-15.6-34.8-34.8v-58.5l37.9-26.5c21.4-15 34.1-39.4 34.1-65.5V112c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112v54.7c0 26.1 12.7 50.6 34.1 65.5L72 258.7V352c0 88.4 71.6 160 160 160h232c97.2 0 176-80 176-177.2 0-50.1-21.2-95.5-55.1-127.5l54.5-186.8zM232 464c-46.3 0-86-28.1-103.1-68.1 8.1 2.7 16.8 4.1 25.9 4.1 20.3 0 39.8-7.4 55-20.9l144.4-128.4c30.9-27.5 70.9-42.7 112.2-42.7 69 0 125.6 57 125.6 126.8 0 71.1-57.7 129.2-128 129.2H232zm264-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarNestingDolls = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNestingDolls",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 112C80 50.1 130.1 0 192 0s112 50.1 112 112v112H80V112zm120.7-47.1c-4.1-5.3-13.2-5.3-17.3 0-11.7 15.1-28.7 26-48.2 29.7-4 .8-7.2 4.2-6.8 8.2 1.5 14 7.6 27.7 18.4 38.5 25 25 65.5 25 90.5 0 10.8-10.8 16.9-24.4 18.4-38.5.4-4.1-2.7-7.5-6.8-8.2-19.5-3.7-36.5-14.6-48.2-29.7zm434.8 409.2c5.2 7.3 5.9 16.9 1.8 24.9s-12.4 13-21.3 13H312c-9 0-17.2-5-21.3-13-4.1-8-3.4-17.6 1.8-24.9l.2-.3c.2-.3.6-.8 1-1.5.9-1.4 2.3-3.5 4-6.3 3.4-5.6 7.9-13.8 12.5-23.8 9.2-20.3 17.8-46.8 17.8-74.1v-8c0-75.1 60.9-136 136-136s136 60.9 136 136v8c0 27.3 8.6 53.7 17.8 74.1 4.6 10 9.1 18.2 12.5 23.8 1.7 2.8 3.1 5 4 6.3.5.7.8 1.2 1 1.5l.2.3zM455.3 320.9C440.7 339.8 417.8 352 392 352c-4.3 0-8 3.3-7.6 7.6 1.7 17.9 9.4 35.3 23.1 49 31.2 31.2 81.9 31.2 113.1 0 13.7-13.7 21.4-31.1 23.1-49 .4-4.3-3.3-7.6-7.6-7.6-25.8 0-48.7-12.2-63.3-31.1-4.1-5.3-13.2-5.3-17.3 0zM261.4 464c-7.1 15.1-7.3 32.7 0 48H74.5c-17 0-33.4-6.7-42.7-20.9C17.9 469.7 0 432.8 0 384c0-44.4 20.2-84.4 37.9-119.4 2.7-5.3 8.1-8.6 14-8.6h280.2c-11.3 14.3-20.3 30.5-26.5 48H71.9c-14 28.9-23.9 54-23.9 80 0 35.9 12.8 63.3 23.2 79.6.2 0 .4.1.6.1.7.1 1.6.3 2.7.3h186.9z"
        }
    ]
};

const FarNetworkWired = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNetworkWired",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 48v96H240V48h160zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h56v40H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h112v40H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-56v-40h272v40h-56c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-56v-40h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H344v-40h56c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM80 368h160v96H80v-96zm480 0v96H400v-96h160z"
        }
    ]
};

const FarNeuter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNeuter",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 176a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm152 174.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4V488c0 13.3 10.7 24 24 24s24-10.7 24-24V350.4z"
        }
    ]
};

const FarNewspaper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNewspaper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 80c-13.3 0-24 10.7-24 24v304c0 8.4-1.4 16.5-4.1 24H440c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H168zM72 480c-39.8 0-72-32.2-72-72V112c0-13.3 10.7-24 24-24s24 10.7 24 24v296c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-39.8 32.2-72 72-72h272c39.8 0 72 32.2 72 72v304c0 39.8-32.2 72-72 72H72zm104-344c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24v-80zm200-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-176 80h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarNfcLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNfcLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h256v48H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v65.1c-17.7 2.5-34 9.2-48 18.9V96c0-8.8-7.2-16-16-16zm-16 72v62.3c-10.2 16.9-16 36.6-16 57.7v24.6c-19.1 11.1-32 31.7-32 55.4V160h-72v54.4c14.3 8.3 24 23.8 24 41.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V152c0-22.1 17.9-40 40-40h88c22.1 0 40 17.9 40 40zM128 352h192v48H120c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v192zm336-112c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FarNfcMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNfcMagnifyingGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h269.7c20.2 20.6 46 35.8 74.8 43.1-7.6 3.2-15.9 4.9-24.6 4.9H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v64c-16.7 0-32.8 2.6-48 7.3V96c0-8.8-7.2-16-16-16zm-16 72v29.4c-18.7 10.8-35.1 25.4-48 42.6v-64h-72v54.4c14.3 8.3 24 23.8 24 41.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V152c0-22.1 17.9-40 40-40h88c22.1 0 40 17.9 40 40zm-58.6 248H120c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v192h163.2c3.5 17.2 9.7 33.3 18.2 48zm138.6.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l79.1 79.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"
        }
    ]
};

const FarNfcPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNfcPen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h206.5l-12 48H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v139.6l-48 48V96c0-8.8-7.2-16-16-16zm-94.7 314.3c-1.8 1.8-3.5 3.7-5 5.7H120c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v192h192V160h-72v54.4c14.3 8.3 24 23.8 24 41.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V152c0-22.1 17.9-40 40-40h88c22.1 0 40 17.9 40 40v163.6l-78.7 78.7zm260.5-158.6 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FarNfcSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNfcSignal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h166c-3.4 15.5-5.3 31.6-5.8 48H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v131c-16.6 2.5-32.6 6.6-48 12V96c0-8.8-7.2-16-16-16zm-16 72v100.8c-17.2 8.8-33.3 19.4-48 31.6V160h-72v54.4c14.3 8.3 24 23.8 24 41.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V152c0-22.1 17.9-40 40-40h88c22.1 0 40 17.9 40 40zM239 400H120c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v192h133.7c-9.1 15.1-16.7 31.1-22.7 48zm249-144c13.3 0 24 10.7 24 24s-10.7 24-24 24c-101.6 0-184 82.4-184 184 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1 103.9-232 232-232zm-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-72c0 13.3-10.7 24-24 24-48.6 0-88 39.4-88 88 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1 60.9-136 136-136 13.3 0 24 10.7 24 24z"
        }
    ]
};

const FarNfcSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNfcSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1l-68.9-54zm106.9 83.8c2.6-5.3 8.1-8.9 14.3-8.9h320c8.8 0 16 7.2 16 16v267.5l-32-25.1V152c0-22.1-17.9-40-40-40h-88c-22.1 0-40 17.9-40 40v54.7l-60-47c11.4-1.9 20-11.8 20-23.7 0-13.3-10.7-24-24-24h-16c-10.5 0-20.1 4-27.2 10.7l-43.1-33.8zM416 300.8l-48.5-38c.3-2.2.5-4.5.5-6.8 0-17.8-9.7-33.3-24-41.6V160h72v140.8zm70.9 178.9L426.5 432H160c-8.8 0-16-7.2-16-16V209.5l-48-37.9V416c0 35.3 28.7 64 64 64h320c2.3 0 4.6-.1 6.9-.4zM385.8 400l-60.9-48H224v-79.5l-48-37.8V360c0 22.1 17.9 40 40 40h169.8z"
        }
    ]
};

const FarNfcSymbol = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNfcSymbol",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M357.4 473.6c7.7 7.2 19.2 8.5 28.3 3.2C461.4 433 512 349.3 512 256S461.4 79 385.7 35.2c-11.5-6.6-26.2-2.7-32.8 8.8s-2.7 26.2 8.8 32.8C422.7 112.1 464 180.1 464 256c0 69.6-34.7 132.6-87.6 169.8L200.3 262.4c-9.7-9-24.9-8.4-33.9 1.3s-8.4 24.9 1.3 33.9l189.7 176zM154.6 38.4c-7.7-7.2-19.2-8.5-28.3-3.2C50.6 79 0 162.7 0 256s50.6 177 126.3 220.8c11.5 6.6 26.2 2.7 32.8-8.8s2.7-26.2-8.8-32.8C89.3 399.9 48 331.9 48 256c0-69.6 34.7-132.6 87.6-169.8l176.1 163.4c9.7 9 24.9 8.4 33.9-1.3s8.4-24.9-1.3-33.9l-189.7-176z"
        }
    ]
};

const FarNfcTrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNfcTrash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h314.2l3.4 48H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v66.7c-11.5 4.1-21.3 12.5-26.9 23.8l-2.7 5.5H400V96c0-8.8-7.2-16-16-16zm-32 160c0 13.7 5.8 26.1 15 34.8l1 14.3V360c0 22.1-17.9 40-40 40H120c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v192h192V160h-72v54.4c14.3 8.3 24 23.8 24 41.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V152c0-22.1 17.9-40 40-40h88c22.1 0 40 17.9 40 40v52.2c-9.8 8.8-16 21.6-16 35.8zm97.7-39.2c2.7-5.4 8.2-8.8 14.3-8.8h96c6.1 0 11.6 3.4 14.3 8.8l11.6 23.2H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h38.1l11.6-23.2zm-35.8 281.5L400 288h224l-13.9 194.3C608.9 499 595 512 578.2 512H445.8c-16.8 0-30.7-13-31.9-29.7z"
        }
    ]
};

const FarNfc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNfc",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm208 224c0-17.8-9.7-33.3-24-41.6V160h72v192H128V160h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16c-22.1 0-40 17.9-40 40v208c0 22.1 17.9 40 40 40h208c22.1 0 40-17.9 40-40V152c0-22.1-17.9-40-40-40h-88c-22.1 0-40 17.9-40 40v62.4c-14.3 8.3-24 23.8-24 41.6 0 26.5 21.5 48 48 48s48-21.5 48-48z"
        }
    ]
};

const FarNose = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNose",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M205.3 12.9c-6.1-11.7-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4C237 178 327.3 280.7 374.8 329.6c16 16.4 25.2 37.6 25.2 59.2 0 41.5-33.7 75.2-75.2 75.2h-10.9l-17-17-30.1-30.1c-21.1-21.1-49.7-32.9-79.5-32.9-32.8 0-59.4 26.6-59.4 59.4v4.6c0 35.3 28.7 64 64 64h132.9c68 0 123.2-55.2 123.2-123.2 0-35.4-15.1-68.3-38.8-92.7-45.5-46.7-132.4-145.7-203.9-283.2zm27.6 437.9 13.2 13.2H192c-8.8 0-16-7.2-16-16v-4.6c0-6.3 5.1-11.4 11.4-11.4 17.1 0 33.5 6.8 45.6 18.9zM141 303.5c13-2.8 21.2-15.5 18.4-28.5s-15.5-21.2-28.5-18.4l-22.8 4.9C45.1 274.9 0 330.7 0 395.2c0 40.6 18 79.1 49.2 105.1l7.4 6.2c10.2 8.5 25.3 7.1 33.8-3.1s7.1-25.3-3.1-33.8l-7.4-6.2C59.7 446.5 48 421.5 48 395.2c0-41.9 29.2-78 70.2-86.8l22.8-4.9z"
        }
    ]
};

const FarNotEqual = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNotEqual",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M373.5 36.2c11 7.5 13.8 22.4 6.3 33.3L329.2 144H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H296.5l-87 128H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H176.9l-69 101.5c-7.5 11-22.4 13.8-33.3 6.3s-13.8-22.4-6.4-33.3l50.6-74.5H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h111.5l87-128H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h231.1l69-101.5c7.5-11 22.4-13.8 33.3-6.4z"
        }
    ]
};

const FarNotdef = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNotdef",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 421.8 162.8 256 48 90.2v331.6zM77.2 464h229.6L192 298.2 77.2 464zm144-208L336 421.8V90.2L221.2 256zm85.6-208H77.2L192 213.8 306.8 48zM0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
        }
    ]
};

const FarNoteMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNoteMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v224h-80c-17.7 0-32 14.3-32 32v80H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 480h229.5c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64zm128-336v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarNoteSticky = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNoteSticky",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h224v-80c0-17.7 14.3-32 32-32h80V96c0-8.8-7.2-16-16-16H64zm224 400H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v229.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7H288z"
        }
    ]
};

const FarNote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNote",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v224h-80c-17.7 0-32 14.3-32 32v80H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 480h229.5c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64zm64-120a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-24-232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 128a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarNotebook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNotebook",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 48h176c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H240V48zm-48 0v416h-64c-8.8 0-16-7.2-16-16v-32h24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24v-88h24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24v-88h24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24V64c0-8.8 7.2-16 16-16h64zM64 416v32c0 35.3 28.7 64 64 64h288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v88H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v88H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40z"
        }
    ]
};

const FarNotesMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNotesMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 96c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16v197.5c0 4.2-1.7 8.3-4.7 11.3l-58.5 58.5c-3 3-7.1 4.7-11.3 4.7H160c-8.8 0-16-7.2-16-16V96zm-48 0v256c0 35.3 28.7 64 64 64h197.5c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm176 32c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32zm24 336H136c-48.6 0-88-39.4-88-88V152c0-13.3-10.7-24-24-24S0 138.7 0 152v224c0 75.1 60.9 136 136 136h160c13.3 0 24-10.7 24-24s-10.7-24-24-24z"
        }
    ]
};

const FarNotes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarNotes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 96c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16v192h-48c-17.7 0-32 14.3-32 32v48H160c-8.8 0-16-7.2-16-16V96zm-48 0v256c0 35.3 28.7 64 64 64h197.5c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm224 392c0-13.3-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V152c0-13.3-10.7-24-24-24S0 138.7 0 152v224c0 75.1 60.9 136 136 136h160c13.3 0 24-10.7 24-24z"
        }
    ]
};

const FarO = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarO",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zm224 176a224 224 0 1 1-448 0 224 224 0 1 1 448 0z"
        }
    ]
};

const FarObjectExclude = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectExclude",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h224c8.8 0 16 7.2 16 16v64h48V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h64v-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm96 336v64c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64h-64v48h64c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16v-64h-48zm128-32c35.3 0 64-28.7 64-64h-48c0 8.8-7.2 16-16 16h-32v48h32zm64-144v-48h-64v48h16v48h48v-48zM224 352v-48h-16v-48h-48v96h64zm-64-128h48c0-8.8 7.2-16 16-16h32v-48h-32c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FarObjectGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectGroup",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48 14.2 0 27 6.2 35.8 16h344.4c8.8-9.8 21.6-16 35.8-16 26.5 0 48 21.5 48 48 0 14.2-6.2 27-16 35.8v280.4c9.8 8.8 16 21.6 16 35.8 0 26.5-21.5 48-48 48-14.2 0-27-6.2-35.8-16H115.8c-8.8 9.8-21.6 16-35.8 16-26.5 0-48-21.5-48-48 0-14.2 6.2-27 16-35.8V115.8zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3v261.4c13.6 4.8 24.4 15.6 29.3 29.3h325.4c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H125.3zm2.7 64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-96zm128 160h32c35.3 0 64-28.7 64-64v-32h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32v-32z"
        }
    ]
};

const FarObjectIntersect = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectIntersect",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 48H64c-8.8 0-16 7.2-16 16v32H0V64C0 28.7 28.7 0 64 0h32v48zm32 0V0h96v48h-96zM0 128h48v96H0v-96zm352 32v128c0 35.3-28.7 64-64 64H160V224c0-35.3 28.7-64 64-64h128zM160 416h48v32c0 8.8 7.2 16 16 16h32v48h-32c-35.3 0-64-28.7-64-64v-32zM352 64v32h-48V64c0-8.8-7.2-16-16-16h-32V0h32c35.3 0 64 28.7 64 64zm64 144v-48h32c35.3 0 64 28.7 64 64v32h-48v-32c0-8.8-7.2-16-16-16h-32zM96 304v48H64c-35.3 0-64-28.7-64-64v-32h48v32c0 8.8 7.2 16 16 16h32zm192 160h96v48h-96v-48zm160 48h-32v-48h32c8.8 0 16-7.2 16-16v-32h48v32c0 35.3-28.7 64-64 64zm64-128h-48v-96h48v96zM304 208h-80c-8.8 0-16 7.2-16 16v80h80c8.8 0 16-7.2 16-16v-80z"
        }
    ]
};

const FarObjectSubtract = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectSubtract",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h32V0H64C28.7 0 0 28.7 0 64v32h48V64c0-8.8 7.2-16 16-16zm160 0V0h-96v48h96zM48 128H0v96h48v-96zm0 128H0v32c0 35.3 28.7 64 64 64h32v-48H64c-8.8 0-16-7.2-16-16v-32zm80 96h96v-48h-96v48zm32 32v64c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64h-64v48h64c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16v-64h-48zm192-176v-80h-48v96h48v-16zm0-144c0-35.3-28.7-64-64-64h-32v48h32c8.8 0 16 7.2 16 16v32h48V64zm-96 240v48h32c35.3 0 64-28.7 64-64v-32h-48v32c0 8.8-7.2 16-16 16h-32z"
        }
    ]
};

const FarObjectUngroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectUngroup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48.2 66.8c-.1-.8-.2-1.7-.2-2.5v-.2c0-8.8 7.2-16 16-16 .9 0 1.9.1 2.8.2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3v105.4C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64 26.9 0 49.9-16.5 59.3-40h201.4c9.5 23.5 32.5 40 59.3 40 35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3V123.3c23.5-9.5 40-32.5 40-59.3 0-35.3-28.7-64-64-64-26.9 0-49.9 16.5-59.3 40H123.3C113.9 16.5 90.9 0 64 0 28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-43.3 24c6.5 16 19.3 28.9 35.3 35.3v105.4c-16 6.5-28.9 19.3-35.3 35.3H123.3c-6.5-16-19.3-28.9-35.3-35.3V123.3c16-6.5 28.9-19.3 35.3-35.3h201.4zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8-.8.1-1.7.2-2.5.2h-.2c-8.8 0-16-7.2-16-16 0-.9.1-1.9.2-2.8 1.2-7.5 7.8-13.2 15.7-13.2 8.8 0 16 7.2 16 16zm391.3-40h45.4c6.5 16 19.3 28.9 35.3 35.3v105.4c-16 6.5-28.9 19.3-35.3 35.3H315.3c-6.5-16-19.3-28.9-35.3-35.3V352h-48v36.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64 26.9 0 49.9-16.5 59.3-40h201.4c9.5 23.5 32.5 40 59.3 40 35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3V283.3c23.5-9.5 40-32.5 40-59.3 0-35.3-28.7-64-64-64-26.9 0-49.9 16.5-59.3 40H448v16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1-31.5-5.5zM271.8 450.7a16 16 0 1 1-31.5-5.5 16 16 0 1 1 31.5 5.5zm301.5 13c-7.5-1.3-13.2-7.9-13.2-15.8 0-8.8 7.2-16 16-16 7.9 0 14.5 5.7 15.8 13.2v.1c.1.9.2 1.8.2 2.7 0 8.8-7.2 16-16 16-.9 0-1.9-.1-2.8-.2z"
        }
    ]
};

const FarObjectUnion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectUnion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 304c26.5 0 48 21.5 48 48v96c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16h-96c-26.5 0-48-21.5-48-48V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h96zm-48 48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v96h96c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-96h-48z"
        }
    ]
};

const FarObjectsAlignBottom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectsAlignBottom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24zm152-176V48h-64v288h64zm-64 48c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-64zm288-48V176h-64v160h64zm-64 48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-64z"
        }
    ]
};

const FarObjectsAlignCenterHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectsAlignCenterHorizontal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 176H80v-64h352v64zm48-64c0-26.5-21.5-48-48-48H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h152v64h-88c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h88v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h88c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-88v-64h152c26.5 0 48-21.5 48-48v-64zM368 400H144v-64h224v64z"
        }
    ]
};

const FarObjectsAlignCenterVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectsAlignCenterVertical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 80v352h64V80h-64zm-48 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v152h64v-88c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v88h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v88c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48v-88h-64v152c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V80zm272 64v224h64V144h-64z"
        }
    ]
};

const FarObjectsAlignLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectsAlignLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0s24 10.7 24 24v464c0 13.3-10.7 24-24 24S0 501.3 0 488V24zm176 152h288v-64H176v64zm-48-64c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48v-64zm48 288h160v-64H176v64zm-48-64c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48v-64z"
        }
    ]
};

const FarObjectsAlignRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectsAlignRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM336 176H48v-64h288v64zm48-64c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-64zm-48 288H176v-64h160v64zm48-64c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-64z"
        }
    ]
};

const FarObjectsAlignTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectsAlignTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24S501.3 0 488 0H24zm152 176v288h-64V176h64zm-64-48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-64zm288 48v160h-64V176h64zm-64-48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-64z"
        }
    ]
};

const FarObjectsColumn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarObjectsColumn",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 80v160h96V80H48zM0 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zm304 192v160h96V272h-96zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V272zm-112 96H48v64h96v-64zm-96-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48zM304 80v64h96V80h-96zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80z"
        }
    ]
};

const FarOctagonCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOctagonCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17l-33.9 33.9A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9 119.4 119.4c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7l119.4-119.4c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM369 209 241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarOctagonDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOctagonDivide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17l-33.9 33.9A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9 119.4 119.4c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7l119.4-119.4c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-88 104h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarOctagonExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOctagonExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17l-33.9 33.9A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9 119.4 119.4c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7l119.4-119.4c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM256 128c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarOctagonMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOctagonMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17l-33.9 33.9A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9 119.4 119.4c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7l119.4-119.4c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM184 232h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarOctagonPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOctagonPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17l-33.9 33.9A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9 119.4 119.4c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7l119.4-119.4c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM232 344v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarOctagonXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOctagonXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17l-33.9 33.9A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9 119.4 119.4c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7l119.4-119.4c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarOctagon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOctagon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M174.5 55.1c4.5-4.5 10.6-7 17-7h129c6.4 0 12.5 2.5 17 7l119.4 119.4c4.5 4.5 7 10.6 7 17v129c0 6.4-2.5 12.5-7 17L337.5 456.9c-4.5 4.5-10.6 7-17 7h-129c-6.4 0-12.5-2.5-17-7L55.1 337.5l-33.9 33.9 33.9-33.9c-4.5-4.5-7-10.6-7-17v-129c0-6.4 2.5-12.5 7-17L174.5 55.1zM.1 320.5c0 19.1 7.6 37.4 21.1 50.9l119.4 119.4c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1l119.4-119.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2A71.983 71.983 0 0 0 320.5.1h-129c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6A71.983 71.983 0 0 0 .1 191.5v129z"
        }
    ]
};

const FarOilCanDrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOilCanDrip",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 88c0 13.3-10.7 24-24 24h-48v48h88.9c9.9 0 19.7 2.3 28.6 6.8L448 192l139.8-30 2.1-.4 11.3-2.4 13.9-3c18.1-3.9 30.7 17.6 18.4 31.5l-9.4 10.6-7.6 8.6-1.4 1.6-164 185.8c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48v-21.3l-67.5-30C11.2 309 0 291.8 0 272.8V208c0-26.5 21.5-48 48-48h184v-48h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h144c13.3 0 24 10.7 24 24zm106.7 154.1c-11.4 2.4-23.2.9-33.6-4.3l-50.5-25.2c-1.8-.9-3.7-1.4-5.7-1.4H147.2v153.6h255.9c3.7 0 7.2-1.6 9.6-4.3l118.1-133.9-72.1 15.4zM96 211.2V208H48v64.8l48 21.3v-82.9zM592 448c-26.5 0-48-21.5-48-48 0-21 20.6-62.6 34.9-88.8 5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400c0 32-21.5 48-48 48z"
        }
    ]
};

const FarOilCan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOilCan",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328 112c13.3 0 24-10.7 24-24s-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48H48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48h259.1c18.4 0 35.8-7.9 48-21.7L615 208.6l1.4-1.6 7.6-8.6 9.4-10.6c12.3-13.9-.3-35.4-18.4-31.5l-13.9 3-11.3 2.4-2.1.4L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H280v-48h48zm97.1 125.8c10.4 5.2 22.3 6.7 33.6 4.3l72.1-15.4-118.1 133.8c-2.4 2.8-5.9 4.3-9.6 4.3H147.2V211.2h221.7c2 0 3.9.5 5.7 1.4l50.5 25.2zM96 294.1l-48-21.3V208h48v86.1z"
        }
    ]
};

const FarOilTemperature = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOilTemperature",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 24c0-13.3 10.7-24 24-24h72c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v83.7c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V24zm24 312a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-176.1-49.9c17.8 15.4 41.2 28.5 65 32.6 2.4 18.1 9.1 34.9 19.1 49.3-1.3 0-2.7.1-4.1.1-34.6 0-67.9-14.3-96-33.8-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7 9.1-8.1 22.8-8.1 31.9 0zM384 368c-1.3 0-2.7 0-4-.1 10-14.3 16.7-31.1 19.1-49.3 23.8-4.1 47.2-17.2 65-32.6 9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8zm-272 62.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7 9.1-8.1 22.8-8.1 31.9 0z"
        }
    ]
};

const FarOilWell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOilWell",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M482 73.7c-4.6-17.1-22.1-27.2-39.2-22.6l58 216.4c17.1-4.6 27.2-22.1 22.6-39.2L482 73.7zm-51.6-69c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-15.5 4.1c-17.1 4.6-34.6-5.6-39.2-22.6l-27.2-101.7L96 280.5V464h44.1L198 294.3l55.6-14.4-24.5 72.1H315l-27.6-80.8 46.6-12.1L404 464h148c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V184c0-13.3 10.7-24 24-24s24 10.7 24 24v46.9l135.7-35.2 17.6-51.5c3.3-9.7 12.4-16.2 22.7-16.2s19.4 6.5 22.7 16.2l11 32.3 113.1-29.3L392.3 48c-4.6-17.1 5.6-34.6 22.6-39.2l15.5-4.1zM353.2 464l-21.9-64H212.7l-21.9 64h162.4z"
        }
    ]
};

const FarOliveBranch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOliveBranch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M2.7 53.1C13.8 41.6 59 0 128 0c66.9 0 111.4 39.1 124.2 52L306 26.7C343.3 9.1 384 0 425.2 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H425.2c-34.2 0-67.9 7.5-98.8 22.1l-134.5 63.3C189.1 219.3 118.6 288 32 288H16c-8.8 0-16-7.2-16-16v-16c0-61.4 34.5-114.6 85.2-141.5-44.8-11.7-73.9-38.7-82.5-47.6C.9 65 0 62.6 0 60s.9-5 2.7-6.9zM399.4 427c19.3-25.7 32.6-63.3 32.6-107s-13.3-81.3-32.6-107c-19.2-25.7-42.2-37-63.4-37s-44.2 11.4-63.4 37c-19.3 25.7-32.6 63.4-32.6 107s13.3 81.3 32.6 107c19.2 25.7 42.2 37 63.4 37s44.2-11.4 63.4-37zM336 512c-79.5 0-144-86-144-192s64.5-192 144-192 144 86 144 192-64.5 192-144 192zm129.7-40.2c9.4-13.1 17.6-27.5 24.4-43.1 3.6.8 7.1 1.5 10.5 2 31.1 4.6 55-3.6 70.2-19.3 15.4-16 23.9-42.1 19.2-76-4.7-33.8-22.2-71.6-53.2-103.7-18-18.7-37.7-32.5-57.2-41.7-4.9-8.8-10.3-17.2-16.2-25-10.5-14-22.7-26.5-36.2-36.9 48.2 1.6 101.3 25.8 144.2 70.3 75 77.8 90.2 188.1 33.9 246.4-34.1 35.4-86.8 43.5-139.6 27z"
        }
    ]
};

const FarOlive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOlive",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 432c-61.9 0-112-50.1-112-112 0-79.2 37-138.4 85.9-179.1C184.3 99 243.7 80 280 80c13.6 0 31.8 7.5 50.4 19.9 8.5 5.7 15.7 11.4 20.8 15.8 2.5 2.1 4.4 3.9 5.6 5l1.2 1.2.1.1.1.1 1.2 1.2c1.1 1.2 2.9 3.1 5 5.6 4.3 5 10.1 12.2 15.8 20.8 12.3 18.5 19.8 36.7 19.8 50.3 0 36.3-19 95.7-60.9 146.1C298.4 395 239.2 432 160 432zM0 320c0 88.4 71.6 160 160 160 192 0 288-181.9 288-280 0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zm271.1-111.1c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8-69.6-40.1-87.8-21.9-8.4 57.5 21.9 87.8z"
        }
    ]
};

const FarOm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOm",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zm10.9 255c7.5-7.5 17.7-11.7 28.3-11.7h5.5c22.1 0 40 17.9 40 40v112c0 17.7-14.3 32-32 32-25.7 0-41.4-12.5-51.2-25.6-5-6.7-8.4-13.4-10.5-18.6-1.1-2.5-1.8-4.6-2.2-6-.2-.7-.4-1.2-.5-1.5l-.1-.3c-1.8-7.3-8.4-12.3-15.9-12.1s-13.8 5.5-15.3 12.9L352 384l-15.7-3.1v.1l-.1.3c0 .3-.1.6-.2 1-.1.8-.3 1.9-.4 3.2-.3 2.7-.6 6.4-.6 10.9 0 8.8 1.2 21 6.1 33.4 5.1 12.7 14.1 25.6 29.4 35.1 15.1 9.5 35.3 14.9 61.5 14.9 44.2 0 80-35.8 80-80V288c0-48.6-39.4-88-88-88h-5.5c-23.3 0-45.7 9.3-62.2 25.8l-26.5 26.5c-7.5 7.5-17.7 11.7-28.3 11.7h-69.8c10.3-16.2 16.3-35.4 16.3-56 0-57.4-46.6-104-104-104-23.4 0-45 7.7-62.4 20.8-10.6 8-12.7 23-4.8 33.6s23 12.7 33.6 4.8c9.4-7 21-11.2 33.6-11.2 30.9 0 56 25.1 56 56s-25.1 56-56 56h-35.1c-7.1 0-12.9 5.8-12.9 12.9 0 2 .5 4 1.4 5.8l5.8 11.6c5.4 10.8 16.5 17.7 28.6 17.7H156c42 0 76 34 76 76 0 41.5-33.2 75.2-74.5 76-50.1-.6-77-18.5-91.6-34.7-7.6-8.5-12.3-16.9-15-23.2-1.3-3.1-2.2-5.6-2.7-7.3-.2-.8-.4-1.4-.5-1.8l-.1-.3c-1.7-8-9.1-13.5-17.2-12.7-8.2.9-14.4 7.8-14.4 16h16-16v1.8c0 1 .1 2.3.3 3.9.3 3.2.9 7.6 2.1 12.8 2.3 10.4 7 24.4 16.3 38.4C53.6 485.3 89.9 511 156 512h4c.8 0 1.5-.1 2.2-.2C227.8 508.6 280 454.4 280 388c0-28.6-9.7-55-26-76h47.5c23.3 0 45.7-9.3 62.2-25.8l26.5-26.5zm80.8-153c10.4-8.3 12-23.4 3.8-33.7l-33.7-3.8-.2.1c-.2.1-.5.4-1 .7-.9.7-2.4 1.7-4.3 3-3.8 2.6-9.5 6-16.4 9.5-14.1 7.1-32.2 13.5-51 13.5h-.2c-20.8 0-42.4-7-59.5-14.6-8.4-3.7-15.4-7.5-20.3-10.3-2.4-1.4-4.3-2.5-5.6-3.3-.6-.4-1.1-.7-1.4-.9l-.3-.2c-6.3-4.2-14.8-3.4-20.2 2s-6.2 13.8-2 20.2L272 80l-13.3 8.9.1.1.1.2.4.6c.3.5.8 1.1 1.4 1.9 1.2 1.6 3 3.8 5.3 6.4 4.6 5.1 11.3 11.9 20.4 18.7 18 13.5 45.3 27.2 81.5 27.2h.1c29.1 0 54.9-9.6 72.7-18.5 9.1-4.5 16.4-9.1 21.6-12.5 2.6-1.7 4.6-3.2 6.1-4.3.7-.5 1.3-1 1.7-1.3l.5-.4.2-.1.1-.1-15-18.7 15 18.7zm-29.9-37.5 33.6 3.8c-8.3-10.3-23.3-12-33.7-3.8zm-73.6 310.9z"
        }
    ]
};

const FarOmega = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOmega",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 80c-97.2 0-176 78.8-176 176 0 63.7 33.8 119.5 84.6 150.4 11.4 7 19.4 19.6 19.4 34.2 0 21.8-17.6 39.4-39.4 39.4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h61.4C33.4 391 0 327.4 0 256 0 132.3 100.3 32 224 32s224 100.3 224 224c0 71.4-33.4 135-85.4 176H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88.6c-21.8 0-39.4-17.6-39.4-39.4 0-14.6 8-27.2 19.4-34.2C366.2 375.5 400 319.7 400 256c0-97.2-78.8-176-176-176z"
        }
    ]
};

const FarOnion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOnion",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 33.9c.2-.7.4-1.5.6-2.2 1-3.8 1.9-7.8 2.5-11.9C176.2 9 184.9 0 195.8 0c6.3 0 12.1 3 15.8 7.9.7.9 1.3 1.9 1.9 3l3.4 6.8c2.9 5.9 11.4 5.9 14.3 0l3.4-6.8c.5-1.1 1.2-2.1 1.9-3C240.1 3 245.9 0 252.2 0c10.9 0 19.6 9 21.3 19.8.6 4.1 1.5 8.1 2.5 11.9.2.7.4 1.5.6 2.2v.1c11.6 39.7 43.1 65.3 76 92C399 163.7 448 203.5 448 288c0 80.4-58 135.2-131.9 160.3l10.7 32.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2L269.4 460c-7.1 1.2-14.2 2.1-21.4 2.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-25.3c-7.2-.7-14.3-1.6-21.4-2.7l-11.9 35.6c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4l10.7-32.1C58 423.2 0 368.4 0 288c0-84.5 49-124.3 95.3-162 32.9-26.7 64.4-52.4 76-92v-.1zm31.3 48.2c-7.9 13.9-17.4 26-27.5 36.8-.5.5-1 1.1-1.5 1.6-.4.8-.9 1.9-1.5 3.2-1.5 3.2-3.6 7.9-6.2 13.7-5.1 11.7-12 28.2-18.9 46.9-13.9 38.1-27 83.8-27 119.5 0 32.5 9.2 60.2 18.5 79.8 3.8 8.1 7.6 14.7 10.8 19.7 17.4 5.8 36.1 9.6 55.3 11.4-10.4-25-20.6-60.5-20.6-102.7 0-61.9 6.1-128.6 12.1-179.6 2.3-19.3 4.6-36.4 6.5-50.2zm34.3-13.5c-.3 1.8-.6 3.8-.9 5.8-2.2 15.1-5.2 36.5-8.2 61.7C221.9 186.6 216 251.9 216 312c0 37.9 9.4 69.8 18.8 92.2 1.7 4 3.3 7.7 4.9 11 21.3-1.7 41.9-5.9 61-12.4 3.3-4.4 7.1-10.2 11-17.2 9.9-17.9 19.7-43.2 19.7-73.6 0-37.1-15.8-88.6-32.6-132.5-8.3-21.6-16.6-40.7-22.8-54.5-.8-1.9-1.7-3.7-2.4-5.3-.2-.2-.4-.5-.7-.7-13.2-14.2-25.6-30.8-34.5-50.7-.5.1-.9.2-1.4.3zm91.9 99.9c16.8 43.9 34.6 100.1 34.6 143.5 0 25.2-5.5 47.4-12.6 65.7 31.3-22.5 49.2-52.4 49.2-89.7 0-53.7-25.3-81.3-63.6-113.2-2.4-2-5-4.1-7.6-6.3zM102.6 381.4C94.6 360.5 88 334.1 88 304c0-41.6 14.9-91.9 29-130.5.6-1.5 1.1-3.1 1.7-4.6-2.5 2-4.8 4-7.1 5.8C73.3 206.7 48 234.3 48 288c0 37.7 18.2 67.7 50 90.2 1.5 1.1 3.1 2.1 4.6 3.2z"
        }
    ]
};

const FarOption = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOption",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M172.1 120.4c-4.6-5.3-11.2-8.4-18.2-8.4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h129.9c21 0 41 9.2 54.7 25.1l259.3 302.5c4.6 5.3 11.2 8.4 18.2 8.4H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H486.1c-21 0-41-9.2-54.7-25.1L172.1 120.4zM616 64c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h176z"
        }
    ]
};

const FarOrnament = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOrnament",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.1 22.6 8.6 32H128c-17.7 0-32 14.3-32 32v25.7C38.6 186.9 0 248.9 0 320c0 106 86 192 192 192s192-86 192-192c0-71.1-38.6-133.1-96-166.3V128c0-17.7-14.3-32-32-32h-8.6zM192 176c42.6 0 81 18.5 107.3 48H84.7c26.4-29.5 64.7-48 107.3-48zM56.2 272h271.6c5.3 15 8.2 31.2 8.2 48s-2.9 33-8.2 48H56.2c-5.3-15-8.2-31.2-8.2-48s2.9-33 8.2-48zm28.5 144h214.6c-26.3 29.5-64.7 48-107.3 48s-81-18.5-107.3-48z"
        }
    ]
};

const FarOtter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOtter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2 12.9 6.4c5.9 3 12.4 4.5 19.1 4.5 23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6 6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2-11.9-7.9zm24.9 55-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6-5.1 0-10.1-.4-14.9-1.2 9.5 28.6 36.5 49.2 68.3 49.2h64c13.3 0 24 10.7 24 24 0 2.8-.5 5.5-1.4 8H352c0-11.4 2.4-22.2 6.7-32H328c-36.7 0-68.1-22.4-81.3-54.3-10.3 4.1-21.5 6.3-33.3 6.3-14.1 0-27.9-3.3-40.5-9.6L160 240zm250.8 16c10.8-45.9 52-80 101.2-80 13.3 0 24 10.7 24 24v-5.7c0-38.8-24.9-73.3-61.7-85.6l-17.9-6c-12.1-4-18.9-16.8-15.6-29s15.7-19.8 28.1-17.2l16.2 3.4c90.3 19 154.9 98.6 154.9 190.9 0 120.3-92.6 218.9-210.4 228.5-4.5.5-9 .8-13.6.8H257.6C133 480 32 379 32 254.4v-37.6c-10.1-14.6-16-32.3-16-51.4v-22.8C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8c18-37.8 56.5-64 101.2-64h64c44.7 0 83.2 26.2 101.2 64h2.8c13.3 0 24 10.7 24 24 0 10.5-6.7 19.3-16 22.6v22.8c0 8-1 15.7-3 23.1 12.4-7.9 27.2-12.5 43-12.5h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-16.6 0-30.2 12.6-31.8 28.7 4.9 2.1 10.2 3.3 15.8 3.3h82.8zM99.7 335.8l.1.2h.3l-.4-.2zM410.8 432c4.7 0 9.4-.2 14.1-.5 35.6-4.4 63.1-34.7 63.1-71.5V229.4c-18.9 9-32 28.3-32 50.6 0 13.3-10.7 24-24 24-17.7 0-32 14.3-32 32v24c0 13.3-10.7 24-24 24H136.2c31.8 29.8 74.5 48 121.4 48h153.2zM536 360c0 8.2-.8 16.3-2.4 24 35.9-33.1 58.4-80.6 58.4-133.3 0-16.7-2.8-32.8-8-47.9v5.2c0 35.5-19.3 66.6-48 83.2V360zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarOutdent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOutdent",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 88 0 77.3 0 64zm192 128c0-13.3 10.7-24 24-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24zm24 104h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 448c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm7-179.6C-.8 262-.8 250 7 243.6l94.8-78.1c10.4-8.6 26.2-1.2 26.2 12.4v156.2c0 13.5-15.7 20.9-26.2 12.4L7 268.4z"
        }
    ]
};

const FarOutlet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOutlet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm80 160c0-52.3 26.5-85.2 43.6-100.9 8.6-8 20.2-11.1 31.9-11.1h137c11.7 0 23.3 3.1 31.9 11.1 17 15.8 43.6 48.7 43.6 100.9s-26.5 85.2-43.6 100.9c-8.6 8-20.2 11.1-31.9 11.1h-137c-11.7 0-23.3-3.1-31.9-11.1C106.5 341.2 80 308.3 80 256zm96-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48zm-104 88v16c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-16c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FarOven = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOven",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48c26.5 0 48 21.5 48 48v64H48V96c0-26.5 21.5-48 48-48h256zm48 160v240c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208h352zM96 0C43 0 0 43 0 96v352c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-53-43-96-96-96H96zm32 104a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 240c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H112zm32 48h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarOverline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarOverline",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm200 80c-97.2 0-176 78.8-176 176v16c0 97.2 78.8 176 176 176s176-78.8 176-176v-16c0-97.2-78.8-176-176-176zM96 288c0-70.7 57.3-128 128-128s128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 374.7 96 304v-16z"
        }
    ]
};

const FarP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarP",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 80h112c57.4 0 104 46.6 104 104s-46.6 104-104 104H48V88c0-4.4 3.6-8 8-8zm-8 256h120c83.9 0 152-68.1 152-152S251.9 32 168 32H56C25.1 32 0 57.1 0 88v368c0 13.3 10.7 24 24 24s24-10.7 24-24V336z"
        }
    ]
};

const FarPageCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPageCaretDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V138.5c0-4.2-1.7-8.3-4.7-11.3l-74.5-74.5c-3-3-7.1-4.7-11.3-4.7H64c-8.8 0-16 7.2-16 16v384zm272 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h181.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64zM192 352c-4.5 0-8.8-1.9-11.8-5.2l-75.7-82.6c-14.1-15.4-3.2-40.2 17.7-40.2h139.6c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2z"
        }
    ]
};

const FarPageCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPageCaretUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V138.5c0-4.2-1.7-8.3-4.7-11.3l-74.5-74.5c-3-3-7.1-4.7-11.3-4.7H64c-8.8 0-16 7.2-16 16v384zm272 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h181.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64zM192 192c4.5 0 8.8 1.9 11.8 5.2l75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2H122.2c-20.9 0-31.8-24.8-17.7-40.2l75.7-82.6c3-3.3 7.3-5.2 11.8-5.2z"
        }
    ]
};

const FarPage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPage",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h256c8.8 0 16-7.2 16-16V138.5c0-4.2-1.7-8.3-4.7-11.3l-74.5-74.5c-3-3-7.1-4.7-11.3-4.7H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16zm256 48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h181.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64z"
        }
    ]
};

const FarPager = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPager",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 112c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h384zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 128v32c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm16 112c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24h-56zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48z"
        }
    ]
};

const FarPaintRoller = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPaintRoller",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48H64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zM64 0h288c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zm96 352c0-17.7 14.3-32 32-32h8v-16c0-39.8 32.2-72 72-72h152c22.1 0 40-17.9 40-40v-48c0-10.4-6.7-19.3-16-22.6v-49c36 4 64 34.5 64 71.6v48c0 48.6-39.4 88-88 88H272c-13.3 0-24 10.7-24 24v16h8c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V352z"
        }
    ]
};

const FarPaintbrushFine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPaintbrushFine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M489 57 306.2 239.7l30.1 30.1L519 87c8.3-8.3 8.3-21.8 0-30.1s-21.8-8.3-30.1 0zM210.5 325c-8.2-3.3-17.2-5-26.5-5-39.8 0-72 32.2-72 72 0 3.8.3 7.5.8 11.1 3.3 21.4-2.2 43.1-13.8 60l-.7.9H184c39.8 0 72-32.2 72-72 0-9.4-1.8-18.3-5-26.5L210.5 325zm-6.2-51.3L455 23c27-27 70.9-27 97.9 0s27 70.9 0 97.9L302.3 371.7c1.1 6.6 1.7 13.4 1.7 20.3 0 66.3-53.7 120-120 120H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h6c18.1 0 30.1-19.8 27.4-37.6-.9-6-1.4-12.1-1.4-18.4 0-66.3 53.7-120 120-120 6.9 0 13.7.6 20.3 1.7z"
        }
    ]
};

const FarPaintbrushPencil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPaintbrushPencil",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M181.3 19.3c-25-25-65.5-25-90.5 0L51.3 58.7c-3.1 3.1-5.9 6.5-8.2 10-16.4 24.8-13.7 58.6 8.2 80.5l88.8 88.8c13.9-4 28.6-6.1 43.9-6.1h1.5l8.2-8.2L161 191l62-62 32.8 32.8 33.9-33.9L181.3 19.3zm232.9 300.8 37.3 37.3c.6.6 1.2 1.2 1.7 1.8 3.9 4.4 6.7 9.6 8.4 15.2l6.9 23.4 16.1 54.8-54.8-16.1-23.4-6.9c-6.4-1.9-12.3-5.4-17-10.1l-37.3-37.3-8.1 8.1v1.7c0 15.2-2.1 29.9-6.1 43.9l17.6 17.6c1.3 1.3 2.6 2.6 4 3.8 9.6 8.5 21 14.8 33.4 18.4l78.1 23 42.2 12.3c8.4 2.5 17.5.2 23.7-6.1s8.5-15.3 6.1-23.7L530.6 439l-23-78.1c-4.2-14.1-11.8-27-22.2-37.4l-37.3-37.3-33.9 33.9zM519 57c8.3 8.3 8.3 21.8 0 30.1L336.3 269.8l-30.1-30.1L489 57c8.3-8.3 21.8-8.3 30.1 0zM184 320c9.4 0 18.3 1.8 26.5 5l40.5 40.5c3.3 8.2 5 17.2 5 26.5 0 39.8-32.2 72-72 72H98.4l.7-.9c11.6-16.9 17.1-38.6 13.8-60-.5-3.6-.8-7.3-.8-11.1 0-39.8 32.2-72 72-72zM455 23 204.3 273.7c-6.6-1.1-13.4-1.7-20.3-1.7-66.3 0-120 53.7-120 120 0 6.2.5 12.4 1.4 18.4C68.1 428.2 56.1 448 38 448h-6c-17.7 0-32 14.3-32 32s14.3 32 32 32h152c66.3 0 120-53.7 120-120 0-6.9-.6-13.7-1.7-20.3L553 121c27-27 27-70.9 0-97.9s-70.9-27-97.9 0z"
        }
    ]
};

const FarPaintbrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPaintbrush",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m278 219.5 78.5 78.5L524.7 73.6c4.8-6.4 4.1-15.3-1.5-20.9s-14.5-6.3-20.9-1.5L278 219.5zm-78.9 102.1c-4.9-1-9.9-1.6-15.1-1.6-39.8 0-72 32.2-72 72 0 3.8.3 7.5.8 11.1 3.3 21.4-2.2 43.1-13.8 60l-.7.9H184c39.8 0 72-32.2 72-72 0-5.2-.5-10.2-1.6-15.1L199 321.5zM384 341.3c-19.1 25.5-48.6 41.1-80.3 42.6.2 2.7.3 5.4.3 8.1 0 66.3-53.7 120-120 120H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h6c18.1 0 30.1-19.8 27.4-37.6-.9-6-1.4-12.1-1.4-18.4 0-66.3 53.7-120 120-120 2.7 0 5.4.1 8.1.3 1.5-31.7 17-61.1 42.5-80.3L473.5 12.8c25.5-19.1 61.1-16.6 83.7 5.9s25.1 58.2 6 83.7L384 341.3z"
        }
    ]
};

const FarPalette = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPalette",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 258.2c0 2.7-1 5.2-4.2 8-3.8 3.1-10.1 5.8-17.8 5.8h-98c-53 0-96 43-96 96 0 6.8.7 13.4 2.1 19.8 3.3 15.7 10.2 31.1 14.4 40.6.7 1.6 1.4 3 1.9 4.3 5 11.5 5.6 15.4 5.6 17.1 0 5.3-1.9 9.5-3.8 11.8-.9 1.1-1.6 1.6-2 1.8-.3.2-.8.3-1.6.4-2.9.1-5.7.2-8.6.2-114.9 0-208-93.1-208-208S141.1 48 256 48s208 93.1 208 208v2.2zm48 .5V256C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c3.5 0 7.1-.1 10.6-.2 31.8-1.3 53.4-30.1 53.4-62 0-14.5-6.1-28.3-12.1-42-4.3-9.8-8.7-19.7-10.8-29.9-.7-3.2-1-6.5-1-9.9 0-26.5 21.5-48 48-48H442c36.5 0 69.7-24.8 70.1-61.3zM160 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarPalletBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPalletBox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48v80c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L320 115.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4.8s-8.5-8.2-8.5-14.1V48h-80v192h288V48h-80zm-256 0c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v192c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V48zM0 344c0-13.3 10.7-24 24-24h592c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v96h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40v-96H24c-13.3 0-24-10.7-24-24zm112 120h184v-96H112v96zm232 0h184v-96H344v96z"
        }
    ]
};

const FarPalletBoxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPalletBoxes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 48H112v160h160V48zM112 0h160c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zm416 112h-96v96h96v-96zm-96-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zM0 344c0-13.3 10.7-24 24-24h592c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v96h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40v-96H24c-13.3 0-24-10.7-24-24zm112 120h184v-96H112v96zm232 0h184v-96H344v96z"
        }
    ]
};

const FarPallet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPallet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v96H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-96h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm88 48h184v96H112v-96zm232 0h184v96H344v-96z"
        }
    ]
};

const FarPanFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPanFood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zm-464 0a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm-16-72v144c0 13.3-10.7 24-24 24S0 341.3 0 328V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm568-24c13.3 0 24 10.7 24 24v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24zm-372.6-17.2C250.7 106.3 282.8 80 320 80s69.3 26.3 76.6 62.8l.6 3.2c1.4 7.3-4.1 14-11.5 14H254.3c-7.4 0-12.9-6.8-11.5-14l.6-3.2zm-13.3 43.1c7.8 7.8 7.8 20.5 0 28.3l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0zM296 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-188.7-75.3c2.1 2.1 3.5 4.6 4.2 7.3.4 1.7.8 3.4 1.1 5.1 1.1 5.4 2.1 11 5.9 14.7l3.4 3.4c3 3 7.1 4.7 11.3 4.7H280c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56v-26.6c0-4.2-1.7-8.3-4.7-11.3l-3.4-3.4c-3.8-3.8-9.3-4.8-14.7-5.9-1.7-.3-3.5-.7-5.1-1.1-2.7-.7-5.2-2.1-7.3-4.2-6.2-6.2-6.2-16.4 0-22.6l8-8 8-8c6.2-6.2 16.4-6.2 22.6 0zm132.9-4.9 79.6-79.6c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6v4.8c0 18.7-8.5 36.4-23.1 48.1-10.9 8.7-24.5 13.5-38.5 13.5h-4.1c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4z"
        }
    ]
};

const FarPanFrying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPanFrying",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 224a176 176 0 1 0-352 0 176 176 0 1 0 352 0zm-35.2 174.3C326.3 429.4 277.3 448 224 448 100.3 448 0 347.7 0 224S100.3 0 224 0s224 100.3 224 224c0 33.4-7.3 65.1-20.4 93.6l123.7 79.9c15.4 11.7 24.7 29.6 24.7 50.5 0 35.3-28.7 64-64 64-15.2 0-28.3-4.6-39.3-13.5L364.8 398.3zM528 448a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM254.1 115.6c15.2 15.8 44.5 32.9 65.8 38.4a63.69 63.69 0 0 1 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5-8.9 6.6-18.9 10.5-29.2 12-18.6 2.6-42.2 16.3-51.6 32.6-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6 1.3-14.9 7.8-29.4 19.4-40.5 25.5-24.5 66-23.7 90.5 1.8zM272 224a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarPancakes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPancakes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 192c0-17.7 14.3-31.9 32-32.6C396.6 155 480 128.3 480 96c0-35.3-100.3-64-224-64S32 60.7 32 96c0 13.8 15.3 26.6 41.3 37 13.2 5.3 22.7 17.6 22.7 31.8V264c0 13.3 10.7 24 24 24s24-10.7 24-24v-76.7c0-18.8 15.8-33.2 34.4-31.2 16 1.7 29.6 15 29.6 31V216c0 13.3 10.7 24 24 24s24-10.7 24-24v-24zM192 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zM64 163.8c-12.1-4.7-23.1-10.1-32.3-16.3-9.1-6.2-19.6-15.3-26-27.8C2 127.1 0 135.2 0 144c0 15.3 6 28.6 16.9 40C6 195.4 0 208.7 0 224s6 28.6 16.9 40C6 275.4 0 288.7 0 304s6 28.6 16.9 40C6 355.4 0 368.7 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-15.3-6-28.6-16.9-40 10.9-11.4 16.9-24.7 16.9-40s-6-28.6-16.9-40c10.9-11.4 16.9-24.7 16.9-40s-6-28.6-16.9-40c10.9-11.4 16.9-24.7 16.9-40 0-8.8-2-16.9-5.7-24.3-6.3 12.4-16.9 21.6-26 27.8-15.3 10.2-35.3 18.3-57.1 24.5-8.2 2.3-17 4.5-26.2 6.5-29.9 7.1-67 11.5-109 12.9V216c0 8.4-1.9 16.5-5.2 23.6 68.3-1.9 128.5-11.1 170.1-28.6 2.5 1.7 4.5 3.3 6.2 4.9 4.9 4.6 4.9 6.9 4.9 8v.2c0 1.2 0 3.4-4.9 8-6.1 5.7-17.8 12.8-37.4 19.4C382.4 264.8 324.4 272 256 272c-6.5 0-13-.1-19.3-.2-1.6.1-3.1.2-4.7.2-2.7 0-5.3-.2-7.8-.5-17-.6-33.1-1.7-48.3-3.2-1.5 19.4-12.8 36-29 44.9C180 317.8 217 320 256 320c79.2 0 150-9.2 196.9-29 2.5 1.7 4.5 3.3 6.2 4.9 4.9 4.6 4.9 6.9 4.9 8v.2c0 1.2 0 3.4-4.9 8-6.1 5.7-17.8 12.8-37.4 19.4C382.4 344.8 324.4 352 256 352s-126.4-7.2-165.6-20.4C70.7 325 59 317.9 53 312.2c-4.9-4.6-4.9-6.9-4.9-8v-.2c0-1.2 0-3.4 4.9-8 1.6-1.5 3.7-3.2 6.2-4.9 4.9 2.1 10.2 4.1 15.6 5.9C68 287.7 64 276.3 64 264v-23.9c-4.8-2.8-8.5-5.5-11.1-7.9-4.9-4.6-4.9-6.9-4.9-8v-.2c0-1.2 0-3.4 4.9-8 1.6-1.5 3.7-3.2 6.2-4.9 1.6.7 3.2 1.3 4.9 2v-49.3zM59.1 371c47 19.8 117.7 29 196.9 29s150-9.2 196.9-29c2.5 1.7 4.5 3.3 6.2 4.9 4.9 4.6 4.9 6.9 4.9 8v.2c0 1.2 0 3.4-4.9 8-6.1 5.7-17.8 12.8-37.4 19.4C382.4 424.8 324.4 432 256 432s-126.4-7.2-165.6-20.4C70.7 405 59 397.8 53 392.2c-4.9-4.6-4.9-6.9-4.9-8v-.2c0-1.2 0-3.4 4.9-8 1.6-1.5 3.7-3.2 6.2-4.9z"
        }
    ]
};

const FarPanelEws = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPanelEws",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v230.7C76.3 307 96 335.2 96 368v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64v-16c0-14.2-6.2-27-16-35.8V448c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm112 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-192 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarPanelFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPanelFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h242.1c8.1 17.5 18.8 33.7 31.5 48H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v32.2c-12.6-1.2-25.5 2.7-35.5 11.7-4.2 3.8-8.4 7.6-12.5 11.5V96c0-8.8-7.2-16-16-16zm-90.2 231.3c-1.8.5-3.8.7-5.8.7-13.3 0-24-10.7-24-24s10.7-24 24-24c8.2 0 15.5 4.1 19.8 10.4-5.8 12.1-10.6 24.5-14 36.9zM96 160c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-32zm32 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm269.5-124.4c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79 0 87.8-71.3 159.8-160 159.8-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM530 432.9c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15z"
        }
    ]
};

const FarPanorama = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPanorama",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 80.9C72.3 88.8 177.5 120 320 120s247.7-31.2 272-39.1v350.2c-9.8-3.2-32.9-10.2-66.3-17.4-.5-1-1-1.9-1.6-2.8l-136-208c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9L264.8 330l-29.5-40.2c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8l-88 120c-1.3 1.8-2.4 3.8-3.1 5.8-28.7 6.5-48.6 12.6-57.5 15.5V80.9zm531.6-46.5C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4c-4.8-1.6-9.7-2.4-14.8-2.4C20.4 32 0 52.4 0 77.6v356.8C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4 25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarPaperPlaneTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPaperPlaneTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M133.9 232 65.8 95.9 383.4 232H133.9zm0 48h249.5L65.8 416.1l68-136.1zM44.6 34.6C32.3 29.3 17.9 32.3 8.7 42S-2.6 66.3 3.4 78.3L92.2 256 3.4 433.7c-6 12-3.9 26.5 5.3 36.3s23.5 12.7 35.9 7.5l448-192c11.8-5 19.4-16.6 19.4-29.4s-7.6-24.4-19.4-29.4l-448-192z"
        }
    ]
};

const FarPaperPlane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPaperPlane",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376v103.3c0 18.1 14.6 32.7 32.7 32.7 9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1-123.1-51.3zm335.1 139.7-166.6-69.5 214.1-239.3-47.5 308.8z"
        }
    ]
};

const FarPaperclipVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPaperclipVertical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 108C48 48.4 96.4 0 156 0s108 48.4 108 108v236c0 39.8-32.2 72-72 72s-72-32.2-72-72V152c0-13.3 10.7-24 24-24s24 10.7 24 24v192c0 13.3 10.7 24 24 24s24-10.7 24-24V108c0-33.1-26.9-60-60-60s-60 26.9-60 60v260c0 53 43 96 96 96s96-43 96-96V152c0-13.3 10.7-24 24-24s24 10.7 24 24v216c0 79.5-64.5 144-144 144S48 447.5 48 368V108z"
        }
    ]
};

const FarPaperclip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPaperclip",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M375 73c-26-26-68.1-26-94.1 0L89 265c-43.7 43.6-43.7 114.4 0 158s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39c44.7-44.7 117.2-44.7 162 0s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8 10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z"
        }
    ]
};

const FarParachuteBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarParachuteBox",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M383.5 192c.3-5.3.5-10.6.5-16 0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4.2 10.7.5 16H232v128h-24c-3.3 0-6.5.3-9.6 1L96.3 188.9c-.2-4.3-.3-8.6-.3-12.9 0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6 1.5 183.1 9 192 18.9 192H38l124.4 161c-1.6 4.7-2.4 9.8-2.4 15v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-5.3-.8-10.3-2.4-15L474 192h19.1c9.9 0 17.4-8.9 14.7-18.4-14.4-51-57.8-124.3-148.9-156.9C393.8 54.8 416 112.1 416 176c0 4.3-.1 8.6-.3 12.9L313.6 321c-3.1-.6-6.3-1-9.6-1h-24V192h103.5zM208 368h96v96h-96v-96z"
        }
    ]
};

const FarParagraphLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarParagraphLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 48h24c13.3 0 24-10.7 24-24S341.3 0 328 0H144C82.1 0 32 50.1 32 112s50.1 112 112 112h32v72c0 13.3 10.7 24 24 24s24-10.7 24-24V48h32v248c0 13.3 10.7 24 24 24s24-10.7 24-24V48zm-128 0v128h-32c-35.3 0-64-28.7-64-64s28.7-64 64-64h32zm-55.9 313.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-8 11.1-8 17.9s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 440H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H86.5l33.5-30.2z"
        }
    ]
};

const FarParagraph = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarParagraph",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 192c0-88.4 71.6-160 160-160h232c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v376c0 13.3-10.7 24-24 24s-24-10.7-24-24V80h-48v376c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-48c-88.4 0-160-71.6-160-160zm208 112V80h-48c-61.9 0-112 50.1-112 112s50.1 112 112 112h48z"
        }
    ]
};

const FarPartyBell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPartyBell",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 224c0-97.2 78.8-176 176-176 27.8 0 54.1 6.5 77.5 17.9.7.4 1.2.8 1.7 1.6.5.9.9 2.1.9 3.2 0 1.7-.7 3.4-1.9 4.6L75.3 302.1c-1.2 1.2-2.9 1.9-4.6 1.9-1.1 0-2.3-.3-3.2-.9-.7-.4-1.2-.9-1.6-1.7C54.5 278.1 48 251.8 48 224zM224 0C100.3 0 0 100.3 0 224c0 35.3 8.2 68.9 22.8 98.7 9.5 19.2 28.9 29.3 47.9 29.3 14.5 0 28.3-5.7 38.5-16L336 109.2c10.2-10.2 16-24.1 16-38.5 0-19-10.1-38.4-29.3-47.8C292.9 8.2 259.3 0 224 0zm256 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 480a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm327-313c-9.4 9.4-9.4 24.6 0 33.9l8.2 8.3c24.4 24.4 56.4 39.8 90.7 43.6l27.4 3c13.2 1.5 25-8 26.5-21.2s-8-25-21.2-26.5l-27.4-3c-23.5-2.6-45.4-13.1-62.1-29.8L393 167c-9.4-9.4-24.6-9.4-33.9 0zM201 359c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8.3 8.3c16.7 16.7 27.2 38.6 29.8 62.1l3 27.4c1.5 13.2 13.3 22.7 26.5 21.2s22.7-13.3 21.2-26.5l-3-27.4c-3.8-34.3-19.2-66.3-43.6-90.7L201 359zm302.5 147.3c10.1-8.6 11.4-23.7 2.8-33.8l-8.5-10c-4.9-5.8-7.5-13.2-7.3-20.7 1.1-42.5-31.7-78.3-74.2-80.8l-30-1.8c-16.6-1-29.4-15-29-31.6.5-19.4-6.1-38.2-18.6-53l-8.5-10c-8.6-10.1-23.7-11.4-33.8-2.8s-11.4 23.7-2.8 33.8l8.5 10c4.9 5.8 7.5 13.2 7.3 20.7-1.1 42.5 31.7 78.3 74.2 80.8l30 1.8c16.6 1 29.4 15 29 31.6-.5 19.4 6.1 38.2 18.6 53l8.5 10c8.6 10.1 23.7 11.4 33.8 2.8z"
        }
    ]
};

const FarPartyHorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPartyHorn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM167 153c-9.4-9.4-9.4-24.6 0-33.9l8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4C209.6 8.2 221.5-1.3 234.7.1s22.7 13.3 21.2 26.5l-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153c-9.4 9.4-24.6 9.4-33.9 0zm192 158 8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3c13.2-1.5 25 8 26.5 21.2s-8 25-21.2 26.5l-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM506.3 8.5c8.6 10.1 7.3 25.3-2.8 33.8l-10 8.5a79.026 79.026 0 0 1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2-7.6-.2-15 2.4-20.7 7.3l-10 8.5c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l10-8.5c14.8-12.5 33.7-19.1 53-18.6 16.6.4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2 7.6.2 15-2.4 20.7-7.3l10-8.5c10.1-8.6 25.3-7.3 33.8 2.8zm-447 444.2 86.9-32.6-54.3-54.3-32.6 86.9zm200.1-75-125-125-23.9 63.8 85.1 85.1 63.8-23.9zM98.1 212.6c8-21.4 36.4-27.6 52.6-11.4l160.2 160.1c16.2 16.2 10 44.6-11.4 52.6L43.3 510C18 519.4-7.4 494 2 468.8l96.1-256.2z"
        }
    ]
};

const FarPassport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPassport",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h320zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm32 400c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm33.3-176h39.1c1.6 30.4 7.7 53.8 14.6 70.8-27.9-13.2-48.4-39.4-53.7-70.8zm94.7 80h-.3c-2.4-3.5-5.7-8.9-9.1-16.5-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5-3.4 7.6-6.7 13-9.1 16.5h-.3zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8 6.8-17.1 12.9-40.4 14.6-70.8h39.1zm0-32h-39.1c-1.6-30.4-7.7-53.8-14.6-70.8 27.9 13.2 48.4 39.4 53.7 70.8zM224 112h.3c2.4 3.5 5.7 8.9 9.1 16.5 6 13.6 12.4 34.3 14.2 63.5h-47.1c1.8-29.2 8.1-49.9 14.2-63.5 3.4-7.6 6.7-13 9.1-16.5h.3zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8-6.8 17.1-12.9 40.4-14.6 70.8h-39.1zM224 336a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
        }
    ]
};

const FarPaste = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPaste",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96v16c0 17.7 14.3 32 32 32h60.8c16.6-28.7 47.6-48 83.2-48h62c-7.1-27.6-32.2-48-62-48h-40.6C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48H64C28.7 48 0 76.7 0 112v272c0 35.3 28.7 64 64 64h96v-48H64c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h16zm64-40a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm112 408c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16h128v48c0 17.7 14.3 32 32 32h48v192c0 8.8-7.2 16-16 16H256zm192 48c35.3 0 64-28.7 64-64V227.9c0-12.7-5.1-24.9-14.1-33.9L446 142.1c-9-9-21.2-14.1-33.9-14.1H256c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h192z"
        }
    ]
};

const FarPause = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPause",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 112v288h48V112H48zm-48 0c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112zm224 0v288h48V112h-48zm-48 0c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-48c-26.5 0-48-21.5-48-48V112z"
        }
    ]
};

const FarPawClaws = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPawClaws",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m178.1 15.3-39.2 43.1c-17.3 19-26.9 43.9-26.9 69.6-.2 11.3 1.5 23.2 5.5 35.1 14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8c-8.2-24.6-24.2-43.8-42.5-53.6V20.7c0-7.3-9-10.8-13.9-5.4zm132 206.3c32.3 10.6 70.1-15.6 84.4-58.5 4-11.9 5.7-23.9 5.5-35.1 0-25.7-9.6-50.6-26.9-69.6l-39.2-43.1C329 9.9 320 13.4 320 20.7v50.5c-18.3 9.8-34.3 28.9-42.5 53.6-14.3 42.9.3 86.2 32.6 96.8zm-209.7 8.9C91.1 214.7 77.9 203 64 196.8v-44.2c0-7.7-9.9-11-14.5-4.7l-37.3 51.3C4.3 210.1 0 223.3 0 236.8v3.2c-.1 13.3 3.7 27.8 11.6 41.4 18.9 32.4 54 47.3 78.5 33.3s29.1-51.7 10.2-84.1zM256 304c20.6 0 96.1 15.4 141.7 137.7 1.4 3.7 2.3 8.5 2.3 14.2 0 4.5-3.6 8.1-8.1 8.1h-3.4c-2.2 0-4.3-.4-6.3-1.2l-72.7-29.1c-34.3-13.7-72.6-13.7-107 0l-72.7 29.1c-2 .8-4.2 1.2-6.3 1.2h-3.4c-4.5 0-8.1-3.6-8.1-8.1 0-5.7.9-10.4 2.3-14.2C159.9 319.4 235.4 304 256 304zm0-48c-41.2 0-134.3 28.4-186.7 169-3.7 9.9-5.3 20.4-5.3 31 0 31 25.1 56.1 56.1 56.1h3.4c8.3 0 16.5-1.6 24.2-4.7l72.7-29.1c22.9-9.2 48.4-9.2 71.3 0l72.7 29.1c7.7 3.1 15.9 4.7 24.2 4.7h3.4c31 0 56.1-25.1 56.1-56.1 0-10.5-1.6-21.1-5.3-31C390.3 284.4 297.2 256 256 256zm165.8 58.7c24.5 14 59.7-.9 78.5-33.3 7.9-13.6 11.7-28.1 11.6-41.4v-3.2c0-13.5-4.3-26.7-12.2-37.6l-37.3-51.3c-4.6-6.3-14.5-3-14.5 4.7v44.2c-13.9 6.1-27.1 17.8-36.4 33.7-18.9 32.4-14.3 70.1 10.2 84.1z"
        }
    ]
};

const FarPawSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPawSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-.7 146.1c7.1-11.3 19.4-18.1 32.7-18.1s25.7 6.9 32.7 18.1l49.2 78.6c8.7 14 20.9 22.8 32.2 28.1 17.8 8.4 30 26.4 30 47.1 0 28.7-23.3 52-52 52-11.1 0-21.2-3.4-29.6-9.2-19.6-13.6-43.8-17.6-62.4-17.6s-42.8 4-62.4 17.6c-8.4 5.8-18.5 9.2-29.6 9.2-28.7 0-52-23.3-52-52 0-20.8 12.2-38.8 30-47.1 11.2-5.3 23.4-14.1 32.2-28.1l49.2-78.6zm-89.9 53.2c-2.8 4.5-7.1 7.8-11.8 10.1-34 16-57.6 50.5-57.6 90.6 0 55.2 44.8 100 100 100 21.2 0 40.8-6.6 56.9-17.8 17.4-12 52.8-12 70.1 0 16.2 11.2 35.8 17.8 57 17.8 55.2 0 100-44.8 100-100 0-40.1-23.6-74.6-57.6-90.6-4.8-2.2-9-5.6-11.8-10.1l-49.1-78.6C281.6 175.4 253.9 160 224 160s-57.6 15.4-73.4 40.7l-49.2 78.6zM304 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm144 64a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM48 240a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarPaw = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPaw",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M193.9 189.7c-32.3 10.6-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8 70.1 15.6 84.4 58.5-.3 86.2-32.6 96.8zm217.7 8.9c18.9-32.4 54-47.3 78.5-33.3s29.1 51.7 10.2 84.1-54 47.3-78.5 33.3-29.1-51.7-10.2-84.1zm-311.3 0c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3-14.3-70.1 10.2-84.1 59.7.9 78.5 33.3zM277.5 92.9c14.3-42.9 52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8-52.1 69.1-84.4 58.5-46.9-53.9-32.6-96.8zM114.3 409.7c-1.4 3.7-2.3 8.5-2.3 14.2 0 4.5 3.6 8.1 8.1 8.1h3.4c2.2 0 4.3-.4 6.3-1.2l72.7-29.1c34.3-13.7 72.6-13.7 107 0l72.7 29.1c2 .8 4.2 1.2 6.3 1.2h3.4c4.5 0 8.1-3.6 8.1-8.1 0-5.7-.9-10.4-2.3-14.2C352.1 287.4 276.6 272 256 272s-96.1 15.4-141.7 137.7zm-45-16.7C121.7 252.4 214.8 224 256 224s134.3 28.4 186.7 169c3.7 9.9 5.3 20.4 5.3 31 0 31-25.1 56.1-56.1 56.1h-3.4c-8.3 0-16.5-1.6-24.2-4.7l-72.7-29.1c-22.9-9.2-48.4-9.2-71.3 0l-72.7 29.1c-7.7 3.1-15.9 4.7-24.2 4.7H120c-31 0-56.1-25.1-56.1-56.1 0-10.5 1.6-21.1 5.3-31z"
        }
    ]
};

const FarPeace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 462.6v-156l-120.7 98.8c32 31 74 51.9 120.7 57.2zM80.9 368.3 232 244.6V49.4C128.4 61.3 48 149.2 48 256c0 41.4 12.1 79.9 32.9 112.3zm319.8 37.1L280 306.6v156c46.7-5.4 88.7-26.2 120.7-57.2zm30.4-37.1C451.9 335.9 464 297.4 464 256c0-106.8-80.4-194.7-184-206.6v195.2l151.1 123.7zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FarPeach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeach",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32c0 34.7 18.4 65.1 46 82C61.6 126.5 0 196 0 280c0 136.2 199.3 214.6 240.6 229.4 5 1.8 10.1 2.6 15.4 2.6s10.4-.8 15.4-2.6C312.7 494.6 512 416.2 512 280c0-84-61.6-153.5-142-166 27.6-16.9 46-47.3 46-82v-8c0-13.3-10.7-24-24-24h-40c-53 0-96 43-96 96 0-53-43-96-96-96h-40c-13.3 0-24 10.7-24 24v8zm72 128c58.1 0 106.6 41.3 117.6 96.2 2.6 13 13.1 23.8 26.4 23.8s24.2-10.8 22.3-23.9c-4.7-32.9-19-62.8-39.9-86.7 4.1-1 8.2-2.1 12.2-3.5 11.7-3.8 24.3-5.9 37.4-5.9 66.3 0 120 53.7 120 120 0 43.4-32.4 84.6-84.3 120.9-49.2 34.4-103.9 55.9-123.7 63-19.8-7.1-74.5-28.6-123.7-63C80.4 364.6 48 323.4 48 280c0-66.3 53.7-120 120-120z"
        }
    ]
};

const FarPeanut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeanut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M435 218.4c18-18.1 29-42.9 29-70.4V80c0-17.7-14.3-32-32-32h-68c-13.6 0-26.5 2.7-38.3 7.6-11.7 4.8-22.7 12-32.3 21.6l-.3.3c-9.6 9.6-16.7 20.6-21.5 32.2-2.7 6.4-4.7 13.2-5.9 20.2l-.1.4-.1.4c-5.3 26.6-15.3 63.2-43.4 91.3s-64.7 38.2-91.3 43.4l-.4.1-.4.1c-7 1.3-13.8 3.3-20.2 5.9-11.8 4.9-22.8 12.1-32.5 21.8-9.7 9.7-16.9 20.7-21.7 32.4-4.9 11.8-7.6 24.7-7.6 38.3v68c0 17.7 14.3 32 32 32h68c27.4 0 52.1-10.9 70.2-28.7l32.7 33.2-32.7-33.2c.4-.4.8-.7 1.1-1.1 9.4-9.5 16.4-20.4 21.1-31.9 2.7-6.4 4.7-13.2 5.9-20.2l.1-.4.1-.4c5.3-26.6 15.3-63.2 43.4-91.3s64.7-38.2 91.3-43.4l.4-.1.4-.1c7-1.3 13.8-3.3 20.2-5.9 11.6-4.8 22.6-11.9 32.2-21.4l.6-.6zm77-70.4c0 40.6-16.4 77.4-42.9 104.2l-.9.9c-14.1 14-30.3 24.6-47.6 31.7-9.5 4-19.6 6.9-30 8.8-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30-7.1 17.1-17.5 33.2-31.3 47.2-.5.6-1.1 1.1-1.7 1.7C225.1 495.8 188.5 512 148 512H80c-44.2 0-80-35.8-80-80v-68c0-20.1 4-39.2 11.2-56.7 7.2-17.5 17.9-33.8 32.1-48 14.2-14.2 30.6-24.9 48.1-32.1 9.5-4 19.6-6.9 30-8.8 24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30 7.2-17.4 17.8-33.6 31.9-47.8l.4-.4c14.2-14.1 30.5-24.8 47.8-32C324.8 4 343.9 0 364 0h68c44.2 0 80 35.8 80 80v68zm-139.2-12a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0zm-64 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0zm-192 192a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0zm83.2-19.2a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM372.8 200a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0zM200 308.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z"
        }
    ]
};

const FarPeanuts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeanuts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M123 504.9c-16.8-19.6-27-45-27-72.9 0-5.2-.1-10.6-.1-16.1-.6-55.4-1.3-125.1 52.8-179.2 26.5-26.5 59-43.2 94.7-49.8 22.9-4.6 39.5-10.9 50-21.5s16.9-27.1 21.5-50c1.6-8.9 3.9-17.5 6.7-26l-22.4-50.5C284.4 5.8 245.7-9 212.6 5.7l-50.9 22.6c-15 6.7-28 16.1-38.7 27.3-10.6 11.2-19.3 24.6-25.2 39.9l-.2.5c-5.8 15.3-8.3 31-7.9 46.4.2 8.5 1.3 17 3.4 25.4 4.5 19.9 6.9 41-.4 60s-23.1 33.1-39.8 44.9c-7.2 4.9-13.7 10.5-19.5 16.6C22.7 300.5 14 314 8.1 329.4 2.2 344.7-.4 360.6 0 376c.4 15.5 3.8 31.1 10.5 46.2l22.7 50.9c14.7 33.1 53.5 48 86.6 33.2l3.2-1.4zm440-286.5-.6.6c-9.6 9.5-20.5 16.6-32.2 21.4-6.4 2.7-13.2 4.7-20.2 5.9l-.4.1-.4.1c-26.6 5.3-63.2 15.3-91.3 43.4s-38.2 64.7-43.4 91.3l-.1.4-.1.4c-1.3 7-3.3 13.8-5.9 20.2-4.8 11.5-11.8 22.3-21.1 31.9l-.7.7-.4.4 32.7 33.2-32.7-33.2C328.1 453.1 303.4 464 276 464h-68c-17.7 0-32-14.3-32-32v-68c0-13.6 2.7-26.5 7.6-38.3 4.9-11.7 12.1-22.8 21.7-32.4 9.7-9.7 20.7-16.9 32.5-21.7 6.4-2.7 13.2-4.7 20.2-5.9l.4-.1.4-.1c26.6-5.3 63.2-15.3 91.3-43.4s38.2-64.7 43.4-91.3l.1-.4.1-.4c1.3-7 3.3-13.8 5.9-20.2 4.8-11.7 12-22.6 21.5-32.2l.3-.3c9.6-9.6 20.6-16.8 32.3-21.6 11.8-5 24.7-7.7 38.3-7.7h68c17.7 0 32 14.3 32 32v68c0 27.5-11 52.3-29 70.4zm34.1 33.8C623.6 225.4 640 188.6 640 148V80c0-44.2-35.8-80-80-80h-68c-20.1 0-39.2 4-56.7 11.2-17.4 7.2-33.7 17.8-47.8 32l-.4.4C373 57.8 362.4 74 355.2 91.4c-4 9.5-6.9 19.6-8.8 30-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8-17.5 7.2-33.9 17.9-48.1 32.1-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364v68c0 44.2 35.8 80 80 80h68c40.5 0 77.1-16.2 103.8-42.5l1.7-1.7c13.8-14 24.2-30.1 31.3-47.2 4-9.5 6.9-19.6 8.8-30 4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8 17.3-7.2 33.5-17.7 47.6-31.7l.9-.9zm-77.1-97a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-192 192a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm83.2-19.2a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0zM520 219.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM347.2 328a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0z"
        }
    ]
};

const FarPeapod = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeapod",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 48C212.8 48 48 212.8 48 416v48h48c203.2 0 368-164.8 368-368V48h-48zm0-48h48c26.5 0 48 21.5 48 48v48c0 229.8-186.2 416-416 416H48c-26.5 0-48-21.5-48-48v-48C0 186.2 186.2 0 416 0zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0 56 56 0 1 1-112 0zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
        }
    ]
};

const FarPear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 7c9.4 9.4 9.4 24.6 0 33.9l-47.1 47.2c14 20.5 22.1 45.3 22.1 71.9 0 30.7-10.8 58.9-28.9 81-29.9 36.5-61.4 81.8-73.3 127.4-8.3 32-25 62.3-50.1 87.3-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1 45.7-11.8 90.9-43.4 127.4-73.3 22.1-18 50.3-28.9 81-28.9 26.7 0 51.4 8.2 71.9 22.1L471 7c9.4-9.4 24.6-9.4 33.9 0zM367 111l22-22c-11.1-5.8-23.7-9.1-37-9.1-19.2 0-36.8 6.7-50.6 18C264 128.6 212 166 155.6 180.6c-23.9 6.2-46.6 18.7-65.5 37.5-56.2 56.2-56.2 147.4 0 203.6s147.4 56.2 203.6 0c18.9-18.9 31.3-41.5 37.5-65.5C346 300 383.4 248 414 210.6c11.3-13.8 18-31.3 18-50.6 0-13.4-3.3-25.9-9.1-37l-22 22c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm-79 209c0 53-43 96-96 96-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64 0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarPedestal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPedestal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48H96c-8.8 0-16 7.2-16 16v368H32V64C32 28.7 60.7 0 96 0h256c35.3 0 64 28.7 64 64v368h-48V64c0-8.8-7.2-16-16-16zM24 464h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm96-352a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarPegasus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPegasus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M109.6 133.9c-9.9 7.3-18.5 16.1-25.5 26.2C37.3 162.1 0 200.7 0 248v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.2 6.4-25 16.3-32.2-.2 2.8-.3 5.6-.3 8.5 0 14.3 2.7 28.4 8 41.7l21.9 54.6-8.2 21.7c-11.3 30.1-12.7 63.1-4.1 94.1l11.2 40.5c5.8 20.8 24.7 35.2 46.2 35.2h49.8c31.7 0 54.7-30.3 46.2-60.8L220.2 398c-.5-1.6-.4-3.4.2-5l12.1-32.3c1.4-3.7 2.6-7.4 3.6-11.2l51.9 15V464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V327.8c19.8-22.6 32-52.3 32-85.5v-10.1c17.7 6 37.5 5.8 55.8-1.5 34.4-13.8 55-49.3 49.7-86l-9.9-69.2c-1.6-11.3-5.3-21.9-10.7-31.3C555.6 40 560 32.5 560 24c0-13.3-10.7-24-24-24h-56v.3c-2.5-.2-5-.3-7.5-.3H432c-1.8 0-3.5.2-5.2.6C365 5.9 313.7 48.2 295.3 105.3l-131-77.9c-7.4-4.4-16.6-4.5-24.1-.2S128 39.4 128 48c0 76.3 36.1 130.2 71.3 164.2 17.5 17 35 29.3 48.1 37.3 6.6 4 12.1 7.1 16.1 9.1l4.8 2.4c.6.3 1 .5 1.4.6l.4.2.1.1h.1l9.6-22-9.6 22c12.1 5.3 26.3-.2 31.6-12.4s-.2-26.3-12.4-31.6h-.1l-.7-.3c-.7-.3-1.9-.9-3.4-1.7-3-1.5-7.5-4-12.9-7.3-10.9-6.7-25.4-16.9-39.9-30.9-20.8-20.2-41.2-47.8-50.8-84.1l19.4 11.6 86.4 51.4c2.6 1.6 5.4 2.6 8.3 3v.3H313c12.1 0 22.3-9 23.8-21 6.1-49.1 46.6-87.7 96.6-90.8.7 0 1.3-.1 2-.2h37.1c19.9 0 36.8 14.6 39.6 34.3l9.9 69.2c2.1 14.8-6.2 29.1-20 34.7-13.3 5.3-28.4 1.3-37.3-9.8l-5.9-7.3c-6.4-8-17.1-11-26.7-7.7S416 173.8 416 183.9v58.2c0 23.5-9.6 44.1-24.7 58.8-4.6 4.5-7.3 10.7-7.3 17.2V464h-48V346.2c0-11.3-7.9-21.1-19-23.5-2.1-.4-4.2-1-6.3-1.6l-88-25.7c-7.3-2.1-15.3-.7-21.3 4s-9.6 11.9-9.4 19.5v1.3c0 8-1.4 16-4.3 23.5L175.6 376c-4.2 11.1-4.7 23.2-1.5 34.6l14.8 53.4h-49.8l-11.2-40.5c-5.9-21.2-4.9-43.7 2.8-64.4l8.2-21.7c4.2-11.2 4.1-23.6-.4-34.7l-21.9-54.6c-3-7.6-4.6-15.7-4.6-23.9 0-17.4 7-33.3 18.2-44.8-8-13.7-15-28.9-20.6-45.5zM464 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarPenCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm357.8-116.3 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM151.9 289l105.2-105.2 71 71-105.2 105.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FarPenClipSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenClipSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l146.8-146.7c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0L384 62.1 370.9 49c-28.1-28.1-73.7-28.1-101.8 0l-76.6 76.6L38.8 5.1zm191.7 150.3L303 82.9c9.4-9.4 24.6-9.4 33.9 0L350.1 96l-85.8 85.8-33.7-26.4zm71.8 56.2 81.7-81.7 62.1 62.1-74.2 74.2-69.6-54.5zM197.5 316.5l36.3-36.3-38-29.9-32.3 32.3c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9.9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.7-47.7-38-29.9-43.6 43.6c-38.8 38.8-87.5 66-140.7 78.6 12.7-53.2 39.9-101.9 78.6-140.7z"
        }
    ]
};

const FarPenClip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenClip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m320 62.1 42.7-42.7c25-25 65.5-25 90.5 0l39.4 39.4c25 25 25 65.5 0 90.5L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L286.1 96 273 82.9c-9.4-9.4-24.6-9.4-33.9 0L137 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L205.1 49c28.1-28.1 73.7-28.1 101.8 0L320 62.1zm0 67.9L133.5 316.5c-38.8 38.8-66 87.5-78.6 140.7 53.2-12.7 101.9-39.9 140.7-78.6L382.1 192 320 129.9z"
        }
    ]
};

const FarPenFancySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenFancySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L398.9 287.3l149.9-139.5A85.29 85.29 0 0 0 576 85.3C576 38.2 537.8 0 490.7 0c-23.7 0-46.3 9.8-62.5 27.2L275.8 190.9 38.8 5.1zm274.9 215.5L463.4 59.9c7.1-7.6 17-11.9 27.3-11.9 20.6 0 37.3 16.7 37.3 37.3 0 10.4-4.3 20.2-11.9 27.3L360.6 257.4l-46.9-36.8zm-138.4 82.9 57.5-17.7-45.8-36.1-25.8 7.9c-22.8 7-40.6 24.9-47.6 47.6L65.9 460.1c-9.4 30.7 19.3 59.4 50 50l154.8-47.6c22.8-7 40.6-24.9 47.6-47.6l15.3-49.6-40.4-31.8-20.7 67.3c-2.3 7.6-8.3 13.5-15.9 15.9l-107.6 33 49.7-49.7h1.3c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24v1.3L126.3 427l33.1-107.7c2.3-7.6 8.3-13.5 15.9-15.9z"
        }
    ]
};

const FarPenFancy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenFancy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M399.4 59.9c7.1-7.6 17-11.9 27.3-11.9 20.6 0 37.3 16.7 37.3 37.3 0 10.4-4.3 20.2-11.9 27.3l-195.5 182-39.2-39.2 182-195.5zM426.7 0c-23.7 0-46.3 9.8-62.5 27.2L170.8 234.9l-73.6 22.7c-22.8 7-40.6 24.9-47.6 47.6L1.9 460.1c-9.4 30.7 19.3 59.4 50 50l154.8-47.6c22.8-7 40.6-24.9 47.6-47.6l22.6-73.6 207.9-193.5A85.29 85.29 0 0 0 512 85.3C512 38.2 473.8 0 426.7 0zM228.8 334.8l-20.3 65.9c-2.3 7.6-8.3 13.5-15.9 15.9L85 449.7l49.7-49.7h1.3c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24v1.3L62.3 427l33.2-107.7c2.3-7.6 8.3-13.5 15.9-15.9l65.9-20.3 51.6 51.6z"
        }
    ]
};

const FarPenField = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenField",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M569.2 59.1 581.1 71c9.4 9.4 9.4 24.6 0 33.9L560 126.1l-45.7-45.7 20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM359.9 236.8l120.7-122.3 45.5 45.5-121.5 121.6c-3.3 3.3-7.5 5.6-12 6.5L343 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM501 25.5 325.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9.8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.2-9.7 36.1-19.6l176.6-176.6c28.1-28.1 28.1-73.7 0-101.8l-12-11.9C574.9-3.1 529-2.9 501 25.5zM72 128c-39.8 0-72 32.2-72 72v240c0 39.8 32.2 72 72 72h432c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24v128c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24h192c13.3 0 24-10.7 24-24s-10.7-24-24-24H72zm56 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarPenLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m13.4 439 23-78.1c4.2-14.1 11.8-27 22.2-37.4L362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c3.1 3.1 5.9 6.5 8.2 10 16.4 24.8 13.7 58.6-8.2 80.5L188.5 453.4c-1.3 1.3-2.6 2.6-4 3.8-9.6 8.5-21 14.8-33.4 18.4l-78.1 23L30.8 511c-8.4 2.5-17.5.2-23.7-6.1s-8.6-15.2-6.1-23.7L13.4 439zm62.2-41.2-16.2 54.8 54.8-16.1 23.4-6.9c6.4-1.9 12.3-5.4 17-10.1L383 191l-62-62L92.5 357.4c-.6.6-1.2 1.2-1.7 1.8-3.9 4.4-6.7 9.6-8.4 15.2l-6.9 23.4zM248 464h304c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarPenNibSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenNibSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L448.6 326.3 476.2 225l10.4-10.4 71-71c21.9-21.9 21.9-57.3 0-79.2l-46-46.1c-21.9-21.9-57.3-21.9-79.2 0l-71 71L351 99.8l-142 38.7L38.8 5.1zm217.3 170.3 104.8-28.6 68.3 68.3-21.6 79.1-151.5-118.8zM272 352c13.5 0 25.7-5.6 34.4-14.6l-75-59.1c-4.7 7.4-7.4 16.2-7.4 25.7 0 7.4 1.7 14.4 4.7 20.7L126.5 426.9l63.6-181.1-39.8-31.4L71 440c-6.5 18.5-1.8 39.1 12 52.9s34.4 18.5 52.9 12L400 412.1l.8-.3-44.7-35.2-207 72.9 102.2-102.2c6.3 3 13.3 4.7 20.7 4.7z"
        }
    ]
};

const FarPenNib = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenNib",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368.4 18.3c21.9-21.9 57.3-21.9 79.2 0l46.1 46.1c21.9 21.9 21.9 57.3 0 79.2l-71 71-10.5 10.4-40.6 149.1c-4.8 17.8-18.1 32-35.5 38.1L72 505c-18.5 6.5-39.1 1.8-52.9-12S.5 458.5 7 440l92.8-264.1c6.1-17.4 20.3-30.6 38.1-35.5L287 99.8l10.4-10.4 71-71zm-71.5 128.5-146.4 39.9c-2.5.7-4.6 2.6-5.4 5.1L62.5 426.9l102.2-102.2c-3-6.3-4.7-13.3-4.7-20.7 0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L85.1 449.5l235.1-82.6c2.5-.9 4.4-2.9 5.1-5.4l39.9-146.4-68.3-68.3z"
        }
    ]
};

const FarPenPaintbrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenPaintbrush",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m68.4 360.9-23 78.1L33 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l42.2-12.4 78.1-23c12.4-3.6 23.7-9.9 33.4-18.4 1.4-1.2 2.7-2.5 4-3.8l304.2-304.1c21.9-21.9 24.6-55.6 8.2-80.5-2.3-3.5-5.1-6.9-8.2-10l-39.4-39.5c-25-25-65.5-25-90.5 0L90.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2.6-.6 1.1-1.2 1.7-1.8L353 129l62 62-228.4 228.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4zm170.2 71.4C304.4 485.1 345 512 391.9 512h152c17.7 0 32-14.3 32-32s-14.3-32-32-32h-6c-18.1 0-30.1-19.8-27.4-37.6.9-6 1.4-12.1 1.4-18.4 0-46.9-26.9-87.5-66.1-107.3l-37.2 37.2c31.7 7.5 55.3 36 55.3 70.1 0 3.8-.3 7.5-.8 11.1-3.3 21.4 2.2 43.1 13.8 60l.7.9h-85.7c-34 0-62.5-23.6-70.1-55.3l-37.2 37.2zM136 24C105.1-6.9 54.9-6.9 24 24s-30.9 81.1 0 112l98.7 98.7 33.9-33.9-98.7-98.7c-12.2-12.2-12.2-31.9 0-44.1s31.9-12.2 44.1 0l98.7 98.7 33.9-33.9L136 24z"
        }
    ]
};

const FarPenRuler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenRuler",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m13.4 439 23-78.1c4.2-14.1 11.8-27 22.2-37.4L362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c3.1 3.1 5.9 6.5 8.2 10 16.4 24.8 13.7 58.6-8.2 80.5L188.5 453.4c-1.3 1.3-2.6 2.6-4 3.8-9.6 8.5-21 14.8-33.4 18.4l-78.1 23L30.8 511c-8.4 2.5-17.5.2-23.7-6.1s-8.6-15.2-6.1-23.7L13.4 439zm62.2-41.2-16.2 54.8 54.8-16.1 23.4-6.9c6.4-1.9 12.3-5.4 17-10.1L383 191l-62-62L92.5 357.4c-.6.6-1.2 1.2-1.7 1.8-3.9 4.4-6.7 9.6-8.4 15.2l-6.9 23.4zm97.7-370.5 65.2 65.2-33.9 33.9-26.2-26.2-23 23c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l23-23-16.5-16.3c-6.2-6.2-16.4-6.2-22.6 0l-55.4 55.4c-6.2 6.2-6.2 16.4 0 22.6l65.2 65.2-34 34-65.2-65.2c-25-25-25-65.5 0-90.5l55.4-55.5c25-25 65.5-25 90.5 0zm199.4 423.4c6.2 6.2 16.4 6.2 22.6 0l55.4-55.4c6.2-6.2 6.2-16.4 0-22.6l-16.4-16.4-23 23c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l23-23-26.2-26.2 33.9-33.9 65.2 65.2c25 25 25 65.5 0 90.5l-55.4 55.4c-25 25-65.5 25-90.5 0l-65.2-65.2 33.9-33.9 65.2 65.2z"
        }
    ]
};

const FarPenSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l146.8-146.7c21.9-21.9 24.6-55.6 8.2-80.5-2.3-3.5-5.1-6.9-8.2-10l-39.4-39.5c-25-25-65.5-25-90.5 0L264.2 181.8 38.8 5.1zm263.5 206.5L385 129l62 62-75.1 75.1-69.6-54.5zM156.5 357.4l77.3-77.3-38-29.9-73.2 73.2c-10.4 10.4-18 23.3-22.2 37.4l-23 78.2L65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l42.2-12.4 78.1-23c12.4-3.6 23.7-9.9 33.4-18.4 1.4-1.2 2.7-2.5 4-3.8l88.6-88.6-38-29.9-84.6 84.6c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4c1.7-5.6 4.5-10.8 8.4-15.2.6-.6 1.1-1.2 1.7-1.8z"
        }
    ]
};

const FarPenSwirl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenSwirl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M441.2 59.1 453.1 71c9.4 9.4 9.4 24.6 0 33.9L432 126.1l-45.7-45.7 20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM231.9 236.8l120.7-122.3 45.5 45.5-121.5 121.6c-3.3 3.3-7.5 5.6-12 6.5L215 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM373 25.5 197.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9.8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.3-9.7 36.1-19.6l176.6-176.6c28.1-28.1 28.1-73.7 0-101.8l-12-11.9C446.9-3.1 401-2.9 373 25.5zm-48.3-7.9C302.9 11.4 279.8 8 256 8 119 8 8 119 8 256s111 248 248 248c13.3 0 24-10.7 24-24s-10.7-24-24-24c-110.5 0-200-89.5-200-200S145.5 56 256 56c9.7 0 19.3.7 28.7 2l40-40.4zm129.4 210.8c1.2 9 1.9 18.2 1.9 27.6 0 57.4-46.6 104-104 104-13.3 0-24 10.7-24 24s10.7 24 24 24c83.9 0 152-68.1 152-152 0-23.6-3.3-46.4-9.4-68l-40.4 40.5z"
        }
    ]
};

const FarPenToSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPenToSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M441 58.9 453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2 344 121.9l46.1 46.1-134.3 134.2c-2.9 2.9-6.5 5-10.4 6.1L186.9 325l16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25 175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25c-28.1-28.1-73.7-28.1-101.8 0zM88 64c-48.6 0-88 39.4-88 88v272c0 48.6 39.4 88 88 88h272c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"
        }
    ]
};

const FarPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m36.4 360.9-23 78.1L1 481.2c-2.5 8.5-.2 17.6 6 23.8s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4 1.4-1.2 2.7-2.5 4-3.8l304.2-304.1c21.9-21.9 24.6-55.6 8.2-80.5-2.3-3.5-5.1-6.9-8.2-10l-39.4-39.5c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2.6-.6 1.1-1.2 1.7-1.8L321 129l62 62-228.4 228.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4z"
        }
    ]
};

const FarPencilMechanical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPencilMechanical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m500.7 36.7-25.4-25.4C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3l-31.2 31.2c-4.3-1.6-8.9-2.5-13.5-2.5-10.2 0-20.1 4.1-27.3 11.3L317 83l-29.4-29.3c-21.9-21.9-57.3-21.9-79.2 0L103 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L242.3 87.6c3.1-3.1 8.2-3.1 11.3 0L283 117 72.8 327.2c-5.8 5.8-10 12.9-12.2 20.8l-27.8 97.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l25.7-25.7 97.4-27.8c7.8-2.2 15-6.4 20.8-12.2l275.9-275.9c7.2-7.2 11.3-17.1 11.3-27.3 0-4.7-.8-9.3-2.5-13.5l31.1-31.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3zM376 91.9l44.1 44.1L183 373.1 138.9 329 376 91.9zm-286.9 331 16.9-59 42.2 42.2-59 16.9z"
        }
    ]
};

const FarPencilSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPencilSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l146.8-146.7c21.9-21.9 24.6-55.6 8.2-80.5-2.3-3.5-5.1-6.9-8.2-10l-39.4-39.5c-25-25-65.5-25-90.5 0L264.3 181.8 38.8 5.1zm263.5 206.5L385 129l62 62-75.1 75.1-69.6-54.5zm.9 123.2-41.7 41.7-49.6-12.4-12.4-49.6 34.4-34.4-38-29.9-73.2 73.2c-2.5 2.5-4.9 5.2-7.1 8l-.8.5.2.3c-6.5 8.5-11.4 18.2-14.5 28.6L77.4 439 65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l42.2-12.4 78.1-23c10.4-3 20.1-8 28.6-14.5l.3.2.5-.8c1.4-1.1 2.7-2.2 4-3.3 1.4-1.2 2.7-2.5 4-3.8l88.6-88.6-38-29.9zM161 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L161 359z"
        }
    ]
};

const FarPencil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPencil",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m36.4 360.9-23 78.1L1 481.2c-2.5 8.5-.2 17.6 6 23.8s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3.2.5-.8c1.4-1.1 2.7-2.2 4-3.3 1.4-1.2 2.7-2.5 4-3.8l304.2-304.1c21.9-21.9 24.6-55.6 8.2-80.5-2.3-3.5-5.1-6.9-8.2-10l-39.4-39.5c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8.5.2.3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191 197.4 376.6l-49.6-12.4-12.4-49.6L321 129l62 62zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9-54.9 16 16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1l11.2-7.4zm218.3-140.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"
        }
    ]
};

const FarPeopleArrows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeopleArrows",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3c-.8 9.4 6.6 17.4 16 17.4H128c0 14.3 5.5 28.7 16.4 39.6l47.6 47.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1-2.6 1.8-5.2 4-7.5 6.3l-28.1 28.1c-4.6-12.1-16.3-20.5-29.9-20.5h-44.8zM448 488v-96.8l47.6-47.6c10.9-10.9 16.4-25.3 16.4-39.6h42.4c9.4 0 16.7-8 15.9-17.3l-4.1-49.3c-1.3-16.6-15.2-29.4-31.8-29.4h-44.8c-13.5 0-25.2 8.4-29.9 20.5l-28.1-28.1c-2.4-2.4-4.9-4.5-7.5-6.3 14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32v136c0 13.3-10.7 24-24 24s-24-10.7-24-24zm0-424a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM265 257l-23 23h156.1l-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23H241.9l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarPeopleCarryBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeopleCarryBox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM53 344.3 1.6 479.5c-4.7 12.4 1.5 26.3 13.9 31s26.3-1.5 31-13.9l46.1-121.2L53 344.3zm43-156.8c0-6.4 5.2-11.5 11.5-11.5 4.4 0 8.6 1 12.5 2.8v116.4l-20.9-16.5c-1.9-1.5-3.1-3.8-3.1-6.3v-84.9zm72 145.4v-89.6l26 39.1c3.3 4.9 7.6 9.1 12.7 12.1l26.1 15.7c5.6 5.9 13.5 9.6 22.3 9.9h129.8c8.7-.2 16.6-4 22.2-9.9l26.1-15.7c5.1-3 9.4-7.2 12.7-12.1l26-39.1v89.6l-25.8 20.3a40.28 40.28 0 0 0-14.9 25.8l-15 105.6c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l14.6-102.5 92.2-72.4c13.5-10.6 21.4-26.9 21.4-44v-85c0-32.9-26.6-59.5-59.5-59.5-25.8 0-50 12.9-64.3 34.4L416 240.7V160c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v80.7l-52.2-78.3c-14.3-21.5-38.5-34.4-64.3-34.4-32.9 0-59.5 26.6-59.5 59.5v84.9c0 17.2 7.9 33.4 21.4 44l92.2 72.4 14.6 102.5c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2L208.7 379a40.28 40.28 0 0 0-14.9-25.8L168 332.9zM272 176h96v96h-96v-96zm240-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm126.4 383.5L587 344.3l-39.5 31.1 46.2 121.2c4.7 12.4 18.6 18.6 31 13.9s18.6-18.6 13.9-31zM532.5 176c6.4 0 11.5 5.2 11.5 11.5v84.9c0 2.5-1.1 4.8-3.1 6.3L520 295.2V178.8c3.8-1.8 8.1-2.8 12.5-2.8z"
        }
    ]
};

const FarPeopleDressSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeopleDressSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM96.9 219.6 63.6 336h128.8l-33.3-116.4c-2-6.9-8.2-11.6-15.4-11.6h-31.4c-7.1 0-13.4 4.7-15.4 11.6zm-46.2-13.2c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-32v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H42.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-31.1 219.6L319.6 336h128.8l-33.3-116.4c-2-6.9-8.2-11.6-15.4-11.6h-31.4c-7.1 0-13.4 4.7-15.4 11.6zm-46.2-13.2c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-32v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-21.6c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"
        }
    ]
};

const FarPeopleDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeopleDress",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm107.1 299.8-47.9-84.6 46.3 148c3.2 10.3-4.5 20.8-15.3 20.8H224v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-32v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H69.8c-10.8 0-18.5-10.5-15.3-20.8l46.3-148-47.9 84.6c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM206.7 336 160 186.5 113.3 336h93.4zM480 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm107.1 299.8-47.9-84.6 46.3 148c3.2 10.3-4.5 20.8-15.3 20.8H544v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-32v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-26.2c-10.8 0-18.5-10.5-15.3-20.8l46.3-148-47.9 84.6c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM526.7 336 480 186.5 433.3 336h93.4z"
        }
    ]
};

const FarPeopleGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeopleGroup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 32C50.1 160 0 210.1 0 272c0 44.7 26.2 83.2 64 101.2V416c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-32c0-13.3-10.7-24-24-24s-24 10.7-24 24v16h-32V208h32c12.6 0 24.3 3.6 34.2 9.9 7.9-14.2 18.1-26.9 30.2-37.6C190.2 167.5 168 160 144 160h-32zm-48 69.7v84.7c-10-11.3-16-26.2-16-42.4s6-31.1 16-42.3zM496 208h32v192h-32v-16c0-13.3-10.7-24-24-24s-24 10.7-24 24v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-42.8c37.8-18 64-56.5 64-101.2 0-61.9-50.1-112-112-112h-32c-24 0-46.2 7.5-64.4 20.3 12 10.7 22.3 23.4 30.2 37.6 9.9-6.3 21.6-9.9 34.2-9.9zm96 64c0 16.2-6 31.1-16 42.3v-84.6c10 11.3 16 26.1 16 42.3zM560 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-240 64a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-16 32c-61.9 0-112 50.1-112 112 0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-58.8c37.8-18 64-56.5 64-101.2 0-61.9-50.1-112-112-112h-32zm0 224V224h32v208h-32v-32zm-48-69.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3v84.7zm128 0v-84.6c10 11.3 16 26.1 16 42.3s-6 31.1-16 42.3z"
        }
    ]
};

const FarPeopleLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeopleLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M360 72a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm-56 104.5c2-.3 4.1-.5 6.2-.5h19.5c2.1 0 4.2.2 6.2.5V256H304v-79.5zm80 55.8 18.9 35c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35V352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-23.7l18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3C568 241.8 538.3 224 505.9 224h-19.7c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.4-28.5-45.1-46.3-77.5-46.3h-19.5c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6h-19.5c-32.4 0-62.1 17.8-77.5 46.3l-37.8 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35V352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-23.7l18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5L233 273.1c1.7-1.7 3.2-3.6 4.3-5.8l18.9-35V272c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-39.7zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-16 128v-63.5c2-.3 4.1-.5 6.2-.5h19.5c2.1 0 4.2.2 6.2.5V336H480zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm120-224a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-16 128v-63.5c2-.3 4.1-.5 6.2-.5h19.5c2.1 0 4.2.2 6.2.5V336H128z"
        }
    ]
};

const FarPeoplePantsSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeoplePantsSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM73.7 237.3l-4.1 49.3c-.8 9.4 6.6 17.4 16 17.4h84.8c9.4 0 16.7-8 15.9-17.3l-4.1-49.3c-1.3-16.6-15.2-29.4-31.8-29.4h-44.8c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-54.3 237.3-4.1 49.3c-.8 9.3 6.6 17.3 15.9 17.3h84.9c9.4 0 16.7-8 15.9-17.3l-4.1-49.3c-1.3-16.5-15.2-29.3-31.8-29.3h-44.8c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3z"
        }
    ]
};

const FarPeoplePants = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeoplePants",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3.1V304H144V176.1c.7 0 1.5-.1 2.3-.1zM144 488V352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-58.6-103.5c-15.6-27.6-44.9-44.7-76.6-44.7h-27.4c-31.7 0-61 17.1-76.6 44.7L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L96 223.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3.1V304H464V176.1c.7 0 1.5-.1 2.3-.1zM464 488V352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-58.6-103.5c-15.6-27.6-44.9-44.7-76.6-44.7h-27.4c-31.7 0-61 17.1-76.6 44.7l-58.6 103.5c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l43.1-76.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarPeoplePulling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeoplePulling",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM48 271.9V328c0 13.3-10.7 24-24 24S0 341.3 0 328V184c0-30.9 25.1-56 56-56h58.4c15.1 0 29.9 3.9 43 11.2l122.5 68.7c17.9-34 48.4-60 85.1-72.3 15.3-5.1 31.3-7.7 47.4-7.7h4.9c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L569 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-29.1-29c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7-28.5 91.3 50.1 40.7c6.9 5.6 11.8 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L370 312.6c-18.1-14.7-25.2-39.1-17.8-61.2l22.8-68.3c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2-6.8-3-11.5-8.8-13.3-15.4L160.5 196l63 286.9c2.8 12.9-5.3 25.7-18.3 28.6s-25.7-5.4-28.6-18.3l-31-141.2h-30.9l28.7 130.9c2.8 12.9-5.3 25.7-18.3 28.6s-25.7-5.4-28.6-18.3L48 271.9zm58.9-95.9H76.1l28.1 128H135l-28.1-128zM464 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-66.2 266.6c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3L449 184.8c.1-.3.2-.7.3-1-6.7-3.5-14-5.9-21.7-7.1l-29.9 89.8zm-42.1 75.6 39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L297 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5 24.1-60.4z"
        }
    ]
};

const FarPeopleRobbery = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeopleRobbery",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M504.5 53.3C493.1 101.7 449.8 136 400 136s-93.1-34.3-104.5-82.7l-8.2-34.8c-3-12.9-16-20.9-28.9-17.9s-20.9 16-17.9 28.9l8.2 34.8c11.3 48.1 44.3 86.5 87.2 106V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V170.2c42.9-19.4 75.9-57.8 87.2-105.9l8.2-34.8c3-12.9-5-25.8-17.9-28.9s-25.8 5-28.9 17.9l-8.2 34.8zM416 183.2V304h-32V183.2c5.3.5 10.6.8 16 .8s10.7-.3 16-.8zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM16 204.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H64v-99.5c0-15.7 12.8-28.5 28.5-28.5 9.4 0 18.1 4.6 23.4 12.3l56.3 81.4c4.5 6.5 11.9 10.3 19.7 10.3h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-35.3l-49.2-71c-14.3-20.6-37.8-33-62.9-33-42.3 0-76.5 34.2-76.5 76.5z"
        }
    ]
};

const FarPeopleRoof = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeopleRoof",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m332.3 3.4 296 176c11.4 6.8 15.1 21.5 8.4 32.9s-21.5 15.1-32.9 8.4L320 51.9 36.3 220.6c-11.4 6.8-26.1 3-32.9-8.4s-3-26.1 8.4-32.9l296-176c7.6-4.5 17-4.5 24.5 0zM496 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-16 208h32v-63.5c-2-.3-4.1-.5-6.2-.5h-19.6c-2.1 0-4.2.2-6.2.5V464zm98.9 27.4-18.9-35V480c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-23.7l-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8l-18.9-35V400c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32v-39.7l-18.9 35c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8l-18.9-35V480c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32v-23.7l-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3C72 369.8 101.8 352 134.2 352h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8zM280 200a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm24 104.5V384h32v-79.5c-2-.3-4.1-.5-6.2-.5h-19.6c-2.1 0-4.2.2-6.2.5zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-16 208h32v-63.5c-2-.3-4.1-.5-6.2-.5h-19.6c-2.1 0-4.2.2-6.2.5V464z"
        }
    ]
};

const FarPeopleSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeopleSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM73.7 237.3l-4.1 49.3c-.8 9.4 6.6 17.4 16 17.4h84.8c9.4 0 16.7-8 15.9-17.3l-4.1-49.3c-1.3-16.6-15.2-29.4-31.8-29.4h-44.8c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-31.1 219.6L319.6 336h128.8l-33.3-116.4c-2-6.9-8.2-11.6-15.4-11.6h-31.4c-7.1 0-13.4 4.7-15.4 11.6zm-46.2-13.2c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-32v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-21.6c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"
        }
    ]
};

const FarPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeople",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3.1V304H144V176.1c.7 0 1.5-.1 2.3-.1zM144 488V352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-58.6-103.5c-15.6-27.6-44.9-44.7-76.6-44.7h-27.4c-31.7 0-61 17.1-76.6 44.7L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L96 223.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm107.1 203.8c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-51.8-91.5c-19.8-35-56.9-56.6-97.1-56.6s-77.3 21.6-97.1 56.6l-51.8 91.5c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l47.9-84.6-46.3 148c-3.2 10.3 4.5 20.8 15.3 20.8H416v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h32v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h26.2c10.8 0 18.5-10.5 15.3-20.8l-46.3-148 47.9 84.6zM526.7 336h-93.4L480 186.5 526.7 336z"
        }
    ]
};

const FarPepperHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPepperHot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110 26.7 28.6 42.9 66.9 42.9 109 0 18.5-3.1 36.3-8.9 52.8-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24v-80c0-13.3-10.7-24-24-24h-17.1c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2 5.5-18.2 3.7-38.4-6-55.8l-4.8-8.7c-6.4-11.6-2.3-26.2 9.3-32.6zm-256 302.7L261.7 160H304v22.8l-90.7 148c-24.9 40.7-65.3 69.5-111.9 79.8L66 418.5c-10.5 2.3-18 11.7-18 22.5 0 12.7 10.3 23 23 23h32.1c133.7 0 254.1-68.7 323.6-176h1.4l23.9 47.8C372.3 443.9 244.3 512 103.2 512H71c-39.2 0-71-31.8-71-71 0-33.3 23.1-62.1 55.6-69.3l35.4-7.9c33.9-7.5 63.2-28.5 81.4-58.1z"
        }
    ]
};

const FarPepper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPepper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M252.6 11.7C245.8.3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37v10.9C215 95.3 195.9 94 177 98.7h-.2c-10.5 2.6-20.1 6.9-28.7 12.4-21.6-13.6-48.6-18.9-75.4-12.2C21.3 111.7-10 163.8 2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8 10.5-2.6 20.1-6.9 28.7-12.4 5.7 3.6 11.8 6.7 18.3 9.2 10.6 4 22 6.1 33.7 6.1v-24 24c11.7 0 23.1-2.1 33.7-6.1 6.5-2.4 12.6-5.5 18.3-9.2 8.6 5.5 18.3 9.8 28.7 12.4 51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.8-116.4-26.8-6.7-53.8-1.4-75.3 12.4-8.6-5.6-18.3-9.8-28.7-12.4-19-4.8-38.1-3.5-55.3 2.6V90.6c0-21.7-5.9-43.1-17.1-61.7l-10.3-17.2zM84.4 145.4c10.5-2.6 21.1-1.6 30.4 2.4-10.4 20-13.8 43.8-7.9 67.5l33.6 134.4c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1l-33.7-134.5c-6.2-25 8.3-50.3 32.7-57.6.7-.2 1.5-.4 2.2-.6 18.7-4.7 37.6 2.3 49 16.4 4.6 5.6 11.4 8.9 18.7 8.9s14.1-3.3 18.7-8.9c11.4-14.1 30.3-21.1 49-16.4 9.2 2.3 17 7 23 13.3 4.5 4.7 10.8 7.4 17.3 7.4s12.8-2.7 17.3-7.4c11.6-12.1 29-17.7 46.3-13.4 25.7 6.4 41.4 32.5 34.9 58.2l-56 224c-6.4 25.7-32.5 41.4-58.2 34.9-9.2-2.3-17-7-23-13.3-4.5-4.7-10.8-7.4-17.3-7.4s-12.8 2.7-17.3 7.4l-.7.7c-4.7 4.7-10.5 8.5-17.1 11-5.3 2-11 3.1-16.8 3.1-5.8 0-11.5-1.1-16.8-3.1-6.6-2.4-12.3-6.2-17-10.9-.2-.2-.5-.5-.7-.8-4.5-4.7-10.8-7.4-17.3-7.4s-12.8 2.7-17.3 7.4c-6 6.3-13.9 11-23 13.3-25.7 6.4-51.8-9.2-58.2-34.9l-56-224c-6.4-25.7 9.2-51.8 34.9-58.2z"
        }
    ]
};

const FarPercent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPercent",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M369 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L369 113zm-257 15a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm256 256a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarPeriod = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPeriod",
    "viewBox": "0 0 128 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
        }
    ]
};

const FarPersonArrowDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonArrowDownToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3.1V304H176V176.1c.7 0 1.5-.1 2.3-.1zM176 464V352h32v112h-32zm-48 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24H256V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-58.6-103.5c-15.6-27.6-44.9-44.7-76.6-44.7h-27.4c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l43.1-76.2V464zM472 56v281.7l-47.9-43.5c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9l88 80c9.2 8.3 23.1 8.3 32.3 0l88-80c9.8-8.9 10.5-24.1 1.6-33.9s-24.1-10.5-33.9-1.6L520 337.7V56c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FarPersonArrowUpFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonArrowUpFromLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3.1V304H176V176.1c.7 0 1.5-.1 2.3-.1zM176 464V352h32v112h-32zm-48 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24H256V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-58.6-103.5c-15.6-27.6-44.9-44.7-76.6-44.7h-27.4c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l43.1-76.2V464zm472.1-345.8-88-80c-9.2-8.3-23.1-8.3-32.3 0l-88 80c-9.8 8.9-10.5 24.1-1.6 33.9s24.1 10.5 33.9 1.6l47.9-43.4V392c0 13.3 10.7 24 24 24s24-10.7 24-24V110.3l47.9 43.5c9.8 8.9 25 8.2 33.9-1.6s8.2-25-1.6-33.9z"
        }
    ]
};

const FarPersonBikingMountain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonBikingMountain",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm.5 103c-2.7-3.4-7.5-4-11-1.4l-74.6 55c-9.6 7.1-8.4 21.8 2.3 27.2l69.6 34.8c8.1 4.1 13.3 12.4 13.3 21.5V416c0 13.3-10.7 24-24 24s-24-10.7-24-24V302.8l-56.3-28.1c-42.8-21.4-47.8-80.4-9.3-108.8l74.6-55c24.1-17.8 58.1-13.4 76.9 10.1l37.6 47H480c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-7.3 0-14.2-3.3-18.7-9l-44.8-56zm-164.1 15.7c-6.9 5.2-16.7 3.9-22.1-2.8l-44-55c-5.6-7.1-4.3-17.4 2.9-22.8l65.2-48.9c27.7-20.7 66.8-15.8 88.4 11.2l14.9 18.7c5.6 7.1 4.3 17.4-2.9 22.8l-102.4 76.8zM120 256h16c12.1 0 22.1 8.9 23.8 20.6 7.6 2.2 14.9 5.3 21.7 9 9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3 3.7 6.8 6.8 14.1 9 21.7C247 353.9 256 363.9 256 376v16c0 12.1-8.9 22.1-20.6 23.8-2.2 7.6-5.3 14.9-9 21.7 7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2-6.8 3.7-14.1 6.8-21.7 9-1.7 11.8-11.7 20.7-23.8 20.7h-16c-12.1 0-22.1-8.9-23.8-20.6-7.6-2.2-14.9-5.3-21.7-9-9.4 7.1-22.8 6.3-31.3-2.2l-11.4-11.3c-8.6-8.6-9.3-21.9-2.3-31.3-3.7-6.9-6.8-14.1-9-21.8C8.9 414.1 0 404.1 0 392v-16c0-12.1 8.9-22.1 20.6-23.8 2.2-7.6 5.3-14.9 9-21.8-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3 6.8-3.7 14.1-6.8 21.7-9 1.7-11.6 11.7-20.5 23.8-20.5zm8 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm352.2-171.4C481.9 265 491.9 256 504 256h16c12.1 0 22.1 8.9 23.8 20.6 7.6 2.2 14.9 5.3 21.8 9 9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3 3.7 6.8 6.8 14.1 9 21.7C631 353.9 640 363.9 640 376v16c0 12.1-8.9 22.1-20.6 23.8-2.2 7.6-5.3 14.9-9 21.7 7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2-6.9 3.7-14.1 6.8-21.8 9-1.7 11.8-11.7 20.7-23.8 20.7h-16c-12.1 0-22.1-8.9-23.8-20.6-7.6-2.2-14.9-5.3-21.7-9-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3-3.7-6.9-6.8-14.1-9-21.8-11.8-1.7-20.7-11.7-20.7-23.8v-16c0-12.1 8.9-22.1 20.6-23.8 2.2-7.6 5.3-14.9 9-21.8-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3 6.8-3.7 14.1-6.8 21.7-9zM576 384a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FarPersonBiking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonBiking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM208 384a80 80 0 1 1-160 0 80 80 0 1 1 160 0zm-80-128a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm464 128a80 80 0 1 1-160 0 80 80 0 1 1 160 0zm-80-128a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM341.5 149.6c3.5-2.5 8.3-1.9 11 1.4l44.8 56c4.6 5.7 11.5 9 18.7 9h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-52.5L390 121c-18.8-23.5-52.7-27.9-76.9-10.1l-74.6 55c-38.5 28.4-33.4 87.4 9.3 108.8l56.2 28.1V416c0 13.3 10.7 24 24 24s24-10.7 24-24V288c0-9.1-5.1-17.4-13.3-21.5l-69.6-34.8c-10.7-5.3-12-20.1-2.3-27.2l74.6-55z"
        }
    ]
};

const FarPersonBooth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonBooth",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m299.2 48 75.1 191.2c2.7 6.8 2.1 14.4-1.5 20.7l-56 98.1c-3.1 5.5-4.8 11.7-4.8 18 0 13.3 10.7 24 24 24 8.3 0 15.7-4.2 20-10.7 4.4-6.7 11.9-10.7 20-10.7s15.5 4 20 10.7c4.3 6.5 11.7 10.7 20 10.7 8.6 0 16.2-4.5 20.5-11.5 4.3-6.9 11.8-11.2 19.9-11.4s15.8 3.8 20.4 10.5c5.1 7.5 13.6 12.3 23.2 12.3 13.2 0 24.3-9.2 27.3-21.5.2-.9.5-1.7.7-2.5V56c0-4.4-3.6-8-8-8H299.2zM528 442.7c-8.7 3.4-18.1 5.3-28 5.3-15.8 0-30.5-4.8-42.6-13.1-11.7 8.2-26 13.1-41.4 13.1-14.8 0-28.6-4.5-40-12.1-11.4 7.7-25.2 12.1-40 12.1-39.8 0-72-32.2-72-72 0-14.7 3.8-29.1 11.1-41.8l50.4-88.1L247.6 48c-4.3.2-7.6 3.7-7.6 8v152h-48V56c0-30.9 25.1-56 56-56h272c30.9 0 56 25.1 56 56v432c0 13.3-10.7 24-24 24s-24-10.7-24-24v-45.3zM192 320h48v168c0 13.3-10.7 24-24 24s-24-10.7-24-24V320zM64 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-2.8 176c-7.3 0-13.2 5.9-13.2 13.2V277c.1 1.7.7 3.4 1.8 4.7L72 309v-99.1c-3.4-1.2-7.1-1.9-10.8-1.9zM0 276.6v-55.4C0 187.4 27.4 160 61.2 160c24.2 0 47.2 11 62.3 29.9l40 50.1H216c13.3 0 24 10.7 24 24s-10.7 24-24 24h-56.3c-12.2 0-23.6-5.5-31.2-15l-8.5-10.6v105.7l23 28.4c5.8 7.1 9 16 9 25.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-63.5l-56-68.9V488c0 13.3-10.7 24-24 24S0 501.3 0 488V276.6z"
        }
    ]
};

const FarPersonBreastfeeding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonBreastfeeding",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM116.9 282.2c19.6-26.5 50.6-42.2 83.6-42.2h58.3c27.6 0 54.1 11 73.7 30.6l55.2 55.3c12 12 12.5 31.3 1.2 43.9L326.1 440c-8.8 9.9-8 25.1 1.9 33.9s25.1 8 33.9-1.9l62.8-70.2c28.3-31.6 27-79.8-3-109.8l-55.2-55.3C338 208.1 299.3 192 258.9 192h-58.3c-48.2 0-93.6 22.9-122.2 61.7l-56 75.7C-8.1 370.6 7.5 429.5 54.5 450.2L190.3 510c12.1 5.3 26.3-.2 31.6-12.3s-.2-26.3-12.3-31.6L73.8 406.2c-18.8-8.3-25-31.8-12.8-48.3l56-75.7zM192 328c0-13.3-10.7-24-24-24s-24 10.7-24 24v43.4c0 7.5 2.1 14.8 6.1 21.2C177.8 437 226.5 464 278.9 464h1.1c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.1c-35.1 0-67.7-17.7-86.9-46.9V328zm80 56a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarPersonBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3.1V304H464V176.1c.7 0 1.5-.1 2.3-.1zM464 488V352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-58.6-103.5c-15.6-27.6-44.9-44.7-76.6-44.7h-27.4c-31.7 0-61 17.1-76.6 44.7l-58.6 103.5c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l43.1-76.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3S33.8 86.4 37 92.1l39.5 69.1-65.6 45.2c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.5c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l58.6-53.8 58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 49.9-7.8 23.5-41.6-53.7-37L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3l-76.1 23.1-29.4-74z"
        }
    ]
};

const FarPersonCane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonCane",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-48 161.5-51.1 90.3c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l58.6-103.5c15.6-27.6 44.9-44.7 76.6-44.7h35c26 0 50.6 11.5 67.3 31.4l81.7 97.2c8.5 10.1 7.2 25.3-2.9 33.8s-25.3 7.2-33.8-2.9L256 214.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.5zm80-33.4c-.9-.1-1.8-.1-2.7-.1H176v128h32V176.1zM352 376v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-30.9 25.1-56 56-56s56 25.1 56 56v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-4.4-3.6-8-8-8s-8 3.6-8 8z"
        }
    ]
};

const FarPersonCarryBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonCarryBox",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM0 488V340.3c.5.4 1.1.9 1.6 1.3L48 378.1V488c0 13.3-10.7 24-24 24S0 501.3 0 488zm59.2-312C53 176 48 181 48 187.2v85.3c0 2.5 1.1 4.8 3.1 6.3L72 295.2V179c-3.9-1.9-8.3-3-12.8-3zm60.8 70.2v86.7l25.8 20.3c8.1 6.4 13.4 15.6 14.9 25.8l15.1 105.6c1.9 13.1-7.2 25.3-20.4 27.2s-25.3-7.2-27.2-20.4l-14.6-102.5-92.2-72.4C7.9 305.9 0 289.6 0 272.4v-85.2C0 154.5 26.5 128 59.2 128c26.1 0 50.5 13.3 64.6 35.3l49.3 76.7H192V128c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H168.7c-13.6 0-26.3-6.9-33.6-18.4L120 246.2zm120-6.2h96v-96h-96v96z"
        }
    ]
};

const FarPersonChalkboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonChalkboard",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80H208v128h-32V176.1c.7 0 1.5-.1 2.3-.1zM176 488V352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V176h136c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24V48h224v224H368v-48h-48v48c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H178.3c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l43.1-76.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarPersonCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1h-27.4c-.8 0-1.5 0-2.3.1zm0 175.9v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6l-43.1 76.2c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l58.6-103.5c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7l46.6 82.4c-11.7 14-21.3 29.9-28.3 47.1-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32zm144 16a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FarPersonCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1h-27.4c-.8 0-1.5 0-2.3.1zm0 175.9v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6l-43.1 76.2c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l58.6-103.5c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7l46.6 82.4c-11.7 14-21.3 29.9-28.3 47.1-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32zm288-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarPersonCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1h-27.4c-.8 0-1.5 0-2.3.1zm0 175.9v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6l-43.1 76.2c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l58.6-103.5c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7l46.6 82.4c-11.7 14-21.3 29.9-28.3 47.1-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32zm144 16a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FarPersonCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1h-27.4c-.8 0-1.5 0-2.3.1zm0 175.9v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6l-43.1 76.2c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l58.6-103.5c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7l46.6 82.4c-11.7 14-21.3 29.9-28.3 47.1-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32zm288-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FarPersonCircleQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonCircleQuestion",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1h-27.4c-.8 0-1.5 0-2.3.1zm0 175.9v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6l-43.1 76.2c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l58.6-103.5c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7l46.6 82.4c-11.7 14-21.3 29.9-28.3 47.1-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32zm288-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64-142.4v6.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9 0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3C486.6 358.7 496 343 496 326c0-25.4-20.6-45.9-45.9-45.9h-40.5c-23 0-41.6 18.6-41.6 41.6z"
        }
    ]
};

const FarPersonCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1h-27.4c-.8 0-1.5 0-2.3.1zm0 175.9v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6l-43.1 76.2c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l58.6-103.5c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7l46.6 82.4c-11.7 14-21.3 29.9-28.3 47.1-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32zm288-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
        }
    ]
};

const FarPersonDigging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonDigging",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 64a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm232.8 224c8.2.3 15.7 4.7 19.8 11.8l104 176c4.4 7.4 4.5 16.6.2 24.1S552.6 512 544 512H288c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l16-48c3.3-9.8 12.4-16.4 22.8-16.4h35.4l20.3-29.5L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4s19.1-18 31.4-12.9l19.7 8.2 19.8-36.2c15.4-28.3 45-45.9 77.2-45.9h3.8c52.3 0 98.5 33.8 114.4 83.6l32.3 101.6 79 32.9 32.8-47.7c4.6-6.8 12.4-10.7 20.6-10.4zm-190.4 1-20-62.8c-9.5-29.9-37.3-50.2-68.6-50.2H158c-14.6 0-28.1 8-35.1 20.8l-17.3 31.8L250.4 289zm188.1 67.6-66.7 97-7.2 10.4h137.3l-63.4-107.4zM81.4 301.1l128 54.4c8.9 3.8 14.6 12.5 14.6 22.1V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-94.5l-88.5-37.6L47 494.7c-3.7 12.7-17 20-29.8 16.3S-2.7 494 1 481.3l48-164.8 7.6-25.9 24.9 10.6z"
        }
    ]
};

const FarPersonDollyEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonDollyEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM0 488V340.3c.5.4 1.1.9 1.6 1.3L48 378.1V488c0 13.3-10.7 24-24 24S0 501.3 0 488zm60.6-312c-6.9 0-12.6 5.6-12.6 12.6v83.9c0 2.5 1.1 4.8 3.1 6.3L72 295.2v-117c-3.6-1.4-7.5-2.2-11.4-2.2zm59.4 58.7v98.2l25.8 20.3c8.1 6.4 13.4 15.6 14.9 25.8l15.1 105.6c1.9 13.1-7.2 25.3-20.4 27.2s-25.3-7.2-27.2-20.4l-14.6-102.5-92.2-72.4C7.9 305.9 0 289.6 0 272.4v-83.8C0 155.1 27.1 128 60.6 128c24.8 0 48.2 11.7 63.1 31.5L172 224h35.3l-6.5-26.2c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5L297 384.6c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1l-134.4 33.6C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64 0-21.3 10.4-40.1 26.3-51.7l-31-124.3H168c-12.6 0-24.4-5.9-32-16l-16-21.3zM304 448a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarPersonDolly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonDolly",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM0 340.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V378.1L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3zm48-153.1c0-6.2 5-11.2 11.2-11.2 4.5 0 8.9 1.1 12.8 3v116.2l-20.9-16.5c-1.9-1.5-3.1-3.8-3.1-6.3v-85.2zm72 145.7v-86.7l15.1 23.5c7.4 11.4 20 18.4 33.6 18.4h54.5l27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7 0 35.3 28.7 64 64 64 32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-134.5 33.5c-10-13.7-25.3-23.3-42.8-25.7l-49.6-198.4c-3.2-12.9-16.2-20.7-29.1-17.5s-20.7 16.2-17.5 29.1l10.6 42.2h-38.2l-49.3-76.7c-14.1-22-38.5-35.3-64.6-35.3C26.5 128 0 154.5 0 187.2v85.3c0 17.2 7.9 33.4 21.4 44l92.2 72.4 14.6 102.5c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2L160.7 379a40.28 40.28 0 0 0-14.9-25.8L120 332.9zM288 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm69.4-55.8 91.6-22.8c17.1-4.3 27.6-21.7 23.3-38.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8l22.9 91.6c4.3 17.1 21.7 27.6 38.8 23.3z"
        }
    ]
};

const FarPersonDotsFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonDotsFromLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 128a88 88 0 1 0 0-176 88 88 0 1 0 0 176zM24 320 8.9 301.3c-10.3 8.4-11.9 23.5-3.6 33.8S28.7 347 39 338.7l.1-.1.7-.6c.7-.5 1.8-1.4 3.3-2.4 3-2.2 7.5-5.4 13.4-9.2 11.9-7.7 29.3-18.2 51.5-28.6 19.4-9.2 42.3-18.3 68-25.6V432h48V261.3c20.2-3.3 41.6-5.3 64-5.3s43.8 1.9 64 5.3V432h48V272.1c25.7 7.4 48.5 16.5 68 25.6 22.2 10.5 39.6 20.9 51.5 28.6 5.9 3.9 10.4 7.1 13.4 9.2 1.5 1.1 2.6 1.9 3.3 2.4l.7.6.1.1c10.3 8.3 25.4 6.7 33.7-3.6s6.7-25.4-3.6-33.8L552 320l15.1-18.7-.1-.1-.3-.3-.6-.5-.6-.4c-1-.8-2.4-1.8-4.2-3.1-3.6-2.6-8.8-6.3-15.5-10.7-13.4-8.8-32.8-20.3-57.3-31.9-48.9-23-118.4-46.3-200.5-46.3s-151.6 23.3-200.4 46.3c-24.4 11.5-43.9 23.1-57.3 31.9-6.7 4.4-11.9 8.1-15.5 10.7-1.8 1.3-3.2 2.4-4.2 3.1-.5.4-.9.7-1.2.9l-.3.3-.1.1L24.1 320zM0 488c0 13.3 10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm56-248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm152-152a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarPersonDressBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonDressBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm107.1 299.8-47.9-84.6 46.3 148c3.2 10.3-4.5 20.8-15.3 20.8H544v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-32v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-26.2c-10.8 0-18.5-10.5-15.3-20.8l46.3-148-47.9 84.6c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM526.7 336 480 186.5 433.3 336h93.4zM176 8c8.9 0 17 4.9 21.2 12.7l30.1 56.7 63.1-11.8c8.7-1.6 17.6 1.7 23.2 8.6s6.8 16.4 3.3 24.5l-25.6 58.9 40.9 35.4-31.7 56.1-32 8.6-2.5 64.2c-.3 8.9-5.6 16.8-13.6 20.7s-17.5 3-24.6-2.3l-51.7-38-51.7 38c-7.2 5.3-16.6 6.1-24.6 2.3s-13.2-11.8-13.6-20.7l-2.5-64.2L21.6 241c-8.6-2.3-15.2-9.2-17.1-17.8s1-17.7 7.7-23.5l48.6-42-25.7-58.9c-3.5-8.1-2.3-17.6 3.3-24.5S52.9 64 61.6 65.7l63.1 11.8 30.1-56.7C159 12.9 167.1 8 176 8zm0 75.2-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c8.5-6.2 20-6.2 28.4 0l29.5 21.7 1.4-36.6c.4-10.5 7.6-19.5 17.7-22.2l35.4-9.6-27.7-24c-7.9-6.9-10.5-18.1-6.3-27.7l14.6-33.6-36 6.7c-10.3 1.9-20.7-3.1-25.6-12.3L176 83.2z"
        }
    ]
};

const FarPersonDressFairy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonDressFairy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm48.3 144c-7.1 0-13.4 4.7-15.4 11.6L255.6 336h128.8l-33.3-116.4c-2-6.9-8.2-11.6-15.4-11.6h-31.4zm0-48h31.5c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H384v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-32v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-21.6c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4-14.1 8-26.1 19.5-34.7 33.5C181.6 120.7 119 85.2 48 80.5V112c0 71.4 33.3 134.9 85.4 176l18.1 14.3c10.1 8 12.1 22.5 4.5 33L142.5 354c-16.3 22.3-26.9 49-29.7 78 32.1-.2 61.9-9.7 87-26.2 7.2 4.6 15.4 7.9 24.3 9.3v32.1C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32 0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64c0-17.7 14.3-32 32-32zm385.6 141.9c-8.6-14-20.6-25.5-34.7-33.5C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32h-16c-41.2 0-79.7-12-112-32.7v-32.1c8.9-1.4 17.1-4.7 24.3-9.3 25 16.4 54.9 26 87 26.2-2.9-29-13.5-55.7-29.7-78L484 335.4c-7.6-10.4-5.6-25 4.5-33l18.1-14.4c52.1-41.1 85.4-104.6 85.4-176V80.5c-71 4.7-133.6 40.2-174.4 93.3z"
        }
    ]
};

const FarPersonDressSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonDressSimple",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM96.9 219.6 63.6 336h128.8l-33.3-116.4c-2-6.9-8.2-11.6-15.4-11.6h-31.4c-7.1 0-13.4 4.7-15.4 11.6zm-46.2-13.2c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-32v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H42.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"
        }
    ]
};

const FarPersonDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonDress",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm21.7 185.7 37.4 66.1c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-51.8-91.5c-19.8-35-56.9-56.6-97.1-56.6s-77.3 21.6-97.1 56.6l-51.8 91.5c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l37.4-66.1-36.6 130c-2.9 10.2 4.8 20.3 15.4 20.3H96v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h32v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h26.9c10.6 0 18.3-10.1 15.4-20.3l-36.6-130zM160 176c2.2 0 4 1.4 4.6 3.5l44 156.5h-97.2l44-156.5a4.8 4.8 0 0 1 4.6-3.5z"
        }
    ]
};

const FarPersonDrowning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonDrowning",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 32c13.3 0 24 10.7 24 24v36.6c0 58 37.9 109.1 93.4 126 43.9 13.4 90.7 14.3 135.1 2.7L514 192.7c12.8-3.3 25.9 4.3 29.3 17.2s-4.3 25.9-17.2 29.3l-109.6 28.6c-14.3 3.7-28.9 6.4-43.5 7.9l-17.3 103.9c-10.6-3.5-21.2-8.8-30.9-15.5-4.4-3.1-9.1-5.6-14-7.4l13.3-79.8c-23.2-1.4-46.3-5.5-68.8-12.3-4.6-1.4-9-2.9-13.4-4.7l-21.3 119.7c-9.2 3.1-18.9 4.9-28.6 4.9-6.6 0-13.5-.9-20.6-2.7l26.3-147c-43-33.3-69.7-85.3-69.7-142.1V56c0-13.3 10.7-24 24-24zm112 96a56 56 0 1 1 112 0 56 56 0 1 1-112 0zM111.9 398.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7 9.1-8.1 22.8-8.1 31.9 0z"
        }
    ]
};

const FarPersonFairy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonFairy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3c-.8 9.3 6.6 17.3 15.9 17.3h84.9c9.4 0 16.7-8 15.9-17.3l-4.1-49.3c-1.3-16.5-15.2-29.3-31.8-29.3h-44.8zM336 352h-32v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352zM32 32c89.4 0 169.4 40.8 222.2 104.7-15 6.3-28.4 15.9-39.3 27.8-40.8-47.9-100.2-79.6-166.9-84V112c0 71.4 33.3 134.9 85.4 176l18.1 14.3c10.1 8 12.1 22.5 4.5 33L142.5 354c-16.3 22.3-26.9 49-29.7 78 43.3-.2 82.5-17.6 111.2-45.7v61C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32 0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64c0-17.7 14.3-32 32-32zm393.1 132.5c-10.9-11.9-24.3-21.5-39.3-27.8C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32h-16c-41.2 0-79.7-12-112-32.7v-61c28.7 28.2 67.9 45.5 111.2 45.7-2.9-29-13.5-55.7-29.7-78l-13.6-18.7c-7.6-10.4-5.6-25 4.5-33l18.2-14.3c52.1-41.1 85.4-104.6 85.4-176V80.5c-66.7 4.4-126.1 36.1-166.9 84z"
        }
    ]
};

const FarPersonFallingBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonFallingBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 0c13.3 0 24 10.7 24 24v10.4c0 56.5-30.1 107.8-77.5 135.8l58.2 85.8h74.9c13.1 0 25.3 6.4 32.8 17.1l51.2 73.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L307.5 304h-49.6c-1.3 1.5-2.9 2.8-4.6 4l-53.9 36 84.8 131c7.2 11.1 4 26-7.1 33.2s-26 4-33.2-7.1L84.4 254.7c-2.9 9.9-4.4 20.3-4.4 30.9V360c0 13.3-10.7 24-24 24s-24-10.7-24-24v-74.4c0-66.3 41.5-125.5 103.8-148.2 43.3-15.8 72.2-57 72.2-103.1V24c0-13.3 10.7-24 24-24zm-58.7 303.6 26-17.3-64.8-95.5c-8.4 4.9-16.1 10.9-22.8 17.7l61.6 95.2zM0 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm464 222.3-33.3 24.5c-.7-1.2-1.5-2.3-2.3-3.4l-51.2-73.2c-15-21.4-39.4-34.1-65.5-34.1h-19.8c.5-6.2 3.4-12.1 8.2-16.3l48.6-42-25.6-59c-3.5-8.1-2.3-17.6 3.3-24.5s14.5-10.3 23.2-8.6l63.1 11.8 30.1-56.7C447 12.9 455.1 8 464 8s17 4.9 21.2 12.7l30.1 56.7 63.1-11.8c8.7-1.6 17.6 1.7 23.2 8.6s6.8 16.4 3.3 24.5l-25.6 58.9 48.6 42c6.7 5.8 9.7 14.8 7.7 23.5s-8.6 15.5-17.1 17.8l-62 16.7-2.5 64.2c-.3 8.9-5.6 16.8-13.6 20.7s-17.5 3-24.6-2.3l-51.7-38zm0-219.1-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c8.5-6.2 20-6.2 28.4 0l29.5 21.7 1.4-36.6c.4-10.5 7.6-19.5 17.7-22.2l35.4-9.6-27.7-24c-7.9-6.9-10.5-18.1-6.3-27.7l14.6-33.6-36 6.7c-10.3 1.9-20.7-3.1-25.6-12.3L464 83.2z"
        }
    ]
};

const FarPersonFalling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonFalling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v10.4c0 46.1-28.9 87.3-72.2 103.1C137.5 160.1 96 219.3 96 285.6V360c0 13.3 10.7 24 24 24s24-10.7 24-24v-74.4c0-10.7 1.5-21.1 4.4-30.9L307.9 501c7.2 11.1 22.1 14.3 33.2 7.1s14.3-22.1 7.1-33.2l-84.6-130.6L327 304h46.3l64.8 72.1c8.9 9.9 24 10.6 33.9 1.8s10.6-24 1.8-33.9l-67.2-74.7c-7.6-8.4-18.4-13.2-29.7-13.2h-76.2l-58.2-85.9c47.4-28 77.5-79.3 77.5-135.8V24zm-56.1 263.2L237.5 304l-61.8-95.5c6.7-6.8 14.4-12.8 22.8-17.7l65.4 96.4zM112 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarPersonFromPortal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonFromPortal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72.2 436C58.7 404.6 48 348.4 48 256S58.7 107.4 72.2 76c12.4-28.7 22.4-28.1 23.7-28h.2c1.3-.1 11.3-.7 23.7 28 13.5 31.4 24.2 87.7 24.2 180 0 45.7-2.6 82.6-6.9 112H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h84.9c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6L199.4 368h-13.8c4.2-31.3 6.4-68.4 6.4-112 0-21.4-.5-41.2-1.6-59.6l37.7-32.4c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5-34.1 109.6c-4 12.7 3.1 26.1 15.8 30.1s26.1-3.1 30.1-15.8l36-115.6c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.3 23.5 29 39.5 53.6 39.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48.4c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7c-14-3.5-28.7-3.5-42.7 0l-1.8.5c-13.3 3.3-25.6 9.7-35.9 18.6L184.7 138C170.3 38 136 0 96 0 43 0 0 66.6 0 256s43 256 96 256c28 0 53.2-18.6 70.7-64h-52.8c-9.5 16.5-16.7 16.1-17.8 16h-.2c-1.3.1-11.3.7-23.7-28zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-19.9 79.8-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L321 169l27.1 6.8z"
        }
    ]
};

const FarPersonHalfDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonHalfDress",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M154 .4a48 48 0 1 1 12 95.2A48 48 0 1 1 154 .4zM176 352V128c30.8.8 59.1 17.7 74.3 44.6l58.5 103.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1l-43-76.1V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352zM62.9 184.6C80 154.3 110.1 134 144 129.1v108.6L113.3 336H144v152c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H69.8c-10.8 0-18.5-10.5-15.3-20.8l46.3-148-47.9 84.6c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5z"
        }
    ]
};

const FarPersonHarassing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonHarassing",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM96 209.5l-51.1 90.3c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l58.6-103.5c15.6-27.6 44.9-44.7 76.6-44.7h35c26 0 50.6 11.5 67.3 31.4l81.7 97.2c8.5 10.1 7.2 25.3-2.9 33.8s-25.3 7.2-33.8-2.9L224 214.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.5zm80-33.4c-.9-.1-1.8-.1-2.7-.1H144v128h32V176.1zM304 32h56c8.8 0 16 7.2 16 16s-7.2 16-16 16h-56c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 208a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm116 56c33.1 0 60 26.9 60 60v96c0 31.8-24.7 57.8-56 59.9v.1h-4c-5.7 0-11.1-.8-16.3-2.2-19.6-4.4-37.5-15.1-50.7-30.7l-44.6-52.7-39.3 73c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l56-104c3.8-7 10.7-11.7 18.6-12.5s15.7 2.3 20.8 8.4L456 413v-57c0-33.1 26.9-60 60-60zm1.4 167.9c6-.7 10.6-5.8 10.6-11.9v-96c0-6.6-5.4-12-12-12s-12 5.4-12 12v96c0 5.2 3.2 9.5 7.8 11.2 1.8.3 3.7.6 5.6.7zM265.7 104.8c4-7.9 13.6-11.1 21.5-7.2l48 24c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-48-24c-7.9-4-11.1-13.6-7.2-21.5z"
        }
    ]
};

const FarPersonHiking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonHiking",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-151.5 77.8c3.8-15.1-7.7-29.8-23.3-29.8H109c-36 0-67.6 24.1-77.1 59L7 246.4c-3.7 13.7 5.2 27.7 19.2 30l47.9 8c12.3 2.1 24.2-5.7 27.2-17.9l35.2-140.7zM384 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v24h-27.2l-28.7-43.1c-11.2-16.9-28.6-28.7-48.5-32.9-32-6.9-63.6 13.3-70.9 45.2l-19.8 86.5c-4.7 20.4 2.4 41.7 18.4 55.2l80.7 68.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V383.4c0-11.8-5.2-22.9-14.2-30.5l-27.5-23.2 22.4-95.2 2.5 3.7c7.4 11.1 19.9 17.8 33.3 17.8H336v232c0 13.3 10.7 24 24 24s24-10.7 24-24V184zm-162.4-5.1c3.6.8 7 2.2 10 4.1l-26.3 111.9-14.9-12.6c-2.3-1.9-3.3-5-2.6-7.9l19.8-86.5c1.4-6.3 7.7-10.3 14.1-9zM80.9 481.5c-3.6 12.8 3.8 26 16.6 29.6s26-3.8 29.6-16.6l36.7-130-24.8-21c-5.6-4.7-10.5-10.1-14.6-15.8L80.9 481.5z"
        }
    ]
};

const FarPersonMilitaryPointing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonMilitaryPointing",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 39c0-13 10-23.8 22.9-24.9L398.7 1.4C408 .7 416 8 416 17.4V48c0 8.8-7.2 16-16 16H249c-13.8 0-25-11.2-25-25zM32 248c0-13.3 10.7-24 24-24h288.6c42.9 0 82.5 22.9 103.9 60l92.3 160c6.6 11.5 2.7 26.2-8.8 32.8s-26.2 2.7-32.8-8.8L416 323.8V480c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V272H56c-13.3 0-24-10.7-24-24zm240 24v82.1l73.4-82.1H272zm0 192h96v-32h-96v32zm96-145.2L309.7 384H368v-65.2zM240 112c0-5.5.6-10.8 1.6-16h50.7c-2.7 4.7-4.3 10.2-4.3 16 0 17.7 14.3 32 32 32s32-14.3 32-32c0-5.8-1.6-11.3-4.3-16h50.7c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80z"
        }
    ]
};

const FarPersonMilitaryRifle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonMilitaryRifle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 39c0 13.8 11.2 25 25 25h151c8.8 0 16-7.2 16-16V17.4c0-9.4-8-16.7-17.3-16L182.9 14.1C170 15.2 160 26 160 39zm277.9 1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l-94.7 163.8c-10.1-3.8-20.8-6.2-31.7-7.1-2.5-.3-5-.4-7.6-.4H224c-2.6 0-5.1.1-7.5.4-35.7 3.1-68.5 22-88.9 52l-91.4 134c-7.5 11-4.6 25.9 6.3 33.4s25.9 4.6 33.3-6.3L160 314.1V480c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V314.1l84.2 123.5c7.5 11 22.4 13.8 33.4 6.3s13.8-22.4 6.3-33.3l-85.2-125 38.6-66.9c8.8-15.3 3.6-34.9-11.7-43.7l-1.6-.9L471.5 78c4.4-7.7 1.8-17.4-5.9-21.9l-13.9-8-13.9-8zM304 403.6 228.8 272h56.5c1.7 0 3.5.1 5.2.2 7.7 1.2 13.5 7.8 13.5 15.8v115.6zm-96-71.3L283.2 464H208V332.4zM176 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h-50.7c2.7 4.7 4.3 10.2 4.3 16 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16h-50.7c-1 5.2-1.6 10.5-1.6 16z"
        }
    ]
};

const FarPersonMilitaryToPerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonMilitaryToPerson",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M71 12.5 182.2.1C191.7-1 200 6.5 200 16v14.1c0 8.8-7.2 16-16 16H72.9c-9.3 0-16.9-7.5-16.9-16.9 0-8.6 6.5-15.8 15-16.8zM384 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-48 224v16h96v-16c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm-48 0c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32v-32zM66 80h124c1.3 5.1 2 10.5 2 16 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-5.5.7-10.9 2-16zm158 352c0 6.9-3 13.5-8.2 18.1l-64 56c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9l15.9-13.9H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h112.1l-15.9-13.9c-10-8.7-11-23.9-2.3-33.9s23.9-11 33.9-2.3l64 56c5.2 4.6 8.2 11.1 8.2 18.1zm72.2 18.1C291 445.5 288 439 288 432s3-13.5 8.2-18.1l64-56c10-8.7 25.1-7.7 33.9 2.3s7.7 25.1-2.3 33.9L375.9 408H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H375.9l15.9 13.9c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3l-64-56zM32 256c0-18.8 8.1-35.7 21-47.4l144.2 111c-1.7.3-3.4.4-5.2.4H64c-17.7 0-32-14.3-32-32v-32zm192 32c0 3.7-.6 7.2-1.8 10.5L85.1 192.9c3.6-.6 7.2-.9 10.9-.9h64c35.3 0 64 28.7 64 64v32z"
        }
    ]
};

const FarPersonPinball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonPinball",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32 90.2c0-5.6 4.6-10.2 10.2-10.2 4.9 0 9.7 1.3 13.8 3.7v120.1l-21.4-19.9c-1.6-1.5-2.6-3.6-2.6-5.9v-87.8zm72 158.2v-88l6.5 11.5c7.1 12.5 20.4 20.2 34.7 20.2H192V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-88h352v88c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H504c-13.3 0-24 10.7-24 24v42c0 6.9 1.3 13.8 3.8 20.3l44 113.2L251 249.3c-4.4-5.7-11.3-9.3-19-9.3h-66.1l-42.3-74c-13.4-23.5-38.4-38-65.4-38C26.1 128 0 154.1 0 186.2V274c0 15.6 6.5 30.4 17.9 41l94.1 87.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-89c0-11.1-4.6-21.7-12.8-29.3L120 344.4zm472 7.6H240v-51.9l32.1-5.8c0 .6-.1 1.1-.1 1.7 0 13.3 10.7 24 24 24s24-10.7 24-24c0-3.5-.8-6.9-2.2-9.9L592 236.7V352zM48 386.7 0 342.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V386.7zM528 66V48h64v139.2l-16.5 2.4-47-120.7c-.4-.9-.5-1.9-.5-2.9z"
        }
    ]
};

const FarPersonPraying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonPraying",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM202.1 192c5.3 0 10.2 2.7 12.9 7.2l4.3 7.1-67.1 161.2-9.4-6c-9.8-6.3-13.7-18.7-9.2-29.4l54.5-130.7c2.4-5.7 7.9-9.3 14-9.3zm48.3 64.7 7.4 12.1c12.8 20.9 41.2 25.4 59.9 9.6l89.8-76c10.1-8.6 11.4-23.7 2.8-33.8s-23.7-11.4-33.8-2.8l-82.7 70-37.9-61.6C244.4 155.4 224 144 202.1 144c-25.5 0-48.5 15.3-58.3 38.9L89.3 313.6c-13.4 32.3-1.8 69.5 27.6 88.3L214 464H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c10.7 0 20-7 23-17.3s-1.1-21.2-10.1-27l-115.7-74 57.1-137.1z"
        }
    ]
};

const FarPersonPregnant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonPregnant",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM96 352c0 17.7 14.3 32 32 32v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h32v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h64c17.7 0 32-14.3 32-32v-32c0-46.8-33.4-85.7-77.7-94.3l-6.1-32.5c-6.8-36.1-37.1-62.7-73.3-65.1-1-.1-1.9-.2-2.9-.2h-20.7c-32.5 0-62.3 17.9-77.6 46.5L34.8 284.7c-6.2 11.7-1.8 26.2 9.9 32.5s26.2 1.8 32.5-9.9L96 272.1V352zm80-176h13.6c15.4 0 28.6 11 31.5 26.1l6.1 32.5c3.6 19.4 18.7 34.5 38.1 38.3 22.1 4.3 38.8 23.8 38.8 47.1v16H144V208c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarPersonRays = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonRays",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3.1V304H240V176.1c.7 0 1.5-.1 2.3-.1zM240 488V352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-58.6-103.5c-15.6-27.6-44.9-44.7-76.6-44.7h-27.4c-31.7 0-61 17.1-76.6 44.7l-58.6 103.5c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l43.1-76.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM7 7c-9.3 9.4-9.3 24.6 0 34l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7C31.6-2.3 16.4-2.3 7 7zm498 0c-9.4-9.4-24.6-9.4-33.9 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9zM41 505l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm464 0c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0z"
        }
    ]
};

const FarPersonRifle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonRifle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0c-44.2 0-80 35.8-80 80s35.8 80 80 80c43.9 0 79.5-35.3 80-79v-2c-.5-43.7-36.1-79-80-79zm20.7 192h-41.4c-45.5 0-87 25.7-107.3 66.3l-77.5 155c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L152 285.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24V242.6c6.2-1.7 12.7-2.6 19.3-2.6h41.3c3.8 0 7.6.3 11.3.9V488c0 13.3 10.7 24 24 24s24-10.7 24-24V207.7c-17.8-10.1-38.1-15.7-59.3-15.7zM208 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16v100.3c-9.6 5.5-16 15.9-16 27.7v32h-16c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h32v112c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-48v-26.7l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16h-32zm16 336h-32v-96h32v96z"
        }
    ]
};

const FarPersonRunningFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonRunningFast",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8.5c-13.3 3.3-25.6 9.7-35.9 18.6l-44.5 38.2c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5-34.1 109.5c-4 12.7 3.1 26.1 15.8 30.1s26.1-3.1 30.1-15.8l36-115.6c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.3 23.5 29 39.5 53.6 39.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48.4c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L321 169l27.1 6.8zM218.5 317.1 199.4 368H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h84.9c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6zM16 95.8c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm-16 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FarPersonRunning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonRunning",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-85.3 60.6c14-3.5 28.7-3.5 42.7 0l95 23.7c19 4.8 34.2 19.1 39.9 37.9l19.7 64.2c1 3.4 4.1 5.6 7.6 5.6H392c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48.4c-24.6 0-46.3-16-53.5-39.5l-5.6-18.2-28.1 84.4 32.1 18c16.5 9.3 24.2 28.8 18.6 46.8l-36.2 115.7c-4 12.7-17.4 19.7-30.1 15.8s-19.7-17.4-15.7-30.1l34.2-109.5-88-49.5c-23.4-13.2-34.2-41.1-25.7-66.5l32.7-98-8.6-2.1c-6.4-1.6-13-1.6-19.4 0l-1.8.5c-6 1.5-11.6 4.4-16.3 8.4l-44.6 38c-10.1 8.6-25.2 7.5-33.8-2.6s-7.5-25.2 2.6-33.8l44.5-38.2c10.4-8.9 22.7-15.2 35.9-18.6l1.8-.5zm75.1 182.1 38.3-115L225 169l-33.9 101.5c-1.2 3.6.3 7.6 3.7 9.5l19 10.7zM103.4 368l19.1-50.9c7.7 13.3 18.9 24.7 33 32.6l4.9 2.8-14.1 37.6c-5.9 15.6-20.8 25.9-37.4 25.9H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h79.4z"
        }
    ]
};

const FarPersonSeatReclined = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSeatReclined",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16.9 189.6 16.9 76.2c.8 3.7 4.1 6.3 7.8 6.3H234l-19.4-87.3c-1.1-5.1-5.7-8.7-10.9-8.7-7.1 0-12.4 6.6-10.9 13.6zm68.6-15.2.4 1.7H328c13.3 0 24 10.7 24 24s-10.7 24-24 24h-55.4l10.7 48h35.5c30 0 56.9 18.6 67.4 46.7l28.5 76.1 34.7-9.9c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7l-56 16c-12 3.4-24.7-2.9-29.1-14.6l-36.3-96.9c-3.5-9.4-12.5-15.6-22.5-15.6h-101c-26.2 0-49-18.2-54.7-43.9L146.1 232c-8.2-36.9 19.9-72 57.7-72 27.7 0 51.7 19.3 57.7 46.3zM79.6 147.8l34 192.7c6.1 34.4 36 59.5 70.9 59.5H280c13.3 0 24 10.7 24 24s-10.7 24-24 24h-95.5c-58.2 0-108.1-41.8-118.2-99.1l-34-192.7c-2.3-13.1 6.4-25.5 19.5-27.8s25.5 6.4 27.8 19.5z"
        }
    ]
};

const FarPersonSeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSeat",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 92c0-6.6 5.4-12 12-12s12 5.4 12 12v92h-16c-4.4 0-8-3.6-8-8v-84zm72 92v-56h56c13.3 0 24-10.7 24-24s-10.7-24-24-24h-57.2c-5.6-27.4-29.8-48-58.8-48-33.1 0-60 26.9-60 60v84c0 30.9 25.1 56 56 56h94c12 0 22.2 8.9 23.8 20.8l10.4 78.3c1.6 12 11.8 20.9 23.8 20.9h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-43l-7.7-57.5c-4.7-35.8-35.2-62.5-71.3-62.5h-30zM48 152c0-13.3-10.7-24-24-24S0 138.7 0 152v176c0 66.3 53.7 120 120 120h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80c-39.8 0-72-32.2-72-72V152z"
        }
    ]
};

const FarPersonShelter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonShelter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M268.1 3.3c-7.5-4.4-16.8-4.4-24.3 0l-232 136C4.5 143.6 0 151.5 0 160v328c0 13.3 10.7 24 24 24s24-10.7 24-24V173.8l208-122 208 122V488c0 13.3 10.7 24 24 24s24-10.7 24-24V160c0-8.5-4.5-16.4-11.9-20.7l-232-136zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-16 64.5c2-.3 4.1-.5 6.2-.5h19.5c2.1 0 4.2.2 6.2.5V368H240v-95.5zm0 143.5h32v72c0 13.3 10.7 24 24 24s24-10.7 24-24V328.3l18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3C328 241.8 298.2 224 265.8 224h-19.6c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-72z"
        }
    ]
};

const FarPersonSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M438.1 32.2c4.5-12.5-1.9-26.2-14.3-30.8S397.5 3.3 393 15.8l-4.6 12.7-59.7-21.8c-12.5-4.5-26.2 1.9-30.8 14.3l-38.3 105.3c-4.5 12.5 1.9 26.2 14.3 30.8l59.7 21.7-17.1 47.2-19.3-7.2c-12.1-4.6-22.8-12.3-30.9-22.4L238 161c-16.7-20.9-42-33-68.7-33h-39.7c-34.8 0-66.3 20.5-80.4 52.3l-47.1 106c-5.4 12.1.1 26.3 12.2 31.7s26.3-.1 31.7-12.2l34-76.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352h52.2l27.1 59.6c.5 1 .7 2.2.7 3.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-73.1c0-8-1.7-15.9-5-23.2l-35-77V210.4l12.7 15.9c13.5 16.9 31.3 29.8 51.6 37.4l19.7 7.4-11 30.3c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3l38.3-105.3c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7zM334.8 60l120.3 43.8-21.9 60.2-120.3-43.8L334.8 60zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-14.4 80H168v128h-40V176h1.6z"
        }
    ]
};

const FarPersonSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSimple",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM73.7 237.3C75.1 220.8 89 208 105.6 208h44.8c16.6 0 30.5 12.8 31.9 29.3l4.1 49.3c.8 9.3-6.6 17.3-15.9 17.3H85.6c-9.4 0-16.7-8-15.9-17.3l4.1-49.3zM112 352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4h-44.8c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352z"
        }
    ]
};

const FarPersonSkating = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSkating",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-224 72c0-13.3 10.7-24 24-24h169.4c35.6 0 53.5 43.1 28.3 68.3L268.9 245l69.3 60c8.8 7.6 13.8 18.6 13.8 30.2V424c0 13.3-10.7 24-24 24s-24-10.7-24-24v-85l-85.3-74c-24.8-21.5-26-59.7-1.9-82.5 11.9-11.2 26.8-25.1 41.6-38.5H152c-13.3 0-24-10.7-24-24zM79 367l100.4-100.4c4.8 8.5 11.2 16.4 19 23.2l13.7 11.9L113 401c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm324.9 81.4c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zm-268.7 29.9-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
        }
    ]
};

const FarPersonSkiJumping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSkiJumping",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-240 72c0-13.3 10.7-24 24-24h165.2c37 0 54.2 45.9 26.3 70.2L202.4 275 171 385l262.7-135.9c18.6-9.6 30.3-28.8 30.3-49.7V192c0-13.3 10.7-24 24-24s24 10.7 24 24v7.3c0 38.9-21.7 74.5-56.2 92.4L35 509.3c-11.7 6.1-26.2 1.5-32.3-10.3S1.2 472.7 13 466.7l113.2-58.6c-5.4-5.9-7.6-14.4-5.3-22.7l37.2-130.1c.1-.2.1-.5.2-.7l8.3-29c2.7-9.4 7.8-18 14.9-24.9 11.1-10.7 36.2-34.6 60.8-56.8H136c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarPersonSkiLift = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSkiLift",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0c8.8 0 16 7.2 16 16v191.9l-32 7.5V16c0-8.8 7.2-16 16-16zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM13.6 178.3c12-5.7 26.3-.7 32 11.3l65 135.8c8.3 17.4 28 26.4 46.6 21.3l36.5-9.9c12.8-3.5 26 4.1 29.5 16.8s-4.1 26-16.8 29.5l-36.5 9.9c-41 11.2-84.2-8.6-102.5-46.9L2.3 210.4c-5.7-12-.7-26.3 11.3-32zM488 288c13.3 0 24 10.7 24 24v1c0 33.5-20.9 63.4-52.3 75L128.3 510.5c-12.4 4.6-26.2-1.8-30.8-14.2s1.8-26.2 14.2-30.8L272 406.2V286.3l-94.2 22.2c-18 4.2-36.6-4.5-44.9-21l-42.6-85.2c-11.5-23.1 5.2-50.3 31.1-50.3 13.2 0 25.2 7.4 31.1 19.2l42 84 86.2-20.2c20.1-4.7 39.3 10.5 39.3 31.1v122.4L443.1 343c12.6-4.6 20.9-16.6 20.9-30v-1c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarPersonSkiingNordic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSkiingNordic",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8.5c-13.3 3.3-25.6 9.7-35.9 18.6l-44.5 38.2c-10.1 8.6-11.2 23.8-2.6 33.8 1.2 1.5 2.6 2.7 4.1 3.8L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h480c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24h-69.4l27.2-176.7c10.4-2.6 18.2-12 18.2-23.3 0-13.3-10.7-24-24-24h-48.4c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zM429.4 288l-27.1 176h-57.7l26.4-84.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.3 23.5 29 39.5 53.6 39.5h21.7zM99.7 464l55.8-265.1 40.6-34.8c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5-28.8 92.7H190.7l36.8-109.8-8-4.5c-13.1-7.4-23.6-17.6-31.2-29.6L140.1 464H99.7zm216.4-288.2-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L289 169l27.1 6.8z"
        }
    ]
};

const FarPersonSkiing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSkiing",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L239.8 365l49.6-74.5-82.7-87.9c-9.5-10.1-14.4-22.4-15.1-34.9l87.7 42 49.4 52.5a39.98 39.98 0 0 1 4.2 49.6l-50.2 75.4 135.8 70.5c13.6 7.1 29.8 7.2 43.6.3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3c-11.7-6.1-16.3-20.6-10.2-32.4zM118.9 65.6l18.1 8.6 8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5L165.9 88l55.5 26.6c1.7-.9 3.5-1.7 5.4-2.5l80.9-32.4c32.4-13 68.6 6.5 75.6 40.7l12.3 59.7 62.9 30.1c12 5.7 17 20 11.3 32s-20 17-32 11.3l-54.2-25.9c-1-.3-1.9-.6-2.8-1l-229.1-110-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5zm217.3 64.7c-1-4.9-6.2-7.7-10.8-5.8l-45.7 18.3 65.5 31.5-9-43.9z"
        }
    ]
};

const FarPersonSledding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSledding",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 152c0-13.3 10.7-24 24-24h169.4c35.6 0 53.5 43.1 28.3 68.3L281.9 264H344c22.1 0 40 17.9 40 40v80c0 7.7-3.7 14.6-9.4 19l43.9 22.8c13.6 7.1 29.8 7.2 43.6.3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7l-383.5-199c-11.7-6.1-16.3-20.6-10.2-32.4s20.6-16.3 32.4-10.2l124.1 64.4c-4.3-11.5-2.2-25.4 8.8-35.1l90.7-80H152c-13.3 0-24-10.7-24-24zm208 160H199.3L336 383v-71z"
        }
    ]
};

const FarPersonSnowboarding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSnowboarding",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M204.3 3c11.6-6.4 26.2-2.3 32.6 9.3l31.9 57.4c1.3 2.3 3.6 3.8 6.2 4.1l33.8 3.4c24.1 2.4 46.9 12 65.4 27.6l129.3 108.8c10.1 8.5 11.4 23.7 2.9 33.8s-23.7 11.4-33.8 2.9l-68.2-57.5-82.3 43.9 24.7 18.9c24.9 19 34.6 51.9 24.1 81.4l-28.2 79c-1.4 3.8-3.6 7-6.3 9.6l93.3 35.7c4.6 1.8 9.4 2.6 14.3 2.6h28c13.3 0 24 10.7 24 24s-10.7 24-24 24h-28.2c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l19.4 7.4c-2.9-11.4 2.9-23.4 14-28.1L192 272v-68.2c0-21.2 12-40.6 31-50.1l61.4-30.7-14.1-1.4c-18.3-1.8-34.5-12.5-43.4-28.5L195 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zm91.8 407.2c-.3-3.4.1-6.9 1.3-10.3l28.2-79c3.5-9.8.3-20.8-8-27.1L240 234.4v42.9c0 16.1-9.7 30.7-24.6 36.9l-81.4 34 162.1 62.1zM259.6 189l20.5 15.7 84.6-45.1-17.2-14.5-87.9 43.9zM384 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FarPersonSnowmobiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSnowmobiling",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm99.7 75.4c11.4-6.8 26.1-3.1 32.9 8.2l46.8 78.1 138.9 69.4c10.8 5.4 17.7 16.5 17.7 28.6v59.1c0 10.7-5.3 20.7-14.2 26.6L492 392l54 72h20.1l33-33c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-40 40c-4.5 4.5-10.6 7-17 7H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h46l-48-64H313.3c4.3 9.8 6.7 20.6 6.7 32 0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80 0-26.2 12.6-49.4 32-64l8-16 31.2-62.3c5.4-10.8 16.5-17.6 28.6-17.6H288l24-32h-32c-7.6 0-14.7-3.6-19.2-9.6l-33.4-44.5c-4.7-6.2-12-9.9-19.8-9.9-9.8 0-18.6 5.7-22.6 14.7l-19.1 43.1c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l19.1-43.1c11.7-26.3 37.7-43.2 66.4-43.2 22.9 0 44.4 10.8 58.2 29.1L292 192h56l18.7-24.9-35.3-58.8c-6.8-11.4-3.1-26.1 8.2-32.9zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H80zm160-48h225.5l62.5-41.7v-40.6l-129.6-64.9-72 96L312 320H109.7l-16 32H240z"
        }
    ]
};

const FarPersonSwimming = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonSwimming",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 160a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm48 174.1c-17.2 14.9-39 26.7-61.2 31.7C5.9 368.7-2.3 381.5.6 394.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zm176.5-140.2L403 318.1c13.8-3.2 27.9-9.6 40.2-18 2.4-1.7 4.9-3.2 7.5-4.5L295.9 164.3C319.7 151.4 347 144 376 144h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80c-119.3 0-216 96.7-216 216v2.2c10.8 4 21.9 6.2 32 6.2 5.4 0 10.7-.5 16-1.6V312c0-46.1 18.5-87.8 48.5-118.1z"
        }
    ]
};

const FarPersonThroughWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonThroughWindow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 48v18.4c0 46.1-28.9 87.3-72.2 103.1C169.5 192.1 128 251.3 128 317.6V400H48V48h256zm48 0h240v352h-81.7L499 385.4l-75.2-97.8c-7.6-9.8-19.3-15.6-31.7-15.6H333l-49.4-75.7c42.1-28.9 68.4-77.2 68.4-130V48zm97.7 352h-83.8l32 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v352c0 26.5 21.5 48 48 48h255.9l36.2 53.5c7.4 11 22.4 13.8 33.3 6.4s13.8-22.4 6.4-33.3l-82.6-122.1 46.4-32.5h44.6l61.5 80zm-178.3 0H176v-82.4c0-15.7 3.3-30.8 9.4-44.5l86 126.9zm-1.1-87.3-54.1-79.9c7.3-6 15.4-11 24.2-15l51.9 79.6-22 15.4zM192 128a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarPersonToDoor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonToDoor",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8.5c-13.3 3.3-25.6 9.7-35.9 18.6l-44.5 38.1c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5-34.1 109.6c-4 12.7 3.1 26.1 15.7 30.1s26.1-3.1 30.1-15.8L307 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.2 23.5 28.9 39.5 53.5 39.5H392c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48.4c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L225 169l27.1 6.8zM122.5 317.1 103.4 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h84.9c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6zM528 48v416h-96V303.2c-10.2 10.4-24.3 16.8-40 16.8-2.7 0-5.4-.2-8-.6V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v160.6c2.6-.4 5.3-.6 8-.6 15.7 0 29.8 6.4 40 16.8V48h96z"
        }
    ]
};

const FarPersonToPortal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonToPortal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8.5c-13.3 3.3-25.6 9.7-35.9 18.6l-44.5 38.1c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5-34.1 109.6c-4 12.7 3.1 26.1 15.7 30.1s26.1-3.1 30.1-15.8L307 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.2 23.5 28.9 39.5 53.5 39.5H392c13.3 0 24-10.7 24-24s-10.7-24-24-24h-23.9c1.2-82.9 11.4-134.5 24.1-164 12.4-28.7 22.4-28.1 23.7-28h.2c1.3-.1 11.3-.7 23.7 28 13.5 31.4 24.2 87.7 24.2 180s-10.7 148.6-24.2 180c-12.4 28.7-22.4 28.1-23.7 28h-.2c-1.3.1-11.3.7-23.7-28-10.1-23.4-18.6-60.5-22.2-116h-48.1c8.8 140.7 47.6 192 94.1 192 53 0 96-66.6 96-256S469 0 416 0c-46.2 0-84.8 50.6-93.9 189.1l-5.8-18.9c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L225 169l27.1 6.8zM122.5 317.1 103.4 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h84.9c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6z"
        }
    ]
};

const FarPersonWalkingArrowLoopLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonWalkingArrowLoopLeft",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-66.2 170.6 29.9-89.8c7.7 1.2 15 3.6 21.7 7.1-.1.3-.2.7-.3 1l-32.4 103.7-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6 28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3l29 29.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1c-14.3-50.6-60.5-85.4-113.1-85.4h-4.9c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217L10 238.3c-5.4 12.1.1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3c10.9-24.5 30.9-43.6 55.6-53.4l-22.8 68.3c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21-24.2 60.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM447 449c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-39-39H484c86.2 0 156-69.8 156-156s-69.8-156-156-156L344 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h140c59.6 0 108 48.4 108 108s-48.4 108-108 108h-42.1l39-39c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9l80 80z"
        }
    ]
};

const FarPersonWalkingArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonWalkingArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-66.2 170.6 29.9-89.8c7.7 1.2 15 3.6 21.7 7.1-.1.3-.2.7-.3 1l-32.4 103.7-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6 28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3l29 29.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1c-14.3-50.6-60.5-85.4-113.1-85.4h-4.9c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217L10 238.3c-5.4 12.1.1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3c10.9-24.5 30.9-43.6 55.6-53.4l-22.8 68.3c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21-24.2 60.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM553 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H392c-13.3 0-24 10.7-24 24s10.7 24 24 24h166.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"
        }
    ]
};

const FarPersonWalkingDashedLineArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonWalkingDashedLineArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-66.2 170.6 29.9-89.8c7.7 1.2 15 3.6 21.7 7.1-.1.3-.2.7-.3 1l-32.4 103.7-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6 28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3l29 29.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1c-14.3-50.6-60.5-85.4-113.1-85.4h-4.9c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217L10 238.3c-5.4 12.1.1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3c10.9-24.5 30.9-43.6 55.6-53.4l-22.8 68.3c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21-24.2 60.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM416 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V24zm137 135c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H392c-13.3 0-24 10.7-24 24s10.7 24 24 24h166.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80zm-161-31c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16c0-13.3-10.7-24-24-24zm24 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16zm-24 72c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarPersonWalkingLuggage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonWalkingLuggage",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-66.2 170.6 29.9-89.8c7.7 1.2 15 3.6 21.7 7.1-.1.3-.2.7-.3 1l-32.4 103.7-16.3-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6 28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3l29 29.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1c-14.3-50.6-60.5-85.4-113.1-85.4h-4.9c-16.1 0-32.1 2.6-47.4 7.7-39.9 13.3-72.4 42.8-89.5 81.3l-9.5 21.3c-5.4 12.1.1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3c10.9-24.4 30.9-43.5 55.6-53.3l-22.8 68.3c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L488.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21-24.1 60.4L231 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zm-75.7-52c-7.6-4.4-17.4-1.8-21.9 5.8L203 335.9 147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c.6-1 1.1-1.9 1.5-2.9l37.5-64.8c4.4-7.6 1.8-17.4-5.8-21.9z"
        }
    ]
};

const FarPersonWalkingWithCane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonWalkingWithCane",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-14.4 32c-34.8 0-66.3 20.5-80.4 52.3l-47.1 106c-5.4 12.1.1 26.3 12.2 31.7s26.3-.1 31.7-12.2l42-94.7v68.7c0 17.8 8.5 34.6 22.9 45.2l97.1 71.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-95.9c0-12.7-6.1-24.7-16.3-32.3L240 336.6V207.3l68 102c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-77-115.5c-16.3-24.5-43.8-39.2-73.2-39.2h-36.2zm6.4 151.8V176h24v125.4l-20.7-15.2c-2.1-1.5-3.3-3.9-3.3-6.5zm175.4 70.1 107.4 155.2c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L370.4 332.6c-3.2 3.7-7 7.1-11.3 10-5 3.3-10.3 5.7-15.7 7.3zM96.7 482.4c-3.1 12.9 4.8 25.8 17.7 28.9s25.8-4.8 28.9-17.7l26.3-109.4-42-30.8-31 129z"
        }
    ]
};

const FarPersonWalking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPersonWalking",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm11.7 128.8-29.9 89.8c-1.1 3.2 0 6.6 2.5 8.7l16.4 13.3 32.4-103.8c.1-.3.2-.7.3-1-6.7-3.5-14-5.9-21.7-7.1zm57.6 53.1-28.5 91.3 50.1 40.7c6.9 5.6 11.7 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L114 312.6c-18-14.7-25.1-39.1-17.8-61.2l22.8-68.3c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2S4.6 250.3 10 238.2l9.5-21.2c17.1-38.5 49.6-68 89.5-81.3 15.3-5.1 31.3-7.7 47.4-7.7h4.9c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L313 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-29.1-29c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7zM75.5 402.5l24.1-60.4 39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5z"
        }
    ]
};

const FarPerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPerson",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1h-27.4c-.8 0-1.5 0-2.3.1zm0 175.9v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6l-43.1 76.2c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l58.6-103.5c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7l58.5 103.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32z"
        }
    ]
};

const FarPesetaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPesetaSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.9 32C68.6 32 48 52.6 48 77.9V176H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v232c0 13.3 10.7 24 24 24s24-10.7 24-24V352h96c77.4 0 142-55 156.8-128H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8.8C343.2 95.1 275 32 192 32H93.9zm209 144H96V80h96c56.4 0 103.1 41.7 110.9 96zM96 224h203.4c-13.8 46.3-56.6 80-107.4 80H96v-80z"
        }
    ]
};

const FarPesoSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPesoSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.6 32C68.4 32 48 52.4 48 77.6V128H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v184c0 13.3 10.7 24 24 24s24-10.7 24-24v-88h88c67 0 124.9-39.2 151.8-96H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-9.7c1.1-7.8 1.7-15.9 1.7-24s-.6-16.2-1.7-24h9.7c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24.2C308.9 71.2 251 32 184 32H93.6zM280 128H96V80h88c39.3 0 74.1 18.9 96 48zM96 176h205.6c1.6 7.8 2.4 15.8 2.4 24s-.8 16.2-2.4 24H96v-48zm184 96c-21.9 29.1-56.7 48-96 48H96v-48h184z"
        }
    ]
};

const FarPhoneArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneArrowDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.2-.4h-.1c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zm133.8 78.1-100.4-43-29.4 35.8c-14.9 18.2-40.8 22.9-61.2 11.1-53.3-30.9-97.7-75.3-128.6-128.6-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4-99.1 21.4c3.4 215.7 177.7 390 393.4 393.5l21.3-99.2zM505 41 370 176h54c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24v54.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarPhoneArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.2-.4h-.1c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zm133.8 78.1-100.4-43-29.4 35.8c-14.9 18.2-40.8 22.9-61.2 11.1-53.3-30.9-97.7-75.3-128.6-128.6-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4-99.1 21.4c3.4 215.7 177.7 390 393.4 393.5l21.3-99.2zM425 7l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h118.1L391 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FarPhoneArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M295 183 430 48h-54c-13.3 0-24-10.7-24-24s10.7-24 24-24h112c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9L329 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm34 103.6c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.2-.4h-.1c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zm133.8 78.1-100.4-43-29.4 35.9c-14.9 18.2-40.8 22.9-61.2 11.1-53.3-30.9-97.7-75.3-128.6-128.6-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4-99.1 21.4c3.4 215.7 177.7 390 393.4 393.5l21.3-99.2z"
        }
    ]
};

const FarPhoneFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136.2 275.2c16.4-7 35.4-2.4 46.7 11.4l33.2 40.6c46-26.7 84.4-65.1 111.1-111.1L286.7 183c-13.8-11.3-18.5-30.3-11.4-46.7l48-112C330.8 6.7 349.7-3.1 368.4.9l112 24C498.8 28.8 512 45.1 512 64c0 231.2-175.2 421.5-400.1 445.5-9.8 1-19.7 1.8-29.6 2.2h-.1c-6.1.2-12.1.4-18.3.4-18.9 0-35.2-13.2-39.1-31.6l-24-112c-4-18.7 5.8-37.6 23.4-45.1l112-48zM70.5 464c215.8-3.5 390-177.8 393.5-393.5l-99.2-21.3-43 100.4 35.8 29.4c18.2 14.9 22.9 40.8 11.1 61.2-30.9 53.3-75.3 97.7-128.6 128.6-20.4 11.8-46.3 7.1-61.2-11.1l-29.4-35.9-100.4 43L70.5 464zM464 64"
        }
    ]
};

const FarPhoneHangup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneHangup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 144c-126.9 0-221.3 61.9-266.7 106.2-4.6 4.5-6.6 12.9-2.1 21.8l36.1 71.5c1.6 3.2 5.2 4.9 8.7 4.2l102.4-20.3c3.7-.7 6.4-4 6.4-7.8v-71.1c0-10.4 6.6-19.5 16.5-22.8l3.4-1.1c61.9-20.4 128.7-20.4 190.7 0l3.4 1.1c9.8 3.2 16.5 12.4 16.5 22.8v71.1c0 3.8 2.7 7.1 6.4 7.8L544 347.7c3.5.7 7.1-1 8.7-4.2l36.1-71.5c4.5-8.9 2.6-17.3-2.1-21.8C541.3 205.9 446.9 144 320 144zM19.8 215.8C71.5 165.4 177.4 96 320 96s248.5 69.4 300.2 119.8c22 21.5 23.8 53.4 11.4 77.8l-36.1 71.5c-11.3 22.4-36.2 34.6-60.9 29.7l-102.3-20.3c-26.2-5.2-45.1-28.2-45.1-54.9v-53.4c-44-12-90.4-12-134.4 0v53.4c0 26.7-18.9 49.7-45.1 54.9l-102.4 20.3c-24.7 4.9-49.6-7.3-60.9-29.7L8.3 293.6C-4 269.2-2.3 237.3 19.8 215.8z"
        }
    ]
};

const FarPhoneIntercom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneIntercom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h48zm0 400c15.1 0 29-5.3 40-14 11 8.8 24.9 14 40 14h256c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H192c-15.1 0-29 5.3-40 14-11-8.8-24.9-14-40-14H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h48zm64-64V96c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16zm80-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm-96-256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H240z"
        }
    ]
};

const FarPhoneMissed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneMissed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 0h112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-54.1l55.4 55.4c20.9 20.9 49.2 32.6 78.7 32.6s57.8-11.7 78.6-32.6L487 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96.4 96.4C394.7 167.2 354.2 184 312 184s-82.7-16.8-112.6-46.6L144 81.9V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zm328 392v49.3c0 3.9 2.8 7.2 6.6 7.9l85.8 15.6c3.7.7 7.4-1.3 8.8-4.8l24.7-58.8c7.4-17.6 2.5-30.9-4.4-36.9C520 321.8 432.8 272 320 272s-200 49.8-249.5 92.3c-6.9 5.9-11.8 19.3-4.4 36.9L90.8 460c1.5 3.5 5.1 5.4 8.8 4.8l85.8-15.6c3.8-.7 6.6-4 6.6-7.9V392c0-19.6 11.9-37.3 30.2-44.6 62.8-25.1 132.9-25.1 195.7 0 18.1 7.3 30.1 25 30.1 44.6zm-48 49.3V392c-51.4-20.5-108.6-20.5-160 0v49.3c0 27.1-19.4 50.3-46 55.1L108.2 512c-25.8 4.7-51.4-9.2-61.6-33.4l-24.8-58.8c-13.5-32-8.9-69.3 17.4-91.9C95 280 192.9 224 320 224s225 56 280.8 103.9c26.3 22.6 30.9 59.9 17.4 91.9l-24.8 58.8c-10.2 24.2-35.8 38.1-61.6 33.4L446 496.4c-26.6-4.8-46-28-46-55.1z"
        }
    ]
};

const FarPhoneOffice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneOffice",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16h-48zm-55.4-16c11-19.1 31.7-32 55.4-32h48c23.7 0 44.4 12.9 55.4 32H512c35.3 0 64 28.7 64 64v352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h40.6zM96 80H64c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V192H360c-22.1 0-40-17.9-40-40V80h-48v272c0 35.3-28.7 64-64 64h-48c-35.3 0-64-28.7-64-64V80zm272 0v64h160V96c0-8.8-7.2-16-16-16H368zm16 192a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-128a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FarPhonePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhonePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 200v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V24c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24zm-63 86.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.2-.4h-.1c-10-.4-19.8-1.1-29.6-2.2C239.2 485.6 64 295.2 64 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zm133.8 78.1-100.4-43-29.4 35.8c-14.9 18.2-40.8 22.9-61.2 11.1-53.3-30.9-97.7-75.3-128.6-128.6-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4-99.1 21.4c3.4 215.7 177.7 390 393.4 393.5l21.3-99.2z"
        }
    ]
};

const FarPhoneRotary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneRotary",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 176v-34.7c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1V176c0 17.7-14.3 32-32 32h-42.3c-13.1 0-24.9-8-29.7-20.1l-19.4-48.6c-2.9-7.3-8.4-13.2-15.7-16-18.6-7-59.5-19.3-116.8-19.3s-98.2 12.3-116.8 19.3c-7.3 2.8-12.8 8.7-15.7 16L104 187.9C99.2 200 87.4 208 74.3 208H32c-17.7 0-32-14.3-32-32zm80 225v31h352v-31c0-2.8-.7-5.5-2.1-7.9l-101.1-177c-2.8-5-8.2-8.1-13.9-8.1H197.1c-5.7 0-11 3.1-13.9 8.1l-101.1 177c-1.4 2.4-2.1 5.2-2.1 7.9zm61.6-208.7c11.4-20 32.6-32.3 55.5-32.3h117.8c23 0 44.2 12.3 55.6 32.2l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8v31c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-31c0-11.1 2.9-22.1 8.4-31.8l101.1-177zM256 256a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarPhoneSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M601.2 5.1c10.4-8.2 25.5-6.3 33.7 4.1s6.3 25.5-4.1 33.7l-592 464c-10.4 8.2-25.5 6.3-33.7-4.1s-6.3-25.5 4.1-33.7l155.6-122C101.8 270 64 171.4 64 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c8.6 14.9 18.5 29 29.4 42.1L601.2 5.1zM240.4 287.9C228.1 273 217 257 207.2 240.2c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L112 70.5c1.5 93.7 35.2 179.6 90.5 247.1l37.8-29.6zm199.4-12.7 112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.2 31.6-39.1 31.6-6.1 0-12.2-.1-18.3-.4h-.1c-10-.4-19.8-1.1-29.6-2.2-86.2-9.2-165.2-42.8-229.7-93.9l38.8-30.4c65 48.5 145.3 77.6 232.3 79l21.3-99.2-100.4-43-29.4 35.8c-14.9 18.2-40.8 22.9-61.2 11.1-8-4.6-15.7-9.5-23.3-14.7l39.8-31.3c2.5 1.5 5 3.1 7.6 4.5l24.1-29.5 31.4-24.7c7.9-1.7 16.4-1.1 24.3 2.3z"
        }
    ]
};

const FarPhoneVolume = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneVolume",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 0c128.1 0 232 103.9 232 232 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24 75.1 0 136 60.9 136 136 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88-13.3 0-24-10.7-24-24zm73 166.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.2-.4h-.1c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zm133.8 78.1-100.4-43-29.4 35.8c-14.9 18.2-40.8 22.9-61.2 11.1-53.3-30.9-97.7-75.3-128.6-128.6-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4-99.1 21.4c3.4 215.7 177.7 390 393.4 393.5l21.3-99.2z"
        }
    ]
};

const FarPhoneXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhoneXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M393 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.2-.4h-.1c-10-.4-19.8-1.1-29.6-2.2C239.2 485.6 64 295.2 64 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zm133.8 78.1-100.4-43-29.4 35.8c-14.9 18.2-40.8 22.9-61.2 11.1-53.3-30.9-97.7-75.3-128.6-128.6-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4-99.1 21.4c3.4 215.7 177.7 390 393.4 393.5l21.3-99.2zM407 7c9.4-9.4 24.6-9.4 33.9 0l47 47L535 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L407 41c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarPhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1l40.5-33.1c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6.9l-112 24C13.2 28.8 0 45.1 0 64c0 231.2 175.2 421.6 400.1 445.5 9.8 1 19.6 1.8 29.6 2.2h.1c6.1.2 12.1.4 18.2.4 18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464c-215.7-3.5-390-177.8-393.4-393.5l99.2-21.3 43 100.4-35.9 29.4c-18.2 14.9-22.9 40.8-11.1 61.2 30.9 53.3 75.3 97.7 128.6 128.6 20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43-21.4 99.2zM48 64"
        }
    ]
};

const FarPhotoFilmMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhotoFilmMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 48H256c-8.8 0-16 7.2-16 16v192c0 8.7 6.9 15.8 15.6 16l69.1-94.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8l16.5 22.6 56-85.6c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9l30.5 46.7L406.3 195c-22.9 7.6-38.3 29-38.3 53.1V320H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-6.3 2.1V64c0-8.8-7.2-16-16-16zM289.9 448H64c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64h96v288h166.3c-2.3 1.4-4.6 3-6.7 4.6-13.8 10.3-25.2 25.2-29.6 43.4zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 208v-48H64c-8.8 0-16 7.2-16 16v32h64zm0 144H48v32c0 8.8 7.2 16 16 16h48v-48zm0-48v-48H48v48h64zm518-139.5c6.3 4.5 10 11.8 10 19.5v208c0 1.2-.1 2.4-.3 3.6.2 1.5.3 2.9.3 4.4 0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5v-88.2l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5V248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"
        }
    ]
};

const FarPhotoFilm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPhotoFilm",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48c-8.8 0-16 7.2-16 16v224c0 8.7 6.9 15.8 15.6 16l69.1-94.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8l16.5 22.6 56-85.6c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9l102.5 157c7.6-1.3 13.3-7.9 13.3-15.8V64c0-8.8-7.2-16-16-16H256zm-64 16c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zm-56 64h24v336h192v-80h48v80h48c8.8 0 16-7.2 16-16v-64h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h72zm-24 48H64c-8.8 0-16 7.2-16 16v48h64v-64zm0 288v-64H48v48c0 8.8 7.2 16 16 16h48zM48 352h64v-64H48v64zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarPi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPi",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24h88v165.4c0 44.9-11.4 89-33.2 128.2l-3.8 6.7c-6.4 11.6-2.3 26.2 9.3 32.6s26.2 2.3 32.6-9.3l3.8-6.8c25.8-46.4 39.3-98.5 39.3-151.5V112h144v262.6c0 40.6 32.9 73.4 73.4 73.4 27.8 0 53.2-15.7 65.7-40.6l2.3-4.7c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7l-2.3 4.7c-4.3 8.6-13.1 14.1-22.8 14.1-14.1 0-25.4-11.4-25.4-25.4V112h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarPianoKeyboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPianoKeyboard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 224v160c0 8.8-7.2 16-16 16h-80v-84.3c9.6-5.5 16-15.9 16-27.7v-64h80zM400 400h-96v-84.3c9.6-5.5 16-15.9 16-27.7v-64h64v64c0 11.8 6.4 22.2 16 27.7V400zm-128 0h-96v-84.3c9.6-5.5 16-15.9 16-27.7v-64h64v64c0 11.8 6.4 22.2 16 27.7V400zm-128 0H64c-8.8 0-16-7.2-16-16V224h80v64c0 11.8 6.4 22.2 16 27.7V400zm384-224H48v-48c0-8.8 7.2-16 16-16h448c8.8 0 16 7.2 16 16v48zm48 0v-48c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V176z"
        }
    ]
};

const FarPiano = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPiano",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-96v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32H48v64c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16v-64h-32zM48 336h416v-8.4c0-6.1-3.4-11.6-8.8-14.3L396.8 284c-37.2-18.6-60.8-56.7-60.8-98.3 0-76-61.7-137.7-137.7-137.7H192c-79.5 0-144 64.5-144 144v144zm464-8.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192C0 86 86 0 192 0h6.3C300.8 0 384 83.2 384 185.7c0 23.5 13.2 44.9 34.2 55.4l58.4 29.2c21.7 10.8 35.4 33 35.4 57.2z"
        }
    ]
};

const FarPickaxe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPickaxe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M460.3 112.6c47.6 66.4 63.4 152.5 42 231.5-.3.9-.5 1.9-.8 2.8-1.3 4.4-2.6 8.9-4.1 13.2l-.2.6c-1.5 4.5-3.2 8.9-5 13.3-5.4 13.3-24.9 13-29.8-.5-1.8-4.6-3.6-9.3-5.6-13.9-1.6-3.7-3.2-7.4-4.9-11.1l-.8-1.7c-28.4-62.2-70.9-119.9-118.5-167.6-47.3-47.3-105.1-90.3-167.3-118.4l-1.7-.8c-3.7-1.7-7.5-3.3-11.3-4.9-4.6-1.9-9.2-3.7-13.8-5.5-13.4-5-13.7-24.5-.5-29.8 4.4-1.8 8.8-3.4 13.3-5l.2-.1c4.5-1.5 9-2.9 13.5-4.2 1-.3 2-.5 2.9-.8 78.9-21.3 165-5.5 231.3 42.1l9.5-9.9c6-6.2 14.2-9.7 22.8-9.8s16.9 3.3 22.9 9.4l16 16c6.1 6.1 9.5 14.3 9.4 22.9s-3.6 16.8-9.8 22.8l-9.9 9.5zm-62.2.7C357 72.3 301 49.8 244.2 48.4c45.4 27.7 86.9 61.4 122.4 97 35.9 35.9 69.4 77.5 97 122.8-1.3-57.2-24.1-113.6-65.5-154.8zM8.9 457.8l272-282.9c9.7 8.4 19.5 17.4 29.1 27s18.6 19.4 27 29.1L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4s-12.5-32.3-.5-44.9z"
        }
    ]
};

const FarPickleball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPickleball",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M284.3 61.9c18.8-18.7 49.2-18.7 68 0l113.6 113.3c14.8 14.8 17.9 36.9 9.3 54.7 15.7 4.4 30.4 11.1 43.8 19.8 16.6-35.5 10.3-79.1-19.1-108.4L386.3 28c-37.5-37.4-98.4-37.4-135.9 0L92.5 185.5c-22.9 22.9-29.8 57.3-17.3 87.2l18.3 43.8c5 12 2.2 25.7-6.9 34.9l-51.8 51.5c-25 24.9-25 65.4 0 90.4s65.6 25 90.7 0l52-51.8c9.1-9.1 22.9-11.8 34.8-7l42.5 17.4c11.4 4.7 23.4 6.6 35.2 5.8-8-15.3-13.6-32.1-16.2-49.9-.3-.1-.5-.2-.8-.3l-42.5-17.4c-29.9-12.2-64.2-5.4-87.1 17.4l-52 51.8c-6.3 6.2-16.4 6.2-22.7 0-6.3-6.2-6.2-16.3 0-22.6l51.7-51.5c23-22.9 29.8-57.3 17.3-87.2l-18.3-43.8c-4.5-10.9-2.7-23.3 4.6-32.3l148.4 148c1.7-19 6.6-37 14.3-53.5L158 187.9l126.3-126zM560 384a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-192-16a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm48 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm32-96a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm64 32a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48-112a16 16 0 1 1-32 0 16 16 0 1 1 32 0z"
        }
    ]
};

const FarPie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPie",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 240c-7.6 0-14.3-4.9-17-12-37-95.9-130-164-239-164S86 132.1 49 228c-2.7 7.1-9.4 12-17 12-17.7 0-32 14.3-32 32 0 17.2 13.6 31.3 30.7 32 17.7-.5 35-7 48.7-14.2 7-3.6 12.7-7.3 16.7-10 2-1.4 3.5-2.5 4.5-3.2.5-.4.9-.7 1.1-.8l.2-.2 20.7.4.2.1c.2.2.5.4.9.8.9.7 2.2 1.8 4.1 3.1 3.7 2.6 9.1 6.2 16.1 9.8 14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8 1.8-1.3 3.2-2.4 4.1-3.1.4-.4.7-.6.9-.8l.1-.1c6.1-5.4 15.2-5.4 21.2 0l.1.1c.2.2.5.4.9.8.9.7 2.2 1.8 4.1 3.1 3.7 2.6 9.1 6.2 16.1 9.8 14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8 1.8-1.3 3.2-2.4 4.1-3.1.4-.4.7-.6.9-.8l.1-.1c5.9-5.2 14.6-5.4 20.7-.4l.2.2c.2.2.6.5 1.1.8 1 .7 2.5 1.9 4.5 3.2 4 2.7 9.7 6.4 16.7 10C510 297 527.4 303.5 545 304c17.1-.7 30.7-14.7 30.7-32 0-17.7-14.3-32-32-32zm-421.4 36c-5.9-5.2-14.6-5.4-20.7-.4l20.7.4zM81.4 404.2c8.7 26.1 33.2 43.8 60.7 43.8h291.8c27.5 0 52-17.6 60.7-43.8l24-71.9c-14.2-3.5-26.8-9-36.8-14.2-2.7-1.4-5.3-2.8-7.6-4.2l-25 75.1c-2.2 6.5-8.3 10.9-15.2 10.9H142.1c-6.9 0-13-4.4-15.2-10.9l-25-75.1c-2.4 1.4-4.9 2.8-7.6 4.2-10 5.2-22.7 10.7-36.8 14.2l24 71.9zm124.9-253-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zm192-14.3 16 32c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2zM304 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarPig = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPig",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M475 32c-4 0-7.9.5-11.8 1.5L417.1 45c-21.1 5.3-38.6 18-50.2 35H240c-77.4 0-142 55-156.8 128H47.4c-8.5 0-15.4-6.9-15.4-15.4 0-7.1 4.8-13.3 11.7-15l8.2-2c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-8.2 2C14.8 151.8 0 170.8 0 192.6 0 218.8 21.2 240 47.4 240H80v16c0 55.8 31.8 104.2 78.1 128.1l22.3 68.3c5.4 16.5 20.7 27.6 38 27.6H264c22.1 0 40-17.9 40-40v-24h48v24c0 22.1 17.9 40 40 40h45.5c17.3 0 32.7-11.1 38-27.6l13.7-42.1c26.1-7.5 49.6-22.2 67.8-42.4h35c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48h-8.7c-6.7-4.7-12.5-10.5-17.2-17.3 21-14.9 33.9-39.3 33.9-65.6C600 93 587 80 570.9 80H552v29.1c0 12.2-6.9 23.4-17.8 28.9-4.1-3.8-8.4-7.4-12.7-10.8 4.2-10.3 6.5-21.5 6.5-33.2V82.3c0-27.8-22.5-50.3-50.3-50.3H475zm-.1 48h2.7c1.3 0 2.3 1 2.3 2.3V94c0 9.4-3.3 18.2-8.9 25.1-4.3 5.3-6.1 12.2-5 19s5.1 12.7 10.9 16.4c19.3 12.2 36.3 28.2 49.7 47.6 8.8 12.8 20.1 23.6 33.1 31.9 6.7 4.3 14.1 6 20.9 6H592v80h-38.2c-12.8 0-23.8 6.1-31.1 14.5-14.5 16.7-34.3 28.1-56.3 32-8.7 1.6-15.8 7.8-18.6 16.2L431.7 432H400v-40c0-13.3-10.7-24-24-24h-96c-13.3 0-24 10.7-24 24v40h-31.7l-23.7-72.7c-2.2-6.6-7.1-12-13.6-14.7-34.7-14.5-59-48.8-59-88.6v-16c0-61.9 50.1-112 112-112h141c9.6 0 18.3-5.7 22.1-14.5 4.6-10.7 13.9-19 25.7-21.9L474.9 80zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"
        }
    ]
};

const FarPiggyBank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPiggyBank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.1 48c23 0 42.5 14.7 49.8 35.2 4.4 12.5 18.1 19 30.6 14.6s19-18.1 14.6-30.6C358.3 28.1 321 0 277.1 0S195.8 28.1 182 67.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6c7.3-20.5 26.9-35.2 49.9-35.2zM66.7 197.5c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-4.7 2.3C15.7 169.3 0 194.7 0 222.6c0 37.4 28 68.3 64.2 72.9C66.4 344.7 91 388.2 128 416v48c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48v-16h48v16c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48v-37.4c18.7-10.8 35.1-25.4 48-42.6h32c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32h-13.3c-8.2-18.8-19.9-35.7-34.2-49.8l11.3-36.8-22.9-7 22.9 7c6.3-20.6-9.1-41.4-30.6-41.4H456c-31.5 0-60.2 12.2-81.6 32H224c-74.4 0-137 50.8-154.9 119.6-12-2-21.1-12.5-21.1-25.1 0-9.6 5.4-18.4 14.1-22.8l4.7-2.3zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-21.7-120c13.1-14.7 32.1-23.9 53.2-24l-9.5 30.8c-2.9 9.4.2 19.6 7.9 25.8 17.4 13.9 30.4 32.8 37.1 54.5 3.1 10.1 12.4 17 22.9 17h14v64h-28.5c-8.3 0-16 4.3-20.3 11.3-11.7 18.7-28.7 33.7-48.9 42.8-8.7 3.8-14.2 12.3-14.2 21.8v52h-48v-40c0-13.3-10.7-24-24-24h-96c-13.3 0-24 10.7-24 24v40h-48v-60.6c0-8.3-4.3-16-11.3-20.3-31.7-19.8-52.7-55-52.7-95 0-61.9 50.1-112 112-112h160.4c6.8 0 13.4-2.9 17.9-8z"
        }
    ]
};

const FarPills = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPills",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 80c35.3 0 64 28.7 64 64v112H48V144c0-35.3 28.7-64 64-64zM0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm416 288c-61.9 0-112-50.1-112-112 0-22.2 6.5-43 17.7-60.4l154.7 154.7C459 425.5 438.2 432 416 432zm-60.4-206.3C373 214.5 393.8 208 416 208c61.9 0 112 50.1 112 112 0 22.2-6.5 43-17.7 60.4L355.6 225.7zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z"
        }
    ]
};

const FarPinata = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPinata",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H84.4C37.8 48 0 85.8 0 132.4c0 36.3 23.3 68.6 57.7 80.1L96 225.3V440c0 39.8 32.2 72 72 72h22.4c36.2 0 65.6-29.4 65.6-65.6 0-21.2 17.2-38.4 38.4-38.4h19.2c21.2 0 38.4 17.2 38.4 38.4 0 36.2 29.4 65.6 65.6 65.6H440c39.8 0 72-32.2 72-72V328c0-57.4-46.6-104-104-104H272V24zM84.4 96H224v125.2l-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-11.4 4.6v-4.8c0-17.2-11-32.5-27.4-37.9L72.9 167C58 162 48 148.1 48 132.4 48 112.3 64.3 96 84.4 96zm128.2 164.2 17.5-7c7.1 11.3 19.6 18.8 33.9 18.8h144c20.2 0 37.8 10.7 47.7 26.7-6.7-1.8-13.8-1.4-20.3 1.2l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-3.4 1.4v-42.5l23.3-9.3 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1zM144 335.6l15.3-6.1 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 16.7 8.4v54.5l-11.4-4.6c-8.5-3.4-18-3-26.2 1.1l-19.1 9.6-32.3-12.9c-15.7-15.8-37.3-25.5-61.3-25.5h-19.3c-24 0-45.7 9.8-61.3 25.5l-32.3 12.9-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-11.5 4.6v-56.8zm0 91.2 23.3-9.3 19.1 9.6c7.3 3.6 15.6 4.3 23.3 2.1-1.1 5.6-1.7 11.3-1.7 17.2 0 9.7-7.9 17.6-17.6 17.6H168c-13.3 0-24-10.7-24-24v-13.2zm296.7-9.3 23.3 9.3V440c0 13.3-10.7 24-24 24h-22.4c-9.7 0-17.6-7.9-17.6-17.6 0-5.9-.6-11.6-1.7-17.2 7.7 2.3 16 1.5 23.3-2.1l19.1-9.6zM176 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarPinball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPinball",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-40 376L126.8 251.2c-20.3-17-50.5-14.3-67.6 6s-14.4 50.6 6 67.7c4.5 3.8 9.8 6.8 15.9 8.8h.1L312 408zM66.3 379.3c-12.1-3.9-22.8-10-32-17.7-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3c12.6 9.8 15.8 27.1 8.4 40.6-7.2 13.2-23.1 19.9-37.9 15L66.3 379.3zM96 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarPineapple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPineapple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M423.1 1.7c4.2 2.1 7.3 5.9 8.4 10.5l3.6 14.3C447 19.6 460.6 16 474.5 16h5.5c8.8 0 16 7.2 16 16v5.5c0 13.9-3.6 27.5-10.4 39.4l14.3 3.6c4.6 1.1 8.4 4.2 10.5 8.4s2.2 9.1.4 13.4c-6.8 15.9-19.5 26.7-34.1 31.6l14.7 14.7c6.2 6.2 6.2 16.4 0 22.6-15.4 15.4-35.3 23.6-55.5 24.5 8 18.9 12.2 39.3 12.2 60.2 0 41-16.3 80.3-45.3 109.3L301.3 466.7c-29 29-68.3 45.3-109.3 45.3s-80.3-16.3-109.3-45.3l-37.4-37.4 33.9-33.9 37.5 37.5c20 20 47.1 31.2 75.3 31.2s55.3-11.2 75.3-31.2l101.5-101.6c20-20 31.2-47.1 31.2-75.3s-11.2-55.3-31.2-75.3l-37.5-37.5c-20-20-47.1-31.2-75.3-31.2s-55.3 11.2-75.3 31.2L79.2 244.7c-20 20-31.2 47.1-31.2 75.3s11.2 55.3 31.2 75.3l-33.9 34C16.3 400.3 0 361 0 320s16.3-80.3 45.3-109.3l101.4-101.4C175.7 80.3 215 64 256 64c20.9 0 41.3 4.2 60.2 12.2.9-20.2 9.1-40.1 24.5-55.5 6.2-6.2 16.4-6.2 22.6 0L378 35.4c5-14.6 15.8-27.3 31.7-34.1 4.3-1.8 9.2-1.7 13.4.4zm-235.8 211 20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80 20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l20.7 20.7zm-123.3 59.3c6.2-6.2 16.4-6.2 22.6 0l20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FarPipeCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPipeCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 96c13.3 0 24 10.7 24 24v8h416v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v72.7c-5.3-.5-10.6-.7-16-.7-10.9 0-21.6 1-32 2.9V176H48v160h274.9c-1.9 10.4-2.9 21.1-2.9 32 0 5.4.2 10.7.7 16H48v8c0 13.3-10.7 24-24 24S0 405.3 0 392V120c0-13.3 10.7-24 24-24zm328 272a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm188.7-43.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FarPipeCollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPipeCollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M109.3 18.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L35.4 126C12.9 164.1 0 208.5 0 256s12.9 91.9 35.4 130l-16.7 16.7c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l16.8-16.6c38.1 22.5 82.6 35.4 130 35.4s91.9-12.9 130-35.4l16.7 16.7c25 25 65.5 25 90.5 0s25-65.5 0-90.5L476.6 386c22.5-38.1 35.4-82.6 35.4-130s-12.9-91.9-35.4-130l16.7-16.7c25-25 25-65.5 0-90.5s-65.5-25-90.5 0L386 35.4C347.9 12.9 303.5 0 256 0s-91.9 12.9-130 35.4l-16.7-16.7zM48 256a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm208-112a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM48 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm0 384a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm400-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarPipeSection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPipeSection",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v272c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h544v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H48v-8zm0 56h544v160H48V176z"
        }
    ]
};

const FarPipeSmoking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPipeSmoking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M586.8 48c-36.4 0-70.1 19-89 50.2l-85.7 141.6c13 16 14.6 39.3 2.4 57.2l-95.8 141.3c-31.3 46.1-83.3 73.7-139 73.7H168C75.2 512 0 436.8 0 344V232c0-30.9 25.1-56 56-56h160c30.9 0 56 25.1 56 56v9.4l23-29.9c12.3-16 32.9-22.2 51.4-16.9l111.2-138C486.4 20.8 529.9 0 575.9 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24h-29.2zM56 224c-4.4 0-8 3.6-8 8v112c0 66.3 53.7 120 120 120h11.7c39.8 0 77-19.7 99.3-52.6l95.9-141.3-41.9-29.3-66 85.8c-6.3 8.1-17 11.4-26.8 8.1s-16.3-12.4-16.3-22.7v-80c0-4.4-3.6-8-8-8H56z"
        }
    ]
};

const FarPipeValve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPipeValve",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v21L128 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l104-13v77H48v-8c0-13.3-10.7-24-24-24S0 170.7 0 184v272c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h416v8c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H280v-77l104 13c17.7 0 32-14.3 32-32s-14.3-32-32-32L280 77V56zM48 400V240h416v160H48z"
        }
    ]
};

const FarPipe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPipe",
    "viewBox": "0 0 64 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0c13.3 0 24 10.7 24 24v464c0 13.3-10.7 24-24 24S8 501.3 8 488V24C8 10.7 18.7 0 32 0z"
        }
    ]
};

const FarPizzaSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPizzaSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M122.2 35.6.5 491.9c-1.5 5.5.1 11.4 4.1 15.4s9.9 5.6 15.4 4.1l456.4-121.6c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7.9c-22.8-1.6-41.9 14-47.5 34.7zM144.6 138C264.3 152.7 359.3 247.7 374 367.4L61.2 450.8 144.6 138zm12.5-46.8 11.3-42.3c157.2 11.8 282.9 137.5 294.7 294.8L420.8 355C401.1 218.8 293.3 111 157.1 91.3zM192 352a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarPizza = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPizza",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M254.2 322.1c-8.4 3.8-14.2 12.2-14.2 21.9 0 13.3 10.7 24 24 24 9.8 0 18.2-5.8 21.9-14.2l32.2 32.2c-18.8 9-39.8 14-62.1 14-79.5 0-144-64.5-144-144s64.5-144 144-144c22.2 0 43.3 5 62.1 14l-84.7 84.7c-25 25-25 65.5 0 90.5l20.8 20.8zm87.6 87.6 23.4 23.4C333.5 452.7 296.1 464 256 464c-114.9 0-208-93.1-208-208S141.1 48 256 48c40.1 0 77.5 11.3 109.2 30.9l-23.4 23.4C316.4 88.1 287.1 80 256 80c-97.2 0-176 78.8-176 176s78.8 176 176 176c31.1 0 60.4-8.1 85.8-22.3zm83.6 38.3c6.6-5.8 6.6-16 .3-22.3L267.3 267.3c-6.2-6.2-6.2-16.4 0-22.6L425.7 86.3c6.3-6.3 6.3-16.4-.3-22.3C380.2 24.2 320.9 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c64.9 0 124.2-24.2 169.4-64zm71.7-82.8-23.4-23.4c14.2-25.4 22.3-54.7 22.3-85.8s-8.1-60.4-22.3-85.8l23.4-23.4C516.7 178.5 528 215.9 528 256s-11.3 77.5-30.9 109.2zM464 256c0 22.2-5 43.3-14 62.1L387.9 256l62.1-62.1c9 18.8 14 39.8 14 62.1zm48 169.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4c-5.8-6.6-16-6.6-22.3-.3L331.3 244.7c-6.2 6.2-6.2 16.4 0 22.6l158.4 158.4c6.2 6.2 16.4 6.3 22.3-.3zM216 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarPlaceOfWorship = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaceOfWorship",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c6.8 0 13.3 2.9 17.8 7.9l67.9 75.4c6.6 7.3 10.3 16.9 10.3 26.8v75.4l38.4 24.9c15.9 10.3 25.6 28 25.6 47V464h88c13.3 0 24-10.7 24-24v-69.9c0-8.1-4.1-15.7-11-20.2l-69-44.7v-57.1l95.1 61.5c20.5 13.3 32.9 36 32.9 60.4v70c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72v-69.9c0-24.4 12.4-47.2 32.9-60.4l95.1-61.6v57.2L59 350c-6.8 4.4-11 12-11 20.2V440c0 13.3 10.7 24 24 24h88V257.4c0-19 9.6-36.7 25.6-47l38.4-24.9v-75.4c0-9.9 3.7-19.4 10.3-26.8l67.9-75.4c4.5-5 11-7.9 17.8-7.9zm-48 113.2v85.4c0 8.1-4.1 15.7-11 20.1l-49.4 32c-2.3 1.5-3.7 4-3.7 6.7V464h64v-96c0-26.5 21.5-48 48-48s48 21.5 48 48v96h64V257.4c0-2.7-1.4-5.2-3.7-6.7l-49.4-32c-6.8-4.4-11-12-11-20.1v-85.4L320 59.9l-48 53.3z"
        }
    ]
};

const FarPlaneArrival = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneArrival",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M552.2 333.2c4.3 4 2.8 11.1-2.8 12.9-26.5 8.8-54.9 9.7-81.9 2.6L141.9 264c-1.2-.3-2.3-.9-3.2-1.7l-87.7-75c-1.8-1.5-2.8-3.7-2.8-6.1L48 94.6l18.2 4.6c2.5.6 4.5 2.4 5.5 4.8l25.9 64.8c2.8 7 8.8 12.3 16.1 14.3l113.9 30.4c8.4 2.2 17.4-.2 23.4-6.5s8.3-15.3 5.8-23.6L216.3 48H242l107.1 190.4c3.2 5.6 8.5 9.8 14.7 11.4l113 30.1c16.3 4.3 31.3 12.6 43.7 24l31.6 29.2zm12.3 58.5c40.3-13.3 51.5-65 20.3-93.8l-31.6-29.2c-18.1-16.7-40-28.8-63.8-35.1L386 206.1 281.5 20.4C274.4 7.8 261.1 0 246.6 0h-41.1c-26.8 0-46 25.8-38.3 51.5l31.4 104.6-60.8-16.2-21.4-53.6c-6.7-16.7-21-29.2-38.4-33.5l-28.3-7.1C24.5 39.4 0 58.5 0 84.6l.2 96.8c0 16.3 7.2 31.8 19.6 42.4l87.7 75c6.4 5.5 14.1 9.5 22.3 11.6l325.5 84.7c35.9 9.4 73.8 8.1 109.1-3.5zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm168-96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarPlaneCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7 9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128v26.2l84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2L299 187.6c-6.9-4.4-11.1-12-11.1-20.2V128c0-13.6-4.2-36.3-12.5-55.2-4.1-9.4-8.5-16.3-12.7-20.6-4-4.1-6.2-4.2-6.8-4.2-.2 0-2.2 0-6.3 4.2-4.2 4.3-8.7 11.3-12.9 20.7-8.4 19-12.8 41.7-12.8 55.1v39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7v29.6l144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4V376c0 7.6-3.6 14.7-9.6 19.2L160 436v23.9c6.8-2.1 15.3-4.6 24.3-7.3 22.6-6.8 49.1-14.8 64.6-19.6 4.6-1.4 9.5-1.4 14.1 0 15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2-6.4 5-14.5 7.9-23.2 7.9-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23h-.2l-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8-19.5-5.9-42-12.6-57.9-17.5-15.9 4.9-38.4 11.6-57.9 17.5-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4.7-.6.2h-.2l-6.9-23 6.9 23c-2.2.7-4.5 1-6.9 1C129 512 112 495 112 474.1V432c0-12.6 5.9-24.4 16-32l48-36v-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1v-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2-12.9-20.2L176 154.2V128c0-20.7 6.1-50 16.9-74.5 5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1 20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2v-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FarPlaneCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7 9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128v26.2l84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2L299 187.6c-6.9-4.4-11.1-12-11.1-20.2V128c0-13.6-4.2-36.3-12.5-55.2-4.1-9.4-8.5-16.3-12.7-20.6-4-4.1-6.2-4.2-6.8-4.2-.2 0-2.2 0-6.3 4.2-4.2 4.3-8.7 11.3-12.9 20.7-8.4 19-12.8 41.7-12.8 55.1v39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7v29.6l144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4V376c0 7.6-3.6 14.7-9.6 19.2L160 436v23.9c6.8-2.1 15.3-4.6 24.3-7.3 22.6-6.8 49.1-14.8 64.6-19.6 4.6-1.4 9.5-1.4 14.1 0 15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2-6.4 5-14.5 7.9-23.2 7.9-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23h-.2l-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8-19.5-5.9-42-12.6-57.9-17.5-15.9 4.9-38.4 11.6-57.9 17.5-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4.7-.6.2h-.2l-6.9-23 6.9 23c-2.2.7-4.5 1-6.9 1C129 512 112 495 112 474.1V432c0-12.6 5.9-24.4 16-32l48-36v-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1v-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2-12.9-20.2L176 154.2V128c0-20.7 6.1-50 16.9-74.5 5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1 20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2v-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarPlaneCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7 9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128v26.2l84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2L299 187.6c-6.9-4.4-11.1-12-11.1-20.2V128c0-13.6-4.2-36.3-12.5-55.2-4.1-9.4-8.5-16.3-12.7-20.6-4-4.1-6.2-4.2-6.8-4.2-.2 0-2.2 0-6.3 4.2-4.2 4.3-8.7 11.3-12.9 20.7-8.4 19-12.8 41.7-12.8 55.1v39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7v29.6l144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4V376c0 7.6-3.6 14.7-9.6 19.2L160 436v23.9c6.8-2.1 15.3-4.6 24.3-7.3 22.6-6.8 49.1-14.8 64.6-19.6 4.6-1.4 9.5-1.4 14.1 0 15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2-6.4 5-14.5 7.9-23.2 7.9-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23h-.2l-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8-19.5-5.9-42-12.6-57.9-17.5-15.9 4.9-38.4 11.6-57.9 17.5-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4.7-.6.2h-.2l-6.9-23 6.9 23c-2.2.7-4.5 1-6.9 1C129 512 112 495 112 474.1V432c0-12.6 5.9-24.4 16-32l48-36v-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1v-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2-12.9-20.2L176 154.2V128c0-20.7 6.1-50 16.9-74.5 5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1 20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2v-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"
        }
    ]
};

const FarPlaneDeparture = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneDeparture",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M154.5 87.6c9.2-3.8 19.4-4.1 28.8-.8l185.7 66c6.3 2.2 13.2 1.7 19.2-1.4l83.1-43.5c14.9-7.8 31.4-11.9 48.3-11.9h50.8c11.2 0 18.6 11.6 13.9 21.8-17.2 36.8-46 67-81.9 85.8L251.8 335.1c-1.1.6-2.4.9-3.7.9H126.7c-2.3 0-4.6-1-6.1-2.8l-66.4-77.5 23-11.5c2.1-1.1 4.6-1.1 6.8-.2l58.2 25.9c6.7 3 14.4 2.7 20.9-.7l88.1-46.2c7.6-4 12.5-11.7 12.8-20.3s-3.9-16.7-11.2-21.3l-128.8-81 30.5-12.7zm44.8-46a88.05 88.05 0 0 0-63.3 1.7L91.3 62c-29.9 12.5-33.4 53.5-5.9 70.8L192 199.9l-40.9 21.4-47.6-21.2c-15.3-6.8-32.8-6.4-47.8 1.1L66.1 222l-10.3-20.7-32.2 16.1C.3 229-5.8 259.4 11.1 279.2l73.1 85.3 17.6-15.1-17.6 15c10.6 12.4 26.2 19.6 42.5 19.6h121.4c9.1 0 18-2.2 26-6.4l250.4-131.5c45.3-23.8 81.5-61.7 103.1-108 19.6-42-11-90.1-57.4-90.1h-50.7c-24.6 0-48.8 6-70.5 17.4L375.1 104 199.3 41.6zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarPlaneEngines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneEngines",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 256c0-17.4-8.8-31.1-18.7-40.7-9.9-9.6-22.4-16.9-34.8-22.4C498 182.1 468.7 176 448 176h-66.2l-32.5-50.9c11-5 18.7-16.1 18.7-29.1 0-17.7-14.3-32-32-32h-25.9l-24.4-38.2C275.4 9.7 257.6 0 238.5 0h-40.6c-27.1 0-46.4 26.4-38.1 52.2L199.4 176H148l-36-48c-7.6-10.1-19.4-16-32-16H37.9C17 112 0 129 0 149.9c0 3.8.6 7.5 1.7 11.1l19.9 64.7C9 230.1 0 242 0 256s9 25.9 21.6 30.3L1.7 350.9C.6 354.6 0 358.3 0 362.1 0 383 17 400 37.9 400H80c12.6 0 24.4-5.9 32-16l-19.2-14.4L112 384l36-48h51.4l-39.6 123.8c-8.3 25.8 11 52.2 38.1 52.2h40.6c19.1 0 36.9-9.7 47.2-25.8l24.4-38.2H336c17.7 0 32-14.3 32-32 0-13-7.7-24.1-18.8-29.1l32.6-50.9H448c20.6 0 49.8-5.8 74.4-16.5 12.4-5.4 25-12.7 34.9-22.4 10-9.8 18.7-23.6 18.7-41.1zm-128-32c13.4 0 36.1 4.4 55.1 12.8 9.4 4.2 16.4 8.7 20.7 12.9 4.2 4.1 4.2 6.1 4.2 6.3 0 .6-.1 2.8-4.2 6.8-4.3 4.2-11.2 8.6-20.6 12.7-18.9 8.3-41.6 12.5-55.2 12.5h-79.4c-8.2 0-15.8 4.2-20.2 11.1L245.2 460.3c-1.5 2.3-4 3.7-6.7 3.7h-29.6l46.3-144.7c2.3-7.3 1-15.3-3.5-21.5S240 288 232.3 288H136c-7.6 0-14.7 3.6-19.2 9.6L76 352H51.6L79 263.1c1.4-4.6 1.4-9.5 0-14.1l-27.4-89H76l40.8 54.4c4.5 6 11.6 9.6 19.2 9.6h96.3c7.7 0 14.9-3.7 19.4-9.8s5.8-14.2 3.5-21.5L208.9 48h29.6c2.7 0 5.3 1.4 6.7 3.7l20.2-12.9-20.2 12.9 103.2 161.2c4.4 6.9 12 11.1 20.2 11.1H448z"
        }
    ]
};

const FarPlaneLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7 9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128v26.2l95.3 61c-8.3 14.1-13.5 30.2-14.9 47.4l-117.3-75c-6.9-4.4-11.1-12-11.1-20.2V128c0-13.6-4.2-36.3-12.5-55.2-4.1-9.4-8.5-16.3-12.7-20.6-4-4.1-6.2-4.2-6.8-4.2-.2 0-2.2 0-6.3 4.2-4.2 4.3-8.7 11.3-12.9 20.7-8.4 19-12.8 41.7-12.8 55.1v39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7v29.6l144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4V376c0 7.6-3.6 14.7-9.6 19.2L160 436v23.9c6.8-2.1 15.3-4.6 24.3-7.3 22.6-6.8 49.1-14.8 64.6-19.6 4.6-1.4 9.5-1.4 14.1 0 15.5 4.8 42 12.8 64.6 19.6 9 2.7 17.5 5.3 24.3 7.3V436l-54.4-40.8c-6-4.5-9.6-11.6-9.6-19.2v-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5l82.5 26.4c-11 11.5-17.8 27.1-17.8 44.3v.4l-48-15.4V364l48 36v79.3c0 7.9 1.4 15.4 4 22.4-6.8 6.4-15.9 10.3-26 10.3-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23h-.2l-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8-19.5-5.9-42-12.6-57.9-17.5-15.9 4.9-38.4 11.6-57.9 17.5-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4.7-.6.2h-.2l-6.9-23 6.9 23c-2.2.7-4.5 1-6.9 1-20.7 0-37.7-17-37.7-37.9V432c0-12.6 5.9-24.4 16-32l48-36v-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1v-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2-12.9-20.2L176 154.2V128c0-20.7 6.1-50 16.9-74.5 5.5-12.3 12.8-24.9 22.4-34.8zM528 240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FarPlaneProp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneProp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.3 176h49.5L299.1 48h-14.2l-17.6 128zm77.4-148.4 5 36.4c.7-.1 1.5-.1 2.2-.1h16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v32c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-9.4l6.6 48h93.1c21 0 48.1 6.2 70.4 17.4 20.8 10.4 47.4 30.5 47.4 62.6 0 32.5-26.4 52.6-47.4 63-22.5 11.1-49.5 17-70.3 17h-93.1l-6.6 48h9.4v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v32c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-.8 0-1.5 0-2.2-.1l-5 36.4C342.5 500.2 329 512 313 512h-42c-16 0-29.5-11.8-31.7-27.6l-5-36.4H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h1.4l-7.2-52.4-75.7-9.1-5.8 34.3c-2.4 15.6-15.9 27.2-31.7 27.2H71c-15.9 0-29.4-11.7-31.7-27.4l-10.6-68.8C12.6 286.2 0 272.5 0 256s12.6-30.2 28.7-31.8l10.7-68.7C41.6 139.7 55.1 128 71 128h34c15.8 0 29.3 11.6 31.6 27.2l5.8 34.3 75.7-9.1 7.2-52.4H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h10.3l5-36.4C241.5 11.8 255 0 271 0h42c16 0 29.5 11.8 31.7 27.6zM267.3 336 285 464h14.2l17.7-128h-49.6zm191.1-48c13.4 0 33.1-4.1 49-12 17.4-8.6 20.7-16.5 20.7-20 0-2.9-3.2-10.8-20.8-19.7-15.9-8-35.7-12.3-48.9-12.3h-201l-131.9 15.8c-12.7 1.5-24.4-7.2-26.5-19.8l-7.5-44h-6.8l-12.4 80 12.4 80h6.8l7.5-44c2.2-12.6 13.8-21.3 26.5-19.8L257.4 288h200.9z"
        }
    ]
};

const FarPlaneSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L461 336h19c20.6 0 49.8-5.8 74.4-16.5 12.4-5.4 25-12.7 34.9-22.4 10-9.8 18.7-23.6 18.7-41.1 0-17.4-8.8-31.1-18.7-40.7-9.9-9.6-22.4-16.9-34.8-22.4C530 182.1 500.7 176 480 176h-66.2L317.7 25.8C307.4 9.7 289.6 0 270.5 0h-40.6c-27.1 0-46.4 26.4-38.1 52.2l31.1 97.2L38.8 5.1zm249.5 195.6c.1-2.7-.3-5.4-1.1-8L240.9 48h29.6c2.7 0 5.3 1.4 6.7 3.7l20.2-12.9-20.2 12.9 103.2 161.2c4.4 6.9 12 11.1 20.2 11.1H480c13.4 0 36.1 4.4 55.1 12.8 9.4 4.2 16.4 8.7 20.7 12.9 4.2 4.1 4.2 6.1 4.2 6.3 0 .6-.1 2.8-4.2 6.8-4.3 4.2-11.2 8.6-20.6 12.7-18.9 8.3-41.6 12.5-55.2 12.5h-80.3l-111.4-87.3zm88.9 192.5-37.9-29.8-62.1 97c-1.5 2.3-4 3.7-6.7 3.7h-29.6l45.5-142.3-42.7-33.8H168c-7.6 0-14.7 3.6-19.2 9.6L108 352H83.6l27.4-88.9c1.4-4.6 1.4-9.5 0-14.1l-26.7-86.6-44.7-35.2c-4.8 6.3-7.6 14.2-7.6 22.7 0 3.8.6 7.5 1.7 11.1l29.2 95-29.2 94.9c-1.1 3.6-1.7 7.4-1.7 11.1 0 21 17 38 37.9 38H112c12.6 0 24.4-5.9 32-16l-19.2-14.4L144 384l36-48h51.4l-39.6 123.8c-8.3 25.8 11 52.2 38.1 52.2h40.6c19.1 0 36.9-9.7 47.2-25.8l59.5-93z"
        }
    ]
};

const FarPlaneTail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneTail",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m.8 39 60.7 269.8-15.5 4.3c-27.2 7.4-46 32.1-46 60.3 0 26 16.1 49.3 40.4 58.5l196.1 74.4c10 3.8 20.5 5.7 31.2 5.7H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H267.7c-4.8 0-9.7-.9-14.2-2.6L57.4 387c-5.7-2.1-9.4-7.6-9.4-13.6 0-6.6 4.4-12.3 10.7-14.1L254 305.4c3.5-1 7-1.4 10.6-1.4H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H384L154.9 19.5a64 64 0 0 0-46-19.5H32C11.5 0-3.7 19 .8 39zM216 352c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
        }
    ]
};

const FarPlaneUpSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneUpSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-592-464zm537.2 333v-40.6c0-19.1-9.7-36.9-25.8-47.2L400 154.2V128c0-20.6-5.8-49.8-16.5-74.4-5.4-12.4-12.7-25-22.4-34.9C351.2 8.6 337.4 0 320 0c-17.4 0-31.1 8.8-40.7 18.7-9.6 9.9-16.9 22.4-22.4 34.8-6.9 15.7-11.9 33.3-14.6 49.4L288 139v-11c0-13.4 4.4-36.1 12.8-55.1 4.2-9.4 8.7-16.4 12.9-20.7 4.1-4.2 6.1-4.2 6.3-4.2.6 0 2.8.1 6.8 4.2 4.2 4.3 8.6 11.2 12.7 20.6 8.3 18.9 12.5 41.6 12.5 55.2v39.4c0 8.2 4.2 15.8 11.1 20.2l161.2 103.2c2.3 1.5 3.7 4 3.7 6.7v29.6l-2.9-.9 43.8 34.6c4.4-6.4 7.1-14.2 7.1-22.7zM148.8 212.6l-59 37.8 12.9 20.2-12.9-20.3C73.7 260.6 64 278.4 64 297.5v40.6c0 27.1 26.4 46.4 52.2 38.1L240 336.6V364l-48 36c-10.1 7.6-16 19.4-16 32v42.1c0 20.9 17 37.9 37.9 37.9 2.3 0 4.6-.3 6.9-1l-6.9-23 6.9 23h.2l.6-.2 2.4-.7 8.9-2.7c7.5-2.2 17.8-5.4 29.2-8.8 19.5-5.9 42-12.6 57.8-17.5l95 29.2c24 7.4 49.1-10.7 49.1-36.2v-12.7l-48-37.9v36.9L327.1 433c-4.6-1.4-9.5-1.4-14.1 0-15.5 4.8-42 12.8-64.6 19.6-9.1 2.7-17.5 5.3-24.3 7.3V436l54.4-40.8c6-4.5 9.6-11.6 9.6-19.2v-53.5l-46.6-36.8L112 327.1v-29.6c0-2.7 1.4-5.3 3.7-6.7l73-46.7-39.9-31.5z"
        }
    ]
};

const FarPlaneUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlaneUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7 9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128v26.2l150.2 96.1c16.1 10.3 25.8 28.1 25.8 47.2v40.6c0 27.1-26.4 46.4-52.2 38.1L336 336.6V364l48 36c10.1 7.6 16 19.4 16 32v42.1c0 20.9-17 37.9-37.9 37.9-3.8 0-7.5-.6-11.1-1.7l-95-29.2-94.9 29.2c-3.6 1.1-7.4 1.7-11.1 1.7-21 0-38-17-38-37.9V432c0-12.6 5.9-24.4 16-32l48-36v-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1v-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2-12.9-20.2L176 154.2V128c0-20.7 6.1-50 16.9-74.5 5.5-12.3 12.8-24.9 22.4-34.8zm21.5 54.2c-8.4 19-12.8 41.7-12.8 55.1v39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7v29.6l144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4V376c0 7.6-3.6 14.7-9.6 19.2L160 436v24.4l88.9-27.4c4.6-1.4 9.5-1.4 14.1 0l89 27.4V436l-54.4-40.8c-6-4.5-9.6-11.6-9.6-19.2v-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5L464 327.1v-29.6c0-2.7-1.4-5.3-3.7-6.7L299.1 187.6c-6.9-4.4-11.1-12-11.1-20.2V128c0-13.6-4.2-36.3-12.5-55.2-4.1-9.4-8.5-16.3-12.7-20.6-4-4.1-6.2-4.2-6.8-4.2-.2 0-2.2 0-6.3 4.2-4.2 4.3-8.7 11.3-12.9 20.7zm-89.9 391.5z"
        }
    ]
};

const FarPlane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlane",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M557.3 215.3c9.9 9.7 18.7 23.3 18.7 40.7 0 17.4-8.6 31.2-18.7 41.1-9.9 9.7-22.6 17-34.9 22.4-24.6 10.7-53.8 16.5-74.4 16.5h-66.2l-96.1 150.2c-10.3 16.1-28.1 25.8-47.2 25.8h-40.6c-27.1 0-46.4-26.4-38.1-52.2L199.4 336H148l-36 48-19.2-14.4L112 384c-7.6 10.1-19.4 16-32 16H37.9C17 400 0 383 0 362.1c0-3.8.6-7.5 1.7-11.1l29.2-95-29.2-94.9C.6 157.4 0 153.7 0 149.9 0 129 17 112 37.9 112H80c12.6 0 24.4 5.9 32 16l36 48h51.4L159.8 52.2C151.6 26.4 170.8 0 197.9 0h40.6c19.1 0 36.9 9.7 47.2 25.8L381.8 176H448c20.7 0 50 6.1 74.5 16.9 12.3 5.5 24.9 12.8 34.8 22.4zm-54.2 21.5c-19-8.4-41.7-12.8-55.1-12.8h-79.4c-8.2 0-15.8-4.2-20.2-11.1L245.2 51.7l20.2-12.9-20.2 12.9c-1.5-2.3-4-3.7-6.7-3.7h-29.6l46.3 144.7c2.3 7.3 1 15.3-3.5 21.5S240 224 232.3 224H136c-7.6 0-14.7-3.6-19.2-9.6L76 160H51.6L79 248.9c1.4 4.6 1.4 9.5 0 14.1l-27.4 89H76l40.8-54.4c4.5-6 11.6-9.6 19.2-9.6h96.3c7.7 0 14.9 3.7 19.4 9.8s5.8 14.2 3.5 21.5L208.9 464h29.6c2.7 0 5.3-1.4 6.7-3.7l103.2-161.2c4.4-6.9 12-11.1 20.2-11.1H448c13.6 0 36.3-4.2 55.2-12.5 9.4-4.1 16.3-8.5 20.6-12.7 4.1-4 4.2-6.2 4.2-6.8 0-.2 0-2.2-4.2-6.3-4.3-4.2-11.3-8.7-20.7-12.9zM47.6 365zm0-218.1z"
        }
    ]
};

const FarPlanetMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlanetMoon",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 464c97.2 0 176-78.8 176-176 0-82.2-56.4-151.3-132.6-170.6l-71 82.9c-11.5 13.4-10.7 33.4 1.8 45.9 6.3 6.3 14.9 9.9 23.9 9.9h66c17.7 0 32 14.3 32 32V304c0 10.6-2.6 21-7.6 30.3l-41.3 76.6c-4.4 8.1-12.8 13.2-22 13.2-13.8 0-25-11.2-25-25V352c-17.7 0-32-14.3-32-32v-32l-49.9-49.9c-9-9-21.2-14.1-33.9-14.1H60c-7.7 19.8-12 41.4-12 64 0 97.2 78.8 176 176 176zM0 288c0-52.3 17.9-100.5 48-138.6 1-1.3 2.1-2.6 3.2-3.9C92.2 95.7 154.4 64 224 64c13.3 0 26.4 1.2 39.1 3.4C368.2 85.9 448 177.6 448 288c0 123.7-100.3 224-224 224S0 411.7 0 288z"
        }
    ]
};

const FarPlanetRinged = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlanetRinged",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 31.1a.9.9 0 1 0-1.6.5.9.9 0 1 0 1.6-.5zm-5.2 22.1c-11.9 4.4-27 11.5-45 21.9-13.4-11.8-27.9-21.8-43-30 63.8-40.5 113.9-56.2 133.1-37 22.1 22.1-2.3 85.6-57.6 163.7C457.7 197.6 464 226 464 256c0 114.9-93.1 208-208 208-30 0-58.4-6.3-84.2-17.7C93.7 501.6 30.3 526 8.1 503.9c-19.2-19.2-3.4-69.3 37-133.1 8.3 15.1 18.3 29.6 30 43-10.4 18-17.6 33-21.9 45 12.6-4.6 28.7-12.3 48.1-23.8 8.2-4.8 16.7-10.2 25.4-16C78.8 380.9 48 322 48 256c0-114.9 93.1-208 208-208 66 0 124.9 30.8 163 78.8 5.8-8.8 11.2-17.3 16-25.4 11.4-19.4 19.2-35.5 23.8-48.1zm-69.2 114.7C361 124.6 311.8 96 256 96c-88.4 0-160 71.6-160 160 0 55.8 28.6 105 71.9 133.6 37.1-28.2 77.4-63.4 117.8-103.8S361.3 205 389.5 168zM217.9 411.4c12.2 3 25 4.6 38.1 4.6 88.4 0 160-71.6 160-160 0-13.1-1.6-25.9-4.6-38.1-26.5 33-57.4 67.5-91.7 101.8s-68.8 65.2-101.8 91.7zM31.1 464a.9.9 0 1 0 .5-1.6.9.9 0 1 0-.5 1.6zm16.8 16a1.1 1.1 0 1 0 1.8 1.1 1.1 1.1 0 1 0-1.8-1.1zM480 47.9a1.1 1.1 0 1 0 1.1 1.8 1.1 1.1 0 1 0-1.1-1.8z"
        }
    ]
};

const FarPlantWilt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlantWilt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 112c0-35.3 28.7-64 64-64s64 28.7 64 64v18.7c-33.9 8-56 33.6-56 72.4 0 27.9 25.3 74.8 66 111.6 3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6 0-38.8-22.1-64.4-56-72.4V112C456 50.1 405.9 0 344 0S232 50.1 232 112v36.1c-18.1-12.7-40.2-20.1-64-20.1-61.9 0-112 50.1-112 112v18.7c-33.9 8-56 33.6-56 72.4 0 27.9 25.3 74.8 66 111.6 3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6 0-38.8-22.1-64.4-56-72.4V240c0-35.3 28.7-64 64-64s64 28.7 64 64v248c0 13.3 10.7 24 24 24s24-10.7 24-24V112zM54.7 311.3c3.2-2.9 9.9-6.7 22.3-7.2 1 .1 2 .2 3.1.2s2.1-.1 3.1-.2c12.3.5 19.1 4.3 22.3 7.2 2.9 2.6 6.7 7.9 6.7 19.8 0 .1 0 .8-.3 2.3-.3 1.6-.8 3.7-1.8 6.4-1.8 5.4-4.9 12.2-9.3 19.9-5.4 9.3-12.3 19.2-20.7 28.9-8.3-9.7-15.3-19.6-20.7-28.9-4.4-7.7-7.4-14.4-9.3-19.9-.9-2.7-1.4-4.8-1.8-6.4-.3-1.5-.3-2.2-.3-2.3 0-11.9 3.8-17.1 6.7-19.8zM400 203.1c0-11.9 3.8-17.1 6.7-19.8 3.5-3.1 11-7.3 25.3-7.3s21.9 4.1 25.3 7.3c2.9 2.6 6.7 7.9 6.7 19.8 0 .1 0 .8-.3 2.3-.3 1.6-.8 3.7-1.8 6.4-1.8 5.4-4.9 12.2-9.3 19.9-5.4 9.3-12.3 19.2-20.7 28.9-8.3-9.7-15.3-19.6-20.7-28.9-4.4-7.7-7.4-14.4-9.3-19.9-.9-2.7-1.4-4.8-1.8-6.4-.3-1.5-.3-2.2-.3-2.3z"
        }
    ]
};

const FarPlateUtensils = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlateUtensils",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 16c13.3 0 24 10.7 24 24v128c0 4.4 3.6 8 8 8h8V40c0-13.3 10.7-24 24-24s24 10.7 24 24v136h8c4.4 0 8-3.6 8-8V40c0-13.3 10.7-24 24-24s24 10.7 24 24v128c0 30.9-25.1 56-56 56h-8v248c0 13.3-10.7 24-24 24s-24-10.7-24-24V224h-8c-30.9 0-56-25.1-56-56V40c0-13.3 10.7-24 24-24zm536 144v112h32V85.2c-16.6 15.3-32 39.1-32 74.8zm32 160h-48c-17.7 0-32-14.3-32-32V160c0-100.8 84.2-136.8 101.1-143 2-.7 4-1 6.1-1 11.5 0 20.9 9.3 20.9 20.9V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V320zM336 480c-81.5 0-152.8-43.5-192-108.6V252.7c5.7-1.6 11.1-3.8 16.3-6.4-.2 3.2-.3 6.5-.3 9.7 0 97.2 78.8 176 176 176 70.8 0 131.8-41.8 159.7-102 10.6 12.2 25.8 20.3 42.8 21.8C502.6 427.6 425.4 480 336 480zM208 72.2C244.3 46.8 288.4 32 336 32c60.3 0 115 23.8 155.3 62.5-6.5 17.5-10.6 37.5-11.2 60.3C448.2 109.6 395.6 80 336 80c-50.4 0-95.9 21.2-128 55.2v-63zM416 256a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm-208 0a128 128 0 1 1 256 0 128 128 0 1 1-256 0z"
        }
    ]
};

const FarPlateWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlateWheat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32c-8.8 0-16 7.2-16 16v16c0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16v-16c0-44.2-35.8-80-80-80zM56 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm-32 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm8 96c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24zM272 48v16c0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16v-16c0-44.2-35.8-80-80-80-8.8 0-16 7.2-16 16zm128-16c-8.8 0-16 7.2-16 16v16c0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16v-16c0-44.2-35.8-80-80-80zm80 160c0-8.8-7.2-16-16-16-44.2 0-80 35.8-80 80v16c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80v-16zm-128-16c-44.2 0-80 35.8-80 80v16c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80v-16c0-8.8-7.2-16-16-16zm-96 16c0-8.8-7.2-16-16-16-44.2 0-80 35.8-80 80v16c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80v-16zM130 423.7a48.03 48.03 0 0 0-35.3-24.3C76 396.8 60.3 384.6 52.8 368h406.4c-7.5 16.6-23.2 28.8-41.9 31.5-14.9 2.1-28 11.1-35.3 24.3-2.8 5-8.1 8.3-14 8.3H144c-6 0-11.2-3.2-14-8.3zM25.6 320C11.5 320 0 331.5 0 345.6 0 397.3 38.3 440 88 447c10.9 19.7 31.9 33 56 33h224c24.1 0 45.1-13.3 56-33 49.7-7 88-49.7 88-101.4 0-14.1-11.5-25.6-25.6-25.6H25.6z"
        }
    ]
};

const FarPlayPause = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlayPause",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v336c0 13.3 10.7 24 24 24s24-10.7 24-24V88zm144 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v336c0 13.3 10.7 24 24 24s24-10.7 24-24V88zM112 381.8V130.2L263 256 112 381.8zm4.5-310.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96v320c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160z"
        }
    ]
};

const FarPlay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlay",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m48 432 288-176L48 80v352zM24.5 38.1C39.7 29.6 58.2 30 73 39l288 176c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5.9S0 449.4 0 432V80c0-17.4 9.4-33.4 24.5-41.9z"
        }
    ]
};

const FarPlugCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlugCircleBolt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-73.8c15.2-2.3 29.7-6.7 43.1-12.9-2.1-10.8-3.1-21.9-3.1-33.3 0-7.1.4-14.1 1.2-20.9-18.3 13.1-40.9 20.9-65.2 20.9-61.9 0-112-50.1-112-112v-64h224v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm408 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9l30.1-54.1H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1.6z"
        }
    ]
};

const FarPlugCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlugCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-73.8c15.2-2.3 29.7-6.7 43.1-12.9-2.1-10.8-3.1-21.9-3.1-33.3 0-7.1.4-14.1 1.2-20.9-18.3 13.1-40.9 20.9-65.2 20.9-61.9 0-112-50.1-112-112v-64h224v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm552 224a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarPlugCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlugCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-73.8c15.2-2.3 29.7-6.7 43.1-12.9-2.1-10.8-3.1-21.9-3.1-33.3 0-7.1.4-14.1 1.2-20.9-18.3 13.1-40.9 20.9-65.2 20.9-61.9 0-112-50.1-112-112v-64h224v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm408 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarPlugCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlugCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-73.8c15.2-2.3 29.7-6.7 43.1-12.9-2.1-10.8-3.1-21.9-3.1-33.3 0-7.1.4-14.1 1.2-20.9-18.3 13.1-40.9 20.9-65.2 20.9-61.9 0-112-50.1-112-112v-64h224v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm552 224a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FarPlugCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlugCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-80c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16zM104 0c13.3 0 24 10.7 24 24v88H80V24c0-13.3 10.7-24 24-24zm176 0c13.3 0 24 10.7 24 24v88h-48V24c0-13.3 10.7-24 24-24zM0 168c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v19.2c-18 9.2-34.2 21.4-48 36V192H80v64c0 61.9 50.1 112 112 112 24.3 0 46.9-7.8 65.2-20.9-.8 6.9-1.2 13.9-1.2 20.9 0 11.4 1.1 22.5 3.1 33.3-13.5 6.2-28 10.7-43.1 12.9V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-73.8C91 402.6 32 336.2 32 256v-64h-8c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarPlugCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlugCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-73.8c15.2-2.3 29.7-6.7 43.1-12.9-2.1-10.8-3.1-21.9-3.1-33.3 0-7.1.4-14.1 1.2-20.9-18.3 13.1-40.9 20.9-65.2 20.9-61.9 0-112-50.1-112-112v-64h224v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm408 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FarPlug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlug",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-73.8c77-11.6 136-78 136-158.2v-64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm168 224c-61.9 0-112-50.1-112-112v-64h224v64c0 61.9-50.1 112-112 112z"
        }
    ]
};

const FarPlusLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlusLarge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M488 232c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h208V24c0-13.3 10.7-24 24-24s24 10.7 24 24v208h208z"
        }
    ]
};

const FarPlusMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlusMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 32c0-13.3-10.7-24-24-24s-24 10.7-24 24v120H48c-13.3 0-24 10.7-24 24s10.7 24 24 24h120v120c0 13.3 10.7 24 24 24s24-10.7 24-24V200h120c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V32zM8 488c0 13.3 10.7 24 24 24h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H32c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24v160H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h160v160c0 13.3 10.7 24 24 24s24-10.7 24-24V280h160c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"
        }
    ]
};

const FarPodcast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPodcast",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 224c0 61.1-31.1 115-78.4 146.5-1.4 17-4.1 36.6-7.1 54.9l-.6 3.8C392.8 394.7 448 315.8 448 224 448 100.3 347.7 0 224 0S0 100.3 0 224c0 91.8 55.2 170.6 134.2 205.3l-.6-3.7c-3-18.4-5.7-38.1-7.1-55.1C79.1 338.9 48 285.1 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176zm-32 0c0-79.5-64.5-144-144-144S80 144.5 80 224c0 42.4 18.3 80.5 47.5 106.9 1.6-7.1 4.3-13.9 8.1-20.3 5.1-8.5 11.7-15.2 18.8-20.5C138 272.9 128 249.6 128 224c0-53 43-96 96-96s96 43 96 96c0 25.6-10 48.9-26.4 66.1 7.2 5.2 13.7 11.9 18.8 20.5 3.8 6.3 6.4 13.1 8.1 20.3C349.7 304.5 368 266.4 368 224zm-144-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-45.1 199.7c5.3 19.8 25.5 24.3 45.1 24.3s39.8-4.6 45.1-24.3c8.1-29.9 21.5-103.9 21.5-138.2 0-36.5-32.4-45.5-66.6-45.5s-66.6 9-66.6 45.5c0 34.4 13.4 108.5 21.5 138.2zm46.6-23.7h-3c-3.1-13.3-6.7-31.9-9.9-51.4-3.9-23.7-6.5-45.4-7-59 .6-.1 1.4-.3 2.2-.4 4.3-.8 9.7-1.2 16.3-1.2s12 .4 16.3 1.2c.8.1 1.5.3 2.2.4-.5 13.5-3.1 35.1-7 58.8-3.2 19.5-6.9 38.1-10 51.5z"
        }
    ]
};

const FarPodiumStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPodiumStar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.4 72c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48S314.5 0 288 0h-64c-17.8 0-33.3 9.7-41.6 24H168c-48.6 0-88 39.4-88 88v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H128v-32c0-22.1 17.9-40 40-40h14.4zM47.3 224l26.2 231.2c3.7 32.3 31 56.8 63.6 56.8h173.8c32.6 0 59.9-24.4 63.6-56.8L400.7 224h-48.3l-25.6 225.8c-.9 8.1-7.8 14.2-15.9 14.2H137.1c-8.1 0-15-6.1-15.9-14.2L95.6 224H47.3zm201.5 77.7-18.2-41.3c-2.6-5.8-10.5-5.8-13.1 0l-18.2 41.3c-1.1 2.4-3.2 4-5.7 4.3l-43.2 5.4c-6.1.8-8.6 8.7-4 13l31.9 30.9c1.8 1.8 2.7 4.4 2.2 7l-8.6 44.7c-1.2 6.3 5.2 11.2 10.6 8.1l37.9-22.2c2.2-1.3 4.9-1.3 7 0l38.1 22.1c5.4 3.1 11.8-1.7 10.6-8.1l-8.5-44.6c-.5-2.6.3-5.2 2.2-7l31.9-30.9c4.5-4.4 2.1-12.3-4-13l-43.2-5.4c-2.5-.3-4.6-2-5.7-4.3z"
        }
    ]
};

const FarPodium = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPodium",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 72c-22.1 0-40 17.9-40 40v32h296c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h56v-32c0-48.6 39.4-88 88-88h14.4C190.7 9.7 206.2 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48h-64c-17.8 0-33.3-9.7-41.6-24H168zM73.5 455.2 47.3 224h48.3l25.7 225.8c.9 8.1 7.8 14.2 15.9 14.2h173.7c8.1 0 15-6.1 15.9-14.2L352.4 224h48.3l-26.2 231.2c-3.7 32.3-31 56.8-63.6 56.8H137.1c-32.6 0-59.9-24.4-63.6-56.8z"
        }
    ]
};

const FarPoliceBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPoliceBox",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c8.8 0 16 7.2 16 16v16h80c17.7 0 32 14.3 32 32 17.7 0 32 14.3 32 32v368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V96c0-17.7 14.3-32 32-32 0-17.7 14.3-32 32-32h80V16c0-8.8 7.2-16 16-16zM80 464h224V112H80v352zm24-320c0-4.4 3.6-8 8-8h24v32h-32v-24zm0 40h32v32h-24c-4.4 0-8-3.6-8-8v-24zm72-48c4.4 0 8 3.6 8 8v24h-32v-32h24zm-24 48h32v24c0 4.4-3.6 8-8 8h-24v-32zm56-48h24v32h-32v-24c0-4.4 3.6-8 8-8zm24 48v32h-24c-4.4 0-8-3.6-8-8v-24h32zm16-48h24c4.4 0 8 3.6 8 8v24h-32v-32zm32 48v24c0 4.4-3.6 8-8 8h-24v-32h32zm-176 64c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48z"
        }
    ]
};

const FarPollPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPollPeople",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm464 32v64H480V80h112zM272 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H272zm320 336v64H352v-64h240zm-320-48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H272zM64 128c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64H64zm64 208a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-64 80c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarPompebled = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPompebled",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M254.4 22.8c45.2 31.3 55.3 91.3 38 147.2 45.1-35.6 103.5-47.2 148.3-15 64.6 45.8 71.6 140.2 25.7 208.1C386.7 480.8 219.2 542 98.5 455.5-21.8 369.5-25.9 190 53.9 72.2c46-68.6 135.3-95.4 200.5-49.4zm21.5 185.1zM226.7 62.1c-38-26.9-98.3-15-133 36.9l-.1.1c-69.9 103.1-60.2 251 32.8 317.4 91.7 65.7 230.3 23 300.2-80.2 34.9-51.7 24.7-114.9-13.8-142.1l-.1-.1c-25.6-18.4-73.5-11.7-111.5 33.9-12.9 17.5-37.4 21.8-55.4 8.7-17.6-12.7-21.9-36.7-10.4-54.7 28.6-52.7 17.8-101.6-8.5-119.7l-.2-.2z"
        }
    ]
};

const FarPooStorm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPooStorm",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175.3 10.1C179.8 3.8 187 0 194.8 0c58.8 0 132.5 41.8 140.5 121.2 28.9 14.5 48.7 44.3 48.7 78.8 0 2.2-.1 4.4-.2 6.6C421.3 221 448 257.4 448 300c0 55.2-44.8 100-100 100h-8.2c11.5-12.9 15.4-31.2 9.5-47.9v-.1c28.1-.7 50.7-23.7 50.7-52 0-27-20.7-49.3-47-51.8-7.6-.7-14.4-5-18.3-11.5s-4.5-14.5-1.7-21.5c1.9-4.7 3-9.8 3-15.2 0-18.6-12.7-34.3-30-38.7-10.9-2.8-18.4-12.8-18-24.1v-1.5c0-40.2-26.7-68.8-58.4-81 1.3 5.6 2.4 11.6 2.4 16.8 0 38-19.6 61-39 73.6-9.3 6-18.5 9.6-25.2 11.7-3.4 1.1-6.3 1.8-8.4 2.2l-.4.1c-2.2.7-4.5 1-6.9 1h-.1c-22.1 0-40 17.9-40 40 0 5.4 1.1 10.5 3 15.2 2.9 7 2.3 15-1.7 21.5s-10.7 10.8-18.3 11.5C68.7 250.7 48 273 48 300c0 18 9.1 33.8 22.9 43.1-7.3 12-9.1 27-4.2 40.8 1.6 4.6 3.8 8.8 6.6 12.5C31 384.7 0 346 0 300c0-42.6 26.7-79 64.2-93.4-.2-2.2-.2-4.4-.2-6.6 0-47.6 37.8-86.3 84.9-87.9l.5-.1c.9-.2 2.4-.6 4.3-1.1 3.8-1.2 8.6-3.1 13.3-6.1 8.6-5.5 17-14.7 17-33.3 0-.3-.2-1.5-.7-4-.6-2.8-1.5-6.1-2.6-9.9-2.2-7.5-5-15.3-7.1-21.3v-.1c-.5-1.6-1.1-3.1-1.5-4.3-2.5-7.3-1.3-15.4 3.2-21.7zm106.8 217.5c5.8 4.7 7.6 12.9 4.3 19.6L233.9 352H304c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L182.1 384H112c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1z"
        }
    ]
};

const FarPoo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPoo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-9.7 0-18.5 5.8-22.2 14.8S200.1 34.1 207 41l7.4 7.4c6.1 6.1 9.5 14.4 9.5 23v3.2c0 16.2-13.1 29.3-29.3 29.3h-17.7c-6.1 0-12.1.8-17.8 2.2C113.9 115.8 80 155.9 80 204c0 1.1 0 2.2.1 3.3-33 14-56.1 46.6-56.1 84.7 0 14.3 3.3 27.8 9.1 39.9C12.8 350.9 0 377.9 0 408c0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104 0-30.1-12.8-57.1-33.1-76.1 5.8-12.1 9.1-25.6 9.1-39.9 0-38.1-23.1-70.7-56.1-84.7 0-1.1.1-2.2.1-3.3 0-38-21.2-71-52.3-87.9C363.6 49.5 303.6 0 232 0h-8zm48 71.4c0-5.5-.6-10.9-1.6-16.1 33.8 13.4 58.9 44 64.5 81 1.3 8.6 7.2 15.9 15.3 18.9C370 162.6 384 181.7 384 204c0 4.9-.7 9.7-1.9 14.1-1.9 6.7-.8 13.9 3 19.7s10 9.7 16.9 10.6c21.5 2.9 38 21.3 38 43.6 0 11.4-4.3 21.8-11.4 29.6-5 5.4-7.1 12.9-5.9 20.1s5.7 13.6 12.2 17.1c17.4 9.5 29.2 28 29.2 49.2 0 30.9-25.1 56-56 56H104c-30.9 0-56-25.1-56-56 0-21.2 11.7-39.7 29.2-49.2 6.5-3.5 10.9-9.8 12.2-17.1s-1-14.7-5.9-20.1C76.3 313.8 72 303.4 72 292c0-22.3 16.6-40.7 38-43.6 6.9-.9 13-4.8 16.9-10.6s4.9-13 3-19.7c-1.3-4.5-1.9-9.2-1.9-14.1 0-25.1 17.8-46 41.4-50.9l1.2-.3c2-.5 4.1-.8 6.3-.8h17.8c42.7 0 77.3-34.6 77.3-77.3v-3.3zM192 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-147.7 32c-6.8 0-12.3 5.5-12.3 12.3 0 2.4.7 4.8 2.2 6.7 8.2 10.5 39.5 45 93.8 45s85.6-34.6 93.8-45c1.5-1.9 2.2-4.3 2.2-6.7 0-6.8-5.5-12.3-12.3-12.3H172.3z"
        }
    ]
};

const FarPool8Ball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPool8Ball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm120-56a136 136 0 1 1 272 0 136 136 0 1 1-272 0zm173.3-25.8C300 166 304 155.5 304 144c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.5 4 22 10.7 30.2-11.5 10.3-18.7 25.2-18.7 41.8 0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.6-7.2-31.5-18.7-41.8zM240 144a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarPoop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPoop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M201.8 14.8C205.5 5.8 214.3 0 224 0h8c71.6 0 131.6 49.5 147.7 116.1C410.8 133 432 166 432 204c0 1.1 0 2.2-.1 3.3 33 14 56.1 46.6 56.1 84.7 0 14.3-3.3 27.8-9.1 39.9 20.3 19 33.1 46 33.1 76.1 0 57.4-46.6 104-104 104H104C46.6 512 0 465.4 0 408c0-30.1 12.8-57.1 33.1-76.1-5.8-12.1-9.1-25.6-9.1-39.9 0-38.1 23.1-70.7 56.1-84.7 0-1.1-.1-2.2-.1-3.3 0-48.1 33.9-88.2 79.1-97.8 5.7-1.4 11.7-2.2 17.8-2.2h17.8c16.2 0 29.3-13.1 29.3-29.3v-3.3c0-8.6-3.4-16.9-9.5-23L207 41c-6.9-6.9-8.9-17.2-5.2-26.2zm68.5 40.5c1.1 5.3 1.6 10.7 1.6 16.1v3.2c0 42.7-34.6 77.3-77.3 77.3h-17.7c-2.2 0-4.3.3-6.3.8l-1.2.3c-23.6 5-41.4 25.9-41.4 51 0 4.9.7 9.7 1.9 14.1 1.9 6.7.8 13.9-3 19.7s-10 9.7-16.9 10.6c-21.5 2.9-38 21.3-38 43.6 0 11.4 4.3 21.8 11.4 29.6 5 5.4 7.1 12.9 5.9 20.1s-5.7 13.6-12.2 17.1C59.7 368.3 48 386.8 48 408c0 30.9 25.1 56 56 56h304c30.9 0 56-25.1 56-56 0-21.2-11.8-39.7-29.2-49.2-6.5-3.5-10.9-9.8-12.2-17.1s1-14.7 5.9-20.1c7.1-7.8 11.4-18.2 11.4-29.6 0-22.3-16.6-40.7-38-43.6-6.9-.9-13-4.8-16.9-10.6s-4.9-13-3-19.7c1.3-4.5 1.9-9.2 1.9-14.1 0-22.3-14-41.4-33.8-48.7-8.2-3-14-10.3-15.3-18.9-5.6-37-30.7-67.6-64.5-81z"
        }
    ]
};

const FarPopcorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPopcorn",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 156c0-20.9 14.5-38.3 34-42.9-1.3-4.2-2-8.6-2-13.1 0-24.3 19.7-44 44-44 1.9 0 3.7.1 5.6.3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6 20.3 0 37.3 13.7 42.4 32.3 1.8-.2 3.7-.3 5.6-.3 24.3 0 44 19.7 44 44 0 4.6-.7 9-2 13.1 19.5 4.5 34 22 34 42.9 0 1.3-.1 2.7-.2 4H32.2c-.1-1.3-.2-2.7-.2-4zm22.3 84 62.2 224h215l62.2-224h-47l-43.1 179.7c-2.1 8.6-10.7 13.9-19.3 11.8s-13.9-10.7-11.8-19.3L313.8 240H240v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V240h-73.8l41.3 172.3c2.1 8.6-3.2 17.2-11.8 19.3s-17.2-3.2-19.3-11.8L101.3 240h-47zM224 192h195.8c15.6 0 28.2 12.6 28.2 28.2 0 2.5-.3 5.1-1 7.5l-69.2 249.1c-5.8 20.8-24.7 35.2-46.3 35.2h-215c-21.6 0-40.5-14.4-46.2-35.2L1 227.7c-.7-2.5-1-5-1-7.5C0 204.6 12.6 192 28.2 192H224z"
        }
    ]
};

const FarPopsicle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPopsicle",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 160c0-61.9-50.1-112-112-112S48 98.1 48 160v176h88V184c0-13.3 10.7-24 24-24s24 10.7 24 24v152h88V160zM136 384H48c-26.5 0-48-21.5-48-48V160C0 71.6 71.6 0 160 0s160 71.6 160 160v176c0 26.5-21.5 48-48 48h-88v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384z"
        }
    ]
};

const FarPotFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPotFood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 24c0 26.5 10.5 38.7 25.9 56.1l.4.4C154.8 99 176 122.9 176 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C85.2 93 64 69.1 64 24 64 10.7 74.7 0 88 0s24 10.7 24 24zm112 0c0 26.5 10.5 38.7 25.9 56.1l.4.4C266.8 99 288 122.9 288 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C197.2 93 176 69.1 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24zm208 88c50.7 0 93.6 33.7 107.4 80H324.6c13.8-46.3 56.6-80 107.4-80zM16 280c0-13.3 10.7-24 24-24h26.7c6.6-18.6 24.4-32 45.3-32h416c20.9 0 38.7 13.4 45.3 32H600c13.3 0 24 10.7 24 24s-10.7 24-24 24h-26.3c-11 76.9-61.1 141.2-129.5 172.2-8.1 21-28.4 35.8-52.3 35.8H248c-23.8 0-44.2-14.9-52.3-35.8-68.4-31-118.4-95.3-129.4-172.2H40c-13.3 0-24-10.7-24-24zm224.5 178.9c1.2 3.1 4.2 5.1 7.5 5.1h144c3.3 0 6.3-2 7.5-5.1 4.5-11.7 13.5-21.2 25-26.4C485.6 404.8 528 343.3 528 272H112c0 71.3 42.4 132.8 103.5 160.5 11.5 5.2 20.4 14.7 25 26.4z"
        }
    ]
};

const FarPotato = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPotato",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 144c0-53-43-96-96-96-26.6 0-50.5 10.7-68 28.2-30.7 30.8-68 58.7-106 79.5-16.1 8.8-29.4 22.1-38.2 38.2C134.9 232 107 269.3 76.2 300 58.7 317.5 48 341.4 48 368c0 53 43 96 96 96 20.2 0 38.9-6.2 54.3-16.8 31.8-21.9 67.9-39.9 104.3-52.2 29.5-10 53.5-34 62.1-66.1 11.5-42.8 36.5-84.4 68.8-114.7 18.9-17.6 30.5-42.5 30.5-70.2zm48 0c0 41.5-17.6 78.9-45.7 105.2-25.8 24.2-46.1 57.9-55.2 92.1-12.9 48.3-49 84.3-93.1 99.2-32.3 10.9-64.4 26.9-92.5 46.2-23.1 16-51.2 25.3-81.5 25.3C64.5 512 0 447.5 0 368c0-39.8 16.2-75.9 42.3-102 27.5-27.4 52.7-61 71.3-95.1 13.2-24.1 33.1-44 57.3-57.3C205 95 238.6 69.8 266 42.3 292.1 16.2 328.2 0 368 0c79.5 0 144 64.5 144 144zm-160 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-184 88a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-8 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarPowerOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPowerOff",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v240c0 13.3 10.7 24 24 24s24-10.7 24-24V24zm-145.8 83.3c10.7-7.9 12.9-22.9 5.1-33.6s-22.9-12.9-33.6-5.1C46.5 112.3 8 182.7 8 262c0 132.6 107.5 240 240 240s240-107.5 240-240c0-79.3-38.5-149.7-97.8-193.3-10.7-7.9-25.7-5.6-33.6 5.1s-5.6 25.7 5.1 33.6c47.5 35 78.2 91.2 78.2 154.7 0 106-86 192-192 192S56 368 56 262c0-63.4 30.7-119.7 78.2-154.7z"
        }
    ]
};

const FarPrescriptionBottleMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPrescriptionBottleMedical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 48h288v32H48V48zM32 0C14.3 0 0 14.3 0 32v64c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zm0 160v288c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160h-48v288c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V160H32zm133.3 80v37.3H128c-8.8 0-16 7.2-16 16v21.3c0 8.8 7.2 16 16 16h37.3V368c0 8.8 7.2 16 16 16h21.3c8.8 0 16-7.2 16-16v-37.3H256c8.8 0 16-7.2 16-16v-21.4c0-8.8-7.2-16-16-16h-37.3V240c0-8.8-7.2-16-16-16h-21.4c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarPrescriptionBottlePill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPrescriptionBottlePill",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 48h288v32H48V48zM40 0C17.9 0 0 17.9 0 40v48c0 22.1 17.9 40 40 40h304c22.1 0 40-17.9 40-40V40c0-22.1-17.9-40-40-40H40zm-8 160v288c0 35.3 28.7 64 64 64h192c11.6 0 22.4-3.1 31.8-8.4-13.7-11.3-25.6-24.7-35.3-39.6H96c-8.8 0-16-7.2-16-16v-32h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80v-48h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80v-48h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80v-16H32zm320 0h-48v87.2c13.8-14.6 30-26.8 48-36V160zm80 112a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-49-193c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarPrescriptionBottle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPrescriptionBottle",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 48h288v32H48V48zM40 0C17.9 0 0 17.9 0 40v48c0 22.1 17.9 40 40 40h304c22.1 0 40-17.9 40-40V40c0-22.1-17.9-40-40-40H40zm-8 160v288c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160h-48v288c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-32h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80v-48h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80v-48h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80v-16H32z"
        }
    ]
};

const FarPrescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPrescription",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24v272c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h78.1l128 128L135 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L407 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L441 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-95.3-95.3c53.8-8.1 95.2-54.6 95.2-110.8C288 50.1 237.9 0 176 0H24zm152 176H48V48h128c35.3 0 64 28.7 64 64s-28.7 64-64 64z"
        }
    ]
};

const FarPresentationScreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPresentationScreen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24S565.3 0 552 0H24zm8 80v216c0 30.9 25.1 56 56 56h176v46.1l-73 73c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-73-73V352H488c30.9 0 56-25.1 56-56V80h-48v216c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V80H32z"
        }
    ]
};

const FarPretzel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPretzel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 184.2c0 52.5 20.3 100.3 53.5 135.9l19-26.8C103.3 264 88 225.9 88 184.2c0-39.9 32.3-72.2 72.2-72.2h3.8c42 0 76 34 76 76v5.1c0 16.8-5.2 33.2-14.9 46.9l-45.9 64.9c0 .1-.1.1-.1.2l-46.2 65.2c0 .1-.1.1-.1.2L107 406.9c-5.1 7.2-3.4 17.2 3.8 22.3s17.2 3.4 22.3-3.8l30.6-43.4c6.2-8.7 17.3-12.3 27.4-8.8 20.3 7 42.2 10.8 65 10.8 11.2 0 22.3-.9 33-2.7l-21-29.7c-3.9.3-7.9.4-11.9.4-9.2 0-18.3-.7-27.2-2.2-8.2-1.3-15.1-6.8-18.3-14.4s-2.2-16.4 2.6-23.1l23.3-32.9c4.5-6.4 11.8-10.1 19.6-10.1s15.1 3.8 19.6 10.1l11.5 16.3 11.8 16.6s0 .1.1.1l49.3 69.5.1.1 30.6 43.2c5.1 7.2 15.1 8.9 22.3 3.8s8.9-15.1 3.8-22.3l-25.8-36.4c-7.3-10.2-5.4-24.3 4.3-32.4 44.3-36.7 72.4-92 72.4-153.8C456 126.7 409.3 80 351.8 80H348c-29.3 0-55.8 11.6-75.3 30.6-9.3 9.1-24.1 9.1-33.5 0C219.8 91.6 193.3 80 164 80h-3.8C102.7 80 56 126.7 56 184.2zM81.2 360C36.1 315.1 8 253 8 184.2 8 100.1 76.1 32 160.2 32h3.8c34.4 0 66.2 11.2 92 30 25.8-18.9 57.6-30 92-30h3.8c84 0 152.2 68.1 152.2 152.2 0 68.7-28.1 130.9-73.2 175.8l13.5 19c20.4 28.8 13.6 68.8-15.2 89.2s-68.8 13.6-89.2-15.2l-20.6-29.1c-20.3 5.3-41.5 8.1-63.3 8.1s-43-2.8-63.2-8.1L172.2 453c-20.4 28.8-60.4 35.7-89.2 15.2l13.3-18.8L83 468.2c-28.8-20.4-35.7-60.4-15.2-89.2l13.5-19zM136 184.2c0 25.3 7.9 48.9 21.4 68.3l28.5-40.2c4-5.6 6.1-12.3 6.1-19.1V188c0-15.5-12.5-28-28-28h-3.8c-13.4 0-24.2 10.8-24.2 24.2zm184 3.8v5.1c0 6.9 2.1 13.5 6.1 19.1l28.5 40.2c13.5-19.4 21.4-42.9 21.4-68.3 0-13.4-10.8-24.2-24.2-24.2H348c-15.5 0-28 12.5-28 28zm28-76h3.8c39.9 0 72.2 32.3 72.2 72.2 0 49.4-21.5 93.9-55.5 124.6-5.1 4.6-11.9 6.8-18.7 6s-13-4.4-16.9-10l-46-64.8c-9.7-13.7-14.9-30.1-14.9-46.9V188c0-42 34-76 76-76z"
        }
    ]
};

const FarPrintMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPrintMagnifyingGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 160h-48V64c0-35.3 28.7-64 64-64h229.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V160h-48V90.5c0-4.2-1.7-8.3-4.7-11.3l-26.5-26.5c-3-3-7.1-4.7-11.3-4.7H192c-8.8 0-16 7.2-16 16v96zm16 208v96h186.2c21.1 10.2 44.8 16 69.8 16 16.7 0 32.8-2.6 48-7.3v7.3c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32v-80H96c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64h224c-17.2 12.9-31.7 29.3-42.6 48H128c-8.8 0-16 7.2-16 16v96h32c0-17.7 14.3-32 32-32h112c0 16.7 2.6 32.8 7.3 48H192zm256 32.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l79.1 79.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"
        }
    ]
};

const FarPrintSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPrintSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400h1.4c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H277.2L176 112.6V64c0-8.8 7.2-16 16-16h229.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3V160h48V90.5c0-17-6.7-33.3-18.7-45.3l-26.6-26.5C454.7 6.7 438.5 0 421.5 0H192c-35.3 0-64 28.7-64 64v11L38.8 5.1zM338.5 240H512c8.8 0 16 7.2 16 16v96h-46.6L338.5 240zm-155.7 0-60.6-47.7C89.6 195.2 64 222.6 64 256v112c0 17.7 14.3 32 32 32h48v80c0 17.7 14.3 32 32 32h288c15.5 0 28.5-11 31.4-25.7L448 449v15H192v-96h153.2l-60.9-48H176c-17.7 0-32 14.3-32 32h-32v-96c0-8.8 7.2-16 16-16h54.8z"
        }
    ]
};

const FarPrint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPrint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 160V64c0-8.8 7.2-16 16-16h229.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3V160h48V90.5c0-17-6.7-33.3-18.7-45.3l-26.6-26.5C390.7 6.7 374.5 0 357.5 0H128C92.7 0 64 28.7 64 64v96h48zm16 208h256v96H128v-96zm-16-48c-17.7 0-32 14.3-32 32H48v-96c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v96h-32c0-17.7-14.3-32-32-32H112zm320 80h48c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v112c0 17.7 14.3 32 32 32h48v80c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32v-80z"
        }
    ]
};

const FarProjector = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarProjector",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M424 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM265 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56zm304 34c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L479 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56zM288 320a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm272 0c0-29.1-7.8-56.5-21.4-80H576c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16h-37.4c13.6-23.5 21.4-50.9 21.4-80zM400 480c36 0 69.3-11.9 96-32h16v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h16c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-80c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H64c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64h16v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h176c26.7 20.1 60 32 96 32zM240 320c0 29.1 7.8 56.5 21.4 80H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h197.4c-13.6 23.5-21.4 50.9-21.4 80zm-112 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarPumpMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPumpMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 0h48c25.4 0 46.8 16.9 53.7 40h46.4c19.1 0 37.4 7.6 50.9 21.1l42 41.9c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-42-41.9c-4.5-4.5-10.6-7-17-7H272v40h-48V56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v72h-48V56c0-30.9 25.1-56 56-56zm-66.5 222.7-18.7 224c-.7 9.3 6.6 17.3 16 17.3h186.4c9.4 0 16.7-8 15.9-17.3l-18.7-224c-.7-8.3-7.6-14.7-15.9-14.7H117.4c-8.3 0-15.3 6.4-15.9 14.7zm-47.8-4c2.8-33.2 30.5-58.7 63.8-58.7h149.1c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zM216 296v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarPumpSoap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPumpSoap",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 56c0-30.9 25.1-56 56-56h48c25.4 0 46.8 16.9 53.7 40h46.4c19.1 0 37.4 7.6 50.9 21.1l42 41.9c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-42-41.9c-4.5-4.5-10.6-7-17-7H272v40h-48V56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v72h-48V56zm-10.5 166.7-18.7 224c-.7 9.3 6.6 17.3 16 17.3h186.4c9.4 0 16.7-8 15.9-17.3l-18.7-224c-.7-8.3-7.6-14.7-15.9-14.7H117.4c-8.3 0-15.3 6.4-15.9 14.7zm-47.8-4c2.8-33.2 30.5-58.7 63.8-58.7h149.1c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zm125.8 59.9c2.9-4.1 7.5-6.6 12.6-6.6s9.7 2.5 12.6 6.6l33.3 48.1c6.6 9.5 10.1 20.8 10.1 32.4v.9c0 30.9-25.1 56-56 56s-56-25.1-56-56v-.9c0-11.6 3.5-22.9 10.1-32.4l33.3-48.1z"
        }
    ]
};

const FarPump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPump",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C74.7 0 64 10.7 64 24s10.7 24 24 24h8v160H48v-8c0-13.3-10.7-24-24-24S0 186.7 0 200v208c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h272v-48H48v-96h72c13.3 0 24-10.7 24-24V48h96v184c0 13.3 10.7 24 24 24h56v-48h-32V48h8c13.3 0 24-10.7 24-24S309.3 0 296 0H88zm370.5 146.7c2.6-1.8 5.7-2.7 8.9-2.7H576c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H467.4c-3.2 0-6.2-.9-8.9-2.7l-51.4-34.2c-4.4-3-7.1-8-7.1-13.3V194.3c0-5.3 2.7-10.3 7.1-13.3l51.4-34.3zm-26.6 354.6c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3v219.4c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3zM448 224c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarPumpkin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPumpkin",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 118.1V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l-46.1 105.3c-27.3 11.4-50.6 30.6-67 54.7-7.5 11-4.6 25.9 6.3 33.3s25.9 4.6 33.3-6.3c18.8-27.4 50.3-45.4 86-45.4s67.2 18 86 45.5c7.5 11 22.4 13.8 33.3 6.3s13.8-22.4 6.3-33.3c-15.4-22.5-36.7-40.7-61.7-52.4zm-210.7 26.8c12.8-16.9 28.5-31.5 46.4-43.2C176.4 98 164.4 96 152 96c-45.4 0-84 26.5-110.2 64.2C15.5 198 0 248.9 0 304s15.5 106 41.8 143.8C68 485.5 106.6 512 152 512c24.9 0 48-8.1 68-21.6 20 13.6 43.1 21.6 68 21.6s48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6 45.4 0 84-26.5 110.2-64.2C560.5 410 576 359.1 576 304s-15.5-106-41.8-143.8C508 122.5 469.4 96 424 96c-12.4 0-24.4 2-35.8 5.7 17.9 11.6 33.6 26.3 46.4 43.2 21.7 3.5 42.9 17.9 60.1 42.7 20 28.8 33.2 69.9 33.2 116.4s-13.2 87.6-33.2 116.4c-20 28.9-45.4 43.6-70.7 43.6-18 0-35.8-7.4-51.9-21.9-9.1-8.3-23-8.3-32.2 0C323.8 456.6 306 464 288 464s-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C187.8 456.6 170 464 152 464c-25.3 0-50.7-14.7-70.8-43.6C61.2 391.6 48 350.5 48 304s13.2-87.6 33.2-116.4c17.3-24.8 38.5-39.2 60.2-42.7z"
        }
    ]
};

const FarPuzzlePieceSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPuzzlePieceSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 112c-4.4 0-8 3.6-8 8v79.1c0 22.6-18.3 40.9-40.9 40.9-15 0-26.5-8.1-33.5-16.3-4.9-5.9-9.8-7.7-13.6-7.7-4 0-9.5 2.1-14.7 9.1S48 243 48 256s4 23.8 9.3 30.9S68 296 72 296c3.7 0 8.6-1.8 13.6-7.7 7-8.3 18.5-16.3 33.5-16.3 22.6 0 40.9 18.3 40.9 40.9V392c0 4.4 3.6 8 8 8h76.5c-2.9-7.4-4.5-15.5-4.5-24 0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24H472c4.4 0 8-3.6 8-8v-79.1c0-22.6 18.3-40.9 40.9-40.9 15 0 26.5 8.1 33.5 16.3 4.9 5.9 9.8 7.7 13.6 7.7 4 0 9.5-2.1 14.7-9.1S592 269 592 256s-4-23.8-9.3-30.9S572 216 568 216c-3.7 0-8.6 1.8-13.6 7.7-7 8.3-18.5 16.3-33.5 16.3-22.6 0-40.9-18.3-40.9-40.9V120c0-4.4-3.6-8-8-8h-76.5c2.9 7.4 4.5 15.5 4.5 24 0 43.1-39.4 72-80 72s-80-28.9-80-72c0-8.5 1.6-16.6 4.5-24H168zm-56 8c0-30.9 25.1-56 56-56h102.1c18.7 0 33.9 15.2 33.9 33.9 0 10.1-4.5 18.5-9.9 24.2-4.2 4.3-6.1 9.2-6.1 13.9 0 9.9 10.7 24 32 24s32-14.1 32-24c0-4.7-1.9-9.5-6.1-13.9-5.5-5.7-9.9-14.1-9.9-24.2 0-18.7 15.2-33.9 33.9-33.9H472c30.9 0 56 25.1 56 56v62.6c10.9-8.8 24.6-14.6 40-14.6 22.5 0 41 12.2 53.1 28.3S640 233.6 640 256s-6.8 43.5-18.9 59.7S590.5 344 568 344c-15.4 0-29.1-5.8-40-14.6V392c0 30.9-25.1 56-56 56H369.9c-18.7 0-33.9-15.2-33.9-33.9 0-10.1 4.5-18.5 9.9-24.2 4.2-4.3 6.1-9.2 6.1-13.9 0-9.9-10.7-24-32-24s-32 14.1-32 24c0 4.7 1.9 9.5 6.1 13.9 5.5 5.7 9.9 14.1 9.9 24.2 0 18.7-15.2 33.9-33.9 33.9H168c-30.9 0-56-25.1-56-56v-62.6c-10.9 8.8-24.6 14.6-40 14.6-22.5 0-41-12.2-53.1-28.3S0 278.4 0 256s6.8-43.5 18.9-59.7S49.5 168 72 168c15.4 0 29.1 5.8 40 14.6V120z"
        }
    ]
};

const FarPuzzlePiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPuzzlePiece",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M201.1 57.3c-7 5.2-9.1 10.7-9.1 14.7 0 4.2 2.4 10.1 10.4 15.6 7.8 5.3 13.6 14.6 13.6 25.6 0 17-13.8 30.7-30.7 30.7H56c-4.4 0-8 3.6-8 8v52.5c7.4-2.9 15.5-4.5 24-4.5 43.1 0 72 39.4 72 80s-28.9 80-72 80c-8.5 0-16.6-1.6-24-4.5V456c0 4.4 3.6 8 8 8h100.5c-2.9-7.4-4.5-15.5-4.5-24 0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24H360c4.4 0 8-3.6 8-8V326.7c0-17 13.8-30.7 30.7-30.7 11.1 0 20.3 5.8 25.6 13.6 5.5 8 11.4 10.4 15.6 10.4 4 0 9.5-2.1 14.7-9.1s9.3-17.9 9.3-30.9-4-23.8-9.3-30.9-10.7-9.1-14.7-9.1c-4.2 0-10.1 2.4-15.6 10.4-5.3 7.8-14.6 13.6-25.6 13.6-17 0-30.7-13.8-30.7-30.7V152c0-4.4-3.6-8-8-8h-81.3c-17 0-30.7-13.8-30.7-30.7 0-11.1 5.8-20.3 13.6-25.6 8-5.5 10.4-11.4 10.4-15.6 0-4-2.1-9.5-9.1-14.7S245 48 232 48s-23.8 4-30.9 9.3zm-28.8-38.4C188.5 6.8 209.6 0 232 0s43.5 6.8 59.7 18.9S320 49.5 320 72c0 8.6-1.8 16.7-4.9 24H360c30.9 0 56 25.1 56 56v44.9c7.3-3.1 15.4-4.9 24-4.9 22.5 0 41 12.2 53.1 28.3S512 257.6 512 280s-6.8 43.5-18.9 59.7S462.5 368 440 368c-8.6 0-16.7-1.8-24-4.9V456c0 30.9-25.1 56-56 56h-78.1c-18.7 0-33.9-15.2-33.9-33.9 0-10.1 4.5-18.5 9.9-24.2 4.2-4.3 6.1-9.2 6.1-13.9 0-9.9-10.7-24-32-24s-32 14.1-32 24c0 4.7 1.9 9.5 6.1 13.9 5.5 5.7 9.9 14.1 9.9 24.2 0 18.7-15.2 33.9-33.9 33.9H56c-30.9 0-56-25.1-56-56V329.9C0 311.2 15.2 296 33.9 296c10.1 0 18.5 4.5 24.2 9.9 4.3 4.2 9.2 6.1 13.9 6.1 9.9 0 24-10.7 24-32s-14.1-32-24-32c-4.7 0-9.5 1.9-13.9 6.1-5.7 5.4-14.1 9.9-24.2 9.9C15.2 264 0 248.8 0 230.1V152c0-30.9 25.1-56 56-56h92.9c-3.1-7.3-4.9-15.4-4.9-24 0-22.5 12.2-41 28.3-53.1z"
        }
    ]
};

const FarPuzzle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarPuzzle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 0c35.3 0 64 28.7 64 64v128c0 8.8-7.2 16-16 16h-52c-6.6 0-12 5.4-12 12v4c0 17.7-14.3 32-32 32s-32-14.3-32-32v-4c0-6.6-5.4-12-12-12h-36c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h16c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16c-8.8 0-16-7.2-16-16V16c0-8.8 7.2-16 16-16h128zM0 240V128c0-35.3 28.7-64 64-64h144c8.8 0 16 7.2 16 16v52c0 6.6 5.4 12 12 12h4c17.7 0 32 14.3 32 32s-14.3 32-32 32h-4c-6.6 0-12 5.4-12 12v52c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16c0 8.8-7.2 16-16 16H48v152c0 13.3 10.7 24 24 24h152v-36c0-6.6-5.4-12-12-12h-4c-17.7 0-32-14.3-32-32s14.3-32 32-32h4c6.6 0 12-5.4 12-12v-36c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-16c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v144c0 35.3-28.7 64-64 64H72c-39.8 0-72-32.2-72-72V240z"
        }
    ]
};

const FarQ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarQ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0 97.2 78.8 176 176 176 35.7 0 69-10.6 96.7-28.9l-91-107.6c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8l90.5 107C383.7 340.6 400 300.2 400 256c0-97.2-78.8-176-176-176S48 158.8 48 256zm303.9 183.9C315.6 465.2 271.5 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 58.9-22.7 112.5-59.9 152.4l54.2 64.1c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8l-53.8-63.6z"
        }
    ]
};

const FarQrcode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarQrcode",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80v96H48V80h96zM48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm96 304v96H48v-96h96zm-96-48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48H48zM304 80h96v96h-96V80zm-48 0v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48zM72 120v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H88c-8.8 0-16 7.2-16 16zm16 240c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H88zm240-240v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm-72 184v160c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm112 144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"
        }
    ]
};

const FarQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarQuestion",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 160c0-44.2 35.8-80 80-80h32c44.2 0 80 35.8 80 80v4.6c0 24.1-12 46.6-32.1 59.9l-52.3 34.9C149.4 274.2 136 299.2 136 326v2c0 13.3 10.7 24 24 24s24-10.7 24-24v-2c0-10.7 5.3-20.7 14.2-26.6l52.3-34.9c33.4-22.3 53.4-59.7 53.4-99.8V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 13.3 10.7 24 24 24s24-10.7 24-24zm96 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarQuoteLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarQuoteLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 216C0 149.7 53.7 96 120 96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-39.8 0-72 32.2-72 72v10c5.1-1.3 10.5-2 16-2h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V216zm48 72v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm336-16h-64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm-128 48V216c0-66.3 53.7-120 120-120h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-39.8 0-72 32.2-72 72v10c5.1-1.3 10.5-2 16-2h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64v-32z"
        }
    ]
};

const FarQuoteRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarQuoteRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 296c0 66.3-53.7 120-120 120h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c39.8 0 72-32.2 72-72v-10c-5.1 1.3-10.5 2-16 2h-64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v136zm-48-72v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16zM64 240h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16zm128-48v104c0 66.3-53.7 120-120 120H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c39.8 0 72-32.2 72-72v-10c-5.1 1.3-10.5 2-16 2H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32z"
        }
    ]
};

const FarQuotes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarQuotes",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8c-26.5 0-48 21.5-48 48h48c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V96zm48 72v24h48v-48H48v24zm128-72c0-53 43-96 96-96h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8c-26.5 0-48 21.5-48 48h48c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48h-48c-26.5 0-48-21.5-48-48V96zm48 48v48h48v-48h-48zm352 272c0 53-43 96-96 96h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c26.5 0 48-21.5 48-48h-48c-26.5 0-48-21.5-48-48v-48c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v96zm-48-48v-48h-48v48h48zm-128 48c0 53-43 96-96 96h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c26.5 0 48-21.5 48-48h-48c-26.5 0-48-21.5-48-48v-48c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v96zm-48-72v-24h-48v48h48v-24z"
        }
    ]
};

const FarR = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarR",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 32C25.1 32 0 57.1 0 88v368c0 13.3 10.7 24 24 24s24-10.7 24-24V304h109.9l118.6 165.9c7.7 10.8 22.7 13.3 33.5 5.6s13.3-22.7 5.6-33.5L214.5 300.6C274.9 286.7 320 232.6 320 168c0-75.1-60.9-136-136-136H56zm120 224H48V88c0-4.4 3.6-8 8-8h128c48.6 0 88 39.4 88 88s-39.4 88-88 88h-8z"
        }
    ]
};

const FarRabbitRunning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRabbitRunning",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M501.8 167.8c-8.6-5.9-17.8-10.8-27.4-14.6C457.6 98 413.6 54.9 357.5 39.6l-2.7-.8-6.4 23.2 6.3-23.1c-12.2-3.3-25.2-1.7-36.2 4.7l12 20.8-12-20.8-1.1.6c-20.2 11.7-29.8 35.7-23.1 58.1l7.8 26.3c1.2 4 2.5 8 4 11.9L249 119.7c-13.8-5-28.4-7.6-43.1-7.6h-12.2c-30.1 0-57.5 11.7-77.9 30.9-12.1-9.5-27.3-15-43.8-15-39.8 0-72 32.2-72 72s32.2 72 72 72c5.9 0 11.5-.7 17-2 6 14.1 14.8 27 26.1 37.8l37.7 36.1-28.3 18.9c-29.4 19.6-37.4 59.3-17.8 88.8s59.3 37.4 88.8 17.8l52.1-34.7 5.3 5.1c16.3 15.5 38.1 24.2 60.8 24.2H416c35.3 0 64-28.7 64-64 0-19.1-8.4-36.3-21.7-48h33.4c46.5 0 84.3-37.7 84.3-84.3 0-25.3-11.4-49.3-31-65.3L526.1 187c13.8-52.7-1.7-108.8-40.6-147l-1.4-1.4c-5.7-5.6-13.8-8-21.6-6.5l-1.6.3c-8.8 1.7-16 8.3-18.4 16.9-.8 2.8-1.5 5.5-2.1 8.3 28.7 25.3 49.7 59 59.4 97.4 1.1 4.2 1.7 8.5 2 12.7zM88.5 182.5c-5.1 12.4-8.1 25.9-8.4 40.1-2.5.9-5.2 1.4-8 1.4-13.3 0-24-10.7-24-24s10.7-24 24-24c6.4 0 12.2 2.5 16.5 6.5zm62.7 220.1 37.2-24.8 23.6 22.7-43.2 28.8c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2zm190.3-317 .9-.5 2.5.7c41.9 11.5 74.4 44.6 85.1 86.7.4 10.5 7.6 19.6 17.8 22.3 11.7 3.1 22.7 8.7 32.3 16.5l34.6 28.2c8.4 6.9 13.4 17.2 13.4 28.1 0 20-16.2 36.3-36.3 36.3H392c-6.4 0-12.5 2.5-17 7l-9.9 9.9c-9.7-43.6-43.3-79.2-88-90.4l-23.3-5.8c-12.9-3.2-25.9 4.6-29.1 17.5s4.6 25.9 17.5 29.1l23.3 5.8c32.1 8 54.5 36.8 54.5 69.8v13c0 13.3 10.7 24 24 24h72c8.8 0 16 7.2 16 16s-7.2 16-16 16H313.7c-10.3 0-20.2-4-27.6-11.1L148.3 273.1c-13-12.4-20.3-29.5-20.3-47.5 0-36.3 29.4-65.7 65.7-65.7H206c9.1 0 18.1 1.6 26.7 4.7l129.4 47.1c11 4 23.3-.5 29.1-10.7s3.4-23.1-5.7-30.5c-17.6-14.3-30.7-33.7-37.3-55.8l-7.8-26.3c-.3-1.1.1-2.2 1.1-2.8zM480 256a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FarRabbit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRabbit",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M245.7 0c-24.4 0-45.1 17.9-48.5 42.1l-.7 4.9c-7.8 54.3 8.4 108.9 43.5 150.1v20.6c-66.8 20.7-119.8 73-141.4 139.4-8.3-3.3-17.2-5.1-26.6-5.1-39.8 0-72 32.2-72 72s32.2 72 72 72c14.7 0 28.3-4.4 39.7-11.9 16.1 17.2 38.9 27.9 64.3 27.9h128c23.9 0 44.7-13.1 55.7-32.4l5.1 6.8c21.2 28.3 61.3 34 89.6 12.8s34-61.3 12.8-89.6L388 304c46.4-.1 84-37.8 84-84.3 0-25.3-11.4-49.3-31-65.3l-37-30.1c-5.6-4.5-11.5-8.6-17.6-12 10.1-24.8 13.6-52.1 9.8-79.4l-.9-6C393.1 11.4 379.9 0 364.3 0c-8.2 0-16.2 3.3-22 9.1l-2 2c-5.8 5.7-11 11.9-15.7 18.3 14.7 21.5 25.1 45.4 30.7 70.4-8.4-2.1-17-3.4-25.7-3.7-8.2-29.3-23.8-56.6-46.2-78.8l-3.1-3.1-16.9 16.9 16.8-16.9C271 5.1 258.6 0 245.7 0zm-157 406.7c-.4 5.7-.7 11.4-.7 17.3 0 5.6.5 11.1 1.5 16.4-4.4 4.7-10.6 7.6-17.5 7.6-13.3 0-24-10.7-24-24s10.7-24 24-24c6.5 0 12.4 2.6 16.7 6.7zm156-357.9c.1-.5.5-.9 1-.9.3 0 .5.1.7.3l3.1 3.1 16.8-16.9-16.8 17c20.4 20.2 33.2 46.2 37.2 73.7 1 6.7 4.7 12.6 10.3 16.4s12.5 5 19 3.5c2.7-.6 5.5-1 8.5-1 17.9 0 35.3 6.2 49.3 17.5l36.9 30.1c8.4 6.9 13.4 17.2 13.4 28.1 0 20-16.2 36.3-36.3 36.3H352c-13.3 0-24 10.7-24 24v16c0 5.2 1.7 10.2 4.8 14.4l96 128c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2l-68.6-91.4c-4.2-5.6-10.6-9-17.5-9.5s-13.8 2.1-18.7 7L271 391c-6.9 6.9-8.9 17.2-5.2 26.2S278.3 432 288 432h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-22.1 0-40-17.9-40-40 0-80.8 57-148.2 133-164.3 11.1-2.4 19-12.1 19-23.5v-48.3c0-6.1-2.4-12.1-6.6-16.5-29.6-31.3-43.6-74.6-37.4-117.6l.7-4.9zM352 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarRaccoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRaccoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 93.1c12.7-16.1 33.6-24.3 54.1-20.6C376.5 57 356.8 48 336 48s-40.5 9-54.1 24.5c20.5-3.6 41.4 4.5 54.1 20.6zm0 69.5c-2.6 3.4-5.7 6.5-9.1 9.2l-35.8 28.6c3.4 1.9 6.8 4 10.1 6.2l10.9 7.3c1.1-12.3 11.4-21.9 23.9-21.9s22.8 9.6 23.9 21.9l10.9-7.3c3.3-2.2 6.7-4.2 10.1-6.2l-35.8-28.6c-3.4-2.7-6.5-5.8-9.1-9.2zm78.8 23.9 31.9-9.6c5.6-1.7 9.4-6.8 9.4-12.6 0-2.8-.9-5.6-2.6-7.9l-17.8-23.7-42.9-25.7c-14.4-8.6-32.9-.4-36.2 16-1.8 8.9 1.5 18 8.6 23.7l49.6 39.7zm-107.9-39.7c7.1-5.7 10.4-14.8 8.6-23.7-3.3-16.4-21.9-24.7-36.2-16l-42.9 25.7-17.7 23.7c-1.7 2.3-2.6 5-2.6 7.9 0 5.8 3.8 10.9 9.4 12.6l31.9 9.6 49.6-39.7zM206.2 93.1l-12-35.8c-1.5-4.4-2.2-9.1-2.2-13.8 0-24 19.5-43.5 43.5-43.5h1.3c3.3 0 6.5.4 9.7 1.1l41 9.1C302.7 3.6 319.1 0 336 0s33.3 3.6 48.4 10.2l41-9.1c3.2-.7 6.5-1.1 9.7-1.1h1.3c24 0 43.5 19.5 43.5 43.5 0 4.7-.8 9.3-2.2 13.8l-11.9 35.8 25.9 34.6c7.9 10.6 12.2 23.5 12.2 36.7 0 27-17.7 50.8-43.6 58.5L425 233.5c-9.8 2.9-19.2 7.3-27.7 13l-18.8 12.6C366 267.5 351.2 272 336 272s-30-4.5-42.6-12.9l-18.8-12.6c-8.5-5.7-17.9-10.1-27.7-13l-35.3-10.6c-25.9-7.8-43.6-31.6-43.6-58.5 0-13.2 4.3-26.1 12.2-36.7l25.9-34.6zM144 241.9c4.7-4.5 9.6-8.8 14.6-12.8 11.3 10.9 25.2 19.2 40.9 24l6 1.8c-46.4 28-77.5 78.9-77.5 137.1 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-10.9.8-21.6 2.4-32H48v32c0 39.8 32.2 72 72 72h184v-8c0-13.3-10.7-24-24-24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c39.8 0 72 32.2 72 72v8h80v-8c0-13.3-10.7-24-24-24s-24-10.7-24-24 10.7-24 24-24c39.8 0 72 32.2 72 72v32c0 13.3-10.7 24-24 24H120C53.7 512 0 458.3 0 392V104c0-39.8 32.2-72 72-72s72 32.2 72 72v137.9zm-48 70V264H48v48h47.9l.1-.1zm0-95.9v-48H48v48h48zm211.3 148.4-64-40c-11.2-7-14.7-21.8-7.6-33.1s21.8-14.7 33.1-7.6l64 40c11.2 7 14.7 21.8 7.6 33.1s-21.8 14.7-33.1 7.6zm56.4-7.6c-7-11.2-3.6-26 7.6-33.1l64-40c11.2-7 26-3.6 33.1 7.6s3.6 26-7.6 33.1l-64 40c-11.2 7-26 3.6-33.1-7.6zM48 120h48v-16c0-13.3-10.7-24-24-24s-24 10.7-24 24v16zm240-8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarRacquet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRacquet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M349 48c31.9 0 61.1 10.9 82.6 32.4S464 131.2 464 163c0 40.6-17.7 84.9-52.9 120.1-64 64-154.5 68.7-202.7 20.5-21.5-21.5-32.4-50.8-32.4-82.6 0-40.6 17.7-84.9 52.9-120.1S308.4 48 349 48zm0-48c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 17.2 2.4 34.3 7.3 50.6 8.2 27.4 7.6 58.9-9.9 80.6-12.6-11.3-31.9-10.9-44 1.2l-72 72C-3 437.8-3 458.1 9.5 470.6l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.1-12.1 12.5-31.4 1.2-44 21.7-17.5 53.2-18 80.5-9.7 67.7 20.4 148.5-3.6 204.8-59.8 43.6-43.6 67-99.8 66.9-154 0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM54.6 448l49.4-49.4 9.4 9.4L64 457.4l-9.4-9.4z"
        }
    ]
};

const FarRadar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRadar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M316.4 161.7C299 150.5 278.2 144 256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112h48c0 78.2-56.1 143.3-130.3 157.2-7.3-8.1-17.9-13.2-29.7-13.2s-22.4 5.1-29.7 13.2c-64.5-12.1-115.4-63-127.5-127.5 8.1-7.3 13.2-17.9 13.2-29.7s-5.1-22.4-13.2-29.7C112.7 152.1 177.8 96 256 96c35.5 0 68.3 11.6 94.9 31.2L385.1 93C349.7 64.8 304.8 48 256 48 152.7 48 66.9 123.4 50.7 222.1 39.5 229.2 32 241.7 32 256s7.5 26.8 18.7 33.9c14.4 87.7 83.6 157 171.4 171.4 7.1 11.3 19.6 18.7 33.9 18.7s26.8-7.5 33.9-18.7C388.6 445.1 464 359.3 464 256h48c0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L463 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-182 182c3.3 7.7 5.1 16.1 5.1 25 0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l35.4-35.4z"
        }
    ]
};

const FarRadiation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRadiation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m113.2 104.7 41.9 72.5c-7.3 9.3-13.3 19.6-17.8 30.8H53.5c9.5-40.1 30.6-75.8 59.7-103.3zm83.1 350.6 41.9-72.6c5.8.8 11.8 1.2 17.8 1.2s11.9-.4 17.8-1.2l41.9 72.6c-18.9 5.7-38.9 8.7-59.7 8.7s-40.8-3-59.7-8.7zm202.5-350.6c29.1 27.5 50.2 63.1 59.7 103.3h-83.8c-4.5-11.1-10.5-21.5-17.8-30.8l41.9-72.5zM160 256c8.8 0 15.8-7.2 17.6-15.9 3.5-17.4 12.7-32.8 25.5-44.1 6.6-5.8 9.4-15.5 5-23.2L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1-.2 241.6 14.3 256 32 256h128zm48 83.2-64 110.9c-8.8 15.3-3.7 35.1 12.6 41.9 30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9l-64-110.9c-4.4-7.7-14.2-10.1-22.6-7.3-8 2.7-16.5 4.1-25.4 4.1s-17.4-1.4-25.4-4.1c-8.4-2.8-18.2-.4-22.6 7.3zm126.4-99.1c1.7 8.7 8.7 15.9 17.6 15.9h128c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10l-64 110.9c-4.4 7.6-1.7 17.3 5 23.2 12.8 11.3 22 26.7 25.5 44.1zM256 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarRadioTuner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRadioTuner",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M511.1 17.6c3.5 12.8-4 26-16.8 29.5L201.2 128H448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V188.6c0-32.4 21.6-60.8 52.9-69.4L481.6.9c12.8-3.5 26 4 29.5 16.8zM48 272v176c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V272H48zm256 96a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM96 320h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarRadio = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRadio",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M494.4 47.1c12.8-3.5 20.3-16.7 16.8-29.5S494.4-2.7 481.6.9L52.9 119.1C21.6 127.8 0 156.2 0 188.6V448c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H201.2l293.2-80.9zM48 192c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192zm304 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm-16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96z"
        }
    ]
};

const FarRainbow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRainbow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 88C169.8 88 48 209.8 48 360v96c0 13.3-10.7 24-24 24S0 469.3 0 456v-96C0 183.3 143.3 40 320 40s320 143.3 320 320v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-150.2-121.8-272-272-272zm0 224c-26.5 0-48 21.5-48 48v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-53 43-96 96-96s96 43 96 96v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-26.5-21.5-48-48-48zm-160 48v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-114.9 93.1-208 208-208s208 93.1 208 208v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
        }
    ]
};

const FarRaindrops = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRaindrops",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m105.9 106.6 41.9-67.8c2.6-4.2 7.2-6.8 12.2-6.8s9.6 2.6 12.2 6.8l41.9 67.8c6.5 10.5 9.9 22.6 9.9 34.9v2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.5c0-12.3 3.4-24.4 9.9-34.9zm-96 192 41.9-67.8c2.6-4.2 7.2-6.8 12.2-6.8s9.6 2.6 12.2 6.8l41.9 67.8c6.5 10.5 9.9 22.6 9.9 34.9v2.5c0 35.3-28.7 64-64 64S0 371.3 0 336v-2.5c0-12.3 3.4-24.4 9.9-34.9zm242.6 11.5c-8.2 12.7-12.5 27.6-12.5 42.7 0 43.4 35.9 79.2 80 79.2s80-35.8 80-79.2c0-15.1-4.3-30-12.5-42.7L320 204.6l-67.5 105.5zm-40.4-25.9 95.6-149.5c2.7-4.2 7.3-6.7 12.3-6.7s9.6 2.5 12.3 6.7l95.6 149.5c13.1 20.5 20.1 44.3 20.1 68.6C448 423 390.3 480 320 480s-128-57-128-127.2c0-24.3 7-48.1 20.1-68.6z"
        }
    ]
};

const FarRam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRam",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v24.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2V240c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80v-72.2l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21V64c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8.5-16 1.3V64c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-29.5 24.7c-8-10.3-19-18-31.8-21.9C268.8 65 262.5 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8-3.2-.5-6.5-.8-9.8-.8-35.3 0-64 28.7-64 64 0 5.3.7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64h1.5l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32v-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1l17.7-93.9h1.5c26.9 0 49.9-16.5 59.3-40H456c-14.2 0-27.7-2.8-40.1-8-.9 0-1.7-.1-2.4-.2-24.6-3.8-48 11.9-53.9 36-1.7 7-8.1 12.1-15.5 12.1-3.8 0-7.2-1.3-9.9-3.4-20.1-16-49.1-13.3-66 6-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5c-16.9-19.3-45.9-21.9-66-6-2.7 2.2-6.1 3.4-9.9 3.4-7.5 0-13.8-5.1-15.5-12.1-5.9-24.2-29.3-39.8-53.9-36-.8.1-1.6.2-2.5.2-8.8 0-16-7.2-16-16 0-1.4.2-2.7.5-3.9 5.3-21.3-4.6-43.6-24-53.9-5.4-2.8-8.7-8.2-8.7-14.2s3.3-11.4 8.5-14.2c19.4-10.4 29.3-32.6 24-53.9a16 16 0 0 1-.5-3.9c0-8.8 7.2-16 16-16 .9 0 1.7.1 2.5.2 24.6 3.8 48-11.9 53.9-36 1.7-7 8.1-12.1 15.5-12.1 3.8 0 7.2 1.3 9.9 3.5 20.1 16 49.1 13.3 66-6 3-3.4 7.3-5.5 12.1-5.5 5.3 0 10 2.5 13 6.7 8.6 11.9 22 19.2 36.6 19.9 2.5-10 7.7-19.3 15.2-26.6-6.5-6.4-11.5-14.3-14.3-23.3zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarRampLoading = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRampLoading",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 48h256c8.8 0 16 7.2 16 16v248.4l48 88V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v336.4l48-88V64c0-8.8 7.2-16 16-16zm67 240c-20.5 0-39.3 11.2-49.2 29.2l-74 135.7C25.3 479.5 44.6 512 75 512h298c30.4 0 49.7-32.5 35.1-59.2l-74-135.7c-9.8-18-28.7-29.2-49.2-29.2H163zm-7 52.2c1.4-2.6 4.1-4.2 7-4.2h122c2.9 0 5.6 1.6 7 4.2L359.6 464H88.4L156 340.2z"
        }
    ]
};

const FarRankingStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRankingStar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m353.8 54.1 52.3 7.5c9.3 1.4 13.2 12.9 6.4 19.8l-38 36.6 9 52.1c1.4 9.3-8.2 16.5-16.8 12.2l-46.6-24.4-46.9 24.8c-8.6 4.3-18.3-2.9-16.8-12.2l9-52.1-38-37c-6.8-6.8-2.9-18.3 6.4-19.8l52.3-7.5 23.7-47.8c4.3-8.6 16.5-8.3 20.4 0l23.6 47.8zM272 304v160h96V304h-96zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V304zM48 368v96h96v-96H48zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96zm592 32h-96v64h96v-64zm-96-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FarRaygun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRaygun",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64h-96L102.2 4.1C98.2 1.4 93.4 0 88.6 0 75 0 64 11 64 24.6v50.2C26.2 92.8 0 131.3 0 176c0 59.3 46.1 107.8 104.4 111.7l-69 137.9c-7.9 15.8-1.5 35 14.3 42.9l80 40c15.8 7.9 35 1.5 42.9-14.3l103-206 .2-.3H288v8c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8zm-176 48h176v128H112c-35.3 0-64-28.7-64-64s28.7-64 64-64zm280-48c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24s24-10.7 24-24v-56h60.9l77.1 30.9c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2V128c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L476.9 144H416V88c0-13.3-10.7-24-24-24zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-10 112.3-85.2 170.2-51.3-25.7 72.3-144.5H222z"
        }
    ]
};

const FarReceipt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarReceipt",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M39.6 5.8C32.5-.3 22.5-1.7 14 2.2S0 14.6 0 24v464c0 9.4 5.5 17.9 14 21.8s18.5 2.5 25.6-3.6L80 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0l40.4-34.6 40.4 34.6c9 7.7 22.3 7.7 31.2 0l40.4-34.6 40.4 34.6c7.1 6.1 17.1 7.5 25.6 3.6s14-12.4 14-21.8V24c0-9.4-5.5-17.9-14-21.8s-18.5-2.5-25.6 3.6L304 40.4 263.6 5.8c-9-7.7-22.3-7.7-31.2 0L192 40.4 151.6 5.8c-9-7.7-22.3-7.7-31.2 0L80 40.4 39.6 5.8zm8.4 430V76.2l16.4 14c9 7.7 22.3 7.7 31.2 0L136 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L248 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0l16.4-14v359.6l-16.4-14c-9-7.7-22.3-7.7-31.2 0L248 456.4l-40.4-34.6c-9-7.7-22.3-7.7-31.2 0L136 456.4l-40.4-34.6c-9-7.7-22.3-7.7-31.2 0l-16.4 14zM120 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm-24-64c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarRecordVinyl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRecordVinyl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm120 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarRectangleAd = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleAd",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm229.5 77.3 72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-5.4-10.8h-90.4l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7 186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v144c0 13.3-10.7 24-24 24-6.6 0-12.6-2.7-17-7-9.4 4.5-19.9 7-31 7-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
        }
    ]
};

const FarRectangleBarcode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleBarcode",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm120 32c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 0c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24s24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm136-24c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 16c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144z"
        }
    ]
};

const FarRectangleCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h384zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm223 143c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0zm-62 34c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
        }
    ]
};

const FarRectangleHistoryCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleHistoryCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h284.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h384c23.8 0 44.5 12.9 55.5 32.2-2.5-.1-5-.2-7.5-.2-26.2 0-51.1 5.7-73.4 16H64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h368zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h272zm104 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FarRectangleHistoryCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleHistoryCircleUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464h284.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h384c23.8 0 44.5 12.9 55.5 32.2-2.5-.1-5-.2-7.5-.2-26.2 0-51.1 5.7-73.4 16H64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h368zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h272zm-40 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7h-65.2c-21 0-38.9 13.7-45.1 32.7 20.2 19.4 47.5 31.3 77.7 31.3s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarRectangleHistory = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleHistory",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 224c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V224zm-16-64c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h384zm-8-80c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h368zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h272z"
        }
    ]
};

const FarRectangleList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleList",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm104 0c0-13.3 10.7-24 24-24h224c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24h224c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24h224c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-32 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarRectanglePro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectanglePro",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm104 64h56c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v32h32zm80-56c0-13.3 10.7-24 24-24h56c35.3 0 64 28.7 64 64 0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1s-26 3.6-33.1-7.6l-33-52.7H288v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V184zm48 56h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v32zm200-80c48.6 0 88 39.4 88 88v16c0 48.6-39.4 88-88 88s-88-39.4-88-88v-16c0-48.6 39.4-88 88-88zm-40 88v16c0 22.1 17.9 40 40 40s40-17.9 40-40v-16c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
        }
    ]
};

const FarRectangleTerminal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleTerminal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h384zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm38.3 119.8c-9 9.8-8.3 25 1.5 33.9l76.7 70.3-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM248 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
        }
    ]
};

const FarRectangleVerticalHistory = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleVerticalHistory",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H256zm-64 16c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zm-96 8c0-13.3 10.7-24 24-24s24 10.7 24 24v368c0 13.3-10.7 24-24 24s-24-10.7-24-24V72zM0 120c0-13.3 10.7-24 24-24s24 10.7 24 24v272c0 13.3-10.7 24-24 24S0 405.3 0 392V120z"
        }
    ]
};

const FarRectangleVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleVertical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16v384zm48-384c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64z"
        }
    ]
};

const FarRectangleWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleWide",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 112c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h512zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarRectangleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangleXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarRectangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectangle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 112c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h384zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarRectanglesMixed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRectanglesMixed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 80c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h192zM64 32C28.7 32 0 60.7 0 96v96c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm448 48c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h64zm-64-48c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64h-64zM128 352h144c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16zm-64 16v48c0 35.3 28.7 64 64 64h144c35.3 0 64-28.7 64-64v-48c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FarRecycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRecycle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M181.5 40.9C197.7 15.3 226 0 256 0s58.3 15.3 74.5 40.9l62.3 98.1 6.6-31.8c2.7-13 15.4-21.3 28.3-18.7s21.3 15.4 18.7 28.3L427 211.2c-1.4 6.7-5.6 12.5-11.5 15.9s-13.1 4.2-19.6 2l-91.4-30.4c-12.6-4.2-19.4-17.8-15.2-30.3s17.8-19.4 30.3-15.2l32.2 10.7L290 66.6C282.7 55.1 269.8 48 256 48s-26.7 7.1-34 18.6l-21.5 33.9c-7 11-21.4 14.4-32.6 7.7-11.6-6.9-15.1-22-7.9-33.4l21.5-33.9zM439 255.5c11.2-6.7 25.6-3.3 32.6 7.7l26.8 42.2c8.8 13.9 13.5 30 13.6 46.4.3 48.6-39 88.2-87.6 88.2H287.2l24.8 22c9.9 8.8 10.8 24 2 33.9s-24 10.8-33.9 2l-72-64c-5.1-4.6-8.1-11.1-8.1-17.9s2.9-13.4 8.1-17.9l72-64c9.9-8.8 25.1-7.9 33.9 2s7.9 25.1-2 33.9l-24.9 22h137.3c22 0 39.8-17.9 39.6-39.9 0-7.4-2.2-14.7-6.2-21L431 288.9c-7.2-11.4-3.6-26.5 7.9-33.4zm-311.6 3.7-6.7-32.8-66.5 104.7c-4 6.3-6.1 13.6-6.2 21-.1 22 17.7 39.9 39.6 39.9H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H87.6C39 440-.3 400.5 0 351.9c.1-16.4 4.8-32.5 13.6-46.4l65.2-102.7-31.2 10.3c-12.6 4.2-26.2-2.6-30.3-15.2s2.6-26.2 15.2-30.3l91.4-30.4c6.5-2.2 13.6-1.4 19.6 2s10.1 9.2 11.5 15.9l19.4 94.4c2.7 13-5.7 25.7-18.7 28.3s-25.7-5.7-28.3-18.7z"
        }
    ]
};

const FarReel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarReel",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h40v40c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24V48h40c13.3 0 24-10.7 24-24S437.3 0 424 0H24zm80 72V48h240v24H104zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-40c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24v40H24zm320 0H104v-24h240v24zM80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
        }
    ]
};

const FarRefrigerator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRefrigerator",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48c26.5 0 48 21.5 48 48v64h-48v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H48V96c0-26.5 21.5-48 48-48h192zm-48 160v136c0 13.3 10.7 24 24 24s24-10.7 24-24V208h48v240c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208h192zM96 0C43 0 0 43 0 96v352c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V96c0-53-43-96-96-96H96z"
        }
    ]
};

const FarRegistered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRegistered",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-360v208c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h60.9l37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8l-34.1-75c21.8-14.3 36.3-39 36.3-67 0-44.2-35.8-80-80-80h-88c-13.3 0-24 10.7-24 24zm48 88v-64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64z"
        }
    ]
};

const FarRepeat1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRepeat1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 254.8C-.6 268 9.6 279.3 22.8 280s24.5-9.5 25.2-22.8l.4-8C52 176.8 111.7 120 184.2 120H304v36.4c0 19.6 15.9 35.6 35.6 35.6 8.8 0 17.3-3.3 23.8-9.1l76.7-69c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-76.7-69c-6.5-5.9-15-9.1-23.8-9.1C319.9 0 304 15.9 304 35.6V72H184.2C86.2 72 5.3 148.9.4 246.8l-.4 8zM388.1 96 352 128.5v-65L388.1 96zM512 257.2c.7-13.2-9.5-24.5-22.8-25.2s-24.5 9.5-25.2 22.8l-.4 8C460 335.2 400.3 392 327.8 392H208v-36.4c0-19.6-15.9-35.6-35.6-35.6-8.8 0-17.3 3.3-23.8 9.1l-76.7 69c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l76.7 69c6.5 5.9 15 9.1 23.8 9.1 19.6 0 35.6-15.9 35.6-35.6V440h119.8c98 0 178.9-76.9 183.8-174.8l.4-8zM123.9 416l36.1-32.5v65L123.9 416zM288 208c0-9.1-5.1-17.4-13.3-21.5s-17.9-3.2-25.1 2.3l-32 24c-10.6 8-12.8 23-4.8 33.6 6.5 8.6 17.6 11.6 27.2 8.2V304c0 13.3 10.7 24 24 24s24-10.7 24-24v-96z"
        }
    ]
};

const FarRepeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRepeat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M22.8 280C9.6 279.3-.6 268 0 254.8l.4-8C5.3 148.9 86.2 72 184.2 72H304V35.6C304 15.9 319.9 0 339.6 0c8.8 0 17.3 3.3 23.8 9.1l76.7 69c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-76.7 69c-6.5 5.9-15 9.1-23.8 9.1-19.6 0-35.6-15.9-35.6-35.6V120H184.2C111.7 120 52 176.8 48.4 249.2l-.4 8c-.7 13.2-12 23.4-25.2 22.8zM352 128.5 388.1 96 352 63.5v65zM489.2 232c13.2.7 23.4 11.9 22.8 25.2l-.4 8C506.7 363.1 425.8 440 327.8 440H208v36.4c0 19.6-15.9 35.6-35.6 35.6-8.8 0-17.3-3.3-23.8-9.1l-76.7-69c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l76.7-69c6.5-5.9 15-9.1 23.8-9.1 19.6 0 35.6 15.9 35.6 35.6V392h119.8c72.5 0 132.2-56.8 135.8-129.2l.4-8c.7-13.2 11.9-23.4 25.2-22.8zM160 383.5 123.9 416l36.1 32.5v-65z"
        }
    ]
};

const FarReplyAll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarReplyAll",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208.5 73.4c9.6-9.1 10-24.3.9-33.9s-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6l141.7 134.6c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4zM352 240h-24c-13.3 0-24 10.7-24 24v52.1L183.9 208 304 99.9V152c0 13.3 10.7 24 24 24h72c70.7 0 128 57.3 128 128 0 15.3-1.9 29.1-5.2 41.5C506 284.7 450.2 240 384 240h-32zm0 96v-48h32c5.4 0 10.8.5 16 1.3 45.4 7.6 80 47.1 80 94.7 0 17.3-4.2 30.5-9.5 40.2-1.6 2.9-3.3 5.5-5 7.9-2.6 3.5-5.3 6.4-7.7 8.6-.5.5-1 .9-1.4 1.4-4.8 4.9-8.3 11.3-8.3 18.1 0 10.9 8.8 19.7 19.7 19.7 2.8 0 5.6-.6 8.1-1.9 2.6-1.4 6.3-3.5 10.8-6.5 2.7-1.8 5.7-3.8 8.9-6.2 3.7-2.7 7.6-5.8 11.7-9.3 30.1-25.8 68.7-74 68.7-152 0-97.2-78.8-176-176-176h-48V64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2v-16z"
        }
    ]
};

const FarReplyClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarReplyClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 144a144 144 0 1 0-288 0 144 144 0 1 0 288 0zM496 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm16 272c0-5.6-.3-11.2-.8-16.6-5 .4-10.1.6-15.2.6-11.4 0-22.6-1.1-33.4-3.2.9 6.2 1.4 12.6 1.4 19.2 0 15.3-1.9 29.1-5.2 41.5C442 316.7 386.2 272 320 272H200c-13.3 0-24 10.7-24 24v52.1L55.9 240 176 131.9V184c0 13.3 10.7 24 24 24h132c-5.9-15.1-9.8-31.2-11.3-48H224V96c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2v-64h96c53 0 96 43 96 96 0 17.3-4.2 30.5-9.5 40.2-1.6 2.9-3.3 5.5-5 7.9-2.6 3.5-5.3 6.4-7.7 8.6-.5.5-1 .9-1.4 1.4-4.8 4.9-8.3 11.3-8.3 18.1 0 10.9 8.8 19.7 19.7 19.7 2.8 0 5.6-.6 8.1-1.9 2.6-1.4 6.3-3.5 10.8-6.5 2.7-1.8 5.7-3.8 8.9-6.2 3.7-2.7 7.6-5.8 11.7-9.3 30.1-25.8 68.7-74.1 68.7-152z"
        }
    ]
};

const FarReply = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarReply",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 240h96c66.2 0 122 44.7 138.8 105.5 3.3-12.4 5.2-26.2 5.2-41.5 0-70.7-57.3-128-128-128H200c-13.3 0-24-10.7-24-24V99.9L55.9 208 176 316.1V264c0-13.3 10.7-24 24-24h24zm0 48v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2v64h112c97.2 0 176 78.8 176 176 0 78-38.6 126.2-68.7 152.1-4.1 3.5-8.1 6.6-11.7 9.3-3.2 2.4-6.2 4.4-8.9 6.2-4.5 3-8.3 5.1-10.8 6.5-2.5 1.4-5.3 1.9-8.1 1.9-10.9 0-19.7-8.9-19.7-19.7 0-6.8 3.6-13.2 8.3-18.1l1.4-1.4c2.4-2.3 5.1-5.1 7.7-8.6 1.7-2.3 3.4-5 5-7.9 5.3-9.7 9.5-22.9 9.5-40.2 0-53-43-96-96-96h-96z"
        }
    ]
};

const FarRepublican = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRepublican",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 32C68.1 32 0 100.1 0 184v240c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56v-40h160v40c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56v-40h48v24c0 39.8 32.2 72 72 72s72-32.2 72-72v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-83.9-68.1-152-152-152H152zm344 256v48h-72c-13.3 0-24 10.7-24 24v64c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8v-64c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v64c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V288h448zm0-48H48v-56c0-57.4 46.6-104 104-104h240c57.4 0 104 46.6 104 104v56zm-90.3-124.6c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4L381.7 140l-28.2 4c-2.4.3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3.6 4.7 2.5 6s4.6 1.6 6.7.5l25.2-12.8 25.2 12.8c2.2 1.1 4.8.9 6.7-.5s3-3.7 2.5-6l-4.8-27.1 20.5-19.2c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM271.9 112c-2.4 0-4.7 1.3-5.7 3.4L253.6 140l-28.2 4c-2.4.3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3.6 4.7 2.5 6s4.6 1.6 6.7.5l25.2-12.8 25.2 12.8c2.2 1.1 4.8.9 6.7-.5s3-3.7 2.5-6l-4.8-27.1 20.6-19.2c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-122.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4L125.6 140l-28.2 4c-2.4.3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3.6 4.7 2.5 6s4.6 1.6 6.7.5l25.2-12.8 25.2 12.8c2.2 1.1 4.8.9 6.7-.5s3-3.7 2.5-6l-4.8-27.1 20.6-19.2c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6z"
        }
    ]
};

const FarRestroomSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRestroomSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM73.7 237.3C75.1 220.8 89 208 105.6 208h44.8c16.6 0 30.5 12.8 31.9 29.3l4.1 49.3c.8 9.3-6.6 17.3-15.9 17.3H85.6c-9.4 0-16.7-8-15.9-17.3l4.1-49.3zM112 352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4h-44.8c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352zM320 0c-13.3 0-24 10.7-24 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm256 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-79.7 144h31.4c7.1 0 13.4 4.7 15.4 11.6L576.4 336H447.6l33.3-116.4c2-6.9 8.2-11.6 15.4-11.6zm0-48c-28.6 0-53.7 18.9-61.5 46.4l-39.1 136.8c-5.8 20.4 9.5 40.8 30.8 40.8H448v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h32v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.8-27.5-33-46.4-61.5-46.4h-31.5z"
        }
    ]
};

const FarRestroom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRestroom",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-7.3 80h14.6c3 0 5.9.3 8.7 1v127h-32V177c2.8-.6 5.7-1 8.7-1zM112 488V352h32v136c0 13.3 10.7 24 24 24s24-10.7 24-24V251.4l17.6 45.3c4.8 12.4 18.7 18.5 31.1 13.7s18.5-18.7 13.7-31.1l-37-95.2c-13.2-33.8-45.7-56.1-82-56.1h-14.7c-36.3 0-68.9 22.3-82 56.1L1.6 279.3c-4.8 12.4 1.3 26.3 13.7 31.1s26.3-1.3 31.1-13.7L64 251.4V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM320 0c-13.3 0-24 10.7-24 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm240 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 80c-40.7 0-77.2 25-92 62.9l-34.4 88.4c-4.8 12.4 1.3 26.3 13.7 31.1 7.6 3 15.8 1.8 22.1-2.5l-15.7 55.8c-2.9 10.2 4.8 20.3 15.4 20.3H448v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h32v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h26.9c10.6 0 18.3-10.1 15.4-20.3l-15.7-55.8c6.3 4.2 14.5 5.4 22.1 2.5 12.4-4.8 18.5-18.7 13.7-31.1L604 190.9C589.2 153 552.7 128 512 128zm0 48c2.2 0 4 1.4 4.6 3.5l44 156.5h-97.2l44-156.5a4.8 4.8 0 0 1 4.6-3.5z"
        }
    ]
};

const FarRetweet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRetweet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 208h31c22.6 0 41-18.3 41-41 0-10.9-4.3-21.3-12-29l-67-67c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-67 67c-7.7 7.7-12 18.1-12 29 0 22.6 18.3 41 41 41h31v120c0 48.6 39.4 88 88 88h136c13.3 0 24-10.7 24-24s-10.7-24-24-24H160c-22.1 0-40-17.9-40-40V208zm-24-86.1 38.1 38.1H58l38-38.1zM504 304V184c0-48.6-39.4-88-88-88H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h136c22.1 0 40 17.9 40 40v120h-31c-22.6 0-41 18.3-41 41 0 10.9 4.3 21.3 12 29l67 67c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l67-67c7.7-7.7 12-18.1 12-29 0-22.6-18.3-41-41-41h-31zm-24 86.1L441.9 352H518l-38 38.1z"
        }
    ]
};

const FarRhombus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRhombus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 52.3 50.5 256 224 459.7 397.5 256 224 52.3zM9.6 230.1l184-216C201.2 5.1 212.3 0 224 0s22.8 5.1 30.4 14.1l184 216c12.7 14.9 12.7 36.9 0 51.9l-184 216c-7.6 8.9-18.7 14.1-30.4 14.1s-22.8-5.1-30.4-14.1L9.6 282c-12.8-15-12.8-37 0-51.9z"
        }
    ]
};

const FarRibbon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRibbon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m6.5 415.6 96.6-103.4 32.9 35.2-75.5 80.8 40.3 28.2 68.5-73.3 32.8 35.1-80.5 86.2c-8.2 8.7-21.5 10.1-31.3 3.3l-80-56c-5.7-4-9.4-10.2-10.1-17.2s1.6-13.8 6.3-18.9zm239.4-256.2 7-7.5c12.3-13.1 19.1-30.4 19.1-48.4 0-15.3-5-30.2-14.1-42.5l-9.3-12.5c-7.3-.4-15.5-.6-24.4-.6V0c14.8 0 27.9.6 39 1.5 9.1.7 17 1.7 23.5 2.6 21.2 3.1 38.2 15.4 49.5 30.6l40.2 53.6c15.4 20.6 23.7 45.6 23.7 71.3 0 30.1-11.4 59.1-32 81.2l-23 24.6-32.8-35.2 20.6-22.2c12.3-13.1 19.1-30.4 19.1-48.4 0-15.3-5-30.2-14.2-42.5l-18.3-24.5c.3 3.6.5 7.3.5 11 0 30.1-11.4 59.1-32 81.2l-9.2 9.8-32.8-35.2zM224 48c-8.9 0-17.1.2-24.4.6l-9.3 12.5c-9.2 12.3-14.1 27.2-14.1 42.5 0 18 6.8 35.3 19.1 48.4l246.2 263.6c4.7 5.1 7.1 12 6.3 18.9s-4.4 13.2-10.1 17.2l-80 56c-9.8 6.9-23.1 5.5-31.3-3.3L80.1 240.7c-20.6-22-32-51-32-81.2 0-25.7 8.3-50.7 23.7-71.3L112 34.7c11.4-15.2 28.4-27.5 49.5-30.6 6.6-1 14.4-1.9 23.5-2.6C196.1.6 209.2 0 224 0v48zm-113.8 69.1c-9.2 12.3-14.1 27.2-14.1 42.5 0 18 6.8 35.3 19.1 48.4l232.1 248.4 40.3-28.2-227.5-243.5c-20.6-22-32-51-32-81.2 0-3.7.2-7.4.5-11L110.2 117z"
        }
    ]
};

const FarRightFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRightFromBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 146.2 462 256 352 365.8V312c0-13.3-10.7-24-24-24H208v-64h120c13.3 0 24-10.7 24-24v-53.8zM512 256c0-11.5-4.6-22.5-12.7-30.6L383.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6-25.6 0-46.4 20.8-46.4 46.4V176h-96c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h96v33.6c0 25.6 20.8 46.4 46.4 46.4 12.3 0 24.1-4.9 32.8-13.6l116.1-115.8c8.1-8.1 12.7-19.1 12.7-30.6zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H88C39.4 32 0 71.4 0 120v272c0 48.6 39.4 88 88 88h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-22.1 0-40-17.9-40-40V120c0-22.1 17.9-40 40-40h80z"
        }
    ]
};

const FarRightFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRightFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 146.2 398 256 288 365.8V312c0-13.3-10.7-24-24-24H144v-64h120c13.3 0 24-10.7 24-24v-53.8zM448 256c0-11.5-4.6-22.5-12.7-30.6L319.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6-25.6 0-46.4 20.8-46.4 46.4V176h-96c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h96v33.6c0 25.6 20.8 46.4 46.4 46.4 12.3 0 24.1-4.9 32.8-13.6l116.1-115.8c8.1-8.1 12.7-19.1 12.7-30.6zM48 88c0-13.3-10.7-24-24-24S0 74.7 0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V88z"
        }
    ]
};

const FarRightLeftLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRightLeftLarge",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.1 504c-15.4 0-30.1-6.1-41-17L20.7 366.6C12.6 358.5 8 347.5 8 336s4.6-22.5 12.7-30.6L141.1 185c10.9-10.9 25.6-17 41-17 32 0 57.9 25.9 57.9 57.9v6.1h192c8.8 0 16 7.2 16 16v38.1c0 5.5 4.5 9.9 9.9 9.9 2.6 0 5.2-1 7-2.9L582.1 176 465 58.9c-1.9-1.9-4.4-2.9-7-2.9-5.5 0-9.9 4.5-9.9 9.9V104c0 8.8-7.2 16-16 16H320c-13.3 0-24-10.7-24-24s10.7-24 24-24h80v-6.1c0-32 25.9-57.9 57.9-57.9 15.4 0 30.1 6.1 41 17l120.4 120.4c8.1 8.1 12.7 19.1 12.7 30.6s-4.6 22.5-12.7 30.6L498.9 327c-10.9 10.9-25.6 17-41 17-32 0-57.9-25.9-57.9-57.9V280H208c-8.8 0-16-7.2-16-16v-38.1c0-5.5-4.5-9.9-9.9-9.9-2.6 0-5.2 1-7 2.9L57.9 336 175 453.1c1.9 1.9 4.4 2.9 7 2.9 5.5 0 9.9-4.5 9.9-9.9V408c0-8.8 7.2-16 16-16h112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80v6.1c0 32-25.9 57.9-57.9 57.9z"
        }
    ]
};

const FarRightLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRightLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 215c0 22.6 18.3 41 41 41 10.9 0 21.3-4.3 29-12l99-99c4.5-4.5 7-10.6 7-17s-2.5-12.5-7-17l-99-99c-7.7-7.7-18.1-12-29-12-22.6 0-41 18.3-41 41v63H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h312v63zm118.1-87L384 198.1V57.9l70.1 70.1zM135 256c-10.9 0-21.3 4.3-29 12L7 367c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17l99 99c7.7 7.7 18.1 12 29 12 22.6 0 41-18.3 41-41v-63h312c13.3 0 24-10.7 24-24s-10.7-24-24-24H176v-63c0-22.6-18.3-41-41-41zm-7 198.1L57.9 384l70.1-70.1v140.2z"
        }
    ]
};

const FarRightLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRightLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v336c0 13.3 10.7 24 24 24s24-10.7 24-24V88zM505.5 272.4c8.7-9.2 8.7-23.7 0-32.9l-121.4-129c-8.8-9.3-21-14.6-33.7-14.6-25.6 0-46.3 20.7-46.3 46.3v33.7L56 176c-30.9 0-56 25.1-56 56v48c0 30.9 25.1 56 56 56h248v33.7c0 25.6 20.7 46.3 46.3 46.3 12.8 0 25-5.3 33.7-14.6l121.4-129zM352 200v-53.5L455 256 352 365.5V312c0-13.3-10.7-24-24-24H56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h272c13.3 0 24-10.7 24-24z"
        }
    ]
};

const FarRightLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRightLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505.5 239.6c8.7 9.2 8.7 23.7 0 32.9l-121.4 129c-8.8 9.3-21 14.6-33.7 14.6-25.6 0-46.3-20.7-46.3-46.3v-33.7L56 336c-30.9 0-56-25.1-56-56v-48c0-30.9 25.1-56 56-56h248v-33.7c0-25.6 20.7-46.3 46.3-46.3 12.8 0 25 5.3 33.7 14.6l121.4 129zM352 146.5V200c0 13.3-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h272c6.4 0 12.5 2.5 17 7s7 10.6 7 17v53.5L455 256 352 146.5z"
        }
    ]
};

const FarRightToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRightToBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 365.8 302 256 192 146.2V200c0 13.3-10.7 24-24 24H48v64h120c13.3 0 24 10.7 24 24v53.8zM352 256c0 11.5-4.6 22.5-12.7 30.6L223.2 402.4c-8.7 8.7-20.5 13.6-32.8 13.6-25.6 0-46.4-20.8-46.4-46.4V336H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h96v-33.6c0-25.6 20.8-46.4 46.4-46.4 12.3 0 24.1 4.9 32.8 13.6l116.1 115.8c8.1 8.1 12.7 19.1 12.7 30.6zm-8 176h80c22.1 0 40-17.9 40-40V120c0-22.1-17.9-40-40-40h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c48.6 0 88 39.4 88 88v272c0 48.6-39.4 88-88 88h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarRightToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRightToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 146.2 302 256 192 365.8V312c0-13.3-10.7-24-24-24H48v-64h120c13.3 0 24-10.7 24-24v-53.8zM352 256c0-11.5-4.6-22.5-12.7-30.6L223.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6-25.6 0-46.4 20.8-46.4 46.4V176H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h96v33.6c0 25.6 20.8 46.4 46.4 46.4 12.3 0 24.1-4.9 32.8-13.6l116.1-115.8c8.1-8.1 12.7-19.1 12.7-30.6zm48-168v336c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FarRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M397.6 256 247.7 398.7c-.8.8-2 1.3-3.2 1.3-2.5 0-4.6-2-4.6-4.6V312c0-13.3-10.7-24-24-24H48v-64h168c13.3 0 24-10.7 24-24v-83.4c0-2.5 2-4.6 4.6-4.6 1.2 0 2.3.5 3.2 1.3L397.6 256zm-153 192c13.5 0 26.5-5.2 36.3-14.5l153.9-146.6c8.5-8.1 13.2-19.2 13.2-30.9s-4.8-22.8-13.2-30.9l-154-146.6c-9.7-9.3-22.7-14.5-36.2-14.5-29 0-52.6 23.5-52.6 52.6V176H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h144v59.4c0 29 23.5 52.6 52.6 52.6z"
        }
    ]
};

const FarRingDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRingDiamond",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c-8 0-15.5 4-20 10.7l-32 48c-5 7.5-5.4 17.1-1 25l31.8 57.2C51 168.6 0 238.4 0 320c0 106 86 192 192 192s192-86 192-192c0-81.6-51-151.4-122.8-179.1L293 83.7c4.4-7.9 4-17.5-1-25l-32-48C255.5 4 248 0 240 0h-96zm68.8 129.1c-6.8-.7-13.8-1.1-20.8-1.1s-14 .4-20.8 1.1l-31.1-56L156.8 48h70.3l16.8 25.1-31.1 56zM48 320a144 144 0 1 1 288 0 144 144 0 1 1-288 0z"
        }
    ]
};

const FarRing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRing",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M59.7 168c8.9-9.4 22.9-19 42.1-27.6C140 123.2 194.5 112 256 112s116 11.2 154.2 28.4c19.1 8.6 33.2 18.2 42.1 27.6 8.8 9.3 11.7 17.4 11.7 24s-2.9 14.7-11.7 24c-.8.9-1.7 1.7-2.5 2.6C402.4 191.8 332.2 176 256 176s-146.4 15.8-193.8 42.6c-.9-.9-1.7-1.7-2.5-2.6-8.8-9.3-11.7-17.4-11.7-24s2.9-14.7 11.7-24zM464 268.6V320c0 6.6-2.9 14.7-11.7 24-8.9 9.4-22.9 19-42.1 27.6C372 388.8 317.5 400 256 400s-116-11.2-154.2-28.4C82.7 363 68.6 353.4 59.7 344c-8.8-9.3-11.7-17.4-11.7-24v-51.4c10.3 7.1 21.8 13.3 34.1 18.9C127.9 307.9 189.4 320 256 320s128.1-12.1 173.9-32.6c12.4-5.5 23.9-11.8 34.1-18.9zM0 192v128c0 22.1 10.1 41.4 24.8 57 14.6 15.4 34.5 28.2 57.4 38.5C127.9 435.9 189.4 448 256 448s128.1-12.1 173.9-32.6c22.8-10.2 42.8-23 57.4-38.5 14.7-15.6 24.8-34.9 24.8-57V192c0-22.1-10.1-41.4-24.8-57-14.6-15.4-34.5-28.2-57.4-38.5C384.1 76.1 322.6 64 256 64S127.9 76.1 82.1 96.6c-22.8 10.2-42.8 23-57.3 38.4C10.1 150.6 0 169.9 0 192zm256 80c-56.1 0-106.4-9.3-143.8-24 37.1-14.5 87.3-24 143.8-24s106.7 9.5 143.8 24c-37.4 14.7-87.7 24-143.8 24z"
        }
    ]
};

const FarRingsWedding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRingsWedding",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M119.9 105.1C50.2 128.6 0 194.4 0 272c0 97.2 78.8 176 176 176 7.8 0 15.5-.5 23-1.5 32.3 39.9 81.6 65.5 137 65.5 97.2 0 176-78.8 176-176 0-91.9-70.4-167.3-160.3-175.3 10.4 16.5 18.6 34.5 24.2 53.6C427.1 231.1 464 279.2 464 336c0 70.7-57.3 128-128 128-32.8 0-62.7-12.3-85.3-32.6-12.3-11-22.5-24.4-29.8-39.5C212.6 375 208 356.1 208 336c0-54.9 34.6-101.8 83.2-119.9C299.4 233 304 251.9 304 272c0 43.5-21.7 81.9-54.8 105 7 14.8 17.7 27.5 30.8 37 43.7-32 72-83.7 72-142 0-77.6-50.2-143.4-119.9-166.9l22.5-50.6c1.9-4.4 1.8-9.4-.3-13.7l-16-32C235.6 3.4 230.1 0 224 0h-96c-6.1 0-11.6 3.4-14.3 8.8l-16 32c-2.1 4.3-2.3 9.3-.3 13.7l22.5 50.6zM147.8 48h56.4l.4.8L187.2 88h-22.4l-17.4-39.2.4-.8zM160 336c0 22.6 4.2 44.1 12 63.9-68.9-2.1-124-58.6-124-127.9 0-70.7 57.3-128 128-128 32.8 0 62.7 12.3 85.3 32.6C201.5 204.7 160 265.5 160 336z"
        }
    ]
};

const FarRoadBarrier = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRoadBarrier",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32c13.3 0 24 10.7 24 24v24h544V56c0-13.3 10.7-24 24-24s24 10.7 24 24v400c0 13.3-10.7 24-24 24s-24-10.7-24-24V304H48v152c0 13.3-10.7 24-24 24S0 469.3 0 456V56c0-13.3 10.7-24 24-24zm568 224V128h-21.2l-64 128H592zm-544 0h21.2l64-128H48v128zm341.2-128h-74.4l-64 128h74.3l64-128zm-10.4 128h74.3l64-128h-74.3l-64 128zm-192-128-64 128h74.3l64-128h-74.3z"
        }
    ]
};

const FarRoadBridge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRoadBridge",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16h-72v-56c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-72c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h72v56c0 13.3 10.7 24 24 24s24-10.7 24-24V48h72zm0-48H384c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm-96 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24zM24 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h264v-48h-40v-64h40V96H24zm248 208c-57.4 0-104 46.6-104 104v56h-48v-64c0-53-43-96-96-96-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48v72c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40v-64c0-30.9 25.1-56 56-56h16v-48h-16zm-72-160v64h-80v-64h80z"
        }
    ]
};

const FarRoadCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRoadCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M217.7 32c-30.4 0-57.5 19-67.7 47.6l-109.4 304C23.7 430.5 58.4 480 108.3 480h251.9c-21.9-26.6-36.2-59.7-39.5-96h-.7c-13.3 0-24 10.7-24 24v24H108.3c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9H296v24c0 13.3 10.7 24 24 24s24-10.7 24-24V80h78.3c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7 12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32H217.7zm109.2 287c4.1-14.1 9.8-27.4 17.1-39.8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24 2.4 0 4.7-.4 6.9-1zM640 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarRoadCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRoadCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M217.7 32c-30.4 0-57.5 19-67.7 47.6l-109.4 304C23.7 430.5 58.4 480 108.3 480h251.9c-21.9-26.6-36.2-59.7-39.5-96h-.7c-13.3 0-24 10.7-24 24v24H108.3c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9H296v24c0 13.3 10.7 24 24 24s24-10.7 24-24V80h78.3c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7 12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32H217.7zm109.2 287c4.1-14.1 9.8-27.4 17.1-39.8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24 2.4 0 4.7-.4 6.9-1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarRoadCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRoadCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M217.7 32c-30.4 0-57.5 19-67.7 47.6l-109.4 304C23.7 430.5 58.4 480 108.3 480h251.9c-21.9-26.6-36.2-59.7-39.5-96h-.7c-13.3 0-24 10.7-24 24v24H108.3c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9H296v24c0 13.3 10.7 24 24 24s24-10.7 24-24V80h78.3c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7 12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32H217.7zm109.2 287c4.1-14.1 9.8-27.4 17.1-39.8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24 2.4 0 4.7-.4 6.9-1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
        }
    ]
};

const FarRoadLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRoadLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M217.7 32c-30.4 0-57.5 19-67.7 47.6l-109.4 304C23.7 430.5 58.4 480 108.3 480H384v-48h-40v-24c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H108.3c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9H296v24c0 13.3 10.7 24 24 24s24-10.7 24-24V80h78.3c10.1 0 19.2 6.3 22.6 15.9l28.3 78.5c13.8-7.8 29.4-12.7 46-14L490 79.6C479.7 51 452.6 32 422.3 32H217.7zM344 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80zm184 24c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FarRoadSpikes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRoadSpikes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 352H64V116.8c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3 3.2 4.9 80 120V116.8c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3 3.2 4.9 80 120V116.8c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3 3.2 4.9 80 120V116.8c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3 3.2 4.9 110.8 166.2c14.2 21.3-1.1 49.7-26.6 49.7H192zm-25.7-48L112 222.5V304h54.3zM0 424c0-13.3 10.7-24 24-24h592c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm240-201.5V304h54.3L240 222.5zM422.3 304 368 222.5V304h54.3zm73.7-81.5V304h54.3L496 222.5z"
        }
    ]
};

const FarRoad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRoad",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M185.7 32c-30.4 0-57.5 19-67.7 47.6L8.6 383.6C-8.3 430.5 26.4 480 76.3 480h423.4c49.9 0 84.6-49.5 67.7-96.4L458 79.6C447.7 51 420.6 32 390.3 32H185.7zm-22.5 63.9c3.4-9.5 12.5-15.9 22.6-15.9H264v24c0 13.3 10.7 24 24 24s24-10.7 24-24V80h78.3c10.1 0 19.2 6.3 22.6 15.9l109.4 304c5.6 15.6-6 32.1-22.6 32.1H312v-24c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H76.3c-16.6 0-28.2-16.5-22.6-32.1l109.4-304zM312 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80z"
        }
    ]
};

const FarRobotAstromech = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRobotAstromech",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-70.7 0-128 57.3-128 128v16H88c-30.9 0-56 25.1-56 56v210.9L2.1 478.3c-3.3 7.4-2.6 16 1.8 22.8S15.9 512 24 512h112c13.3 0 24-10.7 24-24v-72.9l22.1 24.8c4.6 5.1 11.1 8.1 17.9 8.1h112c6.9 0 13.4-2.9 17.9-8.1l22.1-24.8V488c0 13.3 10.7 24 24 24h112c8.1 0 15.7-4.1 20.1-10.9s5.1-15.4 1.8-22.8L480 410.9V200c0-30.9-25.1-56-56-56h-40v-16C384 57.3 326.7 0 256 0zm-64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM88 192h24v272H60.9l17-38.3c1.4-3.1 2.1-6.4 2.1-9.7V200c0-4.4 3.6-8 8-8zm72 0h192v150.9L301.2 400h-90.4L160 342.9V192zm240 0h24c4.4 0 8 3.6 8 8v216c0 3.4.7 6.7 2.1 9.7l17 38.3H400V192zm-192 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96z"
        }
    ]
};

const FarRobot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRobot",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c13.3 0 24 10.7 24 24v72h104c53 0 96 43 96 96v224c0 53-43 96-96 96H192c-53 0-96-43-96-96V192c0-53 43-96 96-96h104V24c0-13.3 10.7-24 24-24zM192 144c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V192c0-26.5-21.5-48-48-48H192zM48 224h16v192H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-16V224h16zM208 384h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zM200 256a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm200-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
        }
    ]
};

const FarRocketLaunch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRocketLaunch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M197.9 253.9c12.9 6.4 24.7 14.8 35 25.2s18.8 22.2 25.2 35c105.8-30 156.7-79.5 181.5-126 25-46.8 27.3-97.6 22-137.7-40.1-5.3-90.9-3-137.7 22-46.5 24.8-96 75.8-126 181.5zM384 312.1v82.2c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1.2S224 496.7 224 488V373.3c0-22.6-9-44.3-25-60.3s-37.7-25-60.3-25H24c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7.2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3h82.2C281.7-3.8 408.8-8.5 483.9 5.3c11.6 2.1 20.7 11.2 22.8 22.8 13.8 75.1 9.1 202.2-122.7 284zM28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5C132.3 504.3 66 511 28.3 511.9zm50.2-64.5c12.8-.7 31.2-3.7 41.3-13.7 11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3-.5 8 5.9 14.3 13.9 13.9zM328 144a40 40 0 1 1 80 0 40 40 0 1 1-80 0z"
        }
    ]
};

const FarRocket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRocket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368.3 265c-44.5 30.1-129.3 68.2-175.7 88l-35-35c20.4-46.1 59.2-130 89.3-174.4C309.1 52 398.4 41.9 461.7 50.3c8.5 63.3-1.7 152.6-93.3 214.7zm-249.8 23c-3.6 8-6.8 15.2-9.4 21.2-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9 6.5-2.7 14.3-6 23-9.8v96.2c0 8.6 4.6 16.6 12.1 20.9s16.7 4.2 24.1-.2l88.5-52.5c21.9-13 35.3-36.5 35.3-61.9v-82.3c4-2.5 7.7-4.9 11.3-7.3 120.8-81.9 124.8-203.9 111.4-276.7-2.1-11.6-11.2-20.6-22.8-22.8-72.8-13.4-194.8-9.4-276.7 111.4-2.4 3.6-4.9 7.3-7.3 11.3h-82.1c-25.4 0-49 13.4-61.9 35.3L3.4 251.8c-4.4 7.4-4.5 16.6-.2 24.1S15.4 288 24 288h94.5zM408 144a40 40 0 1 0-80 0 40 40 0 1 0 80 0z"
        }
    ]
};

const FarRollerCoaster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRollerCoaster",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 184c0-40.1 22.7-74.9 56-92.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V80h5.1c15 0 29.6 3.2 42.9 9.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V132.6l48 69.1V456c0 13.3 10.7 24 24 24s24-10.7 24-24V270.9l14.9 21.5c9.4 13.6 20.6 25.6 33.1 35.8V456c0 13.3 10.7 24 24 24s24-10.7 24-24v-99.9c15.3 5.9 31.4 9.7 48 11.2V456c0 13.3 10.7 24 24 24s24-10.7 24-24v-90.2c20.9-4 40-13 56-25.8v116c0 13.3 10.7 24 24 24s24-10.7 24-24V232c0-75.1-60.9-136-136-136h-8.1c-30.4 0-60.3 8.3-86.4 23.9L358 150.8l58 83.5V172l18.1-10.9c14.1-8.4 29.7-13.9 45.9-16V264c0 13.3 10.7 24 24 24s24-10.7 24-24V147.3c36.9 10.4 64 44.4 64 84.7v8c0 44.2-35.8 80-80 80h-8.5c-41.9 0-81.2-20.5-105.1-55L281.9 97.3C253.5 56.4 206.9 32 157.1 32H152C68.1 32 0 100.1 0 184v272c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"
        }
    ]
};

const FarRotateExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRotateExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416.5 176c-23.6-25.7-42.6-46.5-63.3-62.8C326.4 92.1 298.2 80 256 80c-77.8 0-145.9 50.4-169.3 119.7-4.2 12.6-17.9 19.3-30.4 15.1S37 196.9 41.2 184.4C71.3 95.5 157.7 32 256 32c53.9 0 92.3 16.3 126.9 43.5 21.9 17.2 42.9 39.5 65.1 63.8V104c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24s10.7-24 24-24h40.5zM280 152v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm-24 168a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM40 432c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H97.9l3 3.3c22 24.3 39.8 43.9 59.4 59.6 26.1 21 53.6 33.1 95.8 33.1 77.8 0 145.9-50.4 169.3-119.7 4.2-12.6 17.9-19.3 30.4-15.1s19.3 17.9 15.1 30.4C440.7 416.5 354.3 480 256 480c-53.9 0-91.9-16.4-125.8-43.6-22.1-17.7-43.4-41-66.2-66.2V408c0 13.3-10.7 24-24 24z"
        }
    ]
};

const FarRotateLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRotateLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M140.8 122.9C171.7 96.2 212 80 256 80c97.2 0 176 78.8 176 176s-78.8 176-176 176c-39.7 0-76.2-13.1-105.6-35.2-10.6-8-25.6-5.8-33.6 4.8s-5.8 25.6 4.8 33.6C159 463.3 205.6 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-57.3 0-109.6 21.5-149.2 56.9L76.3 58.3C69.7 51.7 60.7 48 51.3 48 31.8 48 16 63.8 16 83.3V200c0 13.3 10.7 24 24 24h116.7c19.5 0 35.3-15.8 35.3-35.3 0-9.4-3.7-18.3-10.3-25l-40.8-40.8zm-76.8-9 62.1 62.1H64v-62.1z"
        }
    ]
};

const FarRotateRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRotateRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.2 122.9C340.3 96.2 300 80 256 80c-97.2 0-176 78.8-176 176s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2 10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480 132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3V200c0 13.3-10.7 24-24 24H355.3c-19.5 0-35.3-15.8-35.3-35.3 0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176H448v-62.1z"
        }
    ]
};

const FarRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRotate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9l4.1 4.1-35.7 35.7c-6.6 6.6-10.3 15.6-10.3 25 0 19.5 15.8 35.3 35.3 35.3H472c13.3 0 24-10.7 24-24V83.3c0-19.5-15.8-35.3-35.3-35.3-9.4 0-18.3 3.7-25 10.3L400 94.1l-4.1-4.1C358.8 52.8 308.5 32 256 32 163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2.5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3.4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9L146 384l35.7-35.7c6.6-6.6 10.3-15.6 10.3-25 0-19.5-15.8-35.3-35.3-35.3H40c-13.3 0-24 10.7-24 24v116.7c0 19.5 15.8 35.3 35.3 35.3 9.4 0 18.3-3.7 25-10.3l35.7-35.8 4.1 4.1c37.1 37.2 87.4 58 139.9 58 92.5 0 171.8-56 206-135.9zM448 176h-62.1l62.1-62.1V176zM64 336h62.1L64 398.1V336z"
        }
    ]
};

const FarRouteHighway = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRouteHighway",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M236.3 3.4c-7.6-4.6-17.1-4.6-24.7 0L202.3 9C164.8 31.5 118.7 34.1 79 16c-18.7-8.4-40.8-1.3-50.9 16.5L7.4 68.7c-6.6 11.6-7 25.8-1 37.7l8.5 16.9C26.1 145.9 32 170.8 32 196.1c0 20.7-3.9 41.2-11.6 60.4L8.7 285.7C2.9 300 0 315.3 0 330.7c0 46.7 26.8 89.2 68.8 109.4l144.8 69.5c6.6 3.2 14.2 3.2 20.8 0l144.8-69.5c42.1-20.2 68.8-62.7 68.8-109.4 0-15.4-2.9-30.7-8.7-45.1l-11.7-29.2c-7.7-19.2-11.6-39.7-11.6-60.4 0-25.2 5.9-50.1 17.2-72.7l8.5-16.9c6-12 5.6-26.1-1-37.7l-20.8-36.2C409.7 14.7 387.7 7.6 369 16.1c-39.8 18.1-85.9 15.4-123.3-7l-9.4-5.6zM80 192h288v4.1c0 26.8 5.1 53.3 15.1 78.2l11.7 29.2c3.5 8.7 5.2 17.9 5.2 27.2 0 28.2-16.2 53.9-41.6 66.1L224 461.4 89.6 396.9C64.2 384.7 48 359 48 330.7c0-9.3 1.8-18.6 5.2-27.2l11.7-29.2c10-24.9 15.1-51.4 15.1-78.2V192z"
        }
    ]
};

const FarRouteInterstate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRouteInterstate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 192h383.3c-3.3 42-12.4 79.6-27.6 113.3C391 369 338.9 421.2 255.5 461.7c-84.6-37.1-136.4-89.1-164.6-153.4C75.7 273.8 67 235.1 64 192zM272.6 6c-10.2-6.1-23-6.1-33.2 0-53.2 31.8-107 33.5-178.8 20-17.7-3.3-35 8.7-37.7 26.9C8 156.5 12.5 249.5 46.9 327.6c34.7 78.9 98.6 139.8 196.5 181.1 8.3 3.5 17.8 3.3 26-.5 95.4-44.7 158.9-105.4 194.1-183.2 34.9-77.2 40.4-168.5 25.5-272.2-2.6-18.2-19.9-30.2-37.7-26.9C379.6 39.5 325.8 37.8 272.6 6z"
        }
    ]
};

const FarRoute = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRoute",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M438.6 155.7c-7.2 11.5-15 22.6-22.6 32.7-7.5-10.1-15.4-21.2-22.6-32.7C375.7 127.3 368 106.3 368 96c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.3-7.7 31.3-25.4 59.7zM427.4 251C452.9 221.1 512 146.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 33.3 25.9 77.3 50.8 112H328c-48.6 0-88 39.4-88 88s39.4 88 88 88h96c22.1 0 40 17.9 40 40s-17.9 40-40 40H177.8c-2.7 3.8-5.5 7.6-8.2 11.2-10.7 14.2-21.3 26.9-30 36.8H424c48.6 0 88-39.4 88-88s-39.4-88-88-88h-96c-22.1 0-40-17.9-40-40s17.9-40 40-40h84.9c5.1 1.1 10.7-.6 14.5-5zM118.9 408.4c-7.3 11-15.3 21.7-22.9 31.2-7.6-9.5-15.6-20.2-22.9-31.2C55.4 381.7 48 361.9 48 352c0-26.5 21.5-48 48-48s48 21.5 48 48c0 9.9-7.4 29.7-25.1 56.4zm19 55.6c25.9-33.1 54.1-77.3 54.1-112 0-53-43-96-96-96S0 299 0 352c0 50.5 59.8 121 85 148.4 6 6.5 16 6.5 21.9 0l.3-.3c.3-.3.6-.7.9-1 2.8-3.1 6-6.7 9.5-10.7l.2-.2c6.1-7 13-15.2 20-24.2z"
        }
    ]
};

const FarRouter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRouter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M198.6 105.9c-9.9 8.8-25.1 7.8-33.9-2.1s-7.8-25.1 2.1-33.9C216.2 26.4 281.1 0 352 0s135.8 26.4 185.1 69.9c9.9 8.8 10.9 23.9 2.1 33.9s-23.9 10.9-33.9 2.1C464.5 69.8 410.8 48 352 48s-112.5 21.8-153.4 57.9zM64 352c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16v-80c0-8.8-7.2-16-16-16H64zM0 368c0-35.3 28.7-64 64-64h264v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h136c35.3 0 64 28.7 64 64v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-80zm104 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm192-248c-28.6 0-54.9 10-75.5 26.7-10.3 8.3-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C275.2 126 312 112 352 112s76.8 14 105.7 37.4c10.3 8.3 11.9 23.5 3.5 33.8s-23.5 11.9-33.8 3.5C406.9 170 380.6 160 352 160z"
        }
    ]
};

const FarRss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRss",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24 234.2 0 424 189.8 424 424 0 13.3-10.7 24-24 24s-24-10.7-24-24C400 248.3 231.7 80 24 80 10.7 80 0 69.3 0 56zm64 376a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM24 176c154.6 0 280 125.4 280 280 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1-103.9-232-232-232-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarRubleSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRubleSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M111.3 32C85.2 32 64 53.2 64 79.3V272H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h184c13.3 0 24-10.7 24-24s-10.7-24-24-24H112v-48h128c79.5 0 144-64.5 144-144S319.5 32 240 32H111.3zM240 272H112V80h128c53 0 96 43 96 96s-43 96-96 96z"
        }
    ]
};

const FarRug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRug",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24h8v40h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v40h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-40h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-40h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm56 48h48v288H80V112zm384 288H176V112h288v288zm48 0V112h48v288h-48z"
        }
    ]
};

const FarRugbyBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRugbyBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 16h32c70.7 0 128 57.3 128 128v32c0 176.7-143.3 320-320 320h-32c-70.7 0-128-57.3-128-128v-32C16 159.3 159.3 16 336 16zm-27.5 49.4C252.1 71 200.9 93.9 160 128.6c-11.5 9.8-22.2 20.5-32 32.1-34.8 41.3-57.6 93.1-62.8 150C88.5 266 125.5 216.6 172 170c45.1-45.1 92.9-81.2 136.4-104.6zm-108 381.5c57.2-5.1 109.3-27.9 150.8-62.9 11.6-9.8 22.3-20.5 32.1-32 34.9-41.1 57.8-92.6 63.3-149.3-23.4 43.7-59.7 91.7-105 137-46.8 46.8-96.4 83.9-141.3 107.2zM90.4 421.4c2.7 2.7 8.8 5.9 22.3 5 13.4-.9 31.2-5.8 52.5-15.6 42.3-19.4 93.5-55.8 142.7-105s85.6-100.4 105-142.7c9.8-21.2 14.7-39 15.6-52.5.9-13.5-2.3-19.6-5-22.3s-8.8-5.9-22.3-5c-13.4.9-31.2 5.8-52.5 15.6-42.3 19.5-93.5 55.8-142.7 105s-85.6 100.4-105 142.7c-9.8 21.2-14.7 39-15.6 52.5-.9 13.5 2.3 19.6 5 22.3z"
        }
    ]
};

const FarRulerCombined = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRulerCombined",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 288v-64h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v384c0 .6 0 1.2.1 1.7.8 8 7.7 14.3 15.9 14.3h384c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16h-32v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm96-16h160c35.3 0 64 28.7 64 64v112c0 35.3-28.7 64-64 64H64C30.9 512 3.6 486.8.3 454.5c-.2-2.2-.3-4.3-.3-6.5V64C0 28.7 28.7 0 64 0h112c35.3 0 64 28.7 64 64v208h48z"
        }
    ]
};

const FarRulerHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRulerHorizontal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 320c0 8.8 7.2 16 16 16h512c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H64c-8.8 0-16 7.2-16 16v128zm16 64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H64z"
        }
    ]
};

const FarRulerTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRulerTriangle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448V67.9l66.7 66.7-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 66.8 66.8H64c-8.8 0-16-7.2-16-16zm454.6 6.6L57.4 9.4c-6-6-14.2-9.4-22.7-9.4H32C14.3 0 0 14.3 0 32v416c0 35.3 28.7 64 64 64h416c17.7 0 32-14.3 32-32v-2.7c0-8.5-3.4-16.6-9.4-22.6zM128 256v128h128L128 256z"
        }
    ]
};

const FarRulerVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRulerVertical",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48c8.8 0 16 7.2 16 16v32h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h128zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarRuler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRuler",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M63.2 379.3c-6.2-6.2-6.2-16.4 0-22.6l39.4-39.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 39.4-39.4c6.2-6.2 16.4-6.2 22.6 0l69.5 69.5c6.2 6.2 6.2 16.4 0 22.6L155.3 448.8c-6.2 6.2-16.4 6.2-22.6 0l-69.5-69.5zm35.5 103.4c25 25 65.5 25 90.5 0l293.5-293.4c25-25 25-65.5 0-90.5l-69.4-69.5c-25-25-65.5-25-90.5 0L29.3 322.7c-25 25-25 65.5 0 90.5l69.5 69.5z"
        }
    ]
};

const FarRupeeSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRupeeSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h96c75.1 0 136 60.9 136 136 0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304H48v152c0 13.3-10.7 24-24 24S0 469.3 0 456V56zm48 200h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H48v176zm264.6 10.4c-1.2 7.9-.2 12.8 1 15.9s3.5 6.2 7.5 9.4c9.2 7.4 23.3 12.5 43.1 19.6l.8.3c17.4 6.2 40 14.2 56.7 28.5 9 7.7 16.8 17.6 21.5 30.4 4.7 12.7 5.7 26.7 3.5 41.9-3.9 26.6-19.1 46.5-41 57.6-21 10.6-46.4 12.3-71.6 7.6h-.2c-9-1.7-20.2-5.7-29.5-9.2-6.3-2.4-13-5.1-18.5-7.3-2.7-1.1-5-2-6.9-2.8-12.3-4.8-18.4-18.8-13.6-31.1s18.8-18.4 31.1-13.6c2.6 1 5.3 2.1 8.2 3.3 5.1 2.1 10.7 4.3 16.7 6.6 9.4 3.5 17 6 21.5 6.9 18.1 3.3 32.1 1.2 41.2-3.3 8.1-4.1 13.5-10.7 15.1-21.7 1.3-8.8.4-14.5-1-18.3-1.4-3.8-3.8-7.1-7.7-10.5-9-7.7-22.9-13.1-42.4-20l-2.9-1c-16.8-5.9-38.1-13.5-54.1-26.2-9-7.2-17.1-16.6-22.1-29s-6.2-26.1-4-40.8c7.8-52.8 62.2-74.5 112.6-65.2 7.1 1.3 28.4 6.1 36.5 8.7 12.6 4 19.7 17.4 15.7 30.1s-17.4 19.7-30.1 15.7c-5.5-1.7-24.7-6.1-30.8-7.3-36.3-6.7-54.2 10.2-56.4 25z"
        }
    ]
};

const FarRupiahSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRupiahSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h96c75.1 0 136 60.9 136 136 0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304H48v152c0 13.3-10.7 24-24 24S0 469.3 0 456V56zm48 200h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H48v176zm264-96h88c61.9 0 112 50.1 112 112s-50.1 112-112 112h-64v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24zm88 176c35.3 0 64-28.7 64-64s-28.7-64-64-64h-64v128h64z"
        }
    ]
};

const FarRv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarRv",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 24c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v8h136c48.6 0 88 39.4 88 88v40c0 22.5-15.5 41.4-36.4 46.6l53.1 41.7c9.7 7.6 15.3 19.2 15.3 31.5V376c0 22.1-17.9 40-40 40h-25.6c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5.6-10.8 1.6-16H254.4c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7 .9-13.7 2.6-20.1-1.3-.8-2.4-1.8-3.5-2.9l-74-74A71.983 71.983 0 0 1 0 284.1V104c0-39.8 32.2-72 72-72h152v-8zM72 80c-13.3 0-24 10.7-24 24v180.1c0 6.4 2.5 12.5 7 17l66.9 66.9h6.1c13.4-10 30-16 48-16s34.6 6 48 16h160V184c0-13.3 10.7-24 24-24h152v-40c0-22.1-17.9-40-40-40H72zm484.8 176-61.1-48H432v48h124.8zM208 432a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm320 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM120 128h144c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarS",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M91.2 90.6c-24 10.1-37.9 26.2-41.8 48-2.8 16.1-1 27.4 2.8 35.7 3.8 8.5 10.6 16.1 21.1 23.3 22.1 15.1 54.9 24.6 93.2 35.3.8.2 1.6.4 2.4.7 35.3 9.9 75.6 21.2 104.9 41.2 15.6 10.6 29.3 24.5 37.7 43.1 8.5 18.7 10.6 40 6.4 63.9-7.2 40.8-34.4 68.8-70.5 83.9-35.3 14.8-79.6 17.8-125.7 10.7h-.1c-24.5-3.9-64.3-17.2-90.9-26.2-5.3-1.8-10-3.4-14-4.7C4 441.4-2.9 427.8 1.2 415.2s17.7-19.5 30.3-15.4c4.9 1.6 10.5 3.5 16.3 5.4 26.9 9 61.2 20.4 81.3 23.6 40.4 6.2 75.1 2.9 99.8-7.5 24-10.1 37.9-26.2 41.8-48 2.8-16.1 1-27.4-2.8-35.7-3.8-8.5-10.6-16.1-21.1-23.3-22.1-15.1-54.9-24.6-93.2-35.3-.8-.2-1.6-.4-2.4-.7-35.3-9.9-75.6-21.2-104.9-41.2C30.7 226.5 17 212.6 8.6 194 .1 175.3-2 154 2.2 130.1l23.6 4.2-23.7-4c7.2-40.8 34.4-68.8 70.5-83.9 35.3-14.8 79.6-17.8 125.7-10.7 13.7 2.1 55.1 9.9 69.7 13.8 12.8 3.3 20.5 16.5 17.2 29.3S268.7 99.3 255.9 96c-12.4-3.2-52-10.8-64.9-12.8l3.6-23.7-3.6 23.6c-40.4-6.2-75.2-2.9-99.9 7.5z"
        }
    ]
};

const FarSackDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSackDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M218.7 152h74.6l13.8 8.8C361.1 195.4 464 277 464 416c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48 0-139 102.9-220.6 156.9-255.2l13.8-8.8zm67.3-48h-60l-7.5-10.8L187.4 48h137.2l-31.1 45.2L286 104zm-135.2 35.9C89.4 185.5 0 274.8 0 416c0 53 43 96 96 96h320c53 0 96-43 96-96 0-141.2-89.4-230.5-150.8-276.1-10.4-7.7-20-14.2-28.2-19.4L360.3 81l29.8-43.2C401 21.7 389.6 0 370.3 0H141.7c-19.3 0-30.7 21.7-19.8 37.6l29.8 43.2 27.3 39.6c-8.2 5.3-17.8 11.7-28.2 19.4zM276 216c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"
        }
    ]
};

const FarSackXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSackXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M293.3 152h-74.6l-13.8 8.8C150.9 195.4 48 277 48 416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48 0-139-102.9-220.6-156.9-255.2l-13.8-8.8zm.2-58.8L324.6 48H187.4l31.1 45.2L226 104h60l7.5-10.8zM0 416c0-141.2 89.4-230.5 150.8-276.1 10.4-7.7 20-14.2 28.2-19.4l-27.2-39.6-29.9-43.3C111 21.7 122.4 0 141.7 0h228.6c19.3 0 30.7 21.7 19.8 37.6l-29.9 43.3-27.2 39.5c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96zm209-177 47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FarSack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSack",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M293.3 152h-74.6l-13.8 8.8C150.9 195.4 48 277 48 416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48 0-139-102.9-220.6-156.9-255.2l-13.8-8.8zm.2-58.8L324.6 48H187.4l31.1 45.2L226 104h60l7.5-10.8zM0 416c0-141.2 89.4-230.5 150.8-276.1 10.4-7.7 20-14.2 28.2-19.4l-27.2-39.6-29.9-43.3C111 21.7 122.4 0 141.7 0h228.6c19.3 0 30.7 21.7 19.8 37.6l-29.9 43.3-27.2 39.5c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96z"
        }
    ]
};

const FarSailboat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSailboat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M284.6 6.2C280.4.8 273.2-1.3 266.8.9S256 9.2 256 16v288c0 8.8 7.2 16 16 16h224c6.1 0 11.7-3.5 14.4-9s2-12-1.7-16.9l-224-288zm-72 90.5c-6.7-2-14 .6-17.9 6.4l-128 192c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.4 14.1 8.4h128c8.8 0 16-7.2 16-16V112c0-7.1-4.6-13.3-11.4-15.3zM60 400h456l-.4 1.6c-8.2 36.5-40.6 62.4-78 62.4H138.4c-37.4 0-69.8-25.9-78-62.4L60 400zm-40-48c-10.3 0-17.9 9.5-15.6 19.5l9.1 40.6c13.1 58.4 65 99.9 124.9 99.9h299.2c59.9 0 111.7-41.5 124.9-99.9l9.1-40.6c2.2-10-5.4-19.5-15.6-19.5H20z"
        }
    ]
};

const FarSalad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSalad",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 96c-70.7 0-128 57.3-128 128 0 11 1.4 21.8 4 32h-52V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v137.4L107.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l84.7 84.7H96c-53 0-96-43-96-96s43-96 96-96c8.7 0 17.2 1.2 25.3 3.4C138.5 27.7 178 0 224 0s85.5 27.7 102.7 67.4c8-2.2 16.5-3.4 25.3-3.4 28.5 0 54.2 12.5 71.8 32.2-2.6-.2-5.2-.2-7.8-.2zM117.9 422.3c12.9 5.7 22.7 16.7 26.8 30.3 2 6.6 8.2 11.4 15.3 11.4h192c7.2 0 13.4-4.8 15.3-11.4 4-13.5 13.8-24.6 26.8-30.3 35.2-15.4 61.2-47.6 68.1-86.3H49.8c6.9 38.7 32.9 70.9 68.1 86.3zM0 315.4C0 300.3 12.3 288 27.4 288h457.2c15.1 0 27.4 12.3 27.4 27.4 0 67.4-40.6 125.4-98.6 150.8C405.5 492.7 381 512 352 512H160c-29 0-53.5-19.3-61.4-45.7C40.6 440.8 0 382.9 0 315.4zM464 224c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 12.3 4.6 23.5 12.2 32h-54.7c-3.5-10-5.5-20.8-5.5-32 0-53 43-96 96-96s96 43 96 96c0 11.2-1.9 22-5.5 32h-54.7c7.6-8.5 12.2-19.7 12.2-32z"
        }
    ]
};

const FarSaltShaker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSaltShaker",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M325.2 464H58.8c-6 0-10.8-4.8-10.8-10.8 0-.6.1-1.3.2-1.9L94.5 192h195l46.3 259.3c.1.6.2 1.3.2 1.9 0 6-4.8 10.8-10.8 10.8zM58.8 512h266.4c32.5 0 58.8-26.3 58.8-58.8 0-3.5-.3-6.9-.9-10.3l-59.4-332.6C312.3 46.5 256.8 0 192 0S71.7 46.5 60.3 110.3L.9 442.9c-.6 3.4-.9 6.9-.9 10.3C0 485.7 26.3 512 58.8 512zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarSandwich = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSandwich",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 112h416v32H48v-32zM32 64C14.3 64 0 78.3 0 96v64c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H32zm16 304h416v32H48v-32zm-16-48c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H32zm-8-24c11.8 0 23.1-2.9 33.1-6.3 8.8-3 17.8-6.8 26.1-10.3l3.1-1.3c19.6-8.3 35.3-14.1 49.7-14.1 18.2 0 30.9 5.7 48.7 13.8 17.9 8.2 40 18.2 71.3 18.2s53.4-10 71.3-18.2c17.8-8.1 30.5-13.8 48.7-13.8 14.4 0 30.1 5.9 49.7 14.1l3.1 1.3c8.3 3.5 17.3 7.3 26.1 10.3 9.9 3.4 21.3 6.3 33.1 6.3 13.3 0 24-10.7 24-24s-10.7-24-24-24c-4.2 0-9.9-1.1-17.7-3.7-7-2.4-14.3-5.5-22.8-9.1l-3.1-1.3c-18.5-7.8-42.8-17.9-68.4-17.9-28.8 0-49.9 9.6-66.9 17.4l-1.7.8C290.1 242 276.2 248 256 248s-34.1-6-51.4-13.8l-1.7-.8c-17-7.8-38.1-17.4-66.9-17.4-25.6 0-49.9 10.1-68.3 17.9l-3.2 1.3c-8.5 3.6-15.9 6.7-22.8 9.1-7.8 2.6-13.5 3.7-17.7 3.7-13.3 0-24 10.7-24 24s10.7 24 24 24z"
        }
    ]
};

const FarSatelliteDish = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSatelliteDish",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 24c0 13.3 10.7 24 24 24 137 0 248 111 248 248 0 13.3 10.7 24 24 24s24-10.7 24-24C512 132.5 379.5 0 216 0c-13.3 0-24 10.7-24 24zm24 80c-13.3 0-24 10.7-24 24s10.7 24 24 24c79.5 0 144 64.5 144 144 0 13.3 10.7 24 24 24s24-10.7 24-24c0-106-86-192-192-192zm-7 233 40-40c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-40 40L71 199c-13.5-13.5-35.9-12.3-45.1 4.4C9.4 233.2 0 267.5 0 304c0 114.9 93.1 208 208 208 36.5 0 70.8-9.4 100.6-25.9 16.7-9.2 17.8-31.6 4.4-45.1L209 337zM48 304c0-18.1 3-35.5 8.5-51.6l203.1 203.1c-16.1 5.5-33.5 8.5-51.6 8.5-88.4 0-160-71.6-160-160z"
        }
    ]
};

const FarSatellite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSatellite",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241 7c-9.4-9.4-24.6-9.4-33.9 0L95 119c-9.4 9.4-9.4 24.6 0 33.9l58.1 58.1c-50.9-9.8-105.5 3.2-147.2 39.7-3.8 3.3-5.9 8-5.9 13v.5c0 4.9 1.9 9.6 5.4 13L103 375l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48 97.6 97.6c3.5 3.5 8.1 5.4 13 5.4h.5c5 0 9.8-2.2 13-5.9 36.5-41.7 49.6-96.3 39.7-147.2L359 417c9.4 9.4 24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9l-68-68 26-26.1c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41l-46-46c-10.9-10.9-25.6-17-41-17s-30.1 6.1-41 17l-26 26-68-68zm34.6 289.5c-6.4-9.7-13.8-18.8-22.3-27.3l-10.6-10.6c-8.5-8.5-17.6-15.9-27.3-22.3L369 82.9c1.9-1.9 4.4-2.9 7-2.9s5.2 1 7 2.9l46.1 46.1c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L275.6 296.6zM275 109l-78 78-51-51 78-78.1 51 51zm101 257.1-51-51 78-78.1 51 51-78 78.1zm-156.6-62.9c38.8 38.8 47.1 97 23.8 144.1L64.7 268.8c47.1-23.2 105.3-14.9 144.1 23.8l10.6 10.6z"
        }
    ]
};

const FarSausage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSausage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m447.5 69.3 15.2-41.9c.8-2.2 1.2-4.6 1.2-7C464 9.1 454.9 0 443.6 0h-55.2C377.1 0 368 9.1 368 20.4c0 2.4.4 4.7 1.2 7l15.2 41.9C346.9 82.3 320 118 320 160c0 88.4-71.6 160-160 160-42 0-77.7 26.9-90.7 64.5l-41.9-15.3c-2.2-.8-4.6-1.2-7-1.2C9.1 368 0 377.1 0 388.4v55.2C0 454.9 9.1 464 20.4 464c2.4 0 4.7-.4 7-1.2l41.9-15.2C82.3 485.1 118 512 160 512c194.4 0 352-157.6 352-352 0-42-26.9-77.7-64.5-90.7zM112 416c0-26.5 21.5-48 48-48 114.9 0 208-93.1 208-208 0-26.5 21.5-48 48-48s48 21.5 48 48c0 167.9-136.1 304-304 304-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FarSaxophoneFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSaxophoneFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M109.5 2.6C123.3 15 136.3 28.5 148.3 43c5.5-6.9 11.8-14.5 18.5-20.7 3.9-3.6 10.1-3.6 14 0 17.3 15.9 31.9 36.9 42.3 56.8 10.2 19.6 16.9 41.2 16.9 55.3 0 14.6-2.8 28.6-8 41.5h-55.2c8.9-15.4 9.3-35.4.2-52.1-1.4-2.8-2.8-5.6-4.9-8.4l-25.2 29.4S106.3 93 103.5 89.5c-21 26-31.5 40.7-31.5 57.5 0 11.2 2.7 21 7.5 29H23.9c-5.1-12.9-7.9-26.9-7.9-41.5C16 116 24.9 92 38.7 69.7c14-22.7 33.7-46.3 57-67.1 2-1.8 4.5-2.6 7-2.6s4.9.9 6.9 2.6zM0 232c0-13.3 10.7-24 24-24h224c13.3 0 24 10.7 24 24 0 13-10.3 23.6-23.2 24l-21.2 58.3L318 224l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7L366 176l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7L414 128l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7 4.3-4.3c16.6-16.5 39-25.8 62.3-25.8h35c23.3 0 45.7 9.3 62.2 25.8l14.6 14.6c8.7 8.7 13.7 20.6 13.7 33 0 25.8-20.9 46.6-46.6 46.6h-50.6c-2.3 0-4.6 1-6.1 2.8l-224.5 263c-33.7 39.5-83 62.2-134.9 62.2h-5.5C76.9 512 0 435.1 0 340.2c0-9.5.8-18.9 2.3-28.2l9.8-59.1C4.9 248.8 0 241 0 232zm464.3-86.4L417.9 192c-.3.3-.6.7-1 1s-.7.7-1 1l-45.8 45.8c-.4.4-.8.9-1.2 1.3s-.8.8-1.3 1.2l-112.1 112c-8.7 8.7-20.6 13.6-33 13.6h-2.4c-24.4 0-44.3-19.8-44.3-44.3 0-5.2.9-10.3 2.7-15.1l19.2-52.5H60.3l-10.6 63.9c-1.1 6.7-1.7 13.5-1.7 20.3C48 408.6 103.4 464 171.8 464h5.5c37.8 0 73.8-16.6 98.3-45.4l224.5-263c10.6-12.5 26.2-19.6 42.6-19.6H590l-12.3-12.3c-7.5-7.5-17.7-11.7-28.3-11.7h-35c-10.6 0-20.8 4.2-28.3 11.7l-20.6 20.6c-.2.2-.4.5-.6.7s-.5.4-.7.7zM96 312a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarSaxophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSaxophone",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M514.5 32c-23.3 0-45.7 9.3-62.2 25.8l-4.3 4.3-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7-14.1 14-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7L352 158l-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7-90.6 90.6L265 176c12.8-.5 23-11.1 23-24 0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h2.1L4 275.3c-2.7 12-4 24.2-4 36.5C0 404.7 75.3 480 168.2 480h9.1c51.9 0 101.2-22.7 134.9-62.2l224.5-263c1.5-1.8 3.7-2.8 6.1-2.8h50.6c25.8 0 46.6-20.9 46.6-46.6 0-12.4-4.9-24.2-13.7-33l-14.6-14.6C595.2 41.3 572.8 32 549.5 32h-35zM75.3 176h138.8l-35.6 100.7c-1.7 4.7-2.5 9.7-2.5 14.8 0 24.5 19.9 44.4 44.4 44.4h2.3c12.4 0 24.2-4.9 33-13.6l112.1-112c.4-.4.9-.8 1.3-1.2s.8-.8 1.2-1.3l45.7-45.9c.3-.3.7-.6 1-1s.6-.7 1-1l46.4-46.3c.2-.2.5-.4.7-.7s.4-.4.6-.7l20.6-20.6c7.5-7.5 17.7-11.7 28.3-11.7h35c10.6 0 20.8 4.2 28.3 11.7l12.2 12.4h-47.3c-16.4 0-32 7.2-42.6 19.6l-224.5 263c-24.6 28.8-60.5 45.4-98.3 45.4h-9.1C101.8 432 48 378.2 48 311.8c0-8.8 1-17.5 2.9-26.1L75.3 176zM136 304a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-8-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarScaleBalanced = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScaleBalanced",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M520 48H393.3C381 19.7 352.8 0 320 0s-61 19.7-73.3 48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h121.6c5.8 28.6 26.9 51.7 54.4 60.3V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V156.3c27.5-8.6 48.6-31.7 54.4-60.3H520c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 147.8L584.4 320H439.6L512 195.8zM386 337.1C396.8 382 449.1 416 512 416s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1l-95.2-163.2c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8l-95.2 163.3c-5.7 9.8-9.3 21.1-6.7 32.1zM54.4 320l72.4-124.2L199.3 320H54.4zm72.4 96c62.9 0 115.2-34 126-78.9 2.6-11-1-22.3-6.7-32.1l-95.2-163.2c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L7.6 305.1c-5.7 9.8-9.3 21.1-6.7 32.1C11.7 382 64 416 126.8 416zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarScaleUnbalancedFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScaleUnbalancedFlip",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M97.1 16.7c-4 12.6 2.9 26.1 15.5 30.2l127.8 40.8c3.1 32.4 25.5 59.2 55.6 68.6V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h200c13.3 0 24-10.7 24-24V156.3c14.2-4.5 26.8-12.8 36.4-23.8l132.3 42.3c12.6 4 26.1-2.9 30.2-15.5s-2.9-26.1-15.5-30.2L399.6 88.3c.3-2.7.4-5.5.4-8.3 0-44.2-35.8-80-80-80-29.8 0-55.8 16.3-69.6 40.5L127.3 1.1c-12.6-4-26.1 2.9-30.2 15.5zM128 163.8 200.4 288H55.6L128 163.8zm126 141.3c2.6-11-1-22.3-6.7-32.1l-95.2-163.2c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L8.7 273.1c-5.7 9.7-9.3 21-6.7 32C12.8 350 65.1 384 128 384s115.2-34 126-78.9zM583.3 416H438.4l72.4-124.2L583.3 416zm-72.4 96c62.9 0 115.2-34 126-78.9 2.6-11-1-22.3-6.7-32.1l-95.3-163.2c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8l-95.1 163.3c-5.7 9.8-9.3 21.1-6.7 32.1C395.7 478 448 512 510.8 512zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarScaleUnbalanced = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScaleUnbalanced",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M542.9 16.7c4 12.6-2.9 26.1-15.5 30.2L399.6 87.7c-3.1 32.4-25.5 59.2-55.6 68.6V464h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H320c-13.3 0-24-10.7-24-24V156.3c-14.2-4.5-26.8-12.8-36.4-23.8l-132.3 42.4c-12.6 4-26.1-2.9-30.2-15.5s2.9-26.1 15.5-30.2l127.8-40.9c-.3-2.7-.4-5.5-.4-8.3 0-44.2 35.8-80 80-80 29.8 0 55.8 16.3 69.6 40.5L512.7 1.1c12.6-4 26.1 2.9 30.2 15.5zM512 163.8 439.6 288h144.8L512 163.8zM386 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L631.3 273c5.7 9.8 9.3 21.1 6.7 32.1C627.2 350 574.9 384 512 384s-115.2-34-126-78.9zM56.7 416h144.9l-72.4-124.2L56.7 416zm72.4 96C66.3 512 14 478 3.2 433.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L248.5 401c5.7 9.8 9.3 21.1 6.7 32.1C244.3 478 192 512 129.2 512zM320 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarScalpelLineDashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScalpelLineDashed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M441.4 48c-6.7 0-13 2.9-17.3 8L268.9 240h63.8l125-148.3 36.7 31L369.3 271c-9.1 10.8-22.5 17-36.7 17H200c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1l12.2-14.4 5.6-6.7.4-.5L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1l-36.7-31c4-4.8 6.3-10.9 6.3-17.1v-4c0-12.5-10.1-22.6-22.6-22.6zm-272 272H288v16c0 74.9-65.5 118.6-126.1 142.9C100.1 503.6 34.1 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l160-160 4.7-4.7zM248 464h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24zm128 0h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24zm176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48z"
        }
    ]
};

const FarScalpel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScalpel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200 288c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1l12.2-14.4 5.6-6.7.4-.5L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1l-36.7-31c4-4.8 6.3-10.9 6.3-17.1v-4c0-12.5-10.1-22.6-22.6-22.6-6.7 0-13 2.9-17.3 8L268.9 240h63.8l125-148.3 36.7 31L369.3 271c-9.1 10.8-22.5 17-36.7 17H200zm-35.3 36.7 4.7-4.7H288v16c0 74.9-65.5 118.6-126.1 142.9C100.1 503.6 34.1 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l160-160z"
        }
    ]
};

const FarScannerGun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScannerGun",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 80c-35.3 0-64 28.7-64 64s28.7 64 64 64h192V80H112zM79.1 251.1C33.3 237.1 0 194.4 0 144 0 82.1 50.1 32 112 32h192c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48h-44L144.3 454.4c-13.4 23-42.9 30.7-65.8 17.2L25 440.1C2.3 426.8-5.4 397.6 7.8 374.8l71.3-123.7zm52.6 4.9L49.4 398.8l53.5 31.4L204.4 256h-72.7zM440 32h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24 184c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm24 216h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24-288c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16zm16 144h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FarScannerImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScannerImage",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M66.7 34.5c-11.9-5.9-26.3-1.1-32.2 10.7s-1.1 26.3 10.7 32.2L466.3 288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-72.4c0-33.3-18.8-63.8-48.6-78.7L66.7 34.5zM528 352v64c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h448c8.8 0 16 7.2 16 16zm-408 32a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarScannerKeyboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScannerKeyboard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24v40h48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zm176 0v40h48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zM240 0c-8.8 0-16 7.2-16 16v48h32V16c0-8.8-7.2-16-16-16zm144 16v256c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM488 0c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zM64 144h224c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm0-48c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 80c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24v-32c0-13.3-10.7-24-24-24H104zm-8 128c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H96zm-16 96v16c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm128-96c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-48zm-16 96v16c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarScannerTouchscreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScannerTouchscreen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24v40h48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zm176 0v40h48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zM240 0c-8.8 0-16 7.2-16 16v48h32V16c0-8.8-7.2-16-16-16zm144 16v256c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM488 0c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zM64 144h224c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm0-48c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 80c-13.3 0-24 10.7-24 24v208c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H104z"
        }
    ]
};

const FarScarecrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScarecrow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 104a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm131 72h69v32h-45.4c-24.5 0-43.2 21.7-39.6 45.9l13.9 92.7-13-7.4c-7.9-4.5-17.7-4.2-25.2.9L224 363.2 189.3 340c-7.6-5-17.3-5.4-25.2-.9l-13 7.4 13.9-92.6c3.6-24.2-15.1-45.9-39.6-45.9H80v-32h69c18.9 19.7 45.6 32 75 32s56.1-12.3 75-32zm-179-72c0 8.3 1 16.3 2.8 24H32c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5.8 16.4l7.6 11.4-19.9 14.9c-4 3-6.4 7.8-6.4 12.8s2.4 9.8 6.4 12.8l19.9 14.9-7.6 11.4c-3.3 4.9-3.6 11.2-.8 16.4S26.1 256 32 256h84.1L96.3 388.4c-1.4 9.1 2.6 18.2 10.2 23.4s17.5 5.6 25.5 1l43-24.6 35.7 23.8c8.1 5.4 18.6 5.4 26.6 0l35.7-23.8 43.1 24.6c8 4.6 17.9 4.2 25.5-1s11.5-14.3 10.2-23.4L331.9 256H416c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-7.6-11.4 19.9-14.9c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-19.9-14.9 7.6-11.4c3.3-4.9 3.6-11.2.8-16.4s-8.2-8.5-14.1-8.5h-90.8c1.8-7.7 2.8-15.7 2.8-24C328 46.6 281.4 0 224 0S120 46.6 120 104zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 384c0 13.3 10.7 24 24 24s24-10.7 24-24v-45.4c-15.2 7.2-32.8 7.2-48 0V488z"
        }
    ]
};

const FarScarf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScarf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m306.7 256 33.9 33.9 22.1 22.1-50.7 50.7-149.6-149.6c-11.7-11.7-18.4-27.7-18.4-44.3 0-10.8 2.8-21.3 8-30.7l41.5-73.8c5.7-10.1 16.4-16.3 27.9-16.3h69.1c11.6 0 22.2 6.2 27.9 16.3l41.6 73.8c5.3 9.4 8 20 8 30.7 0 16.6-6.6 32.6-18.3 44.3l-9 9-50.7-50.7 8-8c3.9-3.9 6.1-9.1 6.1-14.6 0-11.4-9.3-20.7-20.7-20.7h-54.7c-11.4 0-20.7 9.3-20.7 20.7 0 5.5 2.2 10.7 6.1 14.6l92.6 92.6zm101.8 33.9L396.6 278l-22-22 9-9c20.8-20.8 32.4-48.9 32.4-78.2 0-19-4.9-37.7-14.2-54.2l-41.5-73.8C346.1 15.6 319.5 0 290.6 0h-69.2c-28.9 0-55.6 15.6-69.7 40.8l-41.5 73.8c-9.3 16.5-14.2 35.2-14.2 54.2 0 29.3 11.7 57.5 32.4 78.2l149.7 149.7 30.6 30.6 3.3 3.3 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L334.6 408l11.3-11.3 14.1-14.1 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L382.6 360l14.1-14.1 11.3-11.3 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L430.6 312l-3.3-3.3-18.7-18.7zm-291.8-13.2-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6zm48 48-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6zm48 48-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6z"
        }
    ]
};

const FarSchoolCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSchoolCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92H72c-39.8 0-72 32.2-72 72v272c0 39.8 32.2 72 72 72h322.8c-45.3-31.9-74.8-84.5-74.8-144 0-16.5 2.3-32.5 6.5-47.7-2.1-.2-4.3-.3-6.5-.3-35.3 0-64 28.7-64 64v80H72c-13.3 0-24-10.7-24-24V168c0-13.3 10.7-24 24-24h104c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4h104c13.3 0 24 10.7 24 24v52.5c18.8 12.3 35.1 28 48 46.3V168c0-39.8-32.2-72-72-72h-96.7l-138-92zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1 4.7-10.2 7.3-21.5 7.3-33.5 0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32zm208-176c8.8 0 16 7.2 16 16v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm320 224a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7z"
        }
    ]
};

const FarSchoolCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSchoolCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92H72c-39.8 0-72 32.2-72 72v272c0 39.8 32.2 72 72 72h322.8c-45.3-31.9-74.8-84.5-74.8-144 0-16.5 2.3-32.5 6.5-47.7-2.1-.2-4.3-.3-6.5-.3-35.3 0-64 28.7-64 64v80H72c-13.3 0-24-10.7-24-24V168c0-13.3 10.7-24 24-24h104c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4h104c13.3 0 24 10.7 24 24v52.5c18.8 12.3 35.1 28 48 46.3V168c0-39.8-32.2-72-72-72h-96.7l-138-92zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1 4.7-10.2 7.3-21.5 7.3-33.5 0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32zm208-176c8.8 0 16 7.2 16 16v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm176 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarSchoolCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSchoolCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92H72c-39.8 0-72 32.2-72 72v272c0 39.8 32.2 72 72 72h322.8c-45.3-31.9-74.8-84.5-74.8-144 0-16.5 2.3-32.5 6.5-47.7-2.1-.2-4.3-.3-6.5-.3-35.3 0-64 28.7-64 64v80H72c-13.3 0-24-10.7-24-24V168c0-13.3 10.7-24 24-24h104c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4h104c13.3 0 24 10.7 24 24v52.5c18.8 12.3 35.1 28 48 46.3V168c0-39.8-32.2-72-72-72h-96.7l-138-92zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1 4.7-10.2 7.3-21.5 7.3-33.5 0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32zm208-176c8.8 0 16 7.2 16 16v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm176 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
        }
    ]
};

const FarSchoolFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSchoolFlag",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0h112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-81.9l89.6 64H504c39.8 0 72 32.2 72 72v208c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72V232c0-39.8 32.2-72 72-72h96.3L264 91.6V24c0-13.3 10.7-24 24-24zm216 464c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H400c-5 0-9.9-1.6-13.9-4.5l-98.1-70-98.1 70c-4.1 2.9-8.9 4.5-13.9 4.5H72c-13.3 0-24 10.7-24 24v208c0 13.3 10.7 24 24 24h168v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64h168zM240 240a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-128 16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm-304 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm320 0h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarSchoolLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSchoolLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M306.7 4c8.1-5.4 18.6-5.4 26.6 0l138 92H568c39.8 0 72 32.2 72 72v104c0-38.1-19-71.7-48-91.9V168c0-13.3-10.7-24-24-24H464c-4.7 0-9.4-1.4-13.3-4L320 52.8 189.3 140c-3.9 2.6-8.6 4-13.3 4H72c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h184v-80c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 11.7 3.1 22.6 8.6 32H72c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72h96.7l138-92zM112 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm128-128a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm80-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8v-16c0-8.8-7.2-16-16-16zm208 96c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FarSchool = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSchool",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M306.7 4c8.1-5.4 18.6-5.4 26.6 0l138 92H568c39.8 0 72 32.2 72 72v272c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72h96.7l138-92zM568 464c13.3 0 24-10.7 24-24V168c0-13.3-10.7-24-24-24H464c-4.7 0-9.4-1.4-13.3-4L320 52.8 189.3 140c-3.9 2.6-8.6 4-13.3 4H72c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h184v-80c0-35.3 28.7-64 64-64s64 28.7 64 64v80h184zM112 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm368 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64zM112 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm368 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64zM240 192a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm80-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8v-16c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarScissors = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScissors",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M506.4 439.4c-8.5 10.2-23.7 11.5-33.8 3L312.4 308.2l37.4-31.3 153.6 128.7c10.2 8.5 11.5 23.7 3 33.8zM112 48a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0-48c61.9 0 112 50.1 112 112 0 17.9-4.2 34.8-11.6 49.8l75.1 62.9L472.6 69.6c10.2-8.5 25.3-7.2 33.8 3s7.2 25.3-3 33.8l-291 243.8c7.4 15 11.6 31.9 11.6 49.8 0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c26.6 0 51.1 9.3 70.3 24.8l67.8-56.8-67.8-56.8C163.1 214.7 138.6 224 112 224 50.1 224 0 173.9 0 112S50.1 0 112 0zm64 400a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FarScreenUsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScreenUsers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 320a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64H64zm240-96a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64h-64zm256-112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-96 96c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64zm96-432H96c-8.8 0-16 7.2-16 16v161.3a95.98 95.98 0 0 0-48 23.1V64C32 28.7 60.7 0 96 0h448c35.3 0 64 28.7 64 64v184.4c-13.2-11.8-29.7-20.1-48-23.1V64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarScreencast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScreencast",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80H64c-8.8 0-16 7.2-16 16v97.1c-7.9-.7-15.9-1.1-24-1.1H0V96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H288v-24c0-8.1-.4-16.1-1.1-24H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16zM24 224c128.1 0 232 103.9 232 232 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 344c0-13.3 10.7-24 24-24 75.1 0 136 60.9 136 136 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarScrewdriverWrench = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScrewdriverWrench",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M78.6 5c-9.5-7.4-23-6.5-31.6 2L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4H158l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3L192 158v-54c0-7.5-3.5-14.5-9.4-19L78.6 5zM23.2 376.8a79.09 79.09 0 0 0-23.2 56C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2l103.3-103.3c-8.9-17.6-12.8-37.1-11.6-56.3L101.3 454.9c-5.9 5.8-13.8 9.1-22.1 9.1C62 464 48 450 48 432.8c0-8.3 3.3-16.2 9.1-22.1l137.2-137.2-33.9-33.9L23.2 376.8zM463.9 164c-1.4 38.9-22.6 72.8-53.8 91.8 1.1 1 2.1 2 3.1 3l31.6 31.6c40.7-29 67.2-76.6 67.2-130.3 0-24.8-5.7-48.3-15.7-69.3-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7H368c-8.8 0-16-7.2-16-16v-25.5c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0c-57.3 0-107.6 30.1-135.8 75.4 5 8.6 7.8 18.4 7.8 28.6v40.8l16 16v-.8c0-60.5 48-109.9 108-111.9l-25.3 25.3c-12 12-18.7 28.3-18.7 45.3V144c0 35.3 28.7 64 64 64h25.4c17 0 33.3-6.7 45.3-18.7l25.2-25.3z"
        }
    ]
};

const FarScrewdriver = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScrewdriver",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m445.9 55.9 10.2 10.2-59.9 77.9H368v-28.2l77.9-59.9zM507 78.6c7.4-9.6 6.5-23.1-2.1-31.6L465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19V158l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8l85.6-85.5H408c7.5 0 14.5-3.5 19-9.4l80-104zM155.3 315.3c11.4-11.4 29.9-11.4 41.4 0s11.4 29.9 0 41.4L96 457.4 54.6 416l100.7-100.7zm75.3-33.9c-30.2-30.2-79.1-30.2-109.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3z"
        }
    ]
};

const FarScribble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScribble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.3 21.4C198.3 7.7 218 0 238.4 0h1C283.9 0 320 36.1 320 80.6c0 21.4-8.5 41.9-23.6 57L89.5 344.4c-6.1 6.1-9.5 14.4-9.5 23 0 18 14.6 32.6 32.6 32.6 8.6 0 16.9-3.4 23-9.5l238.9-238.9c15.1-15.1 35.6-23.6 57-23.6 44.5 0 80.6 36.1 80.6 80.6 0 21.4-8.5 41.9-23.6 57L384.2 369.8c-10.4 10.3-16.2 24.4-16.2 39 0 30.5 24.7 55.2 55.2 55.2h4.4c5.6 0 11.2-.9 16.6-2.7l36.2-12.1c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4l-36.2 12.1c-10.2 3.4-21 5.2-31.8 5.2h-4.4c-57 0-103.2-46.2-103.2-103.2 0-27.4 10.9-53.6 30.2-73l104.3-104.3c6.1-6.1 9.5-14.4 9.5-23 0-18-14.6-32.6-32.6-32.6-8.6 0-16.9 3.4-23 9.5L169.5 424.4a80.607 80.607 0 0 1-57 23.6C68.1 448 32 411.9 32 367.4c0-21.4 8.5-41.9 23.6-57l206.9-206.8c6.1-6.1 9.5-14.4 9.5-23 0-18-14.6-32.6-32.6-32.6h-1c-8.4 0-16.5 3.2-22.7 8.8L40.2 217.7c-9.8 9-25 8.3-33.9-1.5s-8.3-25 1.5-33.9L183.3 21.4z"
        }
    ]
};

const FarScrollOld = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScrollOld",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 80c-17.7 0-32 14.3-32 32v48h32v48H48c-26.5 0-48-21.5-48-48v-48c0-44.2 35.8-80 80-80h320c44.2 0 80 35.8 80 80v160h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-80h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-16c0-17.7-14.3-32-32-32H153.3c4.3 9.8 6.7 20.6 6.7 32v112h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v144c0 17.7 14.3 32 32 32s32-14.3 32-32v-48c0-26.5 21.5-48 48-48h260.2c26.5 0 48 21.5 48 48v48c0 44.2-35.8 80-80 80H192c-44.2 0-80-35.8-80-80V112c0-17.7-14.3-32-32-32zm185.3 352H496c17.7 0 32-14.3 32-32v-48H400v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-96v48c0 11.4-2.4 22.2-6.7 32z"
        }
    ]
};

const FarScrollTorah = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScrollTorah",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 48c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-17.7-14.3-32-32-32zm73.3 416c-12.3 28.3-40.5 48-73.3 48-44.2 0-80-35.8-80-80V80C0 35.8 35.8 0 80 0c32.8 0 61 19.7 73.3 48h333.4C499 19.7 527.2 0 560 0c44.2 0 80 35.8 80 80v352c0 44.2-35.8 80-80 80-32.8 0-61-19.7-73.3-48H153.3zm6.7-48h320V96H160v320zm368 16c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v352zM196 313.7c0-3.2.9-6.4 2.5-9.2l28.2-48.5-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2 0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3 0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2 0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9C334 392.2 327.3 396 320 396s-13.9-3.8-17.6-10.1L271 332h-56.7c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7 21.2-36.4h-42.4l21.2 36.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52h-70.4l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zm16.4-75.8H383l16.4 28.2 16.4-28.2zM320 143.6 298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204h-32.8zM257 308l-16.4-28.2-16.4 28.2H257z"
        }
    ]
};

const FarScroll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScroll",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 112c0-17.7 14.3-32 32-32s32 14.3 32 32v288c0 44.2 35.8 80 80 80h304c44.2 0 80-35.8 80-80v-48c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V112c0-11.4-2.4-22.2-6.7-32H400c17.7 0 32 14.3 32 32v160h48V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112v48c0 26.5 21.5 48 48 48h32v-48H48v-48zm448 320H265.3c4.3-9.8 6.7-20.6 6.7-32v-48h260.2v48c0 17.7-14.3 32-32 32z"
        }
    ]
};

const FarScrubber = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScrubber",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarScythe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarScythe",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M639.5 28.9c2.7-13-5.7-25.7-18.6-28.4s-25.7 5.7-28.4 18.6L536.9 288H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h118.9l-30.4 147.1c-2.7 13 5.7 25.7 18.6 28.4s25.7-5.7 28.4-18.6l96-464zM352 0C121.4 0 20.6 155.8 2.9 186.7c-2 3.5-2.9 7.4-2.9 11.4C0 212.4 11.6 224 25.9 224h491.5l9.9-48H68.7C108.6 126.8 196.8 48 352 48h201.8l7.3-35.3c.9-4.5 2.4-8.7 4.2-12.7H352z"
        }
    ]
};

const FarSdCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSdCard",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 64v384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V154.5c0-4.2 1.7-8.3 4.7-11.3l90.5-90.5c3-3 7.1-4.7 11.3-4.7H320c8.8 0 16 7.2 16 16zm48 384V64c0-35.3-28.7-64-64-64H154.5c-17 0-33.3 6.7-45.3 18.7l-90.5 90.6C6.7 121.3 0 137.5 0 154.5V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64zM176 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96z"
        }
    ]
};

const FarSdCards = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSdCards",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 352V64c0-8.8-7.2-16-16-16H234.5c-4.2 0-8.3 1.7-11.3 4.7l-74.5 74.5c-3 3-4.7 7.1-4.7 11.3V352c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16zM114.7 93.3l74.5-74.5C201.3 6.7 217.5 0 234.5 0H384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V138.5c0-17 6.7-33.3 18.7-45.3zM24 96c13.3 0 24 10.7 24 24v256c0 48.6 39.4 88 88 88h224c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24zm280 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarSealExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSealExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 112c12.7 0 24.9-5.1 33.9-14.1l46.1-46L302.1 98c9 9 21.2 14.1 33.9 14.1h64v64c0 12.7 5.1 24.9 14.1 33.9l45.6 45.6-45.6 45.6c-9 9-14.1 21.2-14.1 33.9V400h-64.9c-12.7 0-24.9 5.1-33.9 14.1L256 459.2l-45.1-45.1c-9-9-21.2-14.1-33.9-14.1h-65v-64.9c0-12.7-5.1-24.9-14.1-33.9l-45.5-45.7L98 209.9c9-9 14.1-21.2 14.1-33.9v-64h64zm113.9-94.1C271.2-.8 240.8-.8 222 17.9L176 64h-64c-26.5 0-48 21.5-48 48v64l-45.6 45.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1V400c0 26.5 21.5 48 48 48h64.9l45.1 45.1c18.7 18.7 49.1 18.7 67.9 0l45.2-45.1H400c26.5 0 48-21.5 48-48v-64.9l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176v-64c0-26.5-21.5-48-48-48h-64l-46.1-46.1zM256 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarSealQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSealQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 112c12.7 0 24.9-5.1 33.9-14.1l46.1-46L302.1 98c9 9 21.2 14.1 33.9 14.1h64v64c0 12.7 5.1 24.9 14.1 33.9l45.6 45.6-45.6 45.6c-9 9-14.1 21.2-14.1 33.9V400h-64.9c-12.7 0-24.9 5.1-33.9 14.1L256 459.2l-45.1-45.1c-9-9-21.2-14.1-33.9-14.1h-65v-64.9c0-12.7-5.1-24.9-14.1-33.9l-45.5-45.7L98 209.9c9-9 14.1-21.2 14.1-33.9v-64h64zm113.9-94.1C271.2-.8 240.8-.8 222 17.9L176 64h-64c-26.5 0-48 21.5-48 48v64l-45.6 45.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1V400c0 26.5 21.5 48 48 48h64.9l45.1 45.1c18.7 18.7 49.1 18.7 67.9 0l45.2-45.1H400c26.5 0 48-21.5 48-48v-64.9l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176v-64c0-26.5-21.5-48-48-48h-64l-46.1-46.1zM169.8 165.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L244 229.6c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM288 352a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarSeal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSeal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M210.4 97.9c-9 9-21.2 14.1-33.9 14.1H112v64.5c0 12.7-5.1 24.9-14.1 33.9L52.4 256 98 301.6c9 9 14.1 21.2 14.1 33.9V400h64.5c12.7 0 24.9 5.1 33.9 14.1l45.5 45.5 45.6-45.6c9-9 21.2-14.1 33.9-14.1H400v-64.4c0-12.7 5.1-24.9 14.1-33.9l45.5-45.6-45.6-45.6c-9-9-14.1-21.2-14.1-33.9V112h-64.4c-12.7 0-24.9-5.1-33.9-14.1L256 52.4l-45.6 45.5zM222 18.4c18.7-18.7 49.1-18.7 67.9 0L335.5 64H400c26.5 0 48 21.5 48 48v64.5l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5V400c0 26.5-21.5 48-48 48h-64.5l-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448H112c-26.5 0-48-21.5-48-48v-64.5l-45.6-45.6c-18.7-18.7-18.7-49.1 0-67.9L64 176.5V112c0-26.5 21.5-48 48-48h64.5l45.6-45.6z"
        }
    ]
};

const FarSeatAirline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSeatAirline",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24v118.9c0 14.7 3.1 29.2 9.1 42.5l80 178.6c14.2 31.6 45.6 52 80.3 52H216v48h-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24h-96v-48h88c29.1 0 55.3-17.5 66.5-44.3l27.7-66.5c3.1-7.4 2.3-15.9-2.2-22.5S432 272 424 272H100.5l-14.3-32H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H64.6l-11.7-26.2c-3.2-7.2-4.9-15-4.9-22.9V24zm84.9 320.4L122 320h266l-13.8 33.2c-3.7 8.9-12.5 14.8-22.2 14.8H169.4c-15.8 0-30.1-9.3-36.5-23.6z"
        }
    ]
};

const FarSection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSection",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48.4 90.6c2.8-15.9 12.5-27.3 29-34.6 17.6-7.7 42.8-10.5 73.1-5.6l3.2-20.4-3.3 20.5c9.7 1.6 39.9 7.6 49.1 10.1 12.8 3.5 26-4 29.5-16.8s-4-26-16.8-29.5c-11.5-3.2-43.5-9.5-54.1-11.3C121.8-2.8 86.5-.5 58 12.1 28.6 25.1 6.7 49 1 83.3c-.1.4-.1.8-.2 1.2-2.2 19.5.4 37 7.9 52.3 7.4 15.2 18.8 26.6 31.4 35.3 2.4 1.7 4.9 3.3 7.4 4.8-23.3 12.9-40.7 33.8-45.8 62.5-.1.4-.1.9-.2 1.3-2.3 18.8.4 35.8 8.1 50.7 7.6 14.6 19.1 25.5 31.6 33.7 22.9 15.1 53.3 23.9 79.2 31.5l3.6 1c29 8.5 52.3 15.7 67.7 26.7 7.1 5.1 11.4 10.2 13.7 15.6 2.3 5.3 3.6 12.8 1.6 24.2-2.5 14.2-11.6 25.1-28.5 32.2-17.7 7.4-43.1 9.9-73.3 5.3-14.9-2.4-40.4-10.8-61-17.7-4.5-1.5-8.8-2.9-12.7-4.2-12.6-4.1-26.1 2.8-30.2 15.4s2.8 26.1 15.4 30.2c3 1 6.5 2.1 10.5 3.5 20.3 6.7 51.4 17.1 70.6 20.2h.1c36 5.5 70.9 3.3 99.1-8.5 29-12.1 51.4-34.8 57.3-68.1 3.4-19 1.9-36.3-4.8-51.8-6.7-15.3-17.6-26.8-29.8-35.6 17.7-13.5 30.5-32.7 34.7-58 3.3-19.7 1.8-37.5-4.7-53.4-6.5-15.8-17.3-27.9-29.6-37.2-23.2-17.5-55.1-27.4-81.8-35.6l-.7-.2c-29.3-9-53.3-16.5-69.9-28.1-7.7-5.4-12.7-11-15.7-17-2.8-5.8-4.6-13.7-3.4-25.1zm114.8 228.7c-8.6-2.8-17-5.2-25-7.6l-.8-.2c-29.1-8.5-53.2-15.6-69.8-26.5-7.8-5.1-12.6-10.3-15.4-15.7-2.6-5-4.3-11.9-3.2-22.1 2.7-13.9 11.7-24.6 28.4-31.6 13-5.4 30.2-8.3 50.5-7.5 26.9 8.4 48.6 15.8 63.1 26.8 7.1 5.4 11.6 10.9 14.1 17.1 2.5 6.1 3.9 14.7 1.8 27.2-3.3 19.4-17.2 33.8-43.7 40.1z"
        }
    ]
};

const FarSeedling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSeedling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M307.3 207c82.9-9.1 148.4-75.6 156-159H456c-76.7 0-142 49.1-166.1 117.5-8.8-16.8-19.4-32.6-31.6-47.1C296.1 48 370.5 0 456 0h24c17.7 0 32 14.3 32 32 0 113.6-84.6 207.4-194.2 222-2.1-16.2-5.6-31.9-10.5-47.1zM48 112v16c0 97.2 78.8 176 176 176h8v-16c0-97.2-78.8-176-176-176h-8zm232 176v200c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-8C100.3 352 0 251.7 0 128V96c0-17.7 14.3-32 32-32h24c123.7 0 224 100.3 224 224z"
        }
    ]
};

const FarSemicolon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSemicolon",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 128a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm96 0a72 72 0 1 0-144 0 72 72 0 1 0 144 0zM84.4 347c1.4-6.4 7.1-11 13.6-11 7.3 0 13.9 6.2 13.9 14.3 0 2.7-.8 5.4-2.1 7.6L67.1 428l17.3-81zm-.7 145.8L150.8 383c6-9.8 9.2-21.2 9.2-32.7 0-34.2-27.7-62.3-61.9-62.3-29.2 0-54.4 20.4-60.6 49L10.4 463.6C5 488.5 24 512 49.5 512c14 0 26.9-7.3 34.2-19.2z"
        }
    ]
};

const FarSendBack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSendBack",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h128zM64 0C28.7 0 0 28.7 0 64v128c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm512 304c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V320c0-8.8 7.2-16 16-16h128zm-128-48c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H448zm-288 32v64c0 35.3 28.7 64 64 64h128v-96c0-53 43-96 96-96h32v-64c0-35.3-28.7-64-64-64H288v96c0 53-43 96-96 96h-32z"
        }
    ]
};

const FarSendBackward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSendBackward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h64V224c0-53 43-96 96-96h128V64c0-35.3-28.7-64-64-64H64zm160 208h224c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zm-64 16v224c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FarSensorCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSensorCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80h320c8.8 0 16 7.2 16 16v128c17.2 0 33.5 3.9 48 10.8V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h170.8c-6.9-14.5-10.8-30.8-10.8-48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm96 360h224c44.2 0 80-35.8 80-80 0-39-27.9-71.5-64.8-78.6.5-3.1.8-6.2.8-9.4 0-30.9-25.1-56-56-56-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80 0 5.9.6 11.7 1.9 17.2-37.5 6.7-65.9 39.4-65.9 78.8 0 44.2 35.8 80 80 80z"
        }
    ]
};

const FarSensorFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSensorFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80h320c8.8 0 16 7.2 16 16v55.4c4.1-3.9 8.2-7.7 12.5-11.5 10-8.9 23-12.8 35.5-11.7V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h273.6c-12.7-14.3-23.4-30.5-31.5-48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm213.5 11.6c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.6 32-32.3 66.3-32.3 92.7 0 87.8 70.3 159.8 160 159.8 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96z"
        }
    ]
};

const FarSensorOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSensorOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 96c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm381.3-20c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM536 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zm13.3 140c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32z"
        }
    ]
};

const FarSensorTriangleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSensorTriangleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80h320c8.8 0 16 7.2 16 16v49.9c13.1-11.4 30.1-17.9 48-17.9V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h161c-.6-4-1-8.1-1-12.3 0-12.5 3-24.7 8.9-35.7H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm21.8 293.8c-3.8 6.7-5.8 14.2-5.8 21.9 0 24.5 19.8 44.3 44.3 44.3h295.4c24.5 0 44.3-19.8 44.3-44.3 0-7.7-2-15.2-5.8-21.9l-150.4-265c-7.3-12.8-21-20.8-35.8-20.8s-28.5 8-35.8 20.9l-150.4 265zM464 272v88c0 8.8-7.2 16-16 16s-16-7.2-16-16v-88c0-8.8 7.2-16 16-16s16 7.2 16 16zm-16 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarSensor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSensor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 56v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarServer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarServer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 240c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H64zM0 352c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64zm392 32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-88 280a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarShapes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShapes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m164.6 175.5 96-160C266.3 5.9 276.8 0 288 0s21.7 5.9 27.4 15.5l96 160c5.9 9.9 6.1 22.2.4 32.2s-16.3 16.2-27.8 16.2H192c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3.4-32.2zM288 63.1 220.3 176h135.4L288 63.1zM464 320H336v128h128V320zm-136-48h144c22.1 0 40 17.9 40 40v144c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V312c0-22.1 17.9-40 40-40zM208 384a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM0 384a128 128 0 1 1 256 0 128 128 0 1 1-256 0z"
        }
    ]
};

const FarShareAll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShareAll",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M367.5 73.4c-9.6-9.1-10-24.3-.9-33.9s24.3-10 33.9-.9l141.7 134.6c19.9 18.9 19.9 50.7 0 69.6L400.5 377.4c-9.6 9.1-24.8 8.7-33.9-.9s-8.7-24.8.9-33.9L509.2 208 367.5 73.4zM224 240h24c13.3 0 24 10.7 24 24v52.1L392.1 208 272 99.9V152c0 13.3-10.7 24-24 24h-72c-70.7 0-128 57.3-128 128 0 15.3 1.9 29.1 5.2 41.5C70 284.7 125.8 240 192 240h32zm0 96v-48h-32c-5.5 0-10.8.5-16 1.3-45.4 7.6-80 47.1-80 94.7 0 17.3 4.2 30.5 9.5 40.2 1.6 2.9 3.3 5.5 5 7.9 2.6 3.5 5.3 6.4 7.7 8.6.5.5 1 .9 1.4 1.4 4.8 4.9 8.3 11.3 8.3 18.1 0 10.9-8.8 19.7-19.7 19.7-2.8 0-5.6-.6-8.1-1.9-2.6-1.4-6.3-3.5-10.8-6.5-2.7-1.8-5.7-3.8-8.9-6.2-3.7-2.7-7.6-5.8-11.7-9.3C38.6 430.2 0 382 0 304c0-97.2 78.8-176 176-176h48V64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2v-16z"
        }
    ]
};

const FarShareFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShareFromSquare",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 255.4V208c0-8.8-7.2-16-16-16h-94.5c-50.9 0-93.9 33.5-108.3 79.6-3.3-9.4-5.2-19.8-5.2-31.6 0-61.9 50.1-112 112-112h96c8.8 0 16-7.2 16-16V64.6L506 160l-106 95.4zM336 240h16v48c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0 367.5 0 352 15.5 352 34.7V80h-64c-88.4 0-160 71.6-160 160 0 60.4 34.6 99.1 63.9 120.9 5.9 4.4 11.5 8.1 16.7 11.2 4.4 2.7 8.5 4.9 11.9 6.6 3.4 1.7 6.2 3 8.2 3.9 2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8 0-7.8-5.3-14.7-11.6-19.5-.4-.3-.7-.5-1.1-.8-1.7-1.1-3.4-2.5-5-4.1-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5-2.6-6-4.3-13.3-4.3-22.4 0-36.1 29.3-65.5 65.5-65.5H336zM72 32C32.2 32 0 64.2 0 104v336c0 39.8 32.2 72 72 72h336c39.8 0 72-32.2 72-72v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
        }
    ]
};

const FarShareNodes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShareNodes",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 128c0 53-43 96-96 96-28.9 0-54.8-12.8-72.4-33l-89.7 44.9c1.4 6.5 2.1 13.2 2.1 20.1s-.7 13.6-2.1 20.1l89.7 44.9c17.6-20.2 43.5-33 72.4-33 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-6.9.7-13.6 2.1-20.1L168.4 319c-17.6 20.2-43.5 33-72.4 33-53 0-96-43-96-96s43-96 96-96c28.9 0 54.8 12.8 72.4 33l89.7-44.9c-1.4-6.5-2.1-13.2-2.1-20.1 0-53 43-96 96-96s96 43 96 96zM96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm304-176a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarShare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 240h-96c-66.2 0-122 44.7-138.8 105.5-3.3-12.4-5.2-26.2-5.2-41.5 0-70.7 57.3-128 128-128h136c13.3 0 24-10.7 24-24V99.9L456.1 208 336 316.1V264c0-13.3-10.7-24-24-24h-24zm0 48v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4S288 51.4 288 64v64H176C78.8 128 0 206.8 0 304c0 78 38.6 126.2 68.7 152.1 4.1 3.5 8.1 6.6 11.7 9.3 3.2 2.4 6.2 4.4 8.9 6.2 4.5 3 8.3 5.1 10.8 6.5 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-6.8-3.6-13.2-8.3-18.1l-1.4-1.4c-2.4-2.3-5.1-5.1-7.7-8.6-1.7-2.3-3.4-5-5-7.9-5.3-9.7-9.5-22.9-9.5-40.2 0-53 43-96 96-96h96z"
        }
    ]
};

const FarSheep = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSheep",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 135.8V208c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80v-72.2l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5C544.7 50.2 514.5 32 480 32s-64.7 18.2-81.6 45.4l-47.9 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2zm80-7.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-203.1-1-.4-.9c-6.9-16.1-5.7-33.5 1.8-47.9-7.4-11.8-18.5-21-31.7-26-7-2.7-14.6-4.2-22.6-4.2-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8-3.2-.5-6.5-.8-9.8-.8-35.3 0-64 28.7-64 64 0 5.3.7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64h1.5l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32v-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1l17.7-93.9h1.5c35.3 0 64-28.7 64-64 0-2.7-.2-5.4-.5-8H464c-11.8 0-23.2-1.8-33.8-5.2.2 3.1.6 6.2 1.4 9.3.3 1.2.5 2.5.5 3.9 0 8.8-7.2 16-16 16-.9 0-1.7-.1-2.5-.2-24.6-3.8-48 11.9-53.9 36-1.7 7-8.1 12.1-15.5 12.1-3.8 0-7.2-1.3-9.9-3.4-20.1-16-49.1-13.3-66 6-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5c-16.9-19.3-45.9-21.9-66-6-2.7 2.2-6.1 3.4-9.9 3.4-7.5 0-13.8-5.1-15.5-12.1-5.9-24.2-29.3-39.8-53.9-36-.8.1-1.6.2-2.5.2-8.8 0-16-7.2-16-16 0-1.4.2-2.7.5-3.9 5.3-21.3-4.6-43.6-24-53.9-5.5-2.8-8.8-8.2-8.8-14.2s3.3-11.4 8.5-14.2c19.4-10.4 29.3-32.6 24-53.9a16 16 0 0 1-.5-3.9c0-8.8 7.2-16 16-16 .9 0 1.7.1 2.5.2 24.6 3.8 48-11.9 53.9-36 1.7-7 8.1-12.1 15.5-12.1 3.8 0 7.2 1.3 9.9 3.5 20.1 16 49.1 13.3 66-6 3-3.4 7.3-5.5 12.1-5.5 5.8 0 10.9 3 13.7 7.8 8 13.3 22 21.9 37.4 23.1.6 0 1.2.1 1.7.1z"
        }
    ]
};

const FarSheetPlastic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSheetPlastic",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48c8.8 0 16 7.2 16 16v288h-80c-17.7 0-32 14.3-32 32v80H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h256zM0 448c0 35.3 28.7 64 64 64h172.1c12.7 0 24.9-5.1 33.9-14.1l99.9-99.9c9-9 14.1-21.2 14.1-33.9V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384zM203.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zm96 54.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160z"
        }
    ]
};

const FarShekelSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShekelSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 32c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24s24-10.7 24-24V80h120c39.8 0 72 32.2 72 72v184c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-66.3-53.7-120-120-120H40zm272 448c66.3 0 120-53.7 120-120V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v304c0 39.8-32.2 72-72 72H192V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v272c0 13.3 10.7 24 24 24h144z"
        }
    ]
};

const FarShelvesEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShelvesEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24v-24h544v24c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v136H48V24zm0 184h544v208H48V208z"
        }
    ]
};

const FarShelves = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShelves",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0c13.3 0 24 10.7 24 24v136h544V24c0-13.3 10.7-24 24-24s24 10.7 24 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24v-24H48v24c0 13.3-10.7 24-24 24S0 501.3 0 488V24C0 10.7 10.7 0 24 0zm24 416h544V208H48v208zM352 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V32zM128 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm160 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarShieldCat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldCat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM160 154.4V272c0 53 43 96 96 96s96-43 96-96V154.4c0-5.8-4.7-10.4-10.4-10.4h-.2c-3.4 0-6.5 1.6-8.5 4.3l-40 53.3c-3 4-7.8 6.4-12.8 6.4H232c-5 0-9.8-2.4-12.8-6.4l-40-53.3c-2-2.7-5.2-4.3-8.5-4.3h-.2c-5.8 0-10.4 4.7-10.4 10.4zM216 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarShieldCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
        }
    ]
};

const FarShieldCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldCross",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48h-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h96v176c0 13.3 10.7 24 24 24s24-10.7 24-24V216h96c13.3 0 24-10.7 24-24s-10.7-24-24-24h-96v-48z"
        }
    ]
};

const FarShieldDog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldDog",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM160.9 270.2l-15 30c-1.2 2.5-1.9 5.2-1.9 8 0 7.1 4.3 13.6 10.8 16.4l98.7 42.3c1.7.7 3.4 1.1 5.2 1.1 7.3 0 13.3-5.9 13.3-13.3V304h48c44.2 0 80-35.8 80-80v-32c0-8.8-7.2-16-16-16h-64l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H240v64c0 35.3-28.7 64-64 64-5.2 0-10.3-.6-15.1-1.8zM160 144c-8.8 0-16 7.2-16 16v48c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h-48zm96 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarShieldExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM256 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarShieldHalved = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldHalved",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 59.6v390.7C99.2 375.7 64.4 227.3 64 139.7c0-5 3.1-10.2 9-12.8l159-67.3zm48 390.8V59.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 87.5-35.2 236-168 310.6zM457.7 82.8 269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2z"
        }
    ]
};

const FarShieldHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM144 221.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FarShieldKeyhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldKeyhole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM312 208c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6V328c0 13.3 10.7 24 24 24s24-10.7 24-24v-69.4c18.9-9 32-28.3 32-50.6z"
        }
    ]
};

const FarShieldMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarShieldPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FarShieldQuartered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldQuartered",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M73 127c-5.9 2.5-9.1 7.8-9 12.8.1 17.9 1.6 38.4 5.1 60.3H232V59.6L73 127zm6.7 121c20.9 73.9 65.9 153.7 152.3 202.3V248H79.7zm200.3 0v202.4C366.4 401.8 411.4 322 432.3 248H280zm162.9-48c3.5-21.9 5-42.3 5.1-60.3 0-5-3.1-10.2-9-12.8L280 59.6V200h162.9zM269.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0s9.2 1 13.4 2.9z"
        }
    ]
};

const FarShieldSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M174.2 111.2 320 49.4 503 127c5.9 2.5 9.1 7.8 9 12.8-.3 52.8-13 127.8-52.2 195.3L174.2 111.2zM497.9 365c47.4-78.8 61.8-166.3 62.1-225 .1-26.2-16.3-47.9-38.3-57.2L333.4 2.9C329.2 1 324.7 0 320 0s-9.2 1-13.4 2.9L131 77.4 38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L497.9 365zM80.6 159.5c5.5 102 51.5 266.3 213.1 343.7 16.7 8 36.1 8 52.8 0 35.7-17.1 65.8-38.5 91.1-62.5l-38.2-30.1c-20.8 18.9-45.1 35.7-73.5 49.3-3.6 1.7-7.8 1.7-11.3 0C195.8 403.1 147.9 290.6 133.3 201l-52.7-41.5z"
        }
    ]
};

const FarShieldVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM256 96c-8.8 0-16 7.2-16 16 0 33-39.9 49.5-63.2 26.2-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 184.1 161 224 128 224c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 318.5 240 335 240 368c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2 6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C334.5 295.9 351 256 384 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2 6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 161.5 272 145 272 112c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarShieldXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShieldXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73 127 183-77.6L439 127c5.9 2.5 9.1 7.8 9 12.8-.4 91.4-38.4 249.3-186.3 320.1-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zm384.7-44.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShield",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 49.4 73 127c-5.9 2.5-9.1 7.8-9 12.8.5 91.4 38.4 249.3 186.4 320.1 3.6 1.7 7.8 1.7 11.3 0C409.7 389 447.6 231.2 448 139.7c0-5-3.1-10.2-9-12.8L256 49.4zm13.4-46.5 188.3 79.9c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0s9.2 1 13.4 2.9z"
        }
    ]
};

const FarShip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShip",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v32h40c30.9 0 56 25.1 56 56v118.4l25.9 9.7c38.1 14.3 48.7 63.2 19.9 92L457 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.9-68.9c4.1-4.1 2.6-11.1-2.8-13.1l-198.4-74.4c-1.8-.7-3.8-.7-5.6 0L87 293c-5.4 2-7 9-2.8 13.1L153 375c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-68.9-68.8c-28.8-28.8-18.2-77.7 19.9-92l25.9-9.7V120c0-30.9 25.1-56 56-56h40V32zm-48 88v100.4l124.3-46.6c12.7-4.8 26.6-4.8 39.3 0L432 220.4V120c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8zm-32.1 310.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7 9.1-8.1 22.8-8.1 31.9 0z"
        }
    ]
};

const FarShirtLongSleeve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShirtLongSleeve",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M188.4 48c-26.3 0-50.4 14.3-63.1 37.3L58.9 206C51.7 219 48 233.6 48 248.4V392c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V248.4c0-6.7 1.7-13.4 5-19.3l62-112.8c5.3-9.6 16.4-14.4 27-11.7s18 12.3 18 23.2V448c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16V128c0-11 7.4-20.5 18-23.2s21.7 2.1 27 11.7l62 112.8-21 11.6 21-11.6c3.2 5.9 5 12.5 5 19.3V392c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V248.4c0-14.8-3.7-29.4-10.9-42.4L514.7 85.3c-12.6-23-36.8-37.3-63.1-37.3h-8.9c-1 .1-2 0-3 0h-18.5c-10.8 45.9-52 80-101.2 80s-90.4-34.1-101.2-80h-18.5c-1 .1-2 .1-3 0h-8.9zM83.2 62.2C104.3 23.8 144.6 0 188.4 0H224c23 0 37.7 18.2 41.1 35.2C270.3 60.7 292.9 80 320 80s49.7-19.3 54.9-44.8C378.3 18.2 393 0 416 0h35.6c43.8 0 84.1 23.8 105.1 62.2l66.4 120.7c11 20.1 16.8 42.6 16.8 65.5V392c0 30.9-25.1 56-56 56H552c-30.9 0-56-25.1-56-56V250.5l-16-29.1V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V221.4l-16 29.1V392c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V248.4c0-22.9 5.8-45.5 16.8-65.5L83.2 62.2z"
        }
    ]
};

const FarShirtRunning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShirtRunning",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0c13.3 0 24 10.7 24 24v48c0 44.2 35.8 80 80 80s80-35.8 80-80V24c0-13.3 10.7-24 24-24s24 10.7 24 24c0 127.9 26.8 181 41.5 200.5 9.6 12.8 22.5 32.8 22.5 56.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V280.7c0-23.5 12.9-43.5 22.5-56.3C37.2 205 64 151.9 64 24 64 10.7 74.7 0 88 0zM60.8 253.4C52.2 264.8 48 273.9 48 280.7v110.1l251.3-181.5c-5.4-13.6-10.4-29.8-14.6-49.1-23.3 24.5-56.2 39.8-92.7 39.8s-69.4-15.3-92.7-39.8c-10.3 46.7-25.2 75.5-38.5 93.2zM48.1 450c1 7.9 7.7 14 15.9 14h256c8.8 0 16-7.2 16-16V280.7c0-6.8-4.2-15.9-12.8-27.3-.3-.4-.7-.9-1-1.4L48.1 450z"
        }
    ]
};

const FarShirtTankTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShirtTankTop",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24c0 127.9-26.8 181-41.5 200.5C12.9 237.2 0 257.2 0 280.7V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V280.7c0-23.5-12.9-43.5-22.5-56.3C346.8 205 320 151.9 320 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V24zM99.3 160.2c23.3 24.5 56.2 39.8 92.7 39.8s69.4-15.3 92.7-39.8c10.3 46.7 25.2 75.5 38.5 93.1 8.6 11.4 12.8 20.5 12.8 27.3V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V280.7c0-6.8 4.2-15.9 12.8-27.3 13.3-17.6 28.2-46.5 38.5-93.1z"
        }
    ]
};

const FarShirt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShirt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M146.3 27.8C167.9 9.8 195.1 0 223.2 0c18.2 0 31.1 13.6 34 28.5C263 57.8 288.9 80 320 80s57-22.2 62.8-51.5c2.9-14.9 15.9-28.5 34-28.5 28.1 0 55.3 9.8 76.8 27.8l-15.3 18.5 15.4-18.4L619.8 133c11.6 9.7 18.8 23.6 20 38.6s-3.7 29.9-13.7 41.3l-56 64c-20 22.9-54.6 25.6-78 6.1L480 272.9V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V272.9L147.9 283c-23.4 19.5-58 16.7-78-6.1l-56-64C3.9 201.5-1 186.6.2 171.6s8.4-29 20-38.6L146.3 27.8zm66.5 20.9c-13.1 1.9-25.5 7.4-35.8 15.9L50.9 169.9c-1.7 1.4-2.7 3.4-2.9 5.5s.5 4.3 2 5.9l-18.1 15.8L50 181.3l56 64c2.9 3.3 7.8 3.7 11.1.9l51.5-42.9c7.2-6 17.1-7.2 25.5-3.3s13.8 12.4 13.8 21.7V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V221.7c0-9.3 5.4-17.8 13.8-21.7s18.4-2.7 25.5 3.3l51.5 42.9c3.3 2.8 8.3 2.4 11.1-.9l56-64c1.4-1.6 2.1-3.7 2-5.9s-1.2-4.1-2.9-5.5L462.9 64.7c-10.3-8.6-22.7-14.1-35.8-15.9-14 45.8-56.6 79.2-107.1 79.2s-93.1-33.4-107.1-79.3z"
        }
    ]
};

const FarShishKebab = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShishKebab",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 48c-26.5 0-48 21.5-48 48 0 5.7 1 11.1 2.7 16.1 6.8 19.2 11.3 51.8-11.3 74.5L337 209l24.4 24.4c14.5 14.5 22.6 34.1 22.6 54.6s-8.1 40.1-22.6 54.6l-18.7 18.7C328.1 375.9 308.5 384 288 384c0 20.5-8.1 40.1-22.6 54.6l-18.7 18.7C232.1 471.9 212.5 480 192 480s-40.1-8.1-54.6-22.6L113 433l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72-24.5-24.5C40.1 360.1 32 340.5 32 320s8.1-40.1 22.6-54.6l18.7-18.7C87.9 232.1 107.5 224 128 224c0-20.5 8.1-40.1 22.6-54.6l18.7-18.7c14.6-14.6 34.2-22.7 54.7-22.7s40.1 8.1 54.6 22.6L303 175l22.5-22.5c1.1-1.1 2.5-3.3 2.8-7.8.3-4.7-.6-10.6-2.7-16.6-3.7-10.1-5.6-20.9-5.6-32.1 0-53 43-96 96-96s96 43 96 96c0 19.7-6 38.1-16.2 53.4-7.4 11-22.3 14-33.3 6.6s-14-22.3-6.6-33.3c5.1-7.6 8.1-16.8 8.1-26.7 0-26.5-21.5-48-48-48zM88.6 340.7l82.7 82.7c5.5 5.5 12.9 8.6 20.7 8.6s15.2-3.1 20.7-8.6l18.7-18.7c5.5-5.5 8.6-12.9 8.6-20.7s-3.1-15.2-8.6-20.7l-82.7-82.7c-5.5-5.5-12.9-8.6-20.7-8.6s-15.2 3.1-20.7 8.6l-18.7 18.7c-5.5 5.5-8.6 12.9-8.6 20.7s3.1 15.2 8.6 20.7zm178.7-13.3c5.5 5.5 12.9 8.6 20.7 8.6s15.2-3.1 20.7-8.6l18.7-18.7c5.5-5.5 8.6-12.9 8.6-20.7s-3.1-15.2-8.6-20.7l-82.7-82.7c-5.5-5.5-12.9-8.6-20.7-8.6s-15.2 3.1-20.7 8.6l-18.7 18.7c-5.5 5.5-8.6 12.9-8.6 20.7s3.1 15.2 8.6 20.7l82.7 82.7z"
        }
    ]
};

const FarShoePrints = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShoePrints",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323.7 62.6C355.1 54.7 390.3 48 416 48c41.2 0 89.8 10.6 126.5 28.9C582 96.7 592 116.3 592 128c0 9.4-5.1 21.5-35.9 33.1-29.4 11.1-67 14.9-92.1 14.9-34.7 0-53.5-10.4-80.2-25.7l-.7-.4c-20.6-11.8-45.1-25.8-79.1-33V67.8c6-1.7 12.7-3.4 19.7-5.2zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0c-63.7 0-160 32-160 32v128zM128 96c0 35.3 28.7 64 64 64h32V32h-32c-35.3 0-64 28.7-64 64zm67.7 353.4c-7-1.8-13.7-3.5-19.7-5.2v-49.1c34-7.3 58.5-21.3 79.1-33l.7-.4c26.7-15.3 45.5-25.7 80.2-25.7 25.2 0 62.7 3.7 92.1 14.9 30.8 11.6 35.9 23.7 35.9 33.1 0 11.7-10 31.3-49.5 51.1C377.8 453.4 329.2 464 288 464c-25.7 0-60.9-6.7-92.3-14.6zM128 352v128s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM0 416c0 35.3 28.7 64 64 64h32V352H64c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FarShopLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShopLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25c8.4-15.4 24.5-25 42.1-25h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3 0 12.4-5.9 23.3-14.9 30.3-9.6-16.7-23.4-30.6-39.9-40.4L515.5 48h-391L54.7 176h415.6c-18.8 11.3-34 28-43.5 48H384v248c0 22.1-17.9 40-40 40H104c-22.1 0-40-17.9-40-40V224H38.2C17.1 224 0 206.9 0 185.8zM112 224v96h224v-96H112zm0 240h224v-96H112v96zm416-224c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FarShopSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShopSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224h25.8c21.1 0 38.2-17.1 38.2-38.2 0-6.4-1.6-12.7-4.7-18.3L557.6 25c-8.4-15.4-24.5-25-42.1-25h-391c-17.6 0-33.7 9.6-42.1 25l-5.5 10L38.8 5.1zM115.2 65l9.3-17h391l69.8 128H256.8L115.2 65zm202.9 159H528v164.5L318.1 224zM0 185.8C0 206.9 17.1 224 38.2 224H64v248c0 22.1 17.9 40 40 40h240c22.1 0 40-17.9 40-40v-73.5L284.3 320H112v-96h50.5l-60.9-48H54.7l14.1-25.8L30.5 120 4.7 167.4c-3.1 5.7-4.7 12-4.7 18.4zM112 464v-96h224v96H112z"
        }
    ]
};

const FarShop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25c8.4-15.4 24.5-25 42.1-25h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3 0 21.1-17.1 38.2-38.2 38.2H576V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V224H384v248c0 22.1-17.9 40-40 40H104c-22.1 0-40-17.9-40-40V224H38.2C17.1 224 0 206.9 0 185.8zM112 224v96h224v-96H112zM515.5 48h-391L54.7 176h530.6L515.5 48zM112 464h224v-96H112v96z"
        }
    ]
};

const FarShovelSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShovelSnow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-31.4 31.4a80.607 80.607 0 0 1-57 23.6c-13.5 0-26.2-3.3-37.4-9.2L297.9 248l35.3 35.3c19.8 19.8 21.9 51.2 4.9 73.5L236.7 489.9c-10.6 13.9-27.1 22.1-44.5 22.1h-2.9c-14.9 0-29.1-5.9-39.6-16.4L16.4 362.3A55.924 55.924 0 0 1 0 322.7v-2.9c0-17.5 8.2-34 22.1-44.5l133.1-101.4c22.3-17 53.7-14.9 73.5 4.9l35.3 35.3 81.2-81.2c-5.9-11.2-9.2-23.9-9.2-37.4 0-21.4 8.5-41.9 23.6-57L391 7zm17 50.9-14.5 14.5c-6.1 6.1-9.5 14.4-9.5 23 0 18 14.6 32.6 32.6 32.6 8.6 0 16.9-3.4 23-9.5l14.5-14.5L408 57.9zM184.3 212 51.2 313.5c-2 1.5-3.2 3.9-3.2 6.4v2.9c0 2.1.8 4.2 2.3 5.7l133.3 133.2c1.5 1.5 3.5 2.3 5.7 2.3h2.9c2.5 0 4.9-1.2 6.4-3.2L300 327.7c2.4-3.2 2.1-7.7-.7-10.5L194.8 212.7c-2.8-2.8-7.3-3.1-10.5-.7zm5.8 90.1-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm48 48-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"
        }
    ]
};

const FarShovel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShovel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M375 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9L460.8 181c-17.2 17.2-40.6 26.9-65 26.9-16.7 0-32.3-4.4-45.8-12.2L241 305l56.4 56.4c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32v-93.8c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0L207 271l109.2-109.1c-7.8-13.5-12.2-29.1-12.2-45.8 0-24.4 9.7-47.7 26.9-65L375 7zm17 50.9-27.1 27.2c-8.2 8.2-12.9 19.4-12.9 31 0 24.2 19.6 43.9 43.9 43.9 11.6 0 22.8-4.6 31-12.9l27.2-27.1L392 57.9zM125.7 464c29.7 0 58.2-11.8 79.2-32.8l47.2-47.2L128 259.9l-47.2 47.2c-21 21-32.8 49.5-32.8 79.2V464h77.7z"
        }
    ]
};

const FarShowerDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShowerDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c13.3 0 24 10.7 24 24v9.8c77 11.6 136 78 136 158.2v16h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-16c0-80.2 59-146.6 136-158.2V24c0-13.3 10.7-24 24-24zM80 208h224v-16c0-61.9-50.1-112-112-112S80 130.1 80 192v16zm-27.2 87.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1L53 295.3zm109.8 42.4 18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zm64 128 18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zm82.2-170.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18.2-42.4zM98.7 465.7l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1z"
        }
    ]
};

const FarShower = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShower",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 123.9C48 99.6 67.6 80 91.9 80c11.6 0 22.8 4.6 31 12.9l6.7 6.7c-27.8 43.4-22.8 101.7 15.1 139.6l7 7-.8.8c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-.8.8-6.9-6.9-.2-.2c-37.9-37.9-96.2-43-139.6-15.1l-6.7-6.7c-17.3-17.3-40.6-27-65-27C41.1 32 0 73.1 0 123.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V123.9zm221.5-8.9 6.8 6.8-90.5 90.5-7-7c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l.2.2zM416 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-64 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-96a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarShredder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShredder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 192V64c0-8.8 7.2-16 16-16h229.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3V192H112zM64 64v128c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-35.3-28.7-64-64-64V90.5c0-17-6.7-33.3-18.7-45.3l-26.6-26.5C390.7 6.7 374.5 0 357.5 0H128C92.7 0 64 28.7 64 64zm384 176c8.8 0 16 7.2 16 16v80H48v-80c0-8.8 7.2-16 16-16h384zM40 488c0 13.3 10.7 24 24 24s24-10.7 24-24v-72H40v72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h-48v72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h-48v72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h-48v72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h-48v72z"
        }
    ]
};

const FarShrimp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShrimp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 104c0-39.8 32.2-72 72-72h352c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h264c97.2 0 176 78.8 176 176s-78.8 176-176 176h-88c-13.3 0-24-10.7-24-24 0-12 8.8-21.9 20.2-23.7l-4.9-1.9c-12.4-4.8-18.5-18.7-13.7-31.1s18.7-18.5 31.1-13.7l68.7 26.7c20.5 8 42.6-7.1 42.6-29.1 0-17.3-14-31.2-31.2-31.2h-77.3c-101.5 0-185-77.4-194.6-176.3C28.5 172.1 0 141.4 0 104zm464 200c0-9.3-1-18.4-2.9-27.2L401 336.9c9.4 13 15 29 15 46.3 0 8.2-1.2 16-3.4 23.4C443.8 383.3 464 346 464 304zm-23.7-74.2c-21.8-30.5-56.6-51.1-96.3-53.5v128c6.2.6 12.2 1.8 18 3.8l78.3-78.3zM296 176H113.3c9.5 72.2 71.4 128 146.2 128H296V176zm-72 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarShuffle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShuffle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m425 31 80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H352c-12.6 0-24.4 5.9-32 16l-46 61.3-30-40 37.6-50.1C298.2 117 324.3 104 352 104h78.1L391 65c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM204 322.7l-37.6 50.1C149.8 395 123.7 408 96 408H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c12.6 0 24.4-5.9 32-16l46-61.3 30 40zM391 287c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39h-78c-27.7 0-53.8-13-70.4-35.2L128 168c-7.6-10.1-19.4-16-32-16H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c27.7 0 53.8 13 70.4 35.2L320 344c7.6 10.1 19.4 16 32 16h78.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarShutters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShutters",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm-10.3 96L.4 198c-.3 1.4-.4 2.7-.4 4.1C0 214.2 9.8 224 21.9 224h468.2c12.1 0 21.9-9.8 21.9-21.9 0-1.4-.1-2.8-.4-4.1l-13.3-70h-48.9l9.1 48H53.4l9.1-48H13.7zM.4 326c-.3 1.4-.4 2.7-.4 4.1C0 342.2 9.8 352 21.9 352h468.2c12.1 0 21.9-9.8 21.9-21.9 0-1.4-.1-2.8-.4-4.1l-13.3-70h-48.9l9.1 48H53.4l9.1-48H13.7L.4 326zm0 128c-.3 1.4-.4 2.7-.4 4.1C0 470.2 9.8 480 21.9 480h468.2c12.1 0 21.9-9.8 21.9-21.9 0-1.4-.1-2.8-.4-4.1l-13.3-70h-48.9l9.1 48H53.4l9.1-48H13.7L.4 454z"
        }
    ]
};

const FarShuttleSpace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShuttleSpace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 384h-8c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24h8V80c0-26.5 21.5-48 48-48h50c40.6 0 80.4 11 115.2 31.9L405.3 160H456c69.3 0 135 22.7 179.2 81.6 6.4 8.5 6.4 20.3 0 28.8C591 329.3 525.3 352 456 352h-50.7l-160.1 96.1C210.4 469 170.6 480 130 480H80c-26.5 0-48-21.5-48-48v-48zm280-32H168c-9.9 13.2-23.9 23.3-40 28.3V432h2c31.9 0 63.2-8.7 90.6-25.1L312 352zm0-192-91.5-54.9C193.2 88.7 161.9 80 130 80h-2v51.7c16.1 5.1 30.1 15.1 40 28.3h144zM48 184v152h56c12.7 0 23.8-7.4 28.9-18.3 4-8.4 12.4-13.7 21.7-13.7H456c32.6 0 62.4-5.8 88-18.5v-59c-25.6-12.6-55.4-18.5-88-18.5H154.6c-9.3 0-17.7-5.3-21.7-13.7-5.1-10.9-16.2-18.3-28.9-18.3H48v8zm416 40c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarShuttlecock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarShuttlecock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m247 48-43.3 89.2L280 97.4V48h-33zm-78.5 161.6-38.9 80L159 319l75.9-75.9 25.7-81.5-92.1 48zM328 40v40h72c17.7 0 32 14.3 32 32v72h40c22.1 0 40 17.9 40 40v46c0 15.3-8.7 29.3-22.5 36l-242 117.5c-.7 1.4-1.7 2.7-2.8 3.8l-51.5 51.5c-21.2 21.2-50 33.1-80 33.1C50.7 512 0 461.3 0 398.9c0-30 11.9-58.8 33.1-80l51.5-51.5c1.2-1.2 2.5-2.1 3.8-2.8L206 22.5C212.7 8.7 226.7 0 242 0h46c22.1 0 40 17.9 40 40zM222.3 382.3l80-38.9 48-92.1-81.5 25.7-75.8 76 29.4 29.4zm70.4-163.1 91.3-28.8V128h-62.4l-28.8 91.2zM188.1 416 96 323.9l-22.7 22.7 92.1 92.1 22.7-22.7zm-48.4 42.3-86-86c-3.7 8.3-5.7 17.3-5.7 26.6 0 36 29.2 65.1 65.1 65.1 9.2 0 18.3-2 26.6-5.7zm235.1-150L464 265v-33h-49.4l-39.7 76.3z"
        }
    ]
};

const FarSickle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSickle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M218.2 90.2c56.2-56.2 147.4-56.2 203.6 0 2.3 2.3 4.5 4.7 6.7 7.1-16.4-6-34-9.3-52.5-9.3-83.9 0-152 68.1-152 152 0 17.8 3.1 35 8.7 50.9l-8.7 8.7-5.8-5.8c-56.2-56.2-56.2-147.4 0-203.6zm237.6-34c-75-75-196.5-75-271.5 0s-75 196.5 0 271.5l22.7 22.9c9.4 9.4 24.6 9.4 33.9 0l37.1-37.1c7.3-7.3 9.1-18.4 4.6-27.6-6.8-13.8-10.6-29.4-10.6-45.9 0-57.4 46.6-104 104-104 38.7 0 72.5 21.1 90.5 52.6 5.6 9.8 17.3 14.4 28 11s17.7-13.8 16.7-25.1c-3.9-43.2-22.4-85.3-55.4-118.4zM121 311c-9.4-9.4-24.6-9.4-33.9 0L71 327c-9.4 9.4-9.4 24.6 0 33.9l7 7L7 439c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l71-71 7 7c9.4 9.4 24.6 9.4 33.9 0l16-16c9.4-9.4 9.4-24.6 0-33.9l-24-24-32-32-24-24z"
        }
    ]
};

const FarSidebarFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSidebarFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 80v352H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h224zm224 16c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96zm-64 24c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24zm-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48zm24 120c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24z"
        }
    ]
};

const FarSidebar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSidebar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 80v352h224c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H224zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zM64 312c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarSigma = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSigma",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M1.8 46.8C5.5 37.8 14.3 32 24 32h304c30.9 0 56 25.1 56 56v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-4.4-3.6-8-8-8H81.9L241 239c9.4 9.4 9.4 24.6 0 33.9L81.9 432H328c4.4 0 8-3.6 8-8v-48c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 30.9-25.1 56-56 56H24c-9.7 0-18.5-5.8-22.2-14.8S.1 445.9 7 439l183-183L7 73C.2 66.1-1.9 55.8 1.8 46.8z"
        }
    ]
};

const FarSignHanging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignHanging",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0c13.3 0 24 10.7 24 24v40h376c13.3 0 24 10.7 24 24s-10.7 24-24 24H112v376c0 13.3-10.7 24-24 24s-24-10.7-24-24V112H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V24C64 10.7 74.7 0 88 0zm104 336h240V192H192v144zm-48-160c0-17.7 14.3-32 32-32h272c17.7 0 32 14.3 32 32v176c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V176z"
        }
    ]
};

const FarSignalBarsFair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalBarsFair",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 304c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16zm-64 16c0-35.3 28.7-64 64-64s64 28.7 64 64v128c0 35.3-28.7 64-64 64s-64-28.7-64-64V320zM64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64-16a64 64 0 1 1-128 0 64 64 0 1 1 128 0z"
        }
    ]
};

const FarSignalBarsGood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalBarsGood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M376 192v256c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm-16-64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64s64-28.7 64-64V192c0-35.3-28.7-64-64-64zM208 464c-8.8 0-16-7.2-16-16V320c0-8.8 7.2-16 16-16s16 7.2 16 16v128c0 8.8-7.2 16-16 16zm0-208c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64s64-28.7 64-64V320c0-35.3-28.7-64-64-64zM64 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM0 448a64 64 0 1 0 128 0 64 64 0 1 0-128 0z"
        }
    ]
};

const FarSignalBarsSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalBarsSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V64c0-35.3-28.7-64-64-64s-64 28.7-64 64v261.8L424 307V192c0-35.3-28.7-64-64-64s-64 28.7-64 64v14.7L38.8 5.1zM344 244.3V192c0-8.8 7.2-16 16-16s16 7.2 16 16v77.4l-32-25.1zm152 119.2V64c0-8.8 7.2-16 16-16s16 7.2 16 16v324.5l-32-25.1zm-120 28.7V448c0 8.8-7.2 16-16 16s-16-7.2-16-16v-81l-48-37.8V448c0 35.3 28.7 64 64 64s64-28.7 64-64v-17.9l-48-37.8zm-172.7-136c-33.2 2.4-59.3 30-59.3 63.8v128c0 35.3 28.7 64 64 64s64-28.7 64-64V320c0-3.5-.3-7-.8-10.4l-67.9-53.5zM448 449c.3 23.3 13.1 43.5 32 54.5v-29.3L448 449zm-224-1c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-8.8 7.2-16 16-16s16 7.2 16 16v128zm-144 0a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-16-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"
        }
    ]
};

const FarSignalBarsWeak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalBarsWeak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 448a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-16-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"
        }
    ]
};

const FarSignalBars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalBars",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 448V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v384c0 8.8 7.2 16 16 16s16-7.2 16-16zM448 64c0-35.3 28.7-64 64-64s64 28.7 64 64v384c0 35.3-28.7 64-64 64s-64-28.7-64-64V64zm-72 384V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v256c0 8.8 7.2 16 16 16s16-7.2 16-16zm-80-256c0-35.3 28.7-64 64-64s64 28.7 64 64v256c0 35.3-28.7 64-64 64s-64-28.7-64-64V192zm-88 272c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16zm0-208c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64s-64-28.7-64-64V320c0-35.3 28.7-64 64-64zM64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64-16a64 64 0 1 1-128 0 64 64 0 1 1 128 0z"
        }
    ]
};

const FarSignalFair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalFair",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 288c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarSignalGood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalGood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 192c13.3 0 24 10.7 24 24v272c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zm-128 96c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarSignalSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L600 445V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v383.3l-80-62.7V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v187l-80-62.7V216c0-13.3-10.7-24-24-24-10.4 0-19.2 6.6-22.6 15.8L38.8 5.1zM576 512h-.2.5-.2zm-104-24v-20.1l-48-37.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM344 367l-48-37.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V367zm-152-79c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24s24-10.7 24-24V312c0-13.3-10.7-24-24-24zM64 384c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FarSignalStreamSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalStreamSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-91.7-71.9C562.6 355.5 576 307.3 576 256c0-69.7-24.8-133.6-66-183.4-8.4-10.2-23.6-11.6-33.8-3.2S464.6 93 473 103.2c34.3 41.5 55 94.7 55 152.8 0 40.1-9.8 77.9-27.2 111.2l-51.6-40.4c9.5-21.7 14.8-45.6 14.8-70.8 0-40.7-13.8-78.2-37-108-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7C406 199.2 416 226.4 416 256c0 13.9-2.2 27.3-6.3 39.8L38.8 5.1zm84.7 188.2c-7.4 19.5-11.5 40.6-11.5 62.7 0 40.7 13.8 78.2 37 108 8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7C170 312.8 160 285.6 160 256c0-10.7 1.3-21.1 3.8-31l-40.3-31.7zM33 122C11.9 162 0 207.6 0 256c0 69.7 24.8 133.6 66 183.4 8.4 10.2 23.6 11.6 33.8 3.2s11.6-23.6 3.2-33.8C68.6 367.3 48 314.1 48 256c0-37.1 8.4-72.3 23.5-103.7L33 122z"
        }
    ]
};

const FarSignalStream = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalStream",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M99.8 69.4c10.2 8.4 11.6 23.6 3.2 33.8-34.4 41.5-55 94.7-55 152.8s20.6 111.3 55 152.8c8.4 10.2 7 25.3-3.2 33.8s-25.3 7-33.8-3.2C24.8 389.6 0 325.7 0 256S24.8 122.4 66 72.6c8.4-10.2 23.6-11.6 33.8-3.2zm376.5 0c10.2-8.4 25.3-7 33.8 3.2 41.2 49.8 66 113.8 66 183.4s-24.8 133.6-66 183.4c-8.4 10.2-23.6 11.6-33.8 3.2s-11.6-23.6-3.2-33.8c34.3-41.5 55-94.7 55-152.8s-20.6-111.3-55-152.8c-8.4-10.2-7-25.3 3.2-33.8zM248 256a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm-61.1-78.5C170 199.2 160 226.4 160 256s10 56.8 26.9 78.5c8.1 10.5 6.3 25.5-4.2 33.7s-25.5 6.3-33.7-4.2c-23.2-29.8-37-67.3-37-108s13.8-78.2 37-108c8.1-10.5 23.2-12.3 33.7-4.2s12.3 23.2 4.2 33.7zM427 148c23.2 29.8 37 67.3 37 108s-13.8 78.2-37 108c-8.1 10.5-23.2 12.3-33.7 4.2s-12.3-23.2-4.2-33.7C406 312.8 416 285.6 416 256s-10-56.8-26.9-78.5c-8.1-10.5-6.3-25.5 4.2-33.7s25.5-6.3 33.7 4.2z"
        }
    ]
};

const FarSignalStrong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalStrong",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c13.3 0 24 10.7 24 24v368c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm-128 96c13.3 0 24 10.7 24 24v272c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zm-128 96c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarSignalWeak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignalWeak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 384c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 0c13.3 0 24 10.7 24 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM448 96c13.3 0 24 10.7 24 24v368c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm-128 96c13.3 0 24 10.7 24 24v272c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zm-128 96c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarSignatureLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignatureLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 128c0-26.5 21.5-48 48-48s48 21.5 48 48v7.9c0 27.5-2.3 55-7 82.1L62 251.1c-36.9 11.4-62 45.5-62 84.1V410c0 38.6 31.3 70 70 70 24.6 0 47.4-12.9 60-34l15.9-26.4c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8c-2.6 7.4-1.5 15.5 3 21.9S312.2 320 320 320h72.6c5.6-9.7 13.7-17.8 23.4-23.4V272h-61.9l28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96s-96 43-96 96v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40zm128.1 240c-7 16.3-14.8 32.4-23.3 48H384v-48H208.1zM76.2 297l80.9-25c-11.7 43.2-29.4 84.5-52.4 123l-15.9 26.3C84.8 428 77.7 432 70 432c-12.1 0-22-9.8-22-22v-74.8c0-17.5 11.4-33 28.2-38.2zM528 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FarSignatureSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignatureSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L563 416h53c13.3 0 24-10.7 24-24s-10.7-24-24-24H501.8l-61.2-48H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H450.1l28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96-37 0-69.1 20.9-85.1 51.6L38.8 5.1zM178 114.2c5.9-19.8 24.3-34.2 46-34.2 26.5 0 48 21.5 48 48v7.9c0 16.7-.9 33.4-2.6 50L178 114.2zm165.5 129.7 73.7-22.8-22.5 63-51.2-40.2zm1.7 124.1h-41.1c-7 16.3-14.8 32.4-23.3 48h125.4l-60.9-48zM158 251.1c-36.9 11.4-62 45.5-62 84.1V410c0 38.6 31.3 70 70 70 24.6 0 47.4-12.9 60-34l15.9-26.4c18.5-30.8 33.8-63.3 45.7-97l-40-31.6c-11.5 36.3-27.2 71.2-46.8 103.9l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7-12.1 0-22-9.8-22-22v-74.8c0-17.5 11.4-33 28.2-38.2l59.5-18.4-45.8-36.1-28 8.6zM64 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40.2c-.1-2-.2-4-.2-6v-42z"
        }
    ]
};

const FarSignature = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignature",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 128c0-26.5 21.5-48 48-48s48 21.5 48 48v7.9c0 27.5-2.3 55-7 82.1l-107 33.1c-36.9 11.4-62 45.5-62 84.1V410c0 38.6 31.3 70 70 70 24.6 0 47.4-12.9 60-34l15.9-26.4c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8c-2.6 7.4-1.5 15.5 3 21.9S408.2 320 416 320h136c13.3 0 24-10.7 24-24s-10.7-24-24-24H450.1l28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96s-96 43-96 96v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40zm-3.8 169 80.9-25c-11.7 43.2-29.4 84.5-52.4 123l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7-12.1 0-22-9.8-22-22v-74.9c0-17.5 11.4-33 28.2-38.2zM64 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40.2c-.1-2-.2-4-.2-6v-42zm216.8 48H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H304.1c-7 16.3-14.8 32.4-23.3 48z"
        }
    ]
};

const FarSignsPost = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSignsPost",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h160.3c4.9 0 9.5 2.2 12.5 6l51.2 64c4.7 5.8 4.7 14.1 0 20l-51.2 64c-3 3.8-7.6 6-12.5 6H280v32h168c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H280v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H71.7c-4.9 0-9.5-2.2-12.5-6L8 314c-4.7-5.8-4.7-14.1 0-20l51.2-64c3-3.8 7.6-6 12.5-6H232v-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h168v-8zM80 80v64h344.9l25.6-32-25.6-32H80zm352 256v-64H87.1l-25.6 32 25.6 32H432z"
        }
    ]
};

const FarSimCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSimCard",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 64v384c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V154.5c0-4.2-1.7-8.3-4.7-11.3l-90.5-90.5c-3-3-7.1-4.7-11.3-4.7H64c-8.8 0-16 7.2-16 16zM0 448V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm128-208h16v80H80v-32c0-26.5 21.5-48 48-48zM80 384v-32h128v80h-80c-26.5 0-48-21.5-48-48zm176 48h-16v-80h64v32c0 26.5-21.5 48-48 48zm48-144v32H176v-80h80c26.5 0 48 21.5 48 48z"
        }
    ]
};

const FarSimCards = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSimCards",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 352c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V138.5c0-4.2-1.7-8.3-4.7-11.3l-74.5-74.5c-3-3-7.1-4.7-11.3-4.7H160c-8.8 0-16 7.2-16 16v288zM429.3 93.3c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h149.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5zM24 96c13.3 0 24 10.7 24 24v256c0 48.6 39.4 88 88 88h224c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24zm184 80h64v64h-96v-32c0-17.7 14.3-32 32-32zm-32 128v-32h64v64h-32c-17.7 0-32-14.3-32-32zm192 0c0 17.7-14.3 32-32 32h-64v-64h96v32zm0-96v32h-64v-64h32c17.7 0 32 14.3 32 32z"
        }
    ]
};

const FarSink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 88c0-22.1 17.9-40 40-40s40 17.9 40 40v24c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-48.6-39.4-88-88-88s-88 39.4-88 88v200h-72v-24c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88v-24c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24h-56c-30.9 0-56 25.1-56 56v24h-72V88zM32 368v24c0 66.3 53.7 120 120 120h208c66.3 0 120-53.7 120-120v-24h-48v24c0 39.8-32.2 72-72 72H152c-39.8 0-72-32.2-72-72v-24H32z"
        }
    ]
};

const FarSirenOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSirenOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m69.3 36 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm528 40-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 192h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-62 112h-48.4l-18.2-146c-1-8-7.8-14-15.9-14h-175c-8.1 0-14.9 6-15.9 14l-18.2 146H150l19-151.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L490 304zm-246.1 0 12.2-98c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9l-11.8 94h-32.2zM496 384H144v48h352v-48zm-352-48h352c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48v-48c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FarSiren = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSiren",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M345.6 304H394l-19-151.9C371 120 343.8 96 311.5 96h-175C104.2 96 77 120 73 152.1L54 304h48.4l18.2-146c1-8 7.8-14 15.9-14h175c8.1 0 14.9 6 15.9 14l18.2 146zm-165.5 0 11.8-94c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-12.2 98h32.2zM48 384h352v48H48v-48zm-48 0v48c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-48c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarSitemap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSitemap",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 80v64h-64V80h64zm-64-48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h8v40H112c-30.9 0-56 25.1-56 56v32h-8c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-8v-32c0-4.4 3.6-8 8-8h152v40h-8c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-8v-40h152c4.4 0 8 3.6 8 8v32h-8c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-8v-32c0-30.9-25.1-56-56-56H312v-40h8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-64zM48 368h64v64H48v-64zm208 0h64v64h-64v-64zm208 0h64v64h-64v-64z"
        }
    ]
};

const FarSkeletonRibs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSkeletonRibs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-42c-32.1 0-62.3 17.5-76.7 47.4-14.1 29.2-34.2 74.3-50.9 124.3C109.8 285.3 96 341.4 96 392v11.7c0 42.1 34.2 76.3 76.3 76.3 11.2 0 22.3-2.5 32.5-7.3l70.9-33.4c6.6-3.1 13.4-5.4 20.3-7.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-55.7c6.9 1.6 13.7 4 20.3 7.1l70.9 33.4c10.2 4.8 21.3 7.3 32.5 7.3 42.1 0 76.3-34.2 76.3-76.3V392c0-50.6-13.8-106.7-30.3-156.3-16.7-50-36.9-95.1-50.9-124.3C448.3 81.5 418.1 64 386 64h-42V24zm-48 88v60.3l-102.4 20.5c9.7-23.7 19.3-44.6 27-60.6 5.9-12.3 18.7-20.2 33.5-20.2h42zM173.6 245.8 296 221.3V278l-143.3 41.8c4.9-22.8 11.6-46.1 19.2-68.9.6-1.7 1.2-3.5 1.8-5.2zm-28.8 126.3L296 328v55.4c-14 2.2-27.7 6.4-40.7 12.6l-70.9 33.4c-3.8 1.8-7.9 2.7-12.1 2.7-15.6 0-28.3-12.7-28.3-28.3V392c0-6.5.3-13.1.8-19.9zM344 383.4V328l151.2 44.1c.5 6.8.8 13.4.8 19.9v11.7c0 15.6-12.7 28.3-28.3 28.3-4.2 0-8.3-.9-12.1-2.7l-70.9-33.4c-13.1-6.1-26.8-10.3-40.7-12.6zm143.3-63.6L344 278v-56.7l122.4 24.5c.6 1.7 1.2 3.5 1.8 5.2 7.6 22.7 14.3 46 19.2 68.9zm-40.9-127L344 172.3V112h42c14.8 0 27.5 7.9 33.5 20.2 7.7 16 17.3 36.9 27 60.6zM0 128v360c0 13.3 10.7 24 24 24s24-10.7 24-24V232c0-6.5 3.4-12.4 8.9-15.8L94 194c21.1-12.6 34-35.4 34-60v-6c0-35.3-28.7-64-64-64S0 92.7 0 128zm48 37.6V128c0-8.8 7.2-16 16-16s16 7.2 16 16v6c0 7.7-4 14.9-10.7 18.8L48 165.6zM576 64c-35.3 0-64 28.7-64 64v6c0 24.6 12.9 47.4 34 60l37.1 22.3c5.5 3.3 8.9 9.3 8.9 15.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V128c0-35.3-28.7-64-64-64zm-5.3 88.8c-6.6-4-10.7-11.1-10.7-18.8v-6c0-8.8 7.2-16 16-16s16 7.2 16 16v37.6l-21.3-12.8z"
        }
    ]
};

const FarSkeleton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSkeleton",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c13.3 0 24 10.7 24 24v40h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v48h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v48h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v85.7l75.5-32.3c8.3-3.5 17.2-5.4 26.1-5.4 36.7 0 66.4 29.7 66.4 66.4v1.5c0 18-7.2 35.3-19.9 48l-25.8 25.8c-11.7 11.7-27.6 18.3-44.1 18.3H153.9c-16.6 0-32.4-6.6-44.1-18.3l-25.9-25.8c-12.7-12.7-19.9-30-19.9-48v-1.5c0-36.7 29.7-66.4 66.4-66.4 9 0 17.9 1.8 26.1 5.4l75.5 32.3V304H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h112v-48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h208v-48H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h144V24c0-13.3 10.7-24 24-24zm-72 440a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarSkiBootSki = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSkiBootSki",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M415.6 28.5c2.5-13-6-25.6-19-28.1s-25.6 6-28.1 19L366 32H176c-11.3 0-21.1 7.9-23.5 19L88.8 348.3c-7.5 34.9 19.1 67.7 54.8 67.7H424c30.9 0 56-25.1 56-56v-52.9c0-20.6-11.3-39.5-29.4-49.3l-71.7-38.6 36.7-190.7zM275 80h81.8l-15.4 80H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h31.3l-6.2 32H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.9l81.8 44.1c2.6 1.4 4.2 4.1 4.2 7V360c0 4.4-3.6 8-8 8H143.6c-5.1 0-8.9-4.7-7.8-9.7l26-121.3C202 215.7 249.2 171.2 275 80zm-33.4 0c-17.9 57.7-44.8 92-70.3 112.5L195.4 80h46.2zM640 408c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 30.9-25.1 56-56 56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h512c57.4 0 104-46.6 104-104z"
        }
    ]
};

const FarSkiBoot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSkiBoot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M364.1.3c13.1 2.2 21.8 14.6 19.6 27.7l-45 262.4L449 345.7c19 9.5 31 28.9 31 50.1V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H63.2c-35.4 0-61.9-32.5-54.9-67.2L88.5 51.2C90.8 40 100.6 32 112 32h222.3l2.1-12.1C338.6 6.9 351-1.9 364.1.3zM202.4 80h-70.8L97.7 246.4C135.4 219.3 177.6 170 202.4 80zm33.1 0c-32 124.3-95.5 182.5-146.6 209.4l-33.6 165c-1 5 2.8 9.6 7.8 9.6H432v-68.2c0-3-1.7-5.8-4.4-7.2l-126.3-63.1c-2.8-1.4-5.2-3.3-7.2-5.5H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h66.4l11-64H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h50.8l19.3-112h-90.6z"
        }
    ]
};

const FarSkullCow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSkullCow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M63.2 21.1c2.5-7.4-.7-15.4-7.5-19.1S40.3 0 35.5 6L28 15.3C9.9 38 0 66.4 0 95.5 0 166.1 57.2 224 128 224h16v64c0 45 31 82.8 72.7 93.2l25.6 85.2c8.1 27.1 33 45.6 61.3 45.6h32.8c28.3 0 53.2-18.5 61.3-45.6l25.6-85.2C465 370.8 496 333 496 288v-64h16c70.8 0 128-57.9 128-128.5 0-29-9.9-57.4-28-80.1L604.5 6c-4.8-6.1-13.3-7.8-20.1-4.1s-10 11.8-7.5 19.1L588 54.5c2.5 7.5 3.4 15.4 2.6 23.2-2.9 28.6-26.9 50.3-55.6 50.3h-63.4C454 108.4 428.4 96 400 96H240c-28.4 0-54 12.4-71.6 32H105c-28.7 0-52.7-21.7-55.6-50.3-.8-7.8.1-15.8 2.6-23.2l11.2-33.4zm165.1 313.5c-20.9-5.2-36.3-24.2-36.3-46.6v-96c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v96c0 22.4-15.4 41.4-36.3 46.6-16.4 4.1-29.5 16.6-34.4 32.8l-25.6 85.2c-2 6.8-8.3 11.4-15.3 11.4h-32.8c-7.1 0-13.3-4.6-15.3-11.4l-25.6-85.2c-4.9-16.2-17.9-28.7-34.4-32.8zM288 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarSkullCrossbones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSkullCrossbones",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M290.1 185.8c19.5-15.4 29.9-36.3 29.9-57.8 0-39-37.5-80-96-80s-96 41-96 80c0 21.5 10.4 42.4 29.9 57.8 11.4 9.1 18.1 22.9 18.1 37.6v8.6c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-8.6c0-14.6 6.7-28.5 18.1-37.6zM320 232c0 30.9-25.1 56-56 56h-80c-30.9 0-56-25.1-56-56v-8.6C98.5 200 80 165.9 80 128 80 57.3 144.5 0 224 0s144 57.3 144 128c0 37.9-18.5 72-48 95.4v8.6zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L224 357l188.9-98.2c11.8-6.1 26.2-1.5 32.4 10.2s1.5 26.3-10.2 32.4L276 384l159.1 82.7c11.8 6.1 16.3 20.6 10.2 32.4s-20.6 16.3-32.4 10.2L224 411 35.1 509.3c-11.8 6.1-26.3 1.5-32.4-10.2s-1.5-26.2 10.2-32.4L172 384 12.9 301.3c-11.7-6.1-16.3-20.6-10.2-32.4zM160 136a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarSkull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSkull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 400c-.4-16 7.3-31.2 20.4-40.4C436.1 326.2 464 276.9 464 224c0-91.4-86.9-176-208-176S48 132.6 48 224c0 52.9 27.9 102.2 75.6 135.6 13.1 9.2 20.8 24.4 20.4 40.4v64h48v-24c0-13.3 10.7-24 24-24s24 10.7 24 24v24h32v-24c0-13.3 10.7-24 24-24s24 10.7 24 24v24h48v-64zm48-1.1V464c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48v-65.1C37.5 357.8 0 294.7 0 224 0 100.3 114.6 0 256 0s256 100.3 256 224c0 70.7-37.5 133.8-96 174.9zM112 256a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm232-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
        }
    ]
};

const FarSlashBack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSlashBack",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M11.9 3.3C.4 10-3.4 24.7 3.3 36.1l272 464c6.7 11.4 21.4 15.3 32.8 8.6s15.3-21.4 8.6-32.8l-272-464C38 .4 23.3-3.4 11.9 3.3z"
        }
    ]
};

const FarSlashForward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSlashForward",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M308.1 3.3c11.4 6.7 15.3 21.4 8.6 32.8l-272 464c-6.7 11.4-21.4 15.3-32.8 8.6s-15.3-21.4-8.6-32.8l272-464C282 .4 296.7-3.4 308.1 3.3z"
        }
    ]
};

const FarSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2z"
        }
    ]
};

const FarSleigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSleigh",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h8v176c0 62.5 44.8 114.5 104 125.8V432H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h504c44.2 0 80-35.8 80-80v-16c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 17.7-14.3 32-32 32H440v-48.2c67-4.2 120-59.8 120-127.8V144h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H456c-22.1 0-40 17.9-40 40v45.7c0 23.3-18.9 42.3-42.3 42.3-58.3 0-112.5-30-143.4-79.5l-18.9-30.2C182.5 67.9 133.7 38.1 80 32.8c-5.1-.5-10.2-.8-15.4-.8H24zm368 400H184v-48h208v48zm40-96H160c-44.2 0-80-35.8-80-80V81.1c37.2 5 70.5 26.3 90.7 58.6l18.9 30.3c39.7 63.5 109.2 102 184.1 102 49.9 0 90.3-40.4 90.3-90.3V144h48v112c0 44.2-35.8 80-80 80z"
        }
    ]
};

const FarSlider = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSlider",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 144c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h32zm-32-48c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64v-72h72c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72v-72c0-35.3-28.7-64-64-64h-32zM0 256c0 13.3 10.7 24 24 24h200v-48H24c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarSlidersSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSlidersSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 336a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm76.3 8H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H156.3c-10.2 32.5-40.5 56-76.3 56-44.2 0-80-35.8-80-80s35.8-80 80-80c35.8 0 66.1 23.5 76.3 56zM400 144a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-44.3-24c10.2-32.5 40.5-56 76.3-56 44.2 0 80 35.8 80 80s-35.8 80-80 80c-35.8 0-66.1-23.5-76.3-56H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h331.7z"
        }
    ]
};

const FarSlidersUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSlidersUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0c13.3 0 24 10.7 24 24v59.7c32.5 10.2 56 40.5 56 76.3s-23.5 66.1-56 76.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V236.3c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3V24C72 10.7 82.7 0 96 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-59.7c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3V24c0-13.3 10.7-24 24-24s24 10.7 24 24v251.7c32.5 10.2 56 40.5 56 76.3zm112-160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-8 76.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V268.3c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3V24c0-13.3 10.7-24 24-24s24 10.7 24 24v91.7c32.5 10.2 56 40.5 56 76.3s-23.5 66.1-56 76.3z"
        }
    ]
};

const FarSliders = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSliders",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 416c0 13.3 10.7 24 24 24h59.7c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H236.3c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56H24c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32-80c-35.8 0-66.1 23.5-76.3 56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h251.7c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-59.7c-10.2-32.5-40.5-56-76.3-56zm-160-48a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56H24C10.7 72 0 82.7 0 96s10.7 24 24 24h91.7c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H268.3z"
        }
    ]
};

const FarSlotMachine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSlotMachine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 416H112v32c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16v-32zm48 32c0 5.5-.7 10.9-2 16h82c22.1 0 40-17.9 40-40V217.6c-14.3-8.3-24-23.8-24-41.6 0-26.5 21.5-48 48-48s48 21.5 48 48c0 17.8-9.7 33.3-24 41.6V424c0 48.6-39.4 88-88 88H128c-35.3 0-64-28.7-64-64v-32c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64V64c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v32c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64v32zM400 96V64c0-8.8-7.2-16-16-16H128c-8.8 0-16 7.2-16 16v32h288zm48 48H64c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-336 32h56c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7l28.5-79.9H112c-13.3 0-24-10.7-24-24s10.7-24 24-24zm96 24c0-13.3 10.7-24 24-24h56c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7l28.5-79.9H232c-13.3 0-24-10.7-24-24zm144-24h56c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7l28.5-79.9H352c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarSmog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSmog",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 144c0-53 43-96 96-96 29.5 0 55.9 13.3 73.5 34.3 4.7 5.6 11.8 8.8 19.2 8.5s14.2-3.9 18.6-9.9c14.6-20 38.1-33 64.7-33 36.6 0 67.5 24.6 77 58.2 2 7.1 7.2 12.9 14.1 15.7s14.6 2.3 21-1.4c9.4-5.4 20.2-8.5 31.9-8.5 35.3 0 64 28.7 64 64s-28.7 64-64 64h-37c-6.5 0-12.8 2.7-17.3 7.4-14.6 15.2-35 24.6-57.7 24.6s-43.1-9.4-57.7-24.6c-4.5-4.7-10.8-7.4-17.3-7.4H176c-53 0-96-43-96-96zM176 0C96.5 0 32 64.5 32 144s64.5 144 144 144h123.3c22.5 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112S557.9 64 496 64c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.7 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zm376 464H440c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24zm280-72c0-13.3-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24zm-440-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24h104c13.3 0 24-10.7 24-24s-10.7-24-24-24z"
        }
    ]
};

const FarSmoke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSmoke",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 128c0-44.2 35.8-80 80-80 31.1 0 58 17.7 71.3 43.7 3.3 6.5 9.5 11.2 16.7 12.6s14.7-.5 20.2-5.3c14-11.9 32-19 51.8-19 24.3 0 46.1 10.8 60.7 27.9 4.9 2 9.7 4.3 14.4 6.8 9.3-9.9 19.8-18.6 31.2-25.9C403.4 54.5 364.3 32 320 32c-21.9 0-42.6 5.5-60.7 15.3C235.9 18.5 200.1 0 160 0 89.3 0 32 57.3 32 128c0 32 11.7 61.2 31.1 83.6 16.1-8.3 33.6-14.3 52.2-17.3C94 180 80 155.6 80 128zm512 96c0 27.5-13.8 51.7-34.9 66.1 12.3 10.4 22.8 22.9 31 36.8C619.6 303.6 640 266.2 640 224c0-70.7-57.3-128-128-128-46.6 0-87.3 24.8-109.7 62-22.2-18.7-51-30-82.3-30-51.6 0-96 30.5-116.3 74.4 10.7 3.9 20.9 8.7 30.5 14.5 7.9-5 16.2-9.4 25-13 14.7-17.1 36.5-27.9 60.8-27.9 24.3 0 46.1 10.8 60.7 27.9 13.7 5.6 26.5 13.1 38 22.2 7.5-3 13.1-9.6 14.7-17.7 7.2-36.7 39.7-64.4 78.5-64.4 44.2 0 80 35.8 80 80zM48 368c0-53 43-96 96-96 29.5 0 55.9 13.3 73.5 34.3 4.7 5.6 11.8 8.8 19.2 8.5s14.2-3.9 18.6-9.9c14.6-20 38.1-33 64.7-33 36.6 0 67.5 24.6 77 58.2 2 7.1 7.2 12.9 14.1 15.7s14.6 2.3 21-1.4c9.4-5.4 20.2-8.5 31.9-8.5 35.3 0 64 28.7 64 64s-28.7 64-64 64H144c-53 0-96-43-96-96zm96-144C64.5 224 0 288.5 0 368s64.5 144 144 144h320c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C411.8 251.7 369.1 224 320 224c-32.7 0-62.5 12.2-85.1 32.3-24.7-20.2-56.4-32.3-90.9-32.3z"
        }
    ]
};

const FarSmoking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSmoking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M440 0c13.3 0 24 10.7 24 24v19c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v19c0 13.3-10.7 24-24 24s-24-10.7-24-24v-19c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43V24c0-13.3 10.7-24 24-24zm176 288c-13.3 0-24-10.7-24-24v-19c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24v19c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v19c0 13.3-10.7 24-24 24zm-56 88v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm-416 88h208v-64H224v64zM0 416c0-35.3 28.7-64 64-64h384c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64v-32z"
        }
    ]
};

const FarSnake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSnake",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M305.6 96H168c-57.4 0-104 46.6-104 104s46.6 104 104 104h152c35.3 0 64 28.7 64 64s-28.7 64-64 64H118.7c-7.5 0-14.8 1.7-21.5 5.1L75.3 448l21.9 10.9c6.7 3.3 14 5.1 21.5 5.1H320c53 0 96-43 96-96s-43-96-96-96H168c-39.8 0-72-32.2-72-72s32.2-72 72-72h137.6l14.4 17.5c11.6 14.1 29 22.5 47.6 22.5 9 0 17.9-2 26.1-5.8l54.4-25.4c9.6-4.5 15.8-14.2 15.8-24.8s-6.2-20.3-15.8-24.8l-54.3-25.4c-8.2-3.8-17.1-5.8-26.1-5.8-18.6 0-36 8.4-47.6 22.5L305.6 96zM176 512h-57.3c-14.9 0-29.6-3.5-42.9-10.1l-61.5-30.7C5.5 466.8 0 457.8 0 448s5.5-18.8 14.3-23.2l61.4-30.7c6.5-3.3 13.3-5.7 20.4-7.4 7.4-1.8 14.9-2.7 22.6-2.7H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H168c-17.3 0-33.9-2.9-49.3-8.2-5.7-2-11.3-4.2-16.7-6.8-50.9-24.6-86-76.7-86-137 0-83.9 68.1-152 152-152h114.9c20.6-25.1 51.6-40 84.7-40 16 0 31.9 3.5 46.4 10.3l54.4 25.4C495 56.1 512 82.7 512 112s-17 55.9-43.5 68.3l-49.6 23.1-4.9 2.3c-14.5 6.8-30.4 10.3-46.4 10.3-16.8 0-33-3.8-47.7-10.9-14.2-6.9-26.9-16.7-37.1-29.1H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h152c16.7 0 32.7 2.8 47.7 8.1 16.5 5.8 31.6 14.5 44.7 25.5 31.5 26.3 51.6 66 51.6 110.4 0 79.5-64.5 144-144 144H176zM352 88a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarSnooze = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSnooze",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h59.1l-77.2 88.2c-6.2 7.1-7.7 17.1-3.8 25.7S174.6 176 184 176h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-59.1l77.2-88.2c6.2-7.1 7.7-17.1 3.8-25.7S305.4 0 296 0H184zm128 224c-13.3 0-24 10.7-24 24s10.7 24 24 24h62.9l-81.8 105.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-62.9L443 262.8c5.6-7.2 6.6-17 2.6-25.3S433.2 224 424 224H312zm-288 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h128.6L4.6 473.8c-5.3 7.3-6.1 17-2.1 25S15 512 24 512h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H71.4l148-201.8c5.3-7.3 6.1-17 2.1-25S209 224 200 224H24z"
        }
    ]
};

const FarSnowBlowing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSnowBlowing",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 64c13.3 0 24 10.7 24 24v25.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6v55.8l48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6S329 243.3 320.5 241l-48.2-12.9L224 256l48.3 27.9 48.3-12.9c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2-48.4-27.9v55.8l35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6V424c0 13.3-10.7 24-24 24s-24-10.7-24-24v-25.4l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l35.3-35.3v-55.8l-48.3 27.9-13 48.2c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7c-11.4 6.6-26 2.7-32.7-8.8s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6S23 268.7 31.5 271l48.2 12.9L128 256l-48.3-27.9L31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2 48.3 27.9v-55.8l-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l12.7 12.7V88c0-13.3 10.7-24 24-24zm304 360c0-13.3 10.7-24 24-24h48c22.1 0 40-17.9 40-40s-17.9-40-40-40H408c-13.3 0-24-10.7-24-24s10.7-24 24-24h144c48.6 0 88 39.4 88 88s-39.4 88-88 88h-48c-13.3 0-24-10.7-24-24zm24-360h48c48.6 0 88 39.4 88 88s-39.4 88-88 88H408c-13.3 0-24-10.7-24-24s10.7-24 24-24h144c22.1 0 40-17.9 40-40s-17.9-40-40-40h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarSnowflakeDroplets = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSnowflakeDroplets",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c13.3 0 24 10.7 24 24v46.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2L431 98.5c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-8.4 31.3 37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L493 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L368 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-31.4 8.5 28 16.2-22 42.7-30-17.3 8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8-66.1-38.3v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23v46c0 13.3-10.7 24-24 24s-24-10.7-24-24v-46.1l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57v-76.4L230 335.8l-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l8.4-31.5-30.1 17.4-22-42.7 28-16.2-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L272 256l-66.2-38.2-77.8 20.9c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l31.5-8.4-37.1-21.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8l37 21.3-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8 66.1 38.3v-76.5L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24zm199.1 418.1 47.5-92.4c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5 0 35.3-28.7 64.3-64 64.3s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5zM54.7 325.7c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5C128 483 99.3 512 64 512S0 483 0 447.7c0-10.2 2.4-20.4 7.1-29.5l47.5-92.4z"
        }
    ]
};

const FarSnowflake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSnowflake",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c13.3 0 24 10.7 24 24v46.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2L335 98.5c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-8.4 31.3 37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-31.4 8.5 37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8-66.1-38.3v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23v46c0 13.3-10.7 24-24 24s-24-10.7-24-24v-46.1l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57v-76.4L134 335.8l-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l8.3-31.4-37.1 21.4c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2-77.9 20.8c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l31.5-8.4-37.1-21.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8 66.1 38.3v-76.5L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarSnowflakes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSnowflakes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c13.3 0 24 10.7 24 24v46.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2L335 98.5c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-8.4 31.3 37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-31.4 8.5 37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8-66.1-38.3v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23v46c0 13.3-10.7 24-24 24s-24-10.7-24-24v-46.1l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57v-76.4L134 335.8l-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l8.3-31.4-37.1 21.4c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2-77.9 20.8c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l31.5-8.4-37.1-21.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8 66.1 38.3v-76.5L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24zm263 7c9.4-9.4 24.6-9.4 33.9 0l23 23L567 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L487 41c-9.4-9.4-9.4-24.6 0-33.9zm32 192c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarSnowmanHead = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSnowmanHead",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 144v48H112v-48h224zM64 64v128H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24.7C28 272.3 16 310.8 16 352c0 56 22.1 106.9 58.2 144.3 10.3 10.7 25.1 15.7 40 15.7h219.6c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-41.2-12-79.7-32.7-112H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64zm0 288c0-43.6 17.4-83.1 45.7-112h228.6c28.3 28.9 45.7 68.4 45.7 112 0 43.1-17 82.1-44.7 110.9-.1.1-.3.2-.8.4-.9.4-2.5.7-4.8.7H114.2c-2.2 0-3.8-.4-4.8-.7-.4-.2-.7-.3-.8-.4C81 434.1 64 395.1 64 352zm88-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM219.3 445.2c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l23.8-46.3c2.3-4.5 3.5-9.6 3.5-14.7 0-17.7-14.3-32.2-32-32.2s-32 14.5-32 32.2c0 5.1 1.2 10.2 3.5 14.7l23.8 46.3z"
        }
    ]
};

const FarSnowman = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSnowman",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-66.3 0-120 53.7-120 120 0 19 4.4 37 12.3 53-7.2 9.3-13.2 19.6-17.8 30.6L104 192.2V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v19.6l-22.5-9.7c-12.2-5.2-26.3.4-31.5 12.6s.4 26.3 12.6 31.5l56 24 49.5 21.2c-.1 1.6-.1 3.1-.1 4.7 0 12.5 1.7 24.7 4.9 36.3-18.2 26-28.9 57.7-28.9 91.8 0 39.2 14.1 75.1 37.5 102.9 15.6 18.6 38.4 25.1 58.3 25.1h128.5c19.8 0 42.6-6.5 58.3-25.1C401.9 459.1 416 423.2 416 384c0-34.1-10.7-65.8-28.9-91.7 3.2-11.6 4.9-23.7 4.9-36.3 0-1.6 0-3.1-.1-4.7l49.5-21.2 56-24c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6l-22.5 9.6V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v40.2l-26.5 11.4c-4.6-11-10.6-21.3-17.8-30.6 7.9-16 12.3-34 12.3-53C376 53.7 322.3 0 256 0zm-72 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 15.6-5 30-13.4 41.8-6.9 9.6-5.7 22.9 2.8 31.1 16.4 16 26.6 38.3 26.6 63 0 11.3-2.1 22.1-6 32-3.2 8.2-1.7 17.4 3.9 24.1 16.3 19.6 26.1 44.6 26.1 72 0 27.5-9.8 52.5-26.2 72-3.8 4.6-11.1 8-21.5 8H191.7c-10.4 0-17.7-3.4-21.5-8-16.4-19.5-26.2-44.6-26.2-72s9.8-52.4 26.1-71.8c5.6-6.7 7.1-16 3.9-24.1-3.9-9.9-6-20.7-6-32 0-24.7 10.2-47 26.6-63 8.5-8.3 9.7-21.5 2.8-31.1-8.4-12-13.4-26.4-13.4-42zm56-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2.8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarSnowplow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSnowplow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.8 48c3.2 0 6.1 1.9 7.4 4.9L371.8 208H219.5l-56.8-71-2.7-3.4V48h138.8zM429 220.3c-.4-1.2-.9-2.4-1.4-3.6L350.4 34.2C341.6 13.5 321.3 0 298.8 0H152c-22.1 0-40 17.9-40 40v88H96c-26.5 0-48 21.5-48 48v132.1C19 328.3 0 361.9 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-20.4-5.5-39.5-15-56h47v56c0 6 2.2 11.7 6.2 16.1l80 88c8.9 9.8 24.1 10.5 33.9 1.6s10.5-24.1 1.6-33.9L560 390.7V249.3l73.8-81.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6l-80 88c-4 4.4-6.2 10.2-6.2 16.1v56H432v-64c0-4.2-1.1-8.2-3-11.7zm-45 68.8c-5.2-.7-10.6-1.1-16-1.1H112c-5.4 0-10.8.4-16 1.1V176h36.5l56.8 71c4.6 5.7 11.4 9 18.7 9h176v33.1zM112 336h256c35.3 0 64 28.7 64 64s-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64zm32 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarSoap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSoap",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM96 192h113.1c2.5 17.7 9.2 34 18.9 48H96c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V288c0-26.5-21.5-48-48-48h-4.1c9.6-13.7 16.1-29.6 18.8-46.9 46 7.1 81.3 46.9 81.3 94.9v128c0 53-43 96-96 96H96c-53 0-96-43-96-96V288c0-53 43-96 96-96zm224 96h32c35.3 0 64 28.7 64 64s-28.7 64-64 64H160c-35.3 0-64-28.7-64-64s28.7-64 64-64h160zm-192 64c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm192-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm64-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarSocks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSocks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48c0-17 5.3-32.8 14.4-45.8C297.9.8 293 0 288 0H176c-26.5 0-48 21.5-48 48v186.3c0 21.7-9.8 42.2-26.6 55.9l-66.5 54C12.8 362.2 0 389.1 0 417.5 0 469.7 42.3 512 94.5 512h6.9c22.6 0 44.6-7.6 62.5-21.5l12.9-10.1c-8.4-14.6-13.9-31-15.9-48.5l-26.6 20.8c-9.4 7.3-21 11.3-32.9 11.3h-6.9C68.8 464 48 443.2 48 417.5c0-14 6.3-27.2 17.2-36.1l66.5-54c28-22.8 44.3-57 44.3-93.1V144h112V96H176V48h112zm80-48c-26.5 0-48 21.5-48 48v186.3c0 21.7-9.8 42.2-26.6 55.9l-66.5 54c-22.1 17.9-34.9 44.9-34.9 73.3 0 52.2 42.3 94.5 94.5 94.5h6.3c23.1 0 45.5-7.9 63.4-22.5l111.3-90.1c28.1-22.8 44.5-57.1 44.5-93.3V48c0-26.5-21.5-48-48-48h-96zm0 48h96v48h-96V48zm0 96h96v162.2c0 21.7-9.8 42.3-26.7 56l-111.3 90c-9.4 7.6-21.1 11.8-33.2 11.8h-6.3c-25.7 0-46.5-20.8-46.5-46.5 0-14 6.3-27.2 17.2-36.1l66.5-54c28-22.8 44.3-57 44.3-93.1V144z"
        }
    ]
};

const FarSoftServe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSoftServe",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-8.9 0-17 4.9-21.2 12.7S167.1 30 172 37.3l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7 0 3.7-3 6.7-6.7 6.7H140c-42 0-76 34-76 76 0 5.4.6 10.7 1.7 15.8C27.7 167.2 0 202.3 0 244c0 34.9 19.4 65.2 48 80.8V352c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h134.7c16.3 0 30-12.3 31.8-28.5l11-99.5h1.8c17.7 0 32-14.3 32-32v-27.2c28.6-15.6 48-45.9 48-80.8 0-41.9-28.1-77.3-66.4-88.4 1.6-6.3 2.4-12.8 2.4-19.6v-8C320 57.3 262.7 0 192 0zm100 288H92c-24.3 0-44-19.7-44-44s19.7-44 44-44h20c13.3 0 24-10.7 24-24 0-12.3-9.3-22.5-21.2-23.8-1.8-3.7-2.8-7.8-2.8-12.2 0-15.5 12.5-28 28-28h37.3c29.7 0 53.9-23.7 54.7-53.3 23.9 13.8 40 39.7 40 69.3v8c0 5.8-1.5 11.3-4.3 16H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h76c24.3 0 44 19.7 44 44s-19.7 44-44 44z"
        }
    ]
};

const FarSolarPanel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSolarPanel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M114.5 48c-3.8 0-7.1 2.7-7.9 6.5L86.5 160h116.6l11.2-112h-99.8zm83.8 160H77.4L54.8 326.5c-.9 4.9 2.8 9.5 7.9 9.5h122.8l12.8-128zm48.2 0-12.8 128h172.6l-12.8-128h-147zm142.2-48L377.5 48h-115l-11.2 112h137.4zm53 48 12.8 128h122.8c5 0 8.8-4.6 7.9-9.5L562.6 208H441.7zm111.8-48L533.4 54.5c-.7-3.8-4-6.5-7.9-6.5h-99.8l11.2 112h116.6zM59.5 45.5c5-26.4 28.1-45.5 55-45.5h411c26.9 0 50 19.1 55 45.5l51.8 272c6.6 34.5-19.9 66.5-55 66.5H344v80h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h80v-80H62.7c-35.1 0-61.6-32-55-66.5l51.8-272z"
        }
    ]
};

const FarSolarSystem = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSolarSystem",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0 42.1-12.5 81.3-34 114.1-4.4-1.3-9.1-2.1-14-2.1-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256 512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4 14.2 9 25.3 22.3 31.6 38C196.5 54.6 225.5 48 256 48c114.9 0 208 93.1 208 208zM256 464c-114.9 0-208-93.1-208-208 0-42.1 12.5-81.3 34-114.1 4.4 1.3 9.1 2.1 14 2.1 26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48c0 3.2.3 6.4.9 9.4C18.2 147.7 0 199.7 0 256c0 141.4 114.6 256 256 256 42.1 0 81.7-10.1 116.8-28.1-14.1-9.1-25.1-22.4-31.3-38.2-26.1 11.8-55 18.3-85.5 18.3zm134.8-294.2c.8-3.1 1.2-6.4 1.2-9.8 0-22.1-17.9-40-40-40-3.4 0-6.6.4-9.8 1.2-24.9-16-54.4-25.2-86.2-25.2-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160c0-31.8-9.3-61.3-25.2-86.2zM312 159v1c0 22.1 17.9 40 40 40h1c9.5 16.5 15 35.6 15 56 0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112c20.4 0 39.5 5.5 56 15zm-56 81a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FarSortDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSortDown",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 425.4 70.6 336h178.8L160 425.4zm-22.6 45.3c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S301 288 288 288H32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
        }
    ]
};

const FarSortUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSortUp",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 86.6 70.6 176h178.8L160 86.6zm-22.6-45.2c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9S301 224.1 288 224.1H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"
        }
    ]
};

const FarSort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSort",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M70.6 176h178.8L160 86.6 70.6 176zm112-134.6 128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0zM70.6 336l89.4 89.4 89.4-89.4H70.6zm112 134.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
        }
    ]
};

const FarSpa = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpa",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 92.1c21.2 24.9 52.1 69.7 68.6 134.5 13.3-10.3 27.4-19.5 42.2-27.6-27.3-91.6-79.3-145.6-96.8-161.8-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.5 16.2-69.5 70.1-96.8 161.8 14.8 8.1 28.9 17.3 42.2 27.6 16.5-64.8 47.3-109.7 68.6-134.5zm-96 377c22.9 6.7 47 10.5 72 10.9h48c25-.4 49.1-4.1 72-10.9 111-32.7 192-135.4 192-257 0-11.1-9-20.1-20.1-20.1-61.7 0-121.7 17.9-171.9 54.1-41.8 30-75.1 71-96 118.7-20.9-47.7-54.2-88.6-96-118.7C141.8 209.9 81.8 192 20.1 192 9 192 0 201 0 212.1c0 121.6 81 224.3 192 257zm0-50.5c-75.2-27.7-131.2-95.4-142.1-177.2 55.1 5.9 104.6 30.5 142.1 67.2 33.5 32.9 57.4 75.5 67.2 123.2-23.5-.9-46.1-5.5-67.2-13.3zm192 0c-21.1 7.7-43.6 12.4-67.2 13.3 9.7-47.8 33.7-90.4 67.2-123.2 37.5-36.8 87-61.3 142.1-67.2-10.9 81.7-66.9 149.4-142.1 177z"
        }
    ]
};

const FarSpaceStationMoonConstruction = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpaceStationMoonConstruction",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208.2 53.5c15.3-3.6 31.3-5.5 47.8-5.5 54.9 0 104.8 21.2 142 56h-30c-13.3 0-24 10.7-24 24s10.7 24 24 24h81.5c8.8 0 17-4.9 21.1-12.6s3.7-17.2-1.1-24.6C423.7 45.6 345.2 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c81.4 0 153.9-38 200.7-97.1 8.2-10.4 6.5-25.5-3.9-33.7s-25.5-6.5-33.7 3.9C381 433.2 322.1 464 256 464c-80.8 0-150.8-46.1-185.3-113.3 39.2 12 98.2 25.3 185.3 25.3 116.9 0 183.2-23.9 218.9-36.8 4.8-1.7 9-3.2 12.7-4.5 7.5-2.5 13.3-8.6 15.5-16.2l.6-2.1c5.5-19.3 8.3-39.3 8.3-59.3V256c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.1c0 12.3-1.3 24.5-4 36.5l-.8.3C424.3 306.5 364.4 328 256 328S87.7 306.5 52.8 293.9l-1.5-.5C49.1 281.2 48 268.8 48 256c0-40.8 11.7-78.8 32-110.9.6 52.5 43.3 94.9 96 94.9 53 0 96-43 96-96 0-41.7-26.6-77.2-63.8-90.5zM128 144a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm248 40c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48z"
        }
    ]
};

const FarSpaceStationMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpaceStationMoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48c-16.5 0-32.5 1.9-47.8 5.5C245.4 66.8 272 102.3 272 144c0 53-43 96-96 96-52.7 0-95.4-42.4-96-94.9-20.3 32.1-32 70.1-32 110.9 0 12.8 1.1 25.2 3.3 37.4.5.2 1 .3 1.5.5C87.7 306.5 147.6 328 256 328s168.3-21.5 203.2-34.1c.5-.2 1-.4 1.5-.5 2.2-12.1 3.3-24.6 3.3-37.4 0-114.9-93.1-208-208-208zm185.3 302.7C402.1 362.7 343 376 256 376s-146.1-13.3-185.3-25.3C105.2 417.9 175.2 464 256 464s150.8-46.1 185.3-113.3zM512 256a256 256 0 1 1-512 0 256 256 0 1 1 512 0zm-336-64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarSpade = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpade",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M437.7 242.9 256.4 55 74.2 242.9c-37 38.4-34.9 102.3 6.7 138l.3.2c32 27.9 86 25.1 120.8-10.2l19.7-20.7c9.2-9.7 22-15.1 35.4-14.9s26 5.9 35 15.8l18.3 20.2c34.3 34.4 87.3 38 121.7 9.5 40.6-35.7 42.6-99.6 5.7-138zM233.5 9.7c12-13 33-13 45.9 0l192.8 199.8c55.9 57.9 52.9 153.8-9 207.8-50.7 42.6-122.8 39.2-173 .2-3.5-2.7-6.9-5.6-10.2-8.7V464h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-55.3c-3.1 2.9-6.4 5.7-9.8 8.4-50.4 39.4-123.4 43-172.5.3-62.9-53.9-65.9-149.8-10-207.8L233.5 9.7z"
        }
    ]
};

const FarSpaghettiMonsterFlying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpaghettiMonsterFlying",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 58.3C250 95 256 80.2 256 64c0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64c1.7 0 3.4-.1 5.1-.2l15.1 30.2c-21.1 13.6-37.7 30.2-51.4 46.4-7.1 8.3-13.5 16.6-19.3 24l-1.4 1.8c-6.3 8.1-11.6 14.8-16.7 20.4-10.7 11.7-16.1 13.4-19.4 13.4-2.5 0-4.3-.6-7.1-3.3-3.7-3.5-7.1-8.8-12.5-17.4l-.6-.9c-4.6-7.4-11-17.6-19.4-25.7C54.7 207.4 41.5 200 24 200c-13.3 0-24 10.7-24 24s10.7 24 24 24c2.5 0 4.3.6 7.1 3.3 3.7 3.5 7.1 8.8 12.5 17.4l.6.9c4.6 7.4 11 17.6 19.4 25.7 9.7 9.3 22.9 16.7 40.4 16.7 18.5 0 32.9-8.5 44.3-18.6 3.1 4 6.6 8.3 10.5 12.7-2.4 7.1-4.5 14.2-6.5 20.6L151 331c-3.4 11.2-6.4 20.3-9.8 27.8-3.5 7.5-6.6 11.5-9.4 13.8-2.3 1.8-5.5 3.4-11.7 3.4-8.7 0-16.9-4.2-33.7-13.2-15-8-35.7-18.8-62.3-18.8-13.3 0-24 10.7-24 24s10.7 24 24 24c13.4 0 24.7 5.2 39.7 13.2 1 .6 2.1 1.1 3.2 1.7C80.1 414 98.6 424 120 424c16.2 0 30.2-4.8 41.7-13.9 10.9-8.7 18-20.2 23-31.1 5-10.9 8.8-22.9 12.2-34l.8-2.7c16.4 12.2 36.1 23.6 58.9 31.3-5.6 16.6-13.8 37.5-24.6 55.5-14.8 24.9-28.8 34.9-40 34.9-13.3 0-24 10.7-24 24s10.7 24 24 24c39.1 0 65.6-32 81.2-58.2 14.5-24.2 24.6-51.4 30.7-70.4 5.2.4 10.6.6 16 .6s10.8-.2 16-.6c6.1 19 16.3 46.3 30.7 70.4C382.4 480 408.9 512 448 512c13.3 0 24-10.7 24-24s-10.7-24-24-24c-11.2 0-25.2-10-40-34.8-10.8-18-19-39-24.6-55.5 22.8-7.7 42.5-19 58.9-31.3l.8 2.7c3.4 11 7.2 23.1 12.2 34 5.1 10.9 12.1 22.4 23 31.1 11.5 9.1 25.5 13.9 41.7 13.9 21.4 0 39.9-10 53.1-17.1 1.1-.6 2.2-1.2 3.2-1.7 15-8 26.3-13.2 39.7-13.2 13.3 0 24-10.7 24-24s-10.7-24-24-24c-26.6 0-47.3 10.8-62.3 18.8-16.8 9-25 13.2-33.7 13.2-6.3 0-9.5-1.6-11.7-3.4-2.8-2.2-6-6.3-9.4-13.8-3.5-7.5-6.4-16.6-9.8-27.8l-1.3-4.2c-2-6.5-4.1-13.5-6.5-20.6 3.9-4.5 7.4-8.8 10.5-12.7 11.3 9.9 25.7 18.4 44.2 18.4 17.5 0 30.7-7.4 40.4-16.7 8.4-8.1 14.8-18.3 19.4-25.7l.6-.9c5.4-8.6 8.8-13.9 12.5-17.4 2.8-2.7 4.6-3.3 7.1-3.3 13.3 0 24-10.7 24-24s-10.7-24-24-24c-17.5 0-30.7 7.4-40.4 16.7-8.4 8.1-14.8 18.3-19.4 25.7l-.6.9c-5.4 8.6-8.8 13.9-12.5 17.4-2.8 2.7-4.6 3.3-7.1 3.3-3.3 0-8.7-1.7-19.4-13.4-5.1-5.6-10.4-12.3-16.7-20.4l-1.4-1.8c-5.8-7.4-12.2-15.7-19.3-24-13.8-16.2-30.4-32.8-51.4-46.4l15.1-30.2c1.7.1 3.4.2 5.1.2 35.3 0 64-28.7 64-64S483.3 0 448 0s-64 28.7-64 64c0 16.2 6 31.1 16 42.3l-15.6 31.2c-18.7-6-39.9-9.5-64.4-9.5s-45.8 3.5-64.4 9.5L240 106.3zm219.4 150c-.4.6-.9 1.3-1.4 2-6.3 8.8-15.8 20.5-28.3 32.2C404.5 313.8 368 336 320 336s-84.5-22.2-109.7-45.6c-12.6-11.7-22-23.4-28.3-32.2-.5-.7-1-1.3-1.4-2 5.4-6.9 10.8-13.8 16.7-20.7 26.4-31 60.4-59.6 122.7-59.6s96.3 28.6 122.7 59.6c5.9 6.9 11.3 13.8 16.7 20.7zM448 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarSparkle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSparkle",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c9.4 0 17.9 5.4 21.8 13.9l59.5 128.8 128.8 59.5c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-128.8 59.5-59.5 128.8c-3.9 8.5-12.4 13.9-21.8 13.9s-17.9-5.4-21.8-13.9l-59.5-128.8-128.8-59.5C5.4 273.9 0 265.4 0 256s5.4-17.9 13.9-21.8l128.8-59.5 59.5-128.8C206.1 37.4 214.6 32 224 32zm0 81.2-41.4 89.6c-2.4 5.2-6.5 9.3-11.7 11.7L81.2 256l89.6 41.4c5.2 2.4 9.3 6.5 11.7 11.7l41.5 89.7 41.4-89.6c2.4-5.2 6.5-9.3 11.7-11.7l89.7-41.5-89.6-41.4c-5.2-2.4-9.3-6.5-11.7-11.7L224 113.2z"
        }
    ]
};

const FarSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSparkles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64l-56.5 21.2zM9.3 240c-5.7 2.6-9.3 8.3-9.3 14.6s3.6 11.9 9.3 14.5l17 7.9 8.1 3.7.6.3 88.3 40.8 40.8 88.2.3.6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1.3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6-3.7-8.2-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3.6-40.8 88.3-88.3 40.8-.6.3-8.1 3.7L9.3 240zm83 14.5 51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5l-51.2-23.5zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"
        }
    ]
};

const FarSpeaker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpeaker",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h256zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm168 120a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm-40 312a104 104 0 1 0 0-208 104 104 0 1 0 0 208zm-56-104a56 56 0 1 1 112 0 56 56 0 1 1-112 0z"
        }
    ]
};

const FarSpeakers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpeakers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264.4 0c-11.8 13.2-20.1 29.7-23.1 48H64c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h177.3a95.98 95.98 0 0 0 23.1 48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h200.4zM224 232v56.8c-10.2-10.4-24.3-16.8-40-16.8-30.9 0-56 25.1-56 56s25.1 56 56 56c15.7 0 29.8-6.4 40-16.8V424c-12.3 5.1-25.8 8-40 8-57.4 0-104-46.6-104-104s46.6-104 104-104c14.2 0 27.7 2.8 40 8zM184 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm152-32c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h240c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H336zm-64 16c0-35.3 28.7-64 64-64h240c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H336c-35.3 0-64-28.7-64-64V64zm184 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM352 328a104 104 0 1 1 208 0 104 104 0 1 1-208 0zm104 56a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
        }
    ]
};

const FarSpellCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpellCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M134.1 14.6C130.4 5.8 121.6 0 112 0S93.7 5.8 89.9 14.6l-88 208c-5.2 12.2.5 26.3 12.8 31.5s26.3-.5 31.5-12.8L56.8 216h110.4l10.7 25.4c5.2 12.2 19.2 17.9 31.5 12.8s17.9-19.2 12.8-31.5l-88-208zM146.9 168H77.1L112 85.6l34.9 82.4zM256 24v208c0 13.3 10.7 24 24 24h92c42 0 76-34 76-76 0-24.6-11.7-46.4-29.8-60.3C426.9 107.3 432 92.2 432 76c0-42-34-76-76-76h-76c-13.3 0-24 10.7-24 24zm100 80h-52V48h52c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-52 48h68c15.5 0 28 12.5 28 28s-12.5 28-28 28h-68v-56zm264.6 161.3c9.6-9.2 9.9-24.4.7-33.9s-24.4-9.9-33.9-.7l-183 175.7L265 367c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L335 505c9.2 9.2 24.2 9.4 33.6.3l200-192z"
        }
    ]
};

const FarSpiderBlackWidow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpiderBlackWidow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144.6 1.6c12.4 4.8 18.5 18.6 13.8 31l-32.5 84.6c-1.1 3-.4 6.3 1.8 8.5l32.3 32.4c.6-32.8 17.8-61.6 43.3-78.4 5.8-3.8 13.1-4.9 19.8-3s12.3 6.7 15.2 13l17.7 38.4 17.7-38.3c2.9-6.3 8.5-11.1 15.2-13s13.9-.8 19.8 3c25.6 16.8 42.7 45.5 43.3 78.4l32.3-32.3c2.2-2.2 2.9-5.6 1.8-8.5l-32.5-84.8c-4.8-12.4 1.4-26.3 13.8-31s26.3 1.4 31 13.8l32.5 84.6c7.9 20.7 3 44.1-12.7 59.7l-57.4 57.4 80.4-26.8c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-68.8-22.9c.8 3.2 1.5 6.4 2 9.7l43.8 43.8c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5l-12.1-12.1C358.8 425.8 311.9 464 256 464s-102.8-38.2-116.2-89.9l-12.1 12.1c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l43.8-43.8c.5-3.3 1.2-6.5 2-9.7l-68.8 22.9c-2.4.8-4.3 2.7-5.1 5.1l-18.9 56.8C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4l60.6-20.2-60.5-20.2c-16.7-5.6-29.8-18.7-35.4-35.4l-19-56.8C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1l80.4 26.8-57.5-57.4C78.1 144 73.1 120.6 81.1 100l32.5-84.6c4.8-12.4 18.6-18.5 31-13.8zm66 142.7c-1.7 4.9-2.6 10.2-2.6 15.7v88c0 3.4.4 6.7 1 9.9 1.6 7.6-.6 15.5-5.9 21.2-11.9 12.9-19.1 30-19.1 48.9v16c0 39.8 32.2 72 72 72s72-32.2 72-72v-16c0-18.9-7.2-36-19.1-48.9-5.3-5.7-7.5-13.6-5.9-21.2.7-3.2 1-6.5 1-9.9v-88c0-5.5-.9-10.8-2.6-15.7l-15.6 33.8c-3.9 8.5-12.4 13.9-21.8 13.9h-16c-9.4 0-17.9-5.4-21.8-13.9l-15.6-33.8zm7.8 162.9c-1.6-2.1-2.4-4.6-2.4-7.2 0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12 0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2 0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12 0-2.6.8-5.1 2.4-7.2L240 336l-21.6-28.8z"
        }
    ]
};

const FarSpiderWeb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpiderWeb",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M137.5 23.6c4.1-10.9 15.5-17.3 26.9-15.2l69 12.9c36.1 6.8 73 6.8 109.1 0l69-12.9c11.5-2.1 22.8 4.2 26.9 15.2l28.9 77.2c11.7 31.1 28.5 60 49.8 85.6l45.3 54.3c7.4 8.9 7.4 21.8 0 30.7l-45.3 54.3c-21.3 25.5-38.1 54.5-49.8 85.6l-28.9 77.2c-4.1 10.9-15.4 17.3-26.9 15.2l-69-12.9c-36.1-6.8-73-6.8-109.1 0l-69 12.9c-11.5 2.1-22.8-4.2-26.9-15.2l-28.9-77.2c-11.7-31.1-28.5-60-49.8-85.6l-45.2-54.3c-7.4-8.9-7.4-21.8 0-30.7l45.3-54.3c21.3-25.5 38.1-54.5 49.8-85.6l28.9-77.2zm27 64.7-11 29.3c-13.6 36.2-33.1 69.8-57.8 99.4l-12.5 15H133c23.5-27.6 41.7-59.2 53.7-93.4l2.5-7-24.7-43.3zm42.1-23.1 24 41.9c37.7 9.5 77.2 9.5 114.9 0l24-41.9-18 3.4c-41.9 7.9-84.9 7.9-126.8 0l-18-3.4zm204.9 23.1-24.8 43.3 2.5 7c12.1 34.2 30.3 65.8 53.8 93.4h49.8l-12.5-14.9c-24.7-29.7-44.3-63.3-57.8-99.4l-11-29.3zM492.8 280H443c-23.6 28.1-41.8 60.4-53.6 95.3l-2.1 6.1 24.2 42.4 11-29.3c13.6-36.2 33.1-69.8 57.8-99.4l12.5-15.1zM369.4 446.8l-22.1-38.7c-37.9-11.7-78.3-12.8-116.7-3.2l-24 41.9 18-3.4c41.9-7.9 84.9-7.9 126.8 0l18 3.4zm-204.9-23.1 24.8-43.3-2.5-7a298.12 298.12 0 0 0-53.7-93.4H83.2l12.5 14.9c24.7 29.7 44.3 63.3 57.8 99.4l11 29.3zM193.2 280c10.1 15 18.9 30.7 26.5 47.1l26.9-47.1h-53.4zm67.9 71.4c18.1-1.5 36.3-1.2 54.3 1l-27.4-48-26.9 47zm95.5-23.7c7.6-16.6 16.4-32.5 26.5-47.7h-53.7l27.3 47.7zm26.2-95.7c-10.1-15-18.9-30.7-26.5-47.1L329.4 232h53.4zm-68.1-71c-17.7 1.7-35.6 1.7-53.3 0l26.6 46.6 26.7-46.6zm-94.9 23.9c-7.6 16.4-16.5 32.1-26.5 47.1h53.4l-26.9-47.1z"
        }
    ]
};

const FarSpider = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpider",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4-80.4-26.8c-2.4-.8-4.3-2.7-5.1-5.1l-18.9-56.8C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4l60.6 20.2-60.5 20.2c-16.7 5.6-29.8 18.7-35.4 35.4l-19 56.8C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l68.8-22.9c-.8 3.2-1.5 6.4-2 9.7l-43.9 43.8C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5l12.1-12.1C153.2 425.8 200.1 464 256 464s102.8-38.2 116.2-89.9l12.1 12.1c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l32.5-84.5c7.9-20.7 3-44.1-12.7-59.7l-43.8-43.8c-.5-3.3-1.2-6.5-2-9.7l68.8 22.9c2.4.8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7l-32.4-84.6c-4.8-12.4-18.6-18.6-31-13.8s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L352 158.1c-.6-32.8-17.8-61.6-43.3-78.4-5.8-3.8-13.1-4.9-19.8-3s-12.3 6.7-15.2 13L256 128.1l-17.7-38.4c-2.9-6.3-8.5-11.1-15.2-13s-13.9-.8-19.8 3c-25.6 16.8-42.7 45.5-43.3 78.4l-32.3-32.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6zM208 160c0-5.5.9-10.8 2.6-15.7l15.6 33.8c3.9 8.5 12.4 13.9 21.8 13.9h16c9.4 0 17.9-5.4 21.8-13.9l15.6-33.8c1.7 4.9 2.6 10.2 2.6 15.7v88c0 3.4-.4 6.7-1 9.9-1.6 7.6.6 15.5 5.9 21.2 11.9 12.9 19.1 30 19.1 48.9v16c0 39.8-32.2 72-72 72s-72-32.2-72-72v-16c0-18.9 7.2-36 19.1-48.9 5.3-5.7 7.5-13.6 5.9-21.2-.7-3.2-1-6.5-1-9.9v-88z"
        }
    ]
};

const FarSpinnerThird = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpinnerThird",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M457 372c11.5 6.6 26.3 2.7 31.8-9.3C503.7 330.2 512 294.1 512 256 512 122.7 410.1 13.2 280 1.1c-13.2-1.2-24 9.6-24 22.9 0 13.3 10.8 23.9 24 25.4C383.5 61.2 464 149.2 464 256c0 29.3-6.1 57.3-17 82.6-5.3 12.2-1.5 26.8 10 33.5z"
        }
    ]
};

const FarSpinner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpinner",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0 448a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm160-224a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM32 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm43 149a32 32 0 1 0 45.3-45.3A32 32 0 1 0 75 437zm316.8 0a32 32 0 1 0 45.2-45.2 32 32 0 1 0-45.2 45.2zM75 75a32 32 0 1 0 45.3 45.3A32 32 0 1 0 75 75z"
        }
    ]
};

const FarSplit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSplit",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M391 31c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39h-83.5c-10.6 0-20.8 4.2-28.3 11.7L225.9 256l92.3 92.3c7.5 7.5 17.7 11.7 28.3 11.7H430l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39h-83.5c-23.3 0-45.7-9.3-62.2-25.8L182.1 280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h158.1l102.2-102.2c16.5-16.5 38.9-25.8 62.2-25.8H430l-39-39c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarSplotch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSplotch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m187.7 400.2-102.8 9.3c-11.2 1-20.9-7.8-20.9-19.1 0-4.2 1.3-8.2 3.8-11.5l18.8-25c16.7-22.3 25.4-49.5 24.8-77.3-.5-23.1-7.5-45.7-20.2-65l-40.6-61.9c-1.7-2.6-2.6-5.7-2.6-8.8 0-10.1 9.1-17.7 19-15.9l42.8 7.8c52.6 9.6 106.3-9.9 140.6-51L272.7 55c3.7-4.4 9.1-6.9 14.8-6.9 8.3 0 15.7 5.3 18.3 13.2l15 45.1c15.7 47.2 51.9 84.7 98.5 102.2l32.3 12.1c7.4 2.8 12.4 9.9 12.4 17.8 0 6-2.8 11.6-7.6 15.2l-62 46.5c-37.9 28.4-57.9 74.7-52.7 121.8l2.5 22.7c1.1 10.3-6.9 19.3-17.3 19.3-3.9 0-7.8-1.3-10.9-3.8l-37-29.7c-24.7-19.8-55.4-30.5-87-30.5-1.5 0-2.9.1-4.3.2zM51 237.8c7.8 11.9 12.1 25.7 12.4 39.8.4 17-4.9 33.7-15.2 47.4l-18.8 25C20.7 361.7 16 375.9 16 390.4c0 39.5 33.9 70.5 73.3 66.9L192 448c20.7 0 40.8 7 57 20l37.1 29.7c11.6 9.3 26 14.3 40.8 14.3 39 0 69.3-33.9 65-72.6l-2.5-22.7c-3.4-30.2 9.5-59.9 33.8-78.1l62-46.5c16.9-12.7 26.8-32.5 26.8-53.6 0-28-17.3-53-43.5-62.8l-32.3-12.1c-33-12.4-58.7-39-69.8-72.4L351.3 46c-9.2-27.5-34.9-46-63.8-46-20 0-38.9 8.9-51.7 24.2L213.5 51c-23.2 27.8-59.5 41-95.1 34.5l-42.8-7.8C36.2 70.6 0 100.8 0 140.9c0 12.5 3.6 24.7 10.5 35.1L51 237.8z"
        }
    ]
};

const FarSpoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSpoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m286.1 193.9 32 32c9.3 9.4 21.5 14 33.8 14.1 21.1 0 48.8-13.5 73.2-42.7C449 168.6 464 131.2 464 96c0-26.5-21.5-48-48-48-35.2 0-72.6 15-101.3 38.9-29.2 24.4-42.7 52.1-42.7 73.2 0 12.3 4.7 24.5 14.1 33.8zm-34.9 33c-18.1-18.6-27.1-42.6-27.2-66.7C224 80 320 0 416 0c53 0 96 43 96 96 0 96-80 192-160.2 192-24.1 0-48.2-9.1-66.7-27.2L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l244.1-244.2z"
        }
    ]
};

const FarSportsball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSportsball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M447 99c3.8 33.4 4.4 70.2-.1 107-25.6-8.1-49.2-20.8-69.7-37.2L447 99zm-9 154.5c-7.2 28-17.9 55.2-33 79.8-4.7 7.7-9.9 15.1-15.5 22.3L289.9 256l53.1-53.1c27.5 22.9 59.7 40.3 94.9 50.6zm-81.9 136.6c-19.4 16.1-42.4 29.6-69.7 39.8-10.2 3.8-21 7.1-32.4 9.9-10.2-35.9-27.8-68.7-51.1-96.7l53.1-53.2 100.1 100.2zm-149.8 57.7c-31.5 3.2-67 3-106.9-1.3l69.3-69.3c16.6 20.8 29.5 44.6 37.5 70.6zm-183.4 7.4c.5 2.7 1 5.3 1.6 7.9 1.6 7.5 5.7 14 11.4 18.6 4.2 3.3 9.2 5.6 14.6 6.5 103.9 17.4 187 11 252.6-13.3 66-24.5 112.2-66.5 142.9-116.5 60.2-98.2 59.1-224.7 41.6-309.5-1.5-7.1-5.2-13.3-10.5-17.8-.7-.6-1.5-1.3-2.3-1.8-3.9-2.8-8.4-4.7-13.3-5.5-2.1-.3-4.2-.7-6.2-1-59.6-9.5-112.3-11.1-158.7-5.9-16.6 1.9-32.4 4.6-47.5 8.1-14.1 3.3-27.5 7.4-40.3 12.1-34.1 12.7-63 30-87.1 50.7-12.3 10.7-23.4 22.2-33.4 34.4-8.2 10-15.6 20.5-22.2 31.4-18.4 29.9-31 62.5-39.2 95.7-3.9 15.7-6.8 31.6-8.8 47.4-7.4 56.9-3.6 113 4.9 158.4zM65 413c-3.8-33.4-4.4-70.2.1-107 25.6 8.1 49.2 20.8 69.7 37.2L65 413zm9-154.5c7.2-28 17.9-55.2 33-79.8 4.7-7.7 9.9-15.1 15.5-22.3l99.6 99.6-53.1 53.1c-27.5-22.9-59.7-40.3-94.9-50.6zm81.9-136.6c19.4-16.1 42.4-29.6 69.7-39.8 10.2-3.8 21-7.1 32.4-9.9 10.2 35.9 27.8 68.7 51.1 96.7L256 222.1 155.9 121.9zm149.8-57.7c31.5-3.2 67-3 106.9 1.3l-69.3 69.3c-16.6-20.8-29.5-44.6-37.5-70.6z"
        }
    ]
};

const FarSprayCanSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSprayCanSparkles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM96 208c-26.5 0-48 21.5-48 48v192c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16V256c0-26.5-21.5-48-48-48H96zM0 256c0-53 43-96 96-96h128c53 0 96 43 96 96v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zM381.8 51.6 352 64l-12.4 29.8C339 95 337.4 96 336 96s-3-1-3.6-2.2L320 64l-29.8-12.4C289 51 288 49.4 288 48s1-3 2.2-3.6L320 32l12.4-29.8C333 1 334.6 0 336 0s3 1 3.6 2.2L352 32l29.8 12.4c1.2.6 2.2 2.2 2.2 3.6s-1 3-2.2 3.6zM448 64l-29.8-12.4C417 51 416 49.4 416 48s1-3 2.2-3.6L448 32l12.4-29.8C461 1 462.6 0 464 0s3 1 3.6 2.2L480 32l29.8 12.4c1.2.6 2.2 2.2 2.2 3.6s-1 3-2.2 3.6L480 64l-12.4 29.8C467 95 465.4 96 464 96s-3-1-3.6-2.2L448 64zm32 160 29.8 12.4c1.2.6 2.2 2.2 2.2 3.6s-1 3-2.2 3.6L480 256l-12.4 29.8c-.6 1.2-2.2 2.2-3.6 2.2s-3-1-3.6-2.2L448 256l-29.8-12.4c-1.2-.6-2.2-2.2-2.2-3.6s1-3 2.2-3.6L448 224l12.4-29.8c.6-1.2 2.2-2.2 3.6-2.2s3 1 3.6 2.2L480 224zm-34.2-76.4L416 160l-12.4 29.8c-.6 1.2-2.2 2.2-3.6 2.2s-3-1-3.6-2.2L384 160l-29.8-12.4c-1.2-.6-2.2-2.2-2.2-3.6s1-3 2.2-3.6L384 128l12.4-29.8c.6-1.2 2.2-2.2 3.6-2.2s3 1 3.6 2.2L416 128l29.8 12.4c1.2.6 2.2 2.2 2.2 3.6s-1 3-2.2 3.6zM160 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarSprayCan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSprayCan",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-17.7 0-32 14.3-32 32v96h128V32c0-17.7-14.3-32-32-32h-64zm96 208c26.5 0 48 21.5 48 48v184c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V256c0-26.5 21.5-48 48-48h128zM96 160c-53 0-96 43-96 96v184c0 39.8 32.2 72 72 72h176c39.8 0 72-32.2 72-72V256c0-53-43-96-96-96H96zm128 176a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm96-272a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-128-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarSprinklerCeiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSprinklerCeiling",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 0v96c0 11.5 8.2 21.4 19.5 23.6L128 140.2V91.4L48 76.1V0H0zm256 91.4v48.9l108.5-20.7c11.3-2.2 19.5-12.1 19.5-23.6V0h-48v76.1l-80 15.3zM160 344a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-48 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-152a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v152H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80V56z"
        }
    ]
};

const FarSprinkler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSprinkler",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM88 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 184a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm360 128a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-24-128a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-88 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 136a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-88-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM97.8 270.8c3.7-9 12.5-14.8 22.2-14.8h112V88c0-13.3 10.7-24 24-24s24 10.7 24 24v168h112c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-89 89v86c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-86.1l-89-89c-6.9-6.9-8.9-17.2-5.2-26.2zM256 304h-78.1l55 55c4.5 4.5 7 10.6 7 17v88h32v-88c0-6.4 2.5-12.5 7-17l55-55H256z"
        }
    ]
};

const FarSquare0 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare0",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96v-64c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
        }
    ]
};

const FarSquare1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare1",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm172 99.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9l20.2-11.3V336h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V152c0-8.6-4.6-16.5-12-20.8z"
        }
    ]
};

const FarSquare2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare2",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm190.7 88.7-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4.1c46.5.7 83.8 38.6 83.8 85.1 0 23.5-9.7 46-26.9 62.1L212.7 336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3l108.7-101.9c7.5-7 11.7-16.8 11.7-27.1 0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z"
        }
    ]
};

const FarSquare3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare3",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h128c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6 0 46.5-37.7 84.2-84.2 84.2H208c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2a38.75 38.75 0 0 0 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2 0-20.1-16.3-36.3-36.4-36.2l-51.5.3c-9.9.1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5l50.7-46.2H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarSquare4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare4",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm127.6 97.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10h104v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-56c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-70.7l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z"
        }
    ]
};

const FarSquare5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare5",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 32h104c13.3 0 24 10.7 24 24s-10.7 24-24 24h-84l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8 0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3 0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z"
        }
    ]
};

const FarSquare6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare6",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70c-24.6 21-38.8 51.8-38.8 84.2z"
        }
    ]
};

const FarSquare7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare7",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h144c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2.5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarSquare8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare8",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm168 96h-16c-39.8 0-72 32.2-72 72 0 15.7 5 30.1 13.5 42-18 14.7-29.5 37-29.5 62 0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80 0-25-11.5-47.4-29.5-62 8.5-11.8 13.5-26.3 13.5-42 0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16zm0 48h24c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h8z"
        }
    ]
};

const FarSquare9 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare9",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 240a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70c24.6-21 38.8-51.8 38.8-84.2 0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"
        }
    ]
};

const FarSquareALock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareALock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80h320c8.8 0 16 7.2 16 16v84.1c14-9.8 30.3-16.4 48-18.9V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h256v-48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm181.8 61.9c-3.9-8.5-12.4-13.9-21.8-13.9s-17.9 5.4-21.8 13.9l-96 208c-5.6 12-.3 26.3 11.7 31.8s26.3.3 31.8-11.7l12-26.1h124.5l12 26.1c4 8.8 12.7 13.9 21.8 13.9V352c0-11.4 3-22.1 8.2-31.4l-82.4-178.7zM224 209.3l40 86.7h-80l40-86.7zM464 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FarSquareA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareA",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 336H158.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L182.8 288h82.3L224 205.7z"
        }
    ]
};

const FarSquareAmpersand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareAmpersand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm184 95.6c0 4.1 1.6 8.1 4.6 11l14.4 14.5 23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6 0-7.3-5.9-13.2-13.2-13.2h-19.2c-8.6 0-15.6 7-15.6 15.6zm71 46.9-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4a79.997 79.997 0 0 1-62 29.4h-32.2c-36.7 0-66.5-29.8-66.5-66.5 0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45 0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2 0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9 0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z"
        }
    ]
};

const FarSquareArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareArrowDownLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 432c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64zM0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm288-48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-94.1L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v160c0 13.3 10.7 24 24 24H288z"
        }
    ]
};

const FarSquareArrowDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareArrowDownRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 432c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320zm64-16c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320zm-288-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24v160c0 13.3-10.7 24-24 24H160z"
        }
    ]
};

const FarSquareArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareArrowDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 432c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320zm64-16c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320zm-241-39-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L200 152c0-13.3 10.7-24 24-24s24 10.7 24 24v150.1l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0z"
        }
    ]
};

const FarSquareArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareArrowLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 96c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96zm16-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm39 241 88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L328 280c13.3 0 24-10.7 24-24s-10.7-24-24-24H177.9l47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9z"
        }
    ]
};

const FarSquareArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareArrowRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96zm-16-64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zm-39 241-88 88c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24h150.1l-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l88 88c9.4 9.4 9.4 24.6 0 33.9z"
        }
    ]
};

const FarSquareArrowUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareArrowUpLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm288 48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-94.1L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24H288z"
        }
    ]
};

const FarSquareArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareArrowUpRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zm64 16c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zm-288 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
        }
    ]
};

const FarSquareArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm241 39 88 88c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.9l-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l88-88c9.4-9.4 24.6-9.4 33.9 0z"
        }
    ]
};

const FarSquareB = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareB",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 56c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76 0 16.2-5.1 31.3-13.8 43.7 18.1 13.9 29.8 35.7 29.8 60.3 0 42-34 76-76 76H152c-13.3 0-24-10.7-24-24V152zm144 52c0-15.5-12.5-28-28-28h-68v56h68c15.5 0 28-12.5 28-28zm-96 132h84c15.5 0 28-12.5 28-28s-12.5-28-28-28h-84v56z"
        }
    ]
};

const FarSquareBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareBolt",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm298.1 19.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240H320c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L198.1 272H128c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1z"
        }
    ]
};

const FarSquareC = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareC",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm167.4 103.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181 131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z"
        }
    ]
};

const FarSquareCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareCaretDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 432c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320zm64-16c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320zm-224-64c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4h208c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
        }
    ]
};

const FarSquareCaretLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareCaretLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320zm16 64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22v208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
        }
    ]
};

const FarSquareCaretRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareCaretRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96zm-16-64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zm-64 224c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4S160 369.5 160 360V152c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
        }
    ]
};

const FarSquareCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareCaretUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9S337.5 320 328 320H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
        }
    ]
};

const FarSquareCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm337 113L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarSquareChevronDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareChevronDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 432c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320zm64-16c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320zm-241-71L103 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 345c-9.4 9.4-24.6 9.4-33.9 0z"
        }
    ]
};

const FarSquareChevronLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareChevronLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320zm16 64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm71-241 104-104c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarSquareChevronRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareChevronRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96zm-16-64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zm-71 241L209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239c9.4 9.4 9.4 24.6 0 33.9z"
        }
    ]
};

const FarSquareChevronUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareChevronUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm241 71 104 104c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167c9.4-9.4 24.6-9.4 33.9 0z"
        }
    ]
};

const FarSquareCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareCode",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm191 143c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0zm-62 34c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L95 239c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
        }
    ]
};

const FarSquareD = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareD",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h72c70.7 0 128 57.3 128 128s-57.3 128-128 128h-72c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm24 208h48c44.2 0 80-35.8 80-80s-35.8-80-80-80h-48v160z"
        }
    ]
};

const FarSquareDashedCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareDashedCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 32H88C39.4 32 0 71.4 0 120v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16c0-22.1 17.9-40 40-40h16c13.3 0 24-10.7 24-24s-10.7-24-24-24zM0 296c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24S0 202.7 0 216v80zm24 56c-13.3 0-24 10.7-24 24v16c0 48.6 39.4 88 88 88h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-22.1 0-40-17.9-40-40v-16c0-13.3-10.7-24-24-24zm400-160c13.3 0 24-10.7 24-24v-48c0-48.6-39.4-88-88-88h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c22.1 0 40 17.9 40 40v48c0 13.3 10.7 24 24 24zM256 456c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24zm8-376c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h80zm168 432a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarSquareDashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareDashed",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-22.1 0-40 17.9-40 40v16c0 13.3-10.7 24-24 24S0 149.3 0 136v-16c0-48.6 39.4-88 88-88zM24 192c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24S0 309.3 0 296v-80c0-13.3 10.7-24 24-24zm400 0c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24zm0-32c-13.3 0-24-10.7-24-24v-16c0-22.1-17.9-40-40-40h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c48.6 0 88 39.4 88 88v16c0 13.3-10.7 24-24 24zm24 216v16c0 48.6-39.4 88-88 88h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c22.1 0 40-17.9 40-40v-16c0-13.3 10.7-24 24-24s24 10.7 24 24zm-400 0v16c0 22.1 17.9 40 40 40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-48.6 0-88-39.4-88-88v-16c0-13.3 10.7-24 24-24s24 10.7 24 24zm136 104c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80zM160 56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarSquareDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareDivide",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-88 104h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarSquareDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareDollar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm244.8 37.6v14.2c9.7 1.2 19.4 3.9 29 6.6 1.9.5 3.7 1 5.6 1.6 11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3-7-2-14-3.9-21.1-5.3-13.2-2.5-28.5-1.3-40.8 4-11 4.8-20.1 16.4-7.6 24.4 9.8 6.3 21.8 9.5 33.2 12.6 2.4.6 4.7 1.3 7 1.9 15.6 4.4 35.5 10.1 50.4 20.3 19.4 13.3 28.5 34.9 24.2 58.1-4.1 22.4-19.7 37.1-38.4 44.7-7.8 3.2-16.3 5.2-25.2 6.2v15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6v-17.4c-14.5-3.3-28.7-7.9-42.8-12.5-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5.8 5 1.7 7.5 2.5 11.3 3.8 22.9 7.7 34.5 9.6 17 2.5 30.6 1 39.5-2.6 12-4.8 17.7-19.1 5.9-27.1-10.1-6.9-22.6-10.3-34.5-13.5-2.3-.6-4.5-1.2-6.8-1.9-15.1-4.3-34-9.6-48.2-18.7-19.5-12.5-29.4-33.3-25.2-56.4 4-21.8 21-36.3 39-44.1 5.5-2.4 11.4-4.3 17.5-5.7v-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"
        }
    ]
};

const FarSquareDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareDownLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 432c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64zM0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm128-217.4V336c0 8.8 7.2 16 16 16h137.4c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L264 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7c-3.6-3.6-8.5-5.6-13.6-5.6s-10 2-13.7 5.7L200 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6-12.5 0-22.6 10.1-22.6 22.6z"
        }
    ]
};

const FarSquareDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareDownRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 432c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320zm64-16c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320zM320 198.6V336c0 8.8-7.2 16-16 16H166.6c-12.5 0-22.6-10.1-22.6-22.6 0-6 2.4-11.8 6.6-16L184 280l-66.3-66.3c-3.7-3.7-5.7-8.6-5.7-13.7s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6 12.5 0 22.6 10.1 22.6 22.6z"
        }
    ]
};

const FarSquareDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 416V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320zM328.8 294.6l-91 84c-3.8 3.5-8.7 5.4-13.9 5.4s-10.1-1.9-13.9-5.4l-91-84c-4.6-4.2-7.2-10.1-7.2-16.4 0-12.3 10-22.3 22.3-22.3H176V160c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v96h41.7c12.3 0 22.3 10 22.3 22.3 0 6.2-2.6 12.1-7.2 16.4z"
        }
    ]
};

const FarSquareE = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareE",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v56h120c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarSquareEllipsisVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareEllipsisVertical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarSquareEllipsis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareEllipsis",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320zm16 64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm128-224a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm160-32a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarSquareEnvelope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareEnvelope",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm216.7 159.6L96.1 189.3c1.4-16.4 15.2-29.3 31.9-29.3h192c16.7 0 30.5 12.9 31.9 29.3l-120.6 66.3c-2.2 1.2-4.7 1.9-7.3 1.9s-5.1-.6-7.3-1.9zm30 28L352 225.7V320c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-94.3l105.3 57.9c7 3.8 14.8 5.8 22.7 5.8s15.8-2 22.7-5.8z"
        }
    ]
};

const FarSquareExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareExclamation",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarSquareF = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareF",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarSquareFragile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareFragile",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 38.3c0-12.3 10-22.3 22.3-22.3H176l32 64-32 32 80 64-32-64 48-32-32-64h57.7c12.3 0 22.3 10 22.3 22.3V224c0 47.6-34.6 87.1-80 94.7V368h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-49.3c-45.4-7.6-80-47.1-80-94.7v-89.7z"
        }
    ]
};

const FarSquareFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareFull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 48v416H48V48h416zM48 0H0v512h512V0H48z"
        }
    ]
};

const FarSquareG = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareG",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 160c0 44.2 35.8 80 80 80 35.8 0 66.1-23.5 76.3-56H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24 0 70.7-57.3 128-128 128S96 326.7 96 256s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6 9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z"
        }
    ]
};

const FarSquareH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareH",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm336 56v208c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80H160v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v80h128v-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarSquareHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm335.7 169.6-91.5 92.9c-5.6 5.7-13 8.5-20.3 8.5-7.3 0-14.6-2.9-20.1-8.5l-91.5-92.9c-26.4-26.8-26.4-70.4 0-97.2s69.3-26.8 95.8 0l16 16.2 16-16.2c26.4-26.8 69.3-26.8 95.8 0s26.4 70.4 0 97.2z"
        }
    ]
};

const FarSquareI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareI",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h144c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v160h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarSquareInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareInfo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm184 240h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarSquareJ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareJ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 56v136c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarSquareK = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareK",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm313.1 72.8-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8l102.9-104.6c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5.3 33.9z"
        }
    ]
};

const FarSquareKanban = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareKanban",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 432c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64zM0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm128-128c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24zm168 40c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v176zm-72-72c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24z"
        }
    ]
};

const FarSquareL = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareL",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 56v184h120c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarSquareLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320zm16 64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm121.4-119.2-84-91c-3.5-3.8-5.4-8.7-5.4-13.9s1.9-10.1 5.4-13.9l84-91c4.2-4.6 10.1-7.2 16.4-7.2 12.3 0 22.3 10 22.3 22.3V208h96c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H224v41.7c0 12.3-10 22.3-22.3 22.3-6.2 0-12.1-2.6-16.4-7.2z"
        }
    ]
};

const FarSquareList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareList",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm104 0c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-32 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarSquareM = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareM",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm139.5 41.9L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2L243.4 310c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7.3 26.8 8.8z"
        }
    ]
};

const FarSquareMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareMinus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 136h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarSquareN = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareN",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm154.3 40.5 133.7 158V152c0-13.3 10.7-24 24-24s24 10.7 24 24v208c0 10.1-6.3 19.1-15.7 22.5s-20.1.7-26.6-7L160 217.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7z"
        }
    ]
};

const FarSquareNfi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareNfi",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80h320c8.8 0 16 7.2 16 16v32h48V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v32h48V96c0-8.8 7.2-16 16-16zM48 384H0v32c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-32h-48v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-32zm1-223c-10.1 3.1-17 12.4-17 23v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-64.7l52 78c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64.7l-52-78C70.1 161.9 59.2 158 49 161zm167 23v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-32h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64c-13.3 0-24 10.7-24 24zm200 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"
        }
    ]
};

const FarSquareO = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareO",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 160a80 80 0 1 0 160 0 80 80 0 1 0-160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"
        }
    ]
};

const FarSquareP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareP",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h92c50.8 0 92 41.2 92 92s-41.2 92-92 92h-68v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44h-68v88h68z"
        }
    ]
};

const FarSquareParkingSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareParkingSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1l-68.9-54zm106.9 83.8c2.6-5.3 8.1-8.9 14.3-8.9h320c8.8 0 16 7.2 16 16v267.5L408.6 295c19.3-17.6 31.4-42.9 31.4-71 0-53-43-96-96-96h-80c-16.5 0-30.2 12.6-31.8 28.7l-86.5-67.8zm224.1 175.6L280 194.2V176h64c26.5 0 48 21.5 48 48 0 17-8.9 32-22.2 40.5zM232 278.8V360c0 13.3 10.7 24 24 24s24-10.7 24-24v-43.4l-48-37.8zm-88-69.3-48-37.9V416c0 35.3 28.7 64 64 64h320c2.3 0 4.6-.1 6.9-.4L426.5 432H160c-8.8 0-16-7.2-16-16V209.5z"
        }
    ]
};

const FarSquareParking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareParking",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm184 176h64c26.5 0 48-21.5 48-48s-21.5-48-48-48h-64v96zm64 48h-64v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V160c0-17.7 14.3-32 32-32h80c53 0 96 43 96 96s-43 96-96 96z"
        }
    ]
};

const FarSquarePen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquarePen",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm325.8 43.7 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289l105.2-105.2 71 71-105.2 105.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FarSquarePersonConfined = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquarePersonConfined",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm292 104c33.1 0 60 26.9 60 60v88c0 31.8-24.7 57.8-56 59.9v.1h-4c-5.7 0-11.1-.8-16.3-2.2-19.6-4.4-37.5-15.1-50.7-30.7l-44.6-52.7-39.3 73c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l56-104c3.8-7 10.7-11.7 18.6-12.5s15.7 2.3 20.8 8.4L232 309v-49c0-33.1 26.9-60 60-60zm-4.2 159.2c1.8.3 3.7.6 5.6.7 6-.7 10.6-5.8 10.6-11.9v-88c0-6.6-5.4-12-12-12s-12 5.4-12 12v88c0 5.2 3.2 9.5 7.8 11.2zM208 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarSquarePhoneFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquarePhoneFlip",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zm64 16c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zm-154.7 32.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2l24.6 20.2c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224 0-9-6-16.9-14.7-19.3l-44-12z"
        }
    ]
};

const FarSquarePhoneHangup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquarePhoneHangup",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm345.9 207.3c-4.8 7.6-15.1 10.7-24 7.4l-41.6-15.4c-7.9-2.9-12.7-10.1-11.8-17.7l2.6-23.3c-30.4-9.5-63.7-9.5-94.1 0l2.6 23.3c.8 7.6-4 14.8-11.8 17.7l-41.6 15.4c-8.9 3.3-19.2.1-24-7.4l-19.7-30.9c-4.3-6.8-3-15.3 3.1-20.8 76.4-68.8 200.3-68.8 276.7 0 6.1 5.5 7.4 14.1 3.1 20.8l-19.6 30.8z"
        }
    ]
};

const FarSquarePhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquarePhone",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm154.7 32.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384 196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
        }
    ]
};

const FarSquarePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquarePlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm200 248v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarSquarePollHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquarePollHorizontal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96zm-16-64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zM256 160c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h112c13.3 0 24 10.7 24 24zm72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h208zM192 352c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24z"
        }
    ]
};

const FarSquarePollVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquarePollVertical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 128c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm72-72c0-13.3 10.7-24 24-24s24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm120 136c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarSquareQ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareQ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 160c0 44.2 35.8 80 80 80 13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37 0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L296 361.8c-20.5 14-45.3 22.1-71.9 22.1-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128z"
        }
    ]
};

const FarSquareQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareQuarters",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M52.7 84.7 224 256 395.3 84.7c-2.9-2.9-6.9-4.7-11.3-4.7H64c-4.4 0-8.4 1.8-11.3 4.7zm0 342.6c2.9 2.9 6.9 4.7 11.3 4.7h320c4.4 0 8.4-1.8 11.3-4.7L224 256 52.7 427.3zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FarSquareQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareQuestion",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm137.8 69.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarSquareQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareQuote",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm144 208v-48c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V240zm144 39.3V192c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71z"
        }
    ]
};

const FarSquareR = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareR",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h104c44.2 0 80 35.8 80 80 0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288h-44v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v64h56z"
        }
    ]
};

const FarSquareRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96zm-16-64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zM262.6 151.2l84 91c3.5 3.8 5.4 8.7 5.4 13.9s-1.9 10.1-5.4 13.9l-84 91c-4.2 4.6-10.1 7.2-16.4 7.2C234 368 224 358 224 345.7V304h-96c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h96v-41.7c0-12.3 10-22.3 22.3-22.3 6.2 0 12.1 2.6 16.4 7.2z"
        }
    ]
};

const FarSquareRing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareRing",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 160a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm-208 0a128 128 0 1 1 256 0 128 128 0 1 1-256 0z"
        }
    ]
};

const FarSquareRootVariable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareRootVariable",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344.3 80c-3.6 0-6.7 2.4-7.7 5.8L231.1 462.5c-2.6 9.4-10.7 16.3-20.5 17.4s-19.1-3.9-23.8-12.5L83.9 276.2c-1.4-2.6-4.1-4.2-7-4.2H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h52.9c20.6 0 39.5 11.3 49.3 29.5l74.7 138.8 89.4-319.4c6.8-24.2 28.9-40.9 54-40.9H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H344.3zM399 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarSquareRoot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareRoot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344.3 80c-3.6 0-6.7 2.4-7.7 5.8L231.1 462.5c-2.6 9.4-10.7 16.3-20.5 17.4s-19.1-3.9-23.8-12.5L83.9 276.2c-1.4-2.6-4.1-4.2-7-4.2H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h52.9c20.6 0 39.5 11.3 49.3 29.5l74.7 138.8 89.4-319.4c6.8-24.2 28.9-40.9 54-40.9H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H344.3z"
        }
    ]
};

const FarSquareRss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareRss",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 40c0-13.3 10.7-24 24-24 137 0 248 111 248 248 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24 83.9 0 152 68.1 152 152 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarSquareS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareS",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm175.6 100.2c-1.1 6.4-.2 9.7.6 11.6 1 2 2.9 4.6 7.4 7.7 10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2 9.5 6.4 18.5 15.1 24.1 27.2 5.7 12.3 7 25.9 4.4 40.3-4.7 26.3-23.1 43.3-45 52-21.3 8.4-47 9.6-72.6 5.7h-.1c-16.3-2.6-43.7-10.7-57.3-15.1-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4 20.2 3 36.8 1.4 47.7-2.9 10.3-4.1 14.2-9.6 15.4-15.8 1.1-6.4.2-9.7-.6-11.6-1-2-2.9-4.6-7.4-7.7-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2-9.5-6.4-18.5-15.1-24.1-27.2-5.7-12.3-7-25.9-4.4-40.3 4.7-26.3 23.1-43.3 45-52 21.3-8.4 47-9.6 72.6-5.7 8.1 1.2 24.4 4.8 32 6.7 12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7-20.3-3.1-36.8-1.4-47.8 2.9-10.3 4.1-14.2 9.6-15.4 15.8z"
        }
    ]
};

const FarSquareShareNodes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareShareNodes",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm352 80c0 26.5-21.5 48-48 48-9.8 0-18.9-2.9-26.5-7.9L197.7 256l79.9 39.9c7.6-5 16.7-7.9 26.5-7.9 26.5 0 48 21.5 48 48s-21.5 48-48 48c-25.5 0-46.4-20-47.9-45.1l-85.6-42.8c-7.6 5-16.7 7.9-26.5 7.9-26.5 0-48-21.5-48-48s21.5-48 48-48c9.8 0 18.9 2.9 26.5 7.9l85.6-42.8C257.6 148 278.5 128 304 128c26.5 0 48 21.5 48 48z"
        }
    ]
};

const FarSquareSlidersVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareSlidersVertical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 96c-13.3 0-24 10.7-24 24v32h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v128c0 13.3 10.7 24 24 24s24-10.7 24-24V232h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-32c0-13.3-10.7-24-24-24zm184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v128h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v32c0 13.3 10.7 24 24 24s24-10.7 24-24v-32h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16V152z"
        }
    ]
};

const FarSquareSliders = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareSliders",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v320zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 80c0-13.3 10.7-24 24-24h32v-16c0-13.3 10.7-24 24-24s24 10.7 24 24v16h128c13.3 0 24 10.7 24 24s-10.7 24-24 24H200v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-32c-13.3 0-24-10.7-24-24zm24 184c-13.3 0-24-10.7-24-24s10.7-24 24-24h128v-16c0-13.3 10.7-24 24-24s24 10.7 24 24v16h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16H120z"
        }
    ]
};

const FarSquareSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareSmall",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 144c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h192zM64 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarSquareStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareStar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 25c6.1 0 11.7 3.5 14.3 8.9l31.3 63.3 69.9 10.2c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4L297.8 280l11.9 69.6c1 6-1.4 12.1-6.4 15.6s-11.5 4.1-16.8 1.2L224 333.6l-62.5 32.9c-5.4 2.8-11.9 2.4-16.9-1.2s-7.4-9.6-6.4-15.6l12-69.7-50.5-49.3c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l69.9-10.2 31.3-63.3c2.7-5.5 8.3-8.9 14.3-8.9z"
        }
    ]
};

const FarSquareT = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareT",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm120 48h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80v168c0 13.3-10.7 24-24 24s-24-10.7-24-24V192h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarSquareTerminal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareTerminal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm38.3 119.8c-9 9.8-8.3 25 1.5 33.9l76.7 70.3-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
        }
    ]
};

const FarSquareThisWayUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareThisWayUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm120 256h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm208-160v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V192h-25.5c-8 0-14.5-6.5-14.5-14.5 0-3.5 1.3-7 3.7-9.6l42.5-47.9c4.5-5.1 11-8 17.8-8s13.2 2.9 17.8 8l42.6 47.9c2.4 2.7 3.7 6.1 3.7 9.6 0 8-6.5 14.5-14.5 14.5H328zM80 177.5c0-3.5 1.3-7 3.7-9.6l42.5-47.9c4.5-5.1 11-8 17.8-8s13.2 2.9 17.8 8l42.6 47.9c2.4 2.7 3.7 6.1 3.7 9.6 0 8-6.5 14.5-14.5 14.5H168v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H94.5c-8 0-14.5-6.5-14.5-14.5z"
        }
    ]
};

const FarSquareU = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareU",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64v120c0 35.3 28.7 64 64 64s64-28.7 64-64V160c0-13.3 10.7-24 24-24s24 10.7 24 24v120c0 61.9-50.1 112-112 112s-112-50.1-112-112V160c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarSquareUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareUpLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 217.4V176c0-8.8 7.2-16 16-16h137.4c12.5 0 22.6 10.1 22.6 22.6 0 6-2.4 11.8-6.6 16L264 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7c-3.6 3.6-8.5 5.6-13.6 5.6s-10-2-13.7-5.7L200 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6-12.5 0-22.6-10.1-22.6-22.6z"
        }
    ]
};

const FarSquareUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareUpRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zm64 16c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6 0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3c-3.7 3.7-5.7 8.6-5.7 13.7s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6 12.5 0 22.6-10.1 22.6-22.6z"
        }
    ]
};

const FarSquareUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm119.2 121.4 91-84c3.8-3.5 8.7-5.4 13.9-5.4s10.1 1.9 13.9 5.4l91 84c4.6 4.2 7.2 10.1 7.2 16.4 0 12.3-10 22.3-22.3 22.3H272v96c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V256h-41.7c-12.3 0-22.3-10-22.3-22.3 0-6.2 2.6-12.1 7.2-16.4z"
        }
    ]
};

const FarSquareUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16h-1c-7.9-63.1-61.7-112-127-112h-64c-65.3 0-119.1 48.9-127 112h-1c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zm-49.6 352H113.6c7.4-36.5 39.7-64 78.4-64h64c38.7 0 71 27.5 78.4 64zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 208a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0-176 0z"
        }
    ]
};

const FarSquareV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareV",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm141.5 53.3 82.5 165 82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z"
        }
    ]
};

const FarSquareVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareVirus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 13.6c13.3 0 24 10.7 24 24 0 23.8 28.8 35.7 45.6 18.9 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-16.8 16.8-4.9 45.6 18.9 45.6 13.3 0 24 10.7 24 24s-10.7 24-24 24c-23.8 0-35.7 28.8-18.9 45.6 9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-16.8-16.8-45.6-4.9-45.6 18.9 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-23.8-28.8-35.7-45.6-18.9-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c16.8-16.8 4.9-45.6-18.9-45.6-13.3 0-24-10.7-24-24s10.7-24 24-24c23.8 0 35.7-28.8 18.9-45.6-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c16.8 16.8 45.6 4.9 45.6-18.9 0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarSquareW = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareW",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm118.9 64.7L160 289.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 289.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-41-128.7-41.1 128.6c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z"
        }
    ]
};

const FarSquareX = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareX",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm154.3 40.5 69.7 82.3 69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8l74.9-88.5-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z"
        }
    ]
};

const FarSquareXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareXmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm143 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarSquareY = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareY",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm138.1 56.3 85.9 99.1 85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24v-79l-98.1-113.3c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z"
        }
    ]
};

const FarSquareZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquareZ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm136 32h176c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176H136c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarSquid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M261.5 4.8C265.3.9 270.7-.8 276 .3l116.7 23.3C423 14.4 456.7 6.5 494.3.2c5.1-.8 10.3.8 13.9 4.5s5.3 8.8 4.5 13.9c-6.3 37.6-14.2 71.3-23.4 101.5l23.3 116.7c1.1 5.3-.6 10.8-4.5 14.6s-9.4 5.4-14.7 4.2l-58.9-13.1c-46.1 72-101.7 103.5-148.3 110.7l16 16 .1.1 22.5 22.5c6.2 6.2 16.4 6.2 22.6 0l56.4-56.3c18.9-18.9 49.5-18.7 68.2.3l36.4 37.1c6.1 6.3 6.1 16.3-.1 22.5l-2.8 2.8c-34 34-87.7 33.3-121 1.9L370 414.4c-18.7 18.7-49.1 18.7-67.9 0L273.7 386c-9.4-9.2-24.4-9.2-33.7 0l-.1.1-.1.1c-9.2 9.4-9.2 24.4 0 33.8l.1.1 5.7 5.7 9.9 9.9c19.5 19.5 18.6 51.5-2.1 69.8l-2.8 2.5c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6l2.8-2.5c6.9-6.1 7.2-16.8.7-23.3l-9.9-9.8-.1-.1-22.4-22.4-.1-.1c-10.2-10.1-27-9-35.8 2.3l-15.6 20c-2.7 3.5-4.2 7.7-4.2 12.1 0 10.9 8.8 19.7 19.7 19.7h12.3c8.8 0 16 7.2 16 16s-7.2 16-16 16h-12.1c-28.6 0-51.7-23.2-51.7-51.7 0-11.5 3.8-22.7 10.9-31.8l21.9-28.2c7.3-9.4 6.5-22.8-1.9-31.2s-21.8-9.3-31.2-1.9l-28.2 21.9c-9.1 7.1-20.3 10.9-31.8 10.9C24.1 400 .9 376.8.9 348.3V336c0-8.8 7.2-16 16-16s16 7.2 16 16v12.3c0 10.9 8.8 19.7 19.7 19.7 4.4 0 8.7-1.5 12.1-4.2l20-15.6c11.3-8.8 12.4-25.5 2.4-35.8l-22.5-22.5-.2-.2-10.6-10.5c-6.4-6.4-16.7-6.2-22.9.3l-3.3 3.5c-6.1 6.4-16.2 6.7-22.6.6s-6.7-16.2-.6-22.6l3.3-3.5c18.6-19.6 49.7-20 68.7-.9L93 273.1c9.4 9.2 24.4 9.1 33.8-.2 9.4-9.4 9.4-24.5 0-33.9l-5.7-5.7-22.6-22.6c-18.7-18.7-18.7-49.1 0-67.9l14.3-14.3c-31.4-33.3-32.1-87 1.9-121l2.8-2.8c6.2-6.2 16.3-6.3 22.5-.1L177.1 41c19.1 18.7 19.2 49.3.3 68.2L121 165.6c-6.2 6.2-6.2 16.4 0 22.6l22.6 22.6 2 2 14 14c7.2-46.6 38.7-102.2 110.6-148.4l-12.9-58.9c-1.2-5.3.4-10.8 4.2-14.7zM184.9 296a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM432.3 62c-165.6 41.7-204.2 112.4-209.9 153.4-1.9 13.9 6 30.8 25.1 49.9s36 27 49.9 25.1c41-5.6 111.8-44.3 153.5-209.8 2.8-11.3-7.3-21.5-18.6-18.6z"
        }
    ]
};

const FarSquirrel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSquirrel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M147.7 48C92.7 48 48 92.7 48 147.7s44.7 99.7 99.7 99.7c22.4 0 40 19.2 38 41.5l-.7 7.7c-1 11-5.9 20.4-12 27.3-13.1 14.9-21.1 34.4-21.1 55.8 0 39.1 26.6 72 62.8 81.5-14.3-20-22.8-44.4-22.8-70.9 0-25 7.7-49.3 22-69.8l35-49.9C284.8 219.5 304 158.5 304 96V75.2c0-6.2 5-11.2 11.2-11.2 15.2 0 28.7 7.6 36.8 19.2 8.1-11.6 21.6-19.2 36.8-19.2 6.2 0 11.2 5 11.2 11.2V96h7.6c53.4 0 98.2 40.5 103.5 93.7l.8 8c.5 4.5-.4 9.1-2.4 13.1l-4.1 8.2c-14.4 28.8-42 48.1-73.4 52.3V326c24.3 19 40 48.7 40 82 0 20.6-6 39.8-16.3 56h33.4c13.3 0 24 10.7 24 24s-10.7 24-24 24H236.3c-73 0-132.3-59.2-132.3-132.3 0-32.3 11.6-61.9 30.8-84.8C59.3 288.3 0 225 0 147.7 0 66.1 66.1 0 147.7 0 207.3 0 258.6 35.3 282 86c5.5 12 .3 26.3-11.8 31.8s-26.3.3-31.8-11.8c-15.8-34.3-50.5-58-90.6-58zM352 464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56c-5.9 0-11.5.9-16.8 2.6-12.6 4-26.1-3.1-30.1-15.7s3.1-26.1 15.7-30.1c9.9-3.1 20.4-4.8 31.2-4.8 5.4 0 10.8.4 16 1.2V248c0-13.3 10.7-24 24-24h11.5c18.2 0 34.8-10.3 42.9-26.5l1-2-.1-1.1c-2.9-28.6-27-50.4-55.7-50.4h-58.9c-7.6 55.2-28.2 108.1-60.4 154.2l-35 49.9c-8.7 12.4-13.3 27.1-13.3 42.2 0 40.7 33 73.7 73.7 73.7H352zm32-288a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarStaffSnake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStaffSnake",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m222.6 43.2-.1 4.8H296c48.6 0 88 39.4 88 88s-39.4 88-88 88h-48v-48h48c22.1 0 40-17.9 40-40s-17.9-40-40-40h-75l-6 192h25c44.2 0 80 35.8 80 80s-35.8 80-80 80v-48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-26.5l-3.6 115.5-1.4 43.5v1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16v-1l-1.4-43.5-.1-3.5h-54c-13.3 0-24-10.7-24-24s10.7-24 24-24h52.5l-2-64H144c-44.2 0-80-35.8-80-80 0-41.5 31.6-75.6 72-79.6V225c-13.8 3.6-24 16.1-24 31 0 17.7 14.3 32 32 32h25l-6-192h-35.6c.4 2.6.6 5.3.6 8 0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56s25.1-56 56-56h105.5l-.1-4.8L161 32v-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30V32l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarStaff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStaff",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M238.8 57.5C256.4 22.3 292.4 0 331.8 0H408c57.4 0 104 46.6 104 104v103.9c0 42.8-26.1 80.8-65.1 96.5l-17.3 30.7c-4.3 7.7-14.1 10.4-21.8 6.1l-29.4-16.6-124.7 35.5-130.8 130.8c-28.1 28.1-73.7 28.1-101.8 0l16.8-16.8-16.8 16.8C-7 462.8-7 417.2 21.1 389.1L96 314.2V288c0-8.8 7.2-16 16-16h26.2l21-21c12.5-12.5 28-21.6 45-26.5L368 177.7V144h-12.1c-19.8 29.8-59.2 40.8-92.1 24.4-35.6-17.8-50-61-32.2-96.6l7.2-14.3zm93-9.5c-21.2 0-40.6 12-50.1 31l-7.2 14.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l2.7-5.5c4.1-8.1 12.4-13.3 21.5-13.3H392c13.3 0 24 10.7 24 24v75.8c0 10.7-7.1 20.1-17.4 23.1l-181.2 51.7c-9.2 2.6-17.5 7.5-24.2 14.2L55 423c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135.3-135.1c2.9-2.9 6.5-5 10.4-6.1l188.8-54c24-6.9 40.6-28.8 40.6-53.8V104c0-30.9-25.1-56-56-56h-76.2z"
        }
    ]
};

const FarStairs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStairs",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 56c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H432v120c0 13.3-10.7 24-24 24H304v104c0 13.3-10.7 24-24 24H176v104c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h104V328c0-13.3 10.7-24 24-24h104V200c0-13.3 10.7-24 24-24h104V56z"
        }
    ]
};

const FarStamp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStamp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M299.3 116.7c3-6.2 4.7-13.2 4.7-20.7 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 7.5 1.7 14.5 4.7 20.7l.3.6c7 14.6 19 39.6 19 68.7 0 65.2-52.8 118-118 118H96c-26.5 0-48 21.5-48 48v8c0 4.4 3.6 8 8 8h400c4.4 0 8-3.6 8-8v-8c0-26.5-21.5-48-48-48h-18c-65.2 0-118-52.8-118-118 0-29 12-54.1 19-68.6l.3-.6zm43.3 20.8c-7.4 15.4-14.6 31.4-14.6 48.5 0 38.7 31.4 70 70 70h18c53 0 96 43 96 96v8c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56v-8c0-53 43-96 96-96h18c38.7 0 70-31.3 70-70 0-17.1-7.2-33.1-14.6-48.5-6-12.6-9.4-26.6-9.4-41.5 0-53 43-96 96-96s96 43 96 96c0 14.9-3.4 28.9-9.4 41.5zM32 480c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FarStandardDefinition = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStandardDefinition",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm240 152v144c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96h-56c-13.3 0-24 10.7-24 24zm48 24h32c26.5 0 48 21.5 48 48s-21.5 48-48 48h-32v-96zm-189.8 4.5c.7-.7 2.1-1.9 5.4-2.9 7.1-2.3 18.8-2.9 35.5-.6 5.1.7 21 3.3 25.6 4.4 12.9 2.9 25.8-5.1 28.7-18.1s-5.1-25.8-18.1-28.7c-6.6-1.5-24.1-4.4-29.9-5.2-19-2.5-39.3-3.1-56.7 2.5-19.2 6.2-34.9 20.3-39.6 43.5-.1.4-.2.9-.2 1.3-1.7 11.7-.3 23 5.2 33.2 5.3 9.9 13.3 16.7 21.1 21.3 13.9 8.3 32 12.5 45.5 15.6l1.8.4c16.1 3.8 26.9 6.5 33.6 10.5 1.4.8 2.2 1.5 2.7 2 .5.4.6.7.6.7s.1.1.1.5c.1.4.1 1.4-.1 3.2-.4 2.4-1 3.2-1.3 3.5-.4.5-1.8 1.6-5.1 2.7-7.3 2.3-19.5 2.8-36.2.6-7.2-1-20-4.7-31.1-8-2.6-.7-5-1.5-7.3-2.1-12.7-3.6-26 3.7-29.7 16.5s3.7 26 16.5 29.7c1.4.4 3.2.9 5.3 1.5 10.8 3.2 28.6 8.4 39.7 9.9h.1c19 2.5 39.6 3.2 57.1-2.4 9.1-2.9 18.2-7.7 25.6-15.6 7.6-8.1 12.1-18.1 13.8-29.3 1.7-11.7.3-23-5.2-33.2-5.3-9.9-13.3-16.7-21.1-21.3-13.9-8.3-32-12.5-45.5-15.6l-1.8-.4c-16.1-3.8-26.9-6.5-33.6-10.5-1.4-.8-2.2-1.5-2.7-2-.5-.4-.6-.7-.6-.7s-.1-.1-.1-.5-.1-1.2 0-2.5c.5-2.3 1.3-3.3 1.8-3.8z"
        }
    ]
};

const FarStapler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStapler",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 384v48H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h536c26.5 0 48-21.5 48-48V288l-.7-.1c-3.8-31.8-23.3-59.9-52.4-74.4L260.7 50.4C236.6 38.3 209.9 32 182.9 32c-54.7 0-106.2 25.8-139.1 69.6l-32.3 43.1C4 154.6 0 166.7 0 179.1c0 26.4 17.9 49.3 43.5 55.7L64 240v104c0 22.1 17.9 40 40 40h344zm0-48H112v-84l336 84zm72 96h-24v-96c0-22-15-41.2-36.4-46.6L55.2 188.3c-4.2-1.1-7.2-4.8-7.2-9.2 0-2 .7-4 1.9-5.7l32.3-43.1C106 98.7 143.3 80 182.9 80c19.5 0 38.8 4.6 56.3 13.3l326.3 163.1c14.5 7.3 24.3 21.3 26.2 37.2l.3 2.4v136h-72z"
        }
    ]
};

const FarStarAndCrescent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarAndCrescent",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 256c0 95.9 62.5 177.2 149 205.4-65.8-44.6-109-120-109-205.4S123.2 95.2 189 50.6C102.5 78.8 40 160.1 40 256zM256 0c22.2 0 43.7 2.8 64.2 8.1l7.8 2.1c1.4.4 2.8.8 4.2 1.3 4.3 1.3 8.5 2.8 12.7 4.3 1.6.6 3.1 1.2 4.7 1.8 7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-1.7-.1-3.4-.2-5-.3-3.2-.1-6.4-.2-9.6-.2h-2.6c-3.2 0-6.5.2-9.7.3C206.6 54.7 120 145.2 120 256s86.6 201.3 195.7 207.6c3.2.2 6.4.3 9.7.3h2.6c3.2 0 6.4-.1 9.6-.2 1.7-.1 3.4-.2 5-.3 7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4c-1.6.6-3.1 1.2-4.7 1.8-4.2 1.6-8.4 3-12.7 4.3-1.4.4-2.8.8-4.2 1.3-2.6.8-5.2 1.5-7.8 2.1-20.5 5.3-42 8.1-64.2 8.1C114.6 512 0 397.4 0 256S114.6 0 256 0zm101.2 174.2 1.7-3.4 10.9-22.2 5.5-11.2c3.5-7.1 13.7-7.1 17.2 0l5.5 11.2 10.9 22.2 1.7 3.4 13.3 27c1.4 2.8 4.1 4.8 7.2 5.3l29.8 4.3 3.7.5 24.5 3.6 12.4 1.8c7.9 1.1 11 10.8 5.3 16.4l-9 8.7-17.7 17.3-2.7 2.6-21.6 21c-2.3 2.2-3.3 5.4-2.8 8.5l5.1 29.7.6 3.7 4.2 24.4 2.1 12.3c1.3 7.8-6.9 13.8-13.9 10.1l-11.1-5.8-21.9-11.5-3.3-1.7-26.6-14c-2.8-1.5-6.1-1.5-8.9 0l-26.6 14-3.3 1.7-21.9 11.5-11.1 5.8c-7 3.7-15.3-2.3-13.9-10.1l2.1-12.3 4.2-24.4.6-3.7 5.1-29.7c.5-3.1-.5-6.3-2.8-8.5l-21.6-21-2.7-2.6-17.7-17.3-9-8.7c-5.7-5.6-2.6-15.2 5.3-16.4l12.4-1.8 24.5-3.6 3.7-.5 29.8-4.3c3.1-.5 5.8-2.4 7.2-5.3l13.3-27zm-7.7 78.6a36.3 36.3 0 1 0 69 22.4 36.3 36.3 0 1 0-69-22.4z"
        }
    ]
};

const FarStarChristmas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarChristmas",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M279.2 17.9C276.5 7.4 266.9 0 256 0s-20.5 7.4-23.2 17.9l-44.5 170.4-170.4 44.5C7.4 235.5 0 245.1 0 256s7.4 20.5 17.9 23.2l170.4 44.4L232.7 494c2.8 10.6 12.3 17.9 23.2 17.9s20.5-7.4 23.2-17.9l44.4-170.4 170.4-44.4c10.6-2.8 17.9-12.3 17.9-23.2s-7.4-20.5-17.9-23.2l-170.2-44.5-44.5-170.4zm-48 196.1 24.8-95 24.8 95c2.2 8.4 8.8 15 17.2 17.2l95 24.8-95 24.8c-8.4 2.2-15 8.8-17.2 17.2L256 393l-24.8-95c-2.2-8.4-8.8-15-17.2-17.2L119 256l95-24.8c8.4-2.2 15-8.8 17.2-17.2zM71 71c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L105 71c-9.4-9.4-24.6-9.4-33.9 0zm370 0c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9zm0 336-48-48c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM71 441c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 407c-9.4 9.4-9.4 24.6 0 33.9z"
        }
    ]
};

const FarStarExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5l-68.6 141.3-153.2 22.7c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5l111.1 110.1L116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5l-26.4-155.5 111.2-110.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3l-153.3-22.6-68.6-141.3zm-74.1 173.7L287.9 79l52.6 108.2c3.5 7.1 10.2 12.1 18.1 13.3L476.9 218 391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6-105.2-56.1c-7.1-3.8-15.6-3.8-22.6 0l-105.2 56.2 20.2-119.6c1.3-7.7-1.2-15.5-6.8-21L99 217.9l118.3-17.5c7.8-1.2 14.6-6.1 18.1-13.3zM288 168c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.3-10.7-24-24-24zm32 168a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarStarHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarHalfStroke",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M341.5 13.5C337.5 5.2 329.1 0 319.9 0s-17.6 5.2-21.6 13.5l-68.6 141.3-153.2 22.7c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5l111.1 110.1L148 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5l-26.4-155.5 111.2-110.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3l-153.3-22.6-68.6-141.3zM320 384.7V79.1l52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3L508.9 218 423 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6-105.2-56.1c-3.5-1.9-7.4-2.8-11.2-2.8z"
        }
    ]
};

const FarStarHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarHalf",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M293.3.6c10.9 2.5 18.6 12.2 18.6 23.4v384.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6 68.6-141.3c4.9-10.1 16.1-15.4 27-12.9zm-29.4 127.8-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9l85.9 85.1c5.5 5.5 8.1 13.3 6.8 21l-20.3 119.7 92.5-49.4V128.4z"
        }
    ]
};

const FarStarOfDavid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarOfDavid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408.9 301.9 378.2 352h61.5l-30.8-50.1zM380.8 256l-58.9-96H190.1l-58.9 96 58.9 96h131.8l58.9-96zm56.3 0 53.4 87c3.6 5.9 5.5 12.7 5.5 19.6 0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5c-7.7 12.8-21.6 20.5-36.5 20.5s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87-53.4-87c-3.6-5.9-5.5-12.7-5.5-19.6 0-20.6 16.8-37.4 37.4-37.4h109.9l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5l56.1 91.5h109.9c20.7 0 37.4 16.8 37.4 37.4 0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-58.9-96 30.7 50.1 30.8-50.1h-61.5zm-85.8-48L256 52.7 219.6 112h72.8zm-158.6 48H72.3l30.8 50.1 30.7-50.1zm-30.7 141.9L72.3 352h61.5L103 301.9zM219.6 400l36.4 59.3 36.4-59.3h-72.8z"
        }
    ]
};

const FarStarOfLife = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarOfLife",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 64c0-35.3 28.7-64 64-64h16c35.3 0 64 28.7 64 64v67.3l58.3-33.6c30.6-17.7 69.8-7.2 87.4 23.4l8 13.9c17.7 30.6 7.2 69.8-23.4 87.4L400 256l58.3 33.6c30.6 17.7 41.1 56.8 23.4 87.4l-8 13.9c-17.7 30.6-56.8 41.1-87.4 23.4L328 380.7V448c0 35.3-28.7 64-64 64h-16c-35.3 0-64-28.7-64-64v-67.3l-58.3 33.6C95.1 432 56 421.5 38.3 390.9l-8-13.9c-17.7-30.6-7.2-69.8 23.4-87.4L112 256l-58.3-33.6c-30.6-17.7-41.1-56.8-23.4-87.4l8-13.9C56 90.5 95.1 80 125.7 97.6l58.3 33.7V64zm64-16c-8.8 0-16 7.2-16 16v108.9c0 8.6-4.6 16.5-12 20.8s-16.6 4.3-24 0l-94.3-54.4c-7.7-4.4-17.4-1.8-21.9 5.9l-8 13.9c-4.4 7.7-1.8 17.4 5.9 21.9l94.3 54.2c7.4 4.3 12 12.2 12 20.8s-4.6 16.5-12 20.8l-94.3 54.4c-7.7 4.4-10.3 14.2-5.9 21.9l8 13.9c4.4 7.7 14.2 10.3 21.9 5.9l94.3-54.5c7.4-4.3 16.6-4.3 24 0s12 12.2 12 20.8V448c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V339.1c0-8.6 4.6-16.5 12-20.8s16.6-4.3 24 0l94.3 54.4c7.7 4.4 17.4 1.8 21.9-5.9l8-13.9c4.4-7.7 1.8-17.4-5.9-21.9L340 276.8c-7.4-4.3-12-12.2-12-20.8s4.6-16.5 12-20.8l94.3-54.4c7.7-4.4 10.3-14.2 5.9-21.9l-8-13.9c-4.4-7.7-14.2-10.3-21.9-5.9L316 193.6c-7.4 4.3-16.6 4.3-24 0s-12-12.2-12-20.8V64c0-8.8-7.2-16-16-16h-16z"
        }
    ]
};

const FarStarSharpHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarSharpHalfStroke",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7l130.8 101.8-51 160c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4l129.3 100.5c8.3 6.5 19.8 6.8 28.5.7s12.3-16.9 9.1-27l-51-159.9 130.8-101.8c8.1-6.3 11.3-17 8-26.7S530.3 176 520 176H361.6L310.9 16.7zM288 103.2l33.1 104.1c3.2 10 12.4 16.7 22.9 16.7h106.1l-88.8 69.1c-7.9 6.2-11.2 16.6-8.1 26.2l32.5 102.3-82.9-64.5c-4.3-3.4-9.5-5.1-14.7-5.1V103.2z"
        }
    ]
};

const FarStarSharpHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarSharpHalf",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M291.7.3C303.4 2.1 312 12.2 312 24v352c0 7.4-3.4 14.4-9.3 18.9l-144 112c-8.3 6.5-19.8 6.8-28.5.7s-12.3-16.9-9.1-27L172 320.5 41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176h158.5l50.6-159.3C268.7 5.4 280-1.5 291.7.3zM264 178.6l-9.1 28.7c-3.2 10-12.4 16.7-22.9 16.7H126l88.8 69.1c7.9 6.2 11.2 16.6 8.1 26.2l-32.6 102.3 73.7-57.3V178.6z"
        }
    ]
};

const FarStarSharp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarSharp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c10.5 0 19.7 6.8 22.9 16.7L361.5 176H520c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L403.9 320.7l50.9 160.1c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7L288 406.4 158.7 506.9c-8.3 6.5-19.8 6.8-28.5.7s-12.3-16.9-9.1-27L172 320.5 41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176h158.5l50.6-159.3C268.3 6.8 277.5 0 288 0zm0 103.2-33.1 104.1c-3.2 10-12.4 16.7-22.9 16.7H125.9l88.8 69.1c7.9 6.2 11.2 16.6 8.1 26.2l-32.5 102.3 82.9-64.5c8.7-6.7 20.8-6.7 29.5 0l82.9 64.5-32.5-102.3c-3-9.6.2-20 8.1-26.2l88.9-69.1H344c-10.5 0-19.7-6.8-22.9-16.7L288 103.2z"
        }
    ]
};

const FarStarShooting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarShooting",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m313 41-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L279 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM129.5 388.7 120 444l49.5-26.1c14-7.4 30.7-7.4 44.7 0l49.6 26.1-9.5-55.4c-2.7-15.6 2.5-31.4 13.8-42.4l40.2-39.2-55.5-8.1c-15.6-2.3-29.2-12.1-36.1-26.3l-24.8-50.3-24.8 50.3c-7 14.2-20.5 24-36.1 26.3L75.5 307l40.2 39.2c11.3 11 16.4 26.9 13.8 42.4zm-5.4-137.3 46.3-94c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3L192 460.4l-92.7 48.8c-17.6 9.3-38.2-5.7-34.8-25.3l17.7-103.3-75-73.2C-7 293.5.9 269.3 20.5 266.5L124 251.4zM505 199c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zm0-158L361 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4 459.8 484c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6 68.6-141.3C270.4 5.2 278.7 0 287.9 0zm0 79-52.5 108.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9l85.9 85.1c5.5 5.5 8.1 13.3 6.8 21l-20.3 119.7 105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2-20.2-119.6c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1-118.3-17.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
        }
    ]
};

const FarStarfighterTwinIonEngineAdvanced = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarfighterTwinIonEngineAdvanced",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M118.5 7.6c9-9.7 24.2-10.2 33.9-1.2s10.2 24.2 1.2 33.9L50.2 151.2c-1.4 1.5-2.2 3.4-2.2 5.5V195l137.9-26.3C214.4 124.9 263.8 96 320 96s105.6 28.9 134.1 72.7L592 195v-38.4c0-2-.8-4-2.2-5.5L486.5 40.4c-9-9.7-8.5-24.9 1.2-33.9s24.9-8.5 33.9 1.2l103.3 110.7c9.7 10.4 15.1 24 15.1 38.2v198.8c0 14.2-5.4 27.8-15.1 38.2L521.5 504.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9l103.4-110.9c1.4-1.5 2.2-3.4 2.2-5.5V317l-137.9 26.3C425.6 387.1 376.2 416 320 416s-105.6-28.9-134.1-72.7L48 317v38.4c0 2 .8 4 2.2 5.5l103.3 110.7c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2L15.1 393.6C5.4 383.2 0 369.6 0 355.4V156.6c0-14.2 5.4-27.8 15.1-38.2L118.5 7.6zM48 268.1l115.7 22c-2.4-11-3.7-22.4-3.7-34.2s1.3-23.2 3.7-34.2L48 243.9v24.3zm428.3-46.3c2.4 11 3.7 22.4 3.7 34.2s-1.3 23.2-3.7 34.2l115.7-22v-24.3l-115.7-22zM304 334.4c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2v-32.5zm-50.7-34.3c-5.6-8.4-9.6-17.9-11.7-28.1h-32.5c2.7 19 10.2 36.4 21.2 51.1l23-23zM241.6 240c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1h32.5zm34.3-50.7c8.4-5.6 17.9-9.6 28.1-11.7v-32.5c-19 2.7-36.4 10.2-51.1 21.2l23 23zM336 366.9c19-2.7 36.4-10.2 51.1-21.2l-23-23c-8.4 5.6-17.9 9.6-28.1 11.7v32.5zm94.9-94.9h-32.5c-2.1 10.2-6.1 19.7-11.7 28.1l23 23c11-14.7 18.4-32.1 21.2-51.1zm-32.5-32h32.5c-2.7-19-10.2-36.4-21.2-51.1l-23 23c5.6 8.4 9.6 17.9 11.7 28.1zM336 145.1v32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23c-14.7-11-32.1-18.4-51.1-21.2zM352 256c0-8.8-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.2-9.2h-.5c-8.7.1-16.5 3.6-22.2 9.2l-.3.3c-5.7 5.8-9.2 13.7-9.2 22.5 0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FarStarfighterTwinIonEngine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarfighterTwinIonEngine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32c13.3 0 24 10.7 24 24v137.7l105.8-24.9C182.4 125 231.8 96 288 96s105.6 29 134.2 72.8L528 193.7V56c0-13.3 10.7-24 24-24s24 10.7 24 24v400c0 13.3-10.7 24-24 24s-24-10.7-24-24V318.3l-105.8 24.9C393.6 387 344.2 416 288 416s-105.6-29-134.2-72.8L48 318.3V456c0 13.3-10.7 24-24 24S0 469.3 0 456V56c0-13.3 10.7-24 24-24zm420.7 256.6L528 269v-26l-83.3-19.6c2.2 10.5 3.3 21.4 3.3 32.6s-1.1 22.1-3.3 32.6zM48 269l83.3 19.6c-2.2-10.5-3.3-21.4-3.3-32.6s1.1-22.1 3.3-32.6L48 243v26zm224 97.9v-32.5c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2zm-73.7-43.8 23-23c-5.6-8.4-9.6-17.9-11.7-28.1h-32.5c2.7 19 10.2 36.4 21.2 51.1zM177.1 240h32.5c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1zm43.8-73.7 23 23c8.4-5.6 17.9-9.6 28.1-11.7v-32.5c-19 2.7-36.4 10.2-51.1 21.2zm134.2 179.4-23-23c-8.4 5.6-17.9 9.6-28.1 11.7v32.5c19-2.7 36.4-10.2 51.1-21.2zm22.6-22.6c11-14.7 18.4-32.1 21.2-51.1h-32.5c-2.1 10.2-6.1 19.7-11.7 28.1l23 23zm-23-111.2c5.6 8.4 9.6 17.9 11.7 28.1h32.5c-2.7-19-10.2-36.4-21.2-51.1l-23 23zm.3-45.6c-14.7-11-32.1-18.4-51.1-21.2v32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23zm-44.4 112.3c5.8-5.8 9.4-13.8 9.4-22.6s-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.3-9.2h-.5c-8.7.1-16.5 3.6-22.3 9.2l-.3.3c-5.7 5.8-9.2 13.7-9.2 22.5 0 17.7 14.3 32 32 32 8.8 0 16.8-3.6 22.6-9.4z"
        }
    ]
};

const FarStarfighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarfighter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M254.4 35c2.5-20 19.6-35 39.7-35h51.8c20.2 0 37.2 15 39.7 35l25.8 206.4c4.1-.9 8.3-1.4 12.6-1.4h32c30.9 0 56 25.1 56 56v56h56V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24v280c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.7l-88 29.3v5.4c0 17.7-14.3 32-32 32s-32-14.3-32-32v-.6c-8.8-1.3-17-4.6-24-9.5-9.1 6.3-20.1 10-32 10h-80c-11.9 0-22.9-3.7-32-10-7 4.9-15.2 8.2-24 9.5v.6c0 17.7-14.3 32-32 32s-32-14.3-32-32v-5.3l-88-29.4v2.7c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24v184h56v-56c0-30.9 25.1-56 56-56h32c4.3 0 8.6.5 12.6 1.4L254.4 35zM368 424V281.5L338.8 48h-37.6L272 281.5V424c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8zm48-128v128c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8zm-200-8h-32c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8zm104-64c17.7 0 32 14.3 32 32v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FarStars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56l-48.3 13.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zM115.7 346.2 75.5 307l55.5-8.1c15.6-2.3 29.2-12.1 36.1-26.3l24.8-50.3 24.8 50.3c7 14.2 20.5 24 36.1 26.3l55.5 8.1-40.2 39.2c-11.3 11-16.4 26.9-13.8 42.4l9.5 55.4-49.5-26.1c-14-7.4-30.7-7.4-44.7 0L120 444l9.5-55.4c2.7-15.6-2.5-31.4-13.8-42.4zm54.7-188.8-46.3 94-103.6 15.1C.9 269.3-7 293.5 7.2 307.4l74.9 73.2-17.6 103.3c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3l-17.7-103.3 74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9l-103.5-15.1-46.3-94c-8.8-17.9-34.3-17.9-43.1 0zm258.4 85.8 11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"
        }
    ]
};

const FarStarshipFreighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarshipFreighter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 256c0-97.2-78.8-176-176-176S48 158.8 48 256s78.8 176 176 176c14.8 0 29.1-1.8 42.8-5.2L208 350.7c-45.4-7.6-80-47.1-80-94.7 0-53 43-96 96-96s96 43 96 96c0 1.3 0 2.7-.1 4l60 77.7c12.8-24.4 20.1-52.2 20.1-81.7zm40 112c1.1 0 2.3 0 3.4.1l84.6-32.9V280h-81.3c-3.4 31.8-13.4 61.6-28.7 88h22zm6.7-136H528v-55.2l-118.2-46c19.9 29.5 32.9 63.9 36.9 101.1zm108.9 143.9-57 22.2C507 409.9 512 424.4 512 440c0 39.8-32.2 72-72 72h-72c-22.3 0-43.3-10.3-57-28l-9.9-12.9C275.9 477 250 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l207.9 80.9c12.3 4.8 20.4 16.6 20.4 29.8v180.2c0 13.2-8.1 25-20.4 29.8zM88 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm152-80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm77 198.7c4.5 5.9 11.6 9.3 19 9.3h72c13.3 0 24-10.7 24-24s-10.7-24-24-24h-60.2l-79.1-102.3c-9.7 12.9-22.6 23.3-37.5 30l85.8 111z"
        }
    ]
};

const FarStarship = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStarship",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h128c35.3 0 64 28.7 64 64s-28.7 64-64 64h-27.2l37.7 26.1 70.1-8.4C302.6 110.7 369.9 64 448 64c106 0 192 86 192 192s-86 192-192 192c-78.1 0-145.4-46.7-175.3-113.7l-70.1-8.4-37.8 26.1H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H64c-35.3 0-64-28.7-64-64s28.7-64 64-64h16.5l50.1-34.7-13.7-1.6C86.7 312 64 286.4 64 256s22.7-56 52.9-59.6l13.7-1.6L80.5 160H64c-35.3 0-64-28.7-64-64zm64-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm58.6 164c-6.1.7-10.6 5.9-10.6 12s4.6 11.3 10.6 12L258 284.3c-1.4-9.2-2.1-18.6-2.1-28.2s.7-19 2.1-28.2L122.6 244zM48 416c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm400-16a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm32-144a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FarSteak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSteak",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M301.5 72.6c-15.9 14.8-25.5 34.1-32.8 50.6-4.2 9.6-7.7 18-10.9 25.7l-1.3 3.2c-9.3 22.5-18.4 44.6-39.1 65.3-26.6 26.6-56.8 42.7-81.6 55.3-2.8 1.4-5.5 2.8-8.1 4.1-22.4 11.4-39.6 20.1-55.1 32.5C57.7 321.2 48 337.8 48 360c0 50 42.8 75.3 77.6 87.3C162.2 459.8 206.1 464 240 464c70.2 0 140.7-26.7 194-66.3 52.5-39.1 94-95.4 94-157.7 0-48.1-19-95-47-130-27.6-34.5-67.9-62-113-62-27.4 0-49.4 8.6-66.5 24.6zm-32.7-35.2C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80 33.9 42.4 57.5 99.6 57.5 160 0 83.9-55.1 152.8-113.4 196.2-60.5 45-140.9 75.8-222.6 75.8-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1 19.6-15.8 41.4-26.8 63.3-37.8 27.3-13.8 54.6-27.6 77.7-50.7 13.8-13.8 19.7-27.9 30-52.9 3.2-7.7 6.8-16.5 11.2-26.6 7.7-17.6 20.6-44.7 44.1-66.5zm36.8 122c2.5-6 4.8-11.8 7.1-17 6.9-15.7 13.3-27.1 21.5-34.7 7.5-7 17.5-11.7 33.9-11.7 25.4 0 53.3 16.2 75.5 44 22 27.5 36.5 64.1 36.5 100 0 40.8-28.3 84.6-74.7 119.2-46 34.2-106.8 56.8-165.4 56.8-31 0-69.1-3.9-98.8-14.1C110.1 391.2 96 376.7 96 360c0-9 2.6-13.2 6.9-16.9 5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8 28.6-28.6 42.9-63.7 54.3-91.9zM416 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarSteeringWheel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSteeringWheel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 369v93.6C133.7 451.3 56.2 371.4 48.6 272h107.8l74.3 95.5c.4.5.8 1 1.3 1.5zm48 0c.4-.5.9-1 1.3-1.5l74.3-95.5h107.8c-7.6 99.4-85 179.3-183.4 190.6V369zm72-145-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H195.8c-12.1 0-23.2 6.8-28.6 17.7L160 224H50.4C65.8 124.3 152 48 256 48s190.2 76.3 205.6 176H352zm-96 288a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"
        }
    ]
};

const FarSterlingSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSterlingSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 159.2c0-43.7 35.5-79.2 79.2-79.2 8.5 0 17 1.4 25.1 4.1l80.1 26.7c12.6 4.2 26.2-2.6 30.4-15.2s-2.6-26.2-15.2-30.4l-80.1-26.7c-13-4.3-26.6-6.5-40.2-6.5C105 32 48 89 48 159.2V224H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v63.4c0 17.4-4.4 34.5-12.7 49.8L2.9 444.5c-4.1 7.4-3.9 16.5.4 23.7S15.5 480 24 480h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H64.4l13-23.9C89.6 385.8 96 360.8 96 335.4V272h136c13.3 0 24-10.7 24-24s-10.7-24-24-24H96v-64.8z"
        }
    ]
};

const FarStethoscope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStethoscope",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M142.5 15.6c4.7 12.4-1.6 26.2-14 30.9L85.2 62.7c-3.1 1.2-5.2 4.2-5.2 7.5V200c0 57.4 46.6 104 104 104h16c57.4 0 104-46.6 104-104V70.2c0-3.3-2.1-6.3-5.2-7.5l-43.2-16.2c-12.4-4.7-18.7-18.5-14-30.9s18.5-18.7 30.9-14l43.2 16.2c21.8 8.1 36.3 29 36.3 52.4V200c0 78.5-59.5 143.1-135.8 151.1 3.7 63 55.9 112.9 119.8 112.9 66.3 0 120-53.7 120-120v-75.7c-32.5-10.2-56-40.5-56-76.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V344c0 92.8-75.2 168-168 168-90.4 0-164.1-71.4-167.8-160.8C91.7 343.3 32 278.6 32 200V70.2C32 46.9 46.5 26 68.3 17.8l43.3-16.3c12.4-4.7 26.2 1.6 30.9 14zM480 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
        }
    ]
};

const FarStocking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStocking",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C78.3 0 64 14.3 64 32v32c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zm48 238.9V128H96v110.9c0 10.7-5.3 20.7-14.2 26.6l-26.1 17.4C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5V128h-48v187.5c0 26.7-13.4 51.7-35.6 66.6l-104.1 69.3c-12.3 8.2-26.7 12.6-41.5 12.6-41.3 0-74.8-33.5-74.8-74.8V387c0-25.8 12.9-49.8 34.3-64.1l26.1-17.4c22.3-14.8 35.6-39.8 35.6-66.6z"
        }
    ]
};

const FarStomach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStomach",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v72c0 66.3 53.7 120 120 120h.2c-.2 2.6-.2 5.3-.2 8v64c0 39.8-32.2 72-72 72h-64C53.7 360 0 413.7 0 480v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-35.3 28.7-64 64-64 9.6 0 19 3.5 30.6 11.1 8.8 5.7 17.1 12.6 26.9 20.7 4.2 3.4 8.6 7.1 13.5 11C214.6 484 255.9 512 320 512c106 0 192-86 192-192v-96c0-70.7-57.3-128-128-128-50.6 0-94.4 29.4-115.1 72H256c-39.8 0-72-32.2-72-72V24zm18 388.3c-2-1.6-4-3.3-6-4.9 46.2-4.6 84.6-35.4 100.4-77.3 12.2-6.9 22.6-8 32.7-6.6 12.4 1.7 24.9 7.1 41.1 14.4l1.2.6c14.8 6.6 33.1 14.8 53 17.6 11.5 1.6 23.3 1.3 35.4-1.5C444.4 417.4 387.6 464 320 464c-47.9 0-78.6-20-107-42.7-3.5-2.8-7.2-5.8-10.9-8.9zm262-110.7c-12.4 7.1-22.9 8.2-33.1 6.8-12.4-1.7-24.9-7.1-41.1-14.4l-1.2-.6c-14.8-6.6-33.1-14.8-53-17.6-10.3-1.4-20.8-1.4-31.6.7V224c0-44.2 35.8-80 80-80s80 35.8 80 80v77.6z"
        }
    ]
};

const FarStop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStop",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 112c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h256zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarStopwatch20 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStopwatch20",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v49.4C96.4 109.3 16 197.2 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-44.7-14.1-86.1-38.1-120l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-29.2 29.2c-31.1-27.5-70.4-45.9-113.8-50.9V48h32c13.3 0 24-10.7 24-24S293.3 0 280 0H168zM64 304a160 160 0 1 1 320 0 160 160 0 1 1-320 0zm172-48v96c0 28.7 23.3 52 52 52s52-23.3 52-52v-96c0-28.7-23.3-52-52-52s-52 23.3-52 52zm52-12c6.6 0 12 5.4 12 12v96c0 6.6-5.4 12-12 12s-12-5.4-12-12v-96c0-6.6 5.4-12 12-12zm-132.4 8.6c1.7-5.1 6.5-8.6 11.9-8.6 6.9 0 12.5 5.6 12.5 12.5v2.2c0 3.6-1.3 7.1-3.7 9.8l-39 43.9c-13.7 15.4-21.2 35.2-21.2 55.8V384c0 11 9 20 20 20h64c11 0 20-9 20-20s-9-20-20-20h-43.9c.9-9.2 4.7-17.9 10.9-24.9l39-43.9c8.9-10 13.8-23 13.8-36.4v-2.2c0-29-23.5-52.5-52.5-52.5-22.6 0-42.7 14.5-49.8 35.9l-.6 1.7c-3.5 10.5 2.2 21.8 12.6 25.3s21.8-2.2 25.3-12.6l.6-1.7z"
        }
    ]
};

const FarStopwatch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStopwatch",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 24c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v49.4c43.4 5 82.8 23.3 113.8 50.9L391 119c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-31 31c24 33.9 38.1 75.3 38.1 120 0 114.9-93.1 208-208 208S16 418.9 16 304c0-106.8 80.4-194.7 184-206.6V48h-32c-13.3 0-24-10.7-24-24zm80 440a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm24-248v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarStoreLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStoreLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.1 129.5c5.8 9.2 6.4 20.5 2.3 30.1-.3.7-.6 1.5-1 2.2 6.4-1.1 13-1.7 19.7-1.7 10.4 0 20.5 1.4 30.1 4.1 4.4-19.8 1.5-41.5-10.4-60.3l-57.5-90.8C485.2 5 476.1 0 466.4 0H109.6c-9.7 0-18.8 5-23.9 13.1l-57.4 90.7c-29.6 46.8-3.4 111.9 51.9 119.4 4 .5 8.1.8 12.1.8 19.6 0 37.5-6.4 51.9-17 4.8-3.5 9.2-7.6 13.2-11.9 4 4.4 8.4 8.4 13.2 11.9 14.5 10.6 32.4 17 52 17s37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12 4 4.4 8.4 8.4 13.2 11.9 14.5 10.6 32.4 17 52 17 19.8 0 37.8-6.5 52.3-17.3 4.7-3.5 9-7.4 12.9-11.7 3.9 4.3 8.3 8.3 13 11.8 1.2.9 2.5 1.8 3.8 2.7 9.7-14.3 22.6-26.3 37.7-34.9-7.4-2.1-13.9-6.2-19-11.8-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2-11.8 0-22.3-5.1-29.6-13.2-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2-11.8 0-22.3-5.1-29.6-13.2-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2-1.8 0-3.8-.1-5.8-.4-8.9-1.2-16-6.8-19.9-16-4.1-9.6-3.5-20.9 2.3-30.1L120.4 48h335.2l51.5 81.5zM112 336v-81.6c-6.4 1.1-12.9 1.6-19.6 1.6-5.5 0-11-.4-16.3-1.1H76c-4.1-.6-8.1-1.3-12-2.3V448c0 35.3 28.7 64 64 64h264.6c-5.4-9.4-8.6-20.3-8.6-32v-16H128c-8.8 0-16-7.2-16-16v-64h272v-32c0-5.5.7-10.9 2-16H112zm416-96c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FarStoreSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStoreSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V252.6c-4 1-8 1.8-12.3 2.3h-.1c-5.3.7-10.7 1.1-16.2 1.1-6.6 0-13.1-.5-19.4-1.6V336h-35L301.2 210.7c1.9-1.2 3.7-2.4 5.5-3.7 4.8-3.5 9.2-7.6 13.2-12 4 4.4 8.4 8.4 13.2 11.9 14.5 10.6 32.4 17 52 17 19.8 0 37.8-6.5 52.3-17.3 4.7-3.5 9-7.4 12.9-11.7 3.9 4.3 8.3 8.3 13 11.8 14.5 10.7 32.5 17.2 52.2 17.2 4.1 0 8.1-.3 12.1-.8 55.5-7.4 81.8-72.5 52.1-119.4l-57.4-90.6C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1L95 49.1l-56.2-44zm94.1 73.7L152.4 48h335.2l51.5 81.5c5.8 9.2 6.4 20.5 2.3 30.1-3.9 9.2-11.1 14.8-20.1 16-2 .3-3.9.4-5.8.4-11.7 0-22.2-5.1-29.7-13.2-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2-11.8 0-22.3-5.1-29.6-13.2-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-6.9 7.6-16.5 12.5-27.5 13.1L132.9 78.9zm-84 55.7c-6.1 40.6 19.5 82.8 63.3 88.7 4 .5 8.1.8 12.1.8 11 0 21.4-2 31-5.6L48.9 134.5zM365.5 384l-60.9-48H144v-81.6c-6.4 1.1-12.9 1.6-19.6 1.6-5.5 0-11-.4-16.3-1.1h-.1c-4.1-.6-8.1-1.3-12-2.3V448c0 35.3 28.7 64 64 64h320c12.9 0 24.8-3.8 34.9-10.3L467.1 464H160c-8.8 0-16-7.2-16-16v-64h221.5z"
        }
    ]
};

const FarStore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStore",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.1 129.5c5.8 9.2 6.4 20.5 2.3 30.1-3.9 9.2-11.1 14.8-20.1 16-2 .3-3.9.4-5.8.4-11.7 0-22.2-5.1-29.7-13.2-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2-11.8 0-22.3-5.1-29.6-13.2-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2-11.8 0-22.3-5.1-29.6-13.2-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2-1.8 0-3.8-.1-5.8-.4-8.9-1.2-16-6.8-19.9-16-4.1-9.6-3.5-20.9 2.3-30.1L120.4 48h335.2l51.5 81.5zM483.5 224c4.1 0 8.1-.3 12-.8 55.5-7.4 81.8-72.5 52.1-119.4l-57.3-90.7C485.2 5 476.1 0 466.4 0H109.6c-9.7 0-18.8 5-23.9 13.1l-57.4 90.7c-29.6 46.8-3.4 111.9 51.9 119.4 4 .5 8.1.8 12.1.8 19.6 0 37.5-6.4 51.9-17 4.8-3.5 9.2-7.6 13.2-11.9 4 4.4 8.4 8.4 13.2 11.9 14.5 10.6 32.4 17 52 17s37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12 4 4.4 8.4 8.4 13.2 11.9 14.5 10.6 32.4 17 52 17 19.8 0 37.8-6.5 52.3-17.3 4.7-3.5 9-7.4 12.9-11.7 3.9 4.3 8.3 8.3 13 11.8 14.5 10.7 32.5 17.2 52.2 17.2zM112 336v-81.6c-6.4 1.1-12.9 1.6-19.6 1.6-5.5 0-11-.4-16.3-1.1H76c-4.1-.6-8.1-1.3-12-2.3V448c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V252.6c-4 1-8 1.8-12.3 2.3h-.1c-5.3.7-10.7 1.1-16.2 1.1-6.6 0-13.1-.5-19.4-1.6V336H112zm352 48v64c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16v-64h352z"
        }
    ]
};

const FarStrawberry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStrawberry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M494.1 33.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3.4-31.5 12.6c-10.3 23.8-29.7 47.2-48 65.4l-2 2v-2.1c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7 4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-10.8-8.6-35.4-24.9-68.2-26.6 19.4-19.7 42.9-47.5 56.3-78.7zM192.2 112c20.5 0 40.8 7.8 56.4 23.4l128 128c15.6 15.6 23.4 36 23.4 56.6 0 59.2-62.9 144-224 144-60 0-87.8-11.7-102.1-25.9S48 396 48 336c0-161 84.9-224 144.2-224zm0-48C96.2 64 0 160 0 336c0 128 48 176 176 176 176 0 272-96 272-192 0-32.8-12.5-65.5-37.5-90.5l-128-128c-24.9-24.9-57.6-37.4-90.3-37.5zm-2.8 90.5c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm47.3 98.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm-32 80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm-32 80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm96.7-66.3c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm24-80c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm55.3 90.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm-192-80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm-23.3 53.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3z"
        }
    ]
};

const FarStreetView = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStreetView",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm-64 136v-40c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v40c-19.4 4.9-33.8 21.3-36 41.2l-6.2 55.6c-.5 4.1-3.9 7.1-8 7.1h-27.7c-4.1 0-7.5-3.1-8-7.1l-6.1-55.5c-2.2-19.9-16.6-36.3-36-41.2zm-5.6 102.2c3.2 28.4 27.1 49.8 55.7 49.8h27.8c28.5 0 52.5-21.5 55.7-49.8l6.2-55.6c20.8-5.2 36.3-24.1 36.3-46.6v-40c0-44.2-35.8-80-80-80H224c-44.2 0-80 35.8-80 80v40c0 22.5 15.4 41.3 36.3 46.6l6.2 55.6zm-54.1 12c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45 14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4 13.7-8.9 29.1-23.6 29.1-45 0-13.5-6.4-24.5-14-32.6-7.5-7.9-17.3-14.3-27.8-19.6-21-10.6-49.5-18.9-82-24.8-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5 3.2 1.6 5.8 3.1 7.9 4.5 3.6 2.4 3.6 7.2 0 9.6-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3-3.6-2.4-3.6-7.2 0-9.6 2.1-1.4 4.8-2.9 7.9-4.5 15.3-7.7 38.8-14.9 69-20.5z"
        }
    ]
};

const FarStretcher = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStretcher",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41.4 71.5c-9.1-9.6-24.3-10-33.9-.9s-10 24.3-.9 33.9l133.1 140.1c16.6 17.5 39.7 27.4 63.8 27.4H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H203.5c-11 0-21.4-4.5-29-12.4L41.4 71.5zM241.2 304l86 62.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64c0-5.3-.7-10.5-1.9-15.5l49.9-36.2 49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 86-62.5h-81.6L368 336.9 322.8 304h-81.6zM240 448a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm224 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarStrikethrough = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStrikethrough",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145.5 138c4-21.5 17.9-37.4 41.7-47.4 24.7-10.4 59.4-13.7 99.9-7.5 12.8 2 52.4 9.5 64.9 12.8 12.8 3.3 25.9-4.3 29.3-17.2s-4.3-25.9-17.2-29.3c-14.7-3.8-56.1-11.7-69.7-13.8-46.2-7.1-90.4-4.1-125.7 10.7-36.1 15.1-63.3 43.1-70.5 83.9-.1.4-.1.9-.2 1.3-2.8 23.4.5 44.2 9.8 62.2 9.2 17.8 23.2 31.2 38.8 41.5 2.4 1.6 5 3.2 7.5 4.7H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H295.8c-9.9-3.1-19.7-6-29.2-8.8l-.3-.1c-37.7-11.1-70.5-20.7-93.3-35.8-10.9-7.2-18.2-14.9-22.6-23.5-4.2-8.2-6.6-18.9-4.9-33.8zM364 337.1c3.7 8.6 5.5 20.1 2.6 36.3-3.8 21.8-17.8 37.9-41.8 48-24.7 10.4-59.4 13.7-99.8 7.5-20.1-3.2-54.3-14.6-81.2-23.6-5.9-2-11.4-3.8-16.3-5.4-12.6-4.1-26.1 2.8-30.3 15.4s2.8 26.2 15.4 30.3c4 1.3 8.8 2.9 14 4.7 26.6 8.9 66.4 22.2 90.9 26.2h.1c46.2 7.1 90.4 4.1 125.7-10.7 36.1-15.1 63.3-43.1 70.5-83.9 4-22.9 2.4-43.5-5-61.7h-57.2c5.7 5.3 9.7 11 12.3 17.1z"
        }
    ]
};

const FarStroopwafel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarStroopwafel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm97.6-45.3 22.6 22.6 45.3-45.3-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l22.6 22.6 45.3-45.3-22.7-22.5c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 97.6 278.6 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414.4 256l22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 414.4 233.4 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3-22.6 22.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.6 256 75 233.4c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm90.5 0L142.9 256l45.3 45.3 45.2-45.3-45.3-45.3zm67.9 22.7 45.3-45.3-45.3-45.2-45.3 45.3 45.3 45.2zm22.6 22.6 45.3 45.3 45.2-45.3-45.3-45.3-45.2 45.3zM256 278.6l-45.3 45.3 45.3 45.2 45.3-45.3-45.3-45.2z"
        }
    ]
};

const FarSubscript = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSubscript",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24h27.2l96 144-96 144H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c8 0 15.5-4 20-10.7l92-138 92 138c4.5 6.7 12 10.7 20 10.7h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-27.2l-96-144 96-144H328c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40c-8 0-15.5 4-20 10.7l-92 138-92-138C79.5 68 72 64 64 64H24zm448 248c0-8-3.9-15.4-10.5-19.9s-15-5.4-22.4-2.4l-40 16c-12.3 4.9-18.3 18.9-13.4 31.2s18.9 18.3 31.2 13.4l7.1-2.8V464h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16V312z"
        }
    ]
};

const FarSubtitlesSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSubtitlesSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9l-38-29.8zM134.4 80H544c8.8 0 16 7.2 16 16v317.6L508.2 373c2.4-3.7 3.8-8.2 3.8-13 0-13.3-10.7-24-24-24h-27l-67.2-52.6c4 2.9 8.9 4.6 14.2 4.6h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24 0 7.4 3.4 14 8.6 18.4L134.4 80zm353 400-60.9-48H96c-8.8 0-16-7.2-16-16V159l-48-37.8V416c0 35.3 28.7 64 64 64h391.4zm-121.9-96-59.9-47.2c-10.1 2.8-17.6 12.1-17.6 23.2 0 13.3 10.7 24 24 24h53.5zm-121.8-96-60.9-48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h91.7zM152 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80z"
        }
    ]
};

const FarSubtitles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSubtitles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm120 144h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm256 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-256 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 0h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarSuitcaseMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSuitcaseMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8zm-56 8v40H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm240 88v288H144V144h224zm-272 0v288H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h32zm320 288V144h32c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16h-32zM229.3 224v37.3H192c-8.8 0-16 7.2-16 16v21.3c0 8.8 7.2 16 16 16h37.3V352c0 8.8 7.2 16 16 16h21.3c8.8 0 16-7.2 16-16v-37.3H320c8.8 0 16-7.2 16-16v-21.4c0-8.8-7.2-16-16-16h-37.3V224c0-8.8-7.2-16-16-16h-21.4c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FarSuitcaseRolling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSuitcaseRolling",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 56v72h96V56c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm-48 72V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56v72h32c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H112v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h32zm-32 48c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H64zm32 72c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm0 112c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarSuitcase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSuitcase",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56v40h160V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V56c0-30.9 25.1-56 56-56h144c30.9 0 56 25.1 56 56v40h64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm232 48H144v288h224V144h-8zm-296 0c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h32V144H64zm384 288c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16h-32v288h32z"
        }
    ]
};

const FarSunBright = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSunBright",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm157 84.9-45.3 45.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L403.1 75c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM108.9 75l45.3 45.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L75 108.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM24 232h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm400 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24zM154.2 391.8 108.9 437c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l45.3-45.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm237.6-33.9 45.2 45.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-45.3-45.3c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM280 424v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64c0-13.3 10.7-24 24-24s24 10.7 24 24zm40-168a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1-224 0z"
        }
    ]
};

const FarSunCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSunCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5-98.5 18.2c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4l82.6-56.8 82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l8.1-44.3c-16.9 0-32.8-4.4-46.6-12.1l-2.1 11.3-65.5-45.3c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3l-78.3-14.4 45.2-65.6c5.7-8.2 5.7-19 0-27.2l-45.2-65.6 78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3 65.6 45.2c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4-13.3 19.3c9.6-2.7 19.7-4.1 30.1-4.1 9.8 0 19.4 1.3 28.5 3.7l15.3-22.1c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1-18.2-98.6zM256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112c11.4 0 22.3-1.7 32.6-4.8-.4-3.7-.6-7.4-.6-11.2 0-21.4 7-41.2 18.8-57.1-11.7 15.2-30.1 25.1-50.8 25.1-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64c0 14.2-4.6 27.3-12.4 37.9 13.2-17.3 32.1-30 54-35.3 1.8-4 3.8-8 6.1-11.7C363 189.3 314.8 144 256 144zm128 272h184c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224c-38.7 0-71 27.5-78.4 64H384c-35.3 0-64 28.7-64 64s28.7 64 64 64z"
        }
    ]
};

const FarSunDust = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSunDust",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5-98.5 18.2c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 37.6-37.6c-3.4-3.4-7.7-5.7-12.6-6.6l-78.3-14.4 45.2-65.6c5.7-8.2 5.7-19 0-27.2l-45.2-65.6 78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3 65.6 45.2c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c.9 4.9 3.3 9.3 6.6 12.6l37.6-37.6-18.1-98.4zM256 144c-61.9 0-112 50.1-112 112 0 30.9 12.5 58.9 32.8 79.2l33.9-33.9C199.2 289.7 192 273.7 192 256c0-35.3 28.7-64 64-64 17.7 0 33.7 7.2 45.3 18.7l33.9-33.9C314.9 156.5 286.9 144 256 144zm256 16a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-80 80a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm48 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-240 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-48-112a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-112-48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarSunHaze = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSunHaze",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M439.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L320 61.1 237.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5-98.5 18.2c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8l56.8 82.5h53.2c0-4.8-1.4-9.5-4.2-13.6l-45.2-65.6 78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3 65.5 45.2c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4-45.2 65.6c-2.8 4.1-4.2 8.9-4.2 13.6H515l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4L458 118.2l-18.3-98.5zM432 256c0-61.9-50.1-112-112-112s-112 50.1-112 112h48c0-35.3 28.7-64 64-64s64 28.7 64 64h48zm184 32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-208 0H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h320c13.3 0 24-10.7 24-24s-10.7-24-24-24zm168 112c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24zM88 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zm208 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H296z"
        }
    ]
};

const FarSunPlantWilt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSunPlantWilt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160-.2c-8.4 0-16.2 4.4-20.5 11.6l-24.3 40.3-45.6-11.3c-8.2-2-16.8.4-22.7 6.3s-8.3 14.6-6.3 22.7L51.9 115l-40.3 24.4C4.4 143.7 0 151.5 0 159.9s4.4 16.2 11.6 20.5l40.2 24.3-11.3 45.7c-2 8.2.4 16.8 6.3 22.7s14.6 8.3 22.7 6.3l45.6-11.3 24.3 40.2c4.3 7.2 12.1 11.6 20.5 11.6s16.2-4.4 20.5-11.6l24.3-40.2 45.6 11.3c8.2 2 16.8-.4 22.7-6.3s8.3-14.6 6.3-22.7L268 204.8l40.2-24.3c7.2-4.3 11.6-12.1 11.6-20.5s-4.4-16.2-11.6-20.5L268 115.2l11.3-45.6c2-8.2-.4-16.8-6.3-22.7s-14.6-8.3-22.7-6.3l-45.4 11.1-24.3-40.3C176.2 4.2 168.5-.2 160-.2zm0 70.4 12.9 21.3c5.4 9 16.1 13.4 26.3 10.9l24.2-6-6 24.2c-2.5 10.2 1.9 20.9 10.9 26.3l21.3 12.9-21.3 12.9c-9 5.4-13.4 16.1-10.9 26.3l6 24.2-24.2-6c-10.2-2.5-20.9 1.9-26.3 10.9L160 249.6l-12.9-21.3c-5.4-9-16.1-13.4-26.3-10.9l-24.2 6 6-24.2c2.5-10.2-1.9-20.9-10.9-26.3l-21.3-13L91.8 147c9-5.4 13.4-16.1 10.9-26.3l-6-24.2 24.2 6c10.2 2.5 20.9-1.9 26.3-10.9L160 70.3zm32 89.8a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6 0 16.8 16 44 37.4 67.2 5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6 0 16.8 16 44 37.4 67.2 5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v192H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24H504V176z"
        }
    ]
};

const FarSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSun",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5-98.5 18.2c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4l82.6-56.8 82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1-18.2-98.5zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4-45.2 65.6c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3-65.6-45.2c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3l-78.3-14.4 45.2-65.6c5.7-8.2 5.7-19 0-27.2l-45.2-65.6 78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3 65.6 45.2c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm-64-112a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FarSunglasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSunglasses",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8 40.1 0 82.2 9.6 118.5 27.3 5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.4 7.7-9.8 13.5-12.7C358 257.5 400.2 248 440.3 248c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1-3.1 0-6.2.6-9.2 1.8l-31.3 12.5c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2 33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2.3 1.8.5 3.7.5 5.6v64c0 61.9-50.1 112-112 112h-44.4c-59.4 0-108.5-46.4-111.8-105.8l-1.3-22.2h-37.2l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368v-64c0-1.9.2-3.8.5-5.7.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-31.3-12.5c-2.9-1.2-6-1.8-9.2-1.8zM48 352v16c0 2.6.2 5.2.5 7.8l144.4-72.2c-18.8-5-38.3-7.6-57.2-7.6-29.5 0-60.5 6.4-87.7 18.2V352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c0 .8.1 1.7.2 2.5l141-70.5c-18.6-4.9-38-7.5-56.7-7.5z"
        }
    ]
};

const FarSunrise = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSunrise",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M271 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9l-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L271 7zm122.3 218.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L493.9 464H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h58.1l-45.9-66.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-13 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4l82.6 56.8 82.5-56.9c6.7-4.6 15.3-5.5 22.8-2.4zM140.4 464h36.7c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96h36.7l43.6-63.2-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3l-14.4-78.3-65.6 45.2c-8.2 5.7-19 5.7-27.2 0l-65.6-45.2-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3l-78.3 14.4 43.6 63.2zm209.6 0c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48h124z"
        }
    ]
};

const FarSunset = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSunset",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M305 217c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V24c0-13.3 10.7-24 24-24s24 10.7 24 24v118.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80zm88.3 8.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L493.9 464H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h58.1l-45.9-66.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-13 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4l82.6 56.8 82.5-56.9c6.7-4.6 15.3-5.5 22.8-2.4zM140.4 464h36.7c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96h36.7l43.6-63.2-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3l-14.4-78.3-65.6 45.2c-8.2 5.7-19 5.7-27.2 0l-65.6-45.2-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3l-78.3 14.4 43.6 63.2zm209.6 0c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48h124z"
        }
    ]
};

const FarSuperscript = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSuperscript",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472 24c0-8-3.9-15.4-10.5-19.9s-15-5.4-22.4-2.4l-40 16c-12.3 4.9-18.3 18.9-13.4 31.2s18.9 18.3 31.2 13.4l7.1-2.8V176h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16V24zM24 64C10.7 64 0 74.7 0 88s10.7 24 24 24h27.2l96 144-96 144H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c8 0 15.5-4 20-10.7l92-138 92 138c4.5 6.7 12 10.7 20 10.7h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-27.2l-96-144 96-144H328c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40c-8 0-15.5 4-20 10.7l-92 138-92-138C79.5 68 72 64 64 64H24z"
        }
    ]
};

const FarSushiRoll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSushiRoll",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 207.7c-13.2 11.2-29 19.7-45 26.1-36 14.4-82.3 22.2-131 22.2s-95-7.8-131-22.2c-16-6.4-31.9-14.9-45-26.1V368c0 3 3.6 18.5 39.1 36.3C119.6 420.5 168 432 224 432s104.4-11.5 136.9-27.7C396.4 386.5 400 371 400 368V207.7zM64 144c0 10.4 6.2 20.1 17.1 28.8 20.4-23.3 45.9-40.4 70.3-52.7 20.1-10.1 40.2-17.3 57.5-21.9-1.7-5.8-3-11.7-3.8-17.7C125.7 84.2 64 111.2 64 144zm54 47.9c28.2 10 65.4 16.1 106 16.1 30.9 0 59.8-3.5 84.2-9.6-35.3-13.5-63.8-36.1-82-63.4-16 3.8-36.4 10.5-56.9 20.8-18.6 9.3-36.6 21.3-51.4 36.1zM384 144c0-32.4-60.1-59.2-138.2-63.4 9.3 42.5 53.3 85.3 122.8 90.8 9.8-8.3 15.4-17.6 15.4-27.4zM224 32c123.7 0 224 50.1 224 112v224c0 61.9-100.3 112-224 112S0 429.9 0 368V144C0 82.1 100.3 32 224 32z"
        }
    ]
};

const FarSushi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSushi",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M524.5 302.9c23.1 7.7 46-12.3 41.5-36.3l-8.6-46c-7.1-37.7-24.8-71-49.8-97.2l-85.9 145.4 102.8 34.1zM393.7 65.6l-97.2 164.6c9 1 17.9 2.9 26.6 5.8l67.5 22.4 92.5-156.6c-25.7-19.1-56.4-31.8-89.4-36.2zM357.5 64H246.6L119.9 278.4l120.9-41.9c5.7-2 11.6-3.6 17.5-4.7L357.5 64zm-150.2 0C115 64 35.7 129.8 18.6 220.6l-8.5 45.2C5.6 290 28.9 310 52.1 302l21.1-7.3L209.5 64h-2.1zM32 336.7V352c0 53 43 96 96 96 17.3 0 33.6-4.6 47.6-12.6 2.7-1.6 6.1-1.6 8.8 0 14 8 30.3 12.6 47.6 12.6 18.8 0 36.4-5.4 51.2-14.8 2.9-1.8 6.6-1.8 9.5 0 14.8 9.4 32.4 14.8 51.2 14.8 17.3 0 33.6-4.6 47.6-12.6 2.7-1.6 6.1-1.6 8.8 0 14 8 30.3 12.6 47.6 12.6 53 0 96-43 96-96v-14.6c-8.5.8-17.4-.1-26.2-3.1l-21.7-7.2V352c0 26.5-21.5 48-48 48-8.7 0-16.8-2.3-23.8-6.3-17.5-10-39-10-56.5 0-7 4-15 6.3-23.8 6.3-9.5 0-18.2-2.7-25.6-7.4-18.6-11.7-42.3-11.7-60.8 0-7.4 4.7-16.1 7.4-25.6 7.4-8.7 0-16.8-2.3-23.8-6.3-17.5-10-39-10-56.5 0-7 4-15 6.3-23.8 6.3-26.5 0-48-21.5-48-48v-25.9l-20.9 7.2c-9.1 3.2-18.3 4.2-27.1 3.3z"
        }
    ]
};

const FarSwapArrows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSwapArrows",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M111 7c9.4-9.4 24.6-9.4 33.9 0l88 88c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47V360c0 39.8 32.2 72 72 72s72-32.2 72-72V152c0-66.3 53.7-120 120-120s120 53.7 120 120v278.1l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47V152c0-39.8-32.2-72-72-72s-72 32.2-72 72v208c0 66.3-53.7 120-120 120s-120-53.7-120-120V81.9L57 129c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L111 7z"
        }
    ]
};

const FarSwap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSwap",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 119c0 22.6-18.3 41-41 41h-47v200c0 39.8 32.2 72 72 72s72-32.2 72-72V152c0-66.3 53.7-120 120-120s120 53.7 120 120v200h47c22.6 0 41 18.3 41 41 0 10.9-4.3 21.3-12 29l-83 83c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-83-83c-7.7-7.7-12-18.1-12-29 0-22.6 18.3-41 41-41h47V152c0-39.8-32.2-72-72-72s-72 32.2-72 72v208c0 66.3-53.7 120-120 120s-120-53.7-120-120V160H57c-22.6 0-41-18.3-41-41 0-10.9 4.3-21.3 12-29l83-83c4.5-4.5 10.6-7 17-7s12.5 2.5 17 7l83 83c7.7 7.7 12 18.1 12 29zm-166.1-7H182l-54-54.1L73.9 112zm384 288 54.1 54.1 54.1-54.1H457.9z"
        }
    ]
};

const FarSwatchbook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSwatchbook",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 400c0 61.9 50.1 112 112 112h336c35.3 0 64-28.7 64-64v-96c0-35.3-28.7-64-64-64h-62.1l50.7-50.7c25-25 25-65.5 0-90.5l-71.3-71.5c-25-25-65.5-25-90.5 0L224 126.1V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v336zm448 64H209.9l128-128H448c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16zm-45.3-260.7L224 382.1V193.9l84.7-84.7c6.2-6.2 16.4-6.2 22.6 0l71.4 71.4c6.2 6.2 6.2 16.4 0 22.6zM112 464c-35.3 0-64-28.7-64-64v-96h128v96c0 35.3-28.7 64-64 64zM48 256v-80h128v80H48zm0-128V64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v64H48zm64 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarSwordLaserAlt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSwordLaserAlt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L225.1 232h105.1L505.7 40.2zM13.2 459.8l39 39C60.6 507.3 72.1 512 84 512s23.4-4.7 31.8-13.2L310.6 304l1.1-1.1 8.3-8.3 11.3-11.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H173.3c-12.7 0-24.9 5.1-33.9 14.1L13.2 396.2C4.7 404.6 0 416.1 0 428s4.7 23.4 13.2 31.8zM242.7 304l-70.1 70.1-34.7-34.7 35.4-35.4h69.5zM150 396.7l-66 66L49.3 428l66.1-66.1 34.7 34.7z"
        }
    ]
};

const FarSwordLaser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSwordLaser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L230.7 226.8l54.4 54.4 220.6-241zM185 231c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l.7.7-59 59L10.3 407C3.7 413.7 0 422.6 0 432s3.7 18.3 10.3 25L55 501.7c6.6 6.6 15.6 10.3 25 10.3s18.3-3.7 25-10.3l82.3-82.3 59-59 .7.7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-96-96zm-20.3 143L138 347.3l12.4-12.4 26.7 26.7-12.4 12.4zm-49.4-4.1 26.7 26.7-62 62.1L53.3 432l62.1-62.1zm57.7-57.6 12.7-12.7 26.7 26.7-12.7 12.7-26.7-26.7z"
        }
    ]
};

const FarSword = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSword",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 4.7C503.7 1 498.5-.6 493.4.2l-75.8 12.6c-16.4 2.7-31.6 10.6-43.4 22.3L166.6 242.7l33.9 33.9L408.1 69.1c4.7-4.7 10.8-7.8 17.4-8.9l31.6-5.3-5.3 31.6c-1.1 6.6-4.2 12.7-8.9 17.4L235.3 311.4l33.9 33.9 207.6-207.5c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8c.8-5.1-.8-10.3-4.5-13.9zm-422.6 224-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1l-39.6 39.6c-2.1 2.1-5.3 2.9-8.2 1.9l-33.9-11.3c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FarSwordsLaser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSwordsLaser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m204.6 250.7 42.9-39.3 50.7 55.5-37 40.5L281 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-.7-.7-59 59-82.4 82.5c-6.7 6.6-15.6 10.3-25 10.3s-18.3-3.7-25-10.3L10.3 457C3.7 450.3 0 441.4 0 432s3.7-18.3 10.3-25l82.3-82.3 59-59-.7-.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l19.7 19.7zM505.7 40.2l-115.3 126-46.7-42.7L471.8 6.3c9.5-8.7 24.1-8.3 33.2.7s9.4 23.7.7 33.2zM177.1 361.6l-26.7-26.7-12.4 12.4 26.7 26.7 12.4-12.4zm-61.8 8.3-62 62.1L80 458.7l62.1-62.1-26.7-26.7zm57.7-57.6 26.7 26.7 12.7-12.7-26.7-26.7-12.7 12.7zM135 7c9.1-9.1 23.7-9.4 33.2-.7L360 181.8v105.1L134.3 40.2c-8.7-9.5-8.3-24.1.7-33.2zm491.8 452.8-39 39c-8.4 8.4-19.9 13.2-31.8 13.2s-23.4-4.7-31.8-13.2L398.1 372.7c-9-9-14.1-21.2-14.1-33.9V211.3c0-21.4 25.9-32.1 41-17l201.8 201.9c8.4 8.4 13.2 19.9 13.2 31.8s-4.7 23.4-13.2 31.8zM590.7 428l-66.1-66.1-34.7 34.7 66.1 66.1 34.7-34.7zM502 339.3l-70-70v69.5l35.3 35.3 34.7-34.7z"
        }
    ]
};

const FarSwords = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSwords",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m54.8 89.6-3.5-38.3 38.2 3.5 277.9 277.9 33.9-33.9L123.5 20.9C115.6 12.9 105.1 8 93.9 7L17.4.1C12.7-.4 8 1.3 4.7 4.7s-5.1 8-4.6 12.7L7 93.9c1 11.2 5.9 21.7 13.9 29.6l277.8 277.9 33.9-33.9L54.8 89.6zm404.5 219.1c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6l16 16c4.7 4.7 11.8 6 17.8 3.3l62-27.5 56.2 56.2c6.2 6.2 16.4 6.2 22.6 0l24-24c6.2-6.2 6.2-16.4 0-22.6l-56.2-56.2 27.5-62c2.7-6.1 1.4-13.1-3.3-17.8l-16-16zm-112-109.3 33.9 33.9 109.9-109.8c7.9-7.9 12.8-18.4 13.9-29.6l7-76.5c.4-4.7-1.3-9.4-4.6-12.8s-8-5.1-12.8-4.6l-76.5 7c-11.2 1-21.7 5.9-29.6 13.9L278.6 130.7l33.9 33.9L422.4 54.8l38.2-3.5-3.5 38.2-109.8 109.9zM233.4 381.3l-33.9-33.9-42.7 42.7-34.7-34.7 42.7-42.7-33.9-33.9L88 321.4l-12.7-12.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-4.7 4.7-6 11.8-3.3 17.8l27.5 62-56.2 56.2c-6.2 6.2-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l56.2-56.2 62 27.5c6 2.7 13.1 1.4 17.8-3.3l16-16c6.2-6.2 6.2-16.4 0-22.6L190.6 424l42.7-42.7z"
        }
    ]
};

const FarSymbols = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSymbols",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24S213.3 0 200 0H24zm0 80C10.7 80 0 90.7 0 104s10.7 24 24 24h64v72c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm440-26.7v76.2c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48V43.5c0-25.2-23.1-44.2-47.8-39.2l-128 25.6C317.5 33.6 304 50 304 69.1v92.4c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48V75.7l112-22.4zM505 295c-9.4-9.4-24.6-9.4-33.9 0L295 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 329c9.4-9.4 9.4-24.6 0-33.9zm-153 25a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM84 256c-37.7 0-68 30.8-68 68.2 0 19.3 8.2 37.9 22.6 50.8l4.5 4-17 13C9.6 404.8 0 424.4 0 445.1v1.4C0 482.7 29.3 512 65.5 512c14.9 0 29.3-5.1 40.9-14.3l36.3-29 41.3 37.2c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9l-35.5-31.9 34.4-27.6c10.4-8.3 12-23.4 3.7-33.7s-23.4-12-33.7-3.8l-40.6 32.5-26.4-23.8 7.9-6c16.5-12.7 26.1-32.2 26.1-53 0-36.9-29.9-66.9-66.9-66.9H84zm12.6 81.9-14.8 11.4-11-9.9c-4.2-3.8-6.7-9.4-6.7-15.2C64 313 73.1 304 84 304h1.1c10.4 0 18.9 8.5 18.9 18.9 0 5.9-2.7 11.4-7.4 15zm-41.2 92.2 24-18.4 27.1 24.4-30.1 24.1c-3.1 2.5-6.9 3.8-10.9 3.8-9.6 0-17.5-7.8-17.5-17.5v-1.4c0-5.9 2.7-11.4 7.4-15z"
        }
    ]
};

const FarSynagogue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSynagogue",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M305.1 5.2c8.7-6.9 21-6.9 29.7 0l127.7 100.7c21.2 16.7 33.5 42.2 33.5 69.1v63l31-31c9.4-9.4 24.6-9.4 33.9 0l62.6 62.6c10.5 10.5 16.4 24.7 16.4 39.6V440c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72V309.3c0-14.9 5.9-29.1 16.4-39.6L79 207c9.4-9.4 24.6-9.4 33.9 0l31 31v-63c0-26.9 12.3-52.4 33.5-69.1L305.1 5.2zM496 464h72c13.3 0 24-10.7 24-24V309.3c0-2.1-.8-4.2-2.3-5.7L544 257.9l-45.7 45.7c-1.5 1.5-2.3 3.5-2.3 5.7V464zm-48-289c0-12.2-5.6-23.8-15.2-31.4L320 54.6l-112.8 89c-9.6 7.6-15.2 19.2-15.2 31.4v289h64v-80c0-35.3 28.7-64 64-64s64 28.7 64 64v80h64V175zM144 309.3c0-2.1-.8-4.2-2.3-5.7L96 257.9l-45.7 45.7c-1.5 1.5-2.3 3.5-2.3 5.7V440c0 13.3 10.7 24 24 24h72V309.3zm183-185 15.9 28.1 32.3-.3c6.2-.1 10.1 6.7 7 12.1L365.7 192l16.4 27.8c3.2 5.4-.7 12.1-7 12.1l-32.3-.3-15.8 28.1c-3.1 5.4-10.9 5.4-13.9 0l-15.9-28.1-32.3.3c-6.2.1-10.1-6.7-7-12.1l16.4-27.8-16.4-27.8c-3.2-5.4.7-12.1 7-12.1l32.3.3 15.8-28.1c3.1-5.4 10.9-5.4 13.9 0z"
        }
    ]
};

const FarSyringe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarSyringe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M407 7c-9.4 9.4-9.4 24.6 0 33.9l15 15-38 38.2L329 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72 72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 38-38.1 15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L473 39 441 7c-9.4-9.4-24.6-9.4-33.9 0zM271.4 94.6l-191 191C69.9 296.2 64 310.4 64 325.3v88.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h88.8c14.9 0 29.1-5.9 39.6-16.4l191-191c-.3-.3-.7-.6-1-1l-33-33-191 191c-1.5 1.5-3.5 2.3-5.7 2.3H112v-74.5c0-2.1.8-4.2 2.3-5.7l27.3-27.3 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 41.4-41.4 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 41.4-41.4 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 13.1-13.1-33-33c-.3-.3-.6-.7-1-1z"
        }
    ]
};

const FarT = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarT",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h144v376c0 13.3 10.7 24 24 24s24-10.7 24-24V80h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarTableCellsLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTableCellsLarge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 80v152h184V96c0-8.8-7.2-16-16-16H280zm-48 0H64c-8.8 0-16 7.2-16 16v136h184V80zM48 280v136c0 8.8 7.2 16 16 16h168V280H48zm232 152h168c8.8 0 16-7.2 16-16V280H280v152zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FarTableCells = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTableCells",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M360 80v88h104V96c0-8.8-7.2-16-16-16h-88zm-48 0H200v88h112V80zm-160 0H64c-8.8 0-16 7.2-16 16v72h104V80zM48 216v80h104v-80H48zm0 128v72c0 8.8 7.2 16 16 16h88v-88H48zm152 88h112v-88H200v88zm160 0h88c8.8 0 16-7.2 16-16v-72H360v88zm104-136v-80H360v80h104zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm200 200h112v-80H200v80z"
        }
    ]
};

const FarTableColumns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTableColumns",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416V160h184v272H64c-8.8 0-16-7.2-16-16zm232 16V160h184v256c0 8.8-7.2 16-16 16H280zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarTableLayout = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTableLayout",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 80c8.8 0 16 7.2 16 16v64H48V96c0-8.8 7.2-16 16-16h384zM48 416V208h96v224H64c-8.8 0-16-7.2-16-16zm144 16V208h272v208c0 8.8-7.2 16-16 16H192zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarTableList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTableList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 80v88h272V96c0-8.8-7.2-16-16-16H192zm-48 0H64c-8.8 0-16 7.2-16 16v72h96V80zM48 216v80h96v-80H48zm0 128v72c0 8.8 7.2 16 16 16h80v-88H48zm144 88h256c8.8 0 16-7.2 16-16v-72H192v88zm272-136v-80H192v80h272zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FarTablePicnic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTablePicnic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h71.4l-53.1 128H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24h-82.3l-53.1-128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zm350.9 256h-52l46.9 113.2c5.1 12.2 19.1 18.1 31.4 13s18.1-19.1 13-31.4L438.9 320zm-313.8 0h-52l-39.3 94.8c-5.1 12.2.7 26.3 13 31.4s26.3-.7 31.4-13L125.1 320zm33.2-80 53.1-128h89.3l53.1 128H158.3z"
        }
    ]
};

const FarTablePivot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTablePivot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 416c0 8.8-7.2 16-16 16H128V192H0v224c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160v128h304v256zM64 32C28.7 32 0 60.7 0 96v64h128V32H64zm350.8 214.1c2.5-6 1.1-12.9-3.5-17.4l-32-32c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h16v48c0 8.8-7.2 16-16 16h-48v-16c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-32 32c-6.2 6.2-6.2 16.4 0 22.6l32 32c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8v-16h48c26.5 0 48-21.5 48-48v-48h16c6.5 0 12.3-3.9 14.8-9.9z"
        }
    ]
};

const FarTableRows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTableRows",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 432H128V280h336v136c0 8.8-7.2 16-16 16zm16-200H128V80h320c8.8 0 16 7.2 16 16v136zM0 416c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320z"
        }
    ]
};

const FarTableTennisPaddleBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTableTennisPaddleBall",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M476.4 99.5c52.2 52.2 64.8 129 37.7 193.1 15.8 4.4 30.4 11.7 43.1 21.3 35.9-82 20.3-181.2-46.8-248.3-87.5-87.5-229.3-87.5-316.8 0l-60.1 60.1c-24 24-37.5 56.6-37.5 90.5v2.8c0 33.9 13.5 66.5 37.5 90.5 13.4 13.4 12 35.6-3 47.2l-49.3 38C70.3 403.1 64 416 64 429.7c0 11.7 4.7 22.9 12.9 31.2L115 499c8.3 8.3 19.5 12.9 31.2 12.9 13.7 0 26.6-6.3 35-17.2l38-49.3c11.6-15 33.8-16.5 47.2-3 24 24 56.6 37.5 90.5 37.5h2.7c3.1 0 6.1-.1 9.2-.3-8.3-14.4-13.8-30.6-16-47.8-19.7-1-38.5-9.3-52.5-23.3l-33.9 33.9 33.9-33.9c-33.9-33.9-89.9-30.3-119.2 7.7L145.9 462l-32-32 45.8-35.3c38-29.3 41.6-85.3 7.7-119.2-15-15-23.4-35.4-23.4-56.6v-2.7c0-11 2.3-21.8 6.6-31.7l204.3 204.3c3.7-17.2 10.9-33.2 20.8-47.1L180.5 146.6l47-47c68.7-68.7 180.2-68.7 248.9 0zM432 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm144 0a96 96 0 1 0-192 0 96 96 0 1 0 192 0z"
        }
    ]
};

const FarTableTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTableTree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 160v256c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V160H128v64c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-5.6 0-11-1-16-2.7V320c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-26.5 0-48-21.5-48-48V160H48zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 144c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16v-32zm80 80h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarTable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTable",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 264V160h184v104H48zm0 48h184v120H64c-8.8 0-16-7.2-16-16V312zm232 120V312h184v104c0 8.8-7.2 16-16 16H280zm184-168H280V160h184v104zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FarTabletButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTabletButton",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm224 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarTabletRugged = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTabletRugged",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h256zM96 0C66.6 0 41.8 19.8 34.3 46.8L8.8 59.6C3.4 62.3 0 67.8 0 73.9v76.2c0 6.1 3.4 11.6 8.8 14.3L32 176v16L8.8 203.6c-5.4 2.7-8.8 8.2-8.8 14.3v76.2c0 6.1 3.4 11.6 8.8 14.3L32 320v16L8.8 347.6c-5.4 2.7-8.8 8.2-8.8 14.3v76.2c0 6.1 3.4 11.6 8.8 14.3l25.5 12.7C41.8 492.2 66.6 512 96 512h256c29.4 0 54.2-19.8 61.7-46.8l25.5-12.7c5.4-2.7 8.8-8.2 8.8-14.3v-76.3c0-6.1-3.4-11.6-8.8-14.3L416 336v-16l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3v-76.2c0-6.1-3.4-11.6-8.8-14.3L416 192v-16l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3V73.9c0-6.1-3.4-11.6-8.8-14.3l-25.5-12.8C406.2 19.8 381.4 0 352 0H96z"
        }
    ]
};

const FarTabletScreenButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTabletScreenButton",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-80H48v80zm0-128h352V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v256zM0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm224 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarTabletScreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTabletScreen",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 448c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-80H48v80zm0-128h352V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v256zM0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm192 336h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarTablet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTablet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm192 336h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarTablets = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTablets",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M608.8 254.9c-4.7 6.4-9.9 12.5-15.7 18.2s-11.9 11-18.2 15.7c-62.6 46.2-151.3 41-208-15.7s-62-145.4-15.7-208c4.7-6.4 9.9-12.5 15.7-18.2s11.9-11 18.2-15.7c62.6-46.2 151.3-41 208 15.7s62 145.4 15.7 208zM559.2 80.8c-37.9-37.9-96.2-43-139.6-15.1l154.7 154.7c27.8-43.4 22.8-101.7-15.1-139.6zm-18.8 173.5L385.7 99.6c-27.8 43.4-22.8 101.7 15.1 139.6s96.2 43 139.6 15.1zM318.2 328c1.2 7.8 1.8 15.8 1.8 24s-.6 16.2-1.8 24c-11.6 77-78 136-158.2 136S13.4 453 1.8 376C.6 368.2 0 360.2 0 352s.6-16.2 1.8-24c11.6-77 78-136 158.2-136s146.6 59 158.2 136zM160 240c-53.6 0-98.4 37.7-109.4 88h218.8c-11-50.3-55.8-88-109.4-88zm0 224c53.6 0 98.4-37.7 109.4-88H50.6c11 50.3 55.8 88 109.4 88z"
        }
    ]
};

const FarTachographDigital = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTachographDigital",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm112 16h224c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32zM80 352c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H416c-8.8 0-16-7.2-16-16zM96 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarTaco = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTaco",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M274.8 38.4c-11-8.6-26.5-8.6-37.5 0l-44.2 34.2c-5.6 4.4-12.6 6.6-19.7 6.4l-55.8-1.7c-14-.4-26.5 8.6-30.4 22.1l-15.5 53.5c-2 6.8-6.3 12.8-12.2 16.8L13.4 201c-11.5 7.9-16.3 22.6-11.6 35.7l17.1 47.7C70.9 209.2 157.7 160 256 160s185.1 49.2 237.1 124.4l17.1-47.7c4.7-13.1 0-27.8-11.6-35.7l-46.1-31.4c-5.9-4-10.2-9.9-12.2-16.8l-15.6-53.5c-3.9-13.4-16.4-22.5-30.4-22.1L338.6 79c-7.1.2-14.1-2-19.7-6.4l-44.1-34.2zM256 240c109.5 0 199.2 84.6 207.4 192H48.6c8.2-107.4 97.9-192 207.4-192zM32 480h448c17.7 0 32-14.3 32-32 0-141.4-114.6-256-256-256S0 306.6 0 448c0 17.7 14.3 32 32 32zm136-112a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm40-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarTag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M197.5 32c17 0 33.3 6.7 45.3 18.7l176 176c25 25 25 65.5 0 90.5L285.3 450.7c-25 25-65.5 25-90.5 0l-176-176C6.7 262.7 0 246.5 0 229.5V80c0-26.5 21.5-48 48-48h149.5zM48 229.5c0 4.2 1.7 8.3 4.7 11.3l176 176c6.2 6.2 16.4 6.2 22.6 0l133.5-133.5c6.2-6.2 6.2-16.4 0-22.6l-176-176c-3-3-7.1-4.7-11.3-4.7H48v149.5zM112 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarTags = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTags",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M345 39.1c-9.3-9.4-24.5-9.5-33.9-.2s-9.5 24.5-.2 33.9l127.7 129.3c33.9 34.3 33.9 89.4 0 123.7L326.7 439.1c-9.3 9.4-9.2 24.6.2 33.9s24.6 9.2 33.9-.2l112-113.2c52.4-53 52.4-138.2 0-191.2L345 39.1zM242.7 50.7c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80v149.5c0 17 6.7 33.3 18.7 45.3l168 168c25 25 65.5 25 90.5 0l133.5-133.5c25-25 25-65.5 0-90.5l-168-168zM48 80h149.5c4.2 0 8.3 1.7 11.3 4.7l168 168c6.2 6.2 6.2 16.4 0 22.6L243.3 408.8c-6.2 6.2-16.4 6.2-22.6 0l-168-168c-3-3-4.7-7.1-4.7-11.3V80zm96 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarTally1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTally1",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 40c13.3 0 24 10.7 24 24v384c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarTally2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTally2",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 64c0-13.3-10.7-24-24-24s-24 10.7-24 24v384c0 13.3 10.7 24 24 24s24-10.7 24-24V64zm128 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v384c0 13.3 10.7 24 24 24s24-10.7 24-24V64z"
        }
    ]
};

const FarTally3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTally3",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 40c13.3 0 24 10.7 24 24v384c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-13.3 10.7-24 24-24zm128 0c13.3 0 24 10.7 24 24v384c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-13.3 10.7-24 24-24zm152 24v384c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarTally4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTally4",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 64c0-13.3-10.7-24-24-24s-24 10.7-24 24v384c0 13.3 10.7 24 24 24s24-10.7 24-24V64zm128 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v384c0 13.3 10.7 24 24 24s24-10.7 24-24V64zm104-24c-13.3 0-24 10.7-24 24v384c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zm152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v384c0 13.3 10.7 24 24 24s24-10.7 24-24V64z"
        }
    ]
};

const FarTally = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTally",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 40c13.3 0 24 10.7 24 24v222.7l80-26.7V64c0-13.3 10.7-24 24-24s24 10.7 24 24v180l80-26.7V64c0-13.3 10.7-24 24-24s24 10.7 24 24v137.4l80-26.7V64c0-13.3 10.7-24 24-24s24 10.7 24 24v94.7l64.4-21.5c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4L536 209.3V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V225.3L408 252v196c0 13.3-10.7 24-24 24s-24-10.7-24-24V268l-80 26.7V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V310.6l-80 26.7V448c0 13.3-10.7 24-24 24s-24-10.7-24-24v-94.7l-64.4 21.5C27 379 13.4 372.2 9.2 359.6s2.6-26.2 15.2-30.4l79.6-26.5V64c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarTamale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTamale",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.6 69.3 296.4 208h-48.6l22.9-137.7c-6.4-4.6-14.9-8.8-25.4-12.1L229.2 208h-32.1l16.7-156.7c-12.5-1.8-25.3-2.7-37.8-3V208h-32V48.2c-12.5.4-25.4 1.3-37.8 3L122.9 208H90.8L74.7 58.2c-10.6 3.4-19 7.5-25.4 12.1L72.2 208H23.6L.4 69.3c-1.7-10.2 1.7-20.6 9-27.9C46 5 112.3 0 160 0s114 5 150.6 41.3c7.3 7.3 10.7 17.7 9 27.9zM296 304h.4l23.1 138.7c1.7 10.2-1.7 20.6-9 27.9C274 507 207.7 512 160 512S46 507 9.4 470.7c-7.3-7.3-10.7-17.7-9-27.9L23.6 304h43.1c-3.7 10.5-3.6 22 .1 32.3L49.3 441.7c6.4 4.6 14.9 8.8 25.4 12.1l10.1-94.3c9.5 6.5 20.6 9.2 31.3 8.3l-10 92.9c12.5 1.8 25.3 2.6 37.8 3v-108c2.3-2.1 4.5-4.4 6.4-7L160 336l9.6 12.8c1.9 2.6 4.1 4.9 6.4 7v108c12.5-.4 25.4-1.3 37.8-3l-10-92.9c10.7.9 21.8-1.7 31.3-8.3l10.1 94.3c10.6-3.4 19-7.5 25.4-12.1l-17.4-105.5c3.7-10.3 3.8-21.7.1-32.3H296zM24 240h272c8.8 0 16 7.2 16 16s-7.2 16-16 16H192l28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272H24c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarTankWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTankWater",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m277.2 80-13.3-24.3L251 32h133c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h133l-12.9 23.7L170.8 80H64c-8.8 0-16 7.2-16 16v206.4c14.1-2.7 27.8-8.7 39.3-15.3 6.9-3.9 13.1-8.2 18.9-12.7 12.9-10 30.6-10 43.4 0 5.9 4.6 12 8.8 18.9 12.7 15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c6.9-3.9 13.1-8.2 18.9-12.7 12.9-10 30.6-10 43.4 0 5.9 4.6 12 8.8 19 12.8 11.6 6.6 25.2 12.5 39.4 15.3V96c0-8.8-7.2-16-16-16H277.2zM48 416c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-65c-25-3.1-47.1-13-63.1-22.1-6.5-3.7-12.2-7.4-17-10.7-4.7 3.3-10.5 7-16.9 10.7-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7-4.7 3.3-10.5 7-16.9 10.7-16 9.1-38.1 19-63 22.1v65zM212.2 71c2.4-4.3 6.9-7 11.8-7s9.5 2.7 11.8 7l37.2 68.2c4.6 8.4 7 17.9 7 27.5v1.3c0 30.9-25.1 56-56 56s-56-25.1-56-56v-1.4c0-9.6 2.4-19 7-27.5L212.2 71z"
        }
    ]
};

const FarTape = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTape",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm138.6 352c52-41 85.4-104.6 85.4-176 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h328c13.3 0 24-10.7 24-24s-10.7-24-24-24H362.6zM224 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
        }
    ]
};

const FarTarpDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTarpDroplet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 160c-35.3 0-64-26.9-64-60 0-24 33.7-70.1 52.2-93.5 6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128h133.5c7 19.8 20.3 36.6 37.5 48H64c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h352v-80c0-17.7 14.3-32 32-32h80V192c0-8.8-7.2-16-16-16H341.1c17.2-11.4 30.5-28.2 37.5-48H512c35.3 0 64 28.7 64 64v172.1c0 12.7-5.1 24.9-14.1 33.9L462 497.9c-9 9-21.2 14.1-33.9 14.1H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm48 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarTarp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTarp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 128c0-8.8 7.2-16 16-16h448c8.8 0 16 7.2 16 16v160h-80c-17.7 0-32 14.3-32 32v80H64c-8.8 0-16-7.2-16-16V128zm528 0c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h364.1c12.7 0 24.9-5.1 33.9-14.1l99.9-99.9c9-9 14.1-21.2 14.1-33.9V128zm-464 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarTaxiBus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTaxiBus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48c71.5 0 110.1 17.3 129.4 32H64.5C86.2 64.8 126.6 48 192 48zM48 208v-80h120v80H48zm0 144v-96h191.2l13.7-48H216v-80h112.6c3.6-25.4 24.3-45.2 50-47.7-4-12.2-10.8-24-22-33.6C327.8 22.1 276.9 0 192 0 111.5 0 58.6 22.7 28.8 46.8 4.6 66.3 0 96.2 0 118.2V352c0 25 12.7 47 32 59.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24v-32h112v-48H72c-13.3 0-24-10.7-24-24zm80-40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm240-168v16h-6.2c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1c-.2.5-.3.9-.5 1.4-24.7 17.4-40.9 46.2-40.9 78.7v120c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h320v40c0 13.3 10.7 24 24 24s24-10.7 24-24V368c0-32.5-16.2-61.3-40.9-78.7-.1-.5-.3-.9-.5-1.4L570 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H496v-16c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zm-6.2 64h140.4c10.1 0 19.2 6.4 22.6 15.9l17.1 48.1H322.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM320 320h224c26.5 0 48 21.5 48 48v32H272v-32c0-26.5 21.5-48 48-48zm40 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarTaxi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTaxi",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-17.7 0-32 14.3-32 32v32.2c-35.2 2.2-65.9 25.2-77.7 58.8l-34.2 97.8C19.3 237.4 0 268.4 0 304v184c0 13.3 10.7 24 24 24s24-10.7 24-24v-56h416v56c0 13.3 10.7 24 24 24s24-10.7 24-24V304c0-35.6-19.4-66.6-48.1-83.2l-34.3-97.9c-11.7-33.6-42.4-56.6-77.6-58.7V32c0-17.7-14.3-32-32-32H192zm-26.6 112h181.2c17 0 32.1 10.7 37.8 26.8l24.2 69.2H103.4l24.2-69.2c5.6-16 20.8-26.8 37.8-26.8zM96 256h320c26.5 0 48 21.5 48 48v80H48v-80c0-26.5 21.5-48 48-48zm48 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarTeddyBear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTeddyBear",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80c0-17.7 14.3-32 32-32 14 0 25.9 9 30.3 21.5 4 11.5 15.9 18.2 27.8 15.6 16-3.5 34.2-5.1 54-5.1s38 1.7 54 5.1c11.9 2.6 23.8-4.1 27.8-15.6C374.1 57 386 48 400 48c17.7 0 32 14.3 32 32 0 11.5-6.1 21.7-15.4 27.3-9 5.5-13.3 16.2-10.8 26.4 1.3 5.3 2.1 11.3 2.1 18.3 0 54.9-51 104-120 104s-120-49.1-120-104c0-6.9.8-13 2.1-18.3 2.6-10.2-1.8-20.9-10.8-26.4-9.1-5.6-15.2-15.8-15.2-27.3zm32-80c-44.2 0-80 35.8-80 80 0 22.8 9.5 43.3 24.7 57.9-.4 3.4-.6 6.8-.7 10.3-25.2-16.9-59.5-16.5-84.6 3.3-31.2 24.6-36.6 69.9-12 101.1l25.8 32.7c5.5 6.9 11.2 13.6 17.1 19.9C28.6 311.7 0 344.5 0 384c0 3.9.3 7.7.8 11.4.1.8.3 1.5.4 2.3l13 53.3c8 33 35.8 56.9 68.9 60.6 1.6.3 3.2.5 4.8.5H488c1.6 0 3.3-.2 4.8-.5 33.1-3.6 60.9-27.6 68.9-60.6l13-53.3c.2-.8.3-1.5.4-2.3.5-3.7.8-7.5.8-11.4 0-39.5-28.6-72.3-66.3-78.8 5.9-6.3 11.6-13 17.1-19.9l25.8-32.7c24.6-31.2 19.2-76.5-12-101.1-25.1-19.8-59.4-20.2-84.6-3.3-.1-3.5-.3-6.9-.7-10.3C470.5 123.3 480 102.8 480 80c0-44.2-35.8-80-80-80-27.5 0-51.8 13.9-66.1 35-14.7-2.1-30.2-3-45.9-3s-31.1.9-45.9 3C227.8 13.9 203.5 0 176 0zM92 464h-1.4c-.3 0-.6-.1-.9-.1-13.8-1-25.5-10.7-28.8-24.3l-12.7-52c-.1-1.2-.2-2.4-.2-3.6 0-17.7 14.3-32 32-32 16.1 0 29.5 11.9 31.7 27.4 1.7 11.8 11.8 20.6 23.8 20.6h.6c13.3 0 24-10.7 24-24v-43.5c0-8.1-4.1-15.7-11-20.1-22.9-14.8-44-33.7-62.1-56.8l-25.9-32.7c-8.2-10.4-6.4-25.5 4-33.7s25.5-6.4 33.7 4l25.8 32.7c83.3 105.7 243.5 105.7 326.8 0l25.8-32.7c8.2-10.4 23.3-12.2 33.7-4s12.2 23.3 4 33.7l-25.8 32.7c-18.1 23-39.2 41.9-62.1 56.8-6.8 4.4-11 12-11 20.1V376c0 13.3 10.7 24 24 24h.6c11.9 0 22.1-8.8 23.8-20.6 2.2-15.5 15.6-27.4 31.7-27.4 17.7 0 32 14.3 32 32 0 1.2-.1 2.4-.2 3.6l-12.7 52c-3.3 13.6-15 23.4-28.8 24.3-.3 0-.6 0-.9.1H376v-48c0-44.2-35.8-80-80-80h-16c-44.2 0-80 35.8-80 80v48H92zm156 0v-48c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v48h-80zm8-320a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 32c0-13.3-14.3-24-32-24s-32 10.7-32 24 14.3 24 32 24 32-10.7 32-24z"
        }
    ]
};

const FarTeethOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTeethOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 48H96c-26.5 0-48 21.5-48 48v29.4C63.9 102.8 90.2 88 120 88c15.2 0 29.5 3.9 42 10.7C178.1 77.6 203.5 64 232 64c21.3 0 40.8 7.5 56 20.1C303.2 71.5 322.7 64 344 64c28.5 0 53.9 13.6 70 34.7 12.5-6.8 26.8-10.7 42-10.7 29.8 0 56.1 14.8 72 37.4V96c0-26.5-21.5-48-48-48zm0 208H64c-35.3 0-64-28.7-64-64V96C0 43 43 0 96 0h384c53 0 96 43 96 96v96c0 35.3-28.7 64-64 64h-32zm0-48c8.8 0 16-7.2 16-16v-16c0-22.1-17.9-40-40-40-9.2 0-17.6 3.1-24.3 8.3-2.9 2.2-5.5 4.8-7.7 7.7-5 6.7-8 15-8 24v16c0 8.2 6.1 14.9 14 15.9.6.1 1.3.1 2 .1h48zm-112 0c.7 0 1.3 0 2-.1 7.9-1 14-7.7 14-15.9v-40c0-6.9-1.7-13.4-4.8-19-6.8-12.5-20-21-35.2-21-11.2 0-21.3 4.6-28.6 12-7.1 7.2-11.4 17.1-11.4 28v40c0 8.2 6.1 14.9 14 15.9.7.1 1.3.1 2 .1h48zm-112 0c.7 0 1.3 0 2-.1 7.9-1 14-7.7 14-15.9v-40c0-10.9-4.4-20.8-11.4-28-7.3-7.4-17.4-12-28.6-12-15.2 0-28.4 8.5-35.2 21-3.1 5.7-4.8 12.1-4.8 19v40c0 8.2 6.1 14.9 14 15.9.7.1 1.3.1 2 .1h48zm-112 0c.7 0 1.3 0 2-.1 7.9-1 14-7.7 14-15.9v-16c0-9-3-17.3-8-24-2.2-2.9-4.8-5.5-7.7-7.7-6.7-5.2-15.2-8.3-24.3-8.3-22.1 0-40 17.9-40 40v16c0 8.8 7.2 16 16 16h48zm336 256c26.5 0 48-21.5 48-48v-5.4c-15.9 22.6-42.2 37.4-72 37.4-21.3 0-40.8-7.5-56-20.1-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1-29.8 0-56.1-14.8-72-37.4v5.4c0 26.5 21.5 48 48 48h384zm0-128h-48c-.7 0-1.3 0-2 .1-7.9 1-14 7.7-14 15.9v8c0 10.9 4.4 20.8 11.4 28 7.3 7.4 17.4 12 28.6 12 22.1 0 40-17.9 40-40v-8c0-8.8-7.2-16-16-16zm-112 0h-48c-.7 0-1.3 0-2 .1-7.9 1-14 7.7-14 15.9v8c0 10.9 4.4 20.8 11.4 28 7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28v-8c0-8.2-6.1-14.9-14-15.9-.6-.1-1.3-.1-2-.1zm112-48h32c35.3 0 64 28.7 64 64v64c0 53-43 96-96 96H96c-53 0-96-43-96-96v-64c0-35.3 28.7-64 64-64h416zM96 336c-8.8 0-16 7.2-16 16v8c0 22.1 17.9 40 40 40 11.2 0 21.3-4.6 28.6-12 7.1-7.2 11.4-17.1 11.4-28v-8c0-8.2-6.1-14.9-14-15.9-.7-.1-1.3-.1-2-.1H96zm112 0c-.7 0-1.3 0-2 .1-7.9 1-14 7.7-14 15.9v8c0 10.9 4.4 20.8 11.4 28 7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28v-8c0-8.2-6.1-14.9-14-15.9-.7-.1-1.3-.1-2-.1h-48z"
        }
    ]
};

const FarTeeth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTeeth",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 80c-26.5 0-48 21.5-48 48v45.4c15.9-22.6 42.2-37.4 72-37.4 15.2 0 29.5 3.9 42 10.7 16.1-21.1 41.4-34.7 70-34.7 21.3 0 40.8 7.5 56 20.1 15.2-12.6 34.7-20.1 56-20.1 28.5 0 53.9 13.6 70 34.7 12.5-6.8 26.8-10.7 42-10.7 29.8 0 56.1 14.8 72 37.4V128c0-26.5-21.5-48-48-48H96zM48 362.6V384c0 26.5 21.5 48 48 48h384c26.5 0 48-21.5 48-48v-21.4c-15.9 22.6-42.2 37.4-72 37.4-21.3 0-40.8-7.5-56-20.1-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1-29.8 0-56.1-14.8-72-37.4zM0 128c0-53 43-96 96-96h384c53 0 96 43 96 96v256c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm192 72v40c0 .7 0 1.3.1 2 .9 7.2 6.6 13 13.9 13.9.7.1 1.3.1 2 .1h48c.7 0 1.3 0 2-.1 7.2-.9 13-6.6 13.9-13.9.1-.7.1-1.3.1-2v-40c0-10.9-4.4-20.8-11.4-28-7.3-7.4-17.4-12-28.6-12-15.2 0-28.4 8.5-35.2 21-3.1 5.7-4.8 12.1-4.8 19zm64 88h-48c-.7 0-1.3 0-2 .1-7.2.9-13 6.6-13.9 13.9-.1.7-.1 1.3-.1 2v8c0 10.9 4.4 20.8 11.4 28 7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28v-8c0-.7 0-1.3-.1-2-.9-7.2-6.6-13-13.9-13.9-.7-.1-1.3-.1-2-.1zm48 16v8c0 10.9 4.4 20.8 11.4 28 7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28v-8c0-.7 0-1.3-.1-2-.9-7.2-6.6-13-13.9-13.9-.6-.1-1.3-.1-2-.1h-48c-.7 0-1.3 0-2 .1-7.2.9-13 6.6-13.9 13.9-.1.7-.1 1.3-.1 2zm16-48h48c.7 0 1.3 0 2-.1 7.3-.9 13-6.6 13.9-13.9.1-.7.1-1.3.1-2v-40c0-6.9-1.7-13.4-4.8-19-6.8-12.5-20-21-35.2-21-11.2 0-21.3 4.6-28.6 12-7.1 7.2-11.4 17.1-11.4 28v40c0 .7 0 1.3.1 2 .9 7.2 6.6 13 13.9 13.9.7.1 1.3.1 2 .1zm110-.1c.6.1 1.3.1 2 .1h48c8.2 0 14.9-6.1 15.9-14 .1-.7.1-1.3.1-2v-16c0-22.1-17.9-40-40-40-9.2 0-17.6 3.1-24.3 8.3-2.9 2.2-5.5 4.8-7.7 7.7-5 6.7-8 15-8 24v16c0 .7 0 1.3.1 2 .9 7.2 6.6 13 13.9 13.9zM416.1 302c-.1.7-.1 1.3-.1 2v8c0 10.9 4.4 20.8 11.4 28 7.3 7.4 17.4 12 28.6 12 22.1 0 40-17.9 40-40v-8c0-.7 0-1.3-.1-2-1-7.9-7.7-14-15.9-14h-48c-.7 0-1.3 0-2 .1-7.3.9-13 6.6-13.9 13.9zM146 288.1c-.7-.1-1.3-.1-2-.1H96c-8.2 0-14.9 6.1-15.9 14-.1.7-.1 1.3-.1 2v8c0 22.1 17.9 40 40 40 11.2 0 21.3-4.6 28.6-12 7.1-7.2 11.4-17.1 11.4-28v-8c0-.7 0-1.3-.1-2-.9-7.2-6.6-13-13.9-13.9zm13.9-46.1c.1-.7.1-1.3.1-2v-16c0-9-3-17.3-8-24-2.2-2.9-4.8-5.5-7.7-7.7-6.7-5.2-15.2-8.3-24.3-8.3-22.1 0-40 17.9-40 40v16c0 .7 0 1.3.1 2 1 7.9 7.7 14 15.9 14h48c.7 0 1.3 0 2-.1 7.2-.9 13-6.6 13.9-13.9z"
        }
    ]
};

const FarTelescope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTelescope",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m459.7 231.7 61.5-35.5-80-138.6-61.5 35.5 80 138.6zM328.4 99.6c-6.2-14.6-.6-31.9 13.5-40.1L431.1 8c15.3-8.8 34.9-3.6 43.7 11.7l96 166.3c8.8 15.3 3.6 34.9-11.7 43.7l-89.2 51.5c-15.3 8.8-34.9 3.6-43.7-11.7l-.5-.8-42.6 23.1c.6 4 .9 8.1.9 12.3 0 20.1-7.4 38.5-19.7 52.5L414.2 479c5 12.3-.9 26.3-13.2 31.3s-26.3-.9-31.3-13.2l-47-115.3c-6 1.5-12.3 2.2-18.8 2.2s-12.8-.8-18.8-2.2l-47 115.3c-5 12.3-19 18.2-31.3 13.2s-18.2-19-13.2-31.3l44.3-108.8-88.4 47.8c-15.2 8.2-34.3 2.9-42.9-12.1l-.7-1.3-44.2 25.5c-11.5 6.6-26.2 2.7-32.8-8.8L3.1 376.4c-6.6-11.5-2.7-26.2 8.8-32.8L56 318.1l-4-6.7c-8.6-14.9-3.9-33.8 10.6-43L328.4 99.6zm73.3 127.5-49.5-85.7-250.9 159.3 39.1 67.7 85.6-46.3c-1.3-5.8-2-11.9-2-18.1 0-44.2 35.8-80 80-80 22.7 0 43.2 9.5 57.8 24.7l39.9-21.6zM304 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarTemperatureArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48c-35.3 0-64 28.7-64 64v161.9c0 14.5-5.7 27.1-12.8 36.6C87.1 326.5 80 346.4 80 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM64 112C64 50.1 114.1 0 176 0s112 50.1 112 112v161.9c0 1.7.7 4.4 3.2 7.8 18.1 24.1 28.8 54 28.8 86.4 0 79.5-64.5 144-144 144S32 447.5 32 368c0-32.4 10.7-62.3 28.8-86.4 2.5-3.4 3.2-6.1 3.2-7.8V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3zm224 112c-6.8 0-13.3-2.9-17.8-7.9l-72-80c-8.9-9.9-8.1-25 1.8-33.9s25-8.1 33.9 1.8l30.1 33.5V56c0-13.3 10.7-24 24-24s24 10.7 24 24v337.5l30.2-33.5c8.9-9.9 24-10.7 33.9-1.8s10.7 24 1.8 33.9l-72 80c-4.6 5.1-11 7.9-17.8 7.9z"
        }
    ]
};

const FarTemperatureArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48c-35.3 0-64 28.7-64 64v161.9c0 14.5-5.7 27.1-12.8 36.6C87.1 326.5 80 346.4 80 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM64 112C64 50.1 114.1 0 176 0s112 50.1 112 112v161.9c0 1.7.7 4.4 3.2 7.8 18.1 24.1 28.8 54 28.8 86.4 0 79.5-64.5 144-144 144S32 447.5 32 368c0-32.4 10.7-62.3 28.8-86.4 2.5-3.4 3.2-6.1 3.2-7.8V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16v210.7c18.6 6.6 32 24.4 32 45.3zM448 32c6.8 0 13.3 2.9 17.8 7.9l72 80c8.9 9.9 8.1 25-1.8 33.9s-25 8.1-33.9-1.8L472 118.5V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V118.5L393.8 152c-8.9 9.9-24 10.7-33.9 1.8s-10.7-24-1.8-33.9l72-80c4.6-5.1 11-7.9 17.8-7.9z"
        }
    ]
};

const FarTemperatureEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureEmpty",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-35.3 28.7-64 64-64s64 28.7 64 64v161.9c0 14.5 5.7 27.1 12.8 36.6 12 16 19.2 35.9 19.2 57.5 0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C90.3 301 96 288.4 96 273.9V112zM160 0C98.1 0 48 50.2 48 112v161.9c0 1.7-.7 4.4-3.2 7.8-18.1 24-28.8 54-28.8 86.3 0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4-2.5-3.4-3.2-6.1-3.2-7.8V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarTemperatureFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureFull",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48c-35.3 0-64 28.7-64 64v161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v161.9c0 1.7.7 4.4 3.2 7.8 18.1 24.1 28.8 54 28.8 86.4 0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4 2.5-3.4 3.2-6.1 3.2-7.8V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16v210.7c18.6 6.6 32 24.4 32 45.3z"
        }
    ]
};

const FarTemperatureHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureHalf",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48c-35.3 0-64 28.7-64 64v161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v161.9c0 1.7.7 4.4 3.2 7.8 18.1 24.1 28.8 54 28.8 86.4 0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4 2.5-3.4 3.2-6.1 3.2-7.8V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V200c0-8.8 7.2-16 16-16s16 7.2 16 16v122.7c18.6 6.6 32 24.4 32 45.3z"
        }
    ]
};

const FarTemperatureHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureHigh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM80 112c0-35.3 28.7-64 64-64s64 28.7 64 64v161.9c0 14.5 5.7 27.1 12.8 36.6 12 16 19.2 35.9 19.2 57.5 0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9V112zM144 0C82.1 0 32 50.2 32 112v161.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4-2.5-3.4-3.2-6.1-3.2-7.8V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48z"
        }
    ]
};

const FarTemperatureList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 112c0-35.3 28.7-64 64-64s64 28.7 64 64v161.9c0 14.5 5.7 27.1 12.8 36.6 12 16 19.2 35.9 19.2 57.5 0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9V112zM144 0C82.1 0 32 50.2 32 112v161.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4-2.5-3.4-3.2-6.1-3.2-7.8V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v146.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48zM344 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zm32 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"
        }
    ]
};

const FarTemperatureLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM80 112c0-35.3 28.7-64 64-64s64 28.7 64 64v161.9c0 14.5 5.7 27.1 12.8 36.6 12 16 19.2 35.9 19.2 57.5 0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9V112zM144 0C82.1 0 32 50.2 32 112v161.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4-2.5-3.4-3.2-6.1-3.2-7.8V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48z"
        }
    ]
};

const FarTemperatureQuarter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureQuarter",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48c-35.3 0-64 28.7-64 64v161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v161.9c0 1.7.7 4.4 3.2 7.8 18.1 24.1 28.8 54 28.8 86.4 0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4 2.5-3.4 3.2-6.1 3.2-7.8V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
        }
    ]
};

const FarTemperatureSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureSnow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 112c0-35.3 28.7-64 64-64s64 28.7 64 64v161.9c0 14.5 5.7 27.1 12.8 36.6 12 16 19.2 35.9 19.2 57.5 0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5 7.1-9.5 12.8-22.1 12.8-36.6V112zM432 0c-61.9 0-112 50.1-112 112v161.9c0 1.7-.7 4.4-3.2 7.8-18.1 24.1-28.8 54-28.8 86.4 0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4-2.5-3.4-3.2-6.1-3.2-7.8V112C544 50.1 493.9 0 432 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48zM288 131.6l-88 50.8v-55.8l35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v25.4l-12.7-12.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l35.3 35.3v55.8l-48.3-27.9-13-48.2c-2.2-8.6-11-13.6-19.5-11.3s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7c-11.5-6.6-26.2-2.7-32.8 8.8s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6S23 211.3 31.5 209l48.2-12.9L128 224l-48.3 27.9L31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2 48.3-27.9v55.8l-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l12.7-12.7V392c0 13.3 10.7 24 24 24s24-10.7 24-24v-25.4l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4v-55.8l67.7 39.1c5.2-13.5 12-26.2 20.3-37.9V261l-64-37 64-37v-55.4z"
        }
    ]
};

const FarTemperatureSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m320.6 98.5-2.7-.5-14.1-84.6c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1l-84.7 14.1c-5.4.9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l70.8-49.6 70.8 49.6c4.5 3.2 10.3 3.8 15.4 1.6.7-.3 1.5-.7 2.1-1.1-5.4-16.9-8.3-34.9-8.3-53.7 0-37.7 11.8-72.6 32-101.2V112c0-4.5.2-9 .6-13.5zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm192 0c0-35.3 28.7-64 64-64s64 28.7 64 64v161.9c0 14.5 5.7 27.1 12.8 36.6 12 16 19.2 35.9 19.2 57.5 0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5 7.1-9.5 12.8-22.1 12.8-36.6V112zM464 0c-61.9 0-112 50.2-112 112v161.9c0 1.7-.7 4.4-3.2 7.8-18.1 24.1-28.8 54-28.8 86.4 0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4-2.5-3.4-3.2-6.1-3.2-7.8V112C576 50.2 525.9 0 464 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48z"
        }
    ]
};

const FarTemperatureThreeQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTemperatureThreeQuarters",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48c-35.3 0-64 28.7-64 64v161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v161.9c0 1.7.7 4.4 3.2 7.8 18.1 24.1 28.8 54 28.8 86.4 0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4 2.5-3.4 3.2-6.1 3.2-7.8V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V152c0-8.8 7.2-16 16-16s16 7.2 16 16v170.7c18.6 6.6 32 24.4 32 45.3z"
        }
    ]
};

const FarTengeSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTengeSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 80 0 69.3 0 56zm0 128c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v248c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H24c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarTennisBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTennisBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 463.8c0-55.2 21.1-110.4 63.3-152.6s97.4-63.2 152.6-63.3C459.7 139.5 372.5 52.3 264 48.2c0 55.2-21.1 110.4-63.3 152.6S103.4 264 48.2 264c4.1 108.5 91.3 195.7 199.8 199.8zm48-3.7C378.8 444 444 378.8 460.2 296c-41.7 1-83.1 17.3-114.9 49.2s-48.3 73.2-49.3 115zM51.9 216c41.7-1 83.1-17.3 114.9-49.2S215 93.6 216 51.9C133.2 68 68 133.2 51.9 216zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FarTentArrowDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTentArrowDownToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24v122.1l39.9-36c9.9-8.9 25-8.1 33.9 1.8zM369.3 133c8.6-6.7 20.7-6.7 29.4 0l166.5 128.7c10.7 8.3 18 20.1 20.7 33.3l33.9 169.3C631.2 466.1 640 476 640 488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h124.3l33.8-169c2.6-13.2 10-25.1 20.7-33.3L369.3 133zm-172 331H360V200.9l-127.9 98.8c-1.5 1.2-2.6 2.9-3 4.8L197.3 464zm274.7 0h98.7l-31.9-159.6c-.4-1.9-1.4-3.6-3-4.8L408 200.9V336l64 128z"
        }
    ]
};

const FarTentArrowLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTentArrowLeftRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72h-403L120 41.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.6-33.9-1.7l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120h402.9l-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8S573 82.8 568 78.3l-80-72zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1c-4.9 33.7 21.3 63.9 55.4 63.9h326.2c34.1 0 60.3-30.2 55.4-63.9l-16.9-118.6c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2V464H124.9c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29V232.9L439 331c1.6 1.3 2.7 3.1 3 5.2l17 118.7c.7 4.8-3.1 9.1-7.9 9.1h-76.7L312 360z"
        }
    ]
};

const FarTentArrowTurnLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTentArrowTurnLeft",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9s-24.1-10.6-34-1.7l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120H456c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40c0-66.3-53.7-120-120-120H86.5L120 41.8zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1c-4.9 33.7 21.3 63.9 55.4 63.9h326.2c34.1 0 60.3-30.2 55.4-63.9l-16.9-118.6c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2V464H124.9c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29V232.9L439 331c1.6 1.3 2.7 3.1 3 5.2l17 118.7c.7 4.8-3.1 9.1-7.9 9.1h-76.7L312 360z"
        }
    ]
};

const FarTentArrowsDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTentArrowsDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24S88 10.7 88 24v122.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v122.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1c-4.9 33.7 21.3 63.9 55.4 63.9h326.2c34.1 0 60.3-30.2 55.4-63.9l-16.9-118.6c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2V464H124.9c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29V232.9L439 331c1.6 1.3 2.7 3.1 3 5.2l17 118.7c.7 4.8-3.1 9.1-7.9 9.1h-76.7L312 360z"
        }
    ]
};

const FarTent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTent",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M274.4 4.2c8.2-5.7 19-5.7 27.3 0l219.8 151.7c13.5 9.3 22.2 24 23.9 40.2l26.7 254c3.5 33.1-22.4 61.9-55.7 61.9H59.5c-33.2 0-59.1-28.8-55.6-61.9l26.7-254c1.7-16.3 10.4-31 23.9-40.2L274.4 4.2zM516.5 464c4.7 0 8.5-4.1 8-8.8l-26.7-254c-.2-2.3-1.5-4.4-3.4-5.7L312 69.7v209.6L413.6 464h102.9zM264 69.7 81.7 195.4c-1.9 1.3-3.2 3.4-3.4 5.7l-26.7 254c-.5 4.7 3.2 8.8 8 8.8H264V69.6z"
        }
    ]
};

const FarTents = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTents",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M430.1 4.6c-8.4-6.1-19.8-6.1-28.2 0l-165 120c-1.7 1.2-3.3 2.6-4.8 4 10.9 1.4 21.5 5.6 30.7 12.6l16.1 12.3L416 53.7l150.8 109.7c1.8 1.3 2.9 3.2 3.2 5.4l17.2 126.1c.7 4.8-3.1 9.1-7.9 9.1H454c.6 2.1 1 4.3 1.3 6.5l6.2 41.5h117.8c33.9 0 60.1-29.9 55.5-63.6l-17.2-126.1c-2.1-15.1-10.2-28.7-22.6-37.7L430 4.6zM238.7 165c-8.6-6.7-20.7-6.7-29.3 0L43.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L5.5 448.1C.6 481.8 26.8 512 60.9 512h326.2c34.1 0 60.3-30.2 55.4-63.9l-16.9-118.6c-2.1-14.4-9.7-27.5-21.2-36.4L238.7 165zM73 331l127-98.2V464H60.9c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.7c.3-2.1 1.4-3.9 3-5.2zm175 29V232.9L375 331c1.6 1.3 2.7 3.1 3 5.2l17 118.7c.7 4.8-3.1 9.1-7.9 9.1h-76.7L248 360z"
        }
    ]
};

const FarTerminal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTerminal",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M6.3 72.2c-9-9.8-8.3-24.9 1.4-33.9s24.9-8.3 33.9 1.4l184 200c8.5 9.2 8.5 23.3 0 32.5l-184 200c-9 9.8-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9L175.4 256 6.3 72.2zM248 432h304c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarTextHeight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTextHeight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 128V80h88v352H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48V80h88v48c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v56c0 13.3 10.7 24 24 24s24-10.7 24-24zm449-89c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23v284.2l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V113.9l23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64z"
        }
    ]
};

const FarTextSize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTextSize",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 128V80h120v352h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48V80h120v48c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v56c0 13.3 10.7 24 24 24s24-10.7 24-24zm312 168v-24h96v160h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V272h88v24c0 13.3 10.7 24 24 24s24-10.7 24-24v-32c0-22.1-17.9-40-40-40H352c-22.1 0-40 17.9-40 40v32c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarTextSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTextSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-281.9-221L396.4 80h124.9l-8.5 34.2c-3.2 12.9 4.6 25.9 17.5 29.1s25.9-4.6 29.1-17.5l11-44.1c6.2-25.2-12.9-49.7-38.9-49.7h-335c-18.4 0-34.4 12.5-38.8 30.3l-7.5 30.1L38.8 5.1zm152.7 119.7L202.7 80h143.8l-38.4 136.2-116.6-91.4zm57.4 300.7-1.8 6.5H192c-13.3 0-24 10.7-24 24s10.7 24 24 24h160c13.3 0 24-10.7 24-24s-10.7-24-24-24h-55.1l23.6-83.5-40.8-32.1-30.8 109.1z"
        }
    ]
};

const FarTextWidth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTextWidth",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 112V80h152v160h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V80h152v32c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24zm393 289c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23H81.9l23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 367c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23H366l-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64z"
        }
    ]
};

const FarText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarText",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 80v48c0 13.3-10.7 24-24 24S0 141.3 0 128V72c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H248v352h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V80H48z"
        }
    ]
};

const FarThermometer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarThermometer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M369.8 64.2c10.3-10.4 24.4-16.2 39-16.2 30.5 0 55.2 24.7 55.2 55.2 0 14.6-5.8 28.7-16.2 39L224.4 365.7c-1.5 1.5-3.5 2.3-5.7 2.3H144v-74.7c0-2.1.8-4.2 2.3-5.7l27.3-27.3 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 41.4-41.4 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 41.4-41.4 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 45.5-45.5zM96 293.3v88.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l89-89h88.8c14.9 0 29.1-5.9 39.6-16.4l223.5-223.3c19.4-19.4 30.2-45.6 30.2-73C512 46.2 465.8 0 408.8 0c-27.4 0-53.6 10.9-73 30.2L112.4 253.7A55.924 55.924 0 0 0 96 293.3z"
        }
    ]
};

const FarTheta = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTheta",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 256c0-55 16.6-103.9 42.1-138.4S157.2 64 192 64s68.3 19 93.9 53.6S328 201 328 256s-16.6 103.9-42.1 138.5S226.8 448 192 448s-68.3-19-93.9-53.5S56 311 56 256zM192 16C138.4 16 91.9 45.4 59.6 89S8 191.7 8 256s19.3 123.4 51.6 167 78.9 73 132.4 73 100.1-29.4 132.4-73S376 320.3 376 256s-19.3-123.4-51.6-167S245.6 16 192 16zm-72 216c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"
        }
    ]
};

const FarThoughtBubble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarThoughtBubble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-48.7 0-91.4 25.6-115.4 64C62.6 65.9 0 129.6 0 208c0 79.5 64.5 144 144 144 9.4 0 18.7-.9 27.6-2.7 21.7 21.4 51.5 34.7 84.4 34.7s62.7-13.3 84.4-34.7c9 1.7 18.2 2.7 27.6 2.7 79.5 0 144-64.5 144-144 0-78.4-62.6-142.1-140.6-144-24-38.4-66.7-64-115.4-64zm-79.7 98.7C190.4 68.7 220.8 48 256 48s65.6 20.7 79.7 50.7c4.3 9.1 13.8 14.6 23.8 13.7 2.8-.2 5.6-.4 8.5-.4 53 0 96 43 96 96s-43 96-96 96c-10 0-19.7-1.5-28.7-4.4-9.6-3-20 .3-26.2 8.3C299.9 325 279.2 336 256 336s-43.9-11-57.1-28.1c-6.1-8-16.6-11.3-26.2-8.3-9 2.8-18.7 4.4-28.7 4.4-53 0-96-43-96-96s43-96 96-96c2.9 0 5.7.1 8.5.4 10 .9 19.5-4.6 23.8-13.7zM192 432a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM64 480a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarThumbsDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarThumbsDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13H448c8.8 0 16-7.2 16-16 0-6.8-4.3-12.7-10.4-15-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6 0-7.8-5.6-14.3-13-15.7-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9 0-6.7-4.2-12.6-10.2-14.9-11.5-4.5-17.7-16.9-14.4-28.8.4-1.3.6-2.8.6-4.3 0-8.8-7.2-16-16-16h-97.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62 14.6 11.7 24 29.7 24 50 0 4.5-.5 8.8-1.3 13 15.4 11.7 25.3 30.2 25.3 51 0 6.5-1 12.8-2.8 18.7 11.6 11.8 18.8 27.8 18.8 45.5 0 35.3-28.6 64-64 64h-92.3c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H32z"
        }
    ]
};

const FarThumbsUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarThumbsUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13H448c8.8 0 16 7.2 16 16 0 6.8-4.3 12.7-10.4 15-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6 0 7.8-5.6 14.3-13 15.7-8.2 1.6-15.1 7.3-18 15.1s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9 0 6.7-4.2 12.6-10.2 14.9-11.5 4.5-17.7 16.9-14.4 28.8.4 1.3.6 2.8.6 4.3 0 8.8-7.2 16-16 16h-97.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62 14.6-11.7 24-29.7 24-50 0-4.5-.5-8.8-1.3-13 15.4-11.7 25.3-30.2 25.3-51 0-6.5-1-12.8-2.8-18.7 11.6-11.7 18.8-27.7 18.8-45.4 0-35.3-28.6-64-64-64h-92.3c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z"
        }
    ]
};

const FarThumbtack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarThumbtack",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m134.6 51.7-10.8 140.9c-1.1 14.6-8.8 27.8-20.9 36-23.9 16.2-41.8 40.8-49.1 70.3l-1.3 5.1H168v-88c0-13.3 10.7-24 24-24s24 10.7 24 24v88h115.5l-1.3-5.1c-7.4-29.5-25.2-54.1-49.1-70.2-12.1-8.2-19.8-21.5-20.9-36l-10.8-141c-.1-1.2-.1-2.5-.1-3.7H134.8c0 1.2 0 2.5-.1 3.7zM168 352H32c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L83.1 96l3.7-48H56c-4.4 0-8.6-1.2-12.2-3.3C36.8 40.5 32 32.8 32 24 32 10.7 42.7 0 56 0h272c13.3 0 24 10.7 24 24 0 8.8-4.8 16.5-11.8 20.7-3.6 2.1-7.7 3.3-12.2 3.3h-30.8l3.7 48 7.1 92.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6.2 19.7-5.8 27.5S361.7 352 351.9 352H216v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V352z"
        }
    ]
};

const FarTick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTick",
    "viewBox": "0 0 128 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 104c0-13.3 10.7-24 24-24s24 10.7 24 24v1.9c0 1.4-.1 2.8-.4 4.3L64 252 40.4 110.1c-.2-1.4-.4-2.8-.4-4.3V104zm95 14c.7-4 1-8.1 1-12.1V104c0-39.8-32.2-72-72-72S-8 64.2-8 104v1.9c0 4.1.3 8.1 1 12.1l24.4 146.5C21.2 287.3 40.9 304 64 304s42.8-16.7 46.6-39.5L135 118z"
        }
    ]
};

const FarTicketAirline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTicketAirline",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h512c8.8 0 16-7.2 16-16v-35c-41.4-10.7-72-48.2-72-93s30.6-82.3 72-93v-35c0-8.8-7.2-16-16-16H64zM0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v61.3c0 11.2-12.8 18.7-24 18.7-26.5 0-48 21.5-48 48s21.5 48 48 48c11.2 0 24 7.5 24 18.7V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm432 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM186.7 224l-23.2-69.5c-1.7-5.2 2.1-10.5 7.6-10.5h31.1c8.5 0 16.4 4.5 20.7 11.9l39.8 68.1H303c16.1 0 31.5 6.4 42.8 17.7 7.9 7.9 7.9 20.7 0 28.5-11.4 11.4-26.8 17.8-42.9 17.8h-40.2L223 356.1a23.93 23.93 0 0 1-20.7 11.9h-31.2c-5.5 0-9.3-5.4-7.6-10.5l23.2-69.5H144l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H98.2c-5.2 0-9-4.9-7.8-9.9l12.6-50.2c.6-2.5.6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9H112c5 0 9.8 2.4 12.8 6.4L144 224h42.7z"
        }
    ]
};

const FarTicketSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTicketSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v60.1c0 10.2-6.4 19.2-16 22.6-18.7 6.6-32 24.4-32 45.3s13.3 38.7 32 45.3c9.6 3.4 16 12.5 16 22.6V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-60.1c0-10.2 6.4-19.2 16-22.6 18.7-6.6 32-24.4 32-45.3s-13.3-38.7-32-45.3c-9.6-3.4-16-12.5-16-22.6V128zm64-16c-8.8 0-16 7.2-16 16v44.9c28.7 16.6 48 47.6 48 83.1s-19.3 66.6-48 83.1V384c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16v-44.9c-28.7-16.6-48-47.6-48-83.1s19.3-66.6 48-83.1V128c0-8.8-7.2-16-16-16H64z"
        }
    ]
};

const FarTicket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTicket",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v60.1c0 10.2 6.4 19.2 16 22.6 18.7 6.6 32 24.4 32 45.3s-13.3 38.7-32 45.3c-9.6 3.4-16 12.5-16 22.6V384c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-60.1c0-10.2-6.4-19.2-16-22.6-18.7-6.6-32-24.4-32-45.3s13.3-38.7 32-45.3c9.6-3.4 16-12.5 16-22.6V128c0-35.3-28.7-64-64-64H64zm-16 64c0-8.8 7.2-16 16-16h448c8.8 0 16 7.2 16 16v44.9c-28.7 16.6-48 47.6-48 83.1s19.3 66.6 48 83.1V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-44.9c28.7-16.6 48-47.6 48-83.1s-19.3-66.6-48-83.1V128zm352 176H176v-96h224v96zM128 192v128c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FarTicketsAirline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTicketsAirline",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 96v224c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-38.2c-24-15.7-40-42.8-40-73.8s16-58.1 40-73.8V96c0-8.8-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zm16-64h416c35.3 0 64 28.7 64 64v56c0 8.8-7.4 15.7-15.6 19.1-14.3 6.1-24.4 20.3-24.4 36.9s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1v56c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zm320 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM24 96c13.3 0 24 10.7 24 24v240c0 39.8 32.2 72 72 72h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H120C53.7 480 0 426.3 0 360V120c0-13.3 10.7-24 24-24zm264.4 80-23.2-69.5c-1.7-5.2 2.1-10.5 7.6-10.5H304c8.5 0 16.4 4.5 20.7 11.9l39.7 68.1h40.3c16.1 0 31.5 6.4 42.8 17.7 7.9 7.9 7.9 20.7 0 28.5-11.4 11.4-26.8 17.7-42.8 17.7h-40.3L324.7 308a23.93 23.93 0 0 1-20.7 11.9h-31.1c-5.5 0-9.3-5.3-7.6-10.5l23.1-69.4h-42.6l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H200c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5.6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9h13.8c5 0 9.8 2.4 12.8 6.4l19.2 25.6h42.7z"
        }
    ]
};

const FarTilde = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTilde",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M100.5 176c-29 0-52.5 23.5-52.5 52.5V320c0 13.3-10.7 24-24 24S0 333.3 0 320v-91.5C0 173 45 128 100.5 128c29.6 0 57.6 13 76.7 35.6l130.2 153.8c10 11.8 24.6 18.6 40.1 18.6 29 0 52.5-23.5 52.5-52.5V192c0-13.3 10.7-24 24-24s24 10.7 24 24v91.5C448 339 403 384 347.5 384c-29.6 0-57.6-13-76.7-35.6L140.6 194.6c-10-11.8-24.6-18.6-40.1-18.6z"
        }
    ]
};

const FarTimelineArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTimelineArrow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm48 0c0 35.8-23.5 66.1-56 76.3V232h176v-59.7c-32.5-10.2-56-40.5-56-76.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V232h178.6l-58.9-54.4c-9.7-9-10.3-24.2-1.4-33.9s24.2-10.3 33.9-1.4l103.9 95.9.4.4.9.9c4 4.3 6.5 10.1 6.5 16.4s-2.5 12.1-6.5 16.4l-.9.9-.4.4-103.8 96c-9.7 9-24.9 8.4-33.9-1.4s-8.4-24.9 1.4-33.9l58.8-54.3H248v59.7c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h80v-59.7C71.5 162.1 48 131.8 48 96c0-44.2 35.8-80 80-80s80 35.8 80 80zm-16 320a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm160-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarTimeline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTimeline",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24 108.3c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S48 51.8 48 96c0 35.8 23.5 66.1 56 76.3V232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h272v59.7c-32.5 10.2-56 40.5-56 76.3 0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3V280h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80v-59.7c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 35.8 23.5 66.1 56 76.3V232H152v-59.7zM320 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM480 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FarTimer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTimer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V49.4C383.6 61.3 464 149.2 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256c0-43.3 13.2-83.5 35.8-116.8 7.5-11 4.6-25.9-6.4-33.3s-25.9-4.6-33.3 6.4C16.3 153.2 0 202.7 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zm-63 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80z"
        }
    ]
};

const FarTireFlat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTireFlat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 288c0-114.9-93.1-208-208-208S48 173.1 48 288c0 31 6.8 60.3 18.8 86.7 6.9 15.1 7 33-.8 48.5l-17.6 35.3c-.3.5-.4 1.1-.4 1.7 0 2.1 1.7 3.8 3.8 3.8h408.4c2.1 0 3.8-1.7 3.8-3.8 0-.6-.1-1.2-.4-1.7l-17.7-35.3c-7.8-15.6-7.7-33.4-.8-48.5C457.2 348.3 464 319 464 288zm48 0c0 38.1-8.3 74.2-23.2 106.7-1 2.2-1 4.8.1 7l17.7 35.3c3.6 7.2 5.5 15.1 5.5 23.2 0 28.6-23.2 51.8-51.8 51.8H51.8C23.2 512 0 488.8 0 460.2c0-8 1.9-16 5.5-23.2l17.7-35.3c1.1-2.2 1.1-4.8.1-7C8.3 362.2 0 326.1 0 288 0 146.6 114.6 32 256 32s256 114.6 256 256zm-136 0c0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5v.9l39.2 12.8c.5-4.5.8-9 .8-13.6zm-54.9 46.5c-10 14-24.4 24.6-41.2 29.9v41.3c34.4-7 63.5-28.7 80.4-58.3L321 334.6zM232 364.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3v-41.3zM136 288c0 4.6.3 9.2.8 13.6l39.2-12.7v-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 228.4 136 256.8 136 288zm120-80c8.9 0 17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8l22.6 31.2 1.6 2.2c8-2.7 16.6-4.2 25.6-4.2zM88 288a168 168 0 1 1 336 0 168 168 0 1 1-336 0zm200 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarTirePressureWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTirePressureWarning",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M424 0c-13.3 0-24 10.7-24 24v30.5c0 30.1 4.9 60 14.4 88.5l2.5 7.4c6.1 18.4 14.4 35.6 22.2 51.5 15 30.5 26.3 66.3 22 105.3-4 36.7-22.3 79.2-70.5 124.8H121.4C73.2 386.4 55 343.9 50.9 307.2c-4.3-39 7-74.8 22-105.3 7.8-15.8 16.1-33 22.2-51.5l2.5-7.4c9.5-28.6 14.4-58.4 14.4-88.5V24c0-13.3-10.7-24-24-24S64 10.7 64 24v30.5c0 24.9-4 49.7-11.9 73.4l-2.5 7.4c-5 15-11.9 29.6-19.7 45.4-17.2 34.8-32.4 80.2-26.7 131.7 5.5 49.7 30 102.1 84.8 154.1V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16h48v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16h48v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16h48v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-29.5c54.8-51.9 79.3-104.3 84.8-154.1 5.7-51.5-9.5-96.9-26.7-131.8-7.8-15.8-14.7-30.4-19.7-45.4l-2.5-7.4C452 104.2 448 79.4 448 54.5V24c0-13.3-10.7-24-24-24zM256 96c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarTireRugged = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTireRugged",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M213.1 62c1-8 7.8-14 15.9-14h54.1c8.1 0 14.9 6 15.9 14 1.2 9.1 7.4 16.8 16.1 19.7 7.7 2.6 15.2 5.7 22.4 9.3 8.2 4.1 18.1 3.1 25.3-2.5 6.3-4.9 15.4-4.4 21.1 1.3l38.3 38.3c5.7 5.7 6.3 14.8 1.3 21.1-5.6 7.3-6.6 17.1-2.5 25.3 3.6 7.2 6.7 14.7 9.3 22.4 2.9 8.7 10.6 15 19.7 16.1 8 1 14 7.8 14 15.9V283c0 8.1-6 14.9-14 15.9-9.1 1.2-16.8 7.4-19.7 16.1-2.6 7.7-5.7 15.2-9.3 22.4-4.1 8.2-3.1 18.1 2.5 25.3 4.9 6.3 4.4 15.4-1.3 21.1l-38.3 38.3c-5.7 5.7-14.8 6.3-21.1 1.3-7.3-5.6-17.1-6.6-25.3-2.5-7.2 3.6-14.7 6.7-22.4 9.3-8.7 2.9-15 10.6-16.1 19.7-1 8-7.8 14-15.9 14h-54.2c-8.1 0-14.9-6-15.9-14-1.2-9.1-7.4-16.8-16.1-19.7-7.7-2.6-15.2-5.7-22.4-9.3-8.2-4.1-18.1-3.1-25.3 2.5-6.3 4.9-15.4 4.4-21.1-1.3l-38.3-38.2c-5.7-5.7-6.3-14.8-1.3-21.1 5.6-7.3 6.6-17.1 2.5-25.3-3.6-7.2-6.7-14.7-9.3-22.4-2.9-8.7-10.6-15-19.7-16.1-8-1-14-7.8-14-15.9v-54.2c0-8.1 6-14.9 14-15.9 9.1-1.2 16.8-7.4 19.7-16.1 2.6-7.7 5.7-15.2 9.3-22.4 4.1-8.2 3.1-18.1-2.5-25.3-4.9-6.3-4.4-15.4 1.3-21.1l38.3-38.3c5.7-5.7 14.8-6.3 21.1-1.3 7.3 5.6 17.1 6.6 25.3 2.5 7.2-3.6 14.7-6.7 22.4-9.3 8.7-2.9 15-10.6 16.1-19.7zm15.8-62c-26.9 0-50.3 16.7-59.6 40.8-1.4.6-2.8 1.1-4.2 1.7-23.6-10.4-51.9-5.7-71 13.4L55.8 94.1c-19 19-23.7 47.4-13.4 71-.6 1.4-1.2 2.8-1.7 4.2C16.7 178.6 0 202 0 228.9V283c0 26.9 16.7 50.3 40.8 59.6.6 1.4 1.1 2.8 1.7 4.2-10.4 23.6-5.7 51.9 13.4 71l38.3 38.3c19 19 47.4 23.7 71 13.4 1.4.6 2.8 1.2 4.2 1.7 9.4 24 32.7 40.8 59.6 40.8h54.1c26.9 0 50.3-16.7 59.6-40.8 1.4-.6 2.8-1.1 4.2-1.7 23.6 10.4 51.9 5.7 71-13.4l38.3-38.3c19-19 23.7-47.4 13.4-71 .6-1.4 1.2-2.8 1.7-4.2 24-9.4 40.8-32.7 40.8-59.6v-54.1c0-26.9-16.7-50.3-40.8-59.6-.6-1.4-1.1-2.8-1.7-4.2 10.4-23.6 5.7-51.9-13.4-71l-38.3-38.3c-19-19-47.4-23.7-71-13.4-1.4-.6-2.8-1.2-4.2-1.7C333.4 16.7 310 0 283.1 0h-54.2zM384 256a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-152-72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-67.3 42.3a24 24 0 1 1 45.7 14.8 24 24 0 1 1-45.7-14.8zm152.4-15.4a24 24 0 1 1 14.8 45.7 24 24 0 1 1-14.8-45.7zm-4.6 122.7a24 24 0 1 1-28.2-38.8 24 24 0 1 1 28.2 38.8zm-79.3-5.3a24 24 0 1 1-38.8-28.2 24 24 0 1 1 38.8 28.2z"
        }
    ]
};

const FarTire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTire",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm336 .9 39.2 12.8c.5-4.5.8-9 .8-13.6 0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5v.9zm-14.9 45.6c-10 14-24.4 24.6-41.2 29.9v41.3c34.4-7 63.5-28.7 80.4-58.3L321 302.6zM232 373.6v-41.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3zm-95.2-104 39.2-12.7v-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 196.4 136 224.8 136 256c0 4.6.3 9.2.8 13.6zm93.6-89.5c8-2.7 16.6-4.2 25.6-4.2s17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8l22.6 31.3 1.6 2.2zM288 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM256 88a168 168 0 1 1 0 336 168 168 0 1 1 0-336z"
        }
    ]
};

const FarToggleLargeOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToggleLargeOff",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 400a144 144 0 1 1 0-288 144 144 0 1 1 0 288zm0 48h192c106 0 192-86 192-192S490 64 384 64H192C86 64 0 150 0 256s86 192 192 192zm127-48c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144h65c79.5 0 144 64.5 144 144s-64.5 144-144 144h-65z"
        }
    ]
};

const FarToggleLargeOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToggleLargeOn",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64H192zm192 48a144 144 0 1 1 0 288 144 144 0 1 1 0-288z"
        }
    ]
};

const FarToggleOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToggleOff",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 112c79.5 0 144 64.5 144 144s-64.5 144-144 144H192c-79.5 0-144-64.5-144-144s64.5-144 144-144h192zm192 144c0-106-86-192-192-192H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192zm-384 96a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
        }
    ]
};

const FarToggleOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToggleOn",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 112c-79.5 0-144 64.5-144 144s64.5 144 144 144h192c79.5 0 144-64.5 144-144s-64.5-144-144-144H192zM0 256C0 150 86 64 192 64h192c106 0 192 86 192 192s-86 192-192 192H192C86 448 0 362 0 256zm384-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FarToiletPaperBlankUnder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToiletPaperBlankUnder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M71 84.3C85.4 56.9 101.1 48 112 48h212.7c-3 4.5-5.7 9.3-8.2 14.1-18 34.5-28.5 80.4-28.5 129.9s10.5 95.4 28.5 129.9c2.5 4.8 5.3 9.5 8.2 14.1H112c-10.9 0-26.6-8.9-41-36.3-13.8-26.4-23-64.4-23-107.7s9.2-81.3 23-107.7zM400 48c10.9 0 26.6 8.9 41 36.3 13.8 26.3 23 64.3 23 107.7s-9.2 81.3-23 107.7c-14.4 27.5-30.1 36.3-41 36.3s-26.6-8.9-41-36.3c-13.8-26.3-23-64.3-23-107.7s9.2-81.3 23-107.7C373.4 56.9 389.1 48 400 48zm64 303.1V456c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8v-40h-48v40c0 30.9 25.1 56 56 56h240c30.9 0 56-25.1 56-56V192c0-49.5-10.5-95.4-28.5-129.9C466 28.7 437.7 0 400 0H112C74.3 0 46 28.7 28.5 62.1 10.5 96.6 0 142.5 0 192s10.5 95.4 28.5 129.9C46 355.3 74.3 384 112 384h288c25.9 0 47.4-13.6 64-32.9zM424 192c0-26.5-10.7-48-24-48s-24 21.5-24 48 10.7 48 24 48 24-21.5 24-48z"
        }
    ]
};

const FarToiletPaperBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToiletPaperBlank",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M20.5 463.6c-4.3 7.2-5.5 15.8-3.6 23.7.7 2.9 1.8 5.7 3.3 8.4C25.8 505.8 36.5 512 48 512h285.9c22.3 0 45.4-12.1 55.4-36.1 9.6-23.2 23.9-66.4 33.3-134.5 0-.3.1-.6.1-.8 5.5-40.5 9.3-89.7 9.3-148.6 0-76 26.2-138.3 59.4-143.6 1.5-.2 3.1-.4 4.6-.4 35.3 0 64 64.5 64 144s-28.7 144-64 144c-14 0-26.9-10-37.4-27.1-2.2 22.3-4.9 42.5-7.9 60.8C463 378 478.2 384 496 384c24.5 0 44.1-11.4 58-24.5 13.6-13 23.7-29.4 31.1-46.1C600 279.8 608 236.9 608 192s-8-87.8-22.9-121.3C577.7 54 567.6 37.5 554 24.5 540.1 11.4 520.5 0 496 0c-1.3 0-2.6 0-3.8.1V0H160c-53 0-96 86-96 192 0 77.6-.4 174.5-32.9 250-3.2 7.4-6.7 14.6-10.5 21.6v.1zM419 48c-4.7 7.3-8.6 15-12.1 22.7C392 104.2 384 147.1 384 192c0 153.2-26.3 235-39 265.5-.9 2.1-2.1 3.5-3.8 4.5-2 1.2-4.6 2-7.3 2H73.8c18.1-40.9 27.3-85.5 32.2-127.9 5.9-50.6 5.9-101.7 5.9-144.1 0-47.2 9.7-87.5 23.1-114.3 6.7-13.4 13.4-21.6 18.6-26 2.5-2.1 4.3-3 5.2-3.4.5-.2.8-.3.9-.3H419zm77 192c13.3 0 24-21.5 24-48s-10.7-48-24-48-24 21.5-24 48 10.7 48 24 48z"
        }
    ]
};

const FarToiletPaperCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToiletPaperCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16.8 487.4c-1.9-8-.7-16.5 3.6-23.7v-.1c3.8-7 7.3-14.2 10.5-21.6C63.6 366.5 64 269.6 64 192 64 86 107 0 160 0h332.1v.1c1.3-.1 2.5-.1 3.8-.1 24.5 0 44.1 11.4 58 24.5 13.6 13 23.7 29.4 31.1 46.1 15 33.6 23 76.5 23 121.4s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1-13.9 13.2-33.5 24.5-58 24.5-17.8 0-33-6-45.3-14.3 3-18.3 5.8-38.5 7.9-60.8C469.1 326 482 336 496 336c35.3 0 64-64.5 64-144S531.3 48 496 48c-1.6 0-3.1.1-4.6.4C458.2 53.7 432 116 432 192c0 58.9-3.8 108.1-9.3 148.6l-.1.8c-9.4 68.1-23.7 111.3-33.3 134.5-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2-1.5-2.7-2.6-5.5-3.3-8.4zM160 48h-.3c-.2 0-.4.1-.9.3-.9.4-2.7 1.3-5.2 3.4-5.2 4.4-11.9 12.6-18.6 26-13.3 26.8-23 67.1-23 114.3 0 42.3-.1 93.4-5.9 144.1-4.9 42.4-14.1 87-32.3 127.9h260.1c2.7 0 5.3-.8 7.3-2 1.7-1 3-2.4 3.8-4.5 12.7-30.5 39-112.3 39-265.5 0-44.9 8-87.8 22.9-121.3 3.4-7.7 7.4-15.4 12.1-22.7H160zm360 144c0 26.5-10.7 48-24 48s-24-21.5-24-48 10.7-48 24-48 24 21.5 24 48zm-204.7-4.7-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FarToiletPaperSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToiletPaperSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-112.7-88.3c14.4-4.3 26.5-12.4 35.9-21.3 13.6-13 23.7-29.4 31.1-46.1C600 279.8 608 236.9 608 192s-8-87.8-22.9-121.3C577.7 54 567.6 37.5 554 24.5 540.1 11.4 520.5 0 496 0c-1.3 0-2.6 0-3.8.1V0H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM134 79.8c.3-.7.7-1.4 1-2.1 6.7-13.4 13.4-21.6 18.6-26 2.5-2.1 4.3-3 5.2-3.4.5-.2.8-.3.9-.3H419c-4.7 7.3-8.6 15-12.1 22.7C392 104.2 384 147.1 384 192c0 29.8-1 57-2.7 81.6L134 79.8zM426.5 309c3.4-33.8 5.5-72.6 5.5-117 0-76 26.2-138.3 59.4-143.6 1.5-.2 3.1-.4 4.6-.4 35.3 0 64 64.5 64 144s-28.7 144-64 144h-35l-34.5-27zm-406 154.6c-4.3 7.2-5.5 15.8-3.6 23.7.7 2.9 1.8 5.7 3.3 8.4C25.8 505.8 36.5 512 48 512h285.9c22.3 0 45.4-12.1 55.4-36.1 5.4-12.9 12.2-32.1 18.8-58.4l-41.7-32.8c-7.5 35.6-15.8 59.2-21.5 72.8-.9 2.1-2.1 3.5-3.8 4.5-2 1.2-4.6 2-7.3 2h-260c18.1-40.9 27.3-85.5 32.2-127.9 5.9-50.6 5.9-101.7 5.9-144.1 0-2.6 0-5.1.1-7.7l-45.5-35.9C64.9 162.4 64 177 64 192c0 77.6-.4 174.5-32.9 250-3.2 7.4-6.7 14.6-10.5 21.6v.1zM496 240c13.3 0 24-21.5 24-48s-10.7-48-24-48-24 21.5-24 48 10.7 48 24 48z"
        }
    ]
};

const FarToiletPaperUnderSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToiletPaperUnderSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V192c0-49.5-10.5-95.4-28.5-129.9C530 28.7 501.7 0 464 0H176c-33.8 0-60 23-77.6 51.8L38.8 5.1zm97.7 76.6c14-25.4 29-33.7 39.5-33.7h212.7c-3 4.5-5.7 9.3-8.2 14.1-18 34.5-28.5 80.4-28.5 129.9 0 22 2.1 43.3 6 63.3L136.5 81.7zm324.1 254L430.4 312c-2.5-3.6-5-7.7-7.4-12.4-13.8-26.3-23-64.3-23-107.7s9.2-81.3 23-107.7C437.4 56.9 453.1 48 464 48s26.6 8.9 41 36.3c13.8 26.3 23 64.3 23 107.7s-9.2 81.3-23 107.7c-14.4 27.5-30.1 36.3-41 36.3-1.1 0-2.2-.1-3.4-.3zm45.1 35.3c8.2-5.4 15.6-12.2 22.3-20v37.5L505.7 371zm21.7 140.5L467.1 464H280c-4.4 0-8-3.6-8-8v-40h-48v40c0 30.9 25.1 56 56 56h240c2.5 0 5-.2 7.4-.5zM304.6 336H176c-10.9 0-26.6-8.9-41-36.3-13.8-26.3-23-64.3-23-107.7 0-2.6 0-5.1.1-7.7l-45.3-35.7C65 162.6 64 177.2 64 192c0 49.5 10.5 95.4 28.5 129.9C110 355.3 138.3 384 176 384h189.5l-60.9-48zM488 192c0-26.5-10.7-48-24-48s-24 21.5-24 48 10.7 48 24 48 24-21.5 24-48z"
        }
    ]
};

const FarToiletPaperUnder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToiletPaperUnder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 192c0 43.3 9.2 81.3 23 107.7 14.4 27.5 30.1 36.3 41 36.3h212.7c-3-4.5-5.7-9.3-8.2-14.1-18-34.5-28.5-80.4-28.5-129.9s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1H112c-10.9 0-26.6 8.9-41 36.3-13.8 26.4-23 64.4-23 107.7zM359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3zM464 456V351.1c-16.6 19.3-38.1 32.9-64 32.9H112c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0h288c37.7 0 66 28.7 83.5 62.1 18 34.5 28.5 80.4 28.5 129.9v264c0 30.9-25.1 56-56 56H216c-30.9 0-56-25.1-56-56v-40h48v40c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8zm-64-216c-13.3 0-24-21.5-24-48s10.7-48 24-48 24 21.5 24 48-10.7 48-24 48zm-288-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarToiletPaperXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToiletPaperXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 192c0 43.3 9.2 81.3 23 107.7 14.4 27.5 30.1 36.3 41 36.3h212.7c-3-4.5-5.7-9.3-8.2-14.1-18-34.5-28.5-80.4-28.5-129.9s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1H112c-10.9 0-26.6 8.9-41 36.3-13.8 26.4-23 64.4-23 107.7zM359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3zM464 456V351.1c-16.6 19.3-38.1 32.9-64 32.9H112c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0h288c37.7 0 66 28.7 83.5 62.1 18 34.5 28.5 80.4 28.5 129.9v264c0 30.9-25.1 56-56 56H216c-30.9 0-56-25.1-56-56v-40h48v40c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8zm-64-216c-13.3 0-24-21.5-24-48s10.7-48 24-48 24 21.5 24 48-10.7 48-24 48zM235.3 132.7c6.2 6.2 6.2 16.4 0 22.6L198.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FarToiletPaper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToiletPaper",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16.9 487.4c-1.9-8-.7-16.5 3.6-23.7v-.1c3.8-7 7.3-14.2 10.5-21.6 32.6-75.5 33-172.4 33-250C64 86 107 0 160 0h332.2v.1c1.3-.1 2.6-.1 3.8-.1 24.5 0 44.1 11.4 58 24.5 13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1-13.9 13.2-33.5 24.5-58 24.5-17.8 0-33-6-45.3-14.3 3-18.3 5.8-38.5 7.9-60.8C469.1 326 482 336 496 336c35.3 0 64-64.5 64-144S531.3 48 496 48c-1.6 0-3.1.1-4.6.4C458.2 53.7 432 116 432 192c0 58.9-3.8 108.1-9.3 148.6l-.1.8c-9.4 68.1-23.7 111.3-33.3 134.5-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2-1.5-2.7-2.6-5.5-3.3-8.4zM160 48h-.3c-.2 0-.4.1-.9.3-.9.4-2.7 1.3-5.2 3.4-5.2 4.4-11.9 12.6-18.6 26-13.3 26.8-23 67.1-23 114.3 0 42.3-.1 93.4-5.9 144.1-4.9 42.4-14.1 87-32.3 127.9h260.1c2.7 0 5.3-.8 7.3-2 1.7-1 3-2.4 3.8-4.5 12.7-30.5 39-112.3 39-265.5 0-44.9 8-87.8 22.9-121.3 3.4-7.7 7.4-15.4 12.1-22.7H160zm360 144c0 26.5-10.7 48-24 48s-24-21.5-24-48 10.7-48 24-48 24 21.5 24 48zm-344 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarToiletPortable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToiletPortable",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 72v24h224V72c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24zm0 72v288h224V320h-24c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h24v-80H48zm0 336v8c0 13.3-10.7 24-24 24S0 501.3 0 488V72C0 32.2 32.2 0 72 0h176c39.8 0 72 32.2 72 72v416c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48z"
        }
    ]
};

const FarToilet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToilet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24S437.3 0 424 0H24C10.7 0 0 10.7 0 24zm81.6 158.9-1.6.5V80H32v127.1l-.4.4C17.5 219.4 8 235.7 8 256c0 72.7 33.4 120.2 78.4 148.3 1.7 1.1 3.5 2.1 5.2 3.2l-22.3 40.7c-3.5 6.3-5.3 13.5-5.3 20.7 0 23.8 19.3 43.1 43.1 43.1h233.8c23.8 0 43.1-19.3 43.1-43.1 0-7.2-1.8-14.4-5.3-20.7l-22.3-40.7c1.8-1 3.5-2.1 5.2-3.2 45-28.1 78.4-75.6 78.4-148.3 0-20.3-9.5-36.6-23.6-48.5l-.4-.4V80h-48v103.4l-1.6-.5C328.4 172 277.7 168 224 168s-104.4 4-142.4 14.9zm292.2 143.9c-9.8 15.7-22.9 27.6-37.6 36.9C303 384.4 259.9 392 224 392s-79-7.6-112.2-28.3c-14.7-9.2-27.8-21.2-37.6-36.9 2.4.8 4.9 1.5 7.4 2.3C119.6 340 170.3 344 224 344s104.4-4 142.4-14.9c2.5-.7 4.9-1.5 7.4-2.3zM56 256c0-3.7 1.2-7.4 6.6-12 6.1-5.1 16.5-10.4 32.3-15 31.4-9 76.7-13 129.1-13s97.7 4 129.1 13.1c15.8 4.5 26.2 9.8 32.2 15 5.4 4.6 6.6 8.2 6.6 12s-1.2 7.4-6.6 12c-6.1 5.1-16.5 10.4-32.2 15C321.7 292 276.4 296 224 296s-97.7-4-129.1-13.1c-15.8-4.5-26.2-9.8-32.3-15-5.4-4.6-6.6-8.2-6.6-12zm256.3 170.8 20.3 37.2H115.4l20.4-37.2c30.5 9.7 61.8 13.2 88.3 13.2s57.7-3.5 88.3-13.2zM128 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48z"
        }
    ]
};

const FarToiletsPortable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToiletsPortable",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 48h112c13.3 0 24 10.7 24 24v24H48V72c0-13.3 10.7-24 24-24zM48 432V144h160v80h-24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h24v112H48zm0 56v-8h160v8c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-39.8-32.2-72-72-72H72C32.2 0 0 32.2 0 72v416c0 13.3 10.7 24 24 24s24-10.7 24-24zM392 48h112c13.3 0 24 10.7 24 24v24H368V72c0-13.3 10.7-24 24-24zm-24 384V144h160v80h-24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h24v112H368zm0 56v-8h160v8c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-39.8-32.2-72-72-72H392c-39.8 0-72 32.2-72 72v416c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FarTomato = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTomato",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m241 7-17 17 17-17 .1.1.2.2.5.5c.4.4 1 1 1.7 1.8 1.4 1.5 3.2 3.6 5.4 6.3 4.4 5.4 10.1 13.1 15.8 22.8 6.6 11.2 13.4 25.5 18 42.1 45.7 3.1 88.5 14.2 125.1 32.8 6.6 3.4 10 10.8 8.3 18s-8.2 12.3-15.6 12.3h-34.6l15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4l-105.7 45.3c-6.5 2.8-14.1 1-18.6-4.5s-4.9-13.2-1-19.1l15.5-23.3-31.3-.2c-7 1.5-14.3-1.7-17.7-8.4-4-7.9-.9-17.5 7-21.5l.8-.4c37.2-18.7 80.6-29.8 127-32.6-2.6-6.4-5.6-12.3-8.7-17.6-4.3-7.3-8.6-13-11.7-16.9-1.6-1.9-2.8-3.4-3.6-4.3-.4-.4-.7-.8-.9-.9l-.1-.1c-9.3-9.4-9.3-24.5.1-33.9 9.4-9.4 24.6-9.4 33.9 0zM71.1 154c6 9.4 14.9 16.1 25 19.5-.4 6.6.7 13.3 3.1 19.6C67.1 219.8 48 256.7 48 304c0 49.8 21.1 88 56.2 115 36.2 27.9 89.2 45 151.8 45s115.5-17.1 151.8-45c35.1-27 56.2-65.2 56.2-115 0-47.3-19.1-84.2-51.1-110.9 2.4-6.3 3.4-13 3.1-19.6 10.3-3.5 19.1-10.4 25-19.5 44 35.5 71.1 86.4 71.1 150 0 130.9-114.6 208-256 208S0 434.9 0 304c0-63.6 27.1-114.5 71.1-150z"
        }
    ]
};

const FarTombstoneBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTombstoneBlank",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 192v240h48V192C416 86 330 0 224 0S32 86 32 192v240h48V192c0-79.5 64.5-144 144-144s144 64.5 144 144zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarTombstone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTombstone",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 432V192c0-79.5-64.5-144-144-144S80 112.5 80 192v240H32V192C32 86 118 0 224 0s192 86 192 192v240h-48zM0 488c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm248-336v40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v120c0 13.3-10.7 24-24 24s-24-10.7-24-24V240h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-40c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarToolbox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToolbox",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 80h144c4.4 0 8 3.6 8 8v40H176V88c0-4.4 3.6-8 8-8zm-56 8v40H99.9c-12.7 0-24.9 5.1-33.9 14.1l-51.9 51.8c-9 9-14.1 21.2-14.1 33.9V416c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V227.9c0-12.7-5.1-24.9-14.1-33.9L446 142.1c-9-9-21.2-14.1-33.9-14.1H384V88c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm336 208h-96v-16c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H192v-16c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H48v-68.1L99.9 176h312.2l51.9 51.9V296zM48 344h96v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h128v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h96v72c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16v-72z"
        }
    ]
};

const FarTooth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTooth",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 143.3c0 12.5 2.9 24.9 8.5 36.1l17.1 34.2c8.8 17.7 15.2 36.4 18.9 55.8L139.6 431c.1.6.6 1 1.2 1 .5 0 1-.4 1.2-.9l28.4-102.4C177.1 304.6 199 288 224 288s46.9 16.6 53.5 40.7L306 431.1c.1.5.6.9 1.2.9s1.1-.4 1.2-1l31.1-161.6c3.7-19.4 10.1-38.2 18.9-55.8l15.1-30.2c6.9-13.9 10.6-29.2 10.6-44.8 0-32.4-26.3-58.7-58.7-58.7h-10.8c-16.6.1-32.6 6-45.2 16.8l-7 6 8.1 6c10.6 8 12.8 23 4.8 33.6s-23 12.8-33.6 4.8l-32-24-32-24-8-6C158.2 84.6 144.3 80 130 80h-2.7c-35 0-63.3 28.3-63.3 63.3zm159-70 15.1-13C259.4 42 286.5 32 314.6 32h10.7C384.2 32 432 79.8 432 138.7c0 23-5.4 45.7-15.6 66.2l-15.1 30.2c-6.9 13.7-11.8 28.3-14.7 43.4l-31.1 161.6c-4.5 23.2-24.7 39.9-48.3 39.9-22.1 0-41.5-14.7-47.4-36l-28.5-102.5c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.3-7.3 5.5L188.3 444c-5.9 21.3-25.3 36-47.4 36-23.6 0-43.9-16.7-48.3-39.9L61.4 278.5c-2.9-15.1-7.8-29.7-14.7-43.4l-17.1-34.3C20.7 183 16 163.3 16 143.3 16 81.8 65.8 32 127.3 32h2.7c24.7 0 48.7 8 68.4 22.8l8 6L223 73.2z"
        }
    ]
};

const FarToothbrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToothbrush",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 176c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c29.4 0 55.1-11.9 71-36.1 4.3-6.5 7.4-13.2 9.7-19.9 6.4 2.7 12 6 16.6 9.7 9.5 7.7 14.6 17 14.6 30.3 0 26.5-21.5 48-48 48H64zM0 160c0 35.3 28.7 64 64 64h288c53 0 96-43 96-96 0-58.5-51.6-89.9-104-95.2-8.8-.9-15.8 6.4-16.4 15.2-1.5 25.3-8.4 48-39.6 48H64c-35.3 0-64 28.7-64 64zm80 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v152h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24H400V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v152h-32V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v152h-32V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v152h-32V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v152H80V280z"
        }
    ]
};

const FarToriiGate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarToriiGate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 112c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V64.5l-1.6.6C437.9 75 411.6 80 385.2 80H126.8c-26.5 0-52.7-5-77.2-14.9l-1.6-.6V112zm-48 0V13.4C0 6 6 0 13.4 0c1.7 0 3.4.3 5 1l49 19.6C86.3 28.1 106.5 32 126.8 32h258.4c20.4 0 40.5-3.9 59.4-11.4l49-19.6c1.6-.6 3.3-1 5-1C506 0 512 6 512 13.4V112c0 35.3-28.7 64-64 64v64h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v200c0 13.3-10.7 24-24 24s-24-10.7-24-24V288H112v200c0 13.3-10.7 24-24 24s-24-10.7-24-24V288H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40v-64c-35.3 0-64-28.7-64-64zm112 128h120v-64H112v64zm168-64v64h120v-64H280z"
        }
    ]
};

const FarTornado = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTornado",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M332.4 48H48c.3 28 6.3 55.1 17 80h239.1c-.1-1.8-.1-3.6-.1-5.4 0-27.6 10.2-54.1 28.4-74.6zm-14.9 128H94c15.5 19.3 34.6 35.9 56.6 48.9l52.9 31.1H376l-49.6-66.1c-3.3-4.4-6.3-9.1-8.9-13.9zm80.9 128H282.9c19.9 15.1 36.1 34.6 47.3 57 8.9 17.8 14.4 37 16.4 56.5l23.6-23.6c19.1-19.1 29.8-45 29.8-72 0-6-.5-12.1-1.6-17.9zm5.7 123.9L340 492l-.4.4-3.6 3.6-10.1 10.1c-3.8 3.8-8.9 5.9-14.2 5.9-12.4 0-21.8-11.1-19.8-23.4l2.4-14.1.8-5 .1-.5 2.7-16c4-24 .3-48.7-10.6-70.5-10-19.9-25.5-36.5-44.6-47.8l-116.5-68.5C48 220.2 0 136.3 0 45.6V32C0 14.3 14.3 0 32 0h361.4C405.9 0 416 10.1 416 22.6c0 6-2.4 11.8-6.6 16l-38.6 38.6c-12 12-18.8 28.4-18.8 45.4 0 13.9 4.5 27.4 12.8 38.5L418 232c19.4 25.9 30 57.5 30 89.9 0 39.7-15.8 77.8-43.9 105.9z"
        }
    ]
};

const FarTowerBroadcast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTowerBroadcast",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M54.8 1.9c-12.2-5.3-26.3.4-31.5 12.5C8.3 49.3 0 87.7 0 128s8.3 78.7 23.3 113.6c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5C54.9 193.6 48 161.6 48 128s6.9-65.6 19.4-94.6C72.6 21.2 67 7.1 54.8 1.9zm466.4 0c-12.2 5.2-17.8 19.3-12.6 31.5 12.5 29 19.4 61 19.4 94.6s-6.9 65.6-19.4 94.6c-5.2 12.2.4 26.3 12.6 31.5s26.3-.4 31.5-12.6c15-34.9 23.3-73.3 23.3-113.6s-8.3-78.7-23.3-113.6c-5.2-12-19.3-17.7-31.5-12.4zM312 187.3c23.5-9.5 40-32.5 40-59.3 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 26.9 16.5 49.9 40 59.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V187.3zM166.5 87.6c4.2-12.6-2.6-26.2-15.2-30.3s-26.2 2.5-30.3 15.1c-5.8 17.5-9 36.2-9 55.6s3.1 38.1 9 55.6c4.2 12.6 17.8 19.4 30.3 15.2s19.4-17.8 15.2-30.3c-4.2-12.7-6.5-26.3-6.5-40.4s2.3-27.7 6.5-40.4zM455 72.4c-4.2-12.6-17.8-19.4-30.3-15.2S405.3 75 409.5 87.5c4.2 12.7 6.5 26.3 6.5 40.4s-2.3 27.7-6.5 40.4c-4.2 12.6 2.6 26.2 15.2 30.3s26.2-2.6 30.3-15.2c5.8-17.5 9-36.2 9-55.6s-3.1-38.1-9-55.6z"
        }
    ]
};

const FarTowerCell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTowerCell",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M51.8 1.6c12.4 4.8 18.5 18.7 13.8 31C54.3 62 48 94.2 48 128s6.3 66 17.6 95.4c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8C7.4 205.8 0 167.8 0 128S7.4 50.2 20.8 15.4C25.6 3 39.5-3.2 51.8 1.6zm472.4 0c12.4-4.8 26.3 1.4 31 13.8C568.6 50.2 576 88.2 576 128s-7.4 77.8-20.8 112.6c-4.8 12.4-18.7 18.5-31 13.8s-18.5-18.7-13.8-31C521.7 194 528 161.8 528 128s-6.3-66-17.6-95.4c-4.8-12.4 1.4-26.3 13.8-31zM291.3 191.9c-1.1.1-2.2.1-3.3.1s-2.2 0-3.3-.1L239.8 288h96.4l-44.8-96.1zM195 384h186l-22.4-48H217.4L195 384zm-22.4 48-30.9 66.2c-5.6 12-19.9 17.2-31.9 11.6s-17.2-19.9-11.6-31.9l143-306.3C230.5 160.2 224 144.9 224 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 16.9-6.5 32.2-17.2 43.6l142.9 306.3c5.6 12 .4 26.3-11.6 31.9s-26.3.4-31.9-11.6L403.4 432H172.6zm-9.3-358.4C156 90.2 152 108.6 152 128s4 37.8 11.3 54.4c5.3 12.1-.2 26.3-12.4 31.6s-26.3-.2-31.6-12.4C109.5 179 104 154.1 104 128s5.5-51 15.3-73.6c5.3-12.1 19.5-17.7 31.6-12.4s17.7 19.5 12.4 31.6zm293.4-19.2C466.5 77 472 101.9 472 128s-5.5 51-15.3 73.6c-5.3 12.1-19.5 17.7-31.6 12.4s-17.7-19.5-12.4-31.6c7.3-16.6 11.3-35 11.3-54.4s-4-37.8-11.3-54.4c-5.3-12.1.2-26.3 12.4-31.6s26.3.2 31.6 12.4z"
        }
    ]
};

const FarTowerControl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTowerControl",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v48h40c17.7 0 32 14.3 32 32h93.2c21.4 0 36.8 20.7 30.6 41.2l-41.1 137.3c7.9 3.9 13.3 12.1 13.3 21.5 0 13.3-10.7 24-24 24h-24v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H128v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H56c-13.3 0-24-10.7-24-24 0-9.4 5.4-17.6 13.3-21.5L4.1 169.2c-6.2-20.5 9.2-41.2 30.7-41.2H128c0-17.7 14.3-32 32-32h40V48h-16c-13.3 0-24-10.7-24-24zM94.7 304H128V176H56.3l38.4 128zm81.3 0h96V176h-96v128zm144-128v128h33.3l38.4-128H320z"
        }
    ]
};

const FarTowerObservation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTowerObservation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M245.7 2.3c6.5-3.1 14.1-3.1 20.6 0l168 80c12 5.7 17 20 11.3 32-5.3 11.2-18.2 16.4-29.7 12.3V200c0 27.2-19.4 49.9-45.2 55l34.8 209H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h82.3l34.8-209c-25.7-5-45.2-27.7-45.2-55v-73.4c-11.4 4.1-24.3-1.1-29.7-12.3-5.7-12-.6-26.3 11.4-32l168-80zM256 50.6l-112 53.3V128h224v-24.1L256 50.6zM144 176v24c0 4.4 3.6 8 8 8h208c4.4 0 8-3.6 8-8v-24H144zm186.8 288L256 400.7 181.2 464h149.6zM189.7 256l-3.7 22.5 70 59.3 70.1-59.3-3.8-22.5H189.7zm-12.9 77.6-13.8 83 55.9-47.3-42.1-35.6zm116.4 35.6 55.9 47.3-13.8-83-42.1 35.6z"
        }
    ]
};

const FarTractor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTractor",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 48h114.3c3.3 0 6.2 2 7.4 5l42.8 107H144V56c0-4.4 3.6-8 8-8zm-56 8v136.6c-11.2-3.9-24.2-1.4-33.1 7.6l-22.7 22.7c-12.5 12.5-12.5 32.8 0 45.3L46 274c-2.2 4.6-4.1 9.3-5.8 14.1H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h8.2c1.7 4.8 3.7 9.5 5.8 14.1l-5.8 5.8c-12.5 12.5-12.5 32.8 0 45.3l22.6 22.6c12.5 12.5 32.8 12.5 45.3 0l5.8-5.8c4.6 2.2 9.3 4.1 14.1 5.8v8.1c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-8.2c4.8-1.7 9.5-3.7 14.1-5.8l5.8 5.8c12.5 12.5 32.8 12.5 45.3 0l22.6-22.6c12.5-12.5 12.5-32.8 0-45.3l-5.8-5.8c2.2-4.6 4.1-9.3 5.8-14.1h103c6.5-18.5 17.5-34.9 31.6-48H352v-16c0-17.7-14.3-32-32-32h-8.2c-1.7-4.8-3.7-9.5-5.8-14.1l5.8-5.8c12.5-12.5 12.5-32.8 0-45.3L296.9 208H584c4.4 0 8 3.6 8 8v32.7c0 7.4-3.4 14.3-9.2 18.9l-46.7 36.7c20.1 1.3 38.9 7.7 55.1 17.7l21.3-16.7c17.4-13.6 27.5-34.5 27.5-56.6V216c0-30.9-25.1-56-56-56h-56v-41.8c0-16.1 3.8-32.1 11-46.5l2.5-5c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7l-2.5 5c-10.6 21.1-16 44.4-16 68V160H368.2L318.3 35.2C309.8 13.9 289.2 0 266.3 0H152c-30.9 0-56 25.1-56 56zm80 200a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm352 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 128a88 88 0 1 0 0-176 88 88 0 1 0 0 176z"
        }
    ]
};

const FarTrademark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrademark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M331.4 105.8c-6.1-8.4-17-11.9-26.8-8.7S288 109.5 288 119.9V392c0 13.3 10.7 24 24 24s24-10.7 24-24V193.5l108.6 148.7c4.5 6.2 11.7 9.8 19.4 9.8s14.9-3.7 19.4-9.8L592 193.5V392c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-10.4-6.7-19.6-16.6-22.8s-20.7.3-26.8 8.7L464 287.3 331.4 105.8zM0 120c0 13.3 10.7 24 24 24h80v248c0 13.3 10.7 24 24 24s24-10.7 24-24V144h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarTrafficCone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrafficCone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M217.8 15c3.7-9 12.5-15 22.2-15h32c9.8 0 18.6 5.9 22.2 15l182.7 449H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h11.1L217.8 15zM386 368H126l-39.1 96h338.2l-39-96zm-19.5-48-45.6-112H191.1l-45.6 112h221zM210.6 160h90.8L256 48.4 210.6 160z"
        }
    ]
};

const FarTrafficLightGo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrafficLightGo",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v288c0 61.9 50.1 112 112 112s112-50.1 112-112V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64v288c0 88.4-71.6 160-160 160S0 440.4 0 352V64zm160 360a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-184a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-16-168a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm64 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0z"
        }
    ]
};

const FarTrafficLightSlow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrafficLightSlow",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v288c0 61.9 50.1 112 112 112s112-50.1 112-112V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64v288c0 88.4-71.6 160-160 160S0 440.4 0 352V64zm144 312a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm64 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm0-120a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm-64-120a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm64 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0z"
        }
    ]
};

const FarTrafficLightStop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrafficLightStop",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v288c0 61.9 50.1 112 112 112s112-50.1 112-112V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64v288c0 88.4-71.6 160-160 160S0 440.4 0 352V64zm144 312a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm64 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm-48-136a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-120a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
        }
    ]
};

const FarTrafficLight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrafficLight",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v288c0 61.9 50.1 112 112 112s112-50.1 112-112V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64v288c0 88.4-71.6 160-160 160S0 440.4 0 352V64zm160 360a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-168a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm-48-72a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
        }
    ]
};

const FarTrailer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrailer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80h432c8.8 0 16 7.2 16 16v240H275.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm224 304h328c13.3 0 24-10.7 24-24s-10.7-24-24-24h-56V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v224c0 35.3 28.7 64 64 64h32c0 53 43 96 96 96s96-43 96-96zM136 112c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24zM144 384a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FarTrainSubwayTunnel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrainSubwayTunnel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48C141.1 48 48 141.1 48 256v232c0 13.3-10.7 24-24 24S0 501.3 0 488V256C0 114.6 114.6 0 256 0s256 114.6 256 256v232c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-114.9-93.1-208-208-208zm24 128v80h72v-48c0-17.7-14.3-32-32-32h-40zm-48 0h-40c-17.7 0-32 14.3-32 32v48h72v-80zm-72 128v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64H160zm-48-96c0-44.2 35.8-80 80-80h128c44.2 0 80 35.8 80 80v160c0 27.7-14.1 52.2-35.5 66.5L401 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-57-57H201.9l-57 57c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l36.5-36.5C126.1 420.2 112 395.7 112 368V208zm64 144a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm136-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarTrainSubway = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrainSubway",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200 48v160H48V96c0-26.5 21.5-48 48-48h104zm48 0h104c26.5 0 48 21.5 48 48v112H248V48zM48 352v-96h352v96c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48zM96 0C43 0 0 43 0 96v256c0 42.8 28 79 66.6 91.4L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h188.2l57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6C420 431 448 394.8 448 352V96c0-53-43-96-96-96H96zm32 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarTrainTrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrainTrack",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.6 64.1c4.5-12.5-2-26.2-14.5-30.7s-26.2 2-30.7 14.5L160.1 96H112c-13.3 0-24 10.7-24 24s10.7 24 24 24h30.8L114 224H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h24.7l-28.8 80H32c-13.3 0-24 10.7-24 24s10.7 24 24 24h18.7l-17.3 47.9c-4.5 12.5 2 26.2 14.5 30.7s26.2-2 30.7-14.5l23.1-64.1h372.6l23.1 64.1c4.5 12.5 18.2 18.9 30.7 14.5s18.9-18.2 14.5-30.7L525.3 400H544c13.3 0 24-10.7 24-24s-10.7-24-24-24h-35.9l-28.8-80H504c13.3 0 24-10.7 24-24s-10.7-24-24-24h-42l-28.8-80H464c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48.1l-17.3-48.1c-4.5-12.5-18.2-18.9-30.7-14.5S349 51.6 353.4 64.1L364.9 96H211.1l11.5-31.9zM193.8 144h188.4l28.8 80H165l28.8-80zm263.3 208H118.9l28.8-80h280.6l28.8 80z"
        }
    ]
};

const FarTrainTram = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrainTram",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M55.5 63c7.6-9.5 19.1-15 31.2-15H200v48h-40c-53 0-96 43-96 96v160c0 26 10.3 49.6 27.2 66.9L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l60.6-60.6c8.4 2.4 17.2 3.7 26.4 3.7H288c9.2 0 18-1.3 26.4-3.7L375 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L356.8 419c16.9-17.4 27.2-41 27.2-67V192c0-53-43-96-96-96h-40V48h113.2c12.2 0 23.6 5.5 31.2 15l12.8 16c8.3 10.4 23.4 12 33.7 3.7s12-23.4 3.8-33.7L430 33c-16.7-20.8-42-33-68.8-33H86.8C60 0 34.7 12.2 18 33L5.3 49C-3 59.4-1.3 74.5 9 82.7s25.5 6.6 33.7-3.7l12.8-16zM160 144h128c26.5 0 48 21.5 48 48v48H112v-48c0-26.5 21.5-48 48-48zm-48 144h224v64c0 26.5-21.5 48-48 48H160c-26.5 0-48-21.5-48-48v-64zm72 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarTrainTunnel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrainTunnel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-114.9 93.1-208 208-208s208 93.1 208 208v232c0 13.3 10.7 24 24 24s24-10.7 24-24V256C512 114.6 397.4 0 256 0S0 114.6 0 256v232c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm304-48v48H160v-48c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32zM160 368v-64h192v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm32-240c-44.2 0-80 35.8-80 80v160c0 27.7 14.1 52.2 35.5 66.5L111 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h108.2l57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-36.5-36.5c21.4-14.3 35.5-38.8 35.5-66.5V208c0-44.2-35.8-80-80-80H192zm96 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarTrain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrain",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48c26.5 0 48 21.5 48 48v96H48V96c0-26.5 21.5-48 48-48h256zM48 352V240h352v112c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48zM96 0C43 0 0 43 0 96v256c0 42.8 28 79 66.6 91.4L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h188.2l57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6C420 431 448 394.8 448 352V96c0-53-43-96-96-96H96zm128 360a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
        }
    ]
};

const FarTransformerBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransformerBolt",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 24c0-13.3-10.7-24-24-24S88 10.7 88 24v8H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-24v-8zm160 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v8h-24c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-24v-8zM48 112c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v256h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V208h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm56 304V208h224v256H80zm153.4-220.9c-5.9-4.3-14-4-19.6.7l-96 80c-5.2 4.3-7.1 11.4-4.8 17.7s8.3 10.6 15 10.6h40.4l-23.2 58.1c-2.7 6.8-.5 14.6 5.5 18.9s14 4 19.6-.7l96-80c5.2-4.3 7.1-11.4 4.8-17.7s-8.3-10.6-15-10.6h-40.5l23.2-58.1c2.7-6.8.5-14.6-5.5-18.9z"
        }
    ]
};

const FarTransgender = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransgender",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 24c0-13.3-10.7-24-24-24H24C10.7 0 0 10.7 0 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9L78.1 112l-7 7c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 15.2 15.2C107.6 187.7 96 220.5 96 256c0 80.2 59 146.6 136 158.2V432h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-17.8c77-11.6 136-78 136-158.2 0-35.5-11.6-68.3-31.2-94.9L464 81.9V104c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1l-79.2 79.2C324.3 107.6 291.5 96 256 96s-68.3 11.6-94.9 31.2L145.9 112l7-7c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-7 7L81.9 48H104c13.3 0 24-10.7 24-24zm128 344c-61.9 0-112-50.1-112-112 0-29.8 11.7-56.9 30.7-77a21.976 21.976 0 0 0 4.3-4.3c20.1-19 47.2-30.7 77-30.7s56.9 11.7 77 30.7a21.976 21.976 0 0 0 4.3 4.3c19 20.1 30.7 47.2 30.7 77 0 61.9-50.1 112-112 112z"
        }
    ]
};

const FarTransporter1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransporter1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-64 192h48V176h32v112h48v-79.2l52.9 69.7c8 10.6 23.1 12.6 33.6 4.6s12.6-23.1 4.6-33.6l-65.7-86.7c-16.6-21.9-42.6-34.8-70.1-34.8h-38.6c-27.5 0-53.5 12.9-70.1 34.8l-65.7 86.7c-8 10.6-5.9 25.6 4.6 33.6s25.6 5.9 33.6-4.6l52.9-69.7V288zm288-128-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 160l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 160zM64 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 352l-25.4 7.3C2.7 360.4 0 363.9 0 368s2.7 7.6 6.6 8.7L32 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 352zm56 112c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm56-144c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
        }
    ]
};

const FarTransporter2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransporter2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m64 32 25.4 7.3c3.9 1.1 6.6 4.6 6.6 8.7s-2.7 7.6-6.6 8.7L64 64l-7.3 25.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32l7.3-25.4C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6L64 32zm416 320 25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 352zM120 464h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zM256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-75.6 224h-60.2l46.4-61.2c16.6-21.9 42.6-34.8 70.1-34.8h38.6c27.5 0 53.5 12.9 70.1 34.8l46.4 61.2H272v-48h-32v48h-59.6zM112 256h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarTransporter3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransporter3",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m480 32-7.3-25.4C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32zM64 128l-7.3-25.4C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128l-25.4 7.3C2.7 136.4 0 139.9 0 144s2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128zm56 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM304 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
        }
    ]
};

const FarTransporter4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransporter4",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm296.7-249.4L480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm-416 224L64 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 416l-25.4-7.3C2.7 407.6 0 404.1 0 400s2.7-7.6 6.6-8.7L32 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarTransporter5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransporter5",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm-48 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM64 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 160l-25.4 7.3C2.7 168.4 0 171.9 0 176s2.7 7.6 6.6 8.7L32 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 160zM472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32l-7.3-25.4z"
        }
    ]
};

const FarTransporter6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransporter6",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56.7 6.6 64 32l25.4 7.3c3.9 1.1 6.6 4.6 6.6 8.7s-2.7 7.6-6.6 8.7L64 64l-7.3 25.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32l7.3-25.4C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6zm416 352L480 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 416l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zM224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarTransporter7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransporter7",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m480 64-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 64l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 96l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 96l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 64zM64 288l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 288l-25.4 7.3C2.7 296.4 0 299.9 0 304s2.7 7.6 6.6 8.7L32 320l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 320l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 288zm56 176c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"
        }
    ]
};

const FarTransporterEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransporterEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 488c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarTransporter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTransporter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472.7 6.6 480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4c1.1-3.9 4.6-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm-416 64L64 96l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 128l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 128l-25.4-7.3C2.7 119.6 0 116.1 0 112s2.7-7.6 6.6-8.7L32 96l7.3-25.4c1.1-3.9 4.6-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zM208 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm32 272v112h-48V208.8l-52.9 69.7c-8 10.6-23.1 12.6-33.6 4.6s-12.6-23.1-4.6-33.6l65.7-86.7c16.6-21.9 42.6-34.8 70.1-34.8h38.6c27.5 0 53.5 12.9 70.1 34.8l65.7 86.7c8 10.6 5.9 25.6-4.6 33.6s-25.6 5.9-33.6-4.6L320 208.8V432h-48V320h-32zm0-48h32v-96h-32v96z"
        }
    ]
};

const FarTrashArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-11.6l-24 324.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.5 0-61.3-25.9-63.8-59.3L35.6 128H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8h201.1c8.4 0 15.3-6.5 16-14.8L364.3 128H83.7zm154.5 65.9 64 64c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L244 256.3V384c0 11-9 20-20 20s-20-9-20-20V256.3l-29.9 29.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l64-64c7.8-7.8 20.5-7.8 28.3 0z"
        }
    ]
};

const FarTrashCanArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashCanArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v304c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128v304c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V128H80zm144 48c6.4 0 12.5 2.5 17 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V257.9l-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c4.5-4.5 10.6-7 17-7z"
        }
    ]
};

const FarTrashCanCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashCanCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v304c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128v304c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V128H80zm257 113L209 369c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 207c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FarTrashCanClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashCanClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v64.7c-16.8 1.5-32.9 5.4-48 11.3v-76H80v304c0 17.7 14.3 32 32 32h172.5c12.3 18.8 28 35.1 46.3 48H112c-44.2 0-80-35.8-80-80V128h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zm2.5 167v40.2c-12.1 10-22.9 21.7-32 34.6V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm-160 0v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm48 176a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarTrashCanList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashCanList",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M161.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zm177.1 32-36.7-55.1C291.1 9.4 273.6 0 254.9 0h-93.8c-18.7 0-36.2 9.4-46.6 24.9L77.8 80H24C10.7 80 0 90.7 0 104s10.7 24 24 24h8v304c0 44.2 35.8 80 80 80h192c44.2 0 80-35.8 80-80V128h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-53.8zm-2.2 48v304c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V128h256zm-176 48c-8.8 0-16 7.2-16 16v208c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v208c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-8.8-7.2-16-16-16zm216-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H472zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H472zm-24 152c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarTrashCanPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashCanPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v304c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128v304c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V128H80zm120 248v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FarTrashCanSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashCanSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V128h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-69.8l-36.7-55.1C403.1 9.4 385.6 0 366.9 0h-93.8c-18.7 0-36.2 9.4-46.6 24.9L189.8 80h-55.4L38.8 5.1zM195.6 128H464v210.4l-48-37.6V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v83.7L336 238v-46c0-8.8-7.2-16-16-16s-16 7.2-16 16v21l-108.4-85zm77.5-80h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zm219.6 436.2-37.8-29.8c-5.8 5.9-13.9 9.6-22.9 9.6H208c-17.7 0-32-14.3-32-32V234.7l-48-37.8V432c0 44.2 35.8 80 80 80h224c24.3 0 46-10.8 60.7-27.8zM224 272.5V400c0 8.8 7.2 16 16 16s16-7.2 16-16V297.7l-32-25.2zm80 63V400c0 8.8 7.2 16 16 16s16-7.2 16-16v-39.3l-32-25.2z"
        }
    ]
};

const FarTrashCanUndo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashCanUndo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v304c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128v304c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V128H80zm145.9 64.1c8.8 9.9 7.9 25.1-2 33.9l-24.8 22H240c48.6 0 88 39.4 88 88v24c0 13.3-10.7 24-24 24s-24-10.7-24-24v-24c0-22.1-17.9-40-40-40h-40.9l24.8 22.1c9.9 8.8 10.8 24 2 33.9s-24 10.8-33.9 2l-72-64c-5.1-4.6-8.1-11.1-8.1-17.9s2.9-13.4 8.1-17.9l72-64c9.9-8.8 25.1-7.9 33.9 2z"
        }
    ]
};

const FarTrashCanXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashCanXmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v304c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128v304c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V128H80zm63 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarTrashCan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashCan",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v304c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128v304c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V128H80zm80 64v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarTrashCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-11.6l-24 324.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.5 0-61.3-25.9-63.8-59.3L35.6 128H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8h201.1c8.4 0 15.3-6.5 16-14.8L364.3 128H83.7zm234.4 118.1-104 104c-7.8 7.8-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l25.9 25.9 89.9-89.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"
        }
    ]
};

const FarTrashClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zm177.1 32-36.7-55.1C307.1 9.4 289.6 0 270.9 0h-93.8c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H24C10.7 80 0 90.7 0 104s10.7 24 24 24h11.6l24 324.7c2.5 33.4 30.3 59.3 63.8 59.3h201.2c2 0 3.9-.1 5.8-.3-18.2-12.9-33.8-29.1-45.9-47.7h-161c-8.4 0-15.3-6.5-16-14.8L83.7 128h280.6l-5.9 80.1c15.3-7.1 31.9-12 49.2-14.4l4.9-65.7H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-69.8zM576 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144-80c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarTrashList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashList",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h113l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-61.7c-2.7 0-5.2 1.3-6.7 3.6zm115-26.6 36.7 55H392c13.3 0 24 10.7 24 24s-10.7 24-24 24h-11.6l-24 324.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.5 0-61.3-25.9-63.8-59.3L35.6 128H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h61.7c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8h169.1c8.4 0 15.3-6.5 16-14.8L332.3 128H83.7zm388.3 0h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24 152c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarTrashPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-11.6l-24 324.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.5 0-61.3-25.9-63.8-59.3L35.6 128H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8h201.1c8.4 0 15.3-6.5 16-14.8L364.3 128H83.7zM204 376v-68h-68c-11 0-20-9-20-20s9-20 20-20h68v-68c0-11 9-20 20-20s20 9 20 20v68h68c11 0 20 9 20 20s-9 20-20 20h-68v68c0 11-9 20-20 20s-20-9-20-20z"
        }
    ]
};

const FarTrashSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L491.3 359.8 508.4 128H520c13.3 0 24-10.7 24-24s-10.7-24-24-24h-69.8l-36.7-55.1C403.1 9.4 385.6 0 366.9 0h-93.8c-18.7 0-36.2 9.4-46.6 24.9L189.8 80h-55.4L38.8 5.1zM195.6 128h264.7l-14.5 196.1L195.6 128zm77.5-80h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM155.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3h201.2c26.1 0 48.8-15.7 58.7-38.4l-42.1-33.1-.6 8.7c-.6 8.4-7.6 14.8-16 14.8H219.4c-8.4 0-15.3-6.5-16-14.8l-15.1-204.8-51.1-40.3 18.4 248.6z"
        }
    ]
};

const FarTrashUndo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashUndo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zm177.1 32-36.7-55.1C307.1 9.4 289.6 0 270.9 0h-93.8c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H24C10.7 80 0 90.7 0 104s10.7 24 24 24h11.6l24 324.7c2.5 33.4 30.3 59.3 63.8 59.3h201.2c33.5 0 61.3-25.9 63.8-59.3l24-324.7H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-69.8zm10.1 48-23.8 321.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128h280.6zm-141.4 66.7c-7.3-8.3-20-9-28.2-1.7l-72 64c-4.3 3.8-6.7 9.2-6.7 14.9s2.4 11.2 6.7 14.9l72 64c8.3 7.3 20.9 6.6 28.2-1.7s6.6-20.9-1.7-28.2L188.6 292H240c24.3 0 44 19.7 44 44v24c0 11 9 20 20 20s20-9 20-20v-24c0-46.4-37.6-84-84-84h-51.4l32.7-29.1c8.3-7.3 9-20 1.7-28.2z"
        }
    ]
};

const FarTrashXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrashXmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-11.6l-24 324.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.5 0-61.3-25.9-63.8-59.3L35.6 128H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8h201.1c8.4 0 15.3-6.5 16-14.8L364.3 128H83.7zm62.2 81.9c7.8-7.8 20.5-7.8 28.3 0l49.8 49.8 49.9-49.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L252.3 288l49.9 49.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L224 316.3l-49.9 49.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l49.9-49.9-49.9-49.9c-7.8-7.8-7.8-20.5 0-28.3z"
        }
    ]
};

const FarTrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrash",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zm177.1 32-36.7-55.1C307.1 9.4 289.6 0 270.9 0h-93.8c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H24C10.7 80 0 90.7 0 104s10.7 24 24 24h11.6l24 324.7c2.5 33.4 30.3 59.3 63.8 59.3h201.2c33.5 0 61.3-25.9 63.8-59.3l24-324.7H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-69.8zm10.1 48-23.8 321.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128h280.6z"
        }
    ]
};

const FarTreasureChest = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTreasureChest",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80h256v160h-64v-16c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v16h-64V80zM48 160c0-38.7 27.5-71 64-78.4V240H48v-80zm0 272V288h64v144H48zm368-144v144H160V288h64v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-32h64zm112 144h-64V288h64v144zm0-272v80h-64V81.6c36.5 7.4 64 39.7 64 78.4zM128 32C57.3 32 0 89.3 0 160v272c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V160c0-70.7-57.3-128-128-128H128zm176 224v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarTreeChristmas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTreeChristmas",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m150.2 71 47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7-17.7 47.1c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9zm125.3 60.5 15.8-5.9 122 193.1c4.7 7.4 4.9 16.7.7 24.4s-12.3 12.4-21 12.4h-25.3L444.2 475c4.7 7.4 5 16.8.8 24.5S432.7 512 423.9 512H24c-8.8 0-16.8-4.8-21.1-12.5s-3.9-17.1.8-24.5l76.6-119.5H55c-8.7 0-16.8-4.8-21-12.4s-3.9-17 .7-24.4l122-193.1 15.8 5.9L185 165c.4 1.2.9 2.3 1.4 3.4L98.6 307.5h25.6c8.8 0 16.8 4.8 21.1 12.5s3.9 17.1-.8 24.5L67.9 464h312.2l-76.5-119.5c-4.7-7.4-5.1-16.8-.8-24.5s12.3-12.5 21.1-12.5h25.6l-88-139.1c.5-1.1 1-2.2 1.4-3.4l12.6-33.5zM160 280a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm128 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarTreeCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTreeCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 56c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v160c0 13.3 10.7 24 24 24h96c4.4 0 8 3.6 8 8v240c0 13.3 10.7 24 24 24s24-10.7 24-24V248c0-28.2-20.9-51.6-48-55.4V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-32V56c0-30.9-25.1-56-56-56H344c-30.9 0-56 25.1-56 56v432c0 13.3 10.7 24 24 24s24-10.7 24-24V56zm32 40v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zM224 160c0-53-43-96-96-96-54 0-96 43-96 96 0 6 0 11 1 16-20 14-33 38-33 64 0 45 35 80 80 80h16v160c0 18 14 32 32 32 17 0 32-14 32-32V320h16c44 0 80-35 80-80 0-26-14-50-34-64 1-5 2-10 2-16z"
        }
    ]
};

const FarTreeDeciduous = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTreeDeciduous",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M185.9 103.6c-1.4 6.2-5.3 11.6-10.7 15s-12 4.4-18.2 3c-4.1-1-8.5-1.5-13-1.5-30.9 0-56 25.1-56 56 0 6.4 1.1 12.5 3 18.2 3.8 11.1-1 23.4-11.3 28.9-18.9 10-31.7 30-31.7 52.8 0 33.1 26.9 60 60 60h124V152c0-13.3 10.7-24 24-24s24 10.7 24 24v184h124c33.1 0 60-26.9 60-60 0-22.8-12.8-42.8-31.7-52.9-10.4-5.6-15.2-17.8-11.3-28.9 1.9-5.7 3-11.8 3-18.2 0-30.9-25.1-56-56-56-4.5 0-8.8.5-13 1.5-6.2 1.5-12.7.4-18.2-3s-9.3-8.7-10.7-15C318.7 71.7 290.1 48 256 48s-62.7 23.7-70.1 55.6zM232 384H108C48.4 384 0 335.6 0 276c0-34.4 16.1-65 41.1-84.8-.7-5-1.1-10.1-1.1-15.2 0-57.4 46.6-104 104-104h2c18.5-42.4 60.8-72 110-72s91.5 29.6 110 72h2c57.4 0 104 46.6 104 104 0 5.2-.4 10.2-1.1 15.2 25 19.8 41.1 50.4 41.1 84.8 0 59.6-48.4 108-108 108H280v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384z"
        }
    ]
};

const FarTreeDecorated = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTreeDecorated",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M242.9 9.3C238.4 3.4 231.4 0 224 0s-14.4 3.4-18.9 9.3L66.8 186.9c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5h16.5L35.1 326.2c-4.9 7.4-5.4 16.8-1.2 24.6s12.3 12.7 21.2 12.7H79L4.1 474.6c-5 7.4-5.5 16.9-1.3 24.7S15.1 512 24 512h400c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.3-24.7L369 363.5h24c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-67.3-100.6h16.5c9.2 0 17.5-5.2 21.6-13.5s3-18-2.6-25.3L242.9 9.3zm-95.7 168.3h-12.3L224 63.1l89.1 114.5h-12.3c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6L348 315.5h-24.2c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.3 24.7l75 111.1H69.1L144 352.9c5-7.4 5.5-16.9 1.3-24.7s-12.3-12.7-21.2-12.7H99.9l67.2-100.6c4.9-7.4 5.4-16.8 1.2-24.6s-12.3-12.7-21.2-12.7zM184 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-152a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm24 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarTreeLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTreeLarge",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c7.4 0 14.4 3.4 18.9 9.3l138.3 177.6c5.6 7.2 6.6 17 2.6 25.3s-12.4 13.5-21.6 13.5h-16.5l67.2 100.6c4.9 7.4 5.4 16.8 1.2 24.6s-12.3 12.7-21.2 12.7H369l74.9 111.1c5 7.4 5.5 16.9 1.3 24.7S432.9 512 424 512H24c-8.9 0-17-4.9-21.2-12.7S-.9 482 4.1 474.6L79 363.5H55c-8.9 0-17-4.9-21.2-12.7s-3.7-17.3 1.2-24.6l67.2-100.6H85.8c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L205.1 9.3C209.6 3.4 216.6 0 224 0zm-89.1 177.6h12.3c8.9 0 17 4.9 21.2 12.7s3.7 17.3-1.2 24.6L99.9 315.5h24.2c8.9 0 17 4.9 21.2 12.7s3.7 17.3-1.3 24.7L69.1 464h309.8l-75-111.1c-5-7.4-5.5-16.9-1.3-24.7s12.3-12.7 21.2-12.7H348l-67.2-100.6c-4.9-7.4-5.4-16.8-1.2-24.6s12.3-12.7 21.2-12.7h12.3L224 63.1l-89.1 114.5z"
        }
    ]
};

const FarTreePalm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTreePalm",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m102.9 91.4 30.3 50.5c-4 3.5-8 7.2-12 11.2-71 71-60.2 151-32.7 191.3 5 7.3 15.2 7.3 21.4 1L236 219.3c2.3 9.3 4.3 20.3 5.6 32.9 4.9 46.6.5 115.1-26.4 208.3-7.3 25.3 11.3 51.5 38.5 51.5h84.1c20 0 37.6-15 39.6-35.7 9.2-95.5-5.9-202-34.3-284.3h103.6c2.8 0 5.4-1.5 6.9-3.9l19.6-32.7c3.1-5.2 10.6-5.2 13.7 0l19.6 32.7c1.4 2.4 4.1 3.9 6.9 3.9H560c8.8 0 16.1-7.2 14.4-15.9C565.3 128.2 516.4 64 416 64c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0 59.6 0 10.7 64.2 1.6 112.1-.1 120.8 7.2 128 16 128h46.7c2.8 0 5.4-1.5 6.9-3.9l19.5-32.7c3.1-5.2 10.6-5.2 13.7 0zM292 192c28.6 74.1 46 177.9 38.3 272h-66.2c25.8-92.9 30.7-164.5 25.2-216.8-2.2-21.5-6.2-39.9-11.4-55.2H292z"
        }
    ]
};

const FarTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTree",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241.8 7.9c-4.5-5-11-7.9-17.8-7.9s-13.3 2.9-17.8 7.9l-144 160c-6.3 7-7.9 17.2-4.1 25.8S70.5 208 80 208h11.8l-62 72.4c-6.1 7.1-7.5 17.1-3.6 25.6s12.4 14 21.8 14h24L4.8 409.6c-5.5 7.3-6.3 17-2.3 25.1S14.9 448 24 448h176v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h176c9.1 0 17.4-5.1 21.5-13.3s3.2-17.9-2.3-25.1L376 320h24c9.4 0 17.9-5.5 21.8-14s2.5-18.5-3.6-25.6l-62-72.4H368c9.5 0 18.1-5.6 21.9-14.2s2.3-18.8-4.1-25.8L241.8 8zM248 400V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v184H72l67.2-89.6c5.5-7.3 6.3-17 2.3-25.1S129.1 272 120 272h-19.8l62-72.4c6.1-7.1 7.5-17.1 3.6-25.6s-12.4-14-21.8-14h-10.1L224 59.9 314.1 160H304c-9.4 0-17.9 5.5-21.8 14s-2.5 18.5 3.6 25.6l62 72.4H328c-9.1 0-17.4 5.1-21.5 13.3s-3.2 17.9 2.3 25.1L376 400H248z"
        }
    ]
};

const FarTrees = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrees",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.4 15.1c16-19 45.2-19 61.2 0l115.8 137.4c6 7.1 7.3 17.1 3.4 25.6S345.4 192 336 192h-14.1l64.8 81c5.8 7.2 6.9 17.1 2.9 25.4S377.2 312 368 312h-25.7l62.1 88h3.6V216c0-13.3 10.7-24 24-24s24 10.7 24 24v184h113.7l-69.3-98.2c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13h22.1l-64.8-81c-5.8-7.2-6.9-17.1-2.9-25.4s12.4-13.6 21.6-13.6h12.4L432 53.3l-59.9 71.1-32.2-36.3 61.5-73c16-19 45.2-19 61.2 0l115.8 137.4c6 7.1 7.3 17.1 3.4 25.6S569.4 192 560 192h-14.1l64.8 81c5.8 7.2 6.9 17.1 2.9 25.4S601.2 312 592 312h-25.7l69.3 98.2c5.2 7.3 5.8 16.9 1.7 24.9s-12.3 13-21.3 13H456v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H232v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H24c-9 0-17.2-5-21.3-13s-3.5-17.6 1.7-24.9L73.7 312H48c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64.8-81H80c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.4 3.4-25.6L177.4 15.1zM256 400h89.7l-69.3-98.2c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13h22.1l-64.8-81c-5.8-7.2-6.9-17.1-2.9-25.4s12.4-13.6 21.6-13.6h12.4L208 53.3 131.6 144H144c9.2 0 17.6 5.3 21.6 13.6s2.9 18.2-2.9 25.4l-64.8 81H120c9 0 17.2 5 21.3 13s3.5 17.6-1.7 24.9L70.3 400H184V216c0-13.3 10.7-24 24-24s24 10.7 24 24v184h24z"
        }
    ]
};

const FarTriangleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTriangleExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5 0 8-6.5 14.5-14.5 14.5h-387c-8 0-14.5-6.5-14.5-14.5 0-2.7.7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5 0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96z"
        }
    ]
};

const FarTriangleInstrument = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTriangleInstrument",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v43.3c-21.3 5.9-40 19.5-52.1 38.7L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94h324c51.9 0 94-42.1 94-94 0-17.8-5-35.2-14.5-50.2L448.2 239l-34.8 34.8 75.5 119.5c4.6 7.4 7.1 15.9 7.1 24.6 0 25.4-20.6 46-46 46H126c-25.4 0-46-20.6-46-46 0-8.7 2.5-17.2 7.1-24.6l165.3-261.7c7.7-12.2 21.1-19.6 35.6-19.6s27.9 7.4 35.6 19.6l46 72.9-62.8 62.8c-5.9-2.1-12.2-3.2-18.8-3.2-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l55.1-55.1 34.8-34.8L537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-98.6 98.6-40.4-63.7C352 86.8 333.3 73.2 312 67.3V24z"
        }
    ]
};

const FarTrianglePersonDigging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrianglePersonDigging",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M70.3 464 320 55.3 570.2 464H70.3zM285.9 19.1l-264 432c-7.5 12.3-7.8 27.8-.8 40.4S41.5 512 56 512h528.5c14.5 0 27.8-7.8 34.9-20.4s6.8-28.1-.8-40.4L354.1 19.1C346.8 7.2 333.9 0 320 0s-26.9 7.3-34.1 19.1zM312 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm36.5 100.1-19.7-49.2c-8.4-21.1-28.9-34.9-51.6-34.9-18.6 0-35.9 9.3-46.3 24.8l-4.2 6.4c-2.5 3.7-3.3 8.2-2.3 12.5s3.8 8 7.6 10.2l153.5 88.6-15.2 25.4c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1h96c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-48-80c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8L402 355l-53.5-30.9zm-131.6-3.4-7.5 16.8-32 72c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l24.5-55.2 40.9 25.6V416c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-5.5-2.8-10.6-7.5-13.6l-64-40-15.6-9.8z"
        }
    ]
};

const FarTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTriangle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5 0 8-6.5 14.5-14.5 14.5h-387c-8 0-14.5-6.5-14.5-14.5 0-2.7.7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5 0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3z"
        }
    ]
};

const FarTricycleAdult = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTricycleAdult",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 88c0-13.3 10.7-24 24-24h38.9c18.7 0 36.2 9.4 46.6 24.9l114.9 172.4c9.9-3.4 20.5-5.3 31.6-5.3 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-24.6 9.3-47 24.5-64l-13.4-20.1-39.8 53.1c-14.7 19.5-37.7 31.1-62.1 31.1-5 0-10-.5-14.9-1.4L287.2 340c.5 4 .8 8.1.8 12.2 0 53-43 96-96 96-17.5 0-33.9-4.7-48-12.8.6-.4 1.3-.8 1.9-1.1-14.5 8.9-31.6 14-49.9 14-53 0-96-43-96-96 0-24.4 9.1-46.6 24-63.5l-4.6-.9c-13-2.5-21.5-15.1-19-28.2s15.1-21.5 28.2-19l322.9 63c1.9.4 3.8.5 5.7.5 9.3 0 18.1-4.4 23.7-11.9l50-66.6-73.3-110c-1.5-2.2-4-3.6-6.7-3.6H312c-13.3 0-24-10.7-24-24zM186.6 320.2c3.5 10 5.4 20.7 5.4 31.8 0 16.9-4.3 32.7-12 46.5 3.8 1 7.8 1.5 12 1.5 26.5 0 48-21.5 48-48 0-8.1-2-15.8-5.6-22.5l-47.8-9.3zM48.7 97.1c12.6-4 26.1 2.9 30.2 15.5l15.3 47.9c2.7 8.3 9.7 14.6 18.3 16.2l84.1 16.4c13 2.5 21.5 15.1 19 28.2s-15.1 21.5-28.2 19l-84.1-16.4c-25.8-5-46.8-23.7-54.8-48.7l-15.4-47.9c-4-12.6 2.9-26.1 15.5-30.2zM144 352a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm448 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarTricycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTricycle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h73.6c7.9 0 14.4 6.4 14.4 14.4 0 4.2-1.8 8.2-5 10.9l-42.6 36.5c-.8.7-1.6 1.4-2.3 2.2h-10.9c-58.8 0-114 23.9-154.1 64.6L133.6 176h2.4c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h21.6l44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112 112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4 30.7-48.1 84-77.6 141.6-77.6h12.1l11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-2.4 0-4.8.1-7.2.2l-13.9-55.6 31.3-26.9C408 129.9 416 112.6 416 94.4c0-34.5-27.9-62.4-62.4-62.4H280zm62.2 251.8 18.5 74c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1l-18.5-74c42 2.5 75.2 37.3 75.2 79.9 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-28.9 15.3-54.2 38.2-68.2zM112 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarTrillium = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrillium",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M203.3 16.2c11.8-11 29.8-11 41.5 0C256.9 27.5 277.9 48.7 296 75c17.9 26 34.2 58.9 34.2 93.4 0 7.3-.8 14.5-2.2 21.5 7.3 2.3 14.4 5.3 21.2 9.3 29.9 17.2 50.4 47.6 64.2 75.9 13.9 28.7 21.9 57.3 25.7 73.5 3.8 15.8-5.4 31.5-20.9 36.1-16 4.8-44.9 12.2-76.8 14.6-31.5 2.3-68.3-.1-98.2-17.2-7-4-13.4-8.7-19.1-14-5.7 5.3-12.1 10-19.1 14-29.9 17.2-66.7 19.6-98.2 17.2-31.9-2.4-60.9-9.8-76.8-14.6-15.7-4.7-24.9-20.3-21.2-36.2 3.8-16.2 11.8-44.8 25.7-73.5 13.7-28.3 34.2-58.8 64.2-75.9 6.9-3.9 14-7 21.3-9.3-1.4-6.9-2.2-14.1-2.2-21.4 0-34.4 16.4-67.4 34.2-93.4 18.1-26.3 39.1-47.5 51.2-58.8zm122 224.5c-6.9-4-14.2-6.3-21.6-7.3-9.9-1.3-18.6-7-23.6-15.6s-5.8-19-2-28.2c2.7-6.6 4.1-13.7 4.1-21.3 0-20.1-10-43.2-25.8-66.2-10.5-15.2-22.4-28.7-32.4-39-9.9 10.2-21.9 23.8-32.4 39.1-15.8 23-25.8 46.1-25.8 66.2 0 7.6 1.5 14.7 4.1 21.3 3.7 9.2 3 19.6-2 28.2s-13.8 14.3-23.6 15.6c-7.4.9-14.8 3.3-21.7 7.3-17.6 10.1-32.8 30.3-44.9 55.2-8 16.6-13.9 33.5-17.8 47.1 13.9 3.4 31.7 6.9 50.3 8.3 27.9 2.1 53.1-.9 70.8-11 7.1-4.1 12.9-9.3 17.4-15.4 6-8 15.5-12.8 25.6-12.8s19.5 4.7 25.6 12.8c4.5 6 10.4 11.3 17.4 15.4 17.6 10.1 42.9 13.1 70.8 11 18.6-1.4 36.4-4.9 50.3-8.3-4-13.6-9.8-30.5-17.8-47.1-12.1-25-27.3-45.1-44.9-55.2zM100.8 123.4c-3 11.8-4.8 24.1-4.8 36.6 0 6.2.4 12.3 1.3 18.3-7.8 2.7-15.4 6.1-22.7 10.3-9.9 5.7-18.8 12.6-26.9 20.2C19 182.7 5.6 157.6 0 144.3c-5.8-13.8 3-29.1 17.9-31 14.7-1.9 44.4-2.8 83 10zm249.9 55c.9-6 1.3-12.1 1.3-18.4 0-12.5-1.8-24.8-4.8-36.6 38.6-12.8 68.2-11.9 83-10 14.9 1.9 23.7 17.1 17.9 31-5.6 13.3-19 38.4-47.7 64.6-8.1-7.7-17.1-14.6-27-20.3-7.3-4.2-14.9-7.6-22.6-10.3zM205.1 497.1c-8.3-12.6-22.8-38.2-31-74.3 9.8-3.1 19.4-7.2 28.5-12.5 7.8-4.5 14.9-9.7 21.4-15.4 6.5 5.8 13.6 11 21.4 15.4 9.2 5.3 18.8 9.4 28.6 12.5-8.2 36.1-22.6 61.6-31 74.2-9.1 13.7-28.8 13.7-37.9 0zM184 240a40 40 0 1 1 80 0 40 40 0 1 1-80 0z"
        }
    ]
};

const FarTrophyStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrophyStar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176.9 48c6.4 160.7 44.3 231.4 71.8 261.7 13.7 15.1 25.9 21.4 33.1 24.1 2.6 1 4.7 1.5 6.1 1.9 1.4-.3 3.5-.9 6.1-1.9 7.2-2.7 19.4-9 33.1-24.1 27.5-30.3 65.5-101 71.8-261.7h-222zM176 0h224c26.5 0 48.1 21.8 47.1 48.2-.2 5.3-.4 10.6-.7 15.8H552c13.3 0 24 10.7 24 24 0 108.5-45.9 177.7-101.4 220.6-53.9 41.7-115.7 57.6-149.5 63.7-4.7 2.5-9.1 4.5-13.1 6.1V464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h80v-85.6c-4-1.6-8.4-3.6-13.1-6.1-33.8-6-95.5-22-149.5-63.7C45.9 265.7 0 196.5 0 88c0-13.3 10.7-24 24-24h105.6c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zm214.8 302.6c18.1-8 36.8-18.4 54.4-32 40.6-31.3 75.9-80.2 81.9-158.6h-84.4c-9.1 90.1-29.2 150.3-51.9 190.6zm-260-32c17.5 13.6 36.3 24 54.4 32-22.7-40.3-42.8-100.5-51.9-190.6H48.9c6 78.4 41.3 127.3 81.9 158.6zm164.4-168.1 14.5 29.3c1.2 2.4 3.4 4 6 4.4l32.4 4.7c6.6 1 9.2 9 4.4 13.6l-23.4 22.8c-1.9 1.8-2.7 4.5-2.3 7.1l5.5 32.2c1.1 6.5-5.7 11.5-11.6 8.4l-29-15.2c-2.3-1.2-5.1-1.2-7.4 0l-29 15.2c-5.9 3.1-12.7-1.9-11.6-8.4l5.5-32.2c.4-2.6-.4-5.2-2.3-7.1l-23.4-22.8c-4.7-4.6-2.1-12.7 4.4-13.6l32.4-4.7c2.6-.4 4.9-2 6-4.4l14.5-29.3c2.9-5.9 11.4-5.9 14.3 0z"
        }
    ]
};

const FarTrophy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrophy",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248.8 309.7c-27.6-30.3-65.5-101-71.8-261.7h222.1c-6.4 160.7-44.3 231.4-71.8 261.7-13.7 15.1-25.9 21.4-33.1 24.1-2.6 1-4.7 1.5-6.1 1.9-1.4-.3-3.5-.9-6.1-1.9-7.2-2.7-19.4-9-33.1-24.1zM400 0H176c-26.5 0-48.1 21.8-47.1 48.2.2 5.3.4 10.6.7 15.8H24C10.7 64 0 74.7 0 88c0 108.5 45.9 177.7 101.5 220.6 53.9 41.7 115.7 57.6 149.5 63.7 4.7 2.5 9.1 4.5 13.1 6.1V464H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80v-85.6c4-1.6 8.4-3.6 13.1-6.1 33.8-6 95.5-22 149.5-63.7C530.1 265.7 576 196.5 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2.5-10.4.7-15.8C448.1 21.8 426.5 0 400 0zm42.7 112h84.4c-6 78.4-41.3 127.3-81.9 158.6-17.5 13.6-36.3 24-54.4 32 22.7-40.3 42.8-100.5 51.9-190.6zM185.2 302.6c-18.1-8-36.8-18.4-54.4-32-40.6-31.3-75.9-80.2-81.9-158.6h84.4c9.1 90.1 29.2 150.3 51.9 190.6z"
        }
    ]
};

const FarTrowelBricks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrowelBricks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240.8 4.8c-9.4-5.8-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4S256 235.1 256 224v-72h89c3.6 13.8 16.1 24 31 24h88c26.5 0 48-21.5 48-48s-21.5-48-48-48h-88c-14.9 0-27.4 10.2-31 24h-89V32c0-11.1-5.7-21.4-15.2-27.2zM288 384h176v80H256v-80h32zm-80 0v80H48v-80h160zm256-48H336v-64h128v64zm-176-64v64H48c-26.5 0-48 21.5-48 48v80c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-80c0-1.3-.1-2.7-.2-4 .1-1.3.2-2.7.2-4V272c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FarTrowel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrowel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m340.4 142 29.6 29.6 87.9-87.9c8.2-8.2 8.2-21.4 0-29.6s-21.4-8.2-29.6 0L340.4 142zM491.8 20.2c26.9 26.9 26.9 70.5 0 97.5l-95.4 95.4c-14.6 14.6-38.2 14.6-52.8 0l-5.4-5.4L237.9 308l75 75c5.9 5.9 8.3 14.5 6.4 22.6s-8 14.6-15.9 17.2l-272 88c-8.6 2.8-18 .5-24.4-5.9s-8.6-15.8-5.9-24.4l88-272c2.6-7.9 9.1-14 17.2-15.9s16.7.5 22.6 6.4l75 75 100.4-100.2-5.4-5.4c-14.6-14.6-14.6-38.2 0-52.8l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0zm-240.5 369L122.8 260.7l-61.5 190 190-61.5z"
        }
    ]
};

const FarTruckArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h12.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H352c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zm416 464c-53 0-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v32h42.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96h142zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM241 95l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H112c-13.3 0-24-10.7-24-24s10.7-24 24-24h134.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FarTruckBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h288zm32 368c0 53 43 96 96 96s96-43 96-96h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V245.3c0-14.9-5.9-29.1-16.4-39.6l-93.3-93.3A55.924 55.924 0 0 0 458.7 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64 0 53 43 96 96 96s96-43 96-96h128zm173.7-176.4.4.4H416v-96h42.7c2.1 0 4.2.8 5.7 2.3l93.3 93.3zM112 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM267.2 84.6c-5.3-5.2-13.4-6.1-19.7-2.2l-128 80c-6.1 3.8-8.9 11.1-6.9 18S120.8 192 128 192h51.7l-33.5 55.8c-3.8 6.3-2.8 14.5 2.5 19.6s13.4 6.1 19.7 2.2l128-80c6.1-3.8 8.9-11.1 6.9-18s-8.2-11.6-15.4-11.6h-51.6l33.5-55.8c3.8-6.3 2.8-14.5-2.5-19.6z"
        }
    ]
};

const FarTruckClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h12.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H352c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zm416 464c-53 0-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v32h42.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96h142zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM96 192a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm112-64c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-32c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarTruckContainerEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckContainerEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 168c0-13.3 10.7-24 24-24h72.8c16.8 0 32.7 7.5 43.3 20.5l58.9 71.9c5.8 7.1 9 16.1 9 25.3V368c0 17.7-14.3 32-32 32 0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h160V168zm103 26.9c-1.5-1.9-3.8-2.9-6.2-2.9H480v64h105l-50-61.1zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-288-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarTruckContainer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckContainer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 104c0-39.8 32.2-72 72-72h256c39.8 0 72 32.2 72 72v184c0 13.3-10.7 24-24 24s-24-10.7-24-24V104c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v184c0 13.3-10.7 24-24 24S0 301.3 0 288V104zm608 296c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h160V168c0-13.3 10.7-24 24-24h72.8c16.8 0 32.7 7.5 43.3 20.5l58.9 71.9c5.8 7.1 9 16.1 9 25.3V368c0 17.7-14.3 32-32 32zm-23-144-50-61.1c-1.5-1.9-3.8-2.9-6.2-2.9H480v64h105zM136 136v128c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0v128c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0v128c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24s24 10.7 24 24zm216 296a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-288-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarTruckDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckDroplet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h12.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H352c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zm416 464c-53 0-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v32h42.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96h142zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM208 272c-39.8 0-72-29.6-72-66 0-27 39.4-82.9 59.9-110.3 6.1-8.2 18.1-8.2 24.2 0C240.6 123 280 179 280 206c0 36.5-32.2 66-72 66z"
        }
    ]
};

const FarTruckFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckFast",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48H128c-8.8 0-16 7.2-16 16v32h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V64c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v32h42.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96V288h48v44.8c14.1-8.2 30.5-12.8 48-12.8 35.5 0 66.6 19.3 83.2 48H352c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zm205.7 191.6-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96h142l-.2-.2-.2-.2zM208 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM48 160h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FarTruckFieldUn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckFieldUn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 80c-8.8 0-16 7.2-16 16v240h12.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H352V96c0-8.8-7.2-16-16-16H80zM16 336v-52.3C6.4 278.2 0 267.8 0 256v-96c0-11.8 6.4-22.2 16-27.7V96c0-35.3 28.7-64 64-64h256c29.8 0 54.9 20.4 62 48h37.7c21.7 0 41.4 12.5 50.7 32.2l52.3 111.2.3.7h5c35.3 0 64 28.7 64 64v48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H16v-1.4C6.7 379.3 0 370.5 0 360s6.7-19.3 16-22.6V336zm96 48a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm288-160h85.9l-43-91.4c-1.3-2.8-4.1-4.6-7.2-4.6H400v96zm80 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FarTruckField = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckField",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 80c8.8 0 16 7.2 16 16v240H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H64V96c0-8.8 7.2-16 16-16h256zM16 283.7v53.7C6.7 340.7 0 349.5 0 360s6.7 19.3 16 22.6v1.4h48c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-48c0-35.3-28.7-64-64-64h-5l-.3-.7-52.3-111.1c-9.2-19.6-29-32.2-50.7-32.2H398c-7.1-27.6-32.2-48-62-48H80c-35.3 0-64 28.7-64 64v36.3C6.4 137.8 0 148.2 0 160v96c0 11.8 6.4 22.2 16 27.7zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm325.9-112H400v-96h35.7c3.1 0 5.9 1.8 7.2 4.6l43 91.4zM528 384a48 48 0 1 1-96 0 48 48 0 1 1 96 0z"
        }
    ]
};

const FarTruckFlatbed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckFlatbed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 120c0-13.3 10.7-24 24-24h66.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h52.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H368V120zm189.7 119.6-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96h142l-.2-.2-.2-.2zM208 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarTruckFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckFront",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 48c-17.7 0-32 14.3-32 32v152c4.2-3.2 8.7-6.1 13.3-8.7l40-85.8c11.9-25.3 37.3-41.5 65.3-41.5h178.8c28 0 53.4 16.2 65.2 41.6l40 85.8c4.6 2.6 9.1 5.5 13.3 8.7V80c0-17.7-14.3-32-32-32H80zM48 328v40c0 17.7 14.3 32 32 32h352c17.7 0 32-14.3 32-32v-40c0-39.8-32.2-72-72-72H120c-39.8 0-72 32.2-72 72zm-48 0V80C0 35.8 35.8 0 80 0h352c44.2 0 80 35.8 80 80v288c0 26.2-12.6 49.4-32 64v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H80v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56c-19.4-14.6-32-37.8-32-64v-40zm121.4-120h269.2l-23.4-50.1c-3.9-8.4-12.4-13.9-21.7-13.9H166.6c-9.3 0-17.8 5.4-21.7 13.9L121.4 208zM96 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarTruckMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckMedical",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h12.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H352c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zm416 464c-53 0-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v32h42.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96h142zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM176 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48V96z"
        }
    ]
};

const FarTruckMonster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckMonster",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 48h88.2c2.5 0 4.8 1.2 6.3 3.1l46.9 60.9H272V56c0-4.4 3.6-8 8-8zm202 64-69.4-90.1A55.99 55.99 0 0 0 368.2 0H280c-30.9 0-56 25.1-56 56v56H120c-48.6 0-88 39.4-88 88v30.3c-6.1 5.1-12 10.6-17.5 16.4-9.1 9.6-8.7 24.8 1 33.9s24.8 8.7 33.9-1c27.8-29.3 67-47.6 110.6-47.6 53.3 0 100.3 27.5 127.4 69.1 4.4 6.8 12 10.9 20.1 10.9h24.9c8.1 0 15.7-4.1 20.1-10.9C379.7 259.5 426.7 232 480 232c43.6 0 82.8 18.3 110.5 47.7 9.1 9.6 24.3 10.1 33.9 1s10.1-24.3 1-33.9c-5.5-5.8-11.3-11.3-17.5-16.4V200c0-48.6-39.4-88-88-88H482zm78 88.6c-24.5-10.7-51.6-16.6-80-16.6-65.4 0-123.5 31.5-160 80-36.5-48.5-94.5-80-160-80-28.4 0-55.5 5.9-80 16.6v-.6c0-22.1 17.9-40 40-40h400c22.1 0 40 17.9 40 40v.6zM152 256c-12.1 0-22.1 8.9-23.8 20.6-7.6 2.2-14.9 5.3-21.7 9-9.4-7.1-22.8-6.3-31.3 2.3l-11.4 11.2c-8.6 8.6-9.3 21.9-2.3 31.3-3.7 6.9-6.8 14.1-9 21.8C40.9 353.9 32 363.9 32 376v16c0 12.1 8.9 22.1 20.6 23.8 2.2 7.6 5.3 14.9 9 21.8-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2 6.8 3.7 14.1 6.8 21.7 9C129.9 503 139.9 512 152 512h16c12.1 0 22.1-8.9 23.8-20.6 7.6-2.2 14.9-5.3 21.7-9 9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3 3.7-6.8 6.8-14.1 9-21.7 11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8-2.2-7.6-5.3-14.9-9-21.7 7-9.4 6.3-22.8-2.3-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3-6.8-3.7-14.1-6.8-21.7-9-1.7-11.7-11.7-20.6-23.8-20.6h-16zm8 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm312-80c-12.1 0-22.1 8.9-23.8 20.6-7.6 2.2-14.9 5.3-21.7 9-9.4-7.1-22.8-6.3-31.3 2.3l-11.3 11.3c-8.6 8.6-9.3 21.9-2.2 31.3-3.7 6.9-6.8 14.1-9 21.8-11.8 1.6-20.7 11.6-20.7 23.7v16c0 12.1 8.9 22.1 20.6 23.8 2.2 7.6 5.3 14.9 9 21.8-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2 6.8 3.7 14.1 6.8 21.7 9 1.7 11.6 11.7 20.6 23.8 20.6h16c12.1 0 22.1-8.9 23.8-20.6 7.6-2.2 14.9-5.3 21.8-9 9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3 3.7-6.8 6.8-14.1 9-21.7 11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8-2.2-7.6-5.3-14.9-9-21.7 7-9.4 6.3-22.8-2.2-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3-6.9-3.7-14.1-6.8-21.8-9-1.6-11.7-11.6-20.6-23.7-20.6h-16zm8 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarTruckMoving = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckMoving",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 80c-13.3 0-24 10.7-24 24v222.7c9.8-4.3 20.6-6.7 32-6.7 26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h160V104c0-13.3-10.7-24-24-24H72zm136 400c-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80V104c0-39.8 32.2-72 72-72h336c39.8 0 72 32.2 72 72v40h48.8c16.8 0 32.7 7.5 43.3 20.5l58.9 71.9c5.8 7.1 9 16.1 9 25.3V368c0 17.7-14.3 32-32 32 0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80zm327-285.1c-1.5-1.9-3.8-2.9-6.2-2.9H480v64h105l-50-61.1zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-288-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarTruckPickup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckPickup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 88v88h174.9l-72.2-92.9c-1.5-1.9-3.8-3.1-6.3-3.1H280c-4.4 0-8 3.6-8 8zm140.6-34.4L507.7 176H552c30.9 0 56 25.1 56 56v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-57.3c.9 5.2 1.3 10.5 1.3 16 0 53-43 96-96 96s-96-43-96-96c0-5.5.5-10.8 1.3-16h-98.6c.9 5.2 1.3 10.5 1.3 16 0 53-43 96-96 96s-96-43-96-96c0-5.5.5-10.8 1.3-16H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-88c0-30.9 25.1-56 56-56h136V88c0-30.9 25.1-56 56-56h88.3c17.3 0 33.6 8 44.2 21.6zM96 320h8.4c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32h144.8c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32H560v-88c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v88h16zm128 64a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm240 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarTruckPlane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckPlane",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.3 18.7C192.9 8.8 206.6 0 224 0c17.4 0 31.2 8.6 41.1 18.7 9.7 9.9 17 22.6 22.4 34.9 7.8 17.9 13 38.3 15.3 56-23.5 14.1-40.5 37.9-45.3 65.9-.9-2.6-1.4-5.3-1.4-8.1V128c0-13.6-4.2-36.3-12.5-55.2-4.1-9.4-8.5-16.3-12.7-20.6-4-4.1-6.2-4.2-6.8-4.2-.2 0-2.2 0-6.3 4.2-4.2 4.3-8.7 11.3-12.9 20.7-8.4 19-12.8 41.7-12.8 55.1v39.4c0 7.3-3.3 14.2-9 18.8L53.7 289.3c-.7.5-1.3 1-2 1.5-2.3 1.5-3.7 4-3.7 6.7v28.7l111-44.8c7.4-3 15.8-2.1 22.4 2.4s10.6 11.9 10.6 19.9V376c0 7.6-3.6 14.7-9.6 19.2L128 436v23.9c6.8-2.1 15.3-4.6 24.3-7.3 22.6-6.8 49.1-14.8 64.6-19.6 4.6-1.4 9.5-1.4 14.1 0 9.1 2.8 21.9 6.7 35.5 10.8 5.4 10.5 12.7 19.9 21.4 27.7V488c0 4.4.5 8.7 1.5 12.9l-7.6-2.3c-19.5-5.9-42-12.6-57.9-17.5-15.9 4.9-38.4 11.6-57.9 17.5-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4.7-.6.2h-.2l-6.9-23 6.9 23c-2.2.7-4.5 1-6.9 1C97 512 80 495 80 474.1V432c0-12.6 5.9-24.4 16-32l48-36v-24.8l-90.1 36.4c-.5.2-1.1.4-1.7.6-25.8 8.2-52.2-11-52.2-38.1v-40.6c0-18.6 9.2-36 24.6-46.4L144 155.8V128c0-20.7 6.1-50 16.9-74.5 5.5-12.3 12.8-24.9 22.4-34.8zM288 192c0-16.2 6-31.1 16-42.3 11.7-13.3 28.9-21.7 48-21.7h224c35.3 0 64 28.7 64 64v208c0 23.7-12.9 44.4-32 55.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-24H368v24c0 13.3-10.7 24-24 24-2.1 0-4.2-.3-6.1-.8-4.9-1.3-9.2-4.1-12.3-7.9-3.4-4.2-5.5-9.5-5.5-15.3v-32.6c-15.5-9-26.9-24.3-30.7-42.4-.9-4.2-1.3-8.5-1.3-13V192zm112 112h144l-11.9-37c-2.5-6.5-8.4-11-15.3-11H411.2c-6.9 0-12.9 4.5-15.3 11l-1.6 5-4.4 13.8L384 304h16zm-50.3-50.3.5-1.4.4-1.2.5-1.2c.2-.6.5-1.2.7-1.8 3.6-8.7 9.2-16.7 16.3-23.3 3.5-3.3 7.5-6.2 11.7-8.6 9.1-5.2 19.8-8.3 31.5-8.3h105.5c28.8 0 51.4 18.7 60.2 41.9l.5 1.2.4 1.2 11.9 37 2.3 7.2V192c0-8.8-7.2-16-16-16H352c-5.7 0-10.6 2.9-13.5 7.4-1.6 2.5-2.5 5.4-2.5 8.6v104.5l2.3-7.2 11.4-35.6zm95.8 98.3H360c-5.1 0-9.8 1.6-13.7 4.3-6.2 4.3-10.3 11.5-10.3 19.7v24c0 8.3 6.3 15.1 14.4 15.9.5.1 1.1.1 1.6.1h224c8.8 0 16-7.2 16-16v-24c0-13.3-10.7-24-24-24H445.5zM368 406.6a24 24 0 1 1 16-45.3 24 24 0 1 1-16 45.3zM552 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarTruckPlow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckPlow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 80h86.1c2.8 0 5.4 1.5 6.8 3.8L343 192H176V88c0-4.4 3.6-8 8-8zm214.6 112c-.6-1.5-1.3-3.1-2.2-4.5L317.8 58.8C307.7 42.2 289.6 32 270.1 32H184c-30.9 0-56 25.1-56 56v104H56c-30.9 0-56 25.1-56 56v96c0 19.4 13.7 35.5 32 39.2v.8c0 53 43 96 96 96s96-43 96-96h48c0 53 43 96 96 96s96-43 96-96h54.1l.1.1 80 88c8.9 9.8 24.1 10.5 33.9 1.6s10.5-24.1 1.6-33.9L560 358.7V217.3l73.8-81.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6l-80 88c-4 4.4-6.2 10.2-6.2 16.1v128H480v-88c0-30.9-25.1-56-56-56h-25.4zM432 312.4c-17-15.2-39.4-24.4-64-24.4-35.5 0-66.6 19.3-83.2 48h-73.6c-16.6-28.7-47.6-48-83.2-48-33.4 0-62.8 17-80 42.9V248c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v64.4zM80 384a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm288-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarTruckRampBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckRampBox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 88c0-48.6 39.4-88 88-88h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-22.1 0-40 17.9-40 40v272.7l25.7-7 .4-.1c17.6-38.7 56.7-65.6 102-65.6 61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.8 0-108.7-46.9-111.8-106l-386 105.2c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5L352 373.8V88zm240 312a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2l-154.6 41.5c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
        }
    ]
};

const FarTruckRampCouch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckRampCouch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 88c0-48.6 39.4-88 88-88h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-22.1 0-40 17.9-40 40v272.7l25.7-7 .4-.1c17.6-38.7 56.7-65.6 102-65.6 61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.8 0-108.7-46.9-111.8-106l-386 105.2c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5L352 373.8V88zm240 312a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM294.5 209.2c8.7-2.3 17.4-2.1 25.5.2v125.4l-38.7 10.4-154.6 41.4-61.8 16.6c-17.1 4.6-34.6-5.6-39.2-22.6l-12.4-46.4c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5-11 2.9-20.8 8-29.2 14.7L8 252.8z"
        }
    ]
};

const FarTruckRamp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckRamp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M440 0c-48.6 0-88 39.4-88 88v285.8l-334.3 91C4.9 468.3-2.6 481.5.8 494.3s16.7 20.3 29.5 16.8L416.2 406c3.1 59.1 52 106 111.8 106 61.9 0 112-50.1 112-112s-50.1-112-112-112c-45.3 0-84.3 26.9-102 65.6l-.4.1-25.7 7V88c0-22.1 17.9-40 40-40H616c13.3 0 24-10.7 24-24S629.3 0 616 0H440zm88 336a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarTruckTow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruckTow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64v96c0 26.5-21.5 48-48 48S0 186.5 0 160v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-11.8 6.4-22.2 16-27.7C84.7 1.6 90.2 0 96 0h49.7c9.1 0 17.8 3.9 23.9 10.7L373.3 240H384v-88c0-30.9 25.1-56 56-56h50.1c20.9 0 40.7 9.1 54.4 24.8l81.8 94.4c8.8 10.2 13.7 23.2 13.7 36.7V360c0 30.9-25.1 56-56 56h-8c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96h-8c-30.9 0-56-25.1-56-56v-64c0-30.9 25.1-56 56-56h128L96 64zm147.2 304h153.6c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H584c4.4 0 8-3.6 8-8v-72H56c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h20.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48zM145.8 56.3 237.7 240h71.4L145.8 56.3zM584.2 240l-76-87.7c-4.6-5.3-11.2-8.3-18.1-8.3H440c-4.4 0-8 3.6-8 8v88h152.2zM208 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarTruck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTruck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h288zm32 368c0 53 43 96 96 96s96-43 96-96h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V245.3c0-14.9-5.9-29.1-16.4-39.6l-93.3-93.3A55.924 55.924 0 0 0 458.7 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64 0 53 43 96 96 96s96-43 96-96h128zm173.7-176.4.4.4H416v-96h42.7c2.1 0 4.2.8 5.7 2.3l93.3 93.3zM112 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FarTrumpet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTrumpet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M592 128.7v222.6c-10-10.5-21.8-22-35.2-33.2C519.9 287.4 467.9 256 408 256H48v-32h360c59.9 0 111.9-31.4 148.8-62.2 13.4-11.2 25.2-22.6 35.2-33.2zM352 304v112h-40V304h40zm48 112V304h8c43.4 0 84.6 23.1 118 51 33 27.6 55.5 57.3 61 64.9 5.7 7.9 14.6 12.1 23.7 12.1 16.2 0 29.2-13.1 29.2-29.2V77.2c.1-16.1-13-29.2-29.1-29.2-9.1 0-18.1 4.2-23.7 12.1-5.5 7.6-27.9 37.3-61 64.9-33.4 27.9-74.6 51-118 51h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H312v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8h-40v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H48v-8c0-13.3-10.7-24-24-24S0 154.7 0 168v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h32.3C70 320.2 64 339.4 64 360c0 57.4 46.6 104 104 104h240c49.6 0 91-34.7 101.5-81.1l-3.9-3.3c-13.7-11.4-27.9-21.2-42.3-28.6.5 2.9.7 5.9.7 9 0 30.9-25.1 56-56 56h-8zm-136 0h-40V304h40v112zm-88 0h-8c-30.9 0-56-25.1-56-56s25.1-56 56-56h8v112z"
        }
    ]
};

const FarTtyAnswer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTtyAnswer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.2-.4h-.1c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zm133.8 78.1-100.4-43-29.4 35.8c-14.9 18.2-40.8 22.9-61.2 11.1-53.3-30.9-97.7-75.3-128.6-128.6-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4-99.1 21.4c3.4 215.7 177.7 390 393.4 393.5l21.3-99.2zM304 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM400 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm-176-16h128c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FarTty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M370 188.8v25.9l76.6 16.9 15.8-53.4c3.3-11.2-.3-17.4-2.5-19.4C421 123.4 349.4 80 256 80S91 123.4 52.1 158.6c-2.2 2-5.8 8.2-2.5 19.4l15.8 53.4 76.6-16.8v-25.8c0-19.5 11.8-37.1 29.9-44.5 53.9-21.9 114.2-21.9 168.1 0 18.1 7.4 29.9 24.9 29.9 44.5zm-48 25.9v-25.9c-42.3-17.2-89.7-17.2-132 0v25.9c0 22.5-15.7 42-37.7 46.9l-76.6 16.8c-24.6 5.4-49.2-9.1-56.4-33.3L3.5 191.7c-7.2-24.5-2.6-51.4 16.3-68.6C64.9 82.2 147.6 32 256 32s191.1 50.2 236.2 91.1c18.9 17.2 23.5 44.1 16.3 68.6l-15.8 53.4c-7.1 24.2-31.8 38.7-56.4 33.3l-76.6-16.9c-22-4.8-37.7-24.3-37.7-46.9zM32 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-32zm0 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-32zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-304 16c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16v-32z"
        }
    ]
};

const FarTugrikSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTugrikSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h144v125.3L58.2 232.7c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l98.2-24.6v46.5L58.2 328.7c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l98.2-24.6V456c0 13.3 10.7 24 24 24s24-10.7 24-24V338.7l109.8-27.5c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L216 289.3v-46.6l109.8-27.5c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L216 193.3V80h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarTurkey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTurkey",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96 176 96 0 224 0 384c0 128 160 128 288 128s288 0 288-128c0-63-27.3-121.1-67.3-168.3-.4.2-.7.4-1 .6l-28.3 20c-3.2 2.3-6.2 5-9 8.3C505.8 285.7 528 334.2 528 384c0 21-6.1 32.8-13.9 41-8.9 9.4-23.9 18.1-47.3 24.8C418.6 463.6 354 464 288 464s-130.6-.4-178.8-14.2c-23.4-6.7-38.4-15.4-47.3-24.8-7.8-8.2-13.9-20-13.9-41 0-62 34.5-122 86-168.3 52.4-46.9 113.4-71.7 154-71.7 20.5 0 46.3 6.4 73.6 18.7-15.2.8-30.8-.5-45.8-2.1-28.5-3-58.2 4.9-82.2 24.3-48.1 38.9-55.5 109.4-16.6 157.5s109.4 55.5 157.5 16.6c18.6-15 31.1-34.8 37.2-56.2.2-.7.4-1.3.6-2 9.6-33.7 20.1-70.5 48.7-90.6l25.7-18.2 2.5-1.8c18.3-12.9 43.3-10.4 67.4-8 9.4.9 18.6 1.8 27.3 1.8 30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2 1.1-4.4 1.7-9 1.7-13.8 0-30.9-25.1-56-56-56s-56 25.1-56 56z"
        }
    ]
};

const FarTurkishLiraSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTurkishLiraSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 32c13.3 0 24 10.7 24 24v56.2l137.4-39.3c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7l-150.6 43v46.1l137.4-39.3c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7l-150.6 43V432h71.8c81.3 0 148.2-63.9 151.8-145.1l.4-8c.6-13.2 11.8-23.5 25.1-22.9s23.5 11.8 22.9 25.1l-.4 8C378.8 395.9 290.7 480 183.8 480H88c-13.3 0-24-10.7-24-24V271.8l-25.4 7.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l38.6-11v-46.1l-25.4 7.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l38.6-11V56c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarTurnDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTurnDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M6.5 271.6c-8.7 9.2-8.7 23.7 0 32.9l121.4 129c8.8 9.3 21 14.6 33.7 14.6 25.6 0 46.3-20.7 46.3-46.3v-41.7h144c88.4 0 160-71.6 160-160v-112c0-30.9-25.1-56-56-56h-32c-30.9 0-56 25.1-56 56v120c0 4.4-3.6 8-8 8h-152v-41.7c0-25.6-20.7-46.3-46.3-46.3-12.8 0-25 5.3-33.7 14.6L6.5 271.6zm153.5-93v61.5c0 13.3 10.7 24 24 24h176c30.9 0 56-25.1 56-56v-120c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v112c0 61.9-50.1 112-112 112H184c-13.3 0-24 10.7-24 24v61.5L57 288l103-109.5z"
        }
    ]
};

const FarTurnDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTurnDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505.5 271.6c8.7 9.2 8.7 23.7 0 32.9l-121.4 129c-8.8 9.3-21 14.6-33.7 14.6-25.6 0-46.3-20.7-46.3-46.3v-41.7h-144C71.6 360 0 288.4 0 200V88c0-30.9 25.1-56 56-56h32c30.9 0 56 25.1 56 56v120c0 4.4 3.6 8 8 8h152v-41.7c0-25.6 20.7-46.3 46.3-46.3 12.8 0 25 5.3 33.7 14.6l121.4 129zM352 178.5V240c0 13.3-10.7 24-24 24H152c-30.9 0-56-25.1-56-56V88c0-4.4-3.6-8-8-8H56c-4.4 0-8 3.6-8 8v112c0 61.9 50.1 112 112 112h168c13.3 0 24 10.7 24 24v61.5L455 288 352 178.5z"
        }
    ]
};

const FarTurnDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTurnDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175.6 505.5c9.2 8.7 23.7 8.7 32.9 0l129-121.4c9.3-8.8 14.6-21 14.6-33.7 0-25.6-20.7-46.3-46.3-46.3H264V160C264 71.6 192.4 0 104 0H56C25.1 0 0 25.1 0 56v32c0 30.9 25.1 56 56 56h56c4.4 0 8 3.6 8 8v152H78.3C52.7 304 32 324.7 32 350.3c0 12.8 5.3 25 14.6 33.7l129 121.4zM82.5 352H144c13.3 0 24-10.7 24-24V152c0-30.9-25.1-56-56-56H56c-4.4 0-8-3.6-8-8V56c0-4.4 3.6-8 8-8h48c61.9 0 112 50.1 112 112v168c0 13.3 10.7 24 24 24h61.5L192 455 82.5 352z"
        }
    ]
};

const FarTurnUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTurnUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175.6 6.5c9.2-8.7 23.7-8.7 32.9 0l129 121.4c9.3 8.8 14.6 21 14.6 33.7 0 25.6-20.7 46.3-46.3 46.3H264V352c0 88.4-71.6 160-160 160H56c-30.9 0-56-25.1-56-56v-32c0-30.9 25.1-56 56-56h56c4.4 0 8-3.6 8-8V208H78.3C52.7 208 32 187.3 32 161.7c0-12.8 5.3-25 14.6-33.7l129-121.5zM82.5 160H144c13.3 0 24 10.7 24 24v176c0 30.9-25.1 56-56 56H56c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h48c61.9 0 112-50.1 112-112V184c0-13.3 10.7-24 24-24h61.5L192 57 82.5 160z"
        }
    ]
};

const FarTurntable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTurntable",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm272-88c0-13.3-10.7-24-24-24s-24 10.7-24 24v135.7c0 6.7-1.7 13.3-4.9 19.2l-40.2 73.7c-6.3 11.6-2.1 26.2 9.6 32.6s26.2 2.1 32.6-9.6l40.2-73.7c7-12.9 10.7-27.4 10.7-42.1V136z"
        }
    ]
};

const FarTurtle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTurtle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 240v-32c0-70.7-57.3-128-128-128S80 137.3 80 208v32h256zm48-32v41.2c0 21.4-17.4 38.8-38.8 38.8H70.8C49.4 288 32 270.6 32 249.2V208c0-97.2 78.8-176 176-176s176 78.8 176 176zm96 80c-8.3 0-16.3-1.6-23.6-4.5C440.3 328 400.4 361 352 367v73c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-72h-32v72c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h312c44.2 0 80-35.8 80-80v-64c0-35.3 28.7-64 64-64 53 0 96 43 96 96v16c0 35.3-28.7 64-64 64h-32zm-208 80v64h32v-64h-32zm-160 0v64h32v-64h-32zm384-144a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FarTvMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTvMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 48c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h512zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm32 488c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zM416 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V96z"
        }
    ]
};

const FarTvRetro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTvRetro",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135 7c9.4-9.4 24.6-9.4 33.9 0l87 87L343 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55H432c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h110.1L135 41c-9.4-9.4-9.4-24.6 0-33.9zM80 144c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h352c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H80zm336 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24 104a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM144 192h160c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V240c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FarTv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTv",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h512c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h512c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm120 400h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FarTypewriter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarTypewriter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64c0-8.8 7.2-16 16-16h191.4c4.2 0 8.3 1.7 11.3 4.7l32.6 32.6c3 3 4.7 7.1 4.7 11.3V160h48V96.6c0-17-6.7-33.3-18.7-45.3l-32.6-32.6C368.7 6.7 352.4 0 335.4 0H144c-35.3 0-64 28.7-64 64v96h48V64zM0 224v32c0 17.7 14.3 32 32 32v160c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V288c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32H365.3c-8.5 0-16.6 3.4-22.6 9.4l-13.3 13.3c-6 6-14.1 9.4-22.6 9.4H205.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H32c-17.7 0-32 14.3-32 32zm80 64h352v160c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V288zm48 112v16c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm40-60a20 20 0 1 0-40 0 20 20 0 1 0 40 0zm52 20a20 20 0 1 0 0-40 20 20 0 1 0 0 40zm92-20a20 20 0 1 0-40 0 20 20 0 1 0 40 0zm52 20a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"
        }
    ]
};

const FarU = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarU",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32c13.3 0 24 10.7 24 24v232c0 79.5 64.5 144 144 144s144-64.5 144-144V56c0-13.3 10.7-24 24-24s24 10.7 24 24v232c0 106-86 192-192 192S0 394 0 288V56c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarUfoBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUfoBeam",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m152.5 163.3-16.9 17c-4-4-6.5-9.2-7-14.9-.6-7-.8-14-.5-20.7-22 6.7-40.3 14.6-53.9 23C52.5 181.2 48 192.2 48 197.9c0 4.1 2.2 11 12.6 20.2 10.4 9.1 26.8 18.4 49.1 26.7C154.2 261.3 217.2 272 288 272s133.8-10.7 178.3-27.2c22.3-8.3 38.7-17.6 49.1-26.7 10.4-9.2 12.6-16 12.6-20.2 0-5.7-4.5-16.7-26.2-30.1-13.7-8.4-31.9-16.3-53.9-23 .3 6.8.1 13.7-.5 20.7-.5 5.6-3 10.9-7 14.9l-16.9-17c16.9 17 16.9 17 16.9 17.1h-.1l-.1.1-.3.3-.7.7c-.6.5-1.3 1.1-2.1 1.9-1.8 1.5-4.2 3.3-7.3 5.5-6.3 4.3-15.4 9.7-27.7 14.9C377.4 214.2 340.3 224 288 224s-89.4-9.8-114.1-20.2c-12.3-5.2-21.4-10.6-27.7-14.9-3.1-2.2-5.6-4-7.3-5.5-.9-.7-1.6-1.4-2.1-1.9l-.7-.7-.3-.3-.1-.1 16.9-17.1zM49 126.9c24-14.8 55.6-26.7 91.7-35.2C165.7 36.3 224.3 0 288 0s122.3 36.3 147.3 91.7c36.1 8.6 67.8 20.4 91.7 35.2 26.1 16.1 49 39.7 49 70.9 0 23-12.6 41.9-28.9 56.2-16.3 14.4-38.6 26.2-64.1 35.7-51 19-120 30.3-195 30.3s-144-11.3-195-30.2c-25.4-9.5-47.7-21.3-64.1-35.7C12.6 239.8 0 220.8 0 197.9c0-31.2 22.9-54.8 49-70.9zm351 24c-.5-57.5-50.3-103-112-103s-111.4 45.5-112 103c3.8 2.4 9.3 5.5 16.7 8.6 18.4 7.8 49.1 16.4 95.3 16.4s76.9-8.6 95.3-16.4c7.4-3.1 12.9-6.2 16.7-8.6zM117.2 363.2l-72 136c-6.2 11.7-20.7 16.2-32.4 10s-16.2-20.7-10-32.4l72-136c6.2-11.7 20.7-16.2 32.4-10s16.2 20.7 10 32.4zm384-22.5 72 136c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-72-136c-6.2-11.7-1.7-26.2 10-32.4s26.2-1.7 32.4 10z"
        }
    ]
};

const FarUfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUfo",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176.6 246.3c-17.5 16.4-17.5 16.4-17.5 16.5v.1l.1.1.3.3.7.7c.6.5 1.3 1.2 2.2 2.1 1.8 1.6 4.3 3.7 7.6 6.2 6.6 4.8 16.1 10.9 29.1 16.8 26.1 11.9 65.3 23 120.8 23s94.7-11.1 120.8-23c13-5.9 22.6-12 29.1-16.8 3.3-2.4 5.8-4.5 7.6-6.2.9-.8 1.6-1.5 2.2-2.1l.7-.7.3-.3.1-.1v-.1l-17.5-16.5 17.5 16.4c3.7-3.9 6-9 6.4-14.4.5-5.8.7-11.6.6-17.2 30 8.9 54.6 19.9 72.5 31.8 24.1 16.2 31.5 30.9 31.5 41.6 0 7.9-3.8 17.7-15.8 29.1-12 11.5-30.8 23-55.8 33.1C470.3 387 399.4 400 320 400s-150.3-13-200.3-33.2c-25.1-10.1-43.8-21.6-55.8-33.1C51.8 322.2 48 312.4 48 304.5c0-10.7 7.4-25.4 31.5-41.6 17.9-12 42.4-23 72.5-31.8-.1 5.7.1 11.4.6 17.2.5 5.4 2.7 10.5 6.4 14.4l17.5-16.4zm302.8-67.2C456.8 110.9 392.6 64 320 64s-136.8 46.9-159.4 115.1c-42.7 10.5-80 25.4-107.8 44C23.4 242.9 0 270.2 0 304.5c0 25.1 12.7 46.7 30.7 63.9 17.9 17.1 42.6 31.4 71 42.9C158.8 434.3 236 448 320 448s161.2-13.7 218.3-36.7c28.5-11.5 53.1-25.8 71-42.9 18-17.1 30.7-38.7 30.7-63.9 0-34.3-23.4-61.7-52.8-81.4-27.8-18.6-65.1-33.5-107.8-44zM440 234.6c-4.1 2.9-10.4 6.8-19.1 10.8-19.6 8.9-52 18.7-100.9 18.7s-81.3-9.7-100.9-18.7c-8.7-4-15-7.9-19.1-10.8-.8-69.9 55-122.6 120-122.6s120.8 52.7 120 122.6zM152 312a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm192 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm168-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarUmbrellaBeach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUmbrellaBeach",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M399.7 18.8c1.3.5 2.6.9 4 1.4 4.1 1.5 8.1 3 12 4.7 103.7 43.7 164.6 148.9 155.7 256.9-1.6 19.2-21.5 30-39.6 23.4L349.7 239l-45.1-16.4-182.1-66.3c-18.1-6.6-26.4-27.7-15.3-43.4 64.2-90.8 182.8-132 292.6-94zM288.8 54.6C240.8 61 196.1 84.1 163 120l68.8 25c14.2-32.9 33.4-63.4 57-90.4zM413.3 211c9.4-32.5 13.2-66.4 11.2-100.2-1.1-18.2-12-34.2-28.2-41.9-3-1.2-6-2.4-9-3.5-1-.4-2-.7-2.9-1-18.2-5.9-38.3-.9-51.5 13.1-23.3 24.6-42.2 53.1-55.9 84L413.3 211zm45.2 16.4 65.5 23.9c-2.2-47-20.3-91.9-51-127.2.4 35-4.5 69.8-14.5 103.3zM552 464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h192.7l76.9-211.4 45.1 16.4-71 195H552z"
        }
    ]
};

const FarUmbrellaSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUmbrellaSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c13.3 0 24 10.7 24 24v9.1c119.6 11.1 215.3 104.5 230 223 2.2 17.5-12.4 31.9-30 31.9H32c-17.7 0-32.2-14.4-30-31.9 14.7-118.5 110.4-211.9 230-223V24c0-13.3 10.7-24 24-24zm202.4 240C436.8 148.3 354.3 80 256 80S75.2 148.3 53.6 240h404.8zM280 438.6c0 40.6-32.9 73.4-73.4 73.4-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1 14.1 0 25.4-11.4 25.4-25.4V320h48v118.6z"
        }
    ]
};

const FarUmbrella = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUmbrella",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c13.3 0 24 10.7 24 24v24.9c123.7 9.6 226.1 93 255.5 204.4.4 1.4.7 2.9 1.1 4.3 1.4 5.8 2.7 11.7 3.7 17.6.6 3.5 1.1 7.1 1.6 10.7 2 15.6-17.3 24.4-27.8 12.7-2.5-2.8-5.5-5.5-8.8-8-3.4-2.5-7.1-4.9-11.1-7l-.7-.4-.6-.3c-13.5-6.8-29.7-11-44.9-11-30.1 0-56.3 16.6-70 41.2-.5.9-1 1.7-1.4 2.6-2.1 4.1-3.8 8.3-5.1 12.8-.7 2.4-1.4 4.9-1.9 7.5-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9c-.5-2.5-1.1-5-1.9-7.5a94.8 94.8 0 0 0-5.1-12.8c-.5-.9-.9-1.8-1.4-2.6-13.7-24.6-39.9-41.2-70-41.2s-56.3 16.6-70 41.2c-.5.9-.9 1.7-1.4 2.6-2.1 4.1-3.8 8.3-5.1 12.8-.7 2.4-1.4 4.9-1.9 7.5-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9c-.5-2.5-1.1-5-1.9-7.5a94.8 94.8 0 0 0-5.1-12.8c-.5-.9-.9-1.8-1.4-2.6-13.7-24.5-39.9-41.1-70-41.1-15.2 0-31.4 4.2-44.9 11-.4.2-.9.5-1.3.7-4 2.1-7.7 4.4-11.1 7-3.3 2.5-6.3 5.2-8.8 8-10.5 11.7-29.8 2.8-27.8-12.8.5-3.6 1-7.2 1.6-10.7 1-5.9 2.3-11.8 3.7-17.6.4-1.4.7-2.9 1.1-4.3C37.9 141.9 140.3 58.6 264 48.9V24c0-13.3 10.7-24 24-24zm96 267.3c23.4-26.6 57.7-43.3 96-43.3 8.6 0 17.5.9 26.4 2.6C468.9 150.2 386.1 96 288 96S107.1 150.2 69.6 226.6c8.9-1.7 17.8-2.6 26.4-2.6 38.3 0 72.6 16.8 96 43.3 23.4-26.6 57.7-43.3 96-43.3s72.6 16.8 96 43.3zM288 304c8.7 0 16.9 2.3 24 6.4v128.2c0 40.6-32.9 73.4-73.4 73.4-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1 14.1 0 25.4-11.4 25.4-25.4V310.4c7.1-4.1 15.3-6.4 24-6.4z"
        }
    ]
};

const FarUnderline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUnderline",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 56c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24v144c0 61.9 50.1 112 112 112s112-50.1 112-112V80h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24v144c0 88.4-71.6 160-160 160S64 312.4 64 224V80H40c-13.3 0-24-10.7-24-24zM0 456c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FarUnicorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUnicorn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M426.8.6c1.7-.4 3.4-.6 5.2-.6h40.5c2.5 0 5 .1 7.5.3V0h56c13.3 0 24 10.7 24 24 0 8.5-4.4 16-11.1 20.3 3.5 6.1 6.3 12.7 8.3 19.7h73.5c5.1 0 9.3 4.2 9.3 9.3 0 4-2.6 7.6-6.4 8.8l-69.8 23.3 5.6 39.4c5.2 36.7-15.3 72.2-49.7 86-18.3 7.3-38 7.5-55.8 1.5v10c0 33.2-12.2 62.9-32 85.5V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48v-99.5l-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-12.1 32.3c-.6 1.6-.7 3.3-.2 5l14.8 53.3c8.5 30.6-14.5 60.8-46.2 60.8h-49.8c-21.6 0-40.5-14.4-46.2-35.2l-11.3-40.4c-8.6-31-7.2-63.9 4.1-94.1l8.2-21.7L72 265.9c-5.3-13.3-8-27.4-8-41.7 0-2.9.1-5.7.3-8.5A40.1 40.1 0 0 0 48 248v64c0 13.3-10.7 24-24 24S0 325.3 0 312v-64c0-47.3 37.3-85.9 84.1-87.9 20.3-29.1 54-48.1 92.1-48.1h117.1C309.8 51.5 362.6 6.1 426.8.6zM416 239v-55c0-10.2 6.4-19.3 16.1-22.6s20.3-.3 26.7 7.7l5.9 7.3c8.9 11.1 24.1 15.1 37.3 9.8 13.9-5.5 22.2-19.9 20-34.7l-9.9-69.2C509.3 62.6 492.4 48 472.5 48h-37.1c-.6.1-1.3.2-2 .2-50 3.1-90.5 41.6-96.6 90.8-1.5 12-11.7 21-23.8 21H176.2c-35.5 0-64.2 28.8-64.2 64.2 0 8.2 1.6 16.3 4.6 23.9l21.9 54.6c4.4 11.1 4.6 23.5.4 34.7l-8.2 21.7c-7.7 20.6-8.7 43.1-2.8 64.4l11.2 40.5h49.8l-14.8-53.3c-3.2-11.4-2.6-23.6 1.5-34.6l12.1-32.3c2.8-7.5 4.3-15.4 4.3-23.5V319c-.2-7.6 3.3-14.9 9.4-19.5s14-6.1 21.3-4l88 25.7c2.1.6 4.2 1.1 6.3 1.6 11.1 2.3 19 12.1 19 23.5V464h48V318.2c0-6.5 2.6-12.7 7.3-17.2 15.1-14.8 24.7-35.3 24.7-58.8V239zm48-159a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarUniformMartialArts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUniformMartialArts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M188.4 48c-26.3 0-50.4 14.3-63.1 37.3L58.9 206C51.7 219 48 233.6 48 248.4V392c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V248.4c0-6.7 1.7-13.4 5-19.3l62-112.8c5.3-9.6 16.4-14.4 27-11.7s18 12.3 18 23.2V288h-48v-66.6l-16 29.1V392c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V248.4c0-22.9 5.8-45.5 16.8-65.5L83.2 62.2C104.3 23.8 144.6 0 188.4 0h51.2c9 0 17.2 5 21.3 13L320 127.1 378.7 13C382.8 5 391 0 400 0h51.2c43.8 0 84.1 23.8 105.1 62.2l66.4 120.7c11 20.1 16.8 42.6 16.8 65.5V392c0 30.9-25.1 56-56 56H552c-30.9 0-56-25.1-56-56V250.5l-16-29.1V288h-48V128c0-11 7.4-20.5 18-23.2s21.7 2.1 27 11.7l62 112.8-21 11.6 21-11.6c3.2 5.9 5 12.5 5 19.3V392c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V248.4c0-14.8-3.7-29.4-10.9-42.4L514.7 85.3c-12.6-23-36.8-37.3-63.1-37.3h-.7.1-1.2.2-1.2.2-1.1.1-33.3l-73.4 142.5-50.1 97.5h-54L293 179.6 225.4 48h-34.5.1-1.2.2-1.2.2-.9zM160 384h48v64c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-64h48v64c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-64zm16-64h304v32H349.9l47.4 71.1c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-50.7-76-50.7 76c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l47.4-71.1H160v-32h16z"
        }
    ]
};

const FarUnion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUnion",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32c13.3 0 24 10.7 24 24v232c0 79.5 64.5 144 144 144s144-64.5 144-144V56c0-13.3 10.7-24 24-24s24 10.7 24 24v232c0 106-86 192-192 192S0 394 0 288V56c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarUniversalAccess = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUniversalAccess",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm161.5-86.1 11.9 5.1c26.1 11.2 54.2 17 82.7 17s56.5-5.8 82.7-17l11.9-5.1c12.2-5.2 26.3.4 31.5 12.6s-.4 26.3-12.6 31.5l-11.9 5.1c-17.3 7.4-35.2 12.9-53.6 16.3v50.1c0 4.3.7 8.6 2.1 12.6l28.7 86.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-24.4-73.2c-1.3-3.8-4.8-6.4-8.8-6.4s-7.6 2.6-8.8 6.4l-24.4 73.2c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4l28.7-86.1c1.4-4.1 2.1-8.3 2.1-12.6v-50c-18.4-3.5-36.3-8.9-53.6-16.3l-11.9-5.1c-12.2-5.2-17.8-19.3-12.6-31.5s19.3-17.8 31.5-12.6zM256 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
        }
    ]
};

const FarUnlockKeyhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUnlockKeyhole",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48c-44.2 0-80 35.8-80 80v64h240c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64h32v-64C96 57.3 153.3 0 224 0c57 0 105.2 37.2 121.8 88.6 4.1 12.6-2.8 26.1-15.5 30.2s-26.1-2.8-30.2-15.5C289.8 71.2 259.6 48 224 48zM64 240c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H64zm192 136h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
        }
    ]
};

const FarUnlock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUnlock",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128c0-44.2 35.8-80 80-80 35.6 0 65.8 23.2 76.1 55.4 4.1 12.6 17.6 19.5 30.2 15.5s19.5-17.6 15.5-30.2C329.2 37.2 281 0 224 0 153.3 0 96 57.3 96 128v64H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144v-64zM48 256c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256z"
        }
    ]
};

const FarUpDownLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpDownLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 55.8 289.5 96h-67L256 55.8zm-26.2-43.5-61.6 73.9c-5.3 6.3-8.2 14.3-8.2 22.6 0 19.5 15.8 35.2 35.2 35.2H232v88h-88v-36.8c0-19.5-15.8-35.2-35.2-35.2-8.2 0-16.2 2.9-22.6 8.2l-73.9 61.6C4.5 236.2 0 245.9 0 256s4.5 19.8 12.3 26.2l73.9 61.6c6.3 5.3 14.3 8.2 22.6 8.2 19.5 0 35.2-15.8 35.2-35.2V280h88v88h-36.8c-19.5 0-35.2 15.8-35.2 35.2 0 8.2 2.9 16.2 8.2 22.6l61.6 73.9c6.5 7.8 16.1 12.3 26.2 12.3s19.8-4.5 26.2-12.3l61.6-73.9c5.3-6.3 8.2-14.3 8.2-22.6 0-19.5-15.8-35.2-35.2-35.2H280v-88h88v36.8c0 19.5 15.8 35.2 35.2 35.2 8.2 0 16.2-2.9 22.6-8.2l73.9-61.6c7.8-6.5 12.3-16.1 12.3-26.2s-4.5-19.8-12.3-26.2l-73.9-61.6c-6.3-5.3-14.3-8.2-22.6-8.2-19.5 0-35.2 15.8-35.2 35.2V232h-88v-88h36.8c19.5 0 35.2-15.8 35.2-35.2 0-8.2-2.9-16.2-8.2-22.6l-61.6-73.9C275.8 4.5 266.1 0 256 0s-19.8 4.5-26.2 12.3zM256 456.2 222.5 416h67L256 456.2zM456.2 256 416 289.5v-67l40.2 33.5zM96 289.5 55.8 256 96 222.5v67z"
        }
    ]
};

const FarUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpDown",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M111.7 6.4c9.2-8.5 23.4-8.5 32.6 0l96.8 89.4c9.5 8.8 14.9 21.1 14.9 34 0 25.5-20.7 46.3-46.3 46.3H200V336h9.7c25.5 0 46.3 20.7 46.3 46.3 0 12.9-5.4 25.2-14.9 34l-96.8 89.4c-9.2 8.5-23.4 8.5-32.6 0l-96.8-89.5C5.4 407.5 0 395.2 0 382.3 0 356.7 20.7 336 46.3 336H56V176h-9.7C20.7 176 0 155.3 0 129.7c0-12.9 5.4-25.2 14.9-34l96.8-89.3zM50.7 128H80c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24H50.7l77.3 71.3 77.3-71.3H176c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24h29.3L128 56.7 50.7 128zm-3.3 253-1.2 1.3 1.2-1.3z"
        }
    ]
};

const FarUpFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpFromBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M114.2 160 224 50l109.8 110H280c-13.3 0-24 10.7-24 24v120h-64V184c0-13.3-10.7-24-24-24h-53.8zM224 0c-11.5 0-22.5 4.6-30.6 12.7L77.6 128.8c-8.7 8.7-13.6 20.5-13.6 32.8 0 25.6 20.8 46.4 46.4 46.4H144v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-96h33.6c25.6 0 46.4-20.8 46.4-46.4 0-12.3-4.9-24.1-13.6-32.8L254.6 12.7C246.5 4.6 235.5 0 224 0zM48 344c0-13.3-10.7-24-24-24S0 330.7 0 344v80c0 48.6 39.4 88 88 88h272c48.6 0 88-39.4 88-88v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40v-80z"
        }
    ]
};

const FarUpFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M114.2 192 224 82l109.8 110H280c-13.3 0-24 10.7-24 24v120h-64V216c0-13.3-10.7-24-24-24h-53.8zM224 32c-11.5 0-22.5 4.6-30.6 12.7L77.6 160.8c-8.7 8.7-13.6 20.5-13.6 32.8 0 25.6 20.8 46.4 46.4 46.4H144v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-96h33.6c25.6 0 46.4-20.8 46.4-46.4 0-12.3-4.9-24.1-13.6-32.8L254.6 44.7C246.5 36.6 235.5 32 224 32zM32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FarUpFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M82.2 192 192 82l109.8 110H248c-13.3 0-24 10.7-24 24v120h-64V216c0-13.3-10.7-24-24-24H82.2zM192 32c-11.5 0-22.5 4.6-30.6 12.7L45.6 160.8c-8.7 8.7-13.6 20.5-13.6 32.8 0 25.6 20.8 46.4 46.4 46.4H112v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-96h33.6c25.6 0 46.4-20.8 46.4-46.4 0-12.3-4.9-24.1-13.6-32.8L222.6 44.7C214.5 36.6 203.5 32 192 32zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128v193.4c0 1.7.8 3.2 2.1 4.2 2.1 1.6 5 1.4 6.9-.5l54-54.1c9.4-9.4 24.6-9.4 33.9 0l124.8 124.7c2.7 2.7 6.5 4.3 10.3 4.3s7.6-1.5 10.3-4.3l25.4-25.4c2.7-2.7 4.3-6.5 4.3-10.3s-1.5-7.6-4.3-10.3L207 225c-9.4-9.4-9.4-24.6 0-33.9l54.1-54.1c1.8-1.8 2.1-4.8.5-6.9-1-1.3-2.5-2.1-4.2-2.1H64zm-48-8c0-22.1 17.9-40 40-40h201.4c16.8 0 32.5 7.9 42.6 21.3 15.9 21.2 13.8 50.9-4.9 69.6L257.9 208l107.8 107.7c11.7 11.8 18.3 27.7 18.3 44.3s-6.6 32.5-18.3 44.3l-25.4 25.4C328.5 441.4 312.6 448 296 448s-32.5-6.6-44.3-18.3L144 321.9 106.9 359c-18.7 18.7-48.4 20.8-69.6 5C23.9 353.9 16 338.1 16 321.4V120z"
        }
    ]
};

const FarUpLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpLong",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M143.6 6.5c9.2-8.7 23.7-8.7 32.9 0l129 121.4c9.3 8.8 14.6 21 14.6 33.7 0 25.6-20.7 46.3-46.3 46.3H240V456c0 30.9-25.1 56-56 56h-48c-30.9 0-56-25.1-56-56V208H46.3C20.7 208 0 187.3 0 161.7c0-12.8 5.3-25 14.6-33.7l129-121.5zM50.5 160H104c13.3 0 24 10.7 24 24v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V184c0-13.3 10.7-24 24-24h53.5L160 57 50.5 160z"
        }
    ]
};

const FarUpRightAndDownLeftFromCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpRightAndDownLeftFromCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323.3 0C303.8 0 288 15.8 288 35.3c0 9.4 3.7 18.3 10.3 25L326.1 88 264 150.1c-18.7 18.7-18.7 49.1 0 67.9l30.1 30c18.7 18.7 49.1 18.7 67.9 0l62-62.1 27.7 27.7c6.6 6.6 15.6 10.3 25 10.3 19.5 0 35.3-15.8 35.3-35.3V40c0-22.1-17.9-40-40-40H323.3zM377 71l-23-23h110v110.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0l-79 79-30.2-30.1 79-79c9.4-9.4 9.4-24.6 0-33.9zM188.7 512c19.5 0 35.3-15.8 35.3-35.3 0-9.4-3.7-18.3-10.3-25L185.9 424l62.1-62.1c18.7-18.7 18.7-49.1 0-67.9l-30.1-30c-18.7-18.7-49.1-18.7-67.9 0l-62 62.1-27.7-27.8c-6.6-6.6-15.6-10.3-25-10.3C15.8 288 0 303.8 0 323.3V472c0 22.1 17.9 40 40 40h148.7zM135 441l23 23H48V353.9l23 23c9.4 9.4 24.6 9.4 33.9 0l79-79 30.2 30.1-79 79c-9.4 9.4-9.4 24.6 0 33.9z"
        }
    ]
};

const FarUpRightFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpRightFromSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 41c0 10.9 4.3 21.3 12 29l46.1 46L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155 46.2 46.1c7.7 7.7 18.1 12 29 12 22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464v102.1L361.9 48zM72 32C32.2 32 0 64.2 0 104v336c0 39.8 32.2 72 72 72h336c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24v128c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
        }
    ]
};

const FarUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128v193.4c0 1.7-.8 3.2-2.1 4.2-2.1 1.6-5 1.4-6.9-.5L257 271c-9.4-9.4-24.6-9.4-33.9 0L98.3 395.7c-2.7 2.7-6.5 4.3-10.3 4.3s-7.6-1.5-10.3-4.3l-25.4-25.4c-2.7-2.7-4.3-6.5-4.3-10.3s1.5-7.6 4.3-10.3L177 225c9.4-9.4 9.4-24.6 0-33.9L122.9 137c-1.8-1.8-2.1-4.8-.5-6.9 1-1.3 2.5-2.1 4.2-2.1H320zm48-8c0-22.1-17.9-40-40-40H126.6c-16.8 0-32.5 7.9-42.6 21.3-15.9 21.2-13.8 50.9 4.9 69.6l37.2 37.1L18.3 315.7C6.6 327.5 0 343.4 0 360s6.6 32.5 18.3 44.3l25.4 25.4C55.5 441.4 71.4 448 88 448s32.5-6.6 44.3-18.3L240 321.9l37.1 37.1c18.7 18.7 48.4 20.8 69.6 5 13.4-10.1 21.3-25.8 21.3-42.6V120z"
        }
    ]
};

const FarUpToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M114.2 288 224 178l109.8 110H280c-13.3 0-24 10.7-24 24v120h-64V312c0-13.3-10.7-24-24-24h-53.8zM224 128c-11.5 0-22.5 4.6-30.6 12.7L77.6 256.8c-8.7 8.7-13.6 20.5-13.6 32.8 0 25.6 20.8 46.4 46.4 46.4H144v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-96h33.6c25.6 0 46.4-20.8 46.4-46.4 0-12.3-4.9-24.1-13.6-32.8L254.6 140.7c-8.1-8.1-19.1-12.7-30.6-12.7zm192-96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM0 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FarUpToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M82.2 288 192 178l109.8 110H248c-13.3 0-24 10.7-24 24v120h-64V312c0-13.3-10.7-24-24-24H82.2zM192 128c-11.5 0-22.5 4.6-30.6 12.7L45.6 256.8c-8.7 8.7-13.6 20.5-13.6 32.8 0 25.6 20.8 46.4 46.4 46.4H112v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-96h33.6c25.6 0 46.4-20.8 46.4-46.4 0-12.3-4.9-24.1-13.6-32.8L222.6 140.7c-8.1-8.1-19.1-12.7-30.6-12.7zM24 80h336c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 32 0 42.7 0 56s10.7 24 24 24z"
        }
    ]
};

const FarUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m192 82.4 142.7 149.9c.8.8 1.3 2 1.3 3.2 0 2.5-2 4.6-4.6 4.6H248c-13.3 0-24 10.7-24 24V432h-64V264c0-13.3-10.7-24-24-24H52.6c-2.5 0-4.6-2-4.6-4.6 0-1.2.5-2.3 1.3-3.2L192 82.4zm192 153c0-13.5-5.2-26.5-14.5-36.3L222.9 45.2C214.8 36.8 203.7 32 192 32s-22.8 4.8-30.9 13.2l-146.6 154C5.2 208.9 0 221.9 0 235.4c0 29 23.5 52.6 52.6 52.6H112v144c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V288h59.4c29 0 52.6-23.5 52.6-52.6z"
        }
    ]
};

const FarUpload = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUpload",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9l-95 95c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L409 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-95-95V360zm32-8v-48h136c35.3 0 64 28.7 64 64v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-80c0-35.3 28.7-64 64-64h136v48H64c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16v-80c0-8.8-7.2-16-16-16H312zm72 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarUsbDrive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUsbDrive",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 144c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h336V144H64zM0 160c0-35.3 28.7-64 64-64h352c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V160zm608-32c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H480V128h128zm-48 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-24 120a24 24 0 1 0 48 0 24 24 0 1 0-48 0z"
        }
    ]
};

const FarUserAlien = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserAlien",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 167c0-67.7 52.1-119 112-119s112 51.3 112 119c0 33.9-18.3 69.4-46.1 102.4-23.3 27.7-49.6 49.4-65.9 61.6-16.3-12.2-42.6-34-65.9-61.6C130.3 236.4 112 201 112 167zM224 0C135.6 0 64 74.8 64 167c0 101 106.6 185 139.2 208.3 6.1 4.3 13.4 6.5 20.8 6.5s14.7-2.1 20.8-6.5C277.4 352 384 268.1 384 167 384 74.8 312.4 0 224 0zM0 486.4C0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-71.4-55.7-129.8-126.1-134.1-22.6 22.1-44 38.6-56.7 47.7h48.3c40 0 73.6 27.1 83.5 64H50.9c9.9-36.9 43.5-64 83.5-64h48.3c-12.7-9.2-34-25.6-56.7-47.7C55.7 356.6 0 415 0 486.4zm208-263.5c0-30.3-24.6-54.9-54.9-54.9h-16c-5 0-9.1 4.1-9.1 9.1 0 30.3 24.6 54.9 54.9 54.9h16c5 0 9.1-4.1 9.1-9.1zm86.9-54.9c-30.3 0-54.9 24.6-54.9 54.9 0 5 4.1 9.1 9.1 9.1h16c30.3 0 54.9-24.6 54.9-54.9 0-5-4.1-9.1-9.1-9.1h-16z"
        }
    ]
};

const FarUserAstronaut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserAstronaut",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm181.2 80.4C379 53.6 307.8 0 224 0S69 53.6 42.8 128.4C27.6 130.9 16 144.1 16 160v64c0 15.9 11.6 29.1 26.8 31.6 9.7 27.6 25.5 52.4 45.8 72.6C35.6 359.1 0 416.5 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-65.8-35.6-123.2-88.6-154.1 20.3-20.2 36.2-45 45.8-72.6 15.2-2.5 26.8-15.7 26.8-31.6v-64c0-15.9-11.6-29.1-26.8-31.6zm-85.5 230.1c44.5 18 77.1 59.3 82.6 108.7H336V448c0-17.7-14.3-32-32-32H144c-17.7 0-32 14.3-32 32v19.2H45.6c5.6-49.5 38.1-90.7 82.6-108.7 28.3 16.2 60.9 25.5 95.8 25.5s67.5-9.3 95.7-25.5zM160 128c-26.5 0-48 21.5-48 48v16c0 53 43 96 96 96h32c53 0 96-43 96-96v-16c0-26.5-21.5-48-48-48H160zm39.3 45.5 6 21.2 21.2 6c3.3.9 5.5 3.9 5.5 7.3s-2.2 6.4-5.5 7.3l-21.2 6-6 21.2c-.9 3.3-3.9 5.5-7.3 5.5s-6.4-2.2-7.3-5.5l-6-21.2-21.2-6c-3.3-.9-5.5-3.9-5.5-7.3s2.2-6.4 5.5-7.3l21.2-6 6-21.2c.9-3.3 3.9-5.5 7.3-5.5s6.4 2.2 7.3 5.5zM176 448c8.8 0 16 7.2 16 16v48h-32v-48c0-8.8 7.2-16 16-16zm80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarUserBountyHunter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserBountyHunter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323 120c-13.6-42-53-72-99-72s-85.4 30-99 72h198zm5.5 36.4L248 171.5v98.4l9.5-1.9c7.6-49.7 42.9-81.5 71.9-97.8l-.9-13.8zm-209 0-.9 13.8c29 16.3 64.2 48.1 71.9 97.8l9.5 1.9v-98.4l-80.5-15.1zM96 70c27.1-42.3 74.5-70 128-70 80.1 0 146.5 62.2 151.7 142.2l7.3 114.3c1.3 20-12.4 37.9-32.1 41.8l-100.8 20.1c-5.2 1-10.4 1.6-15.7 1.6h-20.9c-5.3 0-10.5-.5-15.7-1.6L97 298.3c-16.2-3.2-28.4-16-31.4-31.6-1-3.4-1.6-7-1.6-10.7V16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16v38zm217.6 330H134.4c-40 0-73.6 27.1-83.5 64H160l59.2-44.4c2.8-2.1 6.8-2.1 9.6 0L288 464h109.1c-9.9-36.9-43.5-64-83.5-64zM0 486.4C0 412.2 60.2 352 134.4 352h179.2c74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z"
        }
    ]
};

const FarUserCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm208 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-82.3 224c65.7 0 120.1 48.7 129 112H49.3c8.9-63.3 63.3-112 129-112h91.4zm-91.4-48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4zM625 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L625 177z"
        }
    ]
};

const FarUserChef = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserChef",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c0 20.9-13.4 38.7-32 45.3V176c0 70.7-57.3 128-128 128S96 246.7 96 176V93.3C77.4 86.7 64 68.9 64 48c0-26.5 21.5-48 48-48 14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zm-80 128v-16H144v16c0 44.2 35.8 80 80 80s80-35.8 80-80zM169.4 438c-5.7 2.6-9.4 8.3-9.4 14.6V464h237.1c-7.7-28.9-30.1-51.9-58.8-60.4L304 393.4v-14.3l-13.1 3.8L169.4 438zM128 452.6c0-18.8 11-35.9 28.1-43.7l35.6-16.2-47.7-13.6v14.3l-34.3 10.2c-28.6 8.5-51 31.5-58.8 60.4H128v-11.4zM0 486.4c0-60.9 40.5-112.3 96-128.8V334c0-7.8 6.3-14 14-14 1.3 0 2.6.2 3.9.5L224 352l110.1-31.5c1.3-.4 2.6-.5 3.9-.5 7.8 0 14 6.3 14 14v23.5c55.5 16.5 96 68 96 128.8 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4zM272 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarUserClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM49.3 464h299.2c12.3 18.8 28 35.1 46.3 48H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c20.6 0 40.4 3.5 58.8 9.9-4.9 15.3-7.8 31.4-8.4 48.2-15.5-6.5-32.5-10.1-50.4-10.1h-91.4c-65.7 0-120.1 48.7-129 112zM352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarUserCowboy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserCowboy",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208.5 9.9c4.8 3.3 8.8 6.1 15.5 6.1s10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0c35.6 0 58.8 59.3 72.4 112 7.1-2.2 13.7-4.5 19.8-6.9 32.4-12.7 49.4-27.2 55-34.7 4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9-7.4 5.4-15.4 10.6-23.8 15.5.8 5.8 1.2 11.6 1.2 17.6 0 70.7-57.3 128-128 128s-128-57.3-128-128c0-6 .4-11.9 1.2-17.6-8.4-4.8-16.4-10-23.8-15.5C35.8 147.5 10.1 113 .8 85.1c-2.5-7.4.8-15.6 7.8-19.2s15.5-1.7 20.2 4.6c5.6 7.5 22.7 22 55 34.7 6.1 2.4 12.7 4.7 19.8 6.9C117.2 59.3 140.4 0 176 0c18 0 25.9 5.4 32.5 9.9zM224 224c-29 0-55.8-4.8-79.9-12.7C145.8 254 180.9 288 224 288s78.2-34.1 79.9-76.7C279.8 219.2 253 224 224 224zM54.2 458.7l-.6 5.3h340.8l-.6-5.3c-2.7-24.3-23.2-42.7-47.7-42.7H101.9c-24.5 0-45 18.4-47.7 42.7zm-47.7-5.3C11.9 404.8 53 368 101.9 368h244.2c48.9 0 90 36.8 95.4 85.4l2.6 23.1c2.1 19-12.7 35.5-31.8 35.5H35.8C16.7 512 1.9 495.4 4 476.5l2.6-23.1z"
        }
    ]
};

const FarUserCrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserCrown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128h160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16zm0-108.8-.1-.1c-.3-.2-.6-.4-.8-.6L140 16 124.4 3.5c-2.9-2.3-6.4-3.5-10-3.5H112c-8.8 0-16 7.2-16 16v128c0 70.7 57.3 128 128 128s128-57.3 128-128V16c0-8.8-7.2-16-16-16h-2.4c-3.6 0-7.2 1.2-10 3.5L308 16l-3 2.4c-.3.2-.6.4-.8.6l-.1.1c-10.2 7.5-23.8 8.3-34.9 2L238.9 4c-4.6-2.6-9.7-4-14.9-4s-10.4 1.4-14.9 4l-30.2 17.2c-11 6.3-24.7 5.5-34.9-2zM168 352h112c63.6 0 115.6 49.5 119.7 112H48.3c4.1-62.5 56.2-112 119.7-112zm0-48C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168z"
        }
    ]
};

const FarUserDoctorHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserDoctorHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-16zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5v-11zm80 224c-5.4 0-10.8.3-16 1v49.3c23.1 6.9 40 28.3 40 53.7 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7v-41c-46.9 19-80 65-80 118.7v8c0 13.3-10.7 24-24 24S0 501.3 0 488v-8c0-97.2 78.8-176 176-176h96c97.2 0 176 78.8 176 176v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-53.7-33.1-99.7-80-118.7V402c27.6 7.1 48 32.2 48 62v32c0 8.8-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16s7.2-16 16-16h8v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16v-32c0-29.8 20.4-54.9 48-62v-49c-5.2-.7-10.6-1-16-1h-96zm-8 104a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarUserDoctorHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserDoctorHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32zm-208 0v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0S96 57.3 96 128zm64 225c5.2-.7 10.6-1 16-1h96c5.4 0 10.8.3 16 1v49c-27.6 7.1-48 32.2-48 62v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8v-16c0-17.7 14.3-32 32-32s32 14.3 32 32v16h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24c8.8 0 16-7.2 16-16v-32c0-29.8-20.4-54.9-48-62v-40.7c46.9 19 80 65 80 118.7v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-97.2-78.8-176-176-176h-96C78.8 304 0 382.8 0 480v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-53.7 33.1-99.7 80-118.7v41c-23.1 6.9-40 28.3-40 53.7 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V353zm-16 79a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarUserDoctorMessage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserDoctorMessage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128a80 80 0 1 0 160 0 80 80 0 1 0-160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm-48 96c-5.4 0-10.8.3-16 1v49.3c23.1 6.9 40 28.3 40 53.7 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7v-41c-46.9 19-80 65-80 118.7v8c0 13.3-10.7 24-24 24S0 501.3 0 488v-8c0-97.2 78.8-176 176-176h96c97.2 0 176 78.8 176 176v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-53.7-33.1-99.7-80-118.7V402c27.6 7.1 48 32.2 48 62v32c0 8.8-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16s7.2-16 16-16h8v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16v-32c0-29.8 20.4-54.9 48-62v-49c-5.2-.7-10.6-1-16-1h-96zm-8 104a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM432 0h160c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48h-48l-83.2 62.4c-2.4 1.8-5.7 2.1-8.4.8s-4.4-4.1-4.4-7.2v-56h-16c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FarUserDoctor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserDoctor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM96 128a128 128 0 1 0 256 0 128 128 0 1 0-256 0zm64 225c5.2-.7 10.6-1 16-1h96c5.4 0 10.8.3 16 1v49c-27.6 7.1-48 32.2-48 62v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8v-16c0-17.7 14.3-32 32-32s32 14.3 32 32v16h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24c8.8 0 16-7.2 16-16v-32c0-29.8-20.4-54.9-48-62v-40.7c46.9 19 80 65 80 118.7v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-97.2-78.8-176-176-176h-96C78.8 304 0 382.8 0 480v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-53.7 33.1-99.7 80-118.7v41c-23.1 6.9-40 28.3-40 53.7 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V353zm-16 79a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarUserGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserGear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM49.3 464h287.3c3.3 4.2 6.7 8.2 10.3 12 15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3-2.1 18.5 7.4 35.6 21.8 44.8-3.6 2.3-7 5.1-9.9 8.4-14.4-5.5-30.1-8.5-46.5-8.5h-91.3c-65.7 0-120.1 48.7-129 112zM436 218.2c0-7 4.5-13.3 11.3-14.8 10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4 7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1.7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4L546.3 442c-6.9 5.1-14.3 9.4-22.3 12.8v30.6c0 7-4.5 13.3-11.3 14.8-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8v-30.6c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3.7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2 3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9v-30.4zm92.1 133.5a48.1 48.1 0 1 0-96.1 0 48.1 48.1 0 1 0 96.1 0z"
        }
    ]
};

const FarUserGraduate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserGraduate",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M228.7.5c-3.1-.6-6.3-.6-9.4 0l-200 40C8.1 42.7 0 52.6 0 64c0 10.3 6.5 19.3 16 22.6v71.8L.3 236.9c-.9 4.7.3 9.6 3.3 13.3s7.6 5.9 12.4 5.9h32c4.8 0 9.3-2.1 12.4-5.9s4.3-8.6 3.3-13.3L48 158.4V93.3l171.3 34.3c3.1.6 6.3.6 9.4 0l200-40C439.9 85.3 448 75.4 448 64s-8.1-21.3-19.3-23.5l-200-40zM49.3 464c5.8-37.6 30-69.2 63.3-85.1l63.6 71.5c5 5.6 10.7 10.1 16.9 13.6H49.3zm349.4 0H254.9c6.2-3.4 11.9-7.9 16.9-13.6l63.6-71.5c33.3 15.8 57.5 47.4 63.3 85.1zM109.6 328.4C45.9 350 0 410.3 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-71-45.9-131.3-109.6-152.8-10.9-3.7-22.7.4-30.3 9l-72.1 81c-6.4 7.2-17.6 7.2-23.9 0L140 337.4c-7.6-8.6-19.4-12.7-30.3-9zM96 160c0 70.7 57.3 128 128 128s128-57.3 128-128v-24.5l-48 9.6V160c0 44.2-35.8 80-80 80s-80-35.8-80-80v-14.9l-48-9.6V160z"
        }
    ]
};

const FarUserGroupCrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserGroupCrown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 144c0 44.2 35.8 80 80 80s80-35.8 80-80v-16H144v16zm-.1-124.9.1.1c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2.6-.4.8-.6l3-2.4 15.7-12.6c2.8-2.3 6.4-3.5 10-3.5h2.4c8.8 0 16 7.2 16 16v128c0 70.7-57.3 128-128 128S96 214.7 96 144V16c0-8.8 7.2-16 16-16h2.4c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3.2.6.4.8.6zM48.3 464h351.4c-4.1-62.5-56.2-112-119.7-112H168c-63.6 0-115.6 49.5-119.7 112zM0 472c0-92.8 75.2-168 168-168h112c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8zm432-216c-27.7 0-53-10.1-72.6-26.7.5-.8 1-1.5 1.4-2.3 12.1-19.9 20-42.6 22.4-67 .5-5.3.8-10.6.8-16V42.8c14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112s-50.1 112-112 112zm177.3 256H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8 2.4-.1 4.7-.2 7.1-.2h61.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7z"
        }
    ]
};

const FarUserGroupSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserGroupSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 136a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm160 0a104 104 0 1 0-208 0 104 104 0 1 0 208 0zm216 88a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM128 336h64c44.2 0 80 35.8 80 80v16H48v-16c0-44.2 35.8-80 80-80zm0-48C57.3 288 0 345.3 0 416v16c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128h-64zm320 192h64c70.7 0 128-57.3 128-128v-16c0-26.5-21.5-48-48-48H368c-21.8 0-40.3 14.6-46.1 34.6 18.9 26.3 30.1 58.5 30.1 93.4v16c0 1.5 0 3-.1 4.5 23.4 26.7 57.8 43.5 96.1 43.5z"
        }
    ]
};

const FarUserGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserGroup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M1.5 458.7c6-45.5 29.2-85.6 62.8-113.6 31-25.7 70.7-41.1 114-41.1h91.4c43.3 0 83 15.4 113.9 41.1 33.6 28 56.8 68.1 62.8 113.6 1 7.7 1.5 15.6 1.5 23.6 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3c0-8 .5-15.9 1.5-23.6zM96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm208 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM178.3 352c-47.8 0-89.5 25.7-112.2 64-8.6 14.4-14.4 30.7-16.8 48h349.5c-.4-2.7-.8-5.3-1.4-8-2.9-14.3-8.2-27.8-15.5-40-22.7-38.3-64.4-64-112.2-64h-91.4zm431 160H472.4c4.9-8.8 7.6-18.9 7.6-29.7 0-65-29.5-123.2-75.9-161.8 4.3-.4 8.7-.5 13.2-.5h61.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9 19.7-26.6 31.3-59.5 31.3-95.1 0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
        }
    ]
};

const FarUserHairBuns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserHairBuns",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H160c26.2 0 49.4-12.6 64-32 14.6 19.4 37.8 32 64 32h14.4c1 5.2 1.6 10.5 1.6 16zM84 192c7 0 13.7-1.6 19.6-4.6 17.8 49.3 65 84.6 120.4 84.6s102.7-35.3 120.4-84.6c5.9 2.9 12.5 4.6 19.6 4.6 24.3 0 44-19.7 44-44v-40c0-24.3-19.7-44-44-44-9.3 0-17.9 2.9-25 7.8C318.2 29.3 274.5 0 224 0s-94.2 29.3-115 71.8c-7.1-4.9-15.7-7.8-25-7.8-24.3 0-44 19.7-44 44v40c0 24.3 19.7 44 44 44zM49.3 464c8.3-54.4 55.3-96 112-96h125.4c56.7 0 103.7 41.6 112 96H49.3zM0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3H161.3C72.2 320 0 392.2 0 481.3z"
        }
    ]
};

const FarUserHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-16zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5v-11zM49.3 464h349.4c-8.3-54.4-55.3-96-112-96H161.3c-56.7 0-103.6 41.6-112 96zM0 481.3C0 392.2 72.2 320 161.3 320h125.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z"
        }
    ]
};

const FarUserHairMullet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserHairMullet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128c0-5.7-.6-11.3-1.7-16.6-30.6-3.1-58.5-17.9-78.3-40.6-19.8 22.7-47.6 37.5-78.3 40.6-1.1 5.4-1.7 10.9-1.7 16.6v16c0 18 6 34.6 16 48 14.6 19.4 37.8 32 64 32s49.4-12.6 64-32c10-13.4 16-30 16-48v-16zm-66.6 143.3c-4.4.5-8.9.7-13.4.7s-9-.2-13.4-.7L193 289c-5.5 5.5-13.2 8-20.8 6.7s-14.2-6.1-17.6-13l-6.1-12.2-19.5 7.8c-9.3 3.7-19.8 1.3-26.6-6s-8.3-18.1-3.8-27c8.5-17 11-22.3 12.2-27.1.7-2.9 1.1-5.9 1.2-12.3-10.2-18.4-16-39.5-16-61.9v-16c0-7.1.6-14 1.7-20.7C91.8 102.9 88 95.9 88 88c0-13.3 10.7-24 24-24h1.1C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64h1.1c13.3 0 24 10.7 24 24 0 7.9-3.8 14.9-9.7 19.3 1.1 6.8 1.7 13.7 1.7 20.7v16c0 22.4-5.8 43.5-15.9 61.8.1 6.4.5 9.4 1.2 12.3 1.2 4.8 3.7 10.1 12.2 27.1 4.5 8.9 2.9 19.7-3.8 27s-17.3 9.7-26.6 6l-19.5-7.8-6.1 12.2c-3.4 6.9-10 11.7-17.6 13s-15.4-1.3-20.8-6.7l-17.7-17.7zM49.6 464h348.8c-9.3-54.5-56.8-96-113.9-96H163.6c-57.2 0-104.6 41.5-113.9 96zM0 483.6C0 393.2 73.2 320 163.6 320h120.8c90.4 0 163.6 73.2 163.6 163.6 0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z"
        }
    ]
};

const FarUserHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-16zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 214.7 96 144v-16zM49.6 464h348.8c-9.3-54.5-56.8-96-113.9-96H163.6c-57.2 0-104.6 41.5-113.9 96zM0 483.6C0 393.2 73.2 320 163.6 320h120.8c90.4 0 163.6 73.2 163.6 163.6 0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z"
        }
    ]
};

const FarUserHeadset = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserHeadset",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c-88.4 0-160 71.6-160 160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16C32 86 118 0 224 0s192 86 192 192v16c0 61.9-50.1 112-112 112h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80v-16c0-88.4-71.6-160-160-160zm0 32c70.7 0 128 57.3 128 128 0 13.9-2.2 27.3-6.3 39.8-8.3 14.5-23.9 24.2-41.7 24.2h-8.6c-2.7-4.7-6.1-9.1-9.9-12.9 11.6-13.9 18.5-31.7 18.5-51.1 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 19.4 6.9 37.2 18.4 51.1C151 254.6 144 270.5 144 288c0 1.4 0 2.7.1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128zm-16 288h105.6c74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 412.2 60.2 352 134.4 352H208zm105.6 48H134.4c-40 0-73.6 27.1-83.5 64h346.2c-9.9-36.9-43.5-64-83.5-64z"
        }
    ]
};

const FarUserHelmetSafety = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserHelmetSafety",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 0h16c13.3 0 24 10.7 24 24v56l28.4-56.9c38 20.4 64.5 59.4 67.3 104.9h.2c13.3 0 24 10.7 24 24s-10.7 24-24 24H96c-13.3 0-24-10.7-24-24s10.7-24 24-24h.2c2.8-45.4 29.4-84.5 67.4-104.9L192 80V24c0-13.3 10.7-24 24-24zm-54 304c-34.9-19.4-59.8-54.6-65-96h48.6c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64H351c-5.2 41.4-30.1 76.6-65 96-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16zm-11.4 48h163c74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 412.2 60.2 352 134.4 352h16.2zm246.5 112c-9.9-36.9-43.5-64-83.5-64H134.4c-40 0-73.6 27.1-83.5 64h346.2z"
        }
    ]
};

const FarUserInjured = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserInjured",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208c-44.2 0-80-35.8-80-80h160c0 44.2-35.8 80-80 80zM150.7 96C163 67.7 191.2 48 224 48c1.2 0 2.5 0 3.7.1L170.2 96h-19.5zm113.9-37c14.5 8.5 26 21.5 32.8 37h-77.2l44.4-37zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM49.3 464c4.7-33.3 21.9-62.5 46.7-82.7V464H49.3zm246.3 0h-34.3l-32-48H276c15.5 0 28 12.5 28 28 0 7.8-3.2 14.9-8.4 20zm37 0c2.2-6.3 3.4-13 3.4-20 0-33.1-26.9-60-60-60h-68l-21.3-32h83c65.7 0 120.1 48.7 129 112h-66.1zM178.3 304C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4z"
        }
    ]
};

const FarUserLargeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserLargeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0c-69.6 0-127.6 49.3-141.1 114.9L38.8 5.1zm185.4 145.3c-.1-2.1-.2-4.3-.2-6.4 0-53 43-96 96-96s96 43 96 96c0 47.3-34.3 86.7-79.3 94.6l-112.5-88.2zM545.5 512H528l-60.9-48H113.3c8.3-54.4 55.3-96 112-96h119.9l-60.9-48h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7h450.9z"
        }
    ]
};

const FarUserLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserLarge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 144a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm-240 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zM49.3 464h413.4c-8.3-54.4-55.3-96-112-96H161.3c-56.7 0-103.6 41.6-112 96zM0 481.3C0 392.2 72.2 320 161.3 320h189.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z"
        }
    ]
};

const FarUserLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM49.3 464H384v16c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7-.2 2.1-.3 4.2-.3 6.3v67.7c-22.1-40.4-65-67.7-114.3-67.7h-91.4c-65.7 0-120.1 48.7-129 112zM528 240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FarUserMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserMagnifyingGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM49.3 464c8.9-63.3 63.3-112 129-112h91.4c7.5 0 14.8.6 21.9 1.8-2.3-10.9-3.6-22.2-3.6-33.8 0-5.1.2-10.1.7-15-6.2-.7-12.6-1-19-1h-91.4C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7V480c-25 0-48.7-5.8-69.8-16H49.3zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1l79.1 79.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9 0-70.7-57.3-128-128-128s-128 57.3-128 128 57.3 128 128 128z"
        }
    ]
};

const FarUserMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserMinus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm208 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-82.3 224c65.7 0 120.1 48.7 129 112H49.3c8.9-63.3 63.3-112 129-112h91.4zm-91.4-48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4zM472 200c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H472z"
        }
    ]
};

const FarUserMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM49.3 464H288c0 19.1 7.7 35.4 18.9 48H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c36.3 0 70.1 10.9 98.3 29.5v51.6c-3.2.4-6.5 1-9.6 1.7-23.3-21.6-54.4-34.8-88.7-34.8h-91.4c-65.7 0-120.1 48.7-129 112zM630 164.5c6.3 4.5 10 11.8 10 19.5v208c0 1.2-.1 2.4-.3 3.6.2 1.5.3 2.9.3 4.4 0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5v-88.2l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5V248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"
        }
    ]
};

const FarUserNinja = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserNinja",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 128c0 70.7-57.3 128-128 128-57.2 0-105.6-37.5-122-89.3-1.1 1.3-2.2 2.6-3.5 3.8-15.8 15.8-38.8 20.7-53.6 22.1-8.1.8-14.6-5.7-13.8-13.8 1.4-14.7 6.3-37.8 22.1-53.6 5.8-5.8 12.6-10.1 19.6-13.4-7-3.2-13.8-7.6-19.6-13.4-15.8-15.7-20.6-38.7-22.1-53.5-.8-8.1 5.7-14.6 13.8-13.8 14.7 1.4 37.8 6.3 53.6 22.1 4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128zm-208-16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM49.3 464h163.1l-6.5-7.7c-.2-.2-.4-.4-.6-.7l-78.4-93.1c-41 17.6-71.2 55.8-77.6 101.5zm206.1-23.5 19.8 23.5h123.5c-6.4-45.7-36.6-83.9-77.7-101.5l-65.7 78zM418.3 512H29.7C13.3 512 0 498.7 0 482.3c0-83.7 57.6-153.9 135.4-173.1 5.6-1.4 11.4.7 15.1 5.1l61.3 71.6c6.4 7.4 17.9 7.4 24.3 0l61.3-71.6c3.7-4.4 9.5-6.4 15.1-5.1C390.4 328.4 448 398.6 448 482.3c0 16.4-13.3 29.7-29.7 29.7z"
        }
    ]
};

const FarUserNurseHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserNurseHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 70.2V128h.3c-.2 2.6-.3 5.3-.3 8v35c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h306.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5v-35c0-2.7-.1-5.4-.3-8h.3V70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80h32c29.8 0 55.9-16.3 69.6-40.5 11.7 14.9 29.9 24.5 50.4 24.5h8zM50 461.9c7.8-38.7 38-69.3 76.4-77.7l52.3 52.3c25 25 65.5 25 90.5 0l52.3-52.3c38.5 8.4 68.6 39 76.4 77.7H50zm80.4-127C56.9 343.6 0 406 0 481.8 0 497.4 12.6 510 28.2 510h391.6c15.6 0 28.2-12.6 28.2-28.2 0-75.8-56.9-138.2-130.4-146.8-8.7-1-17.2 2.5-23.4 8.7l-58.9 58.9c-6.2 6.2-16.4 6.2-22.6 0l-58.9-58.9c-6.2-6.2-14.7-9.8-23.4-8.7zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-16v16c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V96h-16c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16V48z"
        }
    ]
};

const FarUserNurseHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserNurseHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6.3 5.3.3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128v-40c0-2.7.1-5.4.3-8H96V70.2zM304 160h-8c-20.5 0-38.7-9.6-50.4-24.5-13.7 24.2-39.8 40.5-69.6 40.5h-32c0 44.2 35.8 80 80 80s80-35.8 80-80v-16zM49.3 461.9h349.4c-6-39.3-32.2-72-67.7-87.1l-61.7 61.7c-25 25-65.5 25-90.5 0l-61.7-61.7c-35.5 15.1-61.7 47.8-67.7 87.1zm65.1-137.1c10.1-3.1 20.9.4 28.4 7.9l69.8 69.8c6.2 6.2 16.4 6.2 22.6 0l69.8-69.8c7.5-7.5 18.3-11 28.4-7.9C399.8 344.9 448 406.4 448 479.2c0 17-13.8 30.7-30.7 30.7H30.7c-17 0-30.7-13.8-30.7-30.7 0-72.8 48.2-134.3 114.4-154.4zM208 48v16h-16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8h-16V48c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8z"
        }
    ]
};

const FarUserNurse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserNurse",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6.3 5.3.3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128v-40c0-2.7.1-5.4.3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80v-16H144v16zm72-136c-4.4 0-8 3.6-8 8v16h-16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8h-16V48c0-4.4-3.6-8-8-8h-16zM49.3 461.9h349.4c-6-39.3-32.2-72-67.7-87.1l-61.7 61.7c-25 25-65.5 25-90.5 0l-61.7-61.7c-35.5 15.1-61.7 47.8-67.7 87.1zm65.1-137.1c10.1-3.1 20.9.4 28.4 7.9l69.8 69.8c6.2 6.2 16.4 6.2 22.6 0l69.8-69.8c7.5-7.5 18.3-11 28.4-7.9C399.8 344.9 448 406.4 448 479.2c0 17-13.8 30.7-30.7 30.7H30.7c-17 0-30.7-13.8-30.7-30.7 0-72.8 48.2-134.3 114.4-154.4z"
        }
    ]
};

const FarUserPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserPen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM49.3 464h277.2l-5.1 20.2c-2.3 9.4-1.8 19 1.4 27.8H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c48.1 0 91.8 19.1 123.9 50.1l-34 33.9c-23.4-22.3-55.1-36-89.9-36h-91.4c-65.7 0-120.1 48.7-129 112zm564.5-228.3 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FarUserPilotTie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserPilotTie",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m217.9.8-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2 24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40c-4-1.1-8.2-1.1-12.2 0zm-34.7 64.9L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2-14 5.4-28.5 9.9-43.3 13.4.4 3.2.6 6.5.6 9.8 0 46-37.2 83.2-83.2 83.2S140.8 238 140.8 192c0-3.3.2-6.6.6-9.8-14.8-3.6-29.3-8.1-43.3-13.4-1.4 7.5-2.1 15.3-2.1 23.2zm91.6 183.2L208 416l-12.2 48.9-.5-.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-68.9-51.8-125.6-118.6-133.5-5.8-.7-11.4 2.4-14.4 7.4L252.8 464l-.5.9L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2h-44.2c-11.9 0-19.6 12.5-14.3 23.2zM139.2 464H50.9c7.2-27 27.3-48.8 53.2-58.5l35.1 58.5zm257.8 0h-88.2l35.1-58.5c25.9 9.7 45.9 31.5 53.2 58.5z"
        }
    ]
};

const FarUserPilot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserPilot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M217.9.8c4-1.1 8.2-1.1 12.2 0l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6L368 102.5v8.4c0 10.7-5.3 20.8-15.1 25.2-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24c-9.8-4.4-15.1-14.5-15.1-25.2v-8.4L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6S57.3 43 65.9 40.8l152-40zm-34.7 64.9c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1l-40.8-20.4zM98.1 168.8c14 5.4 28.5 9.9 43.3 13.4-.4 3.2-.6 6.5-.6 9.8 0 46 37.2 83.2 83.2 83.2s83.2-37.2 83.2-83.2c0-3.3-.2-6.6-.6-9.8 14.8-3.6 29.3-8.1 43.3-13.4 1.4 7.5 2.1 15.3 2.1 23.2 0 70.7-57.3 128-128 128S96 262.7 96 192c0-7.9.7-15.7 2.1-23.2zM50.9 464h137.6c-2.3-1.5-4.5-3.2-6.6-5.1l-65.2-57.1C84.8 408.5 59.4 432.7 51 464zm346.1 0c-8.4-31.2-33.8-55.5-65.7-62.2l-65.2 57.1c-2.1 1.9-4.3 3.6-6.6 5.1h137.6zM126.5 352.2c3.9-.2 7.8 1.2 10.7 3.8l76.3 66.7c6 5.3 15 5.3 21.1 0l76.3-66.7c3-2.6 6.8-4.1 10.7-3.8 70.5 4.1 126.4 62.6 126.4 134.2 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4c0-71.6 55.9-130.1 126.5-134.2z"
        }
    ]
};

const FarUserPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserPlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm208 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-82.3 224c65.7 0 120.1 48.7 129 112H49.3c8.9-63.3 63.3-112 129-112h91.4zm-91.4-48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4zm325.7 8c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FarUserPoliceTie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserPoliceTie",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m217.9.8-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2 24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40c-4-1.1-8.2-1.1-12.2 0zm3.1 47.8c1.9-.8 4-.8 5.9 0l32 12.8c3 1.2 5 4.2 5 7.4 0 17.2-7 46.1-36.9 58.6-2 .8-4.2.8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2-14 5.4-28.5 9.9-43.3 13.4.4 3.2.6 6.5.6 9.8 0 46-37.2 83.2-83.2 83.2S140.8 238 140.8 192c0-3.3.2-6.6.6-9.8-14.8-3.6-29.3-8.1-43.3-13.4-1.4 7.5-2.1 15.3-2.1 23.2zm91.6 183.2L208 416l-12.2 48.9-.5-.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-68.9-51.8-125.6-118.6-133.5-5.8-.7-11.4 2.4-14.4 7.4L252.8 464l-.5.9L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2h-44.2c-11.9 0-19.6 12.5-14.3 23.2zM139.2 464H50.9c7.2-27 27.3-48.8 53.2-58.5l35.1 58.5zm257.8 0h-88.2l35.1-58.5c25.9 9.7 45.9 31.5 53.2 58.5z"
        }
    ]
};

const FarUserPolice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserPolice",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M230.1.8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2 24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4 0 17.2-7 46.1-36.9 58.6-2 .8-4.2.8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2-14 5.4-28.5 9.9-43.3 13.4.4 3.2.6 6.5.6 9.8 0 46-37.2 83.2-83.2 83.2S140.8 238 140.8 192c0-3.3.2-6.6.6-9.8-14.8-3.6-29.3-8.1-43.3-13.4-1.4 7.5-2.1 15.3-2.1 23.2zm20.6 209.8 65.2 57.1c2.1 1.9 4.3 3.6 6.6 5.1H50.9c8.4-31.2 33.8-55.5 65.7-62.2zM358.4 464l4.7-3.4c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5H341l-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-5.4 16.7h-17.4c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9l4.7 3.4h-38.1c2.3-1.5 4.5-3.2 6.6-5.1l65.2-57.1c31.9 6.7 57.3 30.9 65.7 62.2h-38.6zM137.2 356.1c-3-2.6-6.8-4.1-10.7-3.8C55.9 356.3 0 414.8 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-71.6-55.9-130.1-126.5-134.2-3.9-.2-7.8 1.2-10.7 3.8l-76.3 66.7c-6 5.3-15 5.3-21.1 0L137.1 356z"
        }
    ]
};

const FarUserRobotXmarks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserRobotXmarks",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80h160c44.2 0 80-35.8 80-80v-96c0-44.2-35.8-80-80-80h-64V16zm96 128v96c0 17.7-14.3 32-32 32v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-32v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-32v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32zm64 304v16h-96v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H48v-16c0-26.5 21.5-48 48-48h256c26.5 0 48 21.5 48 48zm-176 64h176c26.5 0 48-21.5 48-48v-16c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48h176zM16 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm-280 13.4-14.7-14.7c-5.1-5.1-13.4-5.1-18.6 0s-5.1 13.4 0 18.6l14.7 14.7-14.7 14.7c-5.1 5.1-5.1 13.4 0 18.6s13.4 5.1 18.6 0l14.7-14.7 14.7 14.7c5.1 5.1 13.4 5.1 18.6 0s5.1-13.4 0-18.6L186.6 176l14.7-14.7c5.1-5.1 5.1-13.4 0-18.6s-13.4-5.1-18.6 0L168 157.4zm78.7-14.7c-5.1 5.1-5.1 13.4 0 18.6l14.7 14.7-14.7 14.7c-5.1 5.1-5.1 13.4 0 18.6s13.4 5.1 18.6 0l14.7-14.7 14.7 14.7c5.1 5.1 13.4 5.1 18.6 0s5.1-13.4 0-18.6L298.6 176l14.7-14.7c5.1-5.1 5.1-13.4 0-18.6s-13.4-5.1-18.6 0L280 157.4l-14.7-14.7c-5.1-5.1-13.4-5.1-18.6 0z"
        }
    ]
};

const FarUserRobot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserRobot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80h160c44.2 0 80-35.8 80-80v-96c0-44.2-35.8-80-80-80h-64V16zm96 128v96c0 17.7-14.3 32-32 32v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-32v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-32v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32zm64 304v16h-96v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H48v-16c0-26.5 21.5-48 48-48h256c26.5 0 48 21.5 48 48zm-240 64h240c26.5 0 48-21.5 48-48v-16c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48h112zM16 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm-240 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarUserSecret = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserSecret",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4-47.3 8.7-78 22.8-78 38.6 0 13.4 22.1 25.6 57.7 34.3-1.1 7.1-1.7 14.3-1.7 21.7 0 13.9 2.1 27.4 6 40H45.4C38 224 32 230 32 237.4c0 1.7.3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-58.5-28.2-110.4-71.7-143l38.7-96.9c.6-1.6 1-3.3 1-5 0-7.4-6-13.4-13.4-13.4H354c3.9-12.6 6-26.1 6-40 0-7.4-.6-14.6-1.7-21.7 35.6-8.7 57.7-20.9 57.7-34.3 0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9-4.8 3.3-8.8 6.1-15.5 6.1zm44 448-24.8-99.1c-2.1-8.2-.8-16.9 3.6-24.2l15.7-26.2c25.7-7.6 48.3-22.6 65.2-42.5h23.8l-19.8 49.5c-8.1 20.2-1.6 43.3 15.9 56.3 27.3 20.4 46.2 51 51.2 86.2H268zm-82.5-149.5 15.7 26.2c4.4 7.3 5.7 16 3.6 24.2L180 464H49.3c4.9-35.2 23.9-65.8 51.2-86.2 17.4-13 23.9-36.1 15.9-56.3L96.5 272h23.8c16.9 19.9 39.5 34.9 65.2 42.5zM224 272c-38.2 0-70.7-24.4-82.9-58.4 7.1 6.5 16.5 10.4 26.9 10.4h12.4c16.5 0 31.1-10.6 36.3-26.2 2.3-7 12.2-7 14.5 0 5.2 15.6 19.9 26.2 36.3 26.2H280c10.4 0 19.8-3.9 26.9-10.4-12.2 34-44.7 58.4-82.9 58.4z"
        }
    ]
};

const FarUserShakespeare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserShakespeare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48c-44.2 0-80 35.8-80 80v32c0 40.1 29.5 73.3 68 79.1V224c0-6.6 5.4-12 12-12s12 5.4 12 12v15.1c38.5-5.8 68-39 68-79.1v-32c0-44.2-35.8-80-80-80zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v23.2c0 10.9 3.7 21.5 10.5 30l11.1 13.8c6.7 8.4 10.4 18.8 10.4 29.6 0 26.2-21.2 47.4-47.4 47.4H286c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16h-50.6C85.2 272 64 250.8 64 224.6c0-10.8 3.7-21.2 10.4-29.6l11.1-13.9c6.8-8.5 10.5-19.1 10.5-30V128zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1 4.9 2.9 9.4 4.4 12.8 4.4 6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5 4.7-4.7 12.3-4.7 17 0zm7.5 249.2c-.3 8.5-7.4 15.3-16 15.3s-15.6-6.8-16-15.3c-23.1 1.9-42.4 7.7-56.5 13.5-8.6 3.5-15.2 7-19.6 9.6-2.2 1.3-3.8 2.3-4.8 2.9-.5.3-.8.6-1 .7l-.1.1c-7.3 5.3-16.9 6-24.9 1.9S88 433 88 424v-29.1c-20.3 17.2-34.5 41.5-38.7 69.1H208c0-8.8 7.2-16 16-16s16 7.2 16 16h158.7c-4.2-27.6-18.4-51.9-38.7-69.1V424c0 9-5.1 17.3-13.1 21.4-8 4.1-17.6 3.3-24.9-1.9l-.1-.1c-.2-.1-.5-.3-1-.7-1-.6-2.6-1.7-4.8-2.9-4.4-2.5-11-6-19.6-9.6-14.1-5.8-33.3-11.6-56.5-13.5zm-122.1-90.8c15.5-13.6 35.8-21.9 58.1-21.9h96c22.3 0 42.6 8.3 58.1 21.9 68 18.9 117.9 81.3 117.9 155.4 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-74 49.9-136.4 117.9-155.4zM224 368c35.9 0 65.8 8 87.3 16.4C307.7 366 291.5 352 272 352h-96c-19.5 0-35.7 14-39.3 32.4C158.2 376 188.1 368 224 368z"
        }
    ]
};

const FarUserShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserShield",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM49.3 464h325.4c13.2 17.2 29.3 33.4 48.9 47.5-1.7.3-3.5.5-5.3.5H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c17.6 0 34.6 2.6 50.7 7.3.9 16.6 3.4 35.3 8.3 54.8-17.7-9-37.8-14.1-59-14.1h-91.4c-65.7 0-120.1 48.7-129 112zm437.8-238.3c5.7-2.3 12.1-2.3 17.8 0l120 48c9.1 3.7 15.1 12.5 15.1 22.3 0 63.3-25.9 168.8-134.8 214.2-5.9 2.5-12.6 2.5-18.5 0C377.9 464.8 352 359.3 352 296c0-9.8 6-18.6 15.1-22.3l120-48zM591.4 312 496 273.8v187.9c68.2-33 91.5-99 95.4-149.7z"
        }
    ]
};

const FarUserSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128 448 57.3 390.7 0 320 0c-69.8 0-126.5 55.8-128 125.2L38.8 5.1zm251.7 197.3-35.6-27.9c-9.4-13.1-14.9-29.2-14.9-46.5 0-44.2 35.8-80 80-80s80 35.8 80 80-35.8 80-80 80c-10.4 0-20.4-2-29.5-5.6zm-26.2 101.9C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7h388.6c3.9 0 7.6-.7 11-2.1L467.1 464H145.3c8.9-63.3 63.3-112 129-112h50.6l-60.6-47.7z"
        }
    ]
};

const FarUserTag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserTag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm174.7 464c-.5-3.4-1.1-6.7-1.8-10l45.6 45.6c-5.4 7.5-14.2 12.5-24.2 12.5H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c17.5 0 34.3 2.5 50.3 7.2v33c0 6.4.8 12.7 2.3 18.8-16.1-7.1-33.9-11-52.6-11h-91.4c-65.7 0-120.1 48.7-129 112h349.4zM384 224h82.7c17 0 33.3 6.7 45.3 18.7l107.3 107.4c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3V256c0-17.7 14.3-32 32-32zm72 80a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FarUserTieHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserTieHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h306.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5v-11C352 57.3 294.7 0 224 0zm-55.8 511.1-.2.9h112l-.2-.9h137.5c17 0 30.7-13.8 30.7-30.7 0-79.6-57.6-145.7-133.5-158.9-6.6-1.1-12.9 2.4-15.9 8.4l-44 87.9-15.8-58.6 18.6-31c6.4-10.7-1.3-24.2-13.7-24.2h-39.4c-12.4 0-20.1 13.6-13.7 24.2l18.6 31-15.8 58.6-44-87.9c-3-6-9.4-9.5-15.9-8.4C57.6 334.7 0 400.8 0 480.4c0 17 13.8 30.7 30.7 30.7h137.5zm-49.7-135.6 43.8 87.7h-113c6.1-39.8 33-72.9 69.2-87.7zm167.2 87.7 43.8-87.7c36.2 14.8 63.1 47.8 69.2 87.7h-113z"
        }
    ]
};

const FarUserTieHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserTieHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 144v-16c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80zM224 0c70.7 0 128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 214.7 96 144v-16C96 57.3 153.3 0 224 0zm30.8 418.4 43.8-87.6c3-6 9.4-9.5 15.9-8.4C390.4 335.6 448 401.7 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-79.6 57.6-145.7 133.5-158.9 6.6-1.1 12.9 2.4 15.9 8.4l43.8 87.6 15.9-59.2-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2h39.5c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 15.9 59.2zm-136.3-42.1c-36.2 14.8-63.1 47.9-69.2 87.7h113l-43.8-87.7zM285.7 464h113c-6.1-39.8-33-72.9-69.2-87.7L285.7 464z"
        }
    ]
};

const FarUserTie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserTie",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80a128 128 0 1 1-256 0 128 128 0 1 1 256 0zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2h39.5c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 15.9 59.2 43.8-87.6c3-6 9.4-9.5 15.9-8.4 76 13.2 133.6 79.3 133.6 158.9 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-79.6 57.6-145.7 133.5-158.9 6.6-1.1 12.9 2.4 15.9 8.4l43.8 87.6 15.9-59.2zm-90.6 17.1c-36.2 14.8-63.1 47.9-69.2 87.7h113l-43.8-87.7zM285.7 464h113c-6.1-39.8-33-72.9-69.2-87.7L285.7 464z"
        }
    ]
};

const FarUserUnlock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserUnlock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM49.3 464H384v16c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7-.2 2.1-.3 4.2-.3 6.3v67.7c-22.1-40.4-65-67.7-114.3-67.7h-91.4c-65.7 0-120.1 48.7-129 112zM496 272v48h112c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48c0-44.2 35.8-80 80-80s80 35.8 80 80h-48c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
        }
    ]
};

const FarUserVisor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserVisor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208c26.2 0 49.4-12.6 64-32H160c14.6 19.4 37.8 32 64 32zm0 48c-54 0-100.2-33.5-119-80.8-14.3-3.2-25-16-25-31.2V80c0-17.7 14.3-32 32-32h12.1C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48H336c17.7 0 32 14.3 32 32v64c0 15.3-10.7 28-25 31.2-18.8 47.3-65 80.8-119 80.8zm-96-144c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm141.7 240h-91.4c-65.7 0-120.1 48.7-129 112h349.4c-8.9-63.3-63.3-112-129-112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM313.5 429c-7.9 0-18.8 9.5-26.5 16.3-2.1 1.9-4 3.5-5.5 4.7-2.3 1.7-5.7 0-5.4-2.9 3.2-30.5 13.2-55.5 29.8-74.7 1.3-1.5 4.1-1.6 5.1.1 15.8 20.6 24.2 45.9 25.1 75.3 0 3.2-4.1 4.7-6.1 2.1-10.2-14.4-14.7-19.2-16.6-20.9z"
        }
    ]
};

const FarUserVneckHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserVneckHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-16zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5v-11zM48.3 461.9h351.4c-3.1-46.7-32.9-86.2-74.4-103.1l-50.2 66.9c-25.6 34.1-76.8 34.1-102.4 0l-50.2-66.9c-41.4 16.9-71.3 56.4-74.4 103.1zm83.8-156.2c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 322.2 448 389.5 448 469.9v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.2z"
        }
    ]
};

const FarUserVneckHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserVneckHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-16zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 214.7 96 144v-16zM48.3 464h351.4c-3.1-46.7-32.9-86.2-74.4-103.1l-50.2 66.9c-25.6 34.1-76.8 34.1-102.4 0l-50.2-66.9C81.2 377.8 51.3 417.3 48.3 464zm83.8-156.2c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.2z"
        }
    ]
};

const FarUserVneck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserVneck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80a128 128 0 1 1-256 0 128 128 0 1 1 256 0zM48.3 464h351.4c-3.1-47.3-33.7-87.3-76-103.8L274 422.4c-25.6 32-74.3 32-100 0l-49.7-62.2C82 376.7 51.4 416.7 48.3 464zm85-156.4c5.6-1.2 11.3 1.1 14.9 5.6l63.4 79.2c6.4 8 18.6 8 25 0l63.4-79.2c3.6-4.5 9.3-6.7 14.9-5.6 76 16 133.1 83.5 133.1 164.4v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.9 57.1-148.4 133.3-164.4z"
        }
    ]
};

const FarUserXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUserXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm208 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-82.3 224c65.7 0 120.1 48.7 129 112H49.3c8.9-63.3 63.3-112 129-112h91.4zm-91.4-48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4zM455 143c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FarUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm-208 0a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM49.3 464h349.4c-8.9-63.3-63.3-112-129-112h-91.4c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"
        }
    ]
};

const FarUsersBetweenLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUsersBetweenLines",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0h592c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24S10.7 0 24 0zm0 464h592c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm297.6-256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-60.5 80.8c4.1-.5 8.3-.8 12.5-.8h96c4.2 0 8.4.3 12.5.8 47.1 6.1 83.5 46.4 83.5 95.2 0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32 0-11.2 1.9-22 5.5-32 10.5-29.7 35.3-52.8 66.1-60.9 3.9-1 7.9-1.8 11.9-2.3zm12.5-48.8c-19.4-14.6-32-37.8-32-64 0-44.2 35.8-80 80-80s80 35.8 80 80c0 26.2-12.6 49.4-32 64-13.4 10-30 16-48 16s-34.6-6-48-16zm119.1 101.9c-6.8-3.8-14.7-5.9-23.1-5.9h-96c-20.9 0-38.7 13.4-45.3 32h186.6c-2.6-7.3-6.9-13.8-12.4-19-3.7-1.7-7-4.2-9.8-7.1zM147.2 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM96 256h96c12.2 0 23.7 3.4 33.4 9.4-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32 0-35.3 28.7-64 64-64zm480 96h-82.4c-10.3-40.1-39.6-72.6-77.7-87.4 9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64 0 17.7-14.3 32-32 32zM499.2 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarUsersGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUsersGear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm368 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320h214.1c-26.6-23.5-43.3-57.8-43.3-96 0-7.6.7-15 1.9-22.3-13.6-6.3-28.7-9.7-44.6-9.7h-42.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3 2.5-3.7 5.2-7.3 8-10.7 2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96 43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h300.5c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2H178.7c9.5-36.8 42.9-64 82.6-64h110.6c3.6-5 8.2-9.1 13.5-12.2l2.7-1.5v-4.6l-2.7-1.5zM533.3 192h-42.6c-15.9 0-31 3.5-44.6 9.7 1.3 7.2 1.9 14.7 1.9 22.3 0 17.4-3.5 33.9-9.7 49 2.5.9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6 7.9-1.2 16-1.9 24.2-1.9s16.3.6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3.7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7 2.3 2.8 4.5 5.8 6.6 8.7-2.1-57.1-49-102.7-106.6-102.7zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm304.6 179.9c6.3-3.6 9.5-11.1 6.8-18-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9-2.6 6.8.5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9 2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5 4.6 5.7 12.7 6.7 19 3l18.2-10.2c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9 6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3 3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8 2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1-80 0z"
        }
    ]
};

const FarUsersLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUsersLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M147.2 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM96 192c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h98.7c18.2-31.4 49.3-54.4 86-61.6-10.6-20.4-32-34.4-56.7-34.4H96zm480 96c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64h-96c-24.5 0-45.7 13.7-56.5 33.9 38 6.6 70.3 29.9 89 62.1H576zm-134.8 0c-14.6-16.3-34.6-27.5-57.1-30.9-.6-.1-1.3-.2-1.9-.3-4.1-.5-8.3-.8-12.5-.8h-96c-4.2 0-8.4.3-12.5.8-1.7.2-3.4.5-5.1.8-21.3 3.9-40.1 14.9-53.9 30.4-15.2 17-24.4 39.4-24.4 64 0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32 0-24.6-9.2-47-24.4-64zm58-128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-177.6-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-48 96c13.4 10 30 16 48 16s34.6-6 48-16c19.4-14.6 32-37.8 32-64 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64zm141.3 128H228.3c6.6-18.6 24.4-32 45.3-32h96c20.9 0 38.7 13.4 45.3 32zM0 456c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FarUsersMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUsersMedical",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm368 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7-1.3 7.2-1.9 14.7-1.9 22.3 0 38.2 16.8 72.5 43.3 96H21.3C9.6 320 0 310.4 0 298.7zM405.3 320h-.7c26.6-23.5 43.3-57.8 43.3-96 0-7.6-.7-15-1.9-22.3 13.6-6.3 28.7-9.7 44.6-9.7h42.7c58.9 0 106.7 47.8 106.7 106.7 0 11.8-9.6 21.3-21.3 21.3h-13.4c-6.6-18.6-24.4-32-45.3-32h-32c-20.9 0-38.7 13.4-45.3 32h-77.4zm-26.7 32c19.3 0 37.6 4.1 54.2 11.5-10.3 8.8-16.8 21.9-16.8 36.5v8.6c-11.3-5.5-23.9-8.6-37.3-8.6H261.3c-39.8 0-73.2 27.2-82.6 64h249.5c8.8 9.8 21.6 16 35.8 16h16v16c0 5.6 1 11 2.7 16h-328c-14.7 0-26.7-11.9-26.7-26.7 0-73.6 59.7-133.3 133.3-133.3h117.4zM320 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm192 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FarUsersRays = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUsersRays",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7 7c9.4-9.3 24.6-9.3 34 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41c-9.3-9.4-9.3-24.6 0-34zm626 0c9.4 9.4 9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L599 7c9.4-9.4 24.6-9.4 33.9 0zM41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72zm592 0c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9zM320 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-51.6 82c6.3-1.3 12.9-2 19.6-2h64c6.7 0 13.3.7 19.6 2 1.1.2 2.2.5 3.3.7 23.6 5.8 43.8 20.3 56.9 39.9 1.2 1.7 2.3 3.5 3.3 5.4 8.2 14.1 12.8 30.5 12.8 48 0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32 0-17.5 4.7-33.9 12.8-48 12.9-22.3 34.6-39 60.3-45.3 1.1-.3 2.2-.5 3.3-.7zm96.2-162.6a72 72 0 1 1-89.2 113.1 72 72 0 1 1 89.2-113.1zM397.3 368c-6.6-18.6-24.4-32-45.3-32h-64c-20.9 0-38.7 13.4-45.3 32h154.6zM127.8 176a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM96 309.3c0-29.5 23.9-53.3 53.3-53.3h69.3c9.8 0 18.9 2.6 26.8 7.2-34.6 12.2-62.5 38.9-76.2 72.8h-46.5c-14.8 0-26.7-11.9-26.7-26.7zM470.7 336c-13.7-33.9-41.5-60.6-76.2-72.8 7.9-4.6 17-7.2 26.8-7.2h69.3c29.5 0 53.3 23.9 53.3 53.3 0 14.7-11.9 26.7-26.7 26.7h-46.5zM416 176a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FarUsersRectangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUsersRectangle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C39.4 0 0 39.4 0 88v336c0 48.6 39.4 88 88 88h464c48.6 0 88-39.4 88-88V88c0-48.6-39.4-88-88-88H88zM48 88c0-22.1 17.9-40 40-40h464c22.1 0 40 17.9 40 40v336c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V88zm272 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-51.6 130c-1.1.2-2.2.5-3.3.7-25.7 6.3-47.4 22.9-60.3 45.3-8.2 14.1-12.8 30.5-12.8 48 0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32 0-17.5-4.7-33.9-12.8-48l-3.3-5.4c-13.1-19.6-33.3-34.1-56.9-39.9-1.1-.3-2.2-.5-3.3-.7-6.3-1.3-12.9-2-19.6-2H288c-6.7 0-13.3.7-19.6 2zm7-49.5a72 72 0 1 0 89.2-113.1 72 72 0 1 0-89.2 113.1zM397.3 352H242.7c6.6-18.6 24.4-32 45.3-32h64c20.9 0 38.7 13.4 45.3 32zM223.8 160a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM96 293.3c0 14.7 11.9 26.7 26.7 26.7h46.6c13.7-33.9 41.5-60.6 76.2-72.8-7.9-4.6-17-7.2-26.8-7.2h-69.4c-29.4 0-53.3 23.9-53.3 53.3zM470.7 320h46.6c14.7 0 26.7-11.9 26.7-26.7 0-29.5-23.9-53.3-53.3-53.3h-69.4c-9.8 0-18.9 2.6-26.8 7.2 34.6 12.2 62.5 38.9 76.2 72.8zM512 160a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FarUsersSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUsersSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320h178.1c11.8 0 21.3-9.6 21.3-21.3 0-58.9-47.8-106.7-106.7-106.7h-42.6c-15.9 0-31 3.5-44.6 9.7 1.3 7.2 1.9 14.7 1.9 22.3 0 30.2-10.5 58-28 79.9l-25.2-19.7c13.3-16.5 21.2-37.4 21.2-60.2 0-53-43-96-96-96-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9 0-44.2-35.8-80-80-80-27.7 0-52.1 14.1-66.5 35.5L38.8 5.1zm242.7 190.2c8.8-11.7 22.7-19.3 38.5-19.3 26.5 0 48 21.5 48 48 0 11.6-4.1 22.2-11 30.5l-75.5-59.2zM106.7 192C47.8 192 0 239.8 0 298.7 0 310.4 9.6 320 21.3 320h214.1c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192h-15.1zm154.6 160C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h330.6c10.5 0 19.5-6 23.9-14.8l-49.7-39.1c.7 1.9 1.2 3.9 1.8 5.9H178.7c9.5-36.8 42.9-64 82.6-64h117.4c2.6 0 5.1.1 7.6.3L324.9 352h-63.6zM512 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
        }
    ]
};

const FarUsersViewfinder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUsersViewfinder",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 48v88c0 13.3-10.7 24-24 24S0 149.3 0 136V32C0 14.3 14.3 0 32 0h104c13.3 0 24 10.7 24 24s-10.7 24-24 24H48zm544 0h-88c-13.3 0-24-10.7-24-24s10.7-24 24-24h104c17.7 0 32 14.3 32 32v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V48zM136 464c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-17.7 0-32-14.3-32-32V376c0-13.3 10.7-24 24-24s24 10.7 24 24v88h88zm456 0v-88c0-13.3 10.7-24 24-24s24 10.7 24 24v104c0 17.7-14.3 32-32 32H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h88zM320 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-51.6 82c6.3-1.3 12.9-2 19.6-2h64c6.7 0 13.3.7 19.6 2 1.1.2 2.2.5 3.3.7 23.6 5.8 43.8 20.3 56.9 39.9 1.2 1.7 2.3 3.5 3.3 5.4 8.2 14.1 12.8 30.5 12.8 48 0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32 0-17.5 4.7-33.9 12.8-48 12.9-22.3 34.6-39 60.3-45.3 1.1-.3 2.2-.5 3.3-.7zm96.2-162.6a72 72 0 1 1-89.2 113.1 72 72 0 1 1 89.2-113.1zM397.3 368c-6.6-18.6-24.4-32-45.3-32h-64c-20.9 0-38.7 13.4-45.3 32h154.6zM127.8 176a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM96 309.3c0-29.5 23.9-53.3 53.3-53.3h69.3c9.8 0 18.9 2.6 26.8 7.2-34.6 12.2-62.5 38.9-76.2 72.8h-46.5c-14.8 0-26.7-11.9-26.7-26.7zM470.7 336c-13.7-33.9-41.5-60.6-76.2-72.8 7.9-4.6 17-7.2 26.8-7.2h69.3c29.5 0 53.3 23.9 53.3 53.3 0 14.7-11.9 26.7-26.7 26.7h-46.5zM416 176a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FarUsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUsers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm368 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320h214.1c-26.6-23.5-43.3-57.8-43.3-96 0-7.6.7-15 1.9-22.3-13.6-6.3-28.7-9.7-44.6-9.7h-42.7C47.8 192 0 239.8 0 298.7zM405.3 320h213.4c11.8 0 21.3-9.6 21.3-21.3 0-58.9-47.8-106.7-106.7-106.7h-42.6c-15.9 0-31 3.5-44.6 9.7 1.3 7.2 1.9 14.7 1.9 22.3 0 38.2-16.8 72.5-43.3 96h.7zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 80h117.4c39.8 0 73.2 27.2 82.6 64H178.7c9.5-36.8 42.9-64 82.6-64zm0-48C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h330.6c14.7 0 26.7-11.9 26.7-26.7 0-73.6-59.7-133.3-133.3-133.3H261.3z"
        }
    ]
};

const FarUtensilsSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUtensilsSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L115.3 65l4.9-43.7C121.6 8.2 133.5-1.3 146.7.1s22.7 13.3 21.2 26.5l-8.1 73.2 40.2 31.7V24c0-13.3 10.7-24 24-24s24 10.7 24 24v145.1l43.2 33.9c3-5.6 4.8-12.1 4.8-19v-14.7L280.1 26.7c-1.5-13.2 8-25 21.2-26.5s25 8 26.5 21.2l16 144 .1 1.3V184c0 18-5.4 34.8-14.7 48.8l54.8 42.9V176C384 32 496 0 512 0c17.7 0 32 14.3 32 32v369.1l86.8 68c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2zM104 184v-6.1l144 113.5V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272h-8c-48.6 0-88-39.4-88-88zm415.7 328h.6-.6zM432 176v112c0 8.8 7.2 16 16 16h48V55.1c-7.1 3.6-14.9 8.5-22.6 15.2-19.7 17.1-41.4 48-41.4 105.7z"
        }
    ]
};

const FarUtensils = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUtensils",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M71.9 26.7c1.5-13.2-8-25-21.2-26.5s-25 8-26.5 21.2l-16 144-.2 1.3V184c0 48.6 39.4 88 88 88h8v216c0 13.3 10.7 24 24 24s24-10.7 24-24V272h8c48.6 0 88-39.4 88-88v-17.3l-.1-1.3-16-144C230.4 8.2 218.5-1.3 205.3.1s-22.7 13.3-21.2 26.5L200 169.3V184c0 22.1-17.9 40-40 40H96c-22.1 0-40-17.9-40-40v-14.7L71.9 26.7zM152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V24zm184 152c0-57.7 21.7-88.6 41.4-105.7 7.7-6.6 15.5-11.6 22.6-15.2V304h-48c-8.8 0-16-7.2-16-16V176zm64 176v136c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32-16 0-128 32-128 176v112c0 35.3 28.7 64 64 64h48z"
        }
    ]
};

const FarUtilityPoleDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUtilityPoleDouble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H128V56c0-13.3-10.7-24-24-24S80 42.7 80 56v24H48V56c0-13.3-10.7-24-24-24S0 42.7 0 56v32c0 22.1 17.9 40 40 40h43.2L232 227.2V272H128v-24c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H48v-24c0-13.3-10.7-24-24-24S0 234.7 0 248v32c0 22.1 17.9 40 40 40h43.2L232 419.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-68.8L428.8 320H472c22.1 0 40-17.9 40-40v-32c0-13.3-10.7-24-24-24s-24 10.7-24 24v24h-32v-24c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H280v-44.8L428.8 128H472c22.1 0 40-17.9 40-40V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v24h-32V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H280V24zm91.2 104L280 188.8V128h91.2zM232 188.8 140.8 128H232v60.8zM371.2 320 280 380.8V320h91.2zM232 380.8 140.8 320H232v60.8z"
        }
    ]
};

const FarUtilityPole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarUtilityPole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H128V56c0-13.3-10.7-24-24-24S80 42.7 80 56v24H48V56c0-13.3-10.7-24-24-24S0 42.7 0 56v32c0 22.1 17.9 40 40 40h43.2L232 227.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V227.2L428.8 128H472c22.1 0 40-17.9 40-40V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v24h-32V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H280V24zm91.2 104L280 188.8V128h91.2zM232 188.8 140.8 128H232v60.8z"
        }
    ]
};

const FarV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarV",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M14.7 33.9c12.2-5.1 26.3.6 31.4 12.8L192 394 337.9 46.7c5.1-12.2 19.2-18 31.4-12.8s18 19.2 12.8 31.4l-168 400c-3.7 8.9-12.5 14.7-22.1 14.7s-18.4-5.8-22.1-14.7l-168-400c-5.2-12.2.6-26.3 12.8-31.4z"
        }
    ]
};

const FarVacuumRobot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVacuumRobot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm335-79c-43.6-43.6-114.4-43.6-158.1 0-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c62.4-62.4 163.5-62.4 225.9 0s62.4 163.5 0 225.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c43.6-43.6 43.6-114.4 0-158.1zm-122.3 35.7c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z"
        }
    ]
};

const FarVacuum = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVacuum",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M290 48c-27.1 0-50.6 19-56.2 45.5L206 224h-49.1l29.9-140.5C197.2 34.8 240.2 0 290 0h238c61.9 0 112 50.1 112 112 0 44.8-26.3 83.5-64.3 101.4C596.1 243.9 608 280.5 608 320v128c0 35.3-28.7 64-64 64h-75.3c14.8-13 26.5-29.4 34-48H544c8.8 0 16-7.2 16-16V320c0-79.5-64.5-144-144-144-8.8 0-16 7.2-16 16v97c-5.2-.7-10.6-1-16-1-11 0-21.8 1.4-32 4V192c0-35.3 28.7-64 64-64 47.9 0 91.8 17.6 125.4 46.6 28.9-6.1 50.6-31.9 50.6-62.6 0-35.3-28.7-64-64-64H290zM150.1 256h49.1l-27.5 129.1c29.8 5.5 52.3 31.6 52.3 62.9 0 35.3-28.7 64-64 64H32c-17.7 0-32-14.3-32-32 0-53 43-96 96-96h26.9l27.2-128zM432 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm-112 32c0-8.8-7.2-16-16-16H96c-20.9 0-38.7 13.4-45.3 32H160c8.8 0 16-7.2 16-16zm208-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarValueAbsolute = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarValueAbsolute",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm153 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l79 79-79 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l79-79 79 79c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79-79 79-79c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-79 79-79-79zm335-87c0-13.3-10.7-24-24-24s-24 10.7-24 24v400c0 13.3 10.7 24 24 24s24-10.7 24-24V56z"
        }
    ]
};

const FarVanShuttle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVanShuttle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 96v96h128V80H64c-8.8 0-16 7.2-16 16zm0 144v80c0 8.8 7.2 16 16 16h12.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48h153.6c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H576c8.8 0 16-7.2 16-16v-80H48zm176-48h112V80H224v112zm160 0h180.1L471.3 82.8c-1.5-1.8-3.7-2.8-6.1-2.8H384v112zm256 128c0 35.3-28.7 64-64 64 0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h401.2c16.4 0 32 7.2 42.7 19.7l118.8 139.8c8.6 10.1 13.3 23 13.3 36.3V320zm-112 64a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-368 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarVault = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVault",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v352c0 35.3-28.7 64-64 64v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H112v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c-35.3 0-64-28.7-64-64V64zm320 176a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm-240 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272-16c0 17.8-9.7 33.3-24 41.6V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V217.6c-14.3-8.3-24-23.8-24-41.6 0-26.5 21.5-48 48-48s48 21.5 48 48z"
        }
    ]
};

const FarVectorCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVectorCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 88h48V40h-48v48zm-40-56c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v17.6c67.8 21 121.4 74.5 142.4 142.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-17.6c-21 67.8-74.5 121.4-142.4 142.4V480c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-17.6c-67.8-21-121.4-74.6-142.4-142.4H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h17.6c21-67.8 74.6-121.4 142.4-142.4V32zm-91.5 160.3C116 194.5 128 207.9 128 224v64c0 16.1-12 29.5-27.5 31.7 17 41.6 50.3 74.8 91.8 91.8C194.5 396 207.9 384 224 384h64c16.1 0 29.5 12 31.7 27.5 41.6-17 74.8-50.3 91.8-91.8C396 317.5 384 304.1 384 288v-64c0-16.1 12-29.5 27.5-31.7-17-41.6-50.3-74.8-91.8-91.8C317.5 116 304.1 128 288 128h-64c-16.1 0-29.5-12-31.7-27.5-41.6 17-74.8 50.3-91.8 91.8zM424 232v48h48v-48h-48zM232 424v48h48v-48h-48zM40 232v48h48v-48H40z"
        }
    ]
};

const FarVectorPolygon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVectorPolygon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M360 72h48v48h-48V72zm-8-40c-17.7 0-32 14.3-32 32v8H128v-8c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32h8v192h-8c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-8h192v8c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-42.4l-27.4-45.6c3.7-5.2 5.8-11.5 5.8-18.4v-64c0-6.8-2.1-13.2-5.8-18.4l27.4-45.6H416c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-64zm-53.6 288 27.4 45.6c-3.7 5.2-5.8 11.5-5.8 18.4v8H128v-8c0-17.7-14.3-32-32-32h-8V160h8c17.7 0 32-14.3 32-32v-8h192v8c0 6.8 2.1 13.2 5.8 18.4L298.4 192H256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h42.4zM40 440v-48h48v48H40zm320 0v-48h48v48h-48zM40 120V72h48v48H40zm224 112h48v48h-48v-48z"
        }
    ]
};

const FarVectorSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVectorSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M360 72h48v48h-48V72zm-8-40c-17.7 0-32 14.3-32 32v8H128v-8c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32h8v192h-8c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-8h192v8c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-8V160h8c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-64zM88 352V160h8c17.7 0 32-14.3 32-32v-8h192v8c0 17.7 14.3 32 32 32h8v192h-8c-17.7 0-32 14.3-32 32v8H128v-8c0-17.7-14.3-32-32-32h-8zm-48 88v-48h48v48H40zm320 0v-48h48v48h-48zM40 120V72h48v48H40z"
        }
    ]
};

const FarVentDamper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVentDamper",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 112c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h384zM128 64c-35.3 0-64 28.7-64 64v32H32c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h32v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32h-32v-32c0-35.3-28.7-64-64-64H128zm56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FarVenusDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVenusDouble",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm176-128c0 89.1-66.2 162.7-152 174.4V400h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-49.6C82.2 338.7 16 265.1 16 176 16 78.8 94.8 0 192 0s176 78.8 176 176zm-24 142c10.9-11.7 20.5-24.6 28.5-38.6 21.2 15.5 47.3 24.6 75.5 24.6 70.7 0 128-57.3 128-128S518.7 48 448 48c-28.2 0-54.3 9.1-75.5 24.6-8-14-17.6-26.9-28.5-38.6 29.1-21.4 65.1-34 104-34 97.2 0 176 78.8 176 176 0 89.1-66.2 162.7-152 174.4V400h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-49.6c-29.7-4-57-15.5-80-32.4z"
        }
    ]
};

const FarVenusMars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVenusMars",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm176-128c0 89.1-66.2 162.7-152 174.4V400h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-49.6C66.2 338.7 0 265.1 0 176 0 78.8 78.8 0 176 0s176 78.8 176 176zm-80.1 184.6c14.6-7.6 28.1-16.8 40.4-27.5C335.2 354.8 366 368 400 368c70.7 0 128-57.3 128-128s-57.3-128-128-128c-8.6 0-17.1.9-25.2 2.5-4.9-15.8-11.6-30.7-19.9-44.7C369.3 66 384.4 64 400 64c39.9 0 76.8 13.3 106.3 35.7L558.1 48H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h112c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9l-51.7 51.7C562.7 163.2 576 200.1 576 240c0 97.2-78.8 176-176 176-50.5 0-96-21.3-128.1-55.4z"
        }
    ]
};

const FarVenus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVenus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 176a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm152 174.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4V400h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-49.6z"
        }
    ]
};

const FarVestPatches = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVestPatches",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m178.5 81.5 28.8 95-25.1 82.8-64-211.2c-.3 0-.6-.1-.9-.1H104c-4.4 0-8 3.6-8 8v130.7c0 13-3.5 25.9-10.3 37l-34.3 57.2c-2.2 3.7-3.4 8-3.4 12.3V456c0 4.4 3.6 8 8 8h120.4c1.6 17.6 8.4 33.8 18.8 46.9-3.6.7-7.4 1.1-11.2 1.1H56c-30.9 0-56-25.1-56-56V293.3c0-13 3.5-25.9 10.3-37l34.3-57.2c2.2-3.7 3.4-8 3.4-12.3V56c0-30.9 25.1-56 56-56h20.1c10.1 0 19.5 3.8 26.7 10.2 4.6 2.8 8.6 6 12 9C172.3 27.6 191.4 40 224 40s51.7-12.4 61.2-20.8c3.4-3.1 7.5-6.2 12-9C304.4 3.8 313.8 0 323.9 0H344c30.9 0 56 25.1 56 56v130.7c0 4.4 1.2 8.6 3.4 12.3l34.3 57.2c6.7 11.2 10.3 24 10.3 37V456c0 30.9-25.1 56-56 56H264c-30.9 0-56-25.1-56-56V295.1c0-7.1 1-14.1 3.1-20.9l58.4-192.7c-13 4-28.1 6.5-45.5 6.5s-32.5-2.6-45.5-6.5zm151.3-33.4L257 288.2c-.7 2.3-1 4.6-1 7V456c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8V293.3c0-4.4-1.2-8.6-3.4-12.3l-34.3-57.2c-6.7-11.2-10.3-24-10.3-37V56c0-3.9-2.7-7.1-6.4-7.8-.5-.1-1.1-.2-1.6-.2h-13.3c-.3 0-.6 0-.9.1zM288 288v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c-8.8 0-16-7.2-16-16v-32zM84.7 260.7c6.2-6.2 16.4-6.2 22.6 0l12.7 12.7 12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L142.6 296l12.7 12.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L120 318.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.4 296l-12.7-12.7c-6.2-6.2-6.2-16.4 0-22.6zM112 360a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
        }
    ]
};

const FarVest = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVest",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 0h13.3c19.4 0 35.2 10 45.5 19.2C172.3 27.6 191.4 40 224 40s51.7-12.4 61.2-20.8C295.5 10 311.3 0 330.7 0H344c1.9 0 3.8.1 5.7.3C378 3.2 400 27 400 56v130.7c0 4.4 1.2 8.6 3.4 12.3l34.3 57.2c6.7 11.2 10.3 24 10.3 37V456c0 30.9-25.1 56-56 56H264c-30.9 0-56-25.1-56-56V295.1c0-7.1 1-14.1 3.1-20.9l58.4-192.7c-13 4-28.1 6.5-45.5 6.5s-32.5-2.6-45.5-6.5l28.8 95-25.1 82.8-62.3-205.6c-1-3.4-4.1-5.7-7.7-5.7H104c-4.4 0-8 3.6-8 8v130.7c0 13-3.5 25.9-10.3 37l-34.3 57.2c-2.2 3.7-3.4 8-3.4 12.3v104.9l55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-85.5 85.5c1.3.9 2.9 1.5 4.6 1.5h120.4c1.6 17.6 8.4 33.8 18.8 46.9-3.6.7-7.4 1.1-11.2 1.1H56c-30.9 0-56-25.1-56-56V293.3c0-13 3.5-25.9 10.3-37l34.3-57.2c2.2-3.7 3.4-8 3.4-12.3V56c0-30.9 25.1-56 56-56zm248 56c0-4.4-3.6-8-8-8h-8.3c-3.5 0-6.6 2.3-7.7 5.7l-71 234.5c-.7 2.3-1 4.6-1 7V456c0 4.4 3.6 8 8 8h128c1.7 0 3.3-.5 4.6-1.5L311 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55V293.3c0-4.4-1.2-8.6-3.4-12.3l-34.3-57.2c-6.7-11.2-10.3-24-10.3-37V56z"
        }
    ]
};

const FarVialCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVialCircleCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v186.8c-20.2 28.6-32 63.5-32 101.2 0 25.2 5.3 49.1 14.8 70.8-17.3 24.9-46.2 41.2-78.8 41.2-53 0-96-43-96-96V80h-8C10.7 80 0 69.3 0 56zm80 24v112h96V80H80zm0 160v144c0 26.5 21.5 48 48 48s48-21.5 48-48V240H80zm144 128a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FarVialVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVialVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h8v304c0 53 43 96 96 96 28 0 53.3-12 70.8-31.2-.2-14.6 5.2-29.3 16.4-40.5.2-.2.2-.3.3-.3 0-.1 0-.3-.1-.6s-.2-.4-.3-.5h-.5c-15.2 0-29-6.1-39.1-15.9-3.4 23.2-23.4 41-47.5 41-26.5 0-48-21.5-48-48V240h96v70.3c10-9.6 23.6-15.4 38.6-15.4h.5c.1-.1.2-.2.3-.5s.1-.5.1-.6c0-.1-.1-.2-.3-.3-21.9-21.9-21.9-57.3 0-79.2 2.7-2.7 5.7-5.1 8.8-7.2V80h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm56 160V80h96v112H80zm271.8-2.3c-13.3 0-24 10.7-24 24 0 29.3-35.4 43.9-56.1 23.2-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.7 20.7 6 56.1-23.2 56.1-13.3 0-24 10.7-24 24s10.7 24 24 24c29.3 0 43.9 35.4 23.2 56.1-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.7-20.7 56.1-6 56.1 23.2 0 13.3 10.7 24 24 24s24-10.7 24-24c0-29.3 35.4-43.9 56.1-23.2 9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.7-20.7-6-56.1 23.2-56.1 13.3 0 24-10.7 24-24s-10.7-24-24-24c-29.3 0-43.9-35.4-23.2-56.1 9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.7 20.7-56.1 6-56.1-23.2 0-13.3-10.7-24-24-24zM320 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FarVial = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVial",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M329 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15 15L30.2 335.8C10.9 355.2 0 381.4 0 408.8 0 465.8 46.2 512 103.2 512c27.4 0 53.6-10.9 73-30.2L456 201.9l15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-32-32L361 39 329 7zM178 256 344 89.9l78.1 78.1-88 88H177.9z"
        }
    ]
};

const FarVials = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVials",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v320c0 44.2-35.8 80-80 80s-80-35.8-80-80V80h-8C10.7 80 0 69.3 0 56zm80 24v176h64V80H80zm208-24c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v320c0 44.2-35.8 80-80 80s-80-35.8-80-80V80h-8c-13.3 0-24-10.7-24-24zm80 24v176h64V80h-64z"
        }
    ]
};

const FarVideoArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVideoArrowDownLeft",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 112c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h256zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm464 84.6v214.8L416 313v52.6l104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5 21.8 0 39.5-17.7 39.5-39.5v-241c0-21.8-17.7-39.5-39.5-39.5-5.6 0-11.1 1.2-16.2 3.5L416 146.4V199l112-50.4zM232 352c13.3 0 24-10.7 24-24s-10.7-24-24-24h-54.1L281 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-103 103V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24H232z"
        }
    ]
};

const FarVideoArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVideoArrowUpRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 112c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h256zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm464 84.6v214.8L416 313v52.6l104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5 21.8 0 39.5-17.7 39.5-39.5v-241c0-21.8-17.7-39.5-39.5-39.5-5.6 0-11.1 1.2-16.2 3.5L416 146.4V199l112-50.4zM152 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1L103 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l103-103V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24H152z"
        }
    ]
};

const FarVideoPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVideoPlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 112c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h256zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm464 84.6v214.8L416 313v52.6l104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5 21.8 0 39.5-17.7 39.5-39.5v-241c0-21.8-17.7-39.5-39.5-39.5-5.6 0-11.1 1.2-16.2 3.5L416 146.4V199l112-50.4zM216 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-48z"
        }
    ]
};

const FarVideoSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVideoSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L113.9 64H352c35.3 0 64 28.7 64 64v172.8l144 112.8v-265L448 199v-52.6l104.3-46.9c5.1-2.3 10.6-3.5 16.2-3.5 21.8 0 39.5 17.7 39.5 39.5v315.8l22.8 17.9c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM368 263.1V128c0-8.8-7.2-16-16-16H175.2L368 263.1zM32 128c0-2.2.1-4.4.3-6.5L80 159v225c0 8.8 7.2 16 16 16h256c8.2 0 15-6.2 15.9-14.1l39.1 30.8c-11.2 18.7-31.6 31.3-55 31.3H96c-35.3 0-64-28.7-64-64V128z"
        }
    ]
};

const FarVideo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVideo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm528 235.4V148.6L416 199v-52.6l104.3-46.9c5.1-2.3 10.6-3.5 16.2-3.5 21.8 0 39.5 17.7 39.5 39.5v241c0 21.8-17.7 39.5-39.5 39.5-5.6 0-11.1-1.2-16.2-3.5L416 365.6V313l112 50.4z"
        }
    ]
};

const FarVihara = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVihara",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M308.5 61.4c-31 21.7-64.8 39-100.5 51.3V160h224v-47.3c-35.7-12.3-69.5-29.6-100.5-51.3L320 53.3l-11.5 8.1zm173.2 65.8-1.7-.5v39.7l1.7 1.9 2.5 2.9c27.3 31.5 62.5 55.1 102.1 68.3l4.8 1.6c1.6.5 3.2 1.2 4.6 2 3.1 1.7 5.8 4.1 7.8 7s3.5 6.1 4.1 9.6c.5 2.7.6 5.5.1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-7 7.8s-6.1 3.5-9.6 4.1c-1.6.3-3.3.4-5 .4H544v36.6l4.3 7.4 1.9 3.3c17.2 29.6 43.4 52.9 74.8 66.5 8.8 3.6 15 12.2 15 22.3 0 13.3-10.7 24-24 24h-40v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H344v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H112v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40H24c-13.3 0-24-10.7-24-24 0-10.1 6.2-18.7 15-22.3 31.4-13.6 57.6-36.9 74.8-66.5l1.9-3.3 4.3-7.4V288H56.6c-1.7 0-3.4-.1-5-.4-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6.1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l4.8-1.6c39.5-13.2 74.8-36.8 102.1-68.3l2.5-2.9 1.7-1.9v-39.7l-1.7.5c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5l23.6-6.4c40-11 77.8-28.7 111.8-52.5l24.8-17.3c1.3-.9 2.7-1.8 4.1-2.4C313.1.7 316.6 0 320 0s6.9.7 10.1 2.2c1.4.7 2.8 1.5 4.1 2.4L359 22c34 23.8 71.8 41.5 111.8 52.4l23.6 6.4c12.8 3.5 20.3 16.7 16.8 29.5s-16.7 20.3-29.5 16.8zM496 320v-32H144v32h352zm-343.2-80h334.4c-12.3-9.6-23.9-20.3-34.5-32H187.3c-10.6 11.7-22.2 22.4-34.5 32zm-52.3 160h439c-9.5-9.8-18.1-20.5-25.5-32H126c-7.5 11.5-16 22.2-25.5 32z"
        }
    ]
};

const FarViolin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarViolin",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM345 41 41 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L311 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM198.4 403.2c6.4-4.8 15.3-4.1 20.9 1.5l16 16c5.6 5.6 6.3 14.5 1.5 20.9l-5.3 7.1c16.6 9.7 35.9 15.3 56.5 15.3 25.2 0 48.3-8.2 67-22.2-2-8.3-3-17-3-25.8 0-60 47.3-109.1 106.6-111.9 8.2-19.7 8.4-46.6-12.7-76.1L361 313c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l84.9-85c-29.5-21-56.4-20.8-76.1-12.7C333.1 240.8 284 288 224 288c-8.8 0-17.5-1-25.8-3-14 18.7-22.2 41.8-22.2 67 0 20.6 5.6 39.9 15.3 56.5l7.1-5.3zm-45.7 34.3C137 412.8 128 383.5 128 352c0-41.2 15.5-78.7 41.1-107 9.7-10.7 25.8-10.1 39.8-6.7 4.8 1.2 9.9 1.8 15.1 1.8 35.3 0 64-28.7 64-64 0-11.6 2.6-24 12.4-30.1 39.3-24.7 94.3-26.4 145.8 14L599 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L480.2 193.8c40.3 51.5 38.6 106.5 14 145.8-6.2 9.8-18.6 12.4-30.2 12.4-35.3 0-64 28.7-64 64 0 5.2.6 10.2 1.8 15.1 3.4 14.1 4 30.2-6.7 39.8C366.7 496.5 329.2 512 288 512c-31.4 0-60.7-9.1-85.5-24.7l-13.7 18.3c-2.8 3.7-7 6-11.7 6.4s-9.2-1.4-12.4-4.6l-32-32c-3.3-3.3-5-7.8-4.6-12.4s2.6-8.9 6.4-11.7l18.3-13.7zM448 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarVirusCovidSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVirusCovidSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v16h-33.6c-4.2-30.7-16.3-58.8-34.1-82.3l23.7-23.8 11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56.5-56.6c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8c-23.5-17.9-51.6-30-82.3-34.2V48h16c13.3 0 24-10.7 24-24S373.3 0 360 0h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-33.2 33L38.8 5.1zm197 154.4c22.5-19.6 52-31.5 84.2-31.5 70.7 0 128 57.3 128 128 0 21.2-5.1 41.1-14.2 58.7l-198-155.2zM145.6 232H112v-16c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9c-12.1 3.7-24.9 5.7-38.2 5.7-70.7 0-128-57.3-128-128 0-2.9.1-5.7.3-8.5l-43.1-34c-1.5 6-2.7 12.2-3.5 18.5z"
        }
    ]
};

const FarVirusCovid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVirusCovid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.6c-30.7 4.2-58.8 16.3-82.3 34.1L125.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-56.6 56.5c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L92 125.9l23.8 23.8c-17.9 23.5-30 51.6-34.2 82.3H48v-16c0-13.3-10.7-24-24-24S0 202.7 0 216v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h33.6c4.2 30.7 16.3 58.8 34.1 82.3L92 386.1l-11.4-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L125.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-33.6c30.7-4.2 58.8-16.3 82.3-34.1l23.8 23.7-11.3 11.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L420 386.1l-23.8-23.8c17.9-23.5 29.9-51.7 34.1-82.3H464v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v16h-33.6c-4.2-30.7-16.3-58.8-34.1-82.3l23.7-23.8 11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56.5-56.6c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L386.1 92l-23.8 23.8c-23.5-17.9-51.6-30-82.3-34.2V48h16c13.3 0 24-10.7 24-24S309.3 0 296 0h-80zm40 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 112a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm48 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarVirusSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVirusSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-11.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11.5c0 49.9-60.3 74.9-95.6 39.6l-8.2-8.1c-12.5-12.5-32.8-12.5-45.3 0-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm181.2 142c39 4.3 78.6-14.2 100-47.6 23.3 36.4 68.4 55.1 110.6 45.8-9.3 42.2 9.4 87.3 45.8 110.6-21.2 13.6-36.4 34.5-43.6 58L220 147.1zm182 265.6-44.6-35.1c-14.9 8.2-27.9 20.1-37.4 34.8-23.3-36.4-68.4-55.1-110.6-45.8 9.3-42.2-9.4-87.3-45.8-110.6 7.1-4.5 13.6-9.9 19.2-16l-38.1-30c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-11.5c0-31.2 23.6-52.7 50-55.7z"
        }
    ]
};

const FarVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M75 75c12.5-12.5 32.8-12.5 45.3 0l8.2 8.2c35.2 35.2 95.5 10.2 95.5-39.7V32c0-17.7 14.3-32 32-32s32 14.3 32 32v11.5c0 49.9 60.3 74.9 95.6 39.6l8.2-8.2c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-8.2 8.2c-35.3 35.3-10.3 95.6 39.6 95.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32h-11.5c-49.9 0-74.9 60.3-39.6 95.6l8.2 8.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-8.2-8.2c-35.3-35.3-95.6-10.3-95.6 39.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-11.5c0-49.9-60.3-74.9-95.6-39.6l-8.2 8.2c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l8.2-8.2c35.3-35.3 10.3-95.6-39.6-95.6H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h11.5c49.9 0 74.9-60.3 39.6-95.6l-8.1-8.2C62.5 107.7 62.5 87.5 75 75zm181 24.6c-23.3 36.4-68.4 55.1-110.6 45.8 9.3 42.2-9.4 87.3-45.8 110.6 36.4 23.3 55.1 68.4 45.8 110.6 42.2-9.3 87.3 9.4 110.6 45.8 23.3-36.4 68.4-55.1 110.6-45.8-9.3-42.2 9.4-87.3 45.8-110.6-36.4-23.3-55.1-68.4-45.8-110.6-21.2 4.7-43.1 2.3-62.6-5.8-19.4-8.1-36.4-21.8-48-40zM192 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarViruses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarViruses",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M327.8 293.8c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5c-25.3-25.2-68.4-7.3-68.4 28.3V360c0 13.3-10.7 24-24 24s-24-10.7-24-24v-13.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h13.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 34 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24s24 10.7 24 24v13.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5c-25.2 25.2-7.3 68.3 28.3 68.3H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-13.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5zm-42-101.8c-17.9-17.2-28-41.6-27.5-66.4-11.1.2-22.1-1.7-32.4-5.5-12.7-4.7-24.4-12.2-33.9-22-17.2 17.9-41.6 28-66.4 27.5.5 24.8-9.6 49.2-27.5 66.4 17.9 17.2 28 41.6 27.5 66.4 24.8-.5 49.2 9.6 66.4 27.5 17.2-17.9 41.6-28 66.4-27.5-.5-24.8 9.6-49.2 27.5-66.4zM512 240c0 33 39.9 49.5 63.2 26.2 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM152 176a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm72 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarVoicemail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVoicemail",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm107.3 192c22.8-25.5 36.7-59.1 36.7-96 0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144h352c79.5 0 144-64.5 144-144S575.5 96 496 96s-144 64.5-144 144c0 36.9 13.9 70.5 36.7 96H251.3zM496 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FarVolcano = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVolcano",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31c11.2-9.4 25.5-15 41.2-15 35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM48 459.8c0 2.3 1.9 4.2 4.2 4.2h407.6c2.3 0 4.2-1.9 4.2-4.2 0-1-.4-2-1.1-2.8L361.3 342.7l-15 15c-6.6 6.6-15.5 10.3-24.8 10.3-11 0-21.4-5.2-28-14l-18-24c-12.3-16.4-31.5-26-52-26-15.2 0-29.9 5.3-41.6 15.1l-39.4 32.8-93.4 105.2c-.7.8-1.1 1.7-1.1 2.8zm115.4-203.6c18.2-20.5 44.3-32.2 71.8-32.2H277c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7 0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
        }
    ]
};

const FarVolleyball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVolleyball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.5 429c-71.4 7-145.1-8.2-210-47.1-8.8 14.8-16.2 30.3-22.3 46.3C172.5 450.8 212.7 464 256 464c42.7 0 82.5-12.9 115.5-35zm60.1-61.5c9.2-14.4 16.6-30.1 22.1-46.7-65.9 7.3-134.5-4.3-197.1-37.1a293.62 293.62 0 0 0-67.2 58.9c75.2 43.8 163.6 51 242.3 24.9zm31.8-96.4c.4-5 .5-10 .5-15.1 0-77.9-42.8-145.8-106.3-181.5 35.6 58.4 54.2 127.7 49.6 200.3 18.8.5 37.6-.7 56.1-3.8zM101 394.7c26.6-60.7 71-114.2 130.7-152-1.3-30-7.1-58.9-16.8-85.9-74.7 32.7-129.2 92.8-156.8 163.5 9 27.9 23.8 53.1 42.9 74.5zM49 234.8C84.1 182.9 133.8 140 195.2 113c-8.7-15.7-18.7-30.4-29.9-44.2-63.4 30.8-108.8 92.8-116.2 166zM213.3 52.4c39.3 53.4 63.5 118.6 66.4 189.2 25.7 13.4 52.6 22.6 79.9 27.9 4.6-84.1-26.8-163-81.5-220.4-7.2-.8-14.6-1.2-22.1-1.2-14.6 0-28.9 1.5-42.7 4.4zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 0z"
        }
    ]
};

const FarVolumeHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVolumeHigh",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M533.6 32.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8c54.2 44 88.7 111 88.7 186.2s-34.5 142.2-88.7 186.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C598.5 426.8 640 346.2 640 256S598.5 85.2 533.6 32.5zM473.1 107c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C475.3 170.7 496 210.9 496 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c21.5-17.7 35.4-44.5 35.4-74.6s-13.9-56.9-35.4-74.5zm-252.7 20.4L272 102.3v307.4l-112.1-99.6c-4.4-3.9-10.1-6.1-15.9-6.1H56c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9l135.5 120.5c5.5 4.8 12.5 7.5 19.8 7.5 16.5 0 29.8-13.3 29.8-29.8V61.8c0-16.5-13.3-29.8-29.8-29.8z"
        }
    ]
};

const FarVolumeLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVolumeLow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M159.9 201.9 272 102.3v307.4l-112.1-99.6c-4.4-3.9-10.1-6.1-15.9-6.1H56c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9l135.5 120.5c5.5 4.8 12.5 7.5 19.8 7.5 16.5 0 29.8-13.3 29.8-29.8V61.8c0-16.5-13.3-29.8-29.8-29.8zm122.4 149.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c21.5-17.7 35.4-44.5 35.4-74.6s-13.9-56.9-35.4-74.5z"
        }
    ]
};

const FarVolumeOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVolumeOff",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m272 102.3-112.1 99.6c-4.4 3.9-10.1 6.1-15.9 6.1H56c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h88c5.9 0 11.6 2.2 15.9 6.1L272 409.7V102.3zm-1.6-62.8c5.5-4.8 12.5-7.5 19.8-7.5 16.5 0 29.8 13.3 29.8 29.8v388.4c0 16.5-13.3 29.8-29.8 29.8-7.3 0-14.3-2.7-19.8-7.5L134.9 352H56c-30.9 0-56-25.1-56-56v-80c0-30.9 25.1-56 56-56h78.9L270.4 39.5z"
        }
    ]
};

const FarVolumeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVolumeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.7-82.9C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6 0-30.1-13.9-56.9-35.4-74.5-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6V61.8c0-16.5-13.3-29.8-29.8-29.8-7.3 0-14.3 2.7-19.8 7.5L199.5 131 38.8 5.1zm199.1 156 66.1-58.8V213l-66.1-51.8zM32 216v80c0 30.9 25.1 56 56 56h78.9l135.5 120.5c5.5 4.8 12.5 7.5 19.8 7.5 16.5 0 29.8-13.3 29.8-29.8v-76.9l-48-37.8v74.2l-112.1-99.6c-4.4-3.9-10.1-6.1-15.9-6.1H88c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h54.2l-60.5-47.6C53.7 163.5 32 187.2 32 216z"
        }
    ]
};

const FarVolumeXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVolumeXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M159.9 201.9 272 102.3v307.4l-112.1-99.6c-4.4-3.9-10.1-6.1-15.9-6.1H56c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9l135.5 120.5c5.5 4.8 12.5 7.5 19.8 7.5 16.5 0 29.8-13.3 29.8-29.8V61.8c0-16.5-13.3-29.8-29.8-29.8zM425 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55z"
        }
    ]
};

const FarVolume = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVolume",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.9 201.9 304 102.3v307.4l-112.1-99.6c-4.4-3.9-10.1-6.1-15.9-6.1H88c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM322.2 32c-7.3 0-14.3 2.7-19.8 7.5L166.9 160H88c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9l135.5 120.5c5.5 4.8 12.5 7.5 19.8 7.5 16.5 0 29.8-13.3 29.8-29.8V61.8c0-16.5-13.3-29.8-29.8-29.8zm182.9 75c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c21.5-17.7 35.4-44.5 35.4-74.6s-13.9-56.9-35.4-74.5z"
        }
    ]
};

const FarVrCardboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarVrCardboard",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M560 112H80c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h110.6c12.1 0 23.2-6.8 28.6-17.7l34.7-69.5c12.5-25 38.1-40.8 66.1-40.8s53.6 15.8 66.1 40.8l34.7 69.5c5.4 10.8 16.5 17.7 28.6 17.7H560c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM80 64h480c44.2 0 80 35.8 80 80v224c0 44.2-35.8 80-80 80H449.4c-30.3 0-58-17.1-71.6-44.2l-34.7-69.5c-4.4-8.8-13.4-14.3-23.2-14.3s-18.8 5.5-23.2 14.3L262 403.8c-13.6 27.1-41.3 44.2-71.6 44.2H80c-44.2 0-80-35.8-80-80V144c0-44.2 35.8-80 80-80zm16 176a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FarW = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarW",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M15.9 33.4c12.5-4.5 26.2 2 30.7 14.5l119.3 331.5L265 49.1C268.1 39 277.4 32 288 32s19.9 7 23 17.1l99.1 330.3L529.4 47.9c4.5-12.5 18.2-18.9 30.7-14.5s18.9 18.2 14.5 30.7l-144 400c-3.5 9.7-12.9 16.1-23.2 15.9s-19.4-7.2-22.3-17.1L288 139.5l-97 323.4c-3 9.9-12 16.8-22.3 17.1s-19.7-6.1-23.2-15.9L1.4 64.1c-4.5-12.5 2-26.2 14.5-30.7z"
        }
    ]
};

const FarWaffle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWaffle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176-144v32h64v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h64v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-64v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-64v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-64h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-64h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 128h64v-64h-64v64zm96 0h64v-64h-64v64zm0 32v64h64v-64h-64zm-32 0h-64v64h64v-64z"
        }
    ]
};

const FarWagonCovered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWagonCovered",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M569.8 4.1c45.9-3.1 79.9 41.8 64.6 85.2L567.8 278c5 4.4 8.2 10.9 8.2 18 0 12.9-10.2 23.5-23 24h-10.6c20.7 20.3 33.6 48.7 33.6 80 0 61.9-50.1 112-112 112-56.4 0-103.1-41.7-110.9-96h-66.2c-7.8 54.3-54.4 96-110.9 96-61.9 0-112-50.1-112-112 0-31.3 12.9-59.7 33.6-80H87c-12.8-.5-23-11.1-23-24 0-7.2 3.2-13.6 8.2-18L5.6 89.3C-9.7 45.9 24.3 1 70.2 4.1l119.7 8c21.6 1.4 41 10.6 55.5 24.7C258.4 23.9 276.3 16 296 16h48c19.7 0 37.6 7.9 50.6 20.8 14.5-14.1 33.9-23.3 55.5-24.7l119.7-8zM519 272l70.2-198.7C593 62.4 584.5 51.2 573 52l-119.7 8c-21 1.4-37.3 18.9-37.3 39.9V272h103zM186.7 60 67 52c-11.5-.8-20 10.5-16.2 21.3L121 272h103V99.9c0-21.1-16.3-38.5-37.3-39.9zM368 272V88c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v184h96zM160 416h-46c5.8 22.5 23.5 40.2 46 46v-46zm0-32v-46c-22.5 5.8-40.2 23.5-46 46h46zm32 78c22.5-5.8 40.2-23.5 46-46h-46v46zm0-124v46h46c-5.8-22.5-23.5-40.2-46-46zm256 124v-46h-46c5.8 22.5 23.5 40.2 46 46zm-46-78h46v-46c-22.5 5.8-40.2 23.5-46 46zm124 32h-46v46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46v46h46z"
        }
    ]
};

const FarWalker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWalker",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M186.4 48H320c22.1 0 40 17.9 40 40v88H124l23.5-97.4c4.3-18 20.4-30.6 38.9-30.6zM360 224v164.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64s64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V88c0-48.6-39.4-88-88-88H186.4c-40.6 0-76 27.8-85.5 67.4L.7 482.4c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7l65-269.7H360zm24 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarWalkieTalkie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWalkieTalkie",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24v72h-8c-30.9 0-56 25.1-56 56v153.4c0 10.6 4.2 20.8 11.7 28.3L32 353.9V456c0 30.9 25.1 56 56 56h208c30.9 0 56-25.1 56-56V353.9l20.3-20.3c7.5-7.5 11.7-17.7 11.7-28.3V152c0-30.9-25.1-56-56-56h-8c0-17.7-14.3-32-32-32s-32 14.3-32 32h-32c0-17.7-14.3-32-32-32s-32 14.3-32 32h-48V24zm80 120h136c4.4 0 8 3.6 8 8v150.1l-20.3 20.3c-7.5 7.5-11.7 17.7-11.7 28.3V456c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V350.6c0-10.6-4.2-20.8-11.7-28.3L48 302.1V152c0-4.4 3.6-8 8-8h136zm-56 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H136zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"
        }
    ]
};

const FarWallet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWallet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 32C39.4 32 0 71.4 0 120v272c0 48.6 39.4 88 88 88h336c48.6 0 88-39.4 88-88V216c0-48.6-39.4-88-88-88H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c22.1 0 40 17.9 40 40v176c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V120c0-22.1 17.9-40 40-40h368c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zm296 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarWandMagicSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWandMagicSparkles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M234.7 42.7 197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1 14.1 37.7c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2l-37.7-14.1L263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5l-14.1 37.7zM461.4 48 496 82.6 386.2 192.3l-34.6-34.6L461.4 48zM80 429.4l237.7-237.7 34.6 34.6L114.6 464 80 429.4zM427.4 14.1 46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0l381.3-381.4c18.7-18.7 18.7-49.1 0-67.9l-34.6-34.5c-18.7-18.7-49.1-18.7-67.9 0zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
        }
    ]
};

const FarWandMagic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWandMagic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m319.7 157.7 34.6 34.6L464 82.6 429.4 48 319.7 157.7zm-33.9 33.9L48 429.4 82.6 464l237.7-237.8-34.6-34.6zM14.1 395.4 395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0l-34.5-34.6c-18.7-18.7-18.7-49.1 0-67.9z"
        }
    ]
};

const FarWandSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWandSparkles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M455.9 49.3c.9-.8 2.1-1.3 3.3-1.3 2.7 0 4.9 2.2 4.9 4.9 0 1.2-.4 2.4-1.3 3.3L97.3 459.6c-2.5 2.8-6.1 4.4-9.9 4.4-3.5 0-6.9-1.4-9.4-3.9L51.9 434c-2.5-2.5-3.9-5.9-3.9-9.4 0-3.8 1.6-7.3 4.4-9.9L455.9 49.3zM459.1 0c-13.1 0-25.7 4.9-35.5 13.7l-263 238.2c-2.9 2.7-6.8 4.1-10.7 4.1H112c-8.8 0-16 7.2-16 16v31.3c0 4.5-1.9 8.8-5.3 11.9l-70.5 63.9C7.3 390.7 0 407.2 0 424.5c0 16.3 6.5 31.9 18 43.4L44.1 494c11.5 11.5 27.1 18 43.4 18 17.3 0 33.8-7.3 45.4-20.2l266.8-294.5c3-3.3 7.3-5.3 11.9-5.3H432c8.8 0 16-7.2 16-16v-25.9c0-4 1.5-7.8 4.1-10.7l46.2-51C507.1 78.6 512 66 512 52.9 512 23.7 488.3 0 459.1 0zM432 288c-3.6 0-6.7 2.4-7.7 5.8l-14.8 51.7-51.7 14.8c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8-14.8-51.7c-1-3.4-4.1-5.8-7.7-5.8zM87.7 69.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.4-7.7 5.8l-14.8 51.7-51.7 14.8c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8-14.8-51.7zM208 0c-3.7 0-6.9 2.5-7.8 6.1l-6.8 27.3-27.3 6.8c-3.6.9-6.1 4.1-6.1 7.8s2.5 6.9 6.1 7.8l27.3 6.8 6.8 27.3c.9 3.6 4.1 6.1 7.8 6.1s6.9-2.5 7.8-6.1l6.8-27.3 27.3-6.8c3.6-.9 6.1-4.1 6.1-7.8s-2.5-6.9-6.1-7.8l-27.3-6.8-6.8-27.3c-.9-3.6-4.1-6.1-7.8-6.1z"
        }
    ]
};

const FarWand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M459.1 48c-1.2 0-2.4.4-3.3 1.3L52.4 414.7c-2.8 2.5-4.4 6.1-4.4 9.9 0 3.5 1.4 6.9 3.9 9.4L78 460.1c2.5 2.5 5.9 3.9 9.4 3.9 3.8 0 7.3-1.6 9.9-4.4L462.7 56.1c.8-.9 1.3-2.1 1.3-3.3 0-2.7-2.2-4.9-4.9-4.9zm-35.5-34.3C433.4 4.9 446 0 459.1 0 488.3 0 512 23.7 512 52.9c0 13.1-4.9 25.8-13.7 35.5l-46.2 51c-2.7 2.9-4.1 6.8-4.1 10.7V176c0 8.8-7.2 16-16 16h-20.4c-4.5 0-8.8 1.9-11.9 5.3L132.9 491.8c-11.6 12.9-28.1 20.2-45.4 20.2-16.3 0-31.9-6.5-43.4-18L18 467.9C6.5 456.4 0 440.8 0 424.5c0-17.3 7.3-33.8 20.2-45.4l70.6-63.9c3.3-3 5.3-7.3 5.3-11.9V272c0-8.8 7.2-16 16-16H150c4 0 7.8-1.5 10.7-4.1l263-238.2z"
        }
    ]
};

const FarWarehouseFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWarehouseFull",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323 51.1a7.8 7.8 0 0 0-6 0l-254 103c-9.1 3.7-15 12.5-15 22.2V488c0 13.3-10.7 24-24 24S0 501.3 0 488V176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 240v248c0 13.3-10.7 24-24 24s-24-10.7-24-24V232c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v256c0 13.3-10.7 24-24 24s-24-10.7-24-24V240H144zm232 176h64c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zM176 312c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24v-48zm24 104h96c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarWarehouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWarehouse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323 51.1a7.8 7.8 0 0 0-6 0l-254 103c-9.1 3.7-15 12.5-15 22.2V488c0 13.3-10.7 24-24 24S0 501.3 0 488V176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 328v48h352v-48H144zm0 136h352v-40H144v40zm-23.7 48h-.3c-13.3 0-24-10.7-24-24V232c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v256c0 13.3-10.7 24-24 24H120.3zM144 280h352v-40H144v40z"
        }
    ]
};

const FarWashingMachine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWashingMachine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h320zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 104a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm130.6 191.7c-3.5.2-7 .3-10.6.3-32 0-56-16-80-32s-48-32-80-32c-3.5 0-7.1.2-10.7.4C146.4 218.9 182 192 224 192c53 0 96 43 96 96 0 11.1-1.9 21.8-5.4 31.7zM368 288a144 144 0 1 0-288 0 144 144 0 1 0 288 0z"
        }
    ]
};

const FarWatchApple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWatchApple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112.3 0C85.6 0 64 21.6 64 48.3v17.3C27.5 73 0 105.3 0 144v224c0 38.7 27.5 71 64 78.4V464c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-17.6c36.5-7.4 64-39.7 64-78.4V144c0-38.7-27.5-71-64-78.4V48.3C320 21.6 298.4 0 271.7 0H112.3zM304 112c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h224zM192 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-168a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-8 48a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm120 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarWatchCalculator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWatchCalculator",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112.3 0C85.6 0 64 21.6 64 48.3v17.3C27.5 73 0 105.3 0 144v224c0 38.7 27.5 71 64 78.4V464c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-17.6c36.5-7.4 64-39.7 64-78.4V144c0-38.7-27.5-71-64-78.4V48.3C320 21.6 298.4 0 271.7 0H112.3zM304 112c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h224zm-200 48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h176c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H104zM88 272a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm104-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-136 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm104-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"
        }
    ]
};

const FarWatchFitness = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWatchFitness",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112.3 0C85.6 0 64 21.6 64 48.3v17.3C27.5 73 0 105.3 0 144v224c0 38.7 27.5 71 64 78.4V464c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-17.6c36.5-7.4 64-39.7 64-78.4V144c0-38.7-27.5-71-64-78.4V48.3C320 21.6 298.4 0 271.7 0H112.3zM304 112c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h224zM93.7 226.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4 0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z"
        }
    ]
};

const FarWatchSmart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWatchSmart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48.3C64 21.6 85.6 0 112.3 0h159.4C298.4 0 320 21.6 320 48.3v17.3c36.5 7.4 64 39.7 64 78.4v224c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48v-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4V48.3zM80 112c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32H80zm136 72v60.8l39.4 32.8c10.2 8.5 11.6 23.6 3.1 33.8s-23.6 11.6-33.8 3.1l-48-40c-5.5-4.6-8.6-11.3-8.6-18.4V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FarWatch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWatch",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0C85.5 0 64 21.5 64 48v64h1C25.1 147.2 0 198.7 0 256s25.1 108.8 65 144h-1v64c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-64h-1c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144h1V48c0-26.5-21.5-48-48-48H112zM48 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm168-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 8 4 15.5 10.7 20l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L216 243.2V176z"
        }
    ]
};

const FarWaterArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWaterArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v137.7l-47.9-43.5c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9l88 80c9.2 8.3 23.1 8.3 32.3 0l88-80c9.8-8.9 10.5-24.1 1.6-33.9s-24.1-10.5-33.9-1.6L312 161.7V24zM80 302.1c-17.2 14.9-39 26.7-61.2 31.7C5.9 336.7-2.3 349.5.6 362.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.7-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zm0 128c-17.2 14.9-39 26.7-61.2 31.7C5.9 464.7-2.3 477.5.6 490.5s15.7 21.1 28.7 18.2c28.7-6.5 52.3-20.5 66.7-30.5 28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4 12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0z"
        }
    ]
};

const FarWaterArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWaterArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 216c0 13.3-10.7 24-24 24s-24-10.7-24-24V78.3l-47.9 43.5c-9.8 8.9-25 8.2-33.9-1.6s-8.2-25 1.6-33.9l88-80c9.2-8.3 23.1-8.3 32.3 0l88 80c9.8 8.9 10.5 24.1 1.6 33.9s-24.1 10.5-33.9 1.6L312 78.3V216zM80 302.1c9.1-8.1 22.8-8.1 31.9 0 21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zm0 128c9.1-8.1 22.8-8.1 31.9 0 21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7z"
        }
    ]
};

const FarWaterLadder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWaterLadder",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128c0-53 43-96 96-96s96 43 96 96v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-26.5-21.5-48-48-48s-48 21.5-48 48v96.2h208V128c0-53 43-96 96-96s96 43 96 96v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-26.5-21.5-48-48-48s-48 21.5-48 48v243c-15.5 8.4-32.8 13.5-48 13.5V272.2H176v110.6c-14.7-2.9-30-9.6-43.1-18.7-1.6-1.1-3.2-2.2-4.9-3.1V128zm-16.1 270.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7 9.1-8.1 22.8-8.1 31.9 0z"
        }
    ]
};

const FarWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 78.1c9.1-8.1 22.8-8.1 31.9 0 21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7C41 104.8 62.8 93 80 78.1zm0 288c9.1-8.1 22.8-8.1 31.9 0 21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zm31.9-144c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0 16.9 15.1 39.3 26.8 61.3 31.8 12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7 9.1-8.1 22.8-8.1 31.9 0z"
        }
    ]
};

const FarWatermelonSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWatermelonSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 408c0-6.4 2.5-12.5 7-17L391 7c9.4-9.4 24.6-9.4 33.9 0 115.6 115.6 116 302.6.3 418.3S122.6 540.5 7 425c-4.5-4.5-7-10.6-7-17zm58.7-.8c97.4 80.4 241.5 75.3 332.6-15.8s96.2-235.2 15.8-332.6l-22.3 22.4C414.3 118.1 432 165 432 216c0 119.3-96.7 216-216 216-51 0-97.9-17.7-134.8-47.2l-22.5 22.4zM384 216c0-37.7-12.4-72.6-33.4-100.6l-26.3 26.3 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-57.4 57.4 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-57.4 57.4 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-26.3 26.3c28 21 62.9 33.4 100.6 33.4 92.8 0 168-75.2 168-168zm-52.7 12.7 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FarWavePulse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWavePulse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.4 0c11.1-.3 21 7.1 23.8 17.9l79.3 303.9 27.1-57.7c9.2-19.6 29-32.2 50.7-32.2H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H500.3c-3.1 0-5.9 1.8-7.2 4.6l-55.4 117.7c-4.3 9.1-13.9 14.6-23.9 13.7s-18.5-8.1-21-17.8l-70.1-268.7-75.2 363.5c-2.2 10.9-11.6 18.8-22.7 19.1s-21-6.9-23.9-17.6l-57.6-208.5c-1-3.5-4.1-5.9-7.7-5.9H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h111.6c25.2 0 47.3 16.8 54 41.1l31 112.6 75.9-366.6C298.8 8.2 308.2.3 319.4 0z"
        }
    ]
};

const FarWaveSine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWaveSine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47.3 237.8.1-.2.3-1.1c.3-1 .7-2.5 1.3-4.5 1.2-4 3-9.8 5.6-16.8 5.2-14.1 13.1-32.6 24-50.9C101.2 126.6 132.9 96 176 96c33.3 0 55.6 16.4 74.1 46.2 19.5 31.3 32.6 73.9 46.9 120.8l.6 1.9c13.6 44.6 28.3 93.1 51.5 130.3C373.6 434.4 409.3 464 464 464c68.9 0 113.2-49.4 138.6-91.7 13-21.7 22.1-43.1 28-59.1 2.9-8 5.1-14.7 6.5-19.5.7-2.4 1.3-4.3 1.6-5.6.2-.7.3-1.2.4-1.6l.1-.5v-.2l-23.3-5.8 23.3 5.8c3.2-12.9-4.6-25.9-17.5-29.1s-25.9 4.6-29.1 17.4l-.1.2-.3 1.1c-.3 1-.7 2.5-1.3 4.5-1.2 4-3 9.8-5.6 16.8-5.2 14.1-13 32.6-24 50.9-22.5 37.8-54.2 68.4-97.3 68.4-33.3 0-55.6-16.4-74.1-46.2-19.5-31.3-32.7-73.9-46.9-120.8l-.6-1.9c-13.6-44.6-28.4-93.1-51.5-130.3C266.4 77.6 230.7 48 176 48c-68.9 0-113.2 49.4-138.6 91.7-13 21.7-22.1 43.1-28 59.1-2.9 8-5.1 14.7-6.5 19.5-.7 2.4-1.3 4.3-1.6 5.6-.2.7-.3 1.2-.4 1.6l-.1.5v.2l23.3 5.8-23.4-5.8c-3.2 12.9 4.6 25.9 17.5 29.1s25.9-4.6 29.1-17.4z"
        }
    ]
};

const FarWaveSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWaveSquare",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 56c0-13.3 10.7-24 24-24h160c13.3 0 24 10.7 24 24v376h112V256c0-13.3 10.7-24 24-24h136c13.3 0 24 10.7 24 24s-10.7 24-24 24H504v176c0 13.3-10.7 24-24 24H320c-13.3 0-24-10.7-24-24V80H184v176c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h112V56z"
        }
    ]
};

const FarWaveTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWaveTriangle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176.1 32c7.7 0 14.9 3.7 19.4 10l268.6 373.1 132.5-181.3c7.8-10.7 22.8-13 33.5-5.2s13 22.8 5.2 33.5l-152 208c-4.5 6.2-11.8 9.9-19.5 9.8s-14.9-3.7-19.4-10l-268.5-373L43.4 278.2c-7.8 10.7-22.8 13-33.5 5.2s-13-22.8-5.2-33.5l152-208c4.5-6.2 11.8-9.9 19.5-9.8z"
        }
    ]
};

const FarWaveformLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWaveformLines",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c13.3 0 24 10.7 24 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zm200 64c13.3 0 24 10.7 24 24v336c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM216 96c13.3 0 24 10.7 24 24v272c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm208 32c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm-304 64c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24zm-96 32c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24S0 277.3 0 264v-16c0-13.3 10.7-24 24-24zm592 0c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FarWaveform = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWaveform",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4 38.5-240.9c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6L500 281.9l20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9l26.7 87.1H616c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6l-25.6-179.1-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6l-40.2 291.7c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5-25.5 179.1c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4c-3.2 10-12.5 16.9-23 16.9H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h22.3l26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6 28.1-197.3c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0z"
        }
    ]
};

const FarWebhook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWebhook",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M306 50c41.1 9.5 67.5 49.2 61.1 90.2-2.1 13.1 6.9 25.4 20 27.4s25.4-6.9 27.4-20C424.8 82 382.6 18.5 316.8 3.3c-68.9-15.9-137.6 27-153.5 95.9-10.7 46.3 5.2 92.6 37.7 122.7L129.7 336H128c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48c0-8.1-2-15.8-5.6-22.5L253.2 229c3.4-5.4 4.5-11.9 3-18.1s-5.3-11.6-10.7-15c-28.2-17.6-43.4-51.7-35.5-85.9 10-43 52.9-69.9 96-60zm-18 62a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm42.4 38.5c3.6-6.7 5.6-14.4 5.6-22.5 0-26.5-21.5-48-48-48s-48 21.5-48 48 21.5 48 48 48h1.7l82.8 132.5c3.4 5.4 8.8 9.2 15 10.7s12.7.3 18.1-3c30.9-19.3 72.1-15.5 99 11.3 31.2 31.2 31.2 81.9 0 113.1-26.8 26.8-68.1 30.6-99 11.3-11.2-7-26-3.6-33.1 7.6s-3.6 26 7.6 33.1c49.4 31 115.4 25 158.4-18 50-50 50-131 0-181-37-37-91-46.6-136.8-28.9l-71.3-114.2zM112 384a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm320 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0c0-26.5-21.5-48-48-48-17.8 0-33.3 9.7-41.6 24H232c-6.4 0-12.5 2.5-17 7s-7 10.6-7 17c0 36.4-25 69.4-62 77.9-43.1 9.9-86-16.9-95.9-60-8.9-38.6 11.7-77.1 47.1-91.8 12.2-5.1 18-19.1 12.9-31.4s-19.1-18-31.4-12.9C22.1 289.4-11 351 3.3 412.8c15.9 68.9 84.6 111.8 153.5 95.9 51-11.8 87.7-52.5 97-100.7h152.6c8.3 14.3 23.8 24 41.6 24 26.5 0 48-21.5 48-48z"
        }
    ]
};

const FarWeightHanging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWeightHanging",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 88a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm118.4 40c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 14.4 3.5 28 9.6 40H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512h416c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128h-57.6zM256 176h136l72 288H48l72-288h136z"
        }
    ]
};

const FarWeightScale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWeightScale",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 176a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm304 0c0-22.6-4.3-44.2-12-64h28c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16h28c-7.7 19.8-12 41.4-12 64 0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-56.2zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5.3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40 0 22.1 17.9 40 40 40s40-17.9 40-40z"
        }
    ]
};

const FarWhale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWhale",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4a80.057 80.057 0 0 0-22.4 69.7l7.9 47.4-14.3 14.3-35.6 35.6C15.7 240.3 0 278.2 0 317.6 0 407.3 72.7 480 162.4 480H544c53 0 96-43 96-96V275.7c0-81.6-66.1-147.7-147.7-147.7-80.5 0-158.6 27.4-221.4 77.7L139 311.2c-7.1 5.7-15.9 8.8-25 8.8h-1c-19 0-35.2-13.7-38.4-32.5-1.7-9.9.6-20.1 6.3-28.4l35.4-51.4 9.1-13.2 47.6 7.9c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9l-84.8-14.2-14.1-84.7zM50.5 341.5C66.4 358 88.7 368 113 368h1c20 0 39.4-6.8 55-19.3l131.9-105.6c54.3-43.4 121.8-67.1 191.4-67.1 55 0 99.7 44.6 99.7 99.7V384c0 26.5-21.5 48-48 48H162.4c-55 0-100.9-38.8-111.9-90.5zM392 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FarWheatAwnCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWheatAwnCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M504.7 7.2c9.4 9.4 9.4 24.6 0 33.9L366.1 179.7c7.9.9 15.8 2.5 23.4 4.8L471 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63.7 63.7c-21.6 7.1-41.4 18.2-58.4 32.5-24.3-10.1-52.5-7.8-75 7l10.1 10.1c9.4 9.4 21 15.3 33.1 17.6-11.9 17.2-20.9 36.7-26.1 57.7-27.3-23.7-66.9-25.8-96.4-6.2l10.1 10.1c23 23 59.1 24.8 84.2 5.5-2 10.7-3.1 21.7-3.1 32.9 0 7.4.5 14.8 1.4 21.9-5.8 2-11.8 3.6-17.8 4.7 6.9 9.4 6.1 22.6-2.4 31.1L284 442.4c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3L41 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5-11.3-11.4c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4 3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4 3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L375 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L470.7 7.2c9.4-9.4 24.6-9.4 33.9 0zm-243.2 96.1c-25 25-25 65.5 0 90.5l10.2 10.2c20.5-31 17.2-73.3-10.2-100.6zm-79.2 79.2c-25 25-25 65.5 0 90.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6zm-22.6 226.2c25 25 65.5 25 90.5 0-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5 10.1 10.1c20.5-31 17.2-73.3-10.2-100.6-25 25-25 65.5 0 90.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FarWheatAwnSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWheatAwnSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M568.7 7.2c9.4 9.4 9.4 24.6 0 33.9L430.1 179.7c7.9.9 15.8 2.5 23.4 4.8L535 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71.4 71.4c3.1 2.5 6 5.2 8.9 8.1l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1 2.8 3.9 4.4 8.4 4.6 13l179.6 140.9c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1l177.8 139.3 12.8-12.8c8.5-8.5 21.7-9.3 31.1-2.4 3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L439 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L534.7 7.2c9.4-9.4 24.6-9.4 33.9 0zM148.2 212.8l228.3 179.8c-3 .8-6 1.4-9 2 6.9 9.4 6 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3-73.5 73.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5-11.3-11.3c-43.7-43.7-43.7-114.7 0-158.4l15-15zm177.3-109.5c-25 25-25 65.5 0 90.5l10.2 10.2c20.5-31 17.2-73.3-10.2-100.6zM223.7 408.7c25 25 65.5 25 90.5 0-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5 10.1 10.1c20.5-31 17.2-73.3-10.2-100.6-25 25-25 65.5 0 90.5zm214.9-101.8c25 25 65.5 25 90.5 0-27.4-27.4-69.6-30.7-100.7-10.2l10.1 10.1z"
        }
    ]
};

const FarWheatAwn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWheatAwn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M504.7 7.2c9.4 9.4 9.4 24.6 0 33.9L366.1 179.7c7.9.9 15.8 2.5 23.4 4.8L471 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71.4 71.4c3.1 2.5 6 5.2 8.9 8.1l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1 6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1 6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0L114.5 431 41 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5-11.3-11.4c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4 3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4 3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L375 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L470.7 7.2c9.4-9.4 24.6-9.4 33.9 0zm-243.2 96.1c-25 25-25 65.5 0 90.5l10.2 10.2c20.5-31 17.2-73.3-10.2-100.6zm-79.2 79.2c-25 25-25 65.5 0 90.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6zm-22.6 226.2c25 25 65.5 25 90.5 0-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5 10.1 10.1c20.5-31 17.2-73.3-10.2-100.6-25 25-25 65.5 0 90.5zm135.7-22.7c25 25 65.5 25 90.5 0-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm79.2-79.2c25 25 65.5 25 90.5 0-27.4-27.3-69.6-30.6-100.7-10.1l10.1 10.1z"
        }
    ]
};

const FarWheatSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWheatSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-174-136.4c3.6-2.8 7.1-5.9 10.5-9.3l16.9-16.9c8.5-8.5 9.3-21.7 2.4-31.1 21.9-3.8 42.9-14.2 59.8-31.1l16.9-16.9c9.4-9.4 9.4-24.6 0-33.9l-16.9-16.9c-11.6-11.6-24.8-20.4-38.9-26.7 39.3-9 68.5-44 68.5-85.9V24c0-13.3-10.7-24-24-24h-40c-41.9 0-76.9 29.3-85.8 68.5C420 54.3 411 41 399.4 29.4l-16.9-17c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-16.9 16.9-27.3 37.9-31.1 59.8-9.4-6.9-22.6-6.1-31.1 2.4l-16.9 16.9c-12.5 12.5-21.5 27.3-26.8 43L38.8 5.1zm228.9 179.4c.8-15.3 7-30.3 18.6-42 19.9 20 27.1 47.8 21.6 73.5l-40.2-31.5zM372 266.3c22-1.3 44.5 6.4 61.3 23.3-5 4.9-10.5 8.9-16.4 11.9L372 266.3zm-198.7 79.8 11.3 11.3L71 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l113.6-113.5 11.2 11.2c43.7 43.7 114.6 43.7 158.4 0l.5-.5-38.1-30c-25.1 21.5-63 20.4-86.8-3.4l-10.1-10.2c20.1-13.3 44.8-16.6 67.2-9.8l-90.2-71.1c.1 15.6-4.3 31.2-13.2 44.7l-10.1-10.1c-17.6-17.6-22.8-43-15.6-65.2l-39.1-30.8c-21.4 42.1-14.5 94.8 20.7 129.9zM512 48h16v16c0 22.1-17.9 40-40 40h-16V88c0-22.1 17.9-40 40-40zM365.5 153.8c-25-25-25-65.5 0-90.5 27.3 27.4 30.7 69.6 10.2 100.6l-10.1-10.1zm147 56.5c-25 25-65.5 25-90.5 0l-10.1-10.1c31-20.5 73.3-17.2 100.6 10.2z"
        }
    ]
};

const FarWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWheat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 48c-22.1 0-40 17.9-40 40v16h16c22.1 0 40-17.9 40-40V48h-16zm-85.8 20.5C371.1 29.3 406.1 0 448 0h40c13.3 0 24 10.7 24 24v40c0 41.9-29.2 76.9-68.4 85.8 14.1 6.2 27.3 15.1 38.9 26.7l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1 6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1 6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.2-11.2L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l113.5-113.6-11.3-11.3c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4 3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4 3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9C347 41 356 54.3 362.2 68.5zm-60.6 85.4 10.1 10.1c20.5-31 17.2-73.3-10.2-100.6-25 25-25 65.5 0 90.5zM222.4 233l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6-25 25-25 65.5 0 90.5zm-79.2 79.2 10.1 10.1c20.5-31 17.2-73.3-10.2-100.6-25 25-25 65.5 0 90.5zm147 56.5c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.2c25 25 65.5 25 90.5 0zm79.2-79.2c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1c25 25 65.5 25 90.5 0zm79.2-79.2c-27.4-27.3-69.6-30.6-100.7-10.1l10.1 10.1c25 25 65.5 25 90.5 0z"
        }
    ]
};

const FarWheelchairMove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWheelchairMove",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-111.4 65c-8-3.4-17.2-2.2-24 3.2l-49.8 38.7c-10.5 8.1-25.5 6.3-33.7-4.2s-6.3-25.5 4.2-33.7l49.8-38.7c20.6-16 48.1-19.6 72.1-9.5l84.2 35.5c35.7 15 45.7 60.9 19.5 89.5L288.6 240h113.9c26.8 0 46 25.8 38.3 51.5L399 430.9c-3.8 12.7-17.2 19.9-29.9 16.1s-19.9-17.2-16.1-29.9L391.7 288h-85c8.6 19.6 13.3 41.2 13.3 64 0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160h3.7l68.9-68.9-24-10.1zm87 48.2c3.7-4.1 2.3-10.6-2.8-12.8l-20.4-8.6-60.7 60.7c11.8 4 22.9 9.4 33.3 15.9l50.6-55.2zM160 464a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
        }
    ]
};

const FarWheelchair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWheelchair",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-71.5 247.2C78.1 263.2 48 304.1 48 352c0 61.9 50.1 112 112 112 42.8 0 80-24 98.9-59.3 6.2-11.7 20.8-16.1 32.5-9.9s16.1 20.8 9.9 32.5c-27 50.4-80.1 84.7-141.3 84.7C71.6 512 0 440.4 0 352c0-68.5 43.1-126.9 103.5-149.7 12.4-4.7 26.2 1.6 30.9 14s-1.6 26.2-14 30.9zm67.2-118.8c13-2.4 25.5 6.3 27.9 19.3l5.1 28.3H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H229.5l13.4 73.4c.7 3.8 4 6.6 7.9 6.6h122.7c15.9 0 30.3 9.4 36.6 24l43 98.3 27.2-9.1c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4l-48 16c-11.8 3.9-24.6-1.8-29.6-13.1L368.3 352H250.7c-27.1 0-50.3-19.4-55.1-46l-27.2-149.7c-2.4-13 6.3-25.5 19.3-27.9z"
        }
    ]
};

const FarWhiskeyGlassIce = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWhiskeyGlassIce",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M50.5 80h411l-47.3 324.6c-2.3 15.7-15.8 27.4-31.7 27.4h-253c-15.9 0-29.4-11.7-31.7-27.4L50.5 80zM32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4.3 68.6l50 342.9C56 450.8 89.7 480 129.5 480h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zm223.4 147.3.6-.6c-5-1.8-10.4-2.7-16-2.7h-96c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h73.8l-19-19c-8.5-8.5-14.7-18.4-18.6-29H144v-96h66.7l44.7-44.7zm56.6 56.6 56.6 56.6L312 349l-56.6-56.6 56.6-56.5zM278.1 202l-56.6 56.6c-18.7 18.7-18.7 49.1 0 67.9l56.6 56.5c18.7 18.7 49.1 18.7 67.9 0l56.6-56.6c18.7-18.7 18.7-49.1 0-67.9L346 201.9c-18.7-18.7-49.1-18.7-67.9 0z"
        }
    ]
};

const FarWhiskeyGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWhiskeyGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80.8 288h350.4l30.3-208h-411l30.3 208zm7 48 10 68.6c2.3 15.7 15.8 27.4 31.7 27.4h253c15.9 0 29.4-11.7 31.7-27.4l10-68.6H87.8zM7.8 43.1C13.9 36 22.7 32 32 32h448c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5h-253c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1z"
        }
    ]
};

const FarWhistle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWhistle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M119 95.2C107.8 76.5 87.4 64 64 64 28.7 64 0 92.7 0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192 64.7 0 121.9-32 156.7-81L529 444.4c4.6 2.4 9.6 3.6 14.8 3.6h2c9 0 17.6-3.8 23.7-10.5l63.4-69.7c4.6-5 7.1-11.6 7.1-18.4 0-8.5-3.9-16.5-10.6-21.6L353.5 114.3C319.4 83.1 273.9 64 224 64c-38.8 0-74.8 11.5-105 31.2zm-50.5 48.2c-1.4.4-2.9.6-4.5.6-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16v1c-4 4.6-7.9 9.4-11.5 14.3zm334.4 181c-21.3-11.1-47.5-4.8-61.4 14.8-26.1 36.9-69 60.8-117.5 60.8-79.5 0-144-64.5-144-144s64.5-144 144-144c37.5 0 71.5 14.2 97.1 37.7 1 .9 2 1.7 3 2.5L391 204l-10.2 13.6c-8 10.6-5.8 25.6 4.8 33.6s25.6 5.8 33.6-4.8l9.8-13 153.3 118.7-40.7 44.7-138.7-72.4zM224 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FarWifiExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWifiExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 56v256c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24s24 10.7 24 24zM8.2 149.6C79.1 87.2 169 45.7 268.1 34.8c-2.6 6.6-4.1 13.7-4.1 21.2v27.7c-85.3 11.2-162.6 47.8-224.1 102-9.9 8.8-25.1 7.8-33.9-2.2s-7.8-25.1 2.2-33.9zm111.7 136.3c39.6-36.3 89.1-62 144.1-72.6v49.1c-42.4 9.8-80.6 30.4-111.6 58.9-9.8 9-24.9 8.3-33.9-1.5s-8.3-24.9 1.5-33.9zM376 213.3c54.9 10.5 104.5 36.2 144.1 72.6 9.8 9 10.4 24.1 1.5 33.9s-24.1 10.4-33.9 1.5c-31-28.4-69.2-49.1-111.6-58.9v-49.1zm0 210.7a56 56 0 1 1-112 0 56 56 0 1 1 112 0zm0-368c0-7.5-1.5-14.6-4.1-21.2 99.1 10.8 189 52.4 259.9 114.8 9.9 8.8 10.9 23.9 2.2 33.9s-23.9 10.9-33.9 2.2c-61.5-54.2-138.8-90.8-224.1-102V56z"
        }
    ]
};

const FarWifiFair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWifiFair",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152.4 321.2c44.1-40.5 103-65.2 167.6-65.2s123.5 24.7 167.6 65.2c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208s-147.4 29.5-200.1 77.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5zM320 480a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
        }
    ]
};

const FarWifiSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWifiSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-267-209.3c47.2 8.4 89.8 30.2 123.8 61.4 9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208c-7.2 0-14.3.3-21.4.8L169.4 107.5C216.2 89.7 267 80 320 80c107.4 0 205.4 39.9 280.1 105.7 9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32c-69.1 0-134.7 14.9-193.9 41.5L38.8 5.1zm38.1 151.5-39.2-30.9c-10.2 7.6-20 15.6-29.5 23.9-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2c11.8-10.4 24.1-20.1 37-29.1zm149.4 117.7L184 241c-23.4 12.1-44.9 27.2-64.1 44.8-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5c21.5-19.7 46.5-35.7 73.9-46.9zM376 424a56 56 0 1 0-112 0 56 56 0 1 0 112 0z"
        }
    ]
};

const FarWifiWeak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWifiWeak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 424a56 56 0 1 1 112 0 56 56 0 1 1-112 0z"
        }
    ]
};

const FarWifi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWifi",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M39.9 185.7C114.6 119.9 212.6 80 320 80s205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32S91.3 76.4 8.2 149.6c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2zM320 256c64.6 0 123.5 24.7 167.6 65.2 9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208s-147.4 29.5-200.1 77.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5C196.5 280.7 255.4 256 320 256zm56 168a56 56 0 1 0-112 0 56 56 0 1 0 112 0z"
        }
    ]
};

const FarWindTurbine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWindTurbine",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M315.7 414.8c9.1 14.8 32 6.5 29.5-10.7L316.8 212c-.5-3.4.1-6.9 1.8-9.9L411 31.2c8.3-15.3-10.4-31-24-20.1L234.7 131.7c-2.7 2.1-6 3.4-9.5 3.5l-194.1 5.4c-17.4.4-21.6 24.4-5.4 30.8l180.6 71.5c3.2 1.3 5.9 3.5 7.7 6.5l101.7 165.4zm-83.7-75V464h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80v-46.2l-48-78zM256 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarWindWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWindWarning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 432c61.8 0 116.1-31.8 147.5-80h54.9c-36 75.7-113.1 128-202.4 128C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208h-48.1C391.2 150.3 315.8 80 224 80c-97.2 0-176 78.8-176 176s78.8 176 176 176zm0-304c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm286-128c-2.1-16.5-5.7-32.6-10.8-48H544c26.5 0 48-21.5 48-48s-21.5-48-48-48h-40c-13.3 0-24-10.7-24-24s10.7-24 24-24h40c53 0 96 43 96 96s-43 96-96 96h-66zm-6 256c-13.3 0-24-10.7-24-24s10.7-24 24-24h64c30.9 0 56-25.1 56-56s-25.1-56-56-56H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h192c57.4 0 104 46.6 104 104s-46.6 104-104 104h-64z"
        }
    ]
};

const FarWind = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWind",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 24c0 13.3 10.7 24 24 24h44c24.3 0 44 19.7 44 44s-19.7 44-44 44H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h332c50.8 0 92-41.2 92-92S406.8 0 356 0h-44c-13.3 0-24 10.7-24 24zm64 368c0 13.3 10.7 24 24 24h44c50.8 0 92-41.2 92-92s-41.2-92-92-92H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h396c24.3 0 44 19.7 44 44s-19.7 44-44 44h-44c-13.3 0-24 10.7-24 24zM120 512h44c50.8 0 92-41.2 92-92s-41.2-92-92-92H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h140c24.3 0 44 19.7 44 44s-19.7 44-44 44h-44c-13.3 0-24 10.7-24 24s10.7 24 24 24z"
        }
    ]
};

const FarWindowFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWindowFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96zM48 224h416v192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224zM416 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FarWindowFrameOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWindowFrameOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 240H280V48h136c8.8 0 16 7.2 16 16v176zm-200 0H80V64c0-8.8 7.2-16 16-16h136v192zm248 48V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v224h448zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V320h-48v144H80V320H32v144h-8z"
        }
    ]
};

const FarWindowFrame = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWindowFrame",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 464h152V272H80v192zm-48 0V64C32 28.7 60.7 0 96 0h320c35.3 0 64 28.7 64 64v400h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8zm400 0V272H280v192h152zM80 224h152V48H96c-8.8 0-16 7.2-16 16v160zm200 0h152V64c0-8.8-7.2-16-16-16H280v176z"
        }
    ]
};

const FarWindowMaximize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWindowMaximize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.3 89.5C.1 91.6 0 93.8 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64c-2.2 0-4.4.1-6.5.3-9.2.9-17.8 3.8-25.5 8.2-10.2 6-18.6 14.6-24.3 25-3.9 7.3-6.5 15.4-7.4 24zM48 224h416v192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224z"
        }
    ]
};

const FarWindowMinimize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWindowMinimize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FarWindowRestore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWindowRestore",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 48H208c-17.7 0-32 14.3-32 32v16h-48V80c0-44.2 35.8-80 80-80h224c44.2 0 80 35.8 80 80v224c0 44.2-35.8 80-80 80h-16v-48h16c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16V256H48v192zm16-320h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FarWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWindow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm464 128H48v192c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V224zM96 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarWindsock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWindsock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0c13.3 0 24 10.7 24 24v72h80v-8.6c0-20.3 18.7-35.5 38.5-31.3l320 66.7c14.8 3.1 25.5 16.2 25.5 31.3V262c0 15.2-10.6 28.2-25.5 31.3l-320 66.7c-19.9 4.1-38.5-11-38.5-31.3V320H48v168c0 13.3-10.7 24-24 24S0 501.3 0 488V24C0 10.7 10.7 0 24 0zm24 144v128h80V144H48zm368 115 48-10v-82l-48-10v102zm-48 10V147l-80-16.7v155.3l80-16.6zm-128 26.6V120.4L176 107v202l64-13.3z"
        }
    ]
};

const FarWineBottle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWineBottle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9-7.5 7.5-18.8 9-27.9 4.4l-72.5 72.5c-8 8-10.9 19.6-9.6 30.9 4 36.7-8.1 74.8-36.2 103L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6l88 88c6.2 6.2 16.4 6.2 22.6 0l36-36L88.7 312.7l-36 36-34-34 161.5-161.4c28.1-28.1 66.3-40.2 103-36.2 11.3 1.2 22.9-1.6 30.9-9.6L386.6 35c-4.6-9-3.1-20.3 4.4-27.9zM200.7 200.7l110.6 110.6 13.5-13.5c17.4-17.4 24.9-41 22.5-63.8-2.4-21.8 2.6-49.3 23.4-70l70.7-70.7-22.7-22.7-70.7 70.7c-20.8 20.8-48.2 25.8-70 23.4-22.9-2.5-46.4 5-63.8 22.4l-13.5 13.5z"
        }
    ]
};

const FarWineGlassCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWineGlassCrack",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 464V350c44.4-7.5 81.5-35.5 101.7-73.6 13.6-24.4 20.4-53.2 17.7-83.7L287.5 14.5C286.8 6.2 279.9 0 271.8 0H48.2c-8.1 0-15 6.2-15.8 14.5L16.6 192.6c-2.7 30.5 4 59.3 17.7 83.7C54.5 314.5 91.6 342.5 136 350v114H72c-1 0-2.1.1-3.1.2C57.1 465.7 48 475.8 48 488c0 12.2 9.1 22.2 20.8 23.8.9.1 1.9.2 2.9.2H248c1 0 2.1-.1 3.1-.2 11.8-1.5 20.9-11.6 20.9-23.8 0-12.2-9.1-22.2-20.8-23.8-.9-.1-1.9-.2-2.9-.2H184zM163.3 48c-.4 3.4-2 6.7-4.6 9.3l-52.3 52.3c-5.9 5.9-6.3 15.3-.9 21.6l76 89.8c1.6 1.9 3.9 3 6.4 3 5.8 0 9.9-5.9 7.8-11.3l-30.9-80.4c-2.8-7.2 0-15.3 6.5-19.3l43.4-27.1c5.6-3.5 8.5-10.2 7.2-16.7L217.6 48h24.2L254 202.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7L78.2 48h85.1z"
        }
    ]
};

const FarWineGlassEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWineGlassEmpty",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 0C43.5 0 33.1 9.6 32.1 22.1l-14 176.4C12.3 273.1 64.8 337.9 136 350v114H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64V350c71.2-12.1 123.7-76.9 117.9-151.5l-14-176.4C286.9 9.6 276.5 0 264 0H56zm10 202.3L78.2 48h163.6L254 202.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7z"
        }
    ]
};

const FarWineGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWineGlass",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 464V350c44.4-7.5 81.5-35.5 101.7-73.6 13.6-24.4 20.4-53.2 17.7-83.7L287.5 14.5C286.8 6.2 279.9 0 271.8 0H48.2c-8.1 0-15 6.2-15.8 14.5L16.6 192.6c-2.7 30.5 4 59.3 17.7 83.7C54.5 314.5 91.6 342.5 136 350v114H72c-1 0-2.1.1-3.1.2C57.1 465.7 48 475.8 48 488c0 12.2 9.1 22.2 20.8 23.8.9.1 1.9.2 2.9.2H248c1 0 2.1-.1 3.1-.2 11.8-1.5 20.9-11.6 20.9-23.8 0-12.2-9.1-22.2-20.8-23.8-.9-.1-1.9-.2-2.9-.2H184zM78.2 48h163.6l6.3 80H71.9l6.3-80zM68.1 176h183.8l2.1 26.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7l2.1-26.3z"
        }
    ]
};

const FarWonSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWonSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M71.1 49.5c-3.6-12.7-16.8-20.2-29.6-16.6S21.3 49.7 24.9 62.5L79.1 256H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h68.5l44.4 158.5c2.9 10.5 12.6 17.7 23.6 17.5s20.3-7.8 22.9-18.4L221.2 304h69.7l37.8 157.6c2.6 10.6 12 18.2 22.9 18.4s20.6-7 23.6-17.5L419.5 304H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-55.1l54.2-193.5c3.6-12.8-3.9-26-16.6-29.6s-26 3.9-29.6 16.6L383.1 256h-54.4L279.3 50.4C276.7 39.6 267.1 32 256 32s-20.7 7.6-23.3 18.4L183.3 256h-54.4L71.1 49.5zM142.4 304h29.4l-13.6 56.6-15.8-56.6zm90.3-48 23.3-97.2 23.3 97.2h-46.6zm107.5 48h29.4l-15.9 56.6-13.5-56.6z"
        }
    ]
};

const FarWorm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWorm",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 192v176c0 35.3-28.7 64-64 64s-64-28.7-64-64v-48c0-53-43-96-96-96s-96 43-96 96v128c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-35.3 28.7-64 64-64s64 28.7 64 64v48c0 53 43 96 96 96s96-43 96-96V96c0-26.5-21.5-48-48-48h-48c-26.5 0-48 21.5-48 48s21.5 48 48 48h64v48zm-224-16c15.9 0 31.2 2.6 45.5 7.3 27.7 9.2 51.7 26.6 69 49.3 5.1 6.7 9.6 13.8 13.5 21.3 10.2 19.8 16 42.2 16 66V368c0 8.8 7.2 16 16 16s16-7.2 16-16V192h-16c-6.3 0-12.5-.6-18.5-1.8-27.6-5.4-51-22.6-64.7-46.2-8.2-14.1-12.8-30.5-12.8-48 0-53 43-96 96-96h48c53 0 96 43 96 96v272c0 79.5-64.5 144-144 144-55.7 0-104.1-31.7-128-78-10.2-19.8-16-42.2-16-66v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 35.3-28.7 64-64 64s-64-28.7-64-64V320c0-79.5 64.5-144 144-144zM376 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FarWreathLaurel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWreathLaurel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m237.1 50.9-11.8.7C205 52.7 188.7 69 187.6 89.3l-.7 11.8 11.8-.7c20.3-1.1 36.6-17.4 37.7-37.7l.7-11.8zm-194 126.8c-11.4-30.3-9.7-65.3 7.8-95.6l20.6-35.7c6.3-10.9 20.2-14.6 31-8.3 15.9 9.2 28.9 21.4 38.8 35.5 8-38.5 41-67.7 81.3-70l38.6-2.1c14.3-.8 26.1 11 25.3 25.3l-2.1 38.6c-2.5 44.8-38.2 80.5-83 83l-24.6 1.4c-21.2 31-32.8 68-32.8 106.2 0 97.2 78.8 176 176 176h11.6c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5c-32.2-16.1-67.7-24.5-103.7-24.5h-23.2c-36 0-71.5 8.4-103.8 24.5l-9.9 5c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l9.9-5c8.3-4.1 16.8-7.9 25.4-11.2-5.5-3.1-10.8-6.5-15.9-10.1l-4.8 2.8-.3.2c-4.6 2.7-9.4 5-14.2 6.9-50.9 20.4-110.3.8-138.5-48l-20.6-35.8c-6.3-10.9-2.6-24.8 8.3-31 6-3.5 12.2-6.4 18.5-8.7C16 306.1 0 274.9 0 240v-41.2C0 186.2 10.2 176 22.7 176c7 0 13.8.6 20.4 1.7zm420-28-24.6-1.4c-44.8-2.5-80.5-38.2-83-83l-2.1-38.6c-.8-14.3 11-26.1 25.3-25.3l38.6 2.1c40.3 2.2 73.3 31.5 81.3 70 9.9-14.1 22.9-26.3 38.8-35.5 10.9-6.3 24.8-2.6 31 8.3L589 82c17.5 30.3 19.2 65.3 7.8 95.6 6.6-1.1 13.4-1.7 20.4-1.7 12.6 0 22.7 10.2 22.7 22.7v41.2c0 34.9-16 66.1-41.1 86.7 6.3 2.3 12.5 5.2 18.5 8.7 10.9 6.3 14.6 20.2 8.3 31L605 401.9c-21.6 37.4-61.5 57.6-101.8 55.9-5.3-8.3-12.8-15.4-22.3-20.1l-9.9-5c-2.8-1.4-5.7-2.8-8.6-4.1-10.4-4.8-21-9-31.8-12.6-7.9-2.7-15.9-5-24-7C460 378.9 496 321.7 496 256c0-38.2-11.6-75.2-32.8-106.3zm-48.4-98.1-11.8-.7.7 11.8c1.1 20.3 17.4 36.6 37.7 37.7l11.8.7-.7-11.8C451.3 69 435 52.7 414.7 51.6zM96 301.9v-4.7c0-31.6-20-58.5-48-68.8V240c0 29.8 20.4 54.9 48 62zm448-4.7v4.7c27.6-7.1 48-32.2 48-62v-11.5c-28 10.3-48 37.2-48 68.8zM149 407.8l-2.4-4.1c-15.8-27.3-46.5-40.6-75.9-35.6l5.7 9.9c14.9 25.8 45.1 37.3 72.5 29.7zm-43.6-228.1c15.8-27.3 11.9-60.6-7.2-83.5l-5.7 9.9c-14.9 25.8-9.8 57.7 10.6 77.7l2.4-4.1zm431.6 4.1c20.3-20 25.5-51.8 10.6-77.7l-5.7-9.9c-19.1 22.9-22.9 56.2-7.2 83.5l2.4 4.1zm-46 224c27.4 7.6 57.6-3.9 72.5-29.7l5.7-9.9c-29.4-5.1-60.1 8.2-75.9 35.6l-2.4 4.1z"
        }
    ]
};

const FarWreath = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWreath",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M339.4 88.7c-24.5 7.3-50.4-5.9-58.9-30-2.2-6.3-8.2-10.7-15.1-10.7-4 0-7.5 1.4-10.3 3.8-17.9 15.2-44.2 15.2-62.1 0-2.8-2.4-6.3-3.8-10.3-3.8-6.9 0-12.9 4.4-15.1 10.7-8.5 24.1-34.4 37.3-58.9 30-1.4-.4-2.9-.7-4.6-.7-8.8 0-16 7.2-16 16 0 1.7.2 3.2.7 4.6 7.3 24.5-5.9 50.4-30 58.9-6.3 2.2-10.7 8.2-10.7 15.1 0 4 1.4 7.5 3.8 10.3 15.2 17.9 15.2 44.2 0 62.2-2.4 2.8-3.8 6.3-3.8 10.3 0 6.9 4.4 12.9 10.7 15.1 24.1 8.5 37.3 34.4 30 58.9-.4 1.4-.7 2.9-.7 4.6 0 8.8 7.2 16 16 16 1.7 0 3.2-.2 4.6-.7 5.4-1.6 10.8-2.2 16.1-1.9-17 8.5-28.7 26.1-28.7 46.4v3.7c-31.6-3.9-56-30.9-56-63.5 0-6.3.9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3-1.7-5.8-2.6-12-2.6-18.3 0-35.3 28.7-64 64-64 6.3 0 12.5.9 18.2 2.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6 5.8-1.7 11.9-2.6 18.2-2.6 35.3 0 64 28.7 64 64 0 6.3-.9 12.5-2.6 18.2 24.8 8.8 42.6 32.5 42.6 60.3 0 15.8-5.7 30.2-15.2 41.4 9.5 11.2 15.2 25.6 15.2 41.4 0 27.9-17.8 51.6-42.6 60.3 1.7 5.8 2.6 11.9 2.6 18.2 0 32.6-24.4 59.6-56 63.5v-3.7c0-20.3-11.7-37.9-28.7-46.4 5.3-.3 10.8.3 16.1 1.9 1.4.4 2.9.7 4.6.7 8.8 0 16-7.2 16-16 0-1.7-.2-3.2-.7-4.6-7.3-24.5 5.9-50.4 30-58.9 6.3-2.2 10.7-8.2 10.7-15.1 0-4-1.4-7.5-3.8-10.3-15.2-17.9-15.2-44.2 0-62.2 2.4-2.8 3.8-6.3 3.8-10.3 0-6.9-4.4-12.9-10.7-15.1-24.1-8.5-37.3-34.4-30-58.9.4-1.4.7-2.9.7-4.6 0-8.8-7.2-16-16-16-1.7 0-3.2.2-4.6.7zM128 492.2v-88.4c0-10.9 8.9-19.8 19.8-19.8 2.8 0 5.5.6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7 10.9 0 19.8 8.9 19.8 19.8v88.4c0 10.9-8.9 19.8-19.8 19.8-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7-10.9 0-19.8-8.9-19.8-19.8zm69.9-294.3c-2 9.3-5.6 18.2-10.8 26.1 5.2 8 8.9 16.8 10.8 26.1 9.3 2 18.2 5.6 26.1 10.8 8-5.2 16.8-8.9 26.1-10.8 2-9.3 5.6-18.2 10.8-26.1-5.2-8-8.9-16.8-10.8-26.1-4.7-1-9.3-2.4-13.7-4.2-4.3-1.8-8.5-4-12.4-6.6-8 5.2-16.8 8.9-26.1 10.8zm5.2-55.5c11.3-12.1 30.6-12.1 41.9 0 5.7 6 13.6 9.4 21.9 9.1 16.6-.6 30.2 13 29.6 29.6-.3 8.3 3 16.3 9.1 21.9 12.1 11.3 12.1 30.6 0 41.9-6 5.7-9.4 13.6-9.1 21.9.6 16.6-13 30.2-29.6 29.6-8.3-.3-16.3 3-21.9 9.1-11.3 12.1-30.6 12.1-41.9 0-5.7-6-13.6-9.4-21.9-9.1-16.6.6-30.2-13-29.6-29.6.3-8.3-3-16.3-9.1-21.9-12.1-11.3-12.1-30.6 0-41.9 6-5.7 9.4-13.6 9.1-21.9-.6-16.6 13-30.2 29.6-29.6 8.3.3 16.3-3 21.9-9.1z"
        }
    ]
};

const FarWrenchSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWrenchSimple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M133 10.3c6.9 4.4 11 12 11 20.2v119.6l48 48 48-48V30.5c0-8.2 4.2-15.8 11-20.2s15.5-5 23-1.6C338.3 38.2 384 98.5 384 176c0 64.3-31.6 121.1-80 156v156c0 13.3-10.7 24-24 24s-24-10.7-24-24V319.1c0-8.3 4.3-16.1 11.4-20.4C308.6 273.3 336 227.8 336 176c0-42.2-18.3-77.7-48-102.4V160c0 6.4-2.5 12.5-7 17l-72 72c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-72-72c-4.5-4.5-7-10.6-7-17V73.6C66.3 98.3 48 133.8 48 176c0 51.8 27.4 97.3 68.6 122.7 7.1 4.4 11.4 12.1 11.4 20.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V332C31.6 297.1 0 240.3 0 176 0 98.5 45.7 38.2 110 8.7c7.4-3.4 16.1-2.8 23 1.6z"
        }
    ]
};

const FarWrench = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarWrench",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M322.3 268c9.4 2.6 19.3 4 29.7 4 60.5 0 109.8-48 111.9-108l-25.3 25.3c-12 12-28.3 18.7-45.3 18.7H368c-35.3 0-64-28.7-64-64v-25.4c0-17 6.7-33.3 18.7-45.3L348 48.1c-60 2-108 51.4-108 111.9 0 10.3 1.4 20.3 4 29.7 4.6 16.6-.2 34.4-12.4 46.6L57.1 410.7c-5.9 5.8-9.1 13.8-9.1 22.1C48 450 62 464 79.2 464c8.3 0 16.2-3.3 22.1-9.1l174.4-174.5c12.2-12.2 30-16.9 46.6-12.4zM424.6 39.4l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3V144c0 8.8 7.2 16 16 16h25.4c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3 10.1 21 15.7 44.5 15.7 69.3 0 88.4-71.6 160-160 160-14.7 0-28.9-2-42.3-5.7L135.2 488.8a79.09 79.09 0 0 1-56 23.2C35.5 512 0 476.5 0 432.8c0-21 8.3-41.1 23.2-56l174.5-174.5c-3.7-13.4-5.7-27.6-5.7-42.3C192 71.6 263.6 0 352 0c24.8 0 48.3 5.7 69.3 15.7 9.2 4.4 10.5 16.5 3.3 23.7zM88 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FarXRay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarXRay",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56s10.7 24 24 24h8v352h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm56 400V80h352v352H80zM256 96c-8.8 0-16 7.2-16 16v32h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v32h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v54.6L189.1 275c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8 0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6h120.8c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4 0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 294.6V240h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96v-32h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-32c0-8.8-7.2-16-16-16zm-48 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FarX = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarX",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M378.4 71.4c8.5-10.1 7.2-25.3-2.9-33.8s-25.3-7.2-33.8 2.9L192 218.7 42.4 40.6c-8.5-10.2-23.7-11.5-33.8-3s-11.5 23.7-3 33.8L160.7 256 5.6 440.6c-8.5 10.2-7.2 25.3 2.9 33.8s25.3 7.2 33.8-2.9L192 293.3l149.6 178.1c8.5 10.1 23.7 11.5 33.8 2.9s11.5-23.7 2.9-33.8L223.3 256l155-184.6z"
        }
    ]
};

const FarXmarkLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarXmarkLarge",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41 39c-9.4-9.3-24.6-9.3-34 0s-9.3 24.6 0 34l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z"
        }
    ]
};

const FarXmarkToSlot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarXmarkToSlot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80v280h288V80H144zM96 360V80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v280c13.3 0 24 10.7 24 24s-10.7 24-24 24H96c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-32-72v48H48v96h480v-96h-16v-48h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48h16zm143-153c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarXmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"
        }
    ]
};

const FarXmarksLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarXmarksLines",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32h592c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 80 0 69.3 0 56s10.7-24 24-24zm0 400h592c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm17-265 55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L41 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55L7 201c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm224 0 55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm190 0c9.4-9.4 24.6-9.4 33.9 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FarY = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarY",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M43.4 41.9c-7.7-10.7-22.7-13.1-33.5-5.3S-3.2 59.3 4.6 70.1L168 295.8V456c0 13.3 10.7 24 24 24s24-10.7 24-24V295.8L379.4 70.1c7.8-10.7 5.4-25.7-5.4-33.5s-25.7-5.4-33.5 5.4L192 247.1 43.4 41.9z"
        }
    ]
};

const FarYenSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarYenSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M43.8 42.5c-7.5-11-22.4-13.8-33.3-6.4S-3.3 58.5 4.2 69.5l105 154.5H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h96v48H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h96v88c0 13.3 10.7 24 24 24s24-10.7 24-24v-88h96c13.3 0 24-10.7 24-24s-10.7-24-24-24h-96v-48h96c13.3 0 24-10.7 24-24s-10.7-24-24-24h-69.2l105-154.5c7.5-11 4.6-25.9-6.4-33.3s-25.9-4.6-33.3 6.4L160 213.3 43.8 42.5z"
        }
    ]
};

const FarYinYang = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarYinYang",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 256c0 114.9-93.1 208-208 208-50.9 0-92.2-41.2-92.2-92s41.3-92 92.2-92c77.3 0 140-62.7 140-140 0-15.4-2.5-30.1-7-44 45.9 38.2 75 95.7 75 160zM256 48c50.8 0 92 41.2 92 92s-41.2 92-92 92c-77.3 0-140.2 62.6-140.2 140 0 15.3 2.5 30 7 43.8C77.1 377.6 48 320.2 48 256c0-114.9 93.1-208 208-208zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm32-368a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FarZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FarZ",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h336c9.3 0 17.8 5.4 21.8 13.9s2.6 18.4-3.4 25.6L75.5 432H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.4 3.4-25.6L308.5 80H24C10.7 80 0 69.3 0 56z"
        }
    ]
};

/**
 * Generated bundle index. Do not edit.
 */

export { Far0, Far00, Far1, Far2, Far3, Far360Degrees, Far4, Far5, Far6, Far7, Far8, Far9, FarA, FarAbacus, FarAccentGrave, FarAcorn, FarAddressBook, FarAddressCard, FarAirConditioner, FarAirplay, FarAlarmClock, FarAlarmExclamation, FarAlarmPlus, FarAlarmSnooze, FarAlbum, FarAlbumCirclePlus, FarAlbumCircleUser, FarAlbumCollection, FarAlbumCollectionCirclePlus, FarAlbumCollectionCircleUser, FarAlicorn, FarAlien, FarAlien8bit, FarAlignCenter, FarAlignJustify, FarAlignLeft, FarAlignRight, FarAlignSlash, FarAlt, FarAmpGuitar, FarAmpersand, FarAnchor, FarAnchorCircleCheck, FarAnchorCircleExclamation, FarAnchorCircleXmark, FarAnchorLock, FarAngel, FarAngle, FarAngle90, FarAngleDown, FarAngleLeft, FarAngleRight, FarAngleUp, FarAnglesDown, FarAnglesLeft, FarAnglesRight, FarAnglesUp, FarAnglesUpDown, FarAnkh, FarApartment, FarAperture, FarApostrophe, FarAppleCore, FarAppleWhole, FarArchway, FarArrowDown, FarArrowDown19, FarArrowDown91, FarArrowDownAZ, FarArrowDownArrowUp, FarArrowDownBigSmall, FarArrowDownFromArc, FarArrowDownFromDottedLine, FarArrowDownFromLine, FarArrowDownLeft, FarArrowDownLeftAndArrowUpRightToCenter, FarArrowDownLong, FarArrowDownRight, FarArrowDownShortWide, FarArrowDownSmallBig, FarArrowDownSquareTriangle, FarArrowDownToArc, FarArrowDownToBracket, FarArrowDownToDottedLine, FarArrowDownToLine, FarArrowDownToSquare, FarArrowDownTriangleSquare, FarArrowDownUpAcrossLine, FarArrowDownUpLock, FarArrowDownWideShort, FarArrowDownZA, FarArrowLeft, FarArrowLeftFromArc, FarArrowLeftFromLine, FarArrowLeftLong, FarArrowLeftLongToLine, FarArrowLeftToArc, FarArrowLeftToLine, FarArrowPointer, FarArrowProgress, FarArrowRight, FarArrowRightArrowLeft, FarArrowRightFromArc, FarArrowRightFromBracket, FarArrowRightFromLine, FarArrowRightLong, FarArrowRightLongToLine, FarArrowRightToArc, FarArrowRightToBracket, FarArrowRightToCity, FarArrowRightToLine, FarArrowRotateLeft, FarArrowRotateRight, FarArrowTrendDown, FarArrowTrendUp, FarArrowTurnDown, FarArrowTurnDownLeft, FarArrowTurnDownRight, FarArrowTurnUp, FarArrowUp, FarArrowUp19, FarArrowUp91, FarArrowUpAZ, FarArrowUpArrowDown, FarArrowUpBigSmall, FarArrowUpFromArc, FarArrowUpFromBracket, FarArrowUpFromDottedLine, FarArrowUpFromGroundWater, FarArrowUpFromLine, FarArrowUpFromSquare, FarArrowUpFromWaterPump, FarArrowUpLeft, FarArrowUpLeftFromCircle, FarArrowUpLong, FarArrowUpRight, FarArrowUpRightAndArrowDownLeftFromCenter, FarArrowUpRightDots, FarArrowUpRightFromSquare, FarArrowUpShortWide, FarArrowUpSmallBig, FarArrowUpSquareTriangle, FarArrowUpToArc, FarArrowUpToDottedLine, FarArrowUpToLine, FarArrowUpTriangleSquare, FarArrowUpWideShort, FarArrowUpZA, FarArrowsCross, FarArrowsDownToLine, FarArrowsDownToPeople, FarArrowsFromDottedLine, FarArrowsFromLine, FarArrowsLeftRight, FarArrowsLeftRightToLine, FarArrowsMaximize, FarArrowsMinimize, FarArrowsRepeat, FarArrowsRepeat1, FarArrowsRetweet, FarArrowsRotate, FarArrowsSpin, FarArrowsSplitUpAndLeft, FarArrowsToCircle, FarArrowsToDot, FarArrowsToDottedLine, FarArrowsToEye, FarArrowsToLine, FarArrowsTurnRight, FarArrowsTurnToDots, FarArrowsUpDown, FarArrowsUpDownLeftRight, FarArrowsUpToLine, FarAsterisk, FarAt, FarAtom, FarAtomSimple, FarAudioDescription, FarAudioDescriptionSlash, FarAustralSign, FarAvocado, FarAward, FarAwardSimple, FarAxe, FarAxeBattle, FarB, FarBaby, FarBabyCarriage, FarBackpack, FarBackward, FarBackwardFast, FarBackwardStep, FarBacon, FarBacteria, FarBacterium, FarBadge, FarBadgeCheck, FarBadgeDollar, FarBadgePercent, FarBadgeSheriff, FarBadgerHoney, FarBadminton, FarBagSeedling, FarBagShopping, FarBagel, FarBagsShopping, FarBaguette, FarBahai, FarBahtSign, FarBallPile, FarBalloon, FarBalloons, FarBallot, FarBallotCheck, FarBan, FarBanBug, FarBanParking, FarBanSmoking, FarBanana, FarBandage, FarBangladeshiTakaSign, FarBanjo, FarBarcode, FarBarcodeRead, FarBarcodeScan, FarBars, FarBarsFilter, FarBarsProgress, FarBarsSort, FarBarsStaggered, FarBaseball, FarBaseballBatBall, FarBasketShopping, FarBasketShoppingSimple, FarBasketball, FarBasketballHoop, FarBat, FarBath, FarBatteryBolt, FarBatteryEmpty, FarBatteryExclamation, FarBatteryFull, FarBatteryHalf, FarBatteryLow, FarBatteryQuarter, FarBatterySlash, FarBatteryThreeQuarters, FarBed, FarBedBunk, FarBedEmpty, FarBedFront, FarBedPulse, FarBee, FarBeerMug, FarBeerMugEmpty, FarBell, FarBellConcierge, FarBellExclamation, FarBellOn, FarBellPlus, FarBellSchool, FarBellSchoolSlash, FarBellSlash, FarBells, FarBenchTree, FarBezierCurve, FarBicycle, FarBillboard, FarBinBottles, FarBinBottlesRecycle, FarBinRecycle, FarBinary, FarBinaryCircleCheck, FarBinaryLock, FarBinarySlash, FarBinoculars, FarBiohazard, FarBird, FarBitcoinSign, FarBlanket, FarBlanketFire, FarBlender, FarBlenderPhone, FarBlinds, FarBlindsOpen, FarBlindsRaised, FarBlock, FarBlockBrick, FarBlockBrickFire, FarBlockQuestion, FarBlockQuote, FarBlog, FarBlueberries, FarBluetooth, FarBold, FarBolt, FarBoltAuto, FarBoltLightning, FarBoltSlash, FarBomb, FarBone, FarBoneBreak, FarBong, FarBook, FarBookArrowRight, FarBookArrowUp, FarBookAtlas, FarBookBible, FarBookBlank, FarBookBookmark, FarBookCircleArrowRight, FarBookCircleArrowUp, FarBookCopy, FarBookFont, FarBookHeart, FarBookJournalWhills, FarBookMedical, FarBookOpen, FarBookOpenCover, FarBookOpenReader, FarBookQuran, FarBookSection, FarBookSkull, FarBookSparkles, FarBookTanakh, FarBookUser, FarBookmark, FarBookmarkSlash, FarBooks, FarBooksMedical, FarBoombox, FarBoot, FarBootHeeled, FarBoothCurtain, FarBorderAll, FarBorderBottom, FarBorderBottomRight, FarBorderCenterH, FarBorderCenterV, FarBorderInner, FarBorderLeft, FarBorderNone, FarBorderOuter, FarBorderRight, FarBorderTop, FarBorderTopLeft, FarBoreHole, FarBottleDroplet, FarBottleWater, FarBowArrow, FarBowlChopsticks, FarBowlChopsticksNoodles, FarBowlFood, FarBowlHot, FarBowlRice, FarBowlScoop, FarBowlScoops, FarBowlSoftServe, FarBowlSpoon, FarBowlingBall, FarBowlingBallPin, FarBowlingPins, FarBox, FarBoxArchive, FarBoxBallot, FarBoxCheck, FarBoxCircleCheck, FarBoxDollar, FarBoxHeart, FarBoxOpen, FarBoxOpenFull, FarBoxTaped, FarBoxTissue, FarBoxesPacking, FarBoxesStacked, FarBoxingGlove, FarBracketCurly, FarBracketCurlyRight, FarBracketRound, FarBracketRoundRight, FarBracketSquare, FarBracketSquareRight, FarBracketsCurly, FarBracketsRound, FarBracketsSquare, FarBraille, FarBrain, FarBrainArrowCurvedRight, FarBrainCircuit, FarBrakeWarning, FarBrazilianRealSign, FarBreadLoaf, FarBreadSlice, FarBreadSliceButter, FarBridge, FarBridgeCircleCheck, FarBridgeCircleExclamation, FarBridgeCircleXmark, FarBridgeLock, FarBridgeSuspension, FarBridgeWater, FarBriefcase, FarBriefcaseArrowRight, FarBriefcaseBlank, FarBriefcaseMedical, FarBrightness, FarBrightnessLow, FarBringForward, FarBringFront, FarBroccoli, FarBroom, FarBroomBall, FarBroomWide, FarBrowser, FarBrowsers, FarBrush, FarBucket, FarBug, FarBugSlash, FarBugs, FarBuilding, FarBuildingCircleArrowRight, FarBuildingCircleCheck, FarBuildingCircleExclamation, FarBuildingCircleXmark, FarBuildingColumns, FarBuildingFlag, FarBuildingLock, FarBuildingNgo, FarBuildingShield, FarBuildingUn, FarBuildingUser, FarBuildingWheat, FarBuildings, FarBullhorn, FarBullseye, FarBullseyeArrow, FarBullseyePointer, FarBuoy, FarBuoyMooring, FarBurger, FarBurgerCheese, FarBurgerFries, FarBurgerGlass, FarBurgerLettuce, FarBurgerSoda, FarBurrito, FarBurst, FarBus, FarBusSchool, FarBusSimple, FarBusinessTime, FarButter, FarC, FarCabin, FarCabinetFiling, FarCableCar, FarCactus, FarCakeCandles, FarCakeSlice, FarCalculator, FarCalculatorSimple, FarCalendar, FarCalendarArrowDown, FarCalendarArrowUp, FarCalendarCheck, FarCalendarCircleExclamation, FarCalendarCircleMinus, FarCalendarCirclePlus, FarCalendarCircleUser, FarCalendarClock, FarCalendarDay, FarCalendarDays, FarCalendarExclamation, FarCalendarHeart, FarCalendarImage, FarCalendarLines, FarCalendarLinesPen, FarCalendarMinus, FarCalendarPen, FarCalendarPlus, FarCalendarRange, FarCalendarStar, FarCalendarUsers, FarCalendarWeek, FarCalendarXmark, FarCalendars, FarCamcorder, FarCamera, FarCameraCctv, FarCameraMovie, FarCameraPolaroid, FarCameraRetro, FarCameraRotate, FarCameraSecurity, FarCameraSlash, FarCameraViewfinder, FarCameraWeb, FarCameraWebSlash, FarCampfire, FarCampground, FarCanFood, FarCandleHolder, FarCandy, FarCandyBar, FarCandyCane, FarCandyCorn, FarCannabis, FarCapsules, FarCar, FarCarBattery, FarCarBolt, FarCarBuilding, FarCarBump, FarCarBurst, FarCarBus, FarCarCircleBolt, FarCarGarage, FarCarMirrors, FarCarOn, FarCarRear, FarCarSide, FarCarSideBolt, FarCarTilt, FarCarTunnel, FarCarWash, FarCarWrench, FarCaravan, FarCaravanSimple, FarCardClub, FarCardDiamond, FarCardHeart, FarCardSpade, FarCards, FarCardsBlank, FarCaretDown, FarCaretLeft, FarCaretRight, FarCaretUp, FarCarrot, FarCars, FarCartArrowDown, FarCartArrowUp, FarCartCircleArrowDown, FarCartCircleArrowUp, FarCartCircleCheck, FarCartCircleExclamation, FarCartCirclePlus, FarCartCircleXmark, FarCartFlatbed, FarCartFlatbedBoxes, FarCartFlatbedEmpty, FarCartFlatbedSuitcase, FarCartMinus, FarCartPlus, FarCartShopping, FarCartShoppingFast, FarCartXmark, FarCashRegister, FarCassetteBetamax, FarCassetteTape, FarCassetteVhs, FarCastle, FarCat, FarCatSpace, FarCauldron, FarCediSign, FarCentSign, FarCertificate, FarChair, FarChairOffice, FarChalkboard, FarChalkboardUser, FarChampagneGlass, FarChampagneGlasses, FarChargingStation, FarChartArea, FarChartBar, FarChartBullet, FarChartCandlestick, FarChartColumn, FarChartGantt, FarChartLine, FarChartLineDown, FarChartLineUp, FarChartLineUpDown, FarChartMixed, FarChartMixedUpCircleCurrency, FarChartMixedUpCircleDollar, FarChartNetwork, FarChartPie, FarChartPieSimple, FarChartPieSimpleCircleCurrency, FarChartPieSimpleCircleDollar, FarChartPyramid, FarChartRadar, FarChartScatter, FarChartScatter3d, FarChartScatterBubble, FarChartSimple, FarChartSimpleHorizontal, FarChartTreeMap, FarChartUser, FarChartWaterfall, FarCheck, FarCheckDouble, FarCheckToSlot, FarCheese, FarCheeseSwiss, FarCherries, FarChess, FarChessBishop, FarChessBishopPiece, FarChessBoard, FarChessClock, FarChessClockFlip, FarChessKing, FarChessKingPiece, FarChessKnight, FarChessKnightPiece, FarChessPawn, FarChessPawnPiece, FarChessQueen, FarChessQueenPiece, FarChessRook, FarChessRookPiece, FarChestnut, FarChevronDown, FarChevronLeft, FarChevronRight, FarChevronUp, FarChevronsDown, FarChevronsLeft, FarChevronsRight, FarChevronsUp, FarChfSign, FarChild, FarChildCombatant, FarChildDress, FarChildReaching, FarChildren, FarChimney, FarChopsticks, FarChurch, FarCircle, FarCircle0, FarCircle1, FarCircle2, FarCircle3, FarCircle4, FarCircle5, FarCircle6, FarCircle7, FarCircle8, FarCircle9, FarCircleA, FarCircleAmpersand, FarCircleArrowDown, FarCircleArrowDownLeft, FarCircleArrowDownRight, FarCircleArrowLeft, FarCircleArrowRight, FarCircleArrowUp, FarCircleArrowUpLeft, FarCircleArrowUpRight, FarCircleB, FarCircleBolt, FarCircleBookOpen, FarCircleBookmark, FarCircleC, FarCircleCalendar, FarCircleCamera, FarCircleCaretDown, FarCircleCaretLeft, FarCircleCaretRight, FarCircleCaretUp, FarCircleCheck, FarCircleChevronDown, FarCircleChevronLeft, FarCircleChevronRight, FarCircleChevronUp, FarCircleD, FarCircleDashed, FarCircleDivide, FarCircleDollar, FarCircleDollarToSlot, FarCircleDot, FarCircleDown, FarCircleDownLeft, FarCircleDownRight, FarCircleE, FarCircleEllipsis, FarCircleEllipsisVertical, FarCircleEnvelope, FarCircleEuro, FarCircleExclamation, FarCircleExclamationCheck, FarCircleF, FarCircleG, FarCircleH, FarCircleHalf, FarCircleHalfStroke, FarCircleHeart, FarCircleI, FarCircleInfo, FarCircleJ, FarCircleK, FarCircleL, FarCircleLeft, FarCircleLocationArrow, FarCircleM, FarCircleMicrophone, FarCircleMicrophoneLines, FarCircleMinus, FarCircleN, FarCircleNodes, FarCircleNotch, FarCircleO, FarCircleP, FarCircleParking, FarCirclePause, FarCirclePhone, FarCirclePhoneFlip, FarCirclePhoneHangup, FarCirclePlay, FarCirclePlus, FarCircleQ, FarCircleQuarter, FarCircleQuarterStroke, FarCircleQuarters, FarCircleQuestion, FarCircleR, FarCircleRadiation, FarCircleRight, FarCircleS, FarCircleSmall, FarCircleSort, FarCircleSortDown, FarCircleSortUp, FarCircleStar, FarCircleSterling, FarCircleStop, FarCircleT, FarCircleThreeQuarters, FarCircleThreeQuartersStroke, FarCircleTrash, FarCircleU, FarCircleUp, FarCircleUpLeft, FarCircleUpRight, FarCircleUser, FarCircleV, FarCircleVideo, FarCircleW, FarCircleWaveformLines, FarCircleX, FarCircleXmark, FarCircleY, FarCircleYen, FarCircleZ, FarCirclesOverlap, FarCitrus, FarCitrusSlice, FarCity, FarClapperboard, FarClapperboardPlay, FarClarinet, FarClawMarks, FarClipboard, FarClipboardCheck, FarClipboardList, FarClipboardListCheck, FarClipboardMedical, FarClipboardPrescription, FarClipboardQuestion, FarClipboardUser, FarClock, FarClockDesk, FarClockEight, FarClockEightThirty, FarClockEleven, FarClockElevenThirty, FarClockFive, FarClockFiveThirty, FarClockFourThirty, FarClockNine, FarClockNineThirty, FarClockOne, FarClockOneThirty, FarClockRotateLeft, FarClockSeven, FarClockSevenThirty, FarClockSix, FarClockSixThirty, FarClockTen, FarClockTenThirty, FarClockThree, FarClockThreeThirty, FarClockTwelve, FarClockTwelveThirty, FarClockTwo, FarClockTwoThirty, FarClone, FarClosedCaptioning, FarClosedCaptioningSlash, FarClothesHanger, FarCloud, FarCloudArrowDown, FarCloudArrowUp, FarCloudBinary, FarCloudBolt, FarCloudBoltMoon, FarCloudBoltSun, FarCloudCheck, FarCloudDrizzle, FarCloudExclamation, FarCloudFog, FarCloudHail, FarCloudHailMixed, FarCloudMeatball, FarCloudMinus, FarCloudMoon, FarCloudMoonRain, FarCloudMusic, FarCloudPlus, FarCloudQuestion, FarCloudRain, FarCloudRainbow, FarCloudShowers, FarCloudShowersHeavy, FarCloudShowersWater, FarCloudSlash, FarCloudSleet, FarCloudSnow, FarCloudSun, FarCloudSunRain, FarCloudWord, FarCloudXmark, FarClouds, FarCloudsMoon, FarCloudsSun, FarClover, FarClub, FarCoconut, FarCode, FarCodeBranch, FarCodeCommit, FarCodeCompare, FarCodeFork, FarCodeMerge, FarCodePullRequest, FarCodePullRequestClosed, FarCodePullRequestDraft, FarCodeSimple, FarCoffeeBean, FarCoffeeBeans, FarCoffeePot, FarCoffin, FarCoffinCross, FarCoin, FarCoinBlank, FarCoinFront, FarCoinVertical, FarCoins, FarColon, FarColonSign, FarColumns3, FarComet, FarComma, FarCommand, FarComment, FarCommentArrowDown, FarCommentArrowUp, FarCommentArrowUpRight, FarCommentCaptions, FarCommentCheck, FarCommentCode, FarCommentDollar, FarCommentDots, FarCommentExclamation, FarCommentHeart, FarCommentImage, FarCommentLines, FarCommentMedical, FarCommentMiddle, FarCommentMiddleTop, FarCommentMinus, FarCommentMusic, FarCommentPen, FarCommentPlus, FarCommentQuestion, FarCommentQuote, FarCommentSlash, FarCommentSmile, FarCommentSms, FarCommentText, FarCommentXmark, FarComments, FarCommentsDollar, FarCommentsQuestion, FarCommentsQuestionCheck, FarCompactDisc, FarCompass, FarCompassDrafting, FarCompassSlash, FarCompress, FarCompressWide, FarComputer, FarComputerClassic, FarComputerMouse, FarComputerMouseScrollwheel, FarComputerSpeaker, FarContainerStorage, FarConveyorBelt, FarConveyorBeltArm, FarConveyorBeltBoxes, FarConveyorBeltEmpty, FarCookie, FarCookieBite, FarCopy, FarCopyright, FarCorn, FarCorner, FarCouch, FarCow, FarCowbell, FarCowbellCirclePlus, FarCrab, FarCrateApple, FarCrateEmpty, FarCreditCard, FarCreditCardBlank, FarCreditCardFront, FarCricketBatBall, FarCroissant, FarCrop, FarCropSimple, FarCross, FarCrosshairs, FarCrosshairsSimple, FarCrow, FarCrown, FarCrutch, FarCrutches, FarCruzeiroSign, FarCrystalBall, FarCube, FarCubes, FarCubesStacked, FarCucumber, FarCupStraw, FarCupStrawSwoosh, FarCupTogo, FarCupcake, FarCurlingStone, FarCustard, FarD, FarDagger, FarDash, FarDatabase, FarDeer, FarDeerRudolph, FarDeleteLeft, FarDeleteRight, FarDemocrat, FarDesktop, FarDesktopArrowDown, FarDharmachakra, FarDiagramCells, FarDiagramLeanCanvas, FarDiagramNested, FarDiagramNext, FarDiagramPredecessor, FarDiagramPrevious, FarDiagramProject, FarDiagramSankey, FarDiagramSubtask, FarDiagramSuccessor, FarDiagramVenn, FarDial, FarDialHigh, FarDialLow, FarDialMax, FarDialMed, FarDialMedLow, FarDialMin, FarDialOff, FarDiamond, FarDiamondExclamation, FarDiamondHalf, FarDiamondHalfStroke, FarDiamondTurnRight, FarDice, FarDiceD10, FarDiceD12, FarDiceD20, FarDiceD4, FarDiceD6, FarDiceD8, FarDiceFive, FarDiceFour, FarDiceOne, FarDiceSix, FarDiceThree, FarDiceTwo, FarDinosaur, FarDiploma, FarDiscDrive, FarDisease, FarDisplay, FarDisplayArrowDown, FarDisplayChartUp, FarDisplayChartUpCircleCurrency, FarDisplayChartUpCircleDollar, FarDisplayCode, FarDisplayMedical, FarDisplaySlash, FarDistributeSpacingHorizontal, FarDistributeSpacingVertical, FarDitto, FarDivide, FarDna, FarDoNotEnter, FarDog, FarDogLeashed, FarDollarSign, FarDolly, FarDollyEmpty, FarDolphin, FarDongSign, FarDonut, FarDoorClosed, FarDoorOpen, FarDove, FarDown, FarDownFromDottedLine, FarDownFromLine, FarDownLeft, FarDownLeftAndUpRightToCenter, FarDownLong, FarDownRight, FarDownToBracket, FarDownToDottedLine, FarDownToLine, FarDownload, FarDragon, FarDrawCircle, FarDrawPolygon, FarDrawSquare, FarDreidel, FarDrone, FarDroneFront, FarDroplet, FarDropletDegree, FarDropletPercent, FarDropletSlash, FarDrum, FarDrumSteelpan, FarDrumstick, FarDrumstickBite, FarDryer, FarDryerHeat, FarDuck, FarDumbbell, FarDumpster, FarDumpsterFire, FarDungeon, FarE, FarEar, FarEarDeaf, FarEarListen, FarEarMuffs, FarEarthAfrica, FarEarthAmericas, FarEarthAsia, FarEarthEurope, FarEarthOceania, FarEclipse, FarEgg, FarEggFried, FarEggplant, FarEject, FarElephant, FarElevator, FarEllipsis, FarEllipsisStroke, FarEllipsisStrokeVertical, FarEllipsisVertical, FarEmptySet, FarEngine, FarEngineWarning, FarEnvelope, FarEnvelopeCircleCheck, FarEnvelopeDot, FarEnvelopeOpen, FarEnvelopeOpenDollar, FarEnvelopeOpenText, FarEnvelopes, FarEnvelopesBulk, FarEquals, FarEraser, FarEscalator, FarEthernet, FarEuroSign, FarExclamation, FarExpand, FarExpandWide, FarExplosion, FarEye, FarEyeDropper, FarEyeDropperFull, FarEyeDropperHalf, FarEyeEvil, FarEyeLowVision, FarEyeSlash, FarEyes, FarF, FarFaceAngry, FarFaceAngryHorns, FarFaceAnguished, FarFaceAnxiousSweat, FarFaceAstonished, FarFaceAwesome, FarFaceBeamHandOverMouth, FarFaceClouds, FarFaceConfounded, FarFaceConfused, FarFaceCowboyHat, FarFaceDiagonalMouth, FarFaceDisappointed, FarFaceDisguise, FarFaceDizzy, FarFaceDotted, FarFaceDowncastSweat, FarFaceDrooling, FarFaceExhaling, FarFaceExplode, FarFaceExpressionless, FarFaceEyesXmarks, FarFaceFearful, FarFaceFlushed, FarFaceFrown, FarFaceFrownOpen, FarFaceFrownSlight, FarFaceGlasses, FarFaceGrimace, FarFaceGrin, FarFaceGrinBeam, FarFaceGrinBeamSweat, FarFaceGrinHearts, FarFaceGrinSquint, FarFaceGrinSquintTears, FarFaceGrinStars, FarFaceGrinTears, FarFaceGrinTongue, FarFaceGrinTongueSquint, FarFaceGrinTongueWink, FarFaceGrinWide, FarFaceGrinWink, FarFaceHandOverMouth, FarFaceHandPeeking, FarFaceHandYawn, FarFaceHeadBandage, FarFaceHoldingBackTears, FarFaceHushed, FarFaceIcicles, FarFaceKiss, FarFaceKissBeam, FarFaceKissClosedEyes, FarFaceKissWinkHeart, FarFaceLaugh, FarFaceLaughBeam, FarFaceLaughSquint, FarFaceLaughWink, FarFaceLying, FarFaceMask, FarFaceMeh, FarFaceMehBlank, FarFaceMelting, FarFaceMonocle, FarFaceNauseated, FarFaceNoseSteam, FarFaceParty, FarFacePensive, FarFacePersevering, FarFacePleading, FarFacePouting, FarFaceRaisedEyebrow, FarFaceRelieved, FarFaceRollingEyes, FarFaceSadCry, FarFaceSadSweat, FarFaceSadTear, FarFaceSaluting, FarFaceScream, FarFaceShush, FarFaceSleeping, FarFaceSleepy, FarFaceSmile, FarFaceSmileBeam, FarFaceSmileHalo, FarFaceSmileHearts, FarFaceSmileHorns, FarFaceSmilePlus, FarFaceSmileRelaxed, FarFaceSmileTear, FarFaceSmileTongue, FarFaceSmileUpsideDown, FarFaceSmileWink, FarFaceSmilingHands, FarFaceSmirking, FarFaceSpiralEyes, FarFaceSunglasses, FarFaceSurprise, FarFaceSwear, FarFaceThermometer, FarFaceThinking, FarFaceTired, FarFaceTissue, FarFaceTongueMoney, FarFaceTongueSweat, FarFaceUnamused, FarFaceViewfinder, FarFaceVomit, FarFaceWeary, FarFaceWoozy, FarFaceWorried, FarFaceZany, FarFaceZipper, FarFalafel, FarFamily, FarFamilyDress, FarFamilyPants, FarFan, FarFanTable, FarFarm, FarFaucet, FarFaucetDrip, FarFax, FarFeather, FarFeatherPointed, FarFence, FarFerrisWheel, FarFerry, FarFieldHockeyStickBall, FarFile, FarFileArrowDown, FarFileArrowUp, FarFileAudio, FarFileBinary, FarFileCertificate, FarFileChartColumn, FarFileChartPie, FarFileCheck, FarFileCircleCheck, FarFileCircleExclamation, FarFileCircleInfo, FarFileCircleMinus, FarFileCirclePlus, FarFileCircleQuestion, FarFileCircleXmark, FarFileCode, FarFileContract, FarFileCsv, FarFileDashedLine, FarFileDoc, FarFileExcel, FarFileExclamation, FarFileExport, FarFileHeart, FarFileImage, FarFileImport, FarFileInvoice, FarFileInvoiceDollar, FarFileLines, FarFileLock, FarFileMagnifyingGlass, FarFileMedical, FarFileMinus, FarFileMusic, FarFilePdf, FarFilePen, FarFilePlus, FarFilePlusMinus, FarFilePowerpoint, FarFilePrescription, FarFileShield, FarFileSignature, FarFileSlash, FarFileSpreadsheet, FarFileUser, FarFileVideo, FarFileWaveform, FarFileWord, FarFileXmark, FarFileZip, FarFileZipper, FarFiles, FarFilesMedical, FarFill, FarFillDrip, FarFilm, FarFilmCanister, FarFilmSimple, FarFilmSlash, FarFilms, FarFilter, FarFilterCircleDollar, FarFilterCircleXmark, FarFilterList, FarFilterSlash, FarFilters, FarFingerprint, FarFire, FarFireBurner, FarFireExtinguisher, FarFireFlame, FarFireFlameCurved, FarFireFlameSimple, FarFireHydrant, FarFireSmoke, FarFireplace, FarFish, FarFishBones, FarFishCooked, FarFishFins, FarFishingRod, FarFlag, FarFlagCheckered, FarFlagPennant, FarFlagSwallowtail, FarFlagUsa, FarFlashlight, FarFlask, FarFlaskGear, FarFlaskRoundPoison, FarFlaskRoundPotion, FarFlaskVial, FarFlatbread, FarFlatbreadStuffed, FarFloppyDisk, FarFloppyDiskCircleArrowRight, FarFloppyDiskCircleXmark, FarFloppyDiskPen, FarFloppyDisks, FarFlorinSign, FarFlower, FarFlowerDaffodil, FarFlowerTulip, FarFlute, FarFluxCapacitor, FarFlyingDisc, FarFolder, FarFolderArrowDown, FarFolderArrowUp, FarFolderBookmark, FarFolderClosed, FarFolderGear, FarFolderGrid, FarFolderHeart, FarFolderImage, FarFolderMagnifyingGlass, FarFolderMedical, FarFolderMinus, FarFolderMusic, FarFolderOpen, FarFolderPlus, FarFolderTree, FarFolderUser, FarFolderXmark, FarFolders, FarFonduePot, FarFont, FarFontAwesome, FarFontCase, FarFootball, FarFootballHelmet, FarFork, FarForkKnife, FarForklift, FarFort, FarForward, FarForwardFast, FarForwardStep, FarFrame, FarFrancSign, FarFrenchFries, FarFrog, FarFunction, FarFutbol, FarG, FarGalaxy, FarGalleryThumbnails, FarGameBoard, FarGameBoardSimple, FarGameConsoleHandheld, FarGameConsoleHandheldCrank, FarGamepad, FarGamepadModern, FarGarage, FarGarageCar, FarGarageOpen, FarGarlic, FarGasPump, FarGasPumpSlash, FarGauge, FarGaugeCircleBolt, FarGaugeCircleMinus, FarGaugeCirclePlus, FarGaugeHigh, FarGaugeLow, FarGaugeMax, FarGaugeMin, FarGaugeSimple, FarGaugeSimpleHigh, FarGaugeSimpleLow, FarGaugeSimpleMax, FarGaugeSimpleMin, FarGavel, FarGear, FarGearCode, FarGearComplex, FarGearComplexCode, FarGears, FarGem, FarGenderless, FarGhost, FarGif, FarGift, FarGiftCard, FarGifts, FarGingerbreadMan, FarGlass, FarGlassCitrus, FarGlassEmpty, FarGlassHalf, FarGlassWater, FarGlassWaterDroplet, FarGlasses, FarGlassesRound, FarGlobe, FarGlobePointer, FarGlobeSnow, FarGlobeStand, FarGoalNet, FarGolfBallTee, FarGolfClub, FarGolfFlagHole, FarGopuram, FarGraduationCap, FarGramophone, FarGrapes, FarGrate, FarGrateDroplet, FarGreaterThan, FarGreaterThanEqual, FarGrid, FarGrid2, FarGrid2Plus, FarGrid4, FarGrid5, FarGridDividers, FarGridHorizontal, FarGridRound, FarGridRound2, FarGridRound2Plus, FarGridRound4, FarGridRound5, FarGrill, FarGrillFire, FarGrillHot, FarGrip, FarGripDots, FarGripDotsVertical, FarGripLines, FarGripLinesVertical, FarGripVertical, FarGroupArrowsRotate, FarGuaraniSign, FarGuitar, FarGuitarElectric, FarGuitars, FarGun, FarGunSlash, FarGunSquirt, FarH, FarH1, FarH2, FarH3, FarH4, FarH5, FarH6, FarHammer, FarHammerCrash, FarHammerWar, FarHamsa, FarHand, FarHandBackFist, FarHandBackPointDown, FarHandBackPointLeft, FarHandBackPointRibbon, FarHandBackPointRight, FarHandBackPointUp, FarHandDots, FarHandFingersCrossed, FarHandFist, FarHandHeart, FarHandHolding, FarHandHoldingBox, FarHandHoldingDollar, FarHandHoldingDroplet, FarHandHoldingHand, FarHandHoldingHeart, FarHandHoldingMagic, FarHandHoldingMedical, FarHandHoldingSeedling, FarHandHoldingSkull, FarHandHorns, FarHandLizard, FarHandLove, FarHandMiddleFinger, FarHandPeace, FarHandPointDown, FarHandPointLeft, FarHandPointRibbon, FarHandPointRight, FarHandPointUp, FarHandPointer, FarHandScissors, FarHandSparkles, FarHandSpock, FarHandWave, FarHandcuffs, FarHands, FarHandsAslInterpreting, FarHandsBound, FarHandsBubbles, FarHandsClapping, FarHandsHolding, FarHandsHoldingChild, FarHandsHoldingCircle, FarHandsHoldingDiamond, FarHandsHoldingDollar, FarHandsHoldingHeart, FarHandsPraying, FarHandshake, FarHandshakeAngle, FarHandshakeSimple, FarHandshakeSimpleSlash, FarHandshakeSlash, FarHanukiah, FarHardDrive, FarHashtag, FarHashtagLock, FarHatBeach, FarHatChef, FarHatCowboy, FarHatCowboySide, FarHatSanta, FarHatWinter, FarHatWitch, FarHatWizard, FarHeadSide, FarHeadSideBrain, FarHeadSideCough, FarHeadSideCoughSlash, FarHeadSideGear, FarHeadSideGoggles, FarHeadSideHeadphones, FarHeadSideHeart, FarHeadSideMask, FarHeadSideMedical, FarHeadSideVirus, FarHeading, FarHeadphones, FarHeadphonesSimple, FarHeadset, FarHeart, FarHeartCircleBolt, FarHeartCircleCheck, FarHeartCircleExclamation, FarHeartCircleMinus, FarHeartCirclePlus, FarHeartCircleXmark, FarHeartCrack, FarHeartHalf, FarHeartHalfStroke, FarHeartPulse, FarHeat, FarHelicopter, FarHelicopterSymbol, FarHelmetBattle, FarHelmetSafety, FarHelmetUn, FarHexagon, FarHexagonCheck, FarHexagonDivide, FarHexagonExclamation, FarHexagonImage, FarHexagonMinus, FarHexagonPlus, FarHexagonVerticalNft, FarHexagonVerticalNftSlanted, FarHexagonXmark, FarHighDefinition, FarHighlighter, FarHighlighterLine, FarHillAvalanche, FarHillRockslide, FarHippo, FarHockeyMask, FarHockeyPuck, FarHockeyStickPuck, FarHockeySticks, FarHollyBerry, FarHoneyPot, FarHoodCloak, FarHorizontalRule, FarHorse, FarHorseHead, FarHorseSaddle, FarHose, FarHoseReel, FarHospital, FarHospitalUser, FarHospitals, FarHotTubPerson, FarHotdog, FarHotel, FarHourglass, FarHourglassClock, FarHourglassEnd, FarHourglassHalf, FarHourglassStart, FarHouse, FarHouseBlank, FarHouseBuilding, FarHouseChimney, FarHouseChimneyBlank, FarHouseChimneyCrack, FarHouseChimneyHeart, FarHouseChimneyMedical, FarHouseChimneyUser, FarHouseChimneyWindow, FarHouseCircleCheck, FarHouseCircleExclamation, FarHouseCircleXmark, FarHouseCrack, FarHouseDay, FarHouseFire, FarHouseFlag, FarHouseFloodWater, FarHouseFloodWaterCircleArrowRight, FarHouseHeart, FarHouseLaptop, FarHouseLock, FarHouseMedical, FarHouseMedicalCircleCheck, FarHouseMedicalCircleExclamation, FarHouseMedicalCircleXmark, FarHouseMedicalFlag, FarHouseNight, FarHousePersonLeave, FarHousePersonReturn, FarHouseSignal, FarHouseTree, FarHouseTsunami, FarHouseTurret, FarHouseUser, FarHouseWater, FarHouseWindow, FarHryvniaSign, FarHundredPoints, FarHurricane, FarHyphen, FarI, FarICursor, FarIceCream, FarIceSkate, FarIcicles, FarIcons, FarIdBadge, FarIdCard, FarIdCardClip, FarIgloo, FarImage, FarImageLandscape, FarImagePolaroid, FarImagePolaroidUser, FarImagePortrait, FarImageSlash, FarImageUser, FarImages, FarImagesUser, FarInbox, FarInboxFull, FarInboxIn, FarInboxOut, FarInboxes, FarIndent, FarIndianRupeeSign, FarIndustry, FarIndustryWindows, FarInfinity, FarInfo, FarInhaler, FarInputNumeric, FarInputPipe, FarInputText, FarIntegral, FarInterrobang, FarIntersection, FarIslandTropical, FarItalic, FarJ, FarJackOLantern, FarJar, FarJarWheat, FarJedi, FarJetFighter, FarJetFighterUp, FarJoint, FarJoystick, FarJug, FarJugBottle, FarJugDetergent, FarK, FarKaaba, FarKazoo, FarKerning, FarKey, FarKeySkeleton, FarKeySkeletonLeftRight, FarKeyboard, FarKeyboardBrightness, FarKeyboardBrightnessLow, FarKeyboardDown, FarKeyboardLeft, FarKeynote, FarKhanda, FarKidneys, FarKipSign, FarKitMedical, FarKitchenSet, FarKite, FarKiwiBird, FarKiwiFruit, FarKnife, FarKnifeKitchen, FarL, FarLacrosseStick, FarLacrosseStickBall, FarLambda, FarLamp, FarLampDesk, FarLampFloor, FarLampStreet, FarLandMineOn, FarLandmark, FarLandmarkDome, FarLandmarkFlag, FarLanguage, FarLaptop, FarLaptopArrowDown, FarLaptopBinary, FarLaptopCode, FarLaptopFile, FarLaptopMedical, FarLaptopMobile, FarLaptopSlash, FarLariSign, FarLasso, FarLassoSparkles, FarLayerGroup, FarLayerMinus, FarLayerPlus, FarLeaf, FarLeafHeart, FarLeafMaple, FarLeafOak, FarLeafyGreen, FarLeft, FarLeftFromLine, FarLeftLong, FarLeftLongToLine, FarLeftRight, FarLeftToLine, FarLemon, FarLessThan, FarLessThanEqual, FarLifeRing, FarLightCeiling, FarLightEmergency, FarLightEmergencyOn, FarLightSwitch, FarLightSwitchOff, FarLightSwitchOn, FarLightbulb, FarLightbulbCfl, FarLightbulbCflOn, FarLightbulbDollar, FarLightbulbExclamation, FarLightbulbExclamationOn, FarLightbulbGear, FarLightbulbOn, FarLightbulbSlash, FarLighthouse, FarLightsHoliday, FarLineColumns, FarLineHeight, FarLinesLeaning, FarLink, FarLinkHorizontal, FarLinkHorizontalSlash, FarLinkSimple, FarLinkSimpleSlash, FarLinkSlash, FarLips, FarLiraSign, FarList, FarListCheck, FarListDropdown, FarListMusic, FarListOl, FarListRadio, FarListTimeline, FarListTree, FarListUl, FarLitecoinSign, FarLoader, FarLobster, FarLocationArrow, FarLocationCheck, FarLocationCrosshairs, FarLocationCrosshairsSlash, FarLocationDot, FarLocationDotSlash, FarLocationExclamation, FarLocationMinus, FarLocationPen, FarLocationPin, FarLocationPinLock, FarLocationPinSlash, FarLocationPlus, FarLocationQuestion, FarLocationSmile, FarLocationXmark, FarLock, FarLockA, FarLockHashtag, FarLockKeyhole, FarLockKeyholeOpen, FarLockOpen, FarLocust, FarLollipop, FarLoveseat, FarLuchadorMask, FarLungs, FarLungsVirus, FarM, FarMace, FarMagnet, FarMagnifyingGlass, FarMagnifyingGlassArrowRight, FarMagnifyingGlassChart, FarMagnifyingGlassDollar, FarMagnifyingGlassLocation, FarMagnifyingGlassMinus, FarMagnifyingGlassPlus, FarMailbox, FarMailboxFlagUp, FarManatSign, FarMandolin, FarMango, FarManhole, FarMap, FarMapLocation, FarMapLocationDot, FarMapPin, FarMarker, FarMars, FarMarsAndVenus, FarMarsAndVenusBurst, FarMarsDouble, FarMarsStroke, FarMarsStrokeRight, FarMarsStrokeUp, FarMartiniGlass, FarMartiniGlassCitrus, FarMartiniGlassEmpty, FarMask, FarMaskFace, FarMaskSnorkel, FarMaskVentilator, FarMasksTheater, FarMattressPillow, FarMaximize, FarMeat, FarMedal, FarMegaphone, FarMelon, FarMelonSlice, FarMemo, FarMemoCircleCheck, FarMemoCircleInfo, FarMemoPad, FarMemory, FarMenorah, FarMercury, FarMerge, FarMessage, FarMessageArrowDown, FarMessageArrowUp, FarMessageArrowUpRight, FarMessageBot, FarMessageCaptions, FarMessageCheck, FarMessageCode, FarMessageDollar, FarMessageDots, FarMessageExclamation, FarMessageHeart, FarMessageImage, FarMessageLines, FarMessageMedical, FarMessageMiddle, FarMessageMiddleTop, FarMessageMinus, FarMessageMusic, FarMessagePen, FarMessagePlus, FarMessageQuestion, FarMessageQuote, FarMessageSlash, FarMessageSmile, FarMessageSms, FarMessageText, FarMessageXmark, FarMessages, FarMessagesDollar, FarMessagesQuestion, FarMeteor, FarMeter, FarMeterBolt, FarMeterDroplet, FarMeterFire, FarMicrochip, FarMicrochipAi, FarMicrophone, FarMicrophoneLines, FarMicrophoneLinesSlash, FarMicrophoneSlash, FarMicrophoneStand, FarMicroscope, FarMicrowave, FarMillSign, FarMinimize, FarMinus, FarMistletoe, FarMitten, FarMobile, FarMobileButton, FarMobileNotch, FarMobileRetro, FarMobileScreen, FarMobileScreenButton, FarMobileSignal, FarMobileSignalOut, FarMoneyBill, FarMoneyBill1, FarMoneyBill1Wave, FarMoneyBillSimple, FarMoneyBillSimpleWave, FarMoneyBillTransfer, FarMoneyBillTrendUp, FarMoneyBillWave, FarMoneyBillWheat, FarMoneyBills, FarMoneyBillsSimple, FarMoneyCheck, FarMoneyCheckDollar, FarMoneyCheckDollarPen, FarMoneyCheckPen, FarMoneyFromBracket, FarMoneySimpleFromBracket, FarMonitorWaveform, FarMonkey, FarMonument, FarMoon, FarMoonCloud, FarMoonOverSun, FarMoonStars, FarMoped, FarMortarPestle, FarMosque, FarMosquito, FarMosquitoNet, FarMotorcycle, FarMound, FarMountain, FarMountainCity, FarMountainSun, FarMountains, FarMouseField, FarMp3Player, FarMug, FarMugHot, FarMugMarshmallows, FarMugSaucer, FarMugTea, FarMugTeaSaucer, FarMushroom, FarMusic, FarMusicNote, FarMusicNoteSlash, FarMusicSlash, FarMustache, FarN, FarNairaSign, FarNarwhal, FarNestingDolls, FarNetworkWired, FarNeuter, FarNewspaper, FarNfc, FarNfcLock, FarNfcMagnifyingGlass, FarNfcPen, FarNfcSignal, FarNfcSlash, FarNfcSymbol, FarNfcTrash, FarNose, FarNotEqual, FarNotdef, FarNote, FarNoteMedical, FarNoteSticky, FarNotebook, FarNotes, FarNotesMedical, FarO, FarObjectExclude, FarObjectGroup, FarObjectIntersect, FarObjectSubtract, FarObjectUngroup, FarObjectUnion, FarObjectsAlignBottom, FarObjectsAlignCenterHorizontal, FarObjectsAlignCenterVertical, FarObjectsAlignLeft, FarObjectsAlignRight, FarObjectsAlignTop, FarObjectsColumn, FarOctagon, FarOctagonCheck, FarOctagonDivide, FarOctagonExclamation, FarOctagonMinus, FarOctagonPlus, FarOctagonXmark, FarOilCan, FarOilCanDrip, FarOilTemperature, FarOilWell, FarOlive, FarOliveBranch, FarOm, FarOmega, FarOnion, FarOption, FarOrnament, FarOtter, FarOutdent, FarOutlet, FarOven, FarOverline, FarP, FarPage, FarPageCaretDown, FarPageCaretUp, FarPager, FarPaintRoller, FarPaintbrush, FarPaintbrushFine, FarPaintbrushPencil, FarPalette, FarPallet, FarPalletBox, FarPalletBoxes, FarPanFood, FarPanFrying, FarPancakes, FarPanelEws, FarPanelFire, FarPanorama, FarPaperPlane, FarPaperPlaneTop, FarPaperclip, FarPaperclipVertical, FarParachuteBox, FarParagraph, FarParagraphLeft, FarPartyBell, FarPartyHorn, FarPassport, FarPaste, FarPause, FarPaw, FarPawClaws, FarPawSimple, FarPeace, FarPeach, FarPeanut, FarPeanuts, FarPeapod, FarPear, FarPedestal, FarPegasus, FarPen, FarPenCircle, FarPenClip, FarPenClipSlash, FarPenFancy, FarPenFancySlash, FarPenField, FarPenLine, FarPenNib, FarPenNibSlash, FarPenPaintbrush, FarPenRuler, FarPenSlash, FarPenSwirl, FarPenToSquare, FarPencil, FarPencilMechanical, FarPencilSlash, FarPeople, FarPeopleArrows, FarPeopleCarryBox, FarPeopleDress, FarPeopleDressSimple, FarPeopleGroup, FarPeopleLine, FarPeoplePants, FarPeoplePantsSimple, FarPeoplePulling, FarPeopleRobbery, FarPeopleRoof, FarPeopleSimple, FarPepper, FarPepperHot, FarPercent, FarPeriod, FarPerson, FarPersonArrowDownToLine, FarPersonArrowUpFromLine, FarPersonBiking, FarPersonBikingMountain, FarPersonBooth, FarPersonBreastfeeding, FarPersonBurst, FarPersonCane, FarPersonCarryBox, FarPersonChalkboard, FarPersonCircleCheck, FarPersonCircleExclamation, FarPersonCircleMinus, FarPersonCirclePlus, FarPersonCircleQuestion, FarPersonCircleXmark, FarPersonDigging, FarPersonDolly, FarPersonDollyEmpty, FarPersonDotsFromLine, FarPersonDress, FarPersonDressBurst, FarPersonDressFairy, FarPersonDressSimple, FarPersonDrowning, FarPersonFairy, FarPersonFalling, FarPersonFallingBurst, FarPersonFromPortal, FarPersonHalfDress, FarPersonHarassing, FarPersonHiking, FarPersonMilitaryPointing, FarPersonMilitaryRifle, FarPersonMilitaryToPerson, FarPersonPinball, FarPersonPraying, FarPersonPregnant, FarPersonRays, FarPersonRifle, FarPersonRunning, FarPersonRunningFast, FarPersonSeat, FarPersonSeatReclined, FarPersonShelter, FarPersonSign, FarPersonSimple, FarPersonSkating, FarPersonSkiJumping, FarPersonSkiLift, FarPersonSkiing, FarPersonSkiingNordic, FarPersonSledding, FarPersonSnowboarding, FarPersonSnowmobiling, FarPersonSwimming, FarPersonThroughWindow, FarPersonToDoor, FarPersonToPortal, FarPersonWalking, FarPersonWalkingArrowLoopLeft, FarPersonWalkingArrowRight, FarPersonWalkingDashedLineArrowRight, FarPersonWalkingLuggage, FarPersonWalkingWithCane, FarPesetaSign, FarPesoSign, FarPhone, FarPhoneArrowDownLeft, FarPhoneArrowRight, FarPhoneArrowUpRight, FarPhoneFlip, FarPhoneHangup, FarPhoneIntercom, FarPhoneMissed, FarPhoneOffice, FarPhonePlus, FarPhoneRotary, FarPhoneSlash, FarPhoneVolume, FarPhoneXmark, FarPhotoFilm, FarPhotoFilmMusic, FarPi, FarPiano, FarPianoKeyboard, FarPickaxe, FarPickleball, FarPie, FarPig, FarPiggyBank, FarPills, FarPinata, FarPinball, FarPineapple, FarPipe, FarPipeCircleCheck, FarPipeCollar, FarPipeSection, FarPipeSmoking, FarPipeValve, FarPizza, FarPizzaSlice, FarPlaceOfWorship, FarPlane, FarPlaneArrival, FarPlaneCircleCheck, FarPlaneCircleExclamation, FarPlaneCircleXmark, FarPlaneDeparture, FarPlaneEngines, FarPlaneLock, FarPlaneProp, FarPlaneSlash, FarPlaneTail, FarPlaneUp, FarPlaneUpSlash, FarPlanetMoon, FarPlanetRinged, FarPlantWilt, FarPlateUtensils, FarPlateWheat, FarPlay, FarPlayPause, FarPlug, FarPlugCircleBolt, FarPlugCircleCheck, FarPlugCircleExclamation, FarPlugCircleMinus, FarPlugCirclePlus, FarPlugCircleXmark, FarPlus, FarPlusLarge, FarPlusMinus, FarPodcast, FarPodium, FarPodiumStar, FarPoliceBox, FarPollPeople, FarPompebled, FarPoo, FarPooStorm, FarPool8Ball, FarPoop, FarPopcorn, FarPopsicle, FarPotFood, FarPotato, FarPowerOff, FarPrescription, FarPrescriptionBottle, FarPrescriptionBottleMedical, FarPrescriptionBottlePill, FarPresentationScreen, FarPretzel, FarPrint, FarPrintMagnifyingGlass, FarPrintSlash, FarProjector, FarPump, FarPumpMedical, FarPumpSoap, FarPumpkin, FarPuzzle, FarPuzzlePiece, FarPuzzlePieceSimple, FarQ, FarQrcode, FarQuestion, FarQuoteLeft, FarQuoteRight, FarQuotes, FarR, FarRabbit, FarRabbitRunning, FarRaccoon, FarRacquet, FarRadar, FarRadiation, FarRadio, FarRadioTuner, FarRainbow, FarRaindrops, FarRam, FarRampLoading, FarRankingStar, FarRaygun, FarReceipt, FarRecordVinyl, FarRectangle, FarRectangleAd, FarRectangleBarcode, FarRectangleCode, FarRectangleHistory, FarRectangleHistoryCirclePlus, FarRectangleHistoryCircleUser, FarRectangleList, FarRectanglePro, FarRectangleTerminal, FarRectangleVertical, FarRectangleVerticalHistory, FarRectangleWide, FarRectangleXmark, FarRectanglesMixed, FarRecycle, FarReel, FarRefrigerator, FarRegistered, FarRepeat, FarRepeat1, FarReply, FarReplyAll, FarReplyClock, FarRepublican, FarRestroom, FarRestroomSimple, FarRetweet, FarRhombus, FarRibbon, FarRight, FarRightFromBracket, FarRightFromLine, FarRightLeft, FarRightLeftLarge, FarRightLong, FarRightLongToLine, FarRightToBracket, FarRightToLine, FarRing, FarRingDiamond, FarRingsWedding, FarRoad, FarRoadBarrier, FarRoadBridge, FarRoadCircleCheck, FarRoadCircleExclamation, FarRoadCircleXmark, FarRoadLock, FarRoadSpikes, FarRobot, FarRobotAstromech, FarRocket, FarRocketLaunch, FarRollerCoaster, FarRotate, FarRotateExclamation, FarRotateLeft, FarRotateRight, FarRoute, FarRouteHighway, FarRouteInterstate, FarRouter, FarRss, FarRubleSign, FarRug, FarRugbyBall, FarRuler, FarRulerCombined, FarRulerHorizontal, FarRulerTriangle, FarRulerVertical, FarRupeeSign, FarRupiahSign, FarRv, FarS, FarSack, FarSackDollar, FarSackXmark, FarSailboat, FarSalad, FarSaltShaker, FarSandwich, FarSatellite, FarSatelliteDish, FarSausage, FarSaxophone, FarSaxophoneFire, FarScaleBalanced, FarScaleUnbalanced, FarScaleUnbalancedFlip, FarScalpel, FarScalpelLineDashed, FarScannerGun, FarScannerImage, FarScannerKeyboard, FarScannerTouchscreen, FarScarecrow, FarScarf, FarSchool, FarSchoolCircleCheck, FarSchoolCircleExclamation, FarSchoolCircleXmark, FarSchoolFlag, FarSchoolLock, FarScissors, FarScreenUsers, FarScreencast, FarScrewdriver, FarScrewdriverWrench, FarScribble, FarScroll, FarScrollOld, FarScrollTorah, FarScrubber, FarScythe, FarSdCard, FarSdCards, FarSeal, FarSealExclamation, FarSealQuestion, FarSeatAirline, FarSection, FarSeedling, FarSemicolon, FarSendBack, FarSendBackward, FarSensor, FarSensorCloud, FarSensorFire, FarSensorOn, FarSensorTriangleExclamation, FarServer, FarShapes, FarShare, FarShareAll, FarShareFromSquare, FarShareNodes, FarSheep, FarSheetPlastic, FarShekelSign, FarShelves, FarShelvesEmpty, FarShield, FarShieldCat, FarShieldCheck, FarShieldCross, FarShieldDog, FarShieldExclamation, FarShieldHalved, FarShieldHeart, FarShieldKeyhole, FarShieldMinus, FarShieldPlus, FarShieldQuartered, FarShieldSlash, FarShieldVirus, FarShieldXmark, FarShip, FarShirt, FarShirtLongSleeve, FarShirtRunning, FarShirtTankTop, FarShishKebab, FarShoePrints, FarShop, FarShopLock, FarShopSlash, FarShovel, FarShovelSnow, FarShower, FarShowerDown, FarShredder, FarShrimp, FarShuffle, FarShutters, FarShuttleSpace, FarShuttlecock, FarSickle, FarSidebar, FarSidebarFlip, FarSigma, FarSignHanging, FarSignal, FarSignalBars, FarSignalBarsFair, FarSignalBarsGood, FarSignalBarsSlash, FarSignalBarsWeak, FarSignalFair, FarSignalGood, FarSignalSlash, FarSignalStream, FarSignalStreamSlash, FarSignalStrong, FarSignalWeak, FarSignature, FarSignatureLock, FarSignatureSlash, FarSignsPost, FarSimCard, FarSimCards, FarSink, FarSiren, FarSirenOn, FarSitemap, FarSkeleton, FarSkeletonRibs, FarSkiBoot, FarSkiBootSki, FarSkull, FarSkullCow, FarSkullCrossbones, FarSlash, FarSlashBack, FarSlashForward, FarSleigh, FarSlider, FarSliders, FarSlidersSimple, FarSlidersUp, FarSlotMachine, FarSmog, FarSmoke, FarSmoking, FarSnake, FarSnooze, FarSnowBlowing, FarSnowflake, FarSnowflakeDroplets, FarSnowflakes, FarSnowman, FarSnowmanHead, FarSnowplow, FarSoap, FarSocks, FarSoftServe, FarSolarPanel, FarSolarSystem, FarSort, FarSortDown, FarSortUp, FarSpa, FarSpaceStationMoon, FarSpaceStationMoonConstruction, FarSpade, FarSpaghettiMonsterFlying, FarSparkle, FarSparkles, FarSpeaker, FarSpeakers, FarSpellCheck, FarSpider, FarSpiderBlackWidow, FarSpiderWeb, FarSpinner, FarSpinnerThird, FarSplit, FarSplotch, FarSpoon, FarSportsball, FarSprayCan, FarSprayCanSparkles, FarSprinkler, FarSprinklerCeiling, FarSquare, FarSquare0, FarSquare1, FarSquare2, FarSquare3, FarSquare4, FarSquare5, FarSquare6, FarSquare7, FarSquare8, FarSquare9, FarSquareA, FarSquareALock, FarSquareAmpersand, FarSquareArrowDown, FarSquareArrowDownLeft, FarSquareArrowDownRight, FarSquareArrowLeft, FarSquareArrowRight, FarSquareArrowUp, FarSquareArrowUpLeft, FarSquareArrowUpRight, FarSquareB, FarSquareBolt, FarSquareC, FarSquareCaretDown, FarSquareCaretLeft, FarSquareCaretRight, FarSquareCaretUp, FarSquareCheck, FarSquareChevronDown, FarSquareChevronLeft, FarSquareChevronRight, FarSquareChevronUp, FarSquareCode, FarSquareD, FarSquareDashed, FarSquareDashedCirclePlus, FarSquareDivide, FarSquareDollar, FarSquareDown, FarSquareDownLeft, FarSquareDownRight, FarSquareE, FarSquareEllipsis, FarSquareEllipsisVertical, FarSquareEnvelope, FarSquareExclamation, FarSquareF, FarSquareFragile, FarSquareFull, FarSquareG, FarSquareH, FarSquareHeart, FarSquareI, FarSquareInfo, FarSquareJ, FarSquareK, FarSquareKanban, FarSquareL, FarSquareLeft, FarSquareList, FarSquareM, FarSquareMinus, FarSquareN, FarSquareNfi, FarSquareO, FarSquareP, FarSquareParking, FarSquareParkingSlash, FarSquarePen, FarSquarePersonConfined, FarSquarePhone, FarSquarePhoneFlip, FarSquarePhoneHangup, FarSquarePlus, FarSquarePollHorizontal, FarSquarePollVertical, FarSquareQ, FarSquareQuarters, FarSquareQuestion, FarSquareQuote, FarSquareR, FarSquareRight, FarSquareRing, FarSquareRoot, FarSquareRootVariable, FarSquareRss, FarSquareS, FarSquareShareNodes, FarSquareSliders, FarSquareSlidersVertical, FarSquareSmall, FarSquareStar, FarSquareT, FarSquareTerminal, FarSquareThisWayUp, FarSquareU, FarSquareUp, FarSquareUpLeft, FarSquareUpRight, FarSquareUser, FarSquareV, FarSquareVirus, FarSquareW, FarSquareX, FarSquareXmark, FarSquareY, FarSquareZ, FarSquid, FarSquirrel, FarStaff, FarStaffSnake, FarStairs, FarStamp, FarStandardDefinition, FarStapler, FarStar, FarStarAndCrescent, FarStarChristmas, FarStarExclamation, FarStarHalf, FarStarHalfStroke, FarStarOfDavid, FarStarOfLife, FarStarSharp, FarStarSharpHalf, FarStarSharpHalfStroke, FarStarShooting, FarStarfighter, FarStarfighterTwinIonEngine, FarStarfighterTwinIonEngineAdvanced, FarStars, FarStarship, FarStarshipFreighter, FarSteak, FarSteeringWheel, FarSterlingSign, FarStethoscope, FarStocking, FarStomach, FarStop, FarStopwatch, FarStopwatch20, FarStore, FarStoreLock, FarStoreSlash, FarStrawberry, FarStreetView, FarStretcher, FarStrikethrough, FarStroopwafel, FarSubscript, FarSubtitles, FarSubtitlesSlash, FarSuitcase, FarSuitcaseMedical, FarSuitcaseRolling, FarSun, FarSunBright, FarSunCloud, FarSunDust, FarSunHaze, FarSunPlantWilt, FarSunglasses, FarSunrise, FarSunset, FarSuperscript, FarSushi, FarSushiRoll, FarSwap, FarSwapArrows, FarSwatchbook, FarSword, FarSwordLaser, FarSwordLaserAlt, FarSwords, FarSwordsLaser, FarSymbols, FarSynagogue, FarSyringe, FarT, FarTable, FarTableCells, FarTableCellsLarge, FarTableColumns, FarTableLayout, FarTableList, FarTablePicnic, FarTablePivot, FarTableRows, FarTableTennisPaddleBall, FarTableTree, FarTablet, FarTabletButton, FarTabletRugged, FarTabletScreen, FarTabletScreenButton, FarTablets, FarTachographDigital, FarTaco, FarTag, FarTags, FarTally, FarTally1, FarTally2, FarTally3, FarTally4, FarTamale, FarTankWater, FarTape, FarTarp, FarTarpDroplet, FarTaxi, FarTaxiBus, FarTeddyBear, FarTeeth, FarTeethOpen, FarTelescope, FarTemperatureArrowDown, FarTemperatureArrowUp, FarTemperatureEmpty, FarTemperatureFull, FarTemperatureHalf, FarTemperatureHigh, FarTemperatureList, FarTemperatureLow, FarTemperatureQuarter, FarTemperatureSnow, FarTemperatureSun, FarTemperatureThreeQuarters, FarTengeSign, FarTennisBall, FarTent, FarTentArrowDownToLine, FarTentArrowLeftRight, FarTentArrowTurnLeft, FarTentArrowsDown, FarTents, FarTerminal, FarText, FarTextHeight, FarTextSize, FarTextSlash, FarTextWidth, FarThermometer, FarTheta, FarThoughtBubble, FarThumbsDown, FarThumbsUp, FarThumbtack, FarTick, FarTicket, FarTicketAirline, FarTicketSimple, FarTicketsAirline, FarTilde, FarTimeline, FarTimelineArrow, FarTimer, FarTire, FarTireFlat, FarTirePressureWarning, FarTireRugged, FarToggleLargeOff, FarToggleLargeOn, FarToggleOff, FarToggleOn, FarToilet, FarToiletPaper, FarToiletPaperBlank, FarToiletPaperBlankUnder, FarToiletPaperCheck, FarToiletPaperSlash, FarToiletPaperUnder, FarToiletPaperUnderSlash, FarToiletPaperXmark, FarToiletPortable, FarToiletsPortable, FarTomato, FarTombstone, FarTombstoneBlank, FarToolbox, FarTooth, FarToothbrush, FarToriiGate, FarTornado, FarTowerBroadcast, FarTowerCell, FarTowerControl, FarTowerObservation, FarTractor, FarTrademark, FarTrafficCone, FarTrafficLight, FarTrafficLightGo, FarTrafficLightSlow, FarTrafficLightStop, FarTrailer, FarTrain, FarTrainSubway, FarTrainSubwayTunnel, FarTrainTrack, FarTrainTram, FarTrainTunnel, FarTransformerBolt, FarTransgender, FarTransporter, FarTransporter1, FarTransporter2, FarTransporter3, FarTransporter4, FarTransporter5, FarTransporter6, FarTransporter7, FarTransporterEmpty, FarTrash, FarTrashArrowUp, FarTrashCan, FarTrashCanArrowUp, FarTrashCanCheck, FarTrashCanClock, FarTrashCanList, FarTrashCanPlus, FarTrashCanSlash, FarTrashCanUndo, FarTrashCanXmark, FarTrashCheck, FarTrashClock, FarTrashList, FarTrashPlus, FarTrashSlash, FarTrashUndo, FarTrashXmark, FarTreasureChest, FarTree, FarTreeChristmas, FarTreeCity, FarTreeDeciduous, FarTreeDecorated, FarTreeLarge, FarTreePalm, FarTrees, FarTriangle, FarTriangleExclamation, FarTriangleInstrument, FarTrianglePersonDigging, FarTricycle, FarTricycleAdult, FarTrillium, FarTrophy, FarTrophyStar, FarTrowel, FarTrowelBricks, FarTruck, FarTruckArrowRight, FarTruckBolt, FarTruckClock, FarTruckContainer, FarTruckContainerEmpty, FarTruckDroplet, FarTruckFast, FarTruckField, FarTruckFieldUn, FarTruckFlatbed, FarTruckFront, FarTruckMedical, FarTruckMonster, FarTruckMoving, FarTruckPickup, FarTruckPlane, FarTruckPlow, FarTruckRamp, FarTruckRampBox, FarTruckRampCouch, FarTruckTow, FarTrumpet, FarTty, FarTtyAnswer, FarTugrikSign, FarTurkey, FarTurkishLiraSign, FarTurnDown, FarTurnDownLeft, FarTurnDownRight, FarTurnUp, FarTurntable, FarTurtle, FarTv, FarTvMusic, FarTvRetro, FarTypewriter, FarU, FarUfo, FarUfoBeam, FarUmbrella, FarUmbrellaBeach, FarUmbrellaSimple, FarUnderline, FarUnicorn, FarUniformMartialArts, FarUnion, FarUniversalAccess, FarUnlock, FarUnlockKeyhole, FarUp, FarUpDown, FarUpDownLeftRight, FarUpFromBracket, FarUpFromDottedLine, FarUpFromLine, FarUpLeft, FarUpLong, FarUpRight, FarUpRightAndDownLeftFromCenter, FarUpRightFromSquare, FarUpToDottedLine, FarUpToLine, FarUpload, FarUsbDrive, FarUser, FarUserAlien, FarUserAstronaut, FarUserBountyHunter, FarUserCheck, FarUserChef, FarUserClock, FarUserCowboy, FarUserCrown, FarUserDoctor, FarUserDoctorHair, FarUserDoctorHairLong, FarUserDoctorMessage, FarUserGear, FarUserGraduate, FarUserGroup, FarUserGroupCrown, FarUserGroupSimple, FarUserHair, FarUserHairBuns, FarUserHairLong, FarUserHairMullet, FarUserHeadset, FarUserHelmetSafety, FarUserInjured, FarUserLarge, FarUserLargeSlash, FarUserLock, FarUserMagnifyingGlass, FarUserMinus, FarUserMusic, FarUserNinja, FarUserNurse, FarUserNurseHair, FarUserNurseHairLong, FarUserPen, FarUserPilot, FarUserPilotTie, FarUserPlus, FarUserPolice, FarUserPoliceTie, FarUserRobot, FarUserRobotXmarks, FarUserSecret, FarUserShakespeare, FarUserShield, FarUserSlash, FarUserTag, FarUserTie, FarUserTieHair, FarUserTieHairLong, FarUserUnlock, FarUserVisor, FarUserVneck, FarUserVneckHair, FarUserVneckHairLong, FarUserXmark, FarUsers, FarUsersBetweenLines, FarUsersGear, FarUsersLine, FarUsersMedical, FarUsersRays, FarUsersRectangle, FarUsersSlash, FarUsersViewfinder, FarUtensils, FarUtensilsSlash, FarUtilityPole, FarUtilityPoleDouble, FarV, FarVacuum, FarVacuumRobot, FarValueAbsolute, FarVanShuttle, FarVault, FarVectorCircle, FarVectorPolygon, FarVectorSquare, FarVentDamper, FarVenus, FarVenusDouble, FarVenusMars, FarVest, FarVestPatches, FarVial, FarVialCircleCheck, FarVialVirus, FarVials, FarVideo, FarVideoArrowDownLeft, FarVideoArrowUpRight, FarVideoPlus, FarVideoSlash, FarVihara, FarViolin, FarVirus, FarVirusCovid, FarVirusCovidSlash, FarVirusSlash, FarViruses, FarVoicemail, FarVolcano, FarVolleyball, FarVolume, FarVolumeHigh, FarVolumeLow, FarVolumeOff, FarVolumeSlash, FarVolumeXmark, FarVrCardboard, FarW, FarWaffle, FarWagonCovered, FarWalker, FarWalkieTalkie, FarWallet, FarWand, FarWandMagic, FarWandMagicSparkles, FarWandSparkles, FarWarehouse, FarWarehouseFull, FarWashingMachine, FarWatch, FarWatchApple, FarWatchCalculator, FarWatchFitness, FarWatchSmart, FarWater, FarWaterArrowDown, FarWaterArrowUp, FarWaterLadder, FarWatermelonSlice, FarWavePulse, FarWaveSine, FarWaveSquare, FarWaveTriangle, FarWaveform, FarWaveformLines, FarWebhook, FarWeightHanging, FarWeightScale, FarWhale, FarWheat, FarWheatAwn, FarWheatAwnCircleExclamation, FarWheatAwnSlash, FarWheatSlash, FarWheelchair, FarWheelchairMove, FarWhiskeyGlass, FarWhiskeyGlassIce, FarWhistle, FarWifi, FarWifiExclamation, FarWifiFair, FarWifiSlash, FarWifiWeak, FarWind, FarWindTurbine, FarWindWarning, FarWindow, FarWindowFlip, FarWindowFrame, FarWindowFrameOpen, FarWindowMaximize, FarWindowMinimize, FarWindowRestore, FarWindsock, FarWineBottle, FarWineGlass, FarWineGlassCrack, FarWineGlassEmpty, FarWonSign, FarWorm, FarWreath, FarWreathLaurel, FarWrench, FarWrenchSimple, FarX, FarXRay, FarXmark, FarXmarkLarge, FarXmarkToSlot, FarXmarksLines, FarY, FarYenSign, FarYinYang, FarZ };
//# sourceMappingURL=virginmediao2-momentum-icons-icons-far.mjs.map
